import { useQuery, useSuspenseQuery, UseQueryOptions, UseSuspenseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '../gql-fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

            type FetchOptions = {
              cache?: RequestCache;
              next?: NextFetchRequestConfig;
            };
            type RequestInit = {
              headers: (HeadersInit & FetchOptions) | FetchOptions;
            };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Bool: { input: any; output: any; }
  Date: { input: any; output: any; }
};

/** Holds AMP data for the Company Admin page */
export type AmpSectionBlock = IContent & IData & {
  __typename?: 'AMPSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackDues?: Maybe<Scalars['String']['output']>;
  BirthYear?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CourtOfTheTableDuesCOT?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DidApplicantHaveAnEthicsComplaintStatus?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstGivenName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastFamilyName?: Maybe<Scalars['String']['output']>;
  LastMemberYear?: Maybe<Scalars['String']['output']>;
  LateFeeAfterMarch1?: Maybe<Scalars['String']['output']>;
  MDRTDues?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MembershipLevel?: Maybe<Scalars['String']['output']>;
  MembershipType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NewBusinessIncome?: Maybe<Scalars['String']['output']>;
  OtherCommission?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesCommission?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesIncome?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesPremium?: Maybe<Scalars['String']['output']>;
  OtherPremium?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RiskProtectionCommission?: Maybe<Scalars['String']['output']>;
  RiskProtectionIncome?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesCommission?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesIncome?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesPremium?: Maybe<Scalars['String']['output']>;
  RiskProtectionPremium?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TermsAndConditions?: Maybe<Scalars['String']['output']>;
  TopOfTheTableDuesTOT?: Maybe<Scalars['String']['output']>;
  TotalIncome?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Year?: Maybe<Scalars['String']['output']>;
  YearsOfMembership?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockBackDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockBirthYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockCourtOfTheTableDuesCotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockDidApplicantHaveAnEthicsComplaintStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockFirstGivenNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockLastFamilyNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockLastMemberYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockLateFeeAfterMarch1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockMdrtDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockMembershipTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockNewBusinessIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockOtherCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockOtherPoliciesCasesCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockOtherPoliciesCasesIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockOtherPoliciesCasesPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockOtherPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockRiskProtectionCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockRiskProtectionIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockRiskProtectionPoliciesCasesCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockRiskProtectionPoliciesCasesIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockRiskProtectionPoliciesCasesPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockRiskProtectionPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockTermsAndConditionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockTopOfTheTableDuesTotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockTotalIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlockYearsOfMembershipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds AMP data for the Company Admin page */
export type AmpSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AmpSectionBlockAutocomplete = {
  __typename?: 'AMPSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AmpSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AmpSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AmpSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AmpSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AmpSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AmpSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AmpSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AmpSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AmpSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AmpSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AmpSectionBlockFacet = {
  __typename?: 'AMPSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackDues?: Maybe<Array<Maybe<StringFacet>>>;
  BirthYear?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CourtOfTheTableDuesCOT?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DidApplicantHaveAnEthicsComplaintStatus?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstGivenName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastFamilyName?: Maybe<Array<Maybe<StringFacet>>>;
  LastMemberYear?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeeAfterMarch1?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTDues?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipLevel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NewBusinessIncome?: Maybe<Array<Maybe<StringFacet>>>;
  OtherCommission?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesCommission?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesIncome?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesPremium?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPremium?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionCommission?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionIncome?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesCommission?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesIncome?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesPremium?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPremium?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TermsAndConditions?: Maybe<Array<Maybe<StringFacet>>>;
  TopOfTheTableDuesTOT?: Maybe<Array<Maybe<StringFacet>>>;
  TotalIncome?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Year?: Maybe<Array<Maybe<StringFacet>>>;
  YearsOfMembership?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type AmpSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetBackDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetBirthYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AmpSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetCourtOfTheTableDuesCotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AmpSectionBlockFacetDidApplicantHaveAnEthicsComplaintStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetFirstGivenNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AmpSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetLastFamilyNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetLastMemberYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetLateFeeAfterMarch1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetMdrtDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetMembershipLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetMembershipTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetNewBusinessIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetOtherCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetOtherPoliciesCasesCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetOtherPoliciesCasesIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetOtherPoliciesCasesPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetOtherPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetRiskProtectionCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetRiskProtectionIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetRiskProtectionPoliciesCasesCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetRiskProtectionPoliciesCasesIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetRiskProtectionPoliciesCasesPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetRiskProtectionPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AmpSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AmpSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AmpSectionBlockFacetTermsAndConditionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetTopOfTheTableDuesTotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetTotalIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacetYearsOfMembershipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AmpSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AmpSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BackDues?: InputMaybe<OrderBy>;
  BirthYear?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CourtOfTheTableDuesCOT?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DidApplicantHaveAnEthicsComplaintStatus?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstGivenName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastFamilyName?: InputMaybe<OrderBy>;
  LastMemberYear?: InputMaybe<OrderBy>;
  LateFeeAfterMarch1?: InputMaybe<OrderBy>;
  MDRTDues?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipLevel?: InputMaybe<OrderBy>;
  MembershipType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NewBusinessIncome?: InputMaybe<OrderBy>;
  OtherCommission?: InputMaybe<OrderBy>;
  OtherPoliciesCasesCommission?: InputMaybe<OrderBy>;
  OtherPoliciesCasesIncome?: InputMaybe<OrderBy>;
  OtherPoliciesCasesPremium?: InputMaybe<OrderBy>;
  OtherPremium?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RiskProtectionCommission?: InputMaybe<OrderBy>;
  RiskProtectionIncome?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesCommission?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesIncome?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesPremium?: InputMaybe<OrderBy>;
  RiskProtectionPremium?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TermsAndConditions?: InputMaybe<OrderBy>;
  TopOfTheTableDuesTOT?: InputMaybe<OrderBy>;
  TotalIncome?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Year?: InputMaybe<OrderBy>;
  YearsOfMembership?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AmpSectionBlockOutput = {
  __typename?: 'AMPSectionBlockOutput';
  autocomplete?: Maybe<AmpSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AmpSectionBlockFacet>;
  item?: Maybe<AmpSectionBlock>;
  items?: Maybe<Array<Maybe<AmpSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type AmpSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AmpSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BackDues?: InputMaybe<SearchableStringFilterInput>;
  BirthYear?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CourtOfTheTableDuesCOT?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DidApplicantHaveAnEthicsComplaintStatus?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstGivenName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastFamilyName?: InputMaybe<SearchableStringFilterInput>;
  LastMemberYear?: InputMaybe<SearchableStringFilterInput>;
  LateFeeAfterMarch1?: InputMaybe<SearchableStringFilterInput>;
  MDRTDues?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipLevel?: InputMaybe<SearchableStringFilterInput>;
  MembershipType?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NewBusinessIncome?: InputMaybe<SearchableStringFilterInput>;
  OtherCommission?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesCommission?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesIncome?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesPremium?: InputMaybe<SearchableStringFilterInput>;
  OtherPremium?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RiskProtectionCommission?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionIncome?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesCommission?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesIncome?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesPremium?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPremium?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TermsAndConditions?: InputMaybe<SearchableStringFilterInput>;
  TopOfTheTableDuesTOT?: InputMaybe<SearchableStringFilterInput>;
  TotalIncome?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Year?: InputMaybe<SearchableStringFilterInput>;
  YearsOfMembership?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AmpSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AmpSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AmpSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is an accordion container block */
export type AccordionContainerBlock = IContent & IData & {
  __typename?: 'AccordionContainerBlock';
  AccordionItemBlock?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Subheading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is an accordion container block */
export type AccordionContainerBlockAccordionItemBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an accordion container block */
export type AccordionContainerBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an accordion container block */
export type AccordionContainerBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an accordion container block */
export type AccordionContainerBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an accordion container block */
export type AccordionContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an accordion container block */
export type AccordionContainerBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an accordion container block */
export type AccordionContainerBlockSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an accordion container block */
export type AccordionContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an accordion container block */
export type AccordionContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AccordionContainerBlockAutocomplete = {
  __typename?: 'AccordionContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AccordionContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionContainerBlockFacet = {
  __typename?: 'AccordionContainerBlockFacet';
  AccordionItemBlock?: Maybe<ContentAreaItemModelSearchFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subheading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type AccordionContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionContainerBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AccordionContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionContainerBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionContainerBlockFacetSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AccordionContainerBlockOrderByInput = {
  AccordionItemBlock?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subheading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AccordionContainerBlockOutput = {
  __typename?: 'AccordionContainerBlockOutput';
  autocomplete?: Maybe<AccordionContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AccordionContainerBlockFacet>;
  item?: Maybe<AccordionContainerBlock>;
  items?: Maybe<Array<Maybe<AccordionContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type AccordionContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionContainerBlockWhereInput = {
  AccordionItemBlock?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subheading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AccordionContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AccordionContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AccordionContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a accordion item block */
export type AccordionItemBlock = IContent & IData & {
  __typename?: 'AccordionItemBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Subheading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a accordion item block */
export type AccordionItemBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a accordion item block */
export type AccordionItemBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a accordion item block */
export type AccordionItemBlockSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a accordion item block */
export type AccordionItemBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a accordion item block */
export type AccordionItemBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AccordionItemBlockAutocomplete = {
  __typename?: 'AccordionItemBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AccordionItemBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionItemBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionItemBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionItemBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionItemBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionItemBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionItemBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionItemBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionItemBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccordionItemBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccordionItemBlockFacet = {
  __typename?: 'AccordionItemBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subheading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type AccordionItemBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionItemBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionItemBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AccordionItemBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionItemBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionItemBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionItemBlockFacetSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccordionItemBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AccordionItemBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subheading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AccordionItemBlockOutput = {
  __typename?: 'AccordionItemBlockOutput';
  autocomplete?: Maybe<AccordionItemBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AccordionItemBlockFacet>;
  item?: Maybe<AccordionItemBlock>;
  items?: Maybe<Array<Maybe<AccordionItemBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type AccordionItemBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionItemBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subheading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AccordionItemBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AccordionItemBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AccordionItemBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is an Account Profile Page */
export type AccountProfilePage = IContent & IData & {
  __typename?: 'AccountProfilePage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  CancelButton?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  CertificateBody?: Maybe<Scalars['String']['output']>;
  CertificateHeading?: Maybe<Scalars['String']['output']>;
  CertificateLogoImage?: Maybe<AccountProfilePageImageBlock>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyChangeLogoutUrl?: Maybe<AccountProfilePageLinkBlock>;
  CompanyChangeMessage?: Maybe<Scalars['String']['output']>;
  CompanyChangeTitle?: Maybe<Scalars['String']['output']>;
  ContactFormHeader?: Maybe<Scalars['String']['output']>;
  ContactUsLink?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  EditLabel?: Maybe<Scalars['String']['output']>;
  ErrorMessage?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LetterAddressText?: Maybe<Scalars['String']['output']>;
  /** Use variables {{ADDITIONAL_LEVEL}}, {{MEMBER_TYPE}}, {{MEMBER_YEARS}}, {{CURRENT_MEMBERSHIP_YEAR}} */
  LetterBodyText?: Maybe<Scalars['String']['output']>;
  LetterCompanyName?: Maybe<Scalars['String']['output']>;
  /** Use variables {{ADDITIONAL_LEVEL}}, {{MEMBER_TYPE}}, {{MEMBER_YEARS}}, {{CURRENT_MEMBERSHIP_YEAR}} */
  LetterCongratulationsText?: Maybe<Scalars['String']['output']>;
  LetterContactInfoText?: Maybe<Scalars['String']['output']>;
  LetterGreeting?: Maybe<Scalars['String']['output']>;
  LetterLogoImage?: Maybe<AccountProfilePageImageBlock>;
  /** Use variable {{MEMBERID}} */
  LetterMemberIdText?: Maybe<Scalars['String']['output']>;
  LetterMembershipYear?: Maybe<Scalars['String']['output']>;
  /** Recommended signature image size is 350 px X 100 px. */
  LetterSignatureImagesAndTexts?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** The Member Section content */
  MemberSection?: Maybe<AccountProfilePageMemberSectionBlock>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<AccountProfilePageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NavHeadingLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PdfFileName?: Maybe<Scalars['String']['output']>;
  /** The Profile Section content */
  ProfileSection?: Maybe<AccountProfilePageProfileSectionBlock>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RequiredMessage?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SaveChangesButton?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  /** The Setting Section content */
  SettingSection?: Maybe<AccountProfilePageSettingSectionBlock>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<AccountProfilePageImageBlock>;
  UniqueEmailErrorText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is an Account Profile Page */
export type AccountProfilePageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageCancelButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageCertificateBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageCertificateHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageCompanyChangeMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageCompanyChangeTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageContactFormHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageContactUsLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageEditLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageLetterAddressTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageLetterBodyTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageLetterCompanyNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageLetterCongratulationsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageLetterContactInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageLetterGreetingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageLetterMemberIdTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageLetterMembershipYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageLetterSignatureImagesAndTextsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageNavHeadingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePagePdfFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageRequiredMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageSaveChangesButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePageUniqueEmailErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Account Profile Page */
export type AccountProfilePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AccountProfilePageAutocomplete = {
  __typename?: 'AccountProfilePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  CertificateLogoImage?: Maybe<AccountProfilePageImageBlockAutocomplete>;
  CompanyChangeLogoutUrl?: Maybe<AccountProfilePageLinkBlockAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LetterLogoImage?: Maybe<AccountProfilePageImageBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MemberSection?: Maybe<AccountProfilePageMemberSectionBlockAutocomplete>;
  MetaImage?: Maybe<AccountProfilePageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SettingSection?: Maybe<AccountProfilePageSettingSectionBlockAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<AccountProfilePageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AccountProfilePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccountProfilePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccountProfilePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccountProfilePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccountProfilePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccountProfilePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccountProfilePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccountProfilePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccountProfilePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AccountProfilePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccountProfilePageFacet = {
  __typename?: 'AccountProfilePageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  CancelButton?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  CertificateBody?: Maybe<Array<Maybe<StringFacet>>>;
  CertificateHeading?: Maybe<Array<Maybe<StringFacet>>>;
  CertificateLogoImage?: Maybe<AccountProfilePageImageBlockFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyChangeLogoutUrl?: Maybe<AccountProfilePageLinkBlockFacet>;
  CompanyChangeMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyChangeTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ContactFormHeader?: Maybe<Array<Maybe<StringFacet>>>;
  ContactUsLink?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EditLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LetterAddressText?: Maybe<Array<Maybe<StringFacet>>>;
  LetterBodyText?: Maybe<Array<Maybe<StringFacet>>>;
  LetterCompanyName?: Maybe<Array<Maybe<StringFacet>>>;
  LetterCongratulationsText?: Maybe<Array<Maybe<StringFacet>>>;
  LetterContactInfoText?: Maybe<Array<Maybe<StringFacet>>>;
  LetterGreeting?: Maybe<Array<Maybe<StringFacet>>>;
  LetterLogoImage?: Maybe<AccountProfilePageImageBlockFacet>;
  LetterMemberIdText?: Maybe<Array<Maybe<StringFacet>>>;
  LetterMembershipYear?: Maybe<Array<Maybe<StringFacet>>>;
  LetterSignatureImagesAndTexts?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MemberSection?: Maybe<AccountProfilePageMemberSectionBlockFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<AccountProfilePageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavHeadingLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PdfFileName?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileSection?: Maybe<AccountProfilePageProfileSectionBlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RequiredMessage?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SaveChangesButton?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SettingSection?: Maybe<AccountProfilePageSettingSectionBlockFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<AccountProfilePageImageBlockFacet>;
  UniqueEmailErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type AccountProfilePageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetCancelButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetCertificateBodyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetCertificateHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountProfilePageFacetCompanyChangeMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetCompanyChangeTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetContactFormHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetContactUsLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AccountProfilePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountProfilePageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetEditLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AccountProfilePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetLetterAddressTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetLetterBodyTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetLetterCompanyNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetLetterCongratulationsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetLetterContactInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetLetterGreetingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetLetterMemberIdTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetLetterMembershipYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetNavHeadingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetPdfFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetRequiredMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetSaveChangesButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountProfilePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountProfilePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountProfilePageFacetUniqueEmailErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AccountProfilePageImageBlock = {
  __typename?: 'AccountProfilePageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type AccountProfilePageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type AccountProfilePageImageBlockAutocomplete = {
  __typename?: 'AccountProfilePageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type AccountProfilePageImageBlockFacet = {
  __typename?: 'AccountProfilePageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AccountProfilePageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AccountProfilePageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccountProfilePageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type AccountProfilePageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type AccountProfilePageLinkBlock = {
  __typename?: 'AccountProfilePageLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type AccountProfilePageLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type AccountProfilePageLinkBlockAutocomplete = {
  __typename?: 'AccountProfilePageLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AccountProfilePageLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccountProfilePageLinkBlockFacet = {
  __typename?: 'AccountProfilePageLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AccountProfilePageLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AccountProfilePageLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccountProfilePageLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type AccountProfilePageLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type AccountProfilePageMemberSectionBlock = {
  __typename?: 'AccountProfilePageMemberSectionBlock';
  DownloadErrorMessage?: Maybe<Scalars['String']['output']>;
  DownloadMembershipCertificateButton?: Maybe<AccountProfilePageMemberSectionBlockLinkBlock>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Level?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MemberSince?: Maybe<Scalars['String']['output']>;
  MembershipExpirationDate?: Maybe<Scalars['String']['output']>;
  RenewNowButtons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Status?: Maybe<Scalars['String']['output']>;
};


export type AccountProfilePageMemberSectionBlockDownloadErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockMemberSinceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockMembershipExpirationDateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockRenewNowButtonsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type AccountProfilePageMemberSectionBlockAutocomplete = {
  __typename?: 'AccountProfilePageMemberSectionBlockAutocomplete';
  DownloadMembershipCertificateButton?: Maybe<AccountProfilePageMemberSectionBlockLinkBlockAutocomplete>;
};

export type AccountProfilePageMemberSectionBlockFacet = {
  __typename?: 'AccountProfilePageMemberSectionBlockFacet';
  DownloadErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadMembershipCertificateButton?: Maybe<AccountProfilePageMemberSectionBlockLinkBlockFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Level?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MemberSince?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipExpirationDate?: Maybe<Array<Maybe<StringFacet>>>;
  RenewNowButtons?: Maybe<ContentAreaItemModelSearchFacet>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AccountProfilePageMemberSectionBlockFacetDownloadErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AccountProfilePageMemberSectionBlockFacetLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockFacetMemberSinceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockFacetMembershipExpirationDateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccountProfilePageMemberSectionBlockLinkBlock = {
  __typename?: 'AccountProfilePageMemberSectionBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type AccountProfilePageMemberSectionBlockLinkBlockAutocomplete = {
  __typename?: 'AccountProfilePageMemberSectionBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccountProfilePageMemberSectionBlockLinkBlockFacet = {
  __typename?: 'AccountProfilePageMemberSectionBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageMemberSectionBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccountProfilePageMemberSectionBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type AccountProfilePageMemberSectionBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type AccountProfilePageMemberSectionBlockOrderByInput = {
  DownloadErrorMessage?: InputMaybe<OrderBy>;
  DownloadMembershipCertificateButton?: InputMaybe<AccountProfilePageMemberSectionBlockLinkBlockOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Level?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MemberSince?: InputMaybe<OrderBy>;
  MembershipExpirationDate?: InputMaybe<OrderBy>;
  RenewNowButtons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Status?: InputMaybe<OrderBy>;
};

export type AccountProfilePageMemberSectionBlockWhereInput = {
  DownloadErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  DownloadMembershipCertificateButton?: InputMaybe<AccountProfilePageMemberSectionBlockLinkBlockWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Level?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MemberSince?: InputMaybe<SearchableStringFilterInput>;
  MembershipExpirationDate?: InputMaybe<SearchableStringFilterInput>;
  RenewNowButtons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Status?: InputMaybe<SearchableStringFilterInput>;
};

export type AccountProfilePageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  CancelButton?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  CertificateBody?: InputMaybe<OrderBy>;
  CertificateHeading?: InputMaybe<OrderBy>;
  CertificateLogoImage?: InputMaybe<AccountProfilePageImageBlockOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyChangeLogoutUrl?: InputMaybe<AccountProfilePageLinkBlockOrderByInput>;
  CompanyChangeMessage?: InputMaybe<OrderBy>;
  CompanyChangeTitle?: InputMaybe<OrderBy>;
  ContactFormHeader?: InputMaybe<OrderBy>;
  ContactUsLink?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  EditLabel?: InputMaybe<OrderBy>;
  ErrorMessage?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LetterAddressText?: InputMaybe<OrderBy>;
  LetterBodyText?: InputMaybe<OrderBy>;
  LetterCompanyName?: InputMaybe<OrderBy>;
  LetterCongratulationsText?: InputMaybe<OrderBy>;
  LetterContactInfoText?: InputMaybe<OrderBy>;
  LetterGreeting?: InputMaybe<OrderBy>;
  LetterLogoImage?: InputMaybe<AccountProfilePageImageBlockOrderByInput>;
  LetterMemberIdText?: InputMaybe<OrderBy>;
  LetterMembershipYear?: InputMaybe<OrderBy>;
  LetterSignatureImagesAndTexts?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MemberSection?: InputMaybe<AccountProfilePageMemberSectionBlockOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<AccountProfilePageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavHeadingLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PdfFileName?: InputMaybe<OrderBy>;
  ProfileSection?: InputMaybe<AccountProfilePageProfileSectionBlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RequiredMessage?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SaveChangesButton?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SettingSection?: InputMaybe<AccountProfilePageSettingSectionBlockOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<AccountProfilePageImageBlockOrderByInput>;
  UniqueEmailErrorText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AccountProfilePageOutput = {
  __typename?: 'AccountProfilePageOutput';
  autocomplete?: Maybe<AccountProfilePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AccountProfilePageFacet>;
  item?: Maybe<AccountProfilePage>;
  items?: Maybe<Array<Maybe<AccountProfilePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type AccountProfilePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountProfilePageProfileSectionBlock = {
  __typename?: 'AccountProfilePageProfileSectionBlock';
  AddLocalAddress?: Maybe<Scalars['String']['output']>;
  AddressFormatError?: Maybe<Scalars['String']['output']>;
  AddressLine1?: Maybe<Scalars['String']['output']>;
  AddressLine2?: Maybe<Scalars['String']['output']>;
  AddressLine3?: Maybe<Scalars['String']['output']>;
  AgencyCompany?: Maybe<Scalars['String']['output']>;
  AgentID?: Maybe<Scalars['String']['output']>;
  AreaCode?: Maybe<Scalars['String']['output']>;
  BrokerCompany?: Maybe<Scalars['String']['output']>;
  BusinessInformationHeading?: Maybe<Scalars['String']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  Company?: Maybe<Scalars['String']['output']>;
  ContactInformationHeading?: Maybe<Scalars['String']['output']>;
  CountryMarket?: Maybe<Scalars['String']['output']>;
  EmailAddress?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FullName?: Maybe<Scalars['String']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  ISOCode?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddress?: Maybe<Scalars['String']['output']>;
  LocalLanguageHelpText?: Maybe<Scalars['String']['output']>;
  LocalMailingAddress?: Maybe<Scalars['String']['output']>;
  MailingAddress?: Maybe<Scalars['String']['output']>;
  MailingAddressHelperText?: Maybe<Scalars['String']['output']>;
  PersonalCompany?: Maybe<Scalars['String']['output']>;
  PersonalInformationHeading?: Maybe<Scalars['String']['output']>;
  PhoneNumber?: Maybe<Scalars['String']['output']>;
  PhoneType?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  PreferredName?: Maybe<Scalars['String']['output']>;
  ProfessionalDesignation?: Maybe<Scalars['String']['output']>;
  RemoveLocalAddressHelperText?: Maybe<Scalars['String']['output']>;
  Salutation?: Maybe<Scalars['String']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Suffix?: Maybe<Scalars['String']['output']>;
  WeChatID?: Maybe<Scalars['String']['output']>;
  YearOfBirth?: Maybe<Scalars['String']['output']>;
};


export type AccountProfilePageProfileSectionBlockAddLocalAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockAddressFormatErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockAddressLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockAddressLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockAddressLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockAgencyCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockBrokerCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockBusinessInformationHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockContactInformationHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockCountryMarketArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockFullNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockGenderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockIsoCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockJobTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockLocalLanguageAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockLocalLanguageHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockLocalMailingAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockMailingAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockMailingAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockPersonalCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockPersonalInformationHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockPhoneTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockPostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockPreferredNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockProfessionalDesignationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockRemoveLocalAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockSalutationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockSuffixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockWeChatIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageProfileSectionBlockYearOfBirthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type AccountProfilePageProfileSectionBlockFacet = {
  __typename?: 'AccountProfilePageProfileSectionBlockFacet';
  AddLocalAddress?: Maybe<Array<Maybe<StringFacet>>>;
  AddressFormatError?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine2?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine3?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyCompany?: Maybe<Array<Maybe<StringFacet>>>;
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  AreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  BrokerCompany?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessInformationHeading?: Maybe<Array<Maybe<StringFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  Company?: Maybe<Array<Maybe<StringFacet>>>;
  ContactInformationHeading?: Maybe<Array<Maybe<StringFacet>>>;
  CountryMarket?: Maybe<Array<Maybe<StringFacet>>>;
  EmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  FirstName?: Maybe<Array<Maybe<StringFacet>>>;
  FullName?: Maybe<Array<Maybe<StringFacet>>>;
  Gender?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  ISOCode?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  JobTitle?: Maybe<Array<Maybe<StringFacet>>>;
  LastName?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddress?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageHelpText?: Maybe<Array<Maybe<StringFacet>>>;
  LocalMailingAddress?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddress?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalCompany?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalInformationHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneType?: Maybe<Array<Maybe<StringFacet>>>;
  PostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredName?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalDesignation?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveLocalAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  Salutation?: Maybe<Array<Maybe<StringFacet>>>;
  State?: Maybe<Array<Maybe<StringFacet>>>;
  Suffix?: Maybe<Array<Maybe<StringFacet>>>;
  WeChatID?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfBirth?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AccountProfilePageProfileSectionBlockFacetAddLocalAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetAddressFormatErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetAddressLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetAddressLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetAddressLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetAgencyCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetBrokerCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetBusinessInformationHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetContactInformationHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetCountryMarketArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetFullNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetGenderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetIsoCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AccountProfilePageProfileSectionBlockFacetJobTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetLocalLanguageAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetLocalLanguageHelpTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetLocalMailingAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetMailingAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetMailingAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetPersonalCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetPersonalInformationHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetPhoneTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetPostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetPreferredNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetProfessionalDesignationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetRemoveLocalAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetSalutationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetSuffixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetWeChatIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageProfileSectionBlockFacetYearOfBirthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccountProfilePageProfileSectionBlockOrderByInput = {
  AddLocalAddress?: InputMaybe<OrderBy>;
  AddressFormatError?: InputMaybe<OrderBy>;
  AddressLine1?: InputMaybe<OrderBy>;
  AddressLine2?: InputMaybe<OrderBy>;
  AddressLine3?: InputMaybe<OrderBy>;
  AgencyCompany?: InputMaybe<OrderBy>;
  AgentID?: InputMaybe<OrderBy>;
  AreaCode?: InputMaybe<OrderBy>;
  BrokerCompany?: InputMaybe<OrderBy>;
  BusinessInformationHeading?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  Company?: InputMaybe<OrderBy>;
  ContactInformationHeading?: InputMaybe<OrderBy>;
  CountryMarket?: InputMaybe<OrderBy>;
  EmailAddress?: InputMaybe<OrderBy>;
  FirstName?: InputMaybe<OrderBy>;
  FullName?: InputMaybe<OrderBy>;
  Gender?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  ISOCode?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  JobTitle?: InputMaybe<OrderBy>;
  LastName?: InputMaybe<OrderBy>;
  LocalLanguageAddress?: InputMaybe<OrderBy>;
  LocalLanguageHelpText?: InputMaybe<OrderBy>;
  LocalMailingAddress?: InputMaybe<OrderBy>;
  MailingAddress?: InputMaybe<OrderBy>;
  MailingAddressHelperText?: InputMaybe<OrderBy>;
  PersonalCompany?: InputMaybe<OrderBy>;
  PersonalInformationHeading?: InputMaybe<OrderBy>;
  PhoneNumber?: InputMaybe<OrderBy>;
  PhoneType?: InputMaybe<OrderBy>;
  PostalCode?: InputMaybe<OrderBy>;
  PreferredName?: InputMaybe<OrderBy>;
  ProfessionalDesignation?: InputMaybe<OrderBy>;
  RemoveLocalAddressHelperText?: InputMaybe<OrderBy>;
  Salutation?: InputMaybe<OrderBy>;
  State?: InputMaybe<OrderBy>;
  Suffix?: InputMaybe<OrderBy>;
  WeChatID?: InputMaybe<OrderBy>;
  YearOfBirth?: InputMaybe<OrderBy>;
};

export type AccountProfilePageProfileSectionBlockWhereInput = {
  AddLocalAddress?: InputMaybe<SearchableStringFilterInput>;
  AddressFormatError?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1?: InputMaybe<SearchableStringFilterInput>;
  AddressLine2?: InputMaybe<SearchableStringFilterInput>;
  AddressLine3?: InputMaybe<SearchableStringFilterInput>;
  AgencyCompany?: InputMaybe<SearchableStringFilterInput>;
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  AreaCode?: InputMaybe<SearchableStringFilterInput>;
  BrokerCompany?: InputMaybe<SearchableStringFilterInput>;
  BusinessInformationHeading?: InputMaybe<SearchableStringFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  Company?: InputMaybe<SearchableStringFilterInput>;
  ContactInformationHeading?: InputMaybe<SearchableStringFilterInput>;
  CountryMarket?: InputMaybe<SearchableStringFilterInput>;
  EmailAddress?: InputMaybe<SearchableStringFilterInput>;
  FirstName?: InputMaybe<SearchableStringFilterInput>;
  FullName?: InputMaybe<SearchableStringFilterInput>;
  Gender?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  ISOCode?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  JobTitle?: InputMaybe<SearchableStringFilterInput>;
  LastName?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddress?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageHelpText?: InputMaybe<SearchableStringFilterInput>;
  LocalMailingAddress?: InputMaybe<SearchableStringFilterInput>;
  MailingAddress?: InputMaybe<SearchableStringFilterInput>;
  MailingAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  PersonalCompany?: InputMaybe<SearchableStringFilterInput>;
  PersonalInformationHeading?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  PhoneType?: InputMaybe<SearchableStringFilterInput>;
  PostalCode?: InputMaybe<SearchableStringFilterInput>;
  PreferredName?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalDesignation?: InputMaybe<SearchableStringFilterInput>;
  RemoveLocalAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  Salutation?: InputMaybe<SearchableStringFilterInput>;
  State?: InputMaybe<SearchableStringFilterInput>;
  Suffix?: InputMaybe<SearchableStringFilterInput>;
  WeChatID?: InputMaybe<SearchableStringFilterInput>;
  YearOfBirth?: InputMaybe<SearchableStringFilterInput>;
};

export type AccountProfilePageSettingSectionBlock = {
  __typename?: 'AccountProfilePageSettingSectionBlock';
  AdditionalLanguagesHeading?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesBusinessAnnouncements?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesContentNewsletter?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesIntroduction?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesMdrtFoundation?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesMdrtMeetings?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesMdrtStore?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesMemberBenefits?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesPleaseSelect?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesUnselectAllExplanation?: Maybe<Scalars['String']['output']>;
  EmailAddressUpdateMessage?: Maybe<Scalars['String']['output']>;
  EmailHeading?: Maybe<Scalars['String']['output']>;
  EmailNotifications?: Maybe<Scalars['String']['output']>;
  EmailNotificationsHeading?: Maybe<Scalars['String']['output']>;
  EmailNotificationsRegardingHeading?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LanguageHeading?: Maybe<Scalars['String']['output']>;
  LoginCredentialsHeading?: Maybe<Scalars['String']['output']>;
  LoginWithFacebook?: Maybe<Scalars['String']['output']>;
  LoginWithGoogle?: Maybe<Scalars['String']['output']>;
  LoginWithLinkedIn?: Maybe<Scalars['String']['output']>;
  LogoutWithFacebook?: Maybe<Scalars['String']['output']>;
  LogoutWithGoogle?: Maybe<Scalars['String']['output']>;
  LogoutWithLinkedIn?: Maybe<Scalars['String']['output']>;
  MdrtIdHeading?: Maybe<Scalars['String']['output']>;
  MemberDirectory?: Maybe<Scalars['String']['output']>;
  MemberDirectoryHeading?: Maybe<Scalars['String']['output']>;
  OptedIn?: Maybe<Scalars['String']['output']>;
  OptedOut?: Maybe<Scalars['String']['output']>;
  PasswordResetButton?: Maybe<AccountProfilePageSettingSectionBlockLinkBlock>;
  PasswordResetImpersonationButton?: Maybe<AccountProfilePageSettingSectionBlockLinkBlock>;
  PermissionsHeading?: Maybe<Scalars['String']['output']>;
  PreferredLanguageHeading?: Maybe<Scalars['String']['output']>;
  RemoveHeading?: Maybe<Scalars['String']['output']>;
  SMSPermissions?: Maybe<Scalars['String']['output']>;
  SocialLoginHeading?: Maybe<Scalars['String']['output']>;
  TextNotificationsHeading?: Maybe<Scalars['String']['output']>;
  UsernameHeading?: Maybe<Scalars['String']['output']>;
};


export type AccountProfilePageSettingSectionBlockAdditionalLanguagesHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockCommunicationPreferencesBusinessAnnouncementsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockCommunicationPreferencesContentNewsletterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockCommunicationPreferencesIntroductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockCommunicationPreferencesMdrtFoundationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockCommunicationPreferencesMdrtMeetingsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockCommunicationPreferencesMdrtStoreArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockCommunicationPreferencesMemberBenefitsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockCommunicationPreferencesPleaseSelectArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockCommunicationPreferencesUnselectAllExplanationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockEmailAddressUpdateMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockEmailHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockEmailNotificationsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockEmailNotificationsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockEmailNotificationsRegardingHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLanguageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLoginCredentialsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLoginWithFacebookArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLoginWithGoogleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLoginWithLinkedInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLogoutWithFacebookArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLogoutWithGoogleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLogoutWithLinkedInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockMdrtIdHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockMemberDirectoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockMemberDirectoryHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockOptedInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockOptedOutArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockPermissionsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockPreferredLanguageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockRemoveHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockSmsPermissionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockSocialLoginHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockTextNotificationsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockUsernameHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type AccountProfilePageSettingSectionBlockAutocomplete = {
  __typename?: 'AccountProfilePageSettingSectionBlockAutocomplete';
  PasswordResetButton?: Maybe<AccountProfilePageSettingSectionBlockLinkBlockAutocomplete>;
  PasswordResetImpersonationButton?: Maybe<AccountProfilePageSettingSectionBlockLinkBlockAutocomplete>;
};

export type AccountProfilePageSettingSectionBlockFacet = {
  __typename?: 'AccountProfilePageSettingSectionBlockFacet';
  AdditionalLanguagesHeading?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesBusinessAnnouncements?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesContentNewsletter?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesIntroduction?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesMdrtFoundation?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesMdrtMeetings?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesMdrtStore?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesMemberBenefits?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesPleaseSelect?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesUnselectAllExplanation?: Maybe<Array<Maybe<StringFacet>>>;
  EmailAddressUpdateMessage?: Maybe<Array<Maybe<StringFacet>>>;
  EmailHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNotifications?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNotificationsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNotificationsRegardingHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LanguageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  LoginCredentialsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  LoginWithFacebook?: Maybe<Array<Maybe<StringFacet>>>;
  LoginWithGoogle?: Maybe<Array<Maybe<StringFacet>>>;
  LoginWithLinkedIn?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutWithFacebook?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutWithGoogle?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutWithLinkedIn?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDirectory?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDirectoryHeading?: Maybe<Array<Maybe<StringFacet>>>;
  OptedIn?: Maybe<Array<Maybe<StringFacet>>>;
  OptedOut?: Maybe<Array<Maybe<StringFacet>>>;
  PasswordResetButton?: Maybe<AccountProfilePageSettingSectionBlockLinkBlockFacet>;
  PasswordResetImpersonationButton?: Maybe<AccountProfilePageSettingSectionBlockLinkBlockFacet>;
  PermissionsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredLanguageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SMSPermissions?: Maybe<Array<Maybe<StringFacet>>>;
  SocialLoginHeading?: Maybe<Array<Maybe<StringFacet>>>;
  TextNotificationsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  UsernameHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AccountProfilePageSettingSectionBlockFacetAdditionalLanguagesHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetCommunicationPreferencesBusinessAnnouncementsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetCommunicationPreferencesContentNewsletterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetCommunicationPreferencesIntroductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetCommunicationPreferencesMdrtFoundationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetCommunicationPreferencesMdrtMeetingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetCommunicationPreferencesMdrtStoreArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetCommunicationPreferencesMemberBenefitsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetCommunicationPreferencesPleaseSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetCommunicationPreferencesUnselectAllExplanationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetEmailAddressUpdateMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetEmailHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetEmailNotificationsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetEmailNotificationsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetEmailNotificationsRegardingHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AccountProfilePageSettingSectionBlockFacetLanguageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetLoginCredentialsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetLoginWithFacebookArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetLoginWithGoogleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetLoginWithLinkedInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetLogoutWithFacebookArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetLogoutWithGoogleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetLogoutWithLinkedInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetMdrtIdHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetMemberDirectoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetMemberDirectoryHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetOptedInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetOptedOutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetPermissionsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetPreferredLanguageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetRemoveHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetSmsPermissionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetSocialLoginHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetTextNotificationsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockFacetUsernameHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccountProfilePageSettingSectionBlockLinkBlock = {
  __typename?: 'AccountProfilePageSettingSectionBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type AccountProfilePageSettingSectionBlockLinkBlockAutocomplete = {
  __typename?: 'AccountProfilePageSettingSectionBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AccountProfilePageSettingSectionBlockLinkBlockFacet = {
  __typename?: 'AccountProfilePageSettingSectionBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AccountProfilePageSettingSectionBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AccountProfilePageSettingSectionBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type AccountProfilePageSettingSectionBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type AccountProfilePageSettingSectionBlockOrderByInput = {
  AdditionalLanguagesHeading?: InputMaybe<OrderBy>;
  CommunicationPreferencesBusinessAnnouncements?: InputMaybe<OrderBy>;
  CommunicationPreferencesContentNewsletter?: InputMaybe<OrderBy>;
  CommunicationPreferencesIntroduction?: InputMaybe<OrderBy>;
  CommunicationPreferencesMdrtFoundation?: InputMaybe<OrderBy>;
  CommunicationPreferencesMdrtMeetings?: InputMaybe<OrderBy>;
  CommunicationPreferencesMdrtStore?: InputMaybe<OrderBy>;
  CommunicationPreferencesMemberBenefits?: InputMaybe<OrderBy>;
  CommunicationPreferencesPleaseSelect?: InputMaybe<OrderBy>;
  CommunicationPreferencesUnselectAllExplanation?: InputMaybe<OrderBy>;
  EmailAddressUpdateMessage?: InputMaybe<OrderBy>;
  EmailHeading?: InputMaybe<OrderBy>;
  EmailNotifications?: InputMaybe<OrderBy>;
  EmailNotificationsHeading?: InputMaybe<OrderBy>;
  EmailNotificationsRegardingHeading?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LanguageHeading?: InputMaybe<OrderBy>;
  LoginCredentialsHeading?: InputMaybe<OrderBy>;
  LoginWithFacebook?: InputMaybe<OrderBy>;
  LoginWithGoogle?: InputMaybe<OrderBy>;
  LoginWithLinkedIn?: InputMaybe<OrderBy>;
  LogoutWithFacebook?: InputMaybe<OrderBy>;
  LogoutWithGoogle?: InputMaybe<OrderBy>;
  LogoutWithLinkedIn?: InputMaybe<OrderBy>;
  MdrtIdHeading?: InputMaybe<OrderBy>;
  MemberDirectory?: InputMaybe<OrderBy>;
  MemberDirectoryHeading?: InputMaybe<OrderBy>;
  OptedIn?: InputMaybe<OrderBy>;
  OptedOut?: InputMaybe<OrderBy>;
  PasswordResetButton?: InputMaybe<AccountProfilePageSettingSectionBlockLinkBlockOrderByInput>;
  PasswordResetImpersonationButton?: InputMaybe<AccountProfilePageSettingSectionBlockLinkBlockOrderByInput>;
  PermissionsHeading?: InputMaybe<OrderBy>;
  PreferredLanguageHeading?: InputMaybe<OrderBy>;
  RemoveHeading?: InputMaybe<OrderBy>;
  SMSPermissions?: InputMaybe<OrderBy>;
  SocialLoginHeading?: InputMaybe<OrderBy>;
  TextNotificationsHeading?: InputMaybe<OrderBy>;
  UsernameHeading?: InputMaybe<OrderBy>;
};

export type AccountProfilePageSettingSectionBlockWhereInput = {
  AdditionalLanguagesHeading?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesBusinessAnnouncements?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesContentNewsletter?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesIntroduction?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesMdrtFoundation?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesMdrtMeetings?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesMdrtStore?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesMemberBenefits?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesPleaseSelect?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesUnselectAllExplanation?: InputMaybe<SearchableStringFilterInput>;
  EmailAddressUpdateMessage?: InputMaybe<SearchableStringFilterInput>;
  EmailHeading?: InputMaybe<SearchableStringFilterInput>;
  EmailNotifications?: InputMaybe<SearchableStringFilterInput>;
  EmailNotificationsHeading?: InputMaybe<SearchableStringFilterInput>;
  EmailNotificationsRegardingHeading?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LanguageHeading?: InputMaybe<SearchableStringFilterInput>;
  LoginCredentialsHeading?: InputMaybe<SearchableStringFilterInput>;
  LoginWithFacebook?: InputMaybe<SearchableStringFilterInput>;
  LoginWithGoogle?: InputMaybe<SearchableStringFilterInput>;
  LoginWithLinkedIn?: InputMaybe<SearchableStringFilterInput>;
  LogoutWithFacebook?: InputMaybe<SearchableStringFilterInput>;
  LogoutWithGoogle?: InputMaybe<SearchableStringFilterInput>;
  LogoutWithLinkedIn?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdHeading?: InputMaybe<SearchableStringFilterInput>;
  MemberDirectory?: InputMaybe<SearchableStringFilterInput>;
  MemberDirectoryHeading?: InputMaybe<SearchableStringFilterInput>;
  OptedIn?: InputMaybe<SearchableStringFilterInput>;
  OptedOut?: InputMaybe<SearchableStringFilterInput>;
  PasswordResetButton?: InputMaybe<AccountProfilePageSettingSectionBlockLinkBlockWhereInput>;
  PasswordResetImpersonationButton?: InputMaybe<AccountProfilePageSettingSectionBlockLinkBlockWhereInput>;
  PermissionsHeading?: InputMaybe<SearchableStringFilterInput>;
  PreferredLanguageHeading?: InputMaybe<SearchableStringFilterInput>;
  RemoveHeading?: InputMaybe<SearchableStringFilterInput>;
  SMSPermissions?: InputMaybe<SearchableStringFilterInput>;
  SocialLoginHeading?: InputMaybe<SearchableStringFilterInput>;
  TextNotificationsHeading?: InputMaybe<SearchableStringFilterInput>;
  UsernameHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type AccountProfilePageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  CancelButton?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  CertificateBody?: InputMaybe<SearchableStringFilterInput>;
  CertificateHeading?: InputMaybe<SearchableStringFilterInput>;
  CertificateLogoImage?: InputMaybe<AccountProfilePageImageBlockWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyChangeLogoutUrl?: InputMaybe<AccountProfilePageLinkBlockWhereInput>;
  CompanyChangeMessage?: InputMaybe<SearchableStringFilterInput>;
  CompanyChangeTitle?: InputMaybe<SearchableStringFilterInput>;
  ContactFormHeader?: InputMaybe<SearchableStringFilterInput>;
  ContactUsLink?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  EditLabel?: InputMaybe<SearchableStringFilterInput>;
  ErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LetterAddressText?: InputMaybe<SearchableStringFilterInput>;
  LetterBodyText?: InputMaybe<SearchableStringFilterInput>;
  LetterCompanyName?: InputMaybe<SearchableStringFilterInput>;
  LetterCongratulationsText?: InputMaybe<SearchableStringFilterInput>;
  LetterContactInfoText?: InputMaybe<SearchableStringFilterInput>;
  LetterGreeting?: InputMaybe<SearchableStringFilterInput>;
  LetterLogoImage?: InputMaybe<AccountProfilePageImageBlockWhereInput>;
  LetterMemberIdText?: InputMaybe<SearchableStringFilterInput>;
  LetterMembershipYear?: InputMaybe<SearchableStringFilterInput>;
  LetterSignatureImagesAndTexts?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MemberSection?: InputMaybe<AccountProfilePageMemberSectionBlockWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<AccountProfilePageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavHeadingLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PdfFileName?: InputMaybe<SearchableStringFilterInput>;
  ProfileSection?: InputMaybe<AccountProfilePageProfileSectionBlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RequiredMessage?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SaveChangesButton?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SettingSection?: InputMaybe<AccountProfilePageSettingSectionBlockWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<AccountProfilePageImageBlockWhereInput>;
  UniqueEmailErrorText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AccountProfilePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AccountProfilePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AccountProfilePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type AddressInfoBlock = IContent & IData & {
  __typename?: 'AddressInfoBlock';
  AddressLineOneInputLabel?: Maybe<Scalars['String']['output']>;
  AddressLineThreeInputLabel?: Maybe<Scalars['String']['output']>;
  AddressLineTwoInputLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CityOrTownInputLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CountryOrMarketInputLabel?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  StateOrProvinceInputLabel?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ZipCodeInputLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type AddressInfoBlockAddressLineOneInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AddressInfoBlockAddressLineThreeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AddressInfoBlockAddressLineTwoInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AddressInfoBlockCityOrTownInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AddressInfoBlockCountryOrMarketInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AddressInfoBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AddressInfoBlockStateOrProvinceInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AddressInfoBlockZipCodeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AddressInfoBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AddressInfoBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AddressInfoBlockAutocomplete = {
  __typename?: 'AddressInfoBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AddressInfoBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddressInfoBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddressInfoBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddressInfoBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddressInfoBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddressInfoBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddressInfoBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddressInfoBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddressInfoBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddressInfoBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AddressInfoBlockFacet = {
  __typename?: 'AddressInfoBlockFacet';
  AddressLineOneInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLineThreeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLineTwoInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CityOrTownInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CountryOrMarketInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StateOrProvinceInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ZipCodeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type AddressInfoBlockFacetAddressLineOneInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetAddressLineThreeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetAddressLineTwoInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AddressInfoBlockFacetCityOrTownInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetCountryOrMarketInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AddressInfoBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AddressInfoBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AddressInfoBlockFacetStateOrProvinceInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AddressInfoBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacetZipCodeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddressInfoBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AddressInfoBlockOrderByInput = {
  AddressLineOneInputLabel?: InputMaybe<OrderBy>;
  AddressLineThreeInputLabel?: InputMaybe<OrderBy>;
  AddressLineTwoInputLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CityOrTownInputLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CountryOrMarketInputLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  StateOrProvinceInputLabel?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ZipCodeInputLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AddressInfoBlockOutput = {
  __typename?: 'AddressInfoBlockOutput';
  autocomplete?: Maybe<AddressInfoBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AddressInfoBlockFacet>;
  item?: Maybe<AddressInfoBlock>;
  items?: Maybe<Array<Maybe<AddressInfoBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type AddressInfoBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressInfoBlockWhereInput = {
  AddressLineOneInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLineThreeInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLineTwoInputLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CityOrTownInputLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CountryOrMarketInputLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  StateOrProvinceInputLabel?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ZipCodeInputLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AddressInfoBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AddressInfoBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AddressInfoBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type AssignedGroupPropertyValue = {
  __typename?: 'AssignedGroupPropertyValue';
  AccessLevels?: Maybe<Scalars['String']['output']>;
  GroupName?: Maybe<Scalars['String']['output']>;
};

export type AssignedGroupPropertyValueAutocomplete = {
  __typename?: 'AssignedGroupPropertyValueAutocomplete';
  AccessLevels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  GroupName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AssignedGroupPropertyValueAutocompleteAccessLevelsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AssignedGroupPropertyValueAutocompleteGroupNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AssignedGroupPropertyValueFacet = {
  __typename?: 'AssignedGroupPropertyValueFacet';
  AccessLevels?: Maybe<Array<Maybe<StringFacet>>>;
  GroupName?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AssignedGroupPropertyValueFacetAccessLevelsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssignedGroupPropertyValueFacetGroupNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AssignedGroupPropertyValueOrderByInput = {
  AccessLevels?: InputMaybe<OrderBy>;
  GroupName?: InputMaybe<OrderBy>;
};

export type AssignedGroupPropertyValueWhereInput = {
  AccessLevels?: InputMaybe<StringFilterInput>;
  GroupName?: InputMaybe<StringFilterInput>;
};

export type AuthorsEntry = {
  __typename?: 'AuthorsEntry';
  Id?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type AuthorsEntryAutocomplete = {
  __typename?: 'AuthorsEntryAutocomplete';
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AuthorsEntryAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AuthorsEntryFacet = {
  __typename?: 'AuthorsEntryFacet';
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AuthorsEntryFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AuthorsEntryFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AuthorsEntryOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type AuthorsEntryWhereInput = {
  Id?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

export type BadgeBlock = IContent & IData & {
  __typename?: 'BadgeBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  COTBadgeLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MDRTBadgeLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TOTBadgeLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type BadgeBlockCotBadgeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BadgeBlockMdrtBadgeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BadgeBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BadgeBlockTotBadgeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BadgeBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BadgeBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BadgeBlockAutocomplete = {
  __typename?: 'BadgeBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BadgeBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BadgeBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BadgeBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BadgeBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BadgeBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BadgeBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BadgeBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BadgeBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BadgeBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BadgeBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BadgeBlockFacet = {
  __typename?: 'BadgeBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  COTBadgeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MDRTBadgeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TOTBadgeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type BadgeBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetCotBadgeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BadgeBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BadgeBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type BadgeBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetMdrtBadgeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BadgeBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BadgeBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BadgeBlockFacetTotBadgeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BadgeBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BadgeBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  COTBadgeLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MDRTBadgeLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TOTBadgeLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BadgeBlockOutput = {
  __typename?: 'BadgeBlockOutput';
  autocomplete?: Maybe<BadgeBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BadgeBlockFacet>;
  item?: Maybe<BadgeBlock>;
  items?: Maybe<Array<Maybe<BadgeBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type BadgeBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BadgeBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  COTBadgeLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MDRTBadgeLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TOTBadgeLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BadgeBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BadgeBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BadgeBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type BlobModel = {
  __typename?: 'BlobModel';
  Id?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
};

export type BlobModelAutocomplete = {
  __typename?: 'BlobModelAutocomplete';
  Id?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BlobModelAutocompleteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BlobModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlobModelFacet = {
  __typename?: 'BlobModelFacet';
  Id?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BlobModelFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BlobModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlobModelOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
};

export type BlobModelWhereInput = {
  Id?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
};

export type BoolFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Renders a 2 column table with a company logo */
export type BrandedTableBlock = IContent & IData & {
  __typename?: 'BrandedTableBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Select the icon to use for the brand icon */
  BrandIconClass?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Renders a 2 column table with a company logo */
export type BrandedTableBlockBrandIconClassArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a 2 column table with a company logo */
export type BrandedTableBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a 2 column table with a company logo */
export type BrandedTableBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a 2 column table with a company logo */
export type BrandedTableBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BrandedTableBlockAutocomplete = {
  __typename?: 'BrandedTableBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BrandedTableBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BrandedTableBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BrandedTableBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BrandedTableBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BrandedTableBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BrandedTableBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BrandedTableBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BrandedTableBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BrandedTableBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BrandedTableBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BrandedTableBlockFacet = {
  __typename?: 'BrandedTableBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BrandIconClass?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type BrandedTableBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacetBrandIconClassArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandedTableBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandedTableBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type BrandedTableBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandedTableBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandedTableBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandedTableBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BrandedTableBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BrandedTableBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BrandIconClass?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BrandedTableBlockOutput = {
  __typename?: 'BrandedTableBlockOutput';
  autocomplete?: Maybe<BrandedTableBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BrandedTableBlockFacet>;
  item?: Maybe<BrandedTableBlock>;
  items?: Maybe<Array<Maybe<BrandedTableBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type BrandedTableBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandedTableBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BrandIconClass?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BrandedTableBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BrandedTableBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BrandedTableBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlock = IContent & IData & {
  __typename?: 'BulkImporterUploaderSectionBlock';
  AlphaNumericSpecialCharactersValidationMessage?: Maybe<Scalars['String']['output']>;
  AlphanumericValidationMessage?: Maybe<Scalars['String']['output']>;
  AmpUploaderHeading?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BirthYearValidationMessage?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CoTDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  ColumnMatchingHelpText?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CotMemberCannotHaveTotDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  CountryValidationMessage?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  CurrentOrPreviousMembershipYearValidationMessage?: Maybe<Scalars['String']['output']>;
  DuplicateAgentValidationMessage?: Maybe<Scalars['String']['output']>;
  DuplicateEmailValidationMessage?: Maybe<Scalars['String']['output']>;
  DuplicatePersonValidationMessage?: Maybe<Scalars['String']['output']>;
  EepUploaderHeading?: Maybe<Scalars['String']['output']>;
  EmailValidationMessage?: Maybe<Scalars['String']['output']>;
  EnglishCharactersOnlyValidationMessage?: Maybe<Scalars['String']['output']>;
  ExceedsMaximumLengthValidationMessage?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  GenderValidationMessage?: Maybe<Scalars['String']['output']>;
  HealthPoliciesUploaderHeading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LanguageValidationMessage?: Maybe<Scalars['String']['output']>;
  LateFeeDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  LengthMustBeBetween2And30CharactersValidationMessage?: Maybe<Scalars['String']['output']>;
  LicenseDateValidationMessage?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  MdrtIdMustBeUniqueValidationMessage?: Maybe<Scalars['String']['output']>;
  MdrtIdValidationMessage?: Maybe<Scalars['String']['output']>;
  MdrtMemberCannotHaveCotDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  MdrtMemberCannotHaveTotDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  MinimumLengthValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBe17YearsAgoValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeMembershipLevelValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeNoValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBePresentBasedOnMembershipLevelValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeQualifyingAndLifeOrLifeValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeQualifyingAndLifeValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeQualifyingValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeYesOrNoValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeYesValidationMessage?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NewIdRequestUploaderHeading?: Maybe<Scalars['String']['output']>;
  NoSpecialCharactersValidationMessage?: Maybe<Scalars['String']['output']>;
  NumericValidationMessage?: Maybe<Scalars['String']['output']>;
  OneOfTheProductionFieldsMustBePresentValidationMessage?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonUpdatesUploaderHeading?: Maybe<Scalars['String']['output']>;
  PhoneNumberValidationMessage?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RequiredValidationMessage?: Maybe<Scalars['String']['output']>;
  ReviewHelpText?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  StateValidationMessage?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  ToTDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  UploadHelpText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WireTransferUploaderHeading?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockAlphaNumericSpecialCharactersValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockAlphanumericValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockAmpUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockBirthYearValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockCoTDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockColumnMatchingHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockCotMemberCannotHaveTotDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockCountryValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockCurrentOrPreviousMembershipYearValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockDuplicateAgentValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockDuplicateEmailValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockDuplicatePersonValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockEepUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockEmailValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockEnglishCharactersOnlyValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockExceedsMaximumLengthValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockGenderValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockHealthPoliciesUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockLanguageValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockLateFeeDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockLengthMustBeBetween2And30CharactersValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockLicenseDateValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMdrtDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMdrtIdMustBeUniqueValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMdrtIdValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMdrtMemberCannotHaveCotDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMdrtMemberCannotHaveTotDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMinimumLengthValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMustBe17YearsAgoValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMustBeMembershipLevelValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMustBeNoValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMustBePresentBasedOnMembershipLevelValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMustBeQualifyingAndLifeOrLifeValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMustBeQualifyingAndLifeValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMustBeQualifyingValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMustBeYesOrNoValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockMustBeYesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockNewIdRequestUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockNoSpecialCharactersValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockNumericValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockOneOfTheProductionFieldsMustBePresentValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockPersonUpdatesUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockPhoneNumberValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockRequiredValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockReviewHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockStateValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockToTDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockUploadHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlockWireTransferUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type BulkImporterUploaderSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BulkImporterUploaderSectionBlockAutocomplete = {
  __typename?: 'BulkImporterUploaderSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BulkImporterUploaderSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BulkImporterUploaderSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BulkImporterUploaderSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BulkImporterUploaderSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BulkImporterUploaderSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BulkImporterUploaderSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BulkImporterUploaderSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BulkImporterUploaderSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BulkImporterUploaderSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BulkImporterUploaderSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BulkImporterUploaderSectionBlockFacet = {
  __typename?: 'BulkImporterUploaderSectionBlockFacet';
  AlphaNumericSpecialCharactersValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  AlphanumericValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  AmpUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BirthYearValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CoTDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ColumnMatchingHelpText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CotMemberCannotHaveTotDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CountryValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CurrentOrPreviousMembershipYearValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  DuplicateAgentValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  DuplicateEmailValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  DuplicatePersonValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  EepUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EmailValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  EnglishCharactersOnlyValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ExceedsMaximumLengthValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GenderValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  HealthPoliciesUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LanguageValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeeDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LengthMustBeBetween2And30CharactersValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LicenseDateValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdMustBeUniqueValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtMemberCannotHaveCotDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtMemberCannotHaveTotDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MinimumLengthValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBe17YearsAgoValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeMembershipLevelValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeNoValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBePresentBasedOnMembershipLevelValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeQualifyingAndLifeOrLifeValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeQualifyingAndLifeValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeQualifyingValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeYesOrNoValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeYesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NewIdRequestUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
  NoSpecialCharactersValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  NumericValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  OneOfTheProductionFieldsMustBePresentValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonUpdatesUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RequiredValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ReviewHelpText?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StateValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ToTDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  UploadHelpText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransferUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type BulkImporterUploaderSectionBlockFacetAlphaNumericSpecialCharactersValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetAlphanumericValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetAmpUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetBirthYearValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BulkImporterUploaderSectionBlockFacetCoTDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetColumnMatchingHelpTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetCotMemberCannotHaveTotDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetCountryValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BulkImporterUploaderSectionBlockFacetCurrentOrPreviousMembershipYearValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetDuplicateAgentValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetDuplicateEmailValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetDuplicatePersonValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetEepUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetEmailValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetEnglishCharactersOnlyValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetExceedsMaximumLengthValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetGenderValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetHealthPoliciesUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type BulkImporterUploaderSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetLanguageValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetLateFeeDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetLengthMustBeBetween2And30CharactersValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetLicenseDateValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMdrtDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMdrtIdMustBeUniqueValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMdrtIdValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMdrtMemberCannotHaveCotDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMdrtMemberCannotHaveTotDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMinimumLengthValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMustBe17YearsAgoValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMustBeMembershipLevelValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMustBeNoValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMustBePresentBasedOnMembershipLevelValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMustBeQualifyingAndLifeOrLifeValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMustBeQualifyingAndLifeValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMustBeQualifyingValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMustBeYesOrNoValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetMustBeYesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetNewIdRequestUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetNoSpecialCharactersValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetNumericValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetOneOfTheProductionFieldsMustBePresentValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetPersonUpdatesUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetPhoneNumberValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetRequiredValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetReviewHelpTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BulkImporterUploaderSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BulkImporterUploaderSectionBlockFacetStateValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BulkImporterUploaderSectionBlockFacetToTDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetUploadHelpTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacetWireTransferUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BulkImporterUploaderSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BulkImporterUploaderSectionBlockOrderByInput = {
  AlphaNumericSpecialCharactersValidationMessage?: InputMaybe<OrderBy>;
  AlphanumericValidationMessage?: InputMaybe<OrderBy>;
  AmpUploaderHeading?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BirthYearValidationMessage?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CoTDuesValidationMessage?: InputMaybe<OrderBy>;
  ColumnMatchingHelpText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CotMemberCannotHaveTotDuesValidationMessage?: InputMaybe<OrderBy>;
  CountryValidationMessage?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CurrentOrPreviousMembershipYearValidationMessage?: InputMaybe<OrderBy>;
  DuplicateAgentValidationMessage?: InputMaybe<OrderBy>;
  DuplicateEmailValidationMessage?: InputMaybe<OrderBy>;
  DuplicatePersonValidationMessage?: InputMaybe<OrderBy>;
  EepUploaderHeading?: InputMaybe<OrderBy>;
  EmailValidationMessage?: InputMaybe<OrderBy>;
  EnglishCharactersOnlyValidationMessage?: InputMaybe<OrderBy>;
  ExceedsMaximumLengthValidationMessage?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GenderValidationMessage?: InputMaybe<OrderBy>;
  HealthPoliciesUploaderHeading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LanguageValidationMessage?: InputMaybe<OrderBy>;
  LateFeeDuesValidationMessage?: InputMaybe<OrderBy>;
  LengthMustBeBetween2And30CharactersValidationMessage?: InputMaybe<OrderBy>;
  LicenseDateValidationMessage?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtDuesValidationMessage?: InputMaybe<OrderBy>;
  MdrtIdMustBeUniqueValidationMessage?: InputMaybe<OrderBy>;
  MdrtIdValidationMessage?: InputMaybe<OrderBy>;
  MdrtMemberCannotHaveCotDuesValidationMessage?: InputMaybe<OrderBy>;
  MdrtMemberCannotHaveTotDuesValidationMessage?: InputMaybe<OrderBy>;
  MinimumLengthValidationMessage?: InputMaybe<OrderBy>;
  MustBe17YearsAgoValidationMessage?: InputMaybe<OrderBy>;
  MustBeMembershipLevelValidationMessage?: InputMaybe<OrderBy>;
  MustBeNoValidationMessage?: InputMaybe<OrderBy>;
  MustBePresentBasedOnMembershipLevelValidationMessage?: InputMaybe<OrderBy>;
  MustBeQualifyingAndLifeOrLifeValidationMessage?: InputMaybe<OrderBy>;
  MustBeQualifyingAndLifeValidationMessage?: InputMaybe<OrderBy>;
  MustBeQualifyingValidationMessage?: InputMaybe<OrderBy>;
  MustBeYesOrNoValidationMessage?: InputMaybe<OrderBy>;
  MustBeYesValidationMessage?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NewIdRequestUploaderHeading?: InputMaybe<OrderBy>;
  NoSpecialCharactersValidationMessage?: InputMaybe<OrderBy>;
  NumericValidationMessage?: InputMaybe<OrderBy>;
  OneOfTheProductionFieldsMustBePresentValidationMessage?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonUpdatesUploaderHeading?: InputMaybe<OrderBy>;
  PhoneNumberValidationMessage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RequiredValidationMessage?: InputMaybe<OrderBy>;
  ReviewHelpText?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  StateValidationMessage?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ToTDuesValidationMessage?: InputMaybe<OrderBy>;
  UploadHelpText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WireTransferUploaderHeading?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BulkImporterUploaderSectionBlockOutput = {
  __typename?: 'BulkImporterUploaderSectionBlockOutput';
  autocomplete?: Maybe<BulkImporterUploaderSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BulkImporterUploaderSectionBlockFacet>;
  item?: Maybe<BulkImporterUploaderSectionBlock>;
  items?: Maybe<Array<Maybe<BulkImporterUploaderSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type BulkImporterUploaderSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkImporterUploaderSectionBlockWhereInput = {
  AlphaNumericSpecialCharactersValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  AlphanumericValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  AmpUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BirthYearValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CoTDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  ColumnMatchingHelpText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CotMemberCannotHaveTotDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  CountryValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CurrentOrPreviousMembershipYearValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  DuplicateAgentValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  DuplicateEmailValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  DuplicatePersonValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  EepUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
  EmailValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  EnglishCharactersOnlyValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  ExceedsMaximumLengthValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GenderValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  HealthPoliciesUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LanguageValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  LateFeeDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  LengthMustBeBetween2And30CharactersValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  LicenseDateValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdMustBeUniqueValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MdrtMemberCannotHaveCotDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MdrtMemberCannotHaveTotDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MinimumLengthValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBe17YearsAgoValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeMembershipLevelValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeNoValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBePresentBasedOnMembershipLevelValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeQualifyingAndLifeOrLifeValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeQualifyingAndLifeValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeQualifyingValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeYesOrNoValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeYesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NewIdRequestUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
  NoSpecialCharactersValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  NumericValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  OneOfTheProductionFieldsMustBePresentValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonUpdatesUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RequiredValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  ReviewHelpText?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  StateValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ToTDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  UploadHelpText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WireTransferUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BulkImporterUploaderSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BulkImporterUploaderSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BulkImporterUploaderSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ButtonLabelBlock = IContent & IData & {
  __typename?: 'ButtonLabelBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackToDashboard?: Maybe<Scalars['String']['output']>;
  BackToDashboardLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ButtonLabelBlockBackToDashboardArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ButtonLabelBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ButtonLabelBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ButtonLabelBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ButtonLabelBlockAutocomplete = {
  __typename?: 'ButtonLabelBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackToDashboardLink?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ButtonLabelBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLabelBlockAutocompleteBackToDashboardLinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLabelBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLabelBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLabelBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLabelBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLabelBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLabelBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLabelBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLabelBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLabelBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonLabelBlockFacet = {
  __typename?: 'ButtonLabelBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackToDashboard?: Maybe<Array<Maybe<StringFacet>>>;
  BackToDashboardLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ButtonLabelBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetBackToDashboardArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetBackToDashboardLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLabelBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLabelBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ButtonLabelBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLabelBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLabelBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLabelBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLabelBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ButtonLabelBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackToDashboard?: InputMaybe<OrderBy>;
  BackToDashboardLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ButtonLabelBlockOutput = {
  __typename?: 'ButtonLabelBlockOutput';
  autocomplete?: Maybe<ButtonLabelBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ButtonLabelBlockFacet>;
  item?: Maybe<ButtonLabelBlock>;
  items?: Maybe<Array<Maybe<ButtonLabelBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ButtonLabelBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLabelBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackToDashboard?: InputMaybe<SearchableStringFilterInput>;
  BackToDashboardLink?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ButtonLabelBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ButtonLabelBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ButtonLabelBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type CaptchaElementBlock = IContent & IData & {
  __typename?: 'CaptchaElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ImageHeight?: Maybe<Scalars['Int']['output']>;
  ImageWidth?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TextLength?: Maybe<Scalars['Int']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type CaptchaElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CaptchaElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CaptchaElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CaptchaElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CaptchaElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CaptchaElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CaptchaElementBlockAutocomplete = {
  __typename?: 'CaptchaElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CaptchaElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockFacet = {
  __typename?: 'CaptchaElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageHeight?: Maybe<Array<Maybe<NumberFacet>>>;
  ImageWidth?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TextLength?: Maybe<Array<Maybe<NumberFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CaptchaElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CaptchaElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CaptchaElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CaptchaElementBlockFacetImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CaptchaElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CaptchaElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CaptchaElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CaptchaElementBlockFacetTextLengthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CaptchaElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CaptchaElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageHeight?: InputMaybe<OrderBy>;
  ImageWidth?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TextLength?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CaptchaElementBlockOutput = {
  __typename?: 'CaptchaElementBlockOutput';
  autocomplete?: Maybe<CaptchaElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CaptchaElementBlockFacet>;
  item?: Maybe<CaptchaElementBlock>;
  items?: Maybe<Array<Maybe<CaptchaElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CaptchaElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CaptchaElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageHeight?: InputMaybe<IntFilterInput>;
  ImageWidth?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TextLength?: InputMaybe<IntFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CaptchaElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CaptchaElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CaptchaElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A block to render the categories tied to a content reference */
export type CategoryListBlock = IContent & IData & {
  __typename?: 'CategoryListBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CategorizableContentReference?: Maybe<ContentModelReference>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block to render the categories tied to a content reference */
export type CategoryListBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block to render the categories tied to a content reference */
export type CategoryListBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block to render the categories tied to a content reference */
export type CategoryListBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CategoryListBlockAutocomplete = {
  __typename?: 'CategoryListBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CategorizableContentReference?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CategoryListBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryListBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryListBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryListBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryListBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryListBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryListBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryListBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryListBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryListBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CategoryListBlockFacet = {
  __typename?: 'CategoryListBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CategorizableContentReference?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CategoryListBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryListBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryListBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CategoryListBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryListBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryListBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryListBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryListBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CategoryListBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CategorizableContentReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CategoryListBlockOutput = {
  __typename?: 'CategoryListBlockOutput';
  autocomplete?: Maybe<CategoryListBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CategoryListBlockFacet>;
  item?: Maybe<CategoryListBlock>;
  items?: Maybe<Array<Maybe<CategoryListBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CategoryListBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryListBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CategorizableContentReference?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CategoryListBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CategoryListBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CategoryListBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type CategoryModel = {
  __typename?: 'CategoryModel';
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type CategoryModelAutocomplete = {
  __typename?: 'CategoryModelAutocomplete';
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CategoryModelAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CategoryModelFacet = {
  __typename?: 'CategoryModelFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CategoryModelFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryModelFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CategoryModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CategoryModelOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type CategoryModelWhereInput = {
  Description?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

/** Holds data for the Company Admin Bulk Import Uploader Section */
export type CertifyingOfficerSectionBlock = IContent & IData & {
  __typename?: 'CertifyingOfficerSectionBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DownloadForm?: Maybe<CertifyingOfficerSectionBlockLinkBlock>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  UploadDescriptionText?: Maybe<Scalars['String']['output']>;
  UploadFileText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type CertifyingOfficerSectionBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type CertifyingOfficerSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type CertifyingOfficerSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type CertifyingOfficerSectionBlockNextButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type CertifyingOfficerSectionBlockUploadDescriptionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type CertifyingOfficerSectionBlockUploadFileTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type CertifyingOfficerSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Uploader Section */
export type CertifyingOfficerSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CertifyingOfficerSectionBlockAutocomplete = {
  __typename?: 'CertifyingOfficerSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DownloadForm?: Maybe<CertifyingOfficerSectionBlockLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CertifyingOfficerSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CertifyingOfficerSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CertifyingOfficerSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CertifyingOfficerSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CertifyingOfficerSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CertifyingOfficerSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CertifyingOfficerSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CertifyingOfficerSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CertifyingOfficerSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CertifyingOfficerSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertifyingOfficerSectionBlockFacet = {
  __typename?: 'CertifyingOfficerSectionBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadForm?: Maybe<CertifyingOfficerSectionBlockLinkBlockFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  UploadDescriptionText?: Maybe<Array<Maybe<StringFacet>>>;
  UploadFileText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CertifyingOfficerSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CertifyingOfficerSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CertifyingOfficerSectionBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CertifyingOfficerSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetNextButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CertifyingOfficerSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CertifyingOfficerSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CertifyingOfficerSectionBlockFacetUploadDescriptionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetUploadFileTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CertifyingOfficerSectionBlockLinkBlock = {
  __typename?: 'CertifyingOfficerSectionBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type CertifyingOfficerSectionBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CertifyingOfficerSectionBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CertifyingOfficerSectionBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CertifyingOfficerSectionBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CertifyingOfficerSectionBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CertifyingOfficerSectionBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CertifyingOfficerSectionBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CertifyingOfficerSectionBlockLinkBlockAutocomplete = {
  __typename?: 'CertifyingOfficerSectionBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CertifyingOfficerSectionBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CertifyingOfficerSectionBlockLinkBlockFacet = {
  __typename?: 'CertifyingOfficerSectionBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CertifyingOfficerSectionBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CertifyingOfficerSectionBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CertifyingOfficerSectionBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CertifyingOfficerSectionBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type CertifyingOfficerSectionBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type CertifyingOfficerSectionBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DownloadForm?: InputMaybe<CertifyingOfficerSectionBlockLinkBlockOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  UploadDescriptionText?: InputMaybe<OrderBy>;
  UploadFileText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CertifyingOfficerSectionBlockOutput = {
  __typename?: 'CertifyingOfficerSectionBlockOutput';
  autocomplete?: Maybe<CertifyingOfficerSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CertifyingOfficerSectionBlockFacet>;
  item?: Maybe<CertifyingOfficerSectionBlock>;
  items?: Maybe<Array<Maybe<CertifyingOfficerSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CertifyingOfficerSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertifyingOfficerSectionBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DownloadForm?: InputMaybe<CertifyingOfficerSectionBlockLinkBlockWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  UploadDescriptionText?: InputMaybe<SearchableStringFilterInput>;
  UploadFileText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CertifyingOfficerSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CertifyingOfficerSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CertifyingOfficerSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used to define CFL membership badges for each year */
export type CflBadgesBlock = IContent & IData & {
  __typename?: 'CflBadgesBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AwardsDiamondBadgeAltText?: Maybe<Scalars['String']['output']>;
  AwardsDiamondBadgeImage?: Maybe<ContentModelReference>;
  AwardsGoldBadgeAltText?: Maybe<Scalars['String']['output']>;
  AwardsGoldBadgeImage?: Maybe<ContentModelReference>;
  AwardsPlatinumBadgeAriaLabel?: Maybe<Scalars['String']['output']>;
  AwardsPlatinumBadgeImage?: Maybe<ContentModelReference>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MembershipBadgeAltText?: Maybe<Scalars['String']['output']>;
  MembershipBadgeImage?: Maybe<ContentModelReference>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SeasonYear?: Maybe<Scalars['Int']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Used to define CFL membership badges for each year */
export type CflBadgesBlockAwardsDiamondBadgeAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define CFL membership badges for each year */
export type CflBadgesBlockAwardsGoldBadgeAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define CFL membership badges for each year */
export type CflBadgesBlockAwardsPlatinumBadgeAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define CFL membership badges for each year */
export type CflBadgesBlockMembershipBadgeAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define CFL membership badges for each year */
export type CflBadgesBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define CFL membership badges for each year */
export type CflBadgesBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define CFL membership badges for each year */
export type CflBadgesBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CflBadgesBlockAutocomplete = {
  __typename?: 'CflBadgesBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AwardsDiamondBadgeImage?: Maybe<ContentModelReferenceAutocomplete>;
  AwardsGoldBadgeImage?: Maybe<ContentModelReferenceAutocomplete>;
  AwardsPlatinumBadgeImage?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MembershipBadgeImage?: Maybe<ContentModelReferenceAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CflBadgesBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflBadgesBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflBadgesBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflBadgesBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflBadgesBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflBadgesBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflBadgesBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflBadgesBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflBadgesBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflBadgesBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CflBadgesBlockFacet = {
  __typename?: 'CflBadgesBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AwardsDiamondBadgeAltText?: Maybe<Array<Maybe<StringFacet>>>;
  AwardsDiamondBadgeImage?: Maybe<ContentModelReferenceFacet>;
  AwardsGoldBadgeAltText?: Maybe<Array<Maybe<StringFacet>>>;
  AwardsGoldBadgeImage?: Maybe<ContentModelReferenceFacet>;
  AwardsPlatinumBadgeAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AwardsPlatinumBadgeImage?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipBadgeAltText?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipBadgeImage?: Maybe<ContentModelReferenceFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SeasonYear?: Maybe<Array<Maybe<NumberFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CflBadgesBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetAwardsDiamondBadgeAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetAwardsGoldBadgeAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetAwardsPlatinumBadgeAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflBadgesBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflBadgesBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CflBadgesBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetMembershipBadgeAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflBadgesBlockFacetSeasonYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CflBadgesBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflBadgesBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflBadgesBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflBadgesBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CflBadgesBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AwardsDiamondBadgeAltText?: InputMaybe<OrderBy>;
  AwardsDiamondBadgeImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  AwardsGoldBadgeAltText?: InputMaybe<OrderBy>;
  AwardsGoldBadgeImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  AwardsPlatinumBadgeAriaLabel?: InputMaybe<OrderBy>;
  AwardsPlatinumBadgeImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipBadgeAltText?: InputMaybe<OrderBy>;
  MembershipBadgeImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SeasonYear?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CflBadgesBlockOutput = {
  __typename?: 'CflBadgesBlockOutput';
  autocomplete?: Maybe<CflBadgesBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CflBadgesBlockFacet>;
  item?: Maybe<CflBadgesBlock>;
  items?: Maybe<Array<Maybe<CflBadgesBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CflBadgesBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CflBadgesBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AwardsDiamondBadgeAltText?: InputMaybe<SearchableStringFilterInput>;
  AwardsDiamondBadgeImage?: InputMaybe<ContentModelReferenceWhereInput>;
  AwardsGoldBadgeAltText?: InputMaybe<SearchableStringFilterInput>;
  AwardsGoldBadgeImage?: InputMaybe<ContentModelReferenceWhereInput>;
  AwardsPlatinumBadgeAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  AwardsPlatinumBadgeImage?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipBadgeAltText?: InputMaybe<SearchableStringFilterInput>;
  MembershipBadgeImage?: InputMaybe<ContentModelReferenceWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SeasonYear?: InputMaybe<IntFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CflBadgesBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CflBadgesBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CflBadgesBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The home page for Center of Field Leadership site */
export type CflHomePage = IContent & IData & {
  __typename?: 'CflHomePage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AuthenticatedContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Badges?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  EnrollmentBadge?: Maybe<CflHomePageLinkBlock>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FoundingMemberTooltip?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MembershipHistoryTitle?: Maybe<Scalars['String']['output']>;
  MembershipKitLinkLabel?: Maybe<Scalars['String']['output']>;
  MembershipYearsLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** This should reference the site settings on the MDRT site. */
  PrimarySiteSettingsPage?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** These cards will appear in the Latest for You section before other cards */
  ResourceCarouselSpecialCards?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ResourcesCarouselTitle?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SiteSettingsPage?: Maybe<ContentModelReference>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The home page for Center of Field Leadership site */
export type CflHomePageAuthenticatedContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for Center of Field Leadership site */
export type CflHomePageBadgesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for Center of Field Leadership site */
export type CflHomePageFoundingMemberTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for Center of Field Leadership site */
export type CflHomePageMembershipHistoryTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for Center of Field Leadership site */
export type CflHomePageMembershipKitLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for Center of Field Leadership site */
export type CflHomePageMembershipYearsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for Center of Field Leadership site */
export type CflHomePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for Center of Field Leadership site */
export type CflHomePageResourceCarouselSpecialCardsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for Center of Field Leadership site */
export type CflHomePageResourcesCarouselTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for Center of Field Leadership site */
export type CflHomePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for Center of Field Leadership site */
export type CflHomePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CflHomePageAutocomplete = {
  __typename?: 'CflHomePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EnrollmentBadge?: Maybe<CflHomePageLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PrimarySiteSettingsPage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteSettingsPage?: Maybe<ContentModelReferenceAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CflHomePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflHomePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflHomePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflHomePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflHomePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflHomePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflHomePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflHomePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflHomePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflHomePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CflHomePageFacet = {
  __typename?: 'CflHomePageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  AuthenticatedContent?: Maybe<ContentAreaItemModelSearchFacet>;
  Badges?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EnrollmentBadge?: Maybe<CflHomePageLinkBlockFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FoundingMemberTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipHistoryTitle?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipKitLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipYearsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PrimarySiteSettingsPage?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ResourceCarouselSpecialCards?: Maybe<ContentAreaItemModelSearchFacet>;
  ResourcesCarouselTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SiteSettingsPage?: Maybe<ContentModelReferenceFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CflHomePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflHomePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CflHomePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflHomePageFacetFoundingMemberTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetMembershipHistoryTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetMembershipKitLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetMembershipYearsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetResourcesCarouselTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflHomePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflHomePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflHomePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CflHomePageLinkBlock = {
  __typename?: 'CflHomePageLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type CflHomePageLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflHomePageLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflHomePageLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflHomePageLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflHomePageLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflHomePageLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflHomePageLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CflHomePageLinkBlockAutocomplete = {
  __typename?: 'CflHomePageLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CflHomePageLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CflHomePageLinkBlockFacet = {
  __typename?: 'CflHomePageLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CflHomePageLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CflHomePageLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflHomePageLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CflHomePageLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type CflHomePageLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type CflHomePageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AuthenticatedContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Badges?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EnrollmentBadge?: InputMaybe<CflHomePageLinkBlockOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FoundingMemberTooltip?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipHistoryTitle?: InputMaybe<OrderBy>;
  MembershipKitLinkLabel?: InputMaybe<OrderBy>;
  MembershipYearsLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PrimarySiteSettingsPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  ResourceCarouselSpecialCards?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ResourcesCarouselTitle?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SiteSettingsPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CflHomePageOutput = {
  __typename?: 'CflHomePageOutput';
  autocomplete?: Maybe<CflHomePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CflHomePageFacet>;
  item?: Maybe<CflHomePage>;
  items?: Maybe<Array<Maybe<CflHomePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CflHomePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CflHomePageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AuthenticatedContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Badges?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EnrollmentBadge?: InputMaybe<CflHomePageLinkBlockWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FoundingMemberTooltip?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipHistoryTitle?: InputMaybe<SearchableStringFilterInput>;
  MembershipKitLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipYearsLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PrimarySiteSettingsPage?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ResourceCarouselSpecialCards?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ResourcesCarouselTitle?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SiteSettingsPage?: InputMaybe<ContentModelReferenceWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CflHomePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CflHomePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CflHomePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used to define cards for membership kit carousel */
export type CflMembershipKitCardBlock = IContent & IData & {
  __typename?: 'CflMembershipKitCardBlock';
  /** Alternative link to show when card is in a different state.Only applicable to some card types */
  AlternativeLink?: Maybe<CflMembershipKitCardBlockLinkBlock>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CardType?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  Link?: Maybe<CflMembershipKitCardBlockLinkBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCardBlockCardTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCardBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCardBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CflMembershipKitCardBlockAutocomplete = {
  __typename?: 'CflMembershipKitCardBlockAutocomplete';
  AlternativeLink?: Maybe<CflMembershipKitCardBlockLinkBlockAutocomplete>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Link?: Maybe<CflMembershipKitCardBlockLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CflMembershipKitCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CflMembershipKitCardBlockFacet = {
  __typename?: 'CflMembershipKitCardBlockFacet';
  AlternativeLink?: Maybe<CflMembershipKitCardBlockLinkBlockFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CardType?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Link?: Maybe<CflMembershipKitCardBlockLinkBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CflMembershipKitCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetCardTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflMembershipKitCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflMembershipKitCardBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CflMembershipKitCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflMembershipKitCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflMembershipKitCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflMembershipKitCardBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CflMembershipKitCardBlockLinkBlock = {
  __typename?: 'CflMembershipKitCardBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type CflMembershipKitCardBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflMembershipKitCardBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflMembershipKitCardBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflMembershipKitCardBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflMembershipKitCardBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflMembershipKitCardBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflMembershipKitCardBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CflMembershipKitCardBlockLinkBlockAutocomplete = {
  __typename?: 'CflMembershipKitCardBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CflMembershipKitCardBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CflMembershipKitCardBlockLinkBlockFacet = {
  __typename?: 'CflMembershipKitCardBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CflMembershipKitCardBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CflMembershipKitCardBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCardBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CflMembershipKitCardBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type CflMembershipKitCardBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type CflMembershipKitCardBlockOrderByInput = {
  AlternativeLink?: InputMaybe<CflMembershipKitCardBlockLinkBlockOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  CardType?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Link?: InputMaybe<CflMembershipKitCardBlockLinkBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CflMembershipKitCardBlockOutput = {
  __typename?: 'CflMembershipKitCardBlockOutput';
  autocomplete?: Maybe<CflMembershipKitCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CflMembershipKitCardBlockFacet>;
  item?: Maybe<CflMembershipKitCardBlock>;
  items?: Maybe<Array<Maybe<CflMembershipKitCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CflMembershipKitCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CflMembershipKitCardBlockWhereInput = {
  AlternativeLink?: InputMaybe<CflMembershipKitCardBlockLinkBlockWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  CardType?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Link?: InputMaybe<CflMembershipKitCardBlockLinkBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CflMembershipKitCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CflMembershipKitCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CflMembershipKitCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used to define cards for membership kit carousel */
export type CflMembershipKitCarouselBlock = IContent & IData & {
  __typename?: 'CflMembershipKitCarouselBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MembershipKitCards?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MembershipKitLabel?: Maybe<Scalars['String']['output']>;
  MembershipKitSectionHash?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCarouselBlockMembershipKitCardsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCarouselBlockMembershipKitLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCarouselBlockMembershipKitSectionHashArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCarouselBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCarouselBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define cards for membership kit carousel */
export type CflMembershipKitCarouselBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CflMembershipKitCarouselBlockAutocomplete = {
  __typename?: 'CflMembershipKitCarouselBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CflMembershipKitCarouselBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCarouselBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCarouselBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCarouselBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCarouselBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCarouselBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCarouselBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCarouselBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCarouselBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflMembershipKitCarouselBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CflMembershipKitCarouselBlockFacet = {
  __typename?: 'CflMembershipKitCarouselBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipKitCards?: Maybe<ContentAreaItemModelSearchFacet>;
  MembershipKitLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipKitSectionHash?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CflMembershipKitCarouselBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflMembershipKitCarouselBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflMembershipKitCarouselBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CflMembershipKitCarouselBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetMembershipKitLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetMembershipKitSectionHashArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflMembershipKitCarouselBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflMembershipKitCarouselBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflMembershipKitCarouselBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflMembershipKitCarouselBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CflMembershipKitCarouselBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipKitCards?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MembershipKitLabel?: InputMaybe<OrderBy>;
  MembershipKitSectionHash?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CflMembershipKitCarouselBlockOutput = {
  __typename?: 'CflMembershipKitCarouselBlockOutput';
  autocomplete?: Maybe<CflMembershipKitCarouselBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CflMembershipKitCarouselBlockFacet>;
  item?: Maybe<CflMembershipKitCarouselBlock>;
  items?: Maybe<Array<Maybe<CflMembershipKitCarouselBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CflMembershipKitCarouselBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CflMembershipKitCarouselBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipKitCards?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MembershipKitLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipKitSectionHash?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CflMembershipKitCarouselBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CflMembershipKitCarouselBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CflMembershipKitCarouselBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPage = IContent & IData & {
  __typename?: 'CflSiteSettingsPage';
  AccessDeniedMessage?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AppDescription?: Maybe<Scalars['String']['output']>;
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Cancel?: Maybe<Scalars['String']['output']>;
  CarouselNextButtonLabel?: Maybe<Scalars['String']['output']>;
  CarouselPreviousButtonLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  CflAwardsPage?: Maybe<ContentModelReference>;
  CflMembershipRenewalPage?: Maybe<ContentModelReference>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Close?: Maybe<Scalars['String']['output']>;
  Confirm?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DefaultRouteTitle?: Maybe<Scalars['String']['output']>;
  EditLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  GenericErrorMessage?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LanguageIdsAndNames?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  LeavingConfirmMessage?: Maybe<Scalars['String']['output']>;
  Loading?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NoLabel?: Maybe<Scalars['String']['output']>;
  NotApplicableLabel?: Maybe<Scalars['String']['output']>;
  PWAPromptAddHomeInstructionsLabelApple?: Maybe<Scalars['String']['output']>;
  PWAPromptAddHomeInstructionsLabelSafari?: Maybe<Scalars['String']['output']>;
  PWAPromptBodyLabelApple?: Maybe<Scalars['String']['output']>;
  PWAPromptBodyLabelSafari?: Maybe<Scalars['String']['output']>;
  PWAPromptBodyLabelWeb?: Maybe<Scalars['String']['output']>;
  PWAPromptCancelLabel?: Maybe<Scalars['String']['output']>;
  PWAPromptInstallLabel?: Maybe<Scalars['String']['output']>;
  PWAPromptShareInstructionsLabelApple?: Maybe<Scalars['String']['output']>;
  PWAPromptShareInstructionsLabelSafari?: Maybe<Scalars['String']['output']>;
  PWAPromptTitleLabelApple?: Maybe<Scalars['String']['output']>;
  PWAPromptTitleLabelSafari?: Maybe<Scalars['String']['output']>;
  PageNotFoundMessage?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SuccessfulSaveMessage?: Maybe<Scalars['String']['output']>;
  TryAgainMessage?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  YesLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageAccessDeniedMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageAppDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageCancelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageCarouselNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageCarouselPreviousButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageCloseArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageConfirmArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageDefaultRouteTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageEditLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageGenericErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageLanguageIdsAndNamesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageLeavingConfirmMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageLoadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageNoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageNotApplicableLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePwaPromptAddHomeInstructionsLabelAppleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePwaPromptAddHomeInstructionsLabelSafariArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePwaPromptBodyLabelAppleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePwaPromptBodyLabelSafariArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePwaPromptBodyLabelWebArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePwaPromptCancelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePwaPromptInstallLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePwaPromptShareInstructionsLabelAppleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePwaPromptShareInstructionsLabelSafariArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePwaPromptTitleLabelAppleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePwaPromptTitleLabelSafariArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPagePageNotFoundMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageSuccessfulSaveMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageTryAgainMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPageYesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the CFL sites */
export type CflSiteSettingsPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CflSiteSettingsPageAutocomplete = {
  __typename?: 'CflSiteSettingsPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  CflAwardsPage?: Maybe<ContentModelReferenceAutocomplete>;
  CflMembershipRenewalPage?: Maybe<ContentModelReferenceAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CflSiteSettingsPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSiteSettingsPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSiteSettingsPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSiteSettingsPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSiteSettingsPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSiteSettingsPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSiteSettingsPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSiteSettingsPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSiteSettingsPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSiteSettingsPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CflSiteSettingsPageFacet = {
  __typename?: 'CflSiteSettingsPageFacet';
  AccessDeniedMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AppDescription?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Cancel?: Maybe<Array<Maybe<StringFacet>>>;
  CarouselNextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CarouselPreviousButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  CflAwardsPage?: Maybe<ContentModelReferenceFacet>;
  CflMembershipRenewalPage?: Maybe<ContentModelReferenceFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Close?: Maybe<Array<Maybe<StringFacet>>>;
  Confirm?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DefaultRouteTitle?: Maybe<Array<Maybe<StringFacet>>>;
  EditLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GenericErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LanguageIdsAndNames?: Maybe<ContentAreaItemModelSearchFacet>;
  LeavingConfirmMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Loading?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NotApplicableLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptAddHomeInstructionsLabelApple?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptAddHomeInstructionsLabelSafari?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptBodyLabelApple?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptBodyLabelSafari?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptBodyLabelWeb?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptCancelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptInstallLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptShareInstructionsLabelApple?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptShareInstructionsLabelSafari?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptTitleLabelApple?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptTitleLabelSafari?: Maybe<Array<Maybe<StringFacet>>>;
  PageNotFoundMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SuccessfulSaveMessage?: Maybe<Array<Maybe<StringFacet>>>;
  TryAgainMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CflSiteSettingsPageFacetAccessDeniedMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetAppDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetCancelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetCarouselNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetCarouselPreviousButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflSiteSettingsPageFacetCloseArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetConfirmArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CflSiteSettingsPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflSiteSettingsPageFacetDefaultRouteTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetEditLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetGenericErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetLeavingConfirmMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetLoadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetNoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetNotApplicableLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPwaPromptAddHomeInstructionsLabelAppleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPwaPromptAddHomeInstructionsLabelSafariArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPwaPromptBodyLabelAppleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPwaPromptBodyLabelSafariArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPwaPromptBodyLabelWebArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPwaPromptCancelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPwaPromptInstallLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPwaPromptShareInstructionsLabelAppleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPwaPromptShareInstructionsLabelSafariArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPwaPromptTitleLabelAppleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPwaPromptTitleLabelSafariArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetPageNotFoundMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflSiteSettingsPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflSiteSettingsPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflSiteSettingsPageFacetSuccessfulSaveMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetTryAgainMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacetYesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSiteSettingsPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CflSiteSettingsPageOrderByInput = {
  AccessDeniedMessage?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AppDescription?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Cancel?: InputMaybe<OrderBy>;
  CarouselNextButtonLabel?: InputMaybe<OrderBy>;
  CarouselPreviousButtonLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  CflAwardsPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  CflMembershipRenewalPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Close?: InputMaybe<OrderBy>;
  Confirm?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DefaultRouteTitle?: InputMaybe<OrderBy>;
  EditLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GenericErrorMessage?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LanguageIdsAndNames?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  LeavingConfirmMessage?: InputMaybe<OrderBy>;
  Loading?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NoLabel?: InputMaybe<OrderBy>;
  NotApplicableLabel?: InputMaybe<OrderBy>;
  PWAPromptAddHomeInstructionsLabelApple?: InputMaybe<OrderBy>;
  PWAPromptAddHomeInstructionsLabelSafari?: InputMaybe<OrderBy>;
  PWAPromptBodyLabelApple?: InputMaybe<OrderBy>;
  PWAPromptBodyLabelSafari?: InputMaybe<OrderBy>;
  PWAPromptBodyLabelWeb?: InputMaybe<OrderBy>;
  PWAPromptCancelLabel?: InputMaybe<OrderBy>;
  PWAPromptInstallLabel?: InputMaybe<OrderBy>;
  PWAPromptShareInstructionsLabelApple?: InputMaybe<OrderBy>;
  PWAPromptShareInstructionsLabelSafari?: InputMaybe<OrderBy>;
  PWAPromptTitleLabelApple?: InputMaybe<OrderBy>;
  PWAPromptTitleLabelSafari?: InputMaybe<OrderBy>;
  PageNotFoundMessage?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SuccessfulSaveMessage?: InputMaybe<OrderBy>;
  TryAgainMessage?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  YesLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CflSiteSettingsPageOutput = {
  __typename?: 'CflSiteSettingsPageOutput';
  autocomplete?: Maybe<CflSiteSettingsPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CflSiteSettingsPageFacet>;
  item?: Maybe<CflSiteSettingsPage>;
  items?: Maybe<Array<Maybe<CflSiteSettingsPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CflSiteSettingsPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CflSiteSettingsPageWhereInput = {
  AccessDeniedMessage?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AppDescription?: InputMaybe<SearchableStringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Cancel?: InputMaybe<SearchableStringFilterInput>;
  CarouselNextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  CarouselPreviousButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  CflAwardsPage?: InputMaybe<ContentModelReferenceWhereInput>;
  CflMembershipRenewalPage?: InputMaybe<ContentModelReferenceWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Close?: InputMaybe<SearchableStringFilterInput>;
  Confirm?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DefaultRouteTitle?: InputMaybe<SearchableStringFilterInput>;
  EditLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GenericErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LanguageIdsAndNames?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  LeavingConfirmMessage?: InputMaybe<SearchableStringFilterInput>;
  Loading?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NoLabel?: InputMaybe<SearchableStringFilterInput>;
  NotApplicableLabel?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptAddHomeInstructionsLabelApple?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptAddHomeInstructionsLabelSafari?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptBodyLabelApple?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptBodyLabelSafari?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptBodyLabelWeb?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptCancelLabel?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptInstallLabel?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptShareInstructionsLabelApple?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptShareInstructionsLabelSafari?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptTitleLabelApple?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptTitleLabelSafari?: InputMaybe<SearchableStringFilterInput>;
  PageNotFoundMessage?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SuccessfulSaveMessage?: InputMaybe<SearchableStringFilterInput>;
  TryAgainMessage?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  YesLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CflSiteSettingsPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CflSiteSettingsPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CflSiteSettingsPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used to define priority cards for Latest For You section */
export type CflSpecialResourceCardBlock = IContent & IData & {
  __typename?: 'CflSpecialResourceCardBlock';
  AccessGroup?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CardIcon?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ImageAltText?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  Link?: Maybe<CflSpecialResourceCardBlockLinkBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Used to define priority cards for Latest For You section */
export type CflSpecialResourceCardBlockAccessGroupArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define priority cards for Latest For You section */
export type CflSpecialResourceCardBlockCardIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define priority cards for Latest For You section */
export type CflSpecialResourceCardBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define priority cards for Latest For You section */
export type CflSpecialResourceCardBlockImageAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define priority cards for Latest For You section */
export type CflSpecialResourceCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define priority cards for Latest For You section */
export type CflSpecialResourceCardBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define priority cards for Latest For You section */
export type CflSpecialResourceCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used to define priority cards for Latest For You section */
export type CflSpecialResourceCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CflSpecialResourceCardBlockAutocomplete = {
  __typename?: 'CflSpecialResourceCardBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Link?: Maybe<CflSpecialResourceCardBlockLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CflSpecialResourceCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSpecialResourceCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSpecialResourceCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSpecialResourceCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSpecialResourceCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSpecialResourceCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSpecialResourceCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSpecialResourceCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSpecialResourceCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CflSpecialResourceCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CflSpecialResourceCardBlockFacet = {
  __typename?: 'CflSpecialResourceCardBlockFacet';
  AccessGroup?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CardIcon?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageAltText?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Link?: Maybe<CflSpecialResourceCardBlockLinkBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CflSpecialResourceCardBlockFacetAccessGroupArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetCardIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflSpecialResourceCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflSpecialResourceCardBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetImageAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CflSpecialResourceCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflSpecialResourceCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflSpecialResourceCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CflSpecialResourceCardBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CflSpecialResourceCardBlockLinkBlock = {
  __typename?: 'CflSpecialResourceCardBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type CflSpecialResourceCardBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflSpecialResourceCardBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflSpecialResourceCardBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflSpecialResourceCardBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflSpecialResourceCardBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflSpecialResourceCardBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CflSpecialResourceCardBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CflSpecialResourceCardBlockLinkBlockAutocomplete = {
  __typename?: 'CflSpecialResourceCardBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CflSpecialResourceCardBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CflSpecialResourceCardBlockLinkBlockFacet = {
  __typename?: 'CflSpecialResourceCardBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CflSpecialResourceCardBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CflSpecialResourceCardBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CflSpecialResourceCardBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CflSpecialResourceCardBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type CflSpecialResourceCardBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type CflSpecialResourceCardBlockOrderByInput = {
  AccessGroup?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  CardIcon?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageAltText?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Link?: InputMaybe<CflSpecialResourceCardBlockLinkBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CflSpecialResourceCardBlockOutput = {
  __typename?: 'CflSpecialResourceCardBlockOutput';
  autocomplete?: Maybe<CflSpecialResourceCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CflSpecialResourceCardBlockFacet>;
  item?: Maybe<CflSpecialResourceCardBlock>;
  items?: Maybe<Array<Maybe<CflSpecialResourceCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CflSpecialResourceCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CflSpecialResourceCardBlockWhereInput = {
  AccessGroup?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  CardIcon?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageAltText?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Link?: InputMaybe<CflSpecialResourceCardBlockLinkBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CflSpecialResourceCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CflSpecialResourceCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CflSpecialResourceCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ChoiceElementBlock = IContent & IData & {
  __typename?: 'ChoiceElementBlock';
  AllowMultiSelect?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Feed?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ChoiceElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlockFeedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ChoiceElementBlockAutocomplete = {
  __typename?: 'ChoiceElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ChoiceElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockFacet = {
  __typename?: 'ChoiceElementBlockFacet';
  AllowMultiSelect?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Feed?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ChoiceElementBlockFacetAllowMultiSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ChoiceElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ChoiceElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ChoiceElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetFeedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ChoiceElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ChoiceElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ChoiceElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ChoiceElementBlockOrderByInput = {
  AllowMultiSelect?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Feed?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ChoiceElementBlockOutput = {
  __typename?: 'ChoiceElementBlockOutput';
  autocomplete?: Maybe<ChoiceElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ChoiceElementBlockFacet>;
  item?: Maybe<ChoiceElementBlock>;
  items?: Maybe<Array<Maybe<ChoiceElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ChoiceElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChoiceElementBlockWhereInput = {
  AllowMultiSelect?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Feed?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ChoiceElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ChoiceElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ChoiceElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A container that can be used to render items in different column layouts */
export type ColumnContainerBlock = IContent & IData & {
  __typename?: 'ColumnContainerBlock';
  /** Add padding between rows at top of content Items */
  AddPaddingBetweenRows?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  /** Makes content stay centered */
  CenterContent?: Maybe<Scalars['Bool']['output']>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** Determines how many columns to render the items in */
  Columns?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** A two column wide footer text area below the items */
  FooterLeftText?: Maybe<Scalars['String']['output']>;
  /** A one column wide footer text area below the items */
  FooterMiddleText?: Maybe<Scalars['String']['output']>;
  /** A one column wide footer text area below the items */
  FooterRightText?: Maybe<Scalars['String']['output']>;
  /** The heading shown above the columns */
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** The items to render in the specified column format */
  Items?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  /** Display the horizontal rule line under the title */
  ShowLine?: Maybe<Scalars['Bool']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Determines the color scheme */
  Theme?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A container that can be used to render items in different column layouts */
export type ColumnContainerBlockColumnsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in different column layouts */
export type ColumnContainerBlockFooterLeftTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in different column layouts */
export type ColumnContainerBlockFooterMiddleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in different column layouts */
export type ColumnContainerBlockFooterRightTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in different column layouts */
export type ColumnContainerBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in different column layouts */
export type ColumnContainerBlockItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in different column layouts */
export type ColumnContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in different column layouts */
export type ColumnContainerBlockThemeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in different column layouts */
export type ColumnContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in different column layouts */
export type ColumnContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ColumnContainerBlockAutocomplete = {
  __typename?: 'ColumnContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ColumnContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ColumnContainerBlockFacet = {
  __typename?: 'ColumnContainerBlockFacet';
  AddPaddingBetweenRows?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  CenterContent?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Columns?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FooterLeftText?: Maybe<Array<Maybe<StringFacet>>>;
  FooterMiddleText?: Maybe<Array<Maybe<StringFacet>>>;
  FooterRightText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<ContentAreaItemModelSearchFacet>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowLine?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Theme?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ColumnContainerBlockFacetAddPaddingBetweenRowsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetCenterContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnContainerBlockFacetColumnsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnContainerBlockFacetFooterLeftTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetFooterMiddleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetFooterRightTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ColumnContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetShowLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnContainerBlockFacetThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ColumnContainerBlockOrderByInput = {
  AddPaddingBetweenRows?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  CenterContent?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  Columns?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FooterLeftText?: InputMaybe<OrderBy>;
  FooterMiddleText?: InputMaybe<OrderBy>;
  FooterRightText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Items?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowLine?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Theme?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ColumnContainerBlockOutput = {
  __typename?: 'ColumnContainerBlockOutput';
  autocomplete?: Maybe<ColumnContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ColumnContainerBlockFacet>;
  item?: Maybe<ColumnContainerBlock>;
  items?: Maybe<Array<Maybe<ColumnContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ColumnContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColumnContainerBlockWhereInput = {
  AddPaddingBetweenRows?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  CenterContent?: InputMaybe<BoolFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Columns?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FooterLeftText?: InputMaybe<SearchableStringFilterInput>;
  FooterMiddleText?: InputMaybe<SearchableStringFilterInput>;
  FooterRightText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowLine?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Theme?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ColumnContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ColumnContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ColumnContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a column links list container block */
export type ColumnLinksListContainerBlock = IContent & IData & {
  __typename?: 'ColumnLinksListContainerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ColumnLinksListItemBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a column links list container block */
export type ColumnLinksListContainerBlockColumnLinksListItemBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a column links list container block */
export type ColumnLinksListContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a column links list container block */
export type ColumnLinksListContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a column links list container block */
export type ColumnLinksListContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ColumnLinksListContainerBlockAutocomplete = {
  __typename?: 'ColumnLinksListContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ColumnLinksListContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ColumnLinksListContainerBlockFacet = {
  __typename?: 'ColumnLinksListContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ColumnLinksListItemBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ColumnLinksListContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnLinksListContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnLinksListContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ColumnLinksListContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnLinksListContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnLinksListContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnLinksListContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ColumnLinksListContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ColumnLinksListItemBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ColumnLinksListContainerBlockOutput = {
  __typename?: 'ColumnLinksListContainerBlockOutput';
  autocomplete?: Maybe<ColumnLinksListContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ColumnLinksListContainerBlockFacet>;
  item?: Maybe<ColumnLinksListContainerBlock>;
  items?: Maybe<Array<Maybe<ColumnLinksListContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ColumnLinksListContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColumnLinksListContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ColumnLinksListItemBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ColumnLinksListContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ColumnLinksListContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ColumnLinksListContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a column links list item block */
export type ColumnLinksListItemBlock = IContent & IData & {
  __typename?: 'ColumnLinksListItemBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** List of links to render */
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** List of links to render */
  LinkList?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a column links list item block */
export type ColumnLinksListItemBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a column links list item block */
export type ColumnLinksListItemBlockLinkListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a column links list item block */
export type ColumnLinksListItemBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a column links list item block */
export type ColumnLinksListItemBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a column links list item block */
export type ColumnLinksListItemBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ColumnLinksListItemBlockAutocomplete = {
  __typename?: 'ColumnLinksListItemBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ColumnLinksListItemBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListItemBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListItemBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListItemBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListItemBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListItemBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListItemBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListItemBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListItemBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ColumnLinksListItemBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ColumnLinksListItemBlockFacet = {
  __typename?: 'ColumnLinksListItemBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkList?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ColumnLinksListItemBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnLinksListItemBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnLinksListItemBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ColumnLinksListItemBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnLinksListItemBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnLinksListItemBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnLinksListItemBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ColumnLinksListItemBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ColumnLinksListItemBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkList?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ColumnLinksListItemBlockOutput = {
  __typename?: 'ColumnLinksListItemBlockOutput';
  autocomplete?: Maybe<ColumnLinksListItemBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ColumnLinksListItemBlockFacet>;
  item?: Maybe<ColumnLinksListItemBlock>;
  items?: Maybe<Array<Maybe<ColumnLinksListItemBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ColumnLinksListItemBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColumnLinksListItemBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkList?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ColumnLinksListItemBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ColumnLinksListItemBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ColumnLinksListItemBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlock = IContent & IData & {
  __typename?: 'CompanyAdminBulkImportDashboardSectionBlock';
  AMPDescription?: Maybe<Scalars['String']['output']>;
  AMPLinkText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Breadcrumb?: Maybe<CompanyAdminBulkImportDashboardSectionBlockLinkBlock>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DescriptionButtonBlock?: Maybe<CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlock>;
  EEPDescription?: Maybe<Scalars['String']['output']>;
  EEPLinkText?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  HealthPoliciesDescription?: Maybe<Scalars['String']['output']>;
  HealthPoliciesText?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NewIDRequestDescription?: Maybe<Scalars['String']['output']>;
  NewIDRequestText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonUpdatesDescription?: Maybe<Scalars['String']['output']>;
  PersonUpdatesText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WireTransferDescription?: Maybe<Scalars['String']['output']>;
  WireTransferText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockAmpDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockAmpLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockEepDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockEepLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockHealthPoliciesDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockHealthPoliciesTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockNewIdRequestDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockNewIdRequestTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockPersonUpdatesDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockPersonUpdatesTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockWireTransferDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlockWireTransferTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Dashboard content for the Company Admin page */
export type CompanyAdminBulkImportDashboardSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CompanyAdminBulkImportDashboardSectionBlockAutocomplete = {
  __typename?: 'CompanyAdminBulkImportDashboardSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Breadcrumb?: Maybe<CompanyAdminBulkImportDashboardSectionBlockLinkBlockAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyAdminBulkImportDashboardSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportDashboardSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportDashboardSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportDashboardSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportDashboardSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportDashboardSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportDashboardSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportDashboardSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportDashboardSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportDashboardSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlock = {
  __typename?: 'CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlock';
  Buttons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  Icon?: Maybe<Scalars['String']['output']>;
  SubText?: Maybe<Scalars['String']['output']>;
  Theme?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockButtonsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockSubTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockThemeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacet = {
  __typename?: 'CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacet';
  Buttons?: Maybe<ContentAreaItemModelSearchFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Icon?: Maybe<Array<Maybe<StringFacet>>>;
  SubText?: Maybe<Array<Maybe<StringFacet>>>;
  Theme?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacetIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacetSubTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacetThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockOrderByInput = {
  Buttons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  Icon?: InputMaybe<OrderBy>;
  SubText?: InputMaybe<OrderBy>;
  Theme?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockWhereInput = {
  Buttons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Icon?: InputMaybe<SearchableStringFilterInput>;
  SubText?: InputMaybe<SearchableStringFilterInput>;
  Theme?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportDashboardSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportDashboardSectionBlockFacet';
  AMPDescription?: Maybe<Array<Maybe<StringFacet>>>;
  AMPLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Breadcrumb?: Maybe<CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DescriptionButtonBlock?: Maybe<CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacet>;
  EEPDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EEPLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HealthPoliciesDescription?: Maybe<Array<Maybe<StringFacet>>>;
  HealthPoliciesText?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NewIDRequestDescription?: Maybe<Array<Maybe<StringFacet>>>;
  NewIDRequestText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonUpdatesDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PersonUpdatesText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransferDescription?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransferText?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetAmpDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetAmpLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetEepDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetEepLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetHealthPoliciesDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetHealthPoliciesTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetNewIdRequestDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetNewIdRequestTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetPersonUpdatesDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetPersonUpdatesTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetWireTransferDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacetWireTransferTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CompanyAdminBulkImportDashboardSectionBlockLinkBlock = {
  __typename?: 'CompanyAdminBulkImportDashboardSectionBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockAutocomplete = {
  __typename?: 'CompanyAdminBulkImportDashboardSectionBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacet = {
  __typename?: 'CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportDashboardSectionBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportDashboardSectionBlockOrderByInput = {
  AMPDescription?: InputMaybe<OrderBy>;
  AMPLinkText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Breadcrumb?: InputMaybe<CompanyAdminBulkImportDashboardSectionBlockLinkBlockOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DescriptionButtonBlock?: InputMaybe<CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockOrderByInput>;
  EEPDescription?: InputMaybe<OrderBy>;
  EEPLinkText?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  HealthPoliciesDescription?: InputMaybe<OrderBy>;
  HealthPoliciesText?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NewIDRequestDescription?: InputMaybe<OrderBy>;
  NewIDRequestText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonUpdatesDescription?: InputMaybe<OrderBy>;
  PersonUpdatesText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WireTransferDescription?: InputMaybe<OrderBy>;
  WireTransferText?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportDashboardSectionBlockOutput = {
  __typename?: 'CompanyAdminBulkImportDashboardSectionBlockOutput';
  autocomplete?: Maybe<CompanyAdminBulkImportDashboardSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CompanyAdminBulkImportDashboardSectionBlockFacet>;
  item?: Maybe<CompanyAdminBulkImportDashboardSectionBlock>;
  items?: Maybe<Array<Maybe<CompanyAdminBulkImportDashboardSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CompanyAdminBulkImportDashboardSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyAdminBulkImportDashboardSectionBlockWhereInput = {
  AMPDescription?: InputMaybe<SearchableStringFilterInput>;
  AMPLinkText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Breadcrumb?: InputMaybe<CompanyAdminBulkImportDashboardSectionBlockLinkBlockWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DescriptionButtonBlock?: InputMaybe<CompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockWhereInput>;
  EEPDescription?: InputMaybe<SearchableStringFilterInput>;
  EEPLinkText?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HealthPoliciesDescription?: InputMaybe<SearchableStringFilterInput>;
  HealthPoliciesText?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NewIDRequestDescription?: InputMaybe<SearchableStringFilterInput>;
  NewIDRequestText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonUpdatesDescription?: InputMaybe<SearchableStringFilterInput>;
  PersonUpdatesText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WireTransferDescription?: InputMaybe<SearchableStringFilterInput>;
  WireTransferText?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CompanyAdminBulkImportDashboardSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CompanyAdminBulkImportDashboardSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CompanyAdminBulkImportDashboardSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Company Admin Bulk Import Dashboard Section */
export type CompanyAdminBulkImportGettingStartedSectionBlock = IContent & IData & {
  __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DescriptionText?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Step1Text?: Maybe<Scalars['String']['output']>;
  Step2Text?: Maybe<Scalars['String']['output']>;
  Step3Text?: Maybe<Scalars['String']['output']>;
  Step4Text?: Maybe<Scalars['String']['output']>;
  Step5Text?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Company Admin Bulk Import Dashboard Section */
export type CompanyAdminBulkImportGettingStartedSectionBlockDescriptionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Dashboard Section */
export type CompanyAdminBulkImportGettingStartedSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Dashboard Section */
export type CompanyAdminBulkImportGettingStartedSectionBlockNextButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Dashboard Section */
export type CompanyAdminBulkImportGettingStartedSectionBlockStep1TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Dashboard Section */
export type CompanyAdminBulkImportGettingStartedSectionBlockStep2TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Dashboard Section */
export type CompanyAdminBulkImportGettingStartedSectionBlockStep3TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Dashboard Section */
export type CompanyAdminBulkImportGettingStartedSectionBlockStep4TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Dashboard Section */
export type CompanyAdminBulkImportGettingStartedSectionBlockStep5TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Dashboard Section */
export type CompanyAdminBulkImportGettingStartedSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Bulk Import Dashboard Section */
export type CompanyAdminBulkImportGettingStartedSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CompanyAdminBulkImportGettingStartedSectionBlockAutocomplete = {
  __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportGettingStartedSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportGettingStartedSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportGettingStartedSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportGettingStartedSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportGettingStartedSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportGettingStartedSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportGettingStartedSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportGettingStartedSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportGettingStartedSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyAdminBulkImportGettingStartedSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DescriptionText?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  Step1Text?: Maybe<Array<Maybe<StringFacet>>>;
  Step2Text?: Maybe<Array<Maybe<StringFacet>>>;
  Step3Text?: Maybe<Array<Maybe<StringFacet>>>;
  Step4Text?: Maybe<Array<Maybe<StringFacet>>>;
  Step5Text?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetDescriptionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetNextButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetStep1TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetStep2TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetStep3TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetStep4TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetStep5TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CompanyAdminBulkImportGettingStartedSectionBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DescriptionText?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  Step1Text?: InputMaybe<OrderBy>;
  Step2Text?: InputMaybe<OrderBy>;
  Step3Text?: InputMaybe<OrderBy>;
  Step4Text?: InputMaybe<OrderBy>;
  Step5Text?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportGettingStartedSectionBlockOutput = {
  __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlockOutput';
  autocomplete?: Maybe<CompanyAdminBulkImportGettingStartedSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CompanyAdminBulkImportGettingStartedSectionBlockFacet>;
  item?: Maybe<CompanyAdminBulkImportGettingStartedSectionBlock>;
  items?: Maybe<Array<Maybe<CompanyAdminBulkImportGettingStartedSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CompanyAdminBulkImportGettingStartedSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyAdminBulkImportGettingStartedSectionBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DescriptionText?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  Step1Text?: InputMaybe<SearchableStringFilterInput>;
  Step2Text?: InputMaybe<SearchableStringFilterInput>;
  Step3Text?: InputMaybe<SearchableStringFilterInput>;
  Step4Text?: InputMaybe<SearchableStringFilterInput>;
  Step5Text?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CompanyAdminBulkImportGettingStartedSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CompanyAdminBulkImportGettingStartedSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CompanyAdminBulkImportGettingStartedSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPage = IContent & IData & {
  __typename?: 'CompanyAdminBulkImportPage';
  /** The AMP Section content */
  AMP?: Maybe<CompanyAdminBulkImportPageAmpSectionBlock>;
  /** The download spreadsheet name should consist of extension .xlsx */
  AMPDownLoadTemplateFileName?: Maybe<Scalars['String']['output']>;
  AmpHeading?: Maybe<Scalars['String']['output']>;
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  /** Contennt rendering below the Main content on page. */
  BottomContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  BulkImporterUploader?: Maybe<CompanyAdminBulkImportPageBulkImporterUploaderSectionBlock>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  CertifyingOfficer?: Maybe<CompanyAdminBulkImportPageCertifyingOfficerSectionBlock>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** The Fashboard content */
  Dashboard?: Maybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlock>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  DownloadUpload?: Maybe<CompanyAdminBulkImportPageDownloadUploadSectionBlock>;
  DownloadUploadBreadcrumbText?: Maybe<Scalars['String']['output']>;
  /** The EEP Section content */
  EEP?: Maybe<CompanyAdminBulkImportPageEepSectionBlock>;
  /** The download spreadsheet name should consist of extension .xlsx */
  EEPDownLoadTemplateFileName?: Maybe<Scalars['String']['output']>;
  EepHeading?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  GettingStarted?: Maybe<CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlock>;
  /** The Person Updates Section content */
  HealthPolicies?: Maybe<CompanyAdminBulkImportPageHealthPoliciesSectionBlock>;
  /** The download spreadsheet name should consist of extension .xlsx */
  HealthPoliciesDownLoadTemplateFileName?: Maybe<Scalars['String']['output']>;
  HealthPoliciesHeading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<CompanyAdminBulkImportPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  /** The New ID Request Section content */
  NewIDRequest?: Maybe<CompanyAdminBulkImportPageNewIdRequestSectionBlock>;
  /** The download spreadsheet name should consist of extension .xlsx */
  NewIdRequestDownLoadTemplateFileName?: Maybe<Scalars['String']['output']>;
  NewIdRequestHeading?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** The Person Updates Section content */
  PersonUpdates?: Maybe<CompanyAdminBulkImportPagePersonUpdatesSectionBlock>;
  /** The download spreadsheet name should consist of extension .xlsx */
  PersonUpdatesDownLoadTemplateFileName?: Maybe<Scalars['String']['output']>;
  PersonUpdatesHeading?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Success?: Maybe<CompanyAdminBulkImportPageSuccessSectionBlock>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<CompanyAdminBulkImportPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** The Wire Transfer Section content */
  WireTransfer?: Maybe<CompanyAdminBulkImportPageWireTransferSectionBlock>;
  /** The download spreadsheet name should consist of extension .xlsx */
  WireTransferDownLoadTemplateFileName?: Maybe<Scalars['String']['output']>;
  WireTransferHeading?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageAmpDownLoadTemplateFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageAmpHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageBottomContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageDownloadUploadBreadcrumbTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageEepDownLoadTemplateFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageEepHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageHealthPoliciesDownLoadTemplateFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageHealthPoliciesHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageNewIdRequestDownLoadTemplateFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageNewIdRequestHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPagePersonUpdatesDownLoadTemplateFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPagePersonUpdatesHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageWireTransferDownLoadTemplateFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPageWireTransferHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Bulk Import Page */
export type CompanyAdminBulkImportPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CompanyAdminBulkImportPageAmpSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPageAMPSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  BackDues?: Maybe<Scalars['String']['output']>;
  BirthYear?: Maybe<Scalars['String']['output']>;
  CourtOfTheTableDuesCOT?: Maybe<Scalars['String']['output']>;
  DidApplicantHaveAnEthicsComplaintStatus?: Maybe<Scalars['String']['output']>;
  FirstGivenName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LastFamilyName?: Maybe<Scalars['String']['output']>;
  LastMemberYear?: Maybe<Scalars['String']['output']>;
  LateFeeAfterMarch1?: Maybe<Scalars['String']['output']>;
  MDRTDues?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MembershipLevel?: Maybe<Scalars['String']['output']>;
  MembershipType?: Maybe<Scalars['String']['output']>;
  NewBusinessIncome?: Maybe<Scalars['String']['output']>;
  OtherCommission?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesCommission?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesIncome?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesPremium?: Maybe<Scalars['String']['output']>;
  OtherPremium?: Maybe<Scalars['String']['output']>;
  RiskProtectionCommission?: Maybe<Scalars['String']['output']>;
  RiskProtectionIncome?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesCommission?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesIncome?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesPremium?: Maybe<Scalars['String']['output']>;
  RiskProtectionPremium?: Maybe<Scalars['String']['output']>;
  TermsAndConditions?: Maybe<Scalars['String']['output']>;
  TopOfTheTableDuesTOT?: Maybe<Scalars['String']['output']>;
  TotalIncome?: Maybe<Scalars['String']['output']>;
  Year?: Maybe<Scalars['String']['output']>;
  YearsOfMembership?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockBackDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockBirthYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockCourtOfTheTableDuesCotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockDidApplicantHaveAnEthicsComplaintStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFirstGivenNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockLastFamilyNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockLastMemberYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockLateFeeAfterMarch1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockMdrtDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockMembershipTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockNewBusinessIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockOtherCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockOtherPoliciesCasesCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockOtherPoliciesCasesIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockOtherPoliciesCasesPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockOtherPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockRiskProtectionCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockRiskProtectionIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockRiskProtectionPoliciesCasesCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockRiskProtectionPoliciesCasesIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockRiskProtectionPoliciesCasesPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockRiskProtectionPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockTermsAndConditionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockTopOfTheTableDuesTotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockTotalIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockYearsOfMembershipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageAmpSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageAMPSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  BackDues?: Maybe<Array<Maybe<StringFacet>>>;
  BirthYear?: Maybe<Array<Maybe<StringFacet>>>;
  CourtOfTheTableDuesCOT?: Maybe<Array<Maybe<StringFacet>>>;
  DidApplicantHaveAnEthicsComplaintStatus?: Maybe<Array<Maybe<StringFacet>>>;
  FirstGivenName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LastFamilyName?: Maybe<Array<Maybe<StringFacet>>>;
  LastMemberYear?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeeAfterMarch1?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTDues?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipType?: Maybe<Array<Maybe<StringFacet>>>;
  NewBusinessIncome?: Maybe<Array<Maybe<StringFacet>>>;
  OtherCommission?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesCommission?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesIncome?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesPremium?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPremium?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionCommission?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionIncome?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesCommission?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesIncome?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesPremium?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPremium?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditions?: Maybe<Array<Maybe<StringFacet>>>;
  TopOfTheTableDuesTOT?: Maybe<Array<Maybe<StringFacet>>>;
  TotalIncome?: Maybe<Array<Maybe<StringFacet>>>;
  Year?: Maybe<Array<Maybe<StringFacet>>>;
  YearsOfMembership?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetBackDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetBirthYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetCourtOfTheTableDuesCotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetDidApplicantHaveAnEthicsComplaintStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetFirstGivenNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetLastFamilyNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetLastMemberYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetLateFeeAfterMarch1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetMdrtDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetMembershipLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetMembershipTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetNewBusinessIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetOtherCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetOtherPoliciesCasesCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetOtherPoliciesCasesIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetOtherPoliciesCasesPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetOtherPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetRiskProtectionCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetRiskProtectionIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetRiskProtectionPoliciesCasesCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetRiskProtectionPoliciesCasesIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetRiskProtectionPoliciesCasesPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetRiskProtectionPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetTermsAndConditionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetTopOfTheTableDuesTotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetTotalIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageAmpSectionBlockFacetYearsOfMembershipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageAmpSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  BackDues?: InputMaybe<OrderBy>;
  BirthYear?: InputMaybe<OrderBy>;
  CourtOfTheTableDuesCOT?: InputMaybe<OrderBy>;
  DidApplicantHaveAnEthicsComplaintStatus?: InputMaybe<OrderBy>;
  FirstGivenName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LastFamilyName?: InputMaybe<OrderBy>;
  LastMemberYear?: InputMaybe<OrderBy>;
  LateFeeAfterMarch1?: InputMaybe<OrderBy>;
  MDRTDues?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MembershipLevel?: InputMaybe<OrderBy>;
  MembershipType?: InputMaybe<OrderBy>;
  NewBusinessIncome?: InputMaybe<OrderBy>;
  OtherCommission?: InputMaybe<OrderBy>;
  OtherPoliciesCasesCommission?: InputMaybe<OrderBy>;
  OtherPoliciesCasesIncome?: InputMaybe<OrderBy>;
  OtherPoliciesCasesPremium?: InputMaybe<OrderBy>;
  OtherPremium?: InputMaybe<OrderBy>;
  RiskProtectionCommission?: InputMaybe<OrderBy>;
  RiskProtectionIncome?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesCommission?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesIncome?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesPremium?: InputMaybe<OrderBy>;
  RiskProtectionPremium?: InputMaybe<OrderBy>;
  TermsAndConditions?: InputMaybe<OrderBy>;
  TopOfTheTableDuesTOT?: InputMaybe<OrderBy>;
  TotalIncome?: InputMaybe<OrderBy>;
  Year?: InputMaybe<OrderBy>;
  YearsOfMembership?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageAmpSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  BackDues?: InputMaybe<SearchableStringFilterInput>;
  BirthYear?: InputMaybe<SearchableStringFilterInput>;
  CourtOfTheTableDuesCOT?: InputMaybe<SearchableStringFilterInput>;
  DidApplicantHaveAnEthicsComplaintStatus?: InputMaybe<SearchableStringFilterInput>;
  FirstGivenName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LastFamilyName?: InputMaybe<SearchableStringFilterInput>;
  LastMemberYear?: InputMaybe<SearchableStringFilterInput>;
  LateFeeAfterMarch1?: InputMaybe<SearchableStringFilterInput>;
  MDRTDues?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevel?: InputMaybe<SearchableStringFilterInput>;
  MembershipType?: InputMaybe<SearchableStringFilterInput>;
  NewBusinessIncome?: InputMaybe<SearchableStringFilterInput>;
  OtherCommission?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesCommission?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesIncome?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesPremium?: InputMaybe<SearchableStringFilterInput>;
  OtherPremium?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionCommission?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionIncome?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesCommission?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesIncome?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesPremium?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPremium?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditions?: InputMaybe<SearchableStringFilterInput>;
  TopOfTheTableDuesTOT?: InputMaybe<SearchableStringFilterInput>;
  TotalIncome?: InputMaybe<SearchableStringFilterInput>;
  Year?: InputMaybe<SearchableStringFilterInput>;
  YearsOfMembership?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageAutocomplete = {
  __typename?: 'CompanyAdminBulkImportPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  CertifyingOfficer?: Maybe<CompanyAdminBulkImportPageCertifyingOfficerSectionBlockAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Dashboard?: Maybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<CompanyAdminBulkImportPageImageBlockAutocomplete>;
  NewIDRequest?: Maybe<CompanyAdminBulkImportPageNewIdRequestSectionBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<CompanyAdminBulkImportPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyAdminBulkImportPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminBulkImportPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPageBulkImporterUploaderSectionBlock';
  AlphaNumericSpecialCharactersValidationMessage?: Maybe<Scalars['String']['output']>;
  AlphanumericValidationMessage?: Maybe<Scalars['String']['output']>;
  AmpUploaderHeading?: Maybe<Scalars['String']['output']>;
  BirthYearValidationMessage?: Maybe<Scalars['String']['output']>;
  CoTDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  ColumnMatchingHelpText?: Maybe<Scalars['String']['output']>;
  CotMemberCannotHaveTotDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  CountryValidationMessage?: Maybe<Scalars['String']['output']>;
  CurrentOrPreviousMembershipYearValidationMessage?: Maybe<Scalars['String']['output']>;
  DuplicateAgentValidationMessage?: Maybe<Scalars['String']['output']>;
  DuplicateEmailValidationMessage?: Maybe<Scalars['String']['output']>;
  DuplicatePersonValidationMessage?: Maybe<Scalars['String']['output']>;
  EepUploaderHeading?: Maybe<Scalars['String']['output']>;
  EmailValidationMessage?: Maybe<Scalars['String']['output']>;
  EnglishCharactersOnlyValidationMessage?: Maybe<Scalars['String']['output']>;
  ExceedsMaximumLengthValidationMessage?: Maybe<Scalars['String']['output']>;
  GenderValidationMessage?: Maybe<Scalars['String']['output']>;
  HealthPoliciesUploaderHeading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LanguageValidationMessage?: Maybe<Scalars['String']['output']>;
  LateFeeDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  LengthMustBeBetween2And30CharactersValidationMessage?: Maybe<Scalars['String']['output']>;
  LicenseDateValidationMessage?: Maybe<Scalars['String']['output']>;
  MdrtDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  MdrtIdMustBeUniqueValidationMessage?: Maybe<Scalars['String']['output']>;
  MdrtIdValidationMessage?: Maybe<Scalars['String']['output']>;
  MdrtMemberCannotHaveCotDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  MdrtMemberCannotHaveTotDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  MinimumLengthValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBe17YearsAgoValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeMembershipLevelValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeNoValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBePresentBasedOnMembershipLevelValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeQualifyingAndLifeOrLifeValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeQualifyingAndLifeValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeQualifyingValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeYesOrNoValidationMessage?: Maybe<Scalars['String']['output']>;
  MustBeYesValidationMessage?: Maybe<Scalars['String']['output']>;
  NewIdRequestUploaderHeading?: Maybe<Scalars['String']['output']>;
  NoSpecialCharactersValidationMessage?: Maybe<Scalars['String']['output']>;
  NumericValidationMessage?: Maybe<Scalars['String']['output']>;
  OneOfTheProductionFieldsMustBePresentValidationMessage?: Maybe<Scalars['String']['output']>;
  PersonUpdatesUploaderHeading?: Maybe<Scalars['String']['output']>;
  PhoneNumberValidationMessage?: Maybe<Scalars['String']['output']>;
  RequiredValidationMessage?: Maybe<Scalars['String']['output']>;
  ReviewHelpText?: Maybe<Scalars['String']['output']>;
  StateValidationMessage?: Maybe<Scalars['String']['output']>;
  ToTDuesValidationMessage?: Maybe<Scalars['String']['output']>;
  UploadHelpText?: Maybe<Scalars['String']['output']>;
  WireTransferUploaderHeading?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockAlphaNumericSpecialCharactersValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockAlphanumericValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockAmpUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockBirthYearValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockCoTDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockColumnMatchingHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockCotMemberCannotHaveTotDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockCountryValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockCurrentOrPreviousMembershipYearValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockDuplicateAgentValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockDuplicateEmailValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockDuplicatePersonValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockEepUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockEmailValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockEnglishCharactersOnlyValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockExceedsMaximumLengthValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockGenderValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockHealthPoliciesUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockLanguageValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockLateFeeDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockLengthMustBeBetween2And30CharactersValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockLicenseDateValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMdrtDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMdrtIdMustBeUniqueValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMdrtIdValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMdrtMemberCannotHaveCotDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMdrtMemberCannotHaveTotDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMinimumLengthValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMustBe17YearsAgoValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMustBeMembershipLevelValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMustBeNoValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMustBePresentBasedOnMembershipLevelValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMustBeQualifyingAndLifeOrLifeValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMustBeQualifyingAndLifeValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMustBeQualifyingValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMustBeYesOrNoValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockMustBeYesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockNewIdRequestUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockNoSpecialCharactersValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockNumericValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockOneOfTheProductionFieldsMustBePresentValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockPersonUpdatesUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockPhoneNumberValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockRequiredValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockReviewHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockStateValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockToTDuesValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockUploadHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockWireTransferUploaderHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacet';
  AlphaNumericSpecialCharactersValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  AlphanumericValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  AmpUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
  BirthYearValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CoTDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ColumnMatchingHelpText?: Maybe<Array<Maybe<StringFacet>>>;
  CotMemberCannotHaveTotDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CountryValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CurrentOrPreviousMembershipYearValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  DuplicateAgentValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  DuplicateEmailValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  DuplicatePersonValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  EepUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EmailValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  EnglishCharactersOnlyValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ExceedsMaximumLengthValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  GenderValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  HealthPoliciesUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LanguageValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeeDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LengthMustBeBetween2And30CharactersValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LicenseDateValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdMustBeUniqueValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtMemberCannotHaveCotDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtMemberCannotHaveTotDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MinimumLengthValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBe17YearsAgoValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeMembershipLevelValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeNoValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBePresentBasedOnMembershipLevelValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeQualifyingAndLifeOrLifeValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeQualifyingAndLifeValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeQualifyingValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeYesOrNoValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MustBeYesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  NewIdRequestUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
  NoSpecialCharactersValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  NumericValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  OneOfTheProductionFieldsMustBePresentValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  PersonUpdatesUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  RequiredValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ReviewHelpText?: Maybe<Array<Maybe<StringFacet>>>;
  StateValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ToTDuesValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  UploadHelpText?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransferUploaderHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetAlphaNumericSpecialCharactersValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetAlphanumericValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetAmpUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetBirthYearValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetCoTDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetColumnMatchingHelpTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetCotMemberCannotHaveTotDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetCountryValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetCurrentOrPreviousMembershipYearValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetDuplicateAgentValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetDuplicateEmailValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetDuplicatePersonValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetEepUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetEmailValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetEnglishCharactersOnlyValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetExceedsMaximumLengthValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetGenderValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetHealthPoliciesUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetLanguageValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetLateFeeDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetLengthMustBeBetween2And30CharactersValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetLicenseDateValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMdrtDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMdrtIdMustBeUniqueValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMdrtIdValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMdrtMemberCannotHaveCotDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMdrtMemberCannotHaveTotDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMinimumLengthValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMustBe17YearsAgoValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMustBeMembershipLevelValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMustBeNoValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMustBePresentBasedOnMembershipLevelValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMustBeQualifyingAndLifeOrLifeValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMustBeQualifyingAndLifeValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMustBeQualifyingValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMustBeYesOrNoValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetMustBeYesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetNewIdRequestUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetNoSpecialCharactersValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetNumericValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetOneOfTheProductionFieldsMustBePresentValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetPersonUpdatesUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetPhoneNumberValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetRequiredValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetReviewHelpTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetStateValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetToTDuesValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetUploadHelpTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacetWireTransferUploaderHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockOrderByInput = {
  AlphaNumericSpecialCharactersValidationMessage?: InputMaybe<OrderBy>;
  AlphanumericValidationMessage?: InputMaybe<OrderBy>;
  AmpUploaderHeading?: InputMaybe<OrderBy>;
  BirthYearValidationMessage?: InputMaybe<OrderBy>;
  CoTDuesValidationMessage?: InputMaybe<OrderBy>;
  ColumnMatchingHelpText?: InputMaybe<OrderBy>;
  CotMemberCannotHaveTotDuesValidationMessage?: InputMaybe<OrderBy>;
  CountryValidationMessage?: InputMaybe<OrderBy>;
  CurrentOrPreviousMembershipYearValidationMessage?: InputMaybe<OrderBy>;
  DuplicateAgentValidationMessage?: InputMaybe<OrderBy>;
  DuplicateEmailValidationMessage?: InputMaybe<OrderBy>;
  DuplicatePersonValidationMessage?: InputMaybe<OrderBy>;
  EepUploaderHeading?: InputMaybe<OrderBy>;
  EmailValidationMessage?: InputMaybe<OrderBy>;
  EnglishCharactersOnlyValidationMessage?: InputMaybe<OrderBy>;
  ExceedsMaximumLengthValidationMessage?: InputMaybe<OrderBy>;
  GenderValidationMessage?: InputMaybe<OrderBy>;
  HealthPoliciesUploaderHeading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LanguageValidationMessage?: InputMaybe<OrderBy>;
  LateFeeDuesValidationMessage?: InputMaybe<OrderBy>;
  LengthMustBeBetween2And30CharactersValidationMessage?: InputMaybe<OrderBy>;
  LicenseDateValidationMessage?: InputMaybe<OrderBy>;
  MdrtDuesValidationMessage?: InputMaybe<OrderBy>;
  MdrtIdMustBeUniqueValidationMessage?: InputMaybe<OrderBy>;
  MdrtIdValidationMessage?: InputMaybe<OrderBy>;
  MdrtMemberCannotHaveCotDuesValidationMessage?: InputMaybe<OrderBy>;
  MdrtMemberCannotHaveTotDuesValidationMessage?: InputMaybe<OrderBy>;
  MinimumLengthValidationMessage?: InputMaybe<OrderBy>;
  MustBe17YearsAgoValidationMessage?: InputMaybe<OrderBy>;
  MustBeMembershipLevelValidationMessage?: InputMaybe<OrderBy>;
  MustBeNoValidationMessage?: InputMaybe<OrderBy>;
  MustBePresentBasedOnMembershipLevelValidationMessage?: InputMaybe<OrderBy>;
  MustBeQualifyingAndLifeOrLifeValidationMessage?: InputMaybe<OrderBy>;
  MustBeQualifyingAndLifeValidationMessage?: InputMaybe<OrderBy>;
  MustBeQualifyingValidationMessage?: InputMaybe<OrderBy>;
  MustBeYesOrNoValidationMessage?: InputMaybe<OrderBy>;
  MustBeYesValidationMessage?: InputMaybe<OrderBy>;
  NewIdRequestUploaderHeading?: InputMaybe<OrderBy>;
  NoSpecialCharactersValidationMessage?: InputMaybe<OrderBy>;
  NumericValidationMessage?: InputMaybe<OrderBy>;
  OneOfTheProductionFieldsMustBePresentValidationMessage?: InputMaybe<OrderBy>;
  PersonUpdatesUploaderHeading?: InputMaybe<OrderBy>;
  PhoneNumberValidationMessage?: InputMaybe<OrderBy>;
  RequiredValidationMessage?: InputMaybe<OrderBy>;
  ReviewHelpText?: InputMaybe<OrderBy>;
  StateValidationMessage?: InputMaybe<OrderBy>;
  ToTDuesValidationMessage?: InputMaybe<OrderBy>;
  UploadHelpText?: InputMaybe<OrderBy>;
  WireTransferUploaderHeading?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockWhereInput = {
  AlphaNumericSpecialCharactersValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  AlphanumericValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  AmpUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
  BirthYearValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  CoTDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  ColumnMatchingHelpText?: InputMaybe<SearchableStringFilterInput>;
  CotMemberCannotHaveTotDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  CountryValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  CurrentOrPreviousMembershipYearValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  DuplicateAgentValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  DuplicateEmailValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  DuplicatePersonValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  EepUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
  EmailValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  EnglishCharactersOnlyValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  ExceedsMaximumLengthValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  GenderValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  HealthPoliciesUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LanguageValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  LateFeeDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  LengthMustBeBetween2And30CharactersValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  LicenseDateValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MdrtDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdMustBeUniqueValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MdrtMemberCannotHaveCotDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MdrtMemberCannotHaveTotDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MinimumLengthValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBe17YearsAgoValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeMembershipLevelValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeNoValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBePresentBasedOnMembershipLevelValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeQualifyingAndLifeOrLifeValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeQualifyingAndLifeValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeQualifyingValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeYesOrNoValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  MustBeYesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  NewIdRequestUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
  NoSpecialCharactersValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  NumericValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  OneOfTheProductionFieldsMustBePresentValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  PersonUpdatesUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  RequiredValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  ReviewHelpText?: InputMaybe<SearchableStringFilterInput>;
  StateValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  ToTDuesValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  UploadHelpText?: InputMaybe<SearchableStringFilterInput>;
  WireTransferUploaderHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPageCertifyingOfficerSectionBlock';
  Description?: Maybe<Scalars['String']['output']>;
  DownloadForm?: Maybe<CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlock>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  NextButtonText?: Maybe<Scalars['String']['output']>;
  UploadDescriptionText?: Maybe<Scalars['String']['output']>;
  UploadFileText?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockNextButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockUploadDescriptionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockUploadFileTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockAutocomplete = {
  __typename?: 'CompanyAdminBulkImportPageCertifyingOfficerSectionBlockAutocomplete';
  DownloadForm?: Maybe<CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockAutocomplete>;
};

export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageCertifyingOfficerSectionBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadForm?: Maybe<CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  NextButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  UploadDescriptionText?: Maybe<Array<Maybe<StringFacet>>>;
  UploadFileText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockFacetNextButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockFacetUploadDescriptionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockFacetUploadFileTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlock = {
  __typename?: 'CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockAutocomplete = {
  __typename?: 'CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  DownloadForm?: InputMaybe<CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  NextButtonText?: InputMaybe<OrderBy>;
  UploadDescriptionText?: InputMaybe<OrderBy>;
  UploadFileText?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageCertifyingOfficerSectionBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  DownloadForm?: InputMaybe<CompanyAdminBulkImportPageCertifyingOfficerSectionBlockLinkBlockWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  NextButtonText?: InputMaybe<SearchableStringFilterInput>;
  UploadDescriptionText?: InputMaybe<SearchableStringFilterInput>;
  UploadFileText?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlock';
  AMPDescription?: Maybe<Scalars['String']['output']>;
  AMPLinkText?: Maybe<Scalars['String']['output']>;
  Breadcrumb?: Maybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlock>;
  Description?: Maybe<Scalars['String']['output']>;
  DescriptionButtonBlock?: Maybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlock>;
  EEPDescription?: Maybe<Scalars['String']['output']>;
  EEPLinkText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HealthPoliciesDescription?: Maybe<Scalars['String']['output']>;
  HealthPoliciesText?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  NewIDRequestDescription?: Maybe<Scalars['String']['output']>;
  NewIDRequestText?: Maybe<Scalars['String']['output']>;
  PersonUpdatesDescription?: Maybe<Scalars['String']['output']>;
  PersonUpdatesText?: Maybe<Scalars['String']['output']>;
  WireTransferDescription?: Maybe<Scalars['String']['output']>;
  WireTransferText?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockAmpDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockAmpLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockEepDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockEepLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockHealthPoliciesDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockHealthPoliciesTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockNewIdRequestDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockNewIdRequestTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockPersonUpdatesDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockPersonUpdatesTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockWireTransferDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockWireTransferTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockAutocomplete = {
  __typename?: 'CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockAutocomplete';
  Breadcrumb?: Maybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockAutocomplete>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlock = {
  __typename?: 'CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlock';
  Buttons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  Icon?: Maybe<Scalars['String']['output']>;
  SubText?: Maybe<Scalars['String']['output']>;
  Theme?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockButtonsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockSubTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockThemeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacet';
  Buttons?: Maybe<ContentAreaItemModelSearchFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Icon?: Maybe<Array<Maybe<StringFacet>>>;
  SubText?: Maybe<Array<Maybe<StringFacet>>>;
  Theme?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacetIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacetSubTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacetThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockOrderByInput = {
  Buttons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  Icon?: InputMaybe<OrderBy>;
  SubText?: InputMaybe<OrderBy>;
  Theme?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockWhereInput = {
  Buttons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Icon?: InputMaybe<SearchableStringFilterInput>;
  SubText?: InputMaybe<SearchableStringFilterInput>;
  Theme?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacet';
  AMPDescription?: Maybe<Array<Maybe<StringFacet>>>;
  AMPLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  Breadcrumb?: Maybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DescriptionButtonBlock?: Maybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockFacet>;
  EEPDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EEPLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HealthPoliciesDescription?: Maybe<Array<Maybe<StringFacet>>>;
  HealthPoliciesText?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  NewIDRequestDescription?: Maybe<Array<Maybe<StringFacet>>>;
  NewIDRequestText?: Maybe<Array<Maybe<StringFacet>>>;
  PersonUpdatesDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PersonUpdatesText?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransferDescription?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransferText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetAmpDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetAmpLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetEepDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetEepLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetHealthPoliciesDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetHealthPoliciesTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetNewIdRequestDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetNewIdRequestTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetPersonUpdatesDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetPersonUpdatesTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetWireTransferDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacetWireTransferTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlock = {
  __typename?: 'CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockAutocomplete = {
  __typename?: 'CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockOrderByInput = {
  AMPDescription?: InputMaybe<OrderBy>;
  AMPLinkText?: InputMaybe<OrderBy>;
  Breadcrumb?: InputMaybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  DescriptionButtonBlock?: InputMaybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockOrderByInput>;
  EEPDescription?: InputMaybe<OrderBy>;
  EEPLinkText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HealthPoliciesDescription?: InputMaybe<OrderBy>;
  HealthPoliciesText?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  NewIDRequestDescription?: InputMaybe<OrderBy>;
  NewIDRequestText?: InputMaybe<OrderBy>;
  PersonUpdatesDescription?: InputMaybe<OrderBy>;
  PersonUpdatesText?: InputMaybe<OrderBy>;
  WireTransferDescription?: InputMaybe<OrderBy>;
  WireTransferText?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockWhereInput = {
  AMPDescription?: InputMaybe<SearchableStringFilterInput>;
  AMPLinkText?: InputMaybe<SearchableStringFilterInput>;
  Breadcrumb?: InputMaybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockLinkBlockWhereInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DescriptionButtonBlock?: InputMaybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockDescriptionButtonBlockWhereInput>;
  EEPDescription?: InputMaybe<SearchableStringFilterInput>;
  EEPLinkText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HealthPoliciesDescription?: InputMaybe<SearchableStringFilterInput>;
  HealthPoliciesText?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  NewIDRequestDescription?: InputMaybe<SearchableStringFilterInput>;
  NewIDRequestText?: InputMaybe<SearchableStringFilterInput>;
  PersonUpdatesDescription?: InputMaybe<SearchableStringFilterInput>;
  PersonUpdatesText?: InputMaybe<SearchableStringFilterInput>;
  WireTransferDescription?: InputMaybe<SearchableStringFilterInput>;
  WireTransferText?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlock';
  DescriptionText?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  NextButtonText?: Maybe<Scalars['String']['output']>;
  Step1Text?: Maybe<Scalars['String']['output']>;
  Step2Text?: Maybe<Scalars['String']['output']>;
  Step3Text?: Maybe<Scalars['String']['output']>;
  Step4Text?: Maybe<Scalars['String']['output']>;
  Step5Text?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockDescriptionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockNextButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockStep1TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockStep2TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockStep3TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockStep4TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockStep5TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockFacet';
  DescriptionText?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  NextButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Step1Text?: Maybe<Array<Maybe<StringFacet>>>;
  Step2Text?: Maybe<Array<Maybe<StringFacet>>>;
  Step3Text?: Maybe<Array<Maybe<StringFacet>>>;
  Step4Text?: Maybe<Array<Maybe<StringFacet>>>;
  Step5Text?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockFacetDescriptionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockFacetNextButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockFacetStep1TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockFacetStep2TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockFacetStep3TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockFacetStep4TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockFacetStep5TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockOrderByInput = {
  DescriptionText?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  NextButtonText?: InputMaybe<OrderBy>;
  Step1Text?: InputMaybe<OrderBy>;
  Step2Text?: InputMaybe<OrderBy>;
  Step3Text?: InputMaybe<OrderBy>;
  Step4Text?: InputMaybe<OrderBy>;
  Step5Text?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockWhereInput = {
  DescriptionText?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  NextButtonText?: InputMaybe<SearchableStringFilterInput>;
  Step1Text?: InputMaybe<SearchableStringFilterInput>;
  Step2Text?: InputMaybe<SearchableStringFilterInput>;
  Step3Text?: InputMaybe<SearchableStringFilterInput>;
  Step4Text?: InputMaybe<SearchableStringFilterInput>;
  Step5Text?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageDownloadUploadSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPageDownloadUploadSectionBlock';
  AMPInstruction?: Maybe<Scalars['String']['output']>;
  DownloadLinkText?: Maybe<Scalars['String']['output']>;
  EEPInstruction?: Maybe<Scalars['String']['output']>;
  EmailConsentLabel?: Maybe<Scalars['String']['output']>;
  HealthPoliciesInstruction?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  NewIDRequestInstruction?: Maybe<Scalars['String']['output']>;
  PersonUpdatesInstruction?: Maybe<Scalars['String']['output']>;
  UploadDescriptionText?: Maybe<Scalars['String']['output']>;
  UploadInstructionText?: Maybe<Scalars['String']['output']>;
  UploadLinkText?: Maybe<Scalars['String']['output']>;
  WireTransferInstruction?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockAmpInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockDownloadLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockEepInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockEmailConsentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockHealthPoliciesInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockNewIdRequestInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockPersonUpdatesInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockUploadDescriptionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockUploadInstructionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockUploadLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockWireTransferInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageDownloadUploadSectionBlockFacet';
  AMPInstruction?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  EEPInstruction?: Maybe<Array<Maybe<StringFacet>>>;
  EmailConsentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HealthPoliciesInstruction?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  NewIDRequestInstruction?: Maybe<Array<Maybe<StringFacet>>>;
  PersonUpdatesInstruction?: Maybe<Array<Maybe<StringFacet>>>;
  UploadDescriptionText?: Maybe<Array<Maybe<StringFacet>>>;
  UploadInstructionText?: Maybe<Array<Maybe<StringFacet>>>;
  UploadLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransferInstruction?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetAmpInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetDownloadLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetEepInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetEmailConsentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetHealthPoliciesInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetNewIdRequestInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetPersonUpdatesInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetUploadDescriptionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetUploadInstructionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetUploadLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageDownloadUploadSectionBlockFacetWireTransferInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageDownloadUploadSectionBlockOrderByInput = {
  AMPInstruction?: InputMaybe<OrderBy>;
  DownloadLinkText?: InputMaybe<OrderBy>;
  EEPInstruction?: InputMaybe<OrderBy>;
  EmailConsentLabel?: InputMaybe<OrderBy>;
  HealthPoliciesInstruction?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  NewIDRequestInstruction?: InputMaybe<OrderBy>;
  PersonUpdatesInstruction?: InputMaybe<OrderBy>;
  UploadDescriptionText?: InputMaybe<OrderBy>;
  UploadInstructionText?: InputMaybe<OrderBy>;
  UploadLinkText?: InputMaybe<OrderBy>;
  WireTransferInstruction?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageDownloadUploadSectionBlockWhereInput = {
  AMPInstruction?: InputMaybe<SearchableStringFilterInput>;
  DownloadLinkText?: InputMaybe<SearchableStringFilterInput>;
  EEPInstruction?: InputMaybe<SearchableStringFilterInput>;
  EmailConsentLabel?: InputMaybe<SearchableStringFilterInput>;
  HealthPoliciesInstruction?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  NewIDRequestInstruction?: InputMaybe<SearchableStringFilterInput>;
  PersonUpdatesInstruction?: InputMaybe<SearchableStringFilterInput>;
  UploadDescriptionText?: InputMaybe<SearchableStringFilterInput>;
  UploadInstructionText?: InputMaybe<SearchableStringFilterInput>;
  UploadLinkText?: InputMaybe<SearchableStringFilterInput>;
  WireTransferInstruction?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageEepSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPageEEPSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  BirthYear?: Maybe<Scalars['String']['output']>;
  FirstGivenName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LastFamilyName?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  NewBusinessIncome?: Maybe<Scalars['String']['output']>;
  OtherCommission?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesCommission?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesIncome?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesPremium?: Maybe<Scalars['String']['output']>;
  OtherPremium?: Maybe<Scalars['String']['output']>;
  RiskProtectionCommission?: Maybe<Scalars['String']['output']>;
  RiskProtectionIncome?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesCommission?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesIncome?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesPremium?: Maybe<Scalars['String']['output']>;
  RiskProtectionPremium?: Maybe<Scalars['String']['output']>;
  TotalIncome?: Maybe<Scalars['String']['output']>;
  Year?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageEepSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockBirthYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFirstGivenNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockLastFamilyNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockNewBusinessIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockOtherCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockOtherPoliciesCasesCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockOtherPoliciesCasesIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockOtherPoliciesCasesPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockOtherPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockRiskProtectionCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockRiskProtectionIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockRiskProtectionPoliciesCasesCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockRiskProtectionPoliciesCasesIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockRiskProtectionPoliciesCasesPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockRiskProtectionPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockTotalIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageEepSectionBlockYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageEepSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageEEPSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  BirthYear?: Maybe<Array<Maybe<StringFacet>>>;
  FirstGivenName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LastFamilyName?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  NewBusinessIncome?: Maybe<Array<Maybe<StringFacet>>>;
  OtherCommission?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesCommission?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesIncome?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesPremium?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPremium?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionCommission?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionIncome?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesCommission?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesIncome?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesPremium?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPremium?: Maybe<Array<Maybe<StringFacet>>>;
  TotalIncome?: Maybe<Array<Maybe<StringFacet>>>;
  Year?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetBirthYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetFirstGivenNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetLastFamilyNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetNewBusinessIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetOtherCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetOtherPoliciesCasesCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetOtherPoliciesCasesIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetOtherPoliciesCasesPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetOtherPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetRiskProtectionCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetRiskProtectionIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetRiskProtectionPoliciesCasesCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetRiskProtectionPoliciesCasesIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetRiskProtectionPoliciesCasesPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetRiskProtectionPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetTotalIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageEepSectionBlockFacetYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageEepSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  BirthYear?: InputMaybe<OrderBy>;
  FirstGivenName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LastFamilyName?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  NewBusinessIncome?: InputMaybe<OrderBy>;
  OtherCommission?: InputMaybe<OrderBy>;
  OtherPoliciesCasesCommission?: InputMaybe<OrderBy>;
  OtherPoliciesCasesIncome?: InputMaybe<OrderBy>;
  OtherPoliciesCasesPremium?: InputMaybe<OrderBy>;
  OtherPremium?: InputMaybe<OrderBy>;
  RiskProtectionCommission?: InputMaybe<OrderBy>;
  RiskProtectionIncome?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesCommission?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesIncome?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesPremium?: InputMaybe<OrderBy>;
  RiskProtectionPremium?: InputMaybe<OrderBy>;
  TotalIncome?: InputMaybe<OrderBy>;
  Year?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageEepSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  BirthYear?: InputMaybe<SearchableStringFilterInput>;
  FirstGivenName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LastFamilyName?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  NewBusinessIncome?: InputMaybe<SearchableStringFilterInput>;
  OtherCommission?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesCommission?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesIncome?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesPremium?: InputMaybe<SearchableStringFilterInput>;
  OtherPremium?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionCommission?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionIncome?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesCommission?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesIncome?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesPremium?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPremium?: InputMaybe<SearchableStringFilterInput>;
  TotalIncome?: InputMaybe<SearchableStringFilterInput>;
  Year?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageFacet = {
  __typename?: 'CompanyAdminBulkImportPageFacet';
  AMP?: Maybe<CompanyAdminBulkImportPageAmpSectionBlockFacet>;
  AMPDownLoadTemplateFileName?: Maybe<Array<Maybe<StringFacet>>>;
  AmpHeading?: Maybe<Array<Maybe<StringFacet>>>;
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  BottomContent?: Maybe<ContentAreaItemModelSearchFacet>;
  BulkImporterUploader?: Maybe<CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  CertifyingOfficer?: Maybe<CompanyAdminBulkImportPageCertifyingOfficerSectionBlockFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Dashboard?: Maybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockFacet>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadUpload?: Maybe<CompanyAdminBulkImportPageDownloadUploadSectionBlockFacet>;
  DownloadUploadBreadcrumbText?: Maybe<Array<Maybe<StringFacet>>>;
  EEP?: Maybe<CompanyAdminBulkImportPageEepSectionBlockFacet>;
  EEPDownLoadTemplateFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EepHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  GettingStarted?: Maybe<CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockFacet>;
  HealthPolicies?: Maybe<CompanyAdminBulkImportPageHealthPoliciesSectionBlockFacet>;
  HealthPoliciesDownLoadTemplateFileName?: Maybe<Array<Maybe<StringFacet>>>;
  HealthPoliciesHeading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<CompanyAdminBulkImportPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NewIDRequest?: Maybe<CompanyAdminBulkImportPageNewIdRequestSectionBlockFacet>;
  NewIdRequestDownLoadTemplateFileName?: Maybe<Array<Maybe<StringFacet>>>;
  NewIdRequestHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonUpdates?: Maybe<CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacet>;
  PersonUpdatesDownLoadTemplateFileName?: Maybe<Array<Maybe<StringFacet>>>;
  PersonUpdatesHeading?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Success?: Maybe<CompanyAdminBulkImportPageSuccessSectionBlockFacet>;
  ThumbnailImage?: Maybe<CompanyAdminBulkImportPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransfer?: Maybe<CompanyAdminBulkImportPageWireTransferSectionBlockFacet>;
  WireTransferDownLoadTemplateFileName?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransferHeading?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CompanyAdminBulkImportPageFacetAmpDownLoadTemplateFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetAmpHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetDownloadUploadBreadcrumbTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetEepDownLoadTemplateFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetEepHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetHealthPoliciesDownLoadTemplateFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetHealthPoliciesHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetNewIdRequestDownLoadTemplateFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetNewIdRequestHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetPersonUpdatesDownLoadTemplateFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetPersonUpdatesHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminBulkImportPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetWireTransferDownLoadTemplateFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacetWireTransferHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CompanyAdminBulkImportPageHealthPoliciesSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPageHealthPoliciesSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  EmailAddress?: Maybe<Scalars['String']['output']>;
  FirstGivenName?: Maybe<Scalars['String']['output']>;
  HealthInsurancePolicesOther?: Maybe<Scalars['String']['output']>;
  HealthInsurancePolicesRisk?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LastFamilyName?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockFirstGivenNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockHealthInsurancePolicesOtherArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockHealthInsurancePolicesRiskArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockLastFamilyNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageHealthPoliciesSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  EmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  FirstGivenName?: Maybe<Array<Maybe<StringFacet>>>;
  HealthInsurancePolicesOther?: Maybe<Array<Maybe<StringFacet>>>;
  HealthInsurancePolicesRisk?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LastFamilyName?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockFacetEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockFacetFirstGivenNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockFacetHealthInsurancePolicesOtherArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockFacetHealthInsurancePolicesRiskArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockFacetLastFamilyNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  EmailAddress?: InputMaybe<OrderBy>;
  FirstGivenName?: InputMaybe<OrderBy>;
  HealthInsurancePolicesOther?: InputMaybe<OrderBy>;
  HealthInsurancePolicesRisk?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LastFamilyName?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageHealthPoliciesSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  EmailAddress?: InputMaybe<SearchableStringFilterInput>;
  FirstGivenName?: InputMaybe<SearchableStringFilterInput>;
  HealthInsurancePolicesOther?: InputMaybe<SearchableStringFilterInput>;
  HealthInsurancePolicesRisk?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LastFamilyName?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageImageBlock = {
  __typename?: 'CompanyAdminBulkImportPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageImageBlockAutocomplete = {
  __typename?: 'CompanyAdminBulkImportPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type CompanyAdminBulkImportPageImageBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageNewIdRequestSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPageNewIDRequestSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  BirthYear?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine1?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine2?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine3?: Maybe<Scalars['String']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  CompanyID?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  Designation1?: Maybe<Scalars['String']['output']>;
  Designation2?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LocalLanguageCity?: Maybe<Scalars['String']['output']>;
  LocalLanguageCountry?: Maybe<Scalars['String']['output']>;
  LocalLanguageLine1?: Maybe<Scalars['String']['output']>;
  LocalLanguageLine2?: Maybe<Scalars['String']['output']>;
  LocalLanguageLine3?: Maybe<Scalars['String']['output']>;
  LocalLanguageName?: Maybe<Scalars['String']['output']>;
  LocalLanguageNickname?: Maybe<Scalars['String']['output']>;
  LocalLanguagePostalCode?: Maybe<Scalars['String']['output']>;
  LocalLanguageState?: Maybe<Scalars['String']['output']>;
  MiddleName?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneAreaCode?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneISOCode?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneNumber?: Maybe<Scalars['String']['output']>;
  NickName?: Maybe<Scalars['String']['output']>;
  OfficePhone?: Maybe<Scalars['String']['output']>;
  OfficePhoneAreaCode?: Maybe<Scalars['String']['output']>;
  OfficePhoneISOCode?: Maybe<Scalars['String']['output']>;
  PersonalCompany?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  Prefix?: Maybe<Scalars['String']['output']>;
  PrimaryEmailAddress?: Maybe<Scalars['String']['output']>;
  SecondaryEmailAddress?: Maybe<Scalars['String']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Suffix?: Maybe<Scalars['String']['output']>;
  YearOfFirstLicense?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockBirthYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockBusinessAddressLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockBusinessAddressLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockBusinessAddressLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockDesignation1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockDesignation2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockGenderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockJobTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockLocalLanguageCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockLocalLanguageCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockLocalLanguageLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockLocalLanguageLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockLocalLanguageLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockLocalLanguageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockLocalLanguageNicknameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockLocalLanguagePostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockLocalLanguageStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockMiddleNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockMobileCellPhoneAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockMobileCellPhoneIsoCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockMobileCellPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockNickNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockOfficePhoneArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockOfficePhoneAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockOfficePhoneIsoCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockPersonalCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockPostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockPrefixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockPrimaryEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockSecondaryEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockSuffixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockYearOfFirstLicenseArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageNewIdRequestSectionBlockAutocomplete = {
  __typename?: 'CompanyAdminBulkImportPageNewIDRequestSectionBlockAutocomplete';
  CompanyID?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockAutocompleteCompanyIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageNewIDRequestSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  BirthYear?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine1?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine2?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine3?: Maybe<Array<Maybe<StringFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyID?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  Designation1?: Maybe<Array<Maybe<StringFacet>>>;
  Designation2?: Maybe<Array<Maybe<StringFacet>>>;
  FirstName?: Maybe<Array<Maybe<StringFacet>>>;
  Gender?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  JobTitle?: Maybe<Array<Maybe<StringFacet>>>;
  LastName?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageCity?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageCountry?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageLine1?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageLine2?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageLine3?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageName?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageNickname?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguagePostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageState?: Maybe<Array<Maybe<StringFacet>>>;
  MiddleName?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneAreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneISOCode?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  NickName?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhone?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneAreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneISOCode?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalCompany?: Maybe<Array<Maybe<StringFacet>>>;
  PostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  Prefix?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryEmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SecondaryEmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  State?: Maybe<Array<Maybe<StringFacet>>>;
  Suffix?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstLicense?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetBirthYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetBusinessAddressLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetBusinessAddressLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetBusinessAddressLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetCompanyIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetDesignation1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetDesignation2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetGenderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetJobTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetLocalLanguageCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetLocalLanguageCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetLocalLanguageLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetLocalLanguageLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetLocalLanguageLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetLocalLanguageNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetLocalLanguageNicknameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetLocalLanguagePostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetLocalLanguageStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetMiddleNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetMobileCellPhoneAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetMobileCellPhoneIsoCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetMobileCellPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetNickNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetOfficePhoneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetOfficePhoneAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetOfficePhoneIsoCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetPersonalCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetPostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetPrefixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetPrimaryEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetSecondaryEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetSuffixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageNewIdRequestSectionBlockFacetYearOfFirstLicenseArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageNewIdRequestSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  BirthYear?: InputMaybe<OrderBy>;
  BusinessAddressLine1?: InputMaybe<OrderBy>;
  BusinessAddressLine2?: InputMaybe<OrderBy>;
  BusinessAddressLine3?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  CompanyID?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  Designation1?: InputMaybe<OrderBy>;
  Designation2?: InputMaybe<OrderBy>;
  FirstName?: InputMaybe<OrderBy>;
  Gender?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  JobTitle?: InputMaybe<OrderBy>;
  LastName?: InputMaybe<OrderBy>;
  LocalLanguageCity?: InputMaybe<OrderBy>;
  LocalLanguageCountry?: InputMaybe<OrderBy>;
  LocalLanguageLine1?: InputMaybe<OrderBy>;
  LocalLanguageLine2?: InputMaybe<OrderBy>;
  LocalLanguageLine3?: InputMaybe<OrderBy>;
  LocalLanguageName?: InputMaybe<OrderBy>;
  LocalLanguageNickname?: InputMaybe<OrderBy>;
  LocalLanguagePostalCode?: InputMaybe<OrderBy>;
  LocalLanguageState?: InputMaybe<OrderBy>;
  MiddleName?: InputMaybe<OrderBy>;
  MobileCellPhoneAreaCode?: InputMaybe<OrderBy>;
  MobileCellPhoneISOCode?: InputMaybe<OrderBy>;
  MobileCellPhoneNumber?: InputMaybe<OrderBy>;
  NickName?: InputMaybe<OrderBy>;
  OfficePhone?: InputMaybe<OrderBy>;
  OfficePhoneAreaCode?: InputMaybe<OrderBy>;
  OfficePhoneISOCode?: InputMaybe<OrderBy>;
  PersonalCompany?: InputMaybe<OrderBy>;
  PostalCode?: InputMaybe<OrderBy>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  Prefix?: InputMaybe<OrderBy>;
  PrimaryEmailAddress?: InputMaybe<OrderBy>;
  SecondaryEmailAddress?: InputMaybe<OrderBy>;
  State?: InputMaybe<OrderBy>;
  Suffix?: InputMaybe<OrderBy>;
  YearOfFirstLicense?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageNewIdRequestSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  BirthYear?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine1?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine2?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine3?: InputMaybe<SearchableStringFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  CompanyID?: InputMaybe<StringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  Designation1?: InputMaybe<SearchableStringFilterInput>;
  Designation2?: InputMaybe<SearchableStringFilterInput>;
  FirstName?: InputMaybe<SearchableStringFilterInput>;
  Gender?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  JobTitle?: InputMaybe<SearchableStringFilterInput>;
  LastName?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageCity?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageCountry?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageLine1?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageLine2?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageLine3?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageName?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageNickname?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguagePostalCode?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageState?: InputMaybe<SearchableStringFilterInput>;
  MiddleName?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneAreaCode?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneISOCode?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  NickName?: InputMaybe<SearchableStringFilterInput>;
  OfficePhone?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneAreaCode?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneISOCode?: InputMaybe<SearchableStringFilterInput>;
  PersonalCompany?: InputMaybe<SearchableStringFilterInput>;
  PostalCode?: InputMaybe<SearchableStringFilterInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  Prefix?: InputMaybe<SearchableStringFilterInput>;
  PrimaryEmailAddress?: InputMaybe<SearchableStringFilterInput>;
  SecondaryEmailAddress?: InputMaybe<SearchableStringFilterInput>;
  State?: InputMaybe<SearchableStringFilterInput>;
  Suffix?: InputMaybe<SearchableStringFilterInput>;
  YearOfFirstLicense?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageOrderByInput = {
  AMP?: InputMaybe<CompanyAdminBulkImportPageAmpSectionBlockOrderByInput>;
  AMPDownLoadTemplateFileName?: InputMaybe<OrderBy>;
  AmpHeading?: InputMaybe<OrderBy>;
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  BottomContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  BulkImporterUploader?: InputMaybe<CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  CertifyingOfficer?: InputMaybe<CompanyAdminBulkImportPageCertifyingOfficerSectionBlockOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Dashboard?: InputMaybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockOrderByInput>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  DownloadUpload?: InputMaybe<CompanyAdminBulkImportPageDownloadUploadSectionBlockOrderByInput>;
  DownloadUploadBreadcrumbText?: InputMaybe<OrderBy>;
  EEP?: InputMaybe<CompanyAdminBulkImportPageEepSectionBlockOrderByInput>;
  EEPDownLoadTemplateFileName?: InputMaybe<OrderBy>;
  EepHeading?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  GettingStarted?: InputMaybe<CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockOrderByInput>;
  HealthPolicies?: InputMaybe<CompanyAdminBulkImportPageHealthPoliciesSectionBlockOrderByInput>;
  HealthPoliciesDownLoadTemplateFileName?: InputMaybe<OrderBy>;
  HealthPoliciesHeading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<CompanyAdminBulkImportPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NewIDRequest?: InputMaybe<CompanyAdminBulkImportPageNewIdRequestSectionBlockOrderByInput>;
  NewIdRequestDownLoadTemplateFileName?: InputMaybe<OrderBy>;
  NewIdRequestHeading?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonUpdates?: InputMaybe<CompanyAdminBulkImportPagePersonUpdatesSectionBlockOrderByInput>;
  PersonUpdatesDownLoadTemplateFileName?: InputMaybe<OrderBy>;
  PersonUpdatesHeading?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Success?: InputMaybe<CompanyAdminBulkImportPageSuccessSectionBlockOrderByInput>;
  ThumbnailImage?: InputMaybe<CompanyAdminBulkImportPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  WireTransfer?: InputMaybe<CompanyAdminBulkImportPageWireTransferSectionBlockOrderByInput>;
  WireTransferDownLoadTemplateFileName?: InputMaybe<OrderBy>;
  WireTransferHeading?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageOutput = {
  __typename?: 'CompanyAdminBulkImportPageOutput';
  autocomplete?: Maybe<CompanyAdminBulkImportPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CompanyAdminBulkImportPageFacet>;
  item?: Maybe<CompanyAdminBulkImportPage>;
  items?: Maybe<Array<Maybe<CompanyAdminBulkImportPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CompanyAdminBulkImportPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyAdminBulkImportPagePersonUpdatesSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPagePersonUpdatesSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  BirthYear?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine1?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine2?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine3?: Maybe<Scalars['String']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  CompanyID?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  Designation1?: Maybe<Scalars['String']['output']>;
  Designation2?: Maybe<Scalars['String']['output']>;
  FirstGivenName?: Maybe<Scalars['String']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LastFamilyName?: Maybe<Scalars['String']['output']>;
  LastYearOfMembership?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddressLine1?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddressLine2?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddressLine3?: Maybe<Scalars['String']['output']>;
  LocalLanguageCity?: Maybe<Scalars['String']['output']>;
  LocalLanguageCountry?: Maybe<Scalars['String']['output']>;
  LocalLanguageName?: Maybe<Scalars['String']['output']>;
  LocalLanguagePostalCode?: Maybe<Scalars['String']['output']>;
  LocalLanguagePreferredName?: Maybe<Scalars['String']['output']>;
  LocalLanguageState?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MiddleName?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneAreaCode?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneCountryCode?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneNumber?: Maybe<Scalars['String']['output']>;
  OfficePhoneAreaCode?: Maybe<Scalars['String']['output']>;
  OfficePhoneCountryCode?: Maybe<Scalars['String']['output']>;
  OfficePhoneNumber?: Maybe<Scalars['String']['output']>;
  PersonalCompany?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  PreferredName?: Maybe<Scalars['String']['output']>;
  Prefix?: Maybe<Scalars['String']['output']>;
  PrimaryEmailAddress?: Maybe<Scalars['String']['output']>;
  SecondaryEmailAddress?: Maybe<Scalars['String']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Suffix?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  YearOfFirstInsuranceLicense?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockBirthYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockBusinessAddressLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockBusinessAddressLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockBusinessAddressLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockCompanyIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockDesignation1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockDesignation2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFirstGivenNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockGenderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockLastFamilyNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockLastYearOfMembershipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockLocalLanguageAddressLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockLocalLanguageAddressLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockLocalLanguageAddressLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockLocalLanguageCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockLocalLanguageCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockLocalLanguageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockLocalLanguagePostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockLocalLanguagePreferredNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockLocalLanguageStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockMiddleNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockMobileCellPhoneAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockMobileCellPhoneCountryCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockMobileCellPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockOfficePhoneAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockOfficePhoneCountryCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockOfficePhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockPersonalCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockPostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockPreferredNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockPrefixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockPrimaryEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockSecondaryEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockSuffixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockYearOfFirstInsuranceLicenseArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  BirthYear?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine1?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine2?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine3?: Maybe<Array<Maybe<StringFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyID?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  Designation1?: Maybe<Array<Maybe<StringFacet>>>;
  Designation2?: Maybe<Array<Maybe<StringFacet>>>;
  FirstGivenName?: Maybe<Array<Maybe<StringFacet>>>;
  Gender?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LastFamilyName?: Maybe<Array<Maybe<StringFacet>>>;
  LastYearOfMembership?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddressLine1?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddressLine2?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddressLine3?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageCity?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageCountry?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageName?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguagePostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguagePreferredName?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageState?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MiddleName?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneAreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneCountryCode?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneAreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneCountryCode?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalCompany?: Maybe<Array<Maybe<StringFacet>>>;
  PostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredName?: Maybe<Array<Maybe<StringFacet>>>;
  Prefix?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryEmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SecondaryEmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  State?: Maybe<Array<Maybe<StringFacet>>>;
  Suffix?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstInsuranceLicense?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetBirthYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetBusinessAddressLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetBusinessAddressLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetBusinessAddressLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetCompanyIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetDesignation1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetDesignation2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetFirstGivenNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetGenderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetLastFamilyNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetLastYearOfMembershipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetLocalLanguageAddressLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetLocalLanguageAddressLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetLocalLanguageAddressLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetLocalLanguageCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetLocalLanguageCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetLocalLanguageNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetLocalLanguagePostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetLocalLanguagePreferredNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetLocalLanguageStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetMiddleNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetMobileCellPhoneAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetMobileCellPhoneCountryCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetMobileCellPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetOfficePhoneAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetOfficePhoneCountryCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetOfficePhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetPersonalCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetPostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetPreferredNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetPrefixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetPrimaryEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetSecondaryEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetSuffixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockFacetYearOfFirstInsuranceLicenseArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  BirthYear?: InputMaybe<OrderBy>;
  BusinessAddressLine1?: InputMaybe<OrderBy>;
  BusinessAddressLine2?: InputMaybe<OrderBy>;
  BusinessAddressLine3?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  CompanyID?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  Designation1?: InputMaybe<OrderBy>;
  Designation2?: InputMaybe<OrderBy>;
  FirstGivenName?: InputMaybe<OrderBy>;
  Gender?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LastFamilyName?: InputMaybe<OrderBy>;
  LastYearOfMembership?: InputMaybe<OrderBy>;
  LocalLanguageAddressLine1?: InputMaybe<OrderBy>;
  LocalLanguageAddressLine2?: InputMaybe<OrderBy>;
  LocalLanguageAddressLine3?: InputMaybe<OrderBy>;
  LocalLanguageCity?: InputMaybe<OrderBy>;
  LocalLanguageCountry?: InputMaybe<OrderBy>;
  LocalLanguageName?: InputMaybe<OrderBy>;
  LocalLanguagePostalCode?: InputMaybe<OrderBy>;
  LocalLanguagePreferredName?: InputMaybe<OrderBy>;
  LocalLanguageState?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MiddleName?: InputMaybe<OrderBy>;
  MobileCellPhoneAreaCode?: InputMaybe<OrderBy>;
  MobileCellPhoneCountryCode?: InputMaybe<OrderBy>;
  MobileCellPhoneNumber?: InputMaybe<OrderBy>;
  OfficePhoneAreaCode?: InputMaybe<OrderBy>;
  OfficePhoneCountryCode?: InputMaybe<OrderBy>;
  OfficePhoneNumber?: InputMaybe<OrderBy>;
  PersonalCompany?: InputMaybe<OrderBy>;
  PostalCode?: InputMaybe<OrderBy>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  PreferredName?: InputMaybe<OrderBy>;
  Prefix?: InputMaybe<OrderBy>;
  PrimaryEmailAddress?: InputMaybe<OrderBy>;
  SecondaryEmailAddress?: InputMaybe<OrderBy>;
  State?: InputMaybe<OrderBy>;
  Suffix?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  YearOfFirstInsuranceLicense?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPagePersonUpdatesSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  BirthYear?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine1?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine2?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine3?: InputMaybe<SearchableStringFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  CompanyID?: InputMaybe<SearchableStringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  Designation1?: InputMaybe<SearchableStringFilterInput>;
  Designation2?: InputMaybe<SearchableStringFilterInput>;
  FirstGivenName?: InputMaybe<SearchableStringFilterInput>;
  Gender?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LastFamilyName?: InputMaybe<SearchableStringFilterInput>;
  LastYearOfMembership?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddressLine1?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddressLine2?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddressLine3?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageCity?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageCountry?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageName?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguagePostalCode?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguagePreferredName?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageState?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MiddleName?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneAreaCode?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneCountryCode?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneAreaCode?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneCountryCode?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  PersonalCompany?: InputMaybe<SearchableStringFilterInput>;
  PostalCode?: InputMaybe<SearchableStringFilterInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  PreferredName?: InputMaybe<SearchableStringFilterInput>;
  Prefix?: InputMaybe<SearchableStringFilterInput>;
  PrimaryEmailAddress?: InputMaybe<SearchableStringFilterInput>;
  SecondaryEmailAddress?: InputMaybe<SearchableStringFilterInput>;
  State?: InputMaybe<SearchableStringFilterInput>;
  Suffix?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  YearOfFirstInsuranceLicense?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageSuccessSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPageSuccessSectionBlock';
  AMPSubmittedText?: Maybe<Scalars['String']['output']>;
  EEPSubmittedText?: Maybe<Scalars['String']['output']>;
  HealthPoliciesSubmittedText?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  NewIDRequestSubmittedText?: Maybe<Scalars['String']['output']>;
  PersonUpdatesSubmittedText?: Maybe<Scalars['String']['output']>;
  WireTransferSubmittedText?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockAmpSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockEepSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockHealthPoliciesSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockNewIdRequestSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockPersonUpdatesSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockWireTransferSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageSuccessSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageSuccessSectionBlockFacet';
  AMPSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
  EEPSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
  HealthPoliciesSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  NewIDRequestSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
  PersonUpdatesSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransferSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockFacetAmpSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockFacetEepSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockFacetHealthPoliciesSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockFacetNewIdRequestSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockFacetPersonUpdatesSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageSuccessSectionBlockFacetWireTransferSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageSuccessSectionBlockOrderByInput = {
  AMPSubmittedText?: InputMaybe<OrderBy>;
  EEPSubmittedText?: InputMaybe<OrderBy>;
  HealthPoliciesSubmittedText?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  NewIDRequestSubmittedText?: InputMaybe<OrderBy>;
  PersonUpdatesSubmittedText?: InputMaybe<OrderBy>;
  WireTransferSubmittedText?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageSuccessSectionBlockWhereInput = {
  AMPSubmittedText?: InputMaybe<SearchableStringFilterInput>;
  EEPSubmittedText?: InputMaybe<SearchableStringFilterInput>;
  HealthPoliciesSubmittedText?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  NewIDRequestSubmittedText?: InputMaybe<SearchableStringFilterInput>;
  PersonUpdatesSubmittedText?: InputMaybe<SearchableStringFilterInput>;
  WireTransferSubmittedText?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminBulkImportPageWhereInput = {
  AMP?: InputMaybe<CompanyAdminBulkImportPageAmpSectionBlockWhereInput>;
  AMPDownLoadTemplateFileName?: InputMaybe<SearchableStringFilterInput>;
  AmpHeading?: InputMaybe<SearchableStringFilterInput>;
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  BottomContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  BulkImporterUploader?: InputMaybe<CompanyAdminBulkImportPageBulkImporterUploaderSectionBlockWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  CertifyingOfficer?: InputMaybe<CompanyAdminBulkImportPageCertifyingOfficerSectionBlockWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Dashboard?: InputMaybe<CompanyAdminBulkImportPageCompanyAdminBulkImportDashboardSectionBlockWhereInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  DownloadUpload?: InputMaybe<CompanyAdminBulkImportPageDownloadUploadSectionBlockWhereInput>;
  DownloadUploadBreadcrumbText?: InputMaybe<SearchableStringFilterInput>;
  EEP?: InputMaybe<CompanyAdminBulkImportPageEepSectionBlockWhereInput>;
  EEPDownLoadTemplateFileName?: InputMaybe<SearchableStringFilterInput>;
  EepHeading?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  GettingStarted?: InputMaybe<CompanyAdminBulkImportPageCompanyAdminBulkImportGettingStartedSectionBlockWhereInput>;
  HealthPolicies?: InputMaybe<CompanyAdminBulkImportPageHealthPoliciesSectionBlockWhereInput>;
  HealthPoliciesDownLoadTemplateFileName?: InputMaybe<SearchableStringFilterInput>;
  HealthPoliciesHeading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<CompanyAdminBulkImportPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NewIDRequest?: InputMaybe<CompanyAdminBulkImportPageNewIdRequestSectionBlockWhereInput>;
  NewIdRequestDownLoadTemplateFileName?: InputMaybe<SearchableStringFilterInput>;
  NewIdRequestHeading?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonUpdates?: InputMaybe<CompanyAdminBulkImportPagePersonUpdatesSectionBlockWhereInput>;
  PersonUpdatesDownLoadTemplateFileName?: InputMaybe<SearchableStringFilterInput>;
  PersonUpdatesHeading?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Success?: InputMaybe<CompanyAdminBulkImportPageSuccessSectionBlockWhereInput>;
  ThumbnailImage?: InputMaybe<CompanyAdminBulkImportPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  WireTransfer?: InputMaybe<CompanyAdminBulkImportPageWireTransferSectionBlockWhereInput>;
  WireTransferDownLoadTemplateFileName?: InputMaybe<SearchableStringFilterInput>;
  WireTransferHeading?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CompanyAdminBulkImportPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CompanyAdminBulkImportPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CompanyAdminBulkImportPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type CompanyAdminBulkImportPageWireTransferSectionBlock = {
  __typename?: 'CompanyAdminBulkImportPageWireTransferSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  BackDues?: Maybe<Scalars['String']['output']>;
  CourtOfTableCOT?: Maybe<Scalars['String']['output']>;
  FirstGivenName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LastFamilyName?: Maybe<Scalars['String']['output']>;
  LateFee?: Maybe<Scalars['String']['output']>;
  MDRTDues?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MembershipYear?: Maybe<Scalars['String']['output']>;
  TopOfTableTOT?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockBackDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockCourtOfTableCotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFirstGivenNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockLastFamilyNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockLateFeeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockMdrtDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockMembershipYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockTopOfTableTotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminBulkImportPageWireTransferSectionBlockFacet = {
  __typename?: 'CompanyAdminBulkImportPageWireTransferSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  BackDues?: Maybe<Array<Maybe<StringFacet>>>;
  CourtOfTableCOT?: Maybe<Array<Maybe<StringFacet>>>;
  FirstGivenName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LastFamilyName?: Maybe<Array<Maybe<StringFacet>>>;
  LateFee?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTDues?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipYear?: Maybe<Array<Maybe<StringFacet>>>;
  TopOfTableTOT?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFacetBackDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFacetCourtOfTableCotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFacetFirstGivenNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFacetLastFamilyNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFacetLateFeeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFacetMdrtDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFacetMembershipYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminBulkImportPageWireTransferSectionBlockFacetTopOfTableTotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminBulkImportPageWireTransferSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  BackDues?: InputMaybe<OrderBy>;
  CourtOfTableCOT?: InputMaybe<OrderBy>;
  FirstGivenName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LastFamilyName?: InputMaybe<OrderBy>;
  LateFee?: InputMaybe<OrderBy>;
  MDRTDues?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MembershipYear?: InputMaybe<OrderBy>;
  TopOfTableTOT?: InputMaybe<OrderBy>;
};

export type CompanyAdminBulkImportPageWireTransferSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  BackDues?: InputMaybe<SearchableStringFilterInput>;
  CourtOfTableCOT?: InputMaybe<SearchableStringFilterInput>;
  FirstGivenName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LastFamilyName?: InputMaybe<SearchableStringFilterInput>;
  LateFee?: InputMaybe<SearchableStringFilterInput>;
  MDRTDues?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MembershipYear?: InputMaybe<SearchableStringFilterInput>;
  TopOfTableTOT?: InputMaybe<SearchableStringFilterInput>;
};

/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPage = IContent & IData & {
  __typename?: 'CompanyAdminCompanyListingsPage';
  AdditionalSearchCriteriaDropDown?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  AdditionalSearchCriteriaDropDownLabel?: Maybe<Scalars['String']['output']>;
  AdditionalSearchCriteriaDropDownRequiredMessage?: Maybe<Scalars['String']['output']>;
  AffiliatedCompanyIdLabel?: Maybe<Scalars['String']['output']>;
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  BackToDashboardLink?: Maybe<CompanyAdminCompanyListingsPageLinkBlock>;
  /** Contennt rendering below the Main content on page. */
  BottomContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  DownloadCompanyListingsLink?: Maybe<CompanyAdminCompanyListingsPageLinkBlock>;
  ErrorResultsText?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** Members Table Header Labels */
  MembersTableHeaderLabels?: Maybe<CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlock>;
  MentorAspirantDropdownValue?: Maybe<CompanyAdminCompanyListingsPageKeyTranslatedValueBlock>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<CompanyAdminCompanyListingsPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NoResultsText?: Maybe<Scalars['String']['output']>;
  /** Displays the page numbers of pages text. Uses variable {{pageCount}} */
  NumbersofPageLabel?: Maybe<Scalars['String']['output']>;
  PageDescription?: Maybe<Scalars['String']['output']>;
  PageTitle?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Displays the number of Records found for the search term. Uses variable {{totalResults}}. */
  RecordsFoundText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  /** Label for showing the records per page. Uses variable {{recordsPerPage}}. */
  RowsPerPageLabel?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SearchButtonText?: Maybe<Scalars['String']['output']>;
  SearchSectionTitle?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<CompanyAdminCompanyListingsPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  YearDropDown?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  YearDropDownLabel?: Maybe<Scalars['String']['output']>;
  YearDropDownRequiredMessage?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageAdditionalSearchCriteriaDropDownArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageAdditionalSearchCriteriaDropDownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageAdditionalSearchCriteriaDropDownRequiredMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageAffiliatedCompanyIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageBottomContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageCompanyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageErrorResultsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageNoResultsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageNumbersofPageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPagePageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageRecordsFoundTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageRowsPerPageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageSearchButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageSearchSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageYearDropDownArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageYearDropDownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPageYearDropDownRequiredMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Company Listing Page */
export type CompanyAdminCompanyListingsPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CompanyAdminCompanyListingsPageAutocomplete = {
  __typename?: 'CompanyAdminCompanyListingsPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  BackToDashboardLink?: Maybe<CompanyAdminCompanyListingsPageLinkBlockAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DownloadCompanyListingsLink?: Maybe<CompanyAdminCompanyListingsPageLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<CompanyAdminCompanyListingsPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<CompanyAdminCompanyListingsPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyAdminCompanyListingsPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminCompanyListingsPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminCompanyListingsPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminCompanyListingsPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminCompanyListingsPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminCompanyListingsPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminCompanyListingsPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminCompanyListingsPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminCompanyListingsPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminCompanyListingsPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyAdminCompanyListingsPageFacet = {
  __typename?: 'CompanyAdminCompanyListingsPageFacet';
  AdditionalSearchCriteriaDropDown?: Maybe<ContentAreaItemModelSearchFacet>;
  AdditionalSearchCriteriaDropDownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AdditionalSearchCriteriaDropDownRequiredMessage?: Maybe<Array<Maybe<StringFacet>>>;
  AffiliatedCompanyIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  BackToDashboardLink?: Maybe<CompanyAdminCompanyListingsPageLinkBlockFacet>;
  BottomContent?: Maybe<ContentAreaItemModelSearchFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadCompanyListingsLink?: Maybe<CompanyAdminCompanyListingsPageLinkBlockFacet>;
  ErrorResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembersTableHeaderLabels?: Maybe<CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacet>;
  MentorAspirantDropdownValue?: Maybe<CompanyAdminCompanyListingsPageKeyTranslatedValueBlockFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<CompanyAdminCompanyListingsPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NoResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  NumbersofPageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RecordsFoundText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  RowsPerPageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  SearchSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<CompanyAdminCompanyListingsPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YearDropDown?: Maybe<ContentAreaItemModelSearchFacet>;
  YearDropDownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  YearDropDownRequiredMessage?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CompanyAdminCompanyListingsPageFacetAdditionalSearchCriteriaDropDownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetAdditionalSearchCriteriaDropDownRequiredMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetAffiliatedCompanyIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminCompanyListingsPageFacetCompanyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminCompanyListingsPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminCompanyListingsPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetErrorResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminCompanyListingsPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetNoResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetNumbersofPageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetPageTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetRecordsFoundTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetRowsPerPageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminCompanyListingsPageFacetSearchButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetSearchSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminCompanyListingsPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminCompanyListingsPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetYearDropDownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacetYearDropDownRequiredMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CompanyAdminCompanyListingsPageImageBlock = {
  __typename?: 'CompanyAdminCompanyListingsPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminCompanyListingsPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminCompanyListingsPageImageBlockAutocomplete = {
  __typename?: 'CompanyAdminCompanyListingsPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type CompanyAdminCompanyListingsPageImageBlockFacet = {
  __typename?: 'CompanyAdminCompanyListingsPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminCompanyListingsPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminCompanyListingsPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminCompanyListingsPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type CompanyAdminCompanyListingsPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminCompanyListingsPageKeyTranslatedValueBlock = {
  __typename?: 'CompanyAdminCompanyListingsPageKeyTranslatedValueBlock';
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminCompanyListingsPageKeyTranslatedValueBlockKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageKeyTranslatedValueBlockValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminCompanyListingsPageKeyTranslatedValueBlockFacet = {
  __typename?: 'CompanyAdminCompanyListingsPageKeyTranslatedValueBlockFacet';
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminCompanyListingsPageKeyTranslatedValueBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminCompanyListingsPageKeyTranslatedValueBlockFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageKeyTranslatedValueBlockFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminCompanyListingsPageKeyTranslatedValueBlockOrderByInput = {
  IndexTrigger?: InputMaybe<OrderBy>;
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type CompanyAdminCompanyListingsPageKeyTranslatedValueBlockWhereInput = {
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminCompanyListingsPageLinkBlock = {
  __typename?: 'CompanyAdminCompanyListingsPageLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminCompanyListingsPageLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminCompanyListingsPageLinkBlockAutocomplete = {
  __typename?: 'CompanyAdminCompanyListingsPageLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyAdminCompanyListingsPageLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyAdminCompanyListingsPageLinkBlockFacet = {
  __typename?: 'CompanyAdminCompanyListingsPageLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminCompanyListingsPageLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminCompanyListingsPageLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminCompanyListingsPageLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type CompanyAdminCompanyListingsPageLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlock = {
  __typename?: 'CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlock';
  AddressLine?: Maybe<Scalars['String']['output']>;
  AgentID?: Maybe<Scalars['String']['output']>;
  ApprovedDate?: Maybe<Scalars['String']['output']>;
  AspirantCity?: Maybe<Scalars['String']['output']>;
  AspirantCountry?: Maybe<Scalars['String']['output']>;
  AspirantFirstName?: Maybe<Scalars['String']['output']>;
  AspirantLastName?: Maybe<Scalars['String']['output']>;
  AspirantMDRTID?: Maybe<Scalars['String']['output']>;
  AspirantState?: Maybe<Scalars['String']['output']>;
  AttendeeStatus?: Maybe<Scalars['String']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MemberStatus?: Maybe<Scalars['String']['output']>;
  MembershipLevel?: Maybe<Scalars['String']['output']>;
  MenteeLabel?: Maybe<Scalars['String']['output']>;
  MentorEnrollmentDate?: Maybe<Scalars['String']['output']>;
  MentorFirstName?: Maybe<Scalars['String']['output']>;
  MentorLabel?: Maybe<Scalars['String']['output']>;
  MentorLastName?: Maybe<Scalars['String']['output']>;
  MentorMDRTID?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneNumber?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  Problem?: Maybe<Scalars['String']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  TotalNumberOfEdgeMeetingsAttended?: Maybe<Scalars['String']['output']>;
  TotalYearsOfMembership?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockAddressLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockApprovedDateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockAspirantCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockAspirantCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockAspirantFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockAspirantLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockAspirantMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockAspirantStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockAttendeeStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockMemberStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockMenteeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockMentorEnrollmentDateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockMentorFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockMentorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockMentorLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockMentorMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockMobileCellPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockPostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockProblemArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockTotalNumberOfEdgeMeetingsAttendedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockTotalYearsOfMembershipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacet = {
  __typename?: 'CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacet';
  AddressLine?: Maybe<Array<Maybe<StringFacet>>>;
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  ApprovedDate?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantCity?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantCountry?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantFirstName?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantLastName?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantMDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantState?: Maybe<Array<Maybe<StringFacet>>>;
  AttendeeStatus?: Maybe<Array<Maybe<StringFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  FirstName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LastName?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MemberStatus?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevel?: Maybe<Array<Maybe<StringFacet>>>;
  MenteeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MentorEnrollmentDate?: Maybe<Array<Maybe<StringFacet>>>;
  MentorFirstName?: Maybe<Array<Maybe<StringFacet>>>;
  MentorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MentorLastName?: Maybe<Array<Maybe<StringFacet>>>;
  MentorMDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  PostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  Problem?: Maybe<Array<Maybe<StringFacet>>>;
  State?: Maybe<Array<Maybe<StringFacet>>>;
  TotalNumberOfEdgeMeetingsAttended?: Maybe<Array<Maybe<StringFacet>>>;
  TotalYearsOfMembership?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetAddressLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetApprovedDateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetAspirantCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetAspirantCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetAspirantFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetAspirantLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetAspirantMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetAspirantStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetAttendeeStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetMemberStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetMembershipLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetMenteeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetMentorEnrollmentDateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetMentorFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetMentorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetMentorLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetMentorMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetMobileCellPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetPostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetProblemArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetTotalNumberOfEdgeMeetingsAttendedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockFacetTotalYearsOfMembershipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockOrderByInput = {
  AddressLine?: InputMaybe<OrderBy>;
  AgentID?: InputMaybe<OrderBy>;
  ApprovedDate?: InputMaybe<OrderBy>;
  AspirantCity?: InputMaybe<OrderBy>;
  AspirantCountry?: InputMaybe<OrderBy>;
  AspirantFirstName?: InputMaybe<OrderBy>;
  AspirantLastName?: InputMaybe<OrderBy>;
  AspirantMDRTID?: InputMaybe<OrderBy>;
  AspirantState?: InputMaybe<OrderBy>;
  AttendeeStatus?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  FirstName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LastName?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MemberStatus?: InputMaybe<OrderBy>;
  MembershipLevel?: InputMaybe<OrderBy>;
  MenteeLabel?: InputMaybe<OrderBy>;
  MentorEnrollmentDate?: InputMaybe<OrderBy>;
  MentorFirstName?: InputMaybe<OrderBy>;
  MentorLabel?: InputMaybe<OrderBy>;
  MentorLastName?: InputMaybe<OrderBy>;
  MentorMDRTID?: InputMaybe<OrderBy>;
  MobileCellPhoneNumber?: InputMaybe<OrderBy>;
  PostalCode?: InputMaybe<OrderBy>;
  Problem?: InputMaybe<OrderBy>;
  State?: InputMaybe<OrderBy>;
  TotalNumberOfEdgeMeetingsAttended?: InputMaybe<OrderBy>;
  TotalYearsOfMembership?: InputMaybe<OrderBy>;
};

export type CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockWhereInput = {
  AddressLine?: InputMaybe<SearchableStringFilterInput>;
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  ApprovedDate?: InputMaybe<SearchableStringFilterInput>;
  AspirantCity?: InputMaybe<SearchableStringFilterInput>;
  AspirantCountry?: InputMaybe<SearchableStringFilterInput>;
  AspirantFirstName?: InputMaybe<SearchableStringFilterInput>;
  AspirantLastName?: InputMaybe<SearchableStringFilterInput>;
  AspirantMDRTID?: InputMaybe<SearchableStringFilterInput>;
  AspirantState?: InputMaybe<SearchableStringFilterInput>;
  AttendeeStatus?: InputMaybe<SearchableStringFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  FirstName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LastName?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MemberStatus?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevel?: InputMaybe<SearchableStringFilterInput>;
  MenteeLabel?: InputMaybe<SearchableStringFilterInput>;
  MentorEnrollmentDate?: InputMaybe<SearchableStringFilterInput>;
  MentorFirstName?: InputMaybe<SearchableStringFilterInput>;
  MentorLabel?: InputMaybe<SearchableStringFilterInput>;
  MentorLastName?: InputMaybe<SearchableStringFilterInput>;
  MentorMDRTID?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  PostalCode?: InputMaybe<SearchableStringFilterInput>;
  Problem?: InputMaybe<SearchableStringFilterInput>;
  State?: InputMaybe<SearchableStringFilterInput>;
  TotalNumberOfEdgeMeetingsAttended?: InputMaybe<SearchableStringFilterInput>;
  TotalYearsOfMembership?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminCompanyListingsPageOrderByInput = {
  AdditionalSearchCriteriaDropDown?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  AdditionalSearchCriteriaDropDownLabel?: InputMaybe<OrderBy>;
  AdditionalSearchCriteriaDropDownRequiredMessage?: InputMaybe<OrderBy>;
  AffiliatedCompanyIdLabel?: InputMaybe<OrderBy>;
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  BackToDashboardLink?: InputMaybe<CompanyAdminCompanyListingsPageLinkBlockOrderByInput>;
  BottomContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  DownloadCompanyListingsLink?: InputMaybe<CompanyAdminCompanyListingsPageLinkBlockOrderByInput>;
  ErrorResultsText?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembersTableHeaderLabels?: InputMaybe<CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockOrderByInput>;
  MentorAspirantDropdownValue?: InputMaybe<CompanyAdminCompanyListingsPageKeyTranslatedValueBlockOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<CompanyAdminCompanyListingsPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NoResultsText?: InputMaybe<OrderBy>;
  NumbersofPageLabel?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageTitle?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RecordsFoundText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  RowsPerPageLabel?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchButtonText?: InputMaybe<OrderBy>;
  SearchSectionTitle?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<CompanyAdminCompanyListingsPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  YearDropDown?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  YearDropDownLabel?: InputMaybe<OrderBy>;
  YearDropDownRequiredMessage?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CompanyAdminCompanyListingsPageOutput = {
  __typename?: 'CompanyAdminCompanyListingsPageOutput';
  autocomplete?: Maybe<CompanyAdminCompanyListingsPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CompanyAdminCompanyListingsPageFacet>;
  item?: Maybe<CompanyAdminCompanyListingsPage>;
  items?: Maybe<Array<Maybe<CompanyAdminCompanyListingsPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CompanyAdminCompanyListingsPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyAdminCompanyListingsPageWhereInput = {
  AdditionalSearchCriteriaDropDown?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  AdditionalSearchCriteriaDropDownLabel?: InputMaybe<SearchableStringFilterInput>;
  AdditionalSearchCriteriaDropDownRequiredMessage?: InputMaybe<SearchableStringFilterInput>;
  AffiliatedCompanyIdLabel?: InputMaybe<SearchableStringFilterInput>;
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  BackToDashboardLink?: InputMaybe<CompanyAdminCompanyListingsPageLinkBlockWhereInput>;
  BottomContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  DownloadCompanyListingsLink?: InputMaybe<CompanyAdminCompanyListingsPageLinkBlockWhereInput>;
  ErrorResultsText?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembersTableHeaderLabels?: InputMaybe<CompanyAdminCompanyListingsPageMembersTableHeaderLabelsBlockWhereInput>;
  MentorAspirantDropdownValue?: InputMaybe<CompanyAdminCompanyListingsPageKeyTranslatedValueBlockWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<CompanyAdminCompanyListingsPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NoResultsText?: InputMaybe<SearchableStringFilterInput>;
  NumbersofPageLabel?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageTitle?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RecordsFoundText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  RowsPerPageLabel?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchButtonText?: InputMaybe<SearchableStringFilterInput>;
  SearchSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<CompanyAdminCompanyListingsPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  YearDropDown?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  YearDropDownLabel?: InputMaybe<SearchableStringFilterInput>;
  YearDropDownRequiredMessage?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CompanyAdminCompanyListingsPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CompanyAdminCompanyListingsPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CompanyAdminCompanyListingsPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPage = IContent & IData & {
  __typename?: 'CompanyAdminMembershipDirectoryPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  BackToDashboardLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlock>;
  /** Contennt rendering below the Main content on page. */
  BottomContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ClearButtonLabel?: Maybe<Scalars['String']['output']>;
  CompanyLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DirectoryLabel?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  DownloadMembershipDirectoryLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlock>;
  EmployeeTableHeaderLabels?: Maybe<CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlock>;
  ErrorResultsText?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<CompanyAdminMembershipDirectoryPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NewActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlock>;
  NoResultsText?: Maybe<Scalars['String']['output']>;
  /** Displays the page numbers of pages text. Uses variable {{pageCount}} */
  NumbersofPageLabel?: Maybe<Scalars['String']['output']>;
  PageDescription?: Maybe<Scalars['String']['output']>;
  PageTitle?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PrintLetterAndCertificateActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlock>;
  PrintReceiptActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlock>;
  /** Displays the number of Records found for the search term. Uses variable {{totalResults}}. */
  RecordsFoundText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  ResumeActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlock>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  /** Label for showing the records per page. Uses variable {{recordsPerPage}}. */
  RowsPerPageLabel?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SearchBarPlaceholder?: Maybe<Scalars['String']['output']>;
  SearchButtonLabel?: Maybe<Scalars['String']['output']>;
  /** The helptext for user to show them what are the search field., Ex: ID , FirstName, email etc.. */
  SearchHeading?: Maybe<Scalars['String']['output']>;
  SearchRequiredMessage?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<CompanyAdminMembershipDirectoryPageImageBlock>;
  UpgradeActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageBottomContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageClearButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageCompanyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageDirectoryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageErrorResultsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageNoResultsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageNumbersofPageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPagePageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPagePageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageRecordsFoundTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageRowsPerPageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageSearchBarPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageSearchButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageSearchHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPageSearchRequiredMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Company Admin Membership Directory Page */
export type CompanyAdminMembershipDirectoryPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CompanyAdminMembershipDirectoryPageAutocomplete = {
  __typename?: 'CompanyAdminMembershipDirectoryPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  BackToDashboardLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DownloadMembershipDirectoryLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<CompanyAdminMembershipDirectoryPageImageBlockAutocomplete>;
  NewActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PrintLetterAndCertificateActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockAutocomplete>;
  PrintReceiptActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ResumeActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockAutocomplete>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<CompanyAdminMembershipDirectoryPageImageBlockAutocomplete>;
  UpgradeActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyAdminMembershipDirectoryPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminMembershipDirectoryPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminMembershipDirectoryPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminMembershipDirectoryPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminMembershipDirectoryPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminMembershipDirectoryPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminMembershipDirectoryPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminMembershipDirectoryPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminMembershipDirectoryPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyAdminMembershipDirectoryPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlock = {
  __typename?: 'CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlock';
  Action?: Maybe<Scalars['String']['output']>;
  AgentID?: Maybe<Scalars['String']['output']>;
  CurrentYearStatus?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  PrepaidCompanyAmount?: Maybe<Scalars['String']['output']>;
  PrepaidPersonAmount?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockCurrentYearStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockPrepaidCompanyAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockPrepaidPersonAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacet = {
  __typename?: 'CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacet';
  Action?: Maybe<Array<Maybe<StringFacet>>>;
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  CurrentYearStatus?: Maybe<Array<Maybe<StringFacet>>>;
  FirstName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LastName?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  PrepaidCompanyAmount?: Maybe<Array<Maybe<StringFacet>>>;
  PrepaidPersonAmount?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacetActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacetCurrentYearStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacetFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacetLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacetPrepaidCompanyAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacetPrepaidPersonAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockOrderByInput = {
  Action?: InputMaybe<OrderBy>;
  AgentID?: InputMaybe<OrderBy>;
  CurrentYearStatus?: InputMaybe<OrderBy>;
  FirstName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LastName?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  PrepaidCompanyAmount?: InputMaybe<OrderBy>;
  PrepaidPersonAmount?: InputMaybe<OrderBy>;
};

export type CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockWhereInput = {
  Action?: InputMaybe<SearchableStringFilterInput>;
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  CurrentYearStatus?: InputMaybe<SearchableStringFilterInput>;
  FirstName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LastName?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  PrepaidCompanyAmount?: InputMaybe<SearchableStringFilterInput>;
  PrepaidPersonAmount?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminMembershipDirectoryPageFacet = {
  __typename?: 'CompanyAdminMembershipDirectoryPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  BackToDashboardLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockFacet>;
  BottomContent?: Maybe<ContentAreaItemModelSearchFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ClearButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DirectoryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadMembershipDirectoryLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockFacet>;
  EmployeeTableHeaderLabels?: Maybe<CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockFacet>;
  ErrorResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<CompanyAdminMembershipDirectoryPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NewActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockFacet>;
  NoResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  NumbersofPageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PrintLetterAndCertificateActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockFacet>;
  PrintReceiptActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockFacet>;
  RecordsFoundText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ResumeActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  RowsPerPageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchBarPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  SearchButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SearchHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SearchRequiredMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<CompanyAdminMembershipDirectoryPageImageBlockFacet>;
  UpgradeActionLink?: Maybe<CompanyAdminMembershipDirectoryPageLinkBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CompanyAdminMembershipDirectoryPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminMembershipDirectoryPageFacetClearButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetCompanyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminMembershipDirectoryPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminMembershipDirectoryPageFacetDirectoryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetErrorResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminMembershipDirectoryPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetNoResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetNumbersofPageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetPageTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetRecordsFoundTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetRowsPerPageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminMembershipDirectoryPageFacetSearchBarPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetSearchButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetSearchHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetSearchRequiredMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminMembershipDirectoryPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminMembershipDirectoryPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CompanyAdminMembershipDirectoryPageImageBlock = {
  __typename?: 'CompanyAdminMembershipDirectoryPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminMembershipDirectoryPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminMembershipDirectoryPageImageBlockAutocomplete = {
  __typename?: 'CompanyAdminMembershipDirectoryPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type CompanyAdminMembershipDirectoryPageImageBlockFacet = {
  __typename?: 'CompanyAdminMembershipDirectoryPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminMembershipDirectoryPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminMembershipDirectoryPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminMembershipDirectoryPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type CompanyAdminMembershipDirectoryPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminMembershipDirectoryPageLinkBlock = {
  __typename?: 'CompanyAdminMembershipDirectoryPageLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyAdminMembershipDirectoryPageLinkBlockAutocomplete = {
  __typename?: 'CompanyAdminMembershipDirectoryPageLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyAdminMembershipDirectoryPageLinkBlockFacet = {
  __typename?: 'CompanyAdminMembershipDirectoryPageLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyAdminMembershipDirectoryPageLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyAdminMembershipDirectoryPageLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type CompanyAdminMembershipDirectoryPageLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyAdminMembershipDirectoryPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  BackToDashboardLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockOrderByInput>;
  BottomContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ClearButtonLabel?: InputMaybe<OrderBy>;
  CompanyLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DirectoryLabel?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  DownloadMembershipDirectoryLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockOrderByInput>;
  EmployeeTableHeaderLabels?: InputMaybe<CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockOrderByInput>;
  ErrorResultsText?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<CompanyAdminMembershipDirectoryPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NewActionLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockOrderByInput>;
  NoResultsText?: InputMaybe<OrderBy>;
  NumbersofPageLabel?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageTitle?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PrintLetterAndCertificateActionLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockOrderByInput>;
  PrintReceiptActionLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockOrderByInput>;
  RecordsFoundText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  ResumeActionLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  RowsPerPageLabel?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchBarPlaceholder?: InputMaybe<OrderBy>;
  SearchButtonLabel?: InputMaybe<OrderBy>;
  SearchHeading?: InputMaybe<OrderBy>;
  SearchRequiredMessage?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<CompanyAdminMembershipDirectoryPageImageBlockOrderByInput>;
  UpgradeActionLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CompanyAdminMembershipDirectoryPageOutput = {
  __typename?: 'CompanyAdminMembershipDirectoryPageOutput';
  autocomplete?: Maybe<CompanyAdminMembershipDirectoryPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CompanyAdminMembershipDirectoryPageFacet>;
  item?: Maybe<CompanyAdminMembershipDirectoryPage>;
  items?: Maybe<Array<Maybe<CompanyAdminMembershipDirectoryPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CompanyAdminMembershipDirectoryPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyAdminMembershipDirectoryPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  BackToDashboardLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockWhereInput>;
  BottomContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ClearButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DirectoryLabel?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  DownloadMembershipDirectoryLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockWhereInput>;
  EmployeeTableHeaderLabels?: InputMaybe<CompanyAdminMembershipDirectoryPageEmployeeTableHeaderLabelsBlockWhereInput>;
  ErrorResultsText?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<CompanyAdminMembershipDirectoryPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NewActionLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockWhereInput>;
  NoResultsText?: InputMaybe<SearchableStringFilterInput>;
  NumbersofPageLabel?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageTitle?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PrintLetterAndCertificateActionLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockWhereInput>;
  PrintReceiptActionLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockWhereInput>;
  RecordsFoundText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ResumeActionLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  RowsPerPageLabel?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchBarPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  SearchButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  SearchHeading?: InputMaybe<SearchableStringFilterInput>;
  SearchRequiredMessage?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<CompanyAdminMembershipDirectoryPageImageBlockWhereInput>;
  UpgradeActionLink?: InputMaybe<CompanyAdminMembershipDirectoryPageLinkBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CompanyAdminMembershipDirectoryPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CompanyAdminMembershipDirectoryPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CompanyAdminMembershipDirectoryPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A page to display annual company rankings */
export type CompanyRankingsPage = IContent & IData & {
  __typename?: 'CompanyRankingsPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  /** Contennt rendering below the Main content on page. */
  BottomContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  /** A single personalizable link that appears on the right side of the hero header */
  HeroHeaderLink?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  HeroImage?: Maybe<CompanyRankingsPageImageBlock>;
  /** Shown at the bottom of the hero section */
  HeroLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  HeroTextContentBlock?: Maybe<CompanyRankingsPageHeroTextContentBlock>;
  /** Setting for hiding the Breadcrumb Control on page. */
  HideBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
  /** Setting for hiding the Hero Contents area on page. */
  HideHeroContent?: Maybe<Scalars['Bool']['output']>;
  /** Hide the horizontal rule line under the title */
  HideLine?: Maybe<Scalars['Bool']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<CompanyRankingsPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SideBar?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  /** On desktop view, checking this will make the hero image stack below the text (defaults to stacking on the right) */
  StackHeroImageVertical?: Maybe<Scalars['Bool']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<CompanyRankingsPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPageBottomContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPageHeroHeaderLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPageHeroLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPageSideBarArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page to display annual company rankings */
export type CompanyRankingsPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CompanyRankingsPageAutocomplete = {
  __typename?: 'CompanyRankingsPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  HeroImage?: Maybe<CompanyRankingsPageImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<CompanyRankingsPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<CompanyRankingsPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyRankingsPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRankingsPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRankingsPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRankingsPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRankingsPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRankingsPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRankingsPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRankingsPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRankingsPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRankingsPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyRankingsPageFacet = {
  __typename?: 'CompanyRankingsPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  BottomContent?: Maybe<ContentAreaItemModelSearchFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  HeroHeaderLink?: Maybe<ContentAreaItemModelSearchFacet>;
  HeroImage?: Maybe<CompanyRankingsPageImageBlockFacet>;
  HeroLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  HeroTextContentBlock?: Maybe<CompanyRankingsPageHeroTextContentBlockFacet>;
  HideBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideHeroContent?: Maybe<Array<Maybe<StringFacet>>>;
  HideLine?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<CompanyRankingsPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SideBar?: Maybe<ContentAreaItemModelSearchFacet>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StackHeroImageVertical?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<CompanyRankingsPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CompanyRankingsPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyRankingsPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyRankingsPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyRankingsPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetHideBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetHideHeroContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetHideLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyRankingsPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyRankingsPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetStackHeroImageVerticalArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyRankingsPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyRankingsPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CompanyRankingsPageHeroTextContentBlock = {
  __typename?: 'CompanyRankingsPageHeroTextContentBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
};


export type CompanyRankingsPageHeroTextContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRankingsPageHeroTextContentBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRankingsPageHeroTextContentBlockPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRankingsPageHeroTextContentBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyRankingsPageHeroTextContentBlockFacet = {
  __typename?: 'CompanyRankingsPageHeroTextContentBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyRankingsPageHeroTextContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageHeroTextContentBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageHeroTextContentBlockFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageHeroTextContentBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyRankingsPageHeroTextContentBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  PreHeading?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
};

export type CompanyRankingsPageHeroTextContentBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyRankingsPageImageBlock = {
  __typename?: 'CompanyRankingsPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type CompanyRankingsPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRankingsPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRankingsPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRankingsPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRankingsPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CompanyRankingsPageImageBlockAutocomplete = {
  __typename?: 'CompanyRankingsPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type CompanyRankingsPageImageBlockFacet = {
  __typename?: 'CompanyRankingsPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyRankingsPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRankingsPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CompanyRankingsPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyRankingsPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type CompanyRankingsPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type CompanyRankingsPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  BottomContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  HeroHeaderLink?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeroImage?: InputMaybe<CompanyRankingsPageImageBlockOrderByInput>;
  HeroLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeroTextContentBlock?: InputMaybe<CompanyRankingsPageHeroTextContentBlockOrderByInput>;
  HideBreadcrumbs?: InputMaybe<OrderBy>;
  HideHeroContent?: InputMaybe<OrderBy>;
  HideLine?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<CompanyRankingsPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SideBar?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StackHeroImageVertical?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<CompanyRankingsPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CompanyRankingsPageOutput = {
  __typename?: 'CompanyRankingsPageOutput';
  autocomplete?: Maybe<CompanyRankingsPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CompanyRankingsPageFacet>;
  item?: Maybe<CompanyRankingsPage>;
  items?: Maybe<Array<Maybe<CompanyRankingsPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CompanyRankingsPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyRankingsPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  BottomContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  HeroHeaderLink?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeroImage?: InputMaybe<CompanyRankingsPageImageBlockWhereInput>;
  HeroLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeroTextContentBlock?: InputMaybe<CompanyRankingsPageHeroTextContentBlockWhereInput>;
  HideBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideHeroContent?: InputMaybe<BoolFilterInput>;
  HideLine?: InputMaybe<BoolFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<CompanyRankingsPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SideBar?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StackHeroImageVertical?: InputMaybe<BoolFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<CompanyRankingsPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CompanyRankingsPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CompanyRankingsPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CompanyRankingsPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ConfirmationModalBlock = IContent & IData & {
  __typename?: 'ConfirmationModalBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CloseButtonText?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ConfirmationModalBlockCloseButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConfirmationModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConfirmationModalBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConfirmationModalBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConfirmationModalBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConfirmationModalBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ConfirmationModalBlockAutocomplete = {
  __typename?: 'ConfirmationModalBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ConfirmationModalBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationModalBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationModalBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationModalBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationModalBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationModalBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationModalBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationModalBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationModalBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationModalBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConfirmationModalBlockFacet = {
  __typename?: 'ConfirmationModalBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CloseButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ConfirmationModalBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationModalBlockFacetCloseButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationModalBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationModalBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationModalBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ConfirmationModalBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CloseButtonText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ConfirmationModalBlockOutput = {
  __typename?: 'ConfirmationModalBlockOutput';
  autocomplete?: Maybe<ConfirmationModalBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ConfirmationModalBlockFacet>;
  item?: Maybe<ConfirmationModalBlock>;
  items?: Maybe<Array<Maybe<ConfirmationModalBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ConfirmationModalBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConfirmationModalBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CloseButtonText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ConfirmationModalBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ConfirmationModalBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ConfirmationModalBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type ConfirmationStepBlock = IContent & IData & {
  __typename?: 'ConfirmationStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Use text {{email}} to insert the user's email */
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkSectionHeading?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SvgLinkBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  UpgradeButtonText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewMoreLink?: Maybe<ConfirmationStepBlockLinkBlock>;
  ViewReceiptLinkText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type ConfirmationStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ConfirmationStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ConfirmationStepBlockLinkSectionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ConfirmationStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ConfirmationStepBlockSvgLinkBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ConfirmationStepBlockUpgradeButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ConfirmationStepBlockViewReceiptLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ConfirmationStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ConfirmationStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ConfirmationStepBlockAutocomplete = {
  __typename?: 'ConfirmationStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ViewMoreLink?: Maybe<ConfirmationStepBlockLinkBlockAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ConfirmationStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConfirmationStepBlockFacet = {
  __typename?: 'ConfirmationStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkSectionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SvgLinkBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  UpgradeButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMoreLink?: Maybe<ConfirmationStepBlockLinkBlockFacet>;
  ViewReceiptLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ConfirmationStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ConfirmationStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetLinkSectionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationStepBlockFacetUpgradeButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacetViewReceiptLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ConfirmationStepBlockLinkBlock = {
  __typename?: 'ConfirmationStepBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type ConfirmationStepBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConfirmationStepBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConfirmationStepBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConfirmationStepBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConfirmationStepBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConfirmationStepBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConfirmationStepBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ConfirmationStepBlockLinkBlockAutocomplete = {
  __typename?: 'ConfirmationStepBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ConfirmationStepBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConfirmationStepBlockLinkBlockFacet = {
  __typename?: 'ConfirmationStepBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ConfirmationStepBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ConfirmationStepBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationStepBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConfirmationStepBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type ConfirmationStepBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type ConfirmationStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkSectionHeading?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  UpgradeButtonText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ViewMoreLink?: InputMaybe<ConfirmationStepBlockLinkBlockOrderByInput>;
  ViewReceiptLinkText?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ConfirmationStepBlockOutput = {
  __typename?: 'ConfirmationStepBlockOutput';
  autocomplete?: Maybe<ConfirmationStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ConfirmationStepBlockFacet>;
  item?: Maybe<ConfirmationStepBlock>;
  items?: Maybe<Array<Maybe<ConfirmationStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ConfirmationStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConfirmationStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkSectionHeading?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  UpgradeButtonText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewMoreLink?: InputMaybe<ConfirmationStepBlockLinkBlockWhereInput>;
  ViewReceiptLinkText?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ConfirmationStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ConfirmationStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ConfirmationStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2Block = IContent & IData & {
  __typename?: 'CongratulationsStepV2Block';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicationHasBeenProcessedMessage?: Maybe<Scalars['String']['output']>;
  ApplicationIsBeingProcessedMessage?: Maybe<Scalars['String']['output']>;
  ApplicationNotProcessedStatusText?: Maybe<Scalars['String']['output']>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  BrowseAllEventsTexts?: Maybe<Scalars['String']['output']>;
  COTLevelLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  GoBackHomeButtonText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  JoinAStudyGroupText?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LearnAboutMentoringText?: Maybe<Scalars['String']['output']>;
  LinkSectionHeading?: Maybe<Scalars['String']['output']>;
  MDRTLevelLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PendingStatusText?: Maybe<Scalars['String']['output']>;
  ProcessedStatusText?: Maybe<Scalars['String']['output']>;
  ReceiptText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SomethingWentWrongMessage?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StatusText?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SyncMessageText?: Maybe<Scalars['String']['output']>;
  TOTLevelLabel?: Maybe<Scalars['String']['output']>;
  TryAgainButtonText?: Maybe<Scalars['String']['output']>;
  UpgradeButtonText?: Maybe<Scalars['String']['output']>;
  UpgradeText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewReceiptButtonText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockApplicationHasBeenProcessedMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockApplicationIsBeingProcessedMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockApplicationNotProcessedStatusTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockBrowseAllEventsTextsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockCotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockGoBackHomeButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockJoinAStudyGroupTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockLearnAboutMentoringTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockLinkSectionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockMdrtLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockPendingStatusTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockProcessedStatusTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockReceiptTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockSomethingWentWrongMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockStatusTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockSyncMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockTotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockTryAgainButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockUpgradeButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockUpgradeTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2BlockViewReceiptButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page V2 */
export type CongratulationsStepV2Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CongratulationsStepV2BlockAutocomplete = {
  __typename?: 'CongratulationsStepV2BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CongratulationsStepV2BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CongratulationsStepV2BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CongratulationsStepV2BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CongratulationsStepV2BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CongratulationsStepV2BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CongratulationsStepV2BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CongratulationsStepV2BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CongratulationsStepV2BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CongratulationsStepV2BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CongratulationsStepV2BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CongratulationsStepV2BlockFacet = {
  __typename?: 'CongratulationsStepV2BlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationHasBeenProcessedMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationIsBeingProcessedMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationNotProcessedStatusText?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BrowseAllEventsTexts?: Maybe<Array<Maybe<StringFacet>>>;
  COTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GoBackHomeButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  JoinAStudyGroupText?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LearnAboutMentoringText?: Maybe<Array<Maybe<StringFacet>>>;
  LinkSectionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PendingStatusText?: Maybe<Array<Maybe<StringFacet>>>;
  ProcessedStatusText?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SomethingWentWrongMessage?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StatusText?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SyncMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  TOTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TryAgainButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  UpgradeButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  UpgradeText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewReceiptButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CongratulationsStepV2BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetApplicationHasBeenProcessedMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetApplicationIsBeingProcessedMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetApplicationNotProcessedStatusTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetBrowseAllEventsTextsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetCotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CongratulationsStepV2BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CongratulationsStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetGoBackHomeButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetJoinAStudyGroupTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetLearnAboutMentoringTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetLinkSectionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetMdrtLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetPendingStatusTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetProcessedStatusTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetReceiptTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CongratulationsStepV2BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetSomethingWentWrongMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CongratulationsStepV2BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetStatusTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CongratulationsStepV2BlockFacetSyncMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetTotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetTryAgainButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetUpgradeButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetUpgradeTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacetViewReceiptButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CongratulationsStepV2BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CongratulationsStepV2BlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationHasBeenProcessedMessage?: InputMaybe<OrderBy>;
  ApplicationIsBeingProcessedMessage?: InputMaybe<OrderBy>;
  ApplicationNotProcessedStatusText?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  BrowseAllEventsTexts?: InputMaybe<OrderBy>;
  COTLevelLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GoBackHomeButtonText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  JoinAStudyGroupText?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LearnAboutMentoringText?: InputMaybe<OrderBy>;
  LinkSectionHeading?: InputMaybe<OrderBy>;
  MDRTLevelLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PendingStatusText?: InputMaybe<OrderBy>;
  ProcessedStatusText?: InputMaybe<OrderBy>;
  ReceiptText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SomethingWentWrongMessage?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StatusText?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SyncMessageText?: InputMaybe<OrderBy>;
  TOTLevelLabel?: InputMaybe<OrderBy>;
  TryAgainButtonText?: InputMaybe<OrderBy>;
  UpgradeButtonText?: InputMaybe<OrderBy>;
  UpgradeText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ViewReceiptButtonText?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CongratulationsStepV2BlockOutput = {
  __typename?: 'CongratulationsStepV2BlockOutput';
  autocomplete?: Maybe<CongratulationsStepV2BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CongratulationsStepV2BlockFacet>;
  item?: Maybe<CongratulationsStepV2Block>;
  items?: Maybe<Array<Maybe<CongratulationsStepV2Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CongratulationsStepV2BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CongratulationsStepV2BlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationHasBeenProcessedMessage?: InputMaybe<SearchableStringFilterInput>;
  ApplicationIsBeingProcessedMessage?: InputMaybe<SearchableStringFilterInput>;
  ApplicationNotProcessedStatusText?: InputMaybe<SearchableStringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  BrowseAllEventsTexts?: InputMaybe<SearchableStringFilterInput>;
  COTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GoBackHomeButtonText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  JoinAStudyGroupText?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LearnAboutMentoringText?: InputMaybe<SearchableStringFilterInput>;
  LinkSectionHeading?: InputMaybe<SearchableStringFilterInput>;
  MDRTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PendingStatusText?: InputMaybe<SearchableStringFilterInput>;
  ProcessedStatusText?: InputMaybe<SearchableStringFilterInput>;
  ReceiptText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SomethingWentWrongMessage?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StatusText?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SyncMessageText?: InputMaybe<SearchableStringFilterInput>;
  TOTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  TryAgainButtonText?: InputMaybe<SearchableStringFilterInput>;
  UpgradeButtonText?: InputMaybe<SearchableStringFilterInput>;
  UpgradeText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewReceiptButtonText?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CongratulationsStepV2BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CongratulationsStepV2BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CongratulationsStepV2BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used as the 'From' address in the submission email */
export type ContactEmailElementBlock = IContent & IData & {
  __typename?: 'ContactEmailElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Used as the 'From' address in the submission email */
export type ContactEmailElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used as the 'From' address in the submission email */
export type ContactEmailElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used as the 'From' address in the submission email */
export type ContactEmailElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used as the 'From' address in the submission email */
export type ContactEmailElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used as the 'From' address in the submission email */
export type ContactEmailElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used as the 'From' address in the submission email */
export type ContactEmailElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used as the 'From' address in the submission email */
export type ContactEmailElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used as the 'From' address in the submission email */
export type ContactEmailElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used as the 'From' address in the submission email */
export type ContactEmailElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContactEmailElementBlockAutocomplete = {
  __typename?: 'ContactEmailElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContactEmailElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactEmailElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactEmailElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactEmailElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactEmailElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactEmailElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactEmailElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactEmailElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactEmailElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactEmailElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContactEmailElementBlockFacet = {
  __typename?: 'ContactEmailElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContactEmailElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContactEmailElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactEmailElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContactEmailElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactEmailElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactEmailElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactEmailElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactEmailElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactEmailElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContactEmailElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContactEmailElementBlockOutput = {
  __typename?: 'ContactEmailElementBlockOutput';
  autocomplete?: Maybe<ContactEmailElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContactEmailElementBlockFacet>;
  item?: Maybe<ContactEmailElementBlock>;
  items?: Maybe<Array<Maybe<ContactEmailElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ContactEmailElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactEmailElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContactEmailElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContactEmailElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContactEmailElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Prepoulates the user's MDRT Id */
export type ContactMdrtIdElementBlock = IContent & IData & {
  __typename?: 'ContactMdrtIdElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Prepoulates the user's MDRT Id */
export type ContactMdrtIdElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's MDRT Id */
export type ContactMdrtIdElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's MDRT Id */
export type ContactMdrtIdElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's MDRT Id */
export type ContactMdrtIdElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's MDRT Id */
export type ContactMdrtIdElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's MDRT Id */
export type ContactMdrtIdElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's MDRT Id */
export type ContactMdrtIdElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's MDRT Id */
export type ContactMdrtIdElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's MDRT Id */
export type ContactMdrtIdElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContactMdrtIdElementBlockAutocomplete = {
  __typename?: 'ContactMdrtIdElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContactMdrtIdElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactMdrtIdElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactMdrtIdElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactMdrtIdElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactMdrtIdElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactMdrtIdElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactMdrtIdElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactMdrtIdElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactMdrtIdElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactMdrtIdElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContactMdrtIdElementBlockFacet = {
  __typename?: 'ContactMdrtIdElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContactMdrtIdElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContactMdrtIdElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactMdrtIdElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContactMdrtIdElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactMdrtIdElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactMdrtIdElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactMdrtIdElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactMdrtIdElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactMdrtIdElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContactMdrtIdElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContactMdrtIdElementBlockOutput = {
  __typename?: 'ContactMdrtIdElementBlockOutput';
  autocomplete?: Maybe<ContactMdrtIdElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContactMdrtIdElementBlockFacet>;
  item?: Maybe<ContactMdrtIdElementBlock>;
  items?: Maybe<Array<Maybe<ContactMdrtIdElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ContactMdrtIdElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactMdrtIdElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContactMdrtIdElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContactMdrtIdElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContactMdrtIdElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Prepoulates the user's name */
export type ContactNameElementBlock = IContent & IData & {
  __typename?: 'ContactNameElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Prepoulates the user's name */
export type ContactNameElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's name */
export type ContactNameElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's name */
export type ContactNameElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's name */
export type ContactNameElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's name */
export type ContactNameElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's name */
export type ContactNameElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's name */
export type ContactNameElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's name */
export type ContactNameElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's name */
export type ContactNameElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContactNameElementBlockAutocomplete = {
  __typename?: 'ContactNameElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContactNameElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactNameElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactNameElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactNameElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactNameElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactNameElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactNameElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactNameElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactNameElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactNameElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContactNameElementBlockFacet = {
  __typename?: 'ContactNameElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContactNameElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContactNameElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactNameElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContactNameElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactNameElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactNameElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactNameElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactNameElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactNameElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContactNameElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContactNameElementBlockOutput = {
  __typename?: 'ContactNameElementBlockOutput';
  autocomplete?: Maybe<ContactNameElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContactNameElementBlockFacet>;
  item?: Maybe<ContactNameElementBlock>;
  items?: Maybe<Array<Maybe<ContactNameElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ContactNameElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactNameElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContactNameElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContactNameElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContactNameElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Prepoulates the user's Phone Number */
export type ContactPhoneElementBlock = IContent & IData & {
  __typename?: 'ContactPhoneElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Prepoulates the user's Phone Number */
export type ContactPhoneElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's Phone Number */
export type ContactPhoneElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's Phone Number */
export type ContactPhoneElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's Phone Number */
export type ContactPhoneElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's Phone Number */
export type ContactPhoneElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's Phone Number */
export type ContactPhoneElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's Phone Number */
export type ContactPhoneElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's Phone Number */
export type ContactPhoneElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Prepoulates the user's Phone Number */
export type ContactPhoneElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContactPhoneElementBlockAutocomplete = {
  __typename?: 'ContactPhoneElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContactPhoneElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactPhoneElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactPhoneElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactPhoneElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactPhoneElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactPhoneElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactPhoneElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactPhoneElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactPhoneElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactPhoneElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContactPhoneElementBlockFacet = {
  __typename?: 'ContactPhoneElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContactPhoneElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContactPhoneElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactPhoneElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContactPhoneElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactPhoneElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactPhoneElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactPhoneElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactPhoneElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactPhoneElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContactPhoneElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContactPhoneElementBlockOutput = {
  __typename?: 'ContactPhoneElementBlockOutput';
  autocomplete?: Maybe<ContactPhoneElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContactPhoneElementBlockFacet>;
  item?: Maybe<ContactPhoneElementBlock>;
  items?: Maybe<Array<Maybe<ContactPhoneElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ContactPhoneElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactPhoneElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContactPhoneElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContactPhoneElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContactPhoneElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Contact box block used for Next static pages */
export type ContactsBlock = IContent & IData & {
  __typename?: 'ContactsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Email Address */
  Email?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Fax Number */
  FaxNumber?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Phone Number */
  PhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Region Title */
  RegionTitle?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Contact box block used for Next static pages */
export type ContactsBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact box block used for Next static pages */
export type ContactsBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact box block used for Next static pages */
export type ContactsBlockEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact box block used for Next static pages */
export type ContactsBlockFaxNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact box block used for Next static pages */
export type ContactsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact box block used for Next static pages */
export type ContactsBlockPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact box block used for Next static pages */
export type ContactsBlockRegionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact box block used for Next static pages */
export type ContactsBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact box block used for Next static pages */
export type ContactsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact box block used for Next static pages */
export type ContactsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContactsBlockAutocomplete = {
  __typename?: 'ContactsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContactsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContactsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContactsBlockFacet = {
  __typename?: 'ContactsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Email?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FaxNumber?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  RegionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContactsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactsBlockFacetEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetFaxNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContactsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetRegionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactsBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContactsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContactsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Email?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FaxNumber?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneNumber?: InputMaybe<OrderBy>;
  RegionTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContactsBlockOutput = {
  __typename?: 'ContactsBlockOutput';
  autocomplete?: Maybe<ContactsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContactsBlockFacet>;
  item?: Maybe<ContactsBlock>;
  items?: Maybe<Array<Maybe<ContactsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ContactsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Email?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FaxNumber?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  RegionTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContactsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContactsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContactsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Content = IContent & IData & {
  __typename?: 'Content';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Content_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Content_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContentAreaItemModelSearch = {
  __typename?: 'ContentAreaItemModelSearch';
  ContentLink?: Maybe<ContentModelReferenceSearch>;
  DisplayOption?: Maybe<Scalars['String']['output']>;
  InlineBlock?: Maybe<InlineBlockPropertyModelSearch>;
  Tag?: Maybe<Scalars['String']['output']>;
};


export type ContentAreaItemModelSearchContentLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchDisplayOptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchInlineBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchTagArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentAreaItemModelSearchFacet = {
  __typename?: 'ContentAreaItemModelSearchFacet';
  ContentLink?: Maybe<ContentModelReferenceSearchFacet>;
  DisplayOption?: Maybe<Array<Maybe<StringFacet>>>;
  InlineBlock?: Maybe<InlineBlockPropertyModelSearchFacet>;
  Tag?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentAreaItemModelSearchFacetDisplayOptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentAreaItemModelSearchFacetTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentAreaItemModelSearchOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceSearchOrderByInput>;
  DisplayOption?: InputMaybe<OrderBy>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelSearchOrderByInput>;
  Tag?: InputMaybe<OrderBy>;
};

export type ContentAreaItemModelSearchWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceSearchWhereInput>;
  DisplayOption?: InputMaybe<SearchableStringFilterInput>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelSearchWhereInput>;
  Tag?: InputMaybe<SearchableStringFilterInput>;
};

export type ContentAutocomplete = {
  __typename?: 'ContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentFacet = {
  __typename?: 'ContentFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentLanguageModel = {
  __typename?: 'ContentLanguageModel';
  DisplayName?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type ContentLanguageModelAutocomplete = {
  __typename?: 'ContentLanguageModelAutocomplete';
  DisplayName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Link?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContentLanguageModelAutocompleteDisplayNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentLanguageModelAutocompleteLinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentLanguageModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentLanguageModelFacet = {
  __typename?: 'ContentLanguageModelFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentLanguageModelFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelFacetLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  Link?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type ContentLanguageModelSearch = {
  __typename?: 'ContentLanguageModelSearch';
  DisplayName?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};


export type ContentLanguageModelSearchDisplayNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentLanguageModelSearchLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentLanguageModelSearchNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentLanguageModelSearchFacet = {
  __typename?: 'ContentLanguageModelSearchFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentLanguageModelSearchFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelSearchFacetLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelSearchFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelSearchOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  Link?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type ContentLanguageModelSearchWhereInput = {
  DisplayName?: InputMaybe<SearchableStringFilterInput>;
  Link?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
};

export type ContentLanguageModelWhereInput = {
  DisplayName?: InputMaybe<StringFilterInput>;
  Link?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

export type ContentModelReference = {
  __typename?: 'ContentModelReference';
  Expanded?: Maybe<IContent>;
  GuidValue?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  ProviderName?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WorkId?: Maybe<Scalars['Int']['output']>;
};

export type ContentModelReferenceAutocomplete = {
  __typename?: 'ContentModelReferenceAutocomplete';
  GuidValue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  ProviderName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContentModelReferenceAutocompleteGuidValueArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentModelReferenceAutocompleteProviderNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentModelReferenceAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentModelReferenceFacet = {
  __typename?: 'ContentModelReferenceFacet';
  GuidValue?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  ProviderName?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WorkId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContentModelReferenceFacetGuidValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContentModelReferenceFacetProviderNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetWorkIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceOrderByInput = {
  GuidValue?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  ProviderName?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WorkId?: InputMaybe<OrderBy>;
};

export type ContentModelReferenceSearch = {
  __typename?: 'ContentModelReferenceSearch';
  Expanded?: Maybe<IContent>;
  GuidValue?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Language?: Maybe<ContentLanguageModelSearch>;
  ProviderName?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WorkId?: Maybe<Scalars['Int']['output']>;
};


export type ContentModelReferenceSearchExpandedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchProviderNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentModelReferenceSearchFacet = {
  __typename?: 'ContentModelReferenceSearchFacet';
  GuidValue?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelSearchFacet>;
  ProviderName?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WorkId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContentModelReferenceSearchFacetGuidValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContentModelReferenceSearchFacetProviderNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetWorkIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceSearchOrderByInput = {
  GuidValue?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelSearchOrderByInput>;
  ProviderName?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WorkId?: InputMaybe<OrderBy>;
};

export type ContentModelReferenceSearchWhereInput = {
  GuidValue?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelSearchWhereInput>;
  ProviderName?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<SearchableStringFilterInput>;
  WorkId?: InputMaybe<IntFilterInput>;
};

export type ContentModelReferenceWhereInput = {
  GuidValue?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  ProviderName?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WorkId?: InputMaybe<IntFilterInput>;
};

export type ContentOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContentOutput = {
  __typename?: 'ContentOutput';
  autocomplete?: Maybe<ContentAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContentFacet>;
  item?: Maybe<IContent>;
  items?: Maybe<Array<Maybe<IContent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentRootsModel = {
  __typename?: 'ContentRootsModel';
  ContentAssetsRoot?: Maybe<ContentModelReference>;
  GlobalAssetsRoot?: Maybe<ContentModelReference>;
  RootPage?: Maybe<ContentModelReference>;
  SiteAssetsRoot?: Maybe<ContentModelReference>;
  StartPage?: Maybe<ContentModelReference>;
  WasteBasket?: Maybe<ContentModelReference>;
};

export type ContentRootsModelAutocomplete = {
  __typename?: 'ContentRootsModelAutocomplete';
  ContentAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  GlobalAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  RootPage?: Maybe<ContentModelReferenceAutocomplete>;
  SiteAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  StartPage?: Maybe<ContentModelReferenceAutocomplete>;
  WasteBasket?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ContentRootsModelFacet = {
  __typename?: 'ContentRootsModelFacet';
  ContentAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  GlobalAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  RootPage?: Maybe<ContentModelReferenceFacet>;
  SiteAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  StartPage?: Maybe<ContentModelReferenceFacet>;
  WasteBasket?: Maybe<ContentModelReferenceFacet>;
};

export type ContentRootsModelOrderByInput = {
  ContentAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  GlobalAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  RootPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  SiteAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  StartPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  WasteBasket?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type ContentRootsModelWhereInput = {
  ContentAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  GlobalAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  RootPage?: InputMaybe<ContentModelReferenceWhereInput>;
  SiteAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  StartPage?: InputMaybe<ContentModelReferenceWhereInput>;
  WasteBasket?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type ContentWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used by the DAM integration, cannot be edited */
export type DamAsset = IContent & IData & {
  __typename?: 'DAMAsset';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Used by the DAM integration, cannot be edited */
export type DamAssetContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used by the DAM integration, cannot be edited */
export type DamAssetNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used by the DAM integration, cannot be edited */
export type DamAsset_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used by the DAM integration, cannot be edited */
export type DamAsset_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DamAssetAutocomplete = {
  __typename?: 'DAMAssetAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DamAssetAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamAssetAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamAssetAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamAssetAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamAssetAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamAssetAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamAssetAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamAssetAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamAssetAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamAssetAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamAssetAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DamAssetFacet = {
  __typename?: 'DAMAssetFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DamAssetFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamAssetFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamAssetFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamAssetFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamAssetFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamAssetFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamAssetFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DamAssetOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DamAssetOutput = {
  __typename?: 'DAMAssetOutput';
  autocomplete?: Maybe<DamAssetAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DamAssetFacet>;
  item?: Maybe<DamAsset>;
  items?: Maybe<Array<Maybe<DamAsset>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DamAssetOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DamAssetWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DamAssetWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DamAssetWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DamAssetWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used by the DAM integration, cannot be edited */
export type DamImageAsset = IContent & IData & {
  __typename?: 'DAMImageAsset';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Used by the DAM integration, cannot be edited */
export type DamImageAssetContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used by the DAM integration, cannot be edited */
export type DamImageAssetNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used by the DAM integration, cannot be edited */
export type DamImageAsset_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used by the DAM integration, cannot be edited */
export type DamImageAsset_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DamImageAssetAutocomplete = {
  __typename?: 'DAMImageAssetAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DamImageAssetAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamImageAssetAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamImageAssetAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamImageAssetAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamImageAssetAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamImageAssetAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamImageAssetAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamImageAssetAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamImageAssetAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamImageAssetAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamImageAssetAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DamImageAssetFacet = {
  __typename?: 'DAMImageAssetFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DamImageAssetFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamImageAssetFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamImageAssetFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamImageAssetFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamImageAssetFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamImageAssetFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamImageAssetFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DamImageAssetOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DamImageAssetOutput = {
  __typename?: 'DAMImageAssetOutput';
  autocomplete?: Maybe<DamImageAssetAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DamImageAssetFacet>;
  item?: Maybe<DamImageAsset>;
  items?: Maybe<Array<Maybe<DamImageAsset>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DamImageAssetOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DamImageAssetWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DamImageAssetWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DamImageAssetWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DamImageAssetWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type DamVideo = IContent & IData & {
  __typename?: 'DAMVideo';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  cmp_link?: Maybe<Scalars['String']['output']>;
};


export type DamVideoContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DamVideoNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DamVideo_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DamVideo_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

/** Used by the DAM integration, cannot be edited */
export type DamVideoAsset = IContent & IData & {
  __typename?: 'DAMVideoAsset';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Used by the DAM integration, cannot be edited */
export type DamVideoAssetContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used by the DAM integration, cannot be edited */
export type DamVideoAssetNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used by the DAM integration, cannot be edited */
export type DamVideoAsset_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used by the DAM integration, cannot be edited */
export type DamVideoAsset_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DamVideoAssetAutocomplete = {
  __typename?: 'DAMVideoAssetAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DamVideoAssetAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAssetAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAssetAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAssetAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAssetAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAssetAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAssetAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAssetAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAssetAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAssetAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAssetAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DamVideoAssetFacet = {
  __typename?: 'DAMVideoAssetFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DamVideoAssetFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamVideoAssetFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamVideoAssetFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamVideoAssetFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamVideoAssetFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamVideoAssetFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoAssetFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DamVideoAssetOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DamVideoAssetOutput = {
  __typename?: 'DAMVideoAssetOutput';
  autocomplete?: Maybe<DamVideoAssetAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DamVideoAssetFacet>;
  item?: Maybe<DamVideoAsset>;
  items?: Maybe<Array<Maybe<DamVideoAsset>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DamVideoAssetOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DamVideoAssetWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DamVideoAssetWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DamVideoAssetWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DamVideoAssetWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type DamVideoAutocomplete = {
  __typename?: 'DAMVideoAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cmp_link?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DamVideoAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DamVideoAutocompleteCmp_LinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DamVideoFacet = {
  __typename?: 'DAMVideoFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
  cmp_link?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DamVideoFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamVideoFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamVideoFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamVideoFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamVideoFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DamVideoFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DamVideoFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DamVideoFacetCmp_LinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DamVideoOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
  cmp_link?: InputMaybe<OrderBy>;
};

export type DamVideoOutput = {
  __typename?: 'DAMVideoOutput';
  autocomplete?: Maybe<DamVideoAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DamVideoFacet>;
  item?: Maybe<DamVideo>;
  items?: Maybe<Array<Maybe<DamVideo>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DamVideoOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DamVideoWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DamVideoWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DamVideoWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DamVideoWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
  cmp_link?: InputMaybe<StringFilterInput>;
};

export type DashBoardSectionBlock = IContent & IData & {
  __typename?: 'DashBoardSectionBlock';
  Add?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Career?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Change?: Maybe<Scalars['String']['output']>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Edit?: Maybe<Scalars['String']['output']>;
  Education?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSizeError?: Maybe<Scalars['String']['output']>;
  FileTypeError?: Maybe<Scalars['String']['output']>;
  Financial?: Maybe<Scalars['String']['output']>;
  GaugeAriaLabel?: Maybe<Scalars['String']['output']>;
  Greeting?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  Health?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkLabel?: Maybe<Scalars['String']['output']>;
  MDRTId?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MembershipYears?: Maybe<Scalars['String']['output']>;
  ModalDescription?: Maybe<Scalars['String']['output']>;
  ModalTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PictureDescription?: Maybe<Scalars['String']['output']>;
  Relationships?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  Remove?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Save?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Service?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  Spiritual?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Upload?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewProfile?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type DashBoardSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashBoardSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashBoardSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DashBoardSectionBlockAutocomplete = {
  __typename?: 'DashBoardSectionBlockAutocomplete';
  Add?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Career?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  Change?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Edit?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Education?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileSizeError?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FileTypeError?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Financial?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  GaugeAriaLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Greeting?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Headline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Health?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MDRTId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MembershipYears?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ModalDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ModalTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PictureDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Relationships?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Remove?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Save?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Service?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Spiritual?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Upload?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ViewProfile?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashBoardSectionBlockAutocompleteAddArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteCareerArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteChangeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteEditArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteEducationArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteFileSizeErrorArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteFileTypeErrorArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteFinancialArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteGaugeAriaLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteGreetingArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteHealthArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteLinkLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteMdrtIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteMembershipYearsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteModalDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteModalTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompletePictureDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteRelationshipsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteRemoveArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteSaveArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteServiceArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteSpiritualArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteUploadArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocompleteViewProfileArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashBoardSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashBoardSectionBlockFacet = {
  __typename?: 'DashBoardSectionBlockFacet';
  Add?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Career?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Change?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Edit?: Maybe<Array<Maybe<StringFacet>>>;
  Education?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSizeError?: Maybe<Array<Maybe<StringFacet>>>;
  FileTypeError?: Maybe<Array<Maybe<StringFacet>>>;
  Financial?: Maybe<Array<Maybe<StringFacet>>>;
  GaugeAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Greeting?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Health?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTId?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipYears?: Maybe<Array<Maybe<StringFacet>>>;
  ModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ModalTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PictureDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Relationships?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  Remove?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Save?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Service?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  Spiritual?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Upload?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewProfile?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DashBoardSectionBlockFacetAddArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetCareerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetChangeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashBoardSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashBoardSectionBlockFacetEditArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetEducationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetFileSizeErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetFileTypeErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetFinancialArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetGaugeAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetGreetingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetHealthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetMdrtIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetMembershipYearsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetModalTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetPictureDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetRelationshipsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetRemoveArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetSaveArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashBoardSectionBlockFacetServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetSpiritualArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashBoardSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashBoardSectionBlockFacetUploadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacetViewProfileArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashBoardSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DashBoardSectionBlockOrderByInput = {
  Add?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Career?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Change?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Edit?: InputMaybe<OrderBy>;
  Education?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSizeError?: InputMaybe<OrderBy>;
  FileTypeError?: InputMaybe<OrderBy>;
  Financial?: InputMaybe<OrderBy>;
  GaugeAriaLabel?: InputMaybe<OrderBy>;
  Greeting?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  Health?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkLabel?: InputMaybe<OrderBy>;
  MDRTId?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipYears?: InputMaybe<OrderBy>;
  ModalDescription?: InputMaybe<OrderBy>;
  ModalTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PictureDescription?: InputMaybe<OrderBy>;
  Relationships?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  Remove?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Save?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Service?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  Spiritual?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Upload?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ViewProfile?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DashBoardSectionBlockOutput = {
  __typename?: 'DashBoardSectionBlockOutput';
  autocomplete?: Maybe<DashBoardSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DashBoardSectionBlockFacet>;
  item?: Maybe<DashBoardSectionBlock>;
  items?: Maybe<Array<Maybe<DashBoardSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DashBoardSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashBoardSectionBlockWhereInput = {
  Add?: InputMaybe<StringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Career?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Change?: InputMaybe<StringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Edit?: InputMaybe<StringFilterInput>;
  Education?: InputMaybe<StringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSizeError?: InputMaybe<StringFilterInput>;
  FileTypeError?: InputMaybe<StringFilterInput>;
  Financial?: InputMaybe<StringFilterInput>;
  GaugeAriaLabel?: InputMaybe<StringFilterInput>;
  Greeting?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<StringFilterInput>;
  Health?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkLabel?: InputMaybe<StringFilterInput>;
  MDRTId?: InputMaybe<StringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipYears?: InputMaybe<StringFilterInput>;
  ModalDescription?: InputMaybe<StringFilterInput>;
  ModalTitle?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PictureDescription?: InputMaybe<StringFilterInput>;
  Relationships?: InputMaybe<StringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  Remove?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Save?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Service?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  Spiritual?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Upload?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewProfile?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DashBoardSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DashBoardSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DashBoardSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for new dashboard account page */
export type DashboardAccountPage = IContent & IData & {
  __typename?: 'DashboardAccountPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContactInformation?: Maybe<DashboardAccountPageDashboardContactInformationBlock>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  CountryHint?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LoginPassword?: Maybe<DashboardAccountPageDashboardLoginPasswordBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<DashboardAccountPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Permissions?: Maybe<DashboardAccountPageDashboardPermissionsBlock>;
  PersonalInformation?: Maybe<DashboardAccountPageDashboardPersonalInformationBlock>;
  ProfessionalInformation?: Maybe<DashboardAccountPageDashboardProfessionalInformationBlock>;
  Profile?: Maybe<DashboardAccountPageDashboardProfileBlock>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SharedContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SitePreferences?: Maybe<DashboardAccountPageDashboardSitePreferencesBlock>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<DashboardAccountPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for new dashboard account page */
export type DashboardAccountPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for new dashboard account page */
export type DashboardAccountPageCountryHintArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for new dashboard account page */
export type DashboardAccountPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for new dashboard account page */
export type DashboardAccountPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for new dashboard account page */
export type DashboardAccountPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for new dashboard account page */
export type DashboardAccountPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for new dashboard account page */
export type DashboardAccountPageSharedContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for new dashboard account page */
export type DashboardAccountPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for new dashboard account page */
export type DashboardAccountPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DashboardAccountPageAutocomplete = {
  __typename?: 'DashboardAccountPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LoginPassword?: Maybe<DashboardAccountPageDashboardLoginPasswordBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<DashboardAccountPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PersonalInformation?: Maybe<DashboardAccountPageDashboardPersonalInformationBlockAutocomplete>;
  ProfessionalInformation?: Maybe<DashboardAccountPageDashboardProfessionalInformationBlockAutocomplete>;
  Profile?: Maybe<DashboardAccountPageDashboardProfileBlockAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<DashboardAccountPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardAccountPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardAccountPageDashboardContactInformationBlock = {
  __typename?: 'DashboardAccountPageDashboardContactInformationBlock';
  AdditionalPhoneLabel?: Maybe<Scalars['String']['output']>;
  AdditionalPhoneTitle?: Maybe<Scalars['String']['output']>;
  AddressLine1?: Maybe<Scalars['String']['output']>;
  AddressLine2?: Maybe<Scalars['String']['output']>;
  AddressLine3?: Maybe<Scalars['String']['output']>;
  AreaCode?: Maybe<Scalars['String']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  ISOCode?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  InvalidEmailValidationMessage?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddressTitle?: Maybe<Scalars['String']['output']>;
  MailingAddress?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  PhoneNumber?: Maybe<Scalars['String']['output']>;
  PhoneType?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  PrimaryPhoneTitle?: Maybe<Scalars['String']['output']>;
  SecondEmail?: Maybe<Scalars['String']['output']>;
  StateProvince?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  UniqueEmailValidationMessage?: Maybe<Scalars['String']['output']>;
  WeChatID?: Maybe<Scalars['String']['output']>;
};


export type DashboardAccountPageDashboardContactInformationBlockAdditionalPhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockAdditionalPhoneTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockAddressLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockAddressLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockAddressLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockIsoCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockInvalidEmailValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockLocalLanguageAddressTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockMailingAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockPhoneTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockPostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockPrimaryPhoneTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockSecondEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockStateProvinceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockUniqueEmailValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardContactInformationBlockWeChatIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardAccountPageDashboardContactInformationBlockFacet = {
  __typename?: 'DashboardAccountPageDashboardContactInformationBlockFacet';
  AdditionalPhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AdditionalPhoneTitle?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine2?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine3?: Maybe<Array<Maybe<StringFacet>>>;
  AreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  Email?: Maybe<Array<Maybe<StringFacet>>>;
  ISOCode?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  InvalidEmailValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddressTitle?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddress?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneType?: Maybe<Array<Maybe<StringFacet>>>;
  PostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryPhoneTitle?: Maybe<Array<Maybe<StringFacet>>>;
  SecondEmail?: Maybe<Array<Maybe<StringFacet>>>;
  StateProvince?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  UniqueEmailValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  WeChatID?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetAdditionalPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetAdditionalPhoneTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetAddressLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetAddressLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetAddressLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetIsoCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetInvalidEmailValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetLocalLanguageAddressTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetMailingAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetPhoneTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetPostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetPrimaryPhoneTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetSecondEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetStateProvinceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetUniqueEmailValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardContactInformationBlockFacetWeChatIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardAccountPageDashboardContactInformationBlockOrderByInput = {
  AdditionalPhoneLabel?: InputMaybe<OrderBy>;
  AdditionalPhoneTitle?: InputMaybe<OrderBy>;
  AddressLine1?: InputMaybe<OrderBy>;
  AddressLine2?: InputMaybe<OrderBy>;
  AddressLine3?: InputMaybe<OrderBy>;
  AreaCode?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  Email?: InputMaybe<OrderBy>;
  ISOCode?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  InvalidEmailValidationMessage?: InputMaybe<OrderBy>;
  LocalLanguageAddressTitle?: InputMaybe<OrderBy>;
  MailingAddress?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  PhoneNumber?: InputMaybe<OrderBy>;
  PhoneType?: InputMaybe<OrderBy>;
  PostalCode?: InputMaybe<OrderBy>;
  PrimaryPhoneTitle?: InputMaybe<OrderBy>;
  SecondEmail?: InputMaybe<OrderBy>;
  StateProvince?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  UniqueEmailValidationMessage?: InputMaybe<OrderBy>;
  WeChatID?: InputMaybe<OrderBy>;
};

export type DashboardAccountPageDashboardContactInformationBlockWhereInput = {
  AdditionalPhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  AdditionalPhoneTitle?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1?: InputMaybe<SearchableStringFilterInput>;
  AddressLine2?: InputMaybe<SearchableStringFilterInput>;
  AddressLine3?: InputMaybe<SearchableStringFilterInput>;
  AreaCode?: InputMaybe<SearchableStringFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  Email?: InputMaybe<SearchableStringFilterInput>;
  ISOCode?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  InvalidEmailValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddressTitle?: InputMaybe<SearchableStringFilterInput>;
  MailingAddress?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  PhoneType?: InputMaybe<SearchableStringFilterInput>;
  PostalCode?: InputMaybe<SearchableStringFilterInput>;
  PrimaryPhoneTitle?: InputMaybe<SearchableStringFilterInput>;
  SecondEmail?: InputMaybe<SearchableStringFilterInput>;
  StateProvince?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  UniqueEmailValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  WeChatID?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardAccountPageDashboardLoginPasswordBlock = {
  __typename?: 'DashboardAccountPageDashboardLoginPasswordBlock';
  AppleLabel?: Maybe<Scalars['String']['output']>;
  ApprovedSocialLogins?: Maybe<Scalars['String']['output']>;
  BiometricsSwitchLabel?: Maybe<Scalars['String']['output']>;
  BrowserPermissionInformation?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  EmailEditInformation?: Maybe<Scalars['String']['output']>;
  FacebookLabel?: Maybe<Scalars['String']['output']>;
  GoogleLabel?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkedInLabel?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  ResetPassword?: Maybe<DashboardAccountPageDashboardLoginPasswordBlockLinkBlock>;
  Title?: Maybe<Scalars['String']['output']>;
  UserName?: Maybe<Scalars['String']['output']>;
  UsernameNotUnique?: Maybe<Scalars['String']['output']>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockAppleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockApprovedSocialLoginsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockBiometricsSwitchLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockBrowserPermissionInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockEmailEditInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacebookLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockGoogleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkedInLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockUserNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockUsernameNotUniqueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardAccountPageDashboardLoginPasswordBlockAutocomplete = {
  __typename?: 'DashboardAccountPageDashboardLoginPasswordBlockAutocomplete';
  ResetPassword?: Maybe<DashboardAccountPageDashboardLoginPasswordBlockLinkBlockAutocomplete>;
};

export type DashboardAccountPageDashboardLoginPasswordBlockFacet = {
  __typename?: 'DashboardAccountPageDashboardLoginPasswordBlockFacet';
  AppleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ApprovedSocialLogins?: Maybe<Array<Maybe<StringFacet>>>;
  BiometricsSwitchLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BrowserPermissionInformation?: Maybe<Array<Maybe<StringFacet>>>;
  Email?: Maybe<Array<Maybe<StringFacet>>>;
  EmailEditInformation?: Maybe<Array<Maybe<StringFacet>>>;
  FacebookLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GoogleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkedInLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  ResetPassword?: Maybe<DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  UserName?: Maybe<Array<Maybe<StringFacet>>>;
  UsernameNotUnique?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetAppleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetApprovedSocialLoginsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetBiometricsSwitchLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetBrowserPermissionInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetEmailEditInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetFacebookLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetGoogleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetLinkedInLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetUserNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockFacetUsernameNotUniqueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlock = {
  __typename?: 'DashboardAccountPageDashboardLoginPasswordBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockAutocomplete = {
  __typename?: 'DashboardAccountPageDashboardLoginPasswordBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacet = {
  __typename?: 'DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type DashboardAccountPageDashboardLoginPasswordBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardAccountPageDashboardLoginPasswordBlockOrderByInput = {
  AppleLabel?: InputMaybe<OrderBy>;
  ApprovedSocialLogins?: InputMaybe<OrderBy>;
  BiometricsSwitchLabel?: InputMaybe<OrderBy>;
  BrowserPermissionInformation?: InputMaybe<OrderBy>;
  Email?: InputMaybe<OrderBy>;
  EmailEditInformation?: InputMaybe<OrderBy>;
  FacebookLabel?: InputMaybe<OrderBy>;
  GoogleLabel?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkedInLabel?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  ResetPassword?: InputMaybe<DashboardAccountPageDashboardLoginPasswordBlockLinkBlockOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  UserName?: InputMaybe<OrderBy>;
  UsernameNotUnique?: InputMaybe<OrderBy>;
};

export type DashboardAccountPageDashboardLoginPasswordBlockWhereInput = {
  AppleLabel?: InputMaybe<SearchableStringFilterInput>;
  ApprovedSocialLogins?: InputMaybe<SearchableStringFilterInput>;
  BiometricsSwitchLabel?: InputMaybe<SearchableStringFilterInput>;
  BrowserPermissionInformation?: InputMaybe<SearchableStringFilterInput>;
  Email?: InputMaybe<SearchableStringFilterInput>;
  EmailEditInformation?: InputMaybe<SearchableStringFilterInput>;
  FacebookLabel?: InputMaybe<SearchableStringFilterInput>;
  GoogleLabel?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkedInLabel?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  ResetPassword?: InputMaybe<DashboardAccountPageDashboardLoginPasswordBlockLinkBlockWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  UserName?: InputMaybe<SearchableStringFilterInput>;
  UsernameNotUnique?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardAccountPageDashboardPermissionsBlock = {
  __typename?: 'DashboardAccountPageDashboardPermissionsBlock';
  Activity?: Maybe<Scalars['String']['output']>;
  AdditionalLanguage?: Maybe<Scalars['String']['output']>;
  Bio?: Maybe<Scalars['String']['output']>;
  BrokerDealer?: Maybe<Scalars['String']['output']>;
  BusinessAnnouncements?: Maybe<Scalars['String']['output']>;
  BusinessType?: Maybe<Scalars['String']['output']>;
  CommunicationRemovalInformation?: Maybe<Scalars['String']['output']>;
  CommunicationTopicInformation?: Maybe<Scalars['String']['output']>;
  Company?: Maybe<Scalars['String']['output']>;
  ContactInformation?: Maybe<Scalars['String']['output']>;
  ContactPhoto?: Maybe<Scalars['String']['output']>;
  ContentNewsletter?: Maybe<Scalars['String']['output']>;
  Designations?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  EmailNotification?: Maybe<Scalars['String']['output']>;
  EmailNotificationInformation?: Maybe<Scalars['String']['output']>;
  EmailPermission?: Maybe<Scalars['String']['output']>;
  Expertise?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Location?: Maybe<Scalars['String']['output']>;
  MDRTFoundation?: Maybe<Scalars['String']['output']>;
  MDRTMeetings?: Maybe<Scalars['String']['output']>;
  MDRTStore?: Maybe<Scalars['String']['output']>;
  MeetingAttendance?: Maybe<Scalars['String']['output']>;
  MemberBenefits?: Maybe<Scalars['String']['output']>;
  MembershipDetailsInformation?: Maybe<Scalars['String']['output']>;
  MentorshipInterest?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  PersonalCompany?: Maybe<Scalars['String']['output']>;
  PersonalInformation?: Maybe<Scalars['String']['output']>;
  PersonalPhoto?: Maybe<Scalars['String']['output']>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  ProfessionalBackgroundInformation?: Maybe<Scalars['String']['output']>;
  Profile?: Maybe<Scalars['String']['output']>;
  ProfilePermissionInformation?: Maybe<Scalars['String']['output']>;
  SMSNotification?: Maybe<Scalars['String']['output']>;
  SMSNotificationPermission?: Maybe<Scalars['String']['output']>;
  ShareActivity?: Maybe<Scalars['String']['output']>;
  ShareActivityInformation?: Maybe<Scalars['String']['output']>;
  ShowNearby?: Maybe<Scalars['String']['output']>;
  ShowNearbyInformation?: Maybe<Scalars['String']['output']>;
  StudyGroupInterest?: Maybe<Scalars['String']['output']>;
  Topics?: Maybe<Scalars['String']['output']>;
  Website?: Maybe<Scalars['String']['output']>;
  YearsAsMember?: Maybe<Scalars['String']['output']>;
  YearsInBusiness?: Maybe<Scalars['String']['output']>;
};


export type DashboardAccountPageDashboardPermissionsBlockActivityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockAdditionalLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockBioArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockBrokerDealerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockBusinessAnnouncementsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockBusinessTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockCommunicationRemovalInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockCommunicationTopicInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockContactInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockContactPhotoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockContentNewsletterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockDesignationsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockEmailNotificationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockEmailNotificationInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockEmailPermissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockExpertiseArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockLocationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockMdrtFoundationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockMdrtMeetingsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockMdrtStoreArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockMeetingAttendanceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockMemberBenefitsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockMembershipDetailsInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockMentorshipInterestArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockPersonalCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockPersonalInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockPersonalPhotoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockProfessionalBackgroundInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockProfileArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockProfilePermissionInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockSmsNotificationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockSmsNotificationPermissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockShareActivityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockShareActivityInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockShowNearbyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockShowNearbyInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockStudyGroupInterestArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockTopicsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockWebsiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockYearsAsMemberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPermissionsBlockYearsInBusinessArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardAccountPageDashboardPermissionsBlockFacet = {
  __typename?: 'DashboardAccountPageDashboardPermissionsBlockFacet';
  Activity?: Maybe<Array<Maybe<StringFacet>>>;
  AdditionalLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  Bio?: Maybe<Array<Maybe<StringFacet>>>;
  BrokerDealer?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAnnouncements?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessType?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationRemovalInformation?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationTopicInformation?: Maybe<Array<Maybe<StringFacet>>>;
  Company?: Maybe<Array<Maybe<StringFacet>>>;
  ContactInformation?: Maybe<Array<Maybe<StringFacet>>>;
  ContactPhoto?: Maybe<Array<Maybe<StringFacet>>>;
  ContentNewsletter?: Maybe<Array<Maybe<StringFacet>>>;
  Designations?: Maybe<Array<Maybe<StringFacet>>>;
  Email?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNotification?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNotificationInformation?: Maybe<Array<Maybe<StringFacet>>>;
  EmailPermission?: Maybe<Array<Maybe<StringFacet>>>;
  Expertise?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Location?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTFoundation?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTMeetings?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTStore?: Maybe<Array<Maybe<StringFacet>>>;
  MeetingAttendance?: Maybe<Array<Maybe<StringFacet>>>;
  MemberBenefits?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipDetailsInformation?: Maybe<Array<Maybe<StringFacet>>>;
  MentorshipInterest?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalCompany?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalInformation?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalPhoto?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalBackgroundInformation?: Maybe<Array<Maybe<StringFacet>>>;
  Profile?: Maybe<Array<Maybe<StringFacet>>>;
  ProfilePermissionInformation?: Maybe<Array<Maybe<StringFacet>>>;
  SMSNotification?: Maybe<Array<Maybe<StringFacet>>>;
  SMSNotificationPermission?: Maybe<Array<Maybe<StringFacet>>>;
  ShareActivity?: Maybe<Array<Maybe<StringFacet>>>;
  ShareActivityInformation?: Maybe<Array<Maybe<StringFacet>>>;
  ShowNearby?: Maybe<Array<Maybe<StringFacet>>>;
  ShowNearbyInformation?: Maybe<Array<Maybe<StringFacet>>>;
  StudyGroupInterest?: Maybe<Array<Maybe<StringFacet>>>;
  Topics?: Maybe<Array<Maybe<StringFacet>>>;
  Website?: Maybe<Array<Maybe<StringFacet>>>;
  YearsAsMember?: Maybe<Array<Maybe<StringFacet>>>;
  YearsInBusiness?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetActivityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetAdditionalLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetBioArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetBrokerDealerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetBusinessAnnouncementsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetBusinessTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetCommunicationRemovalInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetCommunicationTopicInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetContactInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetContactPhotoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetContentNewsletterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetDesignationsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetEmailNotificationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetEmailNotificationInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetEmailPermissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetExpertiseArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetMdrtFoundationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetMdrtMeetingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetMdrtStoreArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetMeetingAttendanceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetMemberBenefitsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetMembershipDetailsInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetMentorshipInterestArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetPersonalCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetPersonalInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetPersonalPhotoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetProfessionalBackgroundInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetProfileArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetProfilePermissionInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetSmsNotificationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetSmsNotificationPermissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetShareActivityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetShareActivityInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetShowNearbyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetShowNearbyInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetStudyGroupInterestArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetTopicsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetWebsiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetYearsAsMemberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPermissionsBlockFacetYearsInBusinessArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardAccountPageDashboardPermissionsBlockOrderByInput = {
  Activity?: InputMaybe<OrderBy>;
  AdditionalLanguage?: InputMaybe<OrderBy>;
  Bio?: InputMaybe<OrderBy>;
  BrokerDealer?: InputMaybe<OrderBy>;
  BusinessAnnouncements?: InputMaybe<OrderBy>;
  BusinessType?: InputMaybe<OrderBy>;
  CommunicationRemovalInformation?: InputMaybe<OrderBy>;
  CommunicationTopicInformation?: InputMaybe<OrderBy>;
  Company?: InputMaybe<OrderBy>;
  ContactInformation?: InputMaybe<OrderBy>;
  ContactPhoto?: InputMaybe<OrderBy>;
  ContentNewsletter?: InputMaybe<OrderBy>;
  Designations?: InputMaybe<OrderBy>;
  Email?: InputMaybe<OrderBy>;
  EmailNotification?: InputMaybe<OrderBy>;
  EmailNotificationInformation?: InputMaybe<OrderBy>;
  EmailPermission?: InputMaybe<OrderBy>;
  Expertise?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Location?: InputMaybe<OrderBy>;
  MDRTFoundation?: InputMaybe<OrderBy>;
  MDRTMeetings?: InputMaybe<OrderBy>;
  MDRTStore?: InputMaybe<OrderBy>;
  MeetingAttendance?: InputMaybe<OrderBy>;
  MemberBenefits?: InputMaybe<OrderBy>;
  MembershipDetailsInformation?: InputMaybe<OrderBy>;
  MentorshipInterest?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  PersonalCompany?: InputMaybe<OrderBy>;
  PersonalInformation?: InputMaybe<OrderBy>;
  PersonalPhoto?: InputMaybe<OrderBy>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  ProfessionalBackgroundInformation?: InputMaybe<OrderBy>;
  Profile?: InputMaybe<OrderBy>;
  ProfilePermissionInformation?: InputMaybe<OrderBy>;
  SMSNotification?: InputMaybe<OrderBy>;
  SMSNotificationPermission?: InputMaybe<OrderBy>;
  ShareActivity?: InputMaybe<OrderBy>;
  ShareActivityInformation?: InputMaybe<OrderBy>;
  ShowNearby?: InputMaybe<OrderBy>;
  ShowNearbyInformation?: InputMaybe<OrderBy>;
  StudyGroupInterest?: InputMaybe<OrderBy>;
  Topics?: InputMaybe<OrderBy>;
  Website?: InputMaybe<OrderBy>;
  YearsAsMember?: InputMaybe<OrderBy>;
  YearsInBusiness?: InputMaybe<OrderBy>;
};

export type DashboardAccountPageDashboardPermissionsBlockWhereInput = {
  Activity?: InputMaybe<SearchableStringFilterInput>;
  AdditionalLanguage?: InputMaybe<SearchableStringFilterInput>;
  Bio?: InputMaybe<SearchableStringFilterInput>;
  BrokerDealer?: InputMaybe<SearchableStringFilterInput>;
  BusinessAnnouncements?: InputMaybe<SearchableStringFilterInput>;
  BusinessType?: InputMaybe<SearchableStringFilterInput>;
  CommunicationRemovalInformation?: InputMaybe<SearchableStringFilterInput>;
  CommunicationTopicInformation?: InputMaybe<SearchableStringFilterInput>;
  Company?: InputMaybe<SearchableStringFilterInput>;
  ContactInformation?: InputMaybe<SearchableStringFilterInput>;
  ContactPhoto?: InputMaybe<SearchableStringFilterInput>;
  ContentNewsletter?: InputMaybe<SearchableStringFilterInput>;
  Designations?: InputMaybe<SearchableStringFilterInput>;
  Email?: InputMaybe<SearchableStringFilterInput>;
  EmailNotification?: InputMaybe<SearchableStringFilterInput>;
  EmailNotificationInformation?: InputMaybe<SearchableStringFilterInput>;
  EmailPermission?: InputMaybe<SearchableStringFilterInput>;
  Expertise?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Location?: InputMaybe<SearchableStringFilterInput>;
  MDRTFoundation?: InputMaybe<SearchableStringFilterInput>;
  MDRTMeetings?: InputMaybe<SearchableStringFilterInput>;
  MDRTStore?: InputMaybe<SearchableStringFilterInput>;
  MeetingAttendance?: InputMaybe<SearchableStringFilterInput>;
  MemberBenefits?: InputMaybe<SearchableStringFilterInput>;
  MembershipDetailsInformation?: InputMaybe<SearchableStringFilterInput>;
  MentorshipInterest?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  PersonalCompany?: InputMaybe<SearchableStringFilterInput>;
  PersonalInformation?: InputMaybe<SearchableStringFilterInput>;
  PersonalPhoto?: InputMaybe<SearchableStringFilterInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalBackgroundInformation?: InputMaybe<SearchableStringFilterInput>;
  Profile?: InputMaybe<SearchableStringFilterInput>;
  ProfilePermissionInformation?: InputMaybe<SearchableStringFilterInput>;
  SMSNotification?: InputMaybe<SearchableStringFilterInput>;
  SMSNotificationPermission?: InputMaybe<SearchableStringFilterInput>;
  ShareActivity?: InputMaybe<SearchableStringFilterInput>;
  ShareActivityInformation?: InputMaybe<SearchableStringFilterInput>;
  ShowNearby?: InputMaybe<SearchableStringFilterInput>;
  ShowNearbyInformation?: InputMaybe<SearchableStringFilterInput>;
  StudyGroupInterest?: InputMaybe<SearchableStringFilterInput>;
  Topics?: InputMaybe<SearchableStringFilterInput>;
  Website?: InputMaybe<SearchableStringFilterInput>;
  YearsAsMember?: InputMaybe<SearchableStringFilterInput>;
  YearsInBusiness?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardAccountPageDashboardPersonalInformationBlock = {
  __typename?: 'DashboardAccountPageDashboardPersonalInformationBlock';
  AdditionalPhoneLabel?: Maybe<Scalars['String']['output']>;
  AdditionalPhoneTitle?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Gendar?: Maybe<Scalars['String']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  MiddleName?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  PreferredName?: Maybe<Scalars['String']['output']>;
  Prefix?: Maybe<Scalars['String']['output']>;
  PrimaryPhoneTitle?: Maybe<Scalars['String']['output']>;
  Suffix?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  YearOfBirth?: Maybe<Scalars['String']['output']>;
  YearOfBirthValidationMessage?: Maybe<Scalars['String']['output']>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockGenderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockMiddleNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockPreferredNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockPrefixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockSuffixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockYearOfBirthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockYearOfBirthValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardAccountPageDashboardPersonalInformationBlockAutocomplete = {
  __typename?: 'DashboardAccountPageDashboardPersonalInformationBlockAutocomplete';
  AdditionalPhoneLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AdditionalPhoneTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Gendar?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PrimaryPhoneTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockAutocompleteAdditionalPhoneLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageDashboardPersonalInformationBlockAutocompleteAdditionalPhoneTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageDashboardPersonalInformationBlockAutocompleteGendarArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardAccountPageDashboardPersonalInformationBlockAutocompletePrimaryPhoneTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardAccountPageDashboardPersonalInformationBlockFacet = {
  __typename?: 'DashboardAccountPageDashboardPersonalInformationBlockFacet';
  AdditionalPhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AdditionalPhoneTitle?: Maybe<Array<Maybe<StringFacet>>>;
  FirstName?: Maybe<Array<Maybe<StringFacet>>>;
  Gendar?: Maybe<Array<Maybe<StringFacet>>>;
  Gender?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LastName?: Maybe<Array<Maybe<StringFacet>>>;
  MiddleName?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredName?: Maybe<Array<Maybe<StringFacet>>>;
  Prefix?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryPhoneTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Suffix?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfBirth?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfBirthValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetAdditionalPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetAdditionalPhoneTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetGendarArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetGenderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetMiddleNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetPreferredNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetPrefixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetPrimaryPhoneTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetSuffixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetYearOfBirthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardPersonalInformationBlockFacetYearOfBirthValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardAccountPageDashboardPersonalInformationBlockOrderByInput = {
  AdditionalPhoneLabel?: InputMaybe<OrderBy>;
  AdditionalPhoneTitle?: InputMaybe<OrderBy>;
  FirstName?: InputMaybe<OrderBy>;
  Gendar?: InputMaybe<OrderBy>;
  Gender?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LastName?: InputMaybe<OrderBy>;
  MiddleName?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  PreferredName?: InputMaybe<OrderBy>;
  Prefix?: InputMaybe<OrderBy>;
  PrimaryPhoneTitle?: InputMaybe<OrderBy>;
  Suffix?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  YearOfBirth?: InputMaybe<OrderBy>;
  YearOfBirthValidationMessage?: InputMaybe<OrderBy>;
};

export type DashboardAccountPageDashboardPersonalInformationBlockWhereInput = {
  AdditionalPhoneLabel?: InputMaybe<StringFilterInput>;
  AdditionalPhoneTitle?: InputMaybe<StringFilterInput>;
  FirstName?: InputMaybe<SearchableStringFilterInput>;
  Gendar?: InputMaybe<StringFilterInput>;
  Gender?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LastName?: InputMaybe<SearchableStringFilterInput>;
  MiddleName?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  PreferredName?: InputMaybe<SearchableStringFilterInput>;
  Prefix?: InputMaybe<SearchableStringFilterInput>;
  PrimaryPhoneTitle?: InputMaybe<StringFilterInput>;
  Suffix?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  YearOfBirth?: InputMaybe<SearchableStringFilterInput>;
  YearOfBirthValidationMessage?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardAccountPageDashboardProfessionalInformationBlock = {
  __typename?: 'DashboardAccountPageDashboardProfessionalInformationBlock';
  AffiliatedCompany?: Maybe<Scalars['String']['output']>;
  AffiliatedCompanyInformation?: Maybe<Scalars['String']['output']>;
  AgencyCompany?: Maybe<Scalars['String']['output']>;
  AgentID?: Maybe<Scalars['String']['output']>;
  BrokerDealerCompany?: Maybe<Scalars['String']['output']>;
  CompanyChangeAlertBody?: Maybe<Scalars['String']['output']>;
  CompanyChangeAlertTitle?: Maybe<Scalars['String']['output']>;
  CountryHint?: Maybe<Scalars['String']['output']>;
  Designation?: Maybe<Scalars['String']['output']>;
  DesignationInformation?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  PersonalCompany?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  YearOfFirstLicense?: Maybe<Scalars['String']['output']>;
  YearOfFirstLicenseValidationMessage?: Maybe<Scalars['String']['output']>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockAffiliatedCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockAffiliatedCompanyInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockAgencyCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockBrokerDealerCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockCompanyChangeAlertBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockCompanyChangeAlertTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockDesignationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockDesignationInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockJobTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockPersonalCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockYearOfFirstLicenseArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockYearOfFirstLicenseValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardAccountPageDashboardProfessionalInformationBlockAutocomplete = {
  __typename?: 'DashboardAccountPageDashboardProfessionalInformationBlockAutocomplete';
  CountryHint?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockAutocompleteCountryHintArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardAccountPageDashboardProfessionalInformationBlockFacet = {
  __typename?: 'DashboardAccountPageDashboardProfessionalInformationBlockFacet';
  AffiliatedCompany?: Maybe<Array<Maybe<StringFacet>>>;
  AffiliatedCompanyInformation?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyCompany?: Maybe<Array<Maybe<StringFacet>>>;
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  BrokerDealerCompany?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyChangeAlertBody?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyChangeAlertTitle?: Maybe<Array<Maybe<StringFacet>>>;
  CountryHint?: Maybe<Array<Maybe<StringFacet>>>;
  Designation?: Maybe<Array<Maybe<StringFacet>>>;
  DesignationInformation?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  JobTitle?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalCompany?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstLicense?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstLicenseValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetAffiliatedCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetAffiliatedCompanyInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetAgencyCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetBrokerDealerCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetCompanyChangeAlertBodyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetCompanyChangeAlertTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetCountryHintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetDesignationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetDesignationInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetJobTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetPersonalCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetYearOfFirstLicenseArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfessionalInformationBlockFacetYearOfFirstLicenseValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardAccountPageDashboardProfessionalInformationBlockOrderByInput = {
  AffiliatedCompany?: InputMaybe<OrderBy>;
  AffiliatedCompanyInformation?: InputMaybe<OrderBy>;
  AgencyCompany?: InputMaybe<OrderBy>;
  AgentID?: InputMaybe<OrderBy>;
  BrokerDealerCompany?: InputMaybe<OrderBy>;
  CompanyChangeAlertBody?: InputMaybe<OrderBy>;
  CompanyChangeAlertTitle?: InputMaybe<OrderBy>;
  CountryHint?: InputMaybe<OrderBy>;
  Designation?: InputMaybe<OrderBy>;
  DesignationInformation?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  JobTitle?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  PersonalCompany?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  YearOfFirstLicense?: InputMaybe<OrderBy>;
  YearOfFirstLicenseValidationMessage?: InputMaybe<OrderBy>;
};

export type DashboardAccountPageDashboardProfessionalInformationBlockWhereInput = {
  AffiliatedCompany?: InputMaybe<SearchableStringFilterInput>;
  AffiliatedCompanyInformation?: InputMaybe<SearchableStringFilterInput>;
  AgencyCompany?: InputMaybe<SearchableStringFilterInput>;
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  BrokerDealerCompany?: InputMaybe<SearchableStringFilterInput>;
  CompanyChangeAlertBody?: InputMaybe<SearchableStringFilterInput>;
  CompanyChangeAlertTitle?: InputMaybe<SearchableStringFilterInput>;
  CountryHint?: InputMaybe<StringFilterInput>;
  Designation?: InputMaybe<SearchableStringFilterInput>;
  DesignationInformation?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  JobTitle?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  PersonalCompany?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  YearOfFirstLicense?: InputMaybe<SearchableStringFilterInput>;
  YearOfFirstLicenseValidationMessage?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardAccountPageDashboardProfileBlock = {
  __typename?: 'DashboardAccountPageDashboardProfileBlock';
  Bio?: Maybe<Scalars['String']['output']>;
  DisplayName?: Maybe<Scalars['String']['output']>;
  Facebook?: Maybe<Scalars['String']['output']>;
  GetMembershipCertificate?: Maybe<Scalars['String']['output']>;
  Instagram?: Maybe<Scalars['String']['output']>;
  LinkedIn?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  ShareSocialLinks?: Maybe<Scalars['String']['output']>;
  SocialLinks?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Twitter?: Maybe<Scalars['String']['output']>;
  ViewMembershipInvoice?: Maybe<Scalars['String']['output']>;
  ViewProfileLink?: Maybe<DashboardAccountPageDashboardProfileBlockLinkBlock>;
  ViewShoppingProfileLink?: Maybe<DashboardAccountPageDashboardProfileBlockLinkBlock>;
};


export type DashboardAccountPageDashboardProfileBlockBioArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockDisplayNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockFacebookArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockGetMembershipCertificateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockInstagramArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockLinkedInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockShareSocialLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockSocialLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockTwitterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockViewMembershipInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardAccountPageDashboardProfileBlockAutocomplete = {
  __typename?: 'DashboardAccountPageDashboardProfileBlockAutocomplete';
  ViewProfileLink?: Maybe<DashboardAccountPageDashboardProfileBlockLinkBlockAutocomplete>;
  ViewShoppingProfileLink?: Maybe<DashboardAccountPageDashboardProfileBlockLinkBlockAutocomplete>;
};

export type DashboardAccountPageDashboardProfileBlockFacet = {
  __typename?: 'DashboardAccountPageDashboardProfileBlockFacet';
  Bio?: Maybe<Array<Maybe<StringFacet>>>;
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  Facebook?: Maybe<Array<Maybe<StringFacet>>>;
  GetMembershipCertificate?: Maybe<Array<Maybe<StringFacet>>>;
  Instagram?: Maybe<Array<Maybe<StringFacet>>>;
  LinkedIn?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  ShareSocialLinks?: Maybe<Array<Maybe<StringFacet>>>;
  SocialLinks?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Twitter?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMembershipInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  ViewProfileLink?: Maybe<DashboardAccountPageDashboardProfileBlockLinkBlockFacet>;
  ViewShoppingProfileLink?: Maybe<DashboardAccountPageDashboardProfileBlockLinkBlockFacet>;
};


export type DashboardAccountPageDashboardProfileBlockFacetBioArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockFacetFacebookArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockFacetGetMembershipCertificateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockFacetInstagramArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockFacetLinkedInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockFacetShareSocialLinksArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockFacetSocialLinksArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockFacetTwitterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockFacetViewMembershipInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardAccountPageDashboardProfileBlockLinkBlock = {
  __typename?: 'DashboardAccountPageDashboardProfileBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardAccountPageDashboardProfileBlockLinkBlockAutocomplete = {
  __typename?: 'DashboardAccountPageDashboardProfileBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardAccountPageDashboardProfileBlockLinkBlockFacet = {
  __typename?: 'DashboardAccountPageDashboardProfileBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardProfileBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardAccountPageDashboardProfileBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type DashboardAccountPageDashboardProfileBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardAccountPageDashboardProfileBlockOrderByInput = {
  Bio?: InputMaybe<OrderBy>;
  DisplayName?: InputMaybe<OrderBy>;
  Facebook?: InputMaybe<OrderBy>;
  GetMembershipCertificate?: InputMaybe<OrderBy>;
  Instagram?: InputMaybe<OrderBy>;
  LinkedIn?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  ShareSocialLinks?: InputMaybe<OrderBy>;
  SocialLinks?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Twitter?: InputMaybe<OrderBy>;
  ViewMembershipInvoice?: InputMaybe<OrderBy>;
  ViewProfileLink?: InputMaybe<DashboardAccountPageDashboardProfileBlockLinkBlockOrderByInput>;
  ViewShoppingProfileLink?: InputMaybe<DashboardAccountPageDashboardProfileBlockLinkBlockOrderByInput>;
};

export type DashboardAccountPageDashboardProfileBlockWhereInput = {
  Bio?: InputMaybe<SearchableStringFilterInput>;
  DisplayName?: InputMaybe<SearchableStringFilterInput>;
  Facebook?: InputMaybe<SearchableStringFilterInput>;
  GetMembershipCertificate?: InputMaybe<SearchableStringFilterInput>;
  Instagram?: InputMaybe<SearchableStringFilterInput>;
  LinkedIn?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  ShareSocialLinks?: InputMaybe<SearchableStringFilterInput>;
  SocialLinks?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Twitter?: InputMaybe<SearchableStringFilterInput>;
  ViewMembershipInvoice?: InputMaybe<SearchableStringFilterInput>;
  ViewProfileLink?: InputMaybe<DashboardAccountPageDashboardProfileBlockLinkBlockWhereInput>;
  ViewShoppingProfileLink?: InputMaybe<DashboardAccountPageDashboardProfileBlockLinkBlockWhereInput>;
};

export type DashboardAccountPageDashboardSitePreferencesBlock = {
  __typename?: 'DashboardAccountPageDashboardSitePreferencesBlock';
  AddMoreTopicsButtonLabel?: Maybe<Scalars['String']['output']>;
  ChooseLanguage?: Maybe<Scalars['String']['output']>;
  ChooseTopics?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Interests?: Maybe<Scalars['String']['output']>;
  InterestsErrorMessage?: Maybe<Scalars['String']['output']>;
  LanguageLabel?: Maybe<Scalars['String']['output']>;
  MemberDirectory?: Maybe<Scalars['String']['output']>;
  MemberDirectoryOptIn?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  SaveInterests?: Maybe<Scalars['String']['output']>;
  SelectTopics?: Maybe<Scalars['String']['output']>;
  WhatInterests?: Maybe<Scalars['String']['output']>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockAddMoreTopicsButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockChooseLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockChooseTopicsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockInterestsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockInterestsErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockLanguageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockMemberDirectoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockMemberDirectoryOptInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockSaveInterestsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockSelectTopicsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockWhatInterestsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardAccountPageDashboardSitePreferencesBlockFacet = {
  __typename?: 'DashboardAccountPageDashboardSitePreferencesBlockFacet';
  AddMoreTopicsButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ChooseLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  ChooseTopics?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Interests?: Maybe<Array<Maybe<StringFacet>>>;
  InterestsErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LanguageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDirectory?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDirectoryOptIn?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  SaveInterests?: Maybe<Array<Maybe<StringFacet>>>;
  SelectTopics?: Maybe<Array<Maybe<StringFacet>>>;
  WhatInterests?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetAddMoreTopicsButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetChooseLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetChooseTopicsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetInterestsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetInterestsErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetLanguageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetMemberDirectoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetMemberDirectoryOptInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetSaveInterestsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetSelectTopicsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageDashboardSitePreferencesBlockFacetWhatInterestsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardAccountPageDashboardSitePreferencesBlockOrderByInput = {
  AddMoreTopicsButtonLabel?: InputMaybe<OrderBy>;
  ChooseLanguage?: InputMaybe<OrderBy>;
  ChooseTopics?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Interests?: InputMaybe<OrderBy>;
  InterestsErrorMessage?: InputMaybe<OrderBy>;
  LanguageLabel?: InputMaybe<OrderBy>;
  MemberDirectory?: InputMaybe<OrderBy>;
  MemberDirectoryOptIn?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  SaveInterests?: InputMaybe<OrderBy>;
  SelectTopics?: InputMaybe<OrderBy>;
  WhatInterests?: InputMaybe<OrderBy>;
};

export type DashboardAccountPageDashboardSitePreferencesBlockWhereInput = {
  AddMoreTopicsButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ChooseLanguage?: InputMaybe<SearchableStringFilterInput>;
  ChooseTopics?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Interests?: InputMaybe<SearchableStringFilterInput>;
  InterestsErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  LanguageLabel?: InputMaybe<SearchableStringFilterInput>;
  MemberDirectory?: InputMaybe<SearchableStringFilterInput>;
  MemberDirectoryOptIn?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  SaveInterests?: InputMaybe<SearchableStringFilterInput>;
  SelectTopics?: InputMaybe<SearchableStringFilterInput>;
  WhatInterests?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardAccountPageFacet = {
  __typename?: 'DashboardAccountPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContactInformation?: Maybe<DashboardAccountPageDashboardContactInformationBlockFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  CountryHint?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LoginPassword?: Maybe<DashboardAccountPageDashboardLoginPasswordBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<DashboardAccountPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Permissions?: Maybe<DashboardAccountPageDashboardPermissionsBlockFacet>;
  PersonalInformation?: Maybe<DashboardAccountPageDashboardPersonalInformationBlockFacet>;
  ProfessionalInformation?: Maybe<DashboardAccountPageDashboardProfessionalInformationBlockFacet>;
  Profile?: Maybe<DashboardAccountPageDashboardProfileBlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SharedContent?: Maybe<ContentAreaItemModelSearchFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SitePreferences?: Maybe<DashboardAccountPageDashboardSitePreferencesBlockFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<DashboardAccountPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DashboardAccountPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardAccountPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardAccountPageFacetCountryHintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardAccountPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardAccountPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardAccountPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardAccountPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardAccountPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DashboardAccountPageImageBlock = {
  __typename?: 'DashboardAccountPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type DashboardAccountPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardAccountPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardAccountPageImageBlockAutocomplete = {
  __typename?: 'DashboardAccountPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type DashboardAccountPageImageBlockFacet = {
  __typename?: 'DashboardAccountPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardAccountPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardAccountPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardAccountPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardAccountPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type DashboardAccountPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardAccountPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContactInformation?: InputMaybe<DashboardAccountPageDashboardContactInformationBlockOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  CountryHint?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LoginPassword?: InputMaybe<DashboardAccountPageDashboardLoginPasswordBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<DashboardAccountPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Permissions?: InputMaybe<DashboardAccountPageDashboardPermissionsBlockOrderByInput>;
  PersonalInformation?: InputMaybe<DashboardAccountPageDashboardPersonalInformationBlockOrderByInput>;
  ProfessionalInformation?: InputMaybe<DashboardAccountPageDashboardProfessionalInformationBlockOrderByInput>;
  Profile?: InputMaybe<DashboardAccountPageDashboardProfileBlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SharedContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SitePreferences?: InputMaybe<DashboardAccountPageDashboardSitePreferencesBlockOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<DashboardAccountPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DashboardAccountPageOutput = {
  __typename?: 'DashboardAccountPageOutput';
  autocomplete?: Maybe<DashboardAccountPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DashboardAccountPageFacet>;
  item?: Maybe<DashboardAccountPage>;
  items?: Maybe<Array<Maybe<DashboardAccountPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DashboardAccountPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardAccountPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContactInformation?: InputMaybe<DashboardAccountPageDashboardContactInformationBlockWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  CountryHint?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LoginPassword?: InputMaybe<DashboardAccountPageDashboardLoginPasswordBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<DashboardAccountPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Permissions?: InputMaybe<DashboardAccountPageDashboardPermissionsBlockWhereInput>;
  PersonalInformation?: InputMaybe<DashboardAccountPageDashboardPersonalInformationBlockWhereInput>;
  ProfessionalInformation?: InputMaybe<DashboardAccountPageDashboardProfessionalInformationBlockWhereInput>;
  Profile?: InputMaybe<DashboardAccountPageDashboardProfileBlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SharedContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SitePreferences?: InputMaybe<DashboardAccountPageDashboardSitePreferencesBlockWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<DashboardAccountPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DashboardAccountPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DashboardAccountPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DashboardAccountPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type DashboardCarouselCardBlock = IContent & IData & {
  __typename?: 'DashboardCarouselCardBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CardUrl?: Maybe<DashboardCarouselCardBlockLinkBlock>;
  CareerStage?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentCategory?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Country?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FoundationDonorLevel?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LearnResourceTopic?: Maybe<Scalars['String']['output']>;
  LocationsAndDates?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MeetingId?: Maybe<Scalars['String']['output']>;
  MeetingRegistrationStatus?: Maybe<Scalars['String']['output']>;
  MemberType?: Maybe<Scalars['String']['output']>;
  MembershipLevel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TotalMemberYearsCountFrom?: Maybe<Scalars['Int']['output']>;
  TotalMemberYearsCountTo?: Maybe<Scalars['Int']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type DashboardCarouselCardBlockCareerStageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockContentCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockFoundationDonorLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockLearnResourceTopicArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockLocationsAndDatesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockMeetingIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockMeetingRegistrationStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockMemberTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DashboardCarouselCardBlockAutocomplete = {
  __typename?: 'DashboardCarouselCardBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CardUrl?: Maybe<DashboardCarouselCardBlockLinkBlockAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardCarouselCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardCarouselCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardCarouselCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardCarouselCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardCarouselCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardCarouselCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardCarouselCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardCarouselCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardCarouselCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardCarouselCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardCarouselCardBlockFacet = {
  __typename?: 'DashboardCarouselCardBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CardUrl?: Maybe<DashboardCarouselCardBlockLinkBlockFacet>;
  CareerStage?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FoundationDonorLevel?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LearnResourceTopic?: Maybe<Array<Maybe<StringFacet>>>;
  LocationsAndDates?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MeetingId?: Maybe<Array<Maybe<StringFacet>>>;
  MeetingRegistrationStatus?: Maybe<Array<Maybe<StringFacet>>>;
  MemberType?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TotalMemberYearsCountFrom?: Maybe<Array<Maybe<NumberFacet>>>;
  TotalMemberYearsCountTo?: Maybe<Array<Maybe<NumberFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DashboardCarouselCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetCareerStageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardCarouselCardBlockFacetContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardCarouselCardBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetFoundationDonorLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardCarouselCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetLearnResourceTopicArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetMeetingIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetMeetingRegistrationStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetMemberTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetMembershipLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardCarouselCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardCarouselCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardCarouselCardBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacetTotalMemberYearsCountFromArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardCarouselCardBlockFacetTotalMemberYearsCountToArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardCarouselCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DashboardCarouselCardBlockLinkBlock = {
  __typename?: 'DashboardCarouselCardBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type DashboardCarouselCardBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardCarouselCardBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardCarouselCardBlockLinkBlockAutocomplete = {
  __typename?: 'DashboardCarouselCardBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardCarouselCardBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardCarouselCardBlockLinkBlockFacet = {
  __typename?: 'DashboardCarouselCardBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardCarouselCardBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardCarouselCardBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardCarouselCardBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardCarouselCardBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type DashboardCarouselCardBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardCarouselCardBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CardUrl?: InputMaybe<DashboardCarouselCardBlockLinkBlockOrderByInput>;
  CareerStage?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentCategory?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FoundationDonorLevel?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LearnResourceTopic?: InputMaybe<OrderBy>;
  LocationsAndDates?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MeetingId?: InputMaybe<OrderBy>;
  MeetingRegistrationStatus?: InputMaybe<OrderBy>;
  MemberType?: InputMaybe<OrderBy>;
  MembershipLevel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TotalMemberYearsCountFrom?: InputMaybe<OrderBy>;
  TotalMemberYearsCountTo?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DashboardCarouselCardBlockOutput = {
  __typename?: 'DashboardCarouselCardBlockOutput';
  autocomplete?: Maybe<DashboardCarouselCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DashboardCarouselCardBlockFacet>;
  item?: Maybe<DashboardCarouselCardBlock>;
  items?: Maybe<Array<Maybe<DashboardCarouselCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DashboardCarouselCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardCarouselCardBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CardUrl?: InputMaybe<DashboardCarouselCardBlockLinkBlockWhereInput>;
  CareerStage?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentCategory?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FoundationDonorLevel?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LearnResourceTopic?: InputMaybe<SearchableStringFilterInput>;
  LocationsAndDates?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MeetingId?: InputMaybe<SearchableStringFilterInput>;
  MeetingRegistrationStatus?: InputMaybe<SearchableStringFilterInput>;
  MemberType?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TotalMemberYearsCountFrom?: InputMaybe<IntFilterInput>;
  TotalMemberYearsCountTo?: InputMaybe<IntFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DashboardCarouselCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DashboardCarouselCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DashboardCarouselCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlock = IContent & IData & {
  __typename?: 'DashboardContactInformationBlock';
  AdditionalPhoneLabel?: Maybe<Scalars['String']['output']>;
  AdditionalPhoneTitle?: Maybe<Scalars['String']['output']>;
  AddressLine1?: Maybe<Scalars['String']['output']>;
  AddressLine2?: Maybe<Scalars['String']['output']>;
  AddressLine3?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AreaCode?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ISOCode?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  InvalidEmailValidationMessage?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LocalLanguageAddressTitle?: Maybe<Scalars['String']['output']>;
  MailingAddress?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PhoneNumber?: Maybe<Scalars['String']['output']>;
  PhoneType?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  PrimaryPhoneTitle?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SecondEmail?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  StateProvince?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  UniqueEmailValidationMessage?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WeChatID?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockAdditionalPhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockAdditionalPhoneTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockAddressLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockAddressLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockAddressLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockIsoCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockInvalidEmailValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockLocalLanguageAddressTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockMailingAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockPhoneTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockPostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockPrimaryPhoneTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockSecondEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockStateProvinceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockUniqueEmailValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlockWeChatIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account contact information block */
export type DashboardContactInformationBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DashboardContactInformationBlockAutocomplete = {
  __typename?: 'DashboardContactInformationBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardContactInformationBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardContactInformationBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardContactInformationBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardContactInformationBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardContactInformationBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardContactInformationBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardContactInformationBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardContactInformationBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardContactInformationBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardContactInformationBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardContactInformationBlockFacet = {
  __typename?: 'DashboardContactInformationBlockFacet';
  AdditionalPhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AdditionalPhoneTitle?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine2?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine3?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Email?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ISOCode?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  InvalidEmailValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LocalLanguageAddressTitle?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddress?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneType?: Maybe<Array<Maybe<StringFacet>>>;
  PostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryPhoneTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SecondEmail?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StateProvince?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  UniqueEmailValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WeChatID?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DashboardContactInformationBlockFacetAdditionalPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetAdditionalPhoneTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetAddressLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetAddressLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetAddressLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardContactInformationBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardContactInformationBlockFacetEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetIsoCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardContactInformationBlockFacetInvalidEmailValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetLocalLanguageAddressTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetMailingAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetPhoneTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetPostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetPrimaryPhoneTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardContactInformationBlockFacetSecondEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardContactInformationBlockFacetStateProvinceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardContactInformationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetUniqueEmailValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacetWeChatIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardContactInformationBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DashboardContactInformationBlockOrderByInput = {
  AdditionalPhoneLabel?: InputMaybe<OrderBy>;
  AdditionalPhoneTitle?: InputMaybe<OrderBy>;
  AddressLine1?: InputMaybe<OrderBy>;
  AddressLine2?: InputMaybe<OrderBy>;
  AddressLine3?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AreaCode?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Email?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ISOCode?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  InvalidEmailValidationMessage?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LocalLanguageAddressTitle?: InputMaybe<OrderBy>;
  MailingAddress?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneNumber?: InputMaybe<OrderBy>;
  PhoneType?: InputMaybe<OrderBy>;
  PostalCode?: InputMaybe<OrderBy>;
  PrimaryPhoneTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SecondEmail?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  StateProvince?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  UniqueEmailValidationMessage?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WeChatID?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DashboardContactInformationBlockOutput = {
  __typename?: 'DashboardContactInformationBlockOutput';
  autocomplete?: Maybe<DashboardContactInformationBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DashboardContactInformationBlockFacet>;
  item?: Maybe<DashboardContactInformationBlock>;
  items?: Maybe<Array<Maybe<DashboardContactInformationBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DashboardContactInformationBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardContactInformationBlockWhereInput = {
  AdditionalPhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  AdditionalPhoneTitle?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1?: InputMaybe<SearchableStringFilterInput>;
  AddressLine2?: InputMaybe<SearchableStringFilterInput>;
  AddressLine3?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AreaCode?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Email?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ISOCode?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  InvalidEmailValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LocalLanguageAddressTitle?: InputMaybe<SearchableStringFilterInput>;
  MailingAddress?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  PhoneType?: InputMaybe<SearchableStringFilterInput>;
  PostalCode?: InputMaybe<SearchableStringFilterInput>;
  PrimaryPhoneTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SecondEmail?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  StateProvince?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  UniqueEmailValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WeChatID?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DashboardContactInformationBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DashboardContactInformationBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DashboardContactInformationBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlock = IContent & IData & {
  __typename?: 'DashboardLoginPasswordBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AppleLabel?: Maybe<Scalars['String']['output']>;
  ApprovedSocialLogins?: Maybe<Scalars['String']['output']>;
  BiometricsSwitchLabel?: Maybe<Scalars['String']['output']>;
  BrowserPermissionInformation?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  EmailEditInformation?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FacebookLabel?: Maybe<Scalars['String']['output']>;
  GoogleLabel?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkedInLabel?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  ResetPassword?: Maybe<DashboardLoginPasswordBlockLinkBlock>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UserName?: Maybe<Scalars['String']['output']>;
  UsernameNotUnique?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockAppleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockApprovedSocialLoginsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockBiometricsSwitchLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockBrowserPermissionInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockEmailEditInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockFacebookLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockGoogleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockLinkedInLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockUserNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlockUsernameNotUniqueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account login / password block */
export type DashboardLoginPasswordBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DashboardLoginPasswordBlockAutocomplete = {
  __typename?: 'DashboardLoginPasswordBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ResetPassword?: Maybe<DashboardLoginPasswordBlockLinkBlockAutocomplete>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardLoginPasswordBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardLoginPasswordBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardLoginPasswordBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardLoginPasswordBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardLoginPasswordBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardLoginPasswordBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardLoginPasswordBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardLoginPasswordBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardLoginPasswordBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardLoginPasswordBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardLoginPasswordBlockFacet = {
  __typename?: 'DashboardLoginPasswordBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AppleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ApprovedSocialLogins?: Maybe<Array<Maybe<StringFacet>>>;
  BiometricsSwitchLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BrowserPermissionInformation?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Email?: Maybe<Array<Maybe<StringFacet>>>;
  EmailEditInformation?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FacebookLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GoogleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkedInLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ResetPassword?: Maybe<DashboardLoginPasswordBlockLinkBlockFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UserName?: Maybe<Array<Maybe<StringFacet>>>;
  UsernameNotUnique?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DashboardLoginPasswordBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetAppleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetApprovedSocialLoginsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetBiometricsSwitchLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetBrowserPermissionInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardLoginPasswordBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardLoginPasswordBlockFacetEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetEmailEditInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetFacebookLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetGoogleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardLoginPasswordBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetLinkedInLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardLoginPasswordBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardLoginPasswordBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardLoginPasswordBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetUserNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacetUsernameNotUniqueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DashboardLoginPasswordBlockLinkBlock = {
  __typename?: 'DashboardLoginPasswordBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type DashboardLoginPasswordBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardLoginPasswordBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardLoginPasswordBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardLoginPasswordBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardLoginPasswordBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardLoginPasswordBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardLoginPasswordBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardLoginPasswordBlockLinkBlockAutocomplete = {
  __typename?: 'DashboardLoginPasswordBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardLoginPasswordBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardLoginPasswordBlockLinkBlockFacet = {
  __typename?: 'DashboardLoginPasswordBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardLoginPasswordBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardLoginPasswordBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardLoginPasswordBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardLoginPasswordBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type DashboardLoginPasswordBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardLoginPasswordBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AppleLabel?: InputMaybe<OrderBy>;
  ApprovedSocialLogins?: InputMaybe<OrderBy>;
  BiometricsSwitchLabel?: InputMaybe<OrderBy>;
  BrowserPermissionInformation?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Email?: InputMaybe<OrderBy>;
  EmailEditInformation?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FacebookLabel?: InputMaybe<OrderBy>;
  GoogleLabel?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkedInLabel?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  ResetPassword?: InputMaybe<DashboardLoginPasswordBlockLinkBlockOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UserName?: InputMaybe<OrderBy>;
  UsernameNotUnique?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DashboardLoginPasswordBlockOutput = {
  __typename?: 'DashboardLoginPasswordBlockOutput';
  autocomplete?: Maybe<DashboardLoginPasswordBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DashboardLoginPasswordBlockFacet>;
  item?: Maybe<DashboardLoginPasswordBlock>;
  items?: Maybe<Array<Maybe<DashboardLoginPasswordBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DashboardLoginPasswordBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardLoginPasswordBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AppleLabel?: InputMaybe<SearchableStringFilterInput>;
  ApprovedSocialLogins?: InputMaybe<SearchableStringFilterInput>;
  BiometricsSwitchLabel?: InputMaybe<SearchableStringFilterInput>;
  BrowserPermissionInformation?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Email?: InputMaybe<SearchableStringFilterInput>;
  EmailEditInformation?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FacebookLabel?: InputMaybe<SearchableStringFilterInput>;
  GoogleLabel?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkedInLabel?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ResetPassword?: InputMaybe<DashboardLoginPasswordBlockLinkBlockWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UserName?: InputMaybe<SearchableStringFilterInput>;
  UsernameNotUnique?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DashboardLoginPasswordBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DashboardLoginPasswordBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DashboardLoginPasswordBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlock = IContent & IData & {
  __typename?: 'DashboardPermissionsBlock';
  Activity?: Maybe<Scalars['String']['output']>;
  AdditionalLanguage?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Bio?: Maybe<Scalars['String']['output']>;
  BrokerDealer?: Maybe<Scalars['String']['output']>;
  BusinessAnnouncements?: Maybe<Scalars['String']['output']>;
  BusinessType?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CommunicationRemovalInformation?: Maybe<Scalars['String']['output']>;
  CommunicationTopicInformation?: Maybe<Scalars['String']['output']>;
  Company?: Maybe<Scalars['String']['output']>;
  ContactInformation?: Maybe<Scalars['String']['output']>;
  ContactPhoto?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentNewsletter?: Maybe<Scalars['String']['output']>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Designations?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  EmailNotification?: Maybe<Scalars['String']['output']>;
  EmailNotificationInformation?: Maybe<Scalars['String']['output']>;
  EmailPermission?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Expertise?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  Location?: Maybe<Scalars['String']['output']>;
  MDRTFoundation?: Maybe<Scalars['String']['output']>;
  MDRTMeetings?: Maybe<Scalars['String']['output']>;
  MDRTStore?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MeetingAttendance?: Maybe<Scalars['String']['output']>;
  MemberBenefits?: Maybe<Scalars['String']['output']>;
  MembershipDetailsInformation?: Maybe<Scalars['String']['output']>;
  MentorshipInterest?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonalCompany?: Maybe<Scalars['String']['output']>;
  PersonalInformation?: Maybe<Scalars['String']['output']>;
  PersonalPhoto?: Maybe<Scalars['String']['output']>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  ProfessionalBackgroundInformation?: Maybe<Scalars['String']['output']>;
  Profile?: Maybe<Scalars['String']['output']>;
  ProfilePermissionInformation?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SMSNotification?: Maybe<Scalars['String']['output']>;
  SMSNotificationPermission?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  ShareActivity?: Maybe<Scalars['String']['output']>;
  ShareActivityInformation?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  ShowNearby?: Maybe<Scalars['String']['output']>;
  ShowNearbyInformation?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  StudyGroupInterest?: Maybe<Scalars['String']['output']>;
  Topics?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Website?: Maybe<Scalars['String']['output']>;
  YearsAsMember?: Maybe<Scalars['String']['output']>;
  YearsInBusiness?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockActivityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockAdditionalLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockBioArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockBrokerDealerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockBusinessAnnouncementsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockBusinessTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockCommunicationRemovalInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockCommunicationTopicInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockContactInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockContactPhotoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockContentNewsletterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockDesignationsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockEmailNotificationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockEmailNotificationInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockEmailPermissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockExpertiseArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockLocationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockMdrtFoundationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockMdrtMeetingsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockMdrtStoreArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockMeetingAttendanceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockMemberBenefitsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockMembershipDetailsInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockMentorshipInterestArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockPersonalCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockPersonalInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockPersonalPhotoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockProfessionalBackgroundInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockProfileArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockProfilePermissionInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockSmsNotificationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockSmsNotificationPermissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockShareActivityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockShareActivityInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockShowNearbyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockShowNearbyInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockStudyGroupInterestArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockTopicsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockWebsiteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockYearsAsMemberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlockYearsInBusinessArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account permissions block */
export type DashboardPermissionsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DashboardPermissionsBlockAutocomplete = {
  __typename?: 'DashboardPermissionsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardPermissionsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPermissionsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPermissionsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPermissionsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPermissionsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPermissionsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPermissionsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPermissionsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPermissionsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPermissionsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardPermissionsBlockFacet = {
  __typename?: 'DashboardPermissionsBlockFacet';
  Activity?: Maybe<Array<Maybe<StringFacet>>>;
  AdditionalLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Bio?: Maybe<Array<Maybe<StringFacet>>>;
  BrokerDealer?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAnnouncements?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessType?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CommunicationRemovalInformation?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationTopicInformation?: Maybe<Array<Maybe<StringFacet>>>;
  Company?: Maybe<Array<Maybe<StringFacet>>>;
  ContactInformation?: Maybe<Array<Maybe<StringFacet>>>;
  ContactPhoto?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentNewsletter?: Maybe<Array<Maybe<StringFacet>>>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Designations?: Maybe<Array<Maybe<StringFacet>>>;
  Email?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNotification?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNotificationInformation?: Maybe<Array<Maybe<StringFacet>>>;
  EmailPermission?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Expertise?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Location?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTFoundation?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTMeetings?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTStore?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MeetingAttendance?: Maybe<Array<Maybe<StringFacet>>>;
  MemberBenefits?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipDetailsInformation?: Maybe<Array<Maybe<StringFacet>>>;
  MentorshipInterest?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonalCompany?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalInformation?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalPhoto?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalBackgroundInformation?: Maybe<Array<Maybe<StringFacet>>>;
  Profile?: Maybe<Array<Maybe<StringFacet>>>;
  ProfilePermissionInformation?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SMSNotification?: Maybe<Array<Maybe<StringFacet>>>;
  SMSNotificationPermission?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShareActivity?: Maybe<Array<Maybe<StringFacet>>>;
  ShareActivityInformation?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowNearby?: Maybe<Array<Maybe<StringFacet>>>;
  ShowNearbyInformation?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StudyGroupInterest?: Maybe<Array<Maybe<StringFacet>>>;
  Topics?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Website?: Maybe<Array<Maybe<StringFacet>>>;
  YearsAsMember?: Maybe<Array<Maybe<StringFacet>>>;
  YearsInBusiness?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DashboardPermissionsBlockFacetActivityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetAdditionalLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetBioArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetBrokerDealerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetBusinessAnnouncementsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetBusinessTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardPermissionsBlockFacetCommunicationRemovalInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetCommunicationTopicInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetContactInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetContactPhotoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetContentNewsletterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardPermissionsBlockFacetDesignationsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetEmailNotificationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetEmailNotificationInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetEmailPermissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetExpertiseArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardPermissionsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetMdrtFoundationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetMdrtMeetingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetMdrtStoreArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetMeetingAttendanceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetMemberBenefitsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetMembershipDetailsInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetMentorshipInterestArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetPersonalCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetPersonalInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetPersonalPhotoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetProfessionalBackgroundInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetProfileArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetProfilePermissionInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetSmsNotificationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetSmsNotificationPermissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardPermissionsBlockFacetShareActivityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetShareActivityInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetShowNearbyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetShowNearbyInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardPermissionsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardPermissionsBlockFacetStudyGroupInterestArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetTopicsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetWebsiteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetYearsAsMemberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacetYearsInBusinessArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPermissionsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DashboardPermissionsBlockOrderByInput = {
  Activity?: InputMaybe<OrderBy>;
  AdditionalLanguage?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Bio?: InputMaybe<OrderBy>;
  BrokerDealer?: InputMaybe<OrderBy>;
  BusinessAnnouncements?: InputMaybe<OrderBy>;
  BusinessType?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CommunicationRemovalInformation?: InputMaybe<OrderBy>;
  CommunicationTopicInformation?: InputMaybe<OrderBy>;
  Company?: InputMaybe<OrderBy>;
  ContactInformation?: InputMaybe<OrderBy>;
  ContactPhoto?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentNewsletter?: InputMaybe<OrderBy>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Designations?: InputMaybe<OrderBy>;
  Email?: InputMaybe<OrderBy>;
  EmailNotification?: InputMaybe<OrderBy>;
  EmailNotificationInformation?: InputMaybe<OrderBy>;
  EmailPermission?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Expertise?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Location?: InputMaybe<OrderBy>;
  MDRTFoundation?: InputMaybe<OrderBy>;
  MDRTMeetings?: InputMaybe<OrderBy>;
  MDRTStore?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MeetingAttendance?: InputMaybe<OrderBy>;
  MemberBenefits?: InputMaybe<OrderBy>;
  MembershipDetailsInformation?: InputMaybe<OrderBy>;
  MentorshipInterest?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonalCompany?: InputMaybe<OrderBy>;
  PersonalInformation?: InputMaybe<OrderBy>;
  PersonalPhoto?: InputMaybe<OrderBy>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  ProfessionalBackgroundInformation?: InputMaybe<OrderBy>;
  Profile?: InputMaybe<OrderBy>;
  ProfilePermissionInformation?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SMSNotification?: InputMaybe<OrderBy>;
  SMSNotificationPermission?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShareActivity?: InputMaybe<OrderBy>;
  ShareActivityInformation?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowNearby?: InputMaybe<OrderBy>;
  ShowNearbyInformation?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  StudyGroupInterest?: InputMaybe<OrderBy>;
  Topics?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Website?: InputMaybe<OrderBy>;
  YearsAsMember?: InputMaybe<OrderBy>;
  YearsInBusiness?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DashboardPermissionsBlockOutput = {
  __typename?: 'DashboardPermissionsBlockOutput';
  autocomplete?: Maybe<DashboardPermissionsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DashboardPermissionsBlockFacet>;
  item?: Maybe<DashboardPermissionsBlock>;
  items?: Maybe<Array<Maybe<DashboardPermissionsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DashboardPermissionsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardPermissionsBlockWhereInput = {
  Activity?: InputMaybe<SearchableStringFilterInput>;
  AdditionalLanguage?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Bio?: InputMaybe<SearchableStringFilterInput>;
  BrokerDealer?: InputMaybe<SearchableStringFilterInput>;
  BusinessAnnouncements?: InputMaybe<SearchableStringFilterInput>;
  BusinessType?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CommunicationRemovalInformation?: InputMaybe<SearchableStringFilterInput>;
  CommunicationTopicInformation?: InputMaybe<SearchableStringFilterInput>;
  Company?: InputMaybe<SearchableStringFilterInput>;
  ContactInformation?: InputMaybe<SearchableStringFilterInput>;
  ContactPhoto?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentNewsletter?: InputMaybe<SearchableStringFilterInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Designations?: InputMaybe<SearchableStringFilterInput>;
  Email?: InputMaybe<SearchableStringFilterInput>;
  EmailNotification?: InputMaybe<SearchableStringFilterInput>;
  EmailNotificationInformation?: InputMaybe<SearchableStringFilterInput>;
  EmailPermission?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Expertise?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Location?: InputMaybe<SearchableStringFilterInput>;
  MDRTFoundation?: InputMaybe<SearchableStringFilterInput>;
  MDRTMeetings?: InputMaybe<SearchableStringFilterInput>;
  MDRTStore?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MeetingAttendance?: InputMaybe<SearchableStringFilterInput>;
  MemberBenefits?: InputMaybe<SearchableStringFilterInput>;
  MembershipDetailsInformation?: InputMaybe<SearchableStringFilterInput>;
  MentorshipInterest?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonalCompany?: InputMaybe<SearchableStringFilterInput>;
  PersonalInformation?: InputMaybe<SearchableStringFilterInput>;
  PersonalPhoto?: InputMaybe<SearchableStringFilterInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalBackgroundInformation?: InputMaybe<SearchableStringFilterInput>;
  Profile?: InputMaybe<SearchableStringFilterInput>;
  ProfilePermissionInformation?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SMSNotification?: InputMaybe<SearchableStringFilterInput>;
  SMSNotificationPermission?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShareActivity?: InputMaybe<SearchableStringFilterInput>;
  ShareActivityInformation?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowNearby?: InputMaybe<SearchableStringFilterInput>;
  ShowNearbyInformation?: InputMaybe<SearchableStringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  StudyGroupInterest?: InputMaybe<SearchableStringFilterInput>;
  Topics?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Website?: InputMaybe<SearchableStringFilterInput>;
  YearsAsMember?: InputMaybe<SearchableStringFilterInput>;
  YearsInBusiness?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DashboardPermissionsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DashboardPermissionsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DashboardPermissionsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlock = IContent & IData & {
  __typename?: 'DashboardPersonalInformationBlock';
  AdditionalPhoneLabel?: Maybe<Scalars['String']['output']>;
  AdditionalPhoneTitle?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Gendar?: Maybe<Scalars['String']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastName?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MiddleName?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreferredName?: Maybe<Scalars['String']['output']>;
  Prefix?: Maybe<Scalars['String']['output']>;
  PrimaryPhoneTitle?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Suffix?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  YearOfBirth?: Maybe<Scalars['String']['output']>;
  YearOfBirthValidationMessage?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockGenderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockMiddleNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockPreferredNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockPrefixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockSuffixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockYearOfBirthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlockYearOfBirthValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account personal information block */
export type DashboardPersonalInformationBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DashboardPersonalInformationBlockAutocomplete = {
  __typename?: 'DashboardPersonalInformationBlockAutocomplete';
  AdditionalPhoneLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AdditionalPhoneTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Gendar?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PrimaryPhoneTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardPersonalInformationBlockAutocompleteAdditionalPhoneLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompleteAdditionalPhoneTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompleteGendarArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompletePrimaryPhoneTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardPersonalInformationBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardPersonalInformationBlockFacet = {
  __typename?: 'DashboardPersonalInformationBlockFacet';
  AdditionalPhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AdditionalPhoneTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstName?: Maybe<Array<Maybe<StringFacet>>>;
  Gendar?: Maybe<Array<Maybe<StringFacet>>>;
  Gender?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastName?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MiddleName?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreferredName?: Maybe<Array<Maybe<StringFacet>>>;
  Prefix?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryPhoneTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Suffix?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfBirth?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfBirthValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DashboardPersonalInformationBlockFacetAdditionalPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetAdditionalPhoneTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardPersonalInformationBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardPersonalInformationBlockFacetFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetGendarArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetGenderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardPersonalInformationBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetMiddleNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetPreferredNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetPrefixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetPrimaryPhoneTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardPersonalInformationBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardPersonalInformationBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardPersonalInformationBlockFacetSuffixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetYearOfBirthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacetYearOfBirthValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardPersonalInformationBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DashboardPersonalInformationBlockOrderByInput = {
  AdditionalPhoneLabel?: InputMaybe<OrderBy>;
  AdditionalPhoneTitle?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstName?: InputMaybe<OrderBy>;
  Gendar?: InputMaybe<OrderBy>;
  Gender?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastName?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MiddleName?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreferredName?: InputMaybe<OrderBy>;
  Prefix?: InputMaybe<OrderBy>;
  PrimaryPhoneTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Suffix?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  YearOfBirth?: InputMaybe<OrderBy>;
  YearOfBirthValidationMessage?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DashboardPersonalInformationBlockOutput = {
  __typename?: 'DashboardPersonalInformationBlockOutput';
  autocomplete?: Maybe<DashboardPersonalInformationBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DashboardPersonalInformationBlockFacet>;
  item?: Maybe<DashboardPersonalInformationBlock>;
  items?: Maybe<Array<Maybe<DashboardPersonalInformationBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DashboardPersonalInformationBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardPersonalInformationBlockWhereInput = {
  AdditionalPhoneLabel?: InputMaybe<StringFilterInput>;
  AdditionalPhoneTitle?: InputMaybe<StringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstName?: InputMaybe<SearchableStringFilterInput>;
  Gendar?: InputMaybe<StringFilterInput>;
  Gender?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastName?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MiddleName?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreferredName?: InputMaybe<SearchableStringFilterInput>;
  Prefix?: InputMaybe<SearchableStringFilterInput>;
  PrimaryPhoneTitle?: InputMaybe<StringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Suffix?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  YearOfBirth?: InputMaybe<SearchableStringFilterInput>;
  YearOfBirthValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DashboardPersonalInformationBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DashboardPersonalInformationBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DashboardPersonalInformationBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlock = IContent & IData & {
  __typename?: 'DashboardProfessionalInformationBlock';
  AffiliatedCompany?: Maybe<Scalars['String']['output']>;
  AffiliatedCompanyInformation?: Maybe<Scalars['String']['output']>;
  AgencyCompany?: Maybe<Scalars['String']['output']>;
  AgentID?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BrokerDealerCompany?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyChangeAlertBody?: Maybe<Scalars['String']['output']>;
  CompanyChangeAlertTitle?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CountryHint?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Designation?: Maybe<Scalars['String']['output']>;
  DesignationInformation?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonalCompany?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  YearOfFirstLicense?: Maybe<Scalars['String']['output']>;
  YearOfFirstLicenseValidationMessage?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockAffiliatedCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockAffiliatedCompanyInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockAgencyCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockBrokerDealerCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockCompanyChangeAlertBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockCompanyChangeAlertTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockDesignationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockDesignationInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockJobTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockPersonalCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockYearOfFirstLicenseArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlockYearOfFirstLicenseValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account professional information block */
export type DashboardProfessionalInformationBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DashboardProfessionalInformationBlockAutocomplete = {
  __typename?: 'DashboardProfessionalInformationBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CountryHint?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardProfessionalInformationBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfessionalInformationBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfessionalInformationBlockAutocompleteCountryHintArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfessionalInformationBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfessionalInformationBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfessionalInformationBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfessionalInformationBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfessionalInformationBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfessionalInformationBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfessionalInformationBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfessionalInformationBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardProfessionalInformationBlockFacet = {
  __typename?: 'DashboardProfessionalInformationBlockFacet';
  AffiliatedCompany?: Maybe<Array<Maybe<StringFacet>>>;
  AffiliatedCompanyInformation?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyCompany?: Maybe<Array<Maybe<StringFacet>>>;
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BrokerDealerCompany?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyChangeAlertBody?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyChangeAlertTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CountryHint?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Designation?: Maybe<Array<Maybe<StringFacet>>>;
  DesignationInformation?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  JobTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonalCompany?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstLicense?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstLicenseValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DashboardProfessionalInformationBlockFacetAffiliatedCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetAffiliatedCompanyInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetAgencyCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetBrokerDealerCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardProfessionalInformationBlockFacetCompanyChangeAlertBodyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetCompanyChangeAlertTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetCountryHintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardProfessionalInformationBlockFacetDesignationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetDesignationInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardProfessionalInformationBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetJobTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetPersonalCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardProfessionalInformationBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardProfessionalInformationBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardProfessionalInformationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetYearOfFirstLicenseArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacetYearOfFirstLicenseValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfessionalInformationBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DashboardProfessionalInformationBlockOrderByInput = {
  AffiliatedCompany?: InputMaybe<OrderBy>;
  AffiliatedCompanyInformation?: InputMaybe<OrderBy>;
  AgencyCompany?: InputMaybe<OrderBy>;
  AgentID?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BrokerDealerCompany?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyChangeAlertBody?: InputMaybe<OrderBy>;
  CompanyChangeAlertTitle?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CountryHint?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Designation?: InputMaybe<OrderBy>;
  DesignationInformation?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  JobTitle?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonalCompany?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  YearOfFirstLicense?: InputMaybe<OrderBy>;
  YearOfFirstLicenseValidationMessage?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DashboardProfessionalInformationBlockOutput = {
  __typename?: 'DashboardProfessionalInformationBlockOutput';
  autocomplete?: Maybe<DashboardProfessionalInformationBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DashboardProfessionalInformationBlockFacet>;
  item?: Maybe<DashboardProfessionalInformationBlock>;
  items?: Maybe<Array<Maybe<DashboardProfessionalInformationBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DashboardProfessionalInformationBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardProfessionalInformationBlockWhereInput = {
  AffiliatedCompany?: InputMaybe<SearchableStringFilterInput>;
  AffiliatedCompanyInformation?: InputMaybe<SearchableStringFilterInput>;
  AgencyCompany?: InputMaybe<SearchableStringFilterInput>;
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BrokerDealerCompany?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyChangeAlertBody?: InputMaybe<SearchableStringFilterInput>;
  CompanyChangeAlertTitle?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CountryHint?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Designation?: InputMaybe<SearchableStringFilterInput>;
  DesignationInformation?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  JobTitle?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonalCompany?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  YearOfFirstLicense?: InputMaybe<SearchableStringFilterInput>;
  YearOfFirstLicenseValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DashboardProfessionalInformationBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DashboardProfessionalInformationBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DashboardProfessionalInformationBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlock = IContent & IData & {
  __typename?: 'DashboardProfileBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Bio?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisplayName?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Facebook?: Maybe<Scalars['String']['output']>;
  GetMembershipCertificate?: Maybe<Scalars['String']['output']>;
  Instagram?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkedIn?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  ShareSocialLinks?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SocialLinks?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Twitter?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewMembershipInvoice?: Maybe<Scalars['String']['output']>;
  ViewProfileLink?: Maybe<DashboardProfileBlockLinkBlock>;
  ViewShoppingProfileLink?: Maybe<DashboardProfileBlockLinkBlock>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockBioArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockDisplayNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockFacebookArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockGetMembershipCertificateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockInstagramArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockLinkedInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockShareSocialLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockSocialLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockTwitterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlockViewMembershipInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account profile block */
export type DashboardProfileBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DashboardProfileBlockAutocomplete = {
  __typename?: 'DashboardProfileBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ViewProfileLink?: Maybe<DashboardProfileBlockLinkBlockAutocomplete>;
  ViewShoppingProfileLink?: Maybe<DashboardProfileBlockLinkBlockAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardProfileBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfileBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfileBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfileBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfileBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfileBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfileBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfileBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfileBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardProfileBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardProfileBlockFacet = {
  __typename?: 'DashboardProfileBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Bio?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Facebook?: Maybe<Array<Maybe<StringFacet>>>;
  GetMembershipCertificate?: Maybe<Array<Maybe<StringFacet>>>;
  Instagram?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkedIn?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShareSocialLinks?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SocialLinks?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Twitter?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMembershipInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  ViewProfileLink?: Maybe<DashboardProfileBlockLinkBlockFacet>;
  ViewShoppingProfileLink?: Maybe<DashboardProfileBlockLinkBlockFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DashboardProfileBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetBioArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardProfileBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardProfileBlockFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetFacebookArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetGetMembershipCertificateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetInstagramArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetLinkedInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardProfileBlockFacetShareSocialLinksArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetSocialLinksArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardProfileBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardProfileBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetTwitterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacetViewMembershipInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DashboardProfileBlockLinkBlock = {
  __typename?: 'DashboardProfileBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type DashboardProfileBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardProfileBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardProfileBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardProfileBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardProfileBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardProfileBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardProfileBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardProfileBlockLinkBlockAutocomplete = {
  __typename?: 'DashboardProfileBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardProfileBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardProfileBlockLinkBlockFacet = {
  __typename?: 'DashboardProfileBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardProfileBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardProfileBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardProfileBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardProfileBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type DashboardProfileBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardProfileBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Bio?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisplayName?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Facebook?: InputMaybe<OrderBy>;
  GetMembershipCertificate?: InputMaybe<OrderBy>;
  Instagram?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkedIn?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShareSocialLinks?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SocialLinks?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Twitter?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ViewMembershipInvoice?: InputMaybe<OrderBy>;
  ViewProfileLink?: InputMaybe<DashboardProfileBlockLinkBlockOrderByInput>;
  ViewShoppingProfileLink?: InputMaybe<DashboardProfileBlockLinkBlockOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DashboardProfileBlockOutput = {
  __typename?: 'DashboardProfileBlockOutput';
  autocomplete?: Maybe<DashboardProfileBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DashboardProfileBlockFacet>;
  item?: Maybe<DashboardProfileBlock>;
  items?: Maybe<Array<Maybe<DashboardProfileBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DashboardProfileBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardProfileBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Bio?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisplayName?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Facebook?: InputMaybe<SearchableStringFilterInput>;
  GetMembershipCertificate?: InputMaybe<SearchableStringFilterInput>;
  Instagram?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkedIn?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShareSocialLinks?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SocialLinks?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Twitter?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewMembershipInvoice?: InputMaybe<SearchableStringFilterInput>;
  ViewProfileLink?: InputMaybe<DashboardProfileBlockLinkBlockWhereInput>;
  ViewShoppingProfileLink?: InputMaybe<DashboardProfileBlockLinkBlockWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<DashboardProfileBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DashboardProfileBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DashboardProfileBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type DashboardSharedPage = IContent & IData & {
  __typename?: 'DashboardSharedPage';
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  BackToDashboard?: Maybe<Scalars['String']['output']>;
  COTBadgeLabel?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MDRTBadgeLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaImage?: Maybe<DashboardSharedPageImageBlock>;
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Sections?: Maybe<DashboardSharedPageDashBoardSectionBlock>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TOTBadgeLabel?: Maybe<Scalars['String']['output']>;
  ThumbnailImage?: Maybe<DashboardSharedPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type DashboardSharedPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardSharedPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardSharedPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DashboardSharedPageAutocomplete = {
  __typename?: 'DashboardSharedPageAutocomplete';
  AnalyticsCampaignName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  BackToDashboard?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  COTBadgeLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MDRTBadgeLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MetaImage?: Maybe<DashboardSharedPageImageBlockAutocomplete>;
  MetaKeywordList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MetaTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Sections?: Maybe<DashboardSharedPageDashBoardSectionBlockAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TOTBadgeLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<DashboardSharedPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardSharedPageAutocompleteAnalyticsCampaignNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteBackToDashboardArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteCotBadgeLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteMdrtBadgeLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteMetaDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteMetaKeywordListArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteMetaTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteTotBadgeLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardSharedPageDashBoardSectionBlock = {
  __typename?: 'DashboardSharedPageDashBoardSectionBlock';
  Add?: Maybe<Scalars['String']['output']>;
  Career?: Maybe<Scalars['String']['output']>;
  Change?: Maybe<Scalars['String']['output']>;
  Edit?: Maybe<Scalars['String']['output']>;
  Education?: Maybe<Scalars['String']['output']>;
  FileSizeError?: Maybe<Scalars['String']['output']>;
  FileTypeError?: Maybe<Scalars['String']['output']>;
  Financial?: Maybe<Scalars['String']['output']>;
  GaugeAriaLabel?: Maybe<Scalars['String']['output']>;
  Greeting?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  Health?: Maybe<Scalars['String']['output']>;
  LinkLabel?: Maybe<Scalars['String']['output']>;
  MDRTId?: Maybe<Scalars['String']['output']>;
  MembershipYears?: Maybe<Scalars['String']['output']>;
  ModalDescription?: Maybe<Scalars['String']['output']>;
  ModalTitle?: Maybe<Scalars['String']['output']>;
  PictureDescription?: Maybe<Scalars['String']['output']>;
  Relationships?: Maybe<Scalars['String']['output']>;
  Remove?: Maybe<Scalars['String']['output']>;
  Save?: Maybe<Scalars['String']['output']>;
  Service?: Maybe<Scalars['String']['output']>;
  Spiritual?: Maybe<Scalars['String']['output']>;
  Upload?: Maybe<Scalars['String']['output']>;
  ViewProfile?: Maybe<Scalars['String']['output']>;
};

export type DashboardSharedPageDashBoardSectionBlockAutocomplete = {
  __typename?: 'DashboardSharedPageDashBoardSectionBlockAutocomplete';
  Add?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Career?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Change?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Edit?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Education?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FileSizeError?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FileTypeError?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Financial?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  GaugeAriaLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Greeting?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Headline?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Health?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  LinkLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MDRTId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MembershipYears?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ModalDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ModalTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  PictureDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Relationships?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Remove?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Save?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Service?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Spiritual?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Upload?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ViewProfile?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteAddArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteCareerArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteChangeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteEditArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteEducationArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteFileSizeErrorArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteFileTypeErrorArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteFinancialArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteGaugeAriaLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteGreetingArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteHeadlineArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteHealthArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteLinkLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteMdrtIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteMembershipYearsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteModalDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteModalTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompletePictureDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteRelationshipsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteRemoveArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteSaveArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteServiceArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteSpiritualArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteUploadArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSharedPageDashBoardSectionBlockAutocompleteViewProfileArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardSharedPageDashBoardSectionBlockFacet = {
  __typename?: 'DashboardSharedPageDashBoardSectionBlockFacet';
  Add?: Maybe<Array<Maybe<StringFacet>>>;
  Career?: Maybe<Array<Maybe<StringFacet>>>;
  Change?: Maybe<Array<Maybe<StringFacet>>>;
  Edit?: Maybe<Array<Maybe<StringFacet>>>;
  Education?: Maybe<Array<Maybe<StringFacet>>>;
  FileSizeError?: Maybe<Array<Maybe<StringFacet>>>;
  FileTypeError?: Maybe<Array<Maybe<StringFacet>>>;
  Financial?: Maybe<Array<Maybe<StringFacet>>>;
  GaugeAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Greeting?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Health?: Maybe<Array<Maybe<StringFacet>>>;
  LinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTId?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipYears?: Maybe<Array<Maybe<StringFacet>>>;
  ModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ModalTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PictureDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Relationships?: Maybe<Array<Maybe<StringFacet>>>;
  Remove?: Maybe<Array<Maybe<StringFacet>>>;
  Save?: Maybe<Array<Maybe<StringFacet>>>;
  Service?: Maybe<Array<Maybe<StringFacet>>>;
  Spiritual?: Maybe<Array<Maybe<StringFacet>>>;
  Upload?: Maybe<Array<Maybe<StringFacet>>>;
  ViewProfile?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetAddArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetCareerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetChangeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetEditArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetEducationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetFileSizeErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetFileTypeErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetFinancialArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetGaugeAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetGreetingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetHealthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetMdrtIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetMembershipYearsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetModalTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetPictureDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetRelationshipsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetRemoveArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetSaveArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetSpiritualArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetUploadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageDashBoardSectionBlockFacetViewProfileArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardSharedPageDashBoardSectionBlockOrderByInput = {
  Add?: InputMaybe<OrderBy>;
  Career?: InputMaybe<OrderBy>;
  Change?: InputMaybe<OrderBy>;
  Edit?: InputMaybe<OrderBy>;
  Education?: InputMaybe<OrderBy>;
  FileSizeError?: InputMaybe<OrderBy>;
  FileTypeError?: InputMaybe<OrderBy>;
  Financial?: InputMaybe<OrderBy>;
  GaugeAriaLabel?: InputMaybe<OrderBy>;
  Greeting?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  Health?: InputMaybe<OrderBy>;
  LinkLabel?: InputMaybe<OrderBy>;
  MDRTId?: InputMaybe<OrderBy>;
  MembershipYears?: InputMaybe<OrderBy>;
  ModalDescription?: InputMaybe<OrderBy>;
  ModalTitle?: InputMaybe<OrderBy>;
  PictureDescription?: InputMaybe<OrderBy>;
  Relationships?: InputMaybe<OrderBy>;
  Remove?: InputMaybe<OrderBy>;
  Save?: InputMaybe<OrderBy>;
  Service?: InputMaybe<OrderBy>;
  Spiritual?: InputMaybe<OrderBy>;
  Upload?: InputMaybe<OrderBy>;
  ViewProfile?: InputMaybe<OrderBy>;
};

export type DashboardSharedPageDashBoardSectionBlockWhereInput = {
  Add?: InputMaybe<StringFilterInput>;
  Career?: InputMaybe<StringFilterInput>;
  Change?: InputMaybe<StringFilterInput>;
  Edit?: InputMaybe<StringFilterInput>;
  Education?: InputMaybe<StringFilterInput>;
  FileSizeError?: InputMaybe<StringFilterInput>;
  FileTypeError?: InputMaybe<StringFilterInput>;
  Financial?: InputMaybe<StringFilterInput>;
  GaugeAriaLabel?: InputMaybe<StringFilterInput>;
  Greeting?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<StringFilterInput>;
  Health?: InputMaybe<StringFilterInput>;
  LinkLabel?: InputMaybe<StringFilterInput>;
  MDRTId?: InputMaybe<StringFilterInput>;
  MembershipYears?: InputMaybe<StringFilterInput>;
  ModalDescription?: InputMaybe<StringFilterInput>;
  ModalTitle?: InputMaybe<StringFilterInput>;
  PictureDescription?: InputMaybe<StringFilterInput>;
  Relationships?: InputMaybe<StringFilterInput>;
  Remove?: InputMaybe<StringFilterInput>;
  Save?: InputMaybe<StringFilterInput>;
  Service?: InputMaybe<StringFilterInput>;
  Spiritual?: InputMaybe<StringFilterInput>;
  Upload?: InputMaybe<StringFilterInput>;
  ViewProfile?: InputMaybe<StringFilterInput>;
};

export type DashboardSharedPageFacet = {
  __typename?: 'DashboardSharedPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  BackToDashboard?: Maybe<Array<Maybe<StringFacet>>>;
  COTBadgeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MDRTBadgeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<DashboardSharedPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Sections?: Maybe<DashboardSharedPageDashBoardSectionBlockFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TOTBadgeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ThumbnailImage?: Maybe<DashboardSharedPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DashboardSharedPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetBackToDashboardArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetCotBadgeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardSharedPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardSharedPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardSharedPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetMdrtBadgeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardSharedPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardSharedPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardSharedPageFacetTotBadgeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DashboardSharedPageImageBlock = {
  __typename?: 'DashboardSharedPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type DashboardSharedPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardSharedPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardSharedPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardSharedPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DashboardSharedPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DashboardSharedPageImageBlockAutocomplete = {
  __typename?: 'DashboardSharedPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type DashboardSharedPageImageBlockFacet = {
  __typename?: 'DashboardSharedPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DashboardSharedPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSharedPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardSharedPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DashboardSharedPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type DashboardSharedPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type DashboardSharedPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  BackToDashboard?: InputMaybe<OrderBy>;
  COTBadgeLabel?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MDRTBadgeLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<DashboardSharedPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Sections?: InputMaybe<DashboardSharedPageDashBoardSectionBlockOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TOTBadgeLabel?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<DashboardSharedPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DashboardSharedPageOutput = {
  __typename?: 'DashboardSharedPageOutput';
  autocomplete?: Maybe<DashboardSharedPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DashboardSharedPageFacet>;
  item?: Maybe<DashboardSharedPage>;
  items?: Maybe<Array<Maybe<DashboardSharedPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DashboardSharedPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardSharedPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<StringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  BackToDashboard?: InputMaybe<StringFilterInput>;
  COTBadgeLabel?: InputMaybe<StringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MDRTBadgeLabel?: InputMaybe<StringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<StringFilterInput>;
  MetaImage?: InputMaybe<DashboardSharedPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<StringFilterInput>;
  MetaTitle?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Sections?: InputMaybe<DashboardSharedPageDashBoardSectionBlockWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TOTBadgeLabel?: InputMaybe<StringFilterInput>;
  ThumbnailImage?: InputMaybe<DashboardSharedPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DashboardSharedPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DashboardSharedPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DashboardSharedPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlock = IContent & IData & {
  __typename?: 'DashboardSitePreferencesBlock';
  AddMoreTopicsButtonLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ChooseLanguage?: Maybe<Scalars['String']['output']>;
  ChooseTopics?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Interests?: Maybe<Scalars['String']['output']>;
  InterestsErrorMessage?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LanguageLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MemberDirectory?: Maybe<Scalars['String']['output']>;
  MemberDirectoryOptIn?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NavigationName?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SaveInterests?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SelectTopics?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WhatInterests?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockAddMoreTopicsButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockChooseLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockChooseTopicsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockInterestsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockInterestsErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockLanguageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockMemberDirectoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockMemberDirectoryOptInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockSaveInterestsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockSelectTopicsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlockWhatInterestsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dashboard account site preferences block */
export type DashboardSitePreferencesBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DashboardSitePreferencesBlockAutocomplete = {
  __typename?: 'DashboardSitePreferencesBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DashboardSitePreferencesBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSitePreferencesBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSitePreferencesBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSitePreferencesBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSitePreferencesBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSitePreferencesBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSitePreferencesBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSitePreferencesBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSitePreferencesBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DashboardSitePreferencesBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DashboardSitePreferencesBlockFacet = {
  __typename?: 'DashboardSitePreferencesBlockFacet';
  AddMoreTopicsButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ChooseLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  ChooseTopics?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Interests?: Maybe<Array<Maybe<StringFacet>>>;
  InterestsErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LanguageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MemberDirectory?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDirectoryOptIn?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SaveInterests?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelectTopics?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WhatInterests?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DashboardSitePreferencesBlockFacetAddMoreTopicsButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardSitePreferencesBlockFacetChooseLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetChooseTopicsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardSitePreferencesBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DashboardSitePreferencesBlockFacetInterestsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetInterestsErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetLanguageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetMemberDirectoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetMemberDirectoryOptInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetSaveInterestsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardSitePreferencesBlockFacetSelectTopicsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardSitePreferencesBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardSitePreferencesBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacetWhatInterestsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DashboardSitePreferencesBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DashboardSitePreferencesBlockOrderByInput = {
  AddMoreTopicsButtonLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ChooseLanguage?: InputMaybe<OrderBy>;
  ChooseTopics?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Interests?: InputMaybe<OrderBy>;
  InterestsErrorMessage?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LanguageLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MemberDirectory?: InputMaybe<OrderBy>;
  MemberDirectoryOptIn?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavigationName?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SaveInterests?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelectTopics?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WhatInterests?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DashboardSitePreferencesBlockOutput = {
  __typename?: 'DashboardSitePreferencesBlockOutput';
  autocomplete?: Maybe<DashboardSitePreferencesBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DashboardSitePreferencesBlockFacet>;
  item?: Maybe<DashboardSitePreferencesBlock>;
  items?: Maybe<Array<Maybe<DashboardSitePreferencesBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DashboardSitePreferencesBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardSitePreferencesBlockWhereInput = {
  AddMoreTopicsButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ChooseLanguage?: InputMaybe<SearchableStringFilterInput>;
  ChooseTopics?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Interests?: InputMaybe<SearchableStringFilterInput>;
  InterestsErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LanguageLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MemberDirectory?: InputMaybe<SearchableStringFilterInput>;
  MemberDirectoryOptIn?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavigationName?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SaveInterests?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelectTopics?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WhatInterests?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DashboardSitePreferencesBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DashboardSitePreferencesBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DashboardSitePreferencesBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Data = IData & {
  __typename?: 'Data';
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
};


export type Data_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Data_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DataMismatchModalBlock = IContent & IData & {
  __typename?: 'DataMismatchModalBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CloseButtonText?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type DataMismatchModalBlockCloseButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DataMismatchModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DataMismatchModalBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DataMismatchModalBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DataMismatchModalBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DataMismatchModalBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DataMismatchModalBlockAutocomplete = {
  __typename?: 'DataMismatchModalBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DataMismatchModalBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DataMismatchModalBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DataMismatchModalBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DataMismatchModalBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DataMismatchModalBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DataMismatchModalBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DataMismatchModalBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DataMismatchModalBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DataMismatchModalBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DataMismatchModalBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DataMismatchModalBlockFacet = {
  __typename?: 'DataMismatchModalBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CloseButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DataMismatchModalBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DataMismatchModalBlockFacetCloseButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DataMismatchModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DataMismatchModalBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DataMismatchModalBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DataMismatchModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DataMismatchModalBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DataMismatchModalBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CloseButtonText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DataMismatchModalBlockOutput = {
  __typename?: 'DataMismatchModalBlockOutput';
  autocomplete?: Maybe<DataMismatchModalBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DataMismatchModalBlockFacet>;
  item?: Maybe<DataMismatchModalBlock>;
  items?: Maybe<Array<Maybe<DataMismatchModalBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DataMismatchModalBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DataMismatchModalBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CloseButtonText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DataMismatchModalBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DataMismatchModalBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DataMismatchModalBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type DataOrderByInput = {
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type DataOutput = {
  __typename?: 'DataOutput';
  cursor?: Maybe<Scalars['String']['output']>;
  item?: Maybe<IData>;
  items?: Maybe<Array<Maybe<IData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DataWhereInput = {
  _and?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
};

export type DateFacet = {
  __typename?: 'DateFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum DateFacetUnit {
  /** Defined as 24 hours (86,400,000 milliseconds). All days begin at the earliest possible time, which is usually 00:00:00 (midnight). */
  Day = 'DAY',
  /** Defined as 60 minutes each (3,600,000 milliseconds). All hours begin at 00 minutes and 00 seconds. */
  Hour = 'HOUR',
  /** Defined as 1000 milliseconds each. */
  Minute = 'MINUTE'
}

export type DateFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `decay` influences the weight of the score with a decay function. For example, results that have a more recent datetime will be ranked higher. The `origin` will be `now()` in case not specified. The `scale` is by default 10. The `rate` must be in the range `[0..1]`. */
  decay?: InputMaybe<Decay>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

/** Decay influences the weight of the score based on field values with a decay function */
export type Decay = {
  origin?: InputMaybe<Scalars['Date']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  scale?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteCertifyinLetterModalBlock = IContent & IData & {
  __typename?: 'DeleteCertifyinLetterModalBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type DeleteCertifyinLetterModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DeleteCertifyinLetterModalBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DeleteCertifyinLetterModalBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DeleteCertifyinLetterModalBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DeleteCertifyinLetterModalBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DeleteCertifyinLetterModalBlockAutocomplete = {
  __typename?: 'DeleteCertifyinLetterModalBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DeleteCertifyinLetterModalBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DeleteCertifyinLetterModalBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DeleteCertifyinLetterModalBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DeleteCertifyinLetterModalBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DeleteCertifyinLetterModalBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DeleteCertifyinLetterModalBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DeleteCertifyinLetterModalBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DeleteCertifyinLetterModalBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DeleteCertifyinLetterModalBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DeleteCertifyinLetterModalBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DeleteCertifyinLetterModalBlockFacet = {
  __typename?: 'DeleteCertifyinLetterModalBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DeleteCertifyinLetterModalBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DeleteCertifyinLetterModalBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DeleteCertifyinLetterModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DeleteCertifyinLetterModalBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DeleteCertifyinLetterModalBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DeleteCertifyinLetterModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DeleteCertifyinLetterModalBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DeleteCertifyinLetterModalBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DeleteCertifyinLetterModalBlockOutput = {
  __typename?: 'DeleteCertifyinLetterModalBlockOutput';
  autocomplete?: Maybe<DeleteCertifyinLetterModalBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DeleteCertifyinLetterModalBlockFacet>;
  item?: Maybe<DeleteCertifyinLetterModalBlock>;
  items?: Maybe<Array<Maybe<DeleteCertifyinLetterModalBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DeleteCertifyinLetterModalBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteCertifyinLetterModalBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DeleteCertifyinLetterModalBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DeleteCertifyinLetterModalBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DeleteCertifyinLetterModalBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a description button block */
export type DescriptionButtonBlock = IContent & IData & {
  __typename?: 'DescriptionButtonBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Buttons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  /** Select the icon to use for the block */
  Icon?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubText?: Maybe<Scalars['String']['output']>;
  /** Determines the color scheme */
  Theme?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a description button block */
export type DescriptionButtonBlockButtonsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a description button block */
export type DescriptionButtonBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a description button block */
export type DescriptionButtonBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a description button block */
export type DescriptionButtonBlockIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a description button block */
export type DescriptionButtonBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a description button block */
export type DescriptionButtonBlockSubTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a description button block */
export type DescriptionButtonBlockThemeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a description button block */
export type DescriptionButtonBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a description button block */
export type DescriptionButtonBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DescriptionButtonBlockAutocomplete = {
  __typename?: 'DescriptionButtonBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DescriptionButtonBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DescriptionButtonBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DescriptionButtonBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DescriptionButtonBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DescriptionButtonBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DescriptionButtonBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DescriptionButtonBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DescriptionButtonBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DescriptionButtonBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DescriptionButtonBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DescriptionButtonBlockFacet = {
  __typename?: 'DescriptionButtonBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Buttons?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Icon?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubText?: Maybe<Array<Maybe<StringFacet>>>;
  Theme?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DescriptionButtonBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DescriptionButtonBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DescriptionButtonBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DescriptionButtonBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DescriptionButtonBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DescriptionButtonBlockFacetSubTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DescriptionButtonBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DescriptionButtonBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Buttons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Icon?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubText?: InputMaybe<OrderBy>;
  Theme?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DescriptionButtonBlockOutput = {
  __typename?: 'DescriptionButtonBlockOutput';
  autocomplete?: Maybe<DescriptionButtonBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DescriptionButtonBlockFacet>;
  item?: Maybe<DescriptionButtonBlock>;
  items?: Maybe<Array<Maybe<DescriptionButtonBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DescriptionButtonBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DescriptionButtonBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Buttons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Icon?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubText?: InputMaybe<SearchableStringFilterInput>;
  Theme?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DescriptionButtonBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DescriptionButtonBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DescriptionButtonBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A generic page with flexible content */
export type DetailPage = IContent & IData & {
  __typename?: 'DetailPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  /** Contennt rendering below the Main content on page. */
  BottomContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  /** A single personalizable link that appears on the right side of the hero header */
  HeroHeaderLink?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  HeroImage?: Maybe<DetailPageImageBlock>;
  /** Shown at the bottom of the hero section */
  HeroLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  HeroTextContentBlock?: Maybe<DetailPageHeroTextContentBlock>;
  /** Setting for hiding the Breadcrumb Control on page. */
  HideBreadcrumbs?: Maybe<Scalars['Bool']['output']>;
  /** Setting for hiding the Hero Contents area on page. */
  HideHeroContent?: Maybe<Scalars['Bool']['output']>;
  /** Hide the horizontal rule line under the title */
  HideLine?: Maybe<Scalars['Bool']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<DetailPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SideBar?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  /** On desktop view, checking this will make the hero image stack below the text (defaults to stacking on the right) */
  StackHeroImageVertical?: Maybe<Scalars['Bool']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<DetailPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A generic page with flexible content */
export type DetailPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic page with flexible content */
export type DetailPageBottomContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic page with flexible content */
export type DetailPageHeroHeaderLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic page with flexible content */
export type DetailPageHeroLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic page with flexible content */
export type DetailPageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic page with flexible content */
export type DetailPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic page with flexible content */
export type DetailPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic page with flexible content */
export type DetailPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic page with flexible content */
export type DetailPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic page with flexible content */
export type DetailPageSideBarArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic page with flexible content */
export type DetailPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic page with flexible content */
export type DetailPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DetailPageAutocomplete = {
  __typename?: 'DetailPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  HeroImage?: Maybe<DetailPageImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<DetailPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<DetailPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DetailPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DetailPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DetailPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DetailPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DetailPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DetailPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DetailPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DetailPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DetailPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DetailPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DetailPageFacet = {
  __typename?: 'DetailPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  BottomContent?: Maybe<ContentAreaItemModelSearchFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  HeroHeaderLink?: Maybe<ContentAreaItemModelSearchFacet>;
  HeroImage?: Maybe<DetailPageImageBlockFacet>;
  HeroLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  HeroTextContentBlock?: Maybe<DetailPageHeroTextContentBlockFacet>;
  HideBreadcrumbs?: Maybe<Array<Maybe<StringFacet>>>;
  HideHeroContent?: Maybe<Array<Maybe<StringFacet>>>;
  HideLine?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<DetailPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SideBar?: Maybe<ContentAreaItemModelSearchFacet>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StackHeroImageVertical?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<DetailPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DetailPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DetailPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DetailPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DetailPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetHideBreadcrumbsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetHideHeroContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetHideLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DetailPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DetailPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetStackHeroImageVerticalArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DetailPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DetailPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DetailPageHeroTextContentBlock = {
  __typename?: 'DetailPageHeroTextContentBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
};


export type DetailPageHeroTextContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DetailPageHeroTextContentBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DetailPageHeroTextContentBlockPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DetailPageHeroTextContentBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DetailPageHeroTextContentBlockFacet = {
  __typename?: 'DetailPageHeroTextContentBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DetailPageHeroTextContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageHeroTextContentBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageHeroTextContentBlockFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageHeroTextContentBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DetailPageHeroTextContentBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  PreHeading?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
};

export type DetailPageHeroTextContentBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type DetailPageImageBlock = {
  __typename?: 'DetailPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type DetailPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DetailPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DetailPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DetailPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DetailPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DetailPageImageBlockAutocomplete = {
  __typename?: 'DetailPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type DetailPageImageBlockFacet = {
  __typename?: 'DetailPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DetailPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DetailPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DetailPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DetailPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type DetailPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type DetailPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  BottomContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  HeroHeaderLink?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeroImage?: InputMaybe<DetailPageImageBlockOrderByInput>;
  HeroLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeroTextContentBlock?: InputMaybe<DetailPageHeroTextContentBlockOrderByInput>;
  HideBreadcrumbs?: InputMaybe<OrderBy>;
  HideHeroContent?: InputMaybe<OrderBy>;
  HideLine?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<DetailPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SideBar?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StackHeroImageVertical?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<DetailPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DetailPageOutput = {
  __typename?: 'DetailPageOutput';
  autocomplete?: Maybe<DetailPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DetailPageFacet>;
  item?: Maybe<DetailPage>;
  items?: Maybe<Array<Maybe<DetailPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DetailPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DetailPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  BottomContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  HeroHeaderLink?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeroImage?: InputMaybe<DetailPageImageBlockWhereInput>;
  HeroLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeroTextContentBlock?: InputMaybe<DetailPageHeroTextContentBlockWhereInput>;
  HideBreadcrumbs?: InputMaybe<BoolFilterInput>;
  HideHeroContent?: InputMaybe<BoolFilterInput>;
  HideLine?: InputMaybe<BoolFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<DetailPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SideBar?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StackHeroImageVertical?: InputMaybe<BoolFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<DetailPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DetailPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DetailPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DetailPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type DocumentMedia = IContent & IData & {
  __typename?: 'DocumentMedia';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type DocumentMediaContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DocumentMediaNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DocumentMedia_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DocumentMedia_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DocumentMediaAutocomplete = {
  __typename?: 'DocumentMediaAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DocumentMediaAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DocumentMediaAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DocumentMediaAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DocumentMediaAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DocumentMediaAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DocumentMediaAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DocumentMediaAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DocumentMediaAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DocumentMediaAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DocumentMediaAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DocumentMediaAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DocumentMediaFacet = {
  __typename?: 'DocumentMediaFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DocumentMediaFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DocumentMediaFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DocumentMediaFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DocumentMediaFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DocumentMediaFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DocumentMediaFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DocumentMediaFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DocumentMediaOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DocumentMediaOutput = {
  __typename?: 'DocumentMediaOutput';
  autocomplete?: Maybe<DocumentMediaAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DocumentMediaFacet>;
  item?: Maybe<DocumentMedia>;
  items?: Maybe<Array<Maybe<DocumentMedia>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DocumentMediaOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentMediaWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DocumentMediaWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DocumentMediaWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DocumentMediaWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type DonationBlock = IContent & IData & {
  __typename?: 'DonationBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnnualChartAriaLabel?: Maybe<Scalars['String']['output']>;
  AnnualDescription?: Maybe<Scalars['String']['output']>;
  AnnualDescriptionNoLevel?: Maybe<Scalars['String']['output']>;
  AnnualTabAriaLabel?: Maybe<Scalars['String']['output']>;
  AnnualTabLabel?: Maybe<Scalars['String']['output']>;
  AnnualTitle?: Maybe<Scalars['String']['output']>;
  AnnualTitleNoLevel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DonateButtonLabel?: Maybe<Scalars['String']['output']>;
  DonateUrl?: Maybe<DonationBlockLinkBlock>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HelpText?: Maybe<Scalars['String']['output']>;
  HelpTextJapan?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LifetimeChartAriaLabel?: Maybe<Scalars['String']['output']>;
  LifetimeDescription?: Maybe<Scalars['String']['output']>;
  LifetimeTabAriaLabel?: Maybe<Scalars['String']['output']>;
  LifetimeTabLabel?: Maybe<Scalars['String']['output']>;
  LifetimeTitle?: Maybe<Scalars['String']['output']>;
  LifetimeTitleNoLevel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NoDonationsDescription?: Maybe<Scalars['String']['output']>;
  NoDonationsTitle?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TabsSectionAriaLabel?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type DonationBlockAnnualChartAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockAnnualDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockAnnualDescriptionNoLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockAnnualTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockAnnualTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockAnnualTitleNoLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockHelpTextJapanArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockLifetimeChartAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockLifetimeDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockLifetimeTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockLifetimeTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockLifetimeTitleNoLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockNoDonationsDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockNoDonationsTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockTabsSectionAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DonationBlockAutocomplete = {
  __typename?: 'DonationBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnnualTabAriaLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DonateButtonLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DonateUrl?: Maybe<DonationBlockLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LifetimeTabAriaLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Title?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DonationBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteAnnualTabAriaLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteDonateButtonLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteLifetimeTabAriaLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DonationBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DonationBlockFacet = {
  __typename?: 'DonationBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnnualChartAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnnualDescription?: Maybe<Array<Maybe<StringFacet>>>;
  AnnualDescriptionNoLevel?: Maybe<Array<Maybe<StringFacet>>>;
  AnnualTabAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnnualTabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnnualTitle?: Maybe<Array<Maybe<StringFacet>>>;
  AnnualTitleNoLevel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DonateButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DonateUrl?: Maybe<DonationBlockLinkBlockFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HelpText?: Maybe<Array<Maybe<StringFacet>>>;
  HelpTextJapan?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LifetimeChartAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifetimeDescription?: Maybe<Array<Maybe<StringFacet>>>;
  LifetimeTabAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifetimeTabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifetimeTitle?: Maybe<Array<Maybe<StringFacet>>>;
  LifetimeTitleNoLevel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NoDonationsDescription?: Maybe<Array<Maybe<StringFacet>>>;
  NoDonationsTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TabsSectionAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DonationBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetAnnualChartAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetAnnualDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetAnnualDescriptionNoLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetAnnualTabAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetAnnualTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetAnnualTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetAnnualTitleNoLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DonationBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DonationBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetDonateButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetHelpTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetHelpTextJapanArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DonationBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetLifetimeChartAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetLifetimeDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetLifetimeTabAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetLifetimeTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetLifetimeTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetLifetimeTitleNoLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetNoDonationsDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetNoDonationsTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DonationBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DonationBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DonationBlockFacetTabsSectionAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DonationBlockLinkBlock = {
  __typename?: 'DonationBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type DonationBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DonationBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DonationBlockLinkBlockAutocomplete = {
  __typename?: 'DonationBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DonationBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DonationBlockLinkBlockFacet = {
  __typename?: 'DonationBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DonationBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DonationBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DonationBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DonationBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type DonationBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type DonationBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnnualChartAriaLabel?: InputMaybe<OrderBy>;
  AnnualDescription?: InputMaybe<OrderBy>;
  AnnualDescriptionNoLevel?: InputMaybe<OrderBy>;
  AnnualTabAriaLabel?: InputMaybe<OrderBy>;
  AnnualTabLabel?: InputMaybe<OrderBy>;
  AnnualTitle?: InputMaybe<OrderBy>;
  AnnualTitleNoLevel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DonateButtonLabel?: InputMaybe<OrderBy>;
  DonateUrl?: InputMaybe<DonationBlockLinkBlockOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HelpText?: InputMaybe<OrderBy>;
  HelpTextJapan?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LifetimeChartAriaLabel?: InputMaybe<OrderBy>;
  LifetimeDescription?: InputMaybe<OrderBy>;
  LifetimeTabAriaLabel?: InputMaybe<OrderBy>;
  LifetimeTabLabel?: InputMaybe<OrderBy>;
  LifetimeTitle?: InputMaybe<OrderBy>;
  LifetimeTitleNoLevel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NoDonationsDescription?: InputMaybe<OrderBy>;
  NoDonationsTitle?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TabsSectionAriaLabel?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DonationBlockOutput = {
  __typename?: 'DonationBlockOutput';
  autocomplete?: Maybe<DonationBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DonationBlockFacet>;
  item?: Maybe<DonationBlock>;
  items?: Maybe<Array<Maybe<DonationBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DonationBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DonationBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnnualChartAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  AnnualDescription?: InputMaybe<SearchableStringFilterInput>;
  AnnualDescriptionNoLevel?: InputMaybe<SearchableStringFilterInput>;
  AnnualTabAriaLabel?: InputMaybe<StringFilterInput>;
  AnnualTabLabel?: InputMaybe<SearchableStringFilterInput>;
  AnnualTitle?: InputMaybe<SearchableStringFilterInput>;
  AnnualTitleNoLevel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<StringFilterInput>;
  DonateButtonLabel?: InputMaybe<StringFilterInput>;
  DonateUrl?: InputMaybe<DonationBlockLinkBlockWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HelpText?: InputMaybe<SearchableStringFilterInput>;
  HelpTextJapan?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LifetimeChartAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  LifetimeDescription?: InputMaybe<SearchableStringFilterInput>;
  LifetimeTabAriaLabel?: InputMaybe<StringFilterInput>;
  LifetimeTabLabel?: InputMaybe<SearchableStringFilterInput>;
  LifetimeTitle?: InputMaybe<SearchableStringFilterInput>;
  LifetimeTitleNoLevel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NoDonationsDescription?: InputMaybe<SearchableStringFilterInput>;
  NoDonationsTitle?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TabsSectionAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DonationBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DonationBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DonationBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlock = IContent & IData & {
  __typename?: 'DownloadUploadSectionBlock';
  AMPInstruction?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DownloadLinkText?: Maybe<Scalars['String']['output']>;
  EEPInstruction?: Maybe<Scalars['String']['output']>;
  EmailConsentLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HealthPoliciesInstruction?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NewIDRequestInstruction?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonUpdatesInstruction?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  UploadDescriptionText?: Maybe<Scalars['String']['output']>;
  UploadInstructionText?: Maybe<Scalars['String']['output']>;
  UploadLinkText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WireTransferInstruction?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockAmpInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockDownloadLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockEepInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockEmailConsentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockHealthPoliciesInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockNewIdRequestInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockPersonUpdatesInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockUploadDescriptionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockUploadInstructionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockUploadLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlockWireTransferInstructionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Download Upload step of the Company Admin page */
export type DownloadUploadSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DownloadUploadSectionBlockAutocomplete = {
  __typename?: 'DownloadUploadSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DownloadUploadSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadUploadSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadUploadSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadUploadSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadUploadSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadUploadSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadUploadSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadUploadSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadUploadSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadUploadSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DownloadUploadSectionBlockFacet = {
  __typename?: 'DownloadUploadSectionBlockFacet';
  AMPInstruction?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DownloadLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  EEPInstruction?: Maybe<Array<Maybe<StringFacet>>>;
  EmailConsentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HealthPoliciesInstruction?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NewIDRequestInstruction?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonUpdatesInstruction?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  UploadDescriptionText?: Maybe<Array<Maybe<StringFacet>>>;
  UploadInstructionText?: Maybe<Array<Maybe<StringFacet>>>;
  UploadLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransferInstruction?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type DownloadUploadSectionBlockFacetAmpInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadUploadSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadUploadSectionBlockFacetDownloadLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetEepInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetEmailConsentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetHealthPoliciesInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DownloadUploadSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetNewIdRequestInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetPersonUpdatesInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadUploadSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadUploadSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadUploadSectionBlockFacetUploadDescriptionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetUploadInstructionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetUploadLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacetWireTransferInstructionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadUploadSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type DownloadUploadSectionBlockOrderByInput = {
  AMPInstruction?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DownloadLinkText?: InputMaybe<OrderBy>;
  EEPInstruction?: InputMaybe<OrderBy>;
  EmailConsentLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HealthPoliciesInstruction?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NewIDRequestInstruction?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonUpdatesInstruction?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  UploadDescriptionText?: InputMaybe<OrderBy>;
  UploadInstructionText?: InputMaybe<OrderBy>;
  UploadLinkText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WireTransferInstruction?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type DownloadUploadSectionBlockOutput = {
  __typename?: 'DownloadUploadSectionBlockOutput';
  autocomplete?: Maybe<DownloadUploadSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DownloadUploadSectionBlockFacet>;
  item?: Maybe<DownloadUploadSectionBlock>;
  items?: Maybe<Array<Maybe<DownloadUploadSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DownloadUploadSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DownloadUploadSectionBlockWhereInput = {
  AMPInstruction?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DownloadLinkText?: InputMaybe<SearchableStringFilterInput>;
  EEPInstruction?: InputMaybe<SearchableStringFilterInput>;
  EmailConsentLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HealthPoliciesInstruction?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NewIDRequestInstruction?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonUpdatesInstruction?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  UploadDescriptionText?: InputMaybe<SearchableStringFilterInput>;
  UploadInstructionText?: InputMaybe<SearchableStringFilterInput>;
  UploadLinkText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WireTransferInstruction?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DownloadUploadSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DownloadUploadSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DownloadUploadSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds EEP data for the Company Admin page */
export type EepSectionBlock = IContent & IData & {
  __typename?: 'EEPSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BirthYear?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstGivenName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastFamilyName?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NewBusinessIncome?: Maybe<Scalars['String']['output']>;
  OtherCommission?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesCommission?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesIncome?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesPremium?: Maybe<Scalars['String']['output']>;
  OtherPremium?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RiskProtectionCommission?: Maybe<Scalars['String']['output']>;
  RiskProtectionIncome?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesCommission?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesIncome?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesPremium?: Maybe<Scalars['String']['output']>;
  RiskProtectionPremium?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TotalIncome?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Year?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockBirthYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockFirstGivenNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockLastFamilyNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockNewBusinessIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockOtherCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockOtherPoliciesCasesCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockOtherPoliciesCasesIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockOtherPoliciesCasesPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockOtherPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockRiskProtectionCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockRiskProtectionIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockRiskProtectionPoliciesCasesCommissionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockRiskProtectionPoliciesCasesIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockRiskProtectionPoliciesCasesPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockRiskProtectionPremiumArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockTotalIncomeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlockYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds EEP data for the Company Admin page */
export type EepSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EepSectionBlockAutocomplete = {
  __typename?: 'EEPSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EepSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EepSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EepSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EepSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EepSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EepSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EepSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EepSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EepSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EepSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EepSectionBlockFacet = {
  __typename?: 'EEPSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BirthYear?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstGivenName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastFamilyName?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NewBusinessIncome?: Maybe<Array<Maybe<StringFacet>>>;
  OtherCommission?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesCommission?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesIncome?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesPremium?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPremium?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionCommission?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionIncome?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesCommission?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesIncome?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesPremium?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPremium?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalIncome?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Year?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EepSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetBirthYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EepSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EepSectionBlockFacetFirstGivenNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EepSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetLastFamilyNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetNewBusinessIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetOtherCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetOtherPoliciesCasesCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetOtherPoliciesCasesIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetOtherPoliciesCasesPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetOtherPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetRiskProtectionCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetRiskProtectionIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetRiskProtectionPoliciesCasesCommissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetRiskProtectionPoliciesCasesIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetRiskProtectionPoliciesCasesPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetRiskProtectionPremiumArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EepSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EepSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EepSectionBlockFacetTotalIncomeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacetYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EepSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EepSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BirthYear?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstGivenName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastFamilyName?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NewBusinessIncome?: InputMaybe<OrderBy>;
  OtherCommission?: InputMaybe<OrderBy>;
  OtherPoliciesCasesCommission?: InputMaybe<OrderBy>;
  OtherPoliciesCasesIncome?: InputMaybe<OrderBy>;
  OtherPoliciesCasesPremium?: InputMaybe<OrderBy>;
  OtherPremium?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RiskProtectionCommission?: InputMaybe<OrderBy>;
  RiskProtectionIncome?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesCommission?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesIncome?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesPremium?: InputMaybe<OrderBy>;
  RiskProtectionPremium?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalIncome?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Year?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EepSectionBlockOutput = {
  __typename?: 'EEPSectionBlockOutput';
  autocomplete?: Maybe<EepSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EepSectionBlockFacet>;
  item?: Maybe<EepSectionBlock>;
  items?: Maybe<Array<Maybe<EepSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EepSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EepSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BirthYear?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstGivenName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastFamilyName?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NewBusinessIncome?: InputMaybe<SearchableStringFilterInput>;
  OtherCommission?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesCommission?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesIncome?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesPremium?: InputMaybe<SearchableStringFilterInput>;
  OtherPremium?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RiskProtectionCommission?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionIncome?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesCommission?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesIncome?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesPremium?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPremium?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalIncome?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Year?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EepSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EepSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EepSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Carousel block used as a property */
export type EvpCarouselBlock = IContent & IData & {
  __typename?: 'EVPCarouselBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MaxSlidesPerView?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  Slides?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Carousel block used as a property */
export type EvpCarouselBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel block used as a property */
export type EvpCarouselBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel block used as a property */
export type EvpCarouselBlockSlidesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel block used as a property */
export type EvpCarouselBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel block used as a property */
export type EvpCarouselBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpCarouselBlockAutocomplete = {
  __typename?: 'EVPCarouselBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpCarouselBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpCarouselBlockFacet = {
  __typename?: 'EVPCarouselBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MaxSlidesPerView?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  Slides?: Maybe<ContentAreaItemModelSearchFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpCarouselBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacetMaxSlidesPerViewArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpCarouselBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpCarouselBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MaxSlidesPerView?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  Slides?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpCarouselBlockOutput = {
  __typename?: 'EVPCarouselBlockOutput';
  autocomplete?: Maybe<EvpCarouselBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpCarouselBlockFacet>;
  item?: Maybe<EvpCarouselBlock>;
  items?: Maybe<Array<Maybe<EvpCarouselBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpCarouselBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpCarouselBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MaxSlidesPerView?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  Slides?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpCarouselBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpCarouselBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpCarouselBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Carousel quote block used as a property */
export type EvpCarouselQuoteBlock = IContent & IData & {
  __typename?: 'EVPCarouselQuoteBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  Slides?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Carousel quote block used as a property */
export type EvpCarouselQuoteBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel quote block used as a property */
export type EvpCarouselQuoteBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel quote block used as a property */
export type EvpCarouselQuoteBlockSlidesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel quote block used as a property */
export type EvpCarouselQuoteBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel quote block used as a property */
export type EvpCarouselQuoteBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpCarouselQuoteBlockAutocomplete = {
  __typename?: 'EVPCarouselQuoteBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpCarouselQuoteBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpCarouselQuoteBlockFacet = {
  __typename?: 'EVPCarouselQuoteBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  Slides?: Maybe<ContentAreaItemModelSearchFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpCarouselQuoteBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselQuoteBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselQuoteBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselQuoteBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselQuoteBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselQuoteBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpCarouselQuoteBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  Slides?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpCarouselQuoteBlockOutput = {
  __typename?: 'EVPCarouselQuoteBlockOutput';
  autocomplete?: Maybe<EvpCarouselQuoteBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpCarouselQuoteBlockFacet>;
  item?: Maybe<EvpCarouselQuoteBlock>;
  items?: Maybe<Array<Maybe<EvpCarouselQuoteBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpCarouselQuoteBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpCarouselQuoteBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  Slides?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpCarouselQuoteBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpCarouselQuoteBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpCarouselQuoteBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Carousel quote slide block used as a property */
export type EvpCarouselQuoteSlideBlock = IContent & IData & {
  __typename?: 'EVPCarouselQuoteSlideBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Author?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Citation?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Image?: Maybe<EvpCarouselQuoteSlideBlockEvpImageBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Quote?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Carousel quote slide block used as a property */
export type EvpCarouselQuoteSlideBlockAuthorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel quote slide block used as a property */
export type EvpCarouselQuoteSlideBlockCitationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel quote slide block used as a property */
export type EvpCarouselQuoteSlideBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel quote slide block used as a property */
export type EvpCarouselQuoteSlideBlockQuoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel quote slide block used as a property */
export type EvpCarouselQuoteSlideBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel quote slide block used as a property */
export type EvpCarouselQuoteSlideBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpCarouselQuoteSlideBlockAutocomplete = {
  __typename?: 'EVPCarouselQuoteSlideBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<EvpCarouselQuoteSlideBlockEvpImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpCarouselQuoteSlideBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteSlideBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteSlideBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteSlideBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteSlideBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteSlideBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteSlideBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteSlideBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteSlideBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselQuoteSlideBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpCarouselQuoteSlideBlockEvpImageBlock = {
  __typename?: 'EVPCarouselQuoteSlideBlockEVPImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
};


export type EvpCarouselQuoteSlideBlockEvpImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpCarouselQuoteSlideBlockEvpImageBlockAutocomplete = {
  __typename?: 'EVPCarouselQuoteSlideBlockEVPImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpCarouselQuoteSlideBlockEvpImageBlockFacet = {
  __typename?: 'EVPCarouselQuoteSlideBlockEVPImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
};


export type EvpCarouselQuoteSlideBlockEvpImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpCarouselQuoteSlideBlockEvpImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type EvpCarouselQuoteSlideBlockEvpImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type EvpCarouselQuoteSlideBlockFacet = {
  __typename?: 'EVPCarouselQuoteSlideBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Author?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Citation?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Image?: Maybe<EvpCarouselQuoteSlideBlockEvpImageBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Quote?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpCarouselQuoteSlideBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetAuthorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselQuoteSlideBlockFacetCitationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselQuoteSlideBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetQuoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselQuoteSlideBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselQuoteSlideBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselQuoteSlideBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselQuoteSlideBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpCarouselQuoteSlideBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Author?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Citation?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Image?: InputMaybe<EvpCarouselQuoteSlideBlockEvpImageBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Quote?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpCarouselQuoteSlideBlockOutput = {
  __typename?: 'EVPCarouselQuoteSlideBlockOutput';
  autocomplete?: Maybe<EvpCarouselQuoteSlideBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpCarouselQuoteSlideBlockFacet>;
  item?: Maybe<EvpCarouselQuoteSlideBlock>;
  items?: Maybe<Array<Maybe<EvpCarouselQuoteSlideBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpCarouselQuoteSlideBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpCarouselQuoteSlideBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Author?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Citation?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Image?: InputMaybe<EvpCarouselQuoteSlideBlockEvpImageBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Quote?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpCarouselQuoteSlideBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpCarouselQuoteSlideBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpCarouselQuoteSlideBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Carousel slide block used as a property */
export type EvpCarouselSlideBlock = IContent & IData & {
  __typename?: 'EVPCarouselSlideBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Blurb?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Link that appears at the bottom of the slide. */
  Cta?: Maybe<EvpCarouselSlideBlockEvpLinkBlock>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Image?: Maybe<EvpCarouselSlideBlockEvpImageBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Carousel slide block used as a property */
export type EvpCarouselSlideBlockBlurbArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel slide block used as a property */
export type EvpCarouselSlideBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel slide block used as a property */
export type EvpCarouselSlideBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel slide block used as a property */
export type EvpCarouselSlideBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Carousel slide block used as a property */
export type EvpCarouselSlideBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpCarouselSlideBlockAutocomplete = {
  __typename?: 'EVPCarouselSlideBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Cta?: Maybe<EvpCarouselSlideBlockEvpLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<EvpCarouselSlideBlockEvpImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpCarouselSlideBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselSlideBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselSlideBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselSlideBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselSlideBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselSlideBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselSlideBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselSlideBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselSlideBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpCarouselSlideBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpCarouselSlideBlockEvpImageBlock = {
  __typename?: 'EVPCarouselSlideBlockEVPImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
};


export type EvpCarouselSlideBlockEvpImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpCarouselSlideBlockEvpImageBlockAutocomplete = {
  __typename?: 'EVPCarouselSlideBlockEVPImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpCarouselSlideBlockEvpImageBlockFacet = {
  __typename?: 'EVPCarouselSlideBlockEVPImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
};


export type EvpCarouselSlideBlockEvpImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpCarouselSlideBlockEvpImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type EvpCarouselSlideBlockEvpImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type EvpCarouselSlideBlockEvpLinkBlock = {
  __typename?: 'EVPCarouselSlideBlockEVPLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type EvpCarouselSlideBlockEvpLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpCarouselSlideBlockEvpLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpCarouselSlideBlockEvpLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpCarouselSlideBlockEvpLinkBlockAutocomplete = {
  __typename?: 'EVPCarouselSlideBlockEVPLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpCarouselSlideBlockEvpLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpCarouselSlideBlockEvpLinkBlockFacet = {
  __typename?: 'EVPCarouselSlideBlockEVPLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EvpCarouselSlideBlockEvpLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockEvpLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockEvpLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockEvpLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpCarouselSlideBlockEvpLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type EvpCarouselSlideBlockEvpLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type EvpCarouselSlideBlockFacet = {
  __typename?: 'EVPCarouselSlideBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Blurb?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Cta?: Maybe<EvpCarouselSlideBlockEvpLinkBlockFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Image?: Maybe<EvpCarouselSlideBlockEvpImageBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpCarouselSlideBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetBlurbArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselSlideBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselSlideBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselSlideBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselSlideBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpCarouselSlideBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpCarouselSlideBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpCarouselSlideBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Blurb?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Cta?: InputMaybe<EvpCarouselSlideBlockEvpLinkBlockOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Image?: InputMaybe<EvpCarouselSlideBlockEvpImageBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpCarouselSlideBlockOutput = {
  __typename?: 'EVPCarouselSlideBlockOutput';
  autocomplete?: Maybe<EvpCarouselSlideBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpCarouselSlideBlockFacet>;
  item?: Maybe<EvpCarouselSlideBlock>;
  items?: Maybe<Array<Maybe<EvpCarouselSlideBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpCarouselSlideBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpCarouselSlideBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Blurb?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Cta?: InputMaybe<EvpCarouselSlideBlockEvpLinkBlockWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Image?: InputMaybe<EvpCarouselSlideBlockEvpImageBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpCarouselSlideBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpCarouselSlideBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpCarouselSlideBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Content block used as a property */
export type EvpContentBlock = IContent & IData & {
  __typename?: 'EVPContentBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Determines the background colour */
  BackgroundCssClass?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Content block used as a property */
export type EvpContentBlockBackgroundCssClassArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content block used as a property */
export type EvpContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content block used as a property */
export type EvpContentBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content block used as a property */
export type EvpContentBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content block used as a property */
export type EvpContentBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpContentBlockAutocomplete = {
  __typename?: 'EVPContentBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpContentBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpContentBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpContentBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpContentBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpContentBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpContentBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpContentBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpContentBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpContentBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpContentBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpContentBlockFacet = {
  __typename?: 'EVPContentBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundCssClass?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpContentBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetBackgroundCssClassArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpContentBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpContentBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpContentBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpContentBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpContentBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpContentBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackgroundCssClass?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpContentBlockOutput = {
  __typename?: 'EVPContentBlockOutput';
  autocomplete?: Maybe<EvpContentBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpContentBlockFacet>;
  item?: Maybe<EvpContentBlock>;
  items?: Maybe<Array<Maybe<EvpContentBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpContentBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpContentBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackgroundCssClass?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpContentBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpContentBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpContentBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Featured resources block used as a property */
export type EvpFeaturedResourcesBlock = IContent & IData & {
  __typename?: 'EVPFeaturedResourcesBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  Resources?: Maybe<Array<Maybe<ContentModelReference>>>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Featured resources block used as a property */
export type EvpFeaturedResourcesBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Featured resources block used as a property */
export type EvpFeaturedResourcesBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Featured resources block used as a property */
export type EvpFeaturedResourcesBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Featured resources block used as a property */
export type EvpFeaturedResourcesBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpFeaturedResourcesBlockAutocomplete = {
  __typename?: 'EVPFeaturedResourcesBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Resources?: Maybe<ContentModelReferenceAutocomplete>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpFeaturedResourcesBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpFeaturedResourcesBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpFeaturedResourcesBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpFeaturedResourcesBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpFeaturedResourcesBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpFeaturedResourcesBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpFeaturedResourcesBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpFeaturedResourcesBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpFeaturedResourcesBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpFeaturedResourcesBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpFeaturedResourcesBlockFacet = {
  __typename?: 'EVPFeaturedResourcesBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  Resources?: Maybe<ContentModelReferenceFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpFeaturedResourcesBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpFeaturedResourcesBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpFeaturedResourcesBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpFeaturedResourcesBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpFeaturedResourcesBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpFeaturedResourcesBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpFeaturedResourcesBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpFeaturedResourcesBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  Resources?: InputMaybe<ContentModelReferenceOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpFeaturedResourcesBlockOutput = {
  __typename?: 'EVPFeaturedResourcesBlockOutput';
  autocomplete?: Maybe<EvpFeaturedResourcesBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpFeaturedResourcesBlockFacet>;
  item?: Maybe<EvpFeaturedResourcesBlock>;
  items?: Maybe<Array<Maybe<EvpFeaturedResourcesBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpFeaturedResourcesBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpFeaturedResourcesBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  Resources?: InputMaybe<ContentModelReferenceWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpFeaturedResourcesBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpFeaturedResourcesBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpFeaturedResourcesBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Generic page for a EVP site. */
export type EvpGenericPage = IContent & IData & {
  __typename?: 'EVPGenericPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<EvpGenericPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<EvpGenericPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Generic page for a EVP site. */
export type EvpGenericPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Generic page for a EVP site. */
export type EvpGenericPageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Generic page for a EVP site. */
export type EvpGenericPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Generic page for a EVP site. */
export type EvpGenericPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Generic page for a EVP site. */
export type EvpGenericPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Generic page for a EVP site. */
export type EvpGenericPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Generic page for a EVP site. */
export type EvpGenericPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Generic page for a EVP site. */
export type EvpGenericPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpGenericPageAutocomplete = {
  __typename?: 'EVPGenericPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<EvpGenericPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<EvpGenericPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpGenericPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpGenericPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpGenericPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpGenericPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpGenericPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpGenericPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpGenericPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpGenericPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpGenericPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpGenericPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpGenericPageFacet = {
  __typename?: 'EVPGenericPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<EvpGenericPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<EvpGenericPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpGenericPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpGenericPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpGenericPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpGenericPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpGenericPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpGenericPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpGenericPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpGenericPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpGenericPageImageBlock = {
  __typename?: 'EVPGenericPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type EvpGenericPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpGenericPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpGenericPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpGenericPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpGenericPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpGenericPageImageBlockAutocomplete = {
  __typename?: 'EVPGenericPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpGenericPageImageBlockFacet = {
  __typename?: 'EVPGenericPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EvpGenericPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpGenericPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpGenericPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpGenericPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type EvpGenericPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type EvpGenericPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<EvpGenericPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<EvpGenericPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpGenericPageOutput = {
  __typename?: 'EVPGenericPageOutput';
  autocomplete?: Maybe<EvpGenericPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpGenericPageFacet>;
  item?: Maybe<EvpGenericPage>;
  items?: Maybe<Array<Maybe<EvpGenericPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpGenericPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpGenericPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<EvpGenericPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<EvpGenericPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpGenericPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpGenericPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpGenericPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Hero quote block used as a property */
export type EvpHeroQuoteBlock = IContent & IData & {
  __typename?: 'EVPHeroQuoteBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HeroText?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<EvpHeroQuoteBlockEvpImageBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Quote for this quote section block. */
  Quote?: Maybe<Scalars['String']['output']>;
  /** Quote author for this quote section block. */
  QuoteAuthor?: Maybe<Scalars['String']['output']>;
  /** Quote citation for this quote section block. */
  QuoteCitation?: Maybe<Scalars['String']['output']>;
  /** Title for this quote section block. */
  QuoteTitle?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Title for this hero block. */
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Hero quote block used as a property */
export type EvpHeroQuoteBlockHeroTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Hero quote block used as a property */
export type EvpHeroQuoteBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Hero quote block used as a property */
export type EvpHeroQuoteBlockQuoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Hero quote block used as a property */
export type EvpHeroQuoteBlockQuoteAuthorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Hero quote block used as a property */
export type EvpHeroQuoteBlockQuoteCitationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Hero quote block used as a property */
export type EvpHeroQuoteBlockQuoteTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Hero quote block used as a property */
export type EvpHeroQuoteBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Hero quote block used as a property */
export type EvpHeroQuoteBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Hero quote block used as a property */
export type EvpHeroQuoteBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpHeroQuoteBlockAutocomplete = {
  __typename?: 'EVPHeroQuoteBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<EvpHeroQuoteBlockEvpImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpHeroQuoteBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHeroQuoteBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHeroQuoteBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHeroQuoteBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHeroQuoteBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHeroQuoteBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHeroQuoteBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHeroQuoteBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHeroQuoteBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHeroQuoteBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpHeroQuoteBlockEvpImageBlock = {
  __typename?: 'EVPHeroQuoteBlockEVPImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
};


export type EvpHeroQuoteBlockEvpImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpHeroQuoteBlockEvpImageBlockAutocomplete = {
  __typename?: 'EVPHeroQuoteBlockEVPImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpHeroQuoteBlockEvpImageBlockFacet = {
  __typename?: 'EVPHeroQuoteBlockEVPImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
};


export type EvpHeroQuoteBlockEvpImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpHeroQuoteBlockEvpImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type EvpHeroQuoteBlockEvpImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type EvpHeroQuoteBlockFacet = {
  __typename?: 'EVPHeroQuoteBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HeroText?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<EvpHeroQuoteBlockEvpImageBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Quote?: Maybe<Array<Maybe<StringFacet>>>;
  QuoteAuthor?: Maybe<Array<Maybe<StringFacet>>>;
  QuoteCitation?: Maybe<Array<Maybe<StringFacet>>>;
  QuoteTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpHeroQuoteBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpHeroQuoteBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpHeroQuoteBlockFacetHeroTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetQuoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetQuoteAuthorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetQuoteCitationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetQuoteTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpHeroQuoteBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpHeroQuoteBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpHeroQuoteBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHeroQuoteBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpHeroQuoteBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HeroText?: InputMaybe<OrderBy>;
  Image?: InputMaybe<EvpHeroQuoteBlockEvpImageBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Quote?: InputMaybe<OrderBy>;
  QuoteAuthor?: InputMaybe<OrderBy>;
  QuoteCitation?: InputMaybe<OrderBy>;
  QuoteTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpHeroQuoteBlockOutput = {
  __typename?: 'EVPHeroQuoteBlockOutput';
  autocomplete?: Maybe<EvpHeroQuoteBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpHeroQuoteBlockFacet>;
  item?: Maybe<EvpHeroQuoteBlock>;
  items?: Maybe<Array<Maybe<EvpHeroQuoteBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpHeroQuoteBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpHeroQuoteBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HeroText?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<EvpHeroQuoteBlockEvpImageBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Quote?: InputMaybe<SearchableStringFilterInput>;
  QuoteAuthor?: InputMaybe<SearchableStringFilterInput>;
  QuoteCitation?: InputMaybe<SearchableStringFilterInput>;
  QuoteTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpHeroQuoteBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpHeroQuoteBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpHeroQuoteBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The home page for a EVP site. Used directly under the root page. */
export type EvpHomePage = IContent & IData & {
  __typename?: 'EVPHomePage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Appears after the login button. */
  LoginSplashAfterLoginButtonText?: Maybe<Scalars['String']['output']>;
  /** Bold text inside the h1 will be underlined. */
  LoginSplashIntroText?: Maybe<Scalars['String']['output']>;
  LoginSplashVideo?: Maybe<EvpHomePageEvpVideoBlock>;
  LoginUrl?: Maybe<EvpHomePageEvpLinkBlock>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<EvpHomePageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** This should reference the site settings on the MDRT site. */
  PrimarySiteSettingsPage?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SiteSettingsPage?: Maybe<ContentModelReference>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<EvpHomePageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The home page for a EVP site. Used directly under the root page. */
export type EvpHomePageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a EVP site. Used directly under the root page. */
export type EvpHomePageLoginSplashAfterLoginButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a EVP site. Used directly under the root page. */
export type EvpHomePageLoginSplashIntroTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a EVP site. Used directly under the root page. */
export type EvpHomePageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a EVP site. Used directly under the root page. */
export type EvpHomePageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a EVP site. Used directly under the root page. */
export type EvpHomePageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a EVP site. Used directly under the root page. */
export type EvpHomePageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a EVP site. Used directly under the root page. */
export type EvpHomePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a EVP site. Used directly under the root page. */
export type EvpHomePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a EVP site. Used directly under the root page. */
export type EvpHomePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpHomePageAutocomplete = {
  __typename?: 'EVPHomePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LoginSplashVideo?: Maybe<EvpHomePageEvpVideoBlockAutocomplete>;
  LoginUrl?: Maybe<EvpHomePageEvpLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<EvpHomePageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PrimarySiteSettingsPage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteSettingsPage?: Maybe<ContentModelReferenceAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<EvpHomePageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpHomePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHomePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHomePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHomePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHomePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHomePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHomePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHomePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHomePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpHomePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpHomePageEvpLinkBlock = {
  __typename?: 'EVPHomePageEVPLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type EvpHomePageEvpLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpHomePageEvpLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpHomePageEvpLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpHomePageEvpLinkBlockAutocomplete = {
  __typename?: 'EVPHomePageEVPLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpHomePageEvpLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpHomePageEvpLinkBlockFacet = {
  __typename?: 'EVPHomePageEVPLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EvpHomePageEvpLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageEvpLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageEvpLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageEvpLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpHomePageEvpLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type EvpHomePageEvpLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type EvpHomePageEvpVideoBlock = {
  __typename?: 'EVPHomePageEVPVideoBlock';
  ImageReference?: Maybe<ContentModelReference>;
  VideoReference?: Maybe<ContentModelReference>;
};

export type EvpHomePageEvpVideoBlockAutocomplete = {
  __typename?: 'EVPHomePageEVPVideoBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  VideoReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpHomePageEvpVideoBlockFacet = {
  __typename?: 'EVPHomePageEVPVideoBlockFacet';
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  VideoReference?: Maybe<ContentModelReferenceFacet>;
};

export type EvpHomePageEvpVideoBlockOrderByInput = {
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  VideoReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type EvpHomePageEvpVideoBlockWhereInput = {
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  VideoReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type EvpHomePageFacet = {
  __typename?: 'EVPHomePageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LoginSplashAfterLoginButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  LoginSplashIntroText?: Maybe<Array<Maybe<StringFacet>>>;
  LoginSplashVideo?: Maybe<EvpHomePageEvpVideoBlockFacet>;
  LoginUrl?: Maybe<EvpHomePageEvpLinkBlockFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<EvpHomePageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PrimarySiteSettingsPage?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SiteSettingsPage?: Maybe<ContentModelReferenceFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<EvpHomePageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpHomePageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpHomePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpHomePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpHomePageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpHomePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetLoginSplashAfterLoginButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetLoginSplashIntroTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpHomePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpHomePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpHomePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpHomePageImageBlock = {
  __typename?: 'EVPHomePageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type EvpHomePageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpHomePageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpHomePageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpHomePageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpHomePageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpHomePageImageBlockAutocomplete = {
  __typename?: 'EVPHomePageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpHomePageImageBlockFacet = {
  __typename?: 'EVPHomePageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EvpHomePageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpHomePageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpHomePageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpHomePageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type EvpHomePageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type EvpHomePageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LoginSplashAfterLoginButtonText?: InputMaybe<OrderBy>;
  LoginSplashIntroText?: InputMaybe<OrderBy>;
  LoginSplashVideo?: InputMaybe<EvpHomePageEvpVideoBlockOrderByInput>;
  LoginUrl?: InputMaybe<EvpHomePageEvpLinkBlockOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<EvpHomePageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PrimarySiteSettingsPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SiteSettingsPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<EvpHomePageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpHomePageOutput = {
  __typename?: 'EVPHomePageOutput';
  autocomplete?: Maybe<EvpHomePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpHomePageFacet>;
  item?: Maybe<EvpHomePage>;
  items?: Maybe<Array<Maybe<EvpHomePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpHomePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpHomePageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LoginSplashAfterLoginButtonText?: InputMaybe<SearchableStringFilterInput>;
  LoginSplashIntroText?: InputMaybe<SearchableStringFilterInput>;
  LoginSplashVideo?: InputMaybe<EvpHomePageEvpVideoBlockWhereInput>;
  LoginUrl?: InputMaybe<EvpHomePageEvpLinkBlockWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<EvpHomePageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PrimarySiteSettingsPage?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SiteSettingsPage?: InputMaybe<ContentModelReferenceWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<EvpHomePageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpHomePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpHomePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpHomePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Image block used as a property */
export type EvpImageBlock = IContent & IData & {
  __typename?: 'EVPImageBlock';
  /** Text for this image when a user is reading the site with a screen reader. */
  AltText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** The image that will be rendered */
  ImageReference?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Image block used as a property */
export type EvpImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type EvpImageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type EvpImageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type EvpImageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpImageBlockAutocomplete = {
  __typename?: 'EVPImageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpImageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpImageBlockFacet = {
  __typename?: 'EVPImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpImageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpImageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpImageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpImageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpImageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpImageBlockOutput = {
  __typename?: 'EVPImageBlockOutput';
  autocomplete?: Maybe<EvpImageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpImageBlockFacet>;
  item?: Maybe<EvpImageBlock>;
  items?: Maybe<Array<Maybe<EvpImageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpImageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpImageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpImageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpImageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Image link block used as a property */
export type EvpImageLinkBlock = IContent & IData & {
  __typename?: 'EVPImageLinkBlock';
  /** Text for this image when a user is reading the site with a screen reader. */
  AltText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EVPLinkBlock?: Maybe<EvpImageLinkBlockEvpLinkBlock>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** The image that will be rendered */
  ImageReference?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Image link block used as a property */
export type EvpImageLinkBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image link block used as a property */
export type EvpImageLinkBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image link block used as a property */
export type EvpImageLinkBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image link block used as a property */
export type EvpImageLinkBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpImageLinkBlockAutocomplete = {
  __typename?: 'EVPImageLinkBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EVPLinkBlock?: Maybe<EvpImageLinkBlockEvpLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpImageLinkBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageLinkBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageLinkBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageLinkBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageLinkBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageLinkBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageLinkBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageLinkBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageLinkBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpImageLinkBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpImageLinkBlockEvpLinkBlock = {
  __typename?: 'EVPImageLinkBlockEVPLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type EvpImageLinkBlockEvpLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpImageLinkBlockEvpLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpImageLinkBlockEvpLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpImageLinkBlockEvpLinkBlockAutocomplete = {
  __typename?: 'EVPImageLinkBlockEVPLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpImageLinkBlockEvpLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpImageLinkBlockEvpLinkBlockFacet = {
  __typename?: 'EVPImageLinkBlockEVPLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EvpImageLinkBlockEvpLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockEvpLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockEvpLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockEvpLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpImageLinkBlockEvpLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type EvpImageLinkBlockEvpLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type EvpImageLinkBlockFacet = {
  __typename?: 'EVPImageLinkBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EVPLinkBlock?: Maybe<EvpImageLinkBlockEvpLinkBlockFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpImageLinkBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpImageLinkBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpImageLinkBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpImageLinkBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpImageLinkBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpImageLinkBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpImageLinkBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpImageLinkBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EVPLinkBlock?: InputMaybe<EvpImageLinkBlockEvpLinkBlockOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpImageLinkBlockOutput = {
  __typename?: 'EVPImageLinkBlockOutput';
  autocomplete?: Maybe<EvpImageLinkBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpImageLinkBlockFacet>;
  item?: Maybe<EvpImageLinkBlock>;
  items?: Maybe<Array<Maybe<EvpImageLinkBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpImageLinkBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpImageLinkBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EVPLinkBlock?: InputMaybe<EvpImageLinkBlockEvpLinkBlockWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpImageLinkBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpImageLinkBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpImageLinkBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Language selector block used as a property */
export type EvpLanguageSelectorBlock = IContent & IData & {
  __typename?: 'EVPLanguageSelectorBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ButtonLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DropdownPlaceholder?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Language selector block used as a property */
export type EvpLanguageSelectorBlockButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Language selector block used as a property */
export type EvpLanguageSelectorBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Language selector block used as a property */
export type EvpLanguageSelectorBlockDropdownPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Language selector block used as a property */
export type EvpLanguageSelectorBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Language selector block used as a property */
export type EvpLanguageSelectorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Language selector block used as a property */
export type EvpLanguageSelectorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Language selector block used as a property */
export type EvpLanguageSelectorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpLanguageSelectorBlockAutocomplete = {
  __typename?: 'EVPLanguageSelectorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpLanguageSelectorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLanguageSelectorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLanguageSelectorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLanguageSelectorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLanguageSelectorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLanguageSelectorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLanguageSelectorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLanguageSelectorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLanguageSelectorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLanguageSelectorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpLanguageSelectorBlockFacet = {
  __typename?: 'EVPLanguageSelectorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DropdownPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpLanguageSelectorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpLanguageSelectorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpLanguageSelectorBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetDropdownPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpLanguageSelectorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpLanguageSelectorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpLanguageSelectorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLanguageSelectorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpLanguageSelectorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  ButtonLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DropdownPlaceholder?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpLanguageSelectorBlockOutput = {
  __typename?: 'EVPLanguageSelectorBlockOutput';
  autocomplete?: Maybe<EvpLanguageSelectorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpLanguageSelectorBlockFacet>;
  item?: Maybe<EvpLanguageSelectorBlock>;
  items?: Maybe<Array<Maybe<EvpLanguageSelectorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpLanguageSelectorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpLanguageSelectorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  ButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DropdownPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpLanguageSelectorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpLanguageSelectorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpLanguageSelectorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A block used to render a link */
export type EvpLinkBlock = IContent & IData & {
  __typename?: 'EVPLinkBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** The text displayed when the link is rendered */
  DisplayText?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Change how the link appears */
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Determines how the link opens */
  Target?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block used to render a link */
export type EvpLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type EvpLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type EvpLinkBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type EvpLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type EvpLinkBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type EvpLinkBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpLinkBlockAutocomplete = {
  __typename?: 'EVPLinkBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpLinkBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLinkBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLinkBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLinkBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLinkBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLinkBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLinkBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLinkBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLinkBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpLinkBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpLinkBlockFacet = {
  __typename?: 'EVPLinkBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpLinkBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpLinkBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpLinkBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpLinkBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpLinkBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpLinkBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisplayText?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpLinkBlockOutput = {
  __typename?: 'EVPLinkBlockOutput';
  autocomplete?: Maybe<EvpLinkBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpLinkBlockFacet>;
  item?: Maybe<EvpLinkBlock>;
  items?: Maybe<Array<Maybe<EvpLinkBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpLinkBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpLinkBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpLinkBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpLinkBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpLinkBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Media file block used as a property */
export type EvpMediaFileBlock = IContent & IData & {
  __typename?: 'EVPMediaFileBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** The media file that will be rendered */
  FileReference?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Media file block used as a property */
export type EvpMediaFileBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Media file block used as a property */
export type EvpMediaFileBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Media file block used as a property */
export type EvpMediaFileBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpMediaFileBlockAutocomplete = {
  __typename?: 'EVPMediaFileBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FileReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpMediaFileBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpMediaFileBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpMediaFileBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpMediaFileBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpMediaFileBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpMediaFileBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpMediaFileBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpMediaFileBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpMediaFileBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpMediaFileBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpMediaFileBlockFacet = {
  __typename?: 'EVPMediaFileBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileReference?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpMediaFileBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpMediaFileBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpMediaFileBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpMediaFileBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpMediaFileBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpMediaFileBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpMediaFileBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpMediaFileBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpMediaFileBlockOutput = {
  __typename?: 'EVPMediaFileBlockOutput';
  autocomplete?: Maybe<EvpMediaFileBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpMediaFileBlockFacet>;
  item?: Maybe<EvpMediaFileBlock>;
  items?: Maybe<Array<Maybe<EvpMediaFileBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpMediaFileBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpMediaFileBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileReference?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpMediaFileBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpMediaFileBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpMediaFileBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Use to specify a navigation page */
export type EvpNavigationPageBlock = IContent & IData & {
  __typename?: 'EVPNavigationPageBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Whether to include child pages */
  IncludeChildren?: Maybe<Scalars['Bool']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  /** The page. */
  Page?: Maybe<ContentModelReference>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Use to specify a navigation page */
export type EvpNavigationPageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Use to specify a navigation page */
export type EvpNavigationPageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Use to specify a navigation page */
export type EvpNavigationPageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpNavigationPageBlockAutocomplete = {
  __typename?: 'EVPNavigationPageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  Page?: Maybe<ContentModelReferenceAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpNavigationPageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpNavigationPageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpNavigationPageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpNavigationPageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpNavigationPageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpNavigationPageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpNavigationPageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpNavigationPageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpNavigationPageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpNavigationPageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpNavigationPageBlockFacet = {
  __typename?: 'EVPNavigationPageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IncludeChildren?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Page?: Maybe<ContentModelReferenceFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpNavigationPageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpNavigationPageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpNavigationPageBlockFacetIncludeChildrenArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpNavigationPageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpNavigationPageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpNavigationPageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpNavigationPageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpNavigationPageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IncludeChildren?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  Page?: InputMaybe<ContentModelReferenceOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpNavigationPageBlockOutput = {
  __typename?: 'EVPNavigationPageBlockOutput';
  autocomplete?: Maybe<EvpNavigationPageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpNavigationPageBlockFacet>;
  item?: Maybe<EvpNavigationPageBlock>;
  items?: Maybe<Array<Maybe<EvpNavigationPageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpNavigationPageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpNavigationPageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IncludeChildren?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  Page?: InputMaybe<ContentModelReferenceWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpNavigationPageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpNavigationPageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpNavigationPageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Use to specify settings for partners */
export type EvpPartnerSettingsBlock = IContent & IData & {
  __typename?: 'EVPPartnerSettingsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Logo displayed in the header next to the MDRT logo. */
  Logo?: Maybe<EvpPartnerSettingsBlockEvpImageBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** The role that the user must have for these settings. */
  Role?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Use to specify settings for partners */
export type EvpPartnerSettingsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Use to specify settings for partners */
export type EvpPartnerSettingsBlockRoleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Use to specify settings for partners */
export type EvpPartnerSettingsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Use to specify settings for partners */
export type EvpPartnerSettingsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpPartnerSettingsBlockAutocomplete = {
  __typename?: 'EVPPartnerSettingsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Logo?: Maybe<EvpPartnerSettingsBlockEvpImageBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpPartnerSettingsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpPartnerSettingsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpPartnerSettingsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpPartnerSettingsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpPartnerSettingsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpPartnerSettingsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpPartnerSettingsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpPartnerSettingsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpPartnerSettingsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpPartnerSettingsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpPartnerSettingsBlockEvpImageBlock = {
  __typename?: 'EVPPartnerSettingsBlockEVPImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
};


export type EvpPartnerSettingsBlockEvpImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpPartnerSettingsBlockEvpImageBlockAutocomplete = {
  __typename?: 'EVPPartnerSettingsBlockEVPImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpPartnerSettingsBlockEvpImageBlockFacet = {
  __typename?: 'EVPPartnerSettingsBlockEVPImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
};


export type EvpPartnerSettingsBlockEvpImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpPartnerSettingsBlockEvpImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type EvpPartnerSettingsBlockEvpImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type EvpPartnerSettingsBlockFacet = {
  __typename?: 'EVPPartnerSettingsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Logo?: Maybe<EvpPartnerSettingsBlockEvpImageBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  Role?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpPartnerSettingsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpPartnerSettingsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpPartnerSettingsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacetRoleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpPartnerSettingsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpPartnerSettingsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpPartnerSettingsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpPartnerSettingsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpPartnerSettingsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Logo?: InputMaybe<EvpPartnerSettingsBlockEvpImageBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  Role?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpPartnerSettingsBlockOutput = {
  __typename?: 'EVPPartnerSettingsBlockOutput';
  autocomplete?: Maybe<EvpPartnerSettingsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpPartnerSettingsBlockFacet>;
  item?: Maybe<EvpPartnerSettingsBlock>;
  items?: Maybe<Array<Maybe<EvpPartnerSettingsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpPartnerSettingsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpPartnerSettingsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Logo?: InputMaybe<EvpPartnerSettingsBlockEvpImageBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  Role?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpPartnerSettingsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpPartnerSettingsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpPartnerSettingsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A resource page for the EVP site. */
export type EvpResourcePage = IContent & IData & {
  __typename?: 'EVPResourcePage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  ContentTypeSelection?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Date?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<EvpResourcePageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** This can be PDF/Image file */
  Resource?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Subheading?: Maybe<Scalars['String']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<EvpResourcePageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A resource page for the EVP site. */
export type EvpResourcePageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A resource page for the EVP site. */
export type EvpResourcePageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A resource page for the EVP site. */
export type EvpResourcePageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A resource page for the EVP site. */
export type EvpResourcePageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A resource page for the EVP site. */
export type EvpResourcePageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A resource page for the EVP site. */
export type EvpResourcePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A resource page for the EVP site. */
export type EvpResourcePageResourceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A resource page for the EVP site. */
export type EvpResourcePageSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A resource page for the EVP site. */
export type EvpResourcePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A resource page for the EVP site. */
export type EvpResourcePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpResourcePageAutocomplete = {
  __typename?: 'EVPResourcePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<EvpResourcePageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<EvpResourcePageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpResourcePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpResourcePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpResourcePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpResourcePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpResourcePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpResourcePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpResourcePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpResourcePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpResourcePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpResourcePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpResourcePageFacet = {
  __typename?: 'EVPResourcePageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentTypeSelection?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Date?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<EvpResourcePageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  Resource?: Maybe<ContentAreaItemModelSearchFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subheading?: Maybe<Array<Maybe<StringFacet>>>;
  ThumbnailImage?: Maybe<EvpResourcePageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpResourcePageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpResourcePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpResourcePageFacetContentTypeSelectionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpResourcePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpResourcePageFacetDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpResourcePageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpResourcePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpResourcePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpResourcePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpResourcePageFacetSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpResourcePageImageBlock = {
  __typename?: 'EVPResourcePageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type EvpResourcePageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpResourcePageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpResourcePageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpResourcePageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpResourcePageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpResourcePageImageBlockAutocomplete = {
  __typename?: 'EVPResourcePageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpResourcePageImageBlockFacet = {
  __typename?: 'EVPResourcePageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EvpResourcePageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpResourcePageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpResourcePageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpResourcePageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type EvpResourcePageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type EvpResourcePageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  ContentTypeSelection?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Date?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<EvpResourcePageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  Resource?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subheading?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<EvpResourcePageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpResourcePageOutput = {
  __typename?: 'EVPResourcePageOutput';
  autocomplete?: Maybe<EvpResourcePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpResourcePageFacet>;
  item?: Maybe<EvpResourcePage>;
  items?: Maybe<Array<Maybe<EvpResourcePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpResourcePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpResourcePageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  ContentTypeSelection?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Date?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<EvpResourcePageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  Resource?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subheading?: InputMaybe<SearchableStringFilterInput>;
  ThumbnailImage?: InputMaybe<EvpResourcePageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpResourcePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpResourcePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpResourcePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Search Header block used as a property */
export type EvpSearchHeaderBlock = IContent & IData & {
  __typename?: 'EVPSearchHeaderBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Search Header block used as a property */
export type EvpSearchHeaderBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Search Header block used as a property */
export type EvpSearchHeaderBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Search Header block used as a property */
export type EvpSearchHeaderBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Search Header block used as a property */
export type EvpSearchHeaderBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Search Header block used as a property */
export type EvpSearchHeaderBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpSearchHeaderBlockAutocomplete = {
  __typename?: 'EVPSearchHeaderBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpSearchHeaderBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchHeaderBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchHeaderBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchHeaderBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchHeaderBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchHeaderBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchHeaderBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchHeaderBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchHeaderBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchHeaderBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpSearchHeaderBlockFacet = {
  __typename?: 'EVPSearchHeaderBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpSearchHeaderBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSearchHeaderBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSearchHeaderBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSearchHeaderBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSearchHeaderBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSearchHeaderBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchHeaderBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpSearchHeaderBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpSearchHeaderBlockOutput = {
  __typename?: 'EVPSearchHeaderBlockOutput';
  autocomplete?: Maybe<EvpSearchHeaderBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpSearchHeaderBlockFacet>;
  item?: Maybe<EvpSearchHeaderBlock>;
  items?: Maybe<Array<Maybe<EvpSearchHeaderBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpSearchHeaderBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpSearchHeaderBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpSearchHeaderBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpSearchHeaderBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpSearchHeaderBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The search page for a EVP site. */
export type EvpSearchPage = IContent & IData & {
  __typename?: 'EVPSearchPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AudioResultLabel?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentSourceFilterLabel?: Maybe<Scalars['String']['output']>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeFilterLabel?: Maybe<Scalars['String']['output']>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ErrorResultsText?: Maybe<Scalars['String']['output']>;
  ExcelResultLabel?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  /** Results that wll be displayed if there is no search query or filter */
  FeaturedResults?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  FileResultLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HtmlResultLabel?: Maybe<Scalars['String']['output']>;
  IllustratorResultLabel?: Maybe<Scalars['String']['output']>;
  ImageResultLabel?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IntroHeading?: Maybe<Scalars['String']['output']>;
  IntroText?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<EvpSearchPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  NoResultsText?: Maybe<Scalars['String']['output']>;
  PageButtonLabel?: Maybe<Scalars['String']['output']>;
  /** Displays the page numbers text. Uses variables {{resultsShown}}, {{totalResults}}, and {{searchTerm}} */
  PageNumbersText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PdfResultLabel?: Maybe<Scalars['String']['output']>;
  PhotoshopResultLabel?: Maybe<Scalars['String']['output']>;
  PowerPointResultLabel?: Maybe<Scalars['String']['output']>;
  ReadMoreLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SearchBarPlaceholder?: Maybe<Scalars['String']['output']>;
  SearchButtonLabel?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<EvpSearchPageImageBlock>;
  TopicsFilterLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VideoResultLabel?: Maybe<Scalars['String']['output']>;
  ZipResultLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The search page for a EVP site. */
export type EvpSearchPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageAudioResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageContentSourceFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageContentTypeFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageErrorResultsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageExcelResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageFeaturedResultsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageFileResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageHtmlResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageIllustratorResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageImageResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageIntroHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageIntroTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageNoResultsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPagePageButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPagePageNumbersTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPagePdfResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPagePhotoshopResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPagePowerPointResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageReadMoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageSearchBarPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageSearchButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageTopicsFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageVideoResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPageZipResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The search page for a EVP site. */
export type EvpSearchPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpSearchPageAutocomplete = {
  __typename?: 'EVPSearchPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<EvpSearchPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<EvpSearchPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpSearchPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSearchPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpSearchPageFacet = {
  __typename?: 'EVPSearchPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  AudioResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentSourceFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  ExcelResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FeaturedResults?: Maybe<ContentAreaItemModelSearchFacet>;
  FileResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HtmlResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IllustratorResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ImageResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IntroHeading?: Maybe<Array<Maybe<StringFacet>>>;
  IntroText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<EvpSearchPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NoResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  PageButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PageNumbersText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PdfResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhotoshopResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PowerPointResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReadMoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchBarPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  SearchButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<EvpSearchPageImageBlockFacet>;
  TopicsFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VideoResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ZipResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpSearchPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetAudioResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSearchPageFacetContentSourceFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetContentTypeFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpSearchPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSearchPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetErrorResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetExcelResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetFileResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetHtmlResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetIllustratorResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetImageResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpSearchPageFacetIntroHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetIntroTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetNoResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetPageButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetPageNumbersTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetPdfResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetPhotoshopResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetPowerPointResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetReadMoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSearchPageFacetSearchBarPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetSearchButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSearchPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSearchPageFacetTopicsFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetVideoResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacetZipResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpSearchPageImageBlock = {
  __typename?: 'EVPSearchPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type EvpSearchPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpSearchPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpSearchPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpSearchPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpSearchPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpSearchPageImageBlockAutocomplete = {
  __typename?: 'EVPSearchPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpSearchPageImageBlockFacet = {
  __typename?: 'EVPSearchPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EvpSearchPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSearchPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpSearchPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpSearchPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type EvpSearchPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type EvpSearchPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AudioResultLabel?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentSourceFilterLabel?: InputMaybe<OrderBy>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeFilterLabel?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ErrorResultsText?: InputMaybe<OrderBy>;
  ExcelResultLabel?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FeaturedResults?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FileResultLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HtmlResultLabel?: InputMaybe<OrderBy>;
  IllustratorResultLabel?: InputMaybe<OrderBy>;
  ImageResultLabel?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IntroHeading?: InputMaybe<OrderBy>;
  IntroText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<EvpSearchPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  NoResultsText?: InputMaybe<OrderBy>;
  PageButtonLabel?: InputMaybe<OrderBy>;
  PageNumbersText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PdfResultLabel?: InputMaybe<OrderBy>;
  PhotoshopResultLabel?: InputMaybe<OrderBy>;
  PowerPointResultLabel?: InputMaybe<OrderBy>;
  ReadMoreLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchBarPlaceholder?: InputMaybe<OrderBy>;
  SearchButtonLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<EvpSearchPageImageBlockOrderByInput>;
  TopicsFilterLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VideoResultLabel?: InputMaybe<OrderBy>;
  ZipResultLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpSearchPageOutput = {
  __typename?: 'EVPSearchPageOutput';
  autocomplete?: Maybe<EvpSearchPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpSearchPageFacet>;
  item?: Maybe<EvpSearchPage>;
  items?: Maybe<Array<Maybe<EvpSearchPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpSearchPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpSearchPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AudioResultLabel?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentSourceFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ErrorResultsText?: InputMaybe<SearchableStringFilterInput>;
  ExcelResultLabel?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FeaturedResults?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FileResultLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HtmlResultLabel?: InputMaybe<SearchableStringFilterInput>;
  IllustratorResultLabel?: InputMaybe<SearchableStringFilterInput>;
  ImageResultLabel?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IntroHeading?: InputMaybe<SearchableStringFilterInput>;
  IntroText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<EvpSearchPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NoResultsText?: InputMaybe<SearchableStringFilterInput>;
  PageButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PageNumbersText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PdfResultLabel?: InputMaybe<SearchableStringFilterInput>;
  PhotoshopResultLabel?: InputMaybe<SearchableStringFilterInput>;
  PowerPointResultLabel?: InputMaybe<SearchableStringFilterInput>;
  ReadMoreLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchBarPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  SearchButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<EvpSearchPageImageBlockWhereInput>;
  TopicsFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VideoResultLabel?: InputMaybe<SearchableStringFilterInput>;
  ZipResultLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpSearchPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpSearchPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpSearchPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPage = IContent & IData & {
  __typename?: 'EVPSiteSettingsPage';
  AccountLinkLabel?: Maybe<Scalars['String']['output']>;
  AccountPageReference?: Maybe<ContentModelReference>;
  Address?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  /** Raw scripts rendered in the body of the html. Used for Tag Manager, etc */
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContactUsLink?: Maybe<EvpSiteSettingsPageEvpLinkBlock>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentSourceCategoryRoot?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FooterColumnOneHeader?: Maybe<Scalars['String']['output']>;
  FooterColumnOneLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  FooterColumnThreeHeader?: Maybe<Scalars['String']['output']>;
  FooterColumnThreeLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  FooterColumnTwoHeader?: Maybe<Scalars['String']['output']>;
  FooterColumnTwoLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  FooterCopyright?: Maybe<Scalars['String']['output']>;
  FooterIconLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  FooterLegalLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  /** Raw scripts rendered in the footer of the html. Used for Tag Manager, etc */
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderNavigationPages?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  /** Raw scripts rendered in the header of the html. Used for Tag Manager, etc */
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LogoutLine?: Maybe<Scalars['String']['output']>;
  LogoutPageReference?: Maybe<ContentModelReference>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PartnerSettings?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  PhoneNumberLink?: Maybe<EvpSiteSettingsPageEvpLinkBlock>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SearchBoxPlaceholder?: Maybe<Scalars['String']['output']>;
  SearchButtonLabel?: Maybe<Scalars['String']['output']>;
  SearchPageReference?: Maybe<ContentModelReference>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  ThumbnailPlaceholder?: Maybe<ContentModelReference>;
  TopicsCategoryRoot?: Maybe<ContentModelReference>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageAccountLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageBodyScriptsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageFooterColumnOneHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageFooterColumnOneLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageFooterColumnThreeHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageFooterColumnThreeLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageFooterColumnTwoHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageFooterColumnTwoLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageFooterCopyrightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageFooterIconLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageFooterLegalLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageFooterScriptsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageHeaderNavigationPagesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageHeaderScriptsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageLogoutLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPagePartnerSettingsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageSearchBoxPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPageSearchButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for EVP properties used throughout the EVP site */
export type EvpSiteSettingsPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpSiteSettingsPageAutocomplete = {
  __typename?: 'EVPSiteSettingsPageAutocomplete';
  AccountPageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContactUsLink?: Maybe<EvpSiteSettingsPageEvpLinkBlockAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentSourceCategoryRoot?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LogoutPageReference?: Maybe<ContentModelReferenceAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PhoneNumberLink?: Maybe<EvpSiteSettingsPageEvpLinkBlockAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SearchPageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailPlaceholder?: Maybe<ContentModelReferenceAutocomplete>;
  TopicsCategoryRoot?: Maybe<ContentModelReferenceAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpSiteSettingsPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSiteSettingsPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSiteSettingsPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSiteSettingsPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSiteSettingsPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSiteSettingsPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSiteSettingsPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSiteSettingsPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSiteSettingsPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpSiteSettingsPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpSiteSettingsPageEvpLinkBlock = {
  __typename?: 'EVPSiteSettingsPageEVPLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type EvpSiteSettingsPageEvpLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpSiteSettingsPageEvpLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpSiteSettingsPageEvpLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpSiteSettingsPageEvpLinkBlockAutocomplete = {
  __typename?: 'EVPSiteSettingsPageEVPLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpSiteSettingsPageEvpLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpSiteSettingsPageEvpLinkBlockFacet = {
  __typename?: 'EVPSiteSettingsPageEVPLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EvpSiteSettingsPageEvpLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageEvpLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageEvpLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageEvpLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpSiteSettingsPageEvpLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type EvpSiteSettingsPageEvpLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type EvpSiteSettingsPageFacet = {
  __typename?: 'EVPSiteSettingsPageFacet';
  AccountLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AccountPageReference?: Maybe<ContentModelReferenceFacet>;
  Address?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContactUsLink?: Maybe<EvpSiteSettingsPageEvpLinkBlockFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentSourceCategoryRoot?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FooterColumnOneHeader?: Maybe<Array<Maybe<StringFacet>>>;
  FooterColumnOneLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  FooterColumnThreeHeader?: Maybe<Array<Maybe<StringFacet>>>;
  FooterColumnThreeLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  FooterColumnTwoHeader?: Maybe<Array<Maybe<StringFacet>>>;
  FooterColumnTwoLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  FooterCopyright?: Maybe<Array<Maybe<StringFacet>>>;
  FooterIconLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  FooterLegalLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderNavigationPages?: Maybe<ContentAreaItemModelSearchFacet>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LogoutLine?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutPageReference?: Maybe<ContentModelReferenceFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PartnerSettings?: Maybe<ContentAreaItemModelSearchFacet>;
  PhoneNumberLink?: Maybe<EvpSiteSettingsPageEvpLinkBlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchBoxPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  SearchButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SearchPageReference?: Maybe<ContentModelReferenceFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailPlaceholder?: Maybe<ContentModelReferenceFacet>;
  TopicsCategoryRoot?: Maybe<ContentModelReferenceFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpSiteSettingsPageFacetAccountLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSiteSettingsPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EvpSiteSettingsPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSiteSettingsPageFacetFooterColumnOneHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetFooterColumnThreeHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetFooterColumnTwoHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetFooterCopyrightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetLogoutLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSiteSettingsPageFacetSearchBoxPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetSearchButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSiteSettingsPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpSiteSettingsPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpSiteSettingsPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpSiteSettingsPageOrderByInput = {
  AccountLinkLabel?: InputMaybe<OrderBy>;
  AccountPageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  Address?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContactUsLink?: InputMaybe<EvpSiteSettingsPageEvpLinkBlockOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentSourceCategoryRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FooterColumnOneHeader?: InputMaybe<OrderBy>;
  FooterColumnOneLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FooterColumnThreeHeader?: InputMaybe<OrderBy>;
  FooterColumnThreeLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FooterColumnTwoHeader?: InputMaybe<OrderBy>;
  FooterColumnTwoLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FooterCopyright?: InputMaybe<OrderBy>;
  FooterIconLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FooterLegalLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderNavigationPages?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeaderScripts?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LogoutLine?: InputMaybe<OrderBy>;
  LogoutPageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PartnerSettings?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  PhoneNumberLink?: InputMaybe<EvpSiteSettingsPageEvpLinkBlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchBoxPlaceholder?: InputMaybe<OrderBy>;
  SearchButtonLabel?: InputMaybe<OrderBy>;
  SearchPageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailPlaceholder?: InputMaybe<ContentModelReferenceOrderByInput>;
  TopicsCategoryRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpSiteSettingsPageOutput = {
  __typename?: 'EVPSiteSettingsPageOutput';
  autocomplete?: Maybe<EvpSiteSettingsPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpSiteSettingsPageFacet>;
  item?: Maybe<EvpSiteSettingsPage>;
  items?: Maybe<Array<Maybe<EvpSiteSettingsPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpSiteSettingsPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpSiteSettingsPageWhereInput = {
  AccountLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  AccountPageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  Address?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  BodyScripts?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContactUsLink?: InputMaybe<EvpSiteSettingsPageEvpLinkBlockWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentSourceCategoryRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FooterColumnOneHeader?: InputMaybe<SearchableStringFilterInput>;
  FooterColumnOneLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FooterColumnThreeHeader?: InputMaybe<SearchableStringFilterInput>;
  FooterColumnThreeLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FooterColumnTwoHeader?: InputMaybe<SearchableStringFilterInput>;
  FooterColumnTwoLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FooterCopyright?: InputMaybe<SearchableStringFilterInput>;
  FooterIconLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FooterLegalLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FooterScripts?: InputMaybe<SearchableStringFilterInput>;
  HeaderNavigationPages?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeaderScripts?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LogoutLine?: InputMaybe<SearchableStringFilterInput>;
  LogoutPageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PartnerSettings?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  PhoneNumberLink?: InputMaybe<EvpSiteSettingsPageEvpLinkBlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchBoxPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  SearchButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  SearchPageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailPlaceholder?: InputMaybe<ContentModelReferenceWhereInput>;
  TopicsCategoryRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpSiteSettingsPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpSiteSettingsPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpSiteSettingsPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Tab block used as a property */
export type EvpTabBlock = IContent & IData & {
  __typename?: 'EVPTabBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Button that appears at the bottom of the tab. */
  Cta?: Maybe<EvpTabBlockEvpLinkBlock>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Image for this tab title. Use instead of a tab title. */
  Image?: Maybe<EvpTabBlockEvpImageBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TabContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  /** Text for this tab title. */
  TabTitle?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Tab block used as a property */
export type EvpTabBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab block used as a property */
export type EvpTabBlockTabContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab block used as a property */
export type EvpTabBlockTabTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab block used as a property */
export type EvpTabBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab block used as a property */
export type EvpTabBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpTabBlockAutocomplete = {
  __typename?: 'EVPTabBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Cta?: Maybe<EvpTabBlockEvpLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<EvpTabBlockEvpImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpTabBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpTabBlockEvpImageBlock = {
  __typename?: 'EVPTabBlockEVPImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
};


export type EvpTabBlockEvpImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpTabBlockEvpImageBlockAutocomplete = {
  __typename?: 'EVPTabBlockEVPImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpTabBlockEvpImageBlockFacet = {
  __typename?: 'EVPTabBlockEVPImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
};


export type EvpTabBlockEvpImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpTabBlockEvpImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type EvpTabBlockEvpImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type EvpTabBlockEvpLinkBlock = {
  __typename?: 'EVPTabBlockEVPLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type EvpTabBlockEvpLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpTabBlockEvpLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpTabBlockEvpLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpTabBlockEvpLinkBlockAutocomplete = {
  __typename?: 'EVPTabBlockEVPLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpTabBlockEvpLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpTabBlockEvpLinkBlockFacet = {
  __typename?: 'EVPTabBlockEVPLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EvpTabBlockEvpLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockEvpLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockEvpLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockEvpLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpTabBlockEvpLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type EvpTabBlockEvpLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type EvpTabBlockFacet = {
  __typename?: 'EVPTabBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Cta?: Maybe<EvpTabBlockEvpLinkBlockFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Image?: Maybe<EvpTabBlockEvpImageBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TabContent?: Maybe<ContentAreaItemModelSearchFacet>;
  TabTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpTabBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabBlockFacetTabTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpTabBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Cta?: InputMaybe<EvpTabBlockEvpLinkBlockOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Image?: InputMaybe<EvpTabBlockEvpImageBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TabContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  TabTitle?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpTabBlockOutput = {
  __typename?: 'EVPTabBlockOutput';
  autocomplete?: Maybe<EvpTabBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpTabBlockFacet>;
  item?: Maybe<EvpTabBlock>;
  items?: Maybe<Array<Maybe<EvpTabBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpTabBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpTabBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Cta?: InputMaybe<EvpTabBlockEvpLinkBlockWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Image?: InputMaybe<EvpTabBlockEvpImageBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TabContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  TabTitle?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpTabBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpTabBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpTabBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Tab card block used as a property */
export type EvpTabCardBlock = IContent & IData & {
  __typename?: 'EVPTabCardBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Image?: Maybe<EvpTabCardBlockEvpImageBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Tab card block used as a property */
export type EvpTabCardBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab card block used as a property */
export type EvpTabCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab card block used as a property */
export type EvpTabCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab card block used as a property */
export type EvpTabCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpTabCardBlockAutocomplete = {
  __typename?: 'EVPTabCardBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<EvpTabCardBlockEvpImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpTabCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpTabCardBlockEvpImageBlock = {
  __typename?: 'EVPTabCardBlockEVPImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
};


export type EvpTabCardBlockEvpImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpTabCardBlockEvpImageBlockAutocomplete = {
  __typename?: 'EVPTabCardBlockEVPImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpTabCardBlockEvpImageBlockFacet = {
  __typename?: 'EVPTabCardBlockEVPImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
};


export type EvpTabCardBlockEvpImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpTabCardBlockEvpImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type EvpTabCardBlockEvpImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type EvpTabCardBlockFacet = {
  __typename?: 'EVPTabCardBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Image?: Maybe<EvpTabCardBlockEvpImageBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpTabCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabCardBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpTabCardBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Image?: InputMaybe<EvpTabCardBlockEvpImageBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpTabCardBlockOutput = {
  __typename?: 'EVPTabCardBlockOutput';
  autocomplete?: Maybe<EvpTabCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpTabCardBlockFacet>;
  item?: Maybe<EvpTabCardBlock>;
  items?: Maybe<Array<Maybe<EvpTabCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpTabCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpTabCardBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Image?: InputMaybe<EvpTabCardBlockEvpImageBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpTabCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpTabCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpTabCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Tab cards block used as a property */
export type EvpTabCardsBlock = IContent & IData & {
  __typename?: 'EVPTabCardsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Cards?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Tab cards block used as a property */
export type EvpTabCardsBlockCardsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab cards block used as a property */
export type EvpTabCardsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab cards block used as a property */
export type EvpTabCardsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab cards block used as a property */
export type EvpTabCardsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpTabCardsBlockAutocomplete = {
  __typename?: 'EVPTabCardsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpTabCardsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabCardsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpTabCardsBlockFacet = {
  __typename?: 'EVPTabCardsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Cards?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpTabCardsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabCardsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabCardsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabCardsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabCardsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabCardsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabCardsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpTabCardsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Cards?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpTabCardsBlockOutput = {
  __typename?: 'EVPTabCardsBlockOutput';
  autocomplete?: Maybe<EvpTabCardsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpTabCardsBlockFacet>;
  item?: Maybe<EvpTabCardsBlock>;
  items?: Maybe<Array<Maybe<EvpTabCardsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpTabCardsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpTabCardsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Cards?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpTabCardsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpTabCardsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpTabCardsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Tab image and text block used as a property */
export type EvpTabImageTextBlock = IContent & IData & {
  __typename?: 'EVPTabImageTextBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<EvpTabImageTextBlockEvpImageBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Tab image and text block used as a property */
export type EvpTabImageTextBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab image and text block used as a property */
export type EvpTabImageTextBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab image and text block used as a property */
export type EvpTabImageTextBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab image and text block used as a property */
export type EvpTabImageTextBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab image and text block used as a property */
export type EvpTabImageTextBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpTabImageTextBlockAutocomplete = {
  __typename?: 'EVPTabImageTextBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<EvpTabImageTextBlockEvpImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpTabImageTextBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabImageTextBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabImageTextBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabImageTextBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabImageTextBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabImageTextBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabImageTextBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabImageTextBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabImageTextBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabImageTextBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpTabImageTextBlockEvpImageBlock = {
  __typename?: 'EVPTabImageTextBlockEVPImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
};


export type EvpTabImageTextBlockEvpImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpTabImageTextBlockEvpImageBlockAutocomplete = {
  __typename?: 'EVPTabImageTextBlockEVPImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpTabImageTextBlockEvpImageBlockFacet = {
  __typename?: 'EVPTabImageTextBlockEVPImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
};


export type EvpTabImageTextBlockEvpImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpTabImageTextBlockEvpImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type EvpTabImageTextBlockEvpImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type EvpTabImageTextBlockFacet = {
  __typename?: 'EVPTabImageTextBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<EvpTabImageTextBlockEvpImageBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpTabImageTextBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabImageTextBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabImageTextBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabImageTextBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabImageTextBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabImageTextBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabImageTextBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpTabImageTextBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<EvpTabImageTextBlockEvpImageBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpTabImageTextBlockOutput = {
  __typename?: 'EVPTabImageTextBlockOutput';
  autocomplete?: Maybe<EvpTabImageTextBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpTabImageTextBlockFacet>;
  item?: Maybe<EvpTabImageTextBlock>;
  items?: Maybe<Array<Maybe<EvpTabImageTextBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpTabImageTextBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpTabImageTextBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<EvpTabImageTextBlockEvpImageBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpTabImageTextBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpTabImageTextBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpTabImageTextBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Tab rich text block used as a property */
export type EvpTabRichTextBlock = IContent & IData & {
  __typename?: 'EVPTabRichTextBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Tab rich text block used as a property */
export type EvpTabRichTextBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab rich text block used as a property */
export type EvpTabRichTextBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab rich text block used as a property */
export type EvpTabRichTextBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab rich text block used as a property */
export type EvpTabRichTextBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpTabRichTextBlockAutocomplete = {
  __typename?: 'EVPTabRichTextBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpTabRichTextBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabRichTextBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabRichTextBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabRichTextBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabRichTextBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabRichTextBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabRichTextBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabRichTextBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabRichTextBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabRichTextBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpTabRichTextBlockFacet = {
  __typename?: 'EVPTabRichTextBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpTabRichTextBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabRichTextBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabRichTextBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabRichTextBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabRichTextBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabRichTextBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabRichTextBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpTabRichTextBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpTabRichTextBlockOutput = {
  __typename?: 'EVPTabRichTextBlockOutput';
  autocomplete?: Maybe<EvpTabRichTextBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpTabRichTextBlockFacet>;
  item?: Maybe<EvpTabRichTextBlock>;
  items?: Maybe<Array<Maybe<EvpTabRichTextBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpTabRichTextBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpTabRichTextBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpTabRichTextBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpTabRichTextBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpTabRichTextBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Tab video block used as a property */
export type EvpTabVideoBlock = IContent & IData & {
  __typename?: 'EVPTabVideoBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  /** Appears on the right side. */
  Stat1?: Maybe<Scalars['String']['output']>;
  /** Appears on the right side beneath stat 1. */
  Stat2?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Video?: Maybe<EvpTabVideoBlockEvpVideoBlock>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Tab video block used as a property */
export type EvpTabVideoBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab video block used as a property */
export type EvpTabVideoBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab video block used as a property */
export type EvpTabVideoBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab video block used as a property */
export type EvpTabVideoBlockStat1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab video block used as a property */
export type EvpTabVideoBlockStat2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab video block used as a property */
export type EvpTabVideoBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab video block used as a property */
export type EvpTabVideoBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpTabVideoBlockAutocomplete = {
  __typename?: 'EVPTabVideoBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Video?: Maybe<EvpTabVideoBlockEvpVideoBlockAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpTabVideoBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabVideoBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabVideoBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabVideoBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabVideoBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabVideoBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabVideoBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabVideoBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabVideoBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabVideoBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpTabVideoBlockEvpVideoBlock = {
  __typename?: 'EVPTabVideoBlockEVPVideoBlock';
  ImageReference?: Maybe<ContentModelReference>;
  VideoReference?: Maybe<ContentModelReference>;
};

export type EvpTabVideoBlockEvpVideoBlockAutocomplete = {
  __typename?: 'EVPTabVideoBlockEVPVideoBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  VideoReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpTabVideoBlockEvpVideoBlockFacet = {
  __typename?: 'EVPTabVideoBlockEVPVideoBlockFacet';
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  VideoReference?: Maybe<ContentModelReferenceFacet>;
};

export type EvpTabVideoBlockEvpVideoBlockOrderByInput = {
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  VideoReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type EvpTabVideoBlockEvpVideoBlockWhereInput = {
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  VideoReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type EvpTabVideoBlockFacet = {
  __typename?: 'EVPTabVideoBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Stat1?: Maybe<Array<Maybe<StringFacet>>>;
  Stat2?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Video?: Maybe<EvpTabVideoBlockEvpVideoBlockFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpTabVideoBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabVideoBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabVideoBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabVideoBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabVideoBlockFacetStat1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetStat2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabVideoBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabVideoBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpTabVideoBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Stat1?: InputMaybe<OrderBy>;
  Stat2?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Video?: InputMaybe<EvpTabVideoBlockEvpVideoBlockOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpTabVideoBlockOutput = {
  __typename?: 'EVPTabVideoBlockOutput';
  autocomplete?: Maybe<EvpTabVideoBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpTabVideoBlockFacet>;
  item?: Maybe<EvpTabVideoBlock>;
  items?: Maybe<Array<Maybe<EvpTabVideoBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpTabVideoBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpTabVideoBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Stat1?: InputMaybe<SearchableStringFilterInput>;
  Stat2?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Video?: InputMaybe<EvpTabVideoBlockEvpVideoBlockWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpTabVideoBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpTabVideoBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpTabVideoBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Tab block used as a property */
export type EvpTabsBlock = IContent & IData & {
  __typename?: 'EVPTabsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  GridColumnCss?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  /** Appears next to the heading. */
  IntroText?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Tabs?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Tab block used as a property */
export type EvpTabsBlockGridColumnCssArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab block used as a property */
export type EvpTabsBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab block used as a property */
export type EvpTabsBlockIntroTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab block used as a property */
export type EvpTabsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab block used as a property */
export type EvpTabsBlockTabsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab block used as a property */
export type EvpTabsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Tab block used as a property */
export type EvpTabsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpTabsBlockAutocomplete = {
  __typename?: 'EVPTabsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpTabsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTabsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpTabsBlockFacet = {
  __typename?: 'EVPTabsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GridColumnCss?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IntroText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Tabs?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpTabsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabsBlockFacetGridColumnCssArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetIntroTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTabsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTabsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpTabsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GridColumnCss?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IntroText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Tabs?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpTabsBlockOutput = {
  __typename?: 'EVPTabsBlockOutput';
  autocomplete?: Maybe<EvpTabsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpTabsBlockFacet>;
  item?: Maybe<EvpTabsBlock>;
  items?: Maybe<Array<Maybe<EvpTabsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpTabsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpTabsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GridColumnCss?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IntroText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Tabs?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpTabsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpTabsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpTabsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a text and image block */
export type EvpTextImageBlock = IContent & IData & {
  __typename?: 'EVPTextImageBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Determines the background colour */
  BackgroundCssClass?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EVPLinkBlock?: Maybe<EvpTextImageBlockEvpLinkBlock>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<EvpTextImageBlockEvpImageBlock>;
  /** If selected the image will be displayed on the left. */
  ImageLeft?: Maybe<Scalars['Bool']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a text and image block */
export type EvpTextImageBlockBackgroundCssClassArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a text and image block */
export type EvpTextImageBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a text and image block */
export type EvpTextImageBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a text and image block */
export type EvpTextImageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a text and image block */
export type EvpTextImageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a text and image block */
export type EvpTextImageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpTextImageBlockAutocomplete = {
  __typename?: 'EVPTextImageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EVPLinkBlock?: Maybe<EvpTextImageBlockEvpLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<EvpTextImageBlockEvpImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpTextImageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTextImageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTextImageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTextImageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTextImageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTextImageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTextImageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTextImageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTextImageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpTextImageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpTextImageBlockEvpImageBlock = {
  __typename?: 'EVPTextImageBlockEVPImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
};


export type EvpTextImageBlockEvpImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpTextImageBlockEvpImageBlockAutocomplete = {
  __typename?: 'EVPTextImageBlockEVPImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EvpTextImageBlockEvpImageBlockFacet = {
  __typename?: 'EVPTextImageBlockEVPImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
};


export type EvpTextImageBlockEvpImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpTextImageBlockEvpImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type EvpTextImageBlockEvpImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type EvpTextImageBlockEvpLinkBlock = {
  __typename?: 'EVPTextImageBlockEVPLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type EvpTextImageBlockEvpLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpTextImageBlockEvpLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EvpTextImageBlockEvpLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EvpTextImageBlockEvpLinkBlockAutocomplete = {
  __typename?: 'EVPTextImageBlockEVPLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpTextImageBlockEvpLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpTextImageBlockEvpLinkBlockFacet = {
  __typename?: 'EVPTextImageBlockEVPLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EvpTextImageBlockEvpLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockEvpLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockEvpLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockEvpLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EvpTextImageBlockEvpLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type EvpTextImageBlockEvpLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type EvpTextImageBlockFacet = {
  __typename?: 'EVPTextImageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundCssClass?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EVPLinkBlock?: Maybe<EvpTextImageBlockEvpLinkBlockFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<EvpTextImageBlockEvpImageBlockFacet>;
  ImageLeft?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpTextImageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetBackgroundCssClassArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTextImageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTextImageBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetImageLeftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTextImageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTextImageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpTextImageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpTextImageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpTextImageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackgroundCssClass?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EVPLinkBlock?: InputMaybe<EvpTextImageBlockEvpLinkBlockOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<EvpTextImageBlockEvpImageBlockOrderByInput>;
  ImageLeft?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpTextImageBlockOutput = {
  __typename?: 'EVPTextImageBlockOutput';
  autocomplete?: Maybe<EvpTextImageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpTextImageBlockFacet>;
  item?: Maybe<EvpTextImageBlock>;
  items?: Maybe<Array<Maybe<EvpTextImageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpTextImageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpTextImageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackgroundCssClass?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EVPLinkBlock?: InputMaybe<EvpTextImageBlockEvpLinkBlockWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<EvpTextImageBlockEvpImageBlockWhereInput>;
  ImageLeft?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpTextImageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpTextImageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpTextImageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Image block used as a property */
export type EvpVideoBlock = IContent & IData & {
  __typename?: 'EVPVideoBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** The that will be displayed until the user plays the video. */
  ImageReference?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** The video that will be rendered */
  VideoReference?: Maybe<ContentModelReference>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Image block used as a property */
export type EvpVideoBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type EvpVideoBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type EvpVideoBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EvpVideoBlockAutocomplete = {
  __typename?: 'EVPVideoBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  VideoReference?: Maybe<ContentModelReferenceAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EvpVideoBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpVideoBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpVideoBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpVideoBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpVideoBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpVideoBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpVideoBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpVideoBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpVideoBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EvpVideoBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EvpVideoBlockFacet = {
  __typename?: 'EVPVideoBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VideoReference?: Maybe<ContentModelReferenceFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EvpVideoBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpVideoBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpVideoBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpVideoBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpVideoBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EvpVideoBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EvpVideoBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EvpVideoBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VideoReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EvpVideoBlockOutput = {
  __typename?: 'EVPVideoBlockOutput';
  autocomplete?: Maybe<EvpVideoBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EvpVideoBlockFacet>;
  item?: Maybe<EvpVideoBlock>;
  items?: Maybe<Array<Maybe<EvpVideoBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EvpVideoBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvpVideoBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VideoReference?: InputMaybe<ContentModelReferenceWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<EvpVideoBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EvpVideoBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EvpVideoBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlock = IContent & IData & {
  __typename?: 'EmployeeTableHeaderLabelsBlock';
  Action?: Maybe<Scalars['String']['output']>;
  AgentID?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  CurrentYearStatus?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastName?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PrepaidCompanyAmount?: Maybe<Scalars['String']['output']>;
  PrepaidPersonAmount?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlockActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlockCurrentYearStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlockFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlockLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlockPrepaidCompanyAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlockPrepaidPersonAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Employee Table Header Labels */
export type EmployeeTableHeaderLabelsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EmployeeTableHeaderLabelsBlockAutocomplete = {
  __typename?: 'EmployeeTableHeaderLabelsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EmployeeTableHeaderLabelsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmployeeTableHeaderLabelsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmployeeTableHeaderLabelsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmployeeTableHeaderLabelsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmployeeTableHeaderLabelsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmployeeTableHeaderLabelsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmployeeTableHeaderLabelsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmployeeTableHeaderLabelsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmployeeTableHeaderLabelsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmployeeTableHeaderLabelsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EmployeeTableHeaderLabelsBlockFacet = {
  __typename?: 'EmployeeTableHeaderLabelsBlockFacet';
  Action?: Maybe<Array<Maybe<StringFacet>>>;
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CurrentYearStatus?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastName?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PrepaidCompanyAmount?: Maybe<Array<Maybe<StringFacet>>>;
  PrepaidPersonAmount?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EmployeeTableHeaderLabelsBlockFacetActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeTableHeaderLabelsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeTableHeaderLabelsBlockFacetCurrentYearStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EmployeeTableHeaderLabelsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetPrepaidCompanyAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetPrepaidPersonAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeTableHeaderLabelsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeTableHeaderLabelsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeTableHeaderLabelsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmployeeTableHeaderLabelsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EmployeeTableHeaderLabelsBlockOrderByInput = {
  Action?: InputMaybe<OrderBy>;
  AgentID?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CurrentYearStatus?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastName?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PrepaidCompanyAmount?: InputMaybe<OrderBy>;
  PrepaidPersonAmount?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EmployeeTableHeaderLabelsBlockOutput = {
  __typename?: 'EmployeeTableHeaderLabelsBlockOutput';
  autocomplete?: Maybe<EmployeeTableHeaderLabelsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EmployeeTableHeaderLabelsBlockFacet>;
  item?: Maybe<EmployeeTableHeaderLabelsBlock>;
  items?: Maybe<Array<Maybe<EmployeeTableHeaderLabelsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EmployeeTableHeaderLabelsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployeeTableHeaderLabelsBlockWhereInput = {
  Action?: InputMaybe<SearchableStringFilterInput>;
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CurrentYearStatus?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastName?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PrepaidCompanyAmount?: InputMaybe<SearchableStringFilterInput>;
  PrepaidPersonAmount?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EmployeeTableHeaderLabelsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EmployeeTableHeaderLabelsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EmployeeTableHeaderLabelsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ErrorModalBlock = IContent & IData & {
  __typename?: 'ErrorModalBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CloseButtonText?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ErrorModalBlockCloseButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorModalBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorModalBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorModalBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorModalBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ErrorModalBlockAutocomplete = {
  __typename?: 'ErrorModalBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ErrorModalBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorModalBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorModalBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorModalBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorModalBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorModalBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorModalBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorModalBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorModalBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorModalBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorModalBlockFacet = {
  __typename?: 'ErrorModalBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CloseButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ErrorModalBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorModalBlockFacetCloseButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorModalBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorModalBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorModalBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ErrorModalBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CloseButtonText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ErrorModalBlockOutput = {
  __typename?: 'ErrorModalBlockOutput';
  autocomplete?: Maybe<ErrorModalBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ErrorModalBlockFacet>;
  item?: Maybe<ErrorModalBlock>;
  items?: Maybe<Array<Maybe<ErrorModalBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ErrorModalBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ErrorModalBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CloseButtonText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ErrorModalBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ErrorModalBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ErrorModalBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Error page */
export type ErrorPage = IContent & IData & {
  __typename?: 'ErrorPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  ButtonLabel?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<ErrorPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<ErrorPageImageBlock>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Error page */
export type ErrorPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Error page */
export type ErrorPageButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Error page */
export type ErrorPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Error page */
export type ErrorPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Error page */
export type ErrorPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Error page */
export type ErrorPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Error page */
export type ErrorPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Error page */
export type ErrorPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Error page */
export type ErrorPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ErrorPageAutocomplete = {
  __typename?: 'ErrorPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<ErrorPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<ErrorPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ErrorPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageBlock = IContent & IData & {
  __typename?: 'ErrorPageBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ErrorPageBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ErrorPageBlockAutocomplete = {
  __typename?: 'ErrorPageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ErrorPageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageBlockFacet = {
  __typename?: 'ErrorPageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ErrorPageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ErrorPageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ErrorPageBlockOutput = {
  __typename?: 'ErrorPageBlockOutput';
  autocomplete?: Maybe<ErrorPageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ErrorPageBlockFacet>;
  item?: Maybe<ErrorPageBlock>;
  items?: Maybe<Array<Maybe<ErrorPageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ErrorPageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ErrorPageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ErrorPageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ErrorPageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ErrorPageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ErrorPageFacet = {
  __typename?: 'ErrorPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  ButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<ErrorPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<ErrorPageImageBlockFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ErrorPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ErrorPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ErrorPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ErrorPageImageBlock = {
  __typename?: 'ErrorPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type ErrorPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ErrorPageImageBlockAutocomplete = {
  __typename?: 'ErrorPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ErrorPageImageBlockFacet = {
  __typename?: 'ErrorPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ErrorPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ErrorPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type ErrorPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type ErrorPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  ButtonLabel?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<ErrorPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<ErrorPageImageBlockOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ErrorPageOutput = {
  __typename?: 'ErrorPageOutput';
  autocomplete?: Maybe<ErrorPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ErrorPageFacet>;
  item?: Maybe<ErrorPage>;
  items?: Maybe<Array<Maybe<ErrorPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ErrorPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ErrorPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  ButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<ErrorPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<ErrorPageImageBlockWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ErrorPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ErrorPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ErrorPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Five coloumn event block */
export type EventBlock = IContent & IData & {
  __typename?: 'EventBlock';
  /** Drag over all of the Hotel blocks for this specific event */
  Accomodations?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of Categories to be displayed in Category List blocks referencing this event. */
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Date of the last day of the event */
  EndDate?: Maybe<Scalars['Date']['output']>;
  EventSessionBlock?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  /** Short Summary used to describe this event throughout the site. */
  EventSummary?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  IsFlagShipEvent?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Drag over an Event Location block for this event */
  Locations?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  /** Date of the first day of the event */
  StartDate?: Maybe<Scalars['Date']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Five coloumn event block */
export type EventBlockAccomodationsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event block */
export type EventBlockEventSessionBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event block */
export type EventBlockEventSummaryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event block */
export type EventBlockLocationsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event block */
export type EventBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event block */
export type EventBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event block */
export type EventBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventBlockAutocomplete = {
  __typename?: 'EventBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventBlockFacet = {
  __typename?: 'EventBlockFacet';
  Accomodations?: Maybe<ContentAreaItemModelSearchFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EndDate?: Maybe<Array<Maybe<DateFacet>>>;
  EventSessionBlock?: Maybe<ContentAreaItemModelSearchFacet>;
  EventSummary?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsFlagShipEvent?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Locations?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartDate?: Maybe<Array<Maybe<DateFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventBlockFacetEndDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventBlockFacetEventSummaryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetIsFlagShipEventArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetStartDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventBlockOrderByInput = {
  Accomodations?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EndDate?: InputMaybe<OrderBy>;
  EventSessionBlock?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  EventSummary?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsFlagShipEvent?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Locations?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartDate?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventBlockOutput = {
  __typename?: 'EventBlockOutput';
  autocomplete?: Maybe<EventBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventBlockFacet>;
  item?: Maybe<EventBlock>;
  items?: Maybe<Array<Maybe<EventBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventBlockWhereInput = {
  Accomodations?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EndDate?: InputMaybe<DateFilterInput>;
  EventSessionBlock?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  EventSummary?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsFlagShipEvent?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Locations?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartDate?: InputMaybe<DateFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This block renders the time and date of the event */
export type EventLocationAndDateBlock = IContent & IData & {
  __typename?: 'EventLocationAndDateBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EndDate?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  Location?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartDate?: Maybe<Scalars['Date']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This block renders the time and date of the event */
export type EventLocationAndDateBlockLocationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders the time and date of the event */
export type EventLocationAndDateBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders the time and date of the event */
export type EventLocationAndDateBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders the time and date of the event */
export type EventLocationAndDateBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventLocationAndDateBlockAutocomplete = {
  __typename?: 'EventLocationAndDateBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventLocationAndDateBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationAndDateBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationAndDateBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationAndDateBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationAndDateBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationAndDateBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationAndDateBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationAndDateBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationAndDateBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationAndDateBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventLocationAndDateBlockFacet = {
  __typename?: 'EventLocationAndDateBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EndDate?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Location?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartDate?: Maybe<Array<Maybe<DateFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventLocationAndDateBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationAndDateBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationAndDateBlockFacetEndDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationAndDateBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventLocationAndDateBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacetLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationAndDateBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacetStartDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationAndDateBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationAndDateBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationAndDateBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationAndDateBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventLocationAndDateBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EndDate?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Location?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartDate?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventLocationAndDateBlockOutput = {
  __typename?: 'EventLocationAndDateBlockOutput';
  autocomplete?: Maybe<EventLocationAndDateBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventLocationAndDateBlockFacet>;
  item?: Maybe<EventLocationAndDateBlock>;
  items?: Maybe<Array<Maybe<EventLocationAndDateBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventLocationAndDateBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventLocationAndDateBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EndDate?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Location?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartDate?: InputMaybe<DateFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventLocationAndDateBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventLocationAndDateBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventLocationAndDateBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Renders the event location and accomodation information for the given Event */
export type EventLocationInformationBlock = IContent & IData & {
  __typename?: 'EventLocationInformationBlock';
  /** This is content between Accommodation Section Header and the list of accommodations. */
  AccommodationsBody?: Maybe<Scalars['String']['output']>;
  AccommodationsHeader?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EventBlockReference?: Maybe<ContentModelReference>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** This is content between the Location Block and the accomodation header. */
  LocationBody?: Maybe<Scalars['String']['output']>;
  LocationHeader?: Maybe<Scalars['String']['output']>;
  /** This is content between the Location Header and the location block. */
  LocationSubHeader?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewMoreLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Renders the event location and accomodation information for the given Event */
export type EventLocationInformationBlockAccommodationsBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders the event location and accomodation information for the given Event */
export type EventLocationInformationBlockAccommodationsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders the event location and accomodation information for the given Event */
export type EventLocationInformationBlockLocationBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders the event location and accomodation information for the given Event */
export type EventLocationInformationBlockLocationHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders the event location and accomodation information for the given Event */
export type EventLocationInformationBlockLocationSubHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders the event location and accomodation information for the given Event */
export type EventLocationInformationBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders the event location and accomodation information for the given Event */
export type EventLocationInformationBlockViewMoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders the event location and accomodation information for the given Event */
export type EventLocationInformationBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders the event location and accomodation information for the given Event */
export type EventLocationInformationBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventLocationInformationBlockAutocomplete = {
  __typename?: 'EventLocationInformationBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EventBlockReference?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventLocationInformationBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationInformationBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationInformationBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationInformationBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationInformationBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationInformationBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationInformationBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationInformationBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationInformationBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventLocationInformationBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventLocationInformationBlockFacet = {
  __typename?: 'EventLocationInformationBlockFacet';
  AccommodationsBody?: Maybe<Array<Maybe<StringFacet>>>;
  AccommodationsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EventBlockReference?: Maybe<ContentModelReferenceFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LocationBody?: Maybe<Array<Maybe<StringFacet>>>;
  LocationHeader?: Maybe<Array<Maybe<StringFacet>>>;
  LocationSubHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventLocationInformationBlockFacetAccommodationsBodyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetAccommodationsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationInformationBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationInformationBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventLocationInformationBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetLocationBodyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetLocationHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetLocationSubHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationInformationBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationInformationBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventLocationInformationBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacetViewMoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventLocationInformationBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventLocationInformationBlockOrderByInput = {
  AccommodationsBody?: InputMaybe<OrderBy>;
  AccommodationsHeader?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EventBlockReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LocationBody?: InputMaybe<OrderBy>;
  LocationHeader?: InputMaybe<OrderBy>;
  LocationSubHeader?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ViewMoreLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventLocationInformationBlockOutput = {
  __typename?: 'EventLocationInformationBlockOutput';
  autocomplete?: Maybe<EventLocationInformationBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventLocationInformationBlockFacet>;
  item?: Maybe<EventLocationInformationBlock>;
  items?: Maybe<Array<Maybe<EventLocationInformationBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventLocationInformationBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventLocationInformationBlockWhereInput = {
  AccommodationsBody?: InputMaybe<SearchableStringFilterInput>;
  AccommodationsHeader?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EventBlockReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LocationBody?: InputMaybe<SearchableStringFilterInput>;
  LocationHeader?: InputMaybe<SearchableStringFilterInput>;
  LocationSubHeader?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewMoreLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventLocationInformationBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventLocationInformationBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventLocationInformationBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** An Event Page and also an Event Detail page */
export type EventPage = IContent & IData & {
  __typename?: 'EventPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** If not Flagship Event, then this is the title of the page to show in the Detail header. */
  DetailPageName?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  EventBlockReference?: Maybe<ContentModelReference>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  HeroImage?: Maybe<EventPageImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<EventPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Link to registration page for this event */
  RegisterButton?: Maybe<EventPageLinkBlock>;
  /** Text to show in the blue info for Flagship Event Hero */
  RegistrationText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  ReturnToEventLink?: Maybe<EventPageLinkBlock>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<EventPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** An Event Page and also an Event Detail page */
export type EventPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event Page and also an Event Detail page */
export type EventPageDetailPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event Page and also an Event Detail page */
export type EventPageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event Page and also an Event Detail page */
export type EventPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event Page and also an Event Detail page */
export type EventPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event Page and also an Event Detail page */
export type EventPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event Page and also an Event Detail page */
export type EventPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event Page and also an Event Detail page */
export type EventPageRegistrationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event Page and also an Event Detail page */
export type EventPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event Page and also an Event Detail page */
export type EventPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventPageAutocomplete = {
  __typename?: 'EventPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EventBlockReference?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  HeroImage?: Maybe<EventPageImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<EventPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RegisterButton?: Maybe<EventPageLinkBlockAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ReturnToEventLink?: Maybe<EventPageLinkBlockAutocomplete>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<EventPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventPageFacet = {
  __typename?: 'EventPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DetailPageName?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EventBlockReference?: Maybe<ContentModelReferenceFacet>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  HeroImage?: Maybe<EventPageImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<EventPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RegisterButton?: Maybe<EventPageLinkBlockFacet>;
  RegistrationText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ReturnToEventLink?: Maybe<EventPageLinkBlockFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<EventPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventPageFacetDetailPageNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetRegistrationTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventPageImageBlock = {
  __typename?: 'EventPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type EventPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EventPageImageBlockAutocomplete = {
  __typename?: 'EventPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EventPageImageBlockFacet = {
  __typename?: 'EventPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EventPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EventPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type EventPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type EventPageLinkBlock = {
  __typename?: 'EventPageLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type EventPageLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventPageLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventPageLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventPageLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventPageLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventPageLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventPageLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EventPageLinkBlockAutocomplete = {
  __typename?: 'EventPageLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventPageLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventPageLinkBlockFacet = {
  __typename?: 'EventPageLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EventPageLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventPageLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventPageLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EventPageLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type EventPageLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type EventPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DetailPageName?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  EventBlockReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  HeroImage?: InputMaybe<EventPageImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<EventPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RegisterButton?: InputMaybe<EventPageLinkBlockOrderByInput>;
  RegistrationText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  ReturnToEventLink?: InputMaybe<EventPageLinkBlockOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<EventPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventPageOutput = {
  __typename?: 'EventPageOutput';
  autocomplete?: Maybe<EventPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventPageFacet>;
  item?: Maybe<EventPage>;
  items?: Maybe<Array<Maybe<EventPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DetailPageName?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  EventBlockReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  HeroImage?: InputMaybe<EventPageImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<EventPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RegisterButton?: InputMaybe<EventPageLinkBlockWhereInput>;
  RegistrationText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ReturnToEventLink?: InputMaybe<EventPageLinkBlockWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<EventPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Displays Information regarding event registration */
export type EventRegistrationInformationBlock = IContent & IData & {
  __typename?: 'EventRegistrationInformationBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BottomBannerDescription?: Maybe<Scalars['String']['output']>;
  /** Email to use for registration questions */
  BottomBannerEmail?: Maybe<Scalars['String']['output']>;
  /** Email address label */
  BottomBannerEmailLabel?: Maybe<Scalars['String']['output']>;
  BottomBannerHeadline?: Maybe<Scalars['String']['output']>;
  /** Select the icon to use for the block */
  BottomBannerIcon?: Maybe<Scalars['String']['output']>;
  /** Email address label */
  BottomBannerPhoneLabel?: Maybe<Scalars['String']['output']>;
  /** Phone Number to use for registration questions */
  BottomBannerPhoneNumber?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CostTileHeadline?: Maybe<Scalars['String']['output']>;
  CostTileSubHead?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Fine print to show below the registration cost tile */
  Disclaimer?: Maybe<Scalars['String']['output']>;
  EventBlockReference?: Maybe<ContentModelReference>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Headline?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContentForEventRegistration?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RegistrationLink?: Maybe<EventRegistrationInformationBlockLinkBlock>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TopBannerDescription?: Maybe<Scalars['String']['output']>;
  TopBannerHeadline?: Maybe<Scalars['String']['output']>;
  USDCost?: Maybe<Scalars['Int']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockBottomBannerDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockBottomBannerEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockBottomBannerEmailLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockBottomBannerHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockBottomBannerIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockBottomBannerPhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockBottomBannerPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockCostTileHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockCostTileSubHeadArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockDisclaimerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockMainContentForEventRegistrationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockTopBannerDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlockTopBannerHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays Information regarding event registration */
export type EventRegistrationInformationBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventRegistrationInformationBlockAutocomplete = {
  __typename?: 'EventRegistrationInformationBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EventBlockReference?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RegistrationLink?: Maybe<EventRegistrationInformationBlockLinkBlockAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventRegistrationInformationBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventRegistrationInformationBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventRegistrationInformationBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventRegistrationInformationBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventRegistrationInformationBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventRegistrationInformationBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventRegistrationInformationBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventRegistrationInformationBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventRegistrationInformationBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventRegistrationInformationBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventRegistrationInformationBlockFacet = {
  __typename?: 'EventRegistrationInformationBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BottomBannerDescription?: Maybe<Array<Maybe<StringFacet>>>;
  BottomBannerEmail?: Maybe<Array<Maybe<StringFacet>>>;
  BottomBannerEmailLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BottomBannerHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  BottomBannerIcon?: Maybe<Array<Maybe<StringFacet>>>;
  BottomBannerPhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BottomBannerPhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CostTileHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  CostTileSubHead?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Disclaimer?: Maybe<Array<Maybe<StringFacet>>>;
  EventBlockReference?: Maybe<ContentModelReferenceFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContentForEventRegistration?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RegistrationLink?: Maybe<EventRegistrationInformationBlockLinkBlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TopBannerDescription?: Maybe<Array<Maybe<StringFacet>>>;
  TopBannerHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  USDCost?: Maybe<Array<Maybe<NumberFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventRegistrationInformationBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetBottomBannerDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetBottomBannerEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetBottomBannerEmailLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetBottomBannerHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetBottomBannerIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetBottomBannerPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetBottomBannerPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventRegistrationInformationBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetCostTileHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetCostTileSubHeadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventRegistrationInformationBlockFacetDisclaimerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventRegistrationInformationBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetMainContentForEventRegistrationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventRegistrationInformationBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventRegistrationInformationBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventRegistrationInformationBlockFacetTopBannerDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetTopBannerHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacetUsdCostArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventRegistrationInformationBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventRegistrationInformationBlockLinkBlock = {
  __typename?: 'EventRegistrationInformationBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type EventRegistrationInformationBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventRegistrationInformationBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventRegistrationInformationBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventRegistrationInformationBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventRegistrationInformationBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventRegistrationInformationBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventRegistrationInformationBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EventRegistrationInformationBlockLinkBlockAutocomplete = {
  __typename?: 'EventRegistrationInformationBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventRegistrationInformationBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventRegistrationInformationBlockLinkBlockFacet = {
  __typename?: 'EventRegistrationInformationBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EventRegistrationInformationBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventRegistrationInformationBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventRegistrationInformationBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EventRegistrationInformationBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type EventRegistrationInformationBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type EventRegistrationInformationBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BottomBannerDescription?: InputMaybe<OrderBy>;
  BottomBannerEmail?: InputMaybe<OrderBy>;
  BottomBannerEmailLabel?: InputMaybe<OrderBy>;
  BottomBannerHeadline?: InputMaybe<OrderBy>;
  BottomBannerIcon?: InputMaybe<OrderBy>;
  BottomBannerPhoneLabel?: InputMaybe<OrderBy>;
  BottomBannerPhoneNumber?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CostTileHeadline?: InputMaybe<OrderBy>;
  CostTileSubHead?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Disclaimer?: InputMaybe<OrderBy>;
  EventBlockReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Headline?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContentForEventRegistration?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RegistrationLink?: InputMaybe<EventRegistrationInformationBlockLinkBlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TopBannerDescription?: InputMaybe<OrderBy>;
  TopBannerHeadline?: InputMaybe<OrderBy>;
  USDCost?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventRegistrationInformationBlockOutput = {
  __typename?: 'EventRegistrationInformationBlockOutput';
  autocomplete?: Maybe<EventRegistrationInformationBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventRegistrationInformationBlockFacet>;
  item?: Maybe<EventRegistrationInformationBlock>;
  items?: Maybe<Array<Maybe<EventRegistrationInformationBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventRegistrationInformationBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventRegistrationInformationBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BottomBannerDescription?: InputMaybe<SearchableStringFilterInput>;
  BottomBannerEmail?: InputMaybe<SearchableStringFilterInput>;
  BottomBannerEmailLabel?: InputMaybe<SearchableStringFilterInput>;
  BottomBannerHeadline?: InputMaybe<SearchableStringFilterInput>;
  BottomBannerIcon?: InputMaybe<SearchableStringFilterInput>;
  BottomBannerPhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  BottomBannerPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CostTileHeadline?: InputMaybe<SearchableStringFilterInput>;
  CostTileSubHead?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Disclaimer?: InputMaybe<SearchableStringFilterInput>;
  EventBlockReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContentForEventRegistration?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RegistrationLink?: InputMaybe<EventRegistrationInformationBlockLinkBlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TopBannerDescription?: InputMaybe<SearchableStringFilterInput>;
  TopBannerHeadline?: InputMaybe<SearchableStringFilterInput>;
  USDCost?: InputMaybe<IntFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventRegistrationInformationBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventRegistrationInformationBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventRegistrationInformationBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Event Session Block  */
export type EventSessionBlock = IContent & IData & {
  __typename?: 'EventSessionBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Date/Time for the Session End */
  EndDate?: Maybe<Scalars['Date']['output']>;
  EventSessionTrackBlock?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkBlock?: Maybe<EventSessionBlockLinkBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RegistrationStatus?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  /** Date/Time for the Session Start */
  StartDate?: Maybe<Scalars['Date']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StatusLinkLabel?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Event Session Block  */
export type EventSessionBlockEventSessionTrackBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Session Block  */
export type EventSessionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Session Block  */
export type EventSessionBlockRegistrationStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Session Block  */
export type EventSessionBlockStatusLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Session Block  */
export type EventSessionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Session Block  */
export type EventSessionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventSessionBlockAutocomplete = {
  __typename?: 'EventSessionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkBlock?: Maybe<EventSessionBlockLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventSessionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventSessionBlockFacet = {
  __typename?: 'EventSessionBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EndDate?: Maybe<Array<Maybe<DateFacet>>>;
  EventSessionTrackBlock?: Maybe<ContentAreaItemModelSearchFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkBlock?: Maybe<EventSessionBlockLinkBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RegistrationStatus?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartDate?: Maybe<Array<Maybe<DateFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StatusLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventSessionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionBlockFacetEndDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventSessionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetRegistrationStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetStartDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetStatusLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventSessionBlockLinkBlock = {
  __typename?: 'EventSessionBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type EventSessionBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventSessionBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventSessionBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventSessionBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventSessionBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventSessionBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventSessionBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EventSessionBlockLinkBlockAutocomplete = {
  __typename?: 'EventSessionBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventSessionBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventSessionBlockLinkBlockFacet = {
  __typename?: 'EventSessionBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EventSessionBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventSessionBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EventSessionBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type EventSessionBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type EventSessionBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EndDate?: InputMaybe<OrderBy>;
  EventSessionTrackBlock?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkBlock?: InputMaybe<EventSessionBlockLinkBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RegistrationStatus?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartDate?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StatusLinkLabel?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventSessionBlockOutput = {
  __typename?: 'EventSessionBlockOutput';
  autocomplete?: Maybe<EventSessionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventSessionBlockFacet>;
  item?: Maybe<EventSessionBlock>;
  items?: Maybe<Array<Maybe<EventSessionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventSessionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventSessionBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EndDate?: InputMaybe<DateFilterInput>;
  EventSessionTrackBlock?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkBlock?: InputMaybe<EventSessionBlockLinkBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RegistrationStatus?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartDate?: InputMaybe<DateFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StatusLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventSessionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventSessionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventSessionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Displays the Event Session Schedule table with optional footer */
export type EventSessionScheduleBlock = IContent & IData & {
  __typename?: 'EventSessionScheduleBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EventBlockReference?: Maybe<ContentModelReference>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  /** Shows beneath table - note about session line items, like '* TOT only' */
  SessionTableNote?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Displays the Event Session Schedule table with optional footer */
export type EventSessionScheduleBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays the Event Session Schedule table with optional footer */
export type EventSessionScheduleBlockSessionTableNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays the Event Session Schedule table with optional footer */
export type EventSessionScheduleBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays the Event Session Schedule table with optional footer */
export type EventSessionScheduleBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventSessionScheduleBlockAutocomplete = {
  __typename?: 'EventSessionScheduleBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EventBlockReference?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventSessionScheduleBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionScheduleBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionScheduleBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionScheduleBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionScheduleBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionScheduleBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionScheduleBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionScheduleBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionScheduleBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionScheduleBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventSessionScheduleBlockFacet = {
  __typename?: 'EventSessionScheduleBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EventBlockReference?: Maybe<ContentModelReferenceFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SessionTableNote?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventSessionScheduleBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionScheduleBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionScheduleBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventSessionScheduleBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionScheduleBlockFacetSessionTableNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionScheduleBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionScheduleBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionScheduleBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventSessionScheduleBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EventBlockReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SessionTableNote?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventSessionScheduleBlockOutput = {
  __typename?: 'EventSessionScheduleBlockOutput';
  autocomplete?: Maybe<EventSessionScheduleBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventSessionScheduleBlockFacet>;
  item?: Maybe<EventSessionScheduleBlock>;
  items?: Maybe<Array<Maybe<EventSessionScheduleBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventSessionScheduleBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventSessionScheduleBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EventBlockReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SessionTableNote?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventSessionScheduleBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventSessionScheduleBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventSessionScheduleBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Event Session Track Block */
export type EventSessionTrackBlock = IContent & IData & {
  __typename?: 'EventSessionTrackBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EventSessionTrackSpeakerBlock?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Event Session Track Block */
export type EventSessionTrackBlockEventSessionTrackSpeakerBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Session Track Block */
export type EventSessionTrackBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Session Track Block */
export type EventSessionTrackBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Session Track Block */
export type EventSessionTrackBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventSessionTrackBlockAutocomplete = {
  __typename?: 'EventSessionTrackBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventSessionTrackBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventSessionTrackBlockFacet = {
  __typename?: 'EventSessionTrackBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EventSessionTrackSpeakerBlock?: Maybe<ContentAreaItemModelSearchFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventSessionTrackBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionTrackBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionTrackBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventSessionTrackBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionTrackBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionTrackBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionTrackBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventSessionTrackBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EventSessionTrackSpeakerBlock?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventSessionTrackBlockOutput = {
  __typename?: 'EventSessionTrackBlockOutput';
  autocomplete?: Maybe<EventSessionTrackBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventSessionTrackBlockFacet>;
  item?: Maybe<EventSessionTrackBlock>;
  items?: Maybe<Array<Maybe<EventSessionTrackBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventSessionTrackBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventSessionTrackBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EventSessionTrackSpeakerBlock?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventSessionTrackBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventSessionTrackBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventSessionTrackBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Event Session Track Speaker Block */
export type EventSessionTrackSpeakerBlock = IContent & IData & {
  __typename?: 'EventSessionTrackSpeakerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  Languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  Speaker?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Event Session Track Speaker Block */
export type EventSessionTrackSpeakerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Session Track Speaker Block */
export type EventSessionTrackSpeakerBlockSpeakerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Session Track Speaker Block */
export type EventSessionTrackSpeakerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Session Track Speaker Block */
export type EventSessionTrackSpeakerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventSessionTrackSpeakerBlockAutocomplete = {
  __typename?: 'EventSessionTrackSpeakerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventSessionTrackSpeakerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackSpeakerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackSpeakerBlockAutocompleteLanguagesArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackSpeakerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackSpeakerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackSpeakerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackSpeakerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackSpeakerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackSpeakerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackSpeakerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSessionTrackSpeakerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventSessionTrackSpeakerBlockFacet = {
  __typename?: 'EventSessionTrackSpeakerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Languages?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  Speaker?: Maybe<ContentAreaItemModelSearchFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventSessionTrackSpeakerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionTrackSpeakerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionTrackSpeakerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventSessionTrackSpeakerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacetLanguagesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionTrackSpeakerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionTrackSpeakerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSessionTrackSpeakerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSessionTrackSpeakerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventSessionTrackSpeakerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Languages?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  Speaker?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventSessionTrackSpeakerBlockOutput = {
  __typename?: 'EventSessionTrackSpeakerBlockOutput';
  autocomplete?: Maybe<EventSessionTrackSpeakerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventSessionTrackSpeakerBlockFacet>;
  item?: Maybe<EventSessionTrackSpeakerBlock>;
  items?: Maybe<Array<Maybe<EventSessionTrackSpeakerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventSessionTrackSpeakerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventSessionTrackSpeakerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Languages?: InputMaybe<StringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  Speaker?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventSessionTrackSpeakerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventSessionTrackSpeakerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventSessionTrackSpeakerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPage = IContent & IData & {
  __typename?: 'EventSpeakerSearchPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  BackToEventLabel?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ClearAllFiltersLabel?: Maybe<Scalars['String']['output']>;
  ClearSearchButtonLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ErrorResultsText?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  FiltersLabel?: Maybe<Scalars['String']['output']>;
  HomeUrl?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LanguageFilterLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<EventSpeakerSearchPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NoResultsText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RegisterButtonLabel?: Maybe<Scalars['String']['output']>;
  RegistrationUrl?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SearchBarPlaceholder?: Maybe<Scalars['String']['output']>;
  SearchButtonLabel?: Maybe<Scalars['String']['output']>;
  SessionTrackFilterLabel?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SocialLinksLabel?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<EventSpeakerSearchPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewMoreMobileLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageBackToEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageClearAllFiltersLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageClearSearchButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageErrorResultsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageFiltersLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageHomeUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageLanguageFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageNoResultsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageRegisterButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageRegistrationUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageSearchBarPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageSearchButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageSessionTrackFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageSocialLinksLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPageViewMoreMobileLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Event Speaker Search Page */
export type EventSpeakerSearchPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventSpeakerSearchPageAutocomplete = {
  __typename?: 'EventSpeakerSearchPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<EventSpeakerSearchPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<EventSpeakerSearchPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventSpeakerSearchPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakerSearchPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakerSearchPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakerSearchPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakerSearchPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakerSearchPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakerSearchPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakerSearchPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakerSearchPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakerSearchPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventSpeakerSearchPageFacet = {
  __typename?: 'EventSpeakerSearchPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  BackToEventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ClearAllFiltersLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ClearSearchButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FiltersLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HomeUrl?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LanguageFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<EventSpeakerSearchPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NoResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RegisterButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RegistrationUrl?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchBarPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  SearchButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SessionTrackFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SocialLinksLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<EventSpeakerSearchPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMoreMobileLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventSpeakerSearchPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetBackToEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSpeakerSearchPageFacetClearAllFiltersLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetClearSearchButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventSpeakerSearchPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSpeakerSearchPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetErrorResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetFiltersLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetHomeUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventSpeakerSearchPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetLanguageFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetNoResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetRegisterButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetRegistrationUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSpeakerSearchPageFacetSearchBarPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetSearchButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetSessionTrackFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetSocialLinksLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSpeakerSearchPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSpeakerSearchPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacetViewMoreMobileLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventSpeakerSearchPageImageBlock = {
  __typename?: 'EventSpeakerSearchPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type EventSpeakerSearchPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventSpeakerSearchPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventSpeakerSearchPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventSpeakerSearchPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EventSpeakerSearchPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EventSpeakerSearchPageImageBlockAutocomplete = {
  __typename?: 'EventSpeakerSearchPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type EventSpeakerSearchPageImageBlockFacet = {
  __typename?: 'EventSpeakerSearchPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EventSpeakerSearchPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakerSearchPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventSpeakerSearchPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EventSpeakerSearchPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type EventSpeakerSearchPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type EventSpeakerSearchPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  BackToEventLabel?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ClearAllFiltersLabel?: InputMaybe<OrderBy>;
  ClearSearchButtonLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ErrorResultsText?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FiltersLabel?: InputMaybe<OrderBy>;
  HomeUrl?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LanguageFilterLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<EventSpeakerSearchPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NoResultsText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RegisterButtonLabel?: InputMaybe<OrderBy>;
  RegistrationUrl?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchBarPlaceholder?: InputMaybe<OrderBy>;
  SearchButtonLabel?: InputMaybe<OrderBy>;
  SessionTrackFilterLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SocialLinksLabel?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<EventSpeakerSearchPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  ViewMoreMobileLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventSpeakerSearchPageOutput = {
  __typename?: 'EventSpeakerSearchPageOutput';
  autocomplete?: Maybe<EventSpeakerSearchPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventSpeakerSearchPageFacet>;
  item?: Maybe<EventSpeakerSearchPage>;
  items?: Maybe<Array<Maybe<EventSpeakerSearchPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventSpeakerSearchPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventSpeakerSearchPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  BackToEventLabel?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ClearAllFiltersLabel?: InputMaybe<SearchableStringFilterInput>;
  ClearSearchButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ErrorResultsText?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FiltersLabel?: InputMaybe<SearchableStringFilterInput>;
  HomeUrl?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LanguageFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<EventSpeakerSearchPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NoResultsText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RegisterButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  RegistrationUrl?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchBarPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  SearchButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  SessionTrackFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SocialLinksLabel?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<EventSpeakerSearchPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewMoreMobileLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventSpeakerSearchPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventSpeakerSearchPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventSpeakerSearchPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Displays a list of Event Speakers */
export type EventSpeakersBlock = IContent & IData & {
  __typename?: 'EventSpeakersBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Event?: Maybe<ContentModelReference>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SocialLabel?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewMoreLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Displays a list of Event Speakers */
export type EventSpeakersBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays a list of Event Speakers */
export type EventSpeakersBlockSocialLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays a list of Event Speakers */
export type EventSpeakersBlockViewMoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays a list of Event Speakers */
export type EventSpeakersBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Displays a list of Event Speakers */
export type EventSpeakersBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventSpeakersBlockAutocomplete = {
  __typename?: 'EventSpeakersBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Event?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventSpeakersBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakersBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakersBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakersBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakersBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakersBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakersBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakersBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakersBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventSpeakersBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventSpeakersBlockFacet = {
  __typename?: 'EventSpeakersBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Event?: Maybe<ContentModelReferenceFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SocialLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventSpeakersBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSpeakersBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSpeakersBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventSpeakersBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSpeakersBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetSocialLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSpeakersBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSpeakersBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacetViewMoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventSpeakersBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventSpeakersBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Event?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SocialLabel?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ViewMoreLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventSpeakersBlockOutput = {
  __typename?: 'EventSpeakersBlockOutput';
  autocomplete?: Maybe<EventSpeakersBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventSpeakersBlockFacet>;
  item?: Maybe<EventSpeakersBlock>;
  items?: Maybe<Array<Maybe<EventSpeakersBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventSpeakersBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventSpeakersBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Event?: InputMaybe<ContentModelReferenceWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SocialLabel?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewMoreLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventSpeakersBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventSpeakersBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventSpeakersBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Five coloumn event table Container block */
export type EventTableContainerBlock = IContent & IData & {
  __typename?: 'EventTableContainerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Date?: Maybe<Scalars['String']['output']>;
  EventBlock?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  EventName?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  Location?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Session?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StatusLink?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewMoreLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Five coloumn event table Container block */
export type EventTableContainerBlockDateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event table Container block */
export type EventTableContainerBlockEventBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event table Container block */
export type EventTableContainerBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event table Container block */
export type EventTableContainerBlockLocationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event table Container block */
export type EventTableContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event table Container block */
export type EventTableContainerBlockSessionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event table Container block */
export type EventTableContainerBlockStatusLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event table Container block */
export type EventTableContainerBlockViewMoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event table Container block */
export type EventTableContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Five coloumn event table Container block */
export type EventTableContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EventTableContainerBlockAutocomplete = {
  __typename?: 'EventTableContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EventTableContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventTableContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventTableContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventTableContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventTableContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventTableContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventTableContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventTableContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventTableContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EventTableContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventTableContainerBlockFacet = {
  __typename?: 'EventTableContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Date?: Maybe<Array<Maybe<StringFacet>>>;
  EventBlock?: Maybe<ContentAreaItemModelSearchFacet>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Location?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Session?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StatusLink?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EventTableContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventTableContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventTableContainerBlockFacetDateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type EventTableContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventTableContainerBlockFacetSessionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventTableContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetStatusLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EventTableContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacetViewMoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EventTableContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EventTableContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Date?: InputMaybe<OrderBy>;
  EventBlock?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  EventName?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Location?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Session?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StatusLink?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ViewMoreLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EventTableContainerBlockOutput = {
  __typename?: 'EventTableContainerBlockOutput';
  autocomplete?: Maybe<EventTableContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EventTableContainerBlockFacet>;
  item?: Maybe<EventTableContainerBlock>;
  items?: Maybe<Array<Maybe<EventTableContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EventTableContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventTableContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Date?: InputMaybe<SearchableStringFilterInput>;
  EventBlock?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Location?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Session?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StatusLink?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewMoreLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EventTableContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EventTableContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EventTableContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a expandable container block */
export type ExpandableContainerBlock = IContent & IData & {
  __typename?: 'ExpandableContainerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ColumnContainerBlock?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  /** If true then the block is rendered in an expanded state on page load. */
  InitiallyExpanded?: Maybe<Scalars['Bool']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewMoreLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a expandable container block */
export type ExpandableContainerBlockColumnContainerBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a expandable container block */
export type ExpandableContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a expandable container block */
export type ExpandableContainerBlockViewMoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a expandable container block */
export type ExpandableContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a expandable container block */
export type ExpandableContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ExpandableContainerBlockAutocomplete = {
  __typename?: 'ExpandableContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ExpandableContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExpandableContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExpandableContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExpandableContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExpandableContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExpandableContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExpandableContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExpandableContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExpandableContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExpandableContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExpandableContainerBlockFacet = {
  __typename?: 'ExpandableContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ColumnContainerBlock?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  InitiallyExpanded?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ExpandableContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExpandableContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExpandableContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ExpandableContainerBlockFacetInitiallyExpandedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExpandableContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExpandableContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExpandableContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacetViewMoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandableContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ExpandableContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ColumnContainerBlock?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  InitiallyExpanded?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ViewMoreLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ExpandableContainerBlockOutput = {
  __typename?: 'ExpandableContainerBlockOutput';
  autocomplete?: Maybe<ExpandableContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ExpandableContainerBlockFacet>;
  item?: Maybe<ExpandableContainerBlock>;
  items?: Maybe<Array<Maybe<ExpandableContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ExpandableContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpandableContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ColumnContainerBlock?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  InitiallyExpanded?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewMoreLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ExpandableContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ExpandableContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ExpandableContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ExpandedCategoriesEntry = {
  __typename?: 'ExpandedCategoriesEntry';
  Id?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['Int']['output']>;
};

export type ExpandedCategoriesEntryAutocomplete = {
  __typename?: 'ExpandedCategoriesEntryAutocomplete';
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ExpandedCategoriesEntryAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExpandedCategoriesEntryFacet = {
  __typename?: 'ExpandedCategoriesEntryFacet';
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ExpandedCategoriesEntryFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ExpandedCategoriesEntryFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandedCategoriesEntryFacetParentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ExpandedCategoriesEntryOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentId?: InputMaybe<OrderBy>;
};

export type ExpandedCategoriesEntryWhereInput = {
  Id?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  ParentId?: InputMaybe<IntFilterInput>;
};

export type ExpandedSourcesEntry = {
  __typename?: 'ExpandedSourcesEntry';
  Id?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['Int']['output']>;
};

export type ExpandedSourcesEntryAutocomplete = {
  __typename?: 'ExpandedSourcesEntryAutocomplete';
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ExpandedSourcesEntryAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExpandedSourcesEntryFacet = {
  __typename?: 'ExpandedSourcesEntryFacet';
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ExpandedSourcesEntryFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ExpandedSourcesEntryFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandedSourcesEntryFacetParentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ExpandedSourcesEntryOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentId?: InputMaybe<OrderBy>;
};

export type ExpandedSourcesEntryWhereInput = {
  Id?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  ParentId?: InputMaybe<IntFilterInput>;
};

export type ExpandedTopicsEntry = {
  __typename?: 'ExpandedTopicsEntry';
  Id?: Maybe<Scalars['Int']['output']>;
  IdName?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['Int']['output']>;
};

export type ExpandedTopicsEntryAutocomplete = {
  __typename?: 'ExpandedTopicsEntryAutocomplete';
  IdName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ExpandedTopicsEntryAutocompleteIdNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExpandedTopicsEntryAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExpandedTopicsEntryFacet = {
  __typename?: 'ExpandedTopicsEntryFacet';
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  IdName?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ExpandedTopicsEntryFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ExpandedTopicsEntryFacetIdNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandedTopicsEntryFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExpandedTopicsEntryFacetParentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ExpandedTopicsEntryOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  IdName?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentId?: InputMaybe<OrderBy>;
};

export type ExpandedTopicsEntryWhereInput = {
  Id?: InputMaybe<IntFilterInput>;
  IdName?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  ParentId?: InputMaybe<IntFilterInput>;
};

export enum FactorModifier {
  /** Add 1 to the field value and take the natural logarithm */
  Log = 'LOG',
  /** Do not apply any multiplier to the field value */
  None = 'NONE',
  /** Reciprocate the field value, same as 1/x where x is the field's value */
  Reciprocal = 'RECIPROCAL',
  /** Take the square root of the field value */
  Sqrt = 'SQRT',
  /** Square the field value (multiply it by itself) */
  Square = 'SQUARE'
}

export type FeaturedContentIdsEntry = {
  __typename?: 'FeaturedContentIdsEntry';
  Id?: Maybe<Scalars['Int']['output']>;
};

export type FeaturedContentIdsEntryFacet = {
  __typename?: 'FeaturedContentIdsEntryFacet';
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type FeaturedContentIdsEntryFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FeaturedContentIdsEntryOrderByInput = {
  Id?: InputMaybe<OrderBy>;
};

export type FeaturedContentIdsEntryWhereInput = {
  Id?: InputMaybe<IntFilterInput>;
};

export type FeaturedPeopleEntry = {
  __typename?: 'FeaturedPeopleEntry';
  Id?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type FeaturedPeopleEntryAutocomplete = {
  __typename?: 'FeaturedPeopleEntryAutocomplete';
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FeaturedPeopleEntryAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeaturedPeopleEntryFacet = {
  __typename?: 'FeaturedPeopleEntryFacet';
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type FeaturedPeopleEntryFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FeaturedPeopleEntryFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeaturedPeopleEntryOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type FeaturedPeopleEntryWhereInput = {
  Id?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

export type FileUploadElementBlock = IContent & IData & {
  __typename?: 'FileUploadElementBlock';
  AllowMultiple?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['Int']['output']>;
  FileTypes?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type FileUploadElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlockFileTypesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FileUploadElementBlockAutocomplete = {
  __typename?: 'FileUploadElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FileUploadElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockFacet = {
  __typename?: 'FileUploadElementBlockFacet';
  AllowMultiple?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<NumberFacet>>>;
  FileTypes?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type FileUploadElementBlockFacetAllowMultipleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FileUploadElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FileUploadElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FileUploadElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FileUploadElementBlockFacetFileTypesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FileUploadElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FileUploadElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FileUploadElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FileUploadElementBlockOrderByInput = {
  AllowMultiple?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  FileTypes?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FileUploadElementBlockOutput = {
  __typename?: 'FileUploadElementBlockOutput';
  autocomplete?: Maybe<FileUploadElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FileUploadElementBlockFacet>;
  item?: Maybe<FileUploadElementBlock>;
  items?: Maybe<Array<Maybe<FileUploadElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FileUploadElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileUploadElementBlockWhereInput = {
  AllowMultiple?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<IntFilterInput>;
  FileTypes?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FileUploadElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FileUploadElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FileUploadElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type FloatFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Float']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `Factor` allows you to use a number value in a field to influence the `_score` directly. If used on a multi-valued field, then only the lowest value of the field is used in calculations. Default for `value` is `1`. Default for `modifier` is `NONE`. */
  factor?: InputMaybe<NumberFactor>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Float']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Float']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FlowFinishInformationBlock = IContent & IData & {
  __typename?: 'FlowFinishInformationBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type FlowFinishInformationBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FlowFinishInformationBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FlowFinishInformationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FlowFinishInformationBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FlowFinishInformationBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FlowFinishInformationBlockAutocomplete = {
  __typename?: 'FlowFinishInformationBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FlowFinishInformationBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FlowFinishInformationBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FlowFinishInformationBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FlowFinishInformationBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FlowFinishInformationBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FlowFinishInformationBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FlowFinishInformationBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FlowFinishInformationBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FlowFinishInformationBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FlowFinishInformationBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FlowFinishInformationBlockFacet = {
  __typename?: 'FlowFinishInformationBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type FlowFinishInformationBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FlowFinishInformationBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FlowFinishInformationBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FlowFinishInformationBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FlowFinishInformationBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FlowFinishInformationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FlowFinishInformationBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FlowFinishInformationBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FlowFinishInformationBlockOutput = {
  __typename?: 'FlowFinishInformationBlockOutput';
  autocomplete?: Maybe<FlowFinishInformationBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FlowFinishInformationBlockFacet>;
  item?: Maybe<FlowFinishInformationBlock>;
  items?: Maybe<Array<Maybe<FlowFinishInformationBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FlowFinishInformationBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlowFinishInformationBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FlowFinishInformationBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FlowFinishInformationBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FlowFinishInformationBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A page with no view that is used like a folder */
export type FolderPage = IContent & IData & {
  __typename?: 'FolderPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A page with no view that is used like a folder */
export type FolderPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page with no view that is used like a folder */
export type FolderPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page with no view that is used like a folder */
export type FolderPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FolderPageAutocomplete = {
  __typename?: 'FolderPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FolderPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FolderPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FolderPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FolderPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FolderPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FolderPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FolderPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FolderPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FolderPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FolderPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FolderPageFacet = {
  __typename?: 'FolderPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type FolderPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FolderPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FolderPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FolderPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FolderPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FolderPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FolderPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FolderPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FolderPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FolderPageOutput = {
  __typename?: 'FolderPageOutput';
  autocomplete?: Maybe<FolderPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FolderPageFacet>;
  item?: Maybe<FolderPage>;
  items?: Maybe<Array<Maybe<FolderPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FolderPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FolderPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FolderPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FolderPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FolderPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type FormContainerBlock = IContent & IData & {
  __typename?: 'FormContainerBlock';
  AllowAnonymousSubmission?: Maybe<Scalars['Bool']['output']>;
  AllowExposingDataFeeds?: Maybe<Scalars['Bool']['output']>;
  AllowMultipleSubmission?: Maybe<Scalars['Bool']['output']>;
  AllowToStoreSubmissionData?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConfirmationMessage?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ElementsArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FinalizedSubmissionRetentionPeriod?: Maybe<Scalars['String']['output']>;
  FocusOnForm?: Maybe<Scalars['Bool']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetadataAttribute?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PartialSubmissionRetentionPeriod?: Maybe<Scalars['String']['output']>;
  RedirectToPage?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  ResetConfirmationMessage?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  ShowNavigationBar?: Maybe<Scalars['Bool']['output']>;
  ShowSummarizedData?: Maybe<Scalars['Bool']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubmitSuccessMessage?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type FormContainerBlockConfirmationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockElementsAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockFinalizedSubmissionRetentionPeriodArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockMetadataAttributeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockPartialSubmissionRetentionPeriodArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockResetConfirmationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockSubmitSuccessMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FormContainerBlockAutocomplete = {
  __typename?: 'FormContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RedirectToPage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FormContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteRedirectToPageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockFacet = {
  __typename?: 'FormContainerBlockFacet';
  AllowAnonymousSubmission?: Maybe<Array<Maybe<StringFacet>>>;
  AllowExposingDataFeeds?: Maybe<Array<Maybe<StringFacet>>>;
  AllowMultipleSubmission?: Maybe<Array<Maybe<StringFacet>>>;
  AllowToStoreSubmissionData?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ElementsArea?: Maybe<ContentAreaItemModelSearchFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FinalizedSubmissionRetentionPeriod?: Maybe<Array<Maybe<StringFacet>>>;
  FocusOnForm?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetadataAttribute?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PartialSubmissionRetentionPeriod?: Maybe<Array<Maybe<StringFacet>>>;
  RedirectToPage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ResetConfirmationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowNavigationBar?: Maybe<Array<Maybe<StringFacet>>>;
  ShowSummarizedData?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubmitSuccessMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type FormContainerBlockFacetAllowAnonymousSubmissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetAllowExposingDataFeedsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetAllowMultipleSubmissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetAllowToStoreSubmissionDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormContainerBlockFacetConfirmationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormContainerBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetFinalizedSubmissionRetentionPeriodArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetFocusOnFormArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetMetadataAttributeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetPartialSubmissionRetentionPeriodArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetRedirectToPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetResetConfirmationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetShowNavigationBarArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetShowSummarizedDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormContainerBlockFacetSubmitSuccessMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FormContainerBlockOrderByInput = {
  AllowAnonymousSubmission?: InputMaybe<OrderBy>;
  AllowExposingDataFeeds?: InputMaybe<OrderBy>;
  AllowMultipleSubmission?: InputMaybe<OrderBy>;
  AllowToStoreSubmissionData?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationMessage?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ElementsArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FinalizedSubmissionRetentionPeriod?: InputMaybe<OrderBy>;
  FocusOnForm?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetadataAttribute?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PartialSubmissionRetentionPeriod?: InputMaybe<OrderBy>;
  RedirectToPage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  ResetConfirmationMessage?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowNavigationBar?: InputMaybe<OrderBy>;
  ShowSummarizedData?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubmitSuccessMessage?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FormContainerBlockOutput = {
  __typename?: 'FormContainerBlockOutput';
  autocomplete?: Maybe<FormContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FormContainerBlockFacet>;
  item?: Maybe<FormContainerBlock>;
  items?: Maybe<Array<Maybe<FormContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FormContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormContainerBlockWhereInput = {
  AllowAnonymousSubmission?: InputMaybe<BoolFilterInput>;
  AllowExposingDataFeeds?: InputMaybe<BoolFilterInput>;
  AllowMultipleSubmission?: InputMaybe<BoolFilterInput>;
  AllowToStoreSubmissionData?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationMessage?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ElementsArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FinalizedSubmissionRetentionPeriod?: InputMaybe<SearchableStringFilterInput>;
  FocusOnForm?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetadataAttribute?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PartialSubmissionRetentionPeriod?: InputMaybe<SearchableStringFilterInput>;
  RedirectToPage?: InputMaybe<StringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ResetConfirmationMessage?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowNavigationBar?: InputMaybe<BoolFilterInput>;
  ShowSummarizedData?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubmitSuccessMessage?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FormContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FormContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FormContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type FormStepBlock = IContent & IData & {
  __typename?: 'FormStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AttachedContentLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DependCondition?: Maybe<Scalars['Int']['output']>;
  DependField?: Maybe<ContentModelReference>;
  DependValue?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type FormStepBlockDependValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormStepBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FormStepBlockAutocomplete = {
  __typename?: 'FormStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AttachedContentLink?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DependField?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FormStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteAttachedContentLinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockFacet = {
  __typename?: 'FormStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AttachedContentLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DependCondition?: Maybe<Array<Maybe<NumberFacet>>>;
  DependField?: Maybe<ContentModelReferenceFacet>;
  DependValue?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type FormStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetAttachedContentLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormStepBlockFacetDependConditionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FormStepBlockFacetDependValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FormStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AttachedContentLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DependCondition?: InputMaybe<OrderBy>;
  DependField?: InputMaybe<ContentModelReferenceOrderByInput>;
  DependValue?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FormStepBlockOutput = {
  __typename?: 'FormStepBlockOutput';
  autocomplete?: Maybe<FormStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FormStepBlockFacet>;
  item?: Maybe<FormStepBlock>;
  items?: Maybe<Array<Maybe<FormStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FormStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AttachedContentLink?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DependCondition?: InputMaybe<IntFilterInput>;
  DependField?: InputMaybe<ContentModelReferenceWhereInput>;
  DependValue?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FormStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FormStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FormStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Renders a 4 column table with a View More button */
export type FourColumnTableBlock = IContent & IData & {
  __typename?: 'FourColumnTableBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Footer?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Rows?: Maybe<Array<Maybe<RowContent>>>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  /** When checked, the first row will render as the table's header */
  ShowFirstRowAsHeader?: Maybe<Scalars['Bool']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TextContent?: Maybe<FourColumnTableBlockTextContentBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewMoreLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Renders a 4 column table with a View More button */
export type FourColumnTableBlockFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a 4 column table with a View More button */
export type FourColumnTableBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a 4 column table with a View More button */
export type FourColumnTableBlockViewMoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a 4 column table with a View More button */
export type FourColumnTableBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a 4 column table with a View More button */
export type FourColumnTableBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FourColumnTableBlockAutocomplete = {
  __typename?: 'FourColumnTableBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Rows?: Maybe<RowContentAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FourColumnTableBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FourColumnTableBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FourColumnTableBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FourColumnTableBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FourColumnTableBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FourColumnTableBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FourColumnTableBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FourColumnTableBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FourColumnTableBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FourColumnTableBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FourColumnTableBlockFacet = {
  __typename?: 'FourColumnTableBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Footer?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Rows?: Maybe<RowContentFacet>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowFirstRowAsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TextContent?: Maybe<FourColumnTableBlockTextContentBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type FourColumnTableBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FourColumnTableBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FourColumnTableBlockFacetFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FourColumnTableBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FourColumnTableBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetShowFirstRowAsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FourColumnTableBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FourColumnTableBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacetViewMoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FourColumnTableBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Footer?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Rows?: InputMaybe<RowContentOrderByInput>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowFirstRowAsHeader?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TextContent?: InputMaybe<FourColumnTableBlockTextContentBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  ViewMoreLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FourColumnTableBlockOutput = {
  __typename?: 'FourColumnTableBlockOutput';
  autocomplete?: Maybe<FourColumnTableBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FourColumnTableBlockFacet>;
  item?: Maybe<FourColumnTableBlock>;
  items?: Maybe<Array<Maybe<FourColumnTableBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FourColumnTableBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FourColumnTableBlockTextContentBlock = {
  __typename?: 'FourColumnTableBlockTextContentBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
};


export type FourColumnTableBlockTextContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FourColumnTableBlockTextContentBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FourColumnTableBlockTextContentBlockPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FourColumnTableBlockTextContentBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FourColumnTableBlockTextContentBlockFacet = {
  __typename?: 'FourColumnTableBlockTextContentBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type FourColumnTableBlockTextContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockTextContentBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockTextContentBlockFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FourColumnTableBlockTextContentBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FourColumnTableBlockTextContentBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  PreHeading?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
};

export type FourColumnTableBlockTextContentBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type FourColumnTableBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Footer?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Rows?: InputMaybe<RowContentWhereInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowFirstRowAsHeader?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TextContent?: InputMaybe<FourColumnTableBlockTextContentBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewMoreLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FourColumnTableBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FourColumnTableBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FourColumnTableBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type GaugeBlock = IContent & IData & {
  __typename?: 'GaugeBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Career?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Education?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Financial?: Maybe<Scalars['String']['output']>;
  GaugeAriaLabel?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  Health?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Relationships?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Service?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  Spiritual?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  UpdateScoresLink?: Maybe<GaugeBlockLinkBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type GaugeBlockCareerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockEducationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockFinancialArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockGaugeAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockHealthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockRelationshipsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockServiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockSpiritualArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GaugeBlockAutocomplete = {
  __typename?: 'GaugeBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  UpdateScoresLink?: Maybe<GaugeBlockLinkBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GaugeBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GaugeBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GaugeBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GaugeBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GaugeBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GaugeBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GaugeBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GaugeBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GaugeBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GaugeBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GaugeBlockFacet = {
  __typename?: 'GaugeBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Career?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Education?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Financial?: Maybe<Array<Maybe<StringFacet>>>;
  GaugeAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Health?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Relationships?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Service?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  Spiritual?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  UpdateScoresLink?: Maybe<GaugeBlockLinkBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GaugeBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetCareerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GaugeBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GaugeBlockFacetEducationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetFinancialArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetGaugeAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetHealthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GaugeBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetRelationshipsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GaugeBlockFacetServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetSpiritualArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GaugeBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GaugeBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GaugeBlockLinkBlock = {
  __typename?: 'GaugeBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type GaugeBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GaugeBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GaugeBlockLinkBlockAutocomplete = {
  __typename?: 'GaugeBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GaugeBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GaugeBlockLinkBlockFacet = {
  __typename?: 'GaugeBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GaugeBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GaugeBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GaugeBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GaugeBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type GaugeBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type GaugeBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Career?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Education?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Financial?: InputMaybe<OrderBy>;
  GaugeAriaLabel?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  Health?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Relationships?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Service?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  Spiritual?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  UpdateScoresLink?: InputMaybe<GaugeBlockLinkBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GaugeBlockOutput = {
  __typename?: 'GaugeBlockOutput';
  autocomplete?: Maybe<GaugeBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GaugeBlockFacet>;
  item?: Maybe<GaugeBlock>;
  items?: Maybe<Array<Maybe<GaugeBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GaugeBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GaugeBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Career?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Education?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Financial?: InputMaybe<SearchableStringFilterInput>;
  GaugeAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  Health?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Relationships?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Service?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  Spiritual?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  UpdateScoresLink?: InputMaybe<GaugeBlockLinkBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GaugeBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GaugeBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GaugeBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type GeoDataBlock = IContent & IData & {
  __typename?: 'GeoDataBlock';
  /** Additional Configuration Options for the chart. Will override default values. Use caution when setting this data. */
  AdditionalOptions?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CTALink?: Maybe<GeoDataBlockLinkBlock>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** Name for each column. The first column should be 'Country'. */
  ColumnNames?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** A comma delimited list of values. Values should match the specified columns in order and number. For country, you can use the ISO3166 code or name. You can specify a custom name for a country like: {v: 'US', f: 'United States'} */
  DataRows?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Heading text at the top of the block */
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type GeoDataBlockColumnNamesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GeoDataBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GeoDataBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GeoDataBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GeoDataBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GeoDataBlockAutocomplete = {
  __typename?: 'GeoDataBlockAutocomplete';
  AdditionalOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CTALink?: Maybe<GeoDataBlockLinkBlockAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DataRows?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GeoDataBlockAutocompleteAdditionalOptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GeoDataBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GeoDataBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GeoDataBlockAutocompleteDataRowsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GeoDataBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GeoDataBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GeoDataBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GeoDataBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GeoDataBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GeoDataBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GeoDataBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GeoDataBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GeoDataBlockFacet = {
  __typename?: 'GeoDataBlockFacet';
  AdditionalOptions?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CTALink?: Maybe<GeoDataBlockLinkBlockFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ColumnNames?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DataRows?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GeoDataBlockFacetAdditionalOptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GeoDataBlockFacetColumnNamesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GeoDataBlockFacetDataRowsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GeoDataBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GeoDataBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GeoDataBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GeoDataBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GeoDataBlockLinkBlock = {
  __typename?: 'GeoDataBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type GeoDataBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GeoDataBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GeoDataBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GeoDataBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GeoDataBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GeoDataBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GeoDataBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GeoDataBlockLinkBlockAutocomplete = {
  __typename?: 'GeoDataBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GeoDataBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GeoDataBlockLinkBlockFacet = {
  __typename?: 'GeoDataBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GeoDataBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GeoDataBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GeoDataBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GeoDataBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type GeoDataBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type GeoDataBlockOrderByInput = {
  AdditionalOptions?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  CTALink?: InputMaybe<GeoDataBlockLinkBlockOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ColumnNames?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DataRows?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GeoDataBlockOutput = {
  __typename?: 'GeoDataBlockOutput';
  autocomplete?: Maybe<GeoDataBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GeoDataBlockFacet>;
  item?: Maybe<GeoDataBlock>;
  items?: Maybe<Array<Maybe<GeoDataBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GeoDataBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeoDataBlockWhereInput = {
  AdditionalOptions?: InputMaybe<StringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  CTALink?: InputMaybe<GeoDataBlockLinkBlockWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ColumnNames?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DataRows?: InputMaybe<StringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GeoDataBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GeoDataBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GeoDataBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlock = IContent & IData & {
  __typename?: 'GettingStartedStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** A description for the Disabled Status radio buttons section */
  DisabledDescription?: Maybe<Scalars['String']['output']>;
  /** A heading for the Disabled Status radio buttons section. Note: The 'Required' asterisk does not need to be added here (it will be automatic) */
  DisabledHeading?: Maybe<Scalars['String']['output']>;
  /** The description for the Disabled alert modal */
  DisabledModalDescription?: Maybe<Scalars['String']['output']>;
  /** A description for the Ethical Complaint radio buttons section */
  EthicalComplaintDescription?: Maybe<Scalars['String']['output']>;
  /** A heading for the Ethical Complaint radio buttons section. Note: The 'Required' asterisk does not need to be added here (it will be automatic) */
  EthicalComplaintHeading?: Maybe<Scalars['String']['output']>;
  /** The description for the ethical complaint alert modal */
  EthicalComplaintModalDescription?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** A description for the Getting Started Form */
  FormDescription?: Maybe<Scalars['String']['output']>;
  /** Displayed on the form view */
  FormHeading?: Maybe<Scalars['String']['output']>;
  /** A description for the Industry Associations radio buttons section */
  IndustryAssociationsDescription?: Maybe<Scalars['String']['output']>;
  /** A heading for the Industry Associations radio buttons section. Note: The 'Required' asterisk does not need to be added here (it will be automatic) */
  IndustryAssociationsHeading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** The Cancel button text for the professional association alert modal */
  ModalCancelLabel?: Maybe<Scalars['String']['output']>;
  /** The Continue button text for the professional association alert modal */
  ModalContinueLabel?: Maybe<Scalars['String']['output']>;
  /** The footer for the professional association alert modal */
  ModalFooter?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** The description for the professional association alert modal */
  ProfessionalAssociationModalDescription?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  UnableToProcessError?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockDisabledDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockDisabledHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockDisabledModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockEthicalComplaintDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockEthicalComplaintHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockEthicalComplaintModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockFormDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockFormHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockIndustryAssociationsDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockIndustryAssociationsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockModalCancelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockModalContinueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockModalFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockProfessionalAssociationModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlockUnableToProcessErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GettingStartedStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GettingStartedStepBlockAutocomplete = {
  __typename?: 'GettingStartedStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GettingStartedStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GettingStartedStepBlockFacet = {
  __typename?: 'GettingStartedStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisabledDescription?: Maybe<Array<Maybe<StringFacet>>>;
  DisabledHeading?: Maybe<Array<Maybe<StringFacet>>>;
  DisabledModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormHeading?: Maybe<Array<Maybe<StringFacet>>>;
  IndustryAssociationsDescription?: Maybe<Array<Maybe<StringFacet>>>;
  IndustryAssociationsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  ModalCancelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ModalContinueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ModalFooter?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ProfessionalAssociationModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  UnableToProcessError?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GettingStartedStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GettingStartedStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GettingStartedStepBlockFacetDisabledDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetDisabledHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetDisabledModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetEthicalComplaintDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetEthicalComplaintHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetEthicalComplaintModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetFormDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetFormHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetIndustryAssociationsDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetIndustryAssociationsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetModalCancelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetModalContinueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetModalFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetProfessionalAssociationModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GettingStartedStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GettingStartedStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GettingStartedStepBlockFacetUnableToProcessErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GettingStartedStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisabledDescription?: InputMaybe<OrderBy>;
  DisabledHeading?: InputMaybe<OrderBy>;
  DisabledModalDescription?: InputMaybe<OrderBy>;
  EthicalComplaintDescription?: InputMaybe<OrderBy>;
  EthicalComplaintHeading?: InputMaybe<OrderBy>;
  EthicalComplaintModalDescription?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormDescription?: InputMaybe<OrderBy>;
  FormHeading?: InputMaybe<OrderBy>;
  IndustryAssociationsDescription?: InputMaybe<OrderBy>;
  IndustryAssociationsHeading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  ModalCancelLabel?: InputMaybe<OrderBy>;
  ModalContinueLabel?: InputMaybe<OrderBy>;
  ModalFooter?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ProfessionalAssociationModalDescription?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  UnableToProcessError?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GettingStartedStepBlockOutput = {
  __typename?: 'GettingStartedStepBlockOutput';
  autocomplete?: Maybe<GettingStartedStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GettingStartedStepBlockFacet>;
  item?: Maybe<GettingStartedStepBlock>;
  items?: Maybe<Array<Maybe<GettingStartedStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GettingStartedStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GettingStartedStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisabledDescription?: InputMaybe<SearchableStringFilterInput>;
  DisabledHeading?: InputMaybe<SearchableStringFilterInput>;
  DisabledModalDescription?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintDescription?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintHeading?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintModalDescription?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormDescription?: InputMaybe<SearchableStringFilterInput>;
  FormHeading?: InputMaybe<SearchableStringFilterInput>;
  IndustryAssociationsDescription?: InputMaybe<SearchableStringFilterInput>;
  IndustryAssociationsHeading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  ModalCancelLabel?: InputMaybe<SearchableStringFilterInput>;
  ModalContinueLabel?: InputMaybe<SearchableStringFilterInput>;
  ModalFooter?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ProfessionalAssociationModalDescription?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  UnableToProcessError?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GettingStartedStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GettingStartedStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GettingStartedStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2Block = IContent & IData & {
  __typename?: 'GettingStartedStepV2Block';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  /** The modals information that is shown if Yes is selected on the disability question */
  DisabilityQuestionModal?: Maybe<GettingStartedStepV2BlockModalInfoBlock>;
  /** A description for the Disabled Status radio buttons section */
  DisabledDescription?: Maybe<Scalars['String']['output']>;
  /** A heading for the Disabled Status radio buttons section. Note: The 'Required' asterisk does not need to be added here (it will be automatic) */
  DisabledHeading?: Maybe<Scalars['String']['output']>;
  /** A description for the Ethical Complaint radio buttons section */
  EthicalComplaintDescription?: Maybe<Scalars['String']['output']>;
  /** A heading for the Ethical Complaint radio buttons section. Note: The 'Required' asterisk does not need to be added here (it will be automatic) */
  EthicalComplaintHeading?: Maybe<Scalars['String']['output']>;
  /** The modals information that is shown if Yes is selected on the ethical question */
  EthicalComplaintQuestionModal?: Maybe<GettingStartedStepV2BlockModalInfoBlock>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** The information that is shown if after the modal question is answered Yes */
  FlowFinishInformation?: Maybe<GettingStartedStepV2BlockFlowFinishInformationBlock>;
  /** A description for the Getting Started Form */
  FormDescription?: Maybe<Scalars['String']['output']>;
  /** Displayed on the form view */
  FormHeading?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** An error text that is shown when a question is not answered */
  QuestionNotAnsweredError?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  UnableToProcessError?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockDisabledDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockDisabledHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockEthicalComplaintDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockEthicalComplaintHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockFormDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockFormHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockQuestionNotAnsweredErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2BlockUnableToProcessErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GettingStartedStepV2Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GettingStartedStepV2BlockAutocomplete = {
  __typename?: 'GettingStartedStepV2BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GettingStartedStepV2BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepV2BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepV2BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepV2BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepV2BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepV2BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepV2BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepV2BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepV2BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GettingStartedStepV2BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GettingStartedStepV2BlockFacet = {
  __typename?: 'GettingStartedStepV2BlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisabilityQuestionModal?: Maybe<GettingStartedStepV2BlockModalInfoBlockFacet>;
  DisabledDescription?: Maybe<Array<Maybe<StringFacet>>>;
  DisabledHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintQuestionModal?: Maybe<GettingStartedStepV2BlockModalInfoBlockFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FlowFinishInformation?: Maybe<GettingStartedStepV2BlockFlowFinishInformationBlockFacet>;
  FormDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  QuestionNotAnsweredError?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  UnableToProcessError?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GettingStartedStepV2BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GettingStartedStepV2BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GettingStartedStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetDisabledDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetDisabledHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetEthicalComplaintDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetEthicalComplaintHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetFormDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetFormHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetQuestionNotAnsweredErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GettingStartedStepV2BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GettingStartedStepV2BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GettingStartedStepV2BlockFacetUnableToProcessErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GettingStartedStepV2BlockFlowFinishInformationBlock = {
  __typename?: 'GettingStartedStepV2BlockFlowFinishInformationBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type GettingStartedStepV2BlockFlowFinishInformationBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GettingStartedStepV2BlockFlowFinishInformationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GettingStartedStepV2BlockFlowFinishInformationBlockFacet = {
  __typename?: 'GettingStartedStepV2BlockFlowFinishInformationBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GettingStartedStepV2BlockFlowFinishInformationBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockFlowFinishInformationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GettingStartedStepV2BlockFlowFinishInformationBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type GettingStartedStepV2BlockFlowFinishInformationBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type GettingStartedStepV2BlockModalInfoBlock = {
  __typename?: 'GettingStartedStepV2BlockModalInfoBlock';
  CancelButtonText?: Maybe<Scalars['String']['output']>;
  ConfirmButtonText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  FooterText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type GettingStartedStepV2BlockModalInfoBlockCancelButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GettingStartedStepV2BlockModalInfoBlockConfirmButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GettingStartedStepV2BlockModalInfoBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GettingStartedStepV2BlockModalInfoBlockFooterTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GettingStartedStepV2BlockModalInfoBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GettingStartedStepV2BlockModalInfoBlockFacet = {
  __typename?: 'GettingStartedStepV2BlockModalInfoBlockFacet';
  CancelButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ConfirmButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  FooterText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GettingStartedStepV2BlockModalInfoBlockFacetCancelButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockModalInfoBlockFacetConfirmButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockModalInfoBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockModalInfoBlockFacetFooterTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GettingStartedStepV2BlockModalInfoBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GettingStartedStepV2BlockModalInfoBlockOrderByInput = {
  CancelButtonText?: InputMaybe<OrderBy>;
  ConfirmButtonText?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  FooterText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type GettingStartedStepV2BlockModalInfoBlockWhereInput = {
  CancelButtonText?: InputMaybe<SearchableStringFilterInput>;
  ConfirmButtonText?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  FooterText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type GettingStartedStepV2BlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisabilityQuestionModal?: InputMaybe<GettingStartedStepV2BlockModalInfoBlockOrderByInput>;
  DisabledDescription?: InputMaybe<OrderBy>;
  DisabledHeading?: InputMaybe<OrderBy>;
  EthicalComplaintDescription?: InputMaybe<OrderBy>;
  EthicalComplaintHeading?: InputMaybe<OrderBy>;
  EthicalComplaintQuestionModal?: InputMaybe<GettingStartedStepV2BlockModalInfoBlockOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FlowFinishInformation?: InputMaybe<GettingStartedStepV2BlockFlowFinishInformationBlockOrderByInput>;
  FormDescription?: InputMaybe<OrderBy>;
  FormHeading?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  QuestionNotAnsweredError?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  UnableToProcessError?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GettingStartedStepV2BlockOutput = {
  __typename?: 'GettingStartedStepV2BlockOutput';
  autocomplete?: Maybe<GettingStartedStepV2BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GettingStartedStepV2BlockFacet>;
  item?: Maybe<GettingStartedStepV2Block>;
  items?: Maybe<Array<Maybe<GettingStartedStepV2Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GettingStartedStepV2BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GettingStartedStepV2BlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisabilityQuestionModal?: InputMaybe<GettingStartedStepV2BlockModalInfoBlockWhereInput>;
  DisabledDescription?: InputMaybe<SearchableStringFilterInput>;
  DisabledHeading?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintDescription?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintHeading?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintQuestionModal?: InputMaybe<GettingStartedStepV2BlockModalInfoBlockWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FlowFinishInformation?: InputMaybe<GettingStartedStepV2BlockFlowFinishInformationBlockWhereInput>;
  FormDescription?: InputMaybe<SearchableStringFilterInput>;
  FormHeading?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  QuestionNotAnsweredError?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  UnableToProcessError?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GettingStartedStepV2BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GettingStartedStepV2BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GettingStartedStepV2BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type GreetingCaseBlock = IContent & IData & {
  __typename?: 'GreetingCaseBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  CertifyingLetters?: Maybe<Scalars['String']['output']>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Payment?: Maybe<Scalars['String']['output']>;
  Production?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type GreetingCaseBlockCertifyingLettersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingCaseBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingCaseBlockPaymentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingCaseBlockProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingCaseBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingCaseBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GreetingCaseBlockAutocomplete = {
  __typename?: 'GreetingCaseBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GreetingCaseBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingCaseBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingCaseBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingCaseBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingCaseBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingCaseBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingCaseBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingCaseBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingCaseBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingCaseBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GreetingCaseBlockFacet = {
  __typename?: 'GreetingCaseBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  CertifyingLetters?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Payment?: Maybe<Array<Maybe<StringFacet>>>;
  Production?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GreetingCaseBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetCertifyingLettersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingCaseBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingCaseBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetPaymentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingCaseBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingCaseBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingCaseBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingCaseBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GreetingCaseBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  CertifyingLetters?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Payment?: InputMaybe<OrderBy>;
  Production?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GreetingCaseBlockOutput = {
  __typename?: 'GreetingCaseBlockOutput';
  autocomplete?: Maybe<GreetingCaseBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GreetingCaseBlockFacet>;
  item?: Maybe<GreetingCaseBlock>;
  items?: Maybe<Array<Maybe<GreetingCaseBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GreetingCaseBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GreetingCaseBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  CertifyingLetters?: InputMaybe<SearchableStringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Payment?: InputMaybe<SearchableStringFilterInput>;
  Production?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GreetingCaseBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GreetingCaseBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GreetingCaseBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type GreetingStepBlock = IContent & IData & {
  __typename?: 'GreetingStepBlock';
  AfternoonHeading?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicationSubmittedByCompanyAdminHeading?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyPaymentNoProduction?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  CompanyPaymentProductionNotRequired?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  CompanyProductionAndPayment?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  CompanyProductionNoPayment?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Use {{membershipYear}} to replace with the users number of years as a member */
  Description?: Maybe<Scalars['String']['output']>;
  EveningHeading?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstTimeMemberHeadingText?: Maybe<Scalars['String']['output']>;
  FirstTimeMemberHeadingTextFirstTimeMemberHeadingText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HelpContactInfo?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  NoPaymentNoProduction?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  NoPaymentProductionNotRequired?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  PageExplanation?: Maybe<Scalars['String']['output']>;
  PaperApplicationAlreadyStartedHeading?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  ProvidingCertifyingLetters?: Maybe<Scalars['String']['output']>;
  ProvidingPayment?: Maybe<Scalars['String']['output']>;
  ProvidingProductionNumbers?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubDescription?: Maybe<Scalars['String']['output']>;
  TenYearCompanyPaymentProductionNotRequired?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  TenYearCompanyProductionAndPayment?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  TenYearCompanyProductionNoPayment?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  TenYearNoPaymentProductionNotRequired?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  TenYearNoProductionCompanyPayment?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  TenYearNoProductionNoPayment?: Maybe<GreetingStepBlockGreetingCaseBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type GreetingStepBlockAfternoonHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockApplicationSubmittedByCompanyAdminHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockEveningHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockFirstTimeMemberHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockFirstTimeMemberHeadingTextFirstTimeMemberHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockHelpContactInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockPageExplanationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockPaperApplicationAlreadyStartedHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockProvidingCertifyingLettersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockProvidingPaymentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockProvidingProductionNumbersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockSubDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GreetingStepBlockAutocomplete = {
  __typename?: 'GreetingStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GreetingStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GreetingStepBlockFacet = {
  __typename?: 'GreetingStepBlockFacet';
  AfternoonHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationSubmittedByCompanyAdminHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyPaymentNoProduction?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  CompanyPaymentProductionNotRequired?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  CompanyProductionAndPayment?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  CompanyProductionNoPayment?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EveningHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstTimeMemberHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  FirstTimeMemberHeadingTextFirstTimeMemberHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HelpContactInfo?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NoPaymentNoProduction?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  NoPaymentProductionNotRequired?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  PageExplanation?: Maybe<Array<Maybe<StringFacet>>>;
  PaperApplicationAlreadyStartedHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ProvidingCertifyingLetters?: Maybe<Array<Maybe<StringFacet>>>;
  ProvidingPayment?: Maybe<Array<Maybe<StringFacet>>>;
  ProvidingProductionNumbers?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubDescription?: Maybe<Array<Maybe<StringFacet>>>;
  TenYearCompanyPaymentProductionNotRequired?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  TenYearCompanyProductionAndPayment?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  TenYearCompanyProductionNoPayment?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  TenYearNoPaymentProductionNotRequired?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  TenYearNoProductionCompanyPayment?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  TenYearNoProductionNoPayment?: Maybe<GreetingStepBlockGreetingCaseBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GreetingStepBlockFacetAfternoonHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetApplicationSubmittedByCompanyAdminHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetEveningHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetFirstTimeMemberHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetFirstTimeMemberHeadingTextFirstTimeMemberHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetHelpContactInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetPageExplanationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetPaperApplicationAlreadyStartedHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetProvidingCertifyingLettersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetProvidingPaymentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetProvidingProductionNumbersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingStepBlockFacetSubDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GreetingStepBlockGreetingCaseBlock = {
  __typename?: 'GreetingStepBlockGreetingCaseBlock';
  CertifyingLetters?: Maybe<Scalars['String']['output']>;
  Payment?: Maybe<Scalars['String']['output']>;
  Production?: Maybe<Scalars['String']['output']>;
};


export type GreetingStepBlockGreetingCaseBlockCertifyingLettersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockGreetingCaseBlockPaymentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepBlockGreetingCaseBlockProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GreetingStepBlockGreetingCaseBlockFacet = {
  __typename?: 'GreetingStepBlockGreetingCaseBlockFacet';
  CertifyingLetters?: Maybe<Array<Maybe<StringFacet>>>;
  Payment?: Maybe<Array<Maybe<StringFacet>>>;
  Production?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GreetingStepBlockGreetingCaseBlockFacetCertifyingLettersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockGreetingCaseBlockFacetPaymentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepBlockGreetingCaseBlockFacetProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GreetingStepBlockGreetingCaseBlockOrderByInput = {
  CertifyingLetters?: InputMaybe<OrderBy>;
  Payment?: InputMaybe<OrderBy>;
  Production?: InputMaybe<OrderBy>;
};

export type GreetingStepBlockGreetingCaseBlockWhereInput = {
  CertifyingLetters?: InputMaybe<SearchableStringFilterInput>;
  Payment?: InputMaybe<SearchableStringFilterInput>;
  Production?: InputMaybe<SearchableStringFilterInput>;
};

export type GreetingStepBlockOrderByInput = {
  AfternoonHeading?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationSubmittedByCompanyAdminHeading?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyPaymentNoProduction?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  CompanyPaymentProductionNotRequired?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  CompanyProductionAndPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  CompanyProductionNoPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EveningHeading?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstTimeMemberHeadingText?: InputMaybe<OrderBy>;
  FirstTimeMemberHeadingTextFirstTimeMemberHeadingText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HelpContactInfo?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  NoPaymentNoProduction?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  NoPaymentProductionNotRequired?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  PageExplanation?: InputMaybe<OrderBy>;
  PaperApplicationAlreadyStartedHeading?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ProvidingCertifyingLetters?: InputMaybe<OrderBy>;
  ProvidingPayment?: InputMaybe<OrderBy>;
  ProvidingProductionNumbers?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubDescription?: InputMaybe<OrderBy>;
  TenYearCompanyPaymentProductionNotRequired?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  TenYearCompanyProductionAndPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  TenYearCompanyProductionNoPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  TenYearNoPaymentProductionNotRequired?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  TenYearNoProductionCompanyPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  TenYearNoProductionNoPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GreetingStepBlockOutput = {
  __typename?: 'GreetingStepBlockOutput';
  autocomplete?: Maybe<GreetingStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GreetingStepBlockFacet>;
  item?: Maybe<GreetingStepBlock>;
  items?: Maybe<Array<Maybe<GreetingStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GreetingStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GreetingStepBlockWhereInput = {
  AfternoonHeading?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationSubmittedByCompanyAdminHeading?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyPaymentNoProduction?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  CompanyPaymentProductionNotRequired?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  CompanyProductionAndPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  CompanyProductionNoPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EveningHeading?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstTimeMemberHeadingText?: InputMaybe<SearchableStringFilterInput>;
  FirstTimeMemberHeadingTextFirstTimeMemberHeadingText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HelpContactInfo?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NoPaymentNoProduction?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  NoPaymentProductionNotRequired?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  PageExplanation?: InputMaybe<SearchableStringFilterInput>;
  PaperApplicationAlreadyStartedHeading?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ProvidingCertifyingLetters?: InputMaybe<SearchableStringFilterInput>;
  ProvidingPayment?: InputMaybe<SearchableStringFilterInput>;
  ProvidingProductionNumbers?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubDescription?: InputMaybe<SearchableStringFilterInput>;
  TenYearCompanyPaymentProductionNotRequired?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  TenYearCompanyProductionAndPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  TenYearCompanyProductionNoPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  TenYearNoPaymentProductionNotRequired?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  TenYearNoProductionCompanyPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  TenYearNoProductionNoPayment?: InputMaybe<GreetingStepBlockGreetingCaseBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GreetingStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GreetingStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GreetingStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2Block = IContent & IData & {
  __typename?: 'GreetingStepV2Block';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstIconNoProductionProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlock>;
  FirstIconProductionProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlock>;
  Footnote?: Maybe<Scalars['String']['output']>;
  GoBackToHomepageButtonText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeeInfoBox?: Maybe<GreetingStepV2BlockInfoBoxBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  NotReadyToJoinMessageText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SecondIconNoProductionProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlock>;
  SecondIconProductionProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlock>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  ThirdIconNoPaymentProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlock>;
  ThirdIconPaymentProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2BlockFootnoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2BlockGoBackToHomepageButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2BlockNotReadyToJoinMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type GreetingStepV2Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GreetingStepV2BlockAutocomplete = {
  __typename?: 'GreetingStepV2BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GreetingStepV2BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepV2BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepV2BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepV2BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepV2BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepV2BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepV2BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepV2BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepV2BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GreetingStepV2BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GreetingStepV2BlockFacet = {
  __typename?: 'GreetingStepV2BlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstIconNoProductionProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlockFacet>;
  FirstIconProductionProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlockFacet>;
  Footnote?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackToHomepageButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeeInfoBox?: Maybe<GreetingStepV2BlockInfoBoxBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NotReadyToJoinMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SecondIconNoProductionProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlockFacet>;
  SecondIconProductionProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlockFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThirdIconNoPaymentProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlockFacet>;
  ThirdIconPaymentProvidedTexts?: Maybe<GreetingStepV2BlockIconRequirementBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GreetingStepV2BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingStepV2BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetFootnoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetGoBackToHomepageButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetNotReadyToJoinMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingStepV2BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingStepV2BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GreetingStepV2BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GreetingStepV2BlockIconRequirementBlock = {
  __typename?: 'GreetingStepV2BlockIconRequirementBlock';
  FirstLine?: Maybe<Scalars['String']['output']>;
  SecondLine?: Maybe<Scalars['String']['output']>;
};


export type GreetingStepV2BlockIconRequirementBlockFirstLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepV2BlockIconRequirementBlockSecondLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GreetingStepV2BlockIconRequirementBlockFacet = {
  __typename?: 'GreetingStepV2BlockIconRequirementBlockFacet';
  FirstLine?: Maybe<Array<Maybe<StringFacet>>>;
  SecondLine?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GreetingStepV2BlockIconRequirementBlockFacetFirstLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockIconRequirementBlockFacetSecondLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GreetingStepV2BlockIconRequirementBlockOrderByInput = {
  FirstLine?: InputMaybe<OrderBy>;
  SecondLine?: InputMaybe<OrderBy>;
};

export type GreetingStepV2BlockIconRequirementBlockWhereInput = {
  FirstLine?: InputMaybe<SearchableStringFilterInput>;
  SecondLine?: InputMaybe<SearchableStringFilterInput>;
};

export type GreetingStepV2BlockInfoBoxBlock = {
  __typename?: 'GreetingStepV2BlockInfoBoxBlock';
  Heading?: Maybe<Scalars['String']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
};


export type GreetingStepV2BlockInfoBoxBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GreetingStepV2BlockInfoBoxBlockTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GreetingStepV2BlockInfoBoxBlockFacet = {
  __typename?: 'GreetingStepV2BlockInfoBoxBlockFacet';
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GreetingStepV2BlockInfoBoxBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GreetingStepV2BlockInfoBoxBlockFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GreetingStepV2BlockInfoBoxBlockOrderByInput = {
  Heading?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
};

export type GreetingStepV2BlockInfoBoxBlockWhereInput = {
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
};

export type GreetingStepV2BlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstIconNoProductionProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockOrderByInput>;
  FirstIconProductionProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockOrderByInput>;
  Footnote?: InputMaybe<OrderBy>;
  GoBackToHomepageButtonText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeeInfoBox?: InputMaybe<GreetingStepV2BlockInfoBoxBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  NotReadyToJoinMessageText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SecondIconNoProductionProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockOrderByInput>;
  SecondIconProductionProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThirdIconNoPaymentProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockOrderByInput>;
  ThirdIconPaymentProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GreetingStepV2BlockOutput = {
  __typename?: 'GreetingStepV2BlockOutput';
  autocomplete?: Maybe<GreetingStepV2BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GreetingStepV2BlockFacet>;
  item?: Maybe<GreetingStepV2Block>;
  items?: Maybe<Array<Maybe<GreetingStepV2Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GreetingStepV2BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GreetingStepV2BlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstIconNoProductionProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockWhereInput>;
  FirstIconProductionProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockWhereInput>;
  Footnote?: InputMaybe<SearchableStringFilterInput>;
  GoBackToHomepageButtonText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeeInfoBox?: InputMaybe<GreetingStepV2BlockInfoBoxBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NotReadyToJoinMessageText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SecondIconNoProductionProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockWhereInput>;
  SecondIconProductionProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThirdIconNoPaymentProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockWhereInput>;
  ThirdIconPaymentProvidedTexts?: InputMaybe<GreetingStepV2BlockIconRequirementBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GreetingStepV2BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GreetingStepV2BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GreetingStepV2BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlock = IContent & IData & {
  __typename?: 'GsAwardsApplicationsBlock';
  AgencyIdLabel?: Maybe<Scalars['String']['output']>;
  AgentIdLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicationPageTitle?: Maybe<Scalars['String']['output']>;
  ApplicationStatus?: Maybe<Scalars['String']['output']>;
  ApproveBtn?: Maybe<Scalars['String']['output']>;
  ApproveCriteriaTooltip?: Maybe<Scalars['String']['output']>;
  Approved?: Maybe<Scalars['String']['output']>;
  BackToSelectApplicantButton?: Maybe<Scalars['String']['output']>;
  BackToSubmissionsButton?: Maybe<Scalars['String']['output']>;
  CancelBtnText?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ColActions?: Maybe<Scalars['String']['output']>;
  ColApplicationStep?: Maybe<Scalars['String']['output']>;
  ColAwardTier?: Maybe<Scalars['String']['output']>;
  ColCompany?: Maybe<Scalars['String']['output']>;
  ColDateStarted?: Maybe<Scalars['String']['output']>;
  ColDateSubmitted?: Maybe<Scalars['String']['output']>;
  ColEmail?: Maybe<Scalars['String']['output']>;
  ColMdrtID?: Maybe<Scalars['String']['output']>;
  ColName?: Maybe<Scalars['String']['output']>;
  ColStatus?: Maybe<Scalars['String']['output']>;
  ColYear?: Maybe<Scalars['String']['output']>;
  CompanyLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CountryLabel?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  CriteriaApprovalText?: Maybe<Scalars['String']['output']>;
  DeleteApprovedRejectedNotice?: Maybe<Scalars['String']['output']>;
  DeleteBtnText?: Maybe<Scalars['String']['output']>;
  DeleteErrorText?: Maybe<Scalars['String']['output']>;
  DeleteModalText?: Maybe<Scalars['String']['output']>;
  EmailLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExportToExcelBtnLabel?: Maybe<Scalars['String']['output']>;
  ExportToExcelDropdownBtnLabel?: Maybe<Scalars['String']['output']>;
  ExportToExcelErrorLabel?: Maybe<Scalars['String']['output']>;
  FileNotProvidedLabel?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  IssueAwardsBadgesBtnLabel?: Maybe<Scalars['String']['output']>;
  IssueAwardsBadgesErrorLabel?: Maybe<Scalars['String']['output']>;
  IssueAwardsBadgesSuccessLabel?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  MembershipSectionTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersistencySectionTitle?: Maybe<Scalars['String']['output']>;
  ProductionSectionTitle?: Maybe<Scalars['String']['output']>;
  RecruitmentSectionTitle?: Maybe<Scalars['String']['output']>;
  ReissueCredlyBadgeButton?: Maybe<Scalars['String']['output']>;
  ReissueCredlyBadgeNotice?: Maybe<Scalars['String']['output']>;
  RejectBtn?: Maybe<Scalars['String']['output']>;
  RejectCriteriaTooltip?: Maybe<Scalars['String']['output']>;
  Rejected?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RetentionSectionTitle?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  RowActionBtnText?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  UnableToDownloadFileError?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VerificationSectionTitle?: Maybe<Scalars['String']['output']>;
  WholePersonSectionTitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockAgencyIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockApplicationPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockApplicationStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockApproveBtnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockApproveCriteriaTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockApprovedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockBackToSelectApplicantButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockBackToSubmissionsButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockCancelBtnTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockColActionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockColApplicationStepArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockColAwardTierArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockColCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockColDateStartedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockColDateSubmittedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockColEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockColMdrtIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockColNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockColStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockColYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockCompanyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockCriteriaApprovalTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockDeleteApprovedRejectedNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockDeleteBtnTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockDeleteErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockDeleteModalTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockEmailLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockExportToExcelBtnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockExportToExcelDropdownBtnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockExportToExcelErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockFileNotProvidedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockIssueAwardsBadgesBtnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockIssueAwardsBadgesErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockIssueAwardsBadgesSuccessLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockMembershipSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockPersistencySectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockProductionSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockRecruitmentSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockReissueCredlyBadgeButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockReissueCredlyBadgeNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockRejectBtnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockRejectCriteriaTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockRejectedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockRetentionSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockRowActionBtnTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockUnableToDownloadFileErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockVerificationSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlockWholePersonSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsApplicationsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsApplicationsBlockAutocomplete = {
  __typename?: 'GsAwardsApplicationsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsApplicationsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsApplicationsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsApplicationsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsApplicationsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsApplicationsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsApplicationsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsApplicationsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsApplicationsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsApplicationsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsApplicationsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsApplicationsBlockFacet = {
  __typename?: 'GsAwardsApplicationsBlockFacet';
  AgencyIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationPageTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationStatus?: Maybe<Array<Maybe<StringFacet>>>;
  ApproveBtn?: Maybe<Array<Maybe<StringFacet>>>;
  ApproveCriteriaTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  Approved?: Maybe<Array<Maybe<StringFacet>>>;
  BackToSelectApplicantButton?: Maybe<Array<Maybe<StringFacet>>>;
  BackToSubmissionsButton?: Maybe<Array<Maybe<StringFacet>>>;
  CancelBtnText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ColActions?: Maybe<Array<Maybe<StringFacet>>>;
  ColApplicationStep?: Maybe<Array<Maybe<StringFacet>>>;
  ColAwardTier?: Maybe<Array<Maybe<StringFacet>>>;
  ColCompany?: Maybe<Array<Maybe<StringFacet>>>;
  ColDateStarted?: Maybe<Array<Maybe<StringFacet>>>;
  ColDateSubmitted?: Maybe<Array<Maybe<StringFacet>>>;
  ColEmail?: Maybe<Array<Maybe<StringFacet>>>;
  ColMdrtID?: Maybe<Array<Maybe<StringFacet>>>;
  ColName?: Maybe<Array<Maybe<StringFacet>>>;
  ColStatus?: Maybe<Array<Maybe<StringFacet>>>;
  ColYear?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CriteriaApprovalText?: Maybe<Array<Maybe<StringFacet>>>;
  DeleteApprovedRejectedNotice?: Maybe<Array<Maybe<StringFacet>>>;
  DeleteBtnText?: Maybe<Array<Maybe<StringFacet>>>;
  DeleteErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  DeleteModalText?: Maybe<Array<Maybe<StringFacet>>>;
  EmailLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExportToExcelBtnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExportToExcelDropdownBtnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExportToExcelErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FileNotProvidedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IssueAwardsBadgesBtnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IssueAwardsBadgesErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IssueAwardsBadgesSuccessLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersistencySectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RecruitmentSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ReissueCredlyBadgeButton?: Maybe<Array<Maybe<StringFacet>>>;
  ReissueCredlyBadgeNotice?: Maybe<Array<Maybe<StringFacet>>>;
  RejectBtn?: Maybe<Array<Maybe<StringFacet>>>;
  RejectCriteriaTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  Rejected?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RetentionSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  RowActionBtnText?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  UnableToDownloadFileError?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VerificationSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  WholePersonSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsApplicationsBlockFacetAgencyIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetApplicationPageTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetApplicationStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetApproveBtnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetApproveCriteriaTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetApprovedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetBackToSelectApplicantButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetBackToSubmissionsButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetCancelBtnTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsApplicationsBlockFacetColActionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetColApplicationStepArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetColAwardTierArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetColCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetColDateStartedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetColDateSubmittedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetColEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetColMdrtIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetColNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetColStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetColYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetCompanyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsApplicationsBlockFacetCriteriaApprovalTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetDeleteApprovedRejectedNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetDeleteBtnTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetDeleteErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetDeleteModalTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetEmailLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetExportToExcelBtnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetExportToExcelDropdownBtnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetExportToExcelErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetFileNotProvidedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetIssueAwardsBadgesBtnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetIssueAwardsBadgesErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetIssueAwardsBadgesSuccessLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetMembershipSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetPersistencySectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetProductionSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetRecruitmentSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetReissueCredlyBadgeButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetReissueCredlyBadgeNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetRejectBtnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetRejectCriteriaTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetRejectedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetRetentionSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetRowActionBtnTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsApplicationsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsApplicationsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsApplicationsBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetUnableToDownloadFileErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetVerificationSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacetWholePersonSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsApplicationsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsApplicationsBlockOrderByInput = {
  AgencyIdLabel?: InputMaybe<OrderBy>;
  AgentIdLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationPageTitle?: InputMaybe<OrderBy>;
  ApplicationStatus?: InputMaybe<OrderBy>;
  ApproveBtn?: InputMaybe<OrderBy>;
  ApproveCriteriaTooltip?: InputMaybe<OrderBy>;
  Approved?: InputMaybe<OrderBy>;
  BackToSelectApplicantButton?: InputMaybe<OrderBy>;
  BackToSubmissionsButton?: InputMaybe<OrderBy>;
  CancelBtnText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ColActions?: InputMaybe<OrderBy>;
  ColApplicationStep?: InputMaybe<OrderBy>;
  ColAwardTier?: InputMaybe<OrderBy>;
  ColCompany?: InputMaybe<OrderBy>;
  ColDateStarted?: InputMaybe<OrderBy>;
  ColDateSubmitted?: InputMaybe<OrderBy>;
  ColEmail?: InputMaybe<OrderBy>;
  ColMdrtID?: InputMaybe<OrderBy>;
  ColName?: InputMaybe<OrderBy>;
  ColStatus?: InputMaybe<OrderBy>;
  ColYear?: InputMaybe<OrderBy>;
  CompanyLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CountryLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CriteriaApprovalText?: InputMaybe<OrderBy>;
  DeleteApprovedRejectedNotice?: InputMaybe<OrderBy>;
  DeleteBtnText?: InputMaybe<OrderBy>;
  DeleteErrorText?: InputMaybe<OrderBy>;
  DeleteModalText?: InputMaybe<OrderBy>;
  EmailLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExportToExcelBtnLabel?: InputMaybe<OrderBy>;
  ExportToExcelDropdownBtnLabel?: InputMaybe<OrderBy>;
  ExportToExcelErrorLabel?: InputMaybe<OrderBy>;
  FileNotProvidedLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IssueAwardsBadgesBtnLabel?: InputMaybe<OrderBy>;
  IssueAwardsBadgesErrorLabel?: InputMaybe<OrderBy>;
  IssueAwardsBadgesSuccessLabel?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  MembershipSectionTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersistencySectionTitle?: InputMaybe<OrderBy>;
  ProductionSectionTitle?: InputMaybe<OrderBy>;
  RecruitmentSectionTitle?: InputMaybe<OrderBy>;
  ReissueCredlyBadgeButton?: InputMaybe<OrderBy>;
  ReissueCredlyBadgeNotice?: InputMaybe<OrderBy>;
  RejectBtn?: InputMaybe<OrderBy>;
  RejectCriteriaTooltip?: InputMaybe<OrderBy>;
  Rejected?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RetentionSectionTitle?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  RowActionBtnText?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  UnableToDownloadFileError?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VerificationSectionTitle?: InputMaybe<OrderBy>;
  WholePersonSectionTitle?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsApplicationsBlockOutput = {
  __typename?: 'GsAwardsApplicationsBlockOutput';
  autocomplete?: Maybe<GsAwardsApplicationsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsApplicationsBlockFacet>;
  item?: Maybe<GsAwardsApplicationsBlock>;
  items?: Maybe<Array<Maybe<GsAwardsApplicationsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsApplicationsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsApplicationsBlockWhereInput = {
  AgencyIdLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentIdLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationPageTitle?: InputMaybe<SearchableStringFilterInput>;
  ApplicationStatus?: InputMaybe<SearchableStringFilterInput>;
  ApproveBtn?: InputMaybe<SearchableStringFilterInput>;
  ApproveCriteriaTooltip?: InputMaybe<SearchableStringFilterInput>;
  Approved?: InputMaybe<SearchableStringFilterInput>;
  BackToSelectApplicantButton?: InputMaybe<SearchableStringFilterInput>;
  BackToSubmissionsButton?: InputMaybe<SearchableStringFilterInput>;
  CancelBtnText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ColActions?: InputMaybe<SearchableStringFilterInput>;
  ColApplicationStep?: InputMaybe<SearchableStringFilterInput>;
  ColAwardTier?: InputMaybe<SearchableStringFilterInput>;
  ColCompany?: InputMaybe<SearchableStringFilterInput>;
  ColDateStarted?: InputMaybe<SearchableStringFilterInput>;
  ColDateSubmitted?: InputMaybe<SearchableStringFilterInput>;
  ColEmail?: InputMaybe<SearchableStringFilterInput>;
  ColMdrtID?: InputMaybe<SearchableStringFilterInput>;
  ColName?: InputMaybe<SearchableStringFilterInput>;
  ColStatus?: InputMaybe<SearchableStringFilterInput>;
  ColYear?: InputMaybe<SearchableStringFilterInput>;
  CompanyLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CountryLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CriteriaApprovalText?: InputMaybe<SearchableStringFilterInput>;
  DeleteApprovedRejectedNotice?: InputMaybe<SearchableStringFilterInput>;
  DeleteBtnText?: InputMaybe<SearchableStringFilterInput>;
  DeleteErrorText?: InputMaybe<SearchableStringFilterInput>;
  DeleteModalText?: InputMaybe<SearchableStringFilterInput>;
  EmailLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExportToExcelBtnLabel?: InputMaybe<SearchableStringFilterInput>;
  ExportToExcelDropdownBtnLabel?: InputMaybe<SearchableStringFilterInput>;
  ExportToExcelErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  FileNotProvidedLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IssueAwardsBadgesBtnLabel?: InputMaybe<SearchableStringFilterInput>;
  IssueAwardsBadgesErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  IssueAwardsBadgesSuccessLabel?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersistencySectionTitle?: InputMaybe<SearchableStringFilterInput>;
  ProductionSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  RecruitmentSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  ReissueCredlyBadgeButton?: InputMaybe<SearchableStringFilterInput>;
  ReissueCredlyBadgeNotice?: InputMaybe<SearchableStringFilterInput>;
  RejectBtn?: InputMaybe<SearchableStringFilterInput>;
  RejectCriteriaTooltip?: InputMaybe<SearchableStringFilterInput>;
  Rejected?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RetentionSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  RowActionBtnText?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  UnableToDownloadFileError?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VerificationSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  WholePersonSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsApplicationsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsApplicationsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsApplicationsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsConfirmationStepBlock = IContent & IData & {
  __typename?: 'GsAwardsConfirmationStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  CeremonyInformationText?: Maybe<Scalars['String']['output']>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  QuestionText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  ReviewingStepText?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsConfirmationStepBlockCeremonyInformationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsConfirmationStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsConfirmationStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsConfirmationStepBlockQuestionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsConfirmationStepBlockReviewingStepTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsConfirmationStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsConfirmationStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsConfirmationStepBlockAutocomplete = {
  __typename?: 'GsAwardsConfirmationStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsConfirmationStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsConfirmationStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsConfirmationStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsConfirmationStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsConfirmationStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsConfirmationStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsConfirmationStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsConfirmationStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsConfirmationStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsConfirmationStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsConfirmationStepBlockFacet = {
  __typename?: 'GsAwardsConfirmationStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  CeremonyInformationText?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  QuestionText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ReviewingStepText?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsConfirmationStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetCeremonyInformationTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsConfirmationStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsConfirmationStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetQuestionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetReviewingStepTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsConfirmationStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsConfirmationStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsConfirmationStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsConfirmationStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsConfirmationStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  CeremonyInformationText?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  QuestionText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  ReviewingStepText?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsConfirmationStepBlockOutput = {
  __typename?: 'GsAwardsConfirmationStepBlockOutput';
  autocomplete?: Maybe<GsAwardsConfirmationStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsConfirmationStepBlockFacet>;
  item?: Maybe<GsAwardsConfirmationStepBlock>;
  items?: Maybe<Array<Maybe<GsAwardsConfirmationStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsConfirmationStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsConfirmationStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  CeremonyInformationText?: InputMaybe<SearchableStringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  QuestionText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ReviewingStepText?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsConfirmationStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsConfirmationStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsConfirmationStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlock = IContent & IData & {
  __typename?: 'GsAwardsFileUploadBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DropActiveLabel?: Maybe<Scalars['String']['output']>;
  ErrorFileTooLarge?: Maybe<Scalars['String']['output']>;
  ErrorFileTooSmall?: Maybe<Scalars['String']['output']>;
  ErrorInvalidFileType?: Maybe<Scalars['String']['output']>;
  ErrorTooManyFiles?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FailedUploadLabel?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SupportedFiles?: Maybe<Scalars['String']['output']>;
  UploadButton?: Maybe<Scalars['String']['output']>;
  UploadLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlockDropActiveLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlockErrorFileTooLargeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlockErrorFileTooSmallArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlockErrorInvalidFileTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlockErrorTooManyFilesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlockFailedUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlockSupportedFilesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlockUploadButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlockUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsFileUploadBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsFileUploadBlockAutocomplete = {
  __typename?: 'GsAwardsFileUploadBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsFileUploadBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsFileUploadBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsFileUploadBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsFileUploadBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsFileUploadBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsFileUploadBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsFileUploadBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsFileUploadBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsFileUploadBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsFileUploadBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsFileUploadBlockFacet = {
  __typename?: 'GsAwardsFileUploadBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DropActiveLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorFileTooLarge?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorFileTooSmall?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorInvalidFileType?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorTooManyFiles?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FailedUploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SupportedFiles?: Maybe<Array<Maybe<StringFacet>>>;
  UploadButton?: Maybe<Array<Maybe<StringFacet>>>;
  UploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsFileUploadBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsFileUploadBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsFileUploadBlockFacetDropActiveLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetErrorFileTooLargeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetErrorFileTooSmallArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetErrorInvalidFileTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetErrorTooManyFilesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetFailedUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsFileUploadBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsFileUploadBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsFileUploadBlockFacetSupportedFilesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetUploadButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsFileUploadBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsFileUploadBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DropActiveLabel?: InputMaybe<OrderBy>;
  ErrorFileTooLarge?: InputMaybe<OrderBy>;
  ErrorFileTooSmall?: InputMaybe<OrderBy>;
  ErrorInvalidFileType?: InputMaybe<OrderBy>;
  ErrorTooManyFiles?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FailedUploadLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SupportedFiles?: InputMaybe<OrderBy>;
  UploadButton?: InputMaybe<OrderBy>;
  UploadLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsFileUploadBlockOutput = {
  __typename?: 'GsAwardsFileUploadBlockOutput';
  autocomplete?: Maybe<GsAwardsFileUploadBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsFileUploadBlockFacet>;
  item?: Maybe<GsAwardsFileUploadBlock>;
  items?: Maybe<Array<Maybe<GsAwardsFileUploadBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsFileUploadBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsFileUploadBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DropActiveLabel?: InputMaybe<SearchableStringFilterInput>;
  ErrorFileTooLarge?: InputMaybe<SearchableStringFilterInput>;
  ErrorFileTooSmall?: InputMaybe<SearchableStringFilterInput>;
  ErrorInvalidFileType?: InputMaybe<SearchableStringFilterInput>;
  ErrorTooManyFiles?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FailedUploadLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SupportedFiles?: InputMaybe<SearchableStringFilterInput>;
  UploadButton?: InputMaybe<SearchableStringFilterInput>;
  UploadLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsFileUploadBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsFileUploadBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsFileUploadBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlock = IContent & IData & {
  __typename?: 'GsAwardsGettingStartedStepBlock';
  AddressDetailCityLabel?: Maybe<Scalars['String']['output']>;
  AddressDetailCountryLabel?: Maybe<Scalars['String']['output']>;
  AddressDetailLine1Hint?: Maybe<Scalars['String']['output']>;
  AddressDetailLine1Label?: Maybe<Scalars['String']['output']>;
  AddressDetailLine2Label?: Maybe<Scalars['String']['output']>;
  AddressDetailLine3Label?: Maybe<Scalars['String']['output']>;
  AddressDetailStateProvinceLabel?: Maybe<Scalars['String']['output']>;
  AddressDetailZipCodeLabel?: Maybe<Scalars['String']['output']>;
  AddressHeading?: Maybe<Scalars['String']['output']>;
  AgencyIdLabel?: Maybe<Scalars['String']['output']>;
  AgentIdLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicantInformationHeading?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CountryLabel?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignationsHint?: Maybe<Scalars['String']['output']>;
  DesignationsLabel?: Maybe<Scalars['String']['output']>;
  EmailErrorLabel?: Maybe<Scalars['String']['output']>;
  EmailLabel?: Maybe<Scalars['String']['output']>;
  EmailNote?: Maybe<Scalars['String']['output']>;
  EmailNote2?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstNameLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastNameLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NameLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PhoneAreaCodeLabel?: Maybe<Scalars['String']['output']>;
  PhoneIsoCodeLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PreferredNameLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UsePreferredNameLabel?: Maybe<Scalars['String']['output']>;
  WholePhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockAddressDetailCityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockAddressDetailCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockAddressDetailLine1HintArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockAddressDetailLine1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockAddressDetailLine2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockAddressDetailLine3LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockAddressDetailStateProvinceLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockAddressDetailZipCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockAddressHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockAgencyIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockApplicantInformationHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockDesignationsHintArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockDesignationsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockEmailErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockEmailLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockEmailNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockEmailNote2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockFirstNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockLastNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockPhoneAreaCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockPhoneIsoCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockPreferredNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockUsePreferredNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlockWholePhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsGettingStartedStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsGettingStartedStepBlockAutocomplete = {
  __typename?: 'GsAwardsGettingStartedStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsGettingStartedStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsGettingStartedStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsGettingStartedStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsGettingStartedStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsGettingStartedStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsGettingStartedStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsGettingStartedStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsGettingStartedStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsGettingStartedStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsGettingStartedStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsGettingStartedStepBlockFacet = {
  __typename?: 'GsAwardsGettingStartedStepBlockFacet';
  AddressDetailCityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailCountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailLine1Hint?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailLine1Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailLine2Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailLine3Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailStateProvinceLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailZipCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressHeading?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicantInformationHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DesignationsHint?: Maybe<Array<Maybe<StringFacet>>>;
  DesignationsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EmailErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EmailLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNote?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNote2?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PhoneAreaCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneIsoCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UsePreferredNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  WholePhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsGettingStartedStepBlockFacetAddressDetailCityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetAddressDetailCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetAddressDetailLine1HintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetAddressDetailLine1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetAddressDetailLine2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetAddressDetailLine3LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetAddressDetailStateProvinceLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetAddressDetailZipCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetAddressHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetAgencyIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetApplicantInformationHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsGettingStartedStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsGettingStartedStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetDesignationsHintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetDesignationsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetEmailErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetEmailLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetEmailNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetEmailNote2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetFirstNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetLastNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetPhoneAreaCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetPhoneIsoCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetPreferredNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsGettingStartedStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsGettingStartedStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsGettingStartedStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetUsePreferredNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacetWholePhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsGettingStartedStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsGettingStartedStepBlockOrderByInput = {
  AddressDetailCityLabel?: InputMaybe<OrderBy>;
  AddressDetailCountryLabel?: InputMaybe<OrderBy>;
  AddressDetailLine1Hint?: InputMaybe<OrderBy>;
  AddressDetailLine1Label?: InputMaybe<OrderBy>;
  AddressDetailLine2Label?: InputMaybe<OrderBy>;
  AddressDetailLine3Label?: InputMaybe<OrderBy>;
  AddressDetailStateProvinceLabel?: InputMaybe<OrderBy>;
  AddressDetailZipCodeLabel?: InputMaybe<OrderBy>;
  AddressHeading?: InputMaybe<OrderBy>;
  AgencyIdLabel?: InputMaybe<OrderBy>;
  AgentIdLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicantInformationHeading?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CountryLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DesignationsHint?: InputMaybe<OrderBy>;
  DesignationsLabel?: InputMaybe<OrderBy>;
  EmailErrorLabel?: InputMaybe<OrderBy>;
  EmailLabel?: InputMaybe<OrderBy>;
  EmailNote?: InputMaybe<OrderBy>;
  EmailNote2?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstNameLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastNameLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NameLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneAreaCodeLabel?: InputMaybe<OrderBy>;
  PhoneIsoCodeLabel?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PreferredNameLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UsePreferredNameLabel?: InputMaybe<OrderBy>;
  WholePhoneNumberLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsGettingStartedStepBlockOutput = {
  __typename?: 'GsAwardsGettingStartedStepBlockOutput';
  autocomplete?: Maybe<GsAwardsGettingStartedStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsGettingStartedStepBlockFacet>;
  item?: Maybe<GsAwardsGettingStartedStepBlock>;
  items?: Maybe<Array<Maybe<GsAwardsGettingStartedStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsGettingStartedStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsGettingStartedStepBlockWhereInput = {
  AddressDetailCityLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailCountryLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailLine1Hint?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailLine1Label?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailLine2Label?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailLine3Label?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailStateProvinceLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailZipCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressHeading?: InputMaybe<SearchableStringFilterInput>;
  AgencyIdLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentIdLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicantInformationHeading?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CountryLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DesignationsHint?: InputMaybe<SearchableStringFilterInput>;
  DesignationsLabel?: InputMaybe<SearchableStringFilterInput>;
  EmailErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  EmailLabel?: InputMaybe<SearchableStringFilterInput>;
  EmailNote?: InputMaybe<SearchableStringFilterInput>;
  EmailNote2?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstNameLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastNameLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NameLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneAreaCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneIsoCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PreferredNameLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UsePreferredNameLabel?: InputMaybe<SearchableStringFilterInput>;
  WholePhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsGettingStartedStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsGettingStartedStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsGettingStartedStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlock = IContent & IData & {
  __typename?: 'GsAwardsMembershipStepBlock';
  AcademyMembershipFileUploadLabel?: Maybe<Scalars['String']['output']>;
  AgentsListDigitsOnlyMdrtIdError?: Maybe<Scalars['String']['output']>;
  AgentsListFirstNameInputLabel?: Maybe<Scalars['String']['output']>;
  AgentsListInvalidCountryError?: Maybe<Scalars['String']['output']>;
  AgentsListLastNameInputLabel?: Maybe<Scalars['String']['output']>;
  AgentsListMdrtIdInputLabel?: Maybe<Scalars['String']['output']>;
  AgentsListMdrtIdNotFoundError?: Maybe<Scalars['String']['output']>;
  AgentsListNonMemberError?: Maybe<Scalars['String']['output']>;
  AgentsListNotSameCompanyError?: Maybe<Scalars['String']['output']>;
  AgentsListOptionalAgentsText?: Maybe<Scalars['String']['output']>;
  AgentsListRequiredAgentsText?: Maybe<Scalars['String']['output']>;
  AgentsListSomethingWentWrongError?: Maybe<Scalars['String']['output']>;
  AgentsListStatusA11yError?: Maybe<Scalars['String']['output']>;
  AgentsListStatusA11yLoading?: Maybe<Scalars['String']['output']>;
  AgentsListStatusA11ySuccess?: Maybe<Scalars['String']['output']>;
  AgentsListUniqueMdrtIdError?: Maybe<Scalars['String']['output']>;
  AgentsListWarningModalCancelBtn?: Maybe<Scalars['String']['output']>;
  AgentsListWarningModalContinueBtn?: Maybe<Scalars['String']['output']>;
  AgentsListWarningModalMessage?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConfirmBtnLabel?: Maybe<Scalars['String']['output']>;
  ConfirmTotalAgentsError?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HasSatisfiedMembershipCriteriaLabel?: Maybe<Scalars['String']['output']>;
  HasSatisfiedMembershipCriteriaNote?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LessThanRetentionTotalError?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TotalAgentsAtEndLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAcademyMembershipFileUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListDigitsOnlyMdrtIdErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListFirstNameInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListInvalidCountryErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListLastNameInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListMdrtIdInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListMdrtIdNotFoundErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListNonMemberErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListNotSameCompanyErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListOptionalAgentsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListRequiredAgentsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListSomethingWentWrongErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListStatusA11yErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListStatusA11yLoadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListStatusA11ySuccessArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListUniqueMdrtIdErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListWarningModalCancelBtnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListWarningModalContinueBtnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockAgentsListWarningModalMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockConfirmBtnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockConfirmTotalAgentsErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockHasSatisfiedMembershipCriteriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockHasSatisfiedMembershipCriteriaNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockLessThanRetentionTotalErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlockTotalAgentsAtEndLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsMembershipStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsMembershipStepBlockAutocomplete = {
  __typename?: 'GsAwardsMembershipStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsMembershipStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsMembershipStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsMembershipStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsMembershipStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsMembershipStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsMembershipStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsMembershipStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsMembershipStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsMembershipStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsMembershipStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsMembershipStepBlockFacet = {
  __typename?: 'GsAwardsMembershipStepBlockFacet';
  AcademyMembershipFileUploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListDigitsOnlyMdrtIdError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListFirstNameInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListInvalidCountryError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListLastNameInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListMdrtIdInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListMdrtIdNotFoundError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListNonMemberError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListNotSameCompanyError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListOptionalAgentsText?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListRequiredAgentsText?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListSomethingWentWrongError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListStatusA11yError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListStatusA11yLoading?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListStatusA11ySuccess?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListUniqueMdrtIdError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListWarningModalCancelBtn?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListWarningModalContinueBtn?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListWarningModalMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmBtnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ConfirmTotalAgentsError?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HasSatisfiedMembershipCriteriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HasSatisfiedMembershipCriteriaNote?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LessThanRetentionTotalError?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalAgentsAtEndLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsMembershipStepBlockFacetAcademyMembershipFileUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListDigitsOnlyMdrtIdErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListFirstNameInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListInvalidCountryErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListLastNameInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListMdrtIdInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListMdrtIdNotFoundErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListNonMemberErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListNotSameCompanyErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListOptionalAgentsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListRequiredAgentsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListSomethingWentWrongErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListStatusA11yErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListStatusA11yLoadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListStatusA11ySuccessArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListUniqueMdrtIdErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListWarningModalCancelBtnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListWarningModalContinueBtnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAgentsListWarningModalMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsMembershipStepBlockFacetConfirmBtnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetConfirmTotalAgentsErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsMembershipStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetHasSatisfiedMembershipCriteriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetHasSatisfiedMembershipCriteriaNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetLessThanRetentionTotalErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsMembershipStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsMembershipStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsMembershipStepBlockFacetTotalAgentsAtEndLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsMembershipStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsMembershipStepBlockOrderByInput = {
  AcademyMembershipFileUploadLabel?: InputMaybe<OrderBy>;
  AgentsListDigitsOnlyMdrtIdError?: InputMaybe<OrderBy>;
  AgentsListFirstNameInputLabel?: InputMaybe<OrderBy>;
  AgentsListInvalidCountryError?: InputMaybe<OrderBy>;
  AgentsListLastNameInputLabel?: InputMaybe<OrderBy>;
  AgentsListMdrtIdInputLabel?: InputMaybe<OrderBy>;
  AgentsListMdrtIdNotFoundError?: InputMaybe<OrderBy>;
  AgentsListNonMemberError?: InputMaybe<OrderBy>;
  AgentsListNotSameCompanyError?: InputMaybe<OrderBy>;
  AgentsListOptionalAgentsText?: InputMaybe<OrderBy>;
  AgentsListRequiredAgentsText?: InputMaybe<OrderBy>;
  AgentsListSomethingWentWrongError?: InputMaybe<OrderBy>;
  AgentsListStatusA11yError?: InputMaybe<OrderBy>;
  AgentsListStatusA11yLoading?: InputMaybe<OrderBy>;
  AgentsListStatusA11ySuccess?: InputMaybe<OrderBy>;
  AgentsListUniqueMdrtIdError?: InputMaybe<OrderBy>;
  AgentsListWarningModalCancelBtn?: InputMaybe<OrderBy>;
  AgentsListWarningModalContinueBtn?: InputMaybe<OrderBy>;
  AgentsListWarningModalMessage?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmBtnLabel?: InputMaybe<OrderBy>;
  ConfirmTotalAgentsError?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HasSatisfiedMembershipCriteriaLabel?: InputMaybe<OrderBy>;
  HasSatisfiedMembershipCriteriaNote?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LessThanRetentionTotalError?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalAgentsAtEndLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsMembershipStepBlockOutput = {
  __typename?: 'GsAwardsMembershipStepBlockOutput';
  autocomplete?: Maybe<GsAwardsMembershipStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsMembershipStepBlockFacet>;
  item?: Maybe<GsAwardsMembershipStepBlock>;
  items?: Maybe<Array<Maybe<GsAwardsMembershipStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsMembershipStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsMembershipStepBlockWhereInput = {
  AcademyMembershipFileUploadLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentsListDigitsOnlyMdrtIdError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListFirstNameInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentsListInvalidCountryError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListLastNameInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentsListMdrtIdInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentsListMdrtIdNotFoundError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListNonMemberError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListNotSameCompanyError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListOptionalAgentsText?: InputMaybe<SearchableStringFilterInput>;
  AgentsListRequiredAgentsText?: InputMaybe<SearchableStringFilterInput>;
  AgentsListSomethingWentWrongError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListStatusA11yError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListStatusA11yLoading?: InputMaybe<SearchableStringFilterInput>;
  AgentsListStatusA11ySuccess?: InputMaybe<SearchableStringFilterInput>;
  AgentsListUniqueMdrtIdError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListWarningModalCancelBtn?: InputMaybe<SearchableStringFilterInput>;
  AgentsListWarningModalContinueBtn?: InputMaybe<SearchableStringFilterInput>;
  AgentsListWarningModalMessage?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmBtnLabel?: InputMaybe<SearchableStringFilterInput>;
  ConfirmTotalAgentsError?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HasSatisfiedMembershipCriteriaLabel?: InputMaybe<SearchableStringFilterInput>;
  HasSatisfiedMembershipCriteriaNote?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LessThanRetentionTotalError?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalAgentsAtEndLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsMembershipStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsMembershipStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsMembershipStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for global services awards application */
export type GsAwardsPage = IContent & IData & {
  __typename?: 'GsAwardsPage';
  AccountLabel?: Maybe<Scalars['String']['output']>;
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Applications page content */
  ApplicationsBlock?: Maybe<GsAwardsPageGsAwardsApplicationsBlock>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** Confirmation step content */
  ConfirmationStepBlock?: Maybe<GsAwardsPageGsAwardsConfirmationStepBlock>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  DiscardAndContinueButton?: Maybe<Scalars['String']['output']>;
  /** General error modal message for 500s, 404s etc */
  ErrorModalDescription?: Maybe<Scalars['String']['output']>;
  /** Error message when a user isnt authorized */
  ErrorModalNotAuthorizedButton1Text?: Maybe<Scalars['String']['output']>;
  /** Error message when a user isnt authorized */
  ErrorModalNotAuthorizedButton2Text?: Maybe<Scalars['String']['output']>;
  /** Error message when a user isnt authorized */
  ErrorModalNotAuthorizedButton3Text?: Maybe<Scalars['String']['output']>;
  /** Error message when a user isnt authorized */
  ErrorModalNotAuthorizedDescription?: Maybe<Scalars['String']['output']>;
  /** Error message when a user is not a previous year member */
  ErrorModalNotAuthorizedDescription2?: Maybe<Scalars['String']['output']>;
  /** Error message when awards application are closed */
  ErrorPageAwardsClosed?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  FileMustBeUploadedModalContent?: Maybe<Scalars['String']['output']>;
  /** File upload component content */
  FileUploadBlock?: Maybe<GsAwardsPageGsAwardsFileUploadBlock>;
  /** Error message when a user submits a form that has a field with a required error */
  FormHasRequiredErrorsLabel?: Maybe<Scalars['String']['output']>;
  /** The Getting Started step content */
  GettingStartedStepBlock?: Maybe<GsAwardsPageGsAwardsGettingStartedStepBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeesTooltip?: Maybe<Scalars['String']['output']>;
  /** Error message when a user enters non-latin characters in a field */
  LatinAlphabetErrorLabel?: Maybe<Scalars['String']['output']>;
  /** The label for your total due, shown beneath the steps */
  LogoutLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** Membership step content */
  MembershipStepBlock?: Maybe<GsAwardsPageGsAwardsMembershipStepBlock>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<GsAwardsPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NavHeadingLabel?: Maybe<Scalars['String']['output']>;
  OptionalLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Persistency step content */
  PersistencyStepBlock?: Maybe<GsAwardsPageGsAwardsPersistencyStepBlock>;
  PhoneNumberErrorLabel?: Maybe<Scalars['String']['output']>;
  PositiveNumberErrorLabel?: Maybe<Scalars['String']['output']>;
  /** Production step content */
  ProductionStepBlock?: Maybe<GsAwardsPageGsAwardsProductionStepBlock>;
  QuestionsHeading?: Maybe<Scalars['String']['output']>;
  /** Recruitment step content */
  RecruitmentStepBlock?: Maybe<GsAwardsPageGsAwardsRecruitmentStepBlock>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** Error message when a user doesn't enter a required field */
  RequiredErrorFieldLabel?: Maybe<Scalars['String']['output']>;
  /** Retention step content */
  RetentionStepBlock?: Maybe<GsAwardsPageGsAwardsRetentionStepBlock>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SaveAndContinueButton?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  /** Select Applicant step content */
  SelectApplicantStepBlock?: Maybe<GsAwardsPageGsAwardsSelectApplicantStepBlock>;
  SelectLanguageHeading?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StayOnThePageButton?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Submit step content */
  SubmitStepBlock?: Maybe<GsAwardsPageGsAwardsSubmitStepBlock>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<GsAwardsPageImageBlock>;
  TooBigNumberErrorLabel?: Maybe<Scalars['String']['output']>;
  /** The label for your total due, shown beneath the steps */
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
  UnsavedChangesMessage?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** Verification step content */
  VerificationStepBlock?: Maybe<GsAwardsPageGsAwardsVerificationStepBlock>;
  WholeNumberErrorLabel?: Maybe<Scalars['String']['output']>;
  /** Whole Person step content */
  WholePersonStepBlock?: Maybe<GsAwardsPageGsAwardsWholePersonStepBlock>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageAccountLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageDiscardAndContinueButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageErrorModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageErrorModalNotAuthorizedButton1TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageErrorModalNotAuthorizedButton2TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageErrorModalNotAuthorizedButton3TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageErrorModalNotAuthorizedDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageErrorModalNotAuthorizedDescription2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageErrorPageAwardsClosedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageFileMustBeUploadedModalContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageFormHasRequiredErrorsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageLateFeesTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageLatinAlphabetErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageLogoutLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageNavHeadingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageOptionalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPagePhoneNumberErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPagePositiveNumberErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageQuestionsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageRequiredErrorFieldLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageSaveAndContinueButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageSelectLanguageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageStayOnThePageButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageTooBigNumberErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageUnsavedChangesMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPageWholeNumberErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for global services awards application */
export type GsAwardsPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsPageAutocomplete = {
  __typename?: 'GsAwardsPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<GsAwardsPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<GsAwardsPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  WholePersonStepBlock?: Maybe<GsAwardsPageGsAwardsWholePersonStepBlockAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsPageFacet = {
  __typename?: 'GsAwardsPageFacet';
  AccountLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationsBlock?: Maybe<GsAwardsPageGsAwardsApplicationsBlockFacet>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationStepBlock?: Maybe<GsAwardsPageGsAwardsConfirmationStepBlockFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  DiscardAndContinueButton?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalNotAuthorizedButton1Text?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalNotAuthorizedButton2Text?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalNotAuthorizedButton3Text?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalNotAuthorizedDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalNotAuthorizedDescription2?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorPageAwardsClosed?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FileMustBeUploadedModalContent?: Maybe<Array<Maybe<StringFacet>>>;
  FileUploadBlock?: Maybe<GsAwardsPageGsAwardsFileUploadBlockFacet>;
  FormHasRequiredErrorsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GettingStartedStepBlock?: Maybe<GsAwardsPageGsAwardsGettingStartedStepBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeesTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  LatinAlphabetErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipStepBlock?: Maybe<GsAwardsPageGsAwardsMembershipStepBlockFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<GsAwardsPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavHeadingLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OptionalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersistencyStepBlock?: Maybe<GsAwardsPageGsAwardsPersistencyStepBlockFacet>;
  PhoneNumberErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PositiveNumberErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionStepBlock?: Maybe<GsAwardsPageGsAwardsProductionStepBlockFacet>;
  QuestionsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  RecruitmentStepBlock?: Maybe<GsAwardsPageGsAwardsRecruitmentStepBlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RequiredErrorFieldLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RetentionStepBlock?: Maybe<GsAwardsPageGsAwardsRetentionStepBlockFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SaveAndContinueButton?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelectApplicantStepBlock?: Maybe<GsAwardsPageGsAwardsSelectApplicantStepBlockFacet>;
  SelectLanguageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StayOnThePageButton?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubmitStepBlock?: Maybe<GsAwardsPageGsAwardsSubmitStepBlockFacet>;
  ThumbnailImage?: Maybe<GsAwardsPageImageBlockFacet>;
  TooBigNumberErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  UnsavedChangesMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VerificationStepBlock?: Maybe<GsAwardsPageGsAwardsVerificationStepBlockFacet>;
  WholeNumberErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  WholePersonStepBlock?: Maybe<GsAwardsPageGsAwardsWholePersonStepBlockFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsPageFacetAccountLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GsAwardsPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetDiscardAndContinueButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetErrorModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetErrorModalNotAuthorizedButton1TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetErrorModalNotAuthorizedButton2TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetErrorModalNotAuthorizedButton3TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetErrorModalNotAuthorizedDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetErrorModalNotAuthorizedDescription2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetErrorPageAwardsClosedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetFileMustBeUploadedModalContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetFormHasRequiredErrorsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GsAwardsPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetLateFeesTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetLatinAlphabetErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetLogoutLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetNavHeadingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetOptionalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetPhoneNumberErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetPositiveNumberErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetQuestionsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetRequiredErrorFieldLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetSaveAndContinueButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsPageFacetSelectLanguageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetStayOnThePageButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsPageFacetTooBigNumberErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetUnsavedChangesMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacetWholeNumberErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsPageGsAwardsApplicationsBlock = {
  __typename?: 'GsAwardsPageGsAwardsApplicationsBlock';
  AgencyIdLabel?: Maybe<Scalars['String']['output']>;
  AgentIdLabel?: Maybe<Scalars['String']['output']>;
  ApplicationPageTitle?: Maybe<Scalars['String']['output']>;
  ApplicationStatus?: Maybe<Scalars['String']['output']>;
  ApproveBtn?: Maybe<Scalars['String']['output']>;
  ApproveCriteriaTooltip?: Maybe<Scalars['String']['output']>;
  Approved?: Maybe<Scalars['String']['output']>;
  BackToSelectApplicantButton?: Maybe<Scalars['String']['output']>;
  BackToSubmissionsButton?: Maybe<Scalars['String']['output']>;
  CancelBtnText?: Maybe<Scalars['String']['output']>;
  ColActions?: Maybe<Scalars['String']['output']>;
  ColApplicationStep?: Maybe<Scalars['String']['output']>;
  ColAwardTier?: Maybe<Scalars['String']['output']>;
  ColCompany?: Maybe<Scalars['String']['output']>;
  ColDateStarted?: Maybe<Scalars['String']['output']>;
  ColDateSubmitted?: Maybe<Scalars['String']['output']>;
  ColEmail?: Maybe<Scalars['String']['output']>;
  ColMdrtID?: Maybe<Scalars['String']['output']>;
  ColName?: Maybe<Scalars['String']['output']>;
  ColStatus?: Maybe<Scalars['String']['output']>;
  ColYear?: Maybe<Scalars['String']['output']>;
  CompanyLabel?: Maybe<Scalars['String']['output']>;
  CountryLabel?: Maybe<Scalars['String']['output']>;
  CriteriaApprovalText?: Maybe<Scalars['String']['output']>;
  DeleteApprovedRejectedNotice?: Maybe<Scalars['String']['output']>;
  DeleteBtnText?: Maybe<Scalars['String']['output']>;
  DeleteErrorText?: Maybe<Scalars['String']['output']>;
  DeleteModalText?: Maybe<Scalars['String']['output']>;
  EmailLabel?: Maybe<Scalars['String']['output']>;
  ExportToExcelBtnLabel?: Maybe<Scalars['String']['output']>;
  ExportToExcelDropdownBtnLabel?: Maybe<Scalars['String']['output']>;
  ExportToExcelErrorLabel?: Maybe<Scalars['String']['output']>;
  FileNotProvidedLabel?: Maybe<Scalars['String']['output']>;
  IssueAwardsBadgesBtnLabel?: Maybe<Scalars['String']['output']>;
  IssueAwardsBadgesErrorLabel?: Maybe<Scalars['String']['output']>;
  IssueAwardsBadgesSuccessLabel?: Maybe<Scalars['String']['output']>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  MembershipSectionTitle?: Maybe<Scalars['String']['output']>;
  PersistencySectionTitle?: Maybe<Scalars['String']['output']>;
  ProductionSectionTitle?: Maybe<Scalars['String']['output']>;
  RecruitmentSectionTitle?: Maybe<Scalars['String']['output']>;
  ReissueCredlyBadgeButton?: Maybe<Scalars['String']['output']>;
  ReissueCredlyBadgeNotice?: Maybe<Scalars['String']['output']>;
  RejectBtn?: Maybe<Scalars['String']['output']>;
  RejectCriteriaTooltip?: Maybe<Scalars['String']['output']>;
  Rejected?: Maybe<Scalars['String']['output']>;
  RetentionSectionTitle?: Maybe<Scalars['String']['output']>;
  RowActionBtnText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  UnableToDownloadFileError?: Maybe<Scalars['String']['output']>;
  VerificationSectionTitle?: Maybe<Scalars['String']['output']>;
  WholePersonSectionTitle?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsApplicationsBlockAgencyIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockApplicationPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockApplicationStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockApproveBtnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockApproveCriteriaTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockApprovedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockBackToSelectApplicantButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockBackToSubmissionsButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockCancelBtnTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockColActionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockColApplicationStepArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockColAwardTierArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockColCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockColDateStartedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockColDateSubmittedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockColEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockColMdrtIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockColNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockColStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockColYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockCompanyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockCriteriaApprovalTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockDeleteApprovedRejectedNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockDeleteBtnTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockDeleteErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockDeleteModalTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockEmailLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockExportToExcelBtnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockExportToExcelDropdownBtnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockExportToExcelErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFileNotProvidedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockIssueAwardsBadgesBtnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockIssueAwardsBadgesErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockIssueAwardsBadgesSuccessLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockMembershipSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockPersistencySectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockProductionSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockRecruitmentSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockReissueCredlyBadgeButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockReissueCredlyBadgeNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockRejectBtnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockRejectCriteriaTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockRejectedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockRetentionSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockRowActionBtnTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockUnableToDownloadFileErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockVerificationSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsApplicationsBlockWholePersonSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsApplicationsBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsApplicationsBlockFacet';
  AgencyIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationPageTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationStatus?: Maybe<Array<Maybe<StringFacet>>>;
  ApproveBtn?: Maybe<Array<Maybe<StringFacet>>>;
  ApproveCriteriaTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  Approved?: Maybe<Array<Maybe<StringFacet>>>;
  BackToSelectApplicantButton?: Maybe<Array<Maybe<StringFacet>>>;
  BackToSubmissionsButton?: Maybe<Array<Maybe<StringFacet>>>;
  CancelBtnText?: Maybe<Array<Maybe<StringFacet>>>;
  ColActions?: Maybe<Array<Maybe<StringFacet>>>;
  ColApplicationStep?: Maybe<Array<Maybe<StringFacet>>>;
  ColAwardTier?: Maybe<Array<Maybe<StringFacet>>>;
  ColCompany?: Maybe<Array<Maybe<StringFacet>>>;
  ColDateStarted?: Maybe<Array<Maybe<StringFacet>>>;
  ColDateSubmitted?: Maybe<Array<Maybe<StringFacet>>>;
  ColEmail?: Maybe<Array<Maybe<StringFacet>>>;
  ColMdrtID?: Maybe<Array<Maybe<StringFacet>>>;
  ColName?: Maybe<Array<Maybe<StringFacet>>>;
  ColStatus?: Maybe<Array<Maybe<StringFacet>>>;
  ColYear?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CriteriaApprovalText?: Maybe<Array<Maybe<StringFacet>>>;
  DeleteApprovedRejectedNotice?: Maybe<Array<Maybe<StringFacet>>>;
  DeleteBtnText?: Maybe<Array<Maybe<StringFacet>>>;
  DeleteErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  DeleteModalText?: Maybe<Array<Maybe<StringFacet>>>;
  EmailLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExportToExcelBtnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExportToExcelDropdownBtnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExportToExcelErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FileNotProvidedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IssueAwardsBadgesBtnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IssueAwardsBadgesErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IssueAwardsBadgesSuccessLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PersistencySectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RecruitmentSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ReissueCredlyBadgeButton?: Maybe<Array<Maybe<StringFacet>>>;
  ReissueCredlyBadgeNotice?: Maybe<Array<Maybe<StringFacet>>>;
  RejectBtn?: Maybe<Array<Maybe<StringFacet>>>;
  RejectCriteriaTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  Rejected?: Maybe<Array<Maybe<StringFacet>>>;
  RetentionSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RowActionBtnText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  UnableToDownloadFileError?: Maybe<Array<Maybe<StringFacet>>>;
  VerificationSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  WholePersonSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetAgencyIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetApplicationPageTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetApplicationStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetApproveBtnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetApproveCriteriaTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetApprovedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetBackToSelectApplicantButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetBackToSubmissionsButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetCancelBtnTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetColActionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetColApplicationStepArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetColAwardTierArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetColCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetColDateStartedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetColDateSubmittedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetColEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetColMdrtIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetColNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetColStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetColYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetCompanyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetCriteriaApprovalTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetDeleteApprovedRejectedNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetDeleteBtnTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetDeleteErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetDeleteModalTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetEmailLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetExportToExcelBtnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetExportToExcelDropdownBtnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetExportToExcelErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetFileNotProvidedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetIssueAwardsBadgesBtnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetIssueAwardsBadgesErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetIssueAwardsBadgesSuccessLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetMembershipSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetPersistencySectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetProductionSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetRecruitmentSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetReissueCredlyBadgeButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetReissueCredlyBadgeNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetRejectBtnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetRejectCriteriaTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetRejectedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetRetentionSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetRowActionBtnTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetUnableToDownloadFileErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetVerificationSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsApplicationsBlockFacetWholePersonSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsApplicationsBlockOrderByInput = {
  AgencyIdLabel?: InputMaybe<OrderBy>;
  AgentIdLabel?: InputMaybe<OrderBy>;
  ApplicationPageTitle?: InputMaybe<OrderBy>;
  ApplicationStatus?: InputMaybe<OrderBy>;
  ApproveBtn?: InputMaybe<OrderBy>;
  ApproveCriteriaTooltip?: InputMaybe<OrderBy>;
  Approved?: InputMaybe<OrderBy>;
  BackToSelectApplicantButton?: InputMaybe<OrderBy>;
  BackToSubmissionsButton?: InputMaybe<OrderBy>;
  CancelBtnText?: InputMaybe<OrderBy>;
  ColActions?: InputMaybe<OrderBy>;
  ColApplicationStep?: InputMaybe<OrderBy>;
  ColAwardTier?: InputMaybe<OrderBy>;
  ColCompany?: InputMaybe<OrderBy>;
  ColDateStarted?: InputMaybe<OrderBy>;
  ColDateSubmitted?: InputMaybe<OrderBy>;
  ColEmail?: InputMaybe<OrderBy>;
  ColMdrtID?: InputMaybe<OrderBy>;
  ColName?: InputMaybe<OrderBy>;
  ColStatus?: InputMaybe<OrderBy>;
  ColYear?: InputMaybe<OrderBy>;
  CompanyLabel?: InputMaybe<OrderBy>;
  CountryLabel?: InputMaybe<OrderBy>;
  CriteriaApprovalText?: InputMaybe<OrderBy>;
  DeleteApprovedRejectedNotice?: InputMaybe<OrderBy>;
  DeleteBtnText?: InputMaybe<OrderBy>;
  DeleteErrorText?: InputMaybe<OrderBy>;
  DeleteModalText?: InputMaybe<OrderBy>;
  EmailLabel?: InputMaybe<OrderBy>;
  ExportToExcelBtnLabel?: InputMaybe<OrderBy>;
  ExportToExcelDropdownBtnLabel?: InputMaybe<OrderBy>;
  ExportToExcelErrorLabel?: InputMaybe<OrderBy>;
  FileNotProvidedLabel?: InputMaybe<OrderBy>;
  IssueAwardsBadgesBtnLabel?: InputMaybe<OrderBy>;
  IssueAwardsBadgesErrorLabel?: InputMaybe<OrderBy>;
  IssueAwardsBadgesSuccessLabel?: InputMaybe<OrderBy>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  MembershipSectionTitle?: InputMaybe<OrderBy>;
  PersistencySectionTitle?: InputMaybe<OrderBy>;
  ProductionSectionTitle?: InputMaybe<OrderBy>;
  RecruitmentSectionTitle?: InputMaybe<OrderBy>;
  ReissueCredlyBadgeButton?: InputMaybe<OrderBy>;
  ReissueCredlyBadgeNotice?: InputMaybe<OrderBy>;
  RejectBtn?: InputMaybe<OrderBy>;
  RejectCriteriaTooltip?: InputMaybe<OrderBy>;
  Rejected?: InputMaybe<OrderBy>;
  RetentionSectionTitle?: InputMaybe<OrderBy>;
  RowActionBtnText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  UnableToDownloadFileError?: InputMaybe<OrderBy>;
  VerificationSectionTitle?: InputMaybe<OrderBy>;
  WholePersonSectionTitle?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsApplicationsBlockWhereInput = {
  AgencyIdLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentIdLabel?: InputMaybe<SearchableStringFilterInput>;
  ApplicationPageTitle?: InputMaybe<SearchableStringFilterInput>;
  ApplicationStatus?: InputMaybe<SearchableStringFilterInput>;
  ApproveBtn?: InputMaybe<SearchableStringFilterInput>;
  ApproveCriteriaTooltip?: InputMaybe<SearchableStringFilterInput>;
  Approved?: InputMaybe<SearchableStringFilterInput>;
  BackToSelectApplicantButton?: InputMaybe<SearchableStringFilterInput>;
  BackToSubmissionsButton?: InputMaybe<SearchableStringFilterInput>;
  CancelBtnText?: InputMaybe<SearchableStringFilterInput>;
  ColActions?: InputMaybe<SearchableStringFilterInput>;
  ColApplicationStep?: InputMaybe<SearchableStringFilterInput>;
  ColAwardTier?: InputMaybe<SearchableStringFilterInput>;
  ColCompany?: InputMaybe<SearchableStringFilterInput>;
  ColDateStarted?: InputMaybe<SearchableStringFilterInput>;
  ColDateSubmitted?: InputMaybe<SearchableStringFilterInput>;
  ColEmail?: InputMaybe<SearchableStringFilterInput>;
  ColMdrtID?: InputMaybe<SearchableStringFilterInput>;
  ColName?: InputMaybe<SearchableStringFilterInput>;
  ColStatus?: InputMaybe<SearchableStringFilterInput>;
  ColYear?: InputMaybe<SearchableStringFilterInput>;
  CompanyLabel?: InputMaybe<SearchableStringFilterInput>;
  CountryLabel?: InputMaybe<SearchableStringFilterInput>;
  CriteriaApprovalText?: InputMaybe<SearchableStringFilterInput>;
  DeleteApprovedRejectedNotice?: InputMaybe<SearchableStringFilterInput>;
  DeleteBtnText?: InputMaybe<SearchableStringFilterInput>;
  DeleteErrorText?: InputMaybe<SearchableStringFilterInput>;
  DeleteModalText?: InputMaybe<SearchableStringFilterInput>;
  EmailLabel?: InputMaybe<SearchableStringFilterInput>;
  ExportToExcelBtnLabel?: InputMaybe<SearchableStringFilterInput>;
  ExportToExcelDropdownBtnLabel?: InputMaybe<SearchableStringFilterInput>;
  ExportToExcelErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  FileNotProvidedLabel?: InputMaybe<SearchableStringFilterInput>;
  IssueAwardsBadgesBtnLabel?: InputMaybe<SearchableStringFilterInput>;
  IssueAwardsBadgesErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  IssueAwardsBadgesSuccessLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  PersistencySectionTitle?: InputMaybe<SearchableStringFilterInput>;
  ProductionSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  RecruitmentSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  ReissueCredlyBadgeButton?: InputMaybe<SearchableStringFilterInput>;
  ReissueCredlyBadgeNotice?: InputMaybe<SearchableStringFilterInput>;
  RejectBtn?: InputMaybe<SearchableStringFilterInput>;
  RejectCriteriaTooltip?: InputMaybe<SearchableStringFilterInput>;
  Rejected?: InputMaybe<SearchableStringFilterInput>;
  RetentionSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  RowActionBtnText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  UnableToDownloadFileError?: InputMaybe<SearchableStringFilterInput>;
  VerificationSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  WholePersonSectionTitle?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsConfirmationStepBlock = {
  __typename?: 'GsAwardsPageGsAwardsConfirmationStepBlock';
  CeremonyInformationText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  QuestionText?: Maybe<Scalars['String']['output']>;
  ReviewingStepText?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsConfirmationStepBlockCeremonyInformationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsConfirmationStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsConfirmationStepBlockQuestionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsConfirmationStepBlockReviewingStepTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsConfirmationStepBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsConfirmationStepBlockFacet';
  CeremonyInformationText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  QuestionText?: Maybe<Array<Maybe<StringFacet>>>;
  ReviewingStepText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsConfirmationStepBlockFacetCeremonyInformationTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsConfirmationStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsConfirmationStepBlockFacetQuestionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsConfirmationStepBlockFacetReviewingStepTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsConfirmationStepBlockOrderByInput = {
  CeremonyInformationText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  QuestionText?: InputMaybe<OrderBy>;
  ReviewingStepText?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsConfirmationStepBlockWhereInput = {
  CeremonyInformationText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  QuestionText?: InputMaybe<SearchableStringFilterInput>;
  ReviewingStepText?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsFileUploadBlock = {
  __typename?: 'GsAwardsPageGsAwardsFileUploadBlock';
  DropActiveLabel?: Maybe<Scalars['String']['output']>;
  ErrorFileTooLarge?: Maybe<Scalars['String']['output']>;
  ErrorFileTooSmall?: Maybe<Scalars['String']['output']>;
  ErrorInvalidFileType?: Maybe<Scalars['String']['output']>;
  ErrorTooManyFiles?: Maybe<Scalars['String']['output']>;
  FailedUploadLabel?: Maybe<Scalars['String']['output']>;
  SupportedFiles?: Maybe<Scalars['String']['output']>;
  UploadButton?: Maybe<Scalars['String']['output']>;
  UploadLabel?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsFileUploadBlockDropActiveLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsFileUploadBlockErrorFileTooLargeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsFileUploadBlockErrorFileTooSmallArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsFileUploadBlockErrorInvalidFileTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsFileUploadBlockErrorTooManyFilesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsFileUploadBlockFailedUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsFileUploadBlockSupportedFilesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsFileUploadBlockUploadButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsFileUploadBlockUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsFileUploadBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsFileUploadBlockFacet';
  DropActiveLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorFileTooLarge?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorFileTooSmall?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorInvalidFileType?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorTooManyFiles?: Maybe<Array<Maybe<StringFacet>>>;
  FailedUploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SupportedFiles?: Maybe<Array<Maybe<StringFacet>>>;
  UploadButton?: Maybe<Array<Maybe<StringFacet>>>;
  UploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsFileUploadBlockFacetDropActiveLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsFileUploadBlockFacetErrorFileTooLargeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsFileUploadBlockFacetErrorFileTooSmallArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsFileUploadBlockFacetErrorInvalidFileTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsFileUploadBlockFacetErrorTooManyFilesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsFileUploadBlockFacetFailedUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsFileUploadBlockFacetSupportedFilesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsFileUploadBlockFacetUploadButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsFileUploadBlockFacetUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsFileUploadBlockOrderByInput = {
  DropActiveLabel?: InputMaybe<OrderBy>;
  ErrorFileTooLarge?: InputMaybe<OrderBy>;
  ErrorFileTooSmall?: InputMaybe<OrderBy>;
  ErrorInvalidFileType?: InputMaybe<OrderBy>;
  ErrorTooManyFiles?: InputMaybe<OrderBy>;
  FailedUploadLabel?: InputMaybe<OrderBy>;
  SupportedFiles?: InputMaybe<OrderBy>;
  UploadButton?: InputMaybe<OrderBy>;
  UploadLabel?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsFileUploadBlockWhereInput = {
  DropActiveLabel?: InputMaybe<SearchableStringFilterInput>;
  ErrorFileTooLarge?: InputMaybe<SearchableStringFilterInput>;
  ErrorFileTooSmall?: InputMaybe<SearchableStringFilterInput>;
  ErrorInvalidFileType?: InputMaybe<SearchableStringFilterInput>;
  ErrorTooManyFiles?: InputMaybe<SearchableStringFilterInput>;
  FailedUploadLabel?: InputMaybe<SearchableStringFilterInput>;
  SupportedFiles?: InputMaybe<SearchableStringFilterInput>;
  UploadButton?: InputMaybe<SearchableStringFilterInput>;
  UploadLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsGettingStartedStepBlock = {
  __typename?: 'GsAwardsPageGsAwardsGettingStartedStepBlock';
  AddressDetailCityLabel?: Maybe<Scalars['String']['output']>;
  AddressDetailCountryLabel?: Maybe<Scalars['String']['output']>;
  AddressDetailLine1Hint?: Maybe<Scalars['String']['output']>;
  AddressDetailLine1Label?: Maybe<Scalars['String']['output']>;
  AddressDetailLine2Label?: Maybe<Scalars['String']['output']>;
  AddressDetailLine3Label?: Maybe<Scalars['String']['output']>;
  AddressDetailStateProvinceLabel?: Maybe<Scalars['String']['output']>;
  AddressDetailZipCodeLabel?: Maybe<Scalars['String']['output']>;
  AddressHeading?: Maybe<Scalars['String']['output']>;
  AgencyIdLabel?: Maybe<Scalars['String']['output']>;
  AgentIdLabel?: Maybe<Scalars['String']['output']>;
  ApplicantInformationHeading?: Maybe<Scalars['String']['output']>;
  CountryLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignationsHint?: Maybe<Scalars['String']['output']>;
  DesignationsLabel?: Maybe<Scalars['String']['output']>;
  EmailErrorLabel?: Maybe<Scalars['String']['output']>;
  EmailLabel?: Maybe<Scalars['String']['output']>;
  EmailNote?: Maybe<Scalars['String']['output']>;
  EmailNote2?: Maybe<Scalars['String']['output']>;
  FirstNameLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  LastNameLabel?: Maybe<Scalars['String']['output']>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  NameLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  PhoneAreaCodeLabel?: Maybe<Scalars['String']['output']>;
  PhoneIsoCodeLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PreferredNameLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  UsePreferredNameLabel?: Maybe<Scalars['String']['output']>;
  WholePhoneNumberLabel?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockAddressDetailCityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockAddressDetailCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockAddressDetailLine1HintArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockAddressDetailLine1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockAddressDetailLine2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockAddressDetailLine3LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockAddressDetailStateProvinceLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockAddressDetailZipCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockAddressHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockAgencyIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockApplicantInformationHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockDesignationsHintArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockDesignationsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockEmailErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockEmailLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockEmailNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockEmailNote2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFirstNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockLastNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockPhoneAreaCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockPhoneIsoCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockPreferredNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockUsePreferredNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockWholePhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsGettingStartedStepBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsGettingStartedStepBlockFacet';
  AddressDetailCityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailCountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailLine1Hint?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailLine1Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailLine2Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailLine3Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailStateProvinceLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressDetailZipCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressHeading?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicantInformationHeading?: Maybe<Array<Maybe<StringFacet>>>;
  CountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DesignationsHint?: Maybe<Array<Maybe<StringFacet>>>;
  DesignationsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EmailErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EmailLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNote?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNote2?: Maybe<Array<Maybe<StringFacet>>>;
  FirstNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  LastNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneAreaCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneIsoCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  UsePreferredNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  WholePhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetAddressDetailCityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetAddressDetailCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetAddressDetailLine1HintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetAddressDetailLine1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetAddressDetailLine2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetAddressDetailLine3LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetAddressDetailStateProvinceLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetAddressDetailZipCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetAddressHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetAgencyIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetApplicantInformationHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetDesignationsHintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetDesignationsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetEmailErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetEmailLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetEmailNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetEmailNote2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetFirstNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetLastNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetPhoneAreaCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetPhoneIsoCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetPreferredNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetUsePreferredNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsGettingStartedStepBlockFacetWholePhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsGettingStartedStepBlockOrderByInput = {
  AddressDetailCityLabel?: InputMaybe<OrderBy>;
  AddressDetailCountryLabel?: InputMaybe<OrderBy>;
  AddressDetailLine1Hint?: InputMaybe<OrderBy>;
  AddressDetailLine1Label?: InputMaybe<OrderBy>;
  AddressDetailLine2Label?: InputMaybe<OrderBy>;
  AddressDetailLine3Label?: InputMaybe<OrderBy>;
  AddressDetailStateProvinceLabel?: InputMaybe<OrderBy>;
  AddressDetailZipCodeLabel?: InputMaybe<OrderBy>;
  AddressHeading?: InputMaybe<OrderBy>;
  AgencyIdLabel?: InputMaybe<OrderBy>;
  AgentIdLabel?: InputMaybe<OrderBy>;
  ApplicantInformationHeading?: InputMaybe<OrderBy>;
  CountryLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DesignationsHint?: InputMaybe<OrderBy>;
  DesignationsLabel?: InputMaybe<OrderBy>;
  EmailErrorLabel?: InputMaybe<OrderBy>;
  EmailLabel?: InputMaybe<OrderBy>;
  EmailNote?: InputMaybe<OrderBy>;
  EmailNote2?: InputMaybe<OrderBy>;
  FirstNameLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  LastNameLabel?: InputMaybe<OrderBy>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  NameLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  PhoneAreaCodeLabel?: InputMaybe<OrderBy>;
  PhoneIsoCodeLabel?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PreferredNameLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  UsePreferredNameLabel?: InputMaybe<OrderBy>;
  WholePhoneNumberLabel?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsGettingStartedStepBlockWhereInput = {
  AddressDetailCityLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailCountryLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailLine1Hint?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailLine1Label?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailLine2Label?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailLine3Label?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailStateProvinceLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressDetailZipCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressHeading?: InputMaybe<SearchableStringFilterInput>;
  AgencyIdLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentIdLabel?: InputMaybe<SearchableStringFilterInput>;
  ApplicantInformationHeading?: InputMaybe<SearchableStringFilterInput>;
  CountryLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DesignationsHint?: InputMaybe<SearchableStringFilterInput>;
  DesignationsLabel?: InputMaybe<SearchableStringFilterInput>;
  EmailErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  EmailLabel?: InputMaybe<SearchableStringFilterInput>;
  EmailNote?: InputMaybe<SearchableStringFilterInput>;
  EmailNote2?: InputMaybe<SearchableStringFilterInput>;
  FirstNameLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  LastNameLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  NameLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneAreaCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneIsoCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PreferredNameLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  UsePreferredNameLabel?: InputMaybe<SearchableStringFilterInput>;
  WholePhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsMembershipStepBlock = {
  __typename?: 'GsAwardsPageGsAwardsMembershipStepBlock';
  AcademyMembershipFileUploadLabel?: Maybe<Scalars['String']['output']>;
  AgentsListDigitsOnlyMdrtIdError?: Maybe<Scalars['String']['output']>;
  AgentsListFirstNameInputLabel?: Maybe<Scalars['String']['output']>;
  AgentsListInvalidCountryError?: Maybe<Scalars['String']['output']>;
  AgentsListLastNameInputLabel?: Maybe<Scalars['String']['output']>;
  AgentsListMdrtIdInputLabel?: Maybe<Scalars['String']['output']>;
  AgentsListMdrtIdNotFoundError?: Maybe<Scalars['String']['output']>;
  AgentsListNonMemberError?: Maybe<Scalars['String']['output']>;
  AgentsListNotSameCompanyError?: Maybe<Scalars['String']['output']>;
  AgentsListOptionalAgentsText?: Maybe<Scalars['String']['output']>;
  AgentsListRequiredAgentsText?: Maybe<Scalars['String']['output']>;
  AgentsListSomethingWentWrongError?: Maybe<Scalars['String']['output']>;
  AgentsListStatusA11yError?: Maybe<Scalars['String']['output']>;
  AgentsListStatusA11yLoading?: Maybe<Scalars['String']['output']>;
  AgentsListStatusA11ySuccess?: Maybe<Scalars['String']['output']>;
  AgentsListUniqueMdrtIdError?: Maybe<Scalars['String']['output']>;
  AgentsListWarningModalCancelBtn?: Maybe<Scalars['String']['output']>;
  AgentsListWarningModalContinueBtn?: Maybe<Scalars['String']['output']>;
  AgentsListWarningModalMessage?: Maybe<Scalars['String']['output']>;
  ConfirmBtnLabel?: Maybe<Scalars['String']['output']>;
  ConfirmTotalAgentsError?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  HasSatisfiedMembershipCriteriaLabel?: Maybe<Scalars['String']['output']>;
  HasSatisfiedMembershipCriteriaNote?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  LessThanRetentionTotalError?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TotalAgentsAtEndLabel?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAcademyMembershipFileUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListDigitsOnlyMdrtIdErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListFirstNameInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListInvalidCountryErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListLastNameInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListMdrtIdInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListMdrtIdNotFoundErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListNonMemberErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListNotSameCompanyErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListOptionalAgentsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListRequiredAgentsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListSomethingWentWrongErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListStatusA11yErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListStatusA11yLoadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListStatusA11ySuccessArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListUniqueMdrtIdErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListWarningModalCancelBtnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListWarningModalContinueBtnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockAgentsListWarningModalMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockConfirmBtnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockConfirmTotalAgentsErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockHasSatisfiedMembershipCriteriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockHasSatisfiedMembershipCriteriaNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockLessThanRetentionTotalErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockTotalAgentsAtEndLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsMembershipStepBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsMembershipStepBlockFacet';
  AcademyMembershipFileUploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListDigitsOnlyMdrtIdError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListFirstNameInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListInvalidCountryError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListLastNameInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListMdrtIdInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListMdrtIdNotFoundError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListNonMemberError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListNotSameCompanyError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListOptionalAgentsText?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListRequiredAgentsText?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListSomethingWentWrongError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListStatusA11yError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListStatusA11yLoading?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListStatusA11ySuccess?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListUniqueMdrtIdError?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListWarningModalCancelBtn?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListWarningModalContinueBtn?: Maybe<Array<Maybe<StringFacet>>>;
  AgentsListWarningModalMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ConfirmBtnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ConfirmTotalAgentsError?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  HasSatisfiedMembershipCriteriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HasSatisfiedMembershipCriteriaNote?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  LessThanRetentionTotalError?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsAtEndLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAcademyMembershipFileUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListDigitsOnlyMdrtIdErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListFirstNameInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListInvalidCountryErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListLastNameInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListMdrtIdInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListMdrtIdNotFoundErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListNonMemberErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListNotSameCompanyErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListOptionalAgentsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListRequiredAgentsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListSomethingWentWrongErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListStatusA11yErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListStatusA11yLoadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListStatusA11ySuccessArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListUniqueMdrtIdErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListWarningModalCancelBtnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListWarningModalContinueBtnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetAgentsListWarningModalMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetConfirmBtnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetConfirmTotalAgentsErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetHasSatisfiedMembershipCriteriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetHasSatisfiedMembershipCriteriaNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetLessThanRetentionTotalErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsMembershipStepBlockFacetTotalAgentsAtEndLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsMembershipStepBlockOrderByInput = {
  AcademyMembershipFileUploadLabel?: InputMaybe<OrderBy>;
  AgentsListDigitsOnlyMdrtIdError?: InputMaybe<OrderBy>;
  AgentsListFirstNameInputLabel?: InputMaybe<OrderBy>;
  AgentsListInvalidCountryError?: InputMaybe<OrderBy>;
  AgentsListLastNameInputLabel?: InputMaybe<OrderBy>;
  AgentsListMdrtIdInputLabel?: InputMaybe<OrderBy>;
  AgentsListMdrtIdNotFoundError?: InputMaybe<OrderBy>;
  AgentsListNonMemberError?: InputMaybe<OrderBy>;
  AgentsListNotSameCompanyError?: InputMaybe<OrderBy>;
  AgentsListOptionalAgentsText?: InputMaybe<OrderBy>;
  AgentsListRequiredAgentsText?: InputMaybe<OrderBy>;
  AgentsListSomethingWentWrongError?: InputMaybe<OrderBy>;
  AgentsListStatusA11yError?: InputMaybe<OrderBy>;
  AgentsListStatusA11yLoading?: InputMaybe<OrderBy>;
  AgentsListStatusA11ySuccess?: InputMaybe<OrderBy>;
  AgentsListUniqueMdrtIdError?: InputMaybe<OrderBy>;
  AgentsListWarningModalCancelBtn?: InputMaybe<OrderBy>;
  AgentsListWarningModalContinueBtn?: InputMaybe<OrderBy>;
  AgentsListWarningModalMessage?: InputMaybe<OrderBy>;
  ConfirmBtnLabel?: InputMaybe<OrderBy>;
  ConfirmTotalAgentsError?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  HasSatisfiedMembershipCriteriaLabel?: InputMaybe<OrderBy>;
  HasSatisfiedMembershipCriteriaNote?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  LessThanRetentionTotalError?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TotalAgentsAtEndLabel?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsMembershipStepBlockWhereInput = {
  AcademyMembershipFileUploadLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentsListDigitsOnlyMdrtIdError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListFirstNameInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentsListInvalidCountryError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListLastNameInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentsListMdrtIdInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentsListMdrtIdNotFoundError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListNonMemberError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListNotSameCompanyError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListOptionalAgentsText?: InputMaybe<SearchableStringFilterInput>;
  AgentsListRequiredAgentsText?: InputMaybe<SearchableStringFilterInput>;
  AgentsListSomethingWentWrongError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListStatusA11yError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListStatusA11yLoading?: InputMaybe<SearchableStringFilterInput>;
  AgentsListStatusA11ySuccess?: InputMaybe<SearchableStringFilterInput>;
  AgentsListUniqueMdrtIdError?: InputMaybe<SearchableStringFilterInput>;
  AgentsListWarningModalCancelBtn?: InputMaybe<SearchableStringFilterInput>;
  AgentsListWarningModalContinueBtn?: InputMaybe<SearchableStringFilterInput>;
  AgentsListWarningModalMessage?: InputMaybe<SearchableStringFilterInput>;
  ConfirmBtnLabel?: InputMaybe<SearchableStringFilterInput>;
  ConfirmTotalAgentsError?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  HasSatisfiedMembershipCriteriaLabel?: InputMaybe<SearchableStringFilterInput>;
  HasSatisfiedMembershipCriteriaNote?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  LessThanRetentionTotalError?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsAtEndLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsPersistencyStepBlock = {
  __typename?: 'GsAwardsPageGsAwardsPersistencyStepBlock';
  Description?: Maybe<Scalars['String']['output']>;
  DidAchievePersistencyRateLabel?: Maybe<Scalars['String']['output']>;
  DidAchievePersistencyRateNote?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  PersistencyFileUploadNote?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TotalPoliciesLabel?: Maybe<Scalars['String']['output']>;
  TotalPoliciesPersistedTooHigh?: Maybe<Scalars['String']['output']>;
  TotalPoliciesRetainedLabel?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockDidAchievePersistencyRateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockDidAchievePersistencyRateNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockPersistencyFileUploadNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockTotalPoliciesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockTotalPoliciesPersistedTooHighArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockTotalPoliciesRetainedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsPersistencyStepBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsPersistencyStepBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DidAchievePersistencyRateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DidAchievePersistencyRateNote?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PersistencyFileUploadNote?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TotalPoliciesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalPoliciesPersistedTooHigh?: Maybe<Array<Maybe<StringFacet>>>;
  TotalPoliciesRetainedLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockFacetDidAchievePersistencyRateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockFacetDidAchievePersistencyRateNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockFacetPersistencyFileUploadNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockFacetTotalPoliciesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockFacetTotalPoliciesPersistedTooHighArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsPersistencyStepBlockFacetTotalPoliciesRetainedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsPersistencyStepBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  DidAchievePersistencyRateLabel?: InputMaybe<OrderBy>;
  DidAchievePersistencyRateNote?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  PersistencyFileUploadNote?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TotalPoliciesLabel?: InputMaybe<OrderBy>;
  TotalPoliciesPersistedTooHigh?: InputMaybe<OrderBy>;
  TotalPoliciesRetainedLabel?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsPersistencyStepBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  DidAchievePersistencyRateLabel?: InputMaybe<SearchableStringFilterInput>;
  DidAchievePersistencyRateNote?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PersistencyFileUploadNote?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TotalPoliciesLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalPoliciesPersistedTooHigh?: InputMaybe<SearchableStringFilterInput>;
  TotalPoliciesRetainedLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsProductionStepBlock = {
  __typename?: 'GsAwardsPageGsAwardsProductionStepBlock';
  AgencyCommissionEndLabel?: Maybe<Scalars['String']['output']>;
  AgencyCommissionStartLabel?: Maybe<Scalars['String']['output']>;
  AgencyPremiumEndLabel?: Maybe<Scalars['String']['output']>;
  AgencyPremiumStartLabel?: Maybe<Scalars['String']['output']>;
  ConversionFileLabel?: Maybe<Scalars['String']['output']>;
  ConversionFileLinkCurrentYear?: Maybe<Scalars['String']['output']>;
  ConversionFileLinkPreviousYear?: Maybe<Scalars['String']['output']>;
  ConversionNote?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  HasRequiredProductionIncreaseLabel?: Maybe<Scalars['String']['output']>;
  HasRequiredProductionIncreaseNote?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HighProductionNumberCheckNote?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ProductionFileUploadNote?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  WholeNumbersOnly?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsProductionStepBlockAgencyCommissionEndLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockAgencyCommissionStartLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockAgencyPremiumEndLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockAgencyPremiumStartLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockConversionFileLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockConversionFileLinkCurrentYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockConversionFileLinkPreviousYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockConversionNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockHasRequiredProductionIncreaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockHasRequiredProductionIncreaseNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockHighProductionNumberCheckNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockProductionFileUploadNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsProductionStepBlockWholeNumbersOnlyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsProductionStepBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsProductionStepBlockFacet';
  AgencyCommissionEndLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyCommissionStartLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyPremiumEndLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyPremiumStartLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ConversionFileLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ConversionFileLinkCurrentYear?: Maybe<Array<Maybe<StringFacet>>>;
  ConversionFileLinkPreviousYear?: Maybe<Array<Maybe<StringFacet>>>;
  ConversionNote?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  HasRequiredProductionIncreaseLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HasRequiredProductionIncreaseNote?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HighProductionNumberCheckNote?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionFileUploadNote?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  WholeNumbersOnly?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetAgencyCommissionEndLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetAgencyCommissionStartLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetAgencyPremiumEndLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetAgencyPremiumStartLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetConversionFileLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetConversionFileLinkCurrentYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetConversionFileLinkPreviousYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetConversionNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetHasRequiredProductionIncreaseLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetHasRequiredProductionIncreaseNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetHighProductionNumberCheckNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetProductionFileUploadNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsProductionStepBlockFacetWholeNumbersOnlyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsProductionStepBlockOrderByInput = {
  AgencyCommissionEndLabel?: InputMaybe<OrderBy>;
  AgencyCommissionStartLabel?: InputMaybe<OrderBy>;
  AgencyPremiumEndLabel?: InputMaybe<OrderBy>;
  AgencyPremiumStartLabel?: InputMaybe<OrderBy>;
  ConversionFileLabel?: InputMaybe<OrderBy>;
  ConversionFileLinkCurrentYear?: InputMaybe<OrderBy>;
  ConversionFileLinkPreviousYear?: InputMaybe<OrderBy>;
  ConversionNote?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  HasRequiredProductionIncreaseLabel?: InputMaybe<OrderBy>;
  HasRequiredProductionIncreaseNote?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HighProductionNumberCheckNote?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ProductionFileUploadNote?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  WholeNumbersOnly?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsProductionStepBlockWhereInput = {
  AgencyCommissionEndLabel?: InputMaybe<SearchableStringFilterInput>;
  AgencyCommissionStartLabel?: InputMaybe<SearchableStringFilterInput>;
  AgencyPremiumEndLabel?: InputMaybe<SearchableStringFilterInput>;
  AgencyPremiumStartLabel?: InputMaybe<SearchableStringFilterInput>;
  ConversionFileLabel?: InputMaybe<SearchableStringFilterInput>;
  ConversionFileLinkCurrentYear?: InputMaybe<SearchableStringFilterInput>;
  ConversionFileLinkPreviousYear?: InputMaybe<SearchableStringFilterInput>;
  ConversionNote?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  HasRequiredProductionIncreaseLabel?: InputMaybe<SearchableStringFilterInput>;
  HasRequiredProductionIncreaseNote?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HighProductionNumberCheckNote?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ProductionFileUploadNote?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  WholeNumbersOnly?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsRecruitmentStepBlock = {
  __typename?: 'GsAwardsPageGsAwardsRecruitmentStepBlock';
  Description?: Maybe<Scalars['String']['output']>;
  HasRequiredRecruitmentRateLabel?: Maybe<Scalars['String']['output']>;
  HasRequiredRecruitmentRateNote?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  RecruitmentFileUploadNote?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TotalAgentsAtTheBeginningLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsHiredLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsLockedFieldNote?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockHasRequiredRecruitmentRateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockHasRequiredRecruitmentRateNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockRecruitmentFileUploadNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockTotalAgentsAtTheBeginningLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockTotalAgentsHiredLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockTotalAgentsLockedFieldNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsRecruitmentStepBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsRecruitmentStepBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  HasRequiredRecruitmentRateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HasRequiredRecruitmentRateNote?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RecruitmentFileUploadNote?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsAtTheBeginningLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsHiredLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsLockedFieldNote?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockFacetHasRequiredRecruitmentRateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockFacetHasRequiredRecruitmentRateNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockFacetRecruitmentFileUploadNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockFacetTotalAgentsAtTheBeginningLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockFacetTotalAgentsHiredLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRecruitmentStepBlockFacetTotalAgentsLockedFieldNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsRecruitmentStepBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  HasRequiredRecruitmentRateLabel?: InputMaybe<OrderBy>;
  HasRequiredRecruitmentRateNote?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  RecruitmentFileUploadNote?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TotalAgentsAtTheBeginningLabel?: InputMaybe<OrderBy>;
  TotalAgentsHiredLabel?: InputMaybe<OrderBy>;
  TotalAgentsLockedFieldNote?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsRecruitmentStepBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  HasRequiredRecruitmentRateLabel?: InputMaybe<SearchableStringFilterInput>;
  HasRequiredRecruitmentRateNote?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  RecruitmentFileUploadNote?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsAtTheBeginningLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsHiredLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsLockedFieldNote?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsRetentionStepBlock = {
  __typename?: 'GsAwardsPageGsAwardsRetentionStepBlock';
  Description?: Maybe<Scalars['String']['output']>;
  HasRequiredRetentionRateLabel?: Maybe<Scalars['String']['output']>;
  HasRequiredRetentionRateNote?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  RetentionFileUploadNote?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TotalAgentsAtTheBeginningLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsRetainedLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsRetainedTooHigh?: Maybe<Scalars['String']['output']>;
  TotalAgentsRetainedTooLow?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockHasRequiredRetentionRateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockHasRequiredRetentionRateNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockRetentionFileUploadNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockTotalAgentsAtTheBeginningLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockTotalAgentsRetainedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockTotalAgentsRetainedTooHighArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockTotalAgentsRetainedTooLowArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsRetentionStepBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsRetentionStepBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  HasRequiredRetentionRateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HasRequiredRetentionRateNote?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RetentionFileUploadNote?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsAtTheBeginningLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsRetainedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsRetainedTooHigh?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsRetainedTooLow?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockFacetHasRequiredRetentionRateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockFacetHasRequiredRetentionRateNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockFacetRetentionFileUploadNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockFacetTotalAgentsAtTheBeginningLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockFacetTotalAgentsRetainedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockFacetTotalAgentsRetainedTooHighArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsRetentionStepBlockFacetTotalAgentsRetainedTooLowArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsRetentionStepBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  HasRequiredRetentionRateLabel?: InputMaybe<OrderBy>;
  HasRequiredRetentionRateNote?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  RetentionFileUploadNote?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TotalAgentsAtTheBeginningLabel?: InputMaybe<OrderBy>;
  TotalAgentsRetainedLabel?: InputMaybe<OrderBy>;
  TotalAgentsRetainedTooHigh?: InputMaybe<OrderBy>;
  TotalAgentsRetainedTooLow?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsRetentionStepBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  HasRequiredRetentionRateLabel?: InputMaybe<SearchableStringFilterInput>;
  HasRequiredRetentionRateNote?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  RetentionFileUploadNote?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsAtTheBeginningLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsRetainedLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsRetainedTooHigh?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsRetainedTooLow?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsSelectApplicantStepBlock = {
  __typename?: 'GsAwardsPageGsAwardsSelectApplicantStepBlock';
  ButtonApplyingForMyself?: Maybe<Scalars['String']['output']>;
  ButtonApplyingOnBehalf?: Maybe<Scalars['String']['output']>;
  ButtonGoBack?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ErrorDescriptionNotAMember?: Maybe<Scalars['String']['output']>;
  ErrorDescriptionNotInCompany?: Maybe<Scalars['String']['output']>;
  ErrorDescriptionUserNotFound?: Maybe<Scalars['String']['output']>;
  FooterDescription1?: Maybe<Scalars['String']['output']>;
  FooterDescription2?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HeadingApplyingOnBehalf?: Maybe<Scalars['String']['output']>;
  HeadingChooseApplicant?: Maybe<Scalars['String']['output']>;
  LabelApplyingOnBehalf?: Maybe<Scalars['String']['output']>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockButtonApplyingForMyselfArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockButtonApplyingOnBehalfArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockButtonGoBackArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockErrorDescriptionNotAMemberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockErrorDescriptionNotInCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockErrorDescriptionUserNotFoundArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFooterDescription1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFooterDescription2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockHeadingApplyingOnBehalfArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockHeadingChooseApplicantArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockLabelApplyingOnBehalfArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsSelectApplicantStepBlockFacet';
  ButtonApplyingForMyself?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonApplyingOnBehalf?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonGoBack?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorDescriptionNotAMember?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorDescriptionNotInCompany?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorDescriptionUserNotFound?: Maybe<Array<Maybe<StringFacet>>>;
  FooterDescription1?: Maybe<Array<Maybe<StringFacet>>>;
  FooterDescription2?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingApplyingOnBehalf?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingChooseApplicant?: Maybe<Array<Maybe<StringFacet>>>;
  LabelApplyingOnBehalf?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetButtonApplyingForMyselfArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetButtonApplyingOnBehalfArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetButtonGoBackArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetErrorDescriptionNotAMemberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetErrorDescriptionNotInCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetErrorDescriptionUserNotFoundArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetFooterDescription1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetFooterDescription2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetHeadingApplyingOnBehalfArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetHeadingChooseApplicantArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetLabelApplyingOnBehalfArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSelectApplicantStepBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsSelectApplicantStepBlockOrderByInput = {
  ButtonApplyingForMyself?: InputMaybe<OrderBy>;
  ButtonApplyingOnBehalf?: InputMaybe<OrderBy>;
  ButtonGoBack?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ErrorDescriptionNotAMember?: InputMaybe<OrderBy>;
  ErrorDescriptionNotInCompany?: InputMaybe<OrderBy>;
  ErrorDescriptionUserNotFound?: InputMaybe<OrderBy>;
  FooterDescription1?: InputMaybe<OrderBy>;
  FooterDescription2?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HeadingApplyingOnBehalf?: InputMaybe<OrderBy>;
  HeadingChooseApplicant?: InputMaybe<OrderBy>;
  LabelApplyingOnBehalf?: InputMaybe<OrderBy>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsSelectApplicantStepBlockWhereInput = {
  ButtonApplyingForMyself?: InputMaybe<SearchableStringFilterInput>;
  ButtonApplyingOnBehalf?: InputMaybe<SearchableStringFilterInput>;
  ButtonGoBack?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ErrorDescriptionNotAMember?: InputMaybe<SearchableStringFilterInput>;
  ErrorDescriptionNotInCompany?: InputMaybe<SearchableStringFilterInput>;
  ErrorDescriptionUserNotFound?: InputMaybe<SearchableStringFilterInput>;
  FooterDescription1?: InputMaybe<SearchableStringFilterInput>;
  FooterDescription2?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HeadingApplyingOnBehalf?: InputMaybe<SearchableStringFilterInput>;
  HeadingChooseApplicant?: InputMaybe<SearchableStringFilterInput>;
  LabelApplyingOnBehalf?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsSubmitStepBlock = {
  __typename?: 'GsAwardsPageGsAwardsSubmitStepBlock';
  AddressLine1Label?: Maybe<Scalars['String']['output']>;
  AddressLine2Label?: Maybe<Scalars['String']['output']>;
  AddressLine3Label?: Maybe<Scalars['String']['output']>;
  AgencyID?: Maybe<Scalars['String']['output']>;
  AgentIDLabel?: Maybe<Scalars['String']['output']>;
  AgentRetentionSatisfiedLabel?: Maybe<Scalars['String']['output']>;
  AliPaySubmitMessage?: Maybe<Scalars['String']['output']>;
  AnnualIncreaseInProductionSatisfiedLabel?: Maybe<Scalars['String']['output']>;
  AwardLineItemLabel?: Maybe<Scalars['String']['output']>;
  AwardType3CriteriaMet?: Maybe<Scalars['String']['output']>;
  AwardType4CriteriaMet?: Maybe<Scalars['String']['output']>;
  AwardType5CriteriaMet?: Maybe<Scalars['String']['output']>;
  AwardTypeBadgeText?: Maybe<Scalars['String']['output']>;
  CityLabel?: Maybe<Scalars['String']['output']>;
  CommissionAmountYear1Label?: Maybe<Scalars['String']['output']>;
  CommissionAmountYear2Label?: Maybe<Scalars['String']['output']>;
  CompanyPaidDuesLineItemLabel?: Maybe<Scalars['String']['output']>;
  CompanyVerificationFileUploadError?: Maybe<Scalars['String']['output']>;
  CompanyVerificationFormUploadLabel?: Maybe<Scalars['String']['output']>;
  CountryLabel?: Maybe<Scalars['String']['output']>;
  CountryMarketLabel?: Maybe<Scalars['String']['output']>;
  CreateOrderErrorMessage?: Maybe<Scalars['String']['output']>;
  CriteriaNotSatisfiedEmailText?: Maybe<Scalars['String']['output']>;
  CriteriaNotSatisfiedHeading?: Maybe<Scalars['String']['output']>;
  CriteriaNotSatisfiedReadMoreText?: Maybe<Scalars['String']['output']>;
  CriteriaNotSatisfiedText?: Maybe<Scalars['String']['output']>;
  CvcDeclinedErrorMessage?: Maybe<Scalars['String']['output']>;
  DateOfServiceLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignationsLabel?: Maybe<Scalars['String']['output']>;
  EmailLabel?: Maybe<Scalars['String']['output']>;
  ExpiredCardErrorMessage?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  InvalidCardNumberErrorMessage?: Maybe<Scalars['String']['output']>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreAspectLabel?: Maybe<Scalars['String']['output']>;
  MDRTCriteriaSatisfied?: Maybe<Scalars['String']['output']>;
  MDRTIDLabel?: Maybe<Scalars['String']['output']>;
  NameLabel?: Maybe<Scalars['String']['output']>;
  NewHiredAgentsLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  PaymentError?: Maybe<Scalars['String']['output']>;
  PaymentPending?: Maybe<Scalars['String']['output']>;
  PaymentRetry?: Maybe<Scalars['String']['output']>;
  PaymentSuccess?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PolicyPersistencySatisfiedLabel?: Maybe<Scalars['String']['output']>;
  PremiumAmountYear1Label?: Maybe<Scalars['String']['output']>;
  PremiumAmountYear2Label?: Maybe<Scalars['String']['output']>;
  PriceBreakdownLabel?: Maybe<Scalars['String']['output']>;
  RecruitmentRateSatisfiedLabel?: Maybe<Scalars['String']['output']>;
  RespondedToAllFeedbackRequestsLabel?: Maybe<Scalars['String']['output']>;
  RetainedPoliciesLabel?: Maybe<Scalars['String']['output']>;
  ServiceDescriptionLabel?: Maybe<Scalars['String']['output']>;
  StateProvinceLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsError?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsMembershipCriteriaLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsRetainedLabel?: Maybe<Scalars['String']['output']>;
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
  TotalPoliciesLabel?: Maybe<Scalars['String']['output']>;
  WholePersonCriteriaSatisfiedLabel?: Maybe<Scalars['String']['output']>;
  ZipCodeLabel?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAddressLine1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAddressLine2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAddressLine3LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAgencyIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAgentRetentionSatisfiedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAliPaySubmitMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAnnualIncreaseInProductionSatisfiedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAwardLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAwardType3CriteriaMetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAwardType4CriteriaMetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAwardType5CriteriaMetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockAwardTypeBadgeTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCommissionAmountYear1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCommissionAmountYear2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCompanyPaidDuesLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCompanyVerificationFileUploadErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCompanyVerificationFormUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCountryMarketLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCreateOrderErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCriteriaNotSatisfiedEmailTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCriteriaNotSatisfiedHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCriteriaNotSatisfiedReadMoreTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCriteriaNotSatisfiedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockCvcDeclinedErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockDateOfServiceLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockDesignationsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockEmailLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockExpiredCardErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockInvalidCardNumberErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockLearningEngagementScoreAspectLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockMdrtCriteriaSatisfiedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockMdrtidLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockNewHiredAgentsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockPaymentErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockPaymentPendingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockPaymentRetryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockPaymentSuccessArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockPolicyPersistencySatisfiedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockPremiumAmountYear1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockPremiumAmountYear2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockPriceBreakdownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockRecruitmentRateSatisfiedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockRespondedToAllFeedbackRequestsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockRetainedPoliciesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockServiceDescriptionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockStateProvinceLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockTermsAndConditionsErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockTermsAndConditionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockTotalAgentsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockTotalAgentsMembershipCriteriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockTotalAgentsRetainedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockTotalPoliciesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockWholePersonCriteriaSatisfiedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockZipCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsSubmitStepBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsSubmitStepBlockFacet';
  AddressLine1Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine2Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine3Label?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyID?: Maybe<Array<Maybe<StringFacet>>>;
  AgentIDLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentRetentionSatisfiedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AliPaySubmitMessage?: Maybe<Array<Maybe<StringFacet>>>;
  AnnualIncreaseInProductionSatisfiedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AwardLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AwardType3CriteriaMet?: Maybe<Array<Maybe<StringFacet>>>;
  AwardType4CriteriaMet?: Maybe<Array<Maybe<StringFacet>>>;
  AwardType5CriteriaMet?: Maybe<Array<Maybe<StringFacet>>>;
  AwardTypeBadgeText?: Maybe<Array<Maybe<StringFacet>>>;
  CityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionAmountYear1Label?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionAmountYear2Label?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPaidDuesLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyVerificationFileUploadError?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyVerificationFormUploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CountryMarketLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CreateOrderErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CriteriaNotSatisfiedEmailText?: Maybe<Array<Maybe<StringFacet>>>;
  CriteriaNotSatisfiedHeading?: Maybe<Array<Maybe<StringFacet>>>;
  CriteriaNotSatisfiedReadMoreText?: Maybe<Array<Maybe<StringFacet>>>;
  CriteriaNotSatisfiedText?: Maybe<Array<Maybe<StringFacet>>>;
  CvcDeclinedErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  DateOfServiceLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DesignationsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EmailLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExpiredCardErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  InvalidCardNumberErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreAspectLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTCriteriaSatisfied?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTIDLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NewHiredAgentsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentPending?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentRetry?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentSuccess?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PolicyPersistencySatisfiedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumAmountYear1Label?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumAmountYear2Label?: Maybe<Array<Maybe<StringFacet>>>;
  PriceBreakdownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RecruitmentRateSatisfiedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RespondedToAllFeedbackRequestsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RetainedPoliciesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceDescriptionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StateProvinceLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsError?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsMembershipCriteriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsRetainedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalPoliciesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  WholePersonCriteriaSatisfiedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ZipCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAddressLine1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAddressLine2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAddressLine3LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAgencyIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAgentRetentionSatisfiedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAliPaySubmitMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAnnualIncreaseInProductionSatisfiedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAwardLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAwardType3CriteriaMetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAwardType4CriteriaMetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAwardType5CriteriaMetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetAwardTypeBadgeTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCommissionAmountYear1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCommissionAmountYear2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCompanyPaidDuesLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCompanyVerificationFileUploadErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCompanyVerificationFormUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCountryMarketLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCreateOrderErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCriteriaNotSatisfiedEmailTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCriteriaNotSatisfiedHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCriteriaNotSatisfiedReadMoreTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCriteriaNotSatisfiedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetCvcDeclinedErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetDateOfServiceLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetDesignationsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetEmailLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetExpiredCardErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetInvalidCardNumberErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetLearningEngagementScoreAspectLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetMdrtCriteriaSatisfiedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetMdrtidLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetNewHiredAgentsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetPaymentErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetPaymentPendingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetPaymentRetryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetPaymentSuccessArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetPolicyPersistencySatisfiedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetPremiumAmountYear1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetPremiumAmountYear2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetPriceBreakdownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetRecruitmentRateSatisfiedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetRespondedToAllFeedbackRequestsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetRetainedPoliciesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetServiceDescriptionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetStateProvinceLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetTermsAndConditionsErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetTermsAndConditionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetTotalAgentsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetTotalAgentsMembershipCriteriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetTotalAgentsRetainedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetTotalPoliciesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetWholePersonCriteriaSatisfiedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsSubmitStepBlockFacetZipCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsSubmitStepBlockOrderByInput = {
  AddressLine1Label?: InputMaybe<OrderBy>;
  AddressLine2Label?: InputMaybe<OrderBy>;
  AddressLine3Label?: InputMaybe<OrderBy>;
  AgencyID?: InputMaybe<OrderBy>;
  AgentIDLabel?: InputMaybe<OrderBy>;
  AgentRetentionSatisfiedLabel?: InputMaybe<OrderBy>;
  AliPaySubmitMessage?: InputMaybe<OrderBy>;
  AnnualIncreaseInProductionSatisfiedLabel?: InputMaybe<OrderBy>;
  AwardLineItemLabel?: InputMaybe<OrderBy>;
  AwardType3CriteriaMet?: InputMaybe<OrderBy>;
  AwardType4CriteriaMet?: InputMaybe<OrderBy>;
  AwardType5CriteriaMet?: InputMaybe<OrderBy>;
  AwardTypeBadgeText?: InputMaybe<OrderBy>;
  CityLabel?: InputMaybe<OrderBy>;
  CommissionAmountYear1Label?: InputMaybe<OrderBy>;
  CommissionAmountYear2Label?: InputMaybe<OrderBy>;
  CompanyPaidDuesLineItemLabel?: InputMaybe<OrderBy>;
  CompanyVerificationFileUploadError?: InputMaybe<OrderBy>;
  CompanyVerificationFormUploadLabel?: InputMaybe<OrderBy>;
  CountryLabel?: InputMaybe<OrderBy>;
  CountryMarketLabel?: InputMaybe<OrderBy>;
  CreateOrderErrorMessage?: InputMaybe<OrderBy>;
  CriteriaNotSatisfiedEmailText?: InputMaybe<OrderBy>;
  CriteriaNotSatisfiedHeading?: InputMaybe<OrderBy>;
  CriteriaNotSatisfiedReadMoreText?: InputMaybe<OrderBy>;
  CriteriaNotSatisfiedText?: InputMaybe<OrderBy>;
  CvcDeclinedErrorMessage?: InputMaybe<OrderBy>;
  DateOfServiceLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DesignationsLabel?: InputMaybe<OrderBy>;
  EmailLabel?: InputMaybe<OrderBy>;
  ExpiredCardErrorMessage?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  InvalidCardNumberErrorMessage?: InputMaybe<OrderBy>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  LearningEngagementScoreAspectLabel?: InputMaybe<OrderBy>;
  MDRTCriteriaSatisfied?: InputMaybe<OrderBy>;
  MDRTIDLabel?: InputMaybe<OrderBy>;
  NameLabel?: InputMaybe<OrderBy>;
  NewHiredAgentsLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  PaymentError?: InputMaybe<OrderBy>;
  PaymentPending?: InputMaybe<OrderBy>;
  PaymentRetry?: InputMaybe<OrderBy>;
  PaymentSuccess?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PolicyPersistencySatisfiedLabel?: InputMaybe<OrderBy>;
  PremiumAmountYear1Label?: InputMaybe<OrderBy>;
  PremiumAmountYear2Label?: InputMaybe<OrderBy>;
  PriceBreakdownLabel?: InputMaybe<OrderBy>;
  RecruitmentRateSatisfiedLabel?: InputMaybe<OrderBy>;
  RespondedToAllFeedbackRequestsLabel?: InputMaybe<OrderBy>;
  RetainedPoliciesLabel?: InputMaybe<OrderBy>;
  ServiceDescriptionLabel?: InputMaybe<OrderBy>;
  StateProvinceLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TermsAndConditionsError?: InputMaybe<OrderBy>;
  TermsAndConditionsLabel?: InputMaybe<OrderBy>;
  TotalAgentsLabel?: InputMaybe<OrderBy>;
  TotalAgentsMembershipCriteriaLabel?: InputMaybe<OrderBy>;
  TotalAgentsRetainedLabel?: InputMaybe<OrderBy>;
  TotalDueLabel?: InputMaybe<OrderBy>;
  TotalPoliciesLabel?: InputMaybe<OrderBy>;
  WholePersonCriteriaSatisfiedLabel?: InputMaybe<OrderBy>;
  ZipCodeLabel?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsSubmitStepBlockWhereInput = {
  AddressLine1Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine2Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine3Label?: InputMaybe<SearchableStringFilterInput>;
  AgencyID?: InputMaybe<SearchableStringFilterInput>;
  AgentIDLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentRetentionSatisfiedLabel?: InputMaybe<SearchableStringFilterInput>;
  AliPaySubmitMessage?: InputMaybe<SearchableStringFilterInput>;
  AnnualIncreaseInProductionSatisfiedLabel?: InputMaybe<SearchableStringFilterInput>;
  AwardLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  AwardType3CriteriaMet?: InputMaybe<SearchableStringFilterInput>;
  AwardType4CriteriaMet?: InputMaybe<SearchableStringFilterInput>;
  AwardType5CriteriaMet?: InputMaybe<SearchableStringFilterInput>;
  AwardTypeBadgeText?: InputMaybe<SearchableStringFilterInput>;
  CityLabel?: InputMaybe<SearchableStringFilterInput>;
  CommissionAmountYear1Label?: InputMaybe<SearchableStringFilterInput>;
  CommissionAmountYear2Label?: InputMaybe<SearchableStringFilterInput>;
  CompanyPaidDuesLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyVerificationFileUploadError?: InputMaybe<SearchableStringFilterInput>;
  CompanyVerificationFormUploadLabel?: InputMaybe<SearchableStringFilterInput>;
  CountryLabel?: InputMaybe<SearchableStringFilterInput>;
  CountryMarketLabel?: InputMaybe<SearchableStringFilterInput>;
  CreateOrderErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  CriteriaNotSatisfiedEmailText?: InputMaybe<SearchableStringFilterInput>;
  CriteriaNotSatisfiedHeading?: InputMaybe<SearchableStringFilterInput>;
  CriteriaNotSatisfiedReadMoreText?: InputMaybe<SearchableStringFilterInput>;
  CriteriaNotSatisfiedText?: InputMaybe<SearchableStringFilterInput>;
  CvcDeclinedErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  DateOfServiceLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DesignationsLabel?: InputMaybe<SearchableStringFilterInput>;
  EmailLabel?: InputMaybe<SearchableStringFilterInput>;
  ExpiredCardErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  InvalidCardNumberErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreAspectLabel?: InputMaybe<SearchableStringFilterInput>;
  MDRTCriteriaSatisfied?: InputMaybe<SearchableStringFilterInput>;
  MDRTIDLabel?: InputMaybe<SearchableStringFilterInput>;
  NameLabel?: InputMaybe<SearchableStringFilterInput>;
  NewHiredAgentsLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentError?: InputMaybe<SearchableStringFilterInput>;
  PaymentPending?: InputMaybe<SearchableStringFilterInput>;
  PaymentRetry?: InputMaybe<SearchableStringFilterInput>;
  PaymentSuccess?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PolicyPersistencySatisfiedLabel?: InputMaybe<SearchableStringFilterInput>;
  PremiumAmountYear1Label?: InputMaybe<SearchableStringFilterInput>;
  PremiumAmountYear2Label?: InputMaybe<SearchableStringFilterInput>;
  PriceBreakdownLabel?: InputMaybe<SearchableStringFilterInput>;
  RecruitmentRateSatisfiedLabel?: InputMaybe<SearchableStringFilterInput>;
  RespondedToAllFeedbackRequestsLabel?: InputMaybe<SearchableStringFilterInput>;
  RetainedPoliciesLabel?: InputMaybe<SearchableStringFilterInput>;
  ServiceDescriptionLabel?: InputMaybe<SearchableStringFilterInput>;
  StateProvinceLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsError?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsMembershipCriteriaLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsRetainedLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalPoliciesLabel?: InputMaybe<SearchableStringFilterInput>;
  WholePersonCriteriaSatisfiedLabel?: InputMaybe<SearchableStringFilterInput>;
  ZipCodeLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsVerificationStepBlock = {
  __typename?: 'GsAwardsPageGsAwardsVerificationStepBlock';
  CompanyVerificationFormUploadLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  StepMembershipQualifying?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  StepPersistencyQualifying?: Maybe<Scalars['String']['output']>;
  StepProductionQualifyingLabel?: Maybe<Scalars['String']['output']>;
  StepRecruitmentQualifyingLabel?: Maybe<Scalars['String']['output']>;
  StepRetentionQualifyingLabel?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockCompanyVerificationFormUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockStepMembershipQualifyingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockStepPersistencyQualifyingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockStepProductionQualifyingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockStepRecruitmentQualifyingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockStepRetentionQualifyingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsVerificationStepBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsVerificationStepBlockFacet';
  CompanyVerificationFormUploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepMembershipQualifying?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StepPersistencyQualifying?: Maybe<Array<Maybe<StringFacet>>>;
  StepProductionQualifyingLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepRecruitmentQualifyingLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepRetentionQualifyingLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockFacetCompanyVerificationFormUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockFacetStepMembershipQualifyingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockFacetStepPersistencyQualifyingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockFacetStepProductionQualifyingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockFacetStepRecruitmentQualifyingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsVerificationStepBlockFacetStepRetentionQualifyingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsVerificationStepBlockOrderByInput = {
  CompanyVerificationFormUploadLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  StepMembershipQualifying?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StepPersistencyQualifying?: InputMaybe<OrderBy>;
  StepProductionQualifyingLabel?: InputMaybe<OrderBy>;
  StepRecruitmentQualifyingLabel?: InputMaybe<OrderBy>;
  StepRetentionQualifyingLabel?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsVerificationStepBlockWhereInput = {
  CompanyVerificationFormUploadLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  StepMembershipQualifying?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StepPersistencyQualifying?: InputMaybe<SearchableStringFilterInput>;
  StepProductionQualifyingLabel?: InputMaybe<SearchableStringFilterInput>;
  StepRecruitmentQualifyingLabel?: InputMaybe<SearchableStringFilterInput>;
  StepRetentionQualifyingLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageGsAwardsWholePersonStepBlock = {
  __typename?: 'GsAwardsPageGsAwardsWholePersonStepBlock';
  Description?: Maybe<Scalars['String']['output']>;
  DidRespondToFeedbackLabel?: Maybe<Scalars['String']['output']>;
  DidRespondToFeedbackNoLabel?: Maybe<Scalars['String']['output']>;
  DidRespondToFeedbackNote?: Maybe<Scalars['String']['output']>;
  HasSatisfiedWholePersonCriteriaLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreError?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreLabel?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreNote?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption1Label?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption1Value?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption2Label?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption2Value?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption3Hint?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption3Label?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption3Value?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption4Label?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption4Value?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ServiceDateHint?: Maybe<Scalars['String']['output']>;
  ServiceDateLabel?: Maybe<Scalars['String']['output']>;
  ServiceDescriptionLabel?: Maybe<Scalars['String']['output']>;
  ServiceDescriptionNote?: Maybe<Scalars['String']['output']>;
  ServiceFileUploadLabel?: Maybe<Scalars['String']['output']>;
  ServiceFileUploadNote?: Maybe<Scalars['String']['output']>;
  ServiceProofHeader?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockDidRespondToFeedbackLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockDidRespondToFeedbackNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockHasSatisfiedWholePersonCriteriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreOption1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreOption1ValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreOption2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreOption2ValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreOption3HintArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreOption3LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreOption3ValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreOption4LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockLearningEngagementScoreOption4ValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockServiceDateHintArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockServiceDateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockServiceDescriptionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockServiceDescriptionNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockServiceFileUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockServiceFileUploadNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockServiceProofHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageGsAwardsWholePersonStepBlockAutocomplete = {
  __typename?: 'GsAwardsPageGsAwardsWholePersonStepBlockAutocomplete';
  DidRespondToFeedbackNoLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockAutocompleteDidRespondToFeedbackNoLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsPageGsAwardsWholePersonStepBlockFacet = {
  __typename?: 'GsAwardsPageGsAwardsWholePersonStepBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DidRespondToFeedbackLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DidRespondToFeedbackNoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DidRespondToFeedbackNote?: Maybe<Array<Maybe<StringFacet>>>;
  HasSatisfiedWholePersonCriteriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreError?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreNote?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption1Label?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption1Value?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption2Label?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption2Value?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption3Hint?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption3Label?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption3Value?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption4Label?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption4Value?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceDateHint?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceDateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceDescriptionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceDescriptionNote?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceFileUploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceFileUploadNote?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceProofHeader?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetDidRespondToFeedbackLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetDidRespondToFeedbackNoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetDidRespondToFeedbackNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetHasSatisfiedWholePersonCriteriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption1ValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption2ValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption3HintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption3LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption3ValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption4LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption4ValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetServiceDateHintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetServiceDateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetServiceDescriptionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetServiceDescriptionNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetServiceFileUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetServiceFileUploadNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetServiceProofHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageGsAwardsWholePersonStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageGsAwardsWholePersonStepBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  DidRespondToFeedbackLabel?: InputMaybe<OrderBy>;
  DidRespondToFeedbackNoLabel?: InputMaybe<OrderBy>;
  DidRespondToFeedbackNote?: InputMaybe<OrderBy>;
  HasSatisfiedWholePersonCriteriaLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  LearningEngagementScoreError?: InputMaybe<OrderBy>;
  LearningEngagementScoreLabel?: InputMaybe<OrderBy>;
  LearningEngagementScoreNote?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption1Label?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption1Value?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption2Label?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption2Value?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption3Hint?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption3Label?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption3Value?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption4Label?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption4Value?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ServiceDateHint?: InputMaybe<OrderBy>;
  ServiceDateLabel?: InputMaybe<OrderBy>;
  ServiceDescriptionLabel?: InputMaybe<OrderBy>;
  ServiceDescriptionNote?: InputMaybe<OrderBy>;
  ServiceFileUploadLabel?: InputMaybe<OrderBy>;
  ServiceFileUploadNote?: InputMaybe<OrderBy>;
  ServiceProofHeader?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
};

export type GsAwardsPageGsAwardsWholePersonStepBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  DidRespondToFeedbackLabel?: InputMaybe<SearchableStringFilterInput>;
  DidRespondToFeedbackNoLabel?: InputMaybe<StringFilterInput>;
  DidRespondToFeedbackNote?: InputMaybe<SearchableStringFilterInput>;
  HasSatisfiedWholePersonCriteriaLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreError?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreLabel?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreNote?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption1Label?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption1Value?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption2Label?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption2Value?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption3Hint?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption3Label?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption3Value?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption4Label?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption4Value?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ServiceDateHint?: InputMaybe<SearchableStringFilterInput>;
  ServiceDateLabel?: InputMaybe<SearchableStringFilterInput>;
  ServiceDescriptionLabel?: InputMaybe<SearchableStringFilterInput>;
  ServiceDescriptionNote?: InputMaybe<SearchableStringFilterInput>;
  ServiceFileUploadLabel?: InputMaybe<SearchableStringFilterInput>;
  ServiceFileUploadNote?: InputMaybe<SearchableStringFilterInput>;
  ServiceProofHeader?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageImageBlock = {
  __typename?: 'GsAwardsPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type GsAwardsPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsAwardsPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsAwardsPageImageBlockAutocomplete = {
  __typename?: 'GsAwardsPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type GsAwardsPageImageBlockFacet = {
  __typename?: 'GsAwardsPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsAwardsPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GsAwardsPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsAwardsPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type GsAwardsPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type GsAwardsPageOrderByInput = {
  AccountLabel?: InputMaybe<OrderBy>;
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationsBlock?: InputMaybe<GsAwardsPageGsAwardsApplicationsBlockOrderByInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationStepBlock?: InputMaybe<GsAwardsPageGsAwardsConfirmationStepBlockOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  DiscardAndContinueButton?: InputMaybe<OrderBy>;
  ErrorModalDescription?: InputMaybe<OrderBy>;
  ErrorModalNotAuthorizedButton1Text?: InputMaybe<OrderBy>;
  ErrorModalNotAuthorizedButton2Text?: InputMaybe<OrderBy>;
  ErrorModalNotAuthorizedButton3Text?: InputMaybe<OrderBy>;
  ErrorModalNotAuthorizedDescription?: InputMaybe<OrderBy>;
  ErrorModalNotAuthorizedDescription2?: InputMaybe<OrderBy>;
  ErrorPageAwardsClosed?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FileMustBeUploadedModalContent?: InputMaybe<OrderBy>;
  FileUploadBlock?: InputMaybe<GsAwardsPageGsAwardsFileUploadBlockOrderByInput>;
  FormHasRequiredErrorsLabel?: InputMaybe<OrderBy>;
  GettingStartedStepBlock?: InputMaybe<GsAwardsPageGsAwardsGettingStartedStepBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeesTooltip?: InputMaybe<OrderBy>;
  LatinAlphabetErrorLabel?: InputMaybe<OrderBy>;
  LogoutLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipStepBlock?: InputMaybe<GsAwardsPageGsAwardsMembershipStepBlockOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<GsAwardsPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavHeadingLabel?: InputMaybe<OrderBy>;
  OptionalLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersistencyStepBlock?: InputMaybe<GsAwardsPageGsAwardsPersistencyStepBlockOrderByInput>;
  PhoneNumberErrorLabel?: InputMaybe<OrderBy>;
  PositiveNumberErrorLabel?: InputMaybe<OrderBy>;
  ProductionStepBlock?: InputMaybe<GsAwardsPageGsAwardsProductionStepBlockOrderByInput>;
  QuestionsHeading?: InputMaybe<OrderBy>;
  RecruitmentStepBlock?: InputMaybe<GsAwardsPageGsAwardsRecruitmentStepBlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RequiredErrorFieldLabel?: InputMaybe<OrderBy>;
  RetentionStepBlock?: InputMaybe<GsAwardsPageGsAwardsRetentionStepBlockOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  SaveAndContinueButton?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelectApplicantStepBlock?: InputMaybe<GsAwardsPageGsAwardsSelectApplicantStepBlockOrderByInput>;
  SelectLanguageHeading?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StayOnThePageButton?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubmitStepBlock?: InputMaybe<GsAwardsPageGsAwardsSubmitStepBlockOrderByInput>;
  ThumbnailImage?: InputMaybe<GsAwardsPageImageBlockOrderByInput>;
  TooBigNumberErrorLabel?: InputMaybe<OrderBy>;
  TotalDueLabel?: InputMaybe<OrderBy>;
  UnsavedChangesMessage?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VerificationStepBlock?: InputMaybe<GsAwardsPageGsAwardsVerificationStepBlockOrderByInput>;
  WholeNumberErrorLabel?: InputMaybe<OrderBy>;
  WholePersonStepBlock?: InputMaybe<GsAwardsPageGsAwardsWholePersonStepBlockOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsPageOutput = {
  __typename?: 'GsAwardsPageOutput';
  autocomplete?: Maybe<GsAwardsPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsPageFacet>;
  item?: Maybe<GsAwardsPage>;
  items?: Maybe<Array<Maybe<GsAwardsPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsPageWhereInput = {
  AccountLabel?: InputMaybe<SearchableStringFilterInput>;
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationsBlock?: InputMaybe<GsAwardsPageGsAwardsApplicationsBlockWhereInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationStepBlock?: InputMaybe<GsAwardsPageGsAwardsConfirmationStepBlockWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  DiscardAndContinueButton?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalDescription?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalNotAuthorizedButton1Text?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalNotAuthorizedButton2Text?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalNotAuthorizedButton3Text?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalNotAuthorizedDescription?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalNotAuthorizedDescription2?: InputMaybe<SearchableStringFilterInput>;
  ErrorPageAwardsClosed?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FileMustBeUploadedModalContent?: InputMaybe<SearchableStringFilterInput>;
  FileUploadBlock?: InputMaybe<GsAwardsPageGsAwardsFileUploadBlockWhereInput>;
  FormHasRequiredErrorsLabel?: InputMaybe<SearchableStringFilterInput>;
  GettingStartedStepBlock?: InputMaybe<GsAwardsPageGsAwardsGettingStartedStepBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeesTooltip?: InputMaybe<SearchableStringFilterInput>;
  LatinAlphabetErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  LogoutLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipStepBlock?: InputMaybe<GsAwardsPageGsAwardsMembershipStepBlockWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<GsAwardsPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavHeadingLabel?: InputMaybe<SearchableStringFilterInput>;
  OptionalLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersistencyStepBlock?: InputMaybe<GsAwardsPageGsAwardsPersistencyStepBlockWhereInput>;
  PhoneNumberErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  PositiveNumberErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  ProductionStepBlock?: InputMaybe<GsAwardsPageGsAwardsProductionStepBlockWhereInput>;
  QuestionsHeading?: InputMaybe<SearchableStringFilterInput>;
  RecruitmentStepBlock?: InputMaybe<GsAwardsPageGsAwardsRecruitmentStepBlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RequiredErrorFieldLabel?: InputMaybe<SearchableStringFilterInput>;
  RetentionStepBlock?: InputMaybe<GsAwardsPageGsAwardsRetentionStepBlockWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SaveAndContinueButton?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelectApplicantStepBlock?: InputMaybe<GsAwardsPageGsAwardsSelectApplicantStepBlockWhereInput>;
  SelectLanguageHeading?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StayOnThePageButton?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubmitStepBlock?: InputMaybe<GsAwardsPageGsAwardsSubmitStepBlockWhereInput>;
  ThumbnailImage?: InputMaybe<GsAwardsPageImageBlockWhereInput>;
  TooBigNumberErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
  UnsavedChangesMessage?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VerificationStepBlock?: InputMaybe<GsAwardsPageGsAwardsVerificationStepBlockWhereInput>;
  WholeNumberErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  WholePersonStepBlock?: InputMaybe<GsAwardsPageGsAwardsWholePersonStepBlockWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlock = IContent & IData & {
  __typename?: 'GsAwardsPersistencyStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DidAchievePersistencyRateLabel?: Maybe<Scalars['String']['output']>;
  DidAchievePersistencyRateNote?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersistencyFileUploadNote?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TotalPoliciesLabel?: Maybe<Scalars['String']['output']>;
  TotalPoliciesPersistedTooHigh?: Maybe<Scalars['String']['output']>;
  TotalPoliciesRetainedLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlockDidAchievePersistencyRateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlockDidAchievePersistencyRateNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlockPersistencyFileUploadNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlockTotalPoliciesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlockTotalPoliciesPersistedTooHighArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlockTotalPoliciesRetainedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsPersistencyStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsPersistencyStepBlockAutocomplete = {
  __typename?: 'GsAwardsPersistencyStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsPersistencyStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPersistencyStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPersistencyStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPersistencyStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPersistencyStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPersistencyStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPersistencyStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPersistencyStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPersistencyStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsPersistencyStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsPersistencyStepBlockFacet = {
  __typename?: 'GsAwardsPersistencyStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DidAchievePersistencyRateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DidAchievePersistencyRateNote?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersistencyFileUploadNote?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalPoliciesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalPoliciesPersistedTooHigh?: Maybe<Array<Maybe<StringFacet>>>;
  TotalPoliciesRetainedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsPersistencyStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsPersistencyStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsPersistencyStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetDidAchievePersistencyRateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetDidAchievePersistencyRateNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetPersistencyFileUploadNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsPersistencyStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsPersistencyStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsPersistencyStepBlockFacetTotalPoliciesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetTotalPoliciesPersistedTooHighArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetTotalPoliciesRetainedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsPersistencyStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsPersistencyStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DidAchievePersistencyRateLabel?: InputMaybe<OrderBy>;
  DidAchievePersistencyRateNote?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersistencyFileUploadNote?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalPoliciesLabel?: InputMaybe<OrderBy>;
  TotalPoliciesPersistedTooHigh?: InputMaybe<OrderBy>;
  TotalPoliciesRetainedLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsPersistencyStepBlockOutput = {
  __typename?: 'GsAwardsPersistencyStepBlockOutput';
  autocomplete?: Maybe<GsAwardsPersistencyStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsPersistencyStepBlockFacet>;
  item?: Maybe<GsAwardsPersistencyStepBlock>;
  items?: Maybe<Array<Maybe<GsAwardsPersistencyStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsPersistencyStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsPersistencyStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DidAchievePersistencyRateLabel?: InputMaybe<SearchableStringFilterInput>;
  DidAchievePersistencyRateNote?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersistencyFileUploadNote?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalPoliciesLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalPoliciesPersistedTooHigh?: InputMaybe<SearchableStringFilterInput>;
  TotalPoliciesRetainedLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsPersistencyStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsPersistencyStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsPersistencyStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlock = IContent & IData & {
  __typename?: 'GsAwardsProductionStepBlock';
  AgencyCommissionEndLabel?: Maybe<Scalars['String']['output']>;
  AgencyCommissionStartLabel?: Maybe<Scalars['String']['output']>;
  AgencyPremiumEndLabel?: Maybe<Scalars['String']['output']>;
  AgencyPremiumStartLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ConversionFileLabel?: Maybe<Scalars['String']['output']>;
  ConversionFileLinkCurrentYear?: Maybe<Scalars['String']['output']>;
  ConversionFileLinkPreviousYear?: Maybe<Scalars['String']['output']>;
  ConversionNote?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HasRequiredProductionIncreaseLabel?: Maybe<Scalars['String']['output']>;
  HasRequiredProductionIncreaseNote?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HighProductionNumberCheckNote?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  ProductionFileUploadNote?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WholeNumbersOnly?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockAgencyCommissionEndLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockAgencyCommissionStartLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockAgencyPremiumEndLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockAgencyPremiumStartLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockConversionFileLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockConversionFileLinkCurrentYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockConversionFileLinkPreviousYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockConversionNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockHasRequiredProductionIncreaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockHasRequiredProductionIncreaseNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockHighProductionNumberCheckNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockProductionFileUploadNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlockWholeNumbersOnlyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsProductionStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsProductionStepBlockAutocomplete = {
  __typename?: 'GsAwardsProductionStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsProductionStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsProductionStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsProductionStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsProductionStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsProductionStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsProductionStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsProductionStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsProductionStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsProductionStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsProductionStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsProductionStepBlockFacet = {
  __typename?: 'GsAwardsProductionStepBlockFacet';
  AgencyCommissionEndLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyCommissionStartLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyPremiumEndLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyPremiumStartLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ConversionFileLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ConversionFileLinkCurrentYear?: Maybe<Array<Maybe<StringFacet>>>;
  ConversionFileLinkPreviousYear?: Maybe<Array<Maybe<StringFacet>>>;
  ConversionNote?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HasRequiredProductionIncreaseLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HasRequiredProductionIncreaseNote?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HighProductionNumberCheckNote?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ProductionFileUploadNote?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WholeNumbersOnly?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsProductionStepBlockFacetAgencyCommissionEndLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetAgencyCommissionStartLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetAgencyPremiumEndLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetAgencyPremiumStartLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsProductionStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetConversionFileLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetConversionFileLinkCurrentYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetConversionFileLinkPreviousYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetConversionNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsProductionStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetHasRequiredProductionIncreaseLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetHasRequiredProductionIncreaseNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetHighProductionNumberCheckNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetProductionFileUploadNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsProductionStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsProductionStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsProductionStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacetWholeNumbersOnlyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsProductionStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsProductionStepBlockOrderByInput = {
  AgencyCommissionEndLabel?: InputMaybe<OrderBy>;
  AgencyCommissionStartLabel?: InputMaybe<OrderBy>;
  AgencyPremiumEndLabel?: InputMaybe<OrderBy>;
  AgencyPremiumStartLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ConversionFileLabel?: InputMaybe<OrderBy>;
  ConversionFileLinkCurrentYear?: InputMaybe<OrderBy>;
  ConversionFileLinkPreviousYear?: InputMaybe<OrderBy>;
  ConversionNote?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HasRequiredProductionIncreaseLabel?: InputMaybe<OrderBy>;
  HasRequiredProductionIncreaseNote?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HighProductionNumberCheckNote?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ProductionFileUploadNote?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WholeNumbersOnly?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsProductionStepBlockOutput = {
  __typename?: 'GsAwardsProductionStepBlockOutput';
  autocomplete?: Maybe<GsAwardsProductionStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsProductionStepBlockFacet>;
  item?: Maybe<GsAwardsProductionStepBlock>;
  items?: Maybe<Array<Maybe<GsAwardsProductionStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsProductionStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsProductionStepBlockWhereInput = {
  AgencyCommissionEndLabel?: InputMaybe<SearchableStringFilterInput>;
  AgencyCommissionStartLabel?: InputMaybe<SearchableStringFilterInput>;
  AgencyPremiumEndLabel?: InputMaybe<SearchableStringFilterInput>;
  AgencyPremiumStartLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ConversionFileLabel?: InputMaybe<SearchableStringFilterInput>;
  ConversionFileLinkCurrentYear?: InputMaybe<SearchableStringFilterInput>;
  ConversionFileLinkPreviousYear?: InputMaybe<SearchableStringFilterInput>;
  ConversionNote?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HasRequiredProductionIncreaseLabel?: InputMaybe<SearchableStringFilterInput>;
  HasRequiredProductionIncreaseNote?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HighProductionNumberCheckNote?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ProductionFileUploadNote?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WholeNumbersOnly?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsProductionStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsProductionStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsProductionStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlock = IContent & IData & {
  __typename?: 'GsAwardsRecruitmentStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HasRequiredRecruitmentRateLabel?: Maybe<Scalars['String']['output']>;
  HasRequiredRecruitmentRateNote?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RecruitmentFileUploadNote?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TotalAgentsAtTheBeginningLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsHiredLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsLockedFieldNote?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlockHasRequiredRecruitmentRateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlockHasRequiredRecruitmentRateNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlockRecruitmentFileUploadNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlockTotalAgentsAtTheBeginningLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlockTotalAgentsHiredLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlockTotalAgentsLockedFieldNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRecruitmentStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsRecruitmentStepBlockAutocomplete = {
  __typename?: 'GsAwardsRecruitmentStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsRecruitmentStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRecruitmentStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRecruitmentStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRecruitmentStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRecruitmentStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRecruitmentStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRecruitmentStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRecruitmentStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRecruitmentStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRecruitmentStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsRecruitmentStepBlockFacet = {
  __typename?: 'GsAwardsRecruitmentStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HasRequiredRecruitmentRateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HasRequiredRecruitmentRateNote?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RecruitmentFileUploadNote?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalAgentsAtTheBeginningLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsHiredLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsLockedFieldNote?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsRecruitmentStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsRecruitmentStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsRecruitmentStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetHasRequiredRecruitmentRateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetHasRequiredRecruitmentRateNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetRecruitmentFileUploadNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsRecruitmentStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsRecruitmentStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsRecruitmentStepBlockFacetTotalAgentsAtTheBeginningLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetTotalAgentsHiredLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetTotalAgentsLockedFieldNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRecruitmentStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsRecruitmentStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HasRequiredRecruitmentRateLabel?: InputMaybe<OrderBy>;
  HasRequiredRecruitmentRateNote?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RecruitmentFileUploadNote?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalAgentsAtTheBeginningLabel?: InputMaybe<OrderBy>;
  TotalAgentsHiredLabel?: InputMaybe<OrderBy>;
  TotalAgentsLockedFieldNote?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsRecruitmentStepBlockOutput = {
  __typename?: 'GsAwardsRecruitmentStepBlockOutput';
  autocomplete?: Maybe<GsAwardsRecruitmentStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsRecruitmentStepBlockFacet>;
  item?: Maybe<GsAwardsRecruitmentStepBlock>;
  items?: Maybe<Array<Maybe<GsAwardsRecruitmentStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsRecruitmentStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsRecruitmentStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HasRequiredRecruitmentRateLabel?: InputMaybe<SearchableStringFilterInput>;
  HasRequiredRecruitmentRateNote?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RecruitmentFileUploadNote?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalAgentsAtTheBeginningLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsHiredLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsLockedFieldNote?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsRecruitmentStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsRecruitmentStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsRecruitmentStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlock = IContent & IData & {
  __typename?: 'GsAwardsRetentionStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HasRequiredRetentionRateLabel?: Maybe<Scalars['String']['output']>;
  HasRequiredRetentionRateNote?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RetentionFileUploadNote?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TotalAgentsAtTheBeginningLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsRetainedLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsRetainedTooHigh?: Maybe<Scalars['String']['output']>;
  TotalAgentsRetainedTooLow?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockHasRequiredRetentionRateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockHasRequiredRetentionRateNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockRetentionFileUploadNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockTotalAgentsAtTheBeginningLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockTotalAgentsRetainedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockTotalAgentsRetainedTooHighArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlockTotalAgentsRetainedTooLowArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsRetentionStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsRetentionStepBlockAutocomplete = {
  __typename?: 'GsAwardsRetentionStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsRetentionStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRetentionStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRetentionStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRetentionStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRetentionStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRetentionStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRetentionStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRetentionStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRetentionStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsRetentionStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsRetentionStepBlockFacet = {
  __typename?: 'GsAwardsRetentionStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HasRequiredRetentionRateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HasRequiredRetentionRateNote?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RetentionFileUploadNote?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalAgentsAtTheBeginningLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsRetainedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsRetainedTooHigh?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsRetainedTooLow?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsRetentionStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsRetentionStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsRetentionStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetHasRequiredRetentionRateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetHasRequiredRetentionRateNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetRetentionFileUploadNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsRetentionStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsRetentionStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsRetentionStepBlockFacetTotalAgentsAtTheBeginningLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetTotalAgentsRetainedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetTotalAgentsRetainedTooHighArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetTotalAgentsRetainedTooLowArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsRetentionStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsRetentionStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HasRequiredRetentionRateLabel?: InputMaybe<OrderBy>;
  HasRequiredRetentionRateNote?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RetentionFileUploadNote?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalAgentsAtTheBeginningLabel?: InputMaybe<OrderBy>;
  TotalAgentsRetainedLabel?: InputMaybe<OrderBy>;
  TotalAgentsRetainedTooHigh?: InputMaybe<OrderBy>;
  TotalAgentsRetainedTooLow?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsRetentionStepBlockOutput = {
  __typename?: 'GsAwardsRetentionStepBlockOutput';
  autocomplete?: Maybe<GsAwardsRetentionStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsRetentionStepBlockFacet>;
  item?: Maybe<GsAwardsRetentionStepBlock>;
  items?: Maybe<Array<Maybe<GsAwardsRetentionStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsRetentionStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsRetentionStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HasRequiredRetentionRateLabel?: InputMaybe<SearchableStringFilterInput>;
  HasRequiredRetentionRateNote?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RetentionFileUploadNote?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalAgentsAtTheBeginningLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsRetainedLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsRetainedTooHigh?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsRetainedTooLow?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsRetentionStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsRetentionStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsRetentionStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlock = IContent & IData & {
  __typename?: 'GsAwardsSelectApplicantStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ButtonApplyingForMyself?: Maybe<Scalars['String']['output']>;
  ButtonApplyingOnBehalf?: Maybe<Scalars['String']['output']>;
  ButtonGoBack?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ErrorDescriptionNotAMember?: Maybe<Scalars['String']['output']>;
  ErrorDescriptionNotInCompany?: Maybe<Scalars['String']['output']>;
  ErrorDescriptionUserNotFound?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FooterDescription1?: Maybe<Scalars['String']['output']>;
  FooterDescription2?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HeadingApplyingOnBehalf?: Maybe<Scalars['String']['output']>;
  HeadingChooseApplicant?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  LabelApplyingOnBehalf?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockButtonApplyingForMyselfArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockButtonApplyingOnBehalfArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockButtonGoBackArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockErrorDescriptionNotAMemberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockErrorDescriptionNotInCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockErrorDescriptionUserNotFoundArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockFooterDescription1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockFooterDescription2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockHeadingApplyingOnBehalfArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockHeadingChooseApplicantArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockLabelApplyingOnBehalfArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSelectApplicantStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsSelectApplicantStepBlockAutocomplete = {
  __typename?: 'GsAwardsSelectApplicantStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsSelectApplicantStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSelectApplicantStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSelectApplicantStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSelectApplicantStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSelectApplicantStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSelectApplicantStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSelectApplicantStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSelectApplicantStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSelectApplicantStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSelectApplicantStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsSelectApplicantStepBlockFacet = {
  __typename?: 'GsAwardsSelectApplicantStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonApplyingForMyself?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonApplyingOnBehalf?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonGoBack?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorDescriptionNotAMember?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorDescriptionNotInCompany?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorDescriptionUserNotFound?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FooterDescription1?: Maybe<Array<Maybe<StringFacet>>>;
  FooterDescription2?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingApplyingOnBehalf?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingChooseApplicant?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  LabelApplyingOnBehalf?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsSelectApplicantStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetButtonApplyingForMyselfArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetButtonApplyingOnBehalfArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetButtonGoBackArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsSelectApplicantStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsSelectApplicantStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetErrorDescriptionNotAMemberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetErrorDescriptionNotInCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetErrorDescriptionUserNotFoundArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetFooterDescription1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetFooterDescription2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetHeadingApplyingOnBehalfArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetHeadingChooseApplicantArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetLabelApplyingOnBehalfArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsSelectApplicantStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsSelectApplicantStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsSelectApplicantStepBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSelectApplicantStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsSelectApplicantStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  ButtonApplyingForMyself?: InputMaybe<OrderBy>;
  ButtonApplyingOnBehalf?: InputMaybe<OrderBy>;
  ButtonGoBack?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ErrorDescriptionNotAMember?: InputMaybe<OrderBy>;
  ErrorDescriptionNotInCompany?: InputMaybe<OrderBy>;
  ErrorDescriptionUserNotFound?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FooterDescription1?: InputMaybe<OrderBy>;
  FooterDescription2?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HeadingApplyingOnBehalf?: InputMaybe<OrderBy>;
  HeadingChooseApplicant?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  LabelApplyingOnBehalf?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsSelectApplicantStepBlockOutput = {
  __typename?: 'GsAwardsSelectApplicantStepBlockOutput';
  autocomplete?: Maybe<GsAwardsSelectApplicantStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsSelectApplicantStepBlockFacet>;
  item?: Maybe<GsAwardsSelectApplicantStepBlock>;
  items?: Maybe<Array<Maybe<GsAwardsSelectApplicantStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsSelectApplicantStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsSelectApplicantStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  ButtonApplyingForMyself?: InputMaybe<SearchableStringFilterInput>;
  ButtonApplyingOnBehalf?: InputMaybe<SearchableStringFilterInput>;
  ButtonGoBack?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ErrorDescriptionNotAMember?: InputMaybe<SearchableStringFilterInput>;
  ErrorDescriptionNotInCompany?: InputMaybe<SearchableStringFilterInput>;
  ErrorDescriptionUserNotFound?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FooterDescription1?: InputMaybe<SearchableStringFilterInput>;
  FooterDescription2?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HeadingApplyingOnBehalf?: InputMaybe<SearchableStringFilterInput>;
  HeadingChooseApplicant?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  LabelApplyingOnBehalf?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsSelectApplicantStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsSelectApplicantStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsSelectApplicantStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlock = IContent & IData & {
  __typename?: 'GsAwardsSubmitStepBlock';
  AddressLine1Label?: Maybe<Scalars['String']['output']>;
  AddressLine2Label?: Maybe<Scalars['String']['output']>;
  AddressLine3Label?: Maybe<Scalars['String']['output']>;
  AgencyID?: Maybe<Scalars['String']['output']>;
  AgentIDLabel?: Maybe<Scalars['String']['output']>;
  AgentRetentionSatisfiedLabel?: Maybe<Scalars['String']['output']>;
  AliPaySubmitMessage?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnnualIncreaseInProductionSatisfiedLabel?: Maybe<Scalars['String']['output']>;
  AwardLineItemLabel?: Maybe<Scalars['String']['output']>;
  AwardType3CriteriaMet?: Maybe<Scalars['String']['output']>;
  AwardType4CriteriaMet?: Maybe<Scalars['String']['output']>;
  AwardType5CriteriaMet?: Maybe<Scalars['String']['output']>;
  AwardTypeBadgeText?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CityLabel?: Maybe<Scalars['String']['output']>;
  CommissionAmountYear1Label?: Maybe<Scalars['String']['output']>;
  CommissionAmountYear2Label?: Maybe<Scalars['String']['output']>;
  CompanyPaidDuesLineItemLabel?: Maybe<Scalars['String']['output']>;
  CompanyVerificationFileUploadError?: Maybe<Scalars['String']['output']>;
  CompanyVerificationFormUploadLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CountryLabel?: Maybe<Scalars['String']['output']>;
  CountryMarketLabel?: Maybe<Scalars['String']['output']>;
  CreateOrderErrorMessage?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  CriteriaNotSatisfiedEmailText?: Maybe<Scalars['String']['output']>;
  CriteriaNotSatisfiedHeading?: Maybe<Scalars['String']['output']>;
  CriteriaNotSatisfiedReadMoreText?: Maybe<Scalars['String']['output']>;
  CriteriaNotSatisfiedText?: Maybe<Scalars['String']['output']>;
  CvcDeclinedErrorMessage?: Maybe<Scalars['String']['output']>;
  DateOfServiceLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignationsLabel?: Maybe<Scalars['String']['output']>;
  EmailLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpiredCardErrorMessage?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  InvalidCardNumberErrorMessage?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreAspectLabel?: Maybe<Scalars['String']['output']>;
  MDRTCriteriaSatisfied?: Maybe<Scalars['String']['output']>;
  MDRTIDLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NameLabel?: Maybe<Scalars['String']['output']>;
  NewHiredAgentsLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentError?: Maybe<Scalars['String']['output']>;
  PaymentPending?: Maybe<Scalars['String']['output']>;
  PaymentRetry?: Maybe<Scalars['String']['output']>;
  PaymentSuccess?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PolicyPersistencySatisfiedLabel?: Maybe<Scalars['String']['output']>;
  PremiumAmountYear1Label?: Maybe<Scalars['String']['output']>;
  PremiumAmountYear2Label?: Maybe<Scalars['String']['output']>;
  PriceBreakdownLabel?: Maybe<Scalars['String']['output']>;
  RecruitmentRateSatisfiedLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RespondedToAllFeedbackRequestsLabel?: Maybe<Scalars['String']['output']>;
  RetainedPoliciesLabel?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  ServiceDescriptionLabel?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  StateProvinceLabel?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TermsAndConditionsError?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsMembershipCriteriaLabel?: Maybe<Scalars['String']['output']>;
  TotalAgentsRetainedLabel?: Maybe<Scalars['String']['output']>;
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
  TotalPoliciesLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WholePersonCriteriaSatisfiedLabel?: Maybe<Scalars['String']['output']>;
  ZipCodeLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAddressLine1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAddressLine2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAddressLine3LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAgencyIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAgentRetentionSatisfiedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAliPaySubmitMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAnnualIncreaseInProductionSatisfiedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAwardLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAwardType3CriteriaMetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAwardType4CriteriaMetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAwardType5CriteriaMetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockAwardTypeBadgeTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCommissionAmountYear1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCommissionAmountYear2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCompanyPaidDuesLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCompanyVerificationFileUploadErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCompanyVerificationFormUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCountryMarketLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCreateOrderErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCriteriaNotSatisfiedEmailTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCriteriaNotSatisfiedHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCriteriaNotSatisfiedReadMoreTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCriteriaNotSatisfiedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockCvcDeclinedErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockDateOfServiceLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockDesignationsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockEmailLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockExpiredCardErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockInvalidCardNumberErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockLearningEngagementScoreAspectLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockMdrtCriteriaSatisfiedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockMdrtidLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockNewHiredAgentsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockPaymentErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockPaymentPendingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockPaymentRetryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockPaymentSuccessArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockPolicyPersistencySatisfiedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockPremiumAmountYear1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockPremiumAmountYear2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockPriceBreakdownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockRecruitmentRateSatisfiedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockRespondedToAllFeedbackRequestsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockRetainedPoliciesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockServiceDescriptionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockStateProvinceLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockTermsAndConditionsErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockTermsAndConditionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockTotalAgentsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockTotalAgentsMembershipCriteriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockTotalAgentsRetainedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockTotalPoliciesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockWholePersonCriteriaSatisfiedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlockZipCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsSubmitStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsSubmitStepBlockAutocomplete = {
  __typename?: 'GsAwardsSubmitStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsSubmitStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSubmitStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSubmitStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSubmitStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSubmitStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSubmitStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSubmitStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSubmitStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSubmitStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsSubmitStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsSubmitStepBlockFacet = {
  __typename?: 'GsAwardsSubmitStepBlockFacet';
  AddressLine1Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine2Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine3Label?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyID?: Maybe<Array<Maybe<StringFacet>>>;
  AgentIDLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgentRetentionSatisfiedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AliPaySubmitMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnnualIncreaseInProductionSatisfiedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AwardLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AwardType3CriteriaMet?: Maybe<Array<Maybe<StringFacet>>>;
  AwardType4CriteriaMet?: Maybe<Array<Maybe<StringFacet>>>;
  AwardType5CriteriaMet?: Maybe<Array<Maybe<StringFacet>>>;
  AwardTypeBadgeText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionAmountYear1Label?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionAmountYear2Label?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPaidDuesLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyVerificationFileUploadError?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyVerificationFormUploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CountryMarketLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CreateOrderErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CriteriaNotSatisfiedEmailText?: Maybe<Array<Maybe<StringFacet>>>;
  CriteriaNotSatisfiedHeading?: Maybe<Array<Maybe<StringFacet>>>;
  CriteriaNotSatisfiedReadMoreText?: Maybe<Array<Maybe<StringFacet>>>;
  CriteriaNotSatisfiedText?: Maybe<Array<Maybe<StringFacet>>>;
  CvcDeclinedErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  DateOfServiceLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DesignationsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EmailLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpiredCardErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  InvalidCardNumberErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreAspectLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTCriteriaSatisfied?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTIDLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NewHiredAgentsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentPending?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentRetry?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentSuccess?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PolicyPersistencySatisfiedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumAmountYear1Label?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumAmountYear2Label?: Maybe<Array<Maybe<StringFacet>>>;
  PriceBreakdownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RecruitmentRateSatisfiedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RespondedToAllFeedbackRequestsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RetainedPoliciesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ServiceDescriptionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StateProvinceLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TermsAndConditionsError?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsMembershipCriteriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAgentsRetainedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalPoliciesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WholePersonCriteriaSatisfiedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ZipCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsSubmitStepBlockFacetAddressLine1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAddressLine2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAddressLine3LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAgencyIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAgentRetentionSatisfiedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAliPaySubmitMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAnnualIncreaseInProductionSatisfiedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAwardLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAwardType3CriteriaMetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAwardType4CriteriaMetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAwardType5CriteriaMetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetAwardTypeBadgeTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsSubmitStepBlockFacetCityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCommissionAmountYear1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCommissionAmountYear2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCompanyPaidDuesLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCompanyVerificationFileUploadErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCompanyVerificationFormUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCountryMarketLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCreateOrderErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsSubmitStepBlockFacetCriteriaNotSatisfiedEmailTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCriteriaNotSatisfiedHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCriteriaNotSatisfiedReadMoreTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCriteriaNotSatisfiedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetCvcDeclinedErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetDateOfServiceLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetDesignationsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetEmailLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetExpiredCardErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetInvalidCardNumberErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetLearningEngagementScoreAspectLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetMdrtCriteriaSatisfiedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetMdrtidLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetNewHiredAgentsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetPaymentErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetPaymentPendingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetPaymentRetryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetPaymentSuccessArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetPolicyPersistencySatisfiedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetPremiumAmountYear1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetPremiumAmountYear2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetPriceBreakdownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetRecruitmentRateSatisfiedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetRespondedToAllFeedbackRequestsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetRetainedPoliciesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsSubmitStepBlockFacetServiceDescriptionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsSubmitStepBlockFacetStateProvinceLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsSubmitStepBlockFacetTermsAndConditionsErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetTermsAndConditionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetTotalAgentsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetTotalAgentsMembershipCriteriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetTotalAgentsRetainedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetTotalPoliciesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetWholePersonCriteriaSatisfiedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacetZipCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsSubmitStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsSubmitStepBlockOrderByInput = {
  AddressLine1Label?: InputMaybe<OrderBy>;
  AddressLine2Label?: InputMaybe<OrderBy>;
  AddressLine3Label?: InputMaybe<OrderBy>;
  AgencyID?: InputMaybe<OrderBy>;
  AgentIDLabel?: InputMaybe<OrderBy>;
  AgentRetentionSatisfiedLabel?: InputMaybe<OrderBy>;
  AliPaySubmitMessage?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AnnualIncreaseInProductionSatisfiedLabel?: InputMaybe<OrderBy>;
  AwardLineItemLabel?: InputMaybe<OrderBy>;
  AwardType3CriteriaMet?: InputMaybe<OrderBy>;
  AwardType4CriteriaMet?: InputMaybe<OrderBy>;
  AwardType5CriteriaMet?: InputMaybe<OrderBy>;
  AwardTypeBadgeText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CityLabel?: InputMaybe<OrderBy>;
  CommissionAmountYear1Label?: InputMaybe<OrderBy>;
  CommissionAmountYear2Label?: InputMaybe<OrderBy>;
  CompanyPaidDuesLineItemLabel?: InputMaybe<OrderBy>;
  CompanyVerificationFileUploadError?: InputMaybe<OrderBy>;
  CompanyVerificationFormUploadLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CountryLabel?: InputMaybe<OrderBy>;
  CountryMarketLabel?: InputMaybe<OrderBy>;
  CreateOrderErrorMessage?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CriteriaNotSatisfiedEmailText?: InputMaybe<OrderBy>;
  CriteriaNotSatisfiedHeading?: InputMaybe<OrderBy>;
  CriteriaNotSatisfiedReadMoreText?: InputMaybe<OrderBy>;
  CriteriaNotSatisfiedText?: InputMaybe<OrderBy>;
  CvcDeclinedErrorMessage?: InputMaybe<OrderBy>;
  DateOfServiceLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DesignationsLabel?: InputMaybe<OrderBy>;
  EmailLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpiredCardErrorMessage?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  InvalidCardNumberErrorMessage?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  LearningEngagementScoreAspectLabel?: InputMaybe<OrderBy>;
  MDRTCriteriaSatisfied?: InputMaybe<OrderBy>;
  MDRTIDLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NameLabel?: InputMaybe<OrderBy>;
  NewHiredAgentsLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentError?: InputMaybe<OrderBy>;
  PaymentPending?: InputMaybe<OrderBy>;
  PaymentRetry?: InputMaybe<OrderBy>;
  PaymentSuccess?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PolicyPersistencySatisfiedLabel?: InputMaybe<OrderBy>;
  PremiumAmountYear1Label?: InputMaybe<OrderBy>;
  PremiumAmountYear2Label?: InputMaybe<OrderBy>;
  PriceBreakdownLabel?: InputMaybe<OrderBy>;
  RecruitmentRateSatisfiedLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RespondedToAllFeedbackRequestsLabel?: InputMaybe<OrderBy>;
  RetainedPoliciesLabel?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ServiceDescriptionLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  StateProvinceLabel?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TermsAndConditionsError?: InputMaybe<OrderBy>;
  TermsAndConditionsLabel?: InputMaybe<OrderBy>;
  TotalAgentsLabel?: InputMaybe<OrderBy>;
  TotalAgentsMembershipCriteriaLabel?: InputMaybe<OrderBy>;
  TotalAgentsRetainedLabel?: InputMaybe<OrderBy>;
  TotalDueLabel?: InputMaybe<OrderBy>;
  TotalPoliciesLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WholePersonCriteriaSatisfiedLabel?: InputMaybe<OrderBy>;
  ZipCodeLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsSubmitStepBlockOutput = {
  __typename?: 'GsAwardsSubmitStepBlockOutput';
  autocomplete?: Maybe<GsAwardsSubmitStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsSubmitStepBlockFacet>;
  item?: Maybe<GsAwardsSubmitStepBlock>;
  items?: Maybe<Array<Maybe<GsAwardsSubmitStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsSubmitStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsSubmitStepBlockWhereInput = {
  AddressLine1Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine2Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine3Label?: InputMaybe<SearchableStringFilterInput>;
  AgencyID?: InputMaybe<SearchableStringFilterInput>;
  AgentIDLabel?: InputMaybe<SearchableStringFilterInput>;
  AgentRetentionSatisfiedLabel?: InputMaybe<SearchableStringFilterInput>;
  AliPaySubmitMessage?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AnnualIncreaseInProductionSatisfiedLabel?: InputMaybe<SearchableStringFilterInput>;
  AwardLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  AwardType3CriteriaMet?: InputMaybe<SearchableStringFilterInput>;
  AwardType4CriteriaMet?: InputMaybe<SearchableStringFilterInput>;
  AwardType5CriteriaMet?: InputMaybe<SearchableStringFilterInput>;
  AwardTypeBadgeText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CityLabel?: InputMaybe<SearchableStringFilterInput>;
  CommissionAmountYear1Label?: InputMaybe<SearchableStringFilterInput>;
  CommissionAmountYear2Label?: InputMaybe<SearchableStringFilterInput>;
  CompanyPaidDuesLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyVerificationFileUploadError?: InputMaybe<SearchableStringFilterInput>;
  CompanyVerificationFormUploadLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CountryLabel?: InputMaybe<SearchableStringFilterInput>;
  CountryMarketLabel?: InputMaybe<SearchableStringFilterInput>;
  CreateOrderErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CriteriaNotSatisfiedEmailText?: InputMaybe<SearchableStringFilterInput>;
  CriteriaNotSatisfiedHeading?: InputMaybe<SearchableStringFilterInput>;
  CriteriaNotSatisfiedReadMoreText?: InputMaybe<SearchableStringFilterInput>;
  CriteriaNotSatisfiedText?: InputMaybe<SearchableStringFilterInput>;
  CvcDeclinedErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  DateOfServiceLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DesignationsLabel?: InputMaybe<SearchableStringFilterInput>;
  EmailLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpiredCardErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  InvalidCardNumberErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreAspectLabel?: InputMaybe<SearchableStringFilterInput>;
  MDRTCriteriaSatisfied?: InputMaybe<SearchableStringFilterInput>;
  MDRTIDLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NameLabel?: InputMaybe<SearchableStringFilterInput>;
  NewHiredAgentsLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentError?: InputMaybe<SearchableStringFilterInput>;
  PaymentPending?: InputMaybe<SearchableStringFilterInput>;
  PaymentRetry?: InputMaybe<SearchableStringFilterInput>;
  PaymentSuccess?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PolicyPersistencySatisfiedLabel?: InputMaybe<SearchableStringFilterInput>;
  PremiumAmountYear1Label?: InputMaybe<SearchableStringFilterInput>;
  PremiumAmountYear2Label?: InputMaybe<SearchableStringFilterInput>;
  PriceBreakdownLabel?: InputMaybe<SearchableStringFilterInput>;
  RecruitmentRateSatisfiedLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RespondedToAllFeedbackRequestsLabel?: InputMaybe<SearchableStringFilterInput>;
  RetainedPoliciesLabel?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ServiceDescriptionLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  StateProvinceLabel?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TermsAndConditionsError?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsMembershipCriteriaLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAgentsRetainedLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalPoliciesLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WholePersonCriteriaSatisfiedLabel?: InputMaybe<SearchableStringFilterInput>;
  ZipCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsSubmitStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsSubmitStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsSubmitStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlock = IContent & IData & {
  __typename?: 'GsAwardsVerificationStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyVerificationFormUploadLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StepMembershipQualifying?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  StepPersistencyQualifying?: Maybe<Scalars['String']['output']>;
  StepProductionQualifyingLabel?: Maybe<Scalars['String']['output']>;
  StepRecruitmentQualifyingLabel?: Maybe<Scalars['String']['output']>;
  StepRetentionQualifyingLabel?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlockCompanyVerificationFormUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlockStepMembershipQualifyingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlockStepPersistencyQualifyingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlockStepProductionQualifyingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlockStepRecruitmentQualifyingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlockStepRetentionQualifyingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsVerificationStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsVerificationStepBlockAutocomplete = {
  __typename?: 'GsAwardsVerificationStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsVerificationStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsVerificationStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsVerificationStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsVerificationStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsVerificationStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsVerificationStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsVerificationStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsVerificationStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsVerificationStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsVerificationStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsVerificationStepBlockFacet = {
  __typename?: 'GsAwardsVerificationStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyVerificationFormUploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepMembershipQualifying?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StepPersistencyQualifying?: Maybe<Array<Maybe<StringFacet>>>;
  StepProductionQualifyingLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepRecruitmentQualifyingLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepRetentionQualifyingLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsVerificationStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsVerificationStepBlockFacetCompanyVerificationFormUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsVerificationStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsVerificationStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsVerificationStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetStepMembershipQualifyingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetStepPersistencyQualifyingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetStepProductionQualifyingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetStepRecruitmentQualifyingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetStepRetentionQualifyingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsVerificationStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsVerificationStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsVerificationStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyVerificationFormUploadLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepMembershipQualifying?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StepPersistencyQualifying?: InputMaybe<OrderBy>;
  StepProductionQualifyingLabel?: InputMaybe<OrderBy>;
  StepRecruitmentQualifyingLabel?: InputMaybe<OrderBy>;
  StepRetentionQualifyingLabel?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsVerificationStepBlockOutput = {
  __typename?: 'GsAwardsVerificationStepBlockOutput';
  autocomplete?: Maybe<GsAwardsVerificationStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsVerificationStepBlockFacet>;
  item?: Maybe<GsAwardsVerificationStepBlock>;
  items?: Maybe<Array<Maybe<GsAwardsVerificationStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsVerificationStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsVerificationStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyVerificationFormUploadLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepMembershipQualifying?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StepPersistencyQualifying?: InputMaybe<SearchableStringFilterInput>;
  StepProductionQualifyingLabel?: InputMaybe<SearchableStringFilterInput>;
  StepRecruitmentQualifyingLabel?: InputMaybe<SearchableStringFilterInput>;
  StepRetentionQualifyingLabel?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsVerificationStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsVerificationStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsVerificationStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlock = IContent & IData & {
  __typename?: 'GsAwardsWholePersonStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DidRespondToFeedbackLabel?: Maybe<Scalars['String']['output']>;
  DidRespondToFeedbackNoLabel?: Maybe<Scalars['String']['output']>;
  DidRespondToFeedbackNote?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HasSatisfiedWholePersonCriteriaLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LearningEngagementScoreError?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreLabel?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreNote?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption1Label?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption1Value?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption2Label?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption2Value?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption3Hint?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption3Label?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption3Value?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption4Label?: Maybe<Scalars['String']['output']>;
  LearningEngagementScoreOption4Value?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  ServiceDateHint?: Maybe<Scalars['String']['output']>;
  ServiceDateLabel?: Maybe<Scalars['String']['output']>;
  ServiceDescriptionLabel?: Maybe<Scalars['String']['output']>;
  ServiceDescriptionNote?: Maybe<Scalars['String']['output']>;
  ServiceFileUploadLabel?: Maybe<Scalars['String']['output']>;
  ServiceFileUploadNote?: Maybe<Scalars['String']['output']>;
  ServiceProofHeader?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockDidRespondToFeedbackLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockDidRespondToFeedbackNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockHasSatisfiedWholePersonCriteriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreOption1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreOption1ValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreOption2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreOption2ValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreOption3HintArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreOption3LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreOption3ValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreOption4LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockLearningEngagementScoreOption4ValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockServiceDateHintArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockServiceDateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockServiceDescriptionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockServiceDescriptionNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockServiceFileUploadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockServiceFileUploadNoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockServiceProofHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Awards page */
export type GsAwardsWholePersonStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsAwardsWholePersonStepBlockAutocomplete = {
  __typename?: 'GsAwardsWholePersonStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DidRespondToFeedbackNoLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsAwardsWholePersonStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsWholePersonStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsWholePersonStepBlockAutocompleteDidRespondToFeedbackNoLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsWholePersonStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsWholePersonStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsWholePersonStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsWholePersonStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsWholePersonStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsWholePersonStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsWholePersonStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsAwardsWholePersonStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsAwardsWholePersonStepBlockFacet = {
  __typename?: 'GsAwardsWholePersonStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DidRespondToFeedbackLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DidRespondToFeedbackNoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DidRespondToFeedbackNote?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HasSatisfiedWholePersonCriteriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LearningEngagementScoreError?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreNote?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption1Label?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption1Value?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption2Label?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption2Value?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption3Hint?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption3Label?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption3Value?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption4Label?: Maybe<Array<Maybe<StringFacet>>>;
  LearningEngagementScoreOption4Value?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ServiceDateHint?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceDateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceDescriptionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceDescriptionNote?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceFileUploadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceFileUploadNote?: Maybe<Array<Maybe<StringFacet>>>;
  ServiceProofHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsAwardsWholePersonStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsWholePersonStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsWholePersonStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetDidRespondToFeedbackLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetDidRespondToFeedbackNoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetDidRespondToFeedbackNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetHasSatisfiedWholePersonCriteriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption1ValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption2ValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption3HintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption3LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption3ValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption4LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetLearningEngagementScoreOption4ValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsWholePersonStepBlockFacetServiceDateHintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetServiceDateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetServiceDescriptionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetServiceDescriptionNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetServiceFileUploadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetServiceFileUploadNoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetServiceProofHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsWholePersonStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsAwardsWholePersonStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsAwardsWholePersonStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsAwardsWholePersonStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DidRespondToFeedbackLabel?: InputMaybe<OrderBy>;
  DidRespondToFeedbackNoLabel?: InputMaybe<OrderBy>;
  DidRespondToFeedbackNote?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HasSatisfiedWholePersonCriteriaLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LearningEngagementScoreError?: InputMaybe<OrderBy>;
  LearningEngagementScoreLabel?: InputMaybe<OrderBy>;
  LearningEngagementScoreNote?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption1Label?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption1Value?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption2Label?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption2Value?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption3Hint?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption3Label?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption3Value?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption4Label?: InputMaybe<OrderBy>;
  LearningEngagementScoreOption4Value?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ServiceDateHint?: InputMaybe<OrderBy>;
  ServiceDateLabel?: InputMaybe<OrderBy>;
  ServiceDescriptionLabel?: InputMaybe<OrderBy>;
  ServiceDescriptionNote?: InputMaybe<OrderBy>;
  ServiceFileUploadLabel?: InputMaybe<OrderBy>;
  ServiceFileUploadNote?: InputMaybe<OrderBy>;
  ServiceProofHeader?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsAwardsWholePersonStepBlockOutput = {
  __typename?: 'GsAwardsWholePersonStepBlockOutput';
  autocomplete?: Maybe<GsAwardsWholePersonStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsAwardsWholePersonStepBlockFacet>;
  item?: Maybe<GsAwardsWholePersonStepBlock>;
  items?: Maybe<Array<Maybe<GsAwardsWholePersonStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsAwardsWholePersonStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsAwardsWholePersonStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DidRespondToFeedbackLabel?: InputMaybe<SearchableStringFilterInput>;
  DidRespondToFeedbackNoLabel?: InputMaybe<StringFilterInput>;
  DidRespondToFeedbackNote?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HasSatisfiedWholePersonCriteriaLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LearningEngagementScoreError?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreLabel?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreNote?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption1Label?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption1Value?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption2Label?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption2Value?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption3Hint?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption3Label?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption3Value?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption4Label?: InputMaybe<SearchableStringFilterInput>;
  LearningEngagementScoreOption4Value?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ServiceDateHint?: InputMaybe<SearchableStringFilterInput>;
  ServiceDateLabel?: InputMaybe<SearchableStringFilterInput>;
  ServiceDescriptionLabel?: InputMaybe<SearchableStringFilterInput>;
  ServiceDescriptionNote?: InputMaybe<SearchableStringFilterInput>;
  ServiceFileUploadLabel?: InputMaybe<SearchableStringFilterInput>;
  ServiceFileUploadNote?: InputMaybe<SearchableStringFilterInput>;
  ServiceProofHeader?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsAwardsWholePersonStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsAwardsWholePersonStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsAwardsWholePersonStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type GsConfirmationStepBlock = IContent & IData & {
  __typename?: 'GsConfirmationStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Use text {{email}} to insert the user's email */
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkSectionHeading?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SvgLinkBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewReceiptLinkText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type GsConfirmationStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsConfirmationStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsConfirmationStepBlockLinkSectionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsConfirmationStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsConfirmationStepBlockSvgLinkBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsConfirmationStepBlockViewReceiptLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsConfirmationStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsConfirmationStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsConfirmationStepBlockAutocomplete = {
  __typename?: 'GsConfirmationStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsConfirmationStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsConfirmationStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsConfirmationStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsConfirmationStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsConfirmationStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsConfirmationStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsConfirmationStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsConfirmationStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsConfirmationStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsConfirmationStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsConfirmationStepBlockFacet = {
  __typename?: 'GsConfirmationStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkSectionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SvgLinkBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewReceiptLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsConfirmationStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsConfirmationStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsConfirmationStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GsConfirmationStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetLinkSectionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsConfirmationStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsConfirmationStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsConfirmationStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacetViewReceiptLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsConfirmationStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsConfirmationStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkSectionHeading?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  ViewReceiptLinkText?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsConfirmationStepBlockOutput = {
  __typename?: 'GsConfirmationStepBlockOutput';
  autocomplete?: Maybe<GsConfirmationStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsConfirmationStepBlockFacet>;
  item?: Maybe<GsConfirmationStepBlock>;
  items?: Maybe<Array<Maybe<GsConfirmationStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsConfirmationStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsConfirmationStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkSectionHeading?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewReceiptLinkText?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsConfirmationStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsConfirmationStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsConfirmationStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlock = IContent & IData & {
  __typename?: 'GsGettingStartedStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** A description for the Ethical Complaint radio buttons section */
  EthicalComplaintDescription?: Maybe<Scalars['String']['output']>;
  /** A heading for the Ethical Complaint radio buttons section. Note: The 'Required' asterisk does not need to be added here (it will be automatic) */
  EthicalComplaintHeading?: Maybe<Scalars['String']['output']>;
  /** The description for the ethical complaint alert modal */
  EthicalComplaintModalDescription?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** A description for the Getting Started Form */
  FormDescription?: Maybe<Scalars['String']['output']>;
  /** Displayed on the form view */
  FormHeading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** The cancel button for the ethical complaint alert modal */
  ModalCancelLabel?: Maybe<Scalars['String']['output']>;
  /** The continue button for the ethical complaint alert modal */
  ModalContinueLabel?: Maybe<Scalars['String']['output']>;
  /** The footer for the ethical complaint alert modal */
  ModalFooter?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  UnableToProcessError?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockEthicalComplaintDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockEthicalComplaintHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockEthicalComplaintModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockFormDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockFormHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockModalCancelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockModalContinueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockModalFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlockUnableToProcessErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsGettingStartedStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsGettingStartedStepBlockAutocomplete = {
  __typename?: 'GsGettingStartedStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsGettingStartedStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGettingStartedStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGettingStartedStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGettingStartedStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGettingStartedStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGettingStartedStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGettingStartedStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGettingStartedStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGettingStartedStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGettingStartedStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsGettingStartedStepBlockFacet = {
  __typename?: 'GsGettingStartedStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EthicalComplaintDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormHeading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  ModalCancelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ModalContinueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ModalFooter?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  UnableToProcessError?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsGettingStartedStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsGettingStartedStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsGettingStartedStepBlockFacetEthicalComplaintDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetEthicalComplaintHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetEthicalComplaintModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetFormDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetFormHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetModalCancelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetModalContinueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetModalFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsGettingStartedStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsGettingStartedStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsGettingStartedStepBlockFacetUnableToProcessErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGettingStartedStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsGettingStartedStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EthicalComplaintDescription?: InputMaybe<OrderBy>;
  EthicalComplaintHeading?: InputMaybe<OrderBy>;
  EthicalComplaintModalDescription?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormDescription?: InputMaybe<OrderBy>;
  FormHeading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  ModalCancelLabel?: InputMaybe<OrderBy>;
  ModalContinueLabel?: InputMaybe<OrderBy>;
  ModalFooter?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  UnableToProcessError?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsGettingStartedStepBlockOutput = {
  __typename?: 'GsGettingStartedStepBlockOutput';
  autocomplete?: Maybe<GsGettingStartedStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsGettingStartedStepBlockFacet>;
  item?: Maybe<GsGettingStartedStepBlock>;
  items?: Maybe<Array<Maybe<GsGettingStartedStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsGettingStartedStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsGettingStartedStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EthicalComplaintDescription?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintHeading?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintModalDescription?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormDescription?: InputMaybe<SearchableStringFilterInput>;
  FormHeading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  ModalCancelLabel?: InputMaybe<SearchableStringFilterInput>;
  ModalContinueLabel?: InputMaybe<SearchableStringFilterInput>;
  ModalFooter?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  UnableToProcessError?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsGettingStartedStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsGettingStartedStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsGettingStartedStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type GsGreetingStepBlock = IContent & IData & {
  __typename?: 'GsGreetingStepBlock';
  AfternoonHeading?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicationSubmittedByCompanyAdminHeading?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Use {{membershipYear}} to replace with the users number of years as a member */
  Description?: Maybe<Scalars['String']['output']>;
  EveningHeading?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstTimeMemberDescriptionText?: Maybe<Scalars['String']['output']>;
  FirstTimeMemberHeadingText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HelpContactInfo?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentMade?: Maybe<Scalars['String']['output']>;
  PaymentNotMade?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type GsGreetingStepBlockAfternoonHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockApplicationSubmittedByCompanyAdminHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockEveningHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockFirstTimeMemberDescriptionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockFirstTimeMemberHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockHelpContactInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockPaymentMadeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockPaymentNotMadeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsGreetingStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsGreetingStepBlockAutocomplete = {
  __typename?: 'GsGreetingStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsGreetingStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGreetingStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGreetingStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGreetingStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGreetingStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGreetingStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGreetingStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGreetingStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGreetingStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsGreetingStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsGreetingStepBlockFacet = {
  __typename?: 'GsGreetingStepBlockFacet';
  AfternoonHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationSubmittedByCompanyAdminHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EveningHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstTimeMemberDescriptionText?: Maybe<Array<Maybe<StringFacet>>>;
  FirstTimeMemberHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HelpContactInfo?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentMade?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentNotMade?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsGreetingStepBlockFacetAfternoonHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetApplicationSubmittedByCompanyAdminHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsGreetingStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsGreetingStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetEveningHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetFirstTimeMemberDescriptionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetFirstTimeMemberHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetHelpContactInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetPaymentMadeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetPaymentNotMadeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsGreetingStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsGreetingStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsGreetingStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsGreetingStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsGreetingStepBlockOrderByInput = {
  AfternoonHeading?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationSubmittedByCompanyAdminHeading?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EveningHeading?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstTimeMemberDescriptionText?: InputMaybe<OrderBy>;
  FirstTimeMemberHeadingText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HelpContactInfo?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentMade?: InputMaybe<OrderBy>;
  PaymentNotMade?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsGreetingStepBlockOutput = {
  __typename?: 'GsGreetingStepBlockOutput';
  autocomplete?: Maybe<GsGreetingStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsGreetingStepBlockFacet>;
  item?: Maybe<GsGreetingStepBlock>;
  items?: Maybe<Array<Maybe<GsGreetingStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsGreetingStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsGreetingStepBlockWhereInput = {
  AfternoonHeading?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationSubmittedByCompanyAdminHeading?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EveningHeading?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstTimeMemberDescriptionText?: InputMaybe<SearchableStringFilterInput>;
  FirstTimeMemberHeadingText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HelpContactInfo?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentMade?: InputMaybe<SearchableStringFilterInput>;
  PaymentNotMade?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsGreetingStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsGreetingStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsGreetingStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlock = IContent & IData & {
  __typename?: 'GsLeadershipInformationStepBlock';
  AgentIdLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BusinessTitleLabel?: Maybe<Scalars['String']['output']>;
  BusinessTitlePlaceHolder?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExperienceDurationLabel?: Maybe<Scalars['String']['output']>;
  FieldLeaderRoleLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  ResponsibilityLabel?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VolunteerDescription?: Maybe<Scalars['String']['output']>;
  VolunteerLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockBusinessTitleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockBusinessTitlePlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockExperienceDurationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockFieldLeaderRoleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockResponsibilityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockVolunteerDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlockVolunteerLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsLeadershipInformationStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsLeadershipInformationStepBlockAutocomplete = {
  __typename?: 'GsLeadershipInformationStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsLeadershipInformationStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsLeadershipInformationStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsLeadershipInformationStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsLeadershipInformationStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsLeadershipInformationStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsLeadershipInformationStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsLeadershipInformationStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsLeadershipInformationStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsLeadershipInformationStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsLeadershipInformationStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsLeadershipInformationStepBlockFacet = {
  __typename?: 'GsLeadershipInformationStepBlockFacet';
  AgentIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessTitleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessTitlePlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExperienceDurationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FieldLeaderRoleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ResponsibilityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VolunteerDescription?: Maybe<Array<Maybe<StringFacet>>>;
  VolunteerLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsLeadershipInformationStepBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetBusinessTitleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetBusinessTitlePlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsLeadershipInformationStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsLeadershipInformationStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetExperienceDurationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetFieldLeaderRoleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetResponsibilityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsLeadershipInformationStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsLeadershipInformationStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsLeadershipInformationStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetVolunteerDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacetVolunteerLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsLeadershipInformationStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsLeadershipInformationStepBlockOrderByInput = {
  AgentIdLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BusinessTitleLabel?: InputMaybe<OrderBy>;
  BusinessTitlePlaceHolder?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExperienceDurationLabel?: InputMaybe<OrderBy>;
  FieldLeaderRoleLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  ResponsibilityLabel?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VolunteerDescription?: InputMaybe<OrderBy>;
  VolunteerLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsLeadershipInformationStepBlockOutput = {
  __typename?: 'GsLeadershipInformationStepBlockOutput';
  autocomplete?: Maybe<GsLeadershipInformationStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsLeadershipInformationStepBlockFacet>;
  item?: Maybe<GsLeadershipInformationStepBlock>;
  items?: Maybe<Array<Maybe<GsLeadershipInformationStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsLeadershipInformationStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsLeadershipInformationStepBlockWhereInput = {
  AgentIdLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BusinessTitleLabel?: InputMaybe<SearchableStringFilterInput>;
  BusinessTitlePlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExperienceDurationLabel?: InputMaybe<SearchableStringFilterInput>;
  FieldLeaderRoleLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ResponsibilityLabel?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VolunteerDescription?: InputMaybe<SearchableStringFilterInput>;
  VolunteerLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsLeadershipInformationStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsLeadershipInformationStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsLeadershipInformationStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for registration */
export type GsMembershipRenewalPage = IContent & IData & {
  __typename?: 'GsMembershipRenewalPage';
  AccountLabel?: Maybe<Scalars['String']['output']>;
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** Error modal message for mainland china. */
  ChinaErrorModalDescription?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Error message for Credly badge issue. */
  CredlyBadgeIssueError?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  /** General error modal message for 500s, 404s etc */
  ErrorModalDescription?: Maybe<Scalars['String']['output']>;
  /** Error message when a user isnt authorized */
  ErrorModalNotAuthorizedButton1Text?: Maybe<Scalars['String']['output']>;
  /** Error message when a user isnt authorized */
  ErrorModalNotAuthorizedButton2Text?: Maybe<Scalars['String']['output']>;
  /** Error message when a user isnt authorized */
  ErrorModalNotAuthorizedDescription?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  /** Error message when a user submits a form that has a field with a required error */
  FormHasRequiredErrorsLabel?: Maybe<Scalars['String']['output']>;
  /** The Confirmation step content */
  GsConfirmationStep?: Maybe<GsMembershipRenewalPageGsConfirmationStepBlock>;
  /** The Getting Started step content */
  GsGettingStartedStep?: Maybe<GsMembershipRenewalPageGsGettingStartedStepBlock>;
  /** The Getting Started step content */
  GsGreetingStepBlock?: Maybe<GsMembershipRenewalPageGsGreetingStepBlock>;
  /** The Leadership Information step content */
  GsLeadershipInformationStep?: Maybe<GsMembershipRenewalPageGsLeadershipInformationStepBlock>;
  /** The Profile step content */
  GsProfileStep?: Maybe<GsMembershipRenewalPageGsProfileStepBlock>;
  /** The Receipt step content */
  GsReceiptStep?: Maybe<GsMembershipRenewalPageGsReceiptStepBlock>;
  /** The Review step content */
  GsReviewStep?: Maybe<GsMembershipRenewalPageGsReviewStepBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeesTooltip?: Maybe<Scalars['String']['output']>;
  /** The label for your total due, shown beneath the steps */
  LogoutLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<GsMembershipRenewalPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NavHeadingLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  QuestionsHeading?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** Error message when a user doesn't enter a required field */
  RequiredErrorFieldLabel?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SelectLanguageHeading?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<GsMembershipRenewalPageImageBlock>;
  /** The label for your total due, shown beneath the steps */
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageAccountLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageChinaErrorModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageCredlyBadgeIssueErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageErrorModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageErrorModalNotAuthorizedButton1TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageErrorModalNotAuthorizedButton2TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageErrorModalNotAuthorizedDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageFormHasRequiredErrorsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageLateFeesTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageLogoutLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageNavHeadingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageQuestionsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageRequiredErrorFieldLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageSelectLanguageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPageTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type GsMembershipRenewalPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsMembershipRenewalPageAutocomplete = {
  __typename?: 'GsMembershipRenewalPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<GsMembershipRenewalPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<GsMembershipRenewalPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsMembershipRenewalPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsMembershipRenewalPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsMembershipRenewalPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsMembershipRenewalPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsMembershipRenewalPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsMembershipRenewalPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsMembershipRenewalPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsMembershipRenewalPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsMembershipRenewalPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsMembershipRenewalPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsMembershipRenewalPageFacet = {
  __typename?: 'GsMembershipRenewalPageFacet';
  AccountLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ChinaErrorModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CredlyBadgeIssueError?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalNotAuthorizedButton1Text?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalNotAuthorizedButton2Text?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalNotAuthorizedDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FormHasRequiredErrorsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GsConfirmationStep?: Maybe<GsMembershipRenewalPageGsConfirmationStepBlockFacet>;
  GsGettingStartedStep?: Maybe<GsMembershipRenewalPageGsGettingStartedStepBlockFacet>;
  GsGreetingStepBlock?: Maybe<GsMembershipRenewalPageGsGreetingStepBlockFacet>;
  GsLeadershipInformationStep?: Maybe<GsMembershipRenewalPageGsLeadershipInformationStepBlockFacet>;
  GsProfileStep?: Maybe<GsMembershipRenewalPageGsProfileStepBlockFacet>;
  GsReceiptStep?: Maybe<GsMembershipRenewalPageGsReceiptStepBlockFacet>;
  GsReviewStep?: Maybe<GsMembershipRenewalPageGsReviewStepBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeesTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<GsMembershipRenewalPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavHeadingLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  QuestionsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RequiredErrorFieldLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelectLanguageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<GsMembershipRenewalPageImageBlockFacet>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsMembershipRenewalPageFacetAccountLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsMembershipRenewalPageFacetChinaErrorModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GsMembershipRenewalPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsMembershipRenewalPageFacetCredlyBadgeIssueErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetErrorModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetErrorModalNotAuthorizedButton1TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetErrorModalNotAuthorizedButton2TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetErrorModalNotAuthorizedDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetFormHasRequiredErrorsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GsMembershipRenewalPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetLateFeesTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetLogoutLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetNavHeadingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetQuestionsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetRequiredErrorFieldLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsMembershipRenewalPageFacetSelectLanguageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsMembershipRenewalPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsMembershipRenewalPageFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsMembershipRenewalPageGsConfirmationStepBlock = {
  __typename?: 'GsMembershipRenewalPageGsConfirmationStepBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkSectionHeading?: Maybe<Scalars['String']['output']>;
  SvgLinkBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ViewReceiptLinkText?: Maybe<Scalars['String']['output']>;
};


export type GsMembershipRenewalPageGsConfirmationStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsConfirmationStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsConfirmationStepBlockLinkSectionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsConfirmationStepBlockSvgLinkBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsConfirmationStepBlockViewReceiptLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsMembershipRenewalPageGsConfirmationStepBlockFacet = {
  __typename?: 'GsMembershipRenewalPageGsConfirmationStepBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkSectionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SvgLinkBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  ViewReceiptLinkText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsMembershipRenewalPageGsConfirmationStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsConfirmationStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsConfirmationStepBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GsMembershipRenewalPageGsConfirmationStepBlockFacetLinkSectionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsConfirmationStepBlockFacetViewReceiptLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsMembershipRenewalPageGsConfirmationStepBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkSectionHeading?: InputMaybe<OrderBy>;
  SvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ViewReceiptLinkText?: InputMaybe<OrderBy>;
};

export type GsMembershipRenewalPageGsConfirmationStepBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkSectionHeading?: InputMaybe<SearchableStringFilterInput>;
  SvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ViewReceiptLinkText?: InputMaybe<SearchableStringFilterInput>;
};

export type GsMembershipRenewalPageGsGettingStartedStepBlock = {
  __typename?: 'GsMembershipRenewalPageGsGettingStartedStepBlock';
  EthicalComplaintDescription?: Maybe<Scalars['String']['output']>;
  EthicalComplaintHeading?: Maybe<Scalars['String']['output']>;
  EthicalComplaintModalDescription?: Maybe<Scalars['String']['output']>;
  FormDescription?: Maybe<Scalars['String']['output']>;
  FormHeading?: Maybe<Scalars['String']['output']>;
  ModalCancelLabel?: Maybe<Scalars['String']['output']>;
  ModalContinueLabel?: Maybe<Scalars['String']['output']>;
  ModalFooter?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  UnableToProcessError?: Maybe<Scalars['String']['output']>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockEthicalComplaintDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockEthicalComplaintHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockEthicalComplaintModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFormDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFormHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockModalCancelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockModalContinueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockModalFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockUnableToProcessErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsMembershipRenewalPageGsGettingStartedStepBlockFacet = {
  __typename?: 'GsMembershipRenewalPageGsGettingStartedStepBlockFacet';
  EthicalComplaintDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ModalCancelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ModalContinueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ModalFooter?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  UnableToProcessError?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFacetEthicalComplaintDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFacetEthicalComplaintHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFacetEthicalComplaintModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFacetFormDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFacetFormHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFacetModalCancelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFacetModalContinueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFacetModalFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGettingStartedStepBlockFacetUnableToProcessErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsMembershipRenewalPageGsGettingStartedStepBlockOrderByInput = {
  EthicalComplaintDescription?: InputMaybe<OrderBy>;
  EthicalComplaintHeading?: InputMaybe<OrderBy>;
  EthicalComplaintModalDescription?: InputMaybe<OrderBy>;
  FormDescription?: InputMaybe<OrderBy>;
  FormHeading?: InputMaybe<OrderBy>;
  ModalCancelLabel?: InputMaybe<OrderBy>;
  ModalContinueLabel?: InputMaybe<OrderBy>;
  ModalFooter?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  UnableToProcessError?: InputMaybe<OrderBy>;
};

export type GsMembershipRenewalPageGsGettingStartedStepBlockWhereInput = {
  EthicalComplaintDescription?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintHeading?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintModalDescription?: InputMaybe<SearchableStringFilterInput>;
  FormDescription?: InputMaybe<SearchableStringFilterInput>;
  FormHeading?: InputMaybe<SearchableStringFilterInput>;
  ModalCancelLabel?: InputMaybe<SearchableStringFilterInput>;
  ModalContinueLabel?: InputMaybe<SearchableStringFilterInput>;
  ModalFooter?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  UnableToProcessError?: InputMaybe<SearchableStringFilterInput>;
};

export type GsMembershipRenewalPageGsGreetingStepBlock = {
  __typename?: 'GsMembershipRenewalPageGsGreetingStepBlock';
  AfternoonHeading?: Maybe<Scalars['String']['output']>;
  ApplicationSubmittedByCompanyAdminHeading?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EveningHeading?: Maybe<Scalars['String']['output']>;
  FirstTimeMemberDescriptionText?: Maybe<Scalars['String']['output']>;
  FirstTimeMemberHeadingText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HelpContactInfo?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  PaymentMade?: Maybe<Scalars['String']['output']>;
  PaymentNotMade?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockAfternoonHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockApplicationSubmittedByCompanyAdminHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockEveningHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFirstTimeMemberDescriptionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFirstTimeMemberHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockHelpContactInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockPaymentMadeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockPaymentNotMadeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsMembershipRenewalPageGsGreetingStepBlockFacet = {
  __typename?: 'GsMembershipRenewalPageGsGreetingStepBlockFacet';
  AfternoonHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationSubmittedByCompanyAdminHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EveningHeading?: Maybe<Array<Maybe<StringFacet>>>;
  FirstTimeMemberDescriptionText?: Maybe<Array<Maybe<StringFacet>>>;
  FirstTimeMemberHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HelpContactInfo?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentMade?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentNotMade?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetAfternoonHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetApplicationSubmittedByCompanyAdminHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetEveningHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetFirstTimeMemberDescriptionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetFirstTimeMemberHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetHelpContactInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetPaymentMadeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetPaymentNotMadeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsGreetingStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsMembershipRenewalPageGsGreetingStepBlockOrderByInput = {
  AfternoonHeading?: InputMaybe<OrderBy>;
  ApplicationSubmittedByCompanyAdminHeading?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EveningHeading?: InputMaybe<OrderBy>;
  FirstTimeMemberDescriptionText?: InputMaybe<OrderBy>;
  FirstTimeMemberHeadingText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HelpContactInfo?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  PaymentMade?: InputMaybe<OrderBy>;
  PaymentNotMade?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
};

export type GsMembershipRenewalPageGsGreetingStepBlockWhereInput = {
  AfternoonHeading?: InputMaybe<SearchableStringFilterInput>;
  ApplicationSubmittedByCompanyAdminHeading?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EveningHeading?: InputMaybe<SearchableStringFilterInput>;
  FirstTimeMemberDescriptionText?: InputMaybe<SearchableStringFilterInput>;
  FirstTimeMemberHeadingText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HelpContactInfo?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentMade?: InputMaybe<SearchableStringFilterInput>;
  PaymentNotMade?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
};

export type GsMembershipRenewalPageGsLeadershipInformationStepBlock = {
  __typename?: 'GsMembershipRenewalPageGsLeadershipInformationStepBlock';
  AgentIdLabel?: Maybe<Scalars['String']['output']>;
  BusinessTitleLabel?: Maybe<Scalars['String']['output']>;
  BusinessTitlePlaceHolder?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExperienceDurationLabel?: Maybe<Scalars['String']['output']>;
  FieldLeaderRoleLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ResponsibilityLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  VolunteerDescription?: Maybe<Scalars['String']['output']>;
  VolunteerLabel?: Maybe<Scalars['String']['output']>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockBusinessTitleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockBusinessTitlePlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockExperienceDurationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFieldLeaderRoleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockResponsibilityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockVolunteerDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockVolunteerLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacet = {
  __typename?: 'GsMembershipRenewalPageGsLeadershipInformationStepBlockFacet';
  AgentIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessTitleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessTitlePlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExperienceDurationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FieldLeaderRoleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ResponsibilityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  VolunteerDescription?: Maybe<Array<Maybe<StringFacet>>>;
  VolunteerLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetBusinessTitleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetBusinessTitlePlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetExperienceDurationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetFieldLeaderRoleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetResponsibilityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetVolunteerDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsLeadershipInformationStepBlockFacetVolunteerLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsMembershipRenewalPageGsLeadershipInformationStepBlockOrderByInput = {
  AgentIdLabel?: InputMaybe<OrderBy>;
  BusinessTitleLabel?: InputMaybe<OrderBy>;
  BusinessTitlePlaceHolder?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExperienceDurationLabel?: InputMaybe<OrderBy>;
  FieldLeaderRoleLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ResponsibilityLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  VolunteerDescription?: InputMaybe<OrderBy>;
  VolunteerLabel?: InputMaybe<OrderBy>;
};

export type GsMembershipRenewalPageGsLeadershipInformationStepBlockWhereInput = {
  AgentIdLabel?: InputMaybe<SearchableStringFilterInput>;
  BusinessTitleLabel?: InputMaybe<SearchableStringFilterInput>;
  BusinessTitlePlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExperienceDurationLabel?: InputMaybe<SearchableStringFilterInput>;
  FieldLeaderRoleLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ResponsibilityLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  VolunteerDescription?: InputMaybe<SearchableStringFilterInput>;
  VolunteerLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type GsMembershipRenewalPageGsProfileStepBlock = {
  __typename?: 'GsMembershipRenewalPageGsProfileStepBlock';
  AddLocalAddressHelperText?: Maybe<Scalars['String']['output']>;
  AddLocalAddressLabel?: Maybe<Scalars['String']['output']>;
  AddressLine1FormatLabel?: Maybe<Scalars['String']['output']>;
  AddressLine1Label?: Maybe<Scalars['String']['output']>;
  AddressLine2Label?: Maybe<Scalars['String']['output']>;
  AddressLine3Label?: Maybe<Scalars['String']['output']>;
  AreaCodeLabel?: Maybe<Scalars['String']['output']>;
  CityLabel?: Maybe<Scalars['String']['output']>;
  CompanyAffiliationLabel?: Maybe<Scalars['String']['output']>;
  ContactInfoLabel?: Maybe<Scalars['String']['output']>;
  CountryLabel?: Maybe<Scalars['String']['output']>;
  DateOfBirthFormatLabel?: Maybe<Scalars['String']['output']>;
  DateOfBirthLabel?: Maybe<Scalars['String']['output']>;
  DateOfBirthLabelRangeValidationMessage?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EmailDirectoryPermissionText?: Maybe<Scalars['String']['output']>;
  GenderLabel?: Maybe<Scalars['String']['output']>;
  GeneralErrorText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsoCodeLabel?: Maybe<Scalars['String']['output']>;
  LocalAddressHeadingText?: Maybe<Scalars['String']['output']>;
  MailingAddressLabel?: Maybe<Scalars['String']['output']>;
  MemberDirectoryPermissionText?: Maybe<Scalars['String']['output']>;
  MobilePhoneHeading?: Maybe<Scalars['String']['output']>;
  MobilePhoneLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  OfficePhoneHeading?: Maybe<Scalars['String']['output']>;
  OfficePhoneLabel?: Maybe<Scalars['String']['output']>;
  OfficePhoneOrMobilePhoneValidation?: Maybe<Scalars['String']['output']>;
  PersonalCompanyLabel?: Maybe<Scalars['String']['output']>;
  PersonalCompanyOrAffiliationValidationMessage?: Maybe<Scalars['String']['output']>;
  PersonalInfoLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberFormatLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberInvalidMessage?: Maybe<Scalars['String']['output']>;
  PrimaryLanguageLabel?: Maybe<Scalars['String']['output']>;
  PrimaryLanguageTooltip?: Maybe<Scalars['String']['output']>;
  ProfessionalInfoLabel?: Maybe<Scalars['String']['output']>;
  RemoveLocalAddressHelperText?: Maybe<Scalars['String']['output']>;
  SmsPermissionText?: Maybe<Scalars['String']['output']>;
  StateLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  UseWesternCharactersMessage?: Maybe<Scalars['String']['output']>;
  ZipCodeLabel?: Maybe<Scalars['String']['output']>;
};


export type GsMembershipRenewalPageGsProfileStepBlockAddLocalAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockAddLocalAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockAddressLine1FormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockAddressLine1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockAddressLine2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockAddressLine3LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockAreaCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockCityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockCompanyAffiliationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockContactInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockDateOfBirthFormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockDateOfBirthLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockDateOfBirthLabelRangeValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockEmailDirectoryPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockGenderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockGeneralErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockIsoCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockLocalAddressHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockMailingAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockMemberDirectoryPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockMobilePhoneHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockMobilePhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockOfficePhoneHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockOfficePhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockOfficePhoneOrMobilePhoneValidationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockPersonalCompanyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockPersonalCompanyOrAffiliationValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockPersonalInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockPhoneNumberFormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockPhoneNumberInvalidMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockPrimaryLanguageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockPrimaryLanguageTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockProfessionalInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockRemoveLocalAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockSmsPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockStateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockUseWesternCharactersMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsProfileStepBlockZipCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsMembershipRenewalPageGsProfileStepBlockFacet = {
  __typename?: 'GsMembershipRenewalPageGsProfileStepBlockFacet';
  AddLocalAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  AddLocalAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1FormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine2Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine3Label?: Maybe<Array<Maybe<StringFacet>>>;
  AreaCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyAffiliationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContactInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DateOfBirthFormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DateOfBirthLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DateOfBirthLabelRangeValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EmailDirectoryPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  GenderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GeneralErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsoCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LocalAddressHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDirectoryPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  MobilePhoneHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MobilePhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneHeading?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneOrMobilePhoneValidation?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalCompanyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalCompanyOrAffiliationValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberFormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberInvalidMessage?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryLanguageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryLanguageTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveLocalAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  SmsPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  StateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  UseWesternCharactersMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ZipCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetAddLocalAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetAddLocalAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetAddressLine1FormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetAddressLine1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetAddressLine2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetAddressLine3LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetAreaCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetCityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetCompanyAffiliationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetContactInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetDateOfBirthFormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetDateOfBirthLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetDateOfBirthLabelRangeValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetEmailDirectoryPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetGenderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetGeneralErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetIsoCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetLocalAddressHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetMailingAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetMemberDirectoryPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetMobilePhoneHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetMobilePhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetOfficePhoneHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetOfficePhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetOfficePhoneOrMobilePhoneValidationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetPersonalCompanyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetPersonalCompanyOrAffiliationValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetPersonalInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetPhoneNumberFormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetPhoneNumberInvalidMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetPrimaryLanguageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetPrimaryLanguageTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetProfessionalInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetRemoveLocalAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetSmsPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetStateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetUseWesternCharactersMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsProfileStepBlockFacetZipCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsMembershipRenewalPageGsProfileStepBlockOrderByInput = {
  AddLocalAddressHelperText?: InputMaybe<OrderBy>;
  AddLocalAddressLabel?: InputMaybe<OrderBy>;
  AddressLine1FormatLabel?: InputMaybe<OrderBy>;
  AddressLine1Label?: InputMaybe<OrderBy>;
  AddressLine2Label?: InputMaybe<OrderBy>;
  AddressLine3Label?: InputMaybe<OrderBy>;
  AreaCodeLabel?: InputMaybe<OrderBy>;
  CityLabel?: InputMaybe<OrderBy>;
  CompanyAffiliationLabel?: InputMaybe<OrderBy>;
  ContactInfoLabel?: InputMaybe<OrderBy>;
  CountryLabel?: InputMaybe<OrderBy>;
  DateOfBirthFormatLabel?: InputMaybe<OrderBy>;
  DateOfBirthLabel?: InputMaybe<OrderBy>;
  DateOfBirthLabelRangeValidationMessage?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EmailDirectoryPermissionText?: InputMaybe<OrderBy>;
  GenderLabel?: InputMaybe<OrderBy>;
  GeneralErrorText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsoCodeLabel?: InputMaybe<OrderBy>;
  LocalAddressHeadingText?: InputMaybe<OrderBy>;
  MailingAddressLabel?: InputMaybe<OrderBy>;
  MemberDirectoryPermissionText?: InputMaybe<OrderBy>;
  MobilePhoneHeading?: InputMaybe<OrderBy>;
  MobilePhoneLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  OfficePhoneHeading?: InputMaybe<OrderBy>;
  OfficePhoneLabel?: InputMaybe<OrderBy>;
  OfficePhoneOrMobilePhoneValidation?: InputMaybe<OrderBy>;
  PersonalCompanyLabel?: InputMaybe<OrderBy>;
  PersonalCompanyOrAffiliationValidationMessage?: InputMaybe<OrderBy>;
  PersonalInfoLabel?: InputMaybe<OrderBy>;
  PhoneNumberFormatLabel?: InputMaybe<OrderBy>;
  PhoneNumberInvalidMessage?: InputMaybe<OrderBy>;
  PrimaryLanguageLabel?: InputMaybe<OrderBy>;
  PrimaryLanguageTooltip?: InputMaybe<OrderBy>;
  ProfessionalInfoLabel?: InputMaybe<OrderBy>;
  RemoveLocalAddressHelperText?: InputMaybe<OrderBy>;
  SmsPermissionText?: InputMaybe<OrderBy>;
  StateLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  UseWesternCharactersMessage?: InputMaybe<OrderBy>;
  ZipCodeLabel?: InputMaybe<OrderBy>;
};

export type GsMembershipRenewalPageGsProfileStepBlockWhereInput = {
  AddLocalAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  AddLocalAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1FormatLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine2Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine3Label?: InputMaybe<SearchableStringFilterInput>;
  AreaCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  CityLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyAffiliationLabel?: InputMaybe<SearchableStringFilterInput>;
  ContactInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  CountryLabel?: InputMaybe<SearchableStringFilterInput>;
  DateOfBirthFormatLabel?: InputMaybe<SearchableStringFilterInput>;
  DateOfBirthLabel?: InputMaybe<SearchableStringFilterInput>;
  DateOfBirthLabelRangeValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EmailDirectoryPermissionText?: InputMaybe<SearchableStringFilterInput>;
  GenderLabel?: InputMaybe<SearchableStringFilterInput>;
  GeneralErrorText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsoCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  LocalAddressHeadingText?: InputMaybe<SearchableStringFilterInput>;
  MailingAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  MemberDirectoryPermissionText?: InputMaybe<SearchableStringFilterInput>;
  MobilePhoneHeading?: InputMaybe<SearchableStringFilterInput>;
  MobilePhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneHeading?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneOrMobilePhoneValidation?: InputMaybe<SearchableStringFilterInput>;
  PersonalCompanyLabel?: InputMaybe<SearchableStringFilterInput>;
  PersonalCompanyOrAffiliationValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  PersonalInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberFormatLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberInvalidMessage?: InputMaybe<SearchableStringFilterInput>;
  PrimaryLanguageLabel?: InputMaybe<SearchableStringFilterInput>;
  PrimaryLanguageTooltip?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  RemoveLocalAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  SmsPermissionText?: InputMaybe<SearchableStringFilterInput>;
  StateLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  UseWesternCharactersMessage?: InputMaybe<SearchableStringFilterInput>;
  ZipCodeLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type GsMembershipRenewalPageGsReceiptStepBlock = {
  __typename?: 'GsMembershipRenewalPageGsReceiptStepBlock';
  AgentIdLabel?: Maybe<Scalars['String']['output']>;
  ApplicationDetailsHeading?: Maybe<Scalars['String']['output']>;
  BusinessTitleLabel?: Maybe<Scalars['String']['output']>;
  CardNumberLabel?: Maybe<Scalars['String']['output']>;
  CompanyNameLabel?: Maybe<Scalars['String']['output']>;
  CompanyPrepaymentLabel?: Maybe<Scalars['String']['output']>;
  CostBreakdownLabel?: Maybe<Scalars['String']['output']>;
  EthicsComplaintLabel?: Maybe<Scalars['String']['output']>;
  ExperienceDurationLabel?: Maybe<Scalars['String']['output']>;
  GoBackButtonLabel?: Maybe<Scalars['String']['output']>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  MdrtGsMembershipLabel?: Maybe<Scalars['String']['output']>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  MemberDetailsHeading?: Maybe<Scalars['String']['output']>;
  MemberNameLabel?: Maybe<Scalars['String']['output']>;
  OrderNumberLabel?: Maybe<Scalars['String']['output']>;
  PaymentDateLabel?: Maybe<Scalars['String']['output']>;
  PaymentDetailsLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PrintButtonLabel?: Maybe<Scalars['String']['output']>;
  ReceiptAddressText?: Maybe<Scalars['String']['output']>;
  ReceiptFaxLabel?: Maybe<Scalars['String']['output']>;
  ReceiptFaxNumber?: Maybe<Scalars['String']['output']>;
  ReceiptHeading?: Maybe<Scalars['String']['output']>;
  ReceiptPhoneLabel?: Maybe<Scalars['String']['output']>;
  ReceiptPhoneNumber?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsLabel?: Maybe<Scalars['String']['output']>;
  TotalAmountPaidLabel?: Maybe<Scalars['String']['output']>;
  VolunteerLabel?: Maybe<Scalars['String']['output']>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockApplicationDetailsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockBusinessTitleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockCardNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockCompanyNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockCompanyPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockCostBreakdownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockEthicsComplaintLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockExperienceDurationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockGoBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockMdrtGsMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockMemberDetailsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockMemberNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockOrderNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockPaymentDateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockPaymentDetailsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockPrintButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockReceiptAddressTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockReceiptFaxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockReceiptFaxNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockReceiptHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockReceiptPhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockReceiptPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockTermsAndConditionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockTotalAmountPaidLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockVolunteerLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsMembershipRenewalPageGsReceiptStepBlockFacet = {
  __typename?: 'GsMembershipRenewalPageGsReceiptStepBlockFacet';
  AgentIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationDetailsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessTitleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CardNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CostBreakdownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EthicsComplaintLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExperienceDurationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtGsMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDetailsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MemberNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OrderNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentDateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentDetailsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrintButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptAddressText?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptFaxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptFaxNumber?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptPhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptPhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAmountPaidLabel?: Maybe<Array<Maybe<StringFacet>>>;
  VolunteerLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetApplicationDetailsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetBusinessTitleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetCardNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetCompanyNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetCompanyPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetCostBreakdownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetEthicsComplaintLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetExperienceDurationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetGoBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetMdrtGsMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetMemberDetailsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetMemberNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetOrderNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetPaymentDateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetPaymentDetailsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetPrintButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetReceiptAddressTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetReceiptFaxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetReceiptFaxNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetReceiptHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetReceiptPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetReceiptPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetTermsAndConditionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetTotalAmountPaidLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReceiptStepBlockFacetVolunteerLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsMembershipRenewalPageGsReceiptStepBlockOrderByInput = {
  AgentIdLabel?: InputMaybe<OrderBy>;
  ApplicationDetailsHeading?: InputMaybe<OrderBy>;
  BusinessTitleLabel?: InputMaybe<OrderBy>;
  CardNumberLabel?: InputMaybe<OrderBy>;
  CompanyNameLabel?: InputMaybe<OrderBy>;
  CompanyPrepaymentLabel?: InputMaybe<OrderBy>;
  CostBreakdownLabel?: InputMaybe<OrderBy>;
  EthicsComplaintLabel?: InputMaybe<OrderBy>;
  ExperienceDurationLabel?: InputMaybe<OrderBy>;
  GoBackButtonLabel?: InputMaybe<OrderBy>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  MdrtGsMembershipLabel?: InputMaybe<OrderBy>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  MemberDetailsHeading?: InputMaybe<OrderBy>;
  MemberNameLabel?: InputMaybe<OrderBy>;
  OrderNumberLabel?: InputMaybe<OrderBy>;
  PaymentDateLabel?: InputMaybe<OrderBy>;
  PaymentDetailsLabel?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PrintButtonLabel?: InputMaybe<OrderBy>;
  ReceiptAddressText?: InputMaybe<OrderBy>;
  ReceiptFaxLabel?: InputMaybe<OrderBy>;
  ReceiptFaxNumber?: InputMaybe<OrderBy>;
  ReceiptHeading?: InputMaybe<OrderBy>;
  ReceiptPhoneLabel?: InputMaybe<OrderBy>;
  ReceiptPhoneNumber?: InputMaybe<OrderBy>;
  TermsAndConditionsLabel?: InputMaybe<OrderBy>;
  TotalAmountPaidLabel?: InputMaybe<OrderBy>;
  VolunteerLabel?: InputMaybe<OrderBy>;
};

export type GsMembershipRenewalPageGsReceiptStepBlockWhereInput = {
  AgentIdLabel?: InputMaybe<SearchableStringFilterInput>;
  ApplicationDetailsHeading?: InputMaybe<SearchableStringFilterInput>;
  BusinessTitleLabel?: InputMaybe<SearchableStringFilterInput>;
  CardNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyNameLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyPrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  CostBreakdownLabel?: InputMaybe<SearchableStringFilterInput>;
  EthicsComplaintLabel?: InputMaybe<SearchableStringFilterInput>;
  ExperienceDurationLabel?: InputMaybe<SearchableStringFilterInput>;
  GoBackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtGsMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  MemberDetailsHeading?: InputMaybe<SearchableStringFilterInput>;
  MemberNameLabel?: InputMaybe<SearchableStringFilterInput>;
  OrderNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentDateLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentDetailsLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PrintButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptAddressText?: InputMaybe<SearchableStringFilterInput>;
  ReceiptFaxLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptFaxNumber?: InputMaybe<SearchableStringFilterInput>;
  ReceiptHeading?: InputMaybe<SearchableStringFilterInput>;
  ReceiptPhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAmountPaidLabel?: InputMaybe<SearchableStringFilterInput>;
  VolunteerLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type GsMembershipRenewalPageGsReviewStepBlock = {
  __typename?: 'GsMembershipRenewalPageGsReviewStepBlock';
  AgentIdLabel?: Maybe<Scalars['String']['output']>;
  AliPaySubmitMessage?: Maybe<Scalars['String']['output']>;
  ApplicationSubmittedWaitingMessageText?: Maybe<Scalars['String']['output']>;
  BusinessTitleLabel?: Maybe<Scalars['String']['output']>;
  CompanyPaidDuesLineItemLabel?: Maybe<Scalars['String']['output']>;
  CreateOrderErrorMessage?: Maybe<Scalars['String']['output']>;
  CvcDeclinedErrorMessage?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EthicalRequirementsLabel?: Maybe<Scalars['String']['output']>;
  ExperienceDurationLabel?: Maybe<Scalars['String']['output']>;
  ExpiredCardErrorMessage?: Maybe<Scalars['String']['output']>;
  FieldLeaderRoleLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  InvalidCardNumberErrorMessage?: Maybe<Scalars['String']['output']>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  MdrtGsMembershipLabel?: Maybe<Scalars['String']['output']>;
  MembershipLineItemLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  PaymentError?: Maybe<Scalars['String']['output']>;
  PaymentPending?: Maybe<Scalars['String']['output']>;
  PaymentRetry?: Maybe<Scalars['String']['output']>;
  PaymentSuccess?: Maybe<Scalars['String']['output']>;
  PriceBreakdownLabel?: Maybe<Scalars['String']['output']>;
  ResponsibilityLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TermsAndAgreementsText?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsTooltip?: Maybe<Scalars['String']['output']>;
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
  VolunteerLabel?: Maybe<Scalars['String']['output']>;
};


export type GsMembershipRenewalPageGsReviewStepBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockAliPaySubmitMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockApplicationSubmittedWaitingMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockBusinessTitleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockCompanyPaidDuesLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockCreateOrderErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockCvcDeclinedErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockEthicalRequirementsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockExperienceDurationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockExpiredCardErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFieldLeaderRoleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockInvalidCardNumberErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockMdrtGsMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockMembershipLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockPaymentErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockPaymentPendingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockPaymentRetryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockPaymentSuccessArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockPriceBreakdownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockResponsibilityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockTermsAndAgreementsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockTermsAndConditionsTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageGsReviewStepBlockVolunteerLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsMembershipRenewalPageGsReviewStepBlockFacet = {
  __typename?: 'GsMembershipRenewalPageGsReviewStepBlockFacet';
  AgentIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AliPaySubmitMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationSubmittedWaitingMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessTitleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPaidDuesLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CreateOrderErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CvcDeclinedErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalRequirementsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExperienceDurationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExpiredCardErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  FieldLeaderRoleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  InvalidCardNumberErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtGsMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentPending?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentRetry?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentSuccess?: Maybe<Array<Maybe<StringFacet>>>;
  PriceBreakdownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ResponsibilityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndAgreementsText?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  VolunteerLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetAliPaySubmitMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetApplicationSubmittedWaitingMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetBusinessTitleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetCompanyPaidDuesLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetCreateOrderErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetCvcDeclinedErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetEthicalRequirementsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetExperienceDurationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetExpiredCardErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetFieldLeaderRoleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetInvalidCardNumberErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetMdrtGsMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetMembershipLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetPaymentErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetPaymentPendingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetPaymentRetryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetPaymentSuccessArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetPriceBreakdownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetResponsibilityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetTermsAndAgreementsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetTermsAndConditionsTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageGsReviewStepBlockFacetVolunteerLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsMembershipRenewalPageGsReviewStepBlockOrderByInput = {
  AgentIdLabel?: InputMaybe<OrderBy>;
  AliPaySubmitMessage?: InputMaybe<OrderBy>;
  ApplicationSubmittedWaitingMessageText?: InputMaybe<OrderBy>;
  BusinessTitleLabel?: InputMaybe<OrderBy>;
  CompanyPaidDuesLineItemLabel?: InputMaybe<OrderBy>;
  CreateOrderErrorMessage?: InputMaybe<OrderBy>;
  CvcDeclinedErrorMessage?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EthicalRequirementsLabel?: InputMaybe<OrderBy>;
  ExperienceDurationLabel?: InputMaybe<OrderBy>;
  ExpiredCardErrorMessage?: InputMaybe<OrderBy>;
  FieldLeaderRoleLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  InvalidCardNumberErrorMessage?: InputMaybe<OrderBy>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  MdrtGsMembershipLabel?: InputMaybe<OrderBy>;
  MembershipLineItemLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  PaymentError?: InputMaybe<OrderBy>;
  PaymentPending?: InputMaybe<OrderBy>;
  PaymentRetry?: InputMaybe<OrderBy>;
  PaymentSuccess?: InputMaybe<OrderBy>;
  PriceBreakdownLabel?: InputMaybe<OrderBy>;
  ResponsibilityLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TermsAndAgreementsText?: InputMaybe<OrderBy>;
  TermsAndConditionsTooltip?: InputMaybe<OrderBy>;
  TotalDueLabel?: InputMaybe<OrderBy>;
  VolunteerLabel?: InputMaybe<OrderBy>;
};

export type GsMembershipRenewalPageGsReviewStepBlockWhereInput = {
  AgentIdLabel?: InputMaybe<SearchableStringFilterInput>;
  AliPaySubmitMessage?: InputMaybe<SearchableStringFilterInput>;
  ApplicationSubmittedWaitingMessageText?: InputMaybe<SearchableStringFilterInput>;
  BusinessTitleLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyPaidDuesLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  CreateOrderErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  CvcDeclinedErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EthicalRequirementsLabel?: InputMaybe<SearchableStringFilterInput>;
  ExperienceDurationLabel?: InputMaybe<SearchableStringFilterInput>;
  ExpiredCardErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  FieldLeaderRoleLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  InvalidCardNumberErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtGsMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentError?: InputMaybe<SearchableStringFilterInput>;
  PaymentPending?: InputMaybe<SearchableStringFilterInput>;
  PaymentRetry?: InputMaybe<SearchableStringFilterInput>;
  PaymentSuccess?: InputMaybe<SearchableStringFilterInput>;
  PriceBreakdownLabel?: InputMaybe<SearchableStringFilterInput>;
  ResponsibilityLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TermsAndAgreementsText?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsTooltip?: InputMaybe<SearchableStringFilterInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
  VolunteerLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type GsMembershipRenewalPageImageBlock = {
  __typename?: 'GsMembershipRenewalPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type GsMembershipRenewalPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GsMembershipRenewalPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GsMembershipRenewalPageImageBlockAutocomplete = {
  __typename?: 'GsMembershipRenewalPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type GsMembershipRenewalPageImageBlockFacet = {
  __typename?: 'GsMembershipRenewalPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GsMembershipRenewalPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsMembershipRenewalPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type GsMembershipRenewalPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GsMembershipRenewalPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type GsMembershipRenewalPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type GsMembershipRenewalPageOrderByInput = {
  AccountLabel?: InputMaybe<OrderBy>;
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ChinaErrorModalDescription?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CredlyBadgeIssueError?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ErrorModalDescription?: InputMaybe<OrderBy>;
  ErrorModalNotAuthorizedButton1Text?: InputMaybe<OrderBy>;
  ErrorModalNotAuthorizedButton2Text?: InputMaybe<OrderBy>;
  ErrorModalNotAuthorizedDescription?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FormHasRequiredErrorsLabel?: InputMaybe<OrderBy>;
  GsConfirmationStep?: InputMaybe<GsMembershipRenewalPageGsConfirmationStepBlockOrderByInput>;
  GsGettingStartedStep?: InputMaybe<GsMembershipRenewalPageGsGettingStartedStepBlockOrderByInput>;
  GsGreetingStepBlock?: InputMaybe<GsMembershipRenewalPageGsGreetingStepBlockOrderByInput>;
  GsLeadershipInformationStep?: InputMaybe<GsMembershipRenewalPageGsLeadershipInformationStepBlockOrderByInput>;
  GsProfileStep?: InputMaybe<GsMembershipRenewalPageGsProfileStepBlockOrderByInput>;
  GsReceiptStep?: InputMaybe<GsMembershipRenewalPageGsReceiptStepBlockOrderByInput>;
  GsReviewStep?: InputMaybe<GsMembershipRenewalPageGsReviewStepBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeesTooltip?: InputMaybe<OrderBy>;
  LogoutLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<GsMembershipRenewalPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavHeadingLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  QuestionsHeading?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RequiredErrorFieldLabel?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelectLanguageHeading?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<GsMembershipRenewalPageImageBlockOrderByInput>;
  TotalDueLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsMembershipRenewalPageOutput = {
  __typename?: 'GsMembershipRenewalPageOutput';
  autocomplete?: Maybe<GsMembershipRenewalPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsMembershipRenewalPageFacet>;
  item?: Maybe<GsMembershipRenewalPage>;
  items?: Maybe<Array<Maybe<GsMembershipRenewalPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsMembershipRenewalPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsMembershipRenewalPageWhereInput = {
  AccountLabel?: InputMaybe<SearchableStringFilterInput>;
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ChinaErrorModalDescription?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CredlyBadgeIssueError?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ErrorModalDescription?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalNotAuthorizedButton1Text?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalNotAuthorizedButton2Text?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalNotAuthorizedDescription?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FormHasRequiredErrorsLabel?: InputMaybe<SearchableStringFilterInput>;
  GsConfirmationStep?: InputMaybe<GsMembershipRenewalPageGsConfirmationStepBlockWhereInput>;
  GsGettingStartedStep?: InputMaybe<GsMembershipRenewalPageGsGettingStartedStepBlockWhereInput>;
  GsGreetingStepBlock?: InputMaybe<GsMembershipRenewalPageGsGreetingStepBlockWhereInput>;
  GsLeadershipInformationStep?: InputMaybe<GsMembershipRenewalPageGsLeadershipInformationStepBlockWhereInput>;
  GsProfileStep?: InputMaybe<GsMembershipRenewalPageGsProfileStepBlockWhereInput>;
  GsReceiptStep?: InputMaybe<GsMembershipRenewalPageGsReceiptStepBlockWhereInput>;
  GsReviewStep?: InputMaybe<GsMembershipRenewalPageGsReviewStepBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeesTooltip?: InputMaybe<SearchableStringFilterInput>;
  LogoutLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<GsMembershipRenewalPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavHeadingLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  QuestionsHeading?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RequiredErrorFieldLabel?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelectLanguageHeading?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<GsMembershipRenewalPageImageBlockWhereInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsMembershipRenewalPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsMembershipRenewalPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsMembershipRenewalPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type GsProfileStepBlock = IContent & IData & {
  __typename?: 'GsProfileStepBlock';
  AddLocalAddressHelperText?: Maybe<Scalars['String']['output']>;
  AddLocalAddressLabel?: Maybe<Scalars['String']['output']>;
  AddressLine1FormatLabel?: Maybe<Scalars['String']['output']>;
  AddressLine1Label?: Maybe<Scalars['String']['output']>;
  AddressLine2Label?: Maybe<Scalars['String']['output']>;
  AddressLine3Label?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AreaCodeLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CityLabel?: Maybe<Scalars['String']['output']>;
  CompanyAffiliationLabel?: Maybe<Scalars['String']['output']>;
  ContactInfoLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CountryLabel?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DateOfBirthFormatLabel?: Maybe<Scalars['String']['output']>;
  DateOfBirthLabel?: Maybe<Scalars['String']['output']>;
  DateOfBirthLabelRangeValidationMessage?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EmailDirectoryPermissionText?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  GenderLabel?: Maybe<Scalars['String']['output']>;
  GeneralErrorText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  IsoCodeLabel?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LocalAddressHeadingText?: Maybe<Scalars['String']['output']>;
  MailingAddressLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MemberDirectoryPermissionText?: Maybe<Scalars['String']['output']>;
  MobilePhoneHeading?: Maybe<Scalars['String']['output']>;
  MobilePhoneLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  OfficePhoneHeading?: Maybe<Scalars['String']['output']>;
  OfficePhoneLabel?: Maybe<Scalars['String']['output']>;
  OfficePhoneOrMobilePhoneValidation?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonalCompanyLabel?: Maybe<Scalars['String']['output']>;
  PersonalCompanyOrAffiliationValidationMessage?: Maybe<Scalars['String']['output']>;
  PersonalInfoLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberFormatLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberInvalidMessage?: Maybe<Scalars['String']['output']>;
  PrimaryLanguageLabel?: Maybe<Scalars['String']['output']>;
  PrimaryLanguageTooltip?: Maybe<Scalars['String']['output']>;
  ProfessionalInfoLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RemoveLocalAddressHelperText?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SmsPermissionText?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  StateLabel?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UseWesternCharactersMessage?: Maybe<Scalars['String']['output']>;
  ZipCodeLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockAddLocalAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockAddLocalAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockAddressLine1FormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockAddressLine1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockAddressLine2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockAddressLine3LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockAreaCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockCityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockCompanyAffiliationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockContactInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockDateOfBirthFormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockDateOfBirthLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockDateOfBirthLabelRangeValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockEmailDirectoryPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockGenderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockGeneralErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockIsoCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockLocalAddressHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockMailingAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockMemberDirectoryPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockMobilePhoneHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockMobilePhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockOfficePhoneHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockOfficePhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockOfficePhoneOrMobilePhoneValidationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockPersonalCompanyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockPersonalCompanyOrAffiliationValidationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockPersonalInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockPhoneNumberFormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockPhoneNumberInvalidMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockPrimaryLanguageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockPrimaryLanguageTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockProfessionalInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockRemoveLocalAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockSmsPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockStateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockUseWesternCharactersMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlockZipCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsProfileStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsProfileStepBlockAutocomplete = {
  __typename?: 'GsProfileStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsProfileStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsProfileStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsProfileStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsProfileStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsProfileStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsProfileStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsProfileStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsProfileStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsProfileStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsProfileStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsProfileStepBlockFacet = {
  __typename?: 'GsProfileStepBlockFacet';
  AddLocalAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  AddLocalAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1FormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine2Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine3Label?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AreaCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyAffiliationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContactInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DateOfBirthFormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DateOfBirthLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DateOfBirthLabelRangeValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EmailDirectoryPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GenderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GeneralErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsoCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LocalAddressHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MemberDirectoryPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  MobilePhoneHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MobilePhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneHeading?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneOrMobilePhoneValidation?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonalCompanyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalCompanyOrAffiliationValidationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberFormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberInvalidMessage?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryLanguageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryLanguageTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveLocalAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SmsPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UseWesternCharactersMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ZipCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsProfileStepBlockFacetAddLocalAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetAddLocalAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetAddressLine1FormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetAddressLine1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetAddressLine2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetAddressLine3LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetAreaCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsProfileStepBlockFacetCityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetCompanyAffiliationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetContactInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsProfileStepBlockFacetDateOfBirthFormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetDateOfBirthLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetDateOfBirthLabelRangeValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetEmailDirectoryPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetGenderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetGeneralErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetIsoCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetLocalAddressHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetMailingAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetMemberDirectoryPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetMobilePhoneHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetMobilePhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetOfficePhoneHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetOfficePhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetOfficePhoneOrMobilePhoneValidationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetPersonalCompanyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetPersonalCompanyOrAffiliationValidationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetPersonalInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetPhoneNumberFormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetPhoneNumberInvalidMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetPrimaryLanguageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetPrimaryLanguageTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetProfessionalInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetRemoveLocalAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsProfileStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetSmsPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsProfileStepBlockFacetStateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsProfileStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetUseWesternCharactersMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacetZipCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsProfileStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsProfileStepBlockOrderByInput = {
  AddLocalAddressHelperText?: InputMaybe<OrderBy>;
  AddLocalAddressLabel?: InputMaybe<OrderBy>;
  AddressLine1FormatLabel?: InputMaybe<OrderBy>;
  AddressLine1Label?: InputMaybe<OrderBy>;
  AddressLine2Label?: InputMaybe<OrderBy>;
  AddressLine3Label?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AreaCodeLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CityLabel?: InputMaybe<OrderBy>;
  CompanyAffiliationLabel?: InputMaybe<OrderBy>;
  ContactInfoLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CountryLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DateOfBirthFormatLabel?: InputMaybe<OrderBy>;
  DateOfBirthLabel?: InputMaybe<OrderBy>;
  DateOfBirthLabelRangeValidationMessage?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EmailDirectoryPermissionText?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GenderLabel?: InputMaybe<OrderBy>;
  GeneralErrorText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsoCodeLabel?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LocalAddressHeadingText?: InputMaybe<OrderBy>;
  MailingAddressLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MemberDirectoryPermissionText?: InputMaybe<OrderBy>;
  MobilePhoneHeading?: InputMaybe<OrderBy>;
  MobilePhoneLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  OfficePhoneHeading?: InputMaybe<OrderBy>;
  OfficePhoneLabel?: InputMaybe<OrderBy>;
  OfficePhoneOrMobilePhoneValidation?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonalCompanyLabel?: InputMaybe<OrderBy>;
  PersonalCompanyOrAffiliationValidationMessage?: InputMaybe<OrderBy>;
  PersonalInfoLabel?: InputMaybe<OrderBy>;
  PhoneNumberFormatLabel?: InputMaybe<OrderBy>;
  PhoneNumberInvalidMessage?: InputMaybe<OrderBy>;
  PrimaryLanguageLabel?: InputMaybe<OrderBy>;
  PrimaryLanguageTooltip?: InputMaybe<OrderBy>;
  ProfessionalInfoLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RemoveLocalAddressHelperText?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SmsPermissionText?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  StateLabel?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UseWesternCharactersMessage?: InputMaybe<OrderBy>;
  ZipCodeLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsProfileStepBlockOutput = {
  __typename?: 'GsProfileStepBlockOutput';
  autocomplete?: Maybe<GsProfileStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsProfileStepBlockFacet>;
  item?: Maybe<GsProfileStepBlock>;
  items?: Maybe<Array<Maybe<GsProfileStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsProfileStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsProfileStepBlockWhereInput = {
  AddLocalAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  AddLocalAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1FormatLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine2Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine3Label?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AreaCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CityLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyAffiliationLabel?: InputMaybe<SearchableStringFilterInput>;
  ContactInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CountryLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DateOfBirthFormatLabel?: InputMaybe<SearchableStringFilterInput>;
  DateOfBirthLabel?: InputMaybe<SearchableStringFilterInput>;
  DateOfBirthLabelRangeValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EmailDirectoryPermissionText?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GenderLabel?: InputMaybe<SearchableStringFilterInput>;
  GeneralErrorText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsoCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LocalAddressHeadingText?: InputMaybe<SearchableStringFilterInput>;
  MailingAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MemberDirectoryPermissionText?: InputMaybe<SearchableStringFilterInput>;
  MobilePhoneHeading?: InputMaybe<SearchableStringFilterInput>;
  MobilePhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneHeading?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneOrMobilePhoneValidation?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonalCompanyLabel?: InputMaybe<SearchableStringFilterInput>;
  PersonalCompanyOrAffiliationValidationMessage?: InputMaybe<SearchableStringFilterInput>;
  PersonalInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberFormatLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberInvalidMessage?: InputMaybe<SearchableStringFilterInput>;
  PrimaryLanguageLabel?: InputMaybe<SearchableStringFilterInput>;
  PrimaryLanguageTooltip?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RemoveLocalAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SmsPermissionText?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  StateLabel?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UseWesternCharactersMessage?: InputMaybe<SearchableStringFilterInput>;
  ZipCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsProfileStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsProfileStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsProfileStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlock = IContent & IData & {
  __typename?: 'GsReceiptStepBlock';
  AgentIdLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicationDetailsHeading?: Maybe<Scalars['String']['output']>;
  BusinessTitleLabel?: Maybe<Scalars['String']['output']>;
  CardNumberLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyNameLabel?: Maybe<Scalars['String']['output']>;
  CompanyPrepaymentLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CostBreakdownLabel?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  EthicsComplaintLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExperienceDurationLabel?: Maybe<Scalars['String']['output']>;
  GoBackButtonLabel?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtGsMembershipLabel?: Maybe<Scalars['String']['output']>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  MemberDetailsHeading?: Maybe<Scalars['String']['output']>;
  MemberNameLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  OrderNumberLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentDateLabel?: Maybe<Scalars['String']['output']>;
  PaymentDetailsLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PrintButtonLabel?: Maybe<Scalars['String']['output']>;
  ReceiptAddressText?: Maybe<Scalars['String']['output']>;
  ReceiptFaxLabel?: Maybe<Scalars['String']['output']>;
  ReceiptFaxNumber?: Maybe<Scalars['String']['output']>;
  ReceiptHeading?: Maybe<Scalars['String']['output']>;
  ReceiptPhoneLabel?: Maybe<Scalars['String']['output']>;
  ReceiptPhoneNumber?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TermsAndConditionsLabel?: Maybe<Scalars['String']['output']>;
  TotalAmountPaidLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VolunteerLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockApplicationDetailsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockBusinessTitleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockCardNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockCompanyNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockCompanyPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockCostBreakdownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockEthicsComplaintLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockExperienceDurationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockGoBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockMdrtGsMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockMemberDetailsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockMemberNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockOrderNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockPaymentDateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockPaymentDetailsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockPrintButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockReceiptAddressTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockReceiptFaxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockReceiptFaxNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockReceiptHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockReceiptPhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockReceiptPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockTermsAndConditionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockTotalAmountPaidLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlockVolunteerLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Global Services Membership Renewal page */
export type GsReceiptStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsReceiptStepBlockAutocomplete = {
  __typename?: 'GsReceiptStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsReceiptStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReceiptStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReceiptStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReceiptStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReceiptStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReceiptStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReceiptStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReceiptStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReceiptStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReceiptStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsReceiptStepBlockFacet = {
  __typename?: 'GsReceiptStepBlockFacet';
  AgentIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationDetailsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessTitleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CardNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CostBreakdownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EthicsComplaintLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExperienceDurationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtGsMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDetailsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MemberNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  OrderNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentDateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentDetailsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrintButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptAddressText?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptFaxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptFaxNumber?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptPhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptPhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TermsAndConditionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAmountPaidLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VolunteerLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsReceiptStepBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetApplicationDetailsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetBusinessTitleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetCardNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsReceiptStepBlockFacetCompanyNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetCompanyPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetCostBreakdownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsReceiptStepBlockFacetEthicsComplaintLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetExperienceDurationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetGoBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetMdrtGsMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetMemberDetailsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetMemberNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetOrderNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetPaymentDateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetPaymentDetailsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetPrintButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetReceiptAddressTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetReceiptFaxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetReceiptFaxNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetReceiptHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetReceiptPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetReceiptPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsReceiptStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsReceiptStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsReceiptStepBlockFacetTermsAndConditionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetTotalAmountPaidLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacetVolunteerLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReceiptStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsReceiptStepBlockOrderByInput = {
  AgentIdLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationDetailsHeading?: InputMaybe<OrderBy>;
  BusinessTitleLabel?: InputMaybe<OrderBy>;
  CardNumberLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyNameLabel?: InputMaybe<OrderBy>;
  CompanyPrepaymentLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CostBreakdownLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EthicsComplaintLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExperienceDurationLabel?: InputMaybe<OrderBy>;
  GoBackButtonLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtGsMembershipLabel?: InputMaybe<OrderBy>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  MemberDetailsHeading?: InputMaybe<OrderBy>;
  MemberNameLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  OrderNumberLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentDateLabel?: InputMaybe<OrderBy>;
  PaymentDetailsLabel?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PrintButtonLabel?: InputMaybe<OrderBy>;
  ReceiptAddressText?: InputMaybe<OrderBy>;
  ReceiptFaxLabel?: InputMaybe<OrderBy>;
  ReceiptFaxNumber?: InputMaybe<OrderBy>;
  ReceiptHeading?: InputMaybe<OrderBy>;
  ReceiptPhoneLabel?: InputMaybe<OrderBy>;
  ReceiptPhoneNumber?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TermsAndConditionsLabel?: InputMaybe<OrderBy>;
  TotalAmountPaidLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VolunteerLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsReceiptStepBlockOutput = {
  __typename?: 'GsReceiptStepBlockOutput';
  autocomplete?: Maybe<GsReceiptStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsReceiptStepBlockFacet>;
  item?: Maybe<GsReceiptStepBlock>;
  items?: Maybe<Array<Maybe<GsReceiptStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsReceiptStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsReceiptStepBlockWhereInput = {
  AgentIdLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationDetailsHeading?: InputMaybe<SearchableStringFilterInput>;
  BusinessTitleLabel?: InputMaybe<SearchableStringFilterInput>;
  CardNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyNameLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyPrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CostBreakdownLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EthicsComplaintLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExperienceDurationLabel?: InputMaybe<SearchableStringFilterInput>;
  GoBackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtGsMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  MemberDetailsHeading?: InputMaybe<SearchableStringFilterInput>;
  MemberNameLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  OrderNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentDateLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentDetailsLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PrintButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptAddressText?: InputMaybe<SearchableStringFilterInput>;
  ReceiptFaxLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptFaxNumber?: InputMaybe<SearchableStringFilterInput>;
  ReceiptHeading?: InputMaybe<SearchableStringFilterInput>;
  ReceiptPhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TermsAndConditionsLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAmountPaidLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VolunteerLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsReceiptStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsReceiptStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsReceiptStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type GsReviewStepBlock = IContent & IData & {
  __typename?: 'GsReviewStepBlock';
  AgentIdLabel?: Maybe<Scalars['String']['output']>;
  AliPaySubmitMessage?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicationSubmittedWaitingMessageText?: Maybe<Scalars['String']['output']>;
  BusinessTitleLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyPaidDuesLineItemLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CreateOrderErrorMessage?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  CvcDeclinedErrorMessage?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EthicalRequirementsLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExperienceDurationLabel?: Maybe<Scalars['String']['output']>;
  ExpiredCardErrorMessage?: Maybe<Scalars['String']['output']>;
  FieldLeaderRoleLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  InvalidCardNumberErrorMessage?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtGsMembershipLabel?: Maybe<Scalars['String']['output']>;
  MembershipLineItemLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentError?: Maybe<Scalars['String']['output']>;
  PaymentPending?: Maybe<Scalars['String']['output']>;
  PaymentRetry?: Maybe<Scalars['String']['output']>;
  PaymentSuccess?: Maybe<Scalars['String']['output']>;
  PriceBreakdownLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  ResponsibilityLabel?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TermsAndAgreementsText?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsTooltip?: Maybe<Scalars['String']['output']>;
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VolunteerLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockAgentIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockAliPaySubmitMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockApplicationSubmittedWaitingMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockBusinessTitleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockCompanyPaidDuesLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockCreateOrderErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockCvcDeclinedErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockEthicalRequirementsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockExperienceDurationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockExpiredCardErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockFieldLeaderRoleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockInvalidCardNumberErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockMdrtGsMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockMembershipLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockPaymentErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockPaymentPendingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockPaymentRetryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockPaymentSuccessArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockPriceBreakdownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockResponsibilityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockTermsAndAgreementsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockTermsAndConditionsTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlockVolunteerLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type GsReviewStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GsReviewStepBlockAutocomplete = {
  __typename?: 'GsReviewStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GsReviewStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReviewStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReviewStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReviewStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReviewStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReviewStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReviewStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReviewStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReviewStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GsReviewStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GsReviewStepBlockFacet = {
  __typename?: 'GsReviewStepBlockFacet';
  AgentIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AliPaySubmitMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationSubmittedWaitingMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessTitleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyPaidDuesLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CreateOrderErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CvcDeclinedErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalRequirementsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExperienceDurationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExpiredCardErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  FieldLeaderRoleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  InvalidCardNumberErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtGsMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentPending?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentRetry?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentSuccess?: Maybe<Array<Maybe<StringFacet>>>;
  PriceBreakdownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ResponsibilityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TermsAndAgreementsText?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VolunteerLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GsReviewStepBlockFacetAgentIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetAliPaySubmitMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetApplicationSubmittedWaitingMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetBusinessTitleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsReviewStepBlockFacetCompanyPaidDuesLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetCreateOrderErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsReviewStepBlockFacetCvcDeclinedErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetEthicalRequirementsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetExperienceDurationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetExpiredCardErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetFieldLeaderRoleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetInvalidCardNumberErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetMdrtGsMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetMembershipLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetPaymentErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetPaymentPendingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetPaymentRetryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetPaymentSuccessArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetPriceBreakdownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetResponsibilityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsReviewStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsReviewStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GsReviewStepBlockFacetTermsAndAgreementsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetTermsAndConditionsTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacetVolunteerLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GsReviewStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GsReviewStepBlockOrderByInput = {
  AgentIdLabel?: InputMaybe<OrderBy>;
  AliPaySubmitMessage?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationSubmittedWaitingMessageText?: InputMaybe<OrderBy>;
  BusinessTitleLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyPaidDuesLineItemLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CreateOrderErrorMessage?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CvcDeclinedErrorMessage?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EthicalRequirementsLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExperienceDurationLabel?: InputMaybe<OrderBy>;
  ExpiredCardErrorMessage?: InputMaybe<OrderBy>;
  FieldLeaderRoleLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  InvalidCardNumberErrorMessage?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtGsMembershipLabel?: InputMaybe<OrderBy>;
  MembershipLineItemLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentError?: InputMaybe<OrderBy>;
  PaymentPending?: InputMaybe<OrderBy>;
  PaymentRetry?: InputMaybe<OrderBy>;
  PaymentSuccess?: InputMaybe<OrderBy>;
  PriceBreakdownLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  ResponsibilityLabel?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TermsAndAgreementsText?: InputMaybe<OrderBy>;
  TermsAndConditionsTooltip?: InputMaybe<OrderBy>;
  TotalDueLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VolunteerLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GsReviewStepBlockOutput = {
  __typename?: 'GsReviewStepBlockOutput';
  autocomplete?: Maybe<GsReviewStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GsReviewStepBlockFacet>;
  item?: Maybe<GsReviewStepBlock>;
  items?: Maybe<Array<Maybe<GsReviewStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GsReviewStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GsReviewStepBlockWhereInput = {
  AgentIdLabel?: InputMaybe<SearchableStringFilterInput>;
  AliPaySubmitMessage?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationSubmittedWaitingMessageText?: InputMaybe<SearchableStringFilterInput>;
  BusinessTitleLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyPaidDuesLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CreateOrderErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CvcDeclinedErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EthicalRequirementsLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExperienceDurationLabel?: InputMaybe<SearchableStringFilterInput>;
  ExpiredCardErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  FieldLeaderRoleLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  InvalidCardNumberErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtGsMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentError?: InputMaybe<SearchableStringFilterInput>;
  PaymentPending?: InputMaybe<SearchableStringFilterInput>;
  PaymentRetry?: InputMaybe<SearchableStringFilterInput>;
  PaymentSuccess?: InputMaybe<SearchableStringFilterInput>;
  PriceBreakdownLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ResponsibilityLabel?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TermsAndAgreementsText?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsTooltip?: InputMaybe<SearchableStringFilterInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VolunteerLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<GsReviewStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GsReviewStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GsReviewStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds health policies for the Company Admin page */
export type HealthPoliciesSectionBlock = IContent & IData & {
  __typename?: 'HealthPoliciesSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EmailAddress?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstGivenName?: Maybe<Scalars['String']['output']>;
  HealthInsurancePolicesOther?: Maybe<Scalars['String']['output']>;
  HealthInsurancePolicesRisk?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastFamilyName?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds health policies for the Company Admin page */
export type HealthPoliciesSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds health policies for the Company Admin page */
export type HealthPoliciesSectionBlockEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds health policies for the Company Admin page */
export type HealthPoliciesSectionBlockFirstGivenNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds health policies for the Company Admin page */
export type HealthPoliciesSectionBlockHealthInsurancePolicesOtherArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds health policies for the Company Admin page */
export type HealthPoliciesSectionBlockHealthInsurancePolicesRiskArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds health policies for the Company Admin page */
export type HealthPoliciesSectionBlockLastFamilyNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds health policies for the Company Admin page */
export type HealthPoliciesSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds health policies for the Company Admin page */
export type HealthPoliciesSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds health policies for the Company Admin page */
export type HealthPoliciesSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds health policies for the Company Admin page */
export type HealthPoliciesSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HealthPoliciesSectionBlockAutocomplete = {
  __typename?: 'HealthPoliciesSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HealthPoliciesSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HealthPoliciesSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HealthPoliciesSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HealthPoliciesSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HealthPoliciesSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HealthPoliciesSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HealthPoliciesSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HealthPoliciesSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HealthPoliciesSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HealthPoliciesSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HealthPoliciesSectionBlockFacet = {
  __typename?: 'HealthPoliciesSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstGivenName?: Maybe<Array<Maybe<StringFacet>>>;
  HealthInsurancePolicesOther?: Maybe<Array<Maybe<StringFacet>>>;
  HealthInsurancePolicesRisk?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastFamilyName?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HealthPoliciesSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HealthPoliciesSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HealthPoliciesSectionBlockFacetEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetFirstGivenNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetHealthInsurancePolicesOtherArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetHealthInsurancePolicesRiskArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HealthPoliciesSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetLastFamilyNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HealthPoliciesSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HealthPoliciesSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HealthPoliciesSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HealthPoliciesSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HealthPoliciesSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EmailAddress?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstGivenName?: InputMaybe<OrderBy>;
  HealthInsurancePolicesOther?: InputMaybe<OrderBy>;
  HealthInsurancePolicesRisk?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastFamilyName?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HealthPoliciesSectionBlockOutput = {
  __typename?: 'HealthPoliciesSectionBlockOutput';
  autocomplete?: Maybe<HealthPoliciesSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HealthPoliciesSectionBlockFacet>;
  item?: Maybe<HealthPoliciesSectionBlock>;
  items?: Maybe<Array<Maybe<HealthPoliciesSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HealthPoliciesSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HealthPoliciesSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EmailAddress?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstGivenName?: InputMaybe<SearchableStringFilterInput>;
  HealthInsurancePolicesOther?: InputMaybe<SearchableStringFilterInput>;
  HealthInsurancePolicesRisk?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastFamilyName?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HealthPoliciesSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HealthPoliciesSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HealthPoliciesSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A block meant to be used as a reusable field that collects various text content */
export type HeroTextContentBlock = IContent & IData & {
  __typename?: 'HeroTextContentBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type HeroTextContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type HeroTextContentBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type HeroTextContentBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type HeroTextContentBlockPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type HeroTextContentBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type HeroTextContentBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type HeroTextContentBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HeroTextContentBlockAutocomplete = {
  __typename?: 'HeroTextContentBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HeroTextContentBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroTextContentBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroTextContentBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroTextContentBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroTextContentBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroTextContentBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroTextContentBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroTextContentBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroTextContentBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroTextContentBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroTextContentBlockFacet = {
  __typename?: 'HeroTextContentBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HeroTextContentBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroTextContentBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroTextContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroTextContentBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroTextContentBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroTextContentBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroTextContentBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HeroTextContentBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreHeading?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HeroTextContentBlockOutput = {
  __typename?: 'HeroTextContentBlockOutput';
  autocomplete?: Maybe<HeroTextContentBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HeroTextContentBlockFacet>;
  item?: Maybe<HeroTextContentBlock>;
  items?: Maybe<Array<Maybe<HeroTextContentBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HeroTextContentBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroTextContentBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HeroTextContentBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HeroTextContentBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HeroTextContentBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Options for highlighting */
export type HighlightOptions = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endToken?: InputMaybe<Scalars['String']['input']>;
  startToken?: InputMaybe<Scalars['String']['input']>;
};

/** The home page for a CMS site. Used directly under the root page. */
export type HomePage = IContent & IData & {
  __typename?: 'HomePage';
  ActionCardsSubHeading?: Maybe<Scalars['String']['output']>;
  AdminHeading?: Maybe<Scalars['String']['output']>;
  AdminMemberDescription?: Maybe<Scalars['String']['output']>;
  AdminMemberHeading?: Maybe<Scalars['String']['output']>;
  AdminPreHeading?: Maybe<Scalars['String']['output']>;
  AdminSvgLinkBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Adminlogo?: Maybe<HomePageImageBlock>;
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Button?: Maybe<HomePageLinkBlock>;
  ButtonLabel?: Maybe<HomePageLinkBlock>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CoTlogo?: Maybe<HomePageImageBlock>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  HeroImage?: Maybe<HomePageImageBlock>;
  HeroMobileImage?: Maybe<HomePageImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtMemberlogo?: Maybe<HomePageImageBlock>;
  MemberDescription?: Maybe<Scalars['String']['output']>;
  MemberHeading?: Maybe<Scalars['String']['output']>;
  MemberYearLabel?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<HomePageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SiteSettingsPage?: Maybe<ContentModelReference>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
  SvgLinkBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  SvgTextCardBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  TextContent?: Maybe<HomePageTextContentBlock>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<HomePageImageBlock>;
  ToTlogo?: Maybe<HomePageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageActionCardsSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageAdminHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageAdminMemberDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageAdminMemberHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageAdminPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageAdminSvgLinkBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageMemberDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageMemberHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageMemberYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePagePreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageSvgLinkBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePageSvgTextCardBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for a CMS site. Used directly under the root page. */
export type HomePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HomePageAutocomplete = {
  __typename?: 'HomePageAutocomplete';
  Adminlogo?: Maybe<HomePageImageBlockAutocomplete>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Button?: Maybe<HomePageLinkBlockAutocomplete>;
  ButtonLabel?: Maybe<HomePageLinkBlockAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  CoTlogo?: Maybe<HomePageImageBlockAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  HeroImage?: Maybe<HomePageImageBlockAutocomplete>;
  HeroMobileImage?: Maybe<HomePageImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MdrtMemberlogo?: Maybe<HomePageImageBlockAutocomplete>;
  MetaImage?: Maybe<HomePageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteSettingsPage?: Maybe<ContentModelReferenceAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<HomePageImageBlockAutocomplete>;
  ToTlogo?: Maybe<HomePageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HomePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomePageFacet = {
  __typename?: 'HomePageFacet';
  ActionCardsSubHeading?: Maybe<Array<Maybe<StringFacet>>>;
  AdminHeading?: Maybe<Array<Maybe<StringFacet>>>;
  AdminMemberDescription?: Maybe<Array<Maybe<StringFacet>>>;
  AdminMemberHeading?: Maybe<Array<Maybe<StringFacet>>>;
  AdminPreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  AdminSvgLinkBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  Adminlogo?: Maybe<HomePageImageBlockFacet>;
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Button?: Maybe<HomePageLinkBlockFacet>;
  ButtonLabel?: Maybe<HomePageLinkBlockFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CoTlogo?: Maybe<HomePageImageBlockFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HeroImage?: Maybe<HomePageImageBlockFacet>;
  HeroMobileImage?: Maybe<HomePageImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtMemberlogo?: Maybe<HomePageImageBlockFacet>;
  MemberDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MemberHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MemberYearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<HomePageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SiteSettingsPage?: Maybe<ContentModelReferenceFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SvgLinkBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  SvgTextCardBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  TextContent?: Maybe<HomePageTextContentBlockFacet>;
  ThumbnailImage?: Maybe<HomePageImageBlockFacet>;
  ToTlogo?: Maybe<HomePageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HomePageFacetActionCardsSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetAdminHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetAdminMemberDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetAdminMemberHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetAdminPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HomePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HomePageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetMemberDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetMemberHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetMemberYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HomePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HomePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HomePageFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HomePageImageBlock = {
  __typename?: 'HomePageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type HomePageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HomePageImageBlockAutocomplete = {
  __typename?: 'HomePageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type HomePageImageBlockFacet = {
  __typename?: 'HomePageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HomePageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomePageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type HomePageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type HomePageLinkBlock = {
  __typename?: 'HomePageLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type HomePageLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HomePageLinkBlockAutocomplete = {
  __typename?: 'HomePageLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HomePageLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomePageLinkBlockFacet = {
  __typename?: 'HomePageLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HomePageLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomePageLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type HomePageLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type HomePageOrderByInput = {
  ActionCardsSubHeading?: InputMaybe<OrderBy>;
  AdminHeading?: InputMaybe<OrderBy>;
  AdminMemberDescription?: InputMaybe<OrderBy>;
  AdminMemberHeading?: InputMaybe<OrderBy>;
  AdminPreHeading?: InputMaybe<OrderBy>;
  AdminSvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Adminlogo?: InputMaybe<HomePageImageBlockOrderByInput>;
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Button?: InputMaybe<HomePageLinkBlockOrderByInput>;
  ButtonLabel?: InputMaybe<HomePageLinkBlockOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CoTlogo?: InputMaybe<HomePageImageBlockOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  HeroImage?: InputMaybe<HomePageImageBlockOrderByInput>;
  HeroMobileImage?: InputMaybe<HomePageImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtMemberlogo?: InputMaybe<HomePageImageBlockOrderByInput>;
  MemberDescription?: InputMaybe<OrderBy>;
  MemberHeading?: InputMaybe<OrderBy>;
  MemberYearLabel?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<HomePageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreHeading?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SiteSettingsPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
  SvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SvgTextCardBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  TextContent?: InputMaybe<HomePageTextContentBlockOrderByInput>;
  ThumbnailImage?: InputMaybe<HomePageImageBlockOrderByInput>;
  ToTlogo?: InputMaybe<HomePageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HomePageOutput = {
  __typename?: 'HomePageOutput';
  autocomplete?: Maybe<HomePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HomePageFacet>;
  item?: Maybe<HomePage>;
  items?: Maybe<Array<Maybe<HomePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HomePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomePageTextContentBlock = {
  __typename?: 'HomePageTextContentBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
};


export type HomePageTextContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageTextContentBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageTextContentBlockPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageTextContentBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HomePageTextContentBlockFacet = {
  __typename?: 'HomePageTextContentBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HomePageTextContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageTextContentBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageTextContentBlockFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageTextContentBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomePageTextContentBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  PreHeading?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
};

export type HomePageTextContentBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
};

/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2 = IContent & IData & {
  __typename?: 'HomePageV2';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The text displayed when the Application Received link is rendered */
  ApplicationReceivedDisplayText?: Maybe<Scalars['String']['output']>;
  /** The text displayed when the Apply for membership link is rendered */
  ApplyForMembershipDisplayText?: Maybe<Scalars['String']['output']>;
  ArticleContentCategory?: Maybe<Scalars['String']['output']>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AudioContentCategory?: Maybe<Scalars['String']['output']>;
  AuthenticatedContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  BiometricAuthenticationDisableMessage?: Maybe<Scalars['String']['output']>;
  BiometricAuthenticationDismissButton?: Maybe<Scalars['String']['output']>;
  BiometricAuthenticationEnableButton?: Maybe<Scalars['String']['output']>;
  BiometricAuthenticationHeading?: Maybe<Scalars['String']['output']>;
  BiometricAuthenticationLoginMessage?: Maybe<Scalars['String']['output']>;
  CardsSectionTitle?: Maybe<Scalars['String']['output']>;
  CardsSectionTitleForMembers?: Maybe<Scalars['String']['output']>;
  CardsTabLearnButtonLabel?: Maybe<Scalars['String']['output']>;
  CardsTabLearnContentCategory?: Maybe<Scalars['String']['output']>;
  CardsTabMemberDirectoryContentCategory?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DashboardCarouselCardsContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  /** The text displayed when the Some Days are left until link is rendered */
  DaysLeft?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  /** The text displayed when the Finish Application link is rendered */
  FinishApplicationDisplayText?: Maybe<Scalars['String']['output']>;
  GuideContentCategory?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** Link to the membership page */
  MembershipPageLink?: Maybe<HomePageV2LinkBlock>;
  MembershipYears?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<HomePageV2ImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PodcastContentCategory?: Maybe<Scalars['String']['output']>;
  /** This should reference the site settings on the MDRT site. */
  PrimarySiteSettingsPage?: Maybe<ContentModelReference>;
  ProfileDataValidationConfirmButtonLabel?: Maybe<Scalars['String']['output']>;
  ProfileDataValidationContactInformationSectionTitle?: Maybe<Scalars['String']['output']>;
  ProfileDataValidationEditLinkAriaLabel?: Maybe<Scalars['String']['output']>;
  ProfileDataValidationModalDescription?: Maybe<Scalars['String']['output']>;
  ProfileDataValidationModalTitle?: Maybe<Scalars['String']['output']>;
  ProfileDataValidationPersonalInformationSectionTitle?: Maybe<Scalars['String']['output']>;
  ProfileDataValidationProfessionalInformationSectionTitle?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** The text displayed when the Renew membership link is rendered */
  RenewMembershipDisplayText?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SiteSettingsPage?: Maybe<ContentModelReference>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<HomePageV2ImageBlock>;
  /** The text displayed when the Upgrade membership link is rendered */
  UpgradeMembershipDisplayText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VideoContentCategory?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2AnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2ApplicationReceivedDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2ApplyForMembershipDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2ArticleContentCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2AudioContentCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2AuthenticatedContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2BiometricAuthenticationDisableMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2BiometricAuthenticationDismissButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2BiometricAuthenticationEnableButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2BiometricAuthenticationHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2BiometricAuthenticationLoginMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2CardsSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2CardsSectionTitleForMembersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2CardsTabLearnButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2CardsTabLearnContentCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2DashboardCarouselCardsContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2DaysLeftArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2FinishApplicationDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2GuideContentCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2MainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2MembershipYearsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2MetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2MetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2MetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2NameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2PodcastContentCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2ProfileDataValidationConfirmButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2ProfileDataValidationContactInformationSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2ProfileDataValidationEditLinkAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2ProfileDataValidationModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2ProfileDataValidationModalTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2ProfileDataValidationPersonalInformationSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2ProfileDataValidationProfessionalInformationSectionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2RenewMembershipDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2UpgradeMembershipDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2VideoContentCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The home page for CMS site. Used directly under the root page. */
export type HomePageV2_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HomePageV2Autocomplete = {
  __typename?: 'HomePageV2Autocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  CardsTabMemberDirectoryContentCategory?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MembershipPageLink?: Maybe<HomePageV2LinkBlockAutocomplete>;
  MetaImage?: Maybe<HomePageV2ImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PrimarySiteSettingsPage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteSettingsPage?: Maybe<ContentModelReferenceAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<HomePageV2ImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HomePageV2AutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageV2AutocompleteCardsTabMemberDirectoryContentCategoryArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageV2AutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageV2AutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageV2AutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageV2AutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageV2AutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageV2AutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageV2AutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageV2AutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HomePageV2Autocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomePageV2Facet = {
  __typename?: 'HomePageV2Facet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationReceivedDisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  ApplyForMembershipDisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  ArticleContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  AudioContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  AuthenticatedContent?: Maybe<ContentAreaItemModelSearchFacet>;
  BiometricAuthenticationDisableMessage?: Maybe<Array<Maybe<StringFacet>>>;
  BiometricAuthenticationDismissButton?: Maybe<Array<Maybe<StringFacet>>>;
  BiometricAuthenticationEnableButton?: Maybe<Array<Maybe<StringFacet>>>;
  BiometricAuthenticationHeading?: Maybe<Array<Maybe<StringFacet>>>;
  BiometricAuthenticationLoginMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CardsSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  CardsSectionTitleForMembers?: Maybe<Array<Maybe<StringFacet>>>;
  CardsTabLearnButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CardsTabLearnContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  CardsTabMemberDirectoryContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DashboardCarouselCardsContent?: Maybe<ContentAreaItemModelSearchFacet>;
  DaysLeft?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FinishApplicationDisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  GuideContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipPageLink?: Maybe<HomePageV2LinkBlockFacet>;
  MembershipYears?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<HomePageV2ImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PodcastContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  PrimarySiteSettingsPage?: Maybe<ContentModelReferenceFacet>;
  ProfileDataValidationConfirmButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileDataValidationContactInformationSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileDataValidationEditLinkAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileDataValidationModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileDataValidationModalTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileDataValidationPersonalInformationSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileDataValidationProfessionalInformationSectionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RenewMembershipDisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SiteSettingsPage?: Maybe<ContentModelReferenceFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<HomePageV2ImageBlockFacet>;
  UpgradeMembershipDisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VideoContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HomePageV2FacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetApplicationReceivedDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetApplyForMembershipDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetArticleContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetAudioContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetBiometricAuthenticationDisableMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetBiometricAuthenticationDismissButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetBiometricAuthenticationEnableButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetBiometricAuthenticationHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetBiometricAuthenticationLoginMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetCardsSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetCardsSectionTitleForMembersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetCardsTabLearnButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetCardsTabLearnContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetCardsTabMemberDirectoryContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HomePageV2FacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageV2FacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HomePageV2FacetDaysLeftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetFinishApplicationDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetGuideContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageV2FacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetMembershipYearsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetPodcastContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetProfileDataValidationConfirmButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetProfileDataValidationContactInformationSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetProfileDataValidationEditLinkAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetProfileDataValidationModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetProfileDataValidationModalTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetProfileDataValidationPersonalInformationSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetProfileDataValidationProfessionalInformationSectionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetRenewMembershipDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HomePageV2FacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HomePageV2FacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HomePageV2FacetUpgradeMembershipDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2FacetVideoContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2Facet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2Facet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HomePageV2ImageBlock = {
  __typename?: 'HomePageV2ImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type HomePageV2ImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageV2ImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageV2ImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageV2ImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageV2ImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HomePageV2ImageBlockAutocomplete = {
  __typename?: 'HomePageV2ImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type HomePageV2ImageBlockFacet = {
  __typename?: 'HomePageV2ImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HomePageV2ImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2ImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2ImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2ImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2ImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageV2ImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomePageV2ImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type HomePageV2ImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type HomePageV2LinkBlock = {
  __typename?: 'HomePageV2LinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type HomePageV2LinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageV2LinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageV2LinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageV2LinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageV2LinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageV2LinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HomePageV2LinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HomePageV2LinkBlockAutocomplete = {
  __typename?: 'HomePageV2LinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HomePageV2LinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HomePageV2LinkBlockFacet = {
  __typename?: 'HomePageV2LinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HomePageV2LinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2LinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2LinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2LinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2LinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2LinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HomePageV2LinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2LinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2LinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HomePageV2LinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HomePageV2LinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type HomePageV2LinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type HomePageV2OrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationReceivedDisplayText?: InputMaybe<OrderBy>;
  ApplyForMembershipDisplayText?: InputMaybe<OrderBy>;
  ArticleContentCategory?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AudioContentCategory?: InputMaybe<OrderBy>;
  AuthenticatedContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  BiometricAuthenticationDisableMessage?: InputMaybe<OrderBy>;
  BiometricAuthenticationDismissButton?: InputMaybe<OrderBy>;
  BiometricAuthenticationEnableButton?: InputMaybe<OrderBy>;
  BiometricAuthenticationHeading?: InputMaybe<OrderBy>;
  BiometricAuthenticationLoginMessage?: InputMaybe<OrderBy>;
  CardsSectionTitle?: InputMaybe<OrderBy>;
  CardsSectionTitleForMembers?: InputMaybe<OrderBy>;
  CardsTabLearnButtonLabel?: InputMaybe<OrderBy>;
  CardsTabLearnContentCategory?: InputMaybe<OrderBy>;
  CardsTabMemberDirectoryContentCategory?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DashboardCarouselCardsContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  DaysLeft?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FinishApplicationDisplayText?: InputMaybe<OrderBy>;
  GuideContentCategory?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipPageLink?: InputMaybe<HomePageV2LinkBlockOrderByInput>;
  MembershipYears?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<HomePageV2ImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PodcastContentCategory?: InputMaybe<OrderBy>;
  PrimarySiteSettingsPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  ProfileDataValidationConfirmButtonLabel?: InputMaybe<OrderBy>;
  ProfileDataValidationContactInformationSectionTitle?: InputMaybe<OrderBy>;
  ProfileDataValidationEditLinkAriaLabel?: InputMaybe<OrderBy>;
  ProfileDataValidationModalDescription?: InputMaybe<OrderBy>;
  ProfileDataValidationModalTitle?: InputMaybe<OrderBy>;
  ProfileDataValidationPersonalInformationSectionTitle?: InputMaybe<OrderBy>;
  ProfileDataValidationProfessionalInformationSectionTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RenewMembershipDisplayText?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SiteSettingsPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<HomePageV2ImageBlockOrderByInput>;
  UpgradeMembershipDisplayText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VideoContentCategory?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HomePageV2Output = {
  __typename?: 'HomePageV2Output';
  autocomplete?: Maybe<HomePageV2Autocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HomePageV2Facet>;
  item?: Maybe<HomePageV2>;
  items?: Maybe<Array<Maybe<HomePageV2>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HomePageV2OutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomePageV2WhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationReceivedDisplayText?: InputMaybe<SearchableStringFilterInput>;
  ApplyForMembershipDisplayText?: InputMaybe<SearchableStringFilterInput>;
  ArticleContentCategory?: InputMaybe<SearchableStringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AudioContentCategory?: InputMaybe<SearchableStringFilterInput>;
  AuthenticatedContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  BiometricAuthenticationDisableMessage?: InputMaybe<SearchableStringFilterInput>;
  BiometricAuthenticationDismissButton?: InputMaybe<SearchableStringFilterInput>;
  BiometricAuthenticationEnableButton?: InputMaybe<SearchableStringFilterInput>;
  BiometricAuthenticationHeading?: InputMaybe<SearchableStringFilterInput>;
  BiometricAuthenticationLoginMessage?: InputMaybe<SearchableStringFilterInput>;
  CardsSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  CardsSectionTitleForMembers?: InputMaybe<SearchableStringFilterInput>;
  CardsTabLearnButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  CardsTabLearnContentCategory?: InputMaybe<SearchableStringFilterInput>;
  CardsTabMemberDirectoryContentCategory?: InputMaybe<StringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DashboardCarouselCardsContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  DaysLeft?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FinishApplicationDisplayText?: InputMaybe<SearchableStringFilterInput>;
  GuideContentCategory?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipPageLink?: InputMaybe<HomePageV2LinkBlockWhereInput>;
  MembershipYears?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<HomePageV2ImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PodcastContentCategory?: InputMaybe<SearchableStringFilterInput>;
  PrimarySiteSettingsPage?: InputMaybe<ContentModelReferenceWhereInput>;
  ProfileDataValidationConfirmButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfileDataValidationContactInformationSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  ProfileDataValidationEditLinkAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfileDataValidationModalDescription?: InputMaybe<SearchableStringFilterInput>;
  ProfileDataValidationModalTitle?: InputMaybe<SearchableStringFilterInput>;
  ProfileDataValidationPersonalInformationSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  ProfileDataValidationProfessionalInformationSectionTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RenewMembershipDisplayText?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SiteSettingsPage?: InputMaybe<ContentModelReferenceWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<HomePageV2ImageBlockWhereInput>;
  UpgradeMembershipDisplayText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VideoContentCategory?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HomePageV2WhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HomePageV2WhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HomePageV2WhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type HomePageWhereInput = {
  ActionCardsSubHeading?: InputMaybe<SearchableStringFilterInput>;
  AdminHeading?: InputMaybe<SearchableStringFilterInput>;
  AdminMemberDescription?: InputMaybe<SearchableStringFilterInput>;
  AdminMemberHeading?: InputMaybe<SearchableStringFilterInput>;
  AdminPreHeading?: InputMaybe<SearchableStringFilterInput>;
  AdminSvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Adminlogo?: InputMaybe<HomePageImageBlockWhereInput>;
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Button?: InputMaybe<HomePageLinkBlockWhereInput>;
  ButtonLabel?: InputMaybe<HomePageLinkBlockWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CoTlogo?: InputMaybe<HomePageImageBlockWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HeroImage?: InputMaybe<HomePageImageBlockWhereInput>;
  HeroMobileImage?: InputMaybe<HomePageImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtMemberlogo?: InputMaybe<HomePageImageBlockWhereInput>;
  MemberDescription?: InputMaybe<SearchableStringFilterInput>;
  MemberHeading?: InputMaybe<SearchableStringFilterInput>;
  MemberYearLabel?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<HomePageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SiteSettingsPage?: InputMaybe<ContentModelReferenceWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
  SvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SvgTextCardBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  TextContent?: InputMaybe<HomePageTextContentBlockWhereInput>;
  ThumbnailImage?: InputMaybe<HomePageImageBlockWhereInput>;
  ToTlogo?: InputMaybe<HomePageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HomePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HomePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HomePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type HostDefinitionModel = {
  __typename?: 'HostDefinitionModel';
  Language?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type HostDefinitionModelAutocomplete = {
  __typename?: 'HostDefinitionModelAutocomplete';
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Type?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HostDefinitionModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HostDefinitionModelAutocompleteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HostDefinitionModelFacet = {
  __typename?: 'HostDefinitionModelFacet';
  Language?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Type?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HostDefinitionModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HostDefinitionModelFacetTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HostDefinitionModelOrderByInput = {
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  Type?: InputMaybe<OrderBy>;
};

export type HostDefinitionModelWhereInput = {
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<StringFilterInput>;
  Type?: InputMaybe<StringFilterInput>;
};

export type IContent = {
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type IContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IData = {
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
};


export type IData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IconRequirementBlock = IContent & IData & {
  __typename?: 'IconRequirementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstLine?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SecondLine?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type IconRequirementBlockFirstLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IconRequirementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IconRequirementBlockSecondLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IconRequirementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IconRequirementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IconRequirementBlockAutocomplete = {
  __typename?: 'IconRequirementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IconRequirementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IconRequirementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IconRequirementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IconRequirementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IconRequirementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IconRequirementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IconRequirementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IconRequirementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IconRequirementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IconRequirementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IconRequirementBlockFacet = {
  __typename?: 'IconRequirementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstLine?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SecondLine?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IconRequirementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IconRequirementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IconRequirementBlockFacetFirstLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IconRequirementBlockFacetSecondLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IconRequirementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IconRequirementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IconRequirementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IconRequirementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstLine?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SecondLine?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IconRequirementBlockOutput = {
  __typename?: 'IconRequirementBlockOutput';
  autocomplete?: Maybe<IconRequirementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IconRequirementBlockFacet>;
  item?: Maybe<IconRequirementBlock>;
  items?: Maybe<Array<Maybe<IconRequirementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IconRequirementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconRequirementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstLine?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SecondLine?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IconRequirementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IconRequirementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IconRequirementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Image = IContent & IData & {
  __typename?: 'Image';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssetId?: Maybe<Scalars['Int']['output']>;
  AssetSize?: Maybe<Scalars['String']['output']>;
  AssetType?: Maybe<Scalars['Int']['output']>;
  AssetTypeName?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  CropName?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ImageHeight?: Maybe<Scalars['Int']['output']>;
  ImageWidth?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  ItemId?: Maybe<Scalars['Int']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastPublished?: Maybe<Scalars['Date']['output']>;
  MMUrl?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentImage?: Maybe<ContentModelReference>;
  ParentLink?: Maybe<ContentModelReference>;
  Preview?: Maybe<BlobModel>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  ReplacedWith?: Maybe<Scalars['Int']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  Source?: Maybe<BlobModel>;
  SourceFileExtension?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Title?: Maybe<Scalars['String']['output']>;
  Transcodes?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ImageContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Image_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Image_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageAutocomplete = {
  __typename?: 'ImageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssetSize?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssetTypeName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CropName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MMUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentImage?: Maybe<ContentModelReferenceAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Preview?: Maybe<BlobModelAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Source?: Maybe<BlobModelAutocomplete>;
  SourceFileExtension?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Title?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Transcodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteAssetSizeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteAssetTypeNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteCropNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteMmUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteSourceFileExtensionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteTranscodesArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

/** Image block used as a property */
export type ImageBlock = IContent & IData & {
  __typename?: 'ImageBlock';
  /** Text for this image when a user is reading the site with a screen reader. */
  AltText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** The image that will be rendered */
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Image block used as a property */
export type ImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type ImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type ImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type ImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type ImageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type ImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type ImageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type ImageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageBlockAutocomplete = {
  __typename?: 'ImageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageBlockFacet = {
  __typename?: 'ImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageBlockOutput = {
  __typename?: 'ImageBlockOutput';
  autocomplete?: Maybe<ImageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageBlockFacet>;
  item?: Maybe<ImageBlock>;
  items?: Maybe<Array<Maybe<ImageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** An Image Caption Rich Text Block */
export type ImageCaptionRichTextBlock = IContent & IData & {
  __typename?: 'ImageCaptionRichTextBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Footer?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ImageCaptionRichTextBlockImageBlock>;
  ImageDescription?: Maybe<Scalars['String']['output']>;
  ImagePosition?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** An Image Caption Rich Text Block */
export type ImageCaptionRichTextBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Image Caption Rich Text Block */
export type ImageCaptionRichTextBlockFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Image Caption Rich Text Block */
export type ImageCaptionRichTextBlockImageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Image Caption Rich Text Block */
export type ImageCaptionRichTextBlockImagePositionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Image Caption Rich Text Block */
export type ImageCaptionRichTextBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Image Caption Rich Text Block */
export type ImageCaptionRichTextBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Image Caption Rich Text Block */
export type ImageCaptionRichTextBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageCaptionRichTextBlockAutocomplete = {
  __typename?: 'ImageCaptionRichTextBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ImageCaptionRichTextBlockImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageCaptionRichTextBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageCaptionRichTextBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageCaptionRichTextBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageCaptionRichTextBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageCaptionRichTextBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageCaptionRichTextBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageCaptionRichTextBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageCaptionRichTextBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageCaptionRichTextBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageCaptionRichTextBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageCaptionRichTextBlockFacet = {
  __typename?: 'ImageCaptionRichTextBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Footer?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ImageCaptionRichTextBlockImageBlockFacet>;
  ImageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ImagePosition?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ImageCaptionRichTextBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageCaptionRichTextBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageCaptionRichTextBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetImageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetImagePositionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageCaptionRichTextBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageCaptionRichTextBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageCaptionRichTextBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageCaptionRichTextBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageCaptionRichTextBlockImageBlock = {
  __typename?: 'ImageCaptionRichTextBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type ImageCaptionRichTextBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageCaptionRichTextBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageCaptionRichTextBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageCaptionRichTextBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageCaptionRichTextBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageCaptionRichTextBlockImageBlockAutocomplete = {
  __typename?: 'ImageCaptionRichTextBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ImageCaptionRichTextBlockImageBlockFacet = {
  __typename?: 'ImageCaptionRichTextBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageCaptionRichTextBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageCaptionRichTextBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageCaptionRichTextBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageCaptionRichTextBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type ImageCaptionRichTextBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type ImageCaptionRichTextBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Footer?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ImageCaptionRichTextBlockImageBlockOrderByInput>;
  ImageDescription?: InputMaybe<OrderBy>;
  ImagePosition?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageCaptionRichTextBlockOutput = {
  __typename?: 'ImageCaptionRichTextBlockOutput';
  autocomplete?: Maybe<ImageCaptionRichTextBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageCaptionRichTextBlockFacet>;
  item?: Maybe<ImageCaptionRichTextBlock>;
  items?: Maybe<Array<Maybe<ImageCaptionRichTextBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageCaptionRichTextBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageCaptionRichTextBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Footer?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ImageCaptionRichTextBlockImageBlockWhereInput>;
  ImageDescription?: InputMaybe<SearchableStringFilterInput>;
  ImagePosition?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageCaptionRichTextBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageCaptionRichTextBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageCaptionRichTextBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ImageChoiceElementBlock = IContent & IData & {
  __typename?: 'ImageChoiceElementBlock';
  AllowMultiSelect?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Items?: Maybe<Array<Maybe<LinkItemNode>>>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  ShowSelectionInputControl?: Maybe<Scalars['Bool']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ImageChoiceElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageChoiceElementBlockAutocomplete = {
  __typename?: 'ImageChoiceElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Items?: Maybe<LinkItemNodeAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageChoiceElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockFacet = {
  __typename?: 'ImageChoiceElementBlockFacet';
  AllowMultiSelect?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<LinkItemNodeFacet>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowSelectionInputControl?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ImageChoiceElementBlockFacetAllowMultiSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageChoiceElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageChoiceElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageChoiceElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageChoiceElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetShowSelectionInputControlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageChoiceElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageChoiceElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageChoiceElementBlockOrderByInput = {
  AllowMultiSelect?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Items?: InputMaybe<LinkItemNodeOrderByInput>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowSelectionInputControl?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageChoiceElementBlockOutput = {
  __typename?: 'ImageChoiceElementBlockOutput';
  autocomplete?: Maybe<ImageChoiceElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageChoiceElementBlockFacet>;
  item?: Maybe<ImageChoiceElementBlock>;
  items?: Maybe<Array<Maybe<ImageChoiceElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageChoiceElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageChoiceElementBlockWhereInput = {
  AllowMultiSelect?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<LinkItemNodeWhereInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowSelectionInputControl?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageChoiceElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageChoiceElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageChoiceElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ImageFacet = {
  __typename?: 'ImageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssetId?: Maybe<Array<Maybe<NumberFacet>>>;
  AssetSize?: Maybe<Array<Maybe<StringFacet>>>;
  AssetType?: Maybe<Array<Maybe<NumberFacet>>>;
  AssetTypeName?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CropName?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageHeight?: Maybe<Array<Maybe<NumberFacet>>>;
  ImageWidth?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  ItemId?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastPublished?: Maybe<Array<Maybe<DateFacet>>>;
  MMUrl?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentImage?: Maybe<ContentModelReferenceFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Preview?: Maybe<BlobModelFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ReplacedWith?: Maybe<Array<Maybe<NumberFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  Source?: Maybe<BlobModelFacet>;
  SourceFileExtension?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Transcodes?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ImageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetAssetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageFacetAssetSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetAssetTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageFacetAssetTypeNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageFacetCropNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageFacetImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetItemIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageFacetLastPublishedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageFacetMmUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetReplacedWithArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetSourceFileExtensionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetTranscodesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

/** Block with image and Link */
export type ImageLinkBlock = IContent & IData & {
  __typename?: 'ImageLinkBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Image?: Maybe<ImageLinkBlockImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkBlock?: Maybe<ImageLinkBlockLinkBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Block with image and Link */
export type ImageLinkBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block with image and Link */
export type ImageLinkBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block with image and Link */
export type ImageLinkBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageLinkBlockAutocomplete = {
  __typename?: 'ImageLinkBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ImageLinkBlockImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkBlock?: Maybe<ImageLinkBlockLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageLinkBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageLinkBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageLinkBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageLinkBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageLinkBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageLinkBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageLinkBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageLinkBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageLinkBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageLinkBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageLinkBlockFacet = {
  __typename?: 'ImageLinkBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Image?: Maybe<ImageLinkBlockImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkBlock?: Maybe<ImageLinkBlockLinkBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ImageLinkBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageLinkBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageLinkBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageLinkBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageLinkBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageLinkBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageLinkBlockImageBlock = {
  __typename?: 'ImageLinkBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type ImageLinkBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageLinkBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageLinkBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageLinkBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageLinkBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageLinkBlockImageBlockAutocomplete = {
  __typename?: 'ImageLinkBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ImageLinkBlockImageBlockFacet = {
  __typename?: 'ImageLinkBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageLinkBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageLinkBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageLinkBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type ImageLinkBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type ImageLinkBlockLinkBlock = {
  __typename?: 'ImageLinkBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type ImageLinkBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageLinkBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageLinkBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageLinkBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageLinkBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageLinkBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageLinkBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageLinkBlockLinkBlockAutocomplete = {
  __typename?: 'ImageLinkBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageLinkBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageLinkBlockLinkBlockFacet = {
  __typename?: 'ImageLinkBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageLinkBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageLinkBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageLinkBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageLinkBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type ImageLinkBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type ImageLinkBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Image?: InputMaybe<ImageLinkBlockImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkBlock?: InputMaybe<ImageLinkBlockLinkBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageLinkBlockOutput = {
  __typename?: 'ImageLinkBlockOutput';
  autocomplete?: Maybe<ImageLinkBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageLinkBlockFacet>;
  item?: Maybe<ImageLinkBlock>;
  items?: Maybe<Array<Maybe<ImageLinkBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageLinkBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageLinkBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Image?: InputMaybe<ImageLinkBlockImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkBlock?: InputMaybe<ImageLinkBlockLinkBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageLinkBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageLinkBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageLinkBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ImageMedia = IContent & IData & {
  __typename?: 'ImageMedia';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ImageMediaContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageMediaNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageMedia_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageMedia_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageMediaAutocomplete = {
  __typename?: 'ImageMediaAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageMediaAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageMediaAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageMediaAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageMediaAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageMediaAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageMediaAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageMediaAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageMediaAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageMediaAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageMediaAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageMediaAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageMediaFacet = {
  __typename?: 'ImageMediaFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ImageMediaFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageMediaFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageMediaFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageMediaFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageMediaFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageMediaFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageMediaFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageMediaOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageMediaOutput = {
  __typename?: 'ImageMediaOutput';
  autocomplete?: Maybe<ImageMediaAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageMediaFacet>;
  item?: Maybe<ImageMedia>;
  items?: Maybe<Array<Maybe<ImageMedia>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageMediaOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageMediaWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageMediaWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageMediaWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageMediaWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ImageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AssetId?: InputMaybe<OrderBy>;
  AssetSize?: InputMaybe<OrderBy>;
  AssetType?: InputMaybe<OrderBy>;
  AssetTypeName?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CropName?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageHeight?: InputMaybe<OrderBy>;
  ImageWidth?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  ItemId?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastPublished?: InputMaybe<OrderBy>;
  MMUrl?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Preview?: InputMaybe<BlobModelOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  ReplacedWith?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  Source?: InputMaybe<BlobModelOrderByInput>;
  SourceFileExtension?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Transcodes?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageOutput = {
  __typename?: 'ImageOutput';
  autocomplete?: Maybe<ImageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageFacet>;
  item?: Maybe<Image>;
  items?: Maybe<Array<Maybe<Image>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block with image and text */
export type ImageTextBlock = IContent & IData & {
  __typename?: 'ImageTextBlock';
  AccessGroup?: Maybe<Scalars['String']['output']>;
  /** When checked, the text content will align to the top of the block */
  AlignTextToTop?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  CallToActionLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Image?: Maybe<ImageTextBlockImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** When checked, rearranges the text and content in the opposite order */
  ReverseContent?: Maybe<Scalars['Bool']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TextContent?: Maybe<ImageTextBlockTextContentBlock>;
  /** Determines the color scheme */
  Theme?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Block with image and text */
export type ImageTextBlockAccessGroupArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block with image and text */
export type ImageTextBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block with image and text */
export type ImageTextBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block with image and text */
export type ImageTextBlockCallToActionLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block with image and text */
export type ImageTextBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block with image and text */
export type ImageTextBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block with image and text */
export type ImageTextBlockThemeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block with image and text */
export type ImageTextBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block with image and text */
export type ImageTextBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageTextBlockAutocomplete = {
  __typename?: 'ImageTextBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ImageTextBlockImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageTextBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageTextBlockFacet = {
  __typename?: 'ImageTextBlockFacet';
  AccessGroup?: Maybe<Array<Maybe<StringFacet>>>;
  AlignTextToTop?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  CallToActionLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Image?: Maybe<ImageTextBlockImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ReverseContent?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TextContent?: Maybe<ImageTextBlockTextContentBlockFacet>;
  Theme?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ImageTextBlockFacetAccessGroupArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetAlignTextToTopArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageTextBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetReverseContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextBlockFacetThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageTextBlockImageBlock = {
  __typename?: 'ImageTextBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type ImageTextBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageTextBlockImageBlockAutocomplete = {
  __typename?: 'ImageTextBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ImageTextBlockImageBlockFacet = {
  __typename?: 'ImageTextBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageTextBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageTextBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageTextBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type ImageTextBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type ImageTextBlockOrderByInput = {
  AccessGroup?: InputMaybe<OrderBy>;
  AlignTextToTop?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  CallToActionLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Image?: InputMaybe<ImageTextBlockImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  ReverseContent?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TextContent?: InputMaybe<ImageTextBlockTextContentBlockOrderByInput>;
  Theme?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageTextBlockOutput = {
  __typename?: 'ImageTextBlockOutput';
  autocomplete?: Maybe<ImageTextBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageTextBlockFacet>;
  item?: Maybe<ImageTextBlock>;
  items?: Maybe<Array<Maybe<ImageTextBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageTextBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageTextBlockTextContentBlock = {
  __typename?: 'ImageTextBlockTextContentBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
};


export type ImageTextBlockTextContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextBlockTextContentBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextBlockTextContentBlockPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextBlockTextContentBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageTextBlockTextContentBlockFacet = {
  __typename?: 'ImageTextBlockTextContentBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageTextBlockTextContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockTextContentBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockTextContentBlockFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockTextContentBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageTextBlockTextContentBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  PreHeading?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
};

export type ImageTextBlockTextContentBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
};

/** Version 2 of the Image Text Block */
export type ImageTextBlockV2 = IContent & IData & {
  __typename?: 'ImageTextBlockV2';
  AccessGroup?: Maybe<Scalars['String']['output']>;
  /** Text for this image when a user is reading the site with a screen reader. */
  AltText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  CallToActionLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Specifies how the image will scale to fit its container. Cover means it will scale to fill the whole container and will crop overflow on the longer axis. Contain means it will scale to fit completely in the container and will be letterboxed on the shorter axis. */
  ImageFit?: Maybe<Scalars['String']['output']>;
  /** The image that will be rendered */
  ImageReference?: Maybe<ContentModelReference>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** When checked, rearranges the text and content in the opposite order */
  ReverseContent?: Maybe<Scalars['Bool']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Sets the vertical alignment of the content if container is larger than content. */
  TextAlignment?: Maybe<Scalars['String']['output']>;
  TextContent?: Maybe<ImageTextBlockV2TextContentBlock>;
  /** Determines the color scheme */
  Theme?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2AccessGroupArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2AltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2AnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2AnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2CallToActionLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2ImageFitArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2NameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2SeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2TextAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2ThemeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Version 2 of the Image Text Block */
export type ImageTextBlockV2_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageTextBlockV2Autocomplete = {
  __typename?: 'ImageTextBlockV2Autocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageTextBlockV2AutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockV2AutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockV2AutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockV2AutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockV2AutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockV2AutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockV2AutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockV2AutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockV2AutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextBlockV2Autocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageTextBlockV2Facet = {
  __typename?: 'ImageTextBlockV2Facet';
  AccessGroup?: Maybe<Array<Maybe<StringFacet>>>;
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  CallToActionLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageFit?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ReverseContent?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TextAlignment?: Maybe<Array<Maybe<StringFacet>>>;
  TextContent?: Maybe<ImageTextBlockV2TextContentBlockFacet>;
  Theme?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ImageTextBlockV2FacetAccessGroupArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextBlockV2FacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextBlockV2FacetImageFitArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageTextBlockV2FacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetReverseContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextBlockV2FacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextBlockV2FacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextBlockV2FacetTextAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2FacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2Facet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2Facet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageTextBlockV2OrderByInput = {
  AccessGroup?: InputMaybe<OrderBy>;
  AltText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  CallToActionLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageFit?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  ReverseContent?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TextAlignment?: InputMaybe<OrderBy>;
  TextContent?: InputMaybe<ImageTextBlockV2TextContentBlockOrderByInput>;
  Theme?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageTextBlockV2Output = {
  __typename?: 'ImageTextBlockV2Output';
  autocomplete?: Maybe<ImageTextBlockV2Autocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageTextBlockV2Facet>;
  item?: Maybe<ImageTextBlockV2>;
  items?: Maybe<Array<Maybe<ImageTextBlockV2>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageTextBlockV2OutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageTextBlockV2TextContentBlock = {
  __typename?: 'ImageTextBlockV2TextContentBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
};


export type ImageTextBlockV2TextContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextBlockV2TextContentBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextBlockV2TextContentBlockPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextBlockV2TextContentBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageTextBlockV2TextContentBlockFacet = {
  __typename?: 'ImageTextBlockV2TextContentBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageTextBlockV2TextContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2TextContentBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2TextContentBlockFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextBlockV2TextContentBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageTextBlockV2TextContentBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  PreHeading?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
};

export type ImageTextBlockV2TextContentBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type ImageTextBlockV2WhereInput = {
  AccessGroup?: InputMaybe<SearchableStringFilterInput>;
  AltText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  CallToActionLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageFit?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ReverseContent?: InputMaybe<BoolFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TextAlignment?: InputMaybe<SearchableStringFilterInput>;
  TextContent?: InputMaybe<ImageTextBlockV2TextContentBlockWhereInput>;
  Theme?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageTextBlockV2WhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageTextBlockV2WhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageTextBlockV2WhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ImageTextBlockWhereInput = {
  AccessGroup?: InputMaybe<SearchableStringFilterInput>;
  AlignTextToTop?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  CallToActionLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Image?: InputMaybe<ImageTextBlockImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ReverseContent?: InputMaybe<BoolFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TextContent?: InputMaybe<ImageTextBlockTextContentBlockWhereInput>;
  Theme?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageTextBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageTextBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageTextBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a image text card block */
export type ImageTextCardBlock = IContent & IData & {
  __typename?: 'ImageTextCardBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ImageTextCardBlockImageBlock>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkBlock?: Maybe<ImageTextCardBlockLinkBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a image text card block */
export type ImageTextCardBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a image text card block */
export type ImageTextCardBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a image text card block */
export type ImageTextCardBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a image text card block */
export type ImageTextCardBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a image text card block */
export type ImageTextCardBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a image text card block */
export type ImageTextCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a image text card block */
export type ImageTextCardBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a image text card block */
export type ImageTextCardBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a image text card block */
export type ImageTextCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a image text card block */
export type ImageTextCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageTextCardBlockAutocomplete = {
  __typename?: 'ImageTextCardBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ImageTextCardBlockImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkBlock?: Maybe<ImageTextCardBlockLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageTextCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageTextCardBlockFacet = {
  __typename?: 'ImageTextCardBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ImageTextCardBlockImageBlockFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkBlock?: Maybe<ImageTextCardBlockLinkBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ImageTextCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextCardBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageTextCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextCardBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextCardBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageTextCardBlockImageBlock = {
  __typename?: 'ImageTextCardBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type ImageTextCardBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextCardBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextCardBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextCardBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextCardBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageTextCardBlockImageBlockAutocomplete = {
  __typename?: 'ImageTextCardBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ImageTextCardBlockImageBlockFacet = {
  __typename?: 'ImageTextCardBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageTextCardBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageTextCardBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageTextCardBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type ImageTextCardBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type ImageTextCardBlockLinkBlock = {
  __typename?: 'ImageTextCardBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type ImageTextCardBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextCardBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextCardBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextCardBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextCardBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextCardBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextCardBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageTextCardBlockLinkBlockAutocomplete = {
  __typename?: 'ImageTextCardBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageTextCardBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageTextCardBlockLinkBlockFacet = {
  __typename?: 'ImageTextCardBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageTextCardBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageTextCardBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextCardBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageTextCardBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type ImageTextCardBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type ImageTextCardBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ImageTextCardBlockImageBlockOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkBlock?: InputMaybe<ImageTextCardBlockLinkBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageTextCardBlockOutput = {
  __typename?: 'ImageTextCardBlockOutput';
  autocomplete?: Maybe<ImageTextCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageTextCardBlockFacet>;
  item?: Maybe<ImageTextCardBlock>;
  items?: Maybe<Array<Maybe<ImageTextCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageTextCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageTextCardBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ImageTextCardBlockImageBlockWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkBlock?: InputMaybe<ImageTextCardBlockLinkBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageTextCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageTextCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageTextCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ImageTextItemBlock = IContent & IData & {
  __typename?: 'ImageTextItemBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ImageTextItemBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextItemBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageTextItemBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageTextItemBlockAutocomplete = {
  __typename?: 'ImageTextItemBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageTextItemBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextItemBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextItemBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextItemBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextItemBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextItemBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextItemBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextItemBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextItemBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageTextItemBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageTextItemBlockFacet = {
  __typename?: 'ImageTextItemBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ImageTextItemBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextItemBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextItemBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextItemBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextItemBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageTextItemBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageTextItemBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ImageTextItemBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ImageTextItemBlockOutput = {
  __typename?: 'ImageTextItemBlockOutput';
  autocomplete?: Maybe<ImageTextItemBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageTextItemBlockFacet>;
  item?: Maybe<ImageTextItemBlock>;
  items?: Maybe<Array<Maybe<ImageTextItemBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageTextItemBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageTextItemBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageTextItemBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageTextItemBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageTextItemBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ImageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AssetId?: InputMaybe<IntFilterInput>;
  AssetSize?: InputMaybe<StringFilterInput>;
  AssetType?: InputMaybe<IntFilterInput>;
  AssetTypeName?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CropName?: InputMaybe<StringFilterInput>;
  Description?: InputMaybe<StringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageHeight?: InputMaybe<IntFilterInput>;
  ImageWidth?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  ItemId?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastPublished?: InputMaybe<DateFilterInput>;
  MMUrl?: InputMaybe<StringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentImage?: InputMaybe<ContentModelReferenceWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Preview?: InputMaybe<BlobModelWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ReplacedWith?: InputMaybe<IntFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  Source?: InputMaybe<BlobModelWhereInput>;
  SourceFileExtension?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Title?: InputMaybe<StringFilterInput>;
  Transcodes?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type InfoBoxBlock = IContent & IData & {
  __typename?: 'InfoBoxBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type InfoBoxBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type InfoBoxBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type InfoBoxBlockTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type InfoBoxBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type InfoBoxBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type InfoBoxBlockAutocomplete = {
  __typename?: 'InfoBoxBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type InfoBoxBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InfoBoxBlockFacet = {
  __typename?: 'InfoBoxBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type InfoBoxBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type InfoBoxBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type InfoBoxBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type InfoBoxBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type InfoBoxBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type InfoBoxBlockFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type InfoBoxBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type InfoBoxBlockOutput = {
  __typename?: 'InfoBoxBlockOutput';
  autocomplete?: Maybe<InfoBoxBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<InfoBoxBlockFacet>;
  item?: Maybe<InfoBoxBlock>;
  items?: Maybe<Array<Maybe<InfoBoxBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type InfoBoxBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InfoBoxBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<InfoBoxBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<InfoBoxBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<InfoBoxBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type InlineBlockPropertyModelSearch = {
  __typename?: 'InlineBlockPropertyModelSearch';
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type InlineBlockPropertyModelSearchContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type InlineBlockPropertyModelSearchFacet = {
  __typename?: 'InlineBlockPropertyModelSearchFacet';
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type InlineBlockPropertyModelSearchFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InlineBlockPropertyModelSearchOrderByInput = {
  ContentType?: InputMaybe<OrderBy>;
};

export type InlineBlockPropertyModelSearchWhereInput = {
  ContentType?: InputMaybe<SearchableStringFilterInput>;
};

export type IntFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `Factor` allows you to use a number value in a field to influence the `_score` directly. If used on a multi-valued field, then only the lowest value of the field is used in calculations. Default for `value` is `1`. Default for `modifier` is `NONE`. */
  factor?: InputMaybe<NumberFactor>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Int']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** A link block value and a key string property on one block */
export type KeyLinkValueBlock = IContent & IData & {
  __typename?: 'KeyLinkValueBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Key?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<KeyLinkValueBlockLinkBlock>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A link block value and a key string property on one block */
export type KeyLinkValueBlockKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A link block value and a key string property on one block */
export type KeyLinkValueBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A link block value and a key string property on one block */
export type KeyLinkValueBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A link block value and a key string property on one block */
export type KeyLinkValueBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type KeyLinkValueBlockAutocomplete = {
  __typename?: 'KeyLinkValueBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Value?: Maybe<KeyLinkValueBlockLinkBlockAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type KeyLinkValueBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyLinkValueBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyLinkValueBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyLinkValueBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyLinkValueBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyLinkValueBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyLinkValueBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyLinkValueBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyLinkValueBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyLinkValueBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type KeyLinkValueBlockFacet = {
  __typename?: 'KeyLinkValueBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<KeyLinkValueBlockLinkBlockFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type KeyLinkValueBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyLinkValueBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyLinkValueBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type KeyLinkValueBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyLinkValueBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyLinkValueBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyLinkValueBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type KeyLinkValueBlockLinkBlock = {
  __typename?: 'KeyLinkValueBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type KeyLinkValueBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type KeyLinkValueBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type KeyLinkValueBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type KeyLinkValueBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type KeyLinkValueBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type KeyLinkValueBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type KeyLinkValueBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type KeyLinkValueBlockLinkBlockAutocomplete = {
  __typename?: 'KeyLinkValueBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type KeyLinkValueBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type KeyLinkValueBlockLinkBlockFacet = {
  __typename?: 'KeyLinkValueBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type KeyLinkValueBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type KeyLinkValueBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyLinkValueBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type KeyLinkValueBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type KeyLinkValueBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type KeyLinkValueBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Key?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Value?: InputMaybe<KeyLinkValueBlockLinkBlockOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type KeyLinkValueBlockOutput = {
  __typename?: 'KeyLinkValueBlockOutput';
  autocomplete?: Maybe<KeyLinkValueBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<KeyLinkValueBlockFacet>;
  item?: Maybe<KeyLinkValueBlock>;
  items?: Maybe<Array<Maybe<KeyLinkValueBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type KeyLinkValueBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KeyLinkValueBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Key?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Value?: InputMaybe<KeyLinkValueBlockLinkBlockWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<KeyLinkValueBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<KeyLinkValueBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<KeyLinkValueBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A translatable block value and a key string property on one block */
export type KeyTranslatedValueBlock = IContent & IData & {
  __typename?: 'KeyTranslatedValueBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Key?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A translatable block value and a key string property on one block */
export type KeyTranslatedValueBlockKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A translatable block value and a key string property on one block */
export type KeyTranslatedValueBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A translatable block value and a key string property on one block */
export type KeyTranslatedValueBlockValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A translatable block value and a key string property on one block */
export type KeyTranslatedValueBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A translatable block value and a key string property on one block */
export type KeyTranslatedValueBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type KeyTranslatedValueBlockAutocomplete = {
  __typename?: 'KeyTranslatedValueBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type KeyTranslatedValueBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyTranslatedValueBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyTranslatedValueBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyTranslatedValueBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyTranslatedValueBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyTranslatedValueBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyTranslatedValueBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyTranslatedValueBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyTranslatedValueBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type KeyTranslatedValueBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type KeyTranslatedValueBlockFacet = {
  __typename?: 'KeyTranslatedValueBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type KeyTranslatedValueBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyTranslatedValueBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyTranslatedValueBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type KeyTranslatedValueBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyTranslatedValueBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyTranslatedValueBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyTranslatedValueBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type KeyTranslatedValueBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type KeyTranslatedValueBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Key?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type KeyTranslatedValueBlockOutput = {
  __typename?: 'KeyTranslatedValueBlockOutput';
  autocomplete?: Maybe<KeyTranslatedValueBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<KeyTranslatedValueBlockFacet>;
  item?: Maybe<KeyTranslatedValueBlock>;
  items?: Maybe<Array<Maybe<KeyTranslatedValueBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type KeyTranslatedValueBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KeyTranslatedValueBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Key?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<KeyTranslatedValueBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<KeyTranslatedValueBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<KeyTranslatedValueBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A landing page to direct users to other content */
export type LandingPage = IContent & IData & {
  __typename?: 'LandingPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  ImageTextBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<LandingPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<LandingPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A landing page to direct users to other content */
export type LandingPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page to direct users to other content */
export type LandingPageImageTextBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page to direct users to other content */
export type LandingPageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page to direct users to other content */
export type LandingPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page to direct users to other content */
export type LandingPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page to direct users to other content */
export type LandingPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page to direct users to other content */
export type LandingPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page to direct users to other content */
export type LandingPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page to direct users to other content */
export type LandingPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LandingPageAutocomplete = {
  __typename?: 'LandingPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<LandingPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<LandingPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LandingPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LandingPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LandingPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LandingPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LandingPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LandingPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LandingPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LandingPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LandingPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LandingPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LandingPageFacet = {
  __typename?: 'LandingPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  ImageTextBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<LandingPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<LandingPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LandingPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LandingPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LandingPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LandingPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LandingPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LandingPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LandingPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LandingPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LandingPageImageBlock = {
  __typename?: 'LandingPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type LandingPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LandingPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LandingPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LandingPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LandingPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LandingPageImageBlockAutocomplete = {
  __typename?: 'LandingPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type LandingPageImageBlockFacet = {
  __typename?: 'LandingPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LandingPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LandingPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LandingPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LandingPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type LandingPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type LandingPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  ImageTextBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<LandingPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<LandingPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LandingPageOutput = {
  __typename?: 'LandingPageOutput';
  autocomplete?: Maybe<LandingPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LandingPageFacet>;
  item?: Maybe<LandingPage>;
  items?: Maybe<Array<Maybe<LandingPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LandingPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LandingPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  ImageTextBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<LandingPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<LandingPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LandingPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LandingPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LandingPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data about each language */
export type LanguageIdAndName = IContent & IData & {
  __typename?: 'LanguageIdAndName';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LanguageId?: Maybe<Scalars['String']['output']>;
  LanguageName?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SelectLanguage?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data about each language */
export type LanguageIdAndNameLanguageIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data about each language */
export type LanguageIdAndNameLanguageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data about each language */
export type LanguageIdAndNameNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data about each language */
export type LanguageIdAndName_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data about each language */
export type LanguageIdAndName_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LanguageIdAndNameAutocomplete = {
  __typename?: 'LanguageIdAndNameAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SelectLanguage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LanguageIdAndNameAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguageIdAndNameAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguageIdAndNameAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguageIdAndNameAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguageIdAndNameAutocompleteSelectLanguageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguageIdAndNameAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguageIdAndNameAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguageIdAndNameAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguageIdAndNameAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguageIdAndNameAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguageIdAndNameAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LanguageIdAndNameFacet = {
  __typename?: 'LanguageIdAndNameFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LanguageId?: Maybe<Array<Maybe<StringFacet>>>;
  LanguageName?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelectLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LanguageIdAndNameFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageIdAndNameFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageIdAndNameFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LanguageIdAndNameFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetLanguageIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetLanguageNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageIdAndNameFacetSelectLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageIdAndNameFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageIdAndNameFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguageIdAndNameFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LanguageIdAndNameOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LanguageId?: InputMaybe<OrderBy>;
  LanguageName?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelectLanguage?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LanguageIdAndNameOutput = {
  __typename?: 'LanguageIdAndNameOutput';
  autocomplete?: Maybe<LanguageIdAndNameAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LanguageIdAndNameFacet>;
  item?: Maybe<LanguageIdAndName>;
  items?: Maybe<Array<Maybe<LanguageIdAndName>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LanguageIdAndNameOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LanguageIdAndNameWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LanguageId?: InputMaybe<SearchableStringFilterInput>;
  LanguageName?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelectLanguage?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LanguageIdAndNameWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LanguageIdAndNameWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LanguageIdAndNameWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This renders different languages in a block */
export type LanguagesBlock = IContent & IData & {
  __typename?: 'LanguagesBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Preheading?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This renders different languages in a block */
export type LanguagesBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This renders different languages in a block */
export type LanguagesBlockPreheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This renders different languages in a block */
export type LanguagesBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This renders different languages in a block */
export type LanguagesBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LanguagesBlockAutocomplete = {
  __typename?: 'LanguagesBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LanguagesBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguagesBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguagesBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguagesBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguagesBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguagesBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguagesBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguagesBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguagesBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LanguagesBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LanguagesBlockFacet = {
  __typename?: 'LanguagesBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Preheading?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LanguagesBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguagesBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguagesBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LanguagesBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacetPreheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguagesBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguagesBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguagesBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LanguagesBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LanguagesBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Preheading?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LanguagesBlockOutput = {
  __typename?: 'LanguagesBlockOutput';
  autocomplete?: Maybe<LanguagesBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LanguagesBlockFacet>;
  item?: Maybe<LanguagesBlock>;
  items?: Maybe<Array<Maybe<LanguagesBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LanguagesBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LanguagesBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Preheading?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LanguagesBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LanguagesBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LanguagesBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlock = IContent & IData & {
  __typename?: 'LearnCarouselContainerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AuthorsByLine?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  /** Automatically adds up to 12 of the most recent items after the items manually added on this block. */
  IncludeRecentlyAdded?: Maybe<Scalars['Bool']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Items?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  ReadLinkLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  /** The categories to be used for the carousel (only works if Use filtering by content catgory is enabled) */
  SelectedCategories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** Use the content filter to pull items into the carousel only, ignoring the added items and always pulling the newest items from the selected category into the carousel. */
  UseFilteringByContentCategory?: Maybe<Scalars['Bool']['output']>;
  /** Uses the single item layout */
  UseHeroLayout?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockAuthorsByLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockReadLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LearnCarouselContainerBlockAutocomplete = {
  __typename?: 'LearnCarouselContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SelectedCategories?: Maybe<ContentModelReferenceAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LearnCarouselContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LearnCarouselContainerBlockFacet = {
  __typename?: 'LearnCarouselContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorsByLine?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncludeRecentlyAdded?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<ContentAreaItemModelSearchFacet>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ReadLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelectedCategories?: Maybe<ContentModelReferenceFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UseFilteringByContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  UseHeroLayout?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LearnCarouselContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetAuthorsByLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnCarouselContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnCarouselContainerBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetIncludeRecentlyAddedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnCarouselContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetReadLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnCarouselContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnCarouselContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnCarouselContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetUseFilteringByContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacetUseHeroLayoutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LearnCarouselContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AuthorsByLine?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IncludeRecentlyAdded?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Items?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ReadLinkLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelectedCategories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UseFilteringByContentCategory?: InputMaybe<OrderBy>;
  UseHeroLayout?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LearnCarouselContainerBlockOutput = {
  __typename?: 'LearnCarouselContainerBlockOutput';
  autocomplete?: Maybe<LearnCarouselContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LearnCarouselContainerBlockFacet>;
  item?: Maybe<LearnCarouselContainerBlock>;
  items?: Maybe<Array<Maybe<LearnCarouselContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LearnCarouselContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockV2 = IContent & IData & {
  __typename?: 'LearnCarouselContainerBlockV2';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedSelectedSources?: Maybe<Array<Maybe<SourcesEntry>>>;
  ExpandedSelectedTopics?: Maybe<Array<Maybe<TopicsEntry>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  /** Only used when type is Source */
  SelectedSources?: Maybe<Array<Maybe<ContentModelReference>>>;
  /** Only used when type is Topic */
  SelectedTopics?: Maybe<Array<Maybe<ContentModelReference>>>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  ShowMagazineIssueFilter?: Maybe<Scalars['Bool']['output']>;
  ShowSourcesFilter?: Maybe<Scalars['Bool']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  /** Only used when Show Sources Filter is enabled */
  SourcesFilterAllSelectionLabel?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Only used when type is Local Advice */
  TargetMarket?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UseHeroLayout?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockV2HeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockV2NameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockV2SourcesFilterAllSelectionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockV2TargetMarketArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockV2TypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockV2_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a carousel of Learn Detail pages */
export type LearnCarouselContainerBlockV2_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LearnCarouselContainerBlockV2Autocomplete = {
  __typename?: 'LearnCarouselContainerBlockV2Autocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedSelectedSources?: Maybe<SourcesEntryAutocomplete>;
  ExpandedSelectedTopics?: Maybe<TopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SelectedSources?: Maybe<ContentModelReferenceAutocomplete>;
  SelectedTopics?: Maybe<ContentModelReferenceAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LearnCarouselContainerBlockV2AutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockV2AutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockV2AutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockV2AutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockV2AutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockV2AutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockV2AutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockV2AutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockV2AutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnCarouselContainerBlockV2Autocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LearnCarouselContainerBlockV2Facet = {
  __typename?: 'LearnCarouselContainerBlockV2Facet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedSelectedSources?: Maybe<SourcesEntryFacet>;
  ExpandedSelectedTopics?: Maybe<TopicsEntryFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelectedSources?: Maybe<ContentModelReferenceFacet>;
  SelectedTopics?: Maybe<ContentModelReferenceFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowMagazineIssueFilter?: Maybe<Array<Maybe<StringFacet>>>;
  ShowSourcesFilter?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SourcesFilterAllSelectionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TargetMarket?: Maybe<Array<Maybe<StringFacet>>>;
  Type?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UseHeroLayout?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LearnCarouselContainerBlockV2FacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnCarouselContainerBlockV2FacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnCarouselContainerBlockV2FacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnCarouselContainerBlockV2FacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnCarouselContainerBlockV2FacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetShowMagazineIssueFilterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetShowSourcesFilterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetSourcesFilterAllSelectionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnCarouselContainerBlockV2FacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnCarouselContainerBlockV2FacetTargetMarketArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2FacetUseHeroLayoutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2Facet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnCarouselContainerBlockV2Facet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LearnCarouselContainerBlockV2OrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedSelectedSources?: InputMaybe<SourcesEntryOrderByInput>;
  ExpandedSelectedTopics?: InputMaybe<TopicsEntryOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelectedSources?: InputMaybe<ContentModelReferenceOrderByInput>;
  SelectedTopics?: InputMaybe<ContentModelReferenceOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowMagazineIssueFilter?: InputMaybe<OrderBy>;
  ShowSourcesFilter?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SourcesFilterAllSelectionLabel?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TargetMarket?: InputMaybe<OrderBy>;
  Type?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UseHeroLayout?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LearnCarouselContainerBlockV2Output = {
  __typename?: 'LearnCarouselContainerBlockV2Output';
  autocomplete?: Maybe<LearnCarouselContainerBlockV2Autocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LearnCarouselContainerBlockV2Facet>;
  item?: Maybe<LearnCarouselContainerBlockV2>;
  items?: Maybe<Array<Maybe<LearnCarouselContainerBlockV2>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LearnCarouselContainerBlockV2OutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LearnCarouselContainerBlockV2WhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedSelectedSources?: InputMaybe<SourcesEntryWhereInput>;
  ExpandedSelectedTopics?: InputMaybe<TopicsEntryWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelectedSources?: InputMaybe<ContentModelReferenceWhereInput>;
  SelectedTopics?: InputMaybe<ContentModelReferenceWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowMagazineIssueFilter?: InputMaybe<BoolFilterInput>;
  ShowSourcesFilter?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SourcesFilterAllSelectionLabel?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TargetMarket?: InputMaybe<SearchableStringFilterInput>;
  Type?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UseHeroLayout?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LearnCarouselContainerBlockV2WhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LearnCarouselContainerBlockV2WhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LearnCarouselContainerBlockV2WhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type LearnCarouselContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AuthorsByLine?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncludeRecentlyAdded?: InputMaybe<BoolFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ReadLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelectedCategories?: InputMaybe<ContentModelReferenceWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UseFilteringByContentCategory?: InputMaybe<BoolFilterInput>;
  UseHeroLayout?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LearnCarouselContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LearnCarouselContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LearnCarouselContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Learn Detail Page */
export type LearnDetailPage = IContent & IData & {
  __typename?: 'LearnDetailPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  /** The author names will be generated from the blocks added here */
  Authors?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  AuthorsByLine?: Maybe<Scalars['String']['output']>;
  CareerStage?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  ContentTypeSelection?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Date?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  DisplayedDate?: Maybe<Scalars['Date']['output']>;
  DisplayedDateYear?: Maybe<Scalars['String']['output']>;
  ExcludeFromAudiencesUpdateUntil?: Maybe<Scalars['Date']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedAuthors?: Maybe<Array<Maybe<AuthorsEntry>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  Footnote?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HideFromAutoCarousels?: Maybe<Scalars['Bool']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Used by Mobile Api. Cannot be edited. */
  LanguageBranchId?: Maybe<Scalars['String']['output']>;
  MagazineIssueMonth?: Maybe<Scalars['Int']['output']>;
  MagazineIssueYear?: Maybe<Scalars['Int']['output']>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<LearnDetailPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Deprecated, will be removed. Instead Read Time In Seconds field will be filled automatically */
  ReadTime?: Maybe<Scalars['String']['output']>;
  /** Read Time In Seconds field is filled after a resource is published or by an automatic job that runs for the published pages once a weak */
  ReadTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** This can be Audio/Image/Video file */
  Resource?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SideBar?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Deprecated, will be removed. Please use Subheading Rich Text field for future updates */
  Subheading?: Maybe<Scalars['String']['output']>;
  /** New rich text Subheading field to replace the plain string Subheading field */
  SubheadingText?: Maybe<Scalars['String']['output']>;
  TargetMarket?: Maybe<Scalars['String']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<LearnDetailPageImageBlock>;
  TopicsCoveredLine?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageAuthorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageAuthorsByLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageCareerStageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageFootnoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageLanguageBranchIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageReadTimeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageResourceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageSideBarArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageSubheadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageTargetMarketArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPageTopicsCoveredLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Detail Page */
export type LearnDetailPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LearnDetailPageAutocomplete = {
  __typename?: 'LearnDetailPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DisplayedDateYear?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedAuthors?: Maybe<AuthorsEntryAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<LearnDetailPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<LearnDetailPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LearnDetailPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnDetailPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnDetailPageAutocompleteDisplayedDateYearArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnDetailPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnDetailPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnDetailPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnDetailPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnDetailPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnDetailPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnDetailPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnDetailPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LearnDetailPageFacet = {
  __typename?: 'LearnDetailPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Authors?: Maybe<ContentAreaItemModelSearchFacet>;
  AuthorsByLine?: Maybe<Array<Maybe<StringFacet>>>;
  CareerStage?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentTypeSelection?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Date?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  DisplayedDate?: Maybe<Array<Maybe<DateFacet>>>;
  DisplayedDateYear?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromAudiencesUpdateUntil?: Maybe<Array<Maybe<DateFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedAuthors?: Maybe<AuthorsEntryFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  Footnote?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HideFromAutoCarousels?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LanguageBranchId?: Maybe<Array<Maybe<StringFacet>>>;
  MagazineIssueMonth?: Maybe<Array<Maybe<NumberFacet>>>;
  MagazineIssueYear?: Maybe<Array<Maybe<NumberFacet>>>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<LearnDetailPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ReadTime?: Maybe<Array<Maybe<StringFacet>>>;
  ReadTimeInSeconds?: Maybe<Array<Maybe<NumberFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  Resource?: Maybe<ContentAreaItemModelSearchFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SideBar?: Maybe<ContentAreaItemModelSearchFacet>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subheading?: Maybe<Array<Maybe<StringFacet>>>;
  SubheadingText?: Maybe<Array<Maybe<StringFacet>>>;
  TargetMarket?: Maybe<Array<Maybe<StringFacet>>>;
  ThumbnailImage?: Maybe<LearnDetailPageImageBlockFacet>;
  TopicsCoveredLine?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LearnDetailPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetAuthorsByLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetCareerStageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnDetailPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnDetailPageFacetContentTypeSelectionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnDetailPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnDetailPageFacetDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnDetailPageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetDisplayedDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnDetailPageFacetDisplayedDateYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetExcludeFromAudiencesUpdateUntilArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnDetailPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetFootnoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetHideFromAutoCarouselsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnDetailPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetLanguageBranchIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetMagazineIssueMonthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnDetailPageFacetMagazineIssueYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnDetailPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetReadTimeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetReadTimeInSecondsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnDetailPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnDetailPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnDetailPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnDetailPageFacetSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetSubheadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetTargetMarketArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetTopicsCoveredLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LearnDetailPageImageBlock = {
  __typename?: 'LearnDetailPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type LearnDetailPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnDetailPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnDetailPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnDetailPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnDetailPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LearnDetailPageImageBlockAutocomplete = {
  __typename?: 'LearnDetailPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type LearnDetailPageImageBlockFacet = {
  __typename?: 'LearnDetailPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LearnDetailPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnDetailPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnDetailPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LearnDetailPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type LearnDetailPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type LearnDetailPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Authors?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  AuthorsByLine?: InputMaybe<OrderBy>;
  CareerStage?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  ContentTypeSelection?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Date?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  DisplayedDate?: InputMaybe<OrderBy>;
  DisplayedDateYear?: InputMaybe<OrderBy>;
  ExcludeFromAudiencesUpdateUntil?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedAuthors?: InputMaybe<AuthorsEntryOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  Footnote?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HideFromAutoCarousels?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LanguageBranchId?: InputMaybe<OrderBy>;
  MagazineIssueMonth?: InputMaybe<OrderBy>;
  MagazineIssueYear?: InputMaybe<OrderBy>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<LearnDetailPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ReadTime?: InputMaybe<OrderBy>;
  ReadTimeInSeconds?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  Resource?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SideBar?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subheading?: InputMaybe<OrderBy>;
  SubheadingText?: InputMaybe<OrderBy>;
  TargetMarket?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<LearnDetailPageImageBlockOrderByInput>;
  TopicsCoveredLine?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LearnDetailPageOutput = {
  __typename?: 'LearnDetailPageOutput';
  autocomplete?: Maybe<LearnDetailPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LearnDetailPageFacet>;
  item?: Maybe<LearnDetailPage>;
  items?: Maybe<Array<Maybe<LearnDetailPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LearnDetailPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LearnDetailPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Authors?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  AuthorsByLine?: InputMaybe<SearchableStringFilterInput>;
  CareerStage?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  ContentTypeSelection?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Date?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  DisplayedDate?: InputMaybe<DateFilterInput>;
  DisplayedDateYear?: InputMaybe<StringFilterInput>;
  ExcludeFromAudiencesUpdateUntil?: InputMaybe<DateFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedAuthors?: InputMaybe<AuthorsEntryWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  Footnote?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HideFromAutoCarousels?: InputMaybe<BoolFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LanguageBranchId?: InputMaybe<SearchableStringFilterInput>;
  MagazineIssueMonth?: InputMaybe<IntFilterInput>;
  MagazineIssueYear?: InputMaybe<IntFilterInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<LearnDetailPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ReadTime?: InputMaybe<SearchableStringFilterInput>;
  ReadTimeInSeconds?: InputMaybe<IntFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  Resource?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SideBar?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subheading?: InputMaybe<SearchableStringFilterInput>;
  SubheadingText?: InputMaybe<SearchableStringFilterInput>;
  TargetMarket?: InputMaybe<SearchableStringFilterInput>;
  ThumbnailImage?: InputMaybe<LearnDetailPageImageBlockWhereInput>;
  TopicsCoveredLine?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LearnDetailPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LearnDetailPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LearnDetailPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Learn Hero Image Block */
export type LearnHeroImageBlock = IContent & IData & {
  __typename?: 'LearnHeroImageBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HeroImage?: Maybe<LearnHeroImageBlockImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MobileImage?: Maybe<LearnHeroImageBlockImageBlock>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Learn Hero Image Block */
export type LearnHeroImageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Hero Image Block */
export type LearnHeroImageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Hero Image Block */
export type LearnHeroImageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LearnHeroImageBlockAutocomplete = {
  __typename?: 'LearnHeroImageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  HeroImage?: Maybe<LearnHeroImageBlockImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MobileImage?: Maybe<LearnHeroImageBlockImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LearnHeroImageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnHeroImageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnHeroImageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnHeroImageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnHeroImageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnHeroImageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnHeroImageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnHeroImageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnHeroImageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnHeroImageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LearnHeroImageBlockFacet = {
  __typename?: 'LearnHeroImageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HeroImage?: Maybe<LearnHeroImageBlockImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MobileImage?: Maybe<LearnHeroImageBlockImageBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LearnHeroImageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnHeroImageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnHeroImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnHeroImageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnHeroImageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnHeroImageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnHeroImageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LearnHeroImageBlockImageBlock = {
  __typename?: 'LearnHeroImageBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type LearnHeroImageBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnHeroImageBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnHeroImageBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnHeroImageBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnHeroImageBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LearnHeroImageBlockImageBlockAutocomplete = {
  __typename?: 'LearnHeroImageBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type LearnHeroImageBlockImageBlockFacet = {
  __typename?: 'LearnHeroImageBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LearnHeroImageBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnHeroImageBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnHeroImageBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LearnHeroImageBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type LearnHeroImageBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type LearnHeroImageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HeroImage?: InputMaybe<LearnHeroImageBlockImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MobileImage?: InputMaybe<LearnHeroImageBlockImageBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LearnHeroImageBlockOutput = {
  __typename?: 'LearnHeroImageBlockOutput';
  autocomplete?: Maybe<LearnHeroImageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LearnHeroImageBlockFacet>;
  item?: Maybe<LearnHeroImageBlock>;
  items?: Maybe<Array<Maybe<LearnHeroImageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LearnHeroImageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LearnHeroImageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HeroImage?: InputMaybe<LearnHeroImageBlockImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MobileImage?: InputMaybe<LearnHeroImageBlockImageBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LearnHeroImageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LearnHeroImageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LearnHeroImageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A landing page for Learn resources */
export type LearnLandingPage = IContent & IData & {
  __typename?: 'LearnLandingPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  /** If the Hero Image is populated, the carousel will not show */
  HeroCarousel?: Maybe<LearnLandingPageLearnCarouselContainerBlock>;
  /** Renders blocks within the hero section container */
  HeroContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  HeroImage?: Maybe<LearnLandingPageImageBlock>;
  HeroImageAltText?: Maybe<Scalars['String']['output']>;
  HeroImageLink?: Maybe<Scalars['String']['output']>;
  /** Leave unpopulated to show the hero carousel */
  HeroImageReference?: Maybe<ContentModelReference>;
  /** Shown at the bottom of the hero section */
  HeroLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  HeroTextContentBlock?: Maybe<LearnLandingPageHeroTextContentBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<LearnLandingPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<LearnLandingPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewTopicsLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A landing page for Learn resources */
export type LearnLandingPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page for Learn resources */
export type LearnLandingPageHeroContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page for Learn resources */
export type LearnLandingPageHeroImageAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page for Learn resources */
export type LearnLandingPageHeroLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page for Learn resources */
export type LearnLandingPageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page for Learn resources */
export type LearnLandingPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page for Learn resources */
export type LearnLandingPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page for Learn resources */
export type LearnLandingPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page for Learn resources */
export type LearnLandingPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page for Learn resources */
export type LearnLandingPageViewTopicsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page for Learn resources */
export type LearnLandingPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A landing page for Learn resources */
export type LearnLandingPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LearnLandingPageAutocomplete = {
  __typename?: 'LearnLandingPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  HeroCarousel?: Maybe<LearnLandingPageLearnCarouselContainerBlockAutocomplete>;
  HeroImage?: Maybe<LearnLandingPageImageBlockAutocomplete>;
  HeroImageLink?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeroImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<LearnLandingPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<LearnLandingPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LearnLandingPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnLandingPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnLandingPageAutocompleteHeroImageLinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnLandingPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnLandingPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnLandingPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnLandingPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnLandingPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnLandingPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnLandingPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnLandingPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LearnLandingPageFacet = {
  __typename?: 'LearnLandingPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  HeroCarousel?: Maybe<LearnLandingPageLearnCarouselContainerBlockFacet>;
  HeroContent?: Maybe<ContentAreaItemModelSearchFacet>;
  HeroImage?: Maybe<LearnLandingPageImageBlockFacet>;
  HeroImageAltText?: Maybe<Array<Maybe<StringFacet>>>;
  HeroImageLink?: Maybe<Array<Maybe<StringFacet>>>;
  HeroImageReference?: Maybe<ContentModelReferenceFacet>;
  HeroLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  HeroTextContentBlock?: Maybe<LearnLandingPageHeroTextContentBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<LearnLandingPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<LearnLandingPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewTopicsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LearnLandingPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnLandingPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnLandingPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnLandingPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetHeroImageAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetHeroImageLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnLandingPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnLandingPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnLandingPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnLandingPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacetViewTopicsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LearnLandingPageHeroTextContentBlock = {
  __typename?: 'LearnLandingPageHeroTextContentBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
};


export type LearnLandingPageHeroTextContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnLandingPageHeroTextContentBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnLandingPageHeroTextContentBlockPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnLandingPageHeroTextContentBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LearnLandingPageHeroTextContentBlockFacet = {
  __typename?: 'LearnLandingPageHeroTextContentBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LearnLandingPageHeroTextContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageHeroTextContentBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageHeroTextContentBlockFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageHeroTextContentBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LearnLandingPageHeroTextContentBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  PreHeading?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
};

export type LearnLandingPageHeroTextContentBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type LearnLandingPageImageBlock = {
  __typename?: 'LearnLandingPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type LearnLandingPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnLandingPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnLandingPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnLandingPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnLandingPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LearnLandingPageImageBlockAutocomplete = {
  __typename?: 'LearnLandingPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type LearnLandingPageImageBlockFacet = {
  __typename?: 'LearnLandingPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LearnLandingPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnLandingPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LearnLandingPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type LearnLandingPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type LearnLandingPageLearnCarouselContainerBlock = {
  __typename?: 'LearnLandingPageLearnCarouselContainerBlock';
  AuthorsByLine?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncludeRecentlyAdded?: Maybe<Scalars['Bool']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Items?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ReadLinkLabel?: Maybe<Scalars['String']['output']>;
  SelectedCategories?: Maybe<Array<Maybe<ContentModelReference>>>;
  UseFilteringByContentCategory?: Maybe<Scalars['Bool']['output']>;
  UseHeroLayout?: Maybe<Scalars['Bool']['output']>;
};


export type LearnLandingPageLearnCarouselContainerBlockAuthorsByLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnLandingPageLearnCarouselContainerBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnLandingPageLearnCarouselContainerBlockItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnLandingPageLearnCarouselContainerBlockReadLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LearnLandingPageLearnCarouselContainerBlockAutocomplete = {
  __typename?: 'LearnLandingPageLearnCarouselContainerBlockAutocomplete';
  SelectedCategories?: Maybe<ContentModelReferenceAutocomplete>;
};

export type LearnLandingPageLearnCarouselContainerBlockFacet = {
  __typename?: 'LearnLandingPageLearnCarouselContainerBlockFacet';
  AuthorsByLine?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncludeRecentlyAdded?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Items?: Maybe<ContentAreaItemModelSearchFacet>;
  ReadLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SelectedCategories?: Maybe<ContentModelReferenceFacet>;
  UseFilteringByContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  UseHeroLayout?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LearnLandingPageLearnCarouselContainerBlockFacetAuthorsByLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageLearnCarouselContainerBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageLearnCarouselContainerBlockFacetIncludeRecentlyAddedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageLearnCarouselContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnLandingPageLearnCarouselContainerBlockFacetReadLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageLearnCarouselContainerBlockFacetUseFilteringByContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnLandingPageLearnCarouselContainerBlockFacetUseHeroLayoutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LearnLandingPageLearnCarouselContainerBlockOrderByInput = {
  AuthorsByLine?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IncludeRecentlyAdded?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Items?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ReadLinkLabel?: InputMaybe<OrderBy>;
  SelectedCategories?: InputMaybe<ContentModelReferenceOrderByInput>;
  UseFilteringByContentCategory?: InputMaybe<OrderBy>;
  UseHeroLayout?: InputMaybe<OrderBy>;
};

export type LearnLandingPageLearnCarouselContainerBlockWhereInput = {
  AuthorsByLine?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncludeRecentlyAdded?: InputMaybe<BoolFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Items?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ReadLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  SelectedCategories?: InputMaybe<ContentModelReferenceWhereInput>;
  UseFilteringByContentCategory?: InputMaybe<BoolFilterInput>;
  UseHeroLayout?: InputMaybe<BoolFilterInput>;
};

export type LearnLandingPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  HeroCarousel?: InputMaybe<LearnLandingPageLearnCarouselContainerBlockOrderByInput>;
  HeroContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeroImage?: InputMaybe<LearnLandingPageImageBlockOrderByInput>;
  HeroImageAltText?: InputMaybe<OrderBy>;
  HeroImageLink?: InputMaybe<OrderBy>;
  HeroImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  HeroLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeroTextContentBlock?: InputMaybe<LearnLandingPageHeroTextContentBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<LearnLandingPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<LearnLandingPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  ViewTopicsLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LearnLandingPageOutput = {
  __typename?: 'LearnLandingPageOutput';
  autocomplete?: Maybe<LearnLandingPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LearnLandingPageFacet>;
  item?: Maybe<LearnLandingPage>;
  items?: Maybe<Array<Maybe<LearnLandingPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LearnLandingPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LearnLandingPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  HeroCarousel?: InputMaybe<LearnLandingPageLearnCarouselContainerBlockWhereInput>;
  HeroContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeroImage?: InputMaybe<LearnLandingPageImageBlockWhereInput>;
  HeroImageAltText?: InputMaybe<SearchableStringFilterInput>;
  HeroImageLink?: InputMaybe<StringFilterInput>;
  HeroImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  HeroLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeroTextContentBlock?: InputMaybe<LearnLandingPageHeroTextContentBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<LearnLandingPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<LearnLandingPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewTopicsLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LearnLandingPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LearnLandingPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LearnLandingPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for Learn V2 */
export type LearnPageV2 = IContent & IData & {
  __typename?: 'LearnPageV2';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  BrowseTopicsLabel?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** The label for description, shown beneath Title */
  Description?: Maybe<Scalars['String']['output']>;
  DetailPageAuthorModalResoucesButtonLabelText?: Maybe<Scalars['String']['output']>;
  DetailPageAuthorsHeading?: Maybe<Scalars['String']['output']>;
  DetailPageMemberDetailsButtonAriaLabelText?: Maybe<Scalars['String']['output']>;
  DetailPageMemberEmailButtonAriaLabelText?: Maybe<Scalars['String']['output']>;
  DetailPageMemberYearsSubheading?: Maybe<Scalars['String']['output']>;
  DetailPageVideoTranscriptAccordionButtonLabelText?: Maybe<Scalars['String']['output']>;
  DetailPageViewResourcesLinkLabelText?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  /** Content shown in hero carousel at the top of the page */
  FeaturedContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  FeaturedContentIds?: Maybe<Array<Maybe<FeaturedContentIdsEntry>>>;
  FeaturedContentViewNowLabelText?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<LearnPageV2ImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  /** Saved items */
  SavedItemsLabel?: Maybe<Scalars['String']['output']>;
  SearchButtonLabel?: Maybe<Scalars['String']['output']>;
  /** Text displayed in the search input when it's empty */
  SearchInputPlaceholder?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  /** Text displayed in alert if user has not signed in */
  SignInAlertText?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<LearnPageV2ImageBlock>;
  /** The title for Learn page, shown on the top */
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2AnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2BrowseTopicsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2DescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2DetailPageAuthorModalResoucesButtonLabelTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2DetailPageAuthorsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2DetailPageMemberDetailsButtonAriaLabelTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2DetailPageMemberEmailButtonAriaLabelTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2DetailPageMemberYearsSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2DetailPageVideoTranscriptAccordionButtonLabelTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2DetailPageViewResourcesLinkLabelTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2FeaturedContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2FeaturedContentViewNowLabelTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2MainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2MetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2MetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2MetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2NameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2SavedItemsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2SearchButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2SearchInputPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2SignInAlertTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2TitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Learn V2 */
export type LearnPageV2_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LearnPageV2Autocomplete = {
  __typename?: 'LearnPageV2Autocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<LearnPageV2ImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<LearnPageV2ImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LearnPageV2AutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPageV2AutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPageV2AutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPageV2AutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPageV2AutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPageV2AutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPageV2AutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPageV2AutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPageV2AutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPageV2Autocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LearnPageV2Facet = {
  __typename?: 'LearnPageV2Facet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  BrowseTopicsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DetailPageAuthorModalResoucesButtonLabelText?: Maybe<Array<Maybe<StringFacet>>>;
  DetailPageAuthorsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  DetailPageMemberDetailsButtonAriaLabelText?: Maybe<Array<Maybe<StringFacet>>>;
  DetailPageMemberEmailButtonAriaLabelText?: Maybe<Array<Maybe<StringFacet>>>;
  DetailPageMemberYearsSubheading?: Maybe<Array<Maybe<StringFacet>>>;
  DetailPageVideoTranscriptAccordionButtonLabelText?: Maybe<Array<Maybe<StringFacet>>>;
  DetailPageViewResourcesLinkLabelText?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FeaturedContent?: Maybe<ContentAreaItemModelSearchFacet>;
  FeaturedContentIds?: Maybe<FeaturedContentIdsEntryFacet>;
  FeaturedContentViewNowLabelText?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<LearnPageV2ImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SavedItemsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SearchButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SearchInputPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SignInAlertText?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<LearnPageV2ImageBlockFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LearnPageV2FacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetBrowseTopicsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnPageV2FacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnPageV2FacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnPageV2FacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetDetailPageAuthorModalResoucesButtonLabelTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetDetailPageAuthorsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetDetailPageMemberDetailsButtonAriaLabelTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetDetailPageMemberEmailButtonAriaLabelTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetDetailPageMemberYearsSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetDetailPageVideoTranscriptAccordionButtonLabelTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetDetailPageViewResourcesLinkLabelTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetFeaturedContentViewNowLabelTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnPageV2FacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnPageV2FacetSavedItemsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetSearchButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetSearchInputPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetSignInAlertTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnPageV2FacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnPageV2FacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2FacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2Facet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2Facet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LearnPageV2ImageBlock = {
  __typename?: 'LearnPageV2ImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type LearnPageV2ImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnPageV2ImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnPageV2ImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnPageV2ImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnPageV2ImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LearnPageV2ImageBlockAutocomplete = {
  __typename?: 'LearnPageV2ImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type LearnPageV2ImageBlockFacet = {
  __typename?: 'LearnPageV2ImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LearnPageV2ImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2ImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2ImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2ImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPageV2ImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnPageV2ImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LearnPageV2ImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type LearnPageV2ImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type LearnPageV2OrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  BrowseTopicsLabel?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DetailPageAuthorModalResoucesButtonLabelText?: InputMaybe<OrderBy>;
  DetailPageAuthorsHeading?: InputMaybe<OrderBy>;
  DetailPageMemberDetailsButtonAriaLabelText?: InputMaybe<OrderBy>;
  DetailPageMemberEmailButtonAriaLabelText?: InputMaybe<OrderBy>;
  DetailPageMemberYearsSubheading?: InputMaybe<OrderBy>;
  DetailPageVideoTranscriptAccordionButtonLabelText?: InputMaybe<OrderBy>;
  DetailPageViewResourcesLinkLabelText?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FeaturedContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FeaturedContentIds?: InputMaybe<FeaturedContentIdsEntryOrderByInput>;
  FeaturedContentViewNowLabelText?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<LearnPageV2ImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SavedItemsLabel?: InputMaybe<OrderBy>;
  SearchButtonLabel?: InputMaybe<OrderBy>;
  SearchInputPlaceholder?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SignInAlertText?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<LearnPageV2ImageBlockOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LearnPageV2Output = {
  __typename?: 'LearnPageV2Output';
  autocomplete?: Maybe<LearnPageV2Autocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LearnPageV2Facet>;
  item?: Maybe<LearnPageV2>;
  items?: Maybe<Array<Maybe<LearnPageV2>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LearnPageV2OutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LearnPageV2WhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  BrowseTopicsLabel?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DetailPageAuthorModalResoucesButtonLabelText?: InputMaybe<SearchableStringFilterInput>;
  DetailPageAuthorsHeading?: InputMaybe<SearchableStringFilterInput>;
  DetailPageMemberDetailsButtonAriaLabelText?: InputMaybe<SearchableStringFilterInput>;
  DetailPageMemberEmailButtonAriaLabelText?: InputMaybe<SearchableStringFilterInput>;
  DetailPageMemberYearsSubheading?: InputMaybe<SearchableStringFilterInput>;
  DetailPageVideoTranscriptAccordionButtonLabelText?: InputMaybe<SearchableStringFilterInput>;
  DetailPageViewResourcesLinkLabelText?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FeaturedContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FeaturedContentIds?: InputMaybe<FeaturedContentIdsEntryWhereInput>;
  FeaturedContentViewNowLabelText?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<LearnPageV2ImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SavedItemsLabel?: InputMaybe<SearchableStringFilterInput>;
  SearchButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  SearchInputPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SignInAlertText?: InputMaybe<SearchableStringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<LearnPageV2ImageBlockWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LearnPageV2WhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LearnPageV2WhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LearnPageV2WhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Learn Play List Page */
export type LearnPlayListPage = IContent & IData & {
  __typename?: 'LearnPlayListPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  ContentTypeSelection?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Date?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** Renders Learn Detail Pages */
  Items?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<LearnPlayListPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  ReadTime?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SideBar?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Subheading?: Maybe<Scalars['String']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<LearnPlayListPageImageBlock>;
  TopicsCoveredLine?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageReadTimeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageSideBarArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPageTopicsCoveredLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Learn Play List Page */
export type LearnPlayListPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LearnPlayListPageAutocomplete = {
  __typename?: 'LearnPlayListPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<LearnPlayListPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<LearnPlayListPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LearnPlayListPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPlayListPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPlayListPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPlayListPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPlayListPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPlayListPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPlayListPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPlayListPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPlayListPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LearnPlayListPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LearnPlayListPageFacet = {
  __typename?: 'LearnPlayListPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentTypeSelection?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Date?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<ContentAreaItemModelSearchFacet>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<LearnPlayListPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ReadTime?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SideBar?: Maybe<ContentAreaItemModelSearchFacet>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subheading?: Maybe<Array<Maybe<StringFacet>>>;
  ThumbnailImage?: Maybe<LearnPlayListPageImageBlockFacet>;
  TopicsCoveredLine?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LearnPlayListPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnPlayListPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnPlayListPageFacetContentTypeSelectionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnPlayListPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnPlayListPageFacetDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnPlayListPageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnPlayListPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetReadTimeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnPlayListPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnPlayListPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnPlayListPageFacetSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetTopicsCoveredLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LearnPlayListPageImageBlock = {
  __typename?: 'LearnPlayListPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type LearnPlayListPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnPlayListPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnPlayListPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnPlayListPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LearnPlayListPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LearnPlayListPageImageBlockAutocomplete = {
  __typename?: 'LearnPlayListPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type LearnPlayListPageImageBlockFacet = {
  __typename?: 'LearnPlayListPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LearnPlayListPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LearnPlayListPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LearnPlayListPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LearnPlayListPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type LearnPlayListPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type LearnPlayListPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  ContentTypeSelection?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Date?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Items?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<LearnPlayListPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ReadTime?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SideBar?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subheading?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<LearnPlayListPageImageBlockOrderByInput>;
  TopicsCoveredLine?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LearnPlayListPageOutput = {
  __typename?: 'LearnPlayListPageOutput';
  autocomplete?: Maybe<LearnPlayListPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LearnPlayListPageFacet>;
  item?: Maybe<LearnPlayListPage>;
  items?: Maybe<Array<Maybe<LearnPlayListPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LearnPlayListPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LearnPlayListPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  ContentTypeSelection?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Date?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<LearnPlayListPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ReadTime?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SideBar?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subheading?: InputMaybe<SearchableStringFilterInput>;
  ThumbnailImage?: InputMaybe<LearnPlayListPageImageBlockWhereInput>;
  TopicsCoveredLine?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LearnPlayListPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LearnPlayListPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LearnPlayListPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A block used to render a link */
export type LikeAndBookmarkBlock = IContent & IData & {
  __typename?: 'LikeAndBookmarkBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BookmarkLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LikeLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block used to render a link */
export type LikeAndBookmarkBlockBookmarkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LikeAndBookmarkBlockLikeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LikeAndBookmarkBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LikeAndBookmarkBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LikeAndBookmarkBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LikeAndBookmarkBlockAutocomplete = {
  __typename?: 'LikeAndBookmarkBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LikeAndBookmarkBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LikeAndBookmarkBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LikeAndBookmarkBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LikeAndBookmarkBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LikeAndBookmarkBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LikeAndBookmarkBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LikeAndBookmarkBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LikeAndBookmarkBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LikeAndBookmarkBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LikeAndBookmarkBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LikeAndBookmarkBlockFacet = {
  __typename?: 'LikeAndBookmarkBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BookmarkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LikeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LikeAndBookmarkBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetBookmarkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LikeAndBookmarkBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LikeAndBookmarkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LikeAndBookmarkBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetLikeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LikeAndBookmarkBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LikeAndBookmarkBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LikeAndBookmarkBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LikeAndBookmarkBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LikeAndBookmarkBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BookmarkLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LikeLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LikeAndBookmarkBlockOutput = {
  __typename?: 'LikeAndBookmarkBlockOutput';
  autocomplete?: Maybe<LikeAndBookmarkBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LikeAndBookmarkBlockFacet>;
  item?: Maybe<LikeAndBookmarkBlock>;
  items?: Maybe<Array<Maybe<LikeAndBookmarkBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LikeAndBookmarkBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LikeAndBookmarkBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BookmarkLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LikeLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LikeAndBookmarkBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LikeAndBookmarkBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LikeAndBookmarkBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A block used to render a link */
export type LinkBlock = IContent & IData & {
  __typename?: 'LinkBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** The text displayed when the link is rendered */
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Change how the link appears */
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  /** When checked,The link file will be downloaded */
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Determines how the link opens */
  Target?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block used to render a link */
export type LinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LinkBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LinkBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link */
export type LinkBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LinkBlockAutocomplete = {
  __typename?: 'LinkBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LinkBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkBlockFacet = {
  __typename?: 'LinkBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LinkBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LinkBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LinkBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LinkBlockOutput = {
  __typename?: 'LinkBlockOutput';
  autocomplete?: Maybe<LinkBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LinkBlockFacet>;
  item?: Maybe<LinkBlock>;
  items?: Maybe<Array<Maybe<LinkBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LinkBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LinkBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LinkBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LinkBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type LinkConfig = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type LinkItemNode = {
  __typename?: 'LinkItemNode';
  ContentLink?: Maybe<ContentModelReference>;
  Href?: Maybe<Scalars['String']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type LinkItemNodeAutocomplete = {
  __typename?: 'LinkItemNodeAutocomplete';
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Href?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Target?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Title?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LinkItemNodeAutocompleteHrefArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkItemNodeAutocompleteTargetArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkItemNodeAutocompleteTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkItemNodeAutocompleteTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkItemNodeFacet = {
  __typename?: 'LinkItemNodeFacet';
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  Href?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LinkItemNodeFacetHrefArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkItemNodeFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkItemNodeFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkItemNodeFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LinkItemNodeOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Href?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type LinkItemNodeWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Href?: InputMaybe<StringFilterInput>;
  Target?: InputMaybe<StringFilterInput>;
  Text?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
};

/** A block used to render a list of links */
export type LinkListBlock = IContent & IData & {
  __typename?: 'LinkListBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** List of links to render */
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** List of links to render */
  LinkList?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** Shows the blue theme */
  UseBlueTheme?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block used to render a list of links */
export type LinkListBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a list of links */
export type LinkListBlockLinkListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a list of links */
export type LinkListBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a list of links */
export type LinkListBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a list of links */
export type LinkListBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LinkListBlockAutocomplete = {
  __typename?: 'LinkListBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LinkListBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkListBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkListBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkListBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkListBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkListBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkListBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkListBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkListBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkListBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkListBlockFacet = {
  __typename?: 'LinkListBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkList?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UseBlueTheme?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LinkListBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkListBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkListBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LinkListBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkListBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkListBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkListBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacetUseBlueThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkListBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LinkListBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkList?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UseBlueTheme?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LinkListBlockOutput = {
  __typename?: 'LinkListBlockOutput';
  autocomplete?: Maybe<LinkListBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LinkListBlockFacet>;
  item?: Maybe<LinkListBlock>;
  items?: Maybe<Array<Maybe<LinkListBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LinkListBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkListBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkList?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UseBlueTheme?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LinkListBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LinkListBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LinkListBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A block used to render a link tile block */
export type LinkTileBlock = IContent & IData & {
  __typename?: 'LinkTileBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkBlock?: Maybe<LinkTileBlockLinkBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block used to render a link tile block */
export type LinkTileBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link tile block */
export type LinkTileBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a link tile block */
export type LinkTileBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LinkTileBlockAutocomplete = {
  __typename?: 'LinkTileBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkBlock?: Maybe<LinkTileBlockLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LinkTileBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTileBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTileBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTileBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTileBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTileBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTileBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTileBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTileBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTileBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkTileBlockFacet = {
  __typename?: 'LinkTileBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkBlock?: Maybe<LinkTileBlockLinkBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LinkTileBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkTileBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkTileBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LinkTileBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkTileBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkTileBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkTileBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LinkTileBlockLinkBlock = {
  __typename?: 'LinkTileBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type LinkTileBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LinkTileBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LinkTileBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LinkTileBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LinkTileBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LinkTileBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LinkTileBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LinkTileBlockLinkBlockAutocomplete = {
  __typename?: 'LinkTileBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LinkTileBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkTileBlockLinkBlockFacet = {
  __typename?: 'LinkTileBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LinkTileBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LinkTileBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTileBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LinkTileBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type LinkTileBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type LinkTileBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkBlock?: InputMaybe<LinkTileBlockLinkBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LinkTileBlockOutput = {
  __typename?: 'LinkTileBlockOutput';
  autocomplete?: Maybe<LinkTileBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LinkTileBlockFacet>;
  item?: Maybe<LinkTileBlock>;
  items?: Maybe<Array<Maybe<LinkTileBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LinkTileBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkTileBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkBlock?: InputMaybe<LinkTileBlockLinkBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LinkTileBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LinkTileBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LinkTileBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum LinkTypes {
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `Ancestors` |
   * | *to*        |        | `ContentLink.GuidValue`   |
   */
  Ancestors = 'ANCESTORS',
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `ContentLink.GuidValue` |
   * | *to*        |        | `ParentLink.GuidValue`   |
   */
  Children = 'CHILDREN',
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `ContentLink.GuidValue` |
   * | *to*        |        | `ParentLink.GuidValue`   |
   */
  Default = 'DEFAULT'
}

export type LoaderBlock = IContent & IData & {
  __typename?: 'LoaderBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Subtitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type LoaderBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LoaderBlockSubtitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LoaderBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LoaderBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LoaderBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LoaderBlockAutocomplete = {
  __typename?: 'LoaderBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LoaderBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LoaderBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LoaderBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LoaderBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LoaderBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LoaderBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LoaderBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LoaderBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LoaderBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LoaderBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LoaderBlockFacet = {
  __typename?: 'LoaderBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subtitle?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LoaderBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LoaderBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LoaderBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LoaderBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LoaderBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LoaderBlockFacetSubtitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LoaderBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LoaderBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subtitle?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LoaderBlockOutput = {
  __typename?: 'LoaderBlockOutput';
  autocomplete?: Maybe<LoaderBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LoaderBlockFacet>;
  item?: Maybe<LoaderBlock>;
  items?: Maybe<Array<Maybe<LoaderBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LoaderBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoaderBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subtitle?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LoaderBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LoaderBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LoaderBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum Locales {
  All = 'ALL',
  Neutral = 'NEUTRAL',
  En = 'en',
  Es = 'es',
  Hi = 'hi',
  Id = 'id',
  Ja = 'ja',
  KmKh = 'km_KH',
  Ko = 'ko',
  PtAo = 'pt_AO',
  Th = 'th',
  Vi = 'vi',
  ZhCht = 'zh_CHT',
  ZhCn = 'zh_CN',
  ZhTw = 'zh_TW'
}

/** Block can be used for individual event locations and accommodations */
export type LocationBlock = IContent & IData & {
  __typename?: 'LocationBlock';
  AddressLine1?: Maybe<Scalars['String']['output']>;
  AddressLine2?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Country?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Location Image */
  Image?: Maybe<LocationBlockImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Decimal Latitude value for the Location */
  Latitude?: Maybe<Scalars['Float']['output']>;
  /** Location or Accommodation name */
  LocationName?: Maybe<Scalars['String']['output']>;
  /** Decimal Longitude value for the Location */
  Longitude?: Maybe<Scalars['Float']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Phone Number used to contact the Accommodation */
  PhoneNumber?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** Optional Button link to make reservation. */
  ReservationLink?: Maybe<LocationBlockLinkBlock>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Subtitle or Short Description of location */
  Subtitle?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** Link of the Website for the Accommodation */
  WebsiteLink?: Maybe<LocationBlockLinkBlock>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlockAddressLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlockAddressLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlockLocationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlockPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlockPostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlockStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlockSubtitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block can be used for individual event locations and accommodations */
export type LocationBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LocationBlockAutocomplete = {
  __typename?: 'LocationBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<LocationBlockImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ReservationLink?: Maybe<LocationBlockLinkBlockAutocomplete>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  WebsiteLink?: Maybe<LocationBlockLinkBlockAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LocationBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LocationBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LocationBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LocationBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LocationBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LocationBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LocationBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LocationBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LocationBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LocationBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationBlockFacet = {
  __typename?: 'LocationBlockFacet';
  AddressLine1?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine2?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Image?: Maybe<LocationBlockImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Latitude?: Maybe<Array<Maybe<NumberFacet>>>;
  LocationName?: Maybe<Array<Maybe<StringFacet>>>;
  Longitude?: Maybe<Array<Maybe<NumberFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  PostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ReservationLink?: Maybe<LocationBlockLinkBlockFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  State?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subtitle?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WebsiteLink?: Maybe<LocationBlockLinkBlockFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LocationBlockFacetAddressLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetAddressLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LocationBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetLatitudeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LocationBlockFacetLocationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetLongitudeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LocationBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetPostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationBlockFacetStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationBlockFacetSubtitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LocationBlockImageBlock = {
  __typename?: 'LocationBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type LocationBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LocationBlockImageBlockAutocomplete = {
  __typename?: 'LocationBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type LocationBlockImageBlockFacet = {
  __typename?: 'LocationBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LocationBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LocationBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type LocationBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type LocationBlockLinkBlock = {
  __typename?: 'LocationBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type LocationBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type LocationBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type LocationBlockLinkBlockAutocomplete = {
  __typename?: 'LocationBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LocationBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LocationBlockLinkBlockFacet = {
  __typename?: 'LocationBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LocationBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type LocationBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LocationBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LocationBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type LocationBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type LocationBlockOrderByInput = {
  AddressLine1?: InputMaybe<OrderBy>;
  AddressLine2?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Image?: InputMaybe<LocationBlockImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Latitude?: InputMaybe<OrderBy>;
  LocationName?: InputMaybe<OrderBy>;
  Longitude?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneNumber?: InputMaybe<OrderBy>;
  PostalCode?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  ReservationLink?: InputMaybe<LocationBlockLinkBlockOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  State?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subtitle?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WebsiteLink?: InputMaybe<LocationBlockLinkBlockOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LocationBlockOutput = {
  __typename?: 'LocationBlockOutput';
  autocomplete?: Maybe<LocationBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LocationBlockFacet>;
  item?: Maybe<LocationBlock>;
  items?: Maybe<Array<Maybe<LocationBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LocationBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationBlockWhereInput = {
  AddressLine1?: InputMaybe<SearchableStringFilterInput>;
  AddressLine2?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Image?: InputMaybe<LocationBlockImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Latitude?: InputMaybe<FloatFilterInput>;
  LocationName?: InputMaybe<SearchableStringFilterInput>;
  Longitude?: InputMaybe<FloatFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  PostalCode?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ReservationLink?: InputMaybe<LocationBlockLinkBlockWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  State?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subtitle?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WebsiteLink?: InputMaybe<LocationBlockLinkBlockWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<LocationBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LocationBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LocationBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for a meeting event card */
export type MeetingEventCardPage = IContent & IData & {
  __typename?: 'MeetingEventCardPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  CallToActionText?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentCategory?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DescriptionForRegisteredUsers?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  EventId?: Maybe<Scalars['Int']['output']>;
  EventUrl?: Maybe<MeetingEventCardPageLinkBlock>;
  EventUrlForRegisteredUsers?: Maybe<MeetingEventCardPageLinkBlock>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  Image?: Maybe<MeetingEventCardPageImageBlock>;
  ImageForRegisteredUsers?: Maybe<MeetingEventCardPageImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LocationsAndDates?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<MeetingEventCardPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<MeetingEventCardPageImageBlock>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPageCallToActionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPageContentCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPageDescriptionForRegisteredUsersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPageLocationsAndDatesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a meeting event card */
export type MeetingEventCardPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MeetingEventCardPageAutocomplete = {
  __typename?: 'MeetingEventCardPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EventUrl?: Maybe<MeetingEventCardPageLinkBlockAutocomplete>;
  EventUrlForRegisteredUsers?: Maybe<MeetingEventCardPageLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Image?: Maybe<MeetingEventCardPageImageBlockAutocomplete>;
  ImageForRegisteredUsers?: Maybe<MeetingEventCardPageImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<MeetingEventCardPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<MeetingEventCardPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MeetingEventCardPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingEventCardPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingEventCardPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingEventCardPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingEventCardPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingEventCardPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingEventCardPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingEventCardPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingEventCardPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingEventCardPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MeetingEventCardPageFacet = {
  __typename?: 'MeetingEventCardPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  CallToActionText?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DescriptionForRegisteredUsers?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EventId?: Maybe<Array<Maybe<NumberFacet>>>;
  EventUrl?: Maybe<MeetingEventCardPageLinkBlockFacet>;
  EventUrlForRegisteredUsers?: Maybe<MeetingEventCardPageLinkBlockFacet>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  Image?: Maybe<MeetingEventCardPageImageBlockFacet>;
  ImageForRegisteredUsers?: Maybe<MeetingEventCardPageImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LocationsAndDates?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<MeetingEventCardPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<MeetingEventCardPageImageBlockFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MeetingEventCardPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetCallToActionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetingEventCardPageFacetContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MeetingEventCardPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetingEventCardPageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetDescriptionForRegisteredUsersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetEventIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MeetingEventCardPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MeetingEventCardPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetingEventCardPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetingEventCardPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetingEventCardPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MeetingEventCardPageImageBlock = {
  __typename?: 'MeetingEventCardPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type MeetingEventCardPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingEventCardPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingEventCardPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingEventCardPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingEventCardPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MeetingEventCardPageImageBlockAutocomplete = {
  __typename?: 'MeetingEventCardPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type MeetingEventCardPageImageBlockFacet = {
  __typename?: 'MeetingEventCardPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MeetingEventCardPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MeetingEventCardPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MeetingEventCardPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type MeetingEventCardPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type MeetingEventCardPageLinkBlock = {
  __typename?: 'MeetingEventCardPageLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type MeetingEventCardPageLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingEventCardPageLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingEventCardPageLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingEventCardPageLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingEventCardPageLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingEventCardPageLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingEventCardPageLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MeetingEventCardPageLinkBlockAutocomplete = {
  __typename?: 'MeetingEventCardPageLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MeetingEventCardPageLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MeetingEventCardPageLinkBlockFacet = {
  __typename?: 'MeetingEventCardPageLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MeetingEventCardPageLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MeetingEventCardPageLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingEventCardPageLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MeetingEventCardPageLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type MeetingEventCardPageLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type MeetingEventCardPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  CallToActionText?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentCategory?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DescriptionForRegisteredUsers?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  EventId?: InputMaybe<OrderBy>;
  EventUrl?: InputMaybe<MeetingEventCardPageLinkBlockOrderByInput>;
  EventUrlForRegisteredUsers?: InputMaybe<MeetingEventCardPageLinkBlockOrderByInput>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  Image?: InputMaybe<MeetingEventCardPageImageBlockOrderByInput>;
  ImageForRegisteredUsers?: InputMaybe<MeetingEventCardPageImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LocationsAndDates?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<MeetingEventCardPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<MeetingEventCardPageImageBlockOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MeetingEventCardPageOutput = {
  __typename?: 'MeetingEventCardPageOutput';
  autocomplete?: Maybe<MeetingEventCardPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MeetingEventCardPageFacet>;
  item?: Maybe<MeetingEventCardPage>;
  items?: Maybe<Array<Maybe<MeetingEventCardPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MeetingEventCardPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MeetingEventCardPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  CallToActionText?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentCategory?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DescriptionForRegisteredUsers?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  EventId?: InputMaybe<IntFilterInput>;
  EventUrl?: InputMaybe<MeetingEventCardPageLinkBlockWhereInput>;
  EventUrlForRegisteredUsers?: InputMaybe<MeetingEventCardPageLinkBlockWhereInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  Image?: InputMaybe<MeetingEventCardPageImageBlockWhereInput>;
  ImageForRegisteredUsers?: InputMaybe<MeetingEventCardPageImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LocationsAndDates?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<MeetingEventCardPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<MeetingEventCardPageImageBlockWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MeetingEventCardPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MeetingEventCardPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MeetingEventCardPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type MeetingPage = IContent & IData & {
  __typename?: 'MeetingPage';
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaImage?: Maybe<MeetingPageImageBlock>;
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  ThumbnailImage?: Maybe<MeetingPageImageBlock>;
  TitleText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type MeetingPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MeetingPageAutocomplete = {
  __typename?: 'MeetingPageAutocomplete';
  AnalyticsCampaignName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MetaImage?: Maybe<MeetingPageImageBlockAutocomplete>;
  MetaKeywordList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MetaTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<MeetingPageImageBlockAutocomplete>;
  TitleText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MeetingPageAutocompleteAnalyticsCampaignNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteMetaDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteMetaKeywordListArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteMetaTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteTitleTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MeetingPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MeetingPageFacet = {
  __typename?: 'MeetingPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<MeetingPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<MeetingPageImageBlockFacet>;
  TitleText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MeetingPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetingPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MeetingPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetingPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetingPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetingPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetingPageFacetTitleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MeetingPageImageBlock = {
  __typename?: 'MeetingPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type MeetingPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MeetingPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MeetingPageImageBlockAutocomplete = {
  __typename?: 'MeetingPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type MeetingPageImageBlockFacet = {
  __typename?: 'MeetingPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MeetingPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MeetingPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MeetingPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MeetingPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type MeetingPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type MeetingPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<MeetingPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<MeetingPageImageBlockOrderByInput>;
  TitleText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MeetingPageOutput = {
  __typename?: 'MeetingPageOutput';
  autocomplete?: Maybe<MeetingPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MeetingPageFacet>;
  item?: Maybe<MeetingPage>;
  items?: Maybe<Array<Maybe<MeetingPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MeetingPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MeetingPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<StringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<StringFilterInput>;
  MetaImage?: InputMaybe<MeetingPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<StringFilterInput>;
  MetaTitle?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<MeetingPageImageBlockWhereInput>;
  TitleText?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MeetingPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MeetingPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MeetingPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Member Directory */
export type MemberDirectory = IContent & IData & {
  __typename?: 'MemberDirectory';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<MemberDirectoryImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParagraphFirst?: Maybe<Scalars['String']['output']>;
  ParagraphSecond?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<MemberDirectoryImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Member Directory */
export type MemberDirectoryAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Member Directory */
export type MemberDirectoryMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Member Directory */
export type MemberDirectoryMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Member Directory */
export type MemberDirectoryMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Member Directory */
export type MemberDirectoryNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Member Directory */
export type MemberDirectoryParagraphFirstArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Member Directory */
export type MemberDirectoryParagraphSecondArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Member Directory */
export type MemberDirectory_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Member Directory */
export type MemberDirectory_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MemberDirectoryAutocomplete = {
  __typename?: 'MemberDirectoryAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<MemberDirectoryImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<MemberDirectoryImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MemberDirectoryAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MemberDirectoryFacet = {
  __typename?: 'MemberDirectoryFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<MemberDirectoryImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParagraphFirst?: Maybe<Array<Maybe<StringFacet>>>;
  ParagraphSecond?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<MemberDirectoryImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MemberDirectoryFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberDirectoryFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MemberDirectoryFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberDirectoryFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MemberDirectoryFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetParagraphFirstArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetParagraphSecondArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberDirectoryFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberDirectoryFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberDirectoryFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MemberDirectoryImageBlock = {
  __typename?: 'MemberDirectoryImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type MemberDirectoryImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MemberDirectoryImageBlockAutocomplete = {
  __typename?: 'MemberDirectoryImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type MemberDirectoryImageBlockFacet = {
  __typename?: 'MemberDirectoryImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MemberDirectoryImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MemberDirectoryImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MemberDirectoryImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type MemberDirectoryImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type MemberDirectoryOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<MemberDirectoryImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParagraphFirst?: InputMaybe<OrderBy>;
  ParagraphSecond?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<MemberDirectoryImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MemberDirectoryOutput = {
  __typename?: 'MemberDirectoryOutput';
  autocomplete?: Maybe<MemberDirectoryAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MemberDirectoryFacet>;
  item?: Maybe<MemberDirectory>;
  items?: Maybe<Array<Maybe<MemberDirectory>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MemberDirectoryOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The page containing content for member directory page */
export type MemberDirectoryPage = IContent & IData & {
  __typename?: 'MemberDirectoryPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  CardDescription?: Maybe<Scalars['String']['output']>;
  CardImage?: Maybe<MemberDirectoryPageImageBlock>;
  CardMembersNearYouLabel?: Maybe<Scalars['String']['output']>;
  CardTitle?: Maybe<Scalars['String']['output']>;
  CardUrl?: Maybe<MemberDirectoryPageLinkBlock>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentCategory?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MembersNearbyLabel?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<MemberDirectoryPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  ResultsForLabel?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SearchInputLabel?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<MemberDirectoryPageImageBlock>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageCardDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageCardMembersNearYouLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageCardTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageContentCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageMembersNearbyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageResultsForLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageSearchInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for member directory page */
export type MemberDirectoryPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MemberDirectoryPageAutocomplete = {
  __typename?: 'MemberDirectoryPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  CardImage?: Maybe<MemberDirectoryPageImageBlockAutocomplete>;
  CardUrl?: Maybe<MemberDirectoryPageLinkBlockAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<MemberDirectoryPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<MemberDirectoryPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MemberDirectoryPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberDirectoryPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MemberDirectoryPageFacet = {
  __typename?: 'MemberDirectoryPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  CardDescription?: Maybe<Array<Maybe<StringFacet>>>;
  CardImage?: Maybe<MemberDirectoryPageImageBlockFacet>;
  CardMembersNearYouLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CardTitle?: Maybe<Array<Maybe<StringFacet>>>;
  CardUrl?: Maybe<MemberDirectoryPageLinkBlockFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembersNearbyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<MemberDirectoryPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ResultsForLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<MemberDirectoryPageImageBlockFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MemberDirectoryPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetCardDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetCardMembersNearYouLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetCardTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberDirectoryPageFacetContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MemberDirectoryPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberDirectoryPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MemberDirectoryPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetMembersNearbyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetResultsForLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberDirectoryPageFacetSearchInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberDirectoryPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberDirectoryPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MemberDirectoryPageImageBlock = {
  __typename?: 'MemberDirectoryPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type MemberDirectoryPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MemberDirectoryPageImageBlockAutocomplete = {
  __typename?: 'MemberDirectoryPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type MemberDirectoryPageImageBlockFacet = {
  __typename?: 'MemberDirectoryPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MemberDirectoryPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MemberDirectoryPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MemberDirectoryPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type MemberDirectoryPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type MemberDirectoryPageLinkBlock = {
  __typename?: 'MemberDirectoryPageLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type MemberDirectoryPageLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryPageLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryPageLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryPageLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryPageLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryPageLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberDirectoryPageLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MemberDirectoryPageLinkBlockAutocomplete = {
  __typename?: 'MemberDirectoryPageLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MemberDirectoryPageLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MemberDirectoryPageLinkBlockFacet = {
  __typename?: 'MemberDirectoryPageLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MemberDirectoryPageLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MemberDirectoryPageLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberDirectoryPageLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MemberDirectoryPageLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type MemberDirectoryPageLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type MemberDirectoryPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  CardDescription?: InputMaybe<OrderBy>;
  CardImage?: InputMaybe<MemberDirectoryPageImageBlockOrderByInput>;
  CardMembersNearYouLabel?: InputMaybe<OrderBy>;
  CardTitle?: InputMaybe<OrderBy>;
  CardUrl?: InputMaybe<MemberDirectoryPageLinkBlockOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentCategory?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembersNearbyLabel?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<MemberDirectoryPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  ResultsForLabel?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchInputLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<MemberDirectoryPageImageBlockOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MemberDirectoryPageOutput = {
  __typename?: 'MemberDirectoryPageOutput';
  autocomplete?: Maybe<MemberDirectoryPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MemberDirectoryPageFacet>;
  item?: Maybe<MemberDirectoryPage>;
  items?: Maybe<Array<Maybe<MemberDirectoryPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MemberDirectoryPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MemberDirectoryPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  CardDescription?: InputMaybe<SearchableStringFilterInput>;
  CardImage?: InputMaybe<MemberDirectoryPageImageBlockWhereInput>;
  CardMembersNearYouLabel?: InputMaybe<SearchableStringFilterInput>;
  CardTitle?: InputMaybe<SearchableStringFilterInput>;
  CardUrl?: InputMaybe<MemberDirectoryPageLinkBlockWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentCategory?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembersNearbyLabel?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<MemberDirectoryPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ResultsForLabel?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchInputLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<MemberDirectoryPageImageBlockWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MemberDirectoryPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MemberDirectoryPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MemberDirectoryPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type MemberDirectoryWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<MemberDirectoryImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParagraphFirst?: InputMaybe<SearchableStringFilterInput>;
  ParagraphSecond?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<MemberDirectoryImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MemberDirectoryWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MemberDirectoryWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MemberDirectoryWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds Member data for the Account Profile page */
export type MemberSectionBlock = IContent & IData & {
  __typename?: 'MemberSectionBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DownloadErrorMessage?: Maybe<Scalars['String']['output']>;
  DownloadMembershipCertificateButton?: Maybe<MemberSectionBlockLinkBlock>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  Level?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MemberSince?: Maybe<Scalars['String']['output']>;
  MembershipExpirationDate?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RenewNowButtons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds Member data for the Account Profile page */
export type MemberSectionBlockDownloadErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Member data for the Account Profile page */
export type MemberSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Member data for the Account Profile page */
export type MemberSectionBlockLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Member data for the Account Profile page */
export type MemberSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Member data for the Account Profile page */
export type MemberSectionBlockMemberSinceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Member data for the Account Profile page */
export type MemberSectionBlockMembershipExpirationDateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Member data for the Account Profile page */
export type MemberSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Member data for the Account Profile page */
export type MemberSectionBlockRenewNowButtonsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Member data for the Account Profile page */
export type MemberSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Member data for the Account Profile page */
export type MemberSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MemberSectionBlockAutocomplete = {
  __typename?: 'MemberSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DownloadMembershipCertificateButton?: Maybe<MemberSectionBlockLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MemberSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MemberSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MemberSectionBlockFacet = {
  __typename?: 'MemberSectionBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DownloadErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadMembershipCertificateButton?: Maybe<MemberSectionBlockLinkBlockFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Level?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MemberSince?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipExpirationDate?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RenewNowButtons?: Maybe<ContentAreaItemModelSearchFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MemberSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberSectionBlockFacetDownloadErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MemberSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetMemberSinceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetMembershipExpirationDateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MemberSectionBlockLinkBlock = {
  __typename?: 'MemberSectionBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type MemberSectionBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberSectionBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberSectionBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberSectionBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberSectionBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberSectionBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MemberSectionBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MemberSectionBlockLinkBlockAutocomplete = {
  __typename?: 'MemberSectionBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MemberSectionBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MemberSectionBlockLinkBlockFacet = {
  __typename?: 'MemberSectionBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MemberSectionBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MemberSectionBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MemberSectionBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MemberSectionBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type MemberSectionBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type MemberSectionBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DownloadErrorMessage?: InputMaybe<OrderBy>;
  DownloadMembershipCertificateButton?: InputMaybe<MemberSectionBlockLinkBlockOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Level?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MemberSince?: InputMaybe<OrderBy>;
  MembershipExpirationDate?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RenewNowButtons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MemberSectionBlockOutput = {
  __typename?: 'MemberSectionBlockOutput';
  autocomplete?: Maybe<MemberSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MemberSectionBlockFacet>;
  item?: Maybe<MemberSectionBlock>;
  items?: Maybe<Array<Maybe<MemberSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MemberSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MemberSectionBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DownloadErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  DownloadMembershipCertificateButton?: InputMaybe<MemberSectionBlockLinkBlockWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Level?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MemberSince?: InputMaybe<SearchableStringFilterInput>;
  MembershipExpirationDate?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RenewNowButtons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MemberSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MemberSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MemberSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlock = IContent & IData & {
  __typename?: 'MembersTableHeaderLabelsBlock';
  AddressLine?: Maybe<Scalars['String']['output']>;
  AgentID?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApprovedDate?: Maybe<Scalars['String']['output']>;
  AspirantCity?: Maybe<Scalars['String']['output']>;
  AspirantCountry?: Maybe<Scalars['String']['output']>;
  AspirantFirstName?: Maybe<Scalars['String']['output']>;
  AspirantLastName?: Maybe<Scalars['String']['output']>;
  AspirantMDRTID?: Maybe<Scalars['String']['output']>;
  AspirantState?: Maybe<Scalars['String']['output']>;
  AttendeeStatus?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Country?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastName?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MemberStatus?: Maybe<Scalars['String']['output']>;
  MembershipLevel?: Maybe<Scalars['String']['output']>;
  MenteeLabel?: Maybe<Scalars['String']['output']>;
  MentorEnrollmentDate?: Maybe<Scalars['String']['output']>;
  MentorFirstName?: Maybe<Scalars['String']['output']>;
  MentorLabel?: Maybe<Scalars['String']['output']>;
  MentorLastName?: Maybe<Scalars['String']['output']>;
  MentorMDRTID?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneNumber?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  Problem?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TotalNumberOfEdgeMeetingsAttended?: Maybe<Scalars['String']['output']>;
  TotalYearsOfMembership?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockAddressLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockApprovedDateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockAspirantCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockAspirantCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockAspirantFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockAspirantLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockAspirantMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockAspirantStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockAttendeeStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockMemberStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockMenteeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockMentorEnrollmentDateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockMentorFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockMentorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockMentorLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockMentorMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockMobileCellPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockPostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockProblemArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockTotalNumberOfEdgeMeetingsAttendedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlockTotalYearsOfMembershipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Company Admin Company Listing Table headers */
export type MembersTableHeaderLabelsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembersTableHeaderLabelsBlockAutocomplete = {
  __typename?: 'MembersTableHeaderLabelsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembersTableHeaderLabelsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembersTableHeaderLabelsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembersTableHeaderLabelsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembersTableHeaderLabelsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembersTableHeaderLabelsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembersTableHeaderLabelsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembersTableHeaderLabelsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembersTableHeaderLabelsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembersTableHeaderLabelsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembersTableHeaderLabelsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembersTableHeaderLabelsBlockFacet = {
  __typename?: 'MembersTableHeaderLabelsBlockFacet';
  AddressLine?: Maybe<Array<Maybe<StringFacet>>>;
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApprovedDate?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantCity?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantCountry?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantFirstName?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantLastName?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantMDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  AspirantState?: Maybe<Array<Maybe<StringFacet>>>;
  AttendeeStatus?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastName?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MemberStatus?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevel?: Maybe<Array<Maybe<StringFacet>>>;
  MenteeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MentorEnrollmentDate?: Maybe<Array<Maybe<StringFacet>>>;
  MentorFirstName?: Maybe<Array<Maybe<StringFacet>>>;
  MentorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MentorLastName?: Maybe<Array<Maybe<StringFacet>>>;
  MentorMDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  Problem?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  State?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalNumberOfEdgeMeetingsAttended?: Maybe<Array<Maybe<StringFacet>>>;
  TotalYearsOfMembership?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembersTableHeaderLabelsBlockFacetAddressLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetApprovedDateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetAspirantCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetAspirantCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetAspirantFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetAspirantLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetAspirantMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetAspirantStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetAttendeeStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembersTableHeaderLabelsBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembersTableHeaderLabelsBlockFacetFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembersTableHeaderLabelsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetMemberStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetMembershipLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetMenteeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetMentorEnrollmentDateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetMentorFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetMentorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetMentorLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetMentorMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetMobileCellPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetPostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetProblemArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembersTableHeaderLabelsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembersTableHeaderLabelsBlockFacetStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembersTableHeaderLabelsBlockFacetTotalNumberOfEdgeMeetingsAttendedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetTotalYearsOfMembershipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembersTableHeaderLabelsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembersTableHeaderLabelsBlockOrderByInput = {
  AddressLine?: InputMaybe<OrderBy>;
  AgentID?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApprovedDate?: InputMaybe<OrderBy>;
  AspirantCity?: InputMaybe<OrderBy>;
  AspirantCountry?: InputMaybe<OrderBy>;
  AspirantFirstName?: InputMaybe<OrderBy>;
  AspirantLastName?: InputMaybe<OrderBy>;
  AspirantMDRTID?: InputMaybe<OrderBy>;
  AspirantState?: InputMaybe<OrderBy>;
  AttendeeStatus?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastName?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MemberStatus?: InputMaybe<OrderBy>;
  MembershipLevel?: InputMaybe<OrderBy>;
  MenteeLabel?: InputMaybe<OrderBy>;
  MentorEnrollmentDate?: InputMaybe<OrderBy>;
  MentorFirstName?: InputMaybe<OrderBy>;
  MentorLabel?: InputMaybe<OrderBy>;
  MentorLastName?: InputMaybe<OrderBy>;
  MentorMDRTID?: InputMaybe<OrderBy>;
  MobileCellPhoneNumber?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PostalCode?: InputMaybe<OrderBy>;
  Problem?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  State?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalNumberOfEdgeMeetingsAttended?: InputMaybe<OrderBy>;
  TotalYearsOfMembership?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembersTableHeaderLabelsBlockOutput = {
  __typename?: 'MembersTableHeaderLabelsBlockOutput';
  autocomplete?: Maybe<MembersTableHeaderLabelsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembersTableHeaderLabelsBlockFacet>;
  item?: Maybe<MembersTableHeaderLabelsBlock>;
  items?: Maybe<Array<Maybe<MembersTableHeaderLabelsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembersTableHeaderLabelsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembersTableHeaderLabelsBlockWhereInput = {
  AddressLine?: InputMaybe<SearchableStringFilterInput>;
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApprovedDate?: InputMaybe<SearchableStringFilterInput>;
  AspirantCity?: InputMaybe<SearchableStringFilterInput>;
  AspirantCountry?: InputMaybe<SearchableStringFilterInput>;
  AspirantFirstName?: InputMaybe<SearchableStringFilterInput>;
  AspirantLastName?: InputMaybe<SearchableStringFilterInput>;
  AspirantMDRTID?: InputMaybe<SearchableStringFilterInput>;
  AspirantState?: InputMaybe<SearchableStringFilterInput>;
  AttendeeStatus?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastName?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MemberStatus?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevel?: InputMaybe<SearchableStringFilterInput>;
  MenteeLabel?: InputMaybe<SearchableStringFilterInput>;
  MentorEnrollmentDate?: InputMaybe<SearchableStringFilterInput>;
  MentorFirstName?: InputMaybe<SearchableStringFilterInput>;
  MentorLabel?: InputMaybe<SearchableStringFilterInput>;
  MentorLastName?: InputMaybe<SearchableStringFilterInput>;
  MentorMDRTID?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PostalCode?: InputMaybe<SearchableStringFilterInput>;
  Problem?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  State?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalNumberOfEdgeMeetingsAttended?: InputMaybe<SearchableStringFilterInput>;
  TotalYearsOfMembership?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembersTableHeaderLabelsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembersTableHeaderLabelsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembersTableHeaderLabelsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This block renders membership history detail */
export type MembershipHistoryDetailBlock = IContent & IData & {
  __typename?: 'MembershipHistoryDetailBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Id?: Maybe<Scalars['Int']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  ProductCode?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubscriptionEndYear?: Maybe<Scalars['Int']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This block renders membership history detail */
export type MembershipHistoryDetailBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders membership history detail */
export type MembershipHistoryDetailBlockProductCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders membership history detail */
export type MembershipHistoryDetailBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders membership history detail */
export type MembershipHistoryDetailBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipHistoryDetailBlockAutocomplete = {
  __typename?: 'MembershipHistoryDetailBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipHistoryDetailBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipHistoryDetailBlockFacet = {
  __typename?: 'MembershipHistoryDetailBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ProductCode?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubscriptionEndYear?: Maybe<Array<Maybe<NumberFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipHistoryDetailBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipHistoryDetailBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipHistoryDetailBlockFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipHistoryDetailBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipHistoryDetailBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacetProductCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipHistoryDetailBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipHistoryDetailBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipHistoryDetailBlockFacetSubscriptionEndYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipHistoryDetailBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipHistoryDetailBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Id?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ProductCode?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubscriptionEndYear?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipHistoryDetailBlockOutput = {
  __typename?: 'MembershipHistoryDetailBlockOutput';
  autocomplete?: Maybe<MembershipHistoryDetailBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipHistoryDetailBlockFacet>;
  item?: Maybe<MembershipHistoryDetailBlock>;
  items?: Maybe<Array<Maybe<MembershipHistoryDetailBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipHistoryDetailBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipHistoryDetailBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Id?: InputMaybe<IntFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ProductCode?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubscriptionEndYear?: InputMaybe<IntFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipHistoryDetailBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipHistoryDetailBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipHistoryDetailBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a membership history detail page */
export type MembershipHistoryDetailPage = IContent & IData & {
  __typename?: 'MembershipHistoryDetailPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** Renders membership history detail */
  MembershipHistoryDetail?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<MembershipHistoryDetailPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<MembershipHistoryDetailPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a membership history detail page */
export type MembershipHistoryDetailPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a membership history detail page */
export type MembershipHistoryDetailPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a membership history detail page */
export type MembershipHistoryDetailPageMembershipHistoryDetailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a membership history detail page */
export type MembershipHistoryDetailPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a membership history detail page */
export type MembershipHistoryDetailPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a membership history detail page */
export type MembershipHistoryDetailPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a membership history detail page */
export type MembershipHistoryDetailPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a membership history detail page */
export type MembershipHistoryDetailPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a membership history detail page */
export type MembershipHistoryDetailPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipHistoryDetailPageAutocomplete = {
  __typename?: 'MembershipHistoryDetailPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<MembershipHistoryDetailPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<MembershipHistoryDetailPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipHistoryDetailPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipHistoryDetailPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipHistoryDetailPageFacet = {
  __typename?: 'MembershipHistoryDetailPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipHistoryDetail?: Maybe<ContentAreaItemModelSearchFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<MembershipHistoryDetailPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<MembershipHistoryDetailPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipHistoryDetailPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipHistoryDetailPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipHistoryDetailPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipHistoryDetailPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipHistoryDetailPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipHistoryDetailPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipHistoryDetailPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipHistoryDetailPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipHistoryDetailPageImageBlock = {
  __typename?: 'MembershipHistoryDetailPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type MembershipHistoryDetailPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipHistoryDetailPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipHistoryDetailPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipHistoryDetailPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipHistoryDetailPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipHistoryDetailPageImageBlockAutocomplete = {
  __typename?: 'MembershipHistoryDetailPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type MembershipHistoryDetailPageImageBlockFacet = {
  __typename?: 'MembershipHistoryDetailPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipHistoryDetailPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipHistoryDetailPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipHistoryDetailPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipHistoryDetailPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type MembershipHistoryDetailPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipHistoryDetailPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipHistoryDetail?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<MembershipHistoryDetailPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<MembershipHistoryDetailPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipHistoryDetailPageOutput = {
  __typename?: 'MembershipHistoryDetailPageOutput';
  autocomplete?: Maybe<MembershipHistoryDetailPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipHistoryDetailPageFacet>;
  item?: Maybe<MembershipHistoryDetailPage>;
  items?: Maybe<Array<Maybe<MembershipHistoryDetailPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipHistoryDetailPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipHistoryDetailPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipHistoryDetail?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<MembershipHistoryDetailPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<MembershipHistoryDetailPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipHistoryDetailPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipHistoryDetailPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipHistoryDetailPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for membership invoice */
export type MembershipInvoicePage = IContent & IData & {
  __typename?: 'MembershipInvoicePage';
  AdditionalFilingFeesLabel?: Maybe<Scalars['String']['output']>;
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicationDetailsHeader?: Maybe<Scalars['String']['output']>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AttestToProduction?: Maybe<Scalars['String']['output']>;
  BackDuesLabel?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyNameLabel?: Maybe<Scalars['String']['output']>;
  CompanyPrePaymentLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisabilityRequestedLabel?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  EthicsComplaintLabel?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  FooterAddressText?: Maybe<Scalars['String']['output']>;
  FooterPhoneText?: Maybe<Scalars['String']['output']>;
  FooterPhoneTextXhtml?: Maybe<Scalars['String']['output']>;
  HeaderAddressText?: Maybe<Scalars['String']['output']>;
  HeaderPhoneText?: Maybe<Scalars['String']['output']>;
  HeaderTitleText?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  InvoiceHeader?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeeLabel?: Maybe<Scalars['String']['output']>;
  LifeMemberText?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  MemberDetailsHeader?: Maybe<Scalars['String']['output']>;
  MemberNameLabel?: Maybe<Scalars['String']['output']>;
  MembershipTypeLabel?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<MembershipInvoicePageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  OrderNumberLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentDateLabel?: Maybe<Scalars['String']['output']>;
  PaymentDetailsHeader?: Maybe<Scalars['String']['output']>;
  PaymentMethodLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PriceBreakdownHeader?: Maybe<Scalars['String']['output']>;
  PrintButtonLabel?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeMemberText?: Maybe<Scalars['String']['output']>;
  QualifyingMemberText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SelfPrePaymentLabel?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TermsAndConditionsLabel?: Maybe<Scalars['String']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<MembershipInvoicePageImageBlock>;
  TotalAmountPaidLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageAdditionalFilingFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageApplicationDetailsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageAttestToProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageBackDuesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageCompanyNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageCompanyPrePaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageDisabilityRequestedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageEthicsComplaintLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageFooterAddressTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageFooterPhoneTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageFooterPhoneTextXhtmlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageHeaderAddressTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageHeaderPhoneTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageHeaderTitleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageInvoiceHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageLateFeeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageLifeMemberTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageMemberDetailsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageMemberNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageMembershipTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageOrderNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePagePaymentDateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePagePaymentDetailsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePagePaymentMethodLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePagePhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePagePriceBreakdownHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePagePrintButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageQualifyingAndLifeMemberTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageQualifyingMemberTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageSelfPrePaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageTermsAndConditionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePageTotalAmountPaidLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership invoice */
export type MembershipInvoicePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipInvoicePageAutocomplete = {
  __typename?: 'MembershipInvoicePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<MembershipInvoicePageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<MembershipInvoicePageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipInvoicePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipInvoicePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipInvoicePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipInvoicePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipInvoicePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipInvoicePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipInvoicePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipInvoicePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipInvoicePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipInvoicePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipInvoicePageFacet = {
  __typename?: 'MembershipInvoicePageFacet';
  AdditionalFilingFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationDetailsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  AttestToProduction?: Maybe<Array<Maybe<StringFacet>>>;
  BackDuesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPrePaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisabilityRequestedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EthicsComplaintLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FooterAddressText?: Maybe<Array<Maybe<StringFacet>>>;
  FooterPhoneText?: Maybe<Array<Maybe<StringFacet>>>;
  FooterPhoneTextXhtml?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderAddressText?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderPhoneText?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderTitleText?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  InvoiceHeader?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberText?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDetailsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MemberNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<MembershipInvoicePageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  OrderNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentDateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentDetailsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentMethodLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PriceBreakdownHeader?: Maybe<Array<Maybe<StringFacet>>>;
  PrintButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberText?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelfPrePaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TermsAndConditionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ThumbnailImage?: Maybe<MembershipInvoicePageImageBlockFacet>;
  TotalAmountPaidLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipInvoicePageFacetAdditionalFilingFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetApplicationDetailsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetAttestToProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetBackDuesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipInvoicePageFacetCompanyNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetCompanyPrePaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipInvoicePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipInvoicePageFacetDisabilityRequestedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetEthicsComplaintLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetFooterAddressTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetFooterPhoneTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetFooterPhoneTextXhtmlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetHeaderAddressTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetHeaderPhoneTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetHeaderTitleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipInvoicePageFacetInvoiceHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetLateFeeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetLifeMemberTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetMemberDetailsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetMemberNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetMembershipTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetOrderNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetPaymentDateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetPaymentDetailsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetPaymentMethodLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetPriceBreakdownHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetPrintButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetQualifyingAndLifeMemberTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetQualifyingMemberTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipInvoicePageFacetSelfPrePaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipInvoicePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipInvoicePageFacetTermsAndConditionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetTotalAmountPaidLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipInvoicePageImageBlock = {
  __typename?: 'MembershipInvoicePageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type MembershipInvoicePageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipInvoicePageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipInvoicePageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipInvoicePageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipInvoicePageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipInvoicePageImageBlockAutocomplete = {
  __typename?: 'MembershipInvoicePageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type MembershipInvoicePageImageBlockFacet = {
  __typename?: 'MembershipInvoicePageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipInvoicePageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipInvoicePageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipInvoicePageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipInvoicePageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type MembershipInvoicePageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipInvoicePageOrderByInput = {
  AdditionalFilingFeesLabel?: InputMaybe<OrderBy>;
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationDetailsHeader?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AttestToProduction?: InputMaybe<OrderBy>;
  BackDuesLabel?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyNameLabel?: InputMaybe<OrderBy>;
  CompanyPrePaymentLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisabilityRequestedLabel?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  EthicsComplaintLabel?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FooterAddressText?: InputMaybe<OrderBy>;
  FooterPhoneText?: InputMaybe<OrderBy>;
  FooterPhoneTextXhtml?: InputMaybe<OrderBy>;
  HeaderAddressText?: InputMaybe<OrderBy>;
  HeaderPhoneText?: InputMaybe<OrderBy>;
  HeaderTitleText?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  InvoiceHeader?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeeLabel?: InputMaybe<OrderBy>;
  LifeMemberText?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  MemberDetailsHeader?: InputMaybe<OrderBy>;
  MemberNameLabel?: InputMaybe<OrderBy>;
  MembershipTypeLabel?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<MembershipInvoicePageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  OrderNumberLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentDateLabel?: InputMaybe<OrderBy>;
  PaymentDetailsHeader?: InputMaybe<OrderBy>;
  PaymentMethodLabel?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PriceBreakdownHeader?: InputMaybe<OrderBy>;
  PrintButtonLabel?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberText?: InputMaybe<OrderBy>;
  QualifyingMemberText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelfPrePaymentLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TermsAndConditionsLabel?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<MembershipInvoicePageImageBlockOrderByInput>;
  TotalAmountPaidLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipInvoicePageOutput = {
  __typename?: 'MembershipInvoicePageOutput';
  autocomplete?: Maybe<MembershipInvoicePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipInvoicePageFacet>;
  item?: Maybe<MembershipInvoicePage>;
  items?: Maybe<Array<Maybe<MembershipInvoicePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipInvoicePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipInvoicePageWhereInput = {
  AdditionalFilingFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationDetailsHeader?: InputMaybe<SearchableStringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AttestToProduction?: InputMaybe<SearchableStringFilterInput>;
  BackDuesLabel?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyNameLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyPrePaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisabilityRequestedLabel?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  EthicsComplaintLabel?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FooterAddressText?: InputMaybe<SearchableStringFilterInput>;
  FooterPhoneText?: InputMaybe<SearchableStringFilterInput>;
  FooterPhoneTextXhtml?: InputMaybe<SearchableStringFilterInput>;
  HeaderAddressText?: InputMaybe<SearchableStringFilterInput>;
  HeaderPhoneText?: InputMaybe<SearchableStringFilterInput>;
  HeaderTitleText?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  InvoiceHeader?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeeLabel?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberText?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  MemberDetailsHeader?: InputMaybe<SearchableStringFilterInput>;
  MemberNameLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<MembershipInvoicePageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  OrderNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentDateLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentDetailsHeader?: InputMaybe<SearchableStringFilterInput>;
  PaymentMethodLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PriceBreakdownHeader?: InputMaybe<SearchableStringFilterInput>;
  PrintButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeMemberText?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMemberText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelfPrePaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TermsAndConditionsLabel?: InputMaybe<SearchableStringFilterInput>;
  ThumbnailImage?: InputMaybe<MembershipInvoicePageImageBlockWhereInput>;
  TotalAmountPaidLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipInvoicePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipInvoicePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipInvoicePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type MembershipLevelBlock = IContent & IData & {
  __typename?: 'MembershipLevelBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** Label for the calculated commission */
  CommissionLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  /** Label for the calculated income */
  IncomeLabel?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Displayed on the form view */
  Logo?: Maybe<ContentModelReference>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** List of features for this membership level */
  MembershipLevelFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Label for the calculated premium */
  PremiumLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use {{membershipFee}} as a placeholder for the membership fee */
  SubHeading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type MembershipLevelBlockCommissionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipLevelBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipLevelBlockIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipLevelBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipLevelBlockPremiumLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipLevelBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipLevelBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipLevelBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipLevelBlockAutocomplete = {
  __typename?: 'MembershipLevelBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Logo?: Maybe<ContentModelReferenceAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MembershipLevelFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipLevelBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelBlockAutocompleteMembershipLevelFeaturesArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipLevelBlockFacet = {
  __typename?: 'MembershipLevelBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CommissionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Logo?: Maybe<ContentModelReferenceFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipLevelFeatures?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PremiumLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipLevelBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelBlockFacetCommissionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetMembershipLevelFeaturesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetPremiumLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipLevelBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CommissionLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IncomeLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Logo?: InputMaybe<ContentModelReferenceOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipLevelFeatures?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PremiumLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipLevelBlockOutput = {
  __typename?: 'MembershipLevelBlockOutput';
  autocomplete?: Maybe<MembershipLevelBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipLevelBlockFacet>;
  item?: Maybe<MembershipLevelBlock>;
  items?: Maybe<Array<Maybe<MembershipLevelBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipLevelBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipLevelBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CommissionLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Logo?: InputMaybe<ContentModelReferenceWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipLevelFeatures?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PremiumLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipLevelBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipLevelBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipLevelBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type MembershipLevelRadioBlock = IContent & IData & {
  __typename?: 'MembershipLevelRadioBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CostText?: Maybe<Scalars['String']['output']>;
  CostTooltip?: Maybe<MembershipLevelRadioBlockTooltipBlock>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextLevelRequirementsButtonLabel?: Maybe<Scalars['String']['output']>;
  NextLevelRequirementsListHeader?: Maybe<Scalars['String']['output']>;
  NextLevelRequirementsTitle?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WaiverTitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type MembershipLevelRadioBlockCostTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelRadioBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelRadioBlockNextLevelRequirementsButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelRadioBlockNextLevelRequirementsListHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelRadioBlockNextLevelRequirementsTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelRadioBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelRadioBlockWaiverTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelRadioBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelRadioBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipLevelRadioBlockAutocomplete = {
  __typename?: 'MembershipLevelRadioBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipLevelRadioBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelRadioBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelRadioBlockAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelRadioBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelRadioBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelRadioBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelRadioBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelRadioBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelRadioBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelRadioBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelRadioBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipLevelRadioBlockFacet = {
  __typename?: 'MembershipLevelRadioBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CostText?: Maybe<Array<Maybe<StringFacet>>>;
  CostTooltip?: Maybe<MembershipLevelRadioBlockTooltipBlockFacet>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextLevelRequirementsButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextLevelRequirementsListHeader?: Maybe<Array<Maybe<StringFacet>>>;
  NextLevelRequirementsTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WaiverTitle?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipLevelRadioBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelRadioBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetCostTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelRadioBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetNextLevelRequirementsButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetNextLevelRequirementsListHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetNextLevelRequirementsTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelRadioBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelRadioBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelRadioBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacetWaiverTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipLevelRadioBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CostText?: InputMaybe<OrderBy>;
  CostTooltip?: InputMaybe<MembershipLevelRadioBlockTooltipBlockOrderByInput>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextLevelRequirementsButtonLabel?: InputMaybe<OrderBy>;
  NextLevelRequirementsListHeader?: InputMaybe<OrderBy>;
  NextLevelRequirementsTitle?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WaiverTitle?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipLevelRadioBlockOutput = {
  __typename?: 'MembershipLevelRadioBlockOutput';
  autocomplete?: Maybe<MembershipLevelRadioBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipLevelRadioBlockFacet>;
  item?: Maybe<MembershipLevelRadioBlock>;
  items?: Maybe<Array<Maybe<MembershipLevelRadioBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipLevelRadioBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipLevelRadioBlockTooltipBlock = {
  __typename?: 'MembershipLevelRadioBlockTooltipBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipLevelRadioBlockTooltipBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelRadioBlockTooltipBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipLevelRadioBlockTooltipBlockFacet = {
  __typename?: 'MembershipLevelRadioBlockTooltipBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipLevelRadioBlockTooltipBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelRadioBlockTooltipBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipLevelRadioBlockTooltipBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipLevelRadioBlockTooltipBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipLevelRadioBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CostText?: InputMaybe<SearchableStringFilterInput>;
  CostTooltip?: InputMaybe<MembershipLevelRadioBlockTooltipBlockWhereInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<StringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextLevelRequirementsButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NextLevelRequirementsListHeader?: InputMaybe<SearchableStringFilterInput>;
  NextLevelRequirementsTitle?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WaiverTitle?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipLevelRadioBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipLevelRadioBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipLevelRadioBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type MembershipLevelSectionBlock = IContent & IData & {
  __typename?: 'MembershipLevelSectionBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type MembershipLevelSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipLevelSectionBlockAutocomplete = {
  __typename?: 'MembershipLevelSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipLevelSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipLevelSectionBlockFacet = {
  __typename?: 'MembershipLevelSectionBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipLevelSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipLevelSectionBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BlockReplacementText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipLevelSectionBlockOutput = {
  __typename?: 'MembershipLevelSectionBlockOutput';
  autocomplete?: Maybe<MembershipLevelSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipLevelSectionBlockFacet>;
  item?: Maybe<MembershipLevelSectionBlock>;
  items?: Maybe<Array<Maybe<MembershipLevelSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipLevelSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipLevelSectionBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipLevelSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipLevelSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipLevelSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal V2 page */
export type MembershipLevelStepV2Block = IContent & IData & {
  __typename?: 'MembershipLevelStepV2Block';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  COTRadioBlock?: Maybe<MembershipLevelStepV2BlockMembershipLevelRadioBlock>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MDRTRadioBlock?: Maybe<MembershipLevelStepV2BlockMembershipLevelRadioBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TOTRadioBlock?: Maybe<MembershipLevelStepV2BlockMembershipLevelRadioBlock>;
  TotWaiverInfoText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal V2 page */
export type MembershipLevelStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type MembershipLevelStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type MembershipLevelStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type MembershipLevelStepV2BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type MembershipLevelStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type MembershipLevelStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type MembershipLevelStepV2BlockTotWaiverInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type MembershipLevelStepV2Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type MembershipLevelStepV2Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipLevelStepV2BlockAutocomplete = {
  __typename?: 'MembershipLevelStepV2BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  COTRadioBlock?: Maybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MDRTRadioBlock?: Maybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TOTRadioBlock?: Maybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipLevelStepV2BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelStepV2BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelStepV2BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelStepV2BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelStepV2BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelStepV2BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelStepV2BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelStepV2BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelStepV2BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelStepV2BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipLevelStepV2BlockFacet = {
  __typename?: 'MembershipLevelStepV2BlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  COTRadioBlock?: Maybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MDRTRadioBlock?: Maybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TOTRadioBlock?: Maybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockFacet>;
  TotWaiverInfoText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipLevelStepV2BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelStepV2BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelStepV2BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelStepV2BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelStepV2BlockFacetTotWaiverInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipLevelStepV2BlockMembershipLevelRadioBlock = {
  __typename?: 'MembershipLevelStepV2BlockMembershipLevelRadioBlock';
  CostText?: Maybe<Scalars['String']['output']>;
  CostTooltip?: Maybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlock>;
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  NextLevelRequirementsButtonLabel?: Maybe<Scalars['String']['output']>;
  NextLevelRequirementsListHeader?: Maybe<Scalars['String']['output']>;
  NextLevelRequirementsTitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  WaiverTitle?: Maybe<Scalars['String']['output']>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockCostTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockNextLevelRequirementsButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockNextLevelRequirementsListHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockNextLevelRequirementsTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockWaiverTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipLevelStepV2BlockMembershipLevelRadioBlockAutocomplete = {
  __typename?: 'MembershipLevelStepV2BlockMembershipLevelRadioBlockAutocomplete';
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipLevelStepV2BlockMembershipLevelRadioBlockFacet = {
  __typename?: 'MembershipLevelStepV2BlockMembershipLevelRadioBlockFacet';
  CostText?: Maybe<Array<Maybe<StringFacet>>>;
  CostTooltip?: Maybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  NextLevelRequirementsButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextLevelRequirementsListHeader?: Maybe<Array<Maybe<StringFacet>>>;
  NextLevelRequirementsTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  WaiverTitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockFacetCostTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockFacetNextLevelRequirementsButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockFacetNextLevelRequirementsListHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockFacetNextLevelRequirementsTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockFacetWaiverTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipLevelStepV2BlockMembershipLevelRadioBlockOrderByInput = {
  CostText?: InputMaybe<OrderBy>;
  CostTooltip?: InputMaybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  NextLevelRequirementsButtonLabel?: InputMaybe<OrderBy>;
  NextLevelRequirementsListHeader?: InputMaybe<OrderBy>;
  NextLevelRequirementsTitle?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  WaiverTitle?: InputMaybe<OrderBy>;
};

export type MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlock = {
  __typename?: 'MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockFacet = {
  __typename?: 'MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipLevelStepV2BlockMembershipLevelRadioBlockWhereInput = {
  CostText?: InputMaybe<SearchableStringFilterInput>;
  CostTooltip?: InputMaybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockWhereInput>;
  Description?: InputMaybe<StringFilterInput>;
  NextLevelRequirementsButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NextLevelRequirementsListHeader?: InputMaybe<SearchableStringFilterInput>;
  NextLevelRequirementsTitle?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  WaiverTitle?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipLevelStepV2BlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  COTRadioBlock?: InputMaybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MDRTRadioBlock?: InputMaybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TOTRadioBlock?: InputMaybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockOrderByInput>;
  TotWaiverInfoText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipLevelStepV2BlockOutput = {
  __typename?: 'MembershipLevelStepV2BlockOutput';
  autocomplete?: Maybe<MembershipLevelStepV2BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipLevelStepV2BlockFacet>;
  item?: Maybe<MembershipLevelStepV2Block>;
  items?: Maybe<Array<Maybe<MembershipLevelStepV2Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipLevelStepV2BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipLevelStepV2BlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  COTRadioBlock?: InputMaybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MDRTRadioBlock?: InputMaybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TOTRadioBlock?: InputMaybe<MembershipLevelStepV2BlockMembershipLevelRadioBlockWhereInput>;
  TotWaiverInfoText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipLevelStepV2BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipLevelStepV2BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipLevelStepV2BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type MembershipLevelsBlock = IContent & IData & {
  __typename?: 'MembershipLevelsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CoTTableLabel?: Maybe<Scalars['String']['output']>;
  CommissionTabDescription?: Maybe<Scalars['String']['output']>;
  CommissionTabLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IncomeTabDescription?: Maybe<Scalars['String']['output']>;
  IncomeTabLabel?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtTableLabel?: Maybe<Scalars['String']['output']>;
  MembershipLevels?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MembershipLevelsCloseLabel?: Maybe<Scalars['String']['output']>;
  MembershipLevelsDescription?: Maybe<Scalars['String']['output']>;
  MembershipLevelsFooter?: Maybe<Scalars['String']['output']>;
  MembershipLevelsHeading?: Maybe<Scalars['String']['output']>;
  MembershipLevelsOpenLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PremiumTabDescription?: Maybe<Scalars['String']['output']>;
  PremiumTabLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** CSV of the membership requirements for the current year */
  RequirementsDocument?: Maybe<ContentModelReference>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TextContent?: Maybe<MembershipLevelsBlockTextContentBlock>;
  ToTTableLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type MembershipLevelsBlockCoTTableLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockCommissionTabDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockCommissionTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockIncomeTabDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockIncomeTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockMdrtTableLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockMembershipLevelsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockMembershipLevelsCloseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockMembershipLevelsDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockMembershipLevelsFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockMembershipLevelsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockMembershipLevelsOpenLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockPremiumTabDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockPremiumTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockToTTableLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipLevelsBlockAutocomplete = {
  __typename?: 'MembershipLevelsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RequirementsDocument?: Maybe<ContentModelReferenceAutocomplete>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipLevelsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipLevelsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipLevelsBlockFacet = {
  __typename?: 'MembershipLevelsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CoTTableLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionTabDescription?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionTabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IncomeTabDescription?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeTabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtTableLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevels?: Maybe<ContentAreaItemModelSearchFacet>;
  MembershipLevelsCloseLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsFooter?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsOpenLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PremiumTabDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumTabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RequirementsDocument?: Maybe<ContentModelReferenceFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TextContent?: Maybe<MembershipLevelsBlockTextContentBlockFacet>;
  ToTTableLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipLevelsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelsBlockFacetCoTTableLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetCommissionTabDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetCommissionTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelsBlockFacetIncomeTabDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetIncomeTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipLevelsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetMdrtTableLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetMembershipLevelsCloseLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetMembershipLevelsDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetMembershipLevelsFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetMembershipLevelsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetMembershipLevelsOpenLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetPremiumTabDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetPremiumTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipLevelsBlockFacetToTTableLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipLevelsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CoTTableLabel?: InputMaybe<OrderBy>;
  CommissionTabDescription?: InputMaybe<OrderBy>;
  CommissionTabLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IncomeTabDescription?: InputMaybe<OrderBy>;
  IncomeTabLabel?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtTableLabel?: InputMaybe<OrderBy>;
  MembershipLevels?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MembershipLevelsCloseLabel?: InputMaybe<OrderBy>;
  MembershipLevelsDescription?: InputMaybe<OrderBy>;
  MembershipLevelsFooter?: InputMaybe<OrderBy>;
  MembershipLevelsHeading?: InputMaybe<OrderBy>;
  MembershipLevelsOpenLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PremiumTabDescription?: InputMaybe<OrderBy>;
  PremiumTabLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RequirementsDocument?: InputMaybe<ContentModelReferenceOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TextContent?: InputMaybe<MembershipLevelsBlockTextContentBlockOrderByInput>;
  ToTTableLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipLevelsBlockOutput = {
  __typename?: 'MembershipLevelsBlockOutput';
  autocomplete?: Maybe<MembershipLevelsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipLevelsBlockFacet>;
  item?: Maybe<MembershipLevelsBlock>;
  items?: Maybe<Array<Maybe<MembershipLevelsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipLevelsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipLevelsBlockTextContentBlock = {
  __typename?: 'MembershipLevelsBlockTextContentBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
};


export type MembershipLevelsBlockTextContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockTextContentBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockTextContentBlockPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipLevelsBlockTextContentBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipLevelsBlockTextContentBlockFacet = {
  __typename?: 'MembershipLevelsBlockTextContentBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipLevelsBlockTextContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockTextContentBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockTextContentBlockFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipLevelsBlockTextContentBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipLevelsBlockTextContentBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  PreHeading?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
};

export type MembershipLevelsBlockTextContentBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipLevelsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CoTTableLabel?: InputMaybe<SearchableStringFilterInput>;
  CommissionTabDescription?: InputMaybe<SearchableStringFilterInput>;
  CommissionTabLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IncomeTabDescription?: InputMaybe<SearchableStringFilterInput>;
  IncomeTabLabel?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtTableLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevels?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MembershipLevelsCloseLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsDescription?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsFooter?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsHeading?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsOpenLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PremiumTabDescription?: InputMaybe<SearchableStringFilterInput>;
  PremiumTabLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RequirementsDocument?: InputMaybe<ContentModelReferenceWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TextContent?: InputMaybe<MembershipLevelsBlockTextContentBlockWhereInput>;
  ToTTableLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipLevelsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipLevelsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipLevelsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for registration */
export type MembershipRenewalPage = IContent & IData & {
  __typename?: 'MembershipRenewalPage';
  AccountLabel?: Maybe<Scalars['String']['output']>;
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** The Confirmation step content */
  ConfirmationStep?: Maybe<MembershipRenewalPageConfirmationStepBlock>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  /** General error modal message for 500s, 404s etc */
  ErrorModalDescription?: Maybe<Scalars['String']['output']>;
  /** Error message when a user isnt authorized */
  ErrorModalNotAuthorizedButton1Text?: Maybe<Scalars['String']['output']>;
  /** Error message when a user isnt authorized */
  ErrorModalNotAuthorizedButton2Text?: Maybe<Scalars['String']['output']>;
  /** Error message when a user isnt authorized */
  ErrorModalNotAuthorizedDescription?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  /** Error message when a user submits a form that has a field with a required error */
  FormHasRequiredErrorsLabel?: Maybe<Scalars['String']['output']>;
  /** The Getting Started step content */
  GettingStartedStep?: Maybe<MembershipRenewalPageGettingStartedStepBlock>;
  /** The Getting Started step content */
  GreetingStepBlock?: Maybe<MembershipRenewalPageGreetingStepBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeesTooltip?: Maybe<Scalars['String']['output']>;
  /** The label for your total due, shown beneath the steps */
  LogoutLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** The Membership Type step content */
  MembershipTypeStep?: Maybe<MembershipRenewalPageMembershipTypeStepBlock>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<MembershipRenewalPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NavHeadingLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** The Review step content */
  ProductionStep?: Maybe<MembershipRenewalPageProductionStepBlock>;
  /** The Profile step content */
  ProfileStep?: Maybe<MembershipRenewalPageProfileStepBlock>;
  QuestionsHeading?: Maybe<Scalars['String']['output']>;
  /** The Receipt step content */
  ReceiptStep?: Maybe<MembershipRenewalPageReceiptStepBlock>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** Error message when a user doesn't enter a required field */
  RequiredErrorFieldLabel?: Maybe<Scalars['String']['output']>;
  /** The Review step content */
  ReviewStep?: Maybe<MembershipRenewalPageReviewStepBlock>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  /** The Routing content */
  RoutingStep?: Maybe<MembershipRenewalPageRoutingStepBlock>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SelectLanguageHeading?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<MembershipRenewalPageImageBlock>;
  /** The label for your total due, shown beneath the steps */
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for registration */
export type MembershipRenewalPageAccountLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageErrorModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageErrorModalNotAuthorizedButton1TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageErrorModalNotAuthorizedButton2TextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageErrorModalNotAuthorizedDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageFormHasRequiredErrorsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageLateFeesTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageLogoutLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageNavHeadingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageQuestionsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageRequiredErrorFieldLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageSelectLanguageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPageTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for registration */
export type MembershipRenewalPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipRenewalPageAutocomplete = {
  __typename?: 'MembershipRenewalPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ConfirmationStep?: Maybe<MembershipRenewalPageConfirmationStepBlockAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MembershipTypeStep?: Maybe<MembershipRenewalPageMembershipTypeStepBlockAutocomplete>;
  MetaImage?: Maybe<MembershipRenewalPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ReviewStep?: Maybe<MembershipRenewalPageReviewStepBlockAutocomplete>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RoutingStep?: Maybe<MembershipRenewalPageRoutingStepBlockAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<MembershipRenewalPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRenewalPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRenewalPageConfirmationStepBlock = {
  __typename?: 'MembershipRenewalPageConfirmationStepBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkSectionHeading?: Maybe<Scalars['String']['output']>;
  SvgLinkBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  UpgradeButtonText?: Maybe<Scalars['String']['output']>;
  ViewMoreLink?: Maybe<MembershipRenewalPageConfirmationStepBlockLinkBlock>;
  ViewReceiptLinkText?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalPageConfirmationStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageConfirmationStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkSectionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageConfirmationStepBlockSvgLinkBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageConfirmationStepBlockUpgradeButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageConfirmationStepBlockViewReceiptLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageConfirmationStepBlockAutocomplete = {
  __typename?: 'MembershipRenewalPageConfirmationStepBlockAutocomplete';
  ViewMoreLink?: Maybe<MembershipRenewalPageConfirmationStepBlockLinkBlockAutocomplete>;
};

export type MembershipRenewalPageConfirmationStepBlockFacet = {
  __typename?: 'MembershipRenewalPageConfirmationStepBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkSectionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SvgLinkBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  UpgradeButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMoreLink?: Maybe<MembershipRenewalPageConfirmationStepBlockLinkBlockFacet>;
  ViewReceiptLinkText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalPageConfirmationStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRenewalPageConfirmationStepBlockFacetLinkSectionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockFacetUpgradeButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockFacetViewReceiptLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageConfirmationStepBlockLinkBlock = {
  __typename?: 'MembershipRenewalPageConfirmationStepBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageConfirmationStepBlockLinkBlockAutocomplete = {
  __typename?: 'MembershipRenewalPageConfirmationStepBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRenewalPageConfirmationStepBlockLinkBlockFacet = {
  __typename?: 'MembershipRenewalPageConfirmationStepBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageConfirmationStepBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageConfirmationStepBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageConfirmationStepBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalPageConfirmationStepBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkSectionHeading?: InputMaybe<OrderBy>;
  SvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  UpgradeButtonText?: InputMaybe<OrderBy>;
  ViewMoreLink?: InputMaybe<MembershipRenewalPageConfirmationStepBlockLinkBlockOrderByInput>;
  ViewReceiptLinkText?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageConfirmationStepBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkSectionHeading?: InputMaybe<SearchableStringFilterInput>;
  SvgLinkBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  UpgradeButtonText?: InputMaybe<SearchableStringFilterInput>;
  ViewMoreLink?: InputMaybe<MembershipRenewalPageConfirmationStepBlockLinkBlockWhereInput>;
  ViewReceiptLinkText?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalPageFacet = {
  __typename?: 'MembershipRenewalPageFacet';
  AccountLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationStep?: Maybe<MembershipRenewalPageConfirmationStepBlockFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalNotAuthorizedButton1Text?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalNotAuthorizedButton2Text?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModalNotAuthorizedDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FormHasRequiredErrorsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GettingStartedStep?: Maybe<MembershipRenewalPageGettingStartedStepBlockFacet>;
  GreetingStepBlock?: Maybe<MembershipRenewalPageGreetingStepBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeesTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipTypeStep?: Maybe<MembershipRenewalPageMembershipTypeStepBlockFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<MembershipRenewalPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavHeadingLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ProductionStep?: Maybe<MembershipRenewalPageProductionStepBlockFacet>;
  ProfileStep?: Maybe<MembershipRenewalPageProfileStepBlockFacet>;
  QuestionsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptStep?: Maybe<MembershipRenewalPageReceiptStepBlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RequiredErrorFieldLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReviewStep?: Maybe<MembershipRenewalPageReviewStepBlockFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  RoutingStep?: Maybe<MembershipRenewalPageRoutingStepBlockFacet>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelectLanguageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<MembershipRenewalPageImageBlockFacet>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipRenewalPageFacetAccountLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRenewalPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRenewalPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRenewalPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetErrorModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetErrorModalNotAuthorizedButton1TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetErrorModalNotAuthorizedButton2TextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetErrorModalNotAuthorizedDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetFormHasRequiredErrorsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRenewalPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetLateFeesTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetLogoutLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetNavHeadingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetQuestionsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetRequiredErrorFieldLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRenewalPageFacetSelectLanguageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRenewalPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRenewalPageFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipRenewalPageGettingStartedStepBlock = {
  __typename?: 'MembershipRenewalPageGettingStartedStepBlock';
  DisabledDescription?: Maybe<Scalars['String']['output']>;
  DisabledHeading?: Maybe<Scalars['String']['output']>;
  DisabledModalDescription?: Maybe<Scalars['String']['output']>;
  EthicalComplaintDescription?: Maybe<Scalars['String']['output']>;
  EthicalComplaintHeading?: Maybe<Scalars['String']['output']>;
  EthicalComplaintModalDescription?: Maybe<Scalars['String']['output']>;
  FormDescription?: Maybe<Scalars['String']['output']>;
  FormHeading?: Maybe<Scalars['String']['output']>;
  IndustryAssociationsDescription?: Maybe<Scalars['String']['output']>;
  IndustryAssociationsHeading?: Maybe<Scalars['String']['output']>;
  ModalCancelLabel?: Maybe<Scalars['String']['output']>;
  ModalContinueLabel?: Maybe<Scalars['String']['output']>;
  ModalFooter?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ProfessionalAssociationModalDescription?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  UnableToProcessError?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalPageGettingStartedStepBlockDisabledDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockDisabledHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockDisabledModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockEthicalComplaintDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockEthicalComplaintHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockEthicalComplaintModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockFormDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockFormHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockIndustryAssociationsDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockIndustryAssociationsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockModalCancelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockModalContinueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockModalFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockProfessionalAssociationModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGettingStartedStepBlockUnableToProcessErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageGettingStartedStepBlockFacet = {
  __typename?: 'MembershipRenewalPageGettingStartedStepBlockFacet';
  DisabledDescription?: Maybe<Array<Maybe<StringFacet>>>;
  DisabledHeading?: Maybe<Array<Maybe<StringFacet>>>;
  DisabledModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormHeading?: Maybe<Array<Maybe<StringFacet>>>;
  IndustryAssociationsDescription?: Maybe<Array<Maybe<StringFacet>>>;
  IndustryAssociationsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ModalCancelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ModalContinueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ModalFooter?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalAssociationModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  UnableToProcessError?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetDisabledDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetDisabledHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetDisabledModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetEthicalComplaintDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetEthicalComplaintHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetEthicalComplaintModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetFormDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetFormHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetIndustryAssociationsDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetIndustryAssociationsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetModalCancelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetModalContinueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetModalFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetProfessionalAssociationModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGettingStartedStepBlockFacetUnableToProcessErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageGettingStartedStepBlockOrderByInput = {
  DisabledDescription?: InputMaybe<OrderBy>;
  DisabledHeading?: InputMaybe<OrderBy>;
  DisabledModalDescription?: InputMaybe<OrderBy>;
  EthicalComplaintDescription?: InputMaybe<OrderBy>;
  EthicalComplaintHeading?: InputMaybe<OrderBy>;
  EthicalComplaintModalDescription?: InputMaybe<OrderBy>;
  FormDescription?: InputMaybe<OrderBy>;
  FormHeading?: InputMaybe<OrderBy>;
  IndustryAssociationsDescription?: InputMaybe<OrderBy>;
  IndustryAssociationsHeading?: InputMaybe<OrderBy>;
  ModalCancelLabel?: InputMaybe<OrderBy>;
  ModalContinueLabel?: InputMaybe<OrderBy>;
  ModalFooter?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ProfessionalAssociationModalDescription?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  UnableToProcessError?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageGettingStartedStepBlockWhereInput = {
  DisabledDescription?: InputMaybe<SearchableStringFilterInput>;
  DisabledHeading?: InputMaybe<SearchableStringFilterInput>;
  DisabledModalDescription?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintDescription?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintHeading?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintModalDescription?: InputMaybe<SearchableStringFilterInput>;
  FormDescription?: InputMaybe<SearchableStringFilterInput>;
  FormHeading?: InputMaybe<SearchableStringFilterInput>;
  IndustryAssociationsDescription?: InputMaybe<SearchableStringFilterInput>;
  IndustryAssociationsHeading?: InputMaybe<SearchableStringFilterInput>;
  ModalCancelLabel?: InputMaybe<SearchableStringFilterInput>;
  ModalContinueLabel?: InputMaybe<SearchableStringFilterInput>;
  ModalFooter?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalAssociationModalDescription?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  UnableToProcessError?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalPageGreetingStepBlock = {
  __typename?: 'MembershipRenewalPageGreetingStepBlock';
  AfternoonHeading?: Maybe<Scalars['String']['output']>;
  ApplicationSubmittedByCompanyAdminHeading?: Maybe<Scalars['String']['output']>;
  CompanyPaymentNoProduction?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
  CompanyPaymentProductionNotRequired?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
  CompanyProductionAndPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
  CompanyProductionNoPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
  Description?: Maybe<Scalars['String']['output']>;
  EveningHeading?: Maybe<Scalars['String']['output']>;
  FirstTimeMemberHeadingText?: Maybe<Scalars['String']['output']>;
  FirstTimeMemberHeadingTextFirstTimeMemberHeadingText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HelpContactInfo?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  NoPaymentNoProduction?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
  NoPaymentProductionNotRequired?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
  PageExplanation?: Maybe<Scalars['String']['output']>;
  PaperApplicationAlreadyStartedHeading?: Maybe<Scalars['String']['output']>;
  ProvidingCertifyingLetters?: Maybe<Scalars['String']['output']>;
  ProvidingPayment?: Maybe<Scalars['String']['output']>;
  ProvidingProductionNumbers?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  SubDescription?: Maybe<Scalars['String']['output']>;
  TenYearCompanyPaymentProductionNotRequired?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
  TenYearCompanyProductionAndPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
  TenYearCompanyProductionNoPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
  TenYearNoPaymentProductionNotRequired?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
  TenYearNoProductionCompanyPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
  TenYearNoProductionNoPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlock>;
};


export type MembershipRenewalPageGreetingStepBlockAfternoonHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockApplicationSubmittedByCompanyAdminHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockEveningHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockFirstTimeMemberHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockFirstTimeMemberHeadingTextFirstTimeMemberHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockHelpContactInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockPageExplanationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockPaperApplicationAlreadyStartedHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockProvidingCertifyingLettersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockProvidingPaymentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockProvidingProductionNumbersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockSubDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageGreetingStepBlockFacet = {
  __typename?: 'MembershipRenewalPageGreetingStepBlockFacet';
  AfternoonHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationSubmittedByCompanyAdminHeading?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPaymentNoProduction?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
  CompanyPaymentProductionNotRequired?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
  CompanyProductionAndPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
  CompanyProductionNoPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EveningHeading?: Maybe<Array<Maybe<StringFacet>>>;
  FirstTimeMemberHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  FirstTimeMemberHeadingTextFirstTimeMemberHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HelpContactInfo?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NoPaymentNoProduction?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
  NoPaymentProductionNotRequired?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
  PageExplanation?: Maybe<Array<Maybe<StringFacet>>>;
  PaperApplicationAlreadyStartedHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ProvidingCertifyingLetters?: Maybe<Array<Maybe<StringFacet>>>;
  ProvidingPayment?: Maybe<Array<Maybe<StringFacet>>>;
  ProvidingProductionNumbers?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  SubDescription?: Maybe<Array<Maybe<StringFacet>>>;
  TenYearCompanyPaymentProductionNotRequired?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
  TenYearCompanyProductionAndPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
  TenYearCompanyProductionNoPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
  TenYearNoPaymentProductionNotRequired?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
  TenYearNoProductionCompanyPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
  TenYearNoProductionNoPayment?: Maybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet>;
};


export type MembershipRenewalPageGreetingStepBlockFacetAfternoonHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetApplicationSubmittedByCompanyAdminHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetEveningHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetFirstTimeMemberHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetFirstTimeMemberHeadingTextFirstTimeMemberHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetHelpContactInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetPageExplanationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetPaperApplicationAlreadyStartedHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetProvidingCertifyingLettersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetProvidingPaymentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetProvidingProductionNumbersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockFacetSubDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageGreetingStepBlockGreetingCaseBlock = {
  __typename?: 'MembershipRenewalPageGreetingStepBlockGreetingCaseBlock';
  CertifyingLetters?: Maybe<Scalars['String']['output']>;
  Payment?: Maybe<Scalars['String']['output']>;
  Production?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalPageGreetingStepBlockGreetingCaseBlockCertifyingLettersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockGreetingCaseBlockPaymentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageGreetingStepBlockGreetingCaseBlockProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet = {
  __typename?: 'MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacet';
  CertifyingLetters?: Maybe<Array<Maybe<StringFacet>>>;
  Payment?: Maybe<Array<Maybe<StringFacet>>>;
  Production?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacetCertifyingLettersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacetPaymentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageGreetingStepBlockGreetingCaseBlockFacetProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput = {
  CertifyingLetters?: InputMaybe<OrderBy>;
  Payment?: InputMaybe<OrderBy>;
  Production?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput = {
  CertifyingLetters?: InputMaybe<SearchableStringFilterInput>;
  Payment?: InputMaybe<SearchableStringFilterInput>;
  Production?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalPageGreetingStepBlockOrderByInput = {
  AfternoonHeading?: InputMaybe<OrderBy>;
  ApplicationSubmittedByCompanyAdminHeading?: InputMaybe<OrderBy>;
  CompanyPaymentNoProduction?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
  CompanyPaymentProductionNotRequired?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
  CompanyProductionAndPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
  CompanyProductionNoPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  EveningHeading?: InputMaybe<OrderBy>;
  FirstTimeMemberHeadingText?: InputMaybe<OrderBy>;
  FirstTimeMemberHeadingTextFirstTimeMemberHeadingText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HelpContactInfo?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  NoPaymentNoProduction?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
  NoPaymentProductionNotRequired?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
  PageExplanation?: InputMaybe<OrderBy>;
  PaperApplicationAlreadyStartedHeading?: InputMaybe<OrderBy>;
  ProvidingCertifyingLetters?: InputMaybe<OrderBy>;
  ProvidingPayment?: InputMaybe<OrderBy>;
  ProvidingProductionNumbers?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  SubDescription?: InputMaybe<OrderBy>;
  TenYearCompanyPaymentProductionNotRequired?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
  TenYearCompanyProductionAndPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
  TenYearCompanyProductionNoPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
  TenYearNoPaymentProductionNotRequired?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
  TenYearNoProductionCompanyPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
  TenYearNoProductionNoPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockOrderByInput>;
};

export type MembershipRenewalPageGreetingStepBlockWhereInput = {
  AfternoonHeading?: InputMaybe<SearchableStringFilterInput>;
  ApplicationSubmittedByCompanyAdminHeading?: InputMaybe<SearchableStringFilterInput>;
  CompanyPaymentNoProduction?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
  CompanyPaymentProductionNotRequired?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
  CompanyProductionAndPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
  CompanyProductionNoPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EveningHeading?: InputMaybe<SearchableStringFilterInput>;
  FirstTimeMemberHeadingText?: InputMaybe<SearchableStringFilterInput>;
  FirstTimeMemberHeadingTextFirstTimeMemberHeadingText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HelpContactInfo?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NoPaymentNoProduction?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
  NoPaymentProductionNotRequired?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
  PageExplanation?: InputMaybe<SearchableStringFilterInput>;
  PaperApplicationAlreadyStartedHeading?: InputMaybe<SearchableStringFilterInput>;
  ProvidingCertifyingLetters?: InputMaybe<SearchableStringFilterInput>;
  ProvidingPayment?: InputMaybe<SearchableStringFilterInput>;
  ProvidingProductionNumbers?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  SubDescription?: InputMaybe<SearchableStringFilterInput>;
  TenYearCompanyPaymentProductionNotRequired?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
  TenYearCompanyProductionAndPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
  TenYearCompanyProductionNoPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
  TenYearNoPaymentProductionNotRequired?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
  TenYearNoProductionCompanyPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
  TenYearNoProductionNoPayment?: InputMaybe<MembershipRenewalPageGreetingStepBlockGreetingCaseBlockWhereInput>;
};

export type MembershipRenewalPageImageBlock = {
  __typename?: 'MembershipRenewalPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageImageBlockAutocomplete = {
  __typename?: 'MembershipRenewalPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type MembershipRenewalPageImageBlockFacet = {
  __typename?: 'MembershipRenewalPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRenewalPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalPageMembershipTypeStepBlock = {
  __typename?: 'MembershipRenewalPageMembershipTypeStepBlock';
  BackduesModalAmount?: Maybe<Scalars['String']['output']>;
  BackduesModalCancelButtonLabel?: Maybe<Scalars['String']['output']>;
  BackduesModalContinueButtonLabel?: Maybe<Scalars['String']['output']>;
  BackduesModalDescription?: Maybe<Scalars['String']['output']>;
  BackduesModalTotalLabel?: Maybe<Scalars['String']['output']>;
  CoTMembershipLevel?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  LifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  LifeMemberLabel?: Maybe<Scalars['String']['output']>;
  MdrtMembershipLevel?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MembershipLevelModalDescription?: Maybe<Scalars['String']['output']>;
  MembershipLevelModalFooter?: Maybe<Scalars['String']['output']>;
  MembershipLevelModalHeading?: Maybe<Scalars['String']['output']>;
  MembershipLevelModalRequirementsFooter?: Maybe<Scalars['String']['output']>;
  MembershipLevelsLabel?: Maybe<Scalars['String']['output']>;
  MembershipTypeContinueError?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingAndLifeMemberLabel?: Maybe<Scalars['String']['output']>;
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingMemberLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TenYearLifeMemberDescription?: Maybe<Scalars['String']['output']>;
  ToTMembershipLevel?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
};


export type MembershipRenewalPageMembershipTypeStepBlockBackduesModalAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockBackduesModalCancelButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockBackduesModalContinueButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockBackduesModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockBackduesModalTotalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockCoTMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockMdrtMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockMembershipLevelModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockMembershipLevelModalFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockMembershipLevelModalHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockMembershipLevelModalRequirementsFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockMembershipLevelsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockMembershipTypeContinueErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockQualifyingAndLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockQualifyingMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockTenYearLifeMemberDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageMembershipTypeStepBlockToTMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageMembershipTypeStepBlockAutocomplete = {
  __typename?: 'MembershipRenewalPageMembershipTypeStepBlockAutocomplete';
  LifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRenewalPageMembershipTypeStepBlockAutocompleteLifeMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalPageMembershipTypeStepBlockAutocompleteQualifyingAndLifeMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalPageMembershipTypeStepBlockAutocompleteQualifyingMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRenewalPageMembershipTypeStepBlockFacet = {
  __typename?: 'MembershipRenewalPageMembershipTypeStepBlockFacet';
  BackduesModalAmount?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesModalCancelButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesModalContinueButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesModalTotalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CoTMembershipLevel?: Maybe<ContentAreaItemModelSearchFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtMembershipLevel?: Maybe<ContentAreaItemModelSearchFacet>;
  MembershipLevelModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelModalFooter?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelModalHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelModalRequirementsFooter?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTypeContinueError?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TenYearLifeMemberDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ToTMembershipLevel?: Maybe<ContentAreaItemModelSearchFacet>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetBackduesModalAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetBackduesModalCancelButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetBackduesModalContinueButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetBackduesModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetBackduesModalTotalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetLifeMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetMembershipLevelModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetMembershipLevelModalFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetMembershipLevelModalHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetMembershipLevelModalRequirementsFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetMembershipLevelsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetMembershipTypeContinueErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetQualifyingAndLifeMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetQualifyingAndLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetQualifyingMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetQualifyingMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageMembershipTypeStepBlockFacetTenYearLifeMemberDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageMembershipTypeStepBlockOrderByInput = {
  BackduesModalAmount?: InputMaybe<OrderBy>;
  BackduesModalCancelButtonLabel?: InputMaybe<OrderBy>;
  BackduesModalContinueButtonLabel?: InputMaybe<OrderBy>;
  BackduesModalDescription?: InputMaybe<OrderBy>;
  BackduesModalTotalLabel?: InputMaybe<OrderBy>;
  CoTMembershipLevel?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  LifeMemberDescriptions?: InputMaybe<OrderBy>;
  LifeMemberLabel?: InputMaybe<OrderBy>;
  MdrtMembershipLevel?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MembershipLevelModalDescription?: InputMaybe<OrderBy>;
  MembershipLevelModalFooter?: InputMaybe<OrderBy>;
  MembershipLevelModalHeading?: InputMaybe<OrderBy>;
  MembershipLevelModalRequirementsFooter?: InputMaybe<OrderBy>;
  MembershipLevelsLabel?: InputMaybe<OrderBy>;
  MembershipTypeContinueError?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberDescriptions?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberLabel?: InputMaybe<OrderBy>;
  QualifyingMemberDescriptions?: InputMaybe<OrderBy>;
  QualifyingMemberLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TenYearLifeMemberDescription?: InputMaybe<OrderBy>;
  ToTMembershipLevel?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
};

export type MembershipRenewalPageMembershipTypeStepBlockWhereInput = {
  BackduesModalAmount?: InputMaybe<SearchableStringFilterInput>;
  BackduesModalCancelButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  BackduesModalContinueButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  BackduesModalDescription?: InputMaybe<SearchableStringFilterInput>;
  BackduesModalTotalLabel?: InputMaybe<SearchableStringFilterInput>;
  CoTMembershipLevel?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberDescriptions?: InputMaybe<StringFilterInput>;
  LifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtMembershipLevel?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MembershipLevelModalDescription?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelModalFooter?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelModalHeading?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelModalRequirementsFooter?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipTypeContinueError?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeMemberDescriptions?: InputMaybe<StringFilterInput>;
  QualifyingAndLifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMemberDescriptions?: InputMaybe<StringFilterInput>;
  QualifyingMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TenYearLifeMemberDescription?: InputMaybe<SearchableStringFilterInput>;
  ToTMembershipLevel?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
};

export type MembershipRenewalPageOrderByInput = {
  AccountLabel?: InputMaybe<OrderBy>;
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationStep?: InputMaybe<MembershipRenewalPageConfirmationStepBlockOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ErrorModalDescription?: InputMaybe<OrderBy>;
  ErrorModalNotAuthorizedButton1Text?: InputMaybe<OrderBy>;
  ErrorModalNotAuthorizedButton2Text?: InputMaybe<OrderBy>;
  ErrorModalNotAuthorizedDescription?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FormHasRequiredErrorsLabel?: InputMaybe<OrderBy>;
  GettingStartedStep?: InputMaybe<MembershipRenewalPageGettingStartedStepBlockOrderByInput>;
  GreetingStepBlock?: InputMaybe<MembershipRenewalPageGreetingStepBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeesTooltip?: InputMaybe<OrderBy>;
  LogoutLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipTypeStep?: InputMaybe<MembershipRenewalPageMembershipTypeStepBlockOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<MembershipRenewalPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavHeadingLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ProductionStep?: InputMaybe<MembershipRenewalPageProductionStepBlockOrderByInput>;
  ProfileStep?: InputMaybe<MembershipRenewalPageProfileStepBlockOrderByInput>;
  QuestionsHeading?: InputMaybe<OrderBy>;
  ReceiptStep?: InputMaybe<MembershipRenewalPageReceiptStepBlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RequiredErrorFieldLabel?: InputMaybe<OrderBy>;
  ReviewStep?: InputMaybe<MembershipRenewalPageReviewStepBlockOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  RoutingStep?: InputMaybe<MembershipRenewalPageRoutingStepBlockOrderByInput>;
  Saved?: InputMaybe<OrderBy>;
  SelectLanguageHeading?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<MembershipRenewalPageImageBlockOrderByInput>;
  TotalDueLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageOutput = {
  __typename?: 'MembershipRenewalPageOutput';
  autocomplete?: Maybe<MembershipRenewalPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipRenewalPageFacet>;
  item?: Maybe<MembershipRenewalPage>;
  items?: Maybe<Array<Maybe<MembershipRenewalPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipRenewalPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipRenewalPageProductionStepBlock = {
  __typename?: 'MembershipRenewalPageProductionStepBlock';
  AddButtonLabel?: Maybe<Scalars['String']['output']>;
  AddPolicesButtonLabel?: Maybe<Scalars['String']['output']>;
  AddPoliciesCasesButtonLabel?: Maybe<Scalars['String']['output']>;
  AttestProductionAddProduction?: Maybe<Scalars['String']['output']>;
  AttestProductionAttestOption?: Maybe<Scalars['String']['output']>;
  AttestProductionBackButton?: Maybe<Scalars['String']['output']>;
  AttestProductionHeadline?: Maybe<Scalars['String']['output']>;
  AttestProductionSelectLabel?: Maybe<Scalars['String']['output']>;
  CertifyingLettersButtonLabel?: Maybe<Scalars['String']['output']>;
  CertifyingLettersDescription?: Maybe<Scalars['String']['output']>;
  CertifyingLettersErrorText?: Maybe<Scalars['String']['output']>;
  CertifyingLettersFileUploadErrorMessage?: Maybe<Scalars['String']['output']>;
  CertifyingLettersFileUploadFailedMessage?: Maybe<Scalars['String']['output']>;
  CertifyingLettersHeading?: Maybe<Scalars['String']['output']>;
  CommissionHeading?: Maybe<Scalars['String']['output']>;
  CommissionRiskErrorMessage?: Maybe<Scalars['String']['output']>;
  CompanyAddedProductionLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EditModalCancelLabel?: Maybe<Scalars['String']['output']>;
  EditModalCommissionDescription?: Maybe<Scalars['String']['output']>;
  EditModalIncomeDescription?: Maybe<Scalars['String']['output']>;
  EditModalPremiumDescription?: Maybe<Scalars['String']['output']>;
  EditModalSaveChangesLabel?: Maybe<Scalars['String']['output']>;
  EditModalSharedLabel?: Maybe<Scalars['String']['output']>;
  EditModalSharedTooltip?: Maybe<Scalars['String']['output']>;
  EditMonetaryProductionModalHeadline?: Maybe<Scalars['String']['output']>;
  EditProductionEntryModalCurrencyLabel?: Maybe<Scalars['String']['output']>;
  EditProductionEntryModalOtherNewBusinessLabel?: Maybe<Scalars['String']['output']>;
  EditProductionEntryModalRiskProtectionLabel?: Maybe<Scalars['String']['output']>;
  GeneralErrorText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncomeOtherNewBusinessErrorMessage?: Maybe<Scalars['String']['output']>;
  IncomeRiskErrorMessage?: Maybe<Scalars['String']['output']>;
  MembershipLevelsBannerCoTNotification?: Maybe<Scalars['String']['output']>;
  MembershipLevelsBannerCollapseLinkLabel?: Maybe<Scalars['String']['output']>;
  MembershipLevelsBannerExplainedLinkLabel?: Maybe<Scalars['String']['output']>;
  MembershipLevelsBannerHeading?: Maybe<Scalars['String']['output']>;
  MembershipLevelsBannerMdrtNotification?: Maybe<Scalars['String']['output']>;
  MembershipLevelsBannerToTNotification?: Maybe<Scalars['String']['output']>;
  MonetaryPolciesModalErrorMessage?: Maybe<Scalars['String']['output']>;
  MonetaryProductionCommissionHeading?: Maybe<Scalars['String']['output']>;
  MonetaryProductionCurrencyLabel?: Maybe<Scalars['String']['output']>;
  MonetaryProductionDescription?: Maybe<Scalars['String']['output']>;
  MonetaryProductionErrorText?: Maybe<Scalars['String']['output']>;
  MonetaryProductionHeading?: Maybe<Scalars['String']['output']>;
  MonetaryProductionIncomeErrorMessage?: Maybe<Scalars['String']['output']>;
  MonetaryProductionIncomeHeading?: Maybe<Scalars['String']['output']>;
  MonetaryProductionModalHeading?: Maybe<Scalars['String']['output']>;
  MonetaryProductionOtherNewBusinessPlaceholder?: Maybe<Scalars['String']['output']>;
  MonetaryProductionPremiumHeading?: Maybe<Scalars['String']['output']>;
  MonetaryProductionRiskProtectionPlaceholder?: Maybe<Scalars['String']['output']>;
  MonetaryProductionSharedLabel?: Maybe<Scalars['String']['output']>;
  MonetaryProductionSharedTooltip?: Maybe<Scalars['String']['output']>;
  MonetaryProductionsTabLabel?: Maybe<Scalars['String']['output']>;
  MonetraryProductionNewBusinessIncomeLabel?: Maybe<Scalars['String']['output']>;
  MonetraryProductionRiskProtectionIncomeLabel?: Maybe<Scalars['String']['output']>;
  MonetraryProductionTotalIncomeReportedLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  OtherNewBusinessColumnLabel?: Maybe<Scalars['String']['output']>;
  OtherNewBusinessPoliciesColumnLabel?: Maybe<Scalars['String']['output']>;
  PoliciesCasesEntryLabel?: Maybe<Scalars['String']['output']>;
  PoliciesCasesError?: Maybe<Scalars['String']['output']>;
  PoliciesCasesModalHeading?: Maybe<Scalars['String']['output']>;
  PremiumHeading?: Maybe<Scalars['String']['output']>;
  PremiumRiskErrorMessage?: Maybe<Scalars['String']['output']>;
  ProductionInLivesDescription?: Maybe<Scalars['String']['output']>;
  ProductionInLivesTabLabel?: Maybe<Scalars['String']['output']>;
  ProductionModalNotice?: Maybe<Scalars['String']['output']>;
  ReasonablenessResponseMessageList?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  RiskProtectionColumnLabel?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesColumnLabel?: Maybe<Scalars['String']['output']>;
  SelfAddedProductionLabel?: Maybe<Scalars['String']['output']>;
  SharedColumnLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TotalColumnLabel?: Maybe<Scalars['String']['output']>;
  TotalCommissionProductionLabel?: Maybe<Scalars['String']['output']>;
  TotalIncomePoliciesCasesLabel?: Maybe<Scalars['String']['output']>;
  TotalPremiumProductionLabel?: Maybe<Scalars['String']['output']>;
  TotalProductionLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalPageProductionStepBlockAddButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockAddPolicesButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockAddPoliciesCasesButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockAttestProductionAddProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockAttestProductionAttestOptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockAttestProductionBackButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockAttestProductionHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockAttestProductionSelectLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockCertifyingLettersButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockCertifyingLettersDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockCertifyingLettersErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockCertifyingLettersFileUploadErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockCertifyingLettersFileUploadFailedMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockCertifyingLettersHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockCommissionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockCommissionRiskErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockCompanyAddedProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockEditModalCancelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockEditModalCommissionDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockEditModalIncomeDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockEditModalPremiumDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockEditModalSaveChangesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockEditModalSharedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockEditModalSharedTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockEditMonetaryProductionModalHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockEditProductionEntryModalCurrencyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockEditProductionEntryModalOtherNewBusinessLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockEditProductionEntryModalRiskProtectionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockGeneralErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockIncomeOtherNewBusinessErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockIncomeRiskErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMembershipLevelsBannerCoTNotificationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMembershipLevelsBannerCollapseLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMembershipLevelsBannerExplainedLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMembershipLevelsBannerHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMembershipLevelsBannerMdrtNotificationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMembershipLevelsBannerToTNotificationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryPolciesModalErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionCommissionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionCurrencyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionIncomeErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionIncomeHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionModalHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionOtherNewBusinessPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionPremiumHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionRiskProtectionPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionSharedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionSharedTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetaryProductionsTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetraryProductionNewBusinessIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetraryProductionRiskProtectionIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockMonetraryProductionTotalIncomeReportedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockOtherNewBusinessColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockOtherNewBusinessPoliciesColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockPoliciesCasesEntryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockPoliciesCasesErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockPoliciesCasesModalHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockPremiumHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockPremiumRiskErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockProductionInLivesDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockProductionInLivesTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockProductionModalNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockReasonablenessResponseMessageListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockRiskProtectionColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockRiskProtectionPoliciesColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockSelfAddedProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockSharedColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockTotalColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockTotalCommissionProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockTotalIncomePoliciesCasesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockTotalPremiumProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProductionStepBlockTotalProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageProductionStepBlockFacet = {
  __typename?: 'MembershipRenewalPageProductionStepBlockFacet';
  AddButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddPolicesButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddPoliciesCasesButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionAddProduction?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionAttestOption?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionBackButton?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionSelectLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersDescription?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersFileUploadErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersFileUploadFailedMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersHeading?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionRiskErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyAddedProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalCancelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalCommissionDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalIncomeDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalPremiumDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalSaveChangesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalSharedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalSharedTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  EditMonetaryProductionModalHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  EditProductionEntryModalCurrencyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditProductionEntryModalOtherNewBusinessLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditProductionEntryModalRiskProtectionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GeneralErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeOtherNewBusinessErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeRiskErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsBannerCoTNotification?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsBannerCollapseLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsBannerExplainedLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsBannerHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsBannerMdrtNotification?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsBannerToTNotification?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryPolciesModalErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionCommissionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionCurrencyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionIncomeErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionIncomeHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionModalHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionOtherNewBusinessPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionPremiumHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionRiskProtectionPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionSharedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionSharedTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionsTabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MonetraryProductionNewBusinessIncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MonetraryProductionRiskProtectionIncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MonetraryProductionTotalIncomeReportedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherNewBusinessColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherNewBusinessPoliciesColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PoliciesCasesEntryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PoliciesCasesError?: Maybe<Array<Maybe<StringFacet>>>;
  PoliciesCasesModalHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumRiskErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionInLivesDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionInLivesTabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionModalNotice?: Maybe<Array<Maybe<StringFacet>>>;
  ReasonablenessResponseMessageList?: Maybe<ContentAreaItemModelSearchFacet>;
  RiskProtectionColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAddedProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SharedColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TotalColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalCommissionProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalIncomePoliciesCasesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalPremiumProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalPageProductionStepBlockFacetAddButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetAddPolicesButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetAddPoliciesCasesButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetAttestProductionAddProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetAttestProductionAttestOptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetAttestProductionBackButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetAttestProductionHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetAttestProductionSelectLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetCertifyingLettersButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetCertifyingLettersDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetCertifyingLettersErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetCertifyingLettersFileUploadErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetCertifyingLettersFileUploadFailedMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetCertifyingLettersHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetCommissionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetCommissionRiskErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetCompanyAddedProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetEditModalCancelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetEditModalCommissionDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetEditModalIncomeDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetEditModalPremiumDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetEditModalSaveChangesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetEditModalSharedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetEditModalSharedTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetEditMonetaryProductionModalHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetEditProductionEntryModalCurrencyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetEditProductionEntryModalOtherNewBusinessLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetEditProductionEntryModalRiskProtectionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetGeneralErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetIncomeOtherNewBusinessErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetIncomeRiskErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMembershipLevelsBannerCoTNotificationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMembershipLevelsBannerCollapseLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMembershipLevelsBannerExplainedLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMembershipLevelsBannerHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMembershipLevelsBannerMdrtNotificationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMembershipLevelsBannerToTNotificationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryPolciesModalErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionCommissionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionCurrencyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionIncomeErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionIncomeHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionModalHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionOtherNewBusinessPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionPremiumHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionRiskProtectionPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionSharedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionSharedTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetaryProductionsTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetraryProductionNewBusinessIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetraryProductionRiskProtectionIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetMonetraryProductionTotalIncomeReportedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetOtherNewBusinessColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetOtherNewBusinessPoliciesColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetPoliciesCasesEntryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetPoliciesCasesErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetPoliciesCasesModalHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetPremiumHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetPremiumRiskErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetProductionInLivesDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetProductionInLivesTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetProductionModalNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetRiskProtectionColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetRiskProtectionPoliciesColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetSelfAddedProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetSharedColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetTotalColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetTotalCommissionProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetTotalIncomePoliciesCasesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetTotalPremiumProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProductionStepBlockFacetTotalProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageProductionStepBlockOrderByInput = {
  AddButtonLabel?: InputMaybe<OrderBy>;
  AddPolicesButtonLabel?: InputMaybe<OrderBy>;
  AddPoliciesCasesButtonLabel?: InputMaybe<OrderBy>;
  AttestProductionAddProduction?: InputMaybe<OrderBy>;
  AttestProductionAttestOption?: InputMaybe<OrderBy>;
  AttestProductionBackButton?: InputMaybe<OrderBy>;
  AttestProductionHeadline?: InputMaybe<OrderBy>;
  AttestProductionSelectLabel?: InputMaybe<OrderBy>;
  CertifyingLettersButtonLabel?: InputMaybe<OrderBy>;
  CertifyingLettersDescription?: InputMaybe<OrderBy>;
  CertifyingLettersErrorText?: InputMaybe<OrderBy>;
  CertifyingLettersFileUploadErrorMessage?: InputMaybe<OrderBy>;
  CertifyingLettersFileUploadFailedMessage?: InputMaybe<OrderBy>;
  CertifyingLettersHeading?: InputMaybe<OrderBy>;
  CommissionHeading?: InputMaybe<OrderBy>;
  CommissionRiskErrorMessage?: InputMaybe<OrderBy>;
  CompanyAddedProductionLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EditModalCancelLabel?: InputMaybe<OrderBy>;
  EditModalCommissionDescription?: InputMaybe<OrderBy>;
  EditModalIncomeDescription?: InputMaybe<OrderBy>;
  EditModalPremiumDescription?: InputMaybe<OrderBy>;
  EditModalSaveChangesLabel?: InputMaybe<OrderBy>;
  EditModalSharedLabel?: InputMaybe<OrderBy>;
  EditModalSharedTooltip?: InputMaybe<OrderBy>;
  EditMonetaryProductionModalHeadline?: InputMaybe<OrderBy>;
  EditProductionEntryModalCurrencyLabel?: InputMaybe<OrderBy>;
  EditProductionEntryModalOtherNewBusinessLabel?: InputMaybe<OrderBy>;
  EditProductionEntryModalRiskProtectionLabel?: InputMaybe<OrderBy>;
  GeneralErrorText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IncomeOtherNewBusinessErrorMessage?: InputMaybe<OrderBy>;
  IncomeRiskErrorMessage?: InputMaybe<OrderBy>;
  MembershipLevelsBannerCoTNotification?: InputMaybe<OrderBy>;
  MembershipLevelsBannerCollapseLinkLabel?: InputMaybe<OrderBy>;
  MembershipLevelsBannerExplainedLinkLabel?: InputMaybe<OrderBy>;
  MembershipLevelsBannerHeading?: InputMaybe<OrderBy>;
  MembershipLevelsBannerMdrtNotification?: InputMaybe<OrderBy>;
  MembershipLevelsBannerToTNotification?: InputMaybe<OrderBy>;
  MonetaryPolciesModalErrorMessage?: InputMaybe<OrderBy>;
  MonetaryProductionCommissionHeading?: InputMaybe<OrderBy>;
  MonetaryProductionCurrencyLabel?: InputMaybe<OrderBy>;
  MonetaryProductionDescription?: InputMaybe<OrderBy>;
  MonetaryProductionErrorText?: InputMaybe<OrderBy>;
  MonetaryProductionHeading?: InputMaybe<OrderBy>;
  MonetaryProductionIncomeErrorMessage?: InputMaybe<OrderBy>;
  MonetaryProductionIncomeHeading?: InputMaybe<OrderBy>;
  MonetaryProductionModalHeading?: InputMaybe<OrderBy>;
  MonetaryProductionOtherNewBusinessPlaceholder?: InputMaybe<OrderBy>;
  MonetaryProductionPremiumHeading?: InputMaybe<OrderBy>;
  MonetaryProductionRiskProtectionPlaceholder?: InputMaybe<OrderBy>;
  MonetaryProductionSharedLabel?: InputMaybe<OrderBy>;
  MonetaryProductionSharedTooltip?: InputMaybe<OrderBy>;
  MonetaryProductionsTabLabel?: InputMaybe<OrderBy>;
  MonetraryProductionNewBusinessIncomeLabel?: InputMaybe<OrderBy>;
  MonetraryProductionRiskProtectionIncomeLabel?: InputMaybe<OrderBy>;
  MonetraryProductionTotalIncomeReportedLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  OtherNewBusinessColumnLabel?: InputMaybe<OrderBy>;
  OtherNewBusinessPoliciesColumnLabel?: InputMaybe<OrderBy>;
  PoliciesCasesEntryLabel?: InputMaybe<OrderBy>;
  PoliciesCasesError?: InputMaybe<OrderBy>;
  PoliciesCasesModalHeading?: InputMaybe<OrderBy>;
  PremiumHeading?: InputMaybe<OrderBy>;
  PremiumRiskErrorMessage?: InputMaybe<OrderBy>;
  ProductionInLivesDescription?: InputMaybe<OrderBy>;
  ProductionInLivesTabLabel?: InputMaybe<OrderBy>;
  ProductionModalNotice?: InputMaybe<OrderBy>;
  ReasonablenessResponseMessageList?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RiskProtectionColumnLabel?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesColumnLabel?: InputMaybe<OrderBy>;
  SelfAddedProductionLabel?: InputMaybe<OrderBy>;
  SharedColumnLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TotalColumnLabel?: InputMaybe<OrderBy>;
  TotalCommissionProductionLabel?: InputMaybe<OrderBy>;
  TotalIncomePoliciesCasesLabel?: InputMaybe<OrderBy>;
  TotalPremiumProductionLabel?: InputMaybe<OrderBy>;
  TotalProductionLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageProductionStepBlockWhereInput = {
  AddButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  AddPolicesButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  AddPoliciesCasesButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  AttestProductionAddProduction?: InputMaybe<SearchableStringFilterInput>;
  AttestProductionAttestOption?: InputMaybe<SearchableStringFilterInput>;
  AttestProductionBackButton?: InputMaybe<SearchableStringFilterInput>;
  AttestProductionHeadline?: InputMaybe<SearchableStringFilterInput>;
  AttestProductionSelectLabel?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersDescription?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersErrorText?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersFileUploadErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersFileUploadFailedMessage?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersHeading?: InputMaybe<SearchableStringFilterInput>;
  CommissionHeading?: InputMaybe<SearchableStringFilterInput>;
  CommissionRiskErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  CompanyAddedProductionLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EditModalCancelLabel?: InputMaybe<SearchableStringFilterInput>;
  EditModalCommissionDescription?: InputMaybe<SearchableStringFilterInput>;
  EditModalIncomeDescription?: InputMaybe<SearchableStringFilterInput>;
  EditModalPremiumDescription?: InputMaybe<SearchableStringFilterInput>;
  EditModalSaveChangesLabel?: InputMaybe<SearchableStringFilterInput>;
  EditModalSharedLabel?: InputMaybe<SearchableStringFilterInput>;
  EditModalSharedTooltip?: InputMaybe<SearchableStringFilterInput>;
  EditMonetaryProductionModalHeadline?: InputMaybe<SearchableStringFilterInput>;
  EditProductionEntryModalCurrencyLabel?: InputMaybe<SearchableStringFilterInput>;
  EditProductionEntryModalOtherNewBusinessLabel?: InputMaybe<SearchableStringFilterInput>;
  EditProductionEntryModalRiskProtectionLabel?: InputMaybe<SearchableStringFilterInput>;
  GeneralErrorText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncomeOtherNewBusinessErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  IncomeRiskErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsBannerCoTNotification?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsBannerCollapseLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsBannerExplainedLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsBannerHeading?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsBannerMdrtNotification?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsBannerToTNotification?: InputMaybe<SearchableStringFilterInput>;
  MonetaryPolciesModalErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionCommissionHeading?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionCurrencyLabel?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionDescription?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionErrorText?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionHeading?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionIncomeErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionIncomeHeading?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionModalHeading?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionOtherNewBusinessPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionPremiumHeading?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionRiskProtectionPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionSharedLabel?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionSharedTooltip?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionsTabLabel?: InputMaybe<SearchableStringFilterInput>;
  MonetraryProductionNewBusinessIncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  MonetraryProductionRiskProtectionIncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  MonetraryProductionTotalIncomeReportedLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherNewBusinessColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherNewBusinessPoliciesColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  PoliciesCasesEntryLabel?: InputMaybe<SearchableStringFilterInput>;
  PoliciesCasesError?: InputMaybe<SearchableStringFilterInput>;
  PoliciesCasesModalHeading?: InputMaybe<SearchableStringFilterInput>;
  PremiumHeading?: InputMaybe<SearchableStringFilterInput>;
  PremiumRiskErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  ProductionInLivesDescription?: InputMaybe<SearchableStringFilterInput>;
  ProductionInLivesTabLabel?: InputMaybe<SearchableStringFilterInput>;
  ProductionModalNotice?: InputMaybe<SearchableStringFilterInput>;
  ReasonablenessResponseMessageList?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RiskProtectionColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  SelfAddedProductionLabel?: InputMaybe<SearchableStringFilterInput>;
  SharedColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TotalColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalCommissionProductionLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalIncomePoliciesCasesLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalPremiumProductionLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalProductionLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalPageProfileStepBlock = {
  __typename?: 'MembershipRenewalPageProfileStepBlock';
  AddLocalAddressHelperText?: Maybe<Scalars['String']['output']>;
  AddLocalAddressLabel?: Maybe<Scalars['String']['output']>;
  AddressLine1FormatLabel?: Maybe<Scalars['String']['output']>;
  AddressLine1Label?: Maybe<Scalars['String']['output']>;
  AddressLine2Label?: Maybe<Scalars['String']['output']>;
  AddressLine3Label?: Maybe<Scalars['String']['output']>;
  CityLabel?: Maybe<Scalars['String']['output']>;
  CompanyAffiliationLabel?: Maybe<Scalars['String']['output']>;
  ContactInfoLabel?: Maybe<Scalars['String']['output']>;
  CountryLabel?: Maybe<Scalars['String']['output']>;
  DateOfBirthFormatLabel?: Maybe<Scalars['String']['output']>;
  DateOfBirthLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EmailDirectoryPermissionText?: Maybe<Scalars['String']['output']>;
  GenderLabel?: Maybe<Scalars['String']['output']>;
  GeneralErrorText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsoCodeLabel?: Maybe<Scalars['String']['output']>;
  LocalAddressHeadingText?: Maybe<Scalars['String']['output']>;
  MailingAddressLabel?: Maybe<Scalars['String']['output']>;
  MemberDirectoryPermissionText?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  PersonalInfoLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberFormatLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PhoneTypeLabel?: Maybe<Scalars['String']['output']>;
  PrimaryLanguageLabel?: Maybe<Scalars['String']['output']>;
  ProfessionalInfoLabel?: Maybe<Scalars['String']['output']>;
  ProfileNavHeadingText?: Maybe<Scalars['String']['output']>;
  RemoveLocalAddressHelperText?: Maybe<Scalars['String']['output']>;
  SmsPermissionText?: Maybe<Scalars['String']['output']>;
  StateLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  ZipCodeLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalPageProfileStepBlockAddLocalAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockAddLocalAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockAddressLine1FormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockAddressLine1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockAddressLine2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockAddressLine3LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockCityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockCompanyAffiliationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockContactInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockDateOfBirthFormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockDateOfBirthLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockEmailDirectoryPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockGenderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockGeneralErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockIsoCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockLocalAddressHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockMailingAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockMemberDirectoryPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockPersonalInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockPhoneNumberFormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockPhoneTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockPrimaryLanguageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockProfessionalInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockProfileNavHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockRemoveLocalAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockSmsPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockStateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageProfileStepBlockZipCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageProfileStepBlockFacet = {
  __typename?: 'MembershipRenewalPageProfileStepBlockFacet';
  AddLocalAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  AddLocalAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1FormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine2Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine3Label?: Maybe<Array<Maybe<StringFacet>>>;
  CityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyAffiliationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContactInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DateOfBirthFormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DateOfBirthLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EmailDirectoryPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  GenderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GeneralErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsoCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LocalAddressHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDirectoryPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberFormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryLanguageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileNavHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveLocalAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  SmsPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  StateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  ZipCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalPageProfileStepBlockFacetAddLocalAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetAddLocalAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetAddressLine1FormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetAddressLine1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetAddressLine2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetAddressLine3LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetCityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetCompanyAffiliationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetContactInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetDateOfBirthFormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetDateOfBirthLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetEmailDirectoryPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetGenderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetGeneralErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetIsoCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetLocalAddressHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetMailingAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetMemberDirectoryPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetPersonalInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetPhoneNumberFormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetPhoneTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetPrimaryLanguageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetProfessionalInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetProfileNavHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetRemoveLocalAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetSmsPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetStateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageProfileStepBlockFacetZipCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageProfileStepBlockOrderByInput = {
  AddLocalAddressHelperText?: InputMaybe<OrderBy>;
  AddLocalAddressLabel?: InputMaybe<OrderBy>;
  AddressLine1FormatLabel?: InputMaybe<OrderBy>;
  AddressLine1Label?: InputMaybe<OrderBy>;
  AddressLine2Label?: InputMaybe<OrderBy>;
  AddressLine3Label?: InputMaybe<OrderBy>;
  CityLabel?: InputMaybe<OrderBy>;
  CompanyAffiliationLabel?: InputMaybe<OrderBy>;
  ContactInfoLabel?: InputMaybe<OrderBy>;
  CountryLabel?: InputMaybe<OrderBy>;
  DateOfBirthFormatLabel?: InputMaybe<OrderBy>;
  DateOfBirthLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EmailDirectoryPermissionText?: InputMaybe<OrderBy>;
  GenderLabel?: InputMaybe<OrderBy>;
  GeneralErrorText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsoCodeLabel?: InputMaybe<OrderBy>;
  LocalAddressHeadingText?: InputMaybe<OrderBy>;
  MailingAddressLabel?: InputMaybe<OrderBy>;
  MemberDirectoryPermissionText?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  PersonalInfoLabel?: InputMaybe<OrderBy>;
  PhoneNumberFormatLabel?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PhoneTypeLabel?: InputMaybe<OrderBy>;
  PrimaryLanguageLabel?: InputMaybe<OrderBy>;
  ProfessionalInfoLabel?: InputMaybe<OrderBy>;
  ProfileNavHeadingText?: InputMaybe<OrderBy>;
  RemoveLocalAddressHelperText?: InputMaybe<OrderBy>;
  SmsPermissionText?: InputMaybe<OrderBy>;
  StateLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  ZipCodeLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageProfileStepBlockWhereInput = {
  AddLocalAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  AddLocalAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1FormatLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine2Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine3Label?: InputMaybe<SearchableStringFilterInput>;
  CityLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyAffiliationLabel?: InputMaybe<SearchableStringFilterInput>;
  ContactInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  CountryLabel?: InputMaybe<SearchableStringFilterInput>;
  DateOfBirthFormatLabel?: InputMaybe<SearchableStringFilterInput>;
  DateOfBirthLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EmailDirectoryPermissionText?: InputMaybe<SearchableStringFilterInput>;
  GenderLabel?: InputMaybe<SearchableStringFilterInput>;
  GeneralErrorText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsoCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  LocalAddressHeadingText?: InputMaybe<SearchableStringFilterInput>;
  MailingAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  MemberDirectoryPermissionText?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PersonalInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberFormatLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  PrimaryLanguageLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfileNavHeadingText?: InputMaybe<SearchableStringFilterInput>;
  RemoveLocalAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  SmsPermissionText?: InputMaybe<SearchableStringFilterInput>;
  StateLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  ZipCodeLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalPageReceiptStepBlock = {
  __typename?: 'MembershipRenewalPageReceiptStepBlock';
  AdditionalMembershipOptionLabel?: Maybe<Scalars['String']['output']>;
  ApplicationDetailsHeading?: Maybe<Scalars['String']['output']>;
  AttestToProductionLabel?: Maybe<Scalars['String']['output']>;
  BackduesLabel?: Maybe<Scalars['String']['output']>;
  CardNumberLabel?: Maybe<Scalars['String']['output']>;
  CoTMembershipLabel?: Maybe<Scalars['String']['output']>;
  CompanyNameLabel?: Maybe<Scalars['String']['output']>;
  CompanyPrepaymentLabel?: Maybe<Scalars['String']['output']>;
  CostBreakdownLabel?: Maybe<Scalars['String']['output']>;
  DisabilityRequirementLabel?: Maybe<Scalars['String']['output']>;
  EthicsComplaintLabel?: Maybe<Scalars['String']['output']>;
  GoBackButtonLabel?: Maybe<Scalars['String']['output']>;
  IndividualPrepaymentLabel?: Maybe<Scalars['String']['output']>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  MdrtMembershipLabel?: Maybe<Scalars['String']['output']>;
  MemberDetailsHeading?: Maybe<Scalars['String']['output']>;
  MemberNameLabel?: Maybe<Scalars['String']['output']>;
  MembershipOptionsLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  OrderNumberLabel?: Maybe<Scalars['String']['output']>;
  PaymentDateLabel?: Maybe<Scalars['String']['output']>;
  PaymentDetailsLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PrintButtonLabel?: Maybe<Scalars['String']['output']>;
  ProfessionalAssociationLabel?: Maybe<Scalars['String']['output']>;
  ReceiptAddressText?: Maybe<Scalars['String']['output']>;
  ReceiptFaxLabel?: Maybe<Scalars['String']['output']>;
  ReceiptFaxNumber?: Maybe<Scalars['String']['output']>;
  ReceiptHeading?: Maybe<Scalars['String']['output']>;
  ReceiptPhoneLabel?: Maybe<Scalars['String']['output']>;
  ReceiptPhoneNumber?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsLabel?: Maybe<Scalars['String']['output']>;
  ToTMembershipLabel?: Maybe<Scalars['String']['output']>;
  TotalAmountPaidLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalPageReceiptStepBlockAdditionalMembershipOptionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockApplicationDetailsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockAttestToProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockBackduesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockCardNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockCoTMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockCompanyNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockCompanyPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockCostBreakdownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockDisabilityRequirementLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockEthicsComplaintLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockGoBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockIndividualPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockMdrtMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockMemberDetailsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockMemberNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockMembershipOptionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockOrderNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockPaymentDateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockPaymentDetailsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockPrintButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockProfessionalAssociationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockReceiptAddressTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockReceiptFaxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockReceiptFaxNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockReceiptHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockReceiptPhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockReceiptPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockTermsAndConditionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockToTMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReceiptStepBlockTotalAmountPaidLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageReceiptStepBlockFacet = {
  __typename?: 'MembershipRenewalPageReceiptStepBlockFacet';
  AdditionalMembershipOptionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationDetailsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  AttestToProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CardNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CoTMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CostBreakdownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DisabilityRequirementLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EthicsComplaintLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IndividualPrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDetailsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MemberNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipOptionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OrderNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentDateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentDetailsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrintButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalAssociationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptAddressText?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptFaxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptFaxNumber?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptPhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptPhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ToTMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAmountPaidLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalPageReceiptStepBlockFacetAdditionalMembershipOptionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetApplicationDetailsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetAttestToProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetBackduesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetCardNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetCoTMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetCompanyNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetCompanyPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetCostBreakdownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetDisabilityRequirementLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetEthicsComplaintLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetGoBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetIndividualPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetMdrtMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetMemberDetailsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetMemberNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetMembershipOptionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetOrderNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetPaymentDateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetPaymentDetailsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetPrintButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetProfessionalAssociationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetReceiptAddressTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetReceiptFaxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetReceiptFaxNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetReceiptHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetReceiptPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetReceiptPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetTermsAndConditionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetToTMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReceiptStepBlockFacetTotalAmountPaidLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageReceiptStepBlockOrderByInput = {
  AdditionalMembershipOptionLabel?: InputMaybe<OrderBy>;
  ApplicationDetailsHeading?: InputMaybe<OrderBy>;
  AttestToProductionLabel?: InputMaybe<OrderBy>;
  BackduesLabel?: InputMaybe<OrderBy>;
  CardNumberLabel?: InputMaybe<OrderBy>;
  CoTMembershipLabel?: InputMaybe<OrderBy>;
  CompanyNameLabel?: InputMaybe<OrderBy>;
  CompanyPrepaymentLabel?: InputMaybe<OrderBy>;
  CostBreakdownLabel?: InputMaybe<OrderBy>;
  DisabilityRequirementLabel?: InputMaybe<OrderBy>;
  EthicsComplaintLabel?: InputMaybe<OrderBy>;
  GoBackButtonLabel?: InputMaybe<OrderBy>;
  IndividualPrepaymentLabel?: InputMaybe<OrderBy>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  MdrtMembershipLabel?: InputMaybe<OrderBy>;
  MemberDetailsHeading?: InputMaybe<OrderBy>;
  MemberNameLabel?: InputMaybe<OrderBy>;
  MembershipOptionsLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  OrderNumberLabel?: InputMaybe<OrderBy>;
  PaymentDateLabel?: InputMaybe<OrderBy>;
  PaymentDetailsLabel?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PrintButtonLabel?: InputMaybe<OrderBy>;
  ProfessionalAssociationLabel?: InputMaybe<OrderBy>;
  ReceiptAddressText?: InputMaybe<OrderBy>;
  ReceiptFaxLabel?: InputMaybe<OrderBy>;
  ReceiptFaxNumber?: InputMaybe<OrderBy>;
  ReceiptHeading?: InputMaybe<OrderBy>;
  ReceiptPhoneLabel?: InputMaybe<OrderBy>;
  ReceiptPhoneNumber?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TermsAndConditionsLabel?: InputMaybe<OrderBy>;
  ToTMembershipLabel?: InputMaybe<OrderBy>;
  TotalAmountPaidLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageReceiptStepBlockWhereInput = {
  AdditionalMembershipOptionLabel?: InputMaybe<SearchableStringFilterInput>;
  ApplicationDetailsHeading?: InputMaybe<SearchableStringFilterInput>;
  AttestToProductionLabel?: InputMaybe<SearchableStringFilterInput>;
  BackduesLabel?: InputMaybe<SearchableStringFilterInput>;
  CardNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  CoTMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyNameLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyPrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  CostBreakdownLabel?: InputMaybe<SearchableStringFilterInput>;
  DisabilityRequirementLabel?: InputMaybe<SearchableStringFilterInput>;
  EthicsComplaintLabel?: InputMaybe<SearchableStringFilterInput>;
  GoBackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  IndividualPrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  MemberDetailsHeading?: InputMaybe<SearchableStringFilterInput>;
  MemberNameLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipOptionsLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  OrderNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentDateLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentDetailsLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PrintButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalAssociationLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptAddressText?: InputMaybe<SearchableStringFilterInput>;
  ReceiptFaxLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptFaxNumber?: InputMaybe<SearchableStringFilterInput>;
  ReceiptHeading?: InputMaybe<SearchableStringFilterInput>;
  ReceiptPhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsLabel?: InputMaybe<SearchableStringFilterInput>;
  ToTMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAmountPaidLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalPageReviewStepBlock = {
  __typename?: 'MembershipRenewalPageReviewStepBlock';
  AliPaySubmitMessage?: Maybe<Scalars['String']['output']>;
  ApplicationSubmittedWaitingMessage?: Maybe<Scalars['String']['output']>;
  ApplicationSubmittedWaitingMessageText?: Maybe<Scalars['String']['output']>;
  BackDuesLabel?: Maybe<Scalars['String']['output']>;
  ChangeMembershipLevelModalHeadline?: Maybe<Scalars['String']['output']>;
  CoTMembershipLabel?: Maybe<Scalars['String']['output']>;
  CommissionLivesLabel?: Maybe<Scalars['String']['output']>;
  CommissionTotalLabel?: Maybe<Scalars['String']['output']>;
  CreateOrderErrorMessage?: Maybe<Scalars['String']['output']>;
  CvcDeclinedErrorMessage?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DisabilityApprovedLabel?: Maybe<Scalars['String']['output']>;
  DisabilityLabel?: Maybe<Scalars['String']['output']>;
  EditMembershipLevelModalHeadline?: Maybe<Scalars['String']['output']>;
  EthicalRequirementsLabel?: Maybe<Scalars['String']['output']>;
  ExpiredCardErrorMessage?: Maybe<Scalars['String']['output']>;
  FiftyYearMembershipLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncomeLivesLabel?: Maybe<Scalars['String']['output']>;
  IncomeTotalLabel?: Maybe<Scalars['String']['output']>;
  IndividualPrePaymentLabel?: Maybe<Scalars['String']['output']>;
  InvalidCardNumberErrorMessage?: Maybe<Scalars['String']['output']>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  LifeAttestLabel?: Maybe<Scalars['String']['output']>;
  MdrtMembershipLabel?: Maybe<Scalars['String']['output']>;
  MembershipLevelLabel?: Maybe<Scalars['String']['output']>;
  MembershipLevelLinkText?: Maybe<Scalars['String']['output']>;
  MembershipLineItemLabel?: Maybe<Scalars['String']['output']>;
  MembershipTypeLabel?: Maybe<Scalars['String']['output']>;
  MetLifeSponsorshipLineItemLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  PastPresidentLabel?: Maybe<Scalars['String']['output']>;
  PaymentError?: Maybe<Scalars['String']['output']>;
  PaymentPending?: Maybe<Scalars['String']['output']>;
  PaymentRetry?: Maybe<Scalars['String']['output']>;
  PaymentSuccess?: Maybe<Scalars['String']['output']>;
  PremiumLivesLabel?: Maybe<Scalars['String']['output']>;
  PremiumTotalLabel?: Maybe<Scalars['String']['output']>;
  PriceBreakdownLabel?: Maybe<Scalars['String']['output']>;
  ProfessionalAssociationLabel?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeAttestLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TaxesLineItemLabel?: Maybe<Scalars['String']['output']>;
  TermsAndAgreementsText?: Maybe<Scalars['String']['output']>;
  ToTMembershipLabel?: Maybe<Scalars['String']['output']>;
  ToTReviewDescription?: Maybe<Scalars['String']['output']>;
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalPageReviewStepBlockAliPaySubmitMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockApplicationSubmittedWaitingMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockBackDuesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockChangeMembershipLevelModalHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockCoTMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockCommissionLivesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockCommissionTotalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockCreateOrderErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockCvcDeclinedErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockDisabilityApprovedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockDisabilityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockEditMembershipLevelModalHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockEthicalRequirementsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockExpiredCardErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockFiftyYearMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockIncomeLivesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockIncomeTotalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockIndividualPrePaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockInvalidCardNumberErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockLifeAttestLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockMdrtMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockMembershipLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockMembershipLevelLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockMembershipLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockMembershipTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockMetLifeSponsorshipLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockPastPresidentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockPaymentErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockPaymentPendingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockPaymentRetryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockPaymentSuccessArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockPremiumLivesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockPremiumTotalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockPriceBreakdownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockProfessionalAssociationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockQualifyingAndLifeAttestLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockTaxesLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockTermsAndAgreementsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockToTMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockToTReviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageReviewStepBlockTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageReviewStepBlockAutocomplete = {
  __typename?: 'MembershipRenewalPageReviewStepBlockAutocomplete';
  ApplicationSubmittedWaitingMessage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRenewalPageReviewStepBlockAutocompleteApplicationSubmittedWaitingMessageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRenewalPageReviewStepBlockFacet = {
  __typename?: 'MembershipRenewalPageReviewStepBlockFacet';
  AliPaySubmitMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationSubmittedWaitingMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationSubmittedWaitingMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  BackDuesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ChangeMembershipLevelModalHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  CoTMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionLivesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionTotalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CreateOrderErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CvcDeclinedErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisabilityApprovedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DisabilityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditMembershipLevelModalHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalRequirementsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExpiredCardErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  FiftyYearMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeLivesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeTotalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IndividualPrePaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  InvalidCardNumberErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifeAttestLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MetLifeSponsorshipLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PastPresidentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentPending?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentRetry?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentSuccess?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumLivesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumTotalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PriceBreakdownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalAssociationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeAttestLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TaxesLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndAgreementsText?: Maybe<Array<Maybe<StringFacet>>>;
  ToTMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ToTReviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalPageReviewStepBlockFacetAliPaySubmitMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetApplicationSubmittedWaitingMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetApplicationSubmittedWaitingMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetBackDuesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetChangeMembershipLevelModalHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetCoTMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetCommissionLivesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetCommissionTotalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetCreateOrderErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetCvcDeclinedErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetDisabilityApprovedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetDisabilityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetEditMembershipLevelModalHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetEthicalRequirementsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetExpiredCardErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetFiftyYearMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetIncomeLivesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetIncomeTotalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetIndividualPrePaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetInvalidCardNumberErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetLifeAttestLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetMdrtMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetMembershipLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetMembershipLevelLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetMembershipLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetMembershipTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetMetLifeSponsorshipLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetPastPresidentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetPaymentErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetPaymentPendingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetPaymentRetryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetPaymentSuccessArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetPremiumLivesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetPremiumTotalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetPriceBreakdownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetProfessionalAssociationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetQualifyingAndLifeAttestLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetTaxesLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetTermsAndAgreementsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetToTMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetToTReviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageReviewStepBlockFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageReviewStepBlockOrderByInput = {
  AliPaySubmitMessage?: InputMaybe<OrderBy>;
  ApplicationSubmittedWaitingMessage?: InputMaybe<OrderBy>;
  ApplicationSubmittedWaitingMessageText?: InputMaybe<OrderBy>;
  BackDuesLabel?: InputMaybe<OrderBy>;
  ChangeMembershipLevelModalHeadline?: InputMaybe<OrderBy>;
  CoTMembershipLabel?: InputMaybe<OrderBy>;
  CommissionLivesLabel?: InputMaybe<OrderBy>;
  CommissionTotalLabel?: InputMaybe<OrderBy>;
  CreateOrderErrorMessage?: InputMaybe<OrderBy>;
  CvcDeclinedErrorMessage?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisabilityApprovedLabel?: InputMaybe<OrderBy>;
  DisabilityLabel?: InputMaybe<OrderBy>;
  EditMembershipLevelModalHeadline?: InputMaybe<OrderBy>;
  EthicalRequirementsLabel?: InputMaybe<OrderBy>;
  ExpiredCardErrorMessage?: InputMaybe<OrderBy>;
  FiftyYearMembershipLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IncomeLivesLabel?: InputMaybe<OrderBy>;
  IncomeTotalLabel?: InputMaybe<OrderBy>;
  IndividualPrePaymentLabel?: InputMaybe<OrderBy>;
  InvalidCardNumberErrorMessage?: InputMaybe<OrderBy>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  LifeAttestLabel?: InputMaybe<OrderBy>;
  MdrtMembershipLabel?: InputMaybe<OrderBy>;
  MembershipLevelLabel?: InputMaybe<OrderBy>;
  MembershipLevelLinkText?: InputMaybe<OrderBy>;
  MembershipLineItemLabel?: InputMaybe<OrderBy>;
  MembershipTypeLabel?: InputMaybe<OrderBy>;
  MetLifeSponsorshipLineItemLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  PastPresidentLabel?: InputMaybe<OrderBy>;
  PaymentError?: InputMaybe<OrderBy>;
  PaymentPending?: InputMaybe<OrderBy>;
  PaymentRetry?: InputMaybe<OrderBy>;
  PaymentSuccess?: InputMaybe<OrderBy>;
  PremiumLivesLabel?: InputMaybe<OrderBy>;
  PremiumTotalLabel?: InputMaybe<OrderBy>;
  PriceBreakdownLabel?: InputMaybe<OrderBy>;
  ProfessionalAssociationLabel?: InputMaybe<OrderBy>;
  QualifyingAndLifeAttestLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TaxesLineItemLabel?: InputMaybe<OrderBy>;
  TermsAndAgreementsText?: InputMaybe<OrderBy>;
  ToTMembershipLabel?: InputMaybe<OrderBy>;
  ToTReviewDescription?: InputMaybe<OrderBy>;
  TotalDueLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageReviewStepBlockWhereInput = {
  AliPaySubmitMessage?: InputMaybe<SearchableStringFilterInput>;
  ApplicationSubmittedWaitingMessage?: InputMaybe<StringFilterInput>;
  ApplicationSubmittedWaitingMessageText?: InputMaybe<SearchableStringFilterInput>;
  BackDuesLabel?: InputMaybe<SearchableStringFilterInput>;
  ChangeMembershipLevelModalHeadline?: InputMaybe<SearchableStringFilterInput>;
  CoTMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  CommissionLivesLabel?: InputMaybe<SearchableStringFilterInput>;
  CommissionTotalLabel?: InputMaybe<SearchableStringFilterInput>;
  CreateOrderErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  CvcDeclinedErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisabilityApprovedLabel?: InputMaybe<SearchableStringFilterInput>;
  DisabilityLabel?: InputMaybe<SearchableStringFilterInput>;
  EditMembershipLevelModalHeadline?: InputMaybe<SearchableStringFilterInput>;
  EthicalRequirementsLabel?: InputMaybe<SearchableStringFilterInput>;
  ExpiredCardErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  FiftyYearMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncomeLivesLabel?: InputMaybe<SearchableStringFilterInput>;
  IncomeTotalLabel?: InputMaybe<SearchableStringFilterInput>;
  IndividualPrePaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  InvalidCardNumberErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  LifeAttestLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelLinkText?: InputMaybe<SearchableStringFilterInput>;
  MembershipLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  MetLifeSponsorshipLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PastPresidentLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentError?: InputMaybe<SearchableStringFilterInput>;
  PaymentPending?: InputMaybe<SearchableStringFilterInput>;
  PaymentRetry?: InputMaybe<SearchableStringFilterInput>;
  PaymentSuccess?: InputMaybe<SearchableStringFilterInput>;
  PremiumLivesLabel?: InputMaybe<SearchableStringFilterInput>;
  PremiumTotalLabel?: InputMaybe<SearchableStringFilterInput>;
  PriceBreakdownLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalAssociationLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeAttestLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TaxesLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  TermsAndAgreementsText?: InputMaybe<SearchableStringFilterInput>;
  ToTMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  ToTReviewDescription?: InputMaybe<SearchableStringFilterInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalPageRoutingStepBlock = {
  __typename?: 'MembershipRenewalPageRoutingStepBlock';
  CalloutButton?: Maybe<MembershipRenewalPageRoutingStepBlockLinkBlock>;
  CalloutHeading?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  MainSiteButton?: Maybe<MembershipRenewalPageRoutingStepBlockLinkBlock>;
  StepNavigationName?: Maybe<Scalars['String']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
  TileCards?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  TileCardsHeading?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalPageRoutingStepBlockCalloutHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageRoutingStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageRoutingStepBlockStepNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageRoutingStepBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageRoutingStepBlockTileCardsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageRoutingStepBlockTileCardsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageRoutingStepBlockAutocomplete = {
  __typename?: 'MembershipRenewalPageRoutingStepBlockAutocomplete';
  CalloutButton?: Maybe<MembershipRenewalPageRoutingStepBlockLinkBlockAutocomplete>;
  MainSiteButton?: Maybe<MembershipRenewalPageRoutingStepBlockLinkBlockAutocomplete>;
};

export type MembershipRenewalPageRoutingStepBlockFacet = {
  __typename?: 'MembershipRenewalPageRoutingStepBlockFacet';
  CalloutButton?: Maybe<MembershipRenewalPageRoutingStepBlockLinkBlockFacet>;
  CalloutHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  MainSiteButton?: Maybe<MembershipRenewalPageRoutingStepBlockLinkBlockFacet>;
  StepNavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
  TileCards?: Maybe<ContentAreaItemModelSearchFacet>;
  TileCardsHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalPageRoutingStepBlockFacetCalloutHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRenewalPageRoutingStepBlockFacetStepNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockFacetTileCardsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageRoutingStepBlockLinkBlock = {
  __typename?: 'MembershipRenewalPageRoutingStepBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalPageRoutingStepBlockLinkBlockAutocomplete = {
  __typename?: 'MembershipRenewalPageRoutingStepBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRenewalPageRoutingStepBlockLinkBlockFacet = {
  __typename?: 'MembershipRenewalPageRoutingStepBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalPageRoutingStepBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalPageRoutingStepBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageRoutingStepBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalPageRoutingStepBlockOrderByInput = {
  CalloutButton?: InputMaybe<MembershipRenewalPageRoutingStepBlockLinkBlockOrderByInput>;
  CalloutHeading?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  MainSiteButton?: InputMaybe<MembershipRenewalPageRoutingStepBlockLinkBlockOrderByInput>;
  StepNavigationName?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
  TileCards?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  TileCardsHeading?: InputMaybe<OrderBy>;
};

export type MembershipRenewalPageRoutingStepBlockWhereInput = {
  CalloutButton?: InputMaybe<MembershipRenewalPageRoutingStepBlockLinkBlockWhereInput>;
  CalloutHeading?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  MainSiteButton?: InputMaybe<MembershipRenewalPageRoutingStepBlockLinkBlockWhereInput>;
  StepNavigationName?: InputMaybe<SearchableStringFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
  TileCards?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  TileCardsHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalPageWhereInput = {
  AccountLabel?: InputMaybe<SearchableStringFilterInput>;
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationStep?: InputMaybe<MembershipRenewalPageConfirmationStepBlockWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ErrorModalDescription?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalNotAuthorizedButton1Text?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalNotAuthorizedButton2Text?: InputMaybe<SearchableStringFilterInput>;
  ErrorModalNotAuthorizedDescription?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FormHasRequiredErrorsLabel?: InputMaybe<SearchableStringFilterInput>;
  GettingStartedStep?: InputMaybe<MembershipRenewalPageGettingStartedStepBlockWhereInput>;
  GreetingStepBlock?: InputMaybe<MembershipRenewalPageGreetingStepBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeesTooltip?: InputMaybe<SearchableStringFilterInput>;
  LogoutLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipTypeStep?: InputMaybe<MembershipRenewalPageMembershipTypeStepBlockWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<MembershipRenewalPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavHeadingLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ProductionStep?: InputMaybe<MembershipRenewalPageProductionStepBlockWhereInput>;
  ProfileStep?: InputMaybe<MembershipRenewalPageProfileStepBlockWhereInput>;
  QuestionsHeading?: InputMaybe<SearchableStringFilterInput>;
  ReceiptStep?: InputMaybe<MembershipRenewalPageReceiptStepBlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RequiredErrorFieldLabel?: InputMaybe<SearchableStringFilterInput>;
  ReviewStep?: InputMaybe<MembershipRenewalPageReviewStepBlockWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  RoutingStep?: InputMaybe<MembershipRenewalPageRoutingStepBlockWhereInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelectLanguageHeading?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<MembershipRenewalPageImageBlockWhereInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipRenewalPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipRenewalPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipRenewalPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for membership renewal */
export type MembershipRenewalV2Page = IContent & IData & {
  __typename?: 'MembershipRenewalV2Page';
  AccountLabel?: Maybe<Scalars['String']['output']>;
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  CancelUpgradeLabel?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConfirmationModal?: Maybe<MembershipRenewalV2PageConfirmationModalBlock>;
  /** The Membership level step content */
  CongratulationsStep?: Maybe<MembershipRenewalV2PageCongratulationsStepV2Block>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DeleteLabel?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  EditLabel?: Maybe<Scalars['String']['output']>;
  ErrorModal?: Maybe<MembershipRenewalV2PageErrorModalBlock>;
  ErrorPage?: Maybe<MembershipRenewalV2PageErrorPageBlock>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  /** Error message when a user submits a form that has a field with a required error */
  FormHasRequiredErrorsLabel?: Maybe<Scalars['String']['output']>;
  GenericHomeButtonLabel?: Maybe<Scalars['String']['output']>;
  /** The Getting Started step content */
  GettingStartedStep?: Maybe<MembershipRenewalV2PageGettingStartedStepV2Block>;
  /** The Getting Started step content */
  GreetingStep?: Maybe<MembershipRenewalV2PageGreetingStepV2Block>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeesTooltip?: Maybe<Scalars['String']['output']>;
  LoaderScreen?: Maybe<MembershipRenewalV2PageLoaderBlock>;
  /** The label for your total due, shown beneath the steps */
  LogoutLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** The Membership level step content */
  MembershipLevelStep?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2Block>;
  /** The Membership type step content */
  MembershipTypeStep?: Maybe<MembershipRenewalV2PageMembershipTypeStepV2Block>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<MembershipRenewalV2PageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NavHeadingLabel?: Maybe<Scalars['String']['output']>;
  NoLabel?: Maybe<Scalars['String']['output']>;
  NotFoundPage?: Maybe<MembershipRenewalV2PageErrorPageBlock>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentProcessingLoaderText?: Maybe<Scalars['String']['output']>;
  ProcessingScreen?: Maybe<MembershipRenewalV2PagePaymentProcessingScreenBlock>;
  /** The production step content */
  ProductionStep?: Maybe<MembershipRenewalV2PageProductionStepV2Block>;
  /** The Profile step content */
  ProfileStep?: Maybe<MembershipRenewalV2PageProfileStepV2Block>;
  QuestionsHeading?: Maybe<Scalars['String']['output']>;
  /** The Membership level step content */
  ReceiptStep?: Maybe<MembershipRenewalV2PageReceiptStepV2Block>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** Error message when a user doesn't enter a required field */
  RequiredErrorFieldLabel?: Maybe<Scalars['String']['output']>;
  /** The Membership level step content */
  ReviewAndSubmitStep?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2Block>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SelectLanguageHeading?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StepDisplayLabel?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<MembershipRenewalV2PageImageBlock>;
  /** The label for your total due, shown beneath the steps */
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  YesLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageAccountLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageCancelUpgradeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageDeleteLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageEditLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageFormHasRequiredErrorsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageGenericHomeButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageLateFeesTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageLogoutLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageNavHeadingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageNoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PagePaymentProcessingLoaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageQuestionsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageRequiredErrorFieldLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageSelectLanguageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageStepDisplayLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2PageYesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2Page_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for membership renewal */
export type MembershipRenewalV2Page_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipRenewalV2PageAutocomplete = {
  __typename?: 'MembershipRenewalV2PageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MembershipLevelStep?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockAutocomplete>;
  MembershipTypeStep?: Maybe<MembershipRenewalV2PageMembershipTypeStepV2BlockAutocomplete>;
  MetaImage?: Maybe<MembershipRenewalV2PageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<MembershipRenewalV2PageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRenewalV2PageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalV2PageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalV2PageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalV2PageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalV2PageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalV2PageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalV2PageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalV2PageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalV2PageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalV2PageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRenewalV2PageConfirmationModalBlock = {
  __typename?: 'MembershipRenewalV2PageConfirmationModalBlock';
  CloseButtonText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageConfirmationModalBlockCloseButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageConfirmationModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageConfirmationModalBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageConfirmationModalBlockFacet = {
  __typename?: 'MembershipRenewalV2PageConfirmationModalBlockFacet';
  CloseButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageConfirmationModalBlockFacetCloseButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageConfirmationModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageConfirmationModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageConfirmationModalBlockOrderByInput = {
  CloseButtonText?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageConfirmationModalBlockWhereInput = {
  CloseButtonText?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageCongratulationsStepV2Block = {
  __typename?: 'MembershipRenewalV2PageCongratulationsStepV2Block';
  ApplicationHasBeenProcessedMessage?: Maybe<Scalars['String']['output']>;
  ApplicationIsBeingProcessedMessage?: Maybe<Scalars['String']['output']>;
  ApplicationNotProcessedStatusText?: Maybe<Scalars['String']['output']>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  BrowseAllEventsTexts?: Maybe<Scalars['String']['output']>;
  COTLevelLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  GoBackHomeButtonText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  JoinAStudyGroupText?: Maybe<Scalars['String']['output']>;
  LearnAboutMentoringText?: Maybe<Scalars['String']['output']>;
  LinkSectionHeading?: Maybe<Scalars['String']['output']>;
  MDRTLevelLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  PendingStatusText?: Maybe<Scalars['String']['output']>;
  ProcessedStatusText?: Maybe<Scalars['String']['output']>;
  ReceiptText?: Maybe<Scalars['String']['output']>;
  SomethingWentWrongMessage?: Maybe<Scalars['String']['output']>;
  StatusText?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  SyncMessageText?: Maybe<Scalars['String']['output']>;
  TOTLevelLabel?: Maybe<Scalars['String']['output']>;
  TryAgainButtonText?: Maybe<Scalars['String']['output']>;
  UpgradeButtonText?: Maybe<Scalars['String']['output']>;
  UpgradeText?: Maybe<Scalars['String']['output']>;
  ViewReceiptButtonText?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockApplicationHasBeenProcessedMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockApplicationIsBeingProcessedMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockApplicationNotProcessedStatusTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockBrowseAllEventsTextsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockCotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockGoBackHomeButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockJoinAStudyGroupTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockLearnAboutMentoringTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockLinkSectionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockMdrtLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockPendingStatusTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockProcessedStatusTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockReceiptTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockSomethingWentWrongMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockStatusTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockSyncMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockTotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockTryAgainButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockUpgradeButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockUpgradeTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockViewReceiptButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageCongratulationsStepV2BlockFacet = {
  __typename?: 'MembershipRenewalV2PageCongratulationsStepV2BlockFacet';
  ApplicationHasBeenProcessedMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationIsBeingProcessedMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationNotProcessedStatusText?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BrowseAllEventsTexts?: Maybe<Array<Maybe<StringFacet>>>;
  COTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackHomeButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  JoinAStudyGroupText?: Maybe<Array<Maybe<StringFacet>>>;
  LearnAboutMentoringText?: Maybe<Array<Maybe<StringFacet>>>;
  LinkSectionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PendingStatusText?: Maybe<Array<Maybe<StringFacet>>>;
  ProcessedStatusText?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptText?: Maybe<Array<Maybe<StringFacet>>>;
  SomethingWentWrongMessage?: Maybe<Array<Maybe<StringFacet>>>;
  StatusText?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  SyncMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  TOTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TryAgainButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  UpgradeButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  UpgradeText?: Maybe<Array<Maybe<StringFacet>>>;
  ViewReceiptButtonText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetApplicationHasBeenProcessedMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetApplicationIsBeingProcessedMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetApplicationNotProcessedStatusTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetBrowseAllEventsTextsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetCotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetGoBackHomeButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetJoinAStudyGroupTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetLearnAboutMentoringTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetLinkSectionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetMdrtLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetPendingStatusTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetProcessedStatusTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetReceiptTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetSomethingWentWrongMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetStatusTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetSyncMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetTotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetTryAgainButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetUpgradeButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetUpgradeTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageCongratulationsStepV2BlockFacetViewReceiptButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageCongratulationsStepV2BlockOrderByInput = {
  ApplicationHasBeenProcessedMessage?: InputMaybe<OrderBy>;
  ApplicationIsBeingProcessedMessage?: InputMaybe<OrderBy>;
  ApplicationNotProcessedStatusText?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  BrowseAllEventsTexts?: InputMaybe<OrderBy>;
  COTLevelLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  GoBackHomeButtonText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  JoinAStudyGroupText?: InputMaybe<OrderBy>;
  LearnAboutMentoringText?: InputMaybe<OrderBy>;
  LinkSectionHeading?: InputMaybe<OrderBy>;
  MDRTLevelLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  PendingStatusText?: InputMaybe<OrderBy>;
  ProcessedStatusText?: InputMaybe<OrderBy>;
  ReceiptText?: InputMaybe<OrderBy>;
  SomethingWentWrongMessage?: InputMaybe<OrderBy>;
  StatusText?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  SyncMessageText?: InputMaybe<OrderBy>;
  TOTLevelLabel?: InputMaybe<OrderBy>;
  TryAgainButtonText?: InputMaybe<OrderBy>;
  UpgradeButtonText?: InputMaybe<OrderBy>;
  UpgradeText?: InputMaybe<OrderBy>;
  ViewReceiptButtonText?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageCongratulationsStepV2BlockWhereInput = {
  ApplicationHasBeenProcessedMessage?: InputMaybe<SearchableStringFilterInput>;
  ApplicationIsBeingProcessedMessage?: InputMaybe<SearchableStringFilterInput>;
  ApplicationNotProcessedStatusText?: InputMaybe<SearchableStringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  BrowseAllEventsTexts?: InputMaybe<SearchableStringFilterInput>;
  COTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  GoBackHomeButtonText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  JoinAStudyGroupText?: InputMaybe<SearchableStringFilterInput>;
  LearnAboutMentoringText?: InputMaybe<SearchableStringFilterInput>;
  LinkSectionHeading?: InputMaybe<SearchableStringFilterInput>;
  MDRTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PendingStatusText?: InputMaybe<SearchableStringFilterInput>;
  ProcessedStatusText?: InputMaybe<SearchableStringFilterInput>;
  ReceiptText?: InputMaybe<SearchableStringFilterInput>;
  SomethingWentWrongMessage?: InputMaybe<SearchableStringFilterInput>;
  StatusText?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  SyncMessageText?: InputMaybe<SearchableStringFilterInput>;
  TOTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  TryAgainButtonText?: InputMaybe<SearchableStringFilterInput>;
  UpgradeButtonText?: InputMaybe<SearchableStringFilterInput>;
  UpgradeText?: InputMaybe<SearchableStringFilterInput>;
  ViewReceiptButtonText?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageErrorModalBlock = {
  __typename?: 'MembershipRenewalV2PageErrorModalBlock';
  CloseButtonText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageErrorModalBlockCloseButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageErrorModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageErrorModalBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageErrorModalBlockFacet = {
  __typename?: 'MembershipRenewalV2PageErrorModalBlockFacet';
  CloseButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageErrorModalBlockFacetCloseButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageErrorModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageErrorModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageErrorModalBlockOrderByInput = {
  CloseButtonText?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageErrorModalBlockWhereInput = {
  CloseButtonText?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageErrorPageBlock = {
  __typename?: 'MembershipRenewalV2PageErrorPageBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageErrorPageBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageErrorPageBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageErrorPageBlockFacet = {
  __typename?: 'MembershipRenewalV2PageErrorPageBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageErrorPageBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageErrorPageBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageErrorPageBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageErrorPageBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageFacet = {
  __typename?: 'MembershipRenewalV2PageFacet';
  AccountLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  CancelUpgradeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationModal?: Maybe<MembershipRenewalV2PageConfirmationModalBlockFacet>;
  CongratulationsStep?: Maybe<MembershipRenewalV2PageCongratulationsStepV2BlockFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DeleteLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EditLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModal?: Maybe<MembershipRenewalV2PageErrorModalBlockFacet>;
  ErrorPage?: Maybe<MembershipRenewalV2PageErrorPageBlockFacet>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FormHasRequiredErrorsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GenericHomeButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GettingStartedStep?: Maybe<MembershipRenewalV2PageGettingStartedStepV2BlockFacet>;
  GreetingStep?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeesTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  LoaderScreen?: Maybe<MembershipRenewalV2PageLoaderBlockFacet>;
  LogoutLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipLevelStep?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockFacet>;
  MembershipTypeStep?: Maybe<MembershipRenewalV2PageMembershipTypeStepV2BlockFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<MembershipRenewalV2PageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavHeadingLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NotFoundPage?: Maybe<MembershipRenewalV2PageErrorPageBlockFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentProcessingLoaderText?: Maybe<Array<Maybe<StringFacet>>>;
  ProcessingScreen?: Maybe<MembershipRenewalV2PagePaymentProcessingScreenBlockFacet>;
  ProductionStep?: Maybe<MembershipRenewalV2PageProductionStepV2BlockFacet>;
  ProfileStep?: Maybe<MembershipRenewalV2PageProfileStepV2BlockFacet>;
  QuestionsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptStep?: Maybe<MembershipRenewalV2PageReceiptStepV2BlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RequiredErrorFieldLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReviewAndSubmitStep?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelectLanguageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepDisplayLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<MembershipRenewalV2PageImageBlockFacet>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipRenewalV2PageFacetAccountLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetCancelUpgradeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRenewalV2PageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRenewalV2PageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRenewalV2PageFacetDeleteLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetEditLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetFormHasRequiredErrorsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetGenericHomeButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRenewalV2PageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetLateFeesTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetLogoutLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetNavHeadingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetNoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetPaymentProcessingLoaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetQuestionsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetRequiredErrorFieldLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRenewalV2PageFacetSelectLanguageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRenewalV2PageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetStepDisplayLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRenewalV2PageFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacetYesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipRenewalV2PageGettingStartedStepV2Block = {
  __typename?: 'MembershipRenewalV2PageGettingStartedStepV2Block';
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DisabilityQuestionModal?: Maybe<MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlock>;
  DisabledDescription?: Maybe<Scalars['String']['output']>;
  DisabledHeading?: Maybe<Scalars['String']['output']>;
  EthicalComplaintDescription?: Maybe<Scalars['String']['output']>;
  EthicalComplaintHeading?: Maybe<Scalars['String']['output']>;
  EthicalComplaintQuestionModal?: Maybe<MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlock>;
  FlowFinishInformation?: Maybe<MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlock>;
  FormDescription?: Maybe<Scalars['String']['output']>;
  FormHeading?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  QuestionNotAnsweredError?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  UnableToProcessError?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockDisabledDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockDisabledHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockEthicalComplaintDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockEthicalComplaintHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFormDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFormHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockQuestionNotAnsweredErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockUnableToProcessErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageGettingStartedStepV2BlockFacet = {
  __typename?: 'MembershipRenewalV2PageGettingStartedStepV2BlockFacet';
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisabilityQuestionModal?: Maybe<MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockFacet>;
  DisabledDescription?: Maybe<Array<Maybe<StringFacet>>>;
  DisabledHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalComplaintQuestionModal?: Maybe<MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockFacet>;
  FlowFinishInformation?: Maybe<MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlockFacet>;
  FormDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QuestionNotAnsweredError?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  UnableToProcessError?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetDisabledDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetDisabledHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetEthicalComplaintDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetEthicalComplaintHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetFormDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetFormHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetQuestionNotAnsweredErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFacetUnableToProcessErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlock = {
  __typename?: 'MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlockFacet = {
  __typename?: 'MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlock = {
  __typename?: 'MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlock';
  CancelButtonText?: Maybe<Scalars['String']['output']>;
  ConfirmButtonText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  FooterText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockCancelButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockConfirmButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockFooterTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockFacet = {
  __typename?: 'MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockFacet';
  CancelButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ConfirmButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  FooterText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockFacetCancelButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockFacetConfirmButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockFacetFooterTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockOrderByInput = {
  CancelButtonText?: InputMaybe<OrderBy>;
  ConfirmButtonText?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  FooterText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockWhereInput = {
  CancelButtonText?: InputMaybe<SearchableStringFilterInput>;
  ConfirmButtonText?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  FooterText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageGettingStartedStepV2BlockOrderByInput = {
  BackButtonLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisabilityQuestionModal?: InputMaybe<MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockOrderByInput>;
  DisabledDescription?: InputMaybe<OrderBy>;
  DisabledHeading?: InputMaybe<OrderBy>;
  EthicalComplaintDescription?: InputMaybe<OrderBy>;
  EthicalComplaintHeading?: InputMaybe<OrderBy>;
  EthicalComplaintQuestionModal?: InputMaybe<MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockOrderByInput>;
  FlowFinishInformation?: InputMaybe<MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlockOrderByInput>;
  FormDescription?: InputMaybe<OrderBy>;
  FormHeading?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  QuestionNotAnsweredError?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  UnableToProcessError?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageGettingStartedStepV2BlockWhereInput = {
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisabilityQuestionModal?: InputMaybe<MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockWhereInput>;
  DisabledDescription?: InputMaybe<SearchableStringFilterInput>;
  DisabledHeading?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintDescription?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintHeading?: InputMaybe<SearchableStringFilterInput>;
  EthicalComplaintQuestionModal?: InputMaybe<MembershipRenewalV2PageGettingStartedStepV2BlockModalInfoBlockWhereInput>;
  FlowFinishInformation?: InputMaybe<MembershipRenewalV2PageGettingStartedStepV2BlockFlowFinishInformationBlockWhereInput>;
  FormDescription?: InputMaybe<SearchableStringFilterInput>;
  FormHeading?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  QuestionNotAnsweredError?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  UnableToProcessError?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageGreetingStepV2Block = {
  __typename?: 'MembershipRenewalV2PageGreetingStepV2Block';
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  FirstIconNoProductionProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlock>;
  FirstIconProductionProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlock>;
  Footnote?: Maybe<Scalars['String']['output']>;
  GoBackToHomepageButtonText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  LateFeeInfoBox?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlock>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  NotReadyToJoinMessageText?: Maybe<Scalars['String']['output']>;
  SecondIconNoProductionProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlock>;
  SecondIconProductionProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlock>;
  StepName?: Maybe<Scalars['String']['output']>;
  ThirdIconNoPaymentProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlock>;
  ThirdIconPaymentProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlock>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockFootnoteArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockGoBackToHomepageButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockNotReadyToJoinMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageGreetingStepV2BlockFacet = {
  __typename?: 'MembershipRenewalV2PageGreetingStepV2BlockFacet';
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  FirstIconNoProductionProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockFacet>;
  FirstIconProductionProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockFacet>;
  Footnote?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackToHomepageButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeeInfoBox?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlockFacet>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NotReadyToJoinMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  SecondIconNoProductionProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockFacet>;
  SecondIconProductionProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockFacet>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  ThirdIconNoPaymentProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockFacet>;
  ThirdIconPaymentProvidedTexts?: Maybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockFacet>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockFacetFootnoteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockFacetGoBackToHomepageButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockFacetNotReadyToJoinMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlock = {
  __typename?: 'MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlock';
  FirstLine?: Maybe<Scalars['String']['output']>;
  SecondLine?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockFirstLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockSecondLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockFacet = {
  __typename?: 'MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockFacet';
  FirstLine?: Maybe<Array<Maybe<StringFacet>>>;
  SecondLine?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockFacetFirstLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockFacetSecondLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockOrderByInput = {
  FirstLine?: InputMaybe<OrderBy>;
  SecondLine?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockWhereInput = {
  FirstLine?: InputMaybe<SearchableStringFilterInput>;
  SecondLine?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlock = {
  __typename?: 'MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlock';
  Heading?: Maybe<Scalars['String']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlockTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlockFacet = {
  __typename?: 'MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlockFacet';
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlockFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlockOrderByInput = {
  Heading?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlockWhereInput = {
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageGreetingStepV2BlockOrderByInput = {
  BackButtonLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  FirstIconNoProductionProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockOrderByInput>;
  FirstIconProductionProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockOrderByInput>;
  Footnote?: InputMaybe<OrderBy>;
  GoBackToHomepageButtonText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  LateFeeInfoBox?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlockOrderByInput>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  NotReadyToJoinMessageText?: InputMaybe<OrderBy>;
  SecondIconNoProductionProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockOrderByInput>;
  SecondIconProductionProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockOrderByInput>;
  StepName?: InputMaybe<OrderBy>;
  ThirdIconNoPaymentProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockOrderByInput>;
  ThirdIconPaymentProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockOrderByInput>;
};

export type MembershipRenewalV2PageGreetingStepV2BlockWhereInput = {
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  FirstIconNoProductionProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockWhereInput>;
  FirstIconProductionProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockWhereInput>;
  Footnote?: InputMaybe<SearchableStringFilterInput>;
  GoBackToHomepageButtonText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  LateFeeInfoBox?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockInfoBoxBlockWhereInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NotReadyToJoinMessageText?: InputMaybe<SearchableStringFilterInput>;
  SecondIconNoProductionProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockWhereInput>;
  SecondIconProductionProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockWhereInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  ThirdIconNoPaymentProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockWhereInput>;
  ThirdIconPaymentProvidedTexts?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockIconRequirementBlockWhereInput>;
};

export type MembershipRenewalV2PageImageBlock = {
  __typename?: 'MembershipRenewalV2PageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageImageBlockAutocomplete = {
  __typename?: 'MembershipRenewalV2PageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type MembershipRenewalV2PageImageBlockFacet = {
  __typename?: 'MembershipRenewalV2PageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRenewalV2PageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageLoaderBlock = {
  __typename?: 'MembershipRenewalV2PageLoaderBlock';
  Subtitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageLoaderBlockSubtitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageLoaderBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageLoaderBlockFacet = {
  __typename?: 'MembershipRenewalV2PageLoaderBlockFacet';
  Subtitle?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageLoaderBlockFacetSubtitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageLoaderBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageLoaderBlockOrderByInput = {
  Subtitle?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageLoaderBlockWhereInput = {
  Subtitle?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2Block = {
  __typename?: 'MembershipRenewalV2PageMembershipLevelStepV2Block';
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  COTRadioBlock?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlock>;
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  MDRTRadioBlock?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlock>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TOTRadioBlock?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlock>;
  TotWaiverInfoText?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockTotWaiverInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockAutocomplete = {
  __typename?: 'MembershipRenewalV2PageMembershipLevelStepV2BlockAutocomplete';
  COTRadioBlock?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockAutocomplete>;
  MDRTRadioBlock?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockAutocomplete>;
  TOTRadioBlock?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockAutocomplete>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockFacet = {
  __typename?: 'MembershipRenewalV2PageMembershipLevelStepV2BlockFacet';
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  COTRadioBlock?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTRadioBlock?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacet>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TOTRadioBlock?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacet>;
  TotWaiverInfoText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockFacetTotWaiverInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlock = {
  __typename?: 'MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlock';
  CostText?: Maybe<Scalars['String']['output']>;
  CostTooltip?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlock>;
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  NextLevelRequirementsButtonLabel?: Maybe<Scalars['String']['output']>;
  NextLevelRequirementsListHeader?: Maybe<Scalars['String']['output']>;
  NextLevelRequirementsTitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  WaiverTitle?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockCostTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockNextLevelRequirementsButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockNextLevelRequirementsListHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockNextLevelRequirementsTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockWaiverTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockAutocomplete = {
  __typename?: 'MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockAutocomplete';
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacet = {
  __typename?: 'MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacet';
  CostText?: Maybe<Array<Maybe<StringFacet>>>;
  CostTooltip?: Maybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  NextLevelRequirementsButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextLevelRequirementsListHeader?: Maybe<Array<Maybe<StringFacet>>>;
  NextLevelRequirementsTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  WaiverTitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacetCostTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacetNextLevelRequirementsButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacetNextLevelRequirementsListHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacetNextLevelRequirementsTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockFacetWaiverTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockOrderByInput = {
  CostText?: InputMaybe<OrderBy>;
  CostTooltip?: InputMaybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  NextLevelRequirementsButtonLabel?: InputMaybe<OrderBy>;
  NextLevelRequirementsListHeader?: InputMaybe<OrderBy>;
  NextLevelRequirementsTitle?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  WaiverTitle?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlock = {
  __typename?: 'MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockFacet = {
  __typename?: 'MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockWhereInput = {
  CostText?: InputMaybe<SearchableStringFilterInput>;
  CostTooltip?: InputMaybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockTooltipBlockWhereInput>;
  Description?: InputMaybe<StringFilterInput>;
  NextLevelRequirementsButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NextLevelRequirementsListHeader?: InputMaybe<SearchableStringFilterInput>;
  NextLevelRequirementsTitle?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  WaiverTitle?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockOrderByInput = {
  BackButtonLabel?: InputMaybe<OrderBy>;
  COTRadioBlock?: InputMaybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  MDRTRadioBlock?: InputMaybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockOrderByInput>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TOTRadioBlock?: InputMaybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockOrderByInput>;
  TotWaiverInfoText?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageMembershipLevelStepV2BlockWhereInput = {
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  COTRadioBlock?: InputMaybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockWhereInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  MDRTRadioBlock?: InputMaybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockWhereInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TOTRadioBlock?: InputMaybe<MembershipRenewalV2PageMembershipLevelStepV2BlockMembershipLevelRadioBlockWhereInput>;
  TotWaiverInfoText?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageMembershipTypeStepV2Block = {
  __typename?: 'MembershipRenewalV2PageMembershipTypeStepV2Block';
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  BackduesAmount?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  LifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  LifeMemberLabel?: Maybe<Scalars['String']['output']>;
  LifeMemberTotWaiverSuggestion?: Maybe<Scalars['String']['output']>;
  LifeMemberWarning?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingAndLifeMemberLabel?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeMemberWarning?: Maybe<Scalars['String']['output']>;
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingMemberLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockBackduesAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockLifeMemberTotWaiverSuggestionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockLifeMemberWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockQualifyingAndLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockQualifyingAndLifeMemberWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockQualifyingMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageMembershipTypeStepV2BlockAutocomplete = {
  __typename?: 'MembershipRenewalV2PageMembershipTypeStepV2BlockAutocomplete';
  LifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockAutocompleteLifeMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockAutocompleteQualifyingAndLifeMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockAutocompleteQualifyingMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacet = {
  __typename?: 'MembershipRenewalV2PageMembershipTypeStepV2BlockFacet';
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesAmount?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberTotWaiverSuggestion?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberWarning?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberWarning?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetBackduesAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetLifeMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetLifeMemberTotWaiverSuggestionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetLifeMemberWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetQualifyingAndLifeMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetQualifyingAndLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetQualifyingAndLifeMemberWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetQualifyingMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetQualifyingMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageMembershipTypeStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageMembershipTypeStepV2BlockOrderByInput = {
  BackButtonLabel?: InputMaybe<OrderBy>;
  BackduesAmount?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  LifeMemberDescriptions?: InputMaybe<OrderBy>;
  LifeMemberLabel?: InputMaybe<OrderBy>;
  LifeMemberTotWaiverSuggestion?: InputMaybe<OrderBy>;
  LifeMemberWarning?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberDescriptions?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberLabel?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberWarning?: InputMaybe<OrderBy>;
  QualifyingMemberDescriptions?: InputMaybe<OrderBy>;
  QualifyingMemberLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageMembershipTypeStepV2BlockWhereInput = {
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  BackduesAmount?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberDescriptions?: InputMaybe<StringFilterInput>;
  LifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberTotWaiverSuggestion?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberWarning?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeMemberDescriptions?: InputMaybe<StringFilterInput>;
  QualifyingAndLifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeMemberWarning?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMemberDescriptions?: InputMaybe<StringFilterInput>;
  QualifyingMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageOrderByInput = {
  AccountLabel?: InputMaybe<OrderBy>;
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  CancelUpgradeLabel?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationModal?: InputMaybe<MembershipRenewalV2PageConfirmationModalBlockOrderByInput>;
  CongratulationsStep?: InputMaybe<MembershipRenewalV2PageCongratulationsStepV2BlockOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DeleteLabel?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  EditLabel?: InputMaybe<OrderBy>;
  ErrorModal?: InputMaybe<MembershipRenewalV2PageErrorModalBlockOrderByInput>;
  ErrorPage?: InputMaybe<MembershipRenewalV2PageErrorPageBlockOrderByInput>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FormHasRequiredErrorsLabel?: InputMaybe<OrderBy>;
  GenericHomeButtonLabel?: InputMaybe<OrderBy>;
  GettingStartedStep?: InputMaybe<MembershipRenewalV2PageGettingStartedStepV2BlockOrderByInput>;
  GreetingStep?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeesTooltip?: InputMaybe<OrderBy>;
  LoaderScreen?: InputMaybe<MembershipRenewalV2PageLoaderBlockOrderByInput>;
  LogoutLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipLevelStep?: InputMaybe<MembershipRenewalV2PageMembershipLevelStepV2BlockOrderByInput>;
  MembershipTypeStep?: InputMaybe<MembershipRenewalV2PageMembershipTypeStepV2BlockOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<MembershipRenewalV2PageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavHeadingLabel?: InputMaybe<OrderBy>;
  NoLabel?: InputMaybe<OrderBy>;
  NotFoundPage?: InputMaybe<MembershipRenewalV2PageErrorPageBlockOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentProcessingLoaderText?: InputMaybe<OrderBy>;
  ProcessingScreen?: InputMaybe<MembershipRenewalV2PagePaymentProcessingScreenBlockOrderByInput>;
  ProductionStep?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockOrderByInput>;
  ProfileStep?: InputMaybe<MembershipRenewalV2PageProfileStepV2BlockOrderByInput>;
  QuestionsHeading?: InputMaybe<OrderBy>;
  ReceiptStep?: InputMaybe<MembershipRenewalV2PageReceiptStepV2BlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RequiredErrorFieldLabel?: InputMaybe<OrderBy>;
  ReviewAndSubmitStep?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelectLanguageHeading?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepDisplayLabel?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<MembershipRenewalV2PageImageBlockOrderByInput>;
  TotalDueLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  YesLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageOutput = {
  __typename?: 'MembershipRenewalV2PageOutput';
  autocomplete?: Maybe<MembershipRenewalV2PageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipRenewalV2PageFacet>;
  item?: Maybe<MembershipRenewalV2Page>;
  items?: Maybe<Array<Maybe<MembershipRenewalV2Page>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipRenewalV2PageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipRenewalV2PagePaymentProcessingScreenBlock = {
  __typename?: 'MembershipRenewalV2PagePaymentProcessingScreenBlock';
  Button?: Maybe<Scalars['String']['output']>;
  Header?: Maybe<Scalars['String']['output']>;
  InfoText?: Maybe<Scalars['String']['output']>;
  ProcessingFailedText?: Maybe<Scalars['String']['output']>;
  Subheader?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PagePaymentProcessingScreenBlockButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PagePaymentProcessingScreenBlockHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PagePaymentProcessingScreenBlockInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PagePaymentProcessingScreenBlockProcessingFailedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PagePaymentProcessingScreenBlockSubheaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PagePaymentProcessingScreenBlockFacet = {
  __typename?: 'MembershipRenewalV2PagePaymentProcessingScreenBlockFacet';
  Button?: Maybe<Array<Maybe<StringFacet>>>;
  Header?: Maybe<Array<Maybe<StringFacet>>>;
  InfoText?: Maybe<Array<Maybe<StringFacet>>>;
  ProcessingFailedText?: Maybe<Array<Maybe<StringFacet>>>;
  Subheader?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PagePaymentProcessingScreenBlockFacetButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PagePaymentProcessingScreenBlockFacetHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PagePaymentProcessingScreenBlockFacetInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PagePaymentProcessingScreenBlockFacetProcessingFailedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PagePaymentProcessingScreenBlockFacetSubheaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PagePaymentProcessingScreenBlockOrderByInput = {
  Button?: InputMaybe<OrderBy>;
  Header?: InputMaybe<OrderBy>;
  InfoText?: InputMaybe<OrderBy>;
  ProcessingFailedText?: InputMaybe<OrderBy>;
  Subheader?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PagePaymentProcessingScreenBlockWhereInput = {
  Button?: InputMaybe<SearchableStringFilterInput>;
  Header?: InputMaybe<SearchableStringFilterInput>;
  InfoText?: InputMaybe<SearchableStringFilterInput>;
  ProcessingFailedText?: InputMaybe<SearchableStringFilterInput>;
  Subheader?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageProductionStepV2Block = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2Block';
  AddProductionModal?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlock>;
  AddProductionNumbersRadioLabels?: Maybe<Scalars['String']['output']>;
  AddedByText?: Maybe<Scalars['String']['output']>;
  AttestProductionNumbersRadioLabels?: Maybe<Scalars['String']['output']>;
  AttestViewMoreLabel?: Maybe<Scalars['String']['output']>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  COTProductionNumberTexts?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlock>;
  COTQualifyingMessageText?: Maybe<Scalars['String']['output']>;
  CertificationLetterFileTooLargeError?: Maybe<Scalars['String']['output']>;
  CertifyinLettersTitle?: Maybe<Scalars['String']['output']>;
  CertifyingLettersDescription?: Maybe<Scalars['String']['output']>;
  CertifyingLettersUploadButtonText?: Maybe<Scalars['String']['output']>;
  CommissionTable?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlock>;
  CompanyAddedProduction?: Maybe<Scalars['String']['output']>;
  CompanyText?: Maybe<Scalars['String']['output']>;
  DeleteCertifyingLetterModal?: Maybe<MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlock>;
  DeleteProductionModal?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlock>;
  Description?: Maybe<Scalars['String']['output']>;
  DescriptionQualifyingAndLife?: Maybe<Scalars['String']['output']>;
  EditProductionModal?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlock>;
  FieldRequiredError?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncomeTable?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlock>;
  MDRTProductionNumberTexts?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlock>;
  MDRTQualifyingMessageText?: Maybe<Scalars['String']['output']>;
  MembershipLevelSelectionText?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  NoCertificationLettersError?: Maybe<Scalars['String']['output']>;
  NotEnoughMonetaryProductionError?: Maybe<Scalars['String']['output']>;
  NotEnoughNewBusinessByCountryError?: Maybe<Scalars['String']['output']>;
  PolicyMultipleText?: Maybe<Scalars['String']['output']>;
  PolicySingleText?: Maybe<Scalars['String']['output']>;
  PremiumTable?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlock>;
  ProductionNumbersFormDescription?: Maybe<Scalars['String']['output']>;
  ProductionNumbersNotSelectedError?: Maybe<Scalars['String']['output']>;
  SelfAttestLevelOptions?: Maybe<MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlock>;
  SelfAttestationFormDescription?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TOTProductionNumberTexts?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlock>;
  TOTQualifyingMessageText?: Maybe<Scalars['String']['output']>;
  YouCanAddMoreProdcution?: Maybe<Scalars['String']['output']>;
  YouCannotAttestToAHigherLevelWarning?: Maybe<Scalars['String']['output']>;
  YouText?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageProductionStepV2BlockAddProductionNumbersRadioLabelsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockAddedByTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockAttestProductionNumbersRadioLabelsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockAttestViewMoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockCotQualifyingMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockCertificationLetterFileTooLargeErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockCertifyinLettersTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockCertifyingLettersDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockCertifyingLettersUploadButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockCompanyAddedProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockCompanyTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockDescriptionQualifyingAndLifeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFieldRequiredErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockMdrtQualifyingMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockMembershipLevelSelectionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockNoCertificationLettersErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockNotEnoughMonetaryProductionErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockNotEnoughNewBusinessByCountryErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockPolicyMultipleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockPolicySingleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionNumbersFormDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionNumbersNotSelectedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestationFormDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockTotQualifyingMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockYouCanAddMoreProdcutionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockYouCannotAttestToAHigherLevelWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockYouTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlock = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlockFacet = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageProductionStepV2BlockFacet = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockFacet';
  AddProductionModal?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacet>;
  AddProductionNumbersRadioLabels?: Maybe<Array<Maybe<StringFacet>>>;
  AddedByText?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionNumbersRadioLabels?: Maybe<Array<Maybe<StringFacet>>>;
  AttestViewMoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  COTProductionNumberTexts?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockFacet>;
  COTQualifyingMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  CertificationLetterFileTooLargeError?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyinLettersTitle?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersDescription?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersUploadButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionTable?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacet>;
  CompanyAddedProduction?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyText?: Maybe<Array<Maybe<StringFacet>>>;
  DeleteCertifyingLetterModal?: Maybe<MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlockFacet>;
  DeleteProductionModal?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DescriptionQualifyingAndLife?: Maybe<Array<Maybe<StringFacet>>>;
  EditProductionModal?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacet>;
  FieldRequiredError?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeTable?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacet>;
  MDRTProductionNumberTexts?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockFacet>;
  MDRTQualifyingMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelSelectionText?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NoCertificationLettersError?: Maybe<Array<Maybe<StringFacet>>>;
  NotEnoughMonetaryProductionError?: Maybe<Array<Maybe<StringFacet>>>;
  NotEnoughNewBusinessByCountryError?: Maybe<Array<Maybe<StringFacet>>>;
  PolicyMultipleText?: Maybe<Array<Maybe<StringFacet>>>;
  PolicySingleText?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumTable?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacet>;
  ProductionNumbersFormDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionNumbersNotSelectedError?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestLevelOptions?: Maybe<MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockFacet>;
  SelfAttestationFormDescription?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TOTProductionNumberTexts?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockFacet>;
  TOTQualifyingMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  YouCanAddMoreProdcution?: Maybe<Array<Maybe<StringFacet>>>;
  YouCannotAttestToAHigherLevelWarning?: Maybe<Array<Maybe<StringFacet>>>;
  YouText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetAddProductionNumbersRadioLabelsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetAddedByTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetAttestProductionNumbersRadioLabelsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetAttestViewMoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetCotQualifyingMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetCertificationLetterFileTooLargeErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetCertifyinLettersTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetCertifyingLettersDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetCertifyingLettersUploadButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetCompanyAddedProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetCompanyTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetDescriptionQualifyingAndLifeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetFieldRequiredErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetMdrtQualifyingMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetMembershipLevelSelectionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetNoCertificationLettersErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetNotEnoughMonetaryProductionErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetNotEnoughNewBusinessByCountryErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetPolicyMultipleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetPolicySingleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetProductionNumbersFormDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetProductionNumbersNotSelectedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetSelfAttestationFormDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetTotQualifyingMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetYouCanAddMoreProdcutionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetYouCannotAttestToAHigherLevelWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockFacetYouTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageProductionStepV2BlockOrderByInput = {
  AddProductionModal?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockOrderByInput>;
  AddProductionNumbersRadioLabels?: InputMaybe<OrderBy>;
  AddedByText?: InputMaybe<OrderBy>;
  AttestProductionNumbersRadioLabels?: InputMaybe<OrderBy>;
  AttestViewMoreLabel?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  COTProductionNumberTexts?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockOrderByInput>;
  COTQualifyingMessageText?: InputMaybe<OrderBy>;
  CertificationLetterFileTooLargeError?: InputMaybe<OrderBy>;
  CertifyinLettersTitle?: InputMaybe<OrderBy>;
  CertifyingLettersDescription?: InputMaybe<OrderBy>;
  CertifyingLettersUploadButtonText?: InputMaybe<OrderBy>;
  CommissionTable?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockOrderByInput>;
  CompanyAddedProduction?: InputMaybe<OrderBy>;
  CompanyText?: InputMaybe<OrderBy>;
  DeleteCertifyingLetterModal?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlockOrderByInput>;
  DeleteProductionModal?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  DescriptionQualifyingAndLife?: InputMaybe<OrderBy>;
  EditProductionModal?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockOrderByInput>;
  FieldRequiredError?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IncomeTable?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockOrderByInput>;
  MDRTProductionNumberTexts?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockOrderByInput>;
  MDRTQualifyingMessageText?: InputMaybe<OrderBy>;
  MembershipLevelSelectionText?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  NoCertificationLettersError?: InputMaybe<OrderBy>;
  NotEnoughMonetaryProductionError?: InputMaybe<OrderBy>;
  NotEnoughNewBusinessByCountryError?: InputMaybe<OrderBy>;
  PolicyMultipleText?: InputMaybe<OrderBy>;
  PolicySingleText?: InputMaybe<OrderBy>;
  PremiumTable?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockOrderByInput>;
  ProductionNumbersFormDescription?: InputMaybe<OrderBy>;
  ProductionNumbersNotSelectedError?: InputMaybe<OrderBy>;
  SelfAttestLevelOptions?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockOrderByInput>;
  SelfAttestationFormDescription?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TOTProductionNumberTexts?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockOrderByInput>;
  TOTQualifyingMessageText?: InputMaybe<OrderBy>;
  YouCanAddMoreProdcution?: InputMaybe<OrderBy>;
  YouCannotAttestToAHigherLevelWarning?: InputMaybe<OrderBy>;
  YouText?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlock = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlock';
  CommisionText?: Maybe<Scalars['String']['output']>;
  CommisionTextHeader?: Maybe<Scalars['String']['output']>;
  IncomeText?: Maybe<Scalars['String']['output']>;
  PremiumText?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockCommisionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockCommisionTextHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockIncomeTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockPremiumTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockFacet = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockFacet';
  CommisionText?: Maybe<Array<Maybe<StringFacet>>>;
  CommisionTextHeader?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeText?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockFacetCommisionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockFacetCommisionTextHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockFacetIncomeTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockFacetPremiumTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockOrderByInput = {
  CommisionText?: InputMaybe<OrderBy>;
  CommisionTextHeader?: InputMaybe<OrderBy>;
  IncomeText?: InputMaybe<OrderBy>;
  PremiumText?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockWhereInput = {
  CommisionText?: InputMaybe<SearchableStringFilterInput>;
  CommisionTextHeader?: InputMaybe<SearchableStringFilterInput>;
  IncomeText?: InputMaybe<SearchableStringFilterInput>;
  PremiumText?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlock = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlock';
  CancelButton?: Maybe<Scalars['String']['output']>;
  CommissionTitle?: Maybe<Scalars['String']['output']>;
  DeleteButton?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  IncomeTitle?: Maybe<Scalars['String']['output']>;
  PremiumTitle?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockCancelButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockCommissionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockDeleteButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockIncomeTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockPremiumTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockFacet = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockFacet';
  CancelButton?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  DeleteButton?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumTitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockFacetCancelButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockFacetCommissionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockFacetDeleteButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockFacetIncomeTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockFacetPremiumTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockOrderByInput = {
  CancelButton?: InputMaybe<OrderBy>;
  CommissionTitle?: InputMaybe<OrderBy>;
  DeleteButton?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  IncomeTitle?: InputMaybe<OrderBy>;
  PremiumTitle?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockWhereInput = {
  CancelButton?: InputMaybe<SearchableStringFilterInput>;
  CommissionTitle?: InputMaybe<SearchableStringFilterInput>;
  DeleteButton?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  IncomeTitle?: InputMaybe<SearchableStringFilterInput>;
  PremiumTitle?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlock = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockProductionModalBlock';
  CancelButton?: Maybe<Scalars['String']['output']>;
  CommissionTitle?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  IncomeTitle?: Maybe<Scalars['String']['output']>;
  NewBusinessIncomeLabel?: Maybe<Scalars['String']['output']>;
  OtherCommissionInputCommissionLabel?: Maybe<Scalars['String']['output']>;
  OtherCommissionInputPremiumLabel?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesInputLabel?: Maybe<Scalars['String']['output']>;
  PremiumTitle?: Maybe<Scalars['String']['output']>;
  RiskProtectionInputCommissionLabel?: Maybe<Scalars['String']['output']>;
  RiskProtectionInputIncomeLabel?: Maybe<Scalars['String']['output']>;
  RiskProtectionInputPremiumLabel?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesInputLabel?: Maybe<Scalars['String']['output']>;
  SaveButton?: Maybe<Scalars['String']['output']>;
  SharedCheckboxLabel?: Maybe<Scalars['String']['output']>;
  SharedTooltip?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlock>;
  SubsectionDescription?: Maybe<Scalars['String']['output']>;
  SubsectionHeader?: Maybe<Scalars['String']['output']>;
  SubsectionPostfix?: Maybe<Scalars['String']['output']>;
  TotalIncomeReportedInputLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockCancelButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockCommissionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockIncomeTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockNewBusinessIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockOtherCommissionInputCommissionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockOtherCommissionInputPremiumLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockOtherPoliciesCasesInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockPremiumTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockRiskProtectionInputCommissionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockRiskProtectionInputIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockRiskProtectionInputPremiumLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockRiskProtectionPoliciesCasesInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockSaveButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockSharedCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockSubsectionDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockSubsectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockSubsectionPostfixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTotalIncomeReportedInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacet = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacet';
  CancelButton?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeTitle?: Maybe<Array<Maybe<StringFacet>>>;
  NewBusinessIncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherCommissionInputCommissionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherCommissionInputPremiumLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionInputCommissionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionInputIncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionInputPremiumLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SaveButton?: Maybe<Array<Maybe<StringFacet>>>;
  SharedCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SharedTooltip?: Maybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlockFacet>;
  SubsectionDescription?: Maybe<Array<Maybe<StringFacet>>>;
  SubsectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  SubsectionPostfix?: Maybe<Array<Maybe<StringFacet>>>;
  TotalIncomeReportedInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetCancelButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetCommissionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetIncomeTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetNewBusinessIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetOtherCommissionInputCommissionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetOtherCommissionInputPremiumLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetOtherPoliciesCasesInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetPremiumTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetRiskProtectionInputCommissionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetRiskProtectionInputIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetRiskProtectionInputPremiumLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetRiskProtectionPoliciesCasesInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetSaveButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetSharedCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetSubsectionDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetSubsectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetSubsectionPostfixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockFacetTotalIncomeReportedInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockOrderByInput = {
  CancelButton?: InputMaybe<OrderBy>;
  CommissionTitle?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  IncomeTitle?: InputMaybe<OrderBy>;
  NewBusinessIncomeLabel?: InputMaybe<OrderBy>;
  OtherCommissionInputCommissionLabel?: InputMaybe<OrderBy>;
  OtherCommissionInputPremiumLabel?: InputMaybe<OrderBy>;
  OtherPoliciesCasesInputLabel?: InputMaybe<OrderBy>;
  PremiumTitle?: InputMaybe<OrderBy>;
  RiskProtectionInputCommissionLabel?: InputMaybe<OrderBy>;
  RiskProtectionInputIncomeLabel?: InputMaybe<OrderBy>;
  RiskProtectionInputPremiumLabel?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesInputLabel?: InputMaybe<OrderBy>;
  SaveButton?: InputMaybe<OrderBy>;
  SharedCheckboxLabel?: InputMaybe<OrderBy>;
  SharedTooltip?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlockOrderByInput>;
  SubsectionDescription?: InputMaybe<OrderBy>;
  SubsectionHeader?: InputMaybe<OrderBy>;
  SubsectionPostfix?: InputMaybe<OrderBy>;
  TotalIncomeReportedInputLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlock = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlockFacet = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockWhereInput = {
  CancelButton?: InputMaybe<SearchableStringFilterInput>;
  CommissionTitle?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  IncomeTitle?: InputMaybe<SearchableStringFilterInput>;
  NewBusinessIncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherCommissionInputCommissionLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherCommissionInputPremiumLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesInputLabel?: InputMaybe<SearchableStringFilterInput>;
  PremiumTitle?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionInputCommissionLabel?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionInputIncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionInputPremiumLabel?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesInputLabel?: InputMaybe<SearchableStringFilterInput>;
  SaveButton?: InputMaybe<SearchableStringFilterInput>;
  SharedCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  SharedTooltip?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockTooltipBlockWhereInput>;
  SubsectionDescription?: InputMaybe<SearchableStringFilterInput>;
  SubsectionHeader?: InputMaybe<SearchableStringFilterInput>;
  SubsectionPostfix?: InputMaybe<SearchableStringFilterInput>;
  TotalIncomeReportedInputLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlock = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockProductionTableBlock';
  AddButtonText?: Maybe<Scalars['String']['output']>;
  AddMoreButtonText?: Maybe<Scalars['String']['output']>;
  ColumnExplanationText?: Maybe<Scalars['String']['output']>;
  HigherThenExpectedWarning?: Maybe<Scalars['String']['output']>;
  OtherNewBusinessColumn?: Maybe<Scalars['String']['output']>;
  RiskProtectionColumn?: Maybe<Scalars['String']['output']>;
  SharedColumn?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TotalCalculationText?: Maybe<Scalars['String']['output']>;
  TotalColumn?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockAddButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockAddMoreButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockColumnExplanationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockHigherThenExpectedWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockOtherNewBusinessColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockRiskProtectionColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockSharedColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockTotalCalculationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockTotalColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacet = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacet';
  AddButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  AddMoreButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ColumnExplanationText?: Maybe<Array<Maybe<StringFacet>>>;
  HigherThenExpectedWarning?: Maybe<Array<Maybe<StringFacet>>>;
  OtherNewBusinessColumn?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionColumn?: Maybe<Array<Maybe<StringFacet>>>;
  SharedColumn?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TotalCalculationText?: Maybe<Array<Maybe<StringFacet>>>;
  TotalColumn?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacetAddButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacetAddMoreButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacetColumnExplanationTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacetHigherThenExpectedWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacetOtherNewBusinessColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacetRiskProtectionColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacetSharedColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacetTotalCalculationTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockFacetTotalColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockOrderByInput = {
  AddButtonText?: InputMaybe<OrderBy>;
  AddMoreButtonText?: InputMaybe<OrderBy>;
  ColumnExplanationText?: InputMaybe<OrderBy>;
  HigherThenExpectedWarning?: InputMaybe<OrderBy>;
  OtherNewBusinessColumn?: InputMaybe<OrderBy>;
  RiskProtectionColumn?: InputMaybe<OrderBy>;
  SharedColumn?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TotalCalculationText?: InputMaybe<OrderBy>;
  TotalColumn?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockWhereInput = {
  AddButtonText?: InputMaybe<SearchableStringFilterInput>;
  AddMoreButtonText?: InputMaybe<SearchableStringFilterInput>;
  ColumnExplanationText?: InputMaybe<SearchableStringFilterInput>;
  HigherThenExpectedWarning?: InputMaybe<SearchableStringFilterInput>;
  OtherNewBusinessColumn?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionColumn?: InputMaybe<SearchableStringFilterInput>;
  SharedColumn?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TotalCalculationText?: InputMaybe<SearchableStringFilterInput>;
  TotalColumn?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlock = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlock';
  SelfAttestCommissionSubheading?: Maybe<Scalars['String']['output']>;
  SelfAttestIncomeSubheading?: Maybe<Scalars['String']['output']>;
  SelfAttestLevelTitle1?: Maybe<Scalars['String']['output']>;
  SelfAttestLevelTitle2?: Maybe<Scalars['String']['output']>;
  SelfAttestLevelTitle3?: Maybe<Scalars['String']['output']>;
  SelfAttestPremiumSubheading?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestCommissionSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestIncomeSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestLevelTitle1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestLevelTitle2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestLevelTitle3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestPremiumSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockFacet = {
  __typename?: 'MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockFacet';
  SelfAttestCommissionSubheading?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestIncomeSubheading?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestLevelTitle1?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestLevelTitle2?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestLevelTitle3?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestPremiumSubheading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestCommissionSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestIncomeSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestLevelTitle1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestLevelTitle2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestLevelTitle3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestPremiumSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockOrderByInput = {
  SelfAttestCommissionSubheading?: InputMaybe<OrderBy>;
  SelfAttestIncomeSubheading?: InputMaybe<OrderBy>;
  SelfAttestLevelTitle1?: InputMaybe<OrderBy>;
  SelfAttestLevelTitle2?: InputMaybe<OrderBy>;
  SelfAttestLevelTitle3?: InputMaybe<OrderBy>;
  SelfAttestPremiumSubheading?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockWhereInput = {
  SelfAttestCommissionSubheading?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestIncomeSubheading?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestLevelTitle1?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestLevelTitle2?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestLevelTitle3?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestPremiumSubheading?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageProductionStepV2BlockWhereInput = {
  AddProductionModal?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockWhereInput>;
  AddProductionNumbersRadioLabels?: InputMaybe<SearchableStringFilterInput>;
  AddedByText?: InputMaybe<SearchableStringFilterInput>;
  AttestProductionNumbersRadioLabels?: InputMaybe<SearchableStringFilterInput>;
  AttestViewMoreLabel?: InputMaybe<SearchableStringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  COTProductionNumberTexts?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockWhereInput>;
  COTQualifyingMessageText?: InputMaybe<SearchableStringFilterInput>;
  CertificationLetterFileTooLargeError?: InputMaybe<SearchableStringFilterInput>;
  CertifyinLettersTitle?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersDescription?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersUploadButtonText?: InputMaybe<SearchableStringFilterInput>;
  CommissionTable?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockWhereInput>;
  CompanyAddedProduction?: InputMaybe<SearchableStringFilterInput>;
  CompanyText?: InputMaybe<SearchableStringFilterInput>;
  DeleteCertifyingLetterModal?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockDeleteCertifyinLetterModalBlockWhereInput>;
  DeleteProductionModal?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionDeleteModalBlockWhereInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DescriptionQualifyingAndLife?: InputMaybe<SearchableStringFilterInput>;
  EditProductionModal?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionModalBlockWhereInput>;
  FieldRequiredError?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncomeTable?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockWhereInput>;
  MDRTProductionNumberTexts?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockWhereInput>;
  MDRTQualifyingMessageText?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelSelectionText?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NoCertificationLettersError?: InputMaybe<SearchableStringFilterInput>;
  NotEnoughMonetaryProductionError?: InputMaybe<SearchableStringFilterInput>;
  NotEnoughNewBusinessByCountryError?: InputMaybe<SearchableStringFilterInput>;
  PolicyMultipleText?: InputMaybe<SearchableStringFilterInput>;
  PolicySingleText?: InputMaybe<SearchableStringFilterInput>;
  PremiumTable?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionTableBlockWhereInput>;
  ProductionNumbersFormDescription?: InputMaybe<SearchableStringFilterInput>;
  ProductionNumbersNotSelectedError?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestLevelOptions?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockSelfAttestLevelOptionsBlockWhereInput>;
  SelfAttestationFormDescription?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TOTProductionNumberTexts?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockProductionAttestmentNumbersBlockWhereInput>;
  TOTQualifyingMessageText?: InputMaybe<SearchableStringFilterInput>;
  YouCanAddMoreProdcution?: InputMaybe<SearchableStringFilterInput>;
  YouCannotAttestToAHigherLevelWarning?: InputMaybe<SearchableStringFilterInput>;
  YouText?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageProfileStepV2Block = {
  __typename?: 'MembershipRenewalV2PageProfileStepV2Block';
  AddLocalLanguageAddressCheckboxLabel?: Maybe<Scalars['String']['output']>;
  AreaCodeInputLabel?: Maybe<Scalars['String']['output']>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  CompanyAffiliationInputLabel?: Maybe<Scalars['String']['output']>;
  ContactInformationHeader?: Maybe<Scalars['String']['output']>;
  CountryOrMarketInputLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignationsLabel?: Maybe<Scalars['String']['output']>;
  FirstNameLabel?: Maybe<Scalars['String']['output']>;
  GenderInputLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncorrectDateOfBirthErrorMessage?: Maybe<Scalars['String']['output']>;
  IsoCodeInputLabel?: Maybe<Scalars['String']['output']>;
  LastNameLabel?: Maybe<Scalars['String']['output']>;
  LatinAlphabetWarning?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddressHeader?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddressLabels?: Maybe<MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlock>;
  MDRTEmailContactCheckboxLabel?: Maybe<Scalars['String']['output']>;
  MDRTMemberDirectoryCheckboxLabel?: Maybe<Scalars['String']['output']>;
  MDRTSmsContactCheckboxLabel?: Maybe<Scalars['String']['output']>;
  MailingAddressHeader?: Maybe<Scalars['String']['output']>;
  MailingAddressLabels?: Maybe<MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlock>;
  MiddleNameLabel?: Maybe<Scalars['String']['output']>;
  MissingInformationInfoBox?: Maybe<MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlock>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  NicknameLabel?: Maybe<Scalars['String']['output']>;
  OptionalHeaderLabelTag?: Maybe<Scalars['String']['output']>;
  PersonalInformationHeader?: Maybe<Scalars['String']['output']>;
  PhoneNumberInputLabel?: Maybe<Scalars['String']['output']>;
  PhoneTypeInputLabel?: Maybe<Scalars['String']['output']>;
  PrefixLabel?: Maybe<Scalars['String']['output']>;
  PrimaryLanguageInputLabel?: Maybe<Scalars['String']['output']>;
  ProfessionalInformationHeader?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  SuffixLabel?: Maybe<Scalars['String']['output']>;
  UpdateInformationInfoBox?: Maybe<MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlock>;
  YearOfBirthInputLabel?: Maybe<Scalars['String']['output']>;
  YearOfFirstLicenseLabel?: Maybe<Scalars['String']['output']>;
  YearOfFirstLicenseValidationLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddLocalLanguageAddressCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAreaCodeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockCompanyAffiliationInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockContactInformationHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockCountryOrMarketInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockDesignationsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFirstNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockGenderInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockIncorrectDateOfBirthErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockIsoCodeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockLastNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockLatinAlphabetWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockLocalLanguageAddressHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockMdrtEmailContactCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockMdrtMemberDirectoryCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockMdrtSmsContactCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockMailingAddressHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockMiddleNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockNicknameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockOptionalHeaderLabelTagArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockPersonalInformationHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockPhoneNumberInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockPhoneTypeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockPrefixLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockPrimaryLanguageInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockProfessionalInformationHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockSuffixLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockYearOfBirthInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockYearOfFirstLicenseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockYearOfFirstLicenseValidationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlock = {
  __typename?: 'MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlock';
  AddressLineOneInputLabel?: Maybe<Scalars['String']['output']>;
  AddressLineThreeInputLabel?: Maybe<Scalars['String']['output']>;
  AddressLineTwoInputLabel?: Maybe<Scalars['String']['output']>;
  CityOrTownInputLabel?: Maybe<Scalars['String']['output']>;
  CountryOrMarketInputLabel?: Maybe<Scalars['String']['output']>;
  StateOrProvinceInputLabel?: Maybe<Scalars['String']['output']>;
  ZipCodeInputLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockAddressLineOneInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockAddressLineThreeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockAddressLineTwoInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockCityOrTownInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockCountryOrMarketInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockStateOrProvinceInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockZipCodeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockFacet = {
  __typename?: 'MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockFacet';
  AddressLineOneInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLineThreeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLineTwoInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CityOrTownInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CountryOrMarketInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StateOrProvinceInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ZipCodeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockFacetAddressLineOneInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockFacetAddressLineThreeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockFacetAddressLineTwoInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockFacetCityOrTownInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockFacetCountryOrMarketInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockFacetStateOrProvinceInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockFacetZipCodeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockOrderByInput = {
  AddressLineOneInputLabel?: InputMaybe<OrderBy>;
  AddressLineThreeInputLabel?: InputMaybe<OrderBy>;
  AddressLineTwoInputLabel?: InputMaybe<OrderBy>;
  CityOrTownInputLabel?: InputMaybe<OrderBy>;
  CountryOrMarketInputLabel?: InputMaybe<OrderBy>;
  StateOrProvinceInputLabel?: InputMaybe<OrderBy>;
  ZipCodeInputLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockWhereInput = {
  AddressLineOneInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLineThreeInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLineTwoInputLabel?: InputMaybe<SearchableStringFilterInput>;
  CityOrTownInputLabel?: InputMaybe<SearchableStringFilterInput>;
  CountryOrMarketInputLabel?: InputMaybe<SearchableStringFilterInput>;
  StateOrProvinceInputLabel?: InputMaybe<SearchableStringFilterInput>;
  ZipCodeInputLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageProfileStepV2BlockFacet = {
  __typename?: 'MembershipRenewalV2PageProfileStepV2BlockFacet';
  AddLocalLanguageAddressCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AreaCodeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyAffiliationInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContactInformationHeader?: Maybe<Array<Maybe<StringFacet>>>;
  CountryOrMarketInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DesignationsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FirstNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GenderInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncorrectDateOfBirthErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  IsoCodeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LastNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LatinAlphabetWarning?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddressHeader?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddressLabels?: Maybe<MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockFacet>;
  MDRTEmailContactCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTMemberDirectoryCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTSmsContactCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddressHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddressLabels?: Maybe<MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockFacet>;
  MiddleNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MissingInformationInfoBox?: Maybe<MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockFacet>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NicknameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OptionalHeaderLabelTag?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalInformationHeader?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneTypeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrefixLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryLanguageInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalInformationHeader?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  SuffixLabel?: Maybe<Array<Maybe<StringFacet>>>;
  UpdateInformationInfoBox?: Maybe<MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockFacet>;
  YearOfBirthInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstLicenseLabel?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstLicenseValidationLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetAddLocalLanguageAddressCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetAreaCodeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetCompanyAffiliationInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetContactInformationHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetCountryOrMarketInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetDesignationsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetFirstNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetGenderInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetIncorrectDateOfBirthErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetIsoCodeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetLastNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetLatinAlphabetWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetLocalLanguageAddressHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetMdrtEmailContactCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetMdrtMemberDirectoryCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetMdrtSmsContactCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetMailingAddressHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetMiddleNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetNicknameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetOptionalHeaderLabelTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetPersonalInformationHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetPhoneNumberInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetPhoneTypeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetPrefixLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetPrimaryLanguageInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetProfessionalInformationHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetSuffixLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetYearOfBirthInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetYearOfFirstLicenseLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockFacetYearOfFirstLicenseValidationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlock = {
  __typename?: 'MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlock';
  Heading?: Maybe<Scalars['String']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockFacet = {
  __typename?: 'MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockFacet';
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockOrderByInput = {
  Heading?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockWhereInput = {
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageProfileStepV2BlockOrderByInput = {
  AddLocalLanguageAddressCheckboxLabel?: InputMaybe<OrderBy>;
  AreaCodeInputLabel?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  CompanyAffiliationInputLabel?: InputMaybe<OrderBy>;
  ContactInformationHeader?: InputMaybe<OrderBy>;
  CountryOrMarketInputLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DesignationsLabel?: InputMaybe<OrderBy>;
  FirstNameLabel?: InputMaybe<OrderBy>;
  GenderInputLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IncorrectDateOfBirthErrorMessage?: InputMaybe<OrderBy>;
  IsoCodeInputLabel?: InputMaybe<OrderBy>;
  LastNameLabel?: InputMaybe<OrderBy>;
  LatinAlphabetWarning?: InputMaybe<OrderBy>;
  LocalLanguageAddressHeader?: InputMaybe<OrderBy>;
  LocalLanguageAddressLabels?: InputMaybe<MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockOrderByInput>;
  MDRTEmailContactCheckboxLabel?: InputMaybe<OrderBy>;
  MDRTMemberDirectoryCheckboxLabel?: InputMaybe<OrderBy>;
  MDRTSmsContactCheckboxLabel?: InputMaybe<OrderBy>;
  MailingAddressHeader?: InputMaybe<OrderBy>;
  MailingAddressLabels?: InputMaybe<MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockOrderByInput>;
  MiddleNameLabel?: InputMaybe<OrderBy>;
  MissingInformationInfoBox?: InputMaybe<MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockOrderByInput>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  NicknameLabel?: InputMaybe<OrderBy>;
  OptionalHeaderLabelTag?: InputMaybe<OrderBy>;
  PersonalInformationHeader?: InputMaybe<OrderBy>;
  PhoneNumberInputLabel?: InputMaybe<OrderBy>;
  PhoneTypeInputLabel?: InputMaybe<OrderBy>;
  PrefixLabel?: InputMaybe<OrderBy>;
  PrimaryLanguageInputLabel?: InputMaybe<OrderBy>;
  ProfessionalInformationHeader?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  SuffixLabel?: InputMaybe<OrderBy>;
  UpdateInformationInfoBox?: InputMaybe<MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockOrderByInput>;
  YearOfBirthInputLabel?: InputMaybe<OrderBy>;
  YearOfFirstLicenseLabel?: InputMaybe<OrderBy>;
  YearOfFirstLicenseValidationLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageProfileStepV2BlockWhereInput = {
  AddLocalLanguageAddressCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  AreaCodeInputLabel?: InputMaybe<SearchableStringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyAffiliationInputLabel?: InputMaybe<SearchableStringFilterInput>;
  ContactInformationHeader?: InputMaybe<SearchableStringFilterInput>;
  CountryOrMarketInputLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DesignationsLabel?: InputMaybe<SearchableStringFilterInput>;
  FirstNameLabel?: InputMaybe<SearchableStringFilterInput>;
  GenderInputLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncorrectDateOfBirthErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  IsoCodeInputLabel?: InputMaybe<SearchableStringFilterInput>;
  LastNameLabel?: InputMaybe<SearchableStringFilterInput>;
  LatinAlphabetWarning?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddressHeader?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddressLabels?: InputMaybe<MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockWhereInput>;
  MDRTEmailContactCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  MDRTMemberDirectoryCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  MDRTSmsContactCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  MailingAddressHeader?: InputMaybe<SearchableStringFilterInput>;
  MailingAddressLabels?: InputMaybe<MembershipRenewalV2PageProfileStepV2BlockAddressInfoBlockWhereInput>;
  MiddleNameLabel?: InputMaybe<SearchableStringFilterInput>;
  MissingInformationInfoBox?: InputMaybe<MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockWhereInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NicknameLabel?: InputMaybe<SearchableStringFilterInput>;
  OptionalHeaderLabelTag?: InputMaybe<SearchableStringFilterInput>;
  PersonalInformationHeader?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberInputLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneTypeInputLabel?: InputMaybe<SearchableStringFilterInput>;
  PrefixLabel?: InputMaybe<SearchableStringFilterInput>;
  PrimaryLanguageInputLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalInformationHeader?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  SuffixLabel?: InputMaybe<SearchableStringFilterInput>;
  UpdateInformationInfoBox?: InputMaybe<MembershipRenewalV2PageProfileStepV2BlockInfoBoxBlockWhereInput>;
  YearOfBirthInputLabel?: InputMaybe<SearchableStringFilterInput>;
  YearOfFirstLicenseLabel?: InputMaybe<SearchableStringFilterInput>;
  YearOfFirstLicenseValidationLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageReceiptStepV2Block = {
  __typename?: 'MembershipRenewalV2PageReceiptStepV2Block';
  AdditionalFilingFeesLabel?: Maybe<Scalars['String']['output']>;
  ApplicationDetailsHeader?: Maybe<Scalars['String']['output']>;
  AttestToProduction?: Maybe<Scalars['String']['output']>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  BackDuesLabel?: Maybe<Scalars['String']['output']>;
  COTLevelLabel?: Maybe<Scalars['String']['output']>;
  CompanyNameLabel?: Maybe<Scalars['String']['output']>;
  CompanyPrePaymentLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DisabilityRequestedLabel?: Maybe<Scalars['String']['output']>;
  EthicsComplaintLabel?: Maybe<Scalars['String']['output']>;
  FooterAddressText?: Maybe<Scalars['String']['output']>;
  FooterPhoneText?: Maybe<Scalars['String']['output']>;
  FooterPhoneTextXhtml?: Maybe<Scalars['String']['output']>;
  GoBackButtonText?: Maybe<Scalars['String']['output']>;
  HeaderAddressText?: Maybe<Scalars['String']['output']>;
  HeaderPhoneText?: Maybe<Scalars['String']['output']>;
  HeaderTitleText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  LateFeeLabel?: Maybe<Scalars['String']['output']>;
  LifeMemberText?: Maybe<Scalars['String']['output']>;
  MDRTLevelLabel?: Maybe<Scalars['String']['output']>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  MemberDetailsHeader?: Maybe<Scalars['String']['output']>;
  MemberNameLabel?: Maybe<Scalars['String']['output']>;
  MembershipTypeLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  OrderNumberLabel?: Maybe<Scalars['String']['output']>;
  PaymentDateLabel?: Maybe<Scalars['String']['output']>;
  PaymentDetailsHeader?: Maybe<Scalars['String']['output']>;
  PaymentMethodLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PriceBreakdownHeader?: Maybe<Scalars['String']['output']>;
  PrintReceiptButtonLabel?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeMemberText?: Maybe<Scalars['String']['output']>;
  QualifyingMemberText?: Maybe<Scalars['String']['output']>;
  SelfPrePaymentLabel?: Maybe<Scalars['String']['output']>;
  StepName?: Maybe<Scalars['String']['output']>;
  TOTLevelLabel?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsLabel?: Maybe<Scalars['String']['output']>;
  TotalAmountPaidLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockAdditionalFilingFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockApplicationDetailsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockAttestToProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockBackDuesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockCotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockCompanyNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockCompanyPrePaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockDisabilityRequestedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockEthicsComplaintLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFooterAddressTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFooterPhoneTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFooterPhoneTextXhtmlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockGoBackButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockHeaderAddressTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockHeaderPhoneTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockHeaderTitleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockLateFeeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockLifeMemberTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockMdrtLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockMemberDetailsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockMemberNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockMembershipTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockOrderNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockPaymentDateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockPaymentDetailsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockPaymentMethodLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockPriceBreakdownHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockPrintReceiptButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockQualifyingAndLifeMemberTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockQualifyingMemberTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockSelfPrePaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockTotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockTermsAndConditionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockTotalAmountPaidLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageReceiptStepV2BlockFacet = {
  __typename?: 'MembershipRenewalV2PageReceiptStepV2BlockFacet';
  AdditionalFilingFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationDetailsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  AttestToProduction?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackDuesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  COTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPrePaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisabilityRequestedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EthicsComplaintLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FooterAddressText?: Maybe<Array<Maybe<StringFacet>>>;
  FooterPhoneText?: Maybe<Array<Maybe<StringFacet>>>;
  FooterPhoneTextXhtml?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderAddressText?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderPhoneText?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderTitleText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberText?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDetailsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MemberNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OrderNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentDateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentDetailsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentMethodLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PriceBreakdownHeader?: Maybe<Array<Maybe<StringFacet>>>;
  PrintReceiptButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberText?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberText?: Maybe<Array<Maybe<StringFacet>>>;
  SelfPrePaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TOTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAmountPaidLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetAdditionalFilingFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetApplicationDetailsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetAttestToProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetBackDuesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetCotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetCompanyNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetCompanyPrePaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetDisabilityRequestedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetEthicsComplaintLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetFooterAddressTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetFooterPhoneTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetFooterPhoneTextXhtmlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetGoBackButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetHeaderAddressTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetHeaderPhoneTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetHeaderTitleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetLateFeeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetLifeMemberTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetMdrtLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetMemberDetailsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetMemberNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetMembershipTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetOrderNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetPaymentDateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetPaymentDetailsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetPaymentMethodLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetPriceBreakdownHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetPrintReceiptButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetQualifyingAndLifeMemberTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetQualifyingMemberTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetSelfPrePaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetTotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetTermsAndConditionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReceiptStepV2BlockFacetTotalAmountPaidLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageReceiptStepV2BlockOrderByInput = {
  AdditionalFilingFeesLabel?: InputMaybe<OrderBy>;
  ApplicationDetailsHeader?: InputMaybe<OrderBy>;
  AttestToProduction?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  BackDuesLabel?: InputMaybe<OrderBy>;
  COTLevelLabel?: InputMaybe<OrderBy>;
  CompanyNameLabel?: InputMaybe<OrderBy>;
  CompanyPrePaymentLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisabilityRequestedLabel?: InputMaybe<OrderBy>;
  EthicsComplaintLabel?: InputMaybe<OrderBy>;
  FooterAddressText?: InputMaybe<OrderBy>;
  FooterPhoneText?: InputMaybe<OrderBy>;
  FooterPhoneTextXhtml?: InputMaybe<OrderBy>;
  GoBackButtonText?: InputMaybe<OrderBy>;
  HeaderAddressText?: InputMaybe<OrderBy>;
  HeaderPhoneText?: InputMaybe<OrderBy>;
  HeaderTitleText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  LateFeeLabel?: InputMaybe<OrderBy>;
  LifeMemberText?: InputMaybe<OrderBy>;
  MDRTLevelLabel?: InputMaybe<OrderBy>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  MemberDetailsHeader?: InputMaybe<OrderBy>;
  MemberNameLabel?: InputMaybe<OrderBy>;
  MembershipTypeLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  OrderNumberLabel?: InputMaybe<OrderBy>;
  PaymentDateLabel?: InputMaybe<OrderBy>;
  PaymentDetailsHeader?: InputMaybe<OrderBy>;
  PaymentMethodLabel?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PriceBreakdownHeader?: InputMaybe<OrderBy>;
  PrintReceiptButtonLabel?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberText?: InputMaybe<OrderBy>;
  QualifyingMemberText?: InputMaybe<OrderBy>;
  SelfPrePaymentLabel?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  TOTLevelLabel?: InputMaybe<OrderBy>;
  TermsAndConditionsLabel?: InputMaybe<OrderBy>;
  TotalAmountPaidLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageReceiptStepV2BlockWhereInput = {
  AdditionalFilingFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  ApplicationDetailsHeader?: InputMaybe<SearchableStringFilterInput>;
  AttestToProduction?: InputMaybe<SearchableStringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  BackDuesLabel?: InputMaybe<SearchableStringFilterInput>;
  COTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyNameLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyPrePaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisabilityRequestedLabel?: InputMaybe<SearchableStringFilterInput>;
  EthicsComplaintLabel?: InputMaybe<SearchableStringFilterInput>;
  FooterAddressText?: InputMaybe<SearchableStringFilterInput>;
  FooterPhoneText?: InputMaybe<SearchableStringFilterInput>;
  FooterPhoneTextXhtml?: InputMaybe<SearchableStringFilterInput>;
  GoBackButtonText?: InputMaybe<SearchableStringFilterInput>;
  HeaderAddressText?: InputMaybe<SearchableStringFilterInput>;
  HeaderPhoneText?: InputMaybe<SearchableStringFilterInput>;
  HeaderTitleText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  LateFeeLabel?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberText?: InputMaybe<SearchableStringFilterInput>;
  MDRTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  MemberDetailsHeader?: InputMaybe<SearchableStringFilterInput>;
  MemberNameLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  OrderNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentDateLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentDetailsHeader?: InputMaybe<SearchableStringFilterInput>;
  PaymentMethodLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PriceBreakdownHeader?: InputMaybe<SearchableStringFilterInput>;
  PrintReceiptButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeMemberText?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMemberText?: InputMaybe<SearchableStringFilterInput>;
  SelfPrePaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TOTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAmountPaidLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2Block = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2Block';
  AliPayPaymentLabel?: Maybe<Scalars['String']['output']>;
  AlipayHelperText?: Maybe<Scalars['String']['output']>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  COTLevelLabel?: Maybe<Scalars['String']['output']>;
  CreditCardPaymentLabel?: Maybe<Scalars['String']['output']>;
  DataMismatchModal?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlock>;
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  MDRTLevelLabel?: Maybe<Scalars['String']['output']>;
  MembershipLevelSection?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlock>;
  MembershipTypeSection?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlock>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  PaymentSectionHeading?: Maybe<Scalars['String']['output']>;
  PriceBreakdownSection?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlock>;
  ProductionDataSection?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlock>;
  StepName?: Maybe<Scalars['String']['output']>;
  TOTLevelLabel?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsCheckboxLabel?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsNotCheckedError?: Maybe<Scalars['String']['output']>;
  YourAnswersSection?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlock>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockAliPayPaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockAlipayHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockCotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockCreditCardPaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMdrtLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPaymentSectionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockTotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockTermsAndConditionsCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockTermsAndConditionsNotCheckedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlock = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlock';
  CloseButtonText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockCloseButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockFacet = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockFacet';
  CloseButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockFacetCloseButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockOrderByInput = {
  CloseButtonText?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockWhereInput = {
  CloseButtonText?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacet = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacet';
  AliPayPaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AlipayHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  COTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CreditCardPaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DataMismatchModal?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelSection?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlockFacet>;
  MembershipTypeSection?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacet>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentSectionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PriceBreakdownSection?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockFacet>;
  ProductionDataSection?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockFacet>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  TOTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsNotCheckedError?: Maybe<Array<Maybe<StringFacet>>>;
  YourAnswersSection?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacet>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetAliPayPaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetAlipayHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetCotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetCreditCardPaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetMdrtLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetPaymentSectionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetTotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetTermsAndConditionsCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockFacetTermsAndConditionsNotCheckedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlock = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlock';
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlockFacet = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlockFacet';
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlockOrderByInput = {
  BlockReplacementText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlockWhereInput = {
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlock = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlock';
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  LifeMemberLabel?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeMemberLabel?: Maybe<Scalars['String']['output']>;
  QualifyingMemberLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockQualifyingAndLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockQualifyingMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacet = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacet';
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacetLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacetQualifyingAndLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacetQualifyingMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockOrderByInput = {
  BlockReplacementText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  LifeMemberLabel?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberLabel?: InputMaybe<OrderBy>;
  QualifyingMemberLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockWhereInput = {
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMemberLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockOrderByInput = {
  AliPayPaymentLabel?: InputMaybe<OrderBy>;
  AlipayHelperText?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  COTLevelLabel?: InputMaybe<OrderBy>;
  CreditCardPaymentLabel?: InputMaybe<OrderBy>;
  DataMismatchModal?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  MDRTLevelLabel?: InputMaybe<OrderBy>;
  MembershipLevelSection?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlockOrderByInput>;
  MembershipTypeSection?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockOrderByInput>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  PaymentSectionHeading?: InputMaybe<OrderBy>;
  PriceBreakdownSection?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockOrderByInput>;
  ProductionDataSection?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockOrderByInput>;
  StepName?: InputMaybe<OrderBy>;
  TOTLevelLabel?: InputMaybe<OrderBy>;
  TermsAndConditionsCheckboxLabel?: InputMaybe<OrderBy>;
  TermsAndConditionsNotCheckedError?: InputMaybe<OrderBy>;
  YourAnswersSection?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockOrderByInput>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlock = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlock';
  BackDueLabel?: Maybe<Scalars['String']['output']>;
  BackDueTooltip?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlock>;
  CompanyPrepaymentLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  LateFeesTooltip?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlock>;
  PrepaymentLabel?: Maybe<Scalars['String']['output']>;
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockBackDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockCompanyPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockFacet = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockFacet';
  BackDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackDueTooltip?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacet>;
  CompanyPrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeesTooltip?: Maybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacet>;
  PrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetBackDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetCompanyPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockOrderByInput = {
  BackDueLabel?: InputMaybe<OrderBy>;
  BackDueTooltip?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockOrderByInput>;
  CompanyPrepaymentLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  LateFeesTooltip?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockOrderByInput>;
  PrepaymentLabel?: InputMaybe<OrderBy>;
  TotalDueLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlock = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacet = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockWhereInput = {
  BackDueLabel?: InputMaybe<SearchableStringFilterInput>;
  BackDueTooltip?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockWhereInput>;
  CompanyPrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  LateFeesTooltip?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockWhereInput>;
  PrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlock = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlock';
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  CommissionLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncomeLabel?: Maybe<Scalars['String']['output']>;
  LifeMemberAttestmentText?: Maybe<Scalars['String']['output']>;
  PoliciesLabel?: Maybe<Scalars['String']['output']>;
  PolicyLabel?: Maybe<Scalars['String']['output']>;
  PremiumLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockCommissionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockLifeMemberAttestmentTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockPoliciesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockPolicyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockPremiumLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockFacet = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockFacet';
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberAttestmentText?: Maybe<Array<Maybe<StringFacet>>>;
  PoliciesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PolicyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetCommissionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetLifeMemberAttestmentTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetPoliciesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetPolicyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetPremiumLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockOrderByInput = {
  BlockReplacementText?: InputMaybe<OrderBy>;
  CommissionLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IncomeLabel?: InputMaybe<OrderBy>;
  LifeMemberAttestmentText?: InputMaybe<OrderBy>;
  PoliciesLabel?: InputMaybe<OrderBy>;
  PolicyLabel?: InputMaybe<OrderBy>;
  PremiumLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockWhereInput = {
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  CommissionLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberAttestmentText?: InputMaybe<SearchableStringFilterInput>;
  PoliciesLabel?: InputMaybe<SearchableStringFilterInput>;
  PolicyLabel?: InputMaybe<SearchableStringFilterInput>;
  PremiumLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockWhereInput = {
  AliPayPaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  AlipayHelperText?: InputMaybe<SearchableStringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  COTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  CreditCardPaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  DataMismatchModal?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockDataMismatchModalBlockWhereInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  MDRTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelSection?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipLevelSectionBlockWhereInput>;
  MembershipTypeSection?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockMembershipTypeSectionBlockWhereInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentSectionHeading?: InputMaybe<SearchableStringFilterInput>;
  PriceBreakdownSection?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockPriceBreakdownBlockWhereInput>;
  ProductionDataSection?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockProductionDataSectionBlockWhereInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  TOTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsNotCheckedError?: InputMaybe<SearchableStringFilterInput>;
  YourAnswersSection?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockWhereInput>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlock = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlock';
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  FirstQuestionLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  SecondQuestionLabel?: Maybe<Scalars['String']['output']>;
  ThirdQuestionLabel?: Maybe<Scalars['String']['output']>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockFirstQuestionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockSecondQuestionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockThirdQuestionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacet = {
  __typename?: 'MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacet';
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  FirstQuestionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  SecondQuestionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ThirdQuestionLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacetFirstQuestionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacetSecondQuestionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacetThirdQuestionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockOrderByInput = {
  BlockReplacementText?: InputMaybe<OrderBy>;
  FirstQuestionLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  SecondQuestionLabel?: InputMaybe<OrderBy>;
  ThirdQuestionLabel?: InputMaybe<OrderBy>;
};

export type MembershipRenewalV2PageReviewAndSubmitStepV2BlockYourAnswersSectionBlockWhereInput = {
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  FirstQuestionLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  SecondQuestionLabel?: InputMaybe<SearchableStringFilterInput>;
  ThirdQuestionLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRenewalV2PageWhereInput = {
  AccountLabel?: InputMaybe<SearchableStringFilterInput>;
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  CancelUpgradeLabel?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationModal?: InputMaybe<MembershipRenewalV2PageConfirmationModalBlockWhereInput>;
  CongratulationsStep?: InputMaybe<MembershipRenewalV2PageCongratulationsStepV2BlockWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DeleteLabel?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  EditLabel?: InputMaybe<SearchableStringFilterInput>;
  ErrorModal?: InputMaybe<MembershipRenewalV2PageErrorModalBlockWhereInput>;
  ErrorPage?: InputMaybe<MembershipRenewalV2PageErrorPageBlockWhereInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FormHasRequiredErrorsLabel?: InputMaybe<SearchableStringFilterInput>;
  GenericHomeButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  GettingStartedStep?: InputMaybe<MembershipRenewalV2PageGettingStartedStepV2BlockWhereInput>;
  GreetingStep?: InputMaybe<MembershipRenewalV2PageGreetingStepV2BlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeesTooltip?: InputMaybe<SearchableStringFilterInput>;
  LoaderScreen?: InputMaybe<MembershipRenewalV2PageLoaderBlockWhereInput>;
  LogoutLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipLevelStep?: InputMaybe<MembershipRenewalV2PageMembershipLevelStepV2BlockWhereInput>;
  MembershipTypeStep?: InputMaybe<MembershipRenewalV2PageMembershipTypeStepV2BlockWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<MembershipRenewalV2PageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavHeadingLabel?: InputMaybe<SearchableStringFilterInput>;
  NoLabel?: InputMaybe<SearchableStringFilterInput>;
  NotFoundPage?: InputMaybe<MembershipRenewalV2PageErrorPageBlockWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentProcessingLoaderText?: InputMaybe<SearchableStringFilterInput>;
  ProcessingScreen?: InputMaybe<MembershipRenewalV2PagePaymentProcessingScreenBlockWhereInput>;
  ProductionStep?: InputMaybe<MembershipRenewalV2PageProductionStepV2BlockWhereInput>;
  ProfileStep?: InputMaybe<MembershipRenewalV2PageProfileStepV2BlockWhereInput>;
  QuestionsHeading?: InputMaybe<SearchableStringFilterInput>;
  ReceiptStep?: InputMaybe<MembershipRenewalV2PageReceiptStepV2BlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RequiredErrorFieldLabel?: InputMaybe<SearchableStringFilterInput>;
  ReviewAndSubmitStep?: InputMaybe<MembershipRenewalV2PageReviewAndSubmitStepV2BlockWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelectLanguageHeading?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepDisplayLabel?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<MembershipRenewalV2PageImageBlockWhereInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  YesLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipRenewalV2PageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipRenewalV2PageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipRenewalV2PageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type MembershipRequirementBlock = IContent & IData & {
  __typename?: 'MembershipRequirementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CoTDues?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ConversionFactorsDescription?: Maybe<Scalars['String']['output']>;
  ConversionFactorsDownloadLink?: Maybe<MembershipRequirementBlockLinkBlock>;
  Created?: Maybe<Scalars['Date']['output']>;
  CurrencyDocument?: Maybe<ContentModelReference>;
  Date?: Maybe<Scalars['Date']['output']>;
  DownloadRequirementsLink?: Maybe<MembershipRequirementBlockLinkBlock>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  GenericProductionFooterText?: Maybe<Scalars['String']['output']>;
  IncomeCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MemberDues?: Maybe<Scalars['Int']['output']>;
  /** Enter the Country Iso Code as the key */
  MonthlyGoalCharts?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Name?: Maybe<Scalars['String']['output']>;
  NonCoreDownloadRequirementsLink?: Maybe<MembershipRequirementBlockLinkBlock>;
  NonCoreIncomeCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlock>;
  NonCorePremiumAndCommissionCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlock>;
  ParentLink?: Maybe<ContentModelReference>;
  PremiumAndCommissionCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlock>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SpecificProductionFooterText?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  ToTDues?: Maybe<Scalars['Int']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type MembershipRequirementBlockConversionFactorsDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlockGenericProductionFooterTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlockMonthlyGoalChartsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlockSpecificProductionFooterTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipRequirementBlockAutocomplete = {
  __typename?: 'MembershipRequirementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ConversionFactorsDownloadLink?: Maybe<MembershipRequirementBlockLinkBlockAutocomplete>;
  CurrencyDocument?: Maybe<ContentModelReferenceAutocomplete>;
  DownloadRequirementsLink?: Maybe<MembershipRequirementBlockLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  IncomeCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  NonCoreDownloadRequirementsLink?: Maybe<MembershipRequirementBlockLinkBlockAutocomplete>;
  NonCoreIncomeCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlockAutocomplete>;
  NonCorePremiumAndCommissionCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PremiumAndCommissionCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlockAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRequirementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRequirementBlockFacet = {
  __typename?: 'MembershipRequirementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CoTDues?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ConversionFactorsDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ConversionFactorsDownloadLink?: Maybe<MembershipRequirementBlockLinkBlockFacet>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CurrencyDocument?: Maybe<ContentModelReferenceFacet>;
  Date?: Maybe<Array<Maybe<DateFacet>>>;
  DownloadRequirementsLink?: Maybe<MembershipRequirementBlockLinkBlockFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GenericProductionFooterText?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MemberDues?: Maybe<Array<Maybe<NumberFacet>>>;
  MonthlyGoalCharts?: Maybe<ContentAreaItemModelSearchFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NonCoreDownloadRequirementsLink?: Maybe<MembershipRequirementBlockLinkBlockFacet>;
  NonCoreIncomeCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlockFacet>;
  NonCorePremiumAndCommissionCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlockFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PremiumAndCommissionCertifyingLetters?: Maybe<MembershipRequirementBlockLinkBlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SpecificProductionFooterText?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ToTDues?: Maybe<Array<Maybe<NumberFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipRequirementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRequirementBlockFacetCoTDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRequirementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetConversionFactorsDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRequirementBlockFacetDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRequirementBlockFacetGenericProductionFooterTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetMemberDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRequirementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRequirementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetSpecificProductionFooterTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRequirementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRequirementBlockFacetToTDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRequirementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipRequirementBlockLinkBlock = {
  __typename?: 'MembershipRequirementBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type MembershipRequirementBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRequirementBlockLinkBlockAutocomplete = {
  __typename?: 'MembershipRequirementBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRequirementBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRequirementBlockLinkBlockFacet = {
  __typename?: 'MembershipRequirementBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRequirementBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRequirementBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRequirementBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type MembershipRequirementBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRequirementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CoTDues?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ConversionFactorsDescription?: InputMaybe<OrderBy>;
  ConversionFactorsDownloadLink?: InputMaybe<MembershipRequirementBlockLinkBlockOrderByInput>;
  Created?: InputMaybe<OrderBy>;
  CurrencyDocument?: InputMaybe<ContentModelReferenceOrderByInput>;
  Date?: InputMaybe<OrderBy>;
  DownloadRequirementsLink?: InputMaybe<MembershipRequirementBlockLinkBlockOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GenericProductionFooterText?: InputMaybe<OrderBy>;
  IncomeCertifyingLetters?: InputMaybe<MembershipRequirementBlockLinkBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MemberDues?: InputMaybe<OrderBy>;
  MonthlyGoalCharts?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NonCoreDownloadRequirementsLink?: InputMaybe<MembershipRequirementBlockLinkBlockOrderByInput>;
  NonCoreIncomeCertifyingLetters?: InputMaybe<MembershipRequirementBlockLinkBlockOrderByInput>;
  NonCorePremiumAndCommissionCertifyingLetters?: InputMaybe<MembershipRequirementBlockLinkBlockOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PremiumAndCommissionCertifyingLetters?: InputMaybe<MembershipRequirementBlockLinkBlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SpecificProductionFooterText?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ToTDues?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipRequirementBlockOutput = {
  __typename?: 'MembershipRequirementBlockOutput';
  autocomplete?: Maybe<MembershipRequirementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipRequirementBlockFacet>;
  item?: Maybe<MembershipRequirementBlock>;
  items?: Maybe<Array<Maybe<MembershipRequirementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipRequirementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipRequirementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CoTDues?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ConversionFactorsDescription?: InputMaybe<SearchableStringFilterInput>;
  ConversionFactorsDownloadLink?: InputMaybe<MembershipRequirementBlockLinkBlockWhereInput>;
  Created?: InputMaybe<DateFilterInput>;
  CurrencyDocument?: InputMaybe<ContentModelReferenceWhereInput>;
  Date?: InputMaybe<DateFilterInput>;
  DownloadRequirementsLink?: InputMaybe<MembershipRequirementBlockLinkBlockWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GenericProductionFooterText?: InputMaybe<SearchableStringFilterInput>;
  IncomeCertifyingLetters?: InputMaybe<MembershipRequirementBlockLinkBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MemberDues?: InputMaybe<IntFilterInput>;
  MonthlyGoalCharts?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NonCoreDownloadRequirementsLink?: InputMaybe<MembershipRequirementBlockLinkBlockWhereInput>;
  NonCoreIncomeCertifyingLetters?: InputMaybe<MembershipRequirementBlockLinkBlockWhereInput>;
  NonCorePremiumAndCommissionCertifyingLetters?: InputMaybe<MembershipRequirementBlockLinkBlockWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PremiumAndCommissionCertifyingLetters?: InputMaybe<MembershipRequirementBlockLinkBlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SpecificProductionFooterText?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ToTDues?: InputMaybe<IntFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipRequirementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipRequirementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipRequirementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type MembershipRequirementsBlock = IContent & IData & {
  __typename?: 'MembershipRequirementsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  CertifyingLettersAnchorLabel?: Maybe<Scalars['String']['output']>;
  CertifyingLettersAnchorLink?: Maybe<Scalars['String']['output']>;
  CertifyingLettersDescription?: Maybe<Scalars['String']['output']>;
  CertifyingLettersFindOfficerLink?: Maybe<MembershipRequirementsBlockLinkBlock>;
  CertifyingLettersStepLabel?: Maybe<Scalars['String']['output']>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Contacts?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ConversionFactorsStepLabel?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  EthicalCodeAnchorLabel?: Maybe<Scalars['String']['output']>;
  EthicalCodeAnchorLink?: Maybe<Scalars['String']['output']>;
  EthicalCodeDescription?: Maybe<Scalars['String']['output']>;
  EthicalCodeStepLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MembershipDuesAnchorLabel?: Maybe<Scalars['String']['output']>;
  MembershipDuesAnchorLink?: Maybe<Scalars['String']['output']>;
  MembershipDuesDescription?: Maybe<Scalars['String']['output']>;
  MembershipDuesStepLabel?: Maybe<Scalars['String']['output']>;
  MembershipRequirementBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MembershipTableCoTHeading?: Maybe<Scalars['String']['output']>;
  MembershipTableCommissionRowHeading?: Maybe<Scalars['String']['output']>;
  MembershipTableIncomeRowHeading?: Maybe<Scalars['String']['output']>;
  MembershipTableMemberHeading?: Maybe<Scalars['String']['output']>;
  MembershipTableName?: Maybe<Scalars['String']['output']>;
  MembershipTablePremiumRowHeading?: Maybe<Scalars['String']['output']>;
  MembershipTableToTHeading?: Maybe<Scalars['String']['output']>;
  MonthlyGoalChartsLinkText?: Maybe<Scalars['String']['output']>;
  MonthlyGoalStepName?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NoRequirementsLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  ProductionApiErrorLabel?: Maybe<Scalars['String']['output']>;
  ProductionRequirementsAnchorLabel?: Maybe<Scalars['String']['output']>;
  ProductionRequirementsAnchorLink?: Maybe<Scalars['String']['output']>;
  ProductionRequirementsMonthlyGoalDescription?: Maybe<Scalars['String']['output']>;
  ProductionRequirementsStepLabel?: Maybe<Scalars['String']['output']>;
  ProfessionalAssociationsDescription?: Maybe<Scalars['String']['output']>;
  ProfessionalAssociationsStepLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewMembershipRequirementsLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type MembershipRequirementsBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockCertifyingLettersAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockCertifyingLettersAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockCertifyingLettersDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockCertifyingLettersStepLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockContactsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockConversionFactorsStepLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockEthicalCodeAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockEthicalCodeAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockEthicalCodeDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockEthicalCodeStepLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipDuesAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipDuesAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipDuesDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipDuesStepLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipRequirementBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipTableCoTHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipTableCommissionRowHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipTableIncomeRowHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipTableMemberHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipTableNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipTablePremiumRowHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMembershipTableToTHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMonthlyGoalChartsLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockMonthlyGoalStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockNoRequirementsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockProductionApiErrorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockProductionRequirementsAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockProductionRequirementsAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockProductionRequirementsMonthlyGoalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockProductionRequirementsStepLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockProfessionalAssociationsDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockProfessionalAssociationsStepLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockViewMembershipRequirementsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipRequirementsBlockAutocomplete = {
  __typename?: 'MembershipRequirementsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  CertifyingLettersFindOfficerLink?: Maybe<MembershipRequirementsBlockLinkBlockAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRequirementsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipRequirementsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRequirementsBlockFacet = {
  __typename?: 'MembershipRequirementsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  CertifyingLettersAnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersAnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersDescription?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersFindOfficerLink?: Maybe<MembershipRequirementsBlockLinkBlockFacet>;
  CertifyingLettersStepLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Contacts?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ConversionFactorsStepLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EthicalCodeAnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalCodeAnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalCodeDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalCodeStepLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipDuesAnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipDuesAnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipDuesDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipDuesStepLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipRequirementBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  MembershipTableCoTHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTableCommissionRowHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTableIncomeRowHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTableMemberHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTableName?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTablePremiumRowHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTableToTHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MonthlyGoalChartsLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  MonthlyGoalStepName?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NoRequirementsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ProductionApiErrorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionRequirementsAnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionRequirementsAnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionRequirementsMonthlyGoalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionRequirementsStepLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalAssociationsDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalAssociationsStepLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMembershipRequirementsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipRequirementsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetCertifyingLettersAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetCertifyingLettersAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetCertifyingLettersDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetCertifyingLettersStepLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRequirementsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetConversionFactorsStepLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRequirementsBlockFacetEthicalCodeAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetEthicalCodeAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetEthicalCodeDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetEthicalCodeStepLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRequirementsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMembershipDuesAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMembershipDuesAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMembershipDuesDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMembershipDuesStepLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMembershipTableCoTHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMembershipTableCommissionRowHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMembershipTableIncomeRowHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMembershipTableMemberHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMembershipTableNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMembershipTablePremiumRowHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMembershipTableToTHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMonthlyGoalChartsLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetMonthlyGoalStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetNoRequirementsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetProductionApiErrorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetProductionRequirementsAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetProductionRequirementsAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetProductionRequirementsMonthlyGoalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetProductionRequirementsStepLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetProfessionalAssociationsDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetProfessionalAssociationsStepLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRequirementsBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRequirementsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipRequirementsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacetViewMembershipRequirementsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipRequirementsBlockLinkBlock = {
  __typename?: 'MembershipRequirementsBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type MembershipRequirementsBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipRequirementsBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MembershipRequirementsBlockLinkBlockAutocomplete = {
  __typename?: 'MembershipRequirementsBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipRequirementsBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipRequirementsBlockLinkBlockFacet = {
  __typename?: 'MembershipRequirementsBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MembershipRequirementsBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MembershipRequirementsBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipRequirementsBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MembershipRequirementsBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type MembershipRequirementsBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type MembershipRequirementsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  CertifyingLettersAnchorLabel?: InputMaybe<OrderBy>;
  CertifyingLettersAnchorLink?: InputMaybe<OrderBy>;
  CertifyingLettersDescription?: InputMaybe<OrderBy>;
  CertifyingLettersFindOfficerLink?: InputMaybe<MembershipRequirementsBlockLinkBlockOrderByInput>;
  CertifyingLettersStepLabel?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  Contacts?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ConversionFactorsStepLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EthicalCodeAnchorLabel?: InputMaybe<OrderBy>;
  EthicalCodeAnchorLink?: InputMaybe<OrderBy>;
  EthicalCodeDescription?: InputMaybe<OrderBy>;
  EthicalCodeStepLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipDuesAnchorLabel?: InputMaybe<OrderBy>;
  MembershipDuesAnchorLink?: InputMaybe<OrderBy>;
  MembershipDuesDescription?: InputMaybe<OrderBy>;
  MembershipDuesStepLabel?: InputMaybe<OrderBy>;
  MembershipRequirementBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MembershipTableCoTHeading?: InputMaybe<OrderBy>;
  MembershipTableCommissionRowHeading?: InputMaybe<OrderBy>;
  MembershipTableIncomeRowHeading?: InputMaybe<OrderBy>;
  MembershipTableMemberHeading?: InputMaybe<OrderBy>;
  MembershipTableName?: InputMaybe<OrderBy>;
  MembershipTablePremiumRowHeading?: InputMaybe<OrderBy>;
  MembershipTableToTHeading?: InputMaybe<OrderBy>;
  MonthlyGoalChartsLinkText?: InputMaybe<OrderBy>;
  MonthlyGoalStepName?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NoRequirementsLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ProductionApiErrorLabel?: InputMaybe<OrderBy>;
  ProductionRequirementsAnchorLabel?: InputMaybe<OrderBy>;
  ProductionRequirementsAnchorLink?: InputMaybe<OrderBy>;
  ProductionRequirementsMonthlyGoalDescription?: InputMaybe<OrderBy>;
  ProductionRequirementsStepLabel?: InputMaybe<OrderBy>;
  ProfessionalAssociationsDescription?: InputMaybe<OrderBy>;
  ProfessionalAssociationsStepLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ViewMembershipRequirementsLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipRequirementsBlockOutput = {
  __typename?: 'MembershipRequirementsBlockOutput';
  autocomplete?: Maybe<MembershipRequirementsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipRequirementsBlockFacet>;
  item?: Maybe<MembershipRequirementsBlock>;
  items?: Maybe<Array<Maybe<MembershipRequirementsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipRequirementsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipRequirementsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  CertifyingLettersAnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersAnchorLink?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersDescription?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersFindOfficerLink?: InputMaybe<MembershipRequirementsBlockLinkBlockWhereInput>;
  CertifyingLettersStepLabel?: InputMaybe<SearchableStringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Contacts?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ConversionFactorsStepLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EthicalCodeAnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  EthicalCodeAnchorLink?: InputMaybe<SearchableStringFilterInput>;
  EthicalCodeDescription?: InputMaybe<SearchableStringFilterInput>;
  EthicalCodeStepLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipDuesAnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipDuesAnchorLink?: InputMaybe<SearchableStringFilterInput>;
  MembershipDuesDescription?: InputMaybe<SearchableStringFilterInput>;
  MembershipDuesStepLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipRequirementBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MembershipTableCoTHeading?: InputMaybe<SearchableStringFilterInput>;
  MembershipTableCommissionRowHeading?: InputMaybe<SearchableStringFilterInput>;
  MembershipTableIncomeRowHeading?: InputMaybe<SearchableStringFilterInput>;
  MembershipTableMemberHeading?: InputMaybe<SearchableStringFilterInput>;
  MembershipTableName?: InputMaybe<SearchableStringFilterInput>;
  MembershipTablePremiumRowHeading?: InputMaybe<SearchableStringFilterInput>;
  MembershipTableToTHeading?: InputMaybe<SearchableStringFilterInput>;
  MonthlyGoalChartsLinkText?: InputMaybe<SearchableStringFilterInput>;
  MonthlyGoalStepName?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NoRequirementsLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ProductionApiErrorLabel?: InputMaybe<SearchableStringFilterInput>;
  ProductionRequirementsAnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  ProductionRequirementsAnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ProductionRequirementsMonthlyGoalDescription?: InputMaybe<SearchableStringFilterInput>;
  ProductionRequirementsStepLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalAssociationsDescription?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalAssociationsStepLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewMembershipRequirementsLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipRequirementsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipRequirementsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipRequirementsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type MembershipTypeSectionBlock = IContent & IData & {
  __typename?: 'MembershipTypeSectionBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LifeMemberLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  QualifyingAndLifeMemberLabel?: Maybe<Scalars['String']['output']>;
  QualifyingMemberLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type MembershipTypeSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipTypeSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipTypeSectionBlockLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipTypeSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipTypeSectionBlockQualifyingAndLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipTypeSectionBlockQualifyingMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipTypeSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MembershipTypeSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipTypeSectionBlockAutocomplete = {
  __typename?: 'MembershipTypeSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipTypeSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipTypeSectionBlockFacet = {
  __typename?: 'MembershipTypeSectionBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  QualifyingAndLifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipTypeSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetQualifyingAndLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetQualifyingMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipTypeSectionBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BlockReplacementText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LifeMemberLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  QualifyingAndLifeMemberLabel?: InputMaybe<OrderBy>;
  QualifyingMemberLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipTypeSectionBlockOutput = {
  __typename?: 'MembershipTypeSectionBlockOutput';
  autocomplete?: Maybe<MembershipTypeSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipTypeSectionBlockFacet>;
  item?: Maybe<MembershipTypeSectionBlock>;
  items?: Maybe<Array<Maybe<MembershipTypeSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipTypeSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipTypeSectionBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  QualifyingAndLifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipTypeSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipTypeSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipTypeSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlock = IContent & IData & {
  __typename?: 'MembershipTypeStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Use placeholders {{backDues}} and {{yearsLapsed}} where you would like to show the backdue information */
  BackduesModalAmount?: Maybe<Scalars['String']['output']>;
  BackduesModalCancelButtonLabel?: Maybe<Scalars['String']['output']>;
  BackduesModalContinueButtonLabel?: Maybe<Scalars['String']['output']>;
  BackduesModalDescription?: Maybe<Scalars['String']['output']>;
  BackduesModalTotalLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CoTMembershipLevel?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Use {{membershipType}} to replace with the users membership type */
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Text for the Qualifying and Life Member description. Use placeholder {{membershipLevels}} where you would like to show the clickable text that opens the Membership Levels modal */
  LifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  LifeMemberLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtMembershipLevel?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MembershipLevelModalDescription?: Maybe<Scalars['String']['output']>;
  /** Displayed on the bottom of the modal */
  MembershipLevelModalFooter?: Maybe<Scalars['String']['output']>;
  MembershipLevelModalHeading?: Maybe<Scalars['String']['output']>;
  /** Displayed on the bottom of the modal */
  MembershipLevelModalRequirementsFooter?: Maybe<Scalars['String']['output']>;
  /** The link text for the Membership Levels modal link */
  MembershipLevelsLabel?: Maybe<Scalars['String']['output']>;
  MembershipTypeContinueError?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Text for the Qualifying and Life Member description. Use placeholder {{membershipLevels}} where you would like the clickable modal link to view Membership Levels */
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingAndLifeMemberLabel?: Maybe<Scalars['String']['output']>;
  /** Text for the Qualifying Member description. Use placeholder {{membershipLevels}} where you would like the clickable modal link to view Membership Levels */
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingMemberLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TenYearLifeMemberDescription?: Maybe<Scalars['String']['output']>;
  ToTMembershipLevel?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockBackduesModalAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockBackduesModalCancelButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockBackduesModalContinueButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockBackduesModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockBackduesModalTotalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockCoTMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockMdrtMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockMembershipLevelModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockMembershipLevelModalFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockMembershipLevelModalHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockMembershipLevelModalRequirementsFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockMembershipLevelsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockMembershipTypeContinueErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockQualifyingAndLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockQualifyingMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockTenYearLifeMemberDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlockToTMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipTypeStepBlockAutocomplete = {
  __typename?: 'MembershipTypeStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipTypeStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocompleteLifeMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocompleteQualifyingAndLifeMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocompleteQualifyingMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipTypeStepBlockFacet = {
  __typename?: 'MembershipTypeStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesModalAmount?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesModalCancelButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesModalContinueButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesModalTotalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CoTMembershipLevel?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LifeMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtMembershipLevel?: Maybe<ContentAreaItemModelSearchFacet>;
  MembershipLevelModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelModalFooter?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelModalHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelModalRequirementsFooter?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTypeContinueError?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TenYearLifeMemberDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ToTMembershipLevel?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipTypeStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetBackduesModalAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetBackduesModalCancelButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetBackduesModalContinueButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetBackduesModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetBackduesModalTotalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetLifeMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetMembershipLevelModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetMembershipLevelModalFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetMembershipLevelModalHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetMembershipLevelModalRequirementsFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetMembershipLevelsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetMembershipTypeContinueErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetQualifyingAndLifeMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetQualifyingAndLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetQualifyingMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetQualifyingMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeStepBlockFacetTenYearLifeMemberDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipTypeStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackduesModalAmount?: InputMaybe<OrderBy>;
  BackduesModalCancelButtonLabel?: InputMaybe<OrderBy>;
  BackduesModalContinueButtonLabel?: InputMaybe<OrderBy>;
  BackduesModalDescription?: InputMaybe<OrderBy>;
  BackduesModalTotalLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CoTMembershipLevel?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LifeMemberDescriptions?: InputMaybe<OrderBy>;
  LifeMemberLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtMembershipLevel?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MembershipLevelModalDescription?: InputMaybe<OrderBy>;
  MembershipLevelModalFooter?: InputMaybe<OrderBy>;
  MembershipLevelModalHeading?: InputMaybe<OrderBy>;
  MembershipLevelModalRequirementsFooter?: InputMaybe<OrderBy>;
  MembershipLevelsLabel?: InputMaybe<OrderBy>;
  MembershipTypeContinueError?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  QualifyingAndLifeMemberDescriptions?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberLabel?: InputMaybe<OrderBy>;
  QualifyingMemberDescriptions?: InputMaybe<OrderBy>;
  QualifyingMemberLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TenYearLifeMemberDescription?: InputMaybe<OrderBy>;
  ToTMembershipLevel?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipTypeStepBlockOutput = {
  __typename?: 'MembershipTypeStepBlockOutput';
  autocomplete?: Maybe<MembershipTypeStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipTypeStepBlockFacet>;
  item?: Maybe<MembershipTypeStepBlock>;
  items?: Maybe<Array<Maybe<MembershipTypeStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipTypeStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipTypeStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackduesModalAmount?: InputMaybe<SearchableStringFilterInput>;
  BackduesModalCancelButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  BackduesModalContinueButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  BackduesModalDescription?: InputMaybe<SearchableStringFilterInput>;
  BackduesModalTotalLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CoTMembershipLevel?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LifeMemberDescriptions?: InputMaybe<StringFilterInput>;
  LifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtMembershipLevel?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MembershipLevelModalDescription?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelModalFooter?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelModalHeading?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelModalRequirementsFooter?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipTypeContinueError?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  QualifyingAndLifeMemberDescriptions?: InputMaybe<StringFilterInput>;
  QualifyingAndLifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMemberDescriptions?: InputMaybe<StringFilterInput>;
  QualifyingMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TenYearLifeMemberDescription?: InputMaybe<SearchableStringFilterInput>;
  ToTMembershipLevel?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipTypeStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipTypeStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipTypeStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2Block = IContent & IData & {
  __typename?: 'MembershipTypeStepV2Block';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  /** Use placeholders {{backDues}} where you would like to show the backdue information */
  BackduesAmount?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Text for the Life Member description. Use placeholder {{backDues}} where you would like to show dum of back dues */
  LifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  LifeMemberLabel?: Maybe<Scalars['String']['output']>;
  LifeMemberTotWaiverSuggestion?: Maybe<Scalars['String']['output']>;
  LifeMemberWarning?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Text for the Qualifying and Life Member description. Use placeholder {{backDues}} where you would like to show dum of back dues */
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingAndLifeMemberLabel?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeMemberWarning?: Maybe<Scalars['String']['output']>;
  /** Text for the Qualifying Member description. */
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingMemberLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockBackduesAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockLifeMemberTotWaiverSuggestionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockLifeMemberWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockQualifyingAndLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockQualifyingAndLifeMemberWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockQualifyingMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type MembershipTypeStepV2Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MembershipTypeStepV2BlockAutocomplete = {
  __typename?: 'MembershipTypeStepV2BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MembershipTypeStepV2BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocompleteLifeMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocompleteQualifyingAndLifeMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocompleteQualifyingMemberDescriptionsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MembershipTypeStepV2BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MembershipTypeStepV2BlockFacet = {
  __typename?: 'MembershipTypeStepV2BlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesAmount?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LifeMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberTotWaiverSuggestion?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberWarning?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  QualifyingAndLifeMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberWarning?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberDescriptions?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MembershipTypeStepV2BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetBackduesAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeStepV2BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetLifeMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetLifeMemberTotWaiverSuggestionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetLifeMemberWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetQualifyingAndLifeMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetQualifyingAndLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetQualifyingAndLifeMemberWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetQualifyingMemberDescriptionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetQualifyingMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeStepV2BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeStepV2BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipTypeStepV2BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MembershipTypeStepV2BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MembershipTypeStepV2BlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  BackduesAmount?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LifeMemberDescriptions?: InputMaybe<OrderBy>;
  LifeMemberLabel?: InputMaybe<OrderBy>;
  LifeMemberTotWaiverSuggestion?: InputMaybe<OrderBy>;
  LifeMemberWarning?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  QualifyingAndLifeMemberDescriptions?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberLabel?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberWarning?: InputMaybe<OrderBy>;
  QualifyingMemberDescriptions?: InputMaybe<OrderBy>;
  QualifyingMemberLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MembershipTypeStepV2BlockOutput = {
  __typename?: 'MembershipTypeStepV2BlockOutput';
  autocomplete?: Maybe<MembershipTypeStepV2BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MembershipTypeStepV2BlockFacet>;
  item?: Maybe<MembershipTypeStepV2Block>;
  items?: Maybe<Array<Maybe<MembershipTypeStepV2Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MembershipTypeStepV2BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipTypeStepV2BlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  BackduesAmount?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LifeMemberDescriptions?: InputMaybe<StringFilterInput>;
  LifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberTotWaiverSuggestion?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberWarning?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  QualifyingAndLifeMemberDescriptions?: InputMaybe<StringFilterInput>;
  QualifyingAndLifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeMemberWarning?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMemberDescriptions?: InputMaybe<StringFilterInput>;
  QualifyingMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MembershipTypeStepV2BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MembershipTypeStepV2BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MembershipTypeStepV2BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ModalInfoBlock = IContent & IData & {
  __typename?: 'ModalInfoBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CancelButtonText?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConfirmButtonText?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FooterText?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ModalInfoBlockCancelButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ModalInfoBlockConfirmButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ModalInfoBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ModalInfoBlockFooterTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ModalInfoBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ModalInfoBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ModalInfoBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ModalInfoBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ModalInfoBlockAutocomplete = {
  __typename?: 'ModalInfoBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ModalInfoBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ModalInfoBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ModalInfoBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ModalInfoBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ModalInfoBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ModalInfoBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ModalInfoBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ModalInfoBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ModalInfoBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ModalInfoBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ModalInfoBlockFacet = {
  __typename?: 'ModalInfoBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CancelButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FooterText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ModalInfoBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetCancelButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ModalInfoBlockFacetConfirmButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ModalInfoBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetFooterTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ModalInfoBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ModalInfoBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ModalInfoBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ModalInfoBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ModalInfoBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CancelButtonText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmButtonText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FooterText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ModalInfoBlockOutput = {
  __typename?: 'ModalInfoBlockOutput';
  autocomplete?: Maybe<ModalInfoBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ModalInfoBlockFacet>;
  item?: Maybe<ModalInfoBlock>;
  items?: Maybe<Array<Maybe<ModalInfoBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ModalInfoBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModalInfoBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CancelButtonText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmButtonText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FooterText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ModalInfoBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ModalInfoBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ModalInfoBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlock = IContent & IData & {
  __typename?: 'NewIDRequestSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BirthYear?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine1?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine2?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine3?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  CompanyID?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Country?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Designation1?: Maybe<Scalars['String']['output']>;
  Designation2?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastName?: Maybe<Scalars['String']['output']>;
  LocalLanguageCity?: Maybe<Scalars['String']['output']>;
  LocalLanguageCountry?: Maybe<Scalars['String']['output']>;
  LocalLanguageLine1?: Maybe<Scalars['String']['output']>;
  LocalLanguageLine2?: Maybe<Scalars['String']['output']>;
  LocalLanguageLine3?: Maybe<Scalars['String']['output']>;
  LocalLanguageName?: Maybe<Scalars['String']['output']>;
  LocalLanguageNickname?: Maybe<Scalars['String']['output']>;
  LocalLanguagePostalCode?: Maybe<Scalars['String']['output']>;
  LocalLanguageState?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MiddleName?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneAreaCode?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneISOCode?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneNumber?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NickName?: Maybe<Scalars['String']['output']>;
  OfficePhone?: Maybe<Scalars['String']['output']>;
  OfficePhoneAreaCode?: Maybe<Scalars['String']['output']>;
  OfficePhoneISOCode?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonalCompany?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  Prefix?: Maybe<Scalars['String']['output']>;
  PrimaryEmailAddress?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SecondaryEmailAddress?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Suffix?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  YearOfFirstLicense?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockBirthYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockBusinessAddressLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockBusinessAddressLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockBusinessAddressLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockDesignation1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockDesignation2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockGenderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockJobTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockLocalLanguageCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockLocalLanguageCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockLocalLanguageLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockLocalLanguageLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockLocalLanguageLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockLocalLanguageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockLocalLanguageNicknameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockLocalLanguagePostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockLocalLanguageStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockMiddleNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockMobileCellPhoneAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockMobileCellPhoneIsoCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockMobileCellPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockNickNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockOfficePhoneArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockOfficePhoneAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockOfficePhoneIsoCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockPersonalCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockPostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockPrefixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockPrimaryEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockSecondaryEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockSuffixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlockYearOfFirstLicenseArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds New ID Request data for the Company Admin page */
export type NewIdRequestSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NewIdRequestSectionBlockAutocomplete = {
  __typename?: 'NewIDRequestSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  CompanyID?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NewIdRequestSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewIdRequestSectionBlockAutocompleteCompanyIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewIdRequestSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewIdRequestSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewIdRequestSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewIdRequestSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewIdRequestSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewIdRequestSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewIdRequestSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewIdRequestSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewIdRequestSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewIdRequestSectionBlockFacet = {
  __typename?: 'NewIDRequestSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BirthYear?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine1?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine2?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine3?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyID?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Designation1?: Maybe<Array<Maybe<StringFacet>>>;
  Designation2?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstName?: Maybe<Array<Maybe<StringFacet>>>;
  Gender?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  JobTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastName?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageCity?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageCountry?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageLine1?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageLine2?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageLine3?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageName?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageNickname?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguagePostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageState?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MiddleName?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneAreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneISOCode?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NickName?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhone?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneAreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneISOCode?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonalCompany?: Maybe<Array<Maybe<StringFacet>>>;
  PostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  Prefix?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryEmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SecondaryEmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  State?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Suffix?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstLicense?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NewIdRequestSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetBirthYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetBusinessAddressLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetBusinessAddressLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetBusinessAddressLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewIdRequestSectionBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetCompanyIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewIdRequestSectionBlockFacetDesignation1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetDesignation2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetGenderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NewIdRequestSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetJobTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetLocalLanguageCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetLocalLanguageCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetLocalLanguageLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetLocalLanguageLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetLocalLanguageLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetLocalLanguageNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetLocalLanguageNicknameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetLocalLanguagePostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetLocalLanguageStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetMiddleNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetMobileCellPhoneAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetMobileCellPhoneIsoCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetMobileCellPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetNickNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetOfficePhoneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetOfficePhoneAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetOfficePhoneIsoCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetPersonalCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetPostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetPrefixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetPrimaryEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewIdRequestSectionBlockFacetSecondaryEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewIdRequestSectionBlockFacetStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewIdRequestSectionBlockFacetSuffixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacetYearOfFirstLicenseArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewIdRequestSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NewIdRequestSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BirthYear?: InputMaybe<OrderBy>;
  BusinessAddressLine1?: InputMaybe<OrderBy>;
  BusinessAddressLine2?: InputMaybe<OrderBy>;
  BusinessAddressLine3?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  CompanyID?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Designation1?: InputMaybe<OrderBy>;
  Designation2?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstName?: InputMaybe<OrderBy>;
  Gender?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  JobTitle?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastName?: InputMaybe<OrderBy>;
  LocalLanguageCity?: InputMaybe<OrderBy>;
  LocalLanguageCountry?: InputMaybe<OrderBy>;
  LocalLanguageLine1?: InputMaybe<OrderBy>;
  LocalLanguageLine2?: InputMaybe<OrderBy>;
  LocalLanguageLine3?: InputMaybe<OrderBy>;
  LocalLanguageName?: InputMaybe<OrderBy>;
  LocalLanguageNickname?: InputMaybe<OrderBy>;
  LocalLanguagePostalCode?: InputMaybe<OrderBy>;
  LocalLanguageState?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MiddleName?: InputMaybe<OrderBy>;
  MobileCellPhoneAreaCode?: InputMaybe<OrderBy>;
  MobileCellPhoneISOCode?: InputMaybe<OrderBy>;
  MobileCellPhoneNumber?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NickName?: InputMaybe<OrderBy>;
  OfficePhone?: InputMaybe<OrderBy>;
  OfficePhoneAreaCode?: InputMaybe<OrderBy>;
  OfficePhoneISOCode?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonalCompany?: InputMaybe<OrderBy>;
  PostalCode?: InputMaybe<OrderBy>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  Prefix?: InputMaybe<OrderBy>;
  PrimaryEmailAddress?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SecondaryEmailAddress?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  State?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Suffix?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  YearOfFirstLicense?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NewIdRequestSectionBlockOutput = {
  __typename?: 'NewIDRequestSectionBlockOutput';
  autocomplete?: Maybe<NewIdRequestSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NewIdRequestSectionBlockFacet>;
  item?: Maybe<NewIdRequestSectionBlock>;
  items?: Maybe<Array<Maybe<NewIdRequestSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NewIdRequestSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewIdRequestSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BirthYear?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine1?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine2?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine3?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  CompanyID?: InputMaybe<StringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Designation1?: InputMaybe<SearchableStringFilterInput>;
  Designation2?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstName?: InputMaybe<SearchableStringFilterInput>;
  Gender?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  JobTitle?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastName?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageCity?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageCountry?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageLine1?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageLine2?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageLine3?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageName?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageNickname?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguagePostalCode?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageState?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MiddleName?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneAreaCode?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneISOCode?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NickName?: InputMaybe<SearchableStringFilterInput>;
  OfficePhone?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneAreaCode?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneISOCode?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonalCompany?: InputMaybe<SearchableStringFilterInput>;
  PostalCode?: InputMaybe<SearchableStringFilterInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  Prefix?: InputMaybe<SearchableStringFilterInput>;
  PrimaryEmailAddress?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SecondaryEmailAddress?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  State?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Suffix?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  YearOfFirstLicense?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NewIdRequestSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NewIdRequestSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NewIdRequestSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Call out block used for Next satic pages */
export type NextCallOutBlock = IContent & IData & {
  __typename?: 'NextCallOutBlock';
  AccessGroup?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  /** Link block for call out block */
  CallOutLinkBlock?: Maybe<NextCallOutBlockLinkBlock>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Heading for call out block. Please use {year} if you want to display dynamic membership year in the content */
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Sub heading for call out block. Please use {year} if you want to display membership dynamic year in the content */
  SubHeading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Call out block used for Next satic pages */
export type NextCallOutBlockAccessGroupArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Call out block used for Next satic pages */
export type NextCallOutBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Call out block used for Next satic pages */
export type NextCallOutBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Call out block used for Next satic pages */
export type NextCallOutBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Call out block used for Next satic pages */
export type NextCallOutBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Call out block used for Next satic pages */
export type NextCallOutBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Call out block used for Next satic pages */
export type NextCallOutBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Call out block used for Next satic pages */
export type NextCallOutBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Call out block used for Next satic pages */
export type NextCallOutBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextCallOutBlockAutocomplete = {
  __typename?: 'NextCallOutBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CallOutLinkBlock?: Maybe<NextCallOutBlockLinkBlockAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextCallOutBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextCallOutBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextCallOutBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextCallOutBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextCallOutBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextCallOutBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextCallOutBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextCallOutBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextCallOutBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextCallOutBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextCallOutBlockFacet = {
  __typename?: 'NextCallOutBlockFacet';
  AccessGroup?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  CallOutLinkBlock?: Maybe<NextCallOutBlockLinkBlockFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextCallOutBlockFacetAccessGroupArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextCallOutBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextCallOutBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextCallOutBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextCallOutBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextCallOutBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextCallOutBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextCallOutBlockLinkBlock = {
  __typename?: 'NextCallOutBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type NextCallOutBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextCallOutBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextCallOutBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextCallOutBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextCallOutBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextCallOutBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextCallOutBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NextCallOutBlockLinkBlockAutocomplete = {
  __typename?: 'NextCallOutBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextCallOutBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextCallOutBlockLinkBlockFacet = {
  __typename?: 'NextCallOutBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NextCallOutBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextCallOutBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextCallOutBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NextCallOutBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type NextCallOutBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type NextCallOutBlockOrderByInput = {
  AccessGroup?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  CallOutLinkBlock?: InputMaybe<NextCallOutBlockLinkBlockOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextCallOutBlockOutput = {
  __typename?: 'NextCallOutBlockOutput';
  autocomplete?: Maybe<NextCallOutBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextCallOutBlockFacet>;
  item?: Maybe<NextCallOutBlock>;
  items?: Maybe<Array<Maybe<NextCallOutBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextCallOutBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextCallOutBlockWhereInput = {
  AccessGroup?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  CallOutLinkBlock?: InputMaybe<NextCallOutBlockLinkBlockWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextCallOutBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextCallOutBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextCallOutBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Contact us block used for Next static pages */
export type NextContactUsBlock = IContent & IData & {
  __typename?: 'NextContactUsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** Text for Next contact us block */
  ContactUsText?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EmailLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  MessageLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NameLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SendButtonLabel?: Maybe<Scalars['String']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockContactUsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockEmailLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockMessageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockSendButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contact us block used for Next static pages */
export type NextContactUsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextContactUsBlockAutocomplete = {
  __typename?: 'NextContactUsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextContactUsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContactUsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContactUsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContactUsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContactUsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContactUsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContactUsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContactUsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContactUsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContactUsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextContactUsBlockFacet = {
  __typename?: 'NextContactUsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContactUsText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EmailLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MessageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SendButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextContactUsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextContactUsBlockFacetContactUsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextContactUsBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetEmailLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextContactUsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetMessageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextContactUsBlockFacetSendButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextContactUsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextContactUsBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContactUsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextContactUsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContactUsText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EmailLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  MessageLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NameLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SendButtonLabel?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextContactUsBlockOutput = {
  __typename?: 'NextContactUsBlockOutput';
  autocomplete?: Maybe<NextContactUsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextContactUsBlockFacet>;
  item?: Maybe<NextContactUsBlock>;
  items?: Maybe<Array<Maybe<NextContactUsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextContactUsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextContactUsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContactUsText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EmailLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  MessageLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NameLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SendButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextContactUsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextContactUsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextContactUsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlock = IContent & IData & {
  __typename?: 'NextContainerBlock';
  AccessGroup?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Description for container block */
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Main content heading for container block */
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** The items to render in content area */
  Items?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Secondary content heading for container block */
  SubHeading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlockAccessGroupArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlockItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container that can be used to render items in layouts. Used for NextJS only */
export type NextContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextContainerBlockAutocomplete = {
  __typename?: 'NextContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextContainerBlockFacet = {
  __typename?: 'NextContainerBlockFacet';
  AccessGroup?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<ContentAreaItemModelSearchFacet>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextContainerBlockFacetAccessGroupArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextContainerBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextContainerBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextContainerBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextContainerBlockOrderByInput = {
  AccessGroup?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Items?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextContainerBlockOutput = {
  __typename?: 'NextContainerBlockOutput';
  autocomplete?: Maybe<NextContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextContainerBlockFacet>;
  item?: Maybe<NextContainerBlock>;
  items?: Maybe<Array<Maybe<NextContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextContainerBlockWhereInput = {
  AccessGroup?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlock = IContent & IData & {
  __typename?: 'NextDeadLetterQueueBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DeadLettersEnqueuedTime?: Maybe<Scalars['String']['output']>;
  DeadLettersMessageId?: Maybe<Scalars['String']['output']>;
  DeadLettersMessageName?: Maybe<Scalars['String']['output']>;
  DeadLettersNoDeadLetters?: Maybe<Scalars['String']['output']>;
  DeadLettersNoDeadLettersTableResults?: Maybe<Scalars['String']['output']>;
  DeadLettersQueue?: Maybe<Scalars['String']['output']>;
  DeadLettersQueueName?: Maybe<Scalars['String']['output']>;
  DeadLettersRetryDeadLetters?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlockDeadLettersEnqueuedTimeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlockDeadLettersMessageIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlockDeadLettersMessageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlockDeadLettersNoDeadLettersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlockDeadLettersNoDeadLettersTableResultsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlockDeadLettersQueueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlockDeadLettersQueueNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlockDeadLettersRetryDeadLettersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Dead Letter Queue block */
export type NextDeadLetterQueueBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextDeadLetterQueueBlockAutocomplete = {
  __typename?: 'NextDeadLetterQueueBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextDeadLetterQueueBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextDeadLetterQueueBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextDeadLetterQueueBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextDeadLetterQueueBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextDeadLetterQueueBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextDeadLetterQueueBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextDeadLetterQueueBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextDeadLetterQueueBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextDeadLetterQueueBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextDeadLetterQueueBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextDeadLetterQueueBlockFacet = {
  __typename?: 'NextDeadLetterQueueBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DeadLettersEnqueuedTime?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersMessageId?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersMessageName?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersNoDeadLetters?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersNoDeadLettersTableResults?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersQueue?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersQueueName?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersRetryDeadLetters?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextDeadLetterQueueBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextDeadLetterQueueBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextDeadLetterQueueBlockFacetDeadLettersEnqueuedTimeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetDeadLettersMessageIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetDeadLettersMessageNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetDeadLettersNoDeadLettersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetDeadLettersNoDeadLettersTableResultsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetDeadLettersQueueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetDeadLettersQueueNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetDeadLettersRetryDeadLettersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextDeadLetterQueueBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextDeadLetterQueueBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextDeadLetterQueueBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextDeadLetterQueueBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextDeadLetterQueueBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DeadLettersEnqueuedTime?: InputMaybe<OrderBy>;
  DeadLettersMessageId?: InputMaybe<OrderBy>;
  DeadLettersMessageName?: InputMaybe<OrderBy>;
  DeadLettersNoDeadLetters?: InputMaybe<OrderBy>;
  DeadLettersNoDeadLettersTableResults?: InputMaybe<OrderBy>;
  DeadLettersQueue?: InputMaybe<OrderBy>;
  DeadLettersQueueName?: InputMaybe<OrderBy>;
  DeadLettersRetryDeadLetters?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextDeadLetterQueueBlockOutput = {
  __typename?: 'NextDeadLetterQueueBlockOutput';
  autocomplete?: Maybe<NextDeadLetterQueueBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextDeadLetterQueueBlockFacet>;
  item?: Maybe<NextDeadLetterQueueBlock>;
  items?: Maybe<Array<Maybe<NextDeadLetterQueueBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextDeadLetterQueueBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextDeadLetterQueueBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DeadLettersEnqueuedTime?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersMessageId?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersMessageName?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersNoDeadLetters?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersNoDeadLettersTableResults?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersQueue?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersQueueName?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersRetryDeadLetters?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextDeadLetterQueueBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextDeadLetterQueueBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextDeadLetterQueueBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** An Event block used for Next static pages */
export type NextEventBlock = IContent & IData & {
  __typename?: 'NextEventBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EventDate?: Maybe<Scalars['Date']['output']>;
  EventDateFrom?: Maybe<Scalars['Date']['output']>;
  EventDateTo?: Maybe<Scalars['Date']['output']>;
  EventDescription?: Maybe<Scalars['String']['output']>;
  EventHeading?: Maybe<Scalars['String']['output']>;
  /** Image block for Event block */
  EventImageBlock?: Maybe<NextEventBlockImageBlock>;
  /** Link block for Event */
  EventLinkBlock?: Maybe<NextEventBlockLinkBlock>;
  EventLocation?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextEventDate?: Maybe<Scalars['Date']['output']>;
  NextEventDateFrom?: Maybe<Scalars['Date']['output']>;
  NextEventDateTo?: Maybe<Scalars['Date']['output']>;
  NextEventLabel?: Maybe<Scalars['String']['output']>;
  NextEventLocation?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** Event block will be displayed in reverse order */
  ReversedContent?: Maybe<Scalars['Bool']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  ShowOnlyForEdgeAccessGroupMembers?: Maybe<Scalars['Bool']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  ThisYearLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** An Event block used for Next static pages */
export type NextEventBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event block used for Next static pages */
export type NextEventBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event block used for Next static pages */
export type NextEventBlockEventDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event block used for Next static pages */
export type NextEventBlockEventHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event block used for Next static pages */
export type NextEventBlockEventLocationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event block used for Next static pages */
export type NextEventBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event block used for Next static pages */
export type NextEventBlockNextEventLocationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event block used for Next static pages */
export type NextEventBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event block used for Next static pages */
export type NextEventBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Event block used for Next static pages */
export type NextEventBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextEventBlockAutocomplete = {
  __typename?: 'NextEventBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EventImageBlock?: Maybe<NextEventBlockImageBlockAutocomplete>;
  EventLinkBlock?: Maybe<NextEventBlockLinkBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  NextEventLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThisYearLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextEventBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextEventBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextEventBlockAutocompleteNextEventLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextEventBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextEventBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextEventBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextEventBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextEventBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextEventBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextEventBlockAutocompleteThisYearLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextEventBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextEventBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextEventBlockFacet = {
  __typename?: 'NextEventBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EventDate?: Maybe<Array<Maybe<DateFacet>>>;
  EventDateFrom?: Maybe<Array<Maybe<DateFacet>>>;
  EventDateTo?: Maybe<Array<Maybe<DateFacet>>>;
  EventDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EventHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EventImageBlock?: Maybe<NextEventBlockImageBlockFacet>;
  EventLinkBlock?: Maybe<NextEventBlockLinkBlockFacet>;
  EventLocation?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextEventDate?: Maybe<Array<Maybe<DateFacet>>>;
  NextEventDateFrom?: Maybe<Array<Maybe<DateFacet>>>;
  NextEventDateTo?: Maybe<Array<Maybe<DateFacet>>>;
  NextEventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextEventLocation?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ReversedContent?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowOnlyForEdgeAccessGroupMembers?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThisYearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextEventBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextEventBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextEventBlockFacetEventDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextEventBlockFacetEventDateFromArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextEventBlockFacetEventDateToArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextEventBlockFacetEventDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetEventHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetEventLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextEventBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetNextEventDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextEventBlockFacetNextEventDateFromArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextEventBlockFacetNextEventDateToArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextEventBlockFacetNextEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetNextEventLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetReversedContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextEventBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetShowOnlyForEdgeAccessGroupMembersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextEventBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextEventBlockFacetThisYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextEventBlockImageBlock = {
  __typename?: 'NextEventBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type NextEventBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextEventBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextEventBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextEventBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextEventBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NextEventBlockImageBlockAutocomplete = {
  __typename?: 'NextEventBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type NextEventBlockImageBlockFacet = {
  __typename?: 'NextEventBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NextEventBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextEventBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NextEventBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type NextEventBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type NextEventBlockLinkBlock = {
  __typename?: 'NextEventBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type NextEventBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextEventBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextEventBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextEventBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextEventBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextEventBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextEventBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NextEventBlockLinkBlockAutocomplete = {
  __typename?: 'NextEventBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextEventBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextEventBlockLinkBlockFacet = {
  __typename?: 'NextEventBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NextEventBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextEventBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextEventBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NextEventBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type NextEventBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type NextEventBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EventDate?: InputMaybe<OrderBy>;
  EventDateFrom?: InputMaybe<OrderBy>;
  EventDateTo?: InputMaybe<OrderBy>;
  EventDescription?: InputMaybe<OrderBy>;
  EventHeading?: InputMaybe<OrderBy>;
  EventImageBlock?: InputMaybe<NextEventBlockImageBlockOrderByInput>;
  EventLinkBlock?: InputMaybe<NextEventBlockLinkBlockOrderByInput>;
  EventLocation?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextEventDate?: InputMaybe<OrderBy>;
  NextEventDateFrom?: InputMaybe<OrderBy>;
  NextEventDateTo?: InputMaybe<OrderBy>;
  NextEventLabel?: InputMaybe<OrderBy>;
  NextEventLocation?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  ReversedContent?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowOnlyForEdgeAccessGroupMembers?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThisYearLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextEventBlockOutput = {
  __typename?: 'NextEventBlockOutput';
  autocomplete?: Maybe<NextEventBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextEventBlockFacet>;
  item?: Maybe<NextEventBlock>;
  items?: Maybe<Array<Maybe<NextEventBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextEventBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextEventBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EventDate?: InputMaybe<DateFilterInput>;
  EventDateFrom?: InputMaybe<DateFilterInput>;
  EventDateTo?: InputMaybe<DateFilterInput>;
  EventDescription?: InputMaybe<SearchableStringFilterInput>;
  EventHeading?: InputMaybe<SearchableStringFilterInput>;
  EventImageBlock?: InputMaybe<NextEventBlockImageBlockWhereInput>;
  EventLinkBlock?: InputMaybe<NextEventBlockLinkBlockWhereInput>;
  EventLocation?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextEventDate?: InputMaybe<DateFilterInput>;
  NextEventDateFrom?: InputMaybe<DateFilterInput>;
  NextEventDateTo?: InputMaybe<DateFilterInput>;
  NextEventLabel?: InputMaybe<StringFilterInput>;
  NextEventLocation?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ReversedContent?: InputMaybe<BoolFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowOnlyForEdgeAccessGroupMembers?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThisYearLabel?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextEventBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextEventBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextEventBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A Hero block used for Next static pages */
export type NextHeroBlock = IContent & IData & {
  __typename?: 'NextHeroBlock';
  AccessGroup?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HeroCtaButtons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  HeroDescription?: Maybe<Scalars['String']['output']>;
  HeroHeading?: Maybe<Scalars['String']['output']>;
  HeroImageBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  HeroLinkBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  /** Determines the color scheme */
  HeroTheme?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlockAccessGroupArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlockHeroCtaButtonsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlockHeroDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlockHeroHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlockHeroImageBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlockHeroLinkBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlockHeroThemeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Hero block used for Next static pages */
export type NextHeroBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextHeroBlockAutocomplete = {
  __typename?: 'NextHeroBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextHeroBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextHeroBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextHeroBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextHeroBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextHeroBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextHeroBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextHeroBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextHeroBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextHeroBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextHeroBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextHeroBlockFacet = {
  __typename?: 'NextHeroBlockFacet';
  AccessGroup?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HeroCtaButtons?: Maybe<ContentAreaItemModelSearchFacet>;
  HeroDescription?: Maybe<Array<Maybe<StringFacet>>>;
  HeroHeading?: Maybe<Array<Maybe<StringFacet>>>;
  HeroImageBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  HeroLinkBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  HeroTheme?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextHeroBlockFacetAccessGroupArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextHeroBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextHeroBlockFacetHeroDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetHeroHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetHeroThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextHeroBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextHeroBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextHeroBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextHeroBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextHeroBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextHeroBlockOrderByInput = {
  AccessGroup?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HeroCtaButtons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeroDescription?: InputMaybe<OrderBy>;
  HeroHeading?: InputMaybe<OrderBy>;
  HeroImageBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeroLinkBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HeroTheme?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextHeroBlockOutput = {
  __typename?: 'NextHeroBlockOutput';
  autocomplete?: Maybe<NextHeroBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextHeroBlockFacet>;
  item?: Maybe<NextHeroBlock>;
  items?: Maybe<Array<Maybe<NextHeroBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextHeroBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextHeroBlockWhereInput = {
  AccessGroup?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HeroCtaButtons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeroDescription?: InputMaybe<SearchableStringFilterInput>;
  HeroHeading?: InputMaybe<SearchableStringFilterInput>;
  HeroImageBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeroLinkBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HeroTheme?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextHeroBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextHeroBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextHeroBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Info box block used for Next static pages */
export type NextInfoBoxBlock = IContent & IData & {
  __typename?: 'NextInfoBoxBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  /** Text for Next info box block */
  NextInfoBoxText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Info box block used for Next static pages */
export type NextInfoBoxBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Info box block used for Next static pages */
export type NextInfoBoxBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Info box block used for Next static pages */
export type NextInfoBoxBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Info box block used for Next static pages */
export type NextInfoBoxBlockNextInfoBoxTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Info box block used for Next static pages */
export type NextInfoBoxBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Info box block used for Next static pages */
export type NextInfoBoxBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Info box block used for Next static pages */
export type NextInfoBoxBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextInfoBoxBlockAutocomplete = {
  __typename?: 'NextInfoBoxBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextInfoBoxBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextInfoBoxBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextInfoBoxBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextInfoBoxBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextInfoBoxBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextInfoBoxBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextInfoBoxBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextInfoBoxBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextInfoBoxBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextInfoBoxBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextInfoBoxBlockFacet = {
  __typename?: 'NextInfoBoxBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextInfoBoxText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextInfoBoxBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextInfoBoxBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextInfoBoxBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextInfoBoxBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetNextInfoBoxTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextInfoBoxBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextInfoBoxBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextInfoBoxBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextInfoBoxBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextInfoBoxBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextInfoBoxText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextInfoBoxBlockOutput = {
  __typename?: 'NextInfoBoxBlockOutput';
  autocomplete?: Maybe<NextInfoBoxBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextInfoBoxBlockFacet>;
  item?: Maybe<NextInfoBoxBlock>;
  items?: Maybe<Array<Maybe<NextInfoBoxBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextInfoBoxBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextInfoBoxBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextInfoBoxText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextInfoBoxBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextInfoBoxBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextInfoBoxBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Container for Person Blocks */
export type NextPersonContainerBlock = IContent & IData & {
  __typename?: 'NextPersonContainerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Collapsable?: Maybe<Scalars['Bool']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  ProfileList?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Container for Person Blocks */
export type NextPersonContainerBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container for Person Blocks */
export type NextPersonContainerBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container for Person Blocks */
export type NextPersonContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container for Person Blocks */
export type NextPersonContainerBlockProfileListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container for Person Blocks */
export type NextPersonContainerBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container for Person Blocks */
export type NextPersonContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container for Person Blocks */
export type NextPersonContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextPersonContainerBlockAutocomplete = {
  __typename?: 'NextPersonContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Heading?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextPersonContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonContainerBlockAutocompleteHeadingArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextPersonContainerBlockFacet = {
  __typename?: 'NextPersonContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Collapsable?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ProfileList?: Maybe<ContentAreaItemModelSearchFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextPersonContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextPersonContainerBlockFacetCollapsableArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextPersonContainerBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextPersonContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextPersonContainerBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextPersonContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextPersonContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextPersonContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Collapsable?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ProfileList?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextPersonContainerBlockOutput = {
  __typename?: 'NextPersonContainerBlockOutput';
  autocomplete?: Maybe<NextPersonContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextPersonContainerBlockFacet>;
  item?: Maybe<NextPersonContainerBlock>;
  items?: Maybe<Array<Maybe<NextPersonContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextPersonContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextPersonContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Collapsable?: InputMaybe<BoolFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<StringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ProfileList?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextPersonContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextPersonContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextPersonContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Person Data block */
export type NextPersonDataBlock = IContent & IData & {
  __typename?: 'NextPersonDataBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonData?: Maybe<Scalars['String']['output']>;
  PersonDataCustomerProfile?: Maybe<Scalars['String']['output']>;
  PersonDataExcludeFromLateFee?: Maybe<Scalars['String']['output']>;
  PersonDataMembershipApplication?: Maybe<Scalars['String']['output']>;
  PersonDataNoResults?: Maybe<Scalars['String']['output']>;
  PersonDataPayments?: Maybe<Scalars['String']['output']>;
  PersonDataPrepayments?: Maybe<Scalars['String']['output']>;
  PersonDataProductions?: Maybe<Scalars['String']['output']>;
  PersonDataTriggerSync?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlockPersonDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlockPersonDataCustomerProfileArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlockPersonDataExcludeFromLateFeeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlockPersonDataMembershipApplicationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlockPersonDataNoResultsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlockPersonDataPaymentsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlockPersonDataPrepaymentsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlockPersonDataProductionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlockPersonDataTriggerSyncArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Data block */
export type NextPersonDataBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextPersonDataBlockAutocomplete = {
  __typename?: 'NextPersonDataBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextPersonDataBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonDataBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonDataBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonDataBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonDataBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonDataBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonDataBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonDataBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonDataBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextPersonDataBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextPersonDataBlockFacet = {
  __typename?: 'NextPersonDataBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonData?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataCustomerProfile?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataExcludeFromLateFee?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataMembershipApplication?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataNoResults?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataPayments?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataPrepayments?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataProductions?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataTriggerSync?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextPersonDataBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextPersonDataBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextPersonDataBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetPersonDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetPersonDataCustomerProfileArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetPersonDataExcludeFromLateFeeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetPersonDataMembershipApplicationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetPersonDataNoResultsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetPersonDataPaymentsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetPersonDataPrepaymentsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetPersonDataProductionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetPersonDataTriggerSyncArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextPersonDataBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextPersonDataBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextPersonDataBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextPersonDataBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextPersonDataBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonData?: InputMaybe<OrderBy>;
  PersonDataCustomerProfile?: InputMaybe<OrderBy>;
  PersonDataExcludeFromLateFee?: InputMaybe<OrderBy>;
  PersonDataMembershipApplication?: InputMaybe<OrderBy>;
  PersonDataNoResults?: InputMaybe<OrderBy>;
  PersonDataPayments?: InputMaybe<OrderBy>;
  PersonDataPrepayments?: InputMaybe<OrderBy>;
  PersonDataProductions?: InputMaybe<OrderBy>;
  PersonDataTriggerSync?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextPersonDataBlockOutput = {
  __typename?: 'NextPersonDataBlockOutput';
  autocomplete?: Maybe<NextPersonDataBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextPersonDataBlockFacet>;
  item?: Maybe<NextPersonDataBlock>;
  items?: Maybe<Array<Maybe<NextPersonDataBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextPersonDataBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextPersonDataBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonData?: InputMaybe<SearchableStringFilterInput>;
  PersonDataCustomerProfile?: InputMaybe<SearchableStringFilterInput>;
  PersonDataExcludeFromLateFee?: InputMaybe<SearchableStringFilterInput>;
  PersonDataMembershipApplication?: InputMaybe<SearchableStringFilterInput>;
  PersonDataNoResults?: InputMaybe<SearchableStringFilterInput>;
  PersonDataPayments?: InputMaybe<SearchableStringFilterInput>;
  PersonDataPrepayments?: InputMaybe<SearchableStringFilterInput>;
  PersonDataProductions?: InputMaybe<SearchableStringFilterInput>;
  PersonDataTriggerSync?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextPersonDataBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextPersonDataBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextPersonDataBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Next Staff Admin Page */
export type NextStaffAdminPage = IContent & IData & {
  __typename?: 'NextStaffAdminPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Back?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DeadLetterQueueBlock?: Maybe<NextStaffAdminPageNextDeadLetterQueueBlock>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<NextStaffAdminPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonData?: Maybe<NextStaffAdminPageNextPersonDataBlock>;
  PersonId?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SyncEventsBlock?: Maybe<NextStaffAdminPageNextSyncEventsBlock>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<NextStaffAdminPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  UsersRequiringAttention?: Maybe<Scalars['String']['output']>;
  UsersRequiringAttentionDeadLetterCount?: Maybe<Scalars['String']['output']>;
  UsersRequiringAttentionDescription?: Maybe<Scalars['String']['output']>;
  UsersRequiringAttentionEmailAddress?: Maybe<Scalars['String']['output']>;
  UsersRequiringAttentionEnterPersonId?: Maybe<Scalars['String']['output']>;
  UsersRequiringAttentionGoToPage?: Maybe<Scalars['String']['output']>;
  UsersRequiringAttentionId?: Maybe<Scalars['String']['output']>;
  UsersRequiringAttentionName?: Maybe<Scalars['String']['output']>;
  UsersRequiringAttentionNoResults?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageBackArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPagePersonIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageUsersRequiringAttentionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageUsersRequiringAttentionDeadLetterCountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageUsersRequiringAttentionDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageUsersRequiringAttentionEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageUsersRequiringAttentionEnterPersonIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageUsersRequiringAttentionGoToPageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageUsersRequiringAttentionIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageUsersRequiringAttentionNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPageUsersRequiringAttentionNoResultsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Next Staff Admin Page */
export type NextStaffAdminPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextStaffAdminPageAutocomplete = {
  __typename?: 'NextStaffAdminPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<NextStaffAdminPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<NextStaffAdminPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextStaffAdminPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaffAdminPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaffAdminPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaffAdminPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaffAdminPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaffAdminPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaffAdminPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaffAdminPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaffAdminPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaffAdminPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextStaffAdminPageFacet = {
  __typename?: 'NextStaffAdminPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Back?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DeadLetterQueueBlock?: Maybe<NextStaffAdminPageNextDeadLetterQueueBlockFacet>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<NextStaffAdminPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonData?: Maybe<NextStaffAdminPageNextPersonDataBlockFacet>;
  PersonId?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SyncEventsBlock?: Maybe<NextStaffAdminPageNextSyncEventsBlockFacet>;
  ThumbnailImage?: Maybe<NextStaffAdminPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UsersRequiringAttention?: Maybe<Array<Maybe<StringFacet>>>;
  UsersRequiringAttentionDeadLetterCount?: Maybe<Array<Maybe<StringFacet>>>;
  UsersRequiringAttentionDescription?: Maybe<Array<Maybe<StringFacet>>>;
  UsersRequiringAttentionEmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  UsersRequiringAttentionEnterPersonId?: Maybe<Array<Maybe<StringFacet>>>;
  UsersRequiringAttentionGoToPage?: Maybe<Array<Maybe<StringFacet>>>;
  UsersRequiringAttentionId?: Maybe<Array<Maybe<StringFacet>>>;
  UsersRequiringAttentionName?: Maybe<Array<Maybe<StringFacet>>>;
  UsersRequiringAttentionNoResults?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextStaffAdminPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetBackArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextStaffAdminPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextStaffAdminPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextStaffAdminPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextStaffAdminPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetPersonIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextStaffAdminPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextStaffAdminPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextStaffAdminPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetUsersRequiringAttentionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetUsersRequiringAttentionDeadLetterCountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetUsersRequiringAttentionDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetUsersRequiringAttentionEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetUsersRequiringAttentionEnterPersonIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetUsersRequiringAttentionGoToPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetUsersRequiringAttentionIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetUsersRequiringAttentionNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacetUsersRequiringAttentionNoResultsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextStaffAdminPageImageBlock = {
  __typename?: 'NextStaffAdminPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type NextStaffAdminPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NextStaffAdminPageImageBlockAutocomplete = {
  __typename?: 'NextStaffAdminPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type NextStaffAdminPageImageBlockFacet = {
  __typename?: 'NextStaffAdminPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NextStaffAdminPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextStaffAdminPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NextStaffAdminPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type NextStaffAdminPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type NextStaffAdminPageNextDeadLetterQueueBlock = {
  __typename?: 'NextStaffAdminPageNextDeadLetterQueueBlock';
  DeadLettersEnqueuedTime?: Maybe<Scalars['String']['output']>;
  DeadLettersMessageId?: Maybe<Scalars['String']['output']>;
  DeadLettersMessageName?: Maybe<Scalars['String']['output']>;
  DeadLettersNoDeadLetters?: Maybe<Scalars['String']['output']>;
  DeadLettersNoDeadLettersTableResults?: Maybe<Scalars['String']['output']>;
  DeadLettersQueue?: Maybe<Scalars['String']['output']>;
  DeadLettersQueueName?: Maybe<Scalars['String']['output']>;
  DeadLettersRetryDeadLetters?: Maybe<Scalars['String']['output']>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockDeadLettersEnqueuedTimeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockDeadLettersMessageIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockDeadLettersMessageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockDeadLettersNoDeadLettersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockDeadLettersNoDeadLettersTableResultsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockDeadLettersQueueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockDeadLettersQueueNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockDeadLettersRetryDeadLettersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NextStaffAdminPageNextDeadLetterQueueBlockFacet = {
  __typename?: 'NextStaffAdminPageNextDeadLetterQueueBlockFacet';
  DeadLettersEnqueuedTime?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersMessageId?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersMessageName?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersNoDeadLetters?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersNoDeadLettersTableResults?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersQueue?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersQueueName?: Maybe<Array<Maybe<StringFacet>>>;
  DeadLettersRetryDeadLetters?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockFacetDeadLettersEnqueuedTimeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockFacetDeadLettersMessageIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockFacetDeadLettersMessageNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockFacetDeadLettersNoDeadLettersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockFacetDeadLettersNoDeadLettersTableResultsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockFacetDeadLettersQueueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockFacetDeadLettersQueueNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextDeadLetterQueueBlockFacetDeadLettersRetryDeadLettersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NextStaffAdminPageNextDeadLetterQueueBlockOrderByInput = {
  DeadLettersEnqueuedTime?: InputMaybe<OrderBy>;
  DeadLettersMessageId?: InputMaybe<OrderBy>;
  DeadLettersMessageName?: InputMaybe<OrderBy>;
  DeadLettersNoDeadLetters?: InputMaybe<OrderBy>;
  DeadLettersNoDeadLettersTableResults?: InputMaybe<OrderBy>;
  DeadLettersQueue?: InputMaybe<OrderBy>;
  DeadLettersQueueName?: InputMaybe<OrderBy>;
  DeadLettersRetryDeadLetters?: InputMaybe<OrderBy>;
};

export type NextStaffAdminPageNextDeadLetterQueueBlockWhereInput = {
  DeadLettersEnqueuedTime?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersMessageId?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersMessageName?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersNoDeadLetters?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersNoDeadLettersTableResults?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersQueue?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersQueueName?: InputMaybe<SearchableStringFilterInput>;
  DeadLettersRetryDeadLetters?: InputMaybe<SearchableStringFilterInput>;
};

export type NextStaffAdminPageNextPersonDataBlock = {
  __typename?: 'NextStaffAdminPageNextPersonDataBlock';
  PersonData?: Maybe<Scalars['String']['output']>;
  PersonDataCustomerProfile?: Maybe<Scalars['String']['output']>;
  PersonDataExcludeFromLateFee?: Maybe<Scalars['String']['output']>;
  PersonDataMembershipApplication?: Maybe<Scalars['String']['output']>;
  PersonDataNoResults?: Maybe<Scalars['String']['output']>;
  PersonDataPayments?: Maybe<Scalars['String']['output']>;
  PersonDataPrepayments?: Maybe<Scalars['String']['output']>;
  PersonDataProductions?: Maybe<Scalars['String']['output']>;
  PersonDataTriggerSync?: Maybe<Scalars['String']['output']>;
};


export type NextStaffAdminPageNextPersonDataBlockPersonDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextPersonDataBlockPersonDataCustomerProfileArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextPersonDataBlockPersonDataExcludeFromLateFeeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextPersonDataBlockPersonDataMembershipApplicationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextPersonDataBlockPersonDataNoResultsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextPersonDataBlockPersonDataPaymentsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextPersonDataBlockPersonDataPrepaymentsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextPersonDataBlockPersonDataProductionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextPersonDataBlockPersonDataTriggerSyncArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NextStaffAdminPageNextPersonDataBlockFacet = {
  __typename?: 'NextStaffAdminPageNextPersonDataBlockFacet';
  PersonData?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataCustomerProfile?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataExcludeFromLateFee?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataMembershipApplication?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataNoResults?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataPayments?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataPrepayments?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataProductions?: Maybe<Array<Maybe<StringFacet>>>;
  PersonDataTriggerSync?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NextStaffAdminPageNextPersonDataBlockFacetPersonDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextPersonDataBlockFacetPersonDataCustomerProfileArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextPersonDataBlockFacetPersonDataExcludeFromLateFeeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextPersonDataBlockFacetPersonDataMembershipApplicationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextPersonDataBlockFacetPersonDataNoResultsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextPersonDataBlockFacetPersonDataPaymentsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextPersonDataBlockFacetPersonDataPrepaymentsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextPersonDataBlockFacetPersonDataProductionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextPersonDataBlockFacetPersonDataTriggerSyncArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NextStaffAdminPageNextPersonDataBlockOrderByInput = {
  PersonData?: InputMaybe<OrderBy>;
  PersonDataCustomerProfile?: InputMaybe<OrderBy>;
  PersonDataExcludeFromLateFee?: InputMaybe<OrderBy>;
  PersonDataMembershipApplication?: InputMaybe<OrderBy>;
  PersonDataNoResults?: InputMaybe<OrderBy>;
  PersonDataPayments?: InputMaybe<OrderBy>;
  PersonDataPrepayments?: InputMaybe<OrderBy>;
  PersonDataProductions?: InputMaybe<OrderBy>;
  PersonDataTriggerSync?: InputMaybe<OrderBy>;
};

export type NextStaffAdminPageNextPersonDataBlockWhereInput = {
  PersonData?: InputMaybe<SearchableStringFilterInput>;
  PersonDataCustomerProfile?: InputMaybe<SearchableStringFilterInput>;
  PersonDataExcludeFromLateFee?: InputMaybe<SearchableStringFilterInput>;
  PersonDataMembershipApplication?: InputMaybe<SearchableStringFilterInput>;
  PersonDataNoResults?: InputMaybe<SearchableStringFilterInput>;
  PersonDataPayments?: InputMaybe<SearchableStringFilterInput>;
  PersonDataPrepayments?: InputMaybe<SearchableStringFilterInput>;
  PersonDataProductions?: InputMaybe<SearchableStringFilterInput>;
  PersonDataTriggerSync?: InputMaybe<SearchableStringFilterInput>;
};

export type NextStaffAdminPageNextSyncEventsBlock = {
  __typename?: 'NextStaffAdminPageNextSyncEventsBlock';
  SyncEvents?: Maybe<Scalars['String']['output']>;
  SyncEventsDate?: Maybe<Scalars['String']['output']>;
  SyncEventsDeleteAllUserData?: Maybe<Scalars['String']['output']>;
  SyncEventsSelectAll?: Maybe<Scalars['String']['output']>;
  SyncEventsSelectCustomerProfile?: Maybe<Scalars['String']['output']>;
  SyncEventsSelectMembershipApplication?: Maybe<Scalars['String']['output']>;
  SyncEventsSelectPrepayment?: Maybe<Scalars['String']['output']>;
  SyncEventsSelectProduction?: Maybe<Scalars['String']['output']>;
  SyncEventsSyncEvent?: Maybe<Scalars['String']['output']>;
  SyncEventsSyncEventsNoResults?: Maybe<Scalars['String']['output']>;
  SyncEventsSyncOperation?: Maybe<Scalars['String']['output']>;
  SyncEventsUserDataDeleteConfirmation?: Maybe<Scalars['String']['output']>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsDateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsDeleteAllUserDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsSelectAllArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsSelectCustomerProfileArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsSelectMembershipApplicationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsSelectPrepaymentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsSelectProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsSyncEventArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsSyncEventsNoResultsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsSyncOperationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaffAdminPageNextSyncEventsBlockSyncEventsUserDataDeleteConfirmationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NextStaffAdminPageNextSyncEventsBlockFacet = {
  __typename?: 'NextStaffAdminPageNextSyncEventsBlockFacet';
  SyncEvents?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsDate?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsDeleteAllUserData?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSelectAll?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSelectCustomerProfile?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSelectMembershipApplication?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSelectPrepayment?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSelectProduction?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSyncEvent?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSyncEventsNoResults?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSyncOperation?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsUserDataDeleteConfirmation?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsDateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsDeleteAllUserDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsSelectAllArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsSelectCustomerProfileArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsSelectMembershipApplicationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsSelectPrepaymentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsSelectProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsSyncEventArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsSyncEventsNoResultsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsSyncOperationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaffAdminPageNextSyncEventsBlockFacetSyncEventsUserDataDeleteConfirmationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NextStaffAdminPageNextSyncEventsBlockOrderByInput = {
  SyncEvents?: InputMaybe<OrderBy>;
  SyncEventsDate?: InputMaybe<OrderBy>;
  SyncEventsDeleteAllUserData?: InputMaybe<OrderBy>;
  SyncEventsSelectAll?: InputMaybe<OrderBy>;
  SyncEventsSelectCustomerProfile?: InputMaybe<OrderBy>;
  SyncEventsSelectMembershipApplication?: InputMaybe<OrderBy>;
  SyncEventsSelectPrepayment?: InputMaybe<OrderBy>;
  SyncEventsSelectProduction?: InputMaybe<OrderBy>;
  SyncEventsSyncEvent?: InputMaybe<OrderBy>;
  SyncEventsSyncEventsNoResults?: InputMaybe<OrderBy>;
  SyncEventsSyncOperation?: InputMaybe<OrderBy>;
  SyncEventsUserDataDeleteConfirmation?: InputMaybe<OrderBy>;
};

export type NextStaffAdminPageNextSyncEventsBlockWhereInput = {
  SyncEvents?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsDate?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsDeleteAllUserData?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSelectAll?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSelectCustomerProfile?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSelectMembershipApplication?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSelectPrepayment?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSelectProduction?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSyncEvent?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSyncEventsNoResults?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSyncOperation?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsUserDataDeleteConfirmation?: InputMaybe<SearchableStringFilterInput>;
};

export type NextStaffAdminPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Back?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DeadLetterQueueBlock?: InputMaybe<NextStaffAdminPageNextDeadLetterQueueBlockOrderByInput>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<NextStaffAdminPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonData?: InputMaybe<NextStaffAdminPageNextPersonDataBlockOrderByInput>;
  PersonId?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SyncEventsBlock?: InputMaybe<NextStaffAdminPageNextSyncEventsBlockOrderByInput>;
  ThumbnailImage?: InputMaybe<NextStaffAdminPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  UsersRequiringAttention?: InputMaybe<OrderBy>;
  UsersRequiringAttentionDeadLetterCount?: InputMaybe<OrderBy>;
  UsersRequiringAttentionDescription?: InputMaybe<OrderBy>;
  UsersRequiringAttentionEmailAddress?: InputMaybe<OrderBy>;
  UsersRequiringAttentionEnterPersonId?: InputMaybe<OrderBy>;
  UsersRequiringAttentionGoToPage?: InputMaybe<OrderBy>;
  UsersRequiringAttentionId?: InputMaybe<OrderBy>;
  UsersRequiringAttentionName?: InputMaybe<OrderBy>;
  UsersRequiringAttentionNoResults?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextStaffAdminPageOutput = {
  __typename?: 'NextStaffAdminPageOutput';
  autocomplete?: Maybe<NextStaffAdminPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextStaffAdminPageFacet>;
  item?: Maybe<NextStaffAdminPage>;
  items?: Maybe<Array<Maybe<NextStaffAdminPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextStaffAdminPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextStaffAdminPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Back?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DeadLetterQueueBlock?: InputMaybe<NextStaffAdminPageNextDeadLetterQueueBlockWhereInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<NextStaffAdminPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonData?: InputMaybe<NextStaffAdminPageNextPersonDataBlockWhereInput>;
  PersonId?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SyncEventsBlock?: InputMaybe<NextStaffAdminPageNextSyncEventsBlockWhereInput>;
  ThumbnailImage?: InputMaybe<NextStaffAdminPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  UsersRequiringAttention?: InputMaybe<SearchableStringFilterInput>;
  UsersRequiringAttentionDeadLetterCount?: InputMaybe<SearchableStringFilterInput>;
  UsersRequiringAttentionDescription?: InputMaybe<SearchableStringFilterInput>;
  UsersRequiringAttentionEmailAddress?: InputMaybe<SearchableStringFilterInput>;
  UsersRequiringAttentionEnterPersonId?: InputMaybe<SearchableStringFilterInput>;
  UsersRequiringAttentionGoToPage?: InputMaybe<SearchableStringFilterInput>;
  UsersRequiringAttentionId?: InputMaybe<SearchableStringFilterInput>;
  UsersRequiringAttentionName?: InputMaybe<SearchableStringFilterInput>;
  UsersRequiringAttentionNoResults?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextStaffAdminPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextStaffAdminPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextStaffAdminPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Content page for static pages */
export type NextStaticPage = IContent & IData & {
  __typename?: 'NextStaticPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  HasSecondaryNavigation?: Maybe<Scalars['Bool']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<NextStaticPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<NextStaticPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Content page for static pages */
export type NextStaticPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content page for static pages */
export type NextStaticPageMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content page for static pages */
export type NextStaticPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content page for static pages */
export type NextStaticPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content page for static pages */
export type NextStaticPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content page for static pages */
export type NextStaticPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content page for static pages */
export type NextStaticPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content page for static pages */
export type NextStaticPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextStaticPageAutocomplete = {
  __typename?: 'NextStaticPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<NextStaticPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<NextStaticPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextStaticPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaticPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaticPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaticPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaticPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaticPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaticPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaticPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaticPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextStaticPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextStaticPageFacet = {
  __typename?: 'NextStaticPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  HasSecondaryNavigation?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<NextStaticPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<NextStaticPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextStaticPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextStaticPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextStaticPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextStaticPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetHasSecondaryNavigationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextStaticPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextStaticPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextStaticPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextStaticPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextStaticPageImageBlock = {
  __typename?: 'NextStaticPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type NextStaticPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaticPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaticPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaticPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NextStaticPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NextStaticPageImageBlockAutocomplete = {
  __typename?: 'NextStaticPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type NextStaticPageImageBlockFacet = {
  __typename?: 'NextStaticPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NextStaticPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextStaticPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NextStaticPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NextStaticPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type NextStaticPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type NextStaticPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  HasSecondaryNavigation?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<NextStaticPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<NextStaticPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextStaticPageOutput = {
  __typename?: 'NextStaticPageOutput';
  autocomplete?: Maybe<NextStaticPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextStaticPageFacet>;
  item?: Maybe<NextStaticPage>;
  items?: Maybe<Array<Maybe<NextStaticPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextStaticPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextStaticPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  HasSecondaryNavigation?: InputMaybe<BoolFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<NextStaticPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<NextStaticPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextStaticPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextStaticPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextStaticPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Sync Events block */
export type NextSyncEventsBlock = IContent & IData & {
  __typename?: 'NextSyncEventsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SyncEvents?: Maybe<Scalars['String']['output']>;
  SyncEventsDate?: Maybe<Scalars['String']['output']>;
  SyncEventsDeleteAllUserData?: Maybe<Scalars['String']['output']>;
  SyncEventsSelectAll?: Maybe<Scalars['String']['output']>;
  SyncEventsSelectCustomerProfile?: Maybe<Scalars['String']['output']>;
  SyncEventsSelectMembershipApplication?: Maybe<Scalars['String']['output']>;
  SyncEventsSelectPrepayment?: Maybe<Scalars['String']['output']>;
  SyncEventsSelectProduction?: Maybe<Scalars['String']['output']>;
  SyncEventsSyncEvent?: Maybe<Scalars['String']['output']>;
  SyncEventsSyncEventsNoResults?: Maybe<Scalars['String']['output']>;
  SyncEventsSyncOperation?: Maybe<Scalars['String']['output']>;
  SyncEventsUserDataDeleteConfirmation?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsDateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsDeleteAllUserDataArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsSelectAllArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsSelectCustomerProfileArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsSelectMembershipApplicationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsSelectPrepaymentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsSelectProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsSyncEventArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsSyncEventsNoResultsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsSyncOperationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlockSyncEventsUserDataDeleteConfirmationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Sync Events block */
export type NextSyncEventsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NextSyncEventsBlockAutocomplete = {
  __typename?: 'NextSyncEventsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NextSyncEventsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextSyncEventsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextSyncEventsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextSyncEventsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextSyncEventsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextSyncEventsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextSyncEventsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextSyncEventsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextSyncEventsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NextSyncEventsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NextSyncEventsBlockFacet = {
  __typename?: 'NextSyncEventsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SyncEvents?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsDate?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsDeleteAllUserData?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSelectAll?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSelectCustomerProfile?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSelectMembershipApplication?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSelectPrepayment?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSelectProduction?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSyncEvent?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSyncEventsNoResults?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsSyncOperation?: Maybe<Array<Maybe<StringFacet>>>;
  SyncEventsUserDataDeleteConfirmation?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NextSyncEventsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextSyncEventsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextSyncEventsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextSyncEventsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextSyncEventsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NextSyncEventsBlockFacetSyncEventsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSyncEventsDateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSyncEventsDeleteAllUserDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSyncEventsSelectAllArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSyncEventsSelectCustomerProfileArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSyncEventsSelectMembershipApplicationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSyncEventsSelectPrepaymentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSyncEventsSelectProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSyncEventsSyncEventArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSyncEventsSyncEventsNoResultsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSyncEventsSyncOperationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetSyncEventsUserDataDeleteConfirmationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NextSyncEventsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NextSyncEventsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SyncEvents?: InputMaybe<OrderBy>;
  SyncEventsDate?: InputMaybe<OrderBy>;
  SyncEventsDeleteAllUserData?: InputMaybe<OrderBy>;
  SyncEventsSelectAll?: InputMaybe<OrderBy>;
  SyncEventsSelectCustomerProfile?: InputMaybe<OrderBy>;
  SyncEventsSelectMembershipApplication?: InputMaybe<OrderBy>;
  SyncEventsSelectPrepayment?: InputMaybe<OrderBy>;
  SyncEventsSelectProduction?: InputMaybe<OrderBy>;
  SyncEventsSyncEvent?: InputMaybe<OrderBy>;
  SyncEventsSyncEventsNoResults?: InputMaybe<OrderBy>;
  SyncEventsSyncOperation?: InputMaybe<OrderBy>;
  SyncEventsUserDataDeleteConfirmation?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NextSyncEventsBlockOutput = {
  __typename?: 'NextSyncEventsBlockOutput';
  autocomplete?: Maybe<NextSyncEventsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NextSyncEventsBlockFacet>;
  item?: Maybe<NextSyncEventsBlock>;
  items?: Maybe<Array<Maybe<NextSyncEventsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NextSyncEventsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NextSyncEventsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SyncEvents?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsDate?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsDeleteAllUserData?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSelectAll?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSelectCustomerProfile?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSelectMembershipApplication?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSelectPrepayment?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSelectProduction?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSyncEvent?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSyncEventsNoResults?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsSyncOperation?: InputMaybe<SearchableStringFilterInput>;
  SyncEventsUserDataDeleteConfirmation?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NextSyncEventsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NextSyncEventsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NextSyncEventsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Not found page */
export type NotFoundPage = IContent & IData & {
  __typename?: 'NotFoundPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<NotFoundPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<NotFoundPageImageBlock>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Not found page */
export type NotFoundPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Not found page */
export type NotFoundPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Not found page */
export type NotFoundPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Not found page */
export type NotFoundPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Not found page */
export type NotFoundPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Not found page */
export type NotFoundPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Not found page */
export type NotFoundPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Not found page */
export type NotFoundPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NotFoundPageAutocomplete = {
  __typename?: 'NotFoundPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<NotFoundPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<NotFoundPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NotFoundPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NotFoundPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NotFoundPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NotFoundPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NotFoundPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NotFoundPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NotFoundPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NotFoundPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NotFoundPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NotFoundPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NotFoundPageFacet = {
  __typename?: 'NotFoundPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<NotFoundPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<NotFoundPageImageBlockFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NotFoundPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NotFoundPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NotFoundPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NotFoundPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NotFoundPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NotFoundPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NotFoundPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NotFoundPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NotFoundPageImageBlock = {
  __typename?: 'NotFoundPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type NotFoundPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NotFoundPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NotFoundPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NotFoundPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NotFoundPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NotFoundPageImageBlockAutocomplete = {
  __typename?: 'NotFoundPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type NotFoundPageImageBlockFacet = {
  __typename?: 'NotFoundPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NotFoundPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NotFoundPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NotFoundPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NotFoundPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type NotFoundPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type NotFoundPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<NotFoundPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<NotFoundPageImageBlockOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NotFoundPageOutput = {
  __typename?: 'NotFoundPageOutput';
  autocomplete?: Maybe<NotFoundPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NotFoundPageFacet>;
  item?: Maybe<NotFoundPage>;
  items?: Maybe<Array<Maybe<NotFoundPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NotFoundPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotFoundPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<NotFoundPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<NotFoundPageImageBlockWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NotFoundPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NotFoundPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NotFoundPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type NumberElementBlock = IContent & IData & {
  __typename?: 'NumberElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type NumberElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NumberElementBlockAutocomplete = {
  __typename?: 'NumberElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NumberElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockFacet = {
  __typename?: 'NumberElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NumberElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NumberElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NumberElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NumberElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NumberElementBlockOutput = {
  __typename?: 'NumberElementBlockOutput';
  autocomplete?: Maybe<NumberElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NumberElementBlockFacet>;
  item?: Maybe<NumberElementBlock>;
  items?: Maybe<Array<Maybe<NumberElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NumberElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NumberElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NumberElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NumberElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type NumberFacet = {
  __typename?: 'NumberFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Factor influences the score based of number values with a factor function */
export type NumberFactor = {
  modifier?: InputMaybe<FactorModifier>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** This is an Numbered container block */
export type NumberedContainerBlock = IContent & IData & {
  __typename?: 'NumberedContainerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NumberedItemBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is an Numbered container block */
export type NumberedContainerBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Numbered container block */
export type NumberedContainerBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Numbered container block */
export type NumberedContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Numbered container block */
export type NumberedContainerBlockNumberedItemBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Numbered container block */
export type NumberedContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is an Numbered container block */
export type NumberedContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NumberedContainerBlockAutocomplete = {
  __typename?: 'NumberedContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NumberedContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberedContainerBlockFacet = {
  __typename?: 'NumberedContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NumberedItemBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NumberedContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberedContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberedContainerBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NumberedContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberedContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberedContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberedContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NumberedContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NumberedItemBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NumberedContainerBlockOutput = {
  __typename?: 'NumberedContainerBlockOutput';
  autocomplete?: Maybe<NumberedContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NumberedContainerBlockFacet>;
  item?: Maybe<NumberedContainerBlock>;
  items?: Maybe<Array<Maybe<NumberedContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NumberedContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberedContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NumberedItemBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NumberedContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NumberedContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NumberedContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a Numbered item block */
export type NumberedItemBlock = IContent & IData & {
  __typename?: 'NumberedItemBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubTitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a Numbered item block */
export type NumberedItemBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Numbered item block */
export type NumberedItemBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Numbered item block */
export type NumberedItemBlockSubTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Numbered item block */
export type NumberedItemBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Numbered item block */
export type NumberedItemBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a Numbered item block */
export type NumberedItemBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NumberedItemBlockAutocomplete = {
  __typename?: 'NumberedItemBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NumberedItemBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedItemBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedItemBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedItemBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedItemBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedItemBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedItemBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedItemBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedItemBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberedItemBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberedItemBlockFacet = {
  __typename?: 'NumberedItemBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type NumberedItemBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberedItemBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberedItemBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NumberedItemBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberedItemBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberedItemBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberedItemBlockFacetSubTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberedItemBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type NumberedItemBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubTitle?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type NumberedItemBlockOutput = {
  __typename?: 'NumberedItemBlockOutput';
  autocomplete?: Maybe<NumberedItemBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NumberedItemBlockFacet>;
  item?: Maybe<NumberedItemBlock>;
  items?: Maybe<Array<Maybe<NumberedItemBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NumberedItemBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberedItemBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubTitle?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NumberedItemBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NumberedItemBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NumberedItemBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum OrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderByFacetType {
  Count = 'COUNT',
  Value = 'VALUE'
}

export type ParagraphTextElementBlock = IContent & IData & {
  __typename?: 'ParagraphTextElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisablePlaceholdersReplacement?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FormSubmissionId?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParagraphText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ParagraphTextElementBlockFormSubmissionIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ParagraphTextElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ParagraphTextElementBlockParagraphTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ParagraphTextElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ParagraphTextElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ParagraphTextElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ParagraphTextElementBlockAutocomplete = {
  __typename?: 'ParagraphTextElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ParagraphTextElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockFacet = {
  __typename?: 'ParagraphTextElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisablePlaceholdersReplacement?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormSubmissionId?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParagraphText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ParagraphTextElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ParagraphTextElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ParagraphTextElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ParagraphTextElementBlockFacetDisablePlaceholdersReplacementArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetFormSubmissionIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetParagraphTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ParagraphTextElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ParagraphTextElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ParagraphTextElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ParagraphTextElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisablePlaceholdersReplacement?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormSubmissionId?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParagraphText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ParagraphTextElementBlockOutput = {
  __typename?: 'ParagraphTextElementBlockOutput';
  autocomplete?: Maybe<ParagraphTextElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ParagraphTextElementBlockFacet>;
  item?: Maybe<ParagraphTextElementBlock>;
  items?: Maybe<Array<Maybe<ParagraphTextElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ParagraphTextElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParagraphTextElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisablePlaceholdersReplacement?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormSubmissionId?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParagraphText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ParagraphTextElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ParagraphTextElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ParagraphTextElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Table list of past presidents */
export type PastPresidentsBlock = IContent & IData & {
  __typename?: 'PastPresidentsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PastPresidentsTableReference?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Table list of past presidents */
export type PastPresidentsBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Table list of past presidents */
export type PastPresidentsBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Table list of past presidents */
export type PastPresidentsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Table list of past presidents */
export type PastPresidentsBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Table list of past presidents */
export type PastPresidentsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Table list of past presidents */
export type PastPresidentsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PastPresidentsBlockAutocomplete = {
  __typename?: 'PastPresidentsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PastPresidentsTableReference?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PastPresidentsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PastPresidentsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PastPresidentsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PastPresidentsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PastPresidentsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PastPresidentsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PastPresidentsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PastPresidentsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PastPresidentsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PastPresidentsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PastPresidentsBlockFacet = {
  __typename?: 'PastPresidentsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PastPresidentsTableReference?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PastPresidentsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PastPresidentsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PastPresidentsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PastPresidentsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PastPresidentsBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PastPresidentsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PastPresidentsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PastPresidentsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PastPresidentsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PastPresidentsTableReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PastPresidentsBlockOutput = {
  __typename?: 'PastPresidentsBlockOutput';
  autocomplete?: Maybe<PastPresidentsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PastPresidentsBlockFacet>;
  item?: Maybe<PastPresidentsBlock>;
  items?: Maybe<Array<Maybe<PastPresidentsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PastPresidentsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PastPresidentsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PastPresidentsTableReference?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PastPresidentsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PastPresidentsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PastPresidentsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PaymentProcessingScreenBlock = IContent & IData & {
  __typename?: 'PaymentProcessingScreenBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Button?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Header?: Maybe<Scalars['String']['output']>;
  InfoText?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  ProcessingFailedText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Subheader?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type PaymentProcessingScreenBlockButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PaymentProcessingScreenBlockHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PaymentProcessingScreenBlockInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PaymentProcessingScreenBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PaymentProcessingScreenBlockProcessingFailedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PaymentProcessingScreenBlockSubheaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PaymentProcessingScreenBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PaymentProcessingScreenBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PaymentProcessingScreenBlockAutocomplete = {
  __typename?: 'PaymentProcessingScreenBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PaymentProcessingScreenBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PaymentProcessingScreenBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PaymentProcessingScreenBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PaymentProcessingScreenBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PaymentProcessingScreenBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PaymentProcessingScreenBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PaymentProcessingScreenBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PaymentProcessingScreenBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PaymentProcessingScreenBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PaymentProcessingScreenBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PaymentProcessingScreenBlockFacet = {
  __typename?: 'PaymentProcessingScreenBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Button?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Header?: Maybe<Array<Maybe<StringFacet>>>;
  InfoText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ProcessingFailedText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subheader?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PaymentProcessingScreenBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PaymentProcessingScreenBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PaymentProcessingScreenBlockFacetHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetProcessingFailedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PaymentProcessingScreenBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PaymentProcessingScreenBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PaymentProcessingScreenBlockFacetSubheaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PaymentProcessingScreenBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PaymentProcessingScreenBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Button?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Header?: InputMaybe<OrderBy>;
  InfoText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ProcessingFailedText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subheader?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PaymentProcessingScreenBlockOutput = {
  __typename?: 'PaymentProcessingScreenBlockOutput';
  autocomplete?: Maybe<PaymentProcessingScreenBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PaymentProcessingScreenBlockFacet>;
  item?: Maybe<PaymentProcessingScreenBlock>;
  items?: Maybe<Array<Maybe<PaymentProcessingScreenBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PaymentProcessingScreenBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentProcessingScreenBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Button?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Header?: InputMaybe<SearchableStringFilterInput>;
  InfoText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ProcessingFailedText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subheader?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PaymentProcessingScreenBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PaymentProcessingScreenBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PaymentProcessingScreenBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A block used to render a Person Profile */
export type PersonBlock = IContent & IData & {
  __typename?: 'PersonBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Country?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EmailAddress?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  FacebookHandle?: Maybe<PersonBlockLinkBlock>;
  Image?: Maybe<PersonBlockImageBlock>;
  ImportId?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  InstagramHandle?: Maybe<PersonBlockLinkBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LanguagesList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  LinkedInHandle?: Maybe<PersonBlockLinkBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MemberYears?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonId?: Maybe<Scalars['String']['output']>;
  PhoneExtensionNumber?: Maybe<Scalars['String']['output']>;
  PhoneNumber?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TwitterHandle?: Maybe<PersonBlockLinkBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  Website?: Maybe<PersonBlockLinkBlock>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block used to render a Person Profile */
export type PersonBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlockEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlockImportIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlockMemberYearsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlockPersonIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlockPhoneExtensionNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlockPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlockStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a Person Profile */
export type PersonBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PersonBlockAutocomplete = {
  __typename?: 'PersonBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  FacebookHandle?: Maybe<PersonBlockLinkBlockAutocomplete>;
  Image?: Maybe<PersonBlockImageBlockAutocomplete>;
  InstagramHandle?: Maybe<PersonBlockLinkBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LanguagesList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  LinkedInHandle?: Maybe<PersonBlockLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TwitterHandle?: Maybe<PersonBlockLinkBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Website?: Maybe<PersonBlockLinkBlockAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PersonBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonBlockAutocompleteLanguagesListArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonBlockFacet = {
  __typename?: 'PersonBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FacebookHandle?: Maybe<PersonBlockLinkBlockFacet>;
  Image?: Maybe<PersonBlockImageBlockFacet>;
  ImportId?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  InstagramHandle?: Maybe<PersonBlockLinkBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LanguagesList?: Maybe<Array<Maybe<StringFacet>>>;
  LinkedInHandle?: Maybe<PersonBlockLinkBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MemberYears?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonId?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneExtensionNumber?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  State?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TwitterHandle?: Maybe<PersonBlockLinkBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Website?: Maybe<PersonBlockLinkBlockFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PersonBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetImportIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PersonBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetLanguagesListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetMemberYearsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetPersonIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetPhoneExtensionNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonBlockFacetStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PersonBlockImageBlock = {
  __typename?: 'PersonBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type PersonBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonBlockImageBlockAutocomplete = {
  __typename?: 'PersonBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type PersonBlockImageBlockFacet = {
  __typename?: 'PersonBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PersonBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type PersonBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonBlockLinkBlock = {
  __typename?: 'PersonBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type PersonBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonBlockLinkBlockAutocomplete = {
  __typename?: 'PersonBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PersonBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonBlockLinkBlockFacet = {
  __typename?: 'PersonBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PersonBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type PersonBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EmailAddress?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FacebookHandle?: InputMaybe<PersonBlockLinkBlockOrderByInput>;
  Image?: InputMaybe<PersonBlockImageBlockOrderByInput>;
  ImportId?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  InstagramHandle?: InputMaybe<PersonBlockLinkBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LanguagesList?: InputMaybe<OrderBy>;
  LinkedInHandle?: InputMaybe<PersonBlockLinkBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MemberYears?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonId?: InputMaybe<OrderBy>;
  PhoneExtensionNumber?: InputMaybe<OrderBy>;
  PhoneNumber?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  State?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TwitterHandle?: InputMaybe<PersonBlockLinkBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  Website?: InputMaybe<PersonBlockLinkBlockOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PersonBlockOutput = {
  __typename?: 'PersonBlockOutput';
  autocomplete?: Maybe<PersonBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PersonBlockFacet>;
  item?: Maybe<PersonBlock>;
  items?: Maybe<Array<Maybe<PersonBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PersonBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EmailAddress?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FacebookHandle?: InputMaybe<PersonBlockLinkBlockWhereInput>;
  Image?: InputMaybe<PersonBlockImageBlockWhereInput>;
  ImportId?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  InstagramHandle?: InputMaybe<PersonBlockLinkBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LanguagesList?: InputMaybe<StringFilterInput>;
  LinkedInHandle?: InputMaybe<PersonBlockLinkBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MemberYears?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonId?: InputMaybe<SearchableStringFilterInput>;
  PhoneExtensionNumber?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  State?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TwitterHandle?: InputMaybe<PersonBlockLinkBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  Website?: InputMaybe<PersonBlockLinkBlockWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<PersonBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PersonBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PersonBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a person container block */
export type PersonContainerBlock = IContent & IData & {
  __typename?: 'PersonContainerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  ProfileList?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a person container block */
export type PersonContainerBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a person container block */
export type PersonContainerBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a person container block */
export type PersonContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a person container block */
export type PersonContainerBlockProfileListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a person container block */
export type PersonContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a person container block */
export type PersonContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PersonContainerBlockAutocomplete = {
  __typename?: 'PersonContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PersonContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonContainerBlockFacet = {
  __typename?: 'PersonContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ProfileList?: Maybe<ContentAreaItemModelSearchFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PersonContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonContainerBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PersonContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PersonContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ProfileList?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PersonContainerBlockOutput = {
  __typename?: 'PersonContainerBlockOutput';
  autocomplete?: Maybe<PersonContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PersonContainerBlockFacet>;
  item?: Maybe<PersonContainerBlock>;
  items?: Maybe<Array<Maybe<PersonContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PersonContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ProfileList?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PersonContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PersonContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PersonContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for person quiz questions */
export type PersonQuizPage = IContent & IData & {
  __typename?: 'PersonQuizPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  /** Career content */
  Career?: Maybe<PersonQuizPageQuizCareerBlock>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** The label for description, shown beneath Title */
  Description?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  /** Education content */
  Education?: Maybe<PersonQuizPageQuizEducationBlock>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  /** Financial content */
  Financial?: Maybe<PersonQuizPageQuizFinancialBlock>;
  /** Health content */
  Health?: Maybe<PersonQuizPageQuizHealthBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<PersonQuizPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Relationships content */
  Relationships?: Maybe<PersonQuizPageQuizRelationshipsBlock>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  /** Service content */
  Service?: Maybe<PersonQuizPageQuizServiceBlock>;
  SharedContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  /** The label for slider information, shown before first question */
  SliderInfo?: Maybe<Scalars['String']['output']>;
  /** Spiritual content */
  Spiritual?: Maybe<PersonQuizPageQuizSpiritualBlock>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<PersonQuizPageImageBlock>;
  /** The title for person quiz, shown on the top */
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for person quiz questions */
export type PersonQuizPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for person quiz questions */
export type PersonQuizPageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for person quiz questions */
export type PersonQuizPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for person quiz questions */
export type PersonQuizPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for person quiz questions */
export type PersonQuizPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for person quiz questions */
export type PersonQuizPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for person quiz questions */
export type PersonQuizPageSharedContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for person quiz questions */
export type PersonQuizPageSliderInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for person quiz questions */
export type PersonQuizPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for person quiz questions */
export type PersonQuizPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for person quiz questions */
export type PersonQuizPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PersonQuizPageAutocomplete = {
  __typename?: 'PersonQuizPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Career?: Maybe<PersonQuizPageQuizCareerBlockAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Education?: Maybe<PersonQuizPageQuizEducationBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Financial?: Maybe<PersonQuizPageQuizFinancialBlockAutocomplete>;
  Health?: Maybe<PersonQuizPageQuizHealthBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<PersonQuizPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Relationships?: Maybe<PersonQuizPageQuizRelationshipsBlockAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Service?: Maybe<PersonQuizPageQuizServiceBlockAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Spiritual?: Maybe<PersonQuizPageQuizSpiritualBlockAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<PersonQuizPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PersonQuizPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonQuizPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonQuizPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonQuizPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonQuizPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonQuizPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonQuizPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonQuizPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonQuizPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonQuizPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonQuizPageFacet = {
  __typename?: 'PersonQuizPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Career?: Maybe<PersonQuizPageQuizCareerBlockFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  Education?: Maybe<PersonQuizPageQuizEducationBlockFacet>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  Financial?: Maybe<PersonQuizPageQuizFinancialBlockFacet>;
  Health?: Maybe<PersonQuizPageQuizHealthBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<PersonQuizPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Relationships?: Maybe<PersonQuizPageQuizRelationshipsBlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Service?: Maybe<PersonQuizPageQuizServiceBlockFacet>;
  SharedContent?: Maybe<ContentAreaItemModelSearchFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SliderInfo?: Maybe<Array<Maybe<StringFacet>>>;
  Spiritual?: Maybe<PersonQuizPageQuizSpiritualBlockFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<PersonQuizPageImageBlockFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PersonQuizPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonQuizPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PersonQuizPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonQuizPageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PersonQuizPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonQuizPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetSliderInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonQuizPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonQuizPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PersonQuizPageImageBlock = {
  __typename?: 'PersonQuizPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type PersonQuizPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonQuizPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonQuizPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonQuizPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonQuizPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonQuizPageImageBlockAutocomplete = {
  __typename?: 'PersonQuizPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type PersonQuizPageImageBlockFacet = {
  __typename?: 'PersonQuizPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonQuizPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PersonQuizPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonQuizPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type PersonQuizPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonQuizPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Career?: InputMaybe<PersonQuizPageQuizCareerBlockOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  Education?: InputMaybe<PersonQuizPageQuizEducationBlockOrderByInput>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  Financial?: InputMaybe<PersonQuizPageQuizFinancialBlockOrderByInput>;
  Health?: InputMaybe<PersonQuizPageQuizHealthBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<PersonQuizPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Relationships?: InputMaybe<PersonQuizPageQuizRelationshipsBlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Service?: InputMaybe<PersonQuizPageQuizServiceBlockOrderByInput>;
  SharedContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SliderInfo?: InputMaybe<OrderBy>;
  Spiritual?: InputMaybe<PersonQuizPageQuizSpiritualBlockOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<PersonQuizPageImageBlockOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PersonQuizPageOutput = {
  __typename?: 'PersonQuizPageOutput';
  autocomplete?: Maybe<PersonQuizPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PersonQuizPageFacet>;
  item?: Maybe<PersonQuizPage>;
  items?: Maybe<Array<Maybe<PersonQuizPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PersonQuizPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonQuizPageQuizCareerBlock = {
  __typename?: 'PersonQuizPageQuizCareerBlock';
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  Title?: Maybe<Scalars['String']['output']>;
  TopicDescription?: Maybe<Scalars['String']['output']>;
};


export type PersonQuizPageQuizCareerBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonQuizPageQuizCareerBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonQuizPageQuizCareerBlockAutocomplete = {
  __typename?: 'PersonQuizPageQuizCareerBlockAutocomplete';
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
};

export type PersonQuizPageQuizCareerBlockFacet = {
  __typename?: 'PersonQuizPageQuizCareerBlockFacet';
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonQuizPageQuizCareerBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageQuizCareerBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonQuizPageQuizCareerBlockOrderByInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
};

export type PersonQuizPageQuizCareerBlockWhereInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonQuizPageQuizEducationBlock = {
  __typename?: 'PersonQuizPageQuizEducationBlock';
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  Title?: Maybe<Scalars['String']['output']>;
  TopicDescription?: Maybe<Scalars['String']['output']>;
};


export type PersonQuizPageQuizEducationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonQuizPageQuizEducationBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonQuizPageQuizEducationBlockAutocomplete = {
  __typename?: 'PersonQuizPageQuizEducationBlockAutocomplete';
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
};

export type PersonQuizPageQuizEducationBlockFacet = {
  __typename?: 'PersonQuizPageQuizEducationBlockFacet';
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonQuizPageQuizEducationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageQuizEducationBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonQuizPageQuizEducationBlockOrderByInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
};

export type PersonQuizPageQuizEducationBlockWhereInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonQuizPageQuizFinancialBlock = {
  __typename?: 'PersonQuizPageQuizFinancialBlock';
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  Title?: Maybe<Scalars['String']['output']>;
  TopicDescription?: Maybe<Scalars['String']['output']>;
};


export type PersonQuizPageQuizFinancialBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonQuizPageQuizFinancialBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonQuizPageQuizFinancialBlockAutocomplete = {
  __typename?: 'PersonQuizPageQuizFinancialBlockAutocomplete';
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
};

export type PersonQuizPageQuizFinancialBlockFacet = {
  __typename?: 'PersonQuizPageQuizFinancialBlockFacet';
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonQuizPageQuizFinancialBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageQuizFinancialBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonQuizPageQuizFinancialBlockOrderByInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
};

export type PersonQuizPageQuizFinancialBlockWhereInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonQuizPageQuizHealthBlock = {
  __typename?: 'PersonQuizPageQuizHealthBlock';
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  Title?: Maybe<Scalars['String']['output']>;
  TopicDescription?: Maybe<Scalars['String']['output']>;
};


export type PersonQuizPageQuizHealthBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonQuizPageQuizHealthBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonQuizPageQuizHealthBlockAutocomplete = {
  __typename?: 'PersonQuizPageQuizHealthBlockAutocomplete';
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
};

export type PersonQuizPageQuizHealthBlockFacet = {
  __typename?: 'PersonQuizPageQuizHealthBlockFacet';
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonQuizPageQuizHealthBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageQuizHealthBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonQuizPageQuizHealthBlockOrderByInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
};

export type PersonQuizPageQuizHealthBlockWhereInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonQuizPageQuizRelationshipsBlock = {
  __typename?: 'PersonQuizPageQuizRelationshipsBlock';
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  Title?: Maybe<Scalars['String']['output']>;
  TopicDescription?: Maybe<Scalars['String']['output']>;
};


export type PersonQuizPageQuizRelationshipsBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonQuizPageQuizRelationshipsBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonQuizPageQuizRelationshipsBlockAutocomplete = {
  __typename?: 'PersonQuizPageQuizRelationshipsBlockAutocomplete';
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
};

export type PersonQuizPageQuizRelationshipsBlockFacet = {
  __typename?: 'PersonQuizPageQuizRelationshipsBlockFacet';
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonQuizPageQuizRelationshipsBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageQuizRelationshipsBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonQuizPageQuizRelationshipsBlockOrderByInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
};

export type PersonQuizPageQuizRelationshipsBlockWhereInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonQuizPageQuizServiceBlock = {
  __typename?: 'PersonQuizPageQuizServiceBlock';
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  Title?: Maybe<Scalars['String']['output']>;
  TopicDescription?: Maybe<Scalars['String']['output']>;
};


export type PersonQuizPageQuizServiceBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonQuizPageQuizServiceBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonQuizPageQuizServiceBlockAutocomplete = {
  __typename?: 'PersonQuizPageQuizServiceBlockAutocomplete';
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
};

export type PersonQuizPageQuizServiceBlockFacet = {
  __typename?: 'PersonQuizPageQuizServiceBlockFacet';
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonQuizPageQuizServiceBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageQuizServiceBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonQuizPageQuizServiceBlockOrderByInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
};

export type PersonQuizPageQuizServiceBlockWhereInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonQuizPageQuizSpiritualBlock = {
  __typename?: 'PersonQuizPageQuizSpiritualBlock';
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  Title?: Maybe<Scalars['String']['output']>;
  TopicDescription?: Maybe<Scalars['String']['output']>;
};


export type PersonQuizPageQuizSpiritualBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonQuizPageQuizSpiritualBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonQuizPageQuizSpiritualBlockAutocomplete = {
  __typename?: 'PersonQuizPageQuizSpiritualBlockAutocomplete';
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
};

export type PersonQuizPageQuizSpiritualBlockFacet = {
  __typename?: 'PersonQuizPageQuizSpiritualBlockFacet';
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonQuizPageQuizSpiritualBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonQuizPageQuizSpiritualBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonQuizPageQuizSpiritualBlockOrderByInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
};

export type PersonQuizPageQuizSpiritualBlockWhereInput = {
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonQuizPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Career?: InputMaybe<PersonQuizPageQuizCareerBlockWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  Education?: InputMaybe<PersonQuizPageQuizEducationBlockWhereInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  Financial?: InputMaybe<PersonQuizPageQuizFinancialBlockWhereInput>;
  Health?: InputMaybe<PersonQuizPageQuizHealthBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<PersonQuizPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Relationships?: InputMaybe<PersonQuizPageQuizRelationshipsBlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Service?: InputMaybe<PersonQuizPageQuizServiceBlockWhereInput>;
  SharedContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SliderInfo?: InputMaybe<SearchableStringFilterInput>;
  Spiritual?: InputMaybe<PersonQuizPageQuizSpiritualBlockWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<PersonQuizPageImageBlockWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PersonQuizPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PersonQuizPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PersonQuizPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlock = IContent & IData & {
  __typename?: 'PersonUpdatesSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BirthYear?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine1?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine2?: Maybe<Scalars['String']['output']>;
  BusinessAddressLine3?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  CompanyID?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Country?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Designation1?: Maybe<Scalars['String']['output']>;
  Designation2?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstGivenName?: Maybe<Scalars['String']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastFamilyName?: Maybe<Scalars['String']['output']>;
  LastYearOfMembership?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddressLine1?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddressLine2?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddressLine3?: Maybe<Scalars['String']['output']>;
  LocalLanguageCity?: Maybe<Scalars['String']['output']>;
  LocalLanguageCountry?: Maybe<Scalars['String']['output']>;
  LocalLanguageName?: Maybe<Scalars['String']['output']>;
  LocalLanguagePostalCode?: Maybe<Scalars['String']['output']>;
  LocalLanguagePreferredName?: Maybe<Scalars['String']['output']>;
  LocalLanguageState?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MiddleName?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneAreaCode?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneCountryCode?: Maybe<Scalars['String']['output']>;
  MobileCellPhoneNumber?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  OfficePhoneAreaCode?: Maybe<Scalars['String']['output']>;
  OfficePhoneCountryCode?: Maybe<Scalars['String']['output']>;
  OfficePhoneNumber?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonalCompany?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  PreferredName?: Maybe<Scalars['String']['output']>;
  Prefix?: Maybe<Scalars['String']['output']>;
  PrimaryEmailAddress?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SecondaryEmailAddress?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Suffix?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  YearOfFirstInsuranceLicense?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockBirthYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockBusinessAddressLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockBusinessAddressLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockBusinessAddressLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockCompanyIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockDesignation1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockDesignation2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockFirstGivenNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockGenderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockLastFamilyNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockLastYearOfMembershipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockLocalLanguageAddressLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockLocalLanguageAddressLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockLocalLanguageAddressLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockLocalLanguageCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockLocalLanguageCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockLocalLanguageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockLocalLanguagePostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockLocalLanguagePreferredNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockLocalLanguageStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockMiddleNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockMobileCellPhoneAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockMobileCellPhoneCountryCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockMobileCellPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockOfficePhoneAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockOfficePhoneCountryCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockOfficePhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockPersonalCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockPostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockPreferredNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockPrefixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockPrimaryEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockSecondaryEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockSuffixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlockYearOfFirstInsuranceLicenseArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Person updates for the Company Admin page */
export type PersonUpdatesSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PersonUpdatesSectionBlockAutocomplete = {
  __typename?: 'PersonUpdatesSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PersonUpdatesSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonUpdatesSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonUpdatesSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonUpdatesSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonUpdatesSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonUpdatesSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonUpdatesSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonUpdatesSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonUpdatesSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonUpdatesSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonUpdatesSectionBlockFacet = {
  __typename?: 'PersonUpdatesSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BirthYear?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine1?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine2?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessAddressLine3?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyID?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Designation1?: Maybe<Array<Maybe<StringFacet>>>;
  Designation2?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstGivenName?: Maybe<Array<Maybe<StringFacet>>>;
  Gender?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastFamilyName?: Maybe<Array<Maybe<StringFacet>>>;
  LastYearOfMembership?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddressLine1?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddressLine2?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddressLine3?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageCity?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageCountry?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageName?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguagePostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguagePreferredName?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageState?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MiddleName?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneAreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneCountryCode?: Maybe<Array<Maybe<StringFacet>>>;
  MobileCellPhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneAreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneCountryCode?: Maybe<Array<Maybe<StringFacet>>>;
  OfficePhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonalCompany?: Maybe<Array<Maybe<StringFacet>>>;
  PostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredName?: Maybe<Array<Maybe<StringFacet>>>;
  Prefix?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryEmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SecondaryEmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  State?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Suffix?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstInsuranceLicense?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PersonUpdatesSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetBirthYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetBusinessAddressLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetBusinessAddressLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetBusinessAddressLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonUpdatesSectionBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetCompanyIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonUpdatesSectionBlockFacetDesignation1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetDesignation2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetFirstGivenNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetGenderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PersonUpdatesSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetLastFamilyNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetLastYearOfMembershipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetLocalLanguageAddressLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetLocalLanguageAddressLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetLocalLanguageAddressLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetLocalLanguageCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetLocalLanguageCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetLocalLanguageNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetLocalLanguagePostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetLocalLanguagePreferredNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetLocalLanguageStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetMiddleNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetMobileCellPhoneAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetMobileCellPhoneCountryCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetMobileCellPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetOfficePhoneAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetOfficePhoneCountryCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetOfficePhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetPersonalCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetPostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetPreferredNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetPrefixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetPrimaryEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonUpdatesSectionBlockFacetSecondaryEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonUpdatesSectionBlockFacetStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonUpdatesSectionBlockFacetSuffixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacetYearOfFirstInsuranceLicenseArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonUpdatesSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PersonUpdatesSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BirthYear?: InputMaybe<OrderBy>;
  BusinessAddressLine1?: InputMaybe<OrderBy>;
  BusinessAddressLine2?: InputMaybe<OrderBy>;
  BusinessAddressLine3?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  CompanyID?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Designation1?: InputMaybe<OrderBy>;
  Designation2?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstGivenName?: InputMaybe<OrderBy>;
  Gender?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastFamilyName?: InputMaybe<OrderBy>;
  LastYearOfMembership?: InputMaybe<OrderBy>;
  LocalLanguageAddressLine1?: InputMaybe<OrderBy>;
  LocalLanguageAddressLine2?: InputMaybe<OrderBy>;
  LocalLanguageAddressLine3?: InputMaybe<OrderBy>;
  LocalLanguageCity?: InputMaybe<OrderBy>;
  LocalLanguageCountry?: InputMaybe<OrderBy>;
  LocalLanguageName?: InputMaybe<OrderBy>;
  LocalLanguagePostalCode?: InputMaybe<OrderBy>;
  LocalLanguagePreferredName?: InputMaybe<OrderBy>;
  LocalLanguageState?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MiddleName?: InputMaybe<OrderBy>;
  MobileCellPhoneAreaCode?: InputMaybe<OrderBy>;
  MobileCellPhoneCountryCode?: InputMaybe<OrderBy>;
  MobileCellPhoneNumber?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  OfficePhoneAreaCode?: InputMaybe<OrderBy>;
  OfficePhoneCountryCode?: InputMaybe<OrderBy>;
  OfficePhoneNumber?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonalCompany?: InputMaybe<OrderBy>;
  PostalCode?: InputMaybe<OrderBy>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  PreferredName?: InputMaybe<OrderBy>;
  Prefix?: InputMaybe<OrderBy>;
  PrimaryEmailAddress?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SecondaryEmailAddress?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  State?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Suffix?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  YearOfFirstInsuranceLicense?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PersonUpdatesSectionBlockOutput = {
  __typename?: 'PersonUpdatesSectionBlockOutput';
  autocomplete?: Maybe<PersonUpdatesSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PersonUpdatesSectionBlockFacet>;
  item?: Maybe<PersonUpdatesSectionBlock>;
  items?: Maybe<Array<Maybe<PersonUpdatesSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PersonUpdatesSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonUpdatesSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BirthYear?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine1?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine2?: InputMaybe<SearchableStringFilterInput>;
  BusinessAddressLine3?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  CompanyID?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Designation1?: InputMaybe<SearchableStringFilterInput>;
  Designation2?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstGivenName?: InputMaybe<SearchableStringFilterInput>;
  Gender?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastFamilyName?: InputMaybe<SearchableStringFilterInput>;
  LastYearOfMembership?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddressLine1?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddressLine2?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddressLine3?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageCity?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageCountry?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageName?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguagePostalCode?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguagePreferredName?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageState?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MiddleName?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneAreaCode?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneCountryCode?: InputMaybe<SearchableStringFilterInput>;
  MobileCellPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneAreaCode?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneCountryCode?: InputMaybe<SearchableStringFilterInput>;
  OfficePhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonalCompany?: InputMaybe<SearchableStringFilterInput>;
  PostalCode?: InputMaybe<SearchableStringFilterInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  PreferredName?: InputMaybe<SearchableStringFilterInput>;
  Prefix?: InputMaybe<SearchableStringFilterInput>;
  PrimaryEmailAddress?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SecondaryEmailAddress?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  State?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Suffix?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  YearOfFirstInsuranceLicense?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PersonUpdatesSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PersonUpdatesSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PersonUpdatesSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a featured in playlist block */
export type PlaylistBlock = IContent & IData & {
  __typename?: 'PlaylistBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** Renders Learn Play List Pages */
  Items?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Subheading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a featured in playlist block */
export type PlaylistBlockItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a featured in playlist block */
export type PlaylistBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a featured in playlist block */
export type PlaylistBlockSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a featured in playlist block */
export type PlaylistBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a featured in playlist block */
export type PlaylistBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PlaylistBlockAutocomplete = {
  __typename?: 'PlaylistBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PlaylistBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PlaylistBlockFacet = {
  __typename?: 'PlaylistBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<ContentAreaItemModelSearchFacet>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subheading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PlaylistBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaylistBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaylistBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PlaylistBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaylistBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaylistBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaylistBlockFacetSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PlaylistBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Items?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subheading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PlaylistBlockOutput = {
  __typename?: 'PlaylistBlockOutput';
  autocomplete?: Maybe<PlaylistBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PlaylistBlockFacet>;
  item?: Maybe<PlaylistBlock>;
  items?: Maybe<Array<Maybe<PlaylistBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PlaylistBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlaylistBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subheading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PlaylistBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PlaylistBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PlaylistBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a  playlist promo block */
export type PlaylistPromoBlock = IContent & IData & {
  __typename?: 'PlaylistPromoBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** Renders Learn Play List Pages */
  Items?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Subheading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a  playlist promo block */
export type PlaylistPromoBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a  playlist promo block */
export type PlaylistPromoBlockItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a  playlist promo block */
export type PlaylistPromoBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a  playlist promo block */
export type PlaylistPromoBlockSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a  playlist promo block */
export type PlaylistPromoBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a  playlist promo block */
export type PlaylistPromoBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PlaylistPromoBlockAutocomplete = {
  __typename?: 'PlaylistPromoBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PlaylistPromoBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistPromoBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistPromoBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistPromoBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistPromoBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistPromoBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistPromoBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistPromoBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistPromoBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlaylistPromoBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PlaylistPromoBlockFacet = {
  __typename?: 'PlaylistPromoBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<ContentAreaItemModelSearchFacet>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subheading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PlaylistPromoBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaylistPromoBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaylistPromoBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaylistPromoBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaylistPromoBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaylistPromoBlockFacetSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlaylistPromoBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PlaylistPromoBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Items?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subheading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PlaylistPromoBlockOutput = {
  __typename?: 'PlaylistPromoBlockOutput';
  autocomplete?: Maybe<PlaylistPromoBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PlaylistPromoBlockFacet>;
  item?: Maybe<PlaylistPromoBlock>;
  items?: Maybe<Array<Maybe<PlaylistPromoBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PlaylistPromoBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlaylistPromoBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subheading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PlaylistPromoBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PlaylistPromoBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PlaylistPromoBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This block renders podcast details */
export type PodcastDetailBlock = IContent & IData & {
  __typename?: 'PodcastDetailBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AppleLink?: Maybe<PodcastDetailBlockLinkBlock>;
  /** Drop an audio file for playback with the native html5 audio player */
  AudioContent?: Maybe<ContentModelReference>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ImageBlock?: Maybe<PodcastDetailBlockLearnHeroImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  ListenonLine?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SoundCloudLink?: Maybe<PodcastDetailBlockLinkBlock>;
  /** Copy the embed html from SoundCloud's Embed feature */
  SoundCloudUrl?: Maybe<Scalars['String']['output']>;
  SpotifyLink?: Maybe<PodcastDetailBlockLinkBlock>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewTranscript?: Maybe<PodcastDetailBlockRichTextBlock>;
  ViewTranscriptLine?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This block renders podcast details */
export type PodcastDetailBlockListenonLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders podcast details */
export type PodcastDetailBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders podcast details */
export type PodcastDetailBlockSoundCloudUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders podcast details */
export type PodcastDetailBlockViewTranscriptLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders podcast details */
export type PodcastDetailBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders podcast details */
export type PodcastDetailBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PodcastDetailBlockAutocomplete = {
  __typename?: 'PodcastDetailBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AppleLink?: Maybe<PodcastDetailBlockLinkBlockAutocomplete>;
  AudioContent?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ImageBlock?: Maybe<PodcastDetailBlockLearnHeroImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SoundCloudLink?: Maybe<PodcastDetailBlockLinkBlockAutocomplete>;
  SpotifyLink?: Maybe<PodcastDetailBlockLinkBlockAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PodcastDetailBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PodcastDetailBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PodcastDetailBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PodcastDetailBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PodcastDetailBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PodcastDetailBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PodcastDetailBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PodcastDetailBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PodcastDetailBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PodcastDetailBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PodcastDetailBlockFacet = {
  __typename?: 'PodcastDetailBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AppleLink?: Maybe<PodcastDetailBlockLinkBlockFacet>;
  AudioContent?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageBlock?: Maybe<PodcastDetailBlockLearnHeroImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  ListenonLine?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SoundCloudLink?: Maybe<PodcastDetailBlockLinkBlockFacet>;
  SoundCloudUrl?: Maybe<Array<Maybe<StringFacet>>>;
  SpotifyLink?: Maybe<PodcastDetailBlockLinkBlockFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewTranscript?: Maybe<PodcastDetailBlockRichTextBlockFacet>;
  ViewTranscriptLine?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PodcastDetailBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PodcastDetailBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PodcastDetailBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PodcastDetailBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetListenonLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PodcastDetailBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetSoundCloudUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PodcastDetailBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PodcastDetailBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacetViewTranscriptLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PodcastDetailBlockLearnHeroImageBlock = {
  __typename?: 'PodcastDetailBlockLearnHeroImageBlock';
  HeroImage?: Maybe<PodcastDetailBlockLearnHeroImageBlockImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  MobileImage?: Maybe<PodcastDetailBlockLearnHeroImageBlockImageBlock>;
};

export type PodcastDetailBlockLearnHeroImageBlockAutocomplete = {
  __typename?: 'PodcastDetailBlockLearnHeroImageBlockAutocomplete';
  HeroImage?: Maybe<PodcastDetailBlockLearnHeroImageBlockImageBlockAutocomplete>;
  MobileImage?: Maybe<PodcastDetailBlockLearnHeroImageBlockImageBlockAutocomplete>;
};

export type PodcastDetailBlockLearnHeroImageBlockFacet = {
  __typename?: 'PodcastDetailBlockLearnHeroImageBlockFacet';
  HeroImage?: Maybe<PodcastDetailBlockLearnHeroImageBlockImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  MobileImage?: Maybe<PodcastDetailBlockLearnHeroImageBlockImageBlockFacet>;
};


export type PodcastDetailBlockLearnHeroImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PodcastDetailBlockLearnHeroImageBlockImageBlock = {
  __typename?: 'PodcastDetailBlockLearnHeroImageBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type PodcastDetailBlockLearnHeroImageBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockLearnHeroImageBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockLearnHeroImageBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockLearnHeroImageBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockLearnHeroImageBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PodcastDetailBlockLearnHeroImageBlockImageBlockAutocomplete = {
  __typename?: 'PodcastDetailBlockLearnHeroImageBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type PodcastDetailBlockLearnHeroImageBlockImageBlockFacet = {
  __typename?: 'PodcastDetailBlockLearnHeroImageBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PodcastDetailBlockLearnHeroImageBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLearnHeroImageBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLearnHeroImageBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLearnHeroImageBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLearnHeroImageBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PodcastDetailBlockLearnHeroImageBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PodcastDetailBlockLearnHeroImageBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type PodcastDetailBlockLearnHeroImageBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type PodcastDetailBlockLearnHeroImageBlockOrderByInput = {
  HeroImage?: InputMaybe<PodcastDetailBlockLearnHeroImageBlockImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  MobileImage?: InputMaybe<PodcastDetailBlockLearnHeroImageBlockImageBlockOrderByInput>;
};

export type PodcastDetailBlockLearnHeroImageBlockWhereInput = {
  HeroImage?: InputMaybe<PodcastDetailBlockLearnHeroImageBlockImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  MobileImage?: InputMaybe<PodcastDetailBlockLearnHeroImageBlockImageBlockWhereInput>;
};

export type PodcastDetailBlockLinkBlock = {
  __typename?: 'PodcastDetailBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type PodcastDetailBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PodcastDetailBlockLinkBlockAutocomplete = {
  __typename?: 'PodcastDetailBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PodcastDetailBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PodcastDetailBlockLinkBlockFacet = {
  __typename?: 'PodcastDetailBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PodcastDetailBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PodcastDetailBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PodcastDetailBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type PodcastDetailBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type PodcastDetailBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AppleLink?: InputMaybe<PodcastDetailBlockLinkBlockOrderByInput>;
  AudioContent?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageBlock?: InputMaybe<PodcastDetailBlockLearnHeroImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  ListenonLine?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SoundCloudLink?: InputMaybe<PodcastDetailBlockLinkBlockOrderByInput>;
  SoundCloudUrl?: InputMaybe<OrderBy>;
  SpotifyLink?: InputMaybe<PodcastDetailBlockLinkBlockOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ViewTranscript?: InputMaybe<PodcastDetailBlockRichTextBlockOrderByInput>;
  ViewTranscriptLine?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PodcastDetailBlockOutput = {
  __typename?: 'PodcastDetailBlockOutput';
  autocomplete?: Maybe<PodcastDetailBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PodcastDetailBlockFacet>;
  item?: Maybe<PodcastDetailBlock>;
  items?: Maybe<Array<Maybe<PodcastDetailBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PodcastDetailBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PodcastDetailBlockRichTextBlock = {
  __typename?: 'PodcastDetailBlockRichTextBlock';
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type PodcastDetailBlockRichTextBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockRichTextBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockRichTextBlockContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockRichTextBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PodcastDetailBlockRichTextBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PodcastDetailBlockRichTextBlockFacet = {
  __typename?: 'PodcastDetailBlockRichTextBlockFacet';
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PodcastDetailBlockRichTextBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockRichTextBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockRichTextBlockFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockRichTextBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PodcastDetailBlockRichTextBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PodcastDetailBlockRichTextBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PodcastDetailBlockRichTextBlockOrderByInput = {
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type PodcastDetailBlockRichTextBlockWhereInput = {
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type PodcastDetailBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AppleLink?: InputMaybe<PodcastDetailBlockLinkBlockWhereInput>;
  AudioContent?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageBlock?: InputMaybe<PodcastDetailBlockLearnHeroImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  ListenonLine?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SoundCloudLink?: InputMaybe<PodcastDetailBlockLinkBlockWhereInput>;
  SoundCloudUrl?: InputMaybe<SearchableStringFilterInput>;
  SpotifyLink?: InputMaybe<PodcastDetailBlockLinkBlockWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewTranscript?: InputMaybe<PodcastDetailBlockRichTextBlockWhereInput>;
  ViewTranscriptLine?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PodcastDetailBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PodcastDetailBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PodcastDetailBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Power Phrase */
export type PowerPhrasePage = IContent & IData & {
  __typename?: 'PowerPhrasePage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Message?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<PowerPhrasePageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PowerPhrase?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SendToEmail?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<PowerPhrasePageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Power Phrase */
export type PowerPhrasePageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Power Phrase */
export type PowerPhrasePageMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Power Phrase */
export type PowerPhrasePageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Power Phrase */
export type PowerPhrasePageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Power Phrase */
export type PowerPhrasePageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Power Phrase */
export type PowerPhrasePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Power Phrase */
export type PowerPhrasePagePowerPhraseArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Power Phrase */
export type PowerPhrasePageSendToEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Power Phrase */
export type PowerPhrasePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Power Phrase */
export type PowerPhrasePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PowerPhrasePageAutocomplete = {
  __typename?: 'PowerPhrasePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<PowerPhrasePageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<PowerPhrasePageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PowerPhrasePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PowerPhrasePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PowerPhrasePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PowerPhrasePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PowerPhrasePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PowerPhrasePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PowerPhrasePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PowerPhrasePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PowerPhrasePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PowerPhrasePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PowerPhrasePageFacet = {
  __typename?: 'PowerPhrasePageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Message?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<PowerPhrasePageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PowerPhrase?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SendToEmail?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<PowerPhrasePageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PowerPhrasePageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PowerPhrasePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PowerPhrasePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PowerPhrasePageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PowerPhrasePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetPowerPhraseArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PowerPhrasePageFacetSendToEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PowerPhrasePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PowerPhrasePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PowerPhrasePageImageBlock = {
  __typename?: 'PowerPhrasePageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type PowerPhrasePageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PowerPhrasePageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PowerPhrasePageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PowerPhrasePageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PowerPhrasePageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PowerPhrasePageImageBlockAutocomplete = {
  __typename?: 'PowerPhrasePageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type PowerPhrasePageImageBlockFacet = {
  __typename?: 'PowerPhrasePageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PowerPhrasePageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PowerPhrasePageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PowerPhrasePageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PowerPhrasePageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type PowerPhrasePageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type PowerPhrasePageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Message?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<PowerPhrasePageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PowerPhrase?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SendToEmail?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<PowerPhrasePageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PowerPhrasePageOutput = {
  __typename?: 'PowerPhrasePageOutput';
  autocomplete?: Maybe<PowerPhrasePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PowerPhrasePageFacet>;
  item?: Maybe<PowerPhrasePage>;
  items?: Maybe<Array<Maybe<PowerPhrasePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PowerPhrasePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PowerPhrasePageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Message?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<PowerPhrasePageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PowerPhrase?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SendToEmail?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<PowerPhrasePageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PowerPhrasePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PowerPhrasePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PowerPhrasePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PredefinedHiddenElementBlock = IContent & IData & {
  __typename?: 'PredefinedHiddenElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type PredefinedHiddenElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PredefinedHiddenElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PredefinedHiddenElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PredefinedHiddenElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PredefinedHiddenElementBlockAutocomplete = {
  __typename?: 'PredefinedHiddenElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PredefinedHiddenElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockFacet = {
  __typename?: 'PredefinedHiddenElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PredefinedHiddenElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PredefinedHiddenElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PredefinedHiddenElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PredefinedHiddenElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PredefinedHiddenElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PredefinedHiddenElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PredefinedHiddenElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PredefinedHiddenElementBlockOutput = {
  __typename?: 'PredefinedHiddenElementBlockOutput';
  autocomplete?: Maybe<PredefinedHiddenElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PredefinedHiddenElementBlockFacet>;
  item?: Maybe<PredefinedHiddenElementBlock>;
  items?: Maybe<Array<Maybe<PredefinedHiddenElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PredefinedHiddenElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PredefinedHiddenElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PredefinedHiddenElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PredefinedHiddenElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PredefinedHiddenElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PrepaymentErrorModalBlock = IContent & IData & {
  __typename?: 'PrepaymentErrorModalBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CloseButtonLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentErrorModalBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentErrorModalBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentErrorModalBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentErrorModalBlockAutocomplete = {
  __typename?: 'PrepaymentErrorModalBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  CloseButtonLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Title?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentErrorModalBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocompleteCloseButtonLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocompleteTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorModalBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentErrorModalBlockFacet = {
  __typename?: 'PrepaymentErrorModalBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CloseButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentErrorModalBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentErrorModalBlockFacetCloseButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentErrorModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentErrorModalBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentErrorModalBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentErrorModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorModalBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentErrorModalBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CloseButtonLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentErrorModalBlockOutput = {
  __typename?: 'PrepaymentErrorModalBlockOutput';
  autocomplete?: Maybe<PrepaymentErrorModalBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentErrorModalBlockFacet>;
  item?: Maybe<PrepaymentErrorModalBlock>;
  items?: Maybe<Array<Maybe<PrepaymentErrorModalBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentErrorModalBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentErrorModalBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CloseButtonLabel?: InputMaybe<StringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<StringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentErrorModalBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentErrorModalBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentErrorModalBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds error pages content */
export type PrepaymentErrorPageBlock = IContent & IData & {
  __typename?: 'PrepaymentErrorPageBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  GenericError?: Maybe<PrepaymentErrorPageBlockPrepaymentGenericErrorBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds error pages content */
export type PrepaymentErrorPageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds error pages content */
export type PrepaymentErrorPageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds error pages content */
export type PrepaymentErrorPageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentErrorPageBlockAutocomplete = {
  __typename?: 'PrepaymentErrorPageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentErrorPageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorPageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorPageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorPageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorPageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorPageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorPageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorPageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorPageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentErrorPageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentErrorPageBlockFacet = {
  __typename?: 'PrepaymentErrorPageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GenericError?: Maybe<PrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentErrorPageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentErrorPageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentErrorPageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentErrorPageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentErrorPageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentErrorPageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentErrorPageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GenericError?: InputMaybe<PrepaymentErrorPageBlockPrepaymentGenericErrorBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentErrorPageBlockOutput = {
  __typename?: 'PrepaymentErrorPageBlockOutput';
  autocomplete?: Maybe<PrepaymentErrorPageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentErrorPageBlockFacet>;
  item?: Maybe<PrepaymentErrorPageBlock>;
  items?: Maybe<Array<Maybe<PrepaymentErrorPageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentErrorPageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentErrorPageBlockPrepaymentGenericErrorBlock = {
  __typename?: 'PrepaymentErrorPageBlockPrepaymentGenericErrorBlock';
  ErrorDescription?: Maybe<Scalars['String']['output']>;
  ErrorHeading?: Maybe<Scalars['String']['output']>;
  LinkText?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentErrorPageBlockPrepaymentGenericErrorBlockErrorDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentErrorPageBlockPrepaymentGenericErrorBlockErrorHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentErrorPageBlockPrepaymentGenericErrorBlockLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacet = {
  __typename?: 'PrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacet';
  ErrorDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorHeading?: Maybe<Array<Maybe<StringFacet>>>;
  LinkText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacetErrorDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacetErrorHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacetLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentErrorPageBlockPrepaymentGenericErrorBlockOrderByInput = {
  ErrorDescription?: InputMaybe<OrderBy>;
  ErrorHeading?: InputMaybe<OrderBy>;
  LinkText?: InputMaybe<OrderBy>;
};

export type PrepaymentErrorPageBlockPrepaymentGenericErrorBlockWhereInput = {
  ErrorDescription?: InputMaybe<SearchableStringFilterInput>;
  ErrorHeading?: InputMaybe<SearchableStringFilterInput>;
  LinkText?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentErrorPageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GenericError?: InputMaybe<PrepaymentErrorPageBlockPrepaymentGenericErrorBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentErrorPageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentErrorPageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentErrorPageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PrepaymentGenericErrorBlock = IContent & IData & {
  __typename?: 'PrepaymentGenericErrorBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ErrorDescription?: Maybe<Scalars['String']['output']>;
  ErrorHeading?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkText?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentGenericErrorBlockErrorDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentGenericErrorBlockErrorHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentGenericErrorBlockLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentGenericErrorBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentGenericErrorBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentGenericErrorBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentGenericErrorBlockAutocomplete = {
  __typename?: 'PrepaymentGenericErrorBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentGenericErrorBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentGenericErrorBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentGenericErrorBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentGenericErrorBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentGenericErrorBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentGenericErrorBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentGenericErrorBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentGenericErrorBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentGenericErrorBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentGenericErrorBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentGenericErrorBlockFacet = {
  __typename?: 'PrepaymentGenericErrorBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ErrorDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkText?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentGenericErrorBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentGenericErrorBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentGenericErrorBlockFacetErrorDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetErrorHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentGenericErrorBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentGenericErrorBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentGenericErrorBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentGenericErrorBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentGenericErrorBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ErrorDescription?: InputMaybe<OrderBy>;
  ErrorHeading?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkText?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentGenericErrorBlockOutput = {
  __typename?: 'PrepaymentGenericErrorBlockOutput';
  autocomplete?: Maybe<PrepaymentGenericErrorBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentGenericErrorBlockFacet>;
  item?: Maybe<PrepaymentGenericErrorBlock>;
  items?: Maybe<Array<Maybe<PrepaymentGenericErrorBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentGenericErrorBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentGenericErrorBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ErrorDescription?: InputMaybe<SearchableStringFilterInput>;
  ErrorHeading?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkText?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentGenericErrorBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentGenericErrorBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentGenericErrorBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds content data for Prepayment initial form page (homepage) */
export type PrepaymentHomepageBlock = IContent & IData & {
  __typename?: 'PrepaymentHomepageBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FellowsDesignation?: Maybe<PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlock>;
  FormHeading?: Maybe<Scalars['String']['output']>;
  GlobalServices?: Maybe<PrepaymentHomepageBlockPrepaymentHomepageGsBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Mdrt?: Maybe<PrepaymentHomepageBlockPrepaymentHomepageMdrtBlock>;
  Name?: Maybe<Scalars['String']['output']>;
  NothingToPayMessage?: Maybe<Scalars['String']['output']>;
  PageHeading?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds content data for Prepayment initial form page (homepage) */
export type PrepaymentHomepageBlockFormHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment initial form page (homepage) */
export type PrepaymentHomepageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment initial form page (homepage) */
export type PrepaymentHomepageBlockNothingToPayMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment initial form page (homepage) */
export type PrepaymentHomepageBlockPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment initial form page (homepage) */
export type PrepaymentHomepageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment initial form page (homepage) */
export type PrepaymentHomepageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentHomepageBlockAutocomplete = {
  __typename?: 'PrepaymentHomepageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentHomepageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentHomepageBlockFacet = {
  __typename?: 'PrepaymentHomepageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FellowsDesignation?: Maybe<PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockFacet>;
  FormHeading?: Maybe<Array<Maybe<StringFacet>>>;
  GlobalServices?: Maybe<PrepaymentHomepageBlockPrepaymentHomepageGsBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Mdrt?: Maybe<PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NothingToPayMessage?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentHomepageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageBlockFacetFormHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetNothingToPayMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetPageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentHomepageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FellowsDesignation?: InputMaybe<PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockOrderByInput>;
  FormHeading?: InputMaybe<OrderBy>;
  GlobalServices?: InputMaybe<PrepaymentHomepageBlockPrepaymentHomepageGsBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Mdrt?: InputMaybe<PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NothingToPayMessage?: InputMaybe<OrderBy>;
  PageHeading?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentHomepageBlockOutput = {
  __typename?: 'PrepaymentHomepageBlockOutput';
  autocomplete?: Maybe<PrepaymentHomepageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentHomepageBlockFacet>;
  item?: Maybe<PrepaymentHomepageBlock>;
  items?: Maybe<Array<Maybe<PrepaymentHomepageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentHomepageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlock = {
  __typename?: 'PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockFacet = {
  __typename?: 'PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageGsBlock = {
  __typename?: 'PrepaymentHomepageBlockPrepaymentHomepageGsBlock';
  ChooseYearLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  WarningDescription?: Maybe<Scalars['String']['output']>;
  WarningTitle?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockChooseYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockWarningDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockWarningTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockFacet = {
  __typename?: 'PrepaymentHomepageBlockPrepaymentHomepageGsBlockFacet';
  ChooseYearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  WarningDescription?: Maybe<Array<Maybe<StringFacet>>>;
  WarningTitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockFacetChooseYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockFacetWarningDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockFacetWarningTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockOrderByInput = {
  ChooseYearLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  WarningDescription?: InputMaybe<OrderBy>;
  WarningTitle?: InputMaybe<OrderBy>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageGsBlockWhereInput = {
  ChooseYearLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  WarningDescription?: InputMaybe<SearchableStringFilterInput>;
  WarningTitle?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageMdrtBlock = {
  __typename?: 'PrepaymentHomepageBlockPrepaymentHomepageMdrtBlock';
  ChooseYearLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockChooseYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacet = {
  __typename?: 'PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacet';
  ChooseYearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacetChooseYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockOrderByInput = {
  ChooseYearLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockWhereInput = {
  ChooseYearLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentHomepageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FellowsDesignation?: InputMaybe<PrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockWhereInput>;
  FormHeading?: InputMaybe<SearchableStringFilterInput>;
  GlobalServices?: InputMaybe<PrepaymentHomepageBlockPrepaymentHomepageGsBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Mdrt?: InputMaybe<PrepaymentHomepageBlockPrepaymentHomepageMdrtBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NothingToPayMessage?: InputMaybe<SearchableStringFilterInput>;
  PageHeading?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentHomepageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentHomepageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentHomepageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PrepaymentHomepageFellowsDesignationBlock = IContent & IData & {
  __typename?: 'PrepaymentHomepageFellowsDesignationBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentHomepageFellowsDesignationBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageFellowsDesignationBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageFellowsDesignationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageFellowsDesignationBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageFellowsDesignationBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentHomepageFellowsDesignationBlockAutocomplete = {
  __typename?: 'PrepaymentHomepageFellowsDesignationBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentHomepageFellowsDesignationBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageFellowsDesignationBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageFellowsDesignationBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageFellowsDesignationBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageFellowsDesignationBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageFellowsDesignationBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageFellowsDesignationBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageFellowsDesignationBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageFellowsDesignationBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageFellowsDesignationBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentHomepageFellowsDesignationBlockFacet = {
  __typename?: 'PrepaymentHomepageFellowsDesignationBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageFellowsDesignationBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentHomepageFellowsDesignationBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentHomepageFellowsDesignationBlockOutput = {
  __typename?: 'PrepaymentHomepageFellowsDesignationBlockOutput';
  autocomplete?: Maybe<PrepaymentHomepageFellowsDesignationBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentHomepageFellowsDesignationBlockFacet>;
  item?: Maybe<PrepaymentHomepageFellowsDesignationBlock>;
  items?: Maybe<Array<Maybe<PrepaymentHomepageFellowsDesignationBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentHomepageFellowsDesignationBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentHomepageFellowsDesignationBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentHomepageFellowsDesignationBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentHomepageFellowsDesignationBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentHomepageFellowsDesignationBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PrepaymentHomepageGsBlock = IContent & IData & {
  __typename?: 'PrepaymentHomepageGsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ChooseYearLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WarningDescription?: Maybe<Scalars['String']['output']>;
  WarningTitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentHomepageGsBlockChooseYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageGsBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageGsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageGsBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageGsBlockWarningDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageGsBlockWarningTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageGsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageGsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentHomepageGsBlockAutocomplete = {
  __typename?: 'PrepaymentHomepageGsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentHomepageGsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageGsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageGsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageGsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageGsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageGsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageGsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageGsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageGsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageGsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentHomepageGsBlockFacet = {
  __typename?: 'PrepaymentHomepageGsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ChooseYearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WarningDescription?: Maybe<Array<Maybe<StringFacet>>>;
  WarningTitle?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentHomepageGsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageGsBlockFacetChooseYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageGsBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageGsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageGsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageGsBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetWarningDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacetWarningTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageGsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentHomepageGsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ChooseYearLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WarningDescription?: InputMaybe<OrderBy>;
  WarningTitle?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentHomepageGsBlockOutput = {
  __typename?: 'PrepaymentHomepageGsBlockOutput';
  autocomplete?: Maybe<PrepaymentHomepageGsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentHomepageGsBlockFacet>;
  item?: Maybe<PrepaymentHomepageGsBlock>;
  items?: Maybe<Array<Maybe<PrepaymentHomepageGsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentHomepageGsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentHomepageGsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ChooseYearLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WarningDescription?: InputMaybe<SearchableStringFilterInput>;
  WarningTitle?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentHomepageGsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentHomepageGsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentHomepageGsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PrepaymentHomepageMdrtBlock = IContent & IData & {
  __typename?: 'PrepaymentHomepageMdrtBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ChooseYearLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentHomepageMdrtBlockChooseYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageMdrtBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageMdrtBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageMdrtBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageMdrtBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentHomepageMdrtBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentHomepageMdrtBlockAutocomplete = {
  __typename?: 'PrepaymentHomepageMdrtBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentHomepageMdrtBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageMdrtBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageMdrtBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageMdrtBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageMdrtBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageMdrtBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageMdrtBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageMdrtBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageMdrtBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentHomepageMdrtBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentHomepageMdrtBlockFacet = {
  __typename?: 'PrepaymentHomepageMdrtBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ChooseYearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentHomepageMdrtBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageMdrtBlockFacetChooseYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageMdrtBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageMdrtBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageMdrtBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentHomepageMdrtBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentHomepageMdrtBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentHomepageMdrtBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ChooseYearLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentHomepageMdrtBlockOutput = {
  __typename?: 'PrepaymentHomepageMdrtBlockOutput';
  autocomplete?: Maybe<PrepaymentHomepageMdrtBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentHomepageMdrtBlockFacet>;
  item?: Maybe<PrepaymentHomepageMdrtBlock>;
  items?: Maybe<Array<Maybe<PrepaymentHomepageMdrtBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentHomepageMdrtBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentHomepageMdrtBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ChooseYearLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentHomepageMdrtBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentHomepageMdrtBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentHomepageMdrtBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds loader screen content */
export type PrepaymentLoaderScreenBlock = IContent & IData & {
  __typename?: 'PrepaymentLoaderScreenBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Subtitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds loader screen content */
export type PrepaymentLoaderScreenBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds loader screen content */
export type PrepaymentLoaderScreenBlockSubtitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds loader screen content */
export type PrepaymentLoaderScreenBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds loader screen content */
export type PrepaymentLoaderScreenBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds loader screen content */
export type PrepaymentLoaderScreenBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentLoaderScreenBlockAutocomplete = {
  __typename?: 'PrepaymentLoaderScreenBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentLoaderScreenBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentLoaderScreenBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentLoaderScreenBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentLoaderScreenBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentLoaderScreenBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentLoaderScreenBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentLoaderScreenBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentLoaderScreenBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentLoaderScreenBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentLoaderScreenBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentLoaderScreenBlockFacet = {
  __typename?: 'PrepaymentLoaderScreenBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subtitle?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentLoaderScreenBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentLoaderScreenBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentLoaderScreenBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentLoaderScreenBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentLoaderScreenBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentLoaderScreenBlockFacetSubtitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentLoaderScreenBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentLoaderScreenBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subtitle?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentLoaderScreenBlockOutput = {
  __typename?: 'PrepaymentLoaderScreenBlockOutput';
  autocomplete?: Maybe<PrepaymentLoaderScreenBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentLoaderScreenBlockFacet>;
  item?: Maybe<PrepaymentLoaderScreenBlock>;
  items?: Maybe<Array<Maybe<PrepaymentLoaderScreenBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentLoaderScreenBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentLoaderScreenBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subtitle?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentLoaderScreenBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentLoaderScreenBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentLoaderScreenBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PrepaymentMembershipInfoCardBlock = IContent & IData & {
  __typename?: 'PrepaymentMembershipInfoCardBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CardDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CardHeading?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentMembershipInfoCardBlockCardHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentMembershipInfoCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentMembershipInfoCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentMembershipInfoCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentMembershipInfoCardBlockAutocomplete = {
  __typename?: 'PrepaymentMembershipInfoCardBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CardDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentMembershipInfoCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoCardBlockAutocompleteCardDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentMembershipInfoCardBlockFacet = {
  __typename?: 'PrepaymentMembershipInfoCardBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CardDescription?: Maybe<Array<Maybe<StringFacet>>>;
  CardHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentMembershipInfoCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetCardDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetCardHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipInfoCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipInfoCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipInfoCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipInfoCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipInfoCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentMembershipInfoCardBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CardDescription?: InputMaybe<OrderBy>;
  CardHeading?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentMembershipInfoCardBlockOutput = {
  __typename?: 'PrepaymentMembershipInfoCardBlockOutput';
  autocomplete?: Maybe<PrepaymentMembershipInfoCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentMembershipInfoCardBlockFacet>;
  item?: Maybe<PrepaymentMembershipInfoCardBlock>;
  items?: Maybe<Array<Maybe<PrepaymentMembershipInfoCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentMembershipInfoCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentMembershipInfoCardBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CardDescription?: InputMaybe<StringFilterInput>;
  CardHeading?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentMembershipInfoCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentMembershipInfoCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentMembershipInfoCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlock = IContent & IData & {
  __typename?: 'PrepaymentMembershipInfoPageBlock';
  AdditionalFeesDescription?: Maybe<Scalars['String']['output']>;
  AdditionalFeesHeading?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CotBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock>;
  Created?: Maybe<Scalars['Date']['output']>;
  EligibleForToTWaiverMessage?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FormLevelDescription?: Maybe<Scalars['String']['output']>;
  FormLevelHeading?: Maybe<Scalars['String']['output']>;
  FormTypeDescription?: Maybe<Scalars['String']['output']>;
  FormTypeHeading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LifeMemberTypeBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock>;
  MembershipYearNotice?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  PageHeading?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentPeriod?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeMemberTypeBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlock>;
  QualifyingMemberTypeBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlock>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TooltipHeading?: Maybe<Scalars['String']['output']>;
  TotBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock>;
  TotWaiverBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock>;
  UpgradingInfoMessage?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockAdditionalFeesDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockAdditionalFeesHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockEligibleForToTWaiverMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockFormLevelDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockFormLevelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockFormTypeDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockFormTypeHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockMembershipYearNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockPaymentPeriodArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockTooltipHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlockUpgradingInfoMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds content data for Prepayment Membership Information page */
export type PrepaymentMembershipInfoPageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentMembershipInfoPageBlockAutocomplete = {
  __typename?: 'PrepaymentMembershipInfoPageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CotBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MdrtBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TotBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete>;
  TotWaiverBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentMembershipInfoPageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoPageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoPageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoPageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoPageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoPageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoPageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoPageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoPageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipInfoPageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentMembershipInfoPageBlockFacet = {
  __typename?: 'PrepaymentMembershipInfoPageBlockFacet';
  AdditionalFeesDescription?: Maybe<Array<Maybe<StringFacet>>>;
  AdditionalFeesHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CotBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EligibleForToTWaiverMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormLevelDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormLevelHeading?: Maybe<Array<Maybe<StringFacet>>>;
  FormTypeDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormTypeHeading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LifeMemberTypeBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet>;
  MembershipYearNotice?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentPeriod?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberTypeBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacet>;
  QualifyingMemberTypeBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TooltipHeading?: Maybe<Array<Maybe<StringFacet>>>;
  TotBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet>;
  TotWaiverBlock?: Maybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet>;
  UpgradingInfoMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentMembershipInfoPageBlockFacetAdditionalFeesDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetAdditionalFeesHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipInfoPageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipInfoPageBlockFacetEligibleForToTWaiverMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetFormLevelDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetFormLevelHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetFormTypeDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetFormTypeHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetMembershipYearNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetPageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetPaymentPeriodArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipInfoPageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipInfoPageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipInfoPageBlockFacetTooltipHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetUpgradingInfoMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentMembershipInfoPageBlockOrderByInput = {
  AdditionalFeesDescription?: InputMaybe<OrderBy>;
  AdditionalFeesHeading?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CotBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockOrderByInput>;
  Created?: InputMaybe<OrderBy>;
  EligibleForToTWaiverMessage?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormLevelDescription?: InputMaybe<OrderBy>;
  FormLevelHeading?: InputMaybe<OrderBy>;
  FormTypeDescription?: InputMaybe<OrderBy>;
  FormTypeHeading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LifeMemberTypeBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockOrderByInput>;
  MembershipYearNotice?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  PageHeading?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentPeriod?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberTypeBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockOrderByInput>;
  QualifyingMemberTypeBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TooltipHeading?: InputMaybe<OrderBy>;
  TotBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockOrderByInput>;
  TotWaiverBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockOrderByInput>;
  UpgradingInfoMessage?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentMembershipInfoPageBlockOutput = {
  __typename?: 'PrepaymentMembershipInfoPageBlockOutput';
  autocomplete?: Maybe<PrepaymentMembershipInfoPageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentMembershipInfoPageBlockFacet>;
  item?: Maybe<PrepaymentMembershipInfoPageBlock>;
  items?: Maybe<Array<Maybe<PrepaymentMembershipInfoPageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentMembershipInfoPageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock = {
  __typename?: 'PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock';
  CardDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CardHeading?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockCardHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete = {
  __typename?: 'PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete';
  CardDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocompleteCardDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet = {
  __typename?: 'PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet';
  CardDescription?: Maybe<Array<Maybe<StringFacet>>>;
  CardHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacetCardDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacetCardHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockOrderByInput = {
  CardDescription?: InputMaybe<OrderBy>;
  CardHeading?: InputMaybe<OrderBy>;
};

export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockWhereInput = {
  CardDescription?: InputMaybe<StringFilterInput>;
  CardHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlock = {
  __typename?: 'PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  Warning?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacet = {
  __typename?: 'PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Warning?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacetWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  Warning?: InputMaybe<OrderBy>;
};

export type PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Warning?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentMembershipInfoPageBlockWhereInput = {
  AdditionalFeesDescription?: InputMaybe<SearchableStringFilterInput>;
  AdditionalFeesHeading?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CotBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockWhereInput>;
  Created?: InputMaybe<DateFilterInput>;
  EligibleForToTWaiverMessage?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormLevelDescription?: InputMaybe<SearchableStringFilterInput>;
  FormLevelHeading?: InputMaybe<SearchableStringFilterInput>;
  FormTypeDescription?: InputMaybe<SearchableStringFilterInput>;
  FormTypeHeading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LifeMemberTypeBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockWhereInput>;
  MembershipYearNotice?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageHeading?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentPeriod?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeMemberTypeBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockWhereInput>;
  QualifyingMemberTypeBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TooltipHeading?: InputMaybe<SearchableStringFilterInput>;
  TotBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockWhereInput>;
  TotWaiverBlock?: InputMaybe<PrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockWhereInput>;
  UpgradingInfoMessage?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentMembershipInfoPageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentMembershipInfoPageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentMembershipInfoPageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PrepaymentMembershipTypeInfoCardBlock = IContent & IData & {
  __typename?: 'PrepaymentMembershipTypeInfoCardBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Warning?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentMembershipTypeInfoCardBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentMembershipTypeInfoCardBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentMembershipTypeInfoCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentMembershipTypeInfoCardBlockWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentMembershipTypeInfoCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentMembershipTypeInfoCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentMembershipTypeInfoCardBlockAutocomplete = {
  __typename?: 'PrepaymentMembershipTypeInfoCardBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentMembershipTypeInfoCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipTypeInfoCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipTypeInfoCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipTypeInfoCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipTypeInfoCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipTypeInfoCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipTypeInfoCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipTypeInfoCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipTypeInfoCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentMembershipTypeInfoCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentMembershipTypeInfoCardBlockFacet = {
  __typename?: 'PrepaymentMembershipTypeInfoCardBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Warning?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacetWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentMembershipTypeInfoCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentMembershipTypeInfoCardBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Warning?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentMembershipTypeInfoCardBlockOutput = {
  __typename?: 'PrepaymentMembershipTypeInfoCardBlockOutput';
  autocomplete?: Maybe<PrepaymentMembershipTypeInfoCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentMembershipTypeInfoCardBlockFacet>;
  item?: Maybe<PrepaymentMembershipTypeInfoCardBlock>;
  items?: Maybe<Array<Maybe<PrepaymentMembershipTypeInfoCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentMembershipTypeInfoCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentMembershipTypeInfoCardBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Warning?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentMembershipTypeInfoCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentMembershipTypeInfoCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentMembershipTypeInfoCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds payment summary page content */
export type PrepaymentPaymentPageBlock = IContent & IData & {
  __typename?: 'PrepaymentPaymentPageBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BlockedCardError?: Maybe<Scalars['String']['output']>;
  CardRestrictedError?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  CvcDeclinedError?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpiredCardError?: Maybe<Scalars['String']['output']>;
  GsPrepaymentNotice?: Maybe<Scalars['String']['output']>;
  GsTermsAndConditions?: Maybe<Scalars['String']['output']>;
  InvalidCardNumberError?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  IssuerUnavailableError?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtTermsAndConditions?: Maybe<Scalars['String']['output']>;
  MobilePinRequiredError?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NotEnoughBalanceError?: Maybe<Scalars['String']['output']>;
  NotSupportedError?: Maybe<Scalars['String']['output']>;
  PageDescription?: Maybe<Scalars['String']['output']>;
  PageHeading?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentGenericError?: Maybe<Scalars['String']['output']>;
  PaymentHasBeenProcessedError?: Maybe<Scalars['String']['output']>;
  PaymentInProgressError?: Maybe<Scalars['String']['output']>;
  PaymentMethodTitle?: Maybe<Scalars['String']['output']>;
  PaymentRefusedError?: Maybe<Scalars['String']['output']>;
  PaymentSummaryTitle?: Maybe<Scalars['String']['output']>;
  PrepaymentNotice?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TotalLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WithdrawalAmountExceededError?: Maybe<Scalars['String']['output']>;
  WithdrawalCountExceededError?: Maybe<Scalars['String']['output']>;
  YearLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockBlockedCardErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockCardRestrictedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockCvcDeclinedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockExpiredCardErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockGsPrepaymentNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockGsTermsAndConditionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockInvalidCardNumberErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockIssuerUnavailableErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockMdrtTermsAndConditionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockMobilePinRequiredErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockNotEnoughBalanceErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockNotSupportedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockPageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockPaymentGenericErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockPaymentHasBeenProcessedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockPaymentInProgressErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockPaymentMethodTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockPaymentRefusedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockPaymentSummaryTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockPrepaymentNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockTotalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockWithdrawalAmountExceededErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockWithdrawalCountExceededErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlockYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment summary page content */
export type PrepaymentPaymentPageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentPaymentPageBlockAutocomplete = {
  __typename?: 'PrepaymentPaymentPageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentPaymentPageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentPageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentPageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentPageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentPageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentPageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentPageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentPageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentPageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentPageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentPaymentPageBlockFacet = {
  __typename?: 'PrepaymentPaymentPageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BlockedCardError?: Maybe<Array<Maybe<StringFacet>>>;
  CardRestrictedError?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CvcDeclinedError?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpiredCardError?: Maybe<Array<Maybe<StringFacet>>>;
  GsPrepaymentNotice?: Maybe<Array<Maybe<StringFacet>>>;
  GsTermsAndConditions?: Maybe<Array<Maybe<StringFacet>>>;
  InvalidCardNumberError?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IssuerUnavailableError?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtTermsAndConditions?: Maybe<Array<Maybe<StringFacet>>>;
  MobilePinRequiredError?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NotEnoughBalanceError?: Maybe<Array<Maybe<StringFacet>>>;
  NotSupportedError?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentGenericError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentHasBeenProcessedError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentInProgressError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentMethodTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentRefusedError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentSummaryTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PrepaymentNotice?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WithdrawalAmountExceededError?: Maybe<Array<Maybe<StringFacet>>>;
  WithdrawalCountExceededError?: Maybe<Array<Maybe<StringFacet>>>;
  YearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentPaymentPageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetBlockedCardErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetCardRestrictedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPaymentPageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPaymentPageBlockFacetCvcDeclinedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetExpiredCardErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetGsPrepaymentNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetGsTermsAndConditionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetInvalidCardNumberErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetIssuerUnavailableErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetMdrtTermsAndConditionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetMobilePinRequiredErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetNotEnoughBalanceErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetNotSupportedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetPageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetPaymentGenericErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetPaymentHasBeenProcessedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetPaymentInProgressErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetPaymentMethodTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetPaymentRefusedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetPaymentSummaryTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetPrepaymentNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPaymentPageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPaymentPageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPaymentPageBlockFacetTotalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetWithdrawalAmountExceededErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetWithdrawalCountExceededErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacetYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentPageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentPaymentPageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BlockedCardError?: InputMaybe<OrderBy>;
  CardRestrictedError?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CvcDeclinedError?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpiredCardError?: InputMaybe<OrderBy>;
  GsPrepaymentNotice?: InputMaybe<OrderBy>;
  GsTermsAndConditions?: InputMaybe<OrderBy>;
  InvalidCardNumberError?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IssuerUnavailableError?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtTermsAndConditions?: InputMaybe<OrderBy>;
  MobilePinRequiredError?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NotEnoughBalanceError?: InputMaybe<OrderBy>;
  NotSupportedError?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageHeading?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentGenericError?: InputMaybe<OrderBy>;
  PaymentHasBeenProcessedError?: InputMaybe<OrderBy>;
  PaymentInProgressError?: InputMaybe<OrderBy>;
  PaymentMethodTitle?: InputMaybe<OrderBy>;
  PaymentRefusedError?: InputMaybe<OrderBy>;
  PaymentSummaryTitle?: InputMaybe<OrderBy>;
  PrepaymentNotice?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WithdrawalAmountExceededError?: InputMaybe<OrderBy>;
  WithdrawalCountExceededError?: InputMaybe<OrderBy>;
  YearLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentPaymentPageBlockOutput = {
  __typename?: 'PrepaymentPaymentPageBlockOutput';
  autocomplete?: Maybe<PrepaymentPaymentPageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentPaymentPageBlockFacet>;
  item?: Maybe<PrepaymentPaymentPageBlock>;
  items?: Maybe<Array<Maybe<PrepaymentPaymentPageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentPaymentPageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentPaymentPageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BlockedCardError?: InputMaybe<SearchableStringFilterInput>;
  CardRestrictedError?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CvcDeclinedError?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpiredCardError?: InputMaybe<SearchableStringFilterInput>;
  GsPrepaymentNotice?: InputMaybe<SearchableStringFilterInput>;
  GsTermsAndConditions?: InputMaybe<SearchableStringFilterInput>;
  InvalidCardNumberError?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IssuerUnavailableError?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtTermsAndConditions?: InputMaybe<SearchableStringFilterInput>;
  MobilePinRequiredError?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NotEnoughBalanceError?: InputMaybe<SearchableStringFilterInput>;
  NotSupportedError?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageHeading?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentGenericError?: InputMaybe<SearchableStringFilterInput>;
  PaymentHasBeenProcessedError?: InputMaybe<SearchableStringFilterInput>;
  PaymentInProgressError?: InputMaybe<SearchableStringFilterInput>;
  PaymentMethodTitle?: InputMaybe<SearchableStringFilterInput>;
  PaymentRefusedError?: InputMaybe<SearchableStringFilterInput>;
  PaymentSummaryTitle?: InputMaybe<SearchableStringFilterInput>;
  PrepaymentNotice?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WithdrawalAmountExceededError?: InputMaybe<SearchableStringFilterInput>;
  WithdrawalCountExceededError?: InputMaybe<SearchableStringFilterInput>;
  YearLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentPaymentPageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentPaymentPageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentPaymentPageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds payment status content */
export type PrepaymentPaymentStatusPageBlock = IContent & IData & {
  __typename?: 'PrepaymentPaymentStatusPageBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FailureToast?: Maybe<Scalars['String']['output']>;
  InfoText?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  PageHeading?: Maybe<Scalars['String']['output']>;
  PageSubtitle?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds payment status content */
export type PrepaymentPaymentStatusPageBlockFailureToastArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment status content */
export type PrepaymentPaymentStatusPageBlockInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment status content */
export type PrepaymentPaymentStatusPageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment status content */
export type PrepaymentPaymentStatusPageBlockPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment status content */
export type PrepaymentPaymentStatusPageBlockPageSubtitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment status content */
export type PrepaymentPaymentStatusPageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds payment status content */
export type PrepaymentPaymentStatusPageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentPaymentStatusPageBlockAutocomplete = {
  __typename?: 'PrepaymentPaymentStatusPageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentPaymentStatusPageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentStatusPageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentStatusPageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentStatusPageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentStatusPageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentStatusPageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentStatusPageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentStatusPageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentStatusPageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPaymentStatusPageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentPaymentStatusPageBlockFacet = {
  __typename?: 'PrepaymentPaymentStatusPageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FailureToast?: Maybe<Array<Maybe<StringFacet>>>;
  InfoText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PageSubtitle?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentPaymentStatusPageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPaymentStatusPageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPaymentStatusPageBlockFacetFailureToastArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetPageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetPageSubtitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPaymentStatusPageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPaymentStatusPageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPaymentStatusPageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPaymentStatusPageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentPaymentStatusPageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FailureToast?: InputMaybe<OrderBy>;
  InfoText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageHeading?: InputMaybe<OrderBy>;
  PageSubtitle?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentPaymentStatusPageBlockOutput = {
  __typename?: 'PrepaymentPaymentStatusPageBlockOutput';
  autocomplete?: Maybe<PrepaymentPaymentStatusPageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentPaymentStatusPageBlockFacet>;
  item?: Maybe<PrepaymentPaymentStatusPageBlock>;
  items?: Maybe<Array<Maybe<PrepaymentPaymentStatusPageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentPaymentStatusPageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentPaymentStatusPageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FailureToast?: InputMaybe<SearchableStringFilterInput>;
  InfoText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageHeading?: InputMaybe<SearchableStringFilterInput>;
  PageSubtitle?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentPaymentStatusPageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentPaymentStatusPageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentPaymentStatusPageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for prepayment portal */
export type PrepaymentPortalPage = IContent & IData & {
  __typename?: 'PrepaymentPortalPage';
  AccountLabel?: Maybe<Scalars['String']['output']>;
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ErrorModal?: Maybe<PrepaymentPortalPagePrepaymentErrorModalBlock>;
  /** Error page content */
  ErrorPageContent?: Maybe<PrepaymentPortalPagePrepaymentErrorPageBlock>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  GoBackToHomepageButtonLabel?: Maybe<Scalars['String']['output']>;
  /** Homepage (initial form) content */
  HomePageContent?: Maybe<PrepaymentPortalPagePrepaymentHomepageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Loader Screen */
  LoaderScreenContent?: Maybe<PrepaymentPortalPagePrepaymentLoaderScreenBlock>;
  LogoutLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtCenterLogoUrl?: Maybe<Scalars['String']['output']>;
  /** Membership Info form content */
  MembershipInfoPageContent?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlock>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<PrepaymentPortalPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NavHeadingLabel?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PayButtonLabel?: Maybe<Scalars['String']['output']>;
  /** Prepayment payment summary page content */
  PaymentPageContent?: Maybe<PrepaymentPortalPagePrepaymentPaymentPageBlock>;
  /** Payment status page */
  PaymentStatusPageContent?: Maybe<PrepaymentPortalPagePrepaymentPaymentStatusPageBlock>;
  /** Prepayment product names (used in tooltip) */
  ProductNamesContent?: Maybe<PrepaymentPortalPagePrepaymentProductNamesBlock>;
  QuestionsHeading?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RequiredLabel?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SelectLanguageHeading?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Successful payment page */
  SuccessfulPaymentPageContent?: Maybe<PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlock>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<PrepaymentPortalPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  VisitFieldLeadership?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageAccountLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageGoBackToHomepageButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageLogoutLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageMdrtCenterLogoUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageNavHeadingLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPagePayButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageQuestionsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageRequiredLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageSelectLanguageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPageVisitFieldLeadershipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for prepayment portal */
export type PrepaymentPortalPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentPortalPageAutocomplete = {
  __typename?: 'PrepaymentPortalPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ErrorModal?: Maybe<PrepaymentPortalPagePrepaymentErrorModalBlockAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MembershipInfoPageContent?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockAutocomplete>;
  MetaImage?: Maybe<PrepaymentPortalPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SuccessfulPaymentPageContent?: Maybe<PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockAutocomplete>;
  ThumbnailImage?: Maybe<PrepaymentPortalPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentPortalPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPortalPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPortalPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPortalPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPortalPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPortalPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPortalPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPortalPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPortalPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPortalPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentPortalPageFacet = {
  __typename?: 'PrepaymentPortalPageFacet';
  AccountLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorModal?: Maybe<PrepaymentPortalPagePrepaymentErrorModalBlockFacet>;
  ErrorPageContent?: Maybe<PrepaymentPortalPagePrepaymentErrorPageBlockFacet>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  GoBackToHomepageButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HomePageContent?: Maybe<PrepaymentPortalPagePrepaymentHomepageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LoaderScreenContent?: Maybe<PrepaymentPortalPagePrepaymentLoaderScreenBlockFacet>;
  LogoutLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtCenterLogoUrl?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipInfoPageContent?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<PrepaymentPortalPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NavHeadingLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PayButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentPageContent?: Maybe<PrepaymentPortalPagePrepaymentPaymentPageBlockFacet>;
  PaymentStatusPageContent?: Maybe<PrepaymentPortalPagePrepaymentPaymentStatusPageBlockFacet>;
  ProductNamesContent?: Maybe<PrepaymentPortalPagePrepaymentProductNamesBlockFacet>;
  QuestionsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RequiredLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelectLanguageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SuccessfulPaymentPageContent?: Maybe<PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockFacet>;
  ThumbnailImage?: Maybe<PrepaymentPortalPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisitFieldLeadership?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentPortalPageFacetAccountLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPortalPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PrepaymentPortalPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPortalPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetGoBackToHomepageButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PrepaymentPortalPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetLogoutLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetMdrtCenterLogoUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetNavHeadingLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetPayButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetQuestionsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetRequiredLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPortalPageFacetSelectLanguageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPortalPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentPortalPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacetVisitFieldLeadershipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentPortalPageImageBlock = {
  __typename?: 'PrepaymentPortalPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPageImageBlockAutocomplete = {
  __typename?: 'PrepaymentPortalPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type PrepaymentPortalPageImageBlockFacet = {
  __typename?: 'PrepaymentPortalPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PrepaymentPortalPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPageOrderByInput = {
  AccountLabel?: InputMaybe<OrderBy>;
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ErrorModal?: InputMaybe<PrepaymentPortalPagePrepaymentErrorModalBlockOrderByInput>;
  ErrorPageContent?: InputMaybe<PrepaymentPortalPagePrepaymentErrorPageBlockOrderByInput>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  GoBackToHomepageButtonLabel?: InputMaybe<OrderBy>;
  HomePageContent?: InputMaybe<PrepaymentPortalPagePrepaymentHomepageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LoaderScreenContent?: InputMaybe<PrepaymentPortalPagePrepaymentLoaderScreenBlockOrderByInput>;
  LogoutLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtCenterLogoUrl?: InputMaybe<OrderBy>;
  MembershipInfoPageContent?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<PrepaymentPortalPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NavHeadingLabel?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PayButtonLabel?: InputMaybe<OrderBy>;
  PaymentPageContent?: InputMaybe<PrepaymentPortalPagePrepaymentPaymentPageBlockOrderByInput>;
  PaymentStatusPageContent?: InputMaybe<PrepaymentPortalPagePrepaymentPaymentStatusPageBlockOrderByInput>;
  ProductNamesContent?: InputMaybe<PrepaymentPortalPagePrepaymentProductNamesBlockOrderByInput>;
  QuestionsHeading?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RequiredLabel?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelectLanguageHeading?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SuccessfulPaymentPageContent?: InputMaybe<PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockOrderByInput>;
  ThumbnailImage?: InputMaybe<PrepaymentPortalPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  VisitFieldLeadership?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPageOutput = {
  __typename?: 'PrepaymentPortalPageOutput';
  autocomplete?: Maybe<PrepaymentPortalPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentPortalPageFacet>;
  item?: Maybe<PrepaymentPortalPage>;
  items?: Maybe<Array<Maybe<PrepaymentPortalPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentPortalPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentPortalPagePrepaymentErrorModalBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentErrorModalBlock';
  CloseButtonLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type PrepaymentPortalPagePrepaymentErrorModalBlockAutocomplete = {
  __typename?: 'PrepaymentPortalPagePrepaymentErrorModalBlockAutocomplete';
  CloseButtonLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Title?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentPortalPagePrepaymentErrorModalBlockAutocompleteCloseButtonLabelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPortalPagePrepaymentErrorModalBlockAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentPortalPagePrepaymentErrorModalBlockAutocompleteTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentPortalPagePrepaymentErrorModalBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentErrorModalBlockFacet';
  CloseButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentErrorModalBlockFacetCloseButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentErrorModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentErrorModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentErrorModalBlockOrderByInput = {
  CloseButtonLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentErrorModalBlockWhereInput = {
  CloseButtonLabel?: InputMaybe<StringFilterInput>;
  Description?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentErrorPageBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentErrorPageBlock';
  GenericError?: Maybe<PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlock>;
};

export type PrepaymentPortalPagePrepaymentErrorPageBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentErrorPageBlockFacet';
  GenericError?: Maybe<PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacet>;
};

export type PrepaymentPortalPagePrepaymentErrorPageBlockOrderByInput = {
  GenericError?: InputMaybe<PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockOrderByInput>;
};

export type PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlock';
  ErrorDescription?: Maybe<Scalars['String']['output']>;
  ErrorHeading?: Maybe<Scalars['String']['output']>;
  LinkText?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockErrorDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockErrorHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacet';
  ErrorDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorHeading?: Maybe<Array<Maybe<StringFacet>>>;
  LinkText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacetErrorDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacetErrorHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockFacetLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockOrderByInput = {
  ErrorDescription?: InputMaybe<OrderBy>;
  ErrorHeading?: InputMaybe<OrderBy>;
  LinkText?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockWhereInput = {
  ErrorDescription?: InputMaybe<SearchableStringFilterInput>;
  ErrorHeading?: InputMaybe<SearchableStringFilterInput>;
  LinkText?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentErrorPageBlockWhereInput = {
  GenericError?: InputMaybe<PrepaymentPortalPagePrepaymentErrorPageBlockPrepaymentGenericErrorBlockWhereInput>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentHomepageBlock';
  FellowsDesignation?: Maybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlock>;
  FormHeading?: Maybe<Scalars['String']['output']>;
  GlobalServices?: Maybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlock>;
  Mdrt?: Maybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlock>;
  NothingToPayMessage?: Maybe<Scalars['String']['output']>;
  PageHeading?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockFormHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockNothingToPayMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentHomepageBlockFacet';
  FellowsDesignation?: Maybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockFacet>;
  FormHeading?: Maybe<Array<Maybe<StringFacet>>>;
  GlobalServices?: Maybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockFacet>;
  Mdrt?: Maybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacet>;
  NothingToPayMessage?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockFacetFormHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockFacetNothingToPayMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockFacetPageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockOrderByInput = {
  FellowsDesignation?: InputMaybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockOrderByInput>;
  FormHeading?: InputMaybe<OrderBy>;
  GlobalServices?: InputMaybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockOrderByInput>;
  Mdrt?: InputMaybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockOrderByInput>;
  NothingToPayMessage?: InputMaybe<OrderBy>;
  PageHeading?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlock';
  ChooseYearLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  WarningDescription?: Maybe<Scalars['String']['output']>;
  WarningTitle?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockChooseYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockWarningDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockWarningTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockFacet';
  ChooseYearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  WarningDescription?: Maybe<Array<Maybe<StringFacet>>>;
  WarningTitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockFacetChooseYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockFacetWarningDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockFacetWarningTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockOrderByInput = {
  ChooseYearLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  WarningDescription?: InputMaybe<OrderBy>;
  WarningTitle?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockWhereInput = {
  ChooseYearLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  WarningDescription?: InputMaybe<SearchableStringFilterInput>;
  WarningTitle?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlock';
  ChooseYearLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockChooseYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacet';
  ChooseYearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacetChooseYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockOrderByInput = {
  ChooseYearLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockWhereInput = {
  ChooseYearLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentHomepageBlockWhereInput = {
  FellowsDesignation?: InputMaybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageFellowsDesignationBlockWhereInput>;
  FormHeading?: InputMaybe<SearchableStringFilterInput>;
  GlobalServices?: InputMaybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageGsBlockWhereInput>;
  Mdrt?: InputMaybe<PrepaymentPortalPagePrepaymentHomepageBlockPrepaymentHomepageMdrtBlockWhereInput>;
  NothingToPayMessage?: InputMaybe<SearchableStringFilterInput>;
  PageHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentLoaderScreenBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentLoaderScreenBlock';
  Subtitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentLoaderScreenBlockSubtitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentLoaderScreenBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentLoaderScreenBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentLoaderScreenBlockFacet';
  Subtitle?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentLoaderScreenBlockFacetSubtitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentLoaderScreenBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentLoaderScreenBlockOrderByInput = {
  Subtitle?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentLoaderScreenBlockWhereInput = {
  Subtitle?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentMembershipInfoPageBlock';
  AdditionalFeesDescription?: Maybe<Scalars['String']['output']>;
  AdditionalFeesHeading?: Maybe<Scalars['String']['output']>;
  CotBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock>;
  EligibleForToTWaiverMessage?: Maybe<Scalars['String']['output']>;
  FormLevelDescription?: Maybe<Scalars['String']['output']>;
  FormLevelHeading?: Maybe<Scalars['String']['output']>;
  FormTypeDescription?: Maybe<Scalars['String']['output']>;
  FormTypeHeading?: Maybe<Scalars['String']['output']>;
  LifeMemberTypeBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlock>;
  MdrtBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock>;
  MembershipYearNotice?: Maybe<Scalars['String']['output']>;
  PageHeading?: Maybe<Scalars['String']['output']>;
  PaymentPeriod?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeMemberTypeBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlock>;
  QualifyingMemberTypeBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlock>;
  TooltipHeading?: Maybe<Scalars['String']['output']>;
  TotBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock>;
  TotWaiverBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock>;
  UpgradingInfoMessage?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockAdditionalFeesDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockAdditionalFeesHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockEligibleForToTWaiverMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFormLevelDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFormLevelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFormTypeDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFormTypeHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockMembershipYearNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPaymentPeriodArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockTooltipHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockUpgradingInfoMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockAutocomplete = {
  __typename?: 'PrepaymentPortalPagePrepaymentMembershipInfoPageBlockAutocomplete';
  CotBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete>;
  MdrtBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete>;
  TotBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete>;
  TotWaiverBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacet';
  AdditionalFeesDescription?: Maybe<Array<Maybe<StringFacet>>>;
  AdditionalFeesHeading?: Maybe<Array<Maybe<StringFacet>>>;
  CotBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet>;
  EligibleForToTWaiverMessage?: Maybe<Array<Maybe<StringFacet>>>;
  FormLevelDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormLevelHeading?: Maybe<Array<Maybe<StringFacet>>>;
  FormTypeDescription?: Maybe<Array<Maybe<StringFacet>>>;
  FormTypeHeading?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberTypeBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacet>;
  MdrtBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet>;
  MembershipYearNotice?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentPeriod?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberTypeBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacet>;
  QualifyingMemberTypeBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacet>;
  TooltipHeading?: Maybe<Array<Maybe<StringFacet>>>;
  TotBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet>;
  TotWaiverBlock?: Maybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet>;
  UpgradingInfoMessage?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetAdditionalFeesDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetAdditionalFeesHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetEligibleForToTWaiverMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetFormLevelDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetFormLevelHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetFormTypeDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetFormTypeHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetMembershipYearNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetPageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetPaymentPeriodArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetTooltipHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockFacetUpgradingInfoMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockOrderByInput = {
  AdditionalFeesDescription?: InputMaybe<OrderBy>;
  AdditionalFeesHeading?: InputMaybe<OrderBy>;
  CotBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockOrderByInput>;
  EligibleForToTWaiverMessage?: InputMaybe<OrderBy>;
  FormLevelDescription?: InputMaybe<OrderBy>;
  FormLevelHeading?: InputMaybe<OrderBy>;
  FormTypeDescription?: InputMaybe<OrderBy>;
  FormTypeHeading?: InputMaybe<OrderBy>;
  LifeMemberTypeBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockOrderByInput>;
  MdrtBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockOrderByInput>;
  MembershipYearNotice?: InputMaybe<OrderBy>;
  PageHeading?: InputMaybe<OrderBy>;
  PaymentPeriod?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberTypeBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockOrderByInput>;
  QualifyingMemberTypeBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockOrderByInput>;
  TooltipHeading?: InputMaybe<OrderBy>;
  TotBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockOrderByInput>;
  TotWaiverBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockOrderByInput>;
  UpgradingInfoMessage?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlock';
  CardDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CardHeading?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockCardHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete = {
  __typename?: 'PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocomplete';
  CardDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockAutocompleteCardDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacet';
  CardDescription?: Maybe<Array<Maybe<StringFacet>>>;
  CardHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacetCardDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockFacetCardHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockOrderByInput = {
  CardDescription?: InputMaybe<OrderBy>;
  CardHeading?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockWhereInput = {
  CardDescription?: InputMaybe<StringFilterInput>;
  CardHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  Warning?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Warning?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockFacetWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  Warning?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Warning?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentMembershipInfoPageBlockWhereInput = {
  AdditionalFeesDescription?: InputMaybe<SearchableStringFilterInput>;
  AdditionalFeesHeading?: InputMaybe<SearchableStringFilterInput>;
  CotBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockWhereInput>;
  EligibleForToTWaiverMessage?: InputMaybe<SearchableStringFilterInput>;
  FormLevelDescription?: InputMaybe<SearchableStringFilterInput>;
  FormLevelHeading?: InputMaybe<SearchableStringFilterInput>;
  FormTypeDescription?: InputMaybe<SearchableStringFilterInput>;
  FormTypeHeading?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberTypeBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockWhereInput>;
  MdrtBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockWhereInput>;
  MembershipYearNotice?: InputMaybe<SearchableStringFilterInput>;
  PageHeading?: InputMaybe<SearchableStringFilterInput>;
  PaymentPeriod?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeMemberTypeBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockWhereInput>;
  QualifyingMemberTypeBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipTypeInfoCardBlockWhereInput>;
  TooltipHeading?: InputMaybe<SearchableStringFilterInput>;
  TotBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockWhereInput>;
  TotWaiverBlock?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockPrepaymentMembershipInfoCardBlockWhereInput>;
  UpgradingInfoMessage?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentPaymentPageBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentPaymentPageBlock';
  BlockedCardError?: Maybe<Scalars['String']['output']>;
  CardRestrictedError?: Maybe<Scalars['String']['output']>;
  CvcDeclinedError?: Maybe<Scalars['String']['output']>;
  ExpiredCardError?: Maybe<Scalars['String']['output']>;
  GsPrepaymentNotice?: Maybe<Scalars['String']['output']>;
  GsTermsAndConditions?: Maybe<Scalars['String']['output']>;
  InvalidCardNumberError?: Maybe<Scalars['String']['output']>;
  IssuerUnavailableError?: Maybe<Scalars['String']['output']>;
  MdrtTermsAndConditions?: Maybe<Scalars['String']['output']>;
  MobilePinRequiredError?: Maybe<Scalars['String']['output']>;
  NotEnoughBalanceError?: Maybe<Scalars['String']['output']>;
  NotSupportedError?: Maybe<Scalars['String']['output']>;
  PageDescription?: Maybe<Scalars['String']['output']>;
  PageHeading?: Maybe<Scalars['String']['output']>;
  PaymentGenericError?: Maybe<Scalars['String']['output']>;
  PaymentHasBeenProcessedError?: Maybe<Scalars['String']['output']>;
  PaymentInProgressError?: Maybe<Scalars['String']['output']>;
  PaymentMethodTitle?: Maybe<Scalars['String']['output']>;
  PaymentRefusedError?: Maybe<Scalars['String']['output']>;
  PaymentSummaryTitle?: Maybe<Scalars['String']['output']>;
  PrepaymentNotice?: Maybe<Scalars['String']['output']>;
  TotalLabel?: Maybe<Scalars['String']['output']>;
  WithdrawalAmountExceededError?: Maybe<Scalars['String']['output']>;
  WithdrawalCountExceededError?: Maybe<Scalars['String']['output']>;
  YearLabel?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockBlockedCardErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockCardRestrictedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockCvcDeclinedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockExpiredCardErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockGsPrepaymentNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockGsTermsAndConditionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockInvalidCardNumberErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockIssuerUnavailableErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockMdrtTermsAndConditionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockMobilePinRequiredErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockNotEnoughBalanceErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockNotSupportedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockPageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockPaymentGenericErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockPaymentHasBeenProcessedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockPaymentInProgressErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockPaymentMethodTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockPaymentRefusedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockPaymentSummaryTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockPrepaymentNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockTotalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockWithdrawalAmountExceededErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockWithdrawalCountExceededErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentPaymentPageBlockFacet';
  BlockedCardError?: Maybe<Array<Maybe<StringFacet>>>;
  CardRestrictedError?: Maybe<Array<Maybe<StringFacet>>>;
  CvcDeclinedError?: Maybe<Array<Maybe<StringFacet>>>;
  ExpiredCardError?: Maybe<Array<Maybe<StringFacet>>>;
  GsPrepaymentNotice?: Maybe<Array<Maybe<StringFacet>>>;
  GsTermsAndConditions?: Maybe<Array<Maybe<StringFacet>>>;
  InvalidCardNumberError?: Maybe<Array<Maybe<StringFacet>>>;
  IssuerUnavailableError?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtTermsAndConditions?: Maybe<Array<Maybe<StringFacet>>>;
  MobilePinRequiredError?: Maybe<Array<Maybe<StringFacet>>>;
  NotEnoughBalanceError?: Maybe<Array<Maybe<StringFacet>>>;
  NotSupportedError?: Maybe<Array<Maybe<StringFacet>>>;
  PageDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentGenericError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentHasBeenProcessedError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentInProgressError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentMethodTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentRefusedError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentSummaryTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PrepaymentNotice?: Maybe<Array<Maybe<StringFacet>>>;
  TotalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  WithdrawalAmountExceededError?: Maybe<Array<Maybe<StringFacet>>>;
  WithdrawalCountExceededError?: Maybe<Array<Maybe<StringFacet>>>;
  YearLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetBlockedCardErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetCardRestrictedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetCvcDeclinedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetExpiredCardErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetGsPrepaymentNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetGsTermsAndConditionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetInvalidCardNumberErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetIssuerUnavailableErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetMdrtTermsAndConditionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetMobilePinRequiredErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetNotEnoughBalanceErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetNotSupportedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetPageDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetPageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetPaymentGenericErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetPaymentHasBeenProcessedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetPaymentInProgressErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetPaymentMethodTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetPaymentRefusedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetPaymentSummaryTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetPrepaymentNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetTotalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetWithdrawalAmountExceededErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetWithdrawalCountExceededErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentPageBlockFacetYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentPaymentPageBlockOrderByInput = {
  BlockedCardError?: InputMaybe<OrderBy>;
  CardRestrictedError?: InputMaybe<OrderBy>;
  CvcDeclinedError?: InputMaybe<OrderBy>;
  ExpiredCardError?: InputMaybe<OrderBy>;
  GsPrepaymentNotice?: InputMaybe<OrderBy>;
  GsTermsAndConditions?: InputMaybe<OrderBy>;
  InvalidCardNumberError?: InputMaybe<OrderBy>;
  IssuerUnavailableError?: InputMaybe<OrderBy>;
  MdrtTermsAndConditions?: InputMaybe<OrderBy>;
  MobilePinRequiredError?: InputMaybe<OrderBy>;
  NotEnoughBalanceError?: InputMaybe<OrderBy>;
  NotSupportedError?: InputMaybe<OrderBy>;
  PageDescription?: InputMaybe<OrderBy>;
  PageHeading?: InputMaybe<OrderBy>;
  PaymentGenericError?: InputMaybe<OrderBy>;
  PaymentHasBeenProcessedError?: InputMaybe<OrderBy>;
  PaymentInProgressError?: InputMaybe<OrderBy>;
  PaymentMethodTitle?: InputMaybe<OrderBy>;
  PaymentRefusedError?: InputMaybe<OrderBy>;
  PaymentSummaryTitle?: InputMaybe<OrderBy>;
  PrepaymentNotice?: InputMaybe<OrderBy>;
  TotalLabel?: InputMaybe<OrderBy>;
  WithdrawalAmountExceededError?: InputMaybe<OrderBy>;
  WithdrawalCountExceededError?: InputMaybe<OrderBy>;
  YearLabel?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentPaymentPageBlockWhereInput = {
  BlockedCardError?: InputMaybe<SearchableStringFilterInput>;
  CardRestrictedError?: InputMaybe<SearchableStringFilterInput>;
  CvcDeclinedError?: InputMaybe<SearchableStringFilterInput>;
  ExpiredCardError?: InputMaybe<SearchableStringFilterInput>;
  GsPrepaymentNotice?: InputMaybe<SearchableStringFilterInput>;
  GsTermsAndConditions?: InputMaybe<SearchableStringFilterInput>;
  InvalidCardNumberError?: InputMaybe<SearchableStringFilterInput>;
  IssuerUnavailableError?: InputMaybe<SearchableStringFilterInput>;
  MdrtTermsAndConditions?: InputMaybe<SearchableStringFilterInput>;
  MobilePinRequiredError?: InputMaybe<SearchableStringFilterInput>;
  NotEnoughBalanceError?: InputMaybe<SearchableStringFilterInput>;
  NotSupportedError?: InputMaybe<SearchableStringFilterInput>;
  PageDescription?: InputMaybe<SearchableStringFilterInput>;
  PageHeading?: InputMaybe<SearchableStringFilterInput>;
  PaymentGenericError?: InputMaybe<SearchableStringFilterInput>;
  PaymentHasBeenProcessedError?: InputMaybe<SearchableStringFilterInput>;
  PaymentInProgressError?: InputMaybe<SearchableStringFilterInput>;
  PaymentMethodTitle?: InputMaybe<SearchableStringFilterInput>;
  PaymentRefusedError?: InputMaybe<SearchableStringFilterInput>;
  PaymentSummaryTitle?: InputMaybe<SearchableStringFilterInput>;
  PrepaymentNotice?: InputMaybe<SearchableStringFilterInput>;
  TotalLabel?: InputMaybe<SearchableStringFilterInput>;
  WithdrawalAmountExceededError?: InputMaybe<SearchableStringFilterInput>;
  WithdrawalCountExceededError?: InputMaybe<SearchableStringFilterInput>;
  YearLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentPaymentStatusPageBlock';
  FailureToast?: Maybe<Scalars['String']['output']>;
  InfoText?: Maybe<Scalars['String']['output']>;
  PageHeading?: Maybe<Scalars['String']['output']>;
  PageSubtitle?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlockFailureToastArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlockInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlockPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlockPageSubtitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentPaymentStatusPageBlockFacet';
  FailureToast?: Maybe<Array<Maybe<StringFacet>>>;
  InfoText?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PageSubtitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlockFacetFailureToastArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlockFacetInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlockFacetPageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlockFacetPageSubtitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlockOrderByInput = {
  FailureToast?: InputMaybe<OrderBy>;
  InfoText?: InputMaybe<OrderBy>;
  PageHeading?: InputMaybe<OrderBy>;
  PageSubtitle?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentPaymentStatusPageBlockWhereInput = {
  FailureToast?: InputMaybe<SearchableStringFilterInput>;
  InfoText?: InputMaybe<SearchableStringFilterInput>;
  PageHeading?: InputMaybe<SearchableStringFilterInput>;
  PageSubtitle?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentProductNamesBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentProductNamesBlock';
  AdditionalFilingFees?: Maybe<Scalars['String']['output']>;
  BackDues?: Maybe<Scalars['String']['output']>;
  COT?: Maybe<Scalars['String']['output']>;
  CompanyPrepayment?: Maybe<Scalars['String']['output']>;
  FellowsDesignation?: Maybe<Scalars['String']['output']>;
  FellowsDesignationFee?: Maybe<Scalars['String']['output']>;
  GlobalServices?: Maybe<Scalars['String']['output']>;
  LifeMember?: Maybe<Scalars['String']['output']>;
  MDRT?: Maybe<Scalars['String']['output']>;
  MdrtCenterForFieldLeadership?: Maybe<Scalars['String']['output']>;
  MdrtDues?: Maybe<Scalars['String']['output']>;
  QualifyingLifeMember?: Maybe<Scalars['String']['output']>;
  QualifyingMember?: Maybe<Scalars['String']['output']>;
  TOT?: Maybe<Scalars['String']['output']>;
  TOTWaiver?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockAdditionalFilingFeesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockBackDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockCotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockCompanyPrepaymentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFellowsDesignationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFellowsDesignationFeeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockGlobalServicesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockLifeMemberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockMdrtArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockMdrtCenterForFieldLeadershipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockMdrtDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockQualifyingLifeMemberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockQualifyingMemberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockTotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockTotWaiverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentProductNamesBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentProductNamesBlockFacet';
  AdditionalFilingFees?: Maybe<Array<Maybe<StringFacet>>>;
  BackDues?: Maybe<Array<Maybe<StringFacet>>>;
  COT?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPrepayment?: Maybe<Array<Maybe<StringFacet>>>;
  FellowsDesignation?: Maybe<Array<Maybe<StringFacet>>>;
  FellowsDesignationFee?: Maybe<Array<Maybe<StringFacet>>>;
  GlobalServices?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMember?: Maybe<Array<Maybe<StringFacet>>>;
  MDRT?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtCenterForFieldLeadership?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtDues?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingLifeMember?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMember?: Maybe<Array<Maybe<StringFacet>>>;
  TOT?: Maybe<Array<Maybe<StringFacet>>>;
  TOTWaiver?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetAdditionalFilingFeesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetBackDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetCotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetCompanyPrepaymentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetFellowsDesignationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetFellowsDesignationFeeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetGlobalServicesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetLifeMemberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetMdrtArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetMdrtCenterForFieldLeadershipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetMdrtDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetQualifyingLifeMemberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetQualifyingMemberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetTotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentProductNamesBlockFacetTotWaiverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentProductNamesBlockOrderByInput = {
  AdditionalFilingFees?: InputMaybe<OrderBy>;
  BackDues?: InputMaybe<OrderBy>;
  COT?: InputMaybe<OrderBy>;
  CompanyPrepayment?: InputMaybe<OrderBy>;
  FellowsDesignation?: InputMaybe<OrderBy>;
  FellowsDesignationFee?: InputMaybe<OrderBy>;
  GlobalServices?: InputMaybe<OrderBy>;
  LifeMember?: InputMaybe<OrderBy>;
  MDRT?: InputMaybe<OrderBy>;
  MdrtCenterForFieldLeadership?: InputMaybe<OrderBy>;
  MdrtDues?: InputMaybe<OrderBy>;
  QualifyingLifeMember?: InputMaybe<OrderBy>;
  QualifyingMember?: InputMaybe<OrderBy>;
  TOT?: InputMaybe<OrderBy>;
  TOTWaiver?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentProductNamesBlockWhereInput = {
  AdditionalFilingFees?: InputMaybe<SearchableStringFilterInput>;
  BackDues?: InputMaybe<SearchableStringFilterInput>;
  COT?: InputMaybe<SearchableStringFilterInput>;
  CompanyPrepayment?: InputMaybe<SearchableStringFilterInput>;
  FellowsDesignation?: InputMaybe<SearchableStringFilterInput>;
  FellowsDesignationFee?: InputMaybe<SearchableStringFilterInput>;
  GlobalServices?: InputMaybe<SearchableStringFilterInput>;
  LifeMember?: InputMaybe<SearchableStringFilterInput>;
  MDRT?: InputMaybe<SearchableStringFilterInput>;
  MdrtCenterForFieldLeadership?: InputMaybe<SearchableStringFilterInput>;
  MdrtDues?: InputMaybe<SearchableStringFilterInput>;
  QualifyingLifeMember?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMember?: InputMaybe<SearchableStringFilterInput>;
  TOT?: InputMaybe<SearchableStringFilterInput>;
  TOTWaiver?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlock = {
  __typename?: 'PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlock';
  BackToLandingPage?: Maybe<Scalars['String']['output']>;
  BuyAgain?: Maybe<Scalars['String']['output']>;
  GlobalServicesThankYou?: Maybe<Scalars['String']['output']>;
  GoBackToMdrt?: Maybe<Scalars['String']['output']>;
  GoBackToMdrtGs?: Maybe<Scalars['String']['output']>;
  PageHeading?: Maybe<Scalars['String']['output']>;
  ThankYou?: Maybe<Scalars['String']['output']>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockBackToLandingPageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockGlobalServicesThankYouArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockGoBackToMdrtArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockGoBackToMdrtGsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockThankYouArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockAutocomplete = {
  __typename?: 'PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockAutocomplete';
  BuyAgain?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockAutocompleteBuyAgainArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockFacet = {
  __typename?: 'PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockFacet';
  BackToLandingPage?: Maybe<Array<Maybe<StringFacet>>>;
  BuyAgain?: Maybe<Array<Maybe<StringFacet>>>;
  GlobalServicesThankYou?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackToMdrt?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackToMdrtGs?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ThankYou?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockFacetBackToLandingPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockFacetBuyAgainArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockFacetGlobalServicesThankYouArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockFacetGoBackToMdrtArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockFacetGoBackToMdrtGsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockFacetPageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockFacetThankYouArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockOrderByInput = {
  BackToLandingPage?: InputMaybe<OrderBy>;
  BuyAgain?: InputMaybe<OrderBy>;
  GlobalServicesThankYou?: InputMaybe<OrderBy>;
  GoBackToMdrt?: InputMaybe<OrderBy>;
  GoBackToMdrtGs?: InputMaybe<OrderBy>;
  PageHeading?: InputMaybe<OrderBy>;
  ThankYou?: InputMaybe<OrderBy>;
};

export type PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockWhereInput = {
  BackToLandingPage?: InputMaybe<SearchableStringFilterInput>;
  BuyAgain?: InputMaybe<StringFilterInput>;
  GlobalServicesThankYou?: InputMaybe<SearchableStringFilterInput>;
  GoBackToMdrt?: InputMaybe<SearchableStringFilterInput>;
  GoBackToMdrtGs?: InputMaybe<SearchableStringFilterInput>;
  PageHeading?: InputMaybe<SearchableStringFilterInput>;
  ThankYou?: InputMaybe<SearchableStringFilterInput>;
};

export type PrepaymentPortalPageWhereInput = {
  AccountLabel?: InputMaybe<SearchableStringFilterInput>;
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ErrorModal?: InputMaybe<PrepaymentPortalPagePrepaymentErrorModalBlockWhereInput>;
  ErrorPageContent?: InputMaybe<PrepaymentPortalPagePrepaymentErrorPageBlockWhereInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  GoBackToHomepageButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  HomePageContent?: InputMaybe<PrepaymentPortalPagePrepaymentHomepageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LoaderScreenContent?: InputMaybe<PrepaymentPortalPagePrepaymentLoaderScreenBlockWhereInput>;
  LogoutLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtCenterLogoUrl?: InputMaybe<SearchableStringFilterInput>;
  MembershipInfoPageContent?: InputMaybe<PrepaymentPortalPagePrepaymentMembershipInfoPageBlockWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<PrepaymentPortalPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NavHeadingLabel?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PayButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentPageContent?: InputMaybe<PrepaymentPortalPagePrepaymentPaymentPageBlockWhereInput>;
  PaymentStatusPageContent?: InputMaybe<PrepaymentPortalPagePrepaymentPaymentStatusPageBlockWhereInput>;
  ProductNamesContent?: InputMaybe<PrepaymentPortalPagePrepaymentProductNamesBlockWhereInput>;
  QuestionsHeading?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RequiredLabel?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelectLanguageHeading?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SuccessfulPaymentPageContent?: InputMaybe<PrepaymentPortalPagePrepaymentSuccessfulPaymentPageBlockWhereInput>;
  ThumbnailImage?: InputMaybe<PrepaymentPortalPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisitFieldLeadership?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentPortalPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentPortalPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentPortalPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds product names for prepayment */
export type PrepaymentProductNamesBlock = IContent & IData & {
  __typename?: 'PrepaymentProductNamesBlock';
  AdditionalFilingFees?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackDues?: Maybe<Scalars['String']['output']>;
  COT?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyPrepayment?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FellowsDesignation?: Maybe<Scalars['String']['output']>;
  FellowsDesignationFee?: Maybe<Scalars['String']['output']>;
  GlobalServices?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LifeMember?: Maybe<Scalars['String']['output']>;
  MDRT?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtCenterForFieldLeadership?: Maybe<Scalars['String']['output']>;
  MdrtDues?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  QualifyingLifeMember?: Maybe<Scalars['String']['output']>;
  QualifyingMember?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TOT?: Maybe<Scalars['String']['output']>;
  TOTWaiver?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockAdditionalFilingFeesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockBackDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockCotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockCompanyPrepaymentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockFellowsDesignationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockFellowsDesignationFeeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockGlobalServicesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockLifeMemberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockMdrtArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockMdrtCenterForFieldLeadershipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockMdrtDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockQualifyingLifeMemberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockQualifyingMemberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockTotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlockTotWaiverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds product names for prepayment */
export type PrepaymentProductNamesBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentProductNamesBlockAutocomplete = {
  __typename?: 'PrepaymentProductNamesBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentProductNamesBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentProductNamesBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentProductNamesBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentProductNamesBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentProductNamesBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentProductNamesBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentProductNamesBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentProductNamesBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentProductNamesBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentProductNamesBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentProductNamesBlockFacet = {
  __typename?: 'PrepaymentProductNamesBlockFacet';
  AdditionalFilingFees?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackDues?: Maybe<Array<Maybe<StringFacet>>>;
  COT?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyPrepayment?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FellowsDesignation?: Maybe<Array<Maybe<StringFacet>>>;
  FellowsDesignationFee?: Maybe<Array<Maybe<StringFacet>>>;
  GlobalServices?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LifeMember?: Maybe<Array<Maybe<StringFacet>>>;
  MDRT?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtCenterForFieldLeadership?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtDues?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  QualifyingLifeMember?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMember?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TOT?: Maybe<Array<Maybe<StringFacet>>>;
  TOTWaiver?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentProductNamesBlockFacetAdditionalFilingFeesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetBackDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetCotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentProductNamesBlockFacetCompanyPrepaymentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentProductNamesBlockFacetFellowsDesignationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetFellowsDesignationFeeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetGlobalServicesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetLifeMemberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetMdrtArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetMdrtCenterForFieldLeadershipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetMdrtDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetQualifyingLifeMemberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetQualifyingMemberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentProductNamesBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentProductNamesBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentProductNamesBlockFacetTotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetTotWaiverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentProductNamesBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentProductNamesBlockOrderByInput = {
  AdditionalFilingFees?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BackDues?: InputMaybe<OrderBy>;
  COT?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyPrepayment?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FellowsDesignation?: InputMaybe<OrderBy>;
  FellowsDesignationFee?: InputMaybe<OrderBy>;
  GlobalServices?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LifeMember?: InputMaybe<OrderBy>;
  MDRT?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtCenterForFieldLeadership?: InputMaybe<OrderBy>;
  MdrtDues?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  QualifyingLifeMember?: InputMaybe<OrderBy>;
  QualifyingMember?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TOT?: InputMaybe<OrderBy>;
  TOTWaiver?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentProductNamesBlockOutput = {
  __typename?: 'PrepaymentProductNamesBlockOutput';
  autocomplete?: Maybe<PrepaymentProductNamesBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentProductNamesBlockFacet>;
  item?: Maybe<PrepaymentProductNamesBlock>;
  items?: Maybe<Array<Maybe<PrepaymentProductNamesBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentProductNamesBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentProductNamesBlockWhereInput = {
  AdditionalFilingFees?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BackDues?: InputMaybe<SearchableStringFilterInput>;
  COT?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyPrepayment?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FellowsDesignation?: InputMaybe<SearchableStringFilterInput>;
  FellowsDesignationFee?: InputMaybe<SearchableStringFilterInput>;
  GlobalServices?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LifeMember?: InputMaybe<SearchableStringFilterInput>;
  MDRT?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtCenterForFieldLeadership?: InputMaybe<SearchableStringFilterInput>;
  MdrtDues?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  QualifyingLifeMember?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMember?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TOT?: InputMaybe<SearchableStringFilterInput>;
  TOTWaiver?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentProductNamesBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentProductNamesBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentProductNamesBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds successful payment pages content */
export type PrepaymentSuccessfulPaymentPageBlock = IContent & IData & {
  __typename?: 'PrepaymentSuccessfulPaymentPageBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackToLandingPage?: Maybe<Scalars['String']['output']>;
  BuyAgain?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  GlobalServicesThankYou?: Maybe<Scalars['String']['output']>;
  GoBackToMdrt?: Maybe<Scalars['String']['output']>;
  GoBackToMdrtGs?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  PageHeading?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  ThankYou?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds successful payment pages content */
export type PrepaymentSuccessfulPaymentPageBlockBackToLandingPageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds successful payment pages content */
export type PrepaymentSuccessfulPaymentPageBlockGlobalServicesThankYouArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds successful payment pages content */
export type PrepaymentSuccessfulPaymentPageBlockGoBackToMdrtArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds successful payment pages content */
export type PrepaymentSuccessfulPaymentPageBlockGoBackToMdrtGsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds successful payment pages content */
export type PrepaymentSuccessfulPaymentPageBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds successful payment pages content */
export type PrepaymentSuccessfulPaymentPageBlockPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds successful payment pages content */
export type PrepaymentSuccessfulPaymentPageBlockThankYouArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds successful payment pages content */
export type PrepaymentSuccessfulPaymentPageBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds successful payment pages content */
export type PrepaymentSuccessfulPaymentPageBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrepaymentSuccessfulPaymentPageBlockAutocomplete = {
  __typename?: 'PrepaymentSuccessfulPaymentPageBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BuyAgain?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrepaymentSuccessfulPaymentPageBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentSuccessfulPaymentPageBlockAutocompleteBuyAgainArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentSuccessfulPaymentPageBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentSuccessfulPaymentPageBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentSuccessfulPaymentPageBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentSuccessfulPaymentPageBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentSuccessfulPaymentPageBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentSuccessfulPaymentPageBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentSuccessfulPaymentPageBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentSuccessfulPaymentPageBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrepaymentSuccessfulPaymentPageBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrepaymentSuccessfulPaymentPageBlockFacet = {
  __typename?: 'PrepaymentSuccessfulPaymentPageBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackToLandingPage?: Maybe<Array<Maybe<StringFacet>>>;
  BuyAgain?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GlobalServicesThankYou?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackToMdrt?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackToMdrtGs?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThankYou?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetBackToLandingPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetBuyAgainArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetGlobalServicesThankYouArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetGoBackToMdrtArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetGoBackToMdrtGsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetPageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetThankYouArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrepaymentSuccessfulPaymentPageBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PrepaymentSuccessfulPaymentPageBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackToLandingPage?: InputMaybe<OrderBy>;
  BuyAgain?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GlobalServicesThankYou?: InputMaybe<OrderBy>;
  GoBackToMdrt?: InputMaybe<OrderBy>;
  GoBackToMdrtGs?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  PageHeading?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThankYou?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PrepaymentSuccessfulPaymentPageBlockOutput = {
  __typename?: 'PrepaymentSuccessfulPaymentPageBlockOutput';
  autocomplete?: Maybe<PrepaymentSuccessfulPaymentPageBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrepaymentSuccessfulPaymentPageBlockFacet>;
  item?: Maybe<PrepaymentSuccessfulPaymentPageBlock>;
  items?: Maybe<Array<Maybe<PrepaymentSuccessfulPaymentPageBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrepaymentSuccessfulPaymentPageBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrepaymentSuccessfulPaymentPageBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackToLandingPage?: InputMaybe<SearchableStringFilterInput>;
  BuyAgain?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GlobalServicesThankYou?: InputMaybe<SearchableStringFilterInput>;
  GoBackToMdrt?: InputMaybe<SearchableStringFilterInput>;
  GoBackToMdrtGs?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  PageHeading?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThankYou?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrepaymentSuccessfulPaymentPageBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrepaymentSuccessfulPaymentPageBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrepaymentSuccessfulPaymentPageBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a press release page */
export type PressReleasePage = IContent & IData & {
  __typename?: 'PressReleasePage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ArticleContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** Renders Person Block */
  Contacts?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  ExtensionLabel?: Maybe<Scalars['String']['output']>;
  ForMoreInformationLine?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<PressReleasePageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PhoneLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SideBar?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Subheading?: Maybe<Scalars['String']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<PressReleasePageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a press release page */
export type PressReleasePageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePageArticleContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePageContactsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePageExtensionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePageForMoreInformationLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePagePhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePageSideBarArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePageSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a press release page */
export type PressReleasePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PressReleasePageAutocomplete = {
  __typename?: 'PressReleasePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<PressReleasePageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<PressReleasePageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PressReleasePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PressReleasePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PressReleasePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PressReleasePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PressReleasePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PressReleasePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PressReleasePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PressReleasePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PressReleasePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PressReleasePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PressReleasePageFacet = {
  __typename?: 'PressReleasePageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ArticleContent?: Maybe<ContentAreaItemModelSearchFacet>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Contacts?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  ExtensionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ForMoreInformationLine?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<PressReleasePageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SideBar?: Maybe<ContentAreaItemModelSearchFacet>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Subheading?: Maybe<Array<Maybe<StringFacet>>>;
  ThumbnailImage?: Maybe<PressReleasePageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PressReleasePageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PressReleasePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PressReleasePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PressReleasePageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetExtensionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetForMoreInformationLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PressReleasePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PressReleasePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PressReleasePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PressReleasePageFacetSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PressReleasePageImageBlock = {
  __typename?: 'PressReleasePageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type PressReleasePageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PressReleasePageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PressReleasePageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PressReleasePageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PressReleasePageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PressReleasePageImageBlockAutocomplete = {
  __typename?: 'PressReleasePageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type PressReleasePageImageBlockFacet = {
  __typename?: 'PressReleasePageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PressReleasePageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PressReleasePageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PressReleasePageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PressReleasePageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type PressReleasePageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type PressReleasePageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ArticleContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Contacts?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  ExtensionLabel?: InputMaybe<OrderBy>;
  ForMoreInformationLine?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<PressReleasePageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SideBar?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Subheading?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<PressReleasePageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PressReleasePageOutput = {
  __typename?: 'PressReleasePageOutput';
  autocomplete?: Maybe<PressReleasePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PressReleasePageFacet>;
  item?: Maybe<PressReleasePage>;
  items?: Maybe<Array<Maybe<PressReleasePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PressReleasePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PressReleasePageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ArticleContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Contacts?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  ExtensionLabel?: InputMaybe<SearchableStringFilterInput>;
  ForMoreInformationLine?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<PressReleasePageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SideBar?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Subheading?: InputMaybe<SearchableStringFilterInput>;
  ThumbnailImage?: InputMaybe<PressReleasePageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PressReleasePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PressReleasePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PressReleasePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PriceBreakdownBlock = IContent & IData & {
  __typename?: 'PriceBreakdownBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackDueLabel?: Maybe<Scalars['String']['output']>;
  BackDueTooltip?: Maybe<PriceBreakdownBlockTooltipBlock>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyPrepaymentLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  LateFeesTooltip?: Maybe<PriceBreakdownBlockTooltipBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PrepaymentLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type PriceBreakdownBlockBackDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PriceBreakdownBlockCompanyPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PriceBreakdownBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PriceBreakdownBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PriceBreakdownBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PriceBreakdownBlockPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PriceBreakdownBlockTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PriceBreakdownBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PriceBreakdownBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PriceBreakdownBlockAutocomplete = {
  __typename?: 'PriceBreakdownBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PriceBreakdownBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceBreakdownBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceBreakdownBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceBreakdownBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceBreakdownBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceBreakdownBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceBreakdownBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceBreakdownBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceBreakdownBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceBreakdownBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PriceBreakdownBlockFacet = {
  __typename?: 'PriceBreakdownBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackDueTooltip?: Maybe<PriceBreakdownBlockTooltipBlockFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyPrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeesTooltip?: Maybe<PriceBreakdownBlockTooltipBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PriceBreakdownBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetBackDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PriceBreakdownBlockFacetCompanyPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PriceBreakdownBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PriceBreakdownBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PriceBreakdownBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PriceBreakdownBlockFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PriceBreakdownBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackDueLabel?: InputMaybe<OrderBy>;
  BackDueTooltip?: InputMaybe<PriceBreakdownBlockTooltipBlockOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyPrepaymentLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  LateFeesTooltip?: InputMaybe<PriceBreakdownBlockTooltipBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PrepaymentLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalDueLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PriceBreakdownBlockOutput = {
  __typename?: 'PriceBreakdownBlockOutput';
  autocomplete?: Maybe<PriceBreakdownBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PriceBreakdownBlockFacet>;
  item?: Maybe<PriceBreakdownBlock>;
  items?: Maybe<Array<Maybe<PriceBreakdownBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PriceBreakdownBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PriceBreakdownBlockTooltipBlock = {
  __typename?: 'PriceBreakdownBlockTooltipBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type PriceBreakdownBlockTooltipBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PriceBreakdownBlockTooltipBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PriceBreakdownBlockTooltipBlockFacet = {
  __typename?: 'PriceBreakdownBlockTooltipBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PriceBreakdownBlockTooltipBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceBreakdownBlockTooltipBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PriceBreakdownBlockTooltipBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type PriceBreakdownBlockTooltipBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type PriceBreakdownBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackDueLabel?: InputMaybe<SearchableStringFilterInput>;
  BackDueTooltip?: InputMaybe<PriceBreakdownBlockTooltipBlockWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyPrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  LateFeesTooltip?: InputMaybe<PriceBreakdownBlockTooltipBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PriceBreakdownBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PriceBreakdownBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PriceBreakdownBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ProductionAttestmentNumbersBlock = IContent & IData & {
  __typename?: 'ProductionAttestmentNumbersBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CommisionText?: Maybe<Scalars['String']['output']>;
  CommisionTextHeader?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IncomeText?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PremiumText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ProductionAttestmentNumbersBlockCommisionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionAttestmentNumbersBlockCommisionTextHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionAttestmentNumbersBlockIncomeTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionAttestmentNumbersBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionAttestmentNumbersBlockPremiumTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionAttestmentNumbersBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionAttestmentNumbersBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProductionAttestmentNumbersBlockAutocomplete = {
  __typename?: 'ProductionAttestmentNumbersBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProductionAttestmentNumbersBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionAttestmentNumbersBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionAttestmentNumbersBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionAttestmentNumbersBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionAttestmentNumbersBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionAttestmentNumbersBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionAttestmentNumbersBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionAttestmentNumbersBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionAttestmentNumbersBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionAttestmentNumbersBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductionAttestmentNumbersBlockFacet = {
  __typename?: 'ProductionAttestmentNumbersBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CommisionText?: Maybe<Array<Maybe<StringFacet>>>;
  CommisionTextHeader?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IncomeText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PremiumText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProductionAttestmentNumbersBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionAttestmentNumbersBlockFacetCommisionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetCommisionTextHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionAttestmentNumbersBlockFacetIncomeTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetPremiumTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionAttestmentNumbersBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionAttestmentNumbersBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionAttestmentNumbersBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionAttestmentNumbersBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProductionAttestmentNumbersBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CommisionText?: InputMaybe<OrderBy>;
  CommisionTextHeader?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IncomeText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PremiumText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProductionAttestmentNumbersBlockOutput = {
  __typename?: 'ProductionAttestmentNumbersBlockOutput';
  autocomplete?: Maybe<ProductionAttestmentNumbersBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProductionAttestmentNumbersBlockFacet>;
  item?: Maybe<ProductionAttestmentNumbersBlock>;
  items?: Maybe<Array<Maybe<ProductionAttestmentNumbersBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProductionAttestmentNumbersBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductionAttestmentNumbersBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CommisionText?: InputMaybe<SearchableStringFilterInput>;
  CommisionTextHeader?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IncomeText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PremiumText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProductionAttestmentNumbersBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProductionAttestmentNumbersBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProductionAttestmentNumbersBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ProductionDataSectionBlock = IContent & IData & {
  __typename?: 'ProductionDataSectionBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CommissionLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncomeLabel?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LifeMemberAttestmentText?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PoliciesLabel?: Maybe<Scalars['String']['output']>;
  PolicyLabel?: Maybe<Scalars['String']['output']>;
  PremiumLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ProductionDataSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDataSectionBlockCommissionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDataSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDataSectionBlockIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDataSectionBlockLifeMemberAttestmentTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDataSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDataSectionBlockPoliciesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDataSectionBlockPolicyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDataSectionBlockPremiumLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDataSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDataSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProductionDataSectionBlockAutocomplete = {
  __typename?: 'ProductionDataSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProductionDataSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDataSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDataSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDataSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDataSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDataSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDataSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDataSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDataSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDataSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductionDataSectionBlockFacet = {
  __typename?: 'ProductionDataSectionBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CommissionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LifeMemberAttestmentText?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PoliciesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PolicyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProductionDataSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionDataSectionBlockFacetCommissionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionDataSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetLifeMemberAttestmentTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetPoliciesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetPolicyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetPremiumLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionDataSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionDataSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionDataSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDataSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProductionDataSectionBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BlockReplacementText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CommissionLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IncomeLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LifeMemberAttestmentText?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PoliciesLabel?: InputMaybe<OrderBy>;
  PolicyLabel?: InputMaybe<OrderBy>;
  PremiumLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProductionDataSectionBlockOutput = {
  __typename?: 'ProductionDataSectionBlockOutput';
  autocomplete?: Maybe<ProductionDataSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProductionDataSectionBlockFacet>;
  item?: Maybe<ProductionDataSectionBlock>;
  items?: Maybe<Array<Maybe<ProductionDataSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProductionDataSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductionDataSectionBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CommissionLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LifeMemberAttestmentText?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PoliciesLabel?: InputMaybe<SearchableStringFilterInput>;
  PolicyLabel?: InputMaybe<SearchableStringFilterInput>;
  PremiumLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProductionDataSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProductionDataSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProductionDataSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ProductionDeleteModalBlock = IContent & IData & {
  __typename?: 'ProductionDeleteModalBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CancelButton?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CommissionTitle?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DeleteButton?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IncomeTitle?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PremiumTitle?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ProductionDeleteModalBlockCancelButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDeleteModalBlockCommissionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDeleteModalBlockDeleteButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDeleteModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDeleteModalBlockIncomeTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDeleteModalBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDeleteModalBlockPremiumTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDeleteModalBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionDeleteModalBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProductionDeleteModalBlockAutocomplete = {
  __typename?: 'ProductionDeleteModalBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProductionDeleteModalBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDeleteModalBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDeleteModalBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDeleteModalBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDeleteModalBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDeleteModalBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDeleteModalBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDeleteModalBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDeleteModalBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionDeleteModalBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductionDeleteModalBlockFacet = {
  __typename?: 'ProductionDeleteModalBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CancelButton?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CommissionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DeleteButton?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IncomeTitle?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PremiumTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProductionDeleteModalBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetCancelButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionDeleteModalBlockFacetCommissionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionDeleteModalBlockFacetDeleteButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetIncomeTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetPremiumTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionDeleteModalBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionDeleteModalBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionDeleteModalBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionDeleteModalBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProductionDeleteModalBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CancelButton?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CommissionTitle?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DeleteButton?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IncomeTitle?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PremiumTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProductionDeleteModalBlockOutput = {
  __typename?: 'ProductionDeleteModalBlockOutput';
  autocomplete?: Maybe<ProductionDeleteModalBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProductionDeleteModalBlockFacet>;
  item?: Maybe<ProductionDeleteModalBlock>;
  items?: Maybe<Array<Maybe<ProductionDeleteModalBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProductionDeleteModalBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductionDeleteModalBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CancelButton?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CommissionTitle?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DeleteButton?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IncomeTitle?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PremiumTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProductionDeleteModalBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProductionDeleteModalBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProductionDeleteModalBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ProductionModalBlock = IContent & IData & {
  __typename?: 'ProductionModalBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CancelButton?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CommissionTitle?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IncomeTitle?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NewBusinessIncomeLabel?: Maybe<Scalars['String']['output']>;
  OtherCommissionInputCommissionLabel?: Maybe<Scalars['String']['output']>;
  OtherCommissionInputPremiumLabel?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesInputLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PremiumTitle?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RiskProtectionInputCommissionLabel?: Maybe<Scalars['String']['output']>;
  RiskProtectionInputIncomeLabel?: Maybe<Scalars['String']['output']>;
  RiskProtectionInputPremiumLabel?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesInputLabel?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SaveButton?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SharedCheckboxLabel?: Maybe<Scalars['String']['output']>;
  SharedTooltip?: Maybe<ProductionModalBlockTooltipBlock>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubsectionDescription?: Maybe<Scalars['String']['output']>;
  SubsectionHeader?: Maybe<Scalars['String']['output']>;
  SubsectionPostfix?: Maybe<Scalars['String']['output']>;
  TotalIncomeReportedInputLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ProductionModalBlockCancelButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockCommissionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockIncomeTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockNewBusinessIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockOtherCommissionInputCommissionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockOtherCommissionInputPremiumLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockOtherPoliciesCasesInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockPremiumTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockRiskProtectionInputCommissionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockRiskProtectionInputIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockRiskProtectionInputPremiumLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockRiskProtectionPoliciesCasesInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockSaveButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockSharedCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockSubsectionDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockSubsectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockSubsectionPostfixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockTotalIncomeReportedInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProductionModalBlockAutocomplete = {
  __typename?: 'ProductionModalBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProductionModalBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionModalBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionModalBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionModalBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionModalBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionModalBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionModalBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionModalBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionModalBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionModalBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductionModalBlockFacet = {
  __typename?: 'ProductionModalBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CancelButton?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CommissionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IncomeTitle?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NewBusinessIncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherCommissionInputCommissionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherCommissionInputPremiumLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PremiumTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionInputCommissionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionInputIncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionInputPremiumLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SaveButton?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SharedCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SharedTooltip?: Maybe<ProductionModalBlockTooltipBlockFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubsectionDescription?: Maybe<Array<Maybe<StringFacet>>>;
  SubsectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  SubsectionPostfix?: Maybe<Array<Maybe<StringFacet>>>;
  TotalIncomeReportedInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProductionModalBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetCancelButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionModalBlockFacetCommissionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetIncomeTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetNewBusinessIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetOtherCommissionInputCommissionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetOtherCommissionInputPremiumLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetOtherPoliciesCasesInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetPremiumTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetRiskProtectionInputCommissionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetRiskProtectionInputIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetRiskProtectionInputPremiumLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetRiskProtectionPoliciesCasesInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetSaveButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionModalBlockFacetSharedCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionModalBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionModalBlockFacetSubsectionDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetSubsectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetSubsectionPostfixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetTotalIncomeReportedInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProductionModalBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CancelButton?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CommissionTitle?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IncomeTitle?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NewBusinessIncomeLabel?: InputMaybe<OrderBy>;
  OtherCommissionInputCommissionLabel?: InputMaybe<OrderBy>;
  OtherCommissionInputPremiumLabel?: InputMaybe<OrderBy>;
  OtherPoliciesCasesInputLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PremiumTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RiskProtectionInputCommissionLabel?: InputMaybe<OrderBy>;
  RiskProtectionInputIncomeLabel?: InputMaybe<OrderBy>;
  RiskProtectionInputPremiumLabel?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesInputLabel?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SaveButton?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SharedCheckboxLabel?: InputMaybe<OrderBy>;
  SharedTooltip?: InputMaybe<ProductionModalBlockTooltipBlockOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubsectionDescription?: InputMaybe<OrderBy>;
  SubsectionHeader?: InputMaybe<OrderBy>;
  SubsectionPostfix?: InputMaybe<OrderBy>;
  TotalIncomeReportedInputLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProductionModalBlockOutput = {
  __typename?: 'ProductionModalBlockOutput';
  autocomplete?: Maybe<ProductionModalBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProductionModalBlockFacet>;
  item?: Maybe<ProductionModalBlock>;
  items?: Maybe<Array<Maybe<ProductionModalBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProductionModalBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductionModalBlockTooltipBlock = {
  __typename?: 'ProductionModalBlockTooltipBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type ProductionModalBlockTooltipBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionModalBlockTooltipBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ProductionModalBlockTooltipBlockFacet = {
  __typename?: 'ProductionModalBlockTooltipBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ProductionModalBlockTooltipBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionModalBlockTooltipBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductionModalBlockTooltipBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type ProductionModalBlockTooltipBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type ProductionModalBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CancelButton?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CommissionTitle?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IncomeTitle?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NewBusinessIncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherCommissionInputCommissionLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherCommissionInputPremiumLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesInputLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PremiumTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RiskProtectionInputCommissionLabel?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionInputIncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionInputPremiumLabel?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesInputLabel?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SaveButton?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SharedCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  SharedTooltip?: InputMaybe<ProductionModalBlockTooltipBlockWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubsectionDescription?: InputMaybe<SearchableStringFilterInput>;
  SubsectionHeader?: InputMaybe<SearchableStringFilterInput>;
  SubsectionPostfix?: InputMaybe<SearchableStringFilterInput>;
  TotalIncomeReportedInputLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProductionModalBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProductionModalBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProductionModalBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type ProductionStepBlock = IContent & IData & {
  __typename?: 'ProductionStepBlock';
  AddButtonLabel?: Maybe<Scalars['String']['output']>;
  AddPolicesButtonLabel?: Maybe<Scalars['String']['output']>;
  AddPoliciesCasesButtonLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AttestProductionAddProduction?: Maybe<Scalars['String']['output']>;
  AttestProductionAttestOption?: Maybe<Scalars['String']['output']>;
  AttestProductionBackButton?: Maybe<Scalars['String']['output']>;
  AttestProductionHeadline?: Maybe<Scalars['String']['output']>;
  AttestProductionSelectLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  CertifyingLettersButtonLabel?: Maybe<Scalars['String']['output']>;
  CertifyingLettersDescription?: Maybe<Scalars['String']['output']>;
  CertifyingLettersErrorText?: Maybe<Scalars['String']['output']>;
  CertifyingLettersFileUploadErrorMessage?: Maybe<Scalars['String']['output']>;
  CertifyingLettersFileUploadFailedMessage?: Maybe<Scalars['String']['output']>;
  CertifyingLettersHeading?: Maybe<Scalars['String']['output']>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CommissionHeading?: Maybe<Scalars['String']['output']>;
  CommissionRiskErrorMessage?: Maybe<Scalars['String']['output']>;
  CompanyAddedProductionLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Use {{companyName}} to insert the user's company name */
  Description?: Maybe<Scalars['String']['output']>;
  EditModalCancelLabel?: Maybe<Scalars['String']['output']>;
  EditModalCommissionDescription?: Maybe<Scalars['String']['output']>;
  EditModalIncomeDescription?: Maybe<Scalars['String']['output']>;
  EditModalPremiumDescription?: Maybe<Scalars['String']['output']>;
  EditModalSaveChangesLabel?: Maybe<Scalars['String']['output']>;
  EditModalSharedLabel?: Maybe<Scalars['String']['output']>;
  EditModalSharedTooltip?: Maybe<Scalars['String']['output']>;
  EditMonetaryProductionModalHeadline?: Maybe<Scalars['String']['output']>;
  EditProductionEntryModalCurrencyLabel?: Maybe<Scalars['String']['output']>;
  EditProductionEntryModalOtherNewBusinessLabel?: Maybe<Scalars['String']['output']>;
  EditProductionEntryModalRiskProtectionLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  GeneralErrorText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncomeOtherNewBusinessErrorMessage?: Maybe<Scalars['String']['output']>;
  IncomeRiskErrorMessage?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MembershipLevelsBannerCoTNotification?: Maybe<Scalars['String']['output']>;
  MembershipLevelsBannerCollapseLinkLabel?: Maybe<Scalars['String']['output']>;
  MembershipLevelsBannerExplainedLinkLabel?: Maybe<Scalars['String']['output']>;
  MembershipLevelsBannerHeading?: Maybe<Scalars['String']['output']>;
  MembershipLevelsBannerMdrtNotification?: Maybe<Scalars['String']['output']>;
  MembershipLevelsBannerToTNotification?: Maybe<Scalars['String']['output']>;
  MonetaryPolciesModalErrorMessage?: Maybe<Scalars['String']['output']>;
  /** Shown when the Add Monetary Production modal is displayed */
  MonetaryProductionCommissionHeading?: Maybe<Scalars['String']['output']>;
  /** Shown when the Add Monetary Production modal is displayed */
  MonetaryProductionCurrencyLabel?: Maybe<Scalars['String']['output']>;
  /** Shown when the Add Monetary Production modal is displayed */
  MonetaryProductionDescription?: Maybe<Scalars['String']['output']>;
  MonetaryProductionErrorText?: Maybe<Scalars['String']['output']>;
  /** Shown when the Add Monetary Production modal is displayed */
  MonetaryProductionHeading?: Maybe<Scalars['String']['output']>;
  MonetaryProductionIncomeErrorMessage?: Maybe<Scalars['String']['output']>;
  /** Shown when the Add Monetary Production modal is displayed */
  MonetaryProductionIncomeHeading?: Maybe<Scalars['String']['output']>;
  /** Shown when the Add Monetary Production modal is displayed */
  MonetaryProductionModalHeading?: Maybe<Scalars['String']['output']>;
  /** Shown when the Add Monetary Production modal is displayed */
  MonetaryProductionOtherNewBusinessPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Shown when the Add Monetary Production modal is displayed */
  MonetaryProductionPremiumHeading?: Maybe<Scalars['String']['output']>;
  /** Shown when the Add Monetary Production modal is displayed */
  MonetaryProductionRiskProtectionPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Shown when the Add Monetary Production modal is displayed */
  MonetaryProductionSharedLabel?: Maybe<Scalars['String']['output']>;
  /** Shown when the Add Monetary Production modal is displayed */
  MonetaryProductionSharedTooltip?: Maybe<Scalars['String']['output']>;
  MonetaryProductionsTabLabel?: Maybe<Scalars['String']['output']>;
  MonetraryProductionNewBusinessIncomeLabel?: Maybe<Scalars['String']['output']>;
  MonetraryProductionRiskProtectionIncomeLabel?: Maybe<Scalars['String']['output']>;
  MonetraryProductionTotalIncomeReportedLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  OtherNewBusinessColumnLabel?: Maybe<Scalars['String']['output']>;
  OtherNewBusinessPoliciesColumnLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PoliciesCasesEntryLabel?: Maybe<Scalars['String']['output']>;
  PoliciesCasesError?: Maybe<Scalars['String']['output']>;
  PoliciesCasesModalHeading?: Maybe<Scalars['String']['output']>;
  PremiumHeading?: Maybe<Scalars['String']['output']>;
  PremiumRiskErrorMessage?: Maybe<Scalars['String']['output']>;
  ProductionInLivesDescription?: Maybe<Scalars['String']['output']>;
  ProductionInLivesTabLabel?: Maybe<Scalars['String']['output']>;
  ProductionModalNotice?: Maybe<Scalars['String']['output']>;
  /** The key is the literal message returned by the Reasonableness API, the Value is the translated display text for that message. You should translate the block itself. */
  ReasonablenessResponseMessageList?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RiskProtectionColumnLabel?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesColumnLabel?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SelfAddedProductionLabel?: Maybe<Scalars['String']['output']>;
  SharedColumnLabel?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TotalColumnLabel?: Maybe<Scalars['String']['output']>;
  TotalCommissionProductionLabel?: Maybe<Scalars['String']['output']>;
  TotalIncomePoliciesCasesLabel?: Maybe<Scalars['String']['output']>;
  TotalPremiumProductionLabel?: Maybe<Scalars['String']['output']>;
  TotalProductionLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockAddButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockAddPolicesButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockAddPoliciesCasesButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockAttestProductionAddProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockAttestProductionAttestOptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockAttestProductionBackButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockAttestProductionHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockAttestProductionSelectLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockCertifyingLettersButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockCertifyingLettersDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockCertifyingLettersErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockCertifyingLettersFileUploadErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockCertifyingLettersFileUploadFailedMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockCertifyingLettersHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockCommissionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockCommissionRiskErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockCompanyAddedProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockEditModalCancelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockEditModalCommissionDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockEditModalIncomeDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockEditModalPremiumDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockEditModalSaveChangesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockEditModalSharedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockEditModalSharedTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockEditMonetaryProductionModalHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockEditProductionEntryModalCurrencyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockEditProductionEntryModalOtherNewBusinessLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockEditProductionEntryModalRiskProtectionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockGeneralErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockIncomeOtherNewBusinessErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockIncomeRiskErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMembershipLevelsBannerCoTNotificationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMembershipLevelsBannerCollapseLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMembershipLevelsBannerExplainedLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMembershipLevelsBannerHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMembershipLevelsBannerMdrtNotificationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMembershipLevelsBannerToTNotificationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryPolciesModalErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionCommissionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionCurrencyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionIncomeErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionIncomeHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionModalHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionOtherNewBusinessPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionPremiumHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionRiskProtectionPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionSharedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionSharedTooltipArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetaryProductionsTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetraryProductionNewBusinessIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetraryProductionRiskProtectionIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockMonetraryProductionTotalIncomeReportedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockOtherNewBusinessColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockOtherNewBusinessPoliciesColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockPoliciesCasesEntryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockPoliciesCasesErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockPoliciesCasesModalHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockPremiumHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockPremiumRiskErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockProductionInLivesDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockProductionInLivesTabLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockProductionModalNoticeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockReasonablenessResponseMessageListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockRiskProtectionColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockRiskProtectionPoliciesColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockSelfAddedProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockSharedColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockTotalColumnLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockTotalCommissionProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockTotalIncomePoliciesCasesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockTotalPremiumProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlockTotalProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProductionStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProductionStepBlockAutocomplete = {
  __typename?: 'ProductionStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProductionStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductionStepBlockFacet = {
  __typename?: 'ProductionStepBlockFacet';
  AddButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddPolicesButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddPoliciesCasesButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionAddProduction?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionAttestOption?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionBackButton?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionSelectLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  CertifyingLettersButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersDescription?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersFileUploadErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersFileUploadFailedMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CommissionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionRiskErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyAddedProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalCancelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalCommissionDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalIncomeDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalPremiumDescription?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalSaveChangesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalSharedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditModalSharedTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  EditMonetaryProductionModalHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  EditProductionEntryModalCurrencyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditProductionEntryModalOtherNewBusinessLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditProductionEntryModalRiskProtectionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GeneralErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeOtherNewBusinessErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeRiskErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipLevelsBannerCoTNotification?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsBannerCollapseLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsBannerExplainedLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsBannerHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsBannerMdrtNotification?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelsBannerToTNotification?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryPolciesModalErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionCommissionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionCurrencyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionIncomeErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionIncomeHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionModalHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionOtherNewBusinessPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionPremiumHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionRiskProtectionPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionSharedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionSharedTooltip?: Maybe<Array<Maybe<StringFacet>>>;
  MonetaryProductionsTabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MonetraryProductionNewBusinessIncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MonetraryProductionRiskProtectionIncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MonetraryProductionTotalIncomeReportedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherNewBusinessColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherNewBusinessPoliciesColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PoliciesCasesEntryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PoliciesCasesError?: Maybe<Array<Maybe<StringFacet>>>;
  PoliciesCasesModalHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumRiskErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionInLivesDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionInLivesTabLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionModalNotice?: Maybe<Array<Maybe<StringFacet>>>;
  ReasonablenessResponseMessageList?: Maybe<ContentAreaItemModelSearchFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelfAddedProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SharedColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalColumnLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalCommissionProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalIncomePoliciesCasesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalPremiumProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProductionStepBlockFacetAddButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetAddPolicesButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetAddPoliciesCasesButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetAttestProductionAddProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetAttestProductionAttestOptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetAttestProductionBackButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetAttestProductionHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetAttestProductionSelectLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetCertifyingLettersButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetCertifyingLettersDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetCertifyingLettersErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetCertifyingLettersFileUploadErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetCertifyingLettersFileUploadFailedMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetCertifyingLettersHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionStepBlockFacetCommissionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetCommissionRiskErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetCompanyAddedProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetEditModalCancelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetEditModalCommissionDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetEditModalIncomeDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetEditModalPremiumDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetEditModalSaveChangesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetEditModalSharedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetEditModalSharedTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetEditMonetaryProductionModalHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetEditProductionEntryModalCurrencyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetEditProductionEntryModalOtherNewBusinessLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetEditProductionEntryModalRiskProtectionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetGeneralErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetIncomeOtherNewBusinessErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetIncomeRiskErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMembershipLevelsBannerCoTNotificationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMembershipLevelsBannerCollapseLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMembershipLevelsBannerExplainedLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMembershipLevelsBannerHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMembershipLevelsBannerMdrtNotificationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMembershipLevelsBannerToTNotificationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryPolciesModalErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionCommissionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionCurrencyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionIncomeErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionIncomeHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionModalHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionOtherNewBusinessPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionPremiumHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionRiskProtectionPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionSharedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionSharedTooltipArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetaryProductionsTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetraryProductionNewBusinessIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetraryProductionRiskProtectionIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetMonetraryProductionTotalIncomeReportedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetOtherNewBusinessColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetOtherNewBusinessPoliciesColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetPoliciesCasesEntryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetPoliciesCasesErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetPoliciesCasesModalHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetPremiumHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetPremiumRiskErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetProductionInLivesDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetProductionInLivesTabLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetProductionModalNoticeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetRiskProtectionColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetRiskProtectionPoliciesColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionStepBlockFacetSelfAddedProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetSharedColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionStepBlockFacetTotalColumnLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetTotalCommissionProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetTotalIncomePoliciesCasesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetTotalPremiumProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetTotalProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProductionStepBlockOrderByInput = {
  AddButtonLabel?: InputMaybe<OrderBy>;
  AddPolicesButtonLabel?: InputMaybe<OrderBy>;
  AddPoliciesCasesButtonLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AttestProductionAddProduction?: InputMaybe<OrderBy>;
  AttestProductionAttestOption?: InputMaybe<OrderBy>;
  AttestProductionBackButton?: InputMaybe<OrderBy>;
  AttestProductionHeadline?: InputMaybe<OrderBy>;
  AttestProductionSelectLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  CertifyingLettersButtonLabel?: InputMaybe<OrderBy>;
  CertifyingLettersDescription?: InputMaybe<OrderBy>;
  CertifyingLettersErrorText?: InputMaybe<OrderBy>;
  CertifyingLettersFileUploadErrorMessage?: InputMaybe<OrderBy>;
  CertifyingLettersFileUploadFailedMessage?: InputMaybe<OrderBy>;
  CertifyingLettersHeading?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  CommissionHeading?: InputMaybe<OrderBy>;
  CommissionRiskErrorMessage?: InputMaybe<OrderBy>;
  CompanyAddedProductionLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EditModalCancelLabel?: InputMaybe<OrderBy>;
  EditModalCommissionDescription?: InputMaybe<OrderBy>;
  EditModalIncomeDescription?: InputMaybe<OrderBy>;
  EditModalPremiumDescription?: InputMaybe<OrderBy>;
  EditModalSaveChangesLabel?: InputMaybe<OrderBy>;
  EditModalSharedLabel?: InputMaybe<OrderBy>;
  EditModalSharedTooltip?: InputMaybe<OrderBy>;
  EditMonetaryProductionModalHeadline?: InputMaybe<OrderBy>;
  EditProductionEntryModalCurrencyLabel?: InputMaybe<OrderBy>;
  EditProductionEntryModalOtherNewBusinessLabel?: InputMaybe<OrderBy>;
  EditProductionEntryModalRiskProtectionLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GeneralErrorText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IncomeOtherNewBusinessErrorMessage?: InputMaybe<OrderBy>;
  IncomeRiskErrorMessage?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipLevelsBannerCoTNotification?: InputMaybe<OrderBy>;
  MembershipLevelsBannerCollapseLinkLabel?: InputMaybe<OrderBy>;
  MembershipLevelsBannerExplainedLinkLabel?: InputMaybe<OrderBy>;
  MembershipLevelsBannerHeading?: InputMaybe<OrderBy>;
  MembershipLevelsBannerMdrtNotification?: InputMaybe<OrderBy>;
  MembershipLevelsBannerToTNotification?: InputMaybe<OrderBy>;
  MonetaryPolciesModalErrorMessage?: InputMaybe<OrderBy>;
  MonetaryProductionCommissionHeading?: InputMaybe<OrderBy>;
  MonetaryProductionCurrencyLabel?: InputMaybe<OrderBy>;
  MonetaryProductionDescription?: InputMaybe<OrderBy>;
  MonetaryProductionErrorText?: InputMaybe<OrderBy>;
  MonetaryProductionHeading?: InputMaybe<OrderBy>;
  MonetaryProductionIncomeErrorMessage?: InputMaybe<OrderBy>;
  MonetaryProductionIncomeHeading?: InputMaybe<OrderBy>;
  MonetaryProductionModalHeading?: InputMaybe<OrderBy>;
  MonetaryProductionOtherNewBusinessPlaceholder?: InputMaybe<OrderBy>;
  MonetaryProductionPremiumHeading?: InputMaybe<OrderBy>;
  MonetaryProductionRiskProtectionPlaceholder?: InputMaybe<OrderBy>;
  MonetaryProductionSharedLabel?: InputMaybe<OrderBy>;
  MonetaryProductionSharedTooltip?: InputMaybe<OrderBy>;
  MonetaryProductionsTabLabel?: InputMaybe<OrderBy>;
  MonetraryProductionNewBusinessIncomeLabel?: InputMaybe<OrderBy>;
  MonetraryProductionRiskProtectionIncomeLabel?: InputMaybe<OrderBy>;
  MonetraryProductionTotalIncomeReportedLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  OtherNewBusinessColumnLabel?: InputMaybe<OrderBy>;
  OtherNewBusinessPoliciesColumnLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PoliciesCasesEntryLabel?: InputMaybe<OrderBy>;
  PoliciesCasesError?: InputMaybe<OrderBy>;
  PoliciesCasesModalHeading?: InputMaybe<OrderBy>;
  PremiumHeading?: InputMaybe<OrderBy>;
  PremiumRiskErrorMessage?: InputMaybe<OrderBy>;
  ProductionInLivesDescription?: InputMaybe<OrderBy>;
  ProductionInLivesTabLabel?: InputMaybe<OrderBy>;
  ProductionModalNotice?: InputMaybe<OrderBy>;
  ReasonablenessResponseMessageList?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RiskProtectionColumnLabel?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesColumnLabel?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelfAddedProductionLabel?: InputMaybe<OrderBy>;
  SharedColumnLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalColumnLabel?: InputMaybe<OrderBy>;
  TotalCommissionProductionLabel?: InputMaybe<OrderBy>;
  TotalIncomePoliciesCasesLabel?: InputMaybe<OrderBy>;
  TotalPremiumProductionLabel?: InputMaybe<OrderBy>;
  TotalProductionLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProductionStepBlockOutput = {
  __typename?: 'ProductionStepBlockOutput';
  autocomplete?: Maybe<ProductionStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProductionStepBlockFacet>;
  item?: Maybe<ProductionStepBlock>;
  items?: Maybe<Array<Maybe<ProductionStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProductionStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductionStepBlockWhereInput = {
  AddButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  AddPolicesButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  AddPoliciesCasesButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AttestProductionAddProduction?: InputMaybe<SearchableStringFilterInput>;
  AttestProductionAttestOption?: InputMaybe<SearchableStringFilterInput>;
  AttestProductionBackButton?: InputMaybe<SearchableStringFilterInput>;
  AttestProductionHeadline?: InputMaybe<SearchableStringFilterInput>;
  AttestProductionSelectLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  CertifyingLettersButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersDescription?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersErrorText?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersFileUploadErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersFileUploadFailedMessage?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersHeading?: InputMaybe<SearchableStringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CommissionHeading?: InputMaybe<SearchableStringFilterInput>;
  CommissionRiskErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  CompanyAddedProductionLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EditModalCancelLabel?: InputMaybe<SearchableStringFilterInput>;
  EditModalCommissionDescription?: InputMaybe<SearchableStringFilterInput>;
  EditModalIncomeDescription?: InputMaybe<SearchableStringFilterInput>;
  EditModalPremiumDescription?: InputMaybe<SearchableStringFilterInput>;
  EditModalSaveChangesLabel?: InputMaybe<SearchableStringFilterInput>;
  EditModalSharedLabel?: InputMaybe<SearchableStringFilterInput>;
  EditModalSharedTooltip?: InputMaybe<SearchableStringFilterInput>;
  EditMonetaryProductionModalHeadline?: InputMaybe<SearchableStringFilterInput>;
  EditProductionEntryModalCurrencyLabel?: InputMaybe<SearchableStringFilterInput>;
  EditProductionEntryModalOtherNewBusinessLabel?: InputMaybe<SearchableStringFilterInput>;
  EditProductionEntryModalRiskProtectionLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GeneralErrorText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncomeOtherNewBusinessErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  IncomeRiskErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipLevelsBannerCoTNotification?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsBannerCollapseLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsBannerExplainedLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsBannerHeading?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsBannerMdrtNotification?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelsBannerToTNotification?: InputMaybe<SearchableStringFilterInput>;
  MonetaryPolciesModalErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionCommissionHeading?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionCurrencyLabel?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionDescription?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionErrorText?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionHeading?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionIncomeErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionIncomeHeading?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionModalHeading?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionOtherNewBusinessPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionPremiumHeading?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionRiskProtectionPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionSharedLabel?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionSharedTooltip?: InputMaybe<SearchableStringFilterInput>;
  MonetaryProductionsTabLabel?: InputMaybe<SearchableStringFilterInput>;
  MonetraryProductionNewBusinessIncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  MonetraryProductionRiskProtectionIncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  MonetraryProductionTotalIncomeReportedLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherNewBusinessColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherNewBusinessPoliciesColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PoliciesCasesEntryLabel?: InputMaybe<SearchableStringFilterInput>;
  PoliciesCasesError?: InputMaybe<SearchableStringFilterInput>;
  PoliciesCasesModalHeading?: InputMaybe<SearchableStringFilterInput>;
  PremiumHeading?: InputMaybe<SearchableStringFilterInput>;
  PremiumRiskErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  ProductionInLivesDescription?: InputMaybe<SearchableStringFilterInput>;
  ProductionInLivesTabLabel?: InputMaybe<SearchableStringFilterInput>;
  ProductionModalNotice?: InputMaybe<SearchableStringFilterInput>;
  ReasonablenessResponseMessageList?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RiskProtectionColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelfAddedProductionLabel?: InputMaybe<SearchableStringFilterInput>;
  SharedColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalColumnLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalCommissionProductionLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalIncomePoliciesCasesLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalPremiumProductionLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalProductionLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProductionStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProductionStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProductionStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2Block = IContent & IData & {
  __typename?: 'ProductionStepV2Block';
  /** Texts used in production add modal */
  AddProductionModal?: Maybe<ProductionStepV2BlockProductionModalBlock>;
  AddProductionNumbersRadioLabels?: Maybe<Scalars['String']['output']>;
  AddedByText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AttestProductionNumbersRadioLabels?: Maybe<Scalars['String']['output']>;
  AttestViewMoreLabel?: Maybe<Scalars['String']['output']>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  /** Texts used for radio buttons under COT block when attesting to production numbers */
  COTProductionNumberTexts?: Maybe<ProductionStepV2BlockProductionAttestmentNumbersBlock>;
  COTQualifyingMessageText?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  CertificationLetterFileTooLargeError?: Maybe<Scalars['String']['output']>;
  /** Title text for certifying letters section */
  CertifyinLettersTitle?: Maybe<Scalars['String']['output']>;
  /** Description text for certifying letters section */
  CertifyingLettersDescription?: Maybe<Scalars['String']['output']>;
  /** Text for certifying letters section upload */
  CertifyingLettersUploadButtonText?: Maybe<Scalars['String']['output']>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CommissionTable?: Maybe<ProductionStepV2BlockProductionTableBlock>;
  CompanyAddedProduction?: Maybe<Scalars['String']['output']>;
  CompanyText?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Texts used in the delete certifying letter modal */
  DeleteCertifyingLetterModal?: Maybe<ProductionStepV2BlockDeleteCertifyinLetterModalBlock>;
  DeleteProductionModal?: Maybe<ProductionStepV2BlockProductionDeleteModalBlock>;
  Description?: Maybe<Scalars['String']['output']>;
  DescriptionQualifyingAndLife?: Maybe<Scalars['String']['output']>;
  /** Texts used in production edit modal */
  EditProductionModal?: Maybe<ProductionStepV2BlockProductionModalBlock>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FieldRequiredError?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  /** Texts used for radio buttons under TOT block when attesting to production numbers */
  IncomeTable?: Maybe<ProductionStepV2BlockProductionTableBlock>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Texts used for radio buttons under MDRT block when attesting to production numbers */
  MDRTProductionNumberTexts?: Maybe<ProductionStepV2BlockProductionAttestmentNumbersBlock>;
  MDRTQualifyingMessageText?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MembershipLevelSelectionText?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  NoCertificationLettersError?: Maybe<Scalars['String']['output']>;
  NotEnoughMonetaryProductionError?: Maybe<Scalars['String']['output']>;
  NotEnoughNewBusinessByCountryError?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PolicyMultipleText?: Maybe<Scalars['String']['output']>;
  PolicySingleText?: Maybe<Scalars['String']['output']>;
  PremiumTable?: Maybe<ProductionStepV2BlockProductionTableBlock>;
  ProductionNumbersFormDescription?: Maybe<Scalars['String']['output']>;
  ProductionNumbersNotSelectedError?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  /** Option data for self attestment level options */
  SelfAttestLevelOptions?: Maybe<ProductionStepV2BlockSelfAttestLevelOptionsBlock>;
  SelfAttestationFormDescription?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Texts used for radio buttons under TOT block when attesting to production numbers */
  TOTProductionNumberTexts?: Maybe<ProductionStepV2BlockProductionAttestmentNumbersBlock>;
  TOTQualifyingMessageText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  YouCanAddMoreProdcution?: Maybe<Scalars['String']['output']>;
  YouCannotAttestToAHigherLevelWarning?: Maybe<Scalars['String']['output']>;
  YouText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockAddProductionNumbersRadioLabelsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockAddedByTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockAttestProductionNumbersRadioLabelsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockAttestViewMoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockCotQualifyingMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockCertificationLetterFileTooLargeErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockCertifyinLettersTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockCertifyingLettersDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockCertifyingLettersUploadButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockCompanyAddedProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockCompanyTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockDescriptionQualifyingAndLifeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockFieldRequiredErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockMdrtQualifyingMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockMembershipLevelSelectionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockNoCertificationLettersErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockNotEnoughMonetaryProductionErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockNotEnoughNewBusinessByCountryErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockPolicyMultipleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockPolicySingleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockProductionNumbersFormDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockProductionNumbersNotSelectedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockSelfAttestationFormDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockTotQualifyingMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockYouCanAddMoreProdcutionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockYouCannotAttestToAHigherLevelWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2BlockYouTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProductionStepV2Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProductionStepV2BlockAutocomplete = {
  __typename?: 'ProductionStepV2BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProductionStepV2BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepV2BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepV2BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepV2BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepV2BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepV2BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepV2BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepV2BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepV2BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionStepV2BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductionStepV2BlockDeleteCertifyinLetterModalBlock = {
  __typename?: 'ProductionStepV2BlockDeleteCertifyinLetterModalBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type ProductionStepV2BlockDeleteCertifyinLetterModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockDeleteCertifyinLetterModalBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ProductionStepV2BlockDeleteCertifyinLetterModalBlockFacet = {
  __typename?: 'ProductionStepV2BlockDeleteCertifyinLetterModalBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ProductionStepV2BlockDeleteCertifyinLetterModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockDeleteCertifyinLetterModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductionStepV2BlockDeleteCertifyinLetterModalBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type ProductionStepV2BlockDeleteCertifyinLetterModalBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type ProductionStepV2BlockFacet = {
  __typename?: 'ProductionStepV2BlockFacet';
  AddProductionModal?: Maybe<ProductionStepV2BlockProductionModalBlockFacet>;
  AddProductionNumbersRadioLabels?: Maybe<Array<Maybe<StringFacet>>>;
  AddedByText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AttestProductionNumbersRadioLabels?: Maybe<Array<Maybe<StringFacet>>>;
  AttestViewMoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  COTProductionNumberTexts?: Maybe<ProductionStepV2BlockProductionAttestmentNumbersBlockFacet>;
  COTQualifyingMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  CertificationLetterFileTooLargeError?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyinLettersTitle?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersDescription?: Maybe<Array<Maybe<StringFacet>>>;
  CertifyingLettersUploadButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CommissionTable?: Maybe<ProductionStepV2BlockProductionTableBlockFacet>;
  CompanyAddedProduction?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DeleteCertifyingLetterModal?: Maybe<ProductionStepV2BlockDeleteCertifyinLetterModalBlockFacet>;
  DeleteProductionModal?: Maybe<ProductionStepV2BlockProductionDeleteModalBlockFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DescriptionQualifyingAndLife?: Maybe<Array<Maybe<StringFacet>>>;
  EditProductionModal?: Maybe<ProductionStepV2BlockProductionModalBlockFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FieldRequiredError?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeTable?: Maybe<ProductionStepV2BlockProductionTableBlockFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MDRTProductionNumberTexts?: Maybe<ProductionStepV2BlockProductionAttestmentNumbersBlockFacet>;
  MDRTQualifyingMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipLevelSelectionText?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NoCertificationLettersError?: Maybe<Array<Maybe<StringFacet>>>;
  NotEnoughMonetaryProductionError?: Maybe<Array<Maybe<StringFacet>>>;
  NotEnoughNewBusinessByCountryError?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PolicyMultipleText?: Maybe<Array<Maybe<StringFacet>>>;
  PolicySingleText?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumTable?: Maybe<ProductionStepV2BlockProductionTableBlockFacet>;
  ProductionNumbersFormDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ProductionNumbersNotSelectedError?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelfAttestLevelOptions?: Maybe<ProductionStepV2BlockSelfAttestLevelOptionsBlockFacet>;
  SelfAttestationFormDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TOTProductionNumberTexts?: Maybe<ProductionStepV2BlockProductionAttestmentNumbersBlockFacet>;
  TOTQualifyingMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YouCanAddMoreProdcution?: Maybe<Array<Maybe<StringFacet>>>;
  YouCannotAttestToAHigherLevelWarning?: Maybe<Array<Maybe<StringFacet>>>;
  YouText?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProductionStepV2BlockFacetAddProductionNumbersRadioLabelsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetAddedByTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetAttestProductionNumbersRadioLabelsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetAttestViewMoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetCotQualifyingMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetCertificationLetterFileTooLargeErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetCertifyinLettersTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetCertifyingLettersDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetCertifyingLettersUploadButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionStepV2BlockFacetCompanyAddedProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetCompanyTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetDescriptionQualifyingAndLifeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetFieldRequiredErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetMdrtQualifyingMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetMembershipLevelSelectionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetNoCertificationLettersErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetNotEnoughMonetaryProductionErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetNotEnoughNewBusinessByCountryErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetPolicyMultipleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetPolicySingleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetProductionNumbersFormDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetProductionNumbersNotSelectedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionStepV2BlockFacetSelfAttestationFormDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionStepV2BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionStepV2BlockFacetTotQualifyingMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetYouCanAddMoreProdcutionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetYouCannotAttestToAHigherLevelWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacetYouTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProductionStepV2BlockOrderByInput = {
  AddProductionModal?: InputMaybe<ProductionStepV2BlockProductionModalBlockOrderByInput>;
  AddProductionNumbersRadioLabels?: InputMaybe<OrderBy>;
  AddedByText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AttestProductionNumbersRadioLabels?: InputMaybe<OrderBy>;
  AttestViewMoreLabel?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  COTProductionNumberTexts?: InputMaybe<ProductionStepV2BlockProductionAttestmentNumbersBlockOrderByInput>;
  COTQualifyingMessageText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  CertificationLetterFileTooLargeError?: InputMaybe<OrderBy>;
  CertifyinLettersTitle?: InputMaybe<OrderBy>;
  CertifyingLettersDescription?: InputMaybe<OrderBy>;
  CertifyingLettersUploadButtonText?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  CommissionTable?: InputMaybe<ProductionStepV2BlockProductionTableBlockOrderByInput>;
  CompanyAddedProduction?: InputMaybe<OrderBy>;
  CompanyText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DeleteCertifyingLetterModal?: InputMaybe<ProductionStepV2BlockDeleteCertifyinLetterModalBlockOrderByInput>;
  DeleteProductionModal?: InputMaybe<ProductionStepV2BlockProductionDeleteModalBlockOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  DescriptionQualifyingAndLife?: InputMaybe<OrderBy>;
  EditProductionModal?: InputMaybe<ProductionStepV2BlockProductionModalBlockOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FieldRequiredError?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IncomeTable?: InputMaybe<ProductionStepV2BlockProductionTableBlockOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MDRTProductionNumberTexts?: InputMaybe<ProductionStepV2BlockProductionAttestmentNumbersBlockOrderByInput>;
  MDRTQualifyingMessageText?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipLevelSelectionText?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  NoCertificationLettersError?: InputMaybe<OrderBy>;
  NotEnoughMonetaryProductionError?: InputMaybe<OrderBy>;
  NotEnoughNewBusinessByCountryError?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PolicyMultipleText?: InputMaybe<OrderBy>;
  PolicySingleText?: InputMaybe<OrderBy>;
  PremiumTable?: InputMaybe<ProductionStepV2BlockProductionTableBlockOrderByInput>;
  ProductionNumbersFormDescription?: InputMaybe<OrderBy>;
  ProductionNumbersNotSelectedError?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelfAttestLevelOptions?: InputMaybe<ProductionStepV2BlockSelfAttestLevelOptionsBlockOrderByInput>;
  SelfAttestationFormDescription?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TOTProductionNumberTexts?: InputMaybe<ProductionStepV2BlockProductionAttestmentNumbersBlockOrderByInput>;
  TOTQualifyingMessageText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  YouCanAddMoreProdcution?: InputMaybe<OrderBy>;
  YouCannotAttestToAHigherLevelWarning?: InputMaybe<OrderBy>;
  YouText?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProductionStepV2BlockOutput = {
  __typename?: 'ProductionStepV2BlockOutput';
  autocomplete?: Maybe<ProductionStepV2BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProductionStepV2BlockFacet>;
  item?: Maybe<ProductionStepV2Block>;
  items?: Maybe<Array<Maybe<ProductionStepV2Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProductionStepV2BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductionStepV2BlockProductionAttestmentNumbersBlock = {
  __typename?: 'ProductionStepV2BlockProductionAttestmentNumbersBlock';
  CommisionText?: Maybe<Scalars['String']['output']>;
  CommisionTextHeader?: Maybe<Scalars['String']['output']>;
  IncomeText?: Maybe<Scalars['String']['output']>;
  PremiumText?: Maybe<Scalars['String']['output']>;
};


export type ProductionStepV2BlockProductionAttestmentNumbersBlockCommisionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionAttestmentNumbersBlockCommisionTextHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionAttestmentNumbersBlockIncomeTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionAttestmentNumbersBlockPremiumTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ProductionStepV2BlockProductionAttestmentNumbersBlockFacet = {
  __typename?: 'ProductionStepV2BlockProductionAttestmentNumbersBlockFacet';
  CommisionText?: Maybe<Array<Maybe<StringFacet>>>;
  CommisionTextHeader?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeText?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ProductionStepV2BlockProductionAttestmentNumbersBlockFacetCommisionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionAttestmentNumbersBlockFacetCommisionTextHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionAttestmentNumbersBlockFacetIncomeTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionAttestmentNumbersBlockFacetPremiumTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductionStepV2BlockProductionAttestmentNumbersBlockOrderByInput = {
  CommisionText?: InputMaybe<OrderBy>;
  CommisionTextHeader?: InputMaybe<OrderBy>;
  IncomeText?: InputMaybe<OrderBy>;
  PremiumText?: InputMaybe<OrderBy>;
};

export type ProductionStepV2BlockProductionAttestmentNumbersBlockWhereInput = {
  CommisionText?: InputMaybe<SearchableStringFilterInput>;
  CommisionTextHeader?: InputMaybe<SearchableStringFilterInput>;
  IncomeText?: InputMaybe<SearchableStringFilterInput>;
  PremiumText?: InputMaybe<SearchableStringFilterInput>;
};

export type ProductionStepV2BlockProductionDeleteModalBlock = {
  __typename?: 'ProductionStepV2BlockProductionDeleteModalBlock';
  CancelButton?: Maybe<Scalars['String']['output']>;
  CommissionTitle?: Maybe<Scalars['String']['output']>;
  DeleteButton?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  IncomeTitle?: Maybe<Scalars['String']['output']>;
  PremiumTitle?: Maybe<Scalars['String']['output']>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockCancelButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockCommissionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockDeleteButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockIncomeTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockPremiumTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ProductionStepV2BlockProductionDeleteModalBlockFacet = {
  __typename?: 'ProductionStepV2BlockProductionDeleteModalBlockFacet';
  CancelButton?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  DeleteButton?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumTitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockFacetCancelButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockFacetCommissionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockFacetDeleteButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockFacetIncomeTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionDeleteModalBlockFacetPremiumTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductionStepV2BlockProductionDeleteModalBlockOrderByInput = {
  CancelButton?: InputMaybe<OrderBy>;
  CommissionTitle?: InputMaybe<OrderBy>;
  DeleteButton?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  IncomeTitle?: InputMaybe<OrderBy>;
  PremiumTitle?: InputMaybe<OrderBy>;
};

export type ProductionStepV2BlockProductionDeleteModalBlockWhereInput = {
  CancelButton?: InputMaybe<SearchableStringFilterInput>;
  CommissionTitle?: InputMaybe<SearchableStringFilterInput>;
  DeleteButton?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  IncomeTitle?: InputMaybe<SearchableStringFilterInput>;
  PremiumTitle?: InputMaybe<SearchableStringFilterInput>;
};

export type ProductionStepV2BlockProductionModalBlock = {
  __typename?: 'ProductionStepV2BlockProductionModalBlock';
  CancelButton?: Maybe<Scalars['String']['output']>;
  CommissionTitle?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  IncomeTitle?: Maybe<Scalars['String']['output']>;
  NewBusinessIncomeLabel?: Maybe<Scalars['String']['output']>;
  OtherCommissionInputCommissionLabel?: Maybe<Scalars['String']['output']>;
  OtherCommissionInputPremiumLabel?: Maybe<Scalars['String']['output']>;
  OtherPoliciesCasesInputLabel?: Maybe<Scalars['String']['output']>;
  PremiumTitle?: Maybe<Scalars['String']['output']>;
  RiskProtectionInputCommissionLabel?: Maybe<Scalars['String']['output']>;
  RiskProtectionInputIncomeLabel?: Maybe<Scalars['String']['output']>;
  RiskProtectionInputPremiumLabel?: Maybe<Scalars['String']['output']>;
  RiskProtectionPoliciesCasesInputLabel?: Maybe<Scalars['String']['output']>;
  SaveButton?: Maybe<Scalars['String']['output']>;
  SharedCheckboxLabel?: Maybe<Scalars['String']['output']>;
  SharedTooltip?: Maybe<ProductionStepV2BlockProductionModalBlockTooltipBlock>;
  SubsectionDescription?: Maybe<Scalars['String']['output']>;
  SubsectionHeader?: Maybe<Scalars['String']['output']>;
  SubsectionPostfix?: Maybe<Scalars['String']['output']>;
  TotalIncomeReportedInputLabel?: Maybe<Scalars['String']['output']>;
};


export type ProductionStepV2BlockProductionModalBlockCancelButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockCommissionTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockIncomeTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockNewBusinessIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockOtherCommissionInputCommissionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockOtherCommissionInputPremiumLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockOtherPoliciesCasesInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockPremiumTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockRiskProtectionInputCommissionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockRiskProtectionInputIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockRiskProtectionInputPremiumLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockRiskProtectionPoliciesCasesInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockSaveButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockSharedCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockSubsectionDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockSubsectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockSubsectionPostfixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockTotalIncomeReportedInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ProductionStepV2BlockProductionModalBlockFacet = {
  __typename?: 'ProductionStepV2BlockProductionModalBlockFacet';
  CancelButton?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeTitle?: Maybe<Array<Maybe<StringFacet>>>;
  NewBusinessIncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherCommissionInputCommissionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherCommissionInputPremiumLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OtherPoliciesCasesInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionInputCommissionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionInputIncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionInputPremiumLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionPoliciesCasesInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SaveButton?: Maybe<Array<Maybe<StringFacet>>>;
  SharedCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SharedTooltip?: Maybe<ProductionStepV2BlockProductionModalBlockTooltipBlockFacet>;
  SubsectionDescription?: Maybe<Array<Maybe<StringFacet>>>;
  SubsectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  SubsectionPostfix?: Maybe<Array<Maybe<StringFacet>>>;
  TotalIncomeReportedInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ProductionStepV2BlockProductionModalBlockFacetCancelButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetCommissionTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetIncomeTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetNewBusinessIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetOtherCommissionInputCommissionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetOtherCommissionInputPremiumLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetOtherPoliciesCasesInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetPremiumTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetRiskProtectionInputCommissionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetRiskProtectionInputIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetRiskProtectionInputPremiumLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetRiskProtectionPoliciesCasesInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetSaveButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetSharedCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetSubsectionDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetSubsectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetSubsectionPostfixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockFacetTotalIncomeReportedInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductionStepV2BlockProductionModalBlockOrderByInput = {
  CancelButton?: InputMaybe<OrderBy>;
  CommissionTitle?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  IncomeTitle?: InputMaybe<OrderBy>;
  NewBusinessIncomeLabel?: InputMaybe<OrderBy>;
  OtherCommissionInputCommissionLabel?: InputMaybe<OrderBy>;
  OtherCommissionInputPremiumLabel?: InputMaybe<OrderBy>;
  OtherPoliciesCasesInputLabel?: InputMaybe<OrderBy>;
  PremiumTitle?: InputMaybe<OrderBy>;
  RiskProtectionInputCommissionLabel?: InputMaybe<OrderBy>;
  RiskProtectionInputIncomeLabel?: InputMaybe<OrderBy>;
  RiskProtectionInputPremiumLabel?: InputMaybe<OrderBy>;
  RiskProtectionPoliciesCasesInputLabel?: InputMaybe<OrderBy>;
  SaveButton?: InputMaybe<OrderBy>;
  SharedCheckboxLabel?: InputMaybe<OrderBy>;
  SharedTooltip?: InputMaybe<ProductionStepV2BlockProductionModalBlockTooltipBlockOrderByInput>;
  SubsectionDescription?: InputMaybe<OrderBy>;
  SubsectionHeader?: InputMaybe<OrderBy>;
  SubsectionPostfix?: InputMaybe<OrderBy>;
  TotalIncomeReportedInputLabel?: InputMaybe<OrderBy>;
};

export type ProductionStepV2BlockProductionModalBlockTooltipBlock = {
  __typename?: 'ProductionStepV2BlockProductionModalBlockTooltipBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type ProductionStepV2BlockProductionModalBlockTooltipBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionModalBlockTooltipBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ProductionStepV2BlockProductionModalBlockTooltipBlockFacet = {
  __typename?: 'ProductionStepV2BlockProductionModalBlockTooltipBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ProductionStepV2BlockProductionModalBlockTooltipBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionModalBlockTooltipBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductionStepV2BlockProductionModalBlockTooltipBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type ProductionStepV2BlockProductionModalBlockTooltipBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type ProductionStepV2BlockProductionModalBlockWhereInput = {
  CancelButton?: InputMaybe<SearchableStringFilterInput>;
  CommissionTitle?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  IncomeTitle?: InputMaybe<SearchableStringFilterInput>;
  NewBusinessIncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherCommissionInputCommissionLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherCommissionInputPremiumLabel?: InputMaybe<SearchableStringFilterInput>;
  OtherPoliciesCasesInputLabel?: InputMaybe<SearchableStringFilterInput>;
  PremiumTitle?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionInputCommissionLabel?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionInputIncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionInputPremiumLabel?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionPoliciesCasesInputLabel?: InputMaybe<SearchableStringFilterInput>;
  SaveButton?: InputMaybe<SearchableStringFilterInput>;
  SharedCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  SharedTooltip?: InputMaybe<ProductionStepV2BlockProductionModalBlockTooltipBlockWhereInput>;
  SubsectionDescription?: InputMaybe<SearchableStringFilterInput>;
  SubsectionHeader?: InputMaybe<SearchableStringFilterInput>;
  SubsectionPostfix?: InputMaybe<SearchableStringFilterInput>;
  TotalIncomeReportedInputLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type ProductionStepV2BlockProductionTableBlock = {
  __typename?: 'ProductionStepV2BlockProductionTableBlock';
  AddButtonText?: Maybe<Scalars['String']['output']>;
  AddMoreButtonText?: Maybe<Scalars['String']['output']>;
  ColumnExplanationText?: Maybe<Scalars['String']['output']>;
  HigherThenExpectedWarning?: Maybe<Scalars['String']['output']>;
  OtherNewBusinessColumn?: Maybe<Scalars['String']['output']>;
  RiskProtectionColumn?: Maybe<Scalars['String']['output']>;
  SharedColumn?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TotalCalculationText?: Maybe<Scalars['String']['output']>;
  TotalColumn?: Maybe<Scalars['String']['output']>;
};


export type ProductionStepV2BlockProductionTableBlockAddButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionTableBlockAddMoreButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionTableBlockColumnExplanationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionTableBlockHigherThenExpectedWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionTableBlockOtherNewBusinessColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionTableBlockRiskProtectionColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionTableBlockSharedColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionTableBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionTableBlockTotalCalculationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockProductionTableBlockTotalColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ProductionStepV2BlockProductionTableBlockFacet = {
  __typename?: 'ProductionStepV2BlockProductionTableBlockFacet';
  AddButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  AddMoreButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ColumnExplanationText?: Maybe<Array<Maybe<StringFacet>>>;
  HigherThenExpectedWarning?: Maybe<Array<Maybe<StringFacet>>>;
  OtherNewBusinessColumn?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionColumn?: Maybe<Array<Maybe<StringFacet>>>;
  SharedColumn?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TotalCalculationText?: Maybe<Array<Maybe<StringFacet>>>;
  TotalColumn?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ProductionStepV2BlockProductionTableBlockFacetAddButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionTableBlockFacetAddMoreButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionTableBlockFacetColumnExplanationTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionTableBlockFacetHigherThenExpectedWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionTableBlockFacetOtherNewBusinessColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionTableBlockFacetRiskProtectionColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionTableBlockFacetSharedColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionTableBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionTableBlockFacetTotalCalculationTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockProductionTableBlockFacetTotalColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductionStepV2BlockProductionTableBlockOrderByInput = {
  AddButtonText?: InputMaybe<OrderBy>;
  AddMoreButtonText?: InputMaybe<OrderBy>;
  ColumnExplanationText?: InputMaybe<OrderBy>;
  HigherThenExpectedWarning?: InputMaybe<OrderBy>;
  OtherNewBusinessColumn?: InputMaybe<OrderBy>;
  RiskProtectionColumn?: InputMaybe<OrderBy>;
  SharedColumn?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TotalCalculationText?: InputMaybe<OrderBy>;
  TotalColumn?: InputMaybe<OrderBy>;
};

export type ProductionStepV2BlockProductionTableBlockWhereInput = {
  AddButtonText?: InputMaybe<SearchableStringFilterInput>;
  AddMoreButtonText?: InputMaybe<SearchableStringFilterInput>;
  ColumnExplanationText?: InputMaybe<SearchableStringFilterInput>;
  HigherThenExpectedWarning?: InputMaybe<SearchableStringFilterInput>;
  OtherNewBusinessColumn?: InputMaybe<SearchableStringFilterInput>;
  RiskProtectionColumn?: InputMaybe<SearchableStringFilterInput>;
  SharedColumn?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TotalCalculationText?: InputMaybe<SearchableStringFilterInput>;
  TotalColumn?: InputMaybe<SearchableStringFilterInput>;
};

export type ProductionStepV2BlockSelfAttestLevelOptionsBlock = {
  __typename?: 'ProductionStepV2BlockSelfAttestLevelOptionsBlock';
  SelfAttestCommissionSubheading?: Maybe<Scalars['String']['output']>;
  SelfAttestIncomeSubheading?: Maybe<Scalars['String']['output']>;
  SelfAttestLevelTitle1?: Maybe<Scalars['String']['output']>;
  SelfAttestLevelTitle2?: Maybe<Scalars['String']['output']>;
  SelfAttestLevelTitle3?: Maybe<Scalars['String']['output']>;
  SelfAttestPremiumSubheading?: Maybe<Scalars['String']['output']>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestCommissionSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestIncomeSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestLevelTitle1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestLevelTitle2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestLevelTitle3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockSelfAttestPremiumSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ProductionStepV2BlockSelfAttestLevelOptionsBlockFacet = {
  __typename?: 'ProductionStepV2BlockSelfAttestLevelOptionsBlockFacet';
  SelfAttestCommissionSubheading?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestIncomeSubheading?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestLevelTitle1?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestLevelTitle2?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestLevelTitle3?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestPremiumSubheading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestCommissionSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestIncomeSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestLevelTitle1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestLevelTitle2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestLevelTitle3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionStepV2BlockSelfAttestLevelOptionsBlockFacetSelfAttestPremiumSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProductionStepV2BlockSelfAttestLevelOptionsBlockOrderByInput = {
  SelfAttestCommissionSubheading?: InputMaybe<OrderBy>;
  SelfAttestIncomeSubheading?: InputMaybe<OrderBy>;
  SelfAttestLevelTitle1?: InputMaybe<OrderBy>;
  SelfAttestLevelTitle2?: InputMaybe<OrderBy>;
  SelfAttestLevelTitle3?: InputMaybe<OrderBy>;
  SelfAttestPremiumSubheading?: InputMaybe<OrderBy>;
};

export type ProductionStepV2BlockSelfAttestLevelOptionsBlockWhereInput = {
  SelfAttestCommissionSubheading?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestIncomeSubheading?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestLevelTitle1?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestLevelTitle2?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestLevelTitle3?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestPremiumSubheading?: InputMaybe<SearchableStringFilterInput>;
};

export type ProductionStepV2BlockWhereInput = {
  AddProductionModal?: InputMaybe<ProductionStepV2BlockProductionModalBlockWhereInput>;
  AddProductionNumbersRadioLabels?: InputMaybe<SearchableStringFilterInput>;
  AddedByText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AttestProductionNumbersRadioLabels?: InputMaybe<SearchableStringFilterInput>;
  AttestViewMoreLabel?: InputMaybe<SearchableStringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  COTProductionNumberTexts?: InputMaybe<ProductionStepV2BlockProductionAttestmentNumbersBlockWhereInput>;
  COTQualifyingMessageText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  CertificationLetterFileTooLargeError?: InputMaybe<SearchableStringFilterInput>;
  CertifyinLettersTitle?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersDescription?: InputMaybe<SearchableStringFilterInput>;
  CertifyingLettersUploadButtonText?: InputMaybe<SearchableStringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CommissionTable?: InputMaybe<ProductionStepV2BlockProductionTableBlockWhereInput>;
  CompanyAddedProduction?: InputMaybe<SearchableStringFilterInput>;
  CompanyText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DeleteCertifyingLetterModal?: InputMaybe<ProductionStepV2BlockDeleteCertifyinLetterModalBlockWhereInput>;
  DeleteProductionModal?: InputMaybe<ProductionStepV2BlockProductionDeleteModalBlockWhereInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DescriptionQualifyingAndLife?: InputMaybe<SearchableStringFilterInput>;
  EditProductionModal?: InputMaybe<ProductionStepV2BlockProductionModalBlockWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FieldRequiredError?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncomeTable?: InputMaybe<ProductionStepV2BlockProductionTableBlockWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MDRTProductionNumberTexts?: InputMaybe<ProductionStepV2BlockProductionAttestmentNumbersBlockWhereInput>;
  MDRTQualifyingMessageText?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipLevelSelectionText?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NoCertificationLettersError?: InputMaybe<SearchableStringFilterInput>;
  NotEnoughMonetaryProductionError?: InputMaybe<SearchableStringFilterInput>;
  NotEnoughNewBusinessByCountryError?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PolicyMultipleText?: InputMaybe<SearchableStringFilterInput>;
  PolicySingleText?: InputMaybe<SearchableStringFilterInput>;
  PremiumTable?: InputMaybe<ProductionStepV2BlockProductionTableBlockWhereInput>;
  ProductionNumbersFormDescription?: InputMaybe<SearchableStringFilterInput>;
  ProductionNumbersNotSelectedError?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelfAttestLevelOptions?: InputMaybe<ProductionStepV2BlockSelfAttestLevelOptionsBlockWhereInput>;
  SelfAttestationFormDescription?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TOTProductionNumberTexts?: InputMaybe<ProductionStepV2BlockProductionAttestmentNumbersBlockWhereInput>;
  TOTQualifyingMessageText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  YouCanAddMoreProdcution?: InputMaybe<SearchableStringFilterInput>;
  YouCannotAttestToAHigherLevelWarning?: InputMaybe<SearchableStringFilterInput>;
  YouText?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProductionStepV2BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProductionStepV2BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProductionStepV2BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ProductionTableBlock = IContent & IData & {
  __typename?: 'ProductionTableBlock';
  AddButtonText?: Maybe<Scalars['String']['output']>;
  AddMoreButtonText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ColumnExplanationText?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HigherThenExpectedWarning?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  OtherNewBusinessColumn?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RiskProtectionColumn?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SharedColumn?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TotalCalculationText?: Maybe<Scalars['String']['output']>;
  TotalColumn?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ProductionTableBlockAddButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlockAddMoreButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlockColumnExplanationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlockHigherThenExpectedWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlockOtherNewBusinessColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlockRiskProtectionColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlockSharedColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlockTotalCalculationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlockTotalColumnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProductionTableBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProductionTableBlockAutocomplete = {
  __typename?: 'ProductionTableBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProductionTableBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionTableBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionTableBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionTableBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionTableBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionTableBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionTableBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionTableBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionTableBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProductionTableBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductionTableBlockFacet = {
  __typename?: 'ProductionTableBlockFacet';
  AddButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  AddMoreButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ColumnExplanationText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HigherThenExpectedWarning?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  OtherNewBusinessColumn?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RiskProtectionColumn?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SharedColumn?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TotalCalculationText?: Maybe<Array<Maybe<StringFacet>>>;
  TotalColumn?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProductionTableBlockFacetAddButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetAddMoreButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionTableBlockFacetColumnExplanationTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionTableBlockFacetHigherThenExpectedWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetOtherNewBusinessColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetRiskProtectionColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionTableBlockFacetSharedColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionTableBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductionTableBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetTotalCalculationTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetTotalColumnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProductionTableBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProductionTableBlockOrderByInput = {
  AddButtonText?: InputMaybe<OrderBy>;
  AddMoreButtonText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ColumnExplanationText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HigherThenExpectedWarning?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  OtherNewBusinessColumn?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RiskProtectionColumn?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SharedColumn?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TotalCalculationText?: InputMaybe<OrderBy>;
  TotalColumn?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProductionTableBlockOutput = {
  __typename?: 'ProductionTableBlockOutput';
  autocomplete?: Maybe<ProductionTableBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProductionTableBlockFacet>;
  item?: Maybe<ProductionTableBlock>;
  items?: Maybe<Array<Maybe<ProductionTableBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProductionTableBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductionTableBlockWhereInput = {
  AddButtonText?: InputMaybe<SearchableStringFilterInput>;
  AddMoreButtonText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ColumnExplanationText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HigherThenExpectedWarning?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  OtherNewBusinessColumn?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RiskProtectionColumn?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SharedColumn?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TotalCalculationText?: InputMaybe<SearchableStringFilterInput>;
  TotalColumn?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProductionTableBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProductionTableBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProductionTableBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A block used to render a person profile with heading */
export type ProfileListBlock = IContent & IData & {
  __typename?: 'ProfileListBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Preheading?: Maybe<Scalars['String']['output']>;
  ProfileList?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block used to render a person profile with heading */
export type ProfileListBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a person profile with heading */
export type ProfileListBlockPreheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a person profile with heading */
export type ProfileListBlockProfileListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a person profile with heading */
export type ProfileListBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block used to render a person profile with heading */
export type ProfileListBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProfileListBlockAutocomplete = {
  __typename?: 'ProfileListBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProfileListBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileListBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileListBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileListBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileListBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileListBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileListBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileListBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileListBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileListBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfileListBlockFacet = {
  __typename?: 'ProfileListBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Preheading?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileList?: Maybe<ContentAreaItemModelSearchFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProfileListBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileListBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileListBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ProfileListBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacetPreheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileListBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileListBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileListBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileListBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProfileListBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Preheading?: InputMaybe<OrderBy>;
  ProfileList?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProfileListBlockOutput = {
  __typename?: 'ProfileListBlockOutput';
  autocomplete?: Maybe<ProfileListBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProfileListBlockFacet>;
  item?: Maybe<ProfileListBlock>;
  items?: Maybe<Array<Maybe<ProfileListBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProfileListBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileListBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Preheading?: InputMaybe<SearchableStringFilterInput>;
  ProfileList?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProfileListBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProfileListBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProfileListBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ProfilePictureBlock = IContent & IData & {
  __typename?: 'ProfilePictureBlock';
  Add?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Change?: Maybe<Scalars['String']['output']>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Edit?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSizeError?: Maybe<Scalars['String']['output']>;
  FileSizeHint?: Maybe<Scalars['String']['output']>;
  FileTypeError?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  ModalDescription?: Maybe<Scalars['String']['output']>;
  ModalTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PictureDescription?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  Remove?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Save?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  ServerFileError?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Upload?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ProfilePictureBlockAddArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockChangeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockEditArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockFileSizeErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockFileSizeHintArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockFileTypeErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockModalTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockPictureDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockRemoveArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockSaveArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockServerFileErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlockUploadArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfilePictureBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProfilePictureBlockAutocomplete = {
  __typename?: 'ProfilePictureBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProfilePictureBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfilePictureBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfilePictureBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfilePictureBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfilePictureBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfilePictureBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfilePictureBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfilePictureBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfilePictureBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfilePictureBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfilePictureBlockFacet = {
  __typename?: 'ProfilePictureBlockFacet';
  Add?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Change?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Edit?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSizeError?: Maybe<Array<Maybe<StringFacet>>>;
  FileSizeHint?: Maybe<Array<Maybe<StringFacet>>>;
  FileTypeError?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  ModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ModalTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PictureDescription?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  Remove?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Save?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ServerFileError?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Upload?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProfilePictureBlockFacetAddArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetChangeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfilePictureBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfilePictureBlockFacetEditArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetFileSizeErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetFileSizeHintArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetFileTypeErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ProfilePictureBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetModalTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetPictureDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetRemoveArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetSaveArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfilePictureBlockFacetServerFileErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfilePictureBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfilePictureBlockFacetUploadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfilePictureBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProfilePictureBlockOrderByInput = {
  Add?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Change?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Edit?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSizeError?: InputMaybe<OrderBy>;
  FileSizeHint?: InputMaybe<OrderBy>;
  FileTypeError?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  ModalDescription?: InputMaybe<OrderBy>;
  ModalTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PictureDescription?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  Remove?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Save?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ServerFileError?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Upload?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProfilePictureBlockOutput = {
  __typename?: 'ProfilePictureBlockOutput';
  autocomplete?: Maybe<ProfilePictureBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProfilePictureBlockFacet>;
  item?: Maybe<ProfilePictureBlock>;
  items?: Maybe<Array<Maybe<ProfilePictureBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProfilePictureBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfilePictureBlockWhereInput = {
  Add?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Change?: InputMaybe<SearchableStringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Edit?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSizeError?: InputMaybe<SearchableStringFilterInput>;
  FileSizeHint?: InputMaybe<SearchableStringFilterInput>;
  FileTypeError?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  ModalDescription?: InputMaybe<SearchableStringFilterInput>;
  ModalTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PictureDescription?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  Remove?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Save?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ServerFileError?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Upload?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProfilePictureBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProfilePictureBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProfilePictureBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds profile data for the Account Profile page */
export type ProfileSectionBlock = IContent & IData & {
  __typename?: 'ProfileSectionBlock';
  AddLocalAddress?: Maybe<Scalars['String']['output']>;
  AddressFormatError?: Maybe<Scalars['String']['output']>;
  AddressLine1?: Maybe<Scalars['String']['output']>;
  AddressLine2?: Maybe<Scalars['String']['output']>;
  AddressLine3?: Maybe<Scalars['String']['output']>;
  AgencyCompany?: Maybe<Scalars['String']['output']>;
  AgentID?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AreaCode?: Maybe<Scalars['String']['output']>;
  BrokerCompany?: Maybe<Scalars['String']['output']>;
  BusinessInformationHeading?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  Company?: Maybe<Scalars['String']['output']>;
  ContactInformationHeading?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CountryMarket?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  EmailAddress?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FullName?: Maybe<Scalars['String']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  ISOCode?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastName?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddress?: Maybe<Scalars['String']['output']>;
  LocalLanguageHelpText?: Maybe<Scalars['String']['output']>;
  LocalMailingAddress?: Maybe<Scalars['String']['output']>;
  MailingAddress?: Maybe<Scalars['String']['output']>;
  MailingAddressHelperText?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonalCompany?: Maybe<Scalars['String']['output']>;
  PersonalInformationHeading?: Maybe<Scalars['String']['output']>;
  PhoneNumber?: Maybe<Scalars['String']['output']>;
  PhoneType?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  PreferredName?: Maybe<Scalars['String']['output']>;
  ProfessionalDesignation?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RemoveLocalAddressHelperText?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Salutation?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Suffix?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WeChatID?: Maybe<Scalars['String']['output']>;
  YearOfBirth?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockAddLocalAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockAddressFormatErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockAddressLine1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockAddressLine2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockAddressLine3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockAgencyCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockAreaCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockBrokerCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockBusinessInformationHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockCityArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockContactInformationHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockCountryMarketArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockEmailAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockFirstNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockFullNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockGenderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockIsoCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockJobTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockLastNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockLocalLanguageAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockLocalLanguageHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockLocalMailingAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockMailingAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockMailingAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockPersonalCompanyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockPersonalInformationHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockPhoneTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockPostalCodeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockPreferredNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockProfessionalDesignationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockRemoveLocalAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockSalutationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockStateArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockSuffixArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockWeChatIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlockYearOfBirthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds profile data for the Account Profile page */
export type ProfileSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProfileSectionBlockAutocomplete = {
  __typename?: 'ProfileSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProfileSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfileSectionBlockFacet = {
  __typename?: 'ProfileSectionBlockFacet';
  AddLocalAddress?: Maybe<Array<Maybe<StringFacet>>>;
  AddressFormatError?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine2?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine3?: Maybe<Array<Maybe<StringFacet>>>;
  AgencyCompany?: Maybe<Array<Maybe<StringFacet>>>;
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AreaCode?: Maybe<Array<Maybe<StringFacet>>>;
  BrokerCompany?: Maybe<Array<Maybe<StringFacet>>>;
  BusinessInformationHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  City?: Maybe<Array<Maybe<StringFacet>>>;
  Company?: Maybe<Array<Maybe<StringFacet>>>;
  ContactInformationHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CountryMarket?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EmailAddress?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstName?: Maybe<Array<Maybe<StringFacet>>>;
  FullName?: Maybe<Array<Maybe<StringFacet>>>;
  Gender?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  ISOCode?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  JobTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastName?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddress?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageHelpText?: Maybe<Array<Maybe<StringFacet>>>;
  LocalMailingAddress?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddress?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonalCompany?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalInformationHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneType?: Maybe<Array<Maybe<StringFacet>>>;
  PostalCode?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredName?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalDesignation?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveLocalAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Salutation?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  State?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Suffix?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WeChatID?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfBirth?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProfileSectionBlockFacetAddLocalAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetAddressFormatErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetAddressLine1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetAddressLine2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetAddressLine3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetAgencyCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetAreaCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetBrokerCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetBusinessInformationHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileSectionBlockFacetCityArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetContactInformationHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetCountryMarketArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileSectionBlockFacetEmailAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetFirstNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetFullNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetGenderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetIsoCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ProfileSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetJobTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetLastNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetLocalLanguageAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetLocalLanguageHelpTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetLocalMailingAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetMailingAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetMailingAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetPersonalCompanyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetPersonalInformationHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetPhoneTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetPostalCodeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetPreferredNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetProfessionalDesignationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetRemoveLocalAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetSalutationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileSectionBlockFacetStateArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileSectionBlockFacetSuffixArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetWeChatIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacetYearOfBirthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProfileSectionBlockOrderByInput = {
  AddLocalAddress?: InputMaybe<OrderBy>;
  AddressFormatError?: InputMaybe<OrderBy>;
  AddressLine1?: InputMaybe<OrderBy>;
  AddressLine2?: InputMaybe<OrderBy>;
  AddressLine3?: InputMaybe<OrderBy>;
  AgencyCompany?: InputMaybe<OrderBy>;
  AgentID?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AreaCode?: InputMaybe<OrderBy>;
  BrokerCompany?: InputMaybe<OrderBy>;
  BusinessInformationHeading?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  City?: InputMaybe<OrderBy>;
  Company?: InputMaybe<OrderBy>;
  ContactInformationHeading?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CountryMarket?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EmailAddress?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstName?: InputMaybe<OrderBy>;
  FullName?: InputMaybe<OrderBy>;
  Gender?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  ISOCode?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  JobTitle?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastName?: InputMaybe<OrderBy>;
  LocalLanguageAddress?: InputMaybe<OrderBy>;
  LocalLanguageHelpText?: InputMaybe<OrderBy>;
  LocalMailingAddress?: InputMaybe<OrderBy>;
  MailingAddress?: InputMaybe<OrderBy>;
  MailingAddressHelperText?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonalCompany?: InputMaybe<OrderBy>;
  PersonalInformationHeading?: InputMaybe<OrderBy>;
  PhoneNumber?: InputMaybe<OrderBy>;
  PhoneType?: InputMaybe<OrderBy>;
  PostalCode?: InputMaybe<OrderBy>;
  PreferredName?: InputMaybe<OrderBy>;
  ProfessionalDesignation?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RemoveLocalAddressHelperText?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Salutation?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  State?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Suffix?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WeChatID?: InputMaybe<OrderBy>;
  YearOfBirth?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProfileSectionBlockOutput = {
  __typename?: 'ProfileSectionBlockOutput';
  autocomplete?: Maybe<ProfileSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProfileSectionBlockFacet>;
  item?: Maybe<ProfileSectionBlock>;
  items?: Maybe<Array<Maybe<ProfileSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProfileSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileSectionBlockWhereInput = {
  AddLocalAddress?: InputMaybe<SearchableStringFilterInput>;
  AddressFormatError?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1?: InputMaybe<SearchableStringFilterInput>;
  AddressLine2?: InputMaybe<SearchableStringFilterInput>;
  AddressLine3?: InputMaybe<SearchableStringFilterInput>;
  AgencyCompany?: InputMaybe<SearchableStringFilterInput>;
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AreaCode?: InputMaybe<SearchableStringFilterInput>;
  BrokerCompany?: InputMaybe<SearchableStringFilterInput>;
  BusinessInformationHeading?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  City?: InputMaybe<SearchableStringFilterInput>;
  Company?: InputMaybe<SearchableStringFilterInput>;
  ContactInformationHeading?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CountryMarket?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EmailAddress?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstName?: InputMaybe<SearchableStringFilterInput>;
  FullName?: InputMaybe<SearchableStringFilterInput>;
  Gender?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  ISOCode?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  JobTitle?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastName?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddress?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageHelpText?: InputMaybe<SearchableStringFilterInput>;
  LocalMailingAddress?: InputMaybe<SearchableStringFilterInput>;
  MailingAddress?: InputMaybe<SearchableStringFilterInput>;
  MailingAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonalCompany?: InputMaybe<SearchableStringFilterInput>;
  PersonalInformationHeading?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  PhoneType?: InputMaybe<SearchableStringFilterInput>;
  PostalCode?: InputMaybe<SearchableStringFilterInput>;
  PreferredName?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalDesignation?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RemoveLocalAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Salutation?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  State?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Suffix?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WeChatID?: InputMaybe<SearchableStringFilterInput>;
  YearOfBirth?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProfileSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProfileSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProfileSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type ProfileStepBlock = IContent & IData & {
  __typename?: 'ProfileStepBlock';
  AddLocalAddressHelperText?: Maybe<Scalars['String']['output']>;
  AddLocalAddressLabel?: Maybe<Scalars['String']['output']>;
  AddressLine1FormatLabel?: Maybe<Scalars['String']['output']>;
  AddressLine1Label?: Maybe<Scalars['String']['output']>;
  AddressLine2Label?: Maybe<Scalars['String']['output']>;
  AddressLine3Label?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CityLabel?: Maybe<Scalars['String']['output']>;
  CompanyAffiliationLabel?: Maybe<Scalars['String']['output']>;
  ContactInfoLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CountryLabel?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DateOfBirthFormatLabel?: Maybe<Scalars['String']['output']>;
  DateOfBirthLabel?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EmailDirectoryPermissionText?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  GenderLabel?: Maybe<Scalars['String']['output']>;
  GeneralErrorText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  IsoCodeLabel?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LocalAddressHeadingText?: Maybe<Scalars['String']['output']>;
  MailingAddressLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MemberDirectoryPermissionText?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonalInfoLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberFormatLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PhoneTypeLabel?: Maybe<Scalars['String']['output']>;
  PrimaryLanguageLabel?: Maybe<Scalars['String']['output']>;
  ProfessionalInfoLabel?: Maybe<Scalars['String']['output']>;
  ProfileNavHeadingText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RemoveLocalAddressHelperText?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SmsPermissionText?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  StateLabel?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ZipCodeLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockAddLocalAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockAddLocalAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockAddressLine1FormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockAddressLine1LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockAddressLine2LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockAddressLine3LabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockCityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockCompanyAffiliationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockContactInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockDateOfBirthFormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockDateOfBirthLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockEmailDirectoryPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockGenderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockGeneralErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockIsoCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockLocalAddressHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockMailingAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockMemberDirectoryPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockPersonalInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockPhoneNumberFormatLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockPhoneTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockPrimaryLanguageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockProfessionalInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockProfileNavHeadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockRemoveLocalAddressHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockSmsPermissionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockStateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlockZipCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ProfileStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProfileStepBlockAutocomplete = {
  __typename?: 'ProfileStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProfileStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfileStepBlockFacet = {
  __typename?: 'ProfileStepBlockFacet';
  AddLocalAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  AddLocalAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1FormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine1Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine2Label?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLine3Label?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyAffiliationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContactInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DateOfBirthFormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DateOfBirthLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  EmailDirectoryPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GenderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GeneralErrorText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsoCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LocalAddressHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MemberDirectoryPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonalInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberFormatLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryLanguageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileNavHeadingText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveLocalAddressHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SmsPermissionText?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ZipCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProfileStepBlockFacetAddLocalAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetAddLocalAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetAddressLine1FormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetAddressLine1LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetAddressLine2LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetAddressLine3LabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileStepBlockFacetCityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetCompanyAffiliationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetContactInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileStepBlockFacetDateOfBirthFormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetDateOfBirthLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetEmailDirectoryPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetGenderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetGeneralErrorTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetIsoCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetLocalAddressHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetMailingAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetMemberDirectoryPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetPersonalInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetPhoneNumberFormatLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetPhoneTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetPrimaryLanguageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetProfessionalInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetProfileNavHeadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetRemoveLocalAddressHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetSmsPermissionTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileStepBlockFacetStateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacetZipCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProfileStepBlockOrderByInput = {
  AddLocalAddressHelperText?: InputMaybe<OrderBy>;
  AddLocalAddressLabel?: InputMaybe<OrderBy>;
  AddressLine1FormatLabel?: InputMaybe<OrderBy>;
  AddressLine1Label?: InputMaybe<OrderBy>;
  AddressLine2Label?: InputMaybe<OrderBy>;
  AddressLine3Label?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CityLabel?: InputMaybe<OrderBy>;
  CompanyAffiliationLabel?: InputMaybe<OrderBy>;
  ContactInfoLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CountryLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DateOfBirthFormatLabel?: InputMaybe<OrderBy>;
  DateOfBirthLabel?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  EmailDirectoryPermissionText?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GenderLabel?: InputMaybe<OrderBy>;
  GeneralErrorText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsoCodeLabel?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LocalAddressHeadingText?: InputMaybe<OrderBy>;
  MailingAddressLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MemberDirectoryPermissionText?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonalInfoLabel?: InputMaybe<OrderBy>;
  PhoneNumberFormatLabel?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PhoneTypeLabel?: InputMaybe<OrderBy>;
  PrimaryLanguageLabel?: InputMaybe<OrderBy>;
  ProfessionalInfoLabel?: InputMaybe<OrderBy>;
  ProfileNavHeadingText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RemoveLocalAddressHelperText?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SmsPermissionText?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  StateLabel?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ZipCodeLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProfileStepBlockOutput = {
  __typename?: 'ProfileStepBlockOutput';
  autocomplete?: Maybe<ProfileStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProfileStepBlockFacet>;
  item?: Maybe<ProfileStepBlock>;
  items?: Maybe<Array<Maybe<ProfileStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProfileStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileStepBlockWhereInput = {
  AddLocalAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  AddLocalAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1FormatLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLine1Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine2Label?: InputMaybe<SearchableStringFilterInput>;
  AddressLine3Label?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CityLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyAffiliationLabel?: InputMaybe<SearchableStringFilterInput>;
  ContactInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CountryLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DateOfBirthFormatLabel?: InputMaybe<SearchableStringFilterInput>;
  DateOfBirthLabel?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  EmailDirectoryPermissionText?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GenderLabel?: InputMaybe<SearchableStringFilterInput>;
  GeneralErrorText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsoCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LocalAddressHeadingText?: InputMaybe<SearchableStringFilterInput>;
  MailingAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MemberDirectoryPermissionText?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonalInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberFormatLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  PrimaryLanguageLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfileNavHeadingText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RemoveLocalAddressHelperText?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SmsPermissionText?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  StateLabel?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ZipCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProfileStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProfileStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProfileStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2Block = IContent & IData & {
  __typename?: 'ProfileStepV2Block';
  AddLocalLanguageAddressCheckboxLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AreaCodeInputLabel?: Maybe<Scalars['String']['output']>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyAffiliationInputLabel?: Maybe<Scalars['String']['output']>;
  ContactInformationHeader?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CountryOrMarketInputLabel?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignationsLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstNameLabel?: Maybe<Scalars['String']['output']>;
  GenderInputLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncorrectDateOfBirthErrorMessage?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  IsoCodeInputLabel?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastNameLabel?: Maybe<Scalars['String']['output']>;
  LatinAlphabetWarning?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddressHeader?: Maybe<Scalars['String']['output']>;
  LocalLanguageAddressLabels?: Maybe<ProfileStepV2BlockAddressInfoBlock>;
  MDRTEmailContactCheckboxLabel?: Maybe<Scalars['String']['output']>;
  MDRTMemberDirectoryCheckboxLabel?: Maybe<Scalars['String']['output']>;
  MDRTSmsContactCheckboxLabel?: Maybe<Scalars['String']['output']>;
  MailingAddressHeader?: Maybe<Scalars['String']['output']>;
  MailingAddressLabels?: Maybe<ProfileStepV2BlockAddressInfoBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MiddleNameLabel?: Maybe<Scalars['String']['output']>;
  MissingInformationInfoBox?: Maybe<ProfileStepV2BlockInfoBoxBlock>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  NicknameLabel?: Maybe<Scalars['String']['output']>;
  OptionalHeaderLabelTag?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonalInformationHeader?: Maybe<Scalars['String']['output']>;
  PhoneNumberInputLabel?: Maybe<Scalars['String']['output']>;
  PhoneTypeInputLabel?: Maybe<Scalars['String']['output']>;
  PrefixLabel?: Maybe<Scalars['String']['output']>;
  PrimaryLanguageInputLabel?: Maybe<Scalars['String']['output']>;
  ProfessionalInformationHeader?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SuffixLabel?: Maybe<Scalars['String']['output']>;
  UpdateInformationInfoBox?: Maybe<ProfileStepV2BlockInfoBoxBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  YearOfBirthInputLabel?: Maybe<Scalars['String']['output']>;
  YearOfFirstLicenseLabel?: Maybe<Scalars['String']['output']>;
  YearOfFirstLicenseValidationLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockAddLocalLanguageAddressCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockAreaCodeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockCompanyAffiliationInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockContactInformationHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockCountryOrMarketInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockDesignationsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockFirstNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockGenderInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockIncorrectDateOfBirthErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockIsoCodeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockLastNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockLatinAlphabetWarningArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockLocalLanguageAddressHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockMdrtEmailContactCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockMdrtMemberDirectoryCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockMdrtSmsContactCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockMailingAddressHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockMiddleNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockNicknameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockOptionalHeaderLabelTagArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockPersonalInformationHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockPhoneNumberInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockPhoneTypeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockPrefixLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockPrimaryLanguageInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockProfessionalInformationHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockSuffixLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockYearOfBirthInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockYearOfFirstLicenseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2BlockYearOfFirstLicenseValidationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ProfileStepV2Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ProfileStepV2BlockAddressInfoBlock = {
  __typename?: 'ProfileStepV2BlockAddressInfoBlock';
  AddressLineOneInputLabel?: Maybe<Scalars['String']['output']>;
  AddressLineThreeInputLabel?: Maybe<Scalars['String']['output']>;
  AddressLineTwoInputLabel?: Maybe<Scalars['String']['output']>;
  CityOrTownInputLabel?: Maybe<Scalars['String']['output']>;
  CountryOrMarketInputLabel?: Maybe<Scalars['String']['output']>;
  StateOrProvinceInputLabel?: Maybe<Scalars['String']['output']>;
  ZipCodeInputLabel?: Maybe<Scalars['String']['output']>;
};


export type ProfileStepV2BlockAddressInfoBlockAddressLineOneInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfileStepV2BlockAddressInfoBlockAddressLineThreeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfileStepV2BlockAddressInfoBlockAddressLineTwoInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfileStepV2BlockAddressInfoBlockCityOrTownInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfileStepV2BlockAddressInfoBlockCountryOrMarketInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfileStepV2BlockAddressInfoBlockStateOrProvinceInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfileStepV2BlockAddressInfoBlockZipCodeInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ProfileStepV2BlockAddressInfoBlockFacet = {
  __typename?: 'ProfileStepV2BlockAddressInfoBlockFacet';
  AddressLineOneInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLineThreeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddressLineTwoInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CityOrTownInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CountryOrMarketInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StateOrProvinceInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ZipCodeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ProfileStepV2BlockAddressInfoBlockFacetAddressLineOneInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockAddressInfoBlockFacetAddressLineThreeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockAddressInfoBlockFacetAddressLineTwoInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockAddressInfoBlockFacetCityOrTownInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockAddressInfoBlockFacetCountryOrMarketInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockAddressInfoBlockFacetStateOrProvinceInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockAddressInfoBlockFacetZipCodeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfileStepV2BlockAddressInfoBlockOrderByInput = {
  AddressLineOneInputLabel?: InputMaybe<OrderBy>;
  AddressLineThreeInputLabel?: InputMaybe<OrderBy>;
  AddressLineTwoInputLabel?: InputMaybe<OrderBy>;
  CityOrTownInputLabel?: InputMaybe<OrderBy>;
  CountryOrMarketInputLabel?: InputMaybe<OrderBy>;
  StateOrProvinceInputLabel?: InputMaybe<OrderBy>;
  ZipCodeInputLabel?: InputMaybe<OrderBy>;
};

export type ProfileStepV2BlockAddressInfoBlockWhereInput = {
  AddressLineOneInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLineThreeInputLabel?: InputMaybe<SearchableStringFilterInput>;
  AddressLineTwoInputLabel?: InputMaybe<SearchableStringFilterInput>;
  CityOrTownInputLabel?: InputMaybe<SearchableStringFilterInput>;
  CountryOrMarketInputLabel?: InputMaybe<SearchableStringFilterInput>;
  StateOrProvinceInputLabel?: InputMaybe<SearchableStringFilterInput>;
  ZipCodeInputLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type ProfileStepV2BlockAutocomplete = {
  __typename?: 'ProfileStepV2BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ProfileStepV2BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepV2BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepV2BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepV2BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepV2BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepV2BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepV2BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepV2BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepV2BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ProfileStepV2BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProfileStepV2BlockFacet = {
  __typename?: 'ProfileStepV2BlockFacet';
  AddLocalLanguageAddressCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AreaCodeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyAffiliationInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContactInformationHeader?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CountryOrMarketInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DesignationsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GenderInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncorrectDateOfBirthErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsoCodeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LatinAlphabetWarning?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddressHeader?: Maybe<Array<Maybe<StringFacet>>>;
  LocalLanguageAddressLabels?: Maybe<ProfileStepV2BlockAddressInfoBlockFacet>;
  MDRTEmailContactCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTMemberDirectoryCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTSmsContactCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddressHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MailingAddressLabels?: Maybe<ProfileStepV2BlockAddressInfoBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MiddleNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MissingInformationInfoBox?: Maybe<ProfileStepV2BlockInfoBoxBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NicknameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OptionalHeaderLabelTag?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonalInformationHeader?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneTypeInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrefixLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrimaryLanguageInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalInformationHeader?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SuffixLabel?: Maybe<Array<Maybe<StringFacet>>>;
  UpdateInformationInfoBox?: Maybe<ProfileStepV2BlockInfoBoxBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfBirthInputLabel?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstLicenseLabel?: Maybe<Array<Maybe<StringFacet>>>;
  YearOfFirstLicenseValidationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ProfileStepV2BlockFacetAddLocalLanguageAddressCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetAreaCodeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileStepV2BlockFacetCompanyAffiliationInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetContactInformationHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetCountryOrMarketInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetDesignationsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetFirstNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetGenderInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetIncorrectDateOfBirthErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetIsoCodeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetLastNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetLatinAlphabetWarningArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetLocalLanguageAddressHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetMdrtEmailContactCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetMdrtMemberDirectoryCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetMdrtSmsContactCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetMailingAddressHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetMiddleNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetNicknameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetOptionalHeaderLabelTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetPersonalInformationHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetPhoneNumberInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetPhoneTypeInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetPrefixLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetPrimaryLanguageInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetProfessionalInformationHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileStepV2BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileStepV2BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileStepV2BlockFacetSuffixLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetYearOfBirthInputLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetYearOfFirstLicenseLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacetYearOfFirstLicenseValidationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ProfileStepV2BlockInfoBoxBlock = {
  __typename?: 'ProfileStepV2BlockInfoBoxBlock';
  Heading?: Maybe<Scalars['String']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
};


export type ProfileStepV2BlockInfoBoxBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ProfileStepV2BlockInfoBoxBlockTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ProfileStepV2BlockInfoBoxBlockFacet = {
  __typename?: 'ProfileStepV2BlockInfoBoxBlockFacet';
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ProfileStepV2BlockInfoBoxBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ProfileStepV2BlockInfoBoxBlockFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ProfileStepV2BlockInfoBoxBlockOrderByInput = {
  Heading?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
};

export type ProfileStepV2BlockInfoBoxBlockWhereInput = {
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
};

export type ProfileStepV2BlockOrderByInput = {
  AddLocalLanguageAddressCheckboxLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AreaCodeInputLabel?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyAffiliationInputLabel?: InputMaybe<OrderBy>;
  ContactInformationHeader?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CountryOrMarketInputLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DesignationsLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstNameLabel?: InputMaybe<OrderBy>;
  GenderInputLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IncorrectDateOfBirthErrorMessage?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsoCodeInputLabel?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastNameLabel?: InputMaybe<OrderBy>;
  LatinAlphabetWarning?: InputMaybe<OrderBy>;
  LocalLanguageAddressHeader?: InputMaybe<OrderBy>;
  LocalLanguageAddressLabels?: InputMaybe<ProfileStepV2BlockAddressInfoBlockOrderByInput>;
  MDRTEmailContactCheckboxLabel?: InputMaybe<OrderBy>;
  MDRTMemberDirectoryCheckboxLabel?: InputMaybe<OrderBy>;
  MDRTSmsContactCheckboxLabel?: InputMaybe<OrderBy>;
  MailingAddressHeader?: InputMaybe<OrderBy>;
  MailingAddressLabels?: InputMaybe<ProfileStepV2BlockAddressInfoBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MiddleNameLabel?: InputMaybe<OrderBy>;
  MissingInformationInfoBox?: InputMaybe<ProfileStepV2BlockInfoBoxBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  NicknameLabel?: InputMaybe<OrderBy>;
  OptionalHeaderLabelTag?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonalInformationHeader?: InputMaybe<OrderBy>;
  PhoneNumberInputLabel?: InputMaybe<OrderBy>;
  PhoneTypeInputLabel?: InputMaybe<OrderBy>;
  PrefixLabel?: InputMaybe<OrderBy>;
  PrimaryLanguageInputLabel?: InputMaybe<OrderBy>;
  ProfessionalInformationHeader?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SuffixLabel?: InputMaybe<OrderBy>;
  UpdateInformationInfoBox?: InputMaybe<ProfileStepV2BlockInfoBoxBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  YearOfBirthInputLabel?: InputMaybe<OrderBy>;
  YearOfFirstLicenseLabel?: InputMaybe<OrderBy>;
  YearOfFirstLicenseValidationLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ProfileStepV2BlockOutput = {
  __typename?: 'ProfileStepV2BlockOutput';
  autocomplete?: Maybe<ProfileStepV2BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ProfileStepV2BlockFacet>;
  item?: Maybe<ProfileStepV2Block>;
  items?: Maybe<Array<Maybe<ProfileStepV2Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ProfileStepV2BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileStepV2BlockWhereInput = {
  AddLocalLanguageAddressCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AreaCodeInputLabel?: InputMaybe<SearchableStringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyAffiliationInputLabel?: InputMaybe<SearchableStringFilterInput>;
  ContactInformationHeader?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CountryOrMarketInputLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DesignationsLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstNameLabel?: InputMaybe<SearchableStringFilterInput>;
  GenderInputLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncorrectDateOfBirthErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsoCodeInputLabel?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastNameLabel?: InputMaybe<SearchableStringFilterInput>;
  LatinAlphabetWarning?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddressHeader?: InputMaybe<SearchableStringFilterInput>;
  LocalLanguageAddressLabels?: InputMaybe<ProfileStepV2BlockAddressInfoBlockWhereInput>;
  MDRTEmailContactCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  MDRTMemberDirectoryCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  MDRTSmsContactCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  MailingAddressHeader?: InputMaybe<SearchableStringFilterInput>;
  MailingAddressLabels?: InputMaybe<ProfileStepV2BlockAddressInfoBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MiddleNameLabel?: InputMaybe<SearchableStringFilterInput>;
  MissingInformationInfoBox?: InputMaybe<ProfileStepV2BlockInfoBoxBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NicknameLabel?: InputMaybe<SearchableStringFilterInput>;
  OptionalHeaderLabelTag?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonalInformationHeader?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberInputLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneTypeInputLabel?: InputMaybe<SearchableStringFilterInput>;
  PrefixLabel?: InputMaybe<SearchableStringFilterInput>;
  PrimaryLanguageInputLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalInformationHeader?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SuffixLabel?: InputMaybe<SearchableStringFilterInput>;
  UpdateInformationInfoBox?: InputMaybe<ProfileStepV2BlockInfoBoxBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  YearOfBirthInputLabel?: InputMaybe<SearchableStringFilterInput>;
  YearOfFirstLicenseLabel?: InputMaybe<SearchableStringFilterInput>;
  YearOfFirstLicenseValidationLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ProfileStepV2BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ProfileStepV2BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ProfileStepV2BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for Public Profile Page */
export type PublicProfilePage = IContent & IData & {
  __typename?: 'PublicProfilePage';
  /** The label for achievement level text */
  AchievementLevelLabel?: Maybe<Scalars['String']['output']>;
  AdditionalInformationTitleLabel?: Maybe<Scalars['String']['output']>;
  AgeLabel?: Maybe<Scalars['String']['output']>;
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnnualMeetingsCountLabel?: Maybe<Scalars['String']['output']>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AveragePercentageLabel?: Maybe<Scalars['String']['output']>;
  BackToMemberDirectoryLabel?: Maybe<Scalars['String']['output']>;
  BioLabel?: Maybe<Scalars['String']['output']>;
  BirthdateLabel?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CommitteeDetailCommitteeLabel?: Maybe<Scalars['String']['output']>;
  CommitteeDetailTitleLabel?: Maybe<Scalars['String']['output']>;
  CommitteeSummaryCommitteeLabel?: Maybe<Scalars['String']['output']>;
  CommitteeSummaryTitleLabel?: Maybe<Scalars['String']['output']>;
  ContactInformationLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  DivisionLabel?: Maybe<Scalars['String']['output']>;
  EmptyBioMessage?: Maybe<Scalars['String']['output']>;
  EngagementLabel?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  FinalScoreLabel?: Maybe<Scalars['String']['output']>;
  FirstLastMembershipLabel?: Maybe<Scalars['String']['output']>;
  FollowedTopicsLabel?: Maybe<Scalars['String']['output']>;
  FoundationDonorLevelLabel?: Maybe<Scalars['String']['output']>;
  GlobalConferenceMeetingsCountLabel?: Maybe<Scalars['String']['output']>;
  GoToMemberDirectoryLabel?: Maybe<Scalars['String']['output']>;
  GracePeriodIndicatorLabel?: Maybe<Scalars['String']['output']>;
  IdLabel?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  JobsLabel?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LeadershipLabel?: Maybe<Scalars['String']['output']>;
  LifeMembershipTypeLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MemberNotFoundErrorMessage?: Maybe<Scalars['String']['output']>;
  /** The label for membership status text */
  MembershipStatusLabel?: Maybe<Scalars['String']['output']>;
  /** The label for membership years text */
  MembershipYearsLabel?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<PublicProfilePageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PictureDescription?: Maybe<Scalars['String']['output']>;
  PointsEarnedLabel?: Maybe<Scalars['String']['output']>;
  PointsPossibleLabel?: Maybe<Scalars['String']['output']>;
  QualifyingLifeMembershipTypeLabel?: Maybe<Scalars['String']['output']>;
  QualifyingMembershipTypeLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RoleLabel?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<PublicProfilePageImageBlock>;
  TotalPointsLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  YearLabel?: Maybe<Scalars['String']['output']>;
  YearsOfMembershipLevelLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageAchievementLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageAdditionalInformationTitleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageAgeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageAnnualMeetingsCountLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageAveragePercentageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageBackToMemberDirectoryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageBioLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageBirthdateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageCommitteeDetailCommitteeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageCommitteeDetailTitleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageCommitteeSummaryCommitteeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageCommitteeSummaryTitleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageContactInformationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageDivisionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageEmptyBioMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageEngagementLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageFinalScoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageFirstLastMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageFollowedTopicsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageFoundationDonorLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageGlobalConferenceMeetingsCountLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageGoToMemberDirectoryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageGracePeriodIndicatorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageJobsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageLeadershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageLifeMembershipTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageMemberNotFoundErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageMembershipStatusLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageMembershipYearsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePagePictureDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePagePointsEarnedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePagePointsPossibleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageQualifyingLifeMembershipTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageQualifyingMembershipTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageRoleLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageTotalPointsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePageYearsOfMembershipLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Public Profile Page */
export type PublicProfilePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PublicProfilePageAutocomplete = {
  __typename?: 'PublicProfilePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<PublicProfilePageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<PublicProfilePageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PublicProfilePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PublicProfilePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PublicProfilePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PublicProfilePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PublicProfilePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PublicProfilePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PublicProfilePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PublicProfilePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PublicProfilePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PublicProfilePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PublicProfilePageFacet = {
  __typename?: 'PublicProfilePageFacet';
  AchievementLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AdditionalInformationTitleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AgeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnnualMeetingsCountLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  AveragePercentageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackToMemberDirectoryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BioLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BirthdateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CommitteeDetailCommitteeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CommitteeDetailTitleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CommitteeSummaryCommitteeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CommitteeSummaryTitleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContactInformationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  DivisionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EmptyBioMessage?: Maybe<Array<Maybe<StringFacet>>>;
  EngagementLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FinalScoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FirstLastMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FollowedTopicsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FoundationDonorLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GlobalConferenceMeetingsCountLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GoToMemberDirectoryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GracePeriodIndicatorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  JobsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LeadershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMembershipTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MemberNotFoundErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipStatusLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipYearsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<PublicProfilePageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PictureDescription?: Maybe<Array<Maybe<StringFacet>>>;
  PointsEarnedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PointsPossibleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingLifeMembershipTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMembershipTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RoleLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<PublicProfilePageImageBlockFacet>;
  TotalPointsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  YearsOfMembershipLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PublicProfilePageFacetAchievementLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetAdditionalInformationTitleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetAgeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetAnnualMeetingsCountLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetAveragePercentageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetBackToMemberDirectoryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetBioLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetBirthdateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PublicProfilePageFacetCommitteeDetailCommitteeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetCommitteeDetailTitleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetCommitteeSummaryCommitteeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetCommitteeSummaryTitleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetContactInformationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PublicProfilePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PublicProfilePageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetDivisionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetEmptyBioMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetEngagementLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetFinalScoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetFirstLastMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetFollowedTopicsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetFoundationDonorLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetGlobalConferenceMeetingsCountLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetGoToMemberDirectoryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetGracePeriodIndicatorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PublicProfilePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetJobsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetLeadershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetLifeMembershipTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetMemberNotFoundErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetMembershipStatusLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetMembershipYearsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetPictureDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetPointsEarnedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetPointsPossibleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetQualifyingLifeMembershipTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetQualifyingMembershipTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetRoleLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PublicProfilePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PublicProfilePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PublicProfilePageFacetTotalPointsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacetYearsOfMembershipLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PublicProfilePageImageBlock = {
  __typename?: 'PublicProfilePageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type PublicProfilePageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PublicProfilePageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PublicProfilePageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PublicProfilePageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PublicProfilePageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PublicProfilePageImageBlockAutocomplete = {
  __typename?: 'PublicProfilePageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type PublicProfilePageImageBlockFacet = {
  __typename?: 'PublicProfilePageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PublicProfilePageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PublicProfilePageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PublicProfilePageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PublicProfilePageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type PublicProfilePageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type PublicProfilePageOrderByInput = {
  AchievementLevelLabel?: InputMaybe<OrderBy>;
  AdditionalInformationTitleLabel?: InputMaybe<OrderBy>;
  AgeLabel?: InputMaybe<OrderBy>;
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AnnualMeetingsCountLabel?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AveragePercentageLabel?: InputMaybe<OrderBy>;
  BackToMemberDirectoryLabel?: InputMaybe<OrderBy>;
  BioLabel?: InputMaybe<OrderBy>;
  BirthdateLabel?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CommitteeDetailCommitteeLabel?: InputMaybe<OrderBy>;
  CommitteeDetailTitleLabel?: InputMaybe<OrderBy>;
  CommitteeSummaryCommitteeLabel?: InputMaybe<OrderBy>;
  CommitteeSummaryTitleLabel?: InputMaybe<OrderBy>;
  ContactInformationLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  DivisionLabel?: InputMaybe<OrderBy>;
  EmptyBioMessage?: InputMaybe<OrderBy>;
  EngagementLabel?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FinalScoreLabel?: InputMaybe<OrderBy>;
  FirstLastMembershipLabel?: InputMaybe<OrderBy>;
  FollowedTopicsLabel?: InputMaybe<OrderBy>;
  FoundationDonorLevelLabel?: InputMaybe<OrderBy>;
  GlobalConferenceMeetingsCountLabel?: InputMaybe<OrderBy>;
  GoToMemberDirectoryLabel?: InputMaybe<OrderBy>;
  GracePeriodIndicatorLabel?: InputMaybe<OrderBy>;
  IdLabel?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  JobsLabel?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LeadershipLabel?: InputMaybe<OrderBy>;
  LifeMembershipTypeLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MemberNotFoundErrorMessage?: InputMaybe<OrderBy>;
  MembershipStatusLabel?: InputMaybe<OrderBy>;
  MembershipYearsLabel?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<PublicProfilePageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PictureDescription?: InputMaybe<OrderBy>;
  PointsEarnedLabel?: InputMaybe<OrderBy>;
  PointsPossibleLabel?: InputMaybe<OrderBy>;
  QualifyingLifeMembershipTypeLabel?: InputMaybe<OrderBy>;
  QualifyingMembershipTypeLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RoleLabel?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<PublicProfilePageImageBlockOrderByInput>;
  TotalPointsLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  YearLabel?: InputMaybe<OrderBy>;
  YearsOfMembershipLevelLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PublicProfilePageOutput = {
  __typename?: 'PublicProfilePageOutput';
  autocomplete?: Maybe<PublicProfilePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PublicProfilePageFacet>;
  item?: Maybe<PublicProfilePage>;
  items?: Maybe<Array<Maybe<PublicProfilePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PublicProfilePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PublicProfilePageWhereInput = {
  AchievementLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  AdditionalInformationTitleLabel?: InputMaybe<SearchableStringFilterInput>;
  AgeLabel?: InputMaybe<SearchableStringFilterInput>;
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AnnualMeetingsCountLabel?: InputMaybe<SearchableStringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AveragePercentageLabel?: InputMaybe<SearchableStringFilterInput>;
  BackToMemberDirectoryLabel?: InputMaybe<SearchableStringFilterInput>;
  BioLabel?: InputMaybe<SearchableStringFilterInput>;
  BirthdateLabel?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CommitteeDetailCommitteeLabel?: InputMaybe<SearchableStringFilterInput>;
  CommitteeDetailTitleLabel?: InputMaybe<SearchableStringFilterInput>;
  CommitteeSummaryCommitteeLabel?: InputMaybe<SearchableStringFilterInput>;
  CommitteeSummaryTitleLabel?: InputMaybe<SearchableStringFilterInput>;
  ContactInformationLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  DivisionLabel?: InputMaybe<SearchableStringFilterInput>;
  EmptyBioMessage?: InputMaybe<SearchableStringFilterInput>;
  EngagementLabel?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FinalScoreLabel?: InputMaybe<SearchableStringFilterInput>;
  FirstLastMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  FollowedTopicsLabel?: InputMaybe<SearchableStringFilterInput>;
  FoundationDonorLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  GlobalConferenceMeetingsCountLabel?: InputMaybe<SearchableStringFilterInput>;
  GoToMemberDirectoryLabel?: InputMaybe<SearchableStringFilterInput>;
  GracePeriodIndicatorLabel?: InputMaybe<SearchableStringFilterInput>;
  IdLabel?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  JobsLabel?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LeadershipLabel?: InputMaybe<SearchableStringFilterInput>;
  LifeMembershipTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MemberNotFoundErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  MembershipStatusLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipYearsLabel?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<PublicProfilePageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PictureDescription?: InputMaybe<SearchableStringFilterInput>;
  PointsEarnedLabel?: InputMaybe<SearchableStringFilterInput>;
  PointsPossibleLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingLifeMembershipTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMembershipTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RoleLabel?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<PublicProfilePageImageBlockWhereInput>;
  TotalPointsLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  YearLabel?: InputMaybe<SearchableStringFilterInput>;
  YearsOfMembershipLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PublicProfilePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PublicProfilePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PublicProfilePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Query = {
  __typename?: 'Query';
  AMPSectionBlock?: Maybe<AmpSectionBlockOutput>;
  AccordionContainerBlock?: Maybe<AccordionContainerBlockOutput>;
  AccordionItemBlock?: Maybe<AccordionItemBlockOutput>;
  AccountProfilePage?: Maybe<AccountProfilePageOutput>;
  AddressInfoBlock?: Maybe<AddressInfoBlockOutput>;
  BadgeBlock?: Maybe<BadgeBlockOutput>;
  BrandedTableBlock?: Maybe<BrandedTableBlockOutput>;
  BulkImporterUploaderSectionBlock?: Maybe<BulkImporterUploaderSectionBlockOutput>;
  ButtonLabelBlock?: Maybe<ButtonLabelBlockOutput>;
  CaptchaElementBlock?: Maybe<CaptchaElementBlockOutput>;
  CategoryListBlock?: Maybe<CategoryListBlockOutput>;
  CertifyingOfficerSectionBlock?: Maybe<CertifyingOfficerSectionBlockOutput>;
  CflBadgesBlock?: Maybe<CflBadgesBlockOutput>;
  CflHomePage?: Maybe<CflHomePageOutput>;
  CflMembershipKitCardBlock?: Maybe<CflMembershipKitCardBlockOutput>;
  CflMembershipKitCarouselBlock?: Maybe<CflMembershipKitCarouselBlockOutput>;
  CflSiteSettingsPage?: Maybe<CflSiteSettingsPageOutput>;
  CflSpecialResourceCardBlock?: Maybe<CflSpecialResourceCardBlockOutput>;
  ChoiceElementBlock?: Maybe<ChoiceElementBlockOutput>;
  ColumnContainerBlock?: Maybe<ColumnContainerBlockOutput>;
  ColumnLinksListContainerBlock?: Maybe<ColumnLinksListContainerBlockOutput>;
  ColumnLinksListItemBlock?: Maybe<ColumnLinksListItemBlockOutput>;
  CompanyAdminBulkImportDashboardSectionBlock?: Maybe<CompanyAdminBulkImportDashboardSectionBlockOutput>;
  CompanyAdminBulkImportGettingStartedSectionBlock?: Maybe<CompanyAdminBulkImportGettingStartedSectionBlockOutput>;
  CompanyAdminBulkImportPage?: Maybe<CompanyAdminBulkImportPageOutput>;
  CompanyAdminCompanyListingsPage?: Maybe<CompanyAdminCompanyListingsPageOutput>;
  CompanyAdminMembershipDirectoryPage?: Maybe<CompanyAdminMembershipDirectoryPageOutput>;
  CompanyRankingsPage?: Maybe<CompanyRankingsPageOutput>;
  ConfirmationModalBlock?: Maybe<ConfirmationModalBlockOutput>;
  ConfirmationStepBlock?: Maybe<ConfirmationStepBlockOutput>;
  CongratulationsStepV2Block?: Maybe<CongratulationsStepV2BlockOutput>;
  ContactEmailElementBlock?: Maybe<ContactEmailElementBlockOutput>;
  ContactMdrtIdElementBlock?: Maybe<ContactMdrtIdElementBlockOutput>;
  ContactNameElementBlock?: Maybe<ContactNameElementBlockOutput>;
  ContactPhoneElementBlock?: Maybe<ContactPhoneElementBlockOutput>;
  ContactsBlock?: Maybe<ContactsBlockOutput>;
  Content?: Maybe<ContentOutput>;
  DAMAsset?: Maybe<DamAssetOutput>;
  DAMImageAsset?: Maybe<DamImageAssetOutput>;
  DAMVideo?: Maybe<DamVideoOutput>;
  DAMVideoAsset?: Maybe<DamVideoAssetOutput>;
  DashBoardSectionBlock?: Maybe<DashBoardSectionBlockOutput>;
  DashboardAccountPage?: Maybe<DashboardAccountPageOutput>;
  DashboardCarouselCardBlock?: Maybe<DashboardCarouselCardBlockOutput>;
  DashboardContactInformationBlock?: Maybe<DashboardContactInformationBlockOutput>;
  DashboardLoginPasswordBlock?: Maybe<DashboardLoginPasswordBlockOutput>;
  DashboardPermissionsBlock?: Maybe<DashboardPermissionsBlockOutput>;
  DashboardPersonalInformationBlock?: Maybe<DashboardPersonalInformationBlockOutput>;
  DashboardProfessionalInformationBlock?: Maybe<DashboardProfessionalInformationBlockOutput>;
  DashboardProfileBlock?: Maybe<DashboardProfileBlockOutput>;
  DashboardSharedPage?: Maybe<DashboardSharedPageOutput>;
  DashboardSitePreferencesBlock?: Maybe<DashboardSitePreferencesBlockOutput>;
  Data?: Maybe<DataOutput>;
  DataMismatchModalBlock?: Maybe<DataMismatchModalBlockOutput>;
  DeleteCertifyinLetterModalBlock?: Maybe<DeleteCertifyinLetterModalBlockOutput>;
  DescriptionButtonBlock?: Maybe<DescriptionButtonBlockOutput>;
  DetailPage?: Maybe<DetailPageOutput>;
  DocumentMedia?: Maybe<DocumentMediaOutput>;
  DonationBlock?: Maybe<DonationBlockOutput>;
  DownloadUploadSectionBlock?: Maybe<DownloadUploadSectionBlockOutput>;
  EEPSectionBlock?: Maybe<EepSectionBlockOutput>;
  EVPCarouselBlock?: Maybe<EvpCarouselBlockOutput>;
  EVPCarouselQuoteBlock?: Maybe<EvpCarouselQuoteBlockOutput>;
  EVPCarouselQuoteSlideBlock?: Maybe<EvpCarouselQuoteSlideBlockOutput>;
  EVPCarouselSlideBlock?: Maybe<EvpCarouselSlideBlockOutput>;
  EVPContentBlock?: Maybe<EvpContentBlockOutput>;
  EVPFeaturedResourcesBlock?: Maybe<EvpFeaturedResourcesBlockOutput>;
  EVPGenericPage?: Maybe<EvpGenericPageOutput>;
  EVPHeroQuoteBlock?: Maybe<EvpHeroQuoteBlockOutput>;
  EVPHomePage?: Maybe<EvpHomePageOutput>;
  EVPImageBlock?: Maybe<EvpImageBlockOutput>;
  EVPImageLinkBlock?: Maybe<EvpImageLinkBlockOutput>;
  EVPLanguageSelectorBlock?: Maybe<EvpLanguageSelectorBlockOutput>;
  EVPLinkBlock?: Maybe<EvpLinkBlockOutput>;
  EVPMediaFileBlock?: Maybe<EvpMediaFileBlockOutput>;
  EVPNavigationPageBlock?: Maybe<EvpNavigationPageBlockOutput>;
  EVPPartnerSettingsBlock?: Maybe<EvpPartnerSettingsBlockOutput>;
  EVPResourcePage?: Maybe<EvpResourcePageOutput>;
  EVPSearchHeaderBlock?: Maybe<EvpSearchHeaderBlockOutput>;
  EVPSearchPage?: Maybe<EvpSearchPageOutput>;
  EVPSiteSettingsPage?: Maybe<EvpSiteSettingsPageOutput>;
  EVPTabBlock?: Maybe<EvpTabBlockOutput>;
  EVPTabCardBlock?: Maybe<EvpTabCardBlockOutput>;
  EVPTabCardsBlock?: Maybe<EvpTabCardsBlockOutput>;
  EVPTabImageTextBlock?: Maybe<EvpTabImageTextBlockOutput>;
  EVPTabRichTextBlock?: Maybe<EvpTabRichTextBlockOutput>;
  EVPTabVideoBlock?: Maybe<EvpTabVideoBlockOutput>;
  EVPTabsBlock?: Maybe<EvpTabsBlockOutput>;
  EVPTextImageBlock?: Maybe<EvpTextImageBlockOutput>;
  EVPVideoBlock?: Maybe<EvpVideoBlockOutput>;
  EmployeeTableHeaderLabelsBlock?: Maybe<EmployeeTableHeaderLabelsBlockOutput>;
  ErrorModalBlock?: Maybe<ErrorModalBlockOutput>;
  ErrorPage?: Maybe<ErrorPageOutput>;
  ErrorPageBlock?: Maybe<ErrorPageBlockOutput>;
  EventBlock?: Maybe<EventBlockOutput>;
  EventLocationAndDateBlock?: Maybe<EventLocationAndDateBlockOutput>;
  EventLocationInformationBlock?: Maybe<EventLocationInformationBlockOutput>;
  EventPage?: Maybe<EventPageOutput>;
  EventRegistrationInformationBlock?: Maybe<EventRegistrationInformationBlockOutput>;
  EventSessionBlock?: Maybe<EventSessionBlockOutput>;
  EventSessionScheduleBlock?: Maybe<EventSessionScheduleBlockOutput>;
  EventSessionTrackBlock?: Maybe<EventSessionTrackBlockOutput>;
  EventSessionTrackSpeakerBlock?: Maybe<EventSessionTrackSpeakerBlockOutput>;
  EventSpeakerSearchPage?: Maybe<EventSpeakerSearchPageOutput>;
  EventSpeakersBlock?: Maybe<EventSpeakersBlockOutput>;
  EventTableContainerBlock?: Maybe<EventTableContainerBlockOutput>;
  ExpandableContainerBlock?: Maybe<ExpandableContainerBlockOutput>;
  FileUploadElementBlock?: Maybe<FileUploadElementBlockOutput>;
  FlowFinishInformationBlock?: Maybe<FlowFinishInformationBlockOutput>;
  FolderPage?: Maybe<FolderPageOutput>;
  FormContainerBlock?: Maybe<FormContainerBlockOutput>;
  FormStepBlock?: Maybe<FormStepBlockOutput>;
  FourColumnTableBlock?: Maybe<FourColumnTableBlockOutput>;
  GaugeBlock?: Maybe<GaugeBlockOutput>;
  GeoDataBlock?: Maybe<GeoDataBlockOutput>;
  GettingStartedStepBlock?: Maybe<GettingStartedStepBlockOutput>;
  GettingStartedStepV2Block?: Maybe<GettingStartedStepV2BlockOutput>;
  GreetingCaseBlock?: Maybe<GreetingCaseBlockOutput>;
  GreetingStepBlock?: Maybe<GreetingStepBlockOutput>;
  GreetingStepV2Block?: Maybe<GreetingStepV2BlockOutput>;
  GsAwardsApplicationsBlock?: Maybe<GsAwardsApplicationsBlockOutput>;
  GsAwardsConfirmationStepBlock?: Maybe<GsAwardsConfirmationStepBlockOutput>;
  GsAwardsFileUploadBlock?: Maybe<GsAwardsFileUploadBlockOutput>;
  GsAwardsGettingStartedStepBlock?: Maybe<GsAwardsGettingStartedStepBlockOutput>;
  GsAwardsMembershipStepBlock?: Maybe<GsAwardsMembershipStepBlockOutput>;
  GsAwardsPage?: Maybe<GsAwardsPageOutput>;
  GsAwardsPersistencyStepBlock?: Maybe<GsAwardsPersistencyStepBlockOutput>;
  GsAwardsProductionStepBlock?: Maybe<GsAwardsProductionStepBlockOutput>;
  GsAwardsRecruitmentStepBlock?: Maybe<GsAwardsRecruitmentStepBlockOutput>;
  GsAwardsRetentionStepBlock?: Maybe<GsAwardsRetentionStepBlockOutput>;
  GsAwardsSelectApplicantStepBlock?: Maybe<GsAwardsSelectApplicantStepBlockOutput>;
  GsAwardsSubmitStepBlock?: Maybe<GsAwardsSubmitStepBlockOutput>;
  GsAwardsVerificationStepBlock?: Maybe<GsAwardsVerificationStepBlockOutput>;
  GsAwardsWholePersonStepBlock?: Maybe<GsAwardsWholePersonStepBlockOutput>;
  GsConfirmationStepBlock?: Maybe<GsConfirmationStepBlockOutput>;
  GsGettingStartedStepBlock?: Maybe<GsGettingStartedStepBlockOutput>;
  GsGreetingStepBlock?: Maybe<GsGreetingStepBlockOutput>;
  GsLeadershipInformationStepBlock?: Maybe<GsLeadershipInformationStepBlockOutput>;
  GsMembershipRenewalPage?: Maybe<GsMembershipRenewalPageOutput>;
  GsProfileStepBlock?: Maybe<GsProfileStepBlockOutput>;
  GsReceiptStepBlock?: Maybe<GsReceiptStepBlockOutput>;
  GsReviewStepBlock?: Maybe<GsReviewStepBlockOutput>;
  HealthPoliciesSectionBlock?: Maybe<HealthPoliciesSectionBlockOutput>;
  HeroTextContentBlock?: Maybe<HeroTextContentBlockOutput>;
  HomePage?: Maybe<HomePageOutput>;
  HomePageV2?: Maybe<HomePageV2Output>;
  IconRequirementBlock?: Maybe<IconRequirementBlockOutput>;
  Image?: Maybe<ImageOutput>;
  ImageBlock?: Maybe<ImageBlockOutput>;
  ImageCaptionRichTextBlock?: Maybe<ImageCaptionRichTextBlockOutput>;
  ImageChoiceElementBlock?: Maybe<ImageChoiceElementBlockOutput>;
  ImageLinkBlock?: Maybe<ImageLinkBlockOutput>;
  ImageMedia?: Maybe<ImageMediaOutput>;
  ImageTextBlock?: Maybe<ImageTextBlockOutput>;
  ImageTextBlockV2?: Maybe<ImageTextBlockV2Output>;
  ImageTextCardBlock?: Maybe<ImageTextCardBlockOutput>;
  ImageTextItemBlock?: Maybe<ImageTextItemBlockOutput>;
  InfoBoxBlock?: Maybe<InfoBoxBlockOutput>;
  KeyLinkValueBlock?: Maybe<KeyLinkValueBlockOutput>;
  KeyTranslatedValueBlock?: Maybe<KeyTranslatedValueBlockOutput>;
  LandingPage?: Maybe<LandingPageOutput>;
  LanguageIdAndName?: Maybe<LanguageIdAndNameOutput>;
  LanguagesBlock?: Maybe<LanguagesBlockOutput>;
  LearnCarouselContainerBlock?: Maybe<LearnCarouselContainerBlockOutput>;
  LearnCarouselContainerBlockV2?: Maybe<LearnCarouselContainerBlockV2Output>;
  LearnDetailPage?: Maybe<LearnDetailPageOutput>;
  LearnHeroImageBlock?: Maybe<LearnHeroImageBlockOutput>;
  LearnLandingPage?: Maybe<LearnLandingPageOutput>;
  LearnPageV2?: Maybe<LearnPageV2Output>;
  LearnPlayListPage?: Maybe<LearnPlayListPageOutput>;
  LikeAndBookmarkBlock?: Maybe<LikeAndBookmarkBlockOutput>;
  LinkBlock?: Maybe<LinkBlockOutput>;
  LinkListBlock?: Maybe<LinkListBlockOutput>;
  LinkTileBlock?: Maybe<LinkTileBlockOutput>;
  LoaderBlock?: Maybe<LoaderBlockOutput>;
  LocationBlock?: Maybe<LocationBlockOutput>;
  MeetingEventCardPage?: Maybe<MeetingEventCardPageOutput>;
  MeetingPage?: Maybe<MeetingPageOutput>;
  MemberDirectory?: Maybe<MemberDirectoryOutput>;
  MemberDirectoryPage?: Maybe<MemberDirectoryPageOutput>;
  MemberSectionBlock?: Maybe<MemberSectionBlockOutput>;
  MembersTableHeaderLabelsBlock?: Maybe<MembersTableHeaderLabelsBlockOutput>;
  MembershipHistoryDetailBlock?: Maybe<MembershipHistoryDetailBlockOutput>;
  MembershipHistoryDetailPage?: Maybe<MembershipHistoryDetailPageOutput>;
  MembershipInvoicePage?: Maybe<MembershipInvoicePageOutput>;
  MembershipLevelBlock?: Maybe<MembershipLevelBlockOutput>;
  MembershipLevelRadioBlock?: Maybe<MembershipLevelRadioBlockOutput>;
  MembershipLevelSectionBlock?: Maybe<MembershipLevelSectionBlockOutput>;
  MembershipLevelStepV2Block?: Maybe<MembershipLevelStepV2BlockOutput>;
  MembershipLevelsBlock?: Maybe<MembershipLevelsBlockOutput>;
  MembershipRenewalPage?: Maybe<MembershipRenewalPageOutput>;
  MembershipRenewalV2Page?: Maybe<MembershipRenewalV2PageOutput>;
  MembershipRequirementBlock?: Maybe<MembershipRequirementBlockOutput>;
  MembershipRequirementsBlock?: Maybe<MembershipRequirementsBlockOutput>;
  MembershipTypeSectionBlock?: Maybe<MembershipTypeSectionBlockOutput>;
  MembershipTypeStepBlock?: Maybe<MembershipTypeStepBlockOutput>;
  MembershipTypeStepV2Block?: Maybe<MembershipTypeStepV2BlockOutput>;
  ModalInfoBlock?: Maybe<ModalInfoBlockOutput>;
  NewIDRequestSectionBlock?: Maybe<NewIdRequestSectionBlockOutput>;
  NextCallOutBlock?: Maybe<NextCallOutBlockOutput>;
  NextContactUsBlock?: Maybe<NextContactUsBlockOutput>;
  NextContainerBlock?: Maybe<NextContainerBlockOutput>;
  NextDeadLetterQueueBlock?: Maybe<NextDeadLetterQueueBlockOutput>;
  NextEventBlock?: Maybe<NextEventBlockOutput>;
  NextHeroBlock?: Maybe<NextHeroBlockOutput>;
  NextInfoBoxBlock?: Maybe<NextInfoBoxBlockOutput>;
  NextPersonContainerBlock?: Maybe<NextPersonContainerBlockOutput>;
  NextPersonDataBlock?: Maybe<NextPersonDataBlockOutput>;
  NextStaffAdminPage?: Maybe<NextStaffAdminPageOutput>;
  NextStaticPage?: Maybe<NextStaticPageOutput>;
  NextSyncEventsBlock?: Maybe<NextSyncEventsBlockOutput>;
  NotFoundPage?: Maybe<NotFoundPageOutput>;
  NumberElementBlock?: Maybe<NumberElementBlockOutput>;
  NumberedContainerBlock?: Maybe<NumberedContainerBlockOutput>;
  NumberedItemBlock?: Maybe<NumberedItemBlockOutput>;
  ParagraphTextElementBlock?: Maybe<ParagraphTextElementBlockOutput>;
  PastPresidentsBlock?: Maybe<PastPresidentsBlockOutput>;
  PaymentProcessingScreenBlock?: Maybe<PaymentProcessingScreenBlockOutput>;
  PersonBlock?: Maybe<PersonBlockOutput>;
  PersonContainerBlock?: Maybe<PersonContainerBlockOutput>;
  PersonQuizPage?: Maybe<PersonQuizPageOutput>;
  PersonUpdatesSectionBlock?: Maybe<PersonUpdatesSectionBlockOutput>;
  PlaylistBlock?: Maybe<PlaylistBlockOutput>;
  PlaylistPromoBlock?: Maybe<PlaylistPromoBlockOutput>;
  PodcastDetailBlock?: Maybe<PodcastDetailBlockOutput>;
  PowerPhrasePage?: Maybe<PowerPhrasePageOutput>;
  PredefinedHiddenElementBlock?: Maybe<PredefinedHiddenElementBlockOutput>;
  PrepaymentErrorModalBlock?: Maybe<PrepaymentErrorModalBlockOutput>;
  PrepaymentErrorPageBlock?: Maybe<PrepaymentErrorPageBlockOutput>;
  PrepaymentGenericErrorBlock?: Maybe<PrepaymentGenericErrorBlockOutput>;
  PrepaymentHomepageBlock?: Maybe<PrepaymentHomepageBlockOutput>;
  PrepaymentHomepageFellowsDesignationBlock?: Maybe<PrepaymentHomepageFellowsDesignationBlockOutput>;
  PrepaymentHomepageGsBlock?: Maybe<PrepaymentHomepageGsBlockOutput>;
  PrepaymentHomepageMdrtBlock?: Maybe<PrepaymentHomepageMdrtBlockOutput>;
  PrepaymentLoaderScreenBlock?: Maybe<PrepaymentLoaderScreenBlockOutput>;
  PrepaymentMembershipInfoCardBlock?: Maybe<PrepaymentMembershipInfoCardBlockOutput>;
  PrepaymentMembershipInfoPageBlock?: Maybe<PrepaymentMembershipInfoPageBlockOutput>;
  PrepaymentMembershipTypeInfoCardBlock?: Maybe<PrepaymentMembershipTypeInfoCardBlockOutput>;
  PrepaymentPaymentPageBlock?: Maybe<PrepaymentPaymentPageBlockOutput>;
  PrepaymentPaymentStatusPageBlock?: Maybe<PrepaymentPaymentStatusPageBlockOutput>;
  PrepaymentPortalPage?: Maybe<PrepaymentPortalPageOutput>;
  PrepaymentProductNamesBlock?: Maybe<PrepaymentProductNamesBlockOutput>;
  PrepaymentSuccessfulPaymentPageBlock?: Maybe<PrepaymentSuccessfulPaymentPageBlockOutput>;
  PressReleasePage?: Maybe<PressReleasePageOutput>;
  PriceBreakdownBlock?: Maybe<PriceBreakdownBlockOutput>;
  ProductionAttestmentNumbersBlock?: Maybe<ProductionAttestmentNumbersBlockOutput>;
  ProductionDataSectionBlock?: Maybe<ProductionDataSectionBlockOutput>;
  ProductionDeleteModalBlock?: Maybe<ProductionDeleteModalBlockOutput>;
  ProductionModalBlock?: Maybe<ProductionModalBlockOutput>;
  ProductionStepBlock?: Maybe<ProductionStepBlockOutput>;
  ProductionStepV2Block?: Maybe<ProductionStepV2BlockOutput>;
  ProductionTableBlock?: Maybe<ProductionTableBlockOutput>;
  ProfileListBlock?: Maybe<ProfileListBlockOutput>;
  ProfilePictureBlock?: Maybe<ProfilePictureBlockOutput>;
  ProfileSectionBlock?: Maybe<ProfileSectionBlockOutput>;
  ProfileStepBlock?: Maybe<ProfileStepBlockOutput>;
  ProfileStepV2Block?: Maybe<ProfileStepV2BlockOutput>;
  PublicProfilePage?: Maybe<PublicProfilePageOutput>;
  QuizCareerBlock?: Maybe<QuizCareerBlockOutput>;
  QuizEducationBlock?: Maybe<QuizEducationBlockOutput>;
  QuizFinancialBlock?: Maybe<QuizFinancialBlockOutput>;
  QuizHealthBlock?: Maybe<QuizHealthBlockOutput>;
  QuizRelationshipsBlock?: Maybe<QuizRelationshipsBlockOutput>;
  QuizServiceBlock?: Maybe<QuizServiceBlockOutput>;
  QuizSpiritualBlock?: Maybe<QuizSpiritualBlockOutput>;
  RTContributorFormPage?: Maybe<RtContributorFormPageOutput>;
  RangeElementBlock?: Maybe<RangeElementBlockOutput>;
  ReceiptStepBlock?: Maybe<ReceiptStepBlockOutput>;
  ReceiptStepV2Block?: Maybe<ReceiptStepV2BlockOutput>;
  ResetButtonElementBlock?: Maybe<ResetButtonElementBlockOutput>;
  ReviewAndSubmitStepV2Block?: Maybe<ReviewAndSubmitStepV2BlockOutput>;
  ReviewBlock?: Maybe<ReviewBlockOutput>;
  ReviewStepBlock?: Maybe<ReviewStepBlockOutput>;
  RichTextBlock?: Maybe<RichTextBlockOutput>;
  RoutingStepBlock?: Maybe<RoutingStepBlockOutput>;
  SearchPage?: Maybe<SearchPageOutput>;
  SearchPageV2?: Maybe<SearchPageV2Output>;
  SectionContainerBlock?: Maybe<SectionContainerBlockOutput>;
  SectionItemBlock?: Maybe<SectionItemBlockOutput>;
  SelectionElementBlock?: Maybe<SelectionElementBlockOutput>;
  SelfAttestLevelOptionsBlock?: Maybe<SelfAttestLevelOptionsBlockOutput>;
  SettingSectionBlock?: Maybe<SettingSectionBlockOutput>;
  SiteDefinition?: Maybe<SiteDefinitionOutput>;
  SiteSettingsPage?: Maybe<SiteSettingsPageOutput>;
  SocialShareBlock?: Maybe<SocialShareBlockOutput>;
  SpeakerEngagementPage?: Maybe<SpeakerEngagementPageOutput>;
  SponsorSpeakerPage?: Maybe<SponsorSpeakerPageOutput>;
  SpotlightBlock?: Maybe<SpotlightBlockOutput>;
  SpotlightContainerBlock?: Maybe<SpotlightContainerBlockOutput>;
  SpotlightDataBlock?: Maybe<SpotlightDataBlockOutput>;
  SpotlightDataContainerBlock?: Maybe<SpotlightDataContainerBlockOutput>;
  StoreCardPage?: Maybe<StoreCardPageOutput>;
  SubmitButtonElementBlock?: Maybe<SubmitButtonElementBlockOutput>;
  SuccessSectionBlock?: Maybe<SuccessSectionBlockOutput>;
  SvgLinkBlock?: Maybe<SvgLinkBlockOutput>;
  SvgMedia?: Maybe<SvgMediaOutput>;
  SvgTextCardBlock?: Maybe<SvgTextCardBlockOutput>;
  TabContainerBlock?: Maybe<TabContainerBlockOutput>;
  TabItemBlock?: Maybe<TabItemBlockOutput>;
  TextCardBlock?: Maybe<TextCardBlockOutput>;
  TextContentBlock?: Maybe<TextContentBlockOutput>;
  TextareaElementBlock?: Maybe<TextareaElementBlockOutput>;
  TextboxElementBlock?: Maybe<TextboxElementBlockOutput>;
  TimelineContainerBlock?: Maybe<TimelineContainerBlockOutput>;
  TimelineItemBlock?: Maybe<TimelineItemBlockOutput>;
  ToolkitBlock?: Maybe<ToolkitBlockOutput>;
  ToolkitItemBlock?: Maybe<ToolkitItemBlockOutput>;
  ToolkitSectionBlock?: Maybe<ToolkitSectionBlockOutput>;
  ToolsCardPage?: Maybe<ToolsCardPageOutput>;
  TooltipBlock?: Maybe<TooltipBlockOutput>;
  UrlElementBlock?: Maybe<UrlElementBlockOutput>;
  Video?: Maybe<VideoOutput>;
  VideoBlock?: Maybe<VideoBlockOutput>;
  VideoDetailBlock?: Maybe<VideoDetailBlockOutput>;
  VideoMedia?: Maybe<VideoMediaOutput>;
  VideoPromoBlock?: Maybe<VideoPromoBlockOutput>;
  VisaLettersPage?: Maybe<VisaLettersPageOutput>;
  VisibilityOptionsBlock?: Maybe<VisibilityOptionsBlockOutput>;
  VisitorDataHiddenElementBlock?: Maybe<VisitorDataHiddenElementBlockOutput>;
  WireTransferSectionBlock?: Maybe<WireTransferSectionBlockOutput>;
  YourAnswersSectionBlock?: Maybe<YourAnswersSectionBlockOutput>;
};


export type QueryAmpSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AmpSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AmpSectionBlockWhereInput>;
};


export type QueryAccordionContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AccordionContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AccordionContainerBlockWhereInput>;
};


export type QueryAccordionItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AccordionItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AccordionItemBlockWhereInput>;
};


export type QueryAccountProfilePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AccountProfilePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AccountProfilePageWhereInput>;
};


export type QueryAddressInfoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AddressInfoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AddressInfoBlockWhereInput>;
};


export type QueryBadgeBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BadgeBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BadgeBlockWhereInput>;
};


export type QueryBrandedTableBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BrandedTableBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BrandedTableBlockWhereInput>;
};


export type QueryBulkImporterUploaderSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BulkImporterUploaderSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BulkImporterUploaderSectionBlockWhereInput>;
};


export type QueryButtonLabelBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ButtonLabelBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ButtonLabelBlockWhereInput>;
};


export type QueryCaptchaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CaptchaElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CaptchaElementBlockWhereInput>;
};


export type QueryCategoryListBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CategoryListBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CategoryListBlockWhereInput>;
};


export type QueryCertifyingOfficerSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CertifyingOfficerSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CertifyingOfficerSectionBlockWhereInput>;
};


export type QueryCflBadgesBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflBadgesBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflBadgesBlockWhereInput>;
};


export type QueryCflHomePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflHomePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflHomePageWhereInput>;
};


export type QueryCflMembershipKitCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflMembershipKitCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflMembershipKitCardBlockWhereInput>;
};


export type QueryCflMembershipKitCarouselBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflMembershipKitCarouselBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflMembershipKitCarouselBlockWhereInput>;
};


export type QueryCflSiteSettingsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflSiteSettingsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflSiteSettingsPageWhereInput>;
};


export type QueryCflSpecialResourceCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflSpecialResourceCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflSpecialResourceCardBlockWhereInput>;
};


export type QueryChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ChoiceElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ChoiceElementBlockWhereInput>;
};


export type QueryColumnContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ColumnContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ColumnContainerBlockWhereInput>;
};


export type QueryColumnLinksListContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ColumnLinksListContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ColumnLinksListContainerBlockWhereInput>;
};


export type QueryColumnLinksListItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ColumnLinksListItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ColumnLinksListItemBlockWhereInput>;
};


export type QueryCompanyAdminBulkImportDashboardSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyAdminBulkImportDashboardSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyAdminBulkImportDashboardSectionBlockWhereInput>;
};


export type QueryCompanyAdminBulkImportGettingStartedSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyAdminBulkImportGettingStartedSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyAdminBulkImportGettingStartedSectionBlockWhereInput>;
};


export type QueryCompanyAdminBulkImportPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyAdminBulkImportPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyAdminBulkImportPageWhereInput>;
};


export type QueryCompanyAdminCompanyListingsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyAdminCompanyListingsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyAdminCompanyListingsPageWhereInput>;
};


export type QueryCompanyAdminMembershipDirectoryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyAdminMembershipDirectoryPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyAdminMembershipDirectoryPageWhereInput>;
};


export type QueryCompanyRankingsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyRankingsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyRankingsPageWhereInput>;
};


export type QueryConfirmationModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ConfirmationModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ConfirmationModalBlockWhereInput>;
};


export type QueryConfirmationStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ConfirmationStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ConfirmationStepBlockWhereInput>;
};


export type QueryCongratulationsStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CongratulationsStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CongratulationsStepV2BlockWhereInput>;
};


export type QueryContactEmailElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContactEmailElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContactEmailElementBlockWhereInput>;
};


export type QueryContactMdrtIdElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContactMdrtIdElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContactMdrtIdElementBlockWhereInput>;
};


export type QueryContactNameElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContactNameElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContactNameElementBlockWhereInput>;
};


export type QueryContactPhoneElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContactPhoneElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContactPhoneElementBlockWhereInput>;
};


export type QueryContactsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContactsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContactsBlockWhereInput>;
};


export type QueryContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryDamAssetArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DamAssetOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DamAssetWhereInput>;
};


export type QueryDamImageAssetArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DamImageAssetOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DamImageAssetWhereInput>;
};


export type QueryDamVideoArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DamVideoOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DamVideoWhereInput>;
};


export type QueryDamVideoAssetArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DamVideoAssetOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DamVideoAssetWhereInput>;
};


export type QueryDashBoardSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashBoardSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashBoardSectionBlockWhereInput>;
};


export type QueryDashboardAccountPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardAccountPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardAccountPageWhereInput>;
};


export type QueryDashboardCarouselCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardCarouselCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardCarouselCardBlockWhereInput>;
};


export type QueryDashboardContactInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardContactInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardContactInformationBlockWhereInput>;
};


export type QueryDashboardLoginPasswordBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardLoginPasswordBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardLoginPasswordBlockWhereInput>;
};


export type QueryDashboardPermissionsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardPermissionsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardPermissionsBlockWhereInput>;
};


export type QueryDashboardPersonalInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardPersonalInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardPersonalInformationBlockWhereInput>;
};


export type QueryDashboardProfessionalInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardProfessionalInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardProfessionalInformationBlockWhereInput>;
};


export type QueryDashboardProfileBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardProfileBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardProfileBlockWhereInput>;
};


export type QueryDashboardSharedPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardSharedPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardSharedPageWhereInput>;
};


export type QueryDashboardSitePreferencesBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardSitePreferencesBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardSitePreferencesBlockWhereInput>;
};


export type QueryDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<System_Locales>>>;
  orderBy?: InputMaybe<DataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DataWhereInput>;
};


export type QueryDataMismatchModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DataMismatchModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DataMismatchModalBlockWhereInput>;
};


export type QueryDeleteCertifyinLetterModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DeleteCertifyinLetterModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DeleteCertifyinLetterModalBlockWhereInput>;
};


export type QueryDescriptionButtonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DescriptionButtonBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DescriptionButtonBlockWhereInput>;
};


export type QueryDetailPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DetailPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DetailPageWhereInput>;
};


export type QueryDocumentMediaArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DocumentMediaOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DocumentMediaWhereInput>;
};


export type QueryDonationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DonationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DonationBlockWhereInput>;
};


export type QueryDownloadUploadSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DownloadUploadSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DownloadUploadSectionBlockWhereInput>;
};


export type QueryEepSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EepSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EepSectionBlockWhereInput>;
};


export type QueryEvpCarouselBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpCarouselBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpCarouselBlockWhereInput>;
};


export type QueryEvpCarouselQuoteBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpCarouselQuoteBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpCarouselQuoteBlockWhereInput>;
};


export type QueryEvpCarouselQuoteSlideBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpCarouselQuoteSlideBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpCarouselQuoteSlideBlockWhereInput>;
};


export type QueryEvpCarouselSlideBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpCarouselSlideBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpCarouselSlideBlockWhereInput>;
};


export type QueryEvpContentBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpContentBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpContentBlockWhereInput>;
};


export type QueryEvpFeaturedResourcesBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpFeaturedResourcesBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpFeaturedResourcesBlockWhereInput>;
};


export type QueryEvpGenericPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpGenericPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpGenericPageWhereInput>;
};


export type QueryEvpHeroQuoteBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpHeroQuoteBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpHeroQuoteBlockWhereInput>;
};


export type QueryEvpHomePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpHomePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpHomePageWhereInput>;
};


export type QueryEvpImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpImageBlockWhereInput>;
};


export type QueryEvpImageLinkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpImageLinkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpImageLinkBlockWhereInput>;
};


export type QueryEvpLanguageSelectorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpLanguageSelectorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpLanguageSelectorBlockWhereInput>;
};


export type QueryEvpLinkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpLinkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpLinkBlockWhereInput>;
};


export type QueryEvpMediaFileBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpMediaFileBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpMediaFileBlockWhereInput>;
};


export type QueryEvpNavigationPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpNavigationPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpNavigationPageBlockWhereInput>;
};


export type QueryEvpPartnerSettingsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpPartnerSettingsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpPartnerSettingsBlockWhereInput>;
};


export type QueryEvpResourcePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpResourcePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpResourcePageWhereInput>;
};


export type QueryEvpSearchHeaderBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpSearchHeaderBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpSearchHeaderBlockWhereInput>;
};


export type QueryEvpSearchPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpSearchPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpSearchPageWhereInput>;
};


export type QueryEvpSiteSettingsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpSiteSettingsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpSiteSettingsPageWhereInput>;
};


export type QueryEvpTabBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabBlockWhereInput>;
};


export type QueryEvpTabCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabCardBlockWhereInput>;
};


export type QueryEvpTabCardsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabCardsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabCardsBlockWhereInput>;
};


export type QueryEvpTabImageTextBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabImageTextBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabImageTextBlockWhereInput>;
};


export type QueryEvpTabRichTextBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabRichTextBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabRichTextBlockWhereInput>;
};


export type QueryEvpTabVideoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabVideoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabVideoBlockWhereInput>;
};


export type QueryEvpTabsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabsBlockWhereInput>;
};


export type QueryEvpTextImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTextImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTextImageBlockWhereInput>;
};


export type QueryEvpVideoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpVideoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpVideoBlockWhereInput>;
};


export type QueryEmployeeTableHeaderLabelsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EmployeeTableHeaderLabelsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EmployeeTableHeaderLabelsBlockWhereInput>;
};


export type QueryErrorModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ErrorModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ErrorModalBlockWhereInput>;
};


export type QueryErrorPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ErrorPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ErrorPageWhereInput>;
};


export type QueryErrorPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ErrorPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ErrorPageBlockWhereInput>;
};


export type QueryEventBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventBlockWhereInput>;
};


export type QueryEventLocationAndDateBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventLocationAndDateBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventLocationAndDateBlockWhereInput>;
};


export type QueryEventLocationInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventLocationInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventLocationInformationBlockWhereInput>;
};


export type QueryEventPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventPageWhereInput>;
};


export type QueryEventRegistrationInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventRegistrationInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventRegistrationInformationBlockWhereInput>;
};


export type QueryEventSessionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSessionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSessionBlockWhereInput>;
};


export type QueryEventSessionScheduleBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSessionScheduleBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSessionScheduleBlockWhereInput>;
};


export type QueryEventSessionTrackBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSessionTrackBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSessionTrackBlockWhereInput>;
};


export type QueryEventSessionTrackSpeakerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSessionTrackSpeakerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSessionTrackSpeakerBlockWhereInput>;
};


export type QueryEventSpeakerSearchPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSpeakerSearchPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSpeakerSearchPageWhereInput>;
};


export type QueryEventSpeakersBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSpeakersBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSpeakersBlockWhereInput>;
};


export type QueryEventTableContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventTableContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventTableContainerBlockWhereInput>;
};


export type QueryExpandableContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExpandableContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ExpandableContainerBlockWhereInput>;
};


export type QueryFileUploadElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FileUploadElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FileUploadElementBlockWhereInput>;
};


export type QueryFlowFinishInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FlowFinishInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FlowFinishInformationBlockWhereInput>;
};


export type QueryFolderPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FolderPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FolderPageWhereInput>;
};


export type QueryFormContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FormContainerBlockWhereInput>;
};


export type QueryFormStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FormStepBlockWhereInput>;
};


export type QueryFourColumnTableBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FourColumnTableBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FourColumnTableBlockWhereInput>;
};


export type QueryGaugeBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GaugeBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GaugeBlockWhereInput>;
};


export type QueryGeoDataBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GeoDataBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GeoDataBlockWhereInput>;
};


export type QueryGettingStartedStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GettingStartedStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GettingStartedStepBlockWhereInput>;
};


export type QueryGettingStartedStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GettingStartedStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GettingStartedStepV2BlockWhereInput>;
};


export type QueryGreetingCaseBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GreetingCaseBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GreetingCaseBlockWhereInput>;
};


export type QueryGreetingStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GreetingStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GreetingStepBlockWhereInput>;
};


export type QueryGreetingStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GreetingStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GreetingStepV2BlockWhereInput>;
};


export type QueryGsAwardsApplicationsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsApplicationsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsApplicationsBlockWhereInput>;
};


export type QueryGsAwardsConfirmationStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsConfirmationStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsConfirmationStepBlockWhereInput>;
};


export type QueryGsAwardsFileUploadBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsFileUploadBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsFileUploadBlockWhereInput>;
};


export type QueryGsAwardsGettingStartedStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsGettingStartedStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsGettingStartedStepBlockWhereInput>;
};


export type QueryGsAwardsMembershipStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsMembershipStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsMembershipStepBlockWhereInput>;
};


export type QueryGsAwardsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsPageWhereInput>;
};


export type QueryGsAwardsPersistencyStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsPersistencyStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsPersistencyStepBlockWhereInput>;
};


export type QueryGsAwardsProductionStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsProductionStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsProductionStepBlockWhereInput>;
};


export type QueryGsAwardsRecruitmentStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsRecruitmentStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsRecruitmentStepBlockWhereInput>;
};


export type QueryGsAwardsRetentionStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsRetentionStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsRetentionStepBlockWhereInput>;
};


export type QueryGsAwardsSelectApplicantStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsSelectApplicantStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsSelectApplicantStepBlockWhereInput>;
};


export type QueryGsAwardsSubmitStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsSubmitStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsSubmitStepBlockWhereInput>;
};


export type QueryGsAwardsVerificationStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsVerificationStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsVerificationStepBlockWhereInput>;
};


export type QueryGsAwardsWholePersonStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsWholePersonStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsWholePersonStepBlockWhereInput>;
};


export type QueryGsConfirmationStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsConfirmationStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsConfirmationStepBlockWhereInput>;
};


export type QueryGsGettingStartedStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsGettingStartedStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsGettingStartedStepBlockWhereInput>;
};


export type QueryGsGreetingStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsGreetingStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsGreetingStepBlockWhereInput>;
};


export type QueryGsLeadershipInformationStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsLeadershipInformationStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsLeadershipInformationStepBlockWhereInput>;
};


export type QueryGsMembershipRenewalPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsMembershipRenewalPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsMembershipRenewalPageWhereInput>;
};


export type QueryGsProfileStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsProfileStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsProfileStepBlockWhereInput>;
};


export type QueryGsReceiptStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsReceiptStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsReceiptStepBlockWhereInput>;
};


export type QueryGsReviewStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsReviewStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsReviewStepBlockWhereInput>;
};


export type QueryHealthPoliciesSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HealthPoliciesSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HealthPoliciesSectionBlockWhereInput>;
};


export type QueryHeroTextContentBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HeroTextContentBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HeroTextContentBlockWhereInput>;
};


export type QueryHomePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HomePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HomePageWhereInput>;
};


export type QueryHomePageV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HomePageV2OrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HomePageV2WhereInput>;
};


export type QueryIconRequirementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IconRequirementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<IconRequirementBlockWhereInput>;
};


export type QueryImageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageWhereInput>;
};


export type QueryImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageBlockWhereInput>;
};


export type QueryImageCaptionRichTextBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageCaptionRichTextBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageCaptionRichTextBlockWhereInput>;
};


export type QueryImageChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageChoiceElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageChoiceElementBlockWhereInput>;
};


export type QueryImageLinkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageLinkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageLinkBlockWhereInput>;
};


export type QueryImageMediaArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageMediaOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageMediaWhereInput>;
};


export type QueryImageTextBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageTextBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageTextBlockWhereInput>;
};


export type QueryImageTextBlockV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageTextBlockV2OrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageTextBlockV2WhereInput>;
};


export type QueryImageTextCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageTextCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageTextCardBlockWhereInput>;
};


export type QueryImageTextItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageTextItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageTextItemBlockWhereInput>;
};


export type QueryInfoBoxBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<InfoBoxBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<InfoBoxBlockWhereInput>;
};


export type QueryKeyLinkValueBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<KeyLinkValueBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<KeyLinkValueBlockWhereInput>;
};


export type QueryKeyTranslatedValueBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<KeyTranslatedValueBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<KeyTranslatedValueBlockWhereInput>;
};


export type QueryLandingPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LandingPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LandingPageWhereInput>;
};


export type QueryLanguageIdAndNameArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LanguageIdAndNameOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LanguageIdAndNameWhereInput>;
};


export type QueryLanguagesBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LanguagesBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LanguagesBlockWhereInput>;
};


export type QueryLearnCarouselContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnCarouselContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnCarouselContainerBlockWhereInput>;
};


export type QueryLearnCarouselContainerBlockV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnCarouselContainerBlockV2OrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnCarouselContainerBlockV2WhereInput>;
};


export type QueryLearnDetailPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnDetailPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnDetailPageWhereInput>;
};


export type QueryLearnHeroImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnHeroImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnHeroImageBlockWhereInput>;
};


export type QueryLearnLandingPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnLandingPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnLandingPageWhereInput>;
};


export type QueryLearnPageV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnPageV2OrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnPageV2WhereInput>;
};


export type QueryLearnPlayListPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnPlayListPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnPlayListPageWhereInput>;
};


export type QueryLikeAndBookmarkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LikeAndBookmarkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LikeAndBookmarkBlockWhereInput>;
};


export type QueryLinkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LinkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LinkBlockWhereInput>;
};


export type QueryLinkListBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LinkListBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LinkListBlockWhereInput>;
};


export type QueryLinkTileBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LinkTileBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LinkTileBlockWhereInput>;
};


export type QueryLoaderBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LoaderBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LoaderBlockWhereInput>;
};


export type QueryLocationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LocationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LocationBlockWhereInput>;
};


export type QueryMeetingEventCardPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MeetingEventCardPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MeetingEventCardPageWhereInput>;
};


export type QueryMeetingPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MeetingPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MeetingPageWhereInput>;
};


export type QueryMemberDirectoryArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MemberDirectoryOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MemberDirectoryWhereInput>;
};


export type QueryMemberDirectoryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MemberDirectoryPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MemberDirectoryPageWhereInput>;
};


export type QueryMemberSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MemberSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MemberSectionBlockWhereInput>;
};


export type QueryMembersTableHeaderLabelsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembersTableHeaderLabelsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembersTableHeaderLabelsBlockWhereInput>;
};


export type QueryMembershipHistoryDetailBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipHistoryDetailBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipHistoryDetailBlockWhereInput>;
};


export type QueryMembershipHistoryDetailPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipHistoryDetailPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipHistoryDetailPageWhereInput>;
};


export type QueryMembershipInvoicePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipInvoicePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipInvoicePageWhereInput>;
};


export type QueryMembershipLevelBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipLevelBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipLevelBlockWhereInput>;
};


export type QueryMembershipLevelRadioBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipLevelRadioBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipLevelRadioBlockWhereInput>;
};


export type QueryMembershipLevelSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipLevelSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipLevelSectionBlockWhereInput>;
};


export type QueryMembershipLevelStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipLevelStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipLevelStepV2BlockWhereInput>;
};


export type QueryMembershipLevelsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipLevelsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipLevelsBlockWhereInput>;
};


export type QueryMembershipRenewalPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipRenewalPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipRenewalPageWhereInput>;
};


export type QueryMembershipRenewalV2PageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipRenewalV2PageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipRenewalV2PageWhereInput>;
};


export type QueryMembershipRequirementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipRequirementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipRequirementBlockWhereInput>;
};


export type QueryMembershipRequirementsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipRequirementsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipRequirementsBlockWhereInput>;
};


export type QueryMembershipTypeSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipTypeSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipTypeSectionBlockWhereInput>;
};


export type QueryMembershipTypeStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipTypeStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipTypeStepBlockWhereInput>;
};


export type QueryMembershipTypeStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipTypeStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipTypeStepV2BlockWhereInput>;
};


export type QueryModalInfoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ModalInfoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ModalInfoBlockWhereInput>;
};


export type QueryNewIdRequestSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NewIdRequestSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NewIdRequestSectionBlockWhereInput>;
};


export type QueryNextCallOutBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextCallOutBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextCallOutBlockWhereInput>;
};


export type QueryNextContactUsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextContactUsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextContactUsBlockWhereInput>;
};


export type QueryNextContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextContainerBlockWhereInput>;
};


export type QueryNextDeadLetterQueueBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextDeadLetterQueueBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextDeadLetterQueueBlockWhereInput>;
};


export type QueryNextEventBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextEventBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextEventBlockWhereInput>;
};


export type QueryNextHeroBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextHeroBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextHeroBlockWhereInput>;
};


export type QueryNextInfoBoxBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextInfoBoxBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextInfoBoxBlockWhereInput>;
};


export type QueryNextPersonContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextPersonContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextPersonContainerBlockWhereInput>;
};


export type QueryNextPersonDataBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextPersonDataBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextPersonDataBlockWhereInput>;
};


export type QueryNextStaffAdminPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextStaffAdminPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextStaffAdminPageWhereInput>;
};


export type QueryNextStaticPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextStaticPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextStaticPageWhereInput>;
};


export type QueryNextSyncEventsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextSyncEventsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextSyncEventsBlockWhereInput>;
};


export type QueryNotFoundPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NotFoundPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NotFoundPageWhereInput>;
};


export type QueryNumberElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NumberElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NumberElementBlockWhereInput>;
};


export type QueryNumberedContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NumberedContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NumberedContainerBlockWhereInput>;
};


export type QueryNumberedItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NumberedItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NumberedItemBlockWhereInput>;
};


export type QueryParagraphTextElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ParagraphTextElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ParagraphTextElementBlockWhereInput>;
};


export type QueryPastPresidentsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PastPresidentsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PastPresidentsBlockWhereInput>;
};


export type QueryPaymentProcessingScreenBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PaymentProcessingScreenBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PaymentProcessingScreenBlockWhereInput>;
};


export type QueryPersonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PersonBlockWhereInput>;
};


export type QueryPersonContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PersonContainerBlockWhereInput>;
};


export type QueryPersonQuizPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonQuizPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PersonQuizPageWhereInput>;
};


export type QueryPersonUpdatesSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonUpdatesSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PersonUpdatesSectionBlockWhereInput>;
};


export type QueryPlaylistBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PlaylistBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PlaylistBlockWhereInput>;
};


export type QueryPlaylistPromoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PlaylistPromoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PlaylistPromoBlockWhereInput>;
};


export type QueryPodcastDetailBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PodcastDetailBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PodcastDetailBlockWhereInput>;
};


export type QueryPowerPhrasePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PowerPhrasePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PowerPhrasePageWhereInput>;
};


export type QueryPredefinedHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PredefinedHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PredefinedHiddenElementBlockWhereInput>;
};


export type QueryPrepaymentErrorModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentErrorModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentErrorModalBlockWhereInput>;
};


export type QueryPrepaymentErrorPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentErrorPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentErrorPageBlockWhereInput>;
};


export type QueryPrepaymentGenericErrorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentGenericErrorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentGenericErrorBlockWhereInput>;
};


export type QueryPrepaymentHomepageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentHomepageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentHomepageBlockWhereInput>;
};


export type QueryPrepaymentHomepageFellowsDesignationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentHomepageFellowsDesignationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentHomepageFellowsDesignationBlockWhereInput>;
};


export type QueryPrepaymentHomepageGsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentHomepageGsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentHomepageGsBlockWhereInput>;
};


export type QueryPrepaymentHomepageMdrtBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentHomepageMdrtBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentHomepageMdrtBlockWhereInput>;
};


export type QueryPrepaymentLoaderScreenBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentLoaderScreenBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentLoaderScreenBlockWhereInput>;
};


export type QueryPrepaymentMembershipInfoCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentMembershipInfoCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentMembershipInfoCardBlockWhereInput>;
};


export type QueryPrepaymentMembershipInfoPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentMembershipInfoPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentMembershipInfoPageBlockWhereInput>;
};


export type QueryPrepaymentMembershipTypeInfoCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentMembershipTypeInfoCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentMembershipTypeInfoCardBlockWhereInput>;
};


export type QueryPrepaymentPaymentPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentPaymentPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentPaymentPageBlockWhereInput>;
};


export type QueryPrepaymentPaymentStatusPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentPaymentStatusPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentPaymentStatusPageBlockWhereInput>;
};


export type QueryPrepaymentPortalPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentPortalPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentPortalPageWhereInput>;
};


export type QueryPrepaymentProductNamesBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentProductNamesBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentProductNamesBlockWhereInput>;
};


export type QueryPrepaymentSuccessfulPaymentPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentSuccessfulPaymentPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentSuccessfulPaymentPageBlockWhereInput>;
};


export type QueryPressReleasePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PressReleasePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PressReleasePageWhereInput>;
};


export type QueryPriceBreakdownBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PriceBreakdownBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PriceBreakdownBlockWhereInput>;
};


export type QueryProductionAttestmentNumbersBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionAttestmentNumbersBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionAttestmentNumbersBlockWhereInput>;
};


export type QueryProductionDataSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionDataSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionDataSectionBlockWhereInput>;
};


export type QueryProductionDeleteModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionDeleteModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionDeleteModalBlockWhereInput>;
};


export type QueryProductionModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionModalBlockWhereInput>;
};


export type QueryProductionStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionStepBlockWhereInput>;
};


export type QueryProductionStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionStepV2BlockWhereInput>;
};


export type QueryProductionTableBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionTableBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionTableBlockWhereInput>;
};


export type QueryProfileListBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfileListBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfileListBlockWhereInput>;
};


export type QueryProfilePictureBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfilePictureBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfilePictureBlockWhereInput>;
};


export type QueryProfileSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfileSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfileSectionBlockWhereInput>;
};


export type QueryProfileStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfileStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfileStepBlockWhereInput>;
};


export type QueryProfileStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfileStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfileStepV2BlockWhereInput>;
};


export type QueryPublicProfilePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PublicProfilePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PublicProfilePageWhereInput>;
};


export type QueryQuizCareerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizCareerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizCareerBlockWhereInput>;
};


export type QueryQuizEducationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizEducationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizEducationBlockWhereInput>;
};


export type QueryQuizFinancialBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizFinancialBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizFinancialBlockWhereInput>;
};


export type QueryQuizHealthBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizHealthBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizHealthBlockWhereInput>;
};


export type QueryQuizRelationshipsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizRelationshipsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizRelationshipsBlockWhereInput>;
};


export type QueryQuizServiceBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizServiceBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizServiceBlockWhereInput>;
};


export type QueryQuizSpiritualBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizSpiritualBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizSpiritualBlockWhereInput>;
};


export type QueryRtContributorFormPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RtContributorFormPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RtContributorFormPageWhereInput>;
};


export type QueryRangeElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RangeElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RangeElementBlockWhereInput>;
};


export type QueryReceiptStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReceiptStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReceiptStepBlockWhereInput>;
};


export type QueryReceiptStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReceiptStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReceiptStepV2BlockWhereInput>;
};


export type QueryResetButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ResetButtonElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ResetButtonElementBlockWhereInput>;
};


export type QueryReviewAndSubmitStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReviewAndSubmitStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReviewAndSubmitStepV2BlockWhereInput>;
};


export type QueryReviewBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReviewBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReviewBlockWhereInput>;
};


export type QueryReviewStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReviewStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReviewStepBlockWhereInput>;
};


export type QueryRichTextBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RichTextBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RichTextBlockWhereInput>;
};


export type QueryRoutingStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RoutingStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RoutingStepBlockWhereInput>;
};


export type QuerySearchPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SearchPageWhereInput>;
};


export type QuerySearchPageV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchPageV2OrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SearchPageV2WhereInput>;
};


export type QuerySectionContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SectionContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SectionContainerBlockWhereInput>;
};


export type QuerySectionItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SectionItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SectionItemBlockWhereInput>;
};


export type QuerySelectionElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SelectionElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SelectionElementBlockWhereInput>;
};


export type QuerySelfAttestLevelOptionsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SelfAttestLevelOptionsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SelfAttestLevelOptionsBlockWhereInput>;
};


export type QuerySettingSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SettingSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SettingSectionBlockWhereInput>;
};


export type QuerySiteDefinitionArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDefinitionOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SiteDefinitionWhereInput>;
};


export type QuerySiteSettingsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteSettingsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SiteSettingsPageWhereInput>;
};


export type QuerySocialShareBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SocialShareBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SocialShareBlockWhereInput>;
};


export type QuerySpeakerEngagementPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpeakerEngagementPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpeakerEngagementPageWhereInput>;
};


export type QuerySponsorSpeakerPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SponsorSpeakerPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SponsorSpeakerPageWhereInput>;
};


export type QuerySpotlightBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpotlightBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpotlightBlockWhereInput>;
};


export type QuerySpotlightContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpotlightContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpotlightContainerBlockWhereInput>;
};


export type QuerySpotlightDataBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpotlightDataBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpotlightDataBlockWhereInput>;
};


export type QuerySpotlightDataContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpotlightDataContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpotlightDataContainerBlockWhereInput>;
};


export type QueryStoreCardPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StoreCardPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<StoreCardPageWhereInput>;
};


export type QuerySubmitButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SubmitButtonElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SubmitButtonElementBlockWhereInput>;
};


export type QuerySuccessSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SuccessSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SuccessSectionBlockWhereInput>;
};


export type QuerySvgLinkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SvgLinkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SvgLinkBlockWhereInput>;
};


export type QuerySvgMediaArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SvgMediaOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SvgMediaWhereInput>;
};


export type QuerySvgTextCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SvgTextCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SvgTextCardBlockWhereInput>;
};


export type QueryTabContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TabContainerBlockWhereInput>;
};


export type QueryTabItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TabItemBlockWhereInput>;
};


export type QueryTextCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextCardBlockWhereInput>;
};


export type QueryTextContentBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextContentBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextContentBlockWhereInput>;
};


export type QueryTextareaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextareaElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextareaElementBlockWhereInput>;
};


export type QueryTextboxElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextboxElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextboxElementBlockWhereInput>;
};


export type QueryTimelineContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TimelineContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TimelineContainerBlockWhereInput>;
};


export type QueryTimelineItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TimelineItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TimelineItemBlockWhereInput>;
};


export type QueryToolkitBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ToolkitBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ToolkitBlockWhereInput>;
};


export type QueryToolkitItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ToolkitItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ToolkitItemBlockWhereInput>;
};


export type QueryToolkitSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ToolkitSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ToolkitSectionBlockWhereInput>;
};


export type QueryToolsCardPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ToolsCardPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ToolsCardPageWhereInput>;
};


export type QueryTooltipBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TooltipBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TooltipBlockWhereInput>;
};


export type QueryUrlElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<UrlElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<UrlElementBlockWhereInput>;
};


export type QueryVideoArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoWhereInput>;
};


export type QueryVideoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoBlockWhereInput>;
};


export type QueryVideoDetailBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoDetailBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoDetailBlockWhereInput>;
};


export type QueryVideoMediaArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoMediaOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoMediaWhereInput>;
};


export type QueryVideoPromoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoPromoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoPromoBlockWhereInput>;
};


export type QueryVisaLettersPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VisaLettersPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VisaLettersPageWhereInput>;
};


export type QueryVisibilityOptionsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VisibilityOptionsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VisibilityOptionsBlockWhereInput>;
};


export type QueryVisitorDataHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VisitorDataHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VisitorDataHiddenElementBlockWhereInput>;
};


export type QueryWireTransferSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<WireTransferSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<WireTransferSectionBlockWhereInput>;
};


export type QueryYourAnswersSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<YourAnswersSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<YourAnswersSectionBlockWhereInput>;
};

export type QueryRef = {
  __typename?: 'QueryRef';
  AMPSectionBlock?: Maybe<AmpSectionBlockOutput>;
  AccordionContainerBlock?: Maybe<AccordionContainerBlockOutput>;
  AccordionItemBlock?: Maybe<AccordionItemBlockOutput>;
  AccountProfilePage?: Maybe<AccountProfilePageOutput>;
  AddressInfoBlock?: Maybe<AddressInfoBlockOutput>;
  BadgeBlock?: Maybe<BadgeBlockOutput>;
  BrandedTableBlock?: Maybe<BrandedTableBlockOutput>;
  BulkImporterUploaderSectionBlock?: Maybe<BulkImporterUploaderSectionBlockOutput>;
  ButtonLabelBlock?: Maybe<ButtonLabelBlockOutput>;
  CaptchaElementBlock?: Maybe<CaptchaElementBlockOutput>;
  CategoryListBlock?: Maybe<CategoryListBlockOutput>;
  CertifyingOfficerSectionBlock?: Maybe<CertifyingOfficerSectionBlockOutput>;
  CflBadgesBlock?: Maybe<CflBadgesBlockOutput>;
  CflHomePage?: Maybe<CflHomePageOutput>;
  CflMembershipKitCardBlock?: Maybe<CflMembershipKitCardBlockOutput>;
  CflMembershipKitCarouselBlock?: Maybe<CflMembershipKitCarouselBlockOutput>;
  CflSiteSettingsPage?: Maybe<CflSiteSettingsPageOutput>;
  CflSpecialResourceCardBlock?: Maybe<CflSpecialResourceCardBlockOutput>;
  ChoiceElementBlock?: Maybe<ChoiceElementBlockOutput>;
  ColumnContainerBlock?: Maybe<ColumnContainerBlockOutput>;
  ColumnLinksListContainerBlock?: Maybe<ColumnLinksListContainerBlockOutput>;
  ColumnLinksListItemBlock?: Maybe<ColumnLinksListItemBlockOutput>;
  CompanyAdminBulkImportDashboardSectionBlock?: Maybe<CompanyAdminBulkImportDashboardSectionBlockOutput>;
  CompanyAdminBulkImportGettingStartedSectionBlock?: Maybe<CompanyAdminBulkImportGettingStartedSectionBlockOutput>;
  CompanyAdminBulkImportPage?: Maybe<CompanyAdminBulkImportPageOutput>;
  CompanyAdminCompanyListingsPage?: Maybe<CompanyAdminCompanyListingsPageOutput>;
  CompanyAdminMembershipDirectoryPage?: Maybe<CompanyAdminMembershipDirectoryPageOutput>;
  CompanyRankingsPage?: Maybe<CompanyRankingsPageOutput>;
  ConfirmationModalBlock?: Maybe<ConfirmationModalBlockOutput>;
  ConfirmationStepBlock?: Maybe<ConfirmationStepBlockOutput>;
  CongratulationsStepV2Block?: Maybe<CongratulationsStepV2BlockOutput>;
  ContactEmailElementBlock?: Maybe<ContactEmailElementBlockOutput>;
  ContactMdrtIdElementBlock?: Maybe<ContactMdrtIdElementBlockOutput>;
  ContactNameElementBlock?: Maybe<ContactNameElementBlockOutput>;
  ContactPhoneElementBlock?: Maybe<ContactPhoneElementBlockOutput>;
  ContactsBlock?: Maybe<ContactsBlockOutput>;
  Content?: Maybe<ContentOutput>;
  DAMAsset?: Maybe<DamAssetOutput>;
  DAMImageAsset?: Maybe<DamImageAssetOutput>;
  DAMVideo?: Maybe<DamVideoOutput>;
  DAMVideoAsset?: Maybe<DamVideoAssetOutput>;
  DashBoardSectionBlock?: Maybe<DashBoardSectionBlockOutput>;
  DashboardAccountPage?: Maybe<DashboardAccountPageOutput>;
  DashboardCarouselCardBlock?: Maybe<DashboardCarouselCardBlockOutput>;
  DashboardContactInformationBlock?: Maybe<DashboardContactInformationBlockOutput>;
  DashboardLoginPasswordBlock?: Maybe<DashboardLoginPasswordBlockOutput>;
  DashboardPermissionsBlock?: Maybe<DashboardPermissionsBlockOutput>;
  DashboardPersonalInformationBlock?: Maybe<DashboardPersonalInformationBlockOutput>;
  DashboardProfessionalInformationBlock?: Maybe<DashboardProfessionalInformationBlockOutput>;
  DashboardProfileBlock?: Maybe<DashboardProfileBlockOutput>;
  DashboardSharedPage?: Maybe<DashboardSharedPageOutput>;
  DashboardSitePreferencesBlock?: Maybe<DashboardSitePreferencesBlockOutput>;
  Data?: Maybe<DataOutput>;
  DataMismatchModalBlock?: Maybe<DataMismatchModalBlockOutput>;
  DeleteCertifyinLetterModalBlock?: Maybe<DeleteCertifyinLetterModalBlockOutput>;
  DescriptionButtonBlock?: Maybe<DescriptionButtonBlockOutput>;
  DetailPage?: Maybe<DetailPageOutput>;
  DocumentMedia?: Maybe<DocumentMediaOutput>;
  DonationBlock?: Maybe<DonationBlockOutput>;
  DownloadUploadSectionBlock?: Maybe<DownloadUploadSectionBlockOutput>;
  EEPSectionBlock?: Maybe<EepSectionBlockOutput>;
  EVPCarouselBlock?: Maybe<EvpCarouselBlockOutput>;
  EVPCarouselQuoteBlock?: Maybe<EvpCarouselQuoteBlockOutput>;
  EVPCarouselQuoteSlideBlock?: Maybe<EvpCarouselQuoteSlideBlockOutput>;
  EVPCarouselSlideBlock?: Maybe<EvpCarouselSlideBlockOutput>;
  EVPContentBlock?: Maybe<EvpContentBlockOutput>;
  EVPFeaturedResourcesBlock?: Maybe<EvpFeaturedResourcesBlockOutput>;
  EVPGenericPage?: Maybe<EvpGenericPageOutput>;
  EVPHeroQuoteBlock?: Maybe<EvpHeroQuoteBlockOutput>;
  EVPHomePage?: Maybe<EvpHomePageOutput>;
  EVPImageBlock?: Maybe<EvpImageBlockOutput>;
  EVPImageLinkBlock?: Maybe<EvpImageLinkBlockOutput>;
  EVPLanguageSelectorBlock?: Maybe<EvpLanguageSelectorBlockOutput>;
  EVPLinkBlock?: Maybe<EvpLinkBlockOutput>;
  EVPMediaFileBlock?: Maybe<EvpMediaFileBlockOutput>;
  EVPNavigationPageBlock?: Maybe<EvpNavigationPageBlockOutput>;
  EVPPartnerSettingsBlock?: Maybe<EvpPartnerSettingsBlockOutput>;
  EVPResourcePage?: Maybe<EvpResourcePageOutput>;
  EVPSearchHeaderBlock?: Maybe<EvpSearchHeaderBlockOutput>;
  EVPSearchPage?: Maybe<EvpSearchPageOutput>;
  EVPSiteSettingsPage?: Maybe<EvpSiteSettingsPageOutput>;
  EVPTabBlock?: Maybe<EvpTabBlockOutput>;
  EVPTabCardBlock?: Maybe<EvpTabCardBlockOutput>;
  EVPTabCardsBlock?: Maybe<EvpTabCardsBlockOutput>;
  EVPTabImageTextBlock?: Maybe<EvpTabImageTextBlockOutput>;
  EVPTabRichTextBlock?: Maybe<EvpTabRichTextBlockOutput>;
  EVPTabVideoBlock?: Maybe<EvpTabVideoBlockOutput>;
  EVPTabsBlock?: Maybe<EvpTabsBlockOutput>;
  EVPTextImageBlock?: Maybe<EvpTextImageBlockOutput>;
  EVPVideoBlock?: Maybe<EvpVideoBlockOutput>;
  EmployeeTableHeaderLabelsBlock?: Maybe<EmployeeTableHeaderLabelsBlockOutput>;
  ErrorModalBlock?: Maybe<ErrorModalBlockOutput>;
  ErrorPage?: Maybe<ErrorPageOutput>;
  ErrorPageBlock?: Maybe<ErrorPageBlockOutput>;
  EventBlock?: Maybe<EventBlockOutput>;
  EventLocationAndDateBlock?: Maybe<EventLocationAndDateBlockOutput>;
  EventLocationInformationBlock?: Maybe<EventLocationInformationBlockOutput>;
  EventPage?: Maybe<EventPageOutput>;
  EventRegistrationInformationBlock?: Maybe<EventRegistrationInformationBlockOutput>;
  EventSessionBlock?: Maybe<EventSessionBlockOutput>;
  EventSessionScheduleBlock?: Maybe<EventSessionScheduleBlockOutput>;
  EventSessionTrackBlock?: Maybe<EventSessionTrackBlockOutput>;
  EventSessionTrackSpeakerBlock?: Maybe<EventSessionTrackSpeakerBlockOutput>;
  EventSpeakerSearchPage?: Maybe<EventSpeakerSearchPageOutput>;
  EventSpeakersBlock?: Maybe<EventSpeakersBlockOutput>;
  EventTableContainerBlock?: Maybe<EventTableContainerBlockOutput>;
  ExpandableContainerBlock?: Maybe<ExpandableContainerBlockOutput>;
  FileUploadElementBlock?: Maybe<FileUploadElementBlockOutput>;
  FlowFinishInformationBlock?: Maybe<FlowFinishInformationBlockOutput>;
  FolderPage?: Maybe<FolderPageOutput>;
  FormContainerBlock?: Maybe<FormContainerBlockOutput>;
  FormStepBlock?: Maybe<FormStepBlockOutput>;
  FourColumnTableBlock?: Maybe<FourColumnTableBlockOutput>;
  GaugeBlock?: Maybe<GaugeBlockOutput>;
  GeoDataBlock?: Maybe<GeoDataBlockOutput>;
  GettingStartedStepBlock?: Maybe<GettingStartedStepBlockOutput>;
  GettingStartedStepV2Block?: Maybe<GettingStartedStepV2BlockOutput>;
  GreetingCaseBlock?: Maybe<GreetingCaseBlockOutput>;
  GreetingStepBlock?: Maybe<GreetingStepBlockOutput>;
  GreetingStepV2Block?: Maybe<GreetingStepV2BlockOutput>;
  GsAwardsApplicationsBlock?: Maybe<GsAwardsApplicationsBlockOutput>;
  GsAwardsConfirmationStepBlock?: Maybe<GsAwardsConfirmationStepBlockOutput>;
  GsAwardsFileUploadBlock?: Maybe<GsAwardsFileUploadBlockOutput>;
  GsAwardsGettingStartedStepBlock?: Maybe<GsAwardsGettingStartedStepBlockOutput>;
  GsAwardsMembershipStepBlock?: Maybe<GsAwardsMembershipStepBlockOutput>;
  GsAwardsPage?: Maybe<GsAwardsPageOutput>;
  GsAwardsPersistencyStepBlock?: Maybe<GsAwardsPersistencyStepBlockOutput>;
  GsAwardsProductionStepBlock?: Maybe<GsAwardsProductionStepBlockOutput>;
  GsAwardsRecruitmentStepBlock?: Maybe<GsAwardsRecruitmentStepBlockOutput>;
  GsAwardsRetentionStepBlock?: Maybe<GsAwardsRetentionStepBlockOutput>;
  GsAwardsSelectApplicantStepBlock?: Maybe<GsAwardsSelectApplicantStepBlockOutput>;
  GsAwardsSubmitStepBlock?: Maybe<GsAwardsSubmitStepBlockOutput>;
  GsAwardsVerificationStepBlock?: Maybe<GsAwardsVerificationStepBlockOutput>;
  GsAwardsWholePersonStepBlock?: Maybe<GsAwardsWholePersonStepBlockOutput>;
  GsConfirmationStepBlock?: Maybe<GsConfirmationStepBlockOutput>;
  GsGettingStartedStepBlock?: Maybe<GsGettingStartedStepBlockOutput>;
  GsGreetingStepBlock?: Maybe<GsGreetingStepBlockOutput>;
  GsLeadershipInformationStepBlock?: Maybe<GsLeadershipInformationStepBlockOutput>;
  GsMembershipRenewalPage?: Maybe<GsMembershipRenewalPageOutput>;
  GsProfileStepBlock?: Maybe<GsProfileStepBlockOutput>;
  GsReceiptStepBlock?: Maybe<GsReceiptStepBlockOutput>;
  GsReviewStepBlock?: Maybe<GsReviewStepBlockOutput>;
  HealthPoliciesSectionBlock?: Maybe<HealthPoliciesSectionBlockOutput>;
  HeroTextContentBlock?: Maybe<HeroTextContentBlockOutput>;
  HomePage?: Maybe<HomePageOutput>;
  HomePageV2?: Maybe<HomePageV2Output>;
  IconRequirementBlock?: Maybe<IconRequirementBlockOutput>;
  Image?: Maybe<ImageOutput>;
  ImageBlock?: Maybe<ImageBlockOutput>;
  ImageCaptionRichTextBlock?: Maybe<ImageCaptionRichTextBlockOutput>;
  ImageChoiceElementBlock?: Maybe<ImageChoiceElementBlockOutput>;
  ImageLinkBlock?: Maybe<ImageLinkBlockOutput>;
  ImageMedia?: Maybe<ImageMediaOutput>;
  ImageTextBlock?: Maybe<ImageTextBlockOutput>;
  ImageTextBlockV2?: Maybe<ImageTextBlockV2Output>;
  ImageTextCardBlock?: Maybe<ImageTextCardBlockOutput>;
  ImageTextItemBlock?: Maybe<ImageTextItemBlockOutput>;
  InfoBoxBlock?: Maybe<InfoBoxBlockOutput>;
  KeyLinkValueBlock?: Maybe<KeyLinkValueBlockOutput>;
  KeyTranslatedValueBlock?: Maybe<KeyTranslatedValueBlockOutput>;
  LandingPage?: Maybe<LandingPageOutput>;
  LanguageIdAndName?: Maybe<LanguageIdAndNameOutput>;
  LanguagesBlock?: Maybe<LanguagesBlockOutput>;
  LearnCarouselContainerBlock?: Maybe<LearnCarouselContainerBlockOutput>;
  LearnCarouselContainerBlockV2?: Maybe<LearnCarouselContainerBlockV2Output>;
  LearnDetailPage?: Maybe<LearnDetailPageOutput>;
  LearnHeroImageBlock?: Maybe<LearnHeroImageBlockOutput>;
  LearnLandingPage?: Maybe<LearnLandingPageOutput>;
  LearnPageV2?: Maybe<LearnPageV2Output>;
  LearnPlayListPage?: Maybe<LearnPlayListPageOutput>;
  LikeAndBookmarkBlock?: Maybe<LikeAndBookmarkBlockOutput>;
  LinkBlock?: Maybe<LinkBlockOutput>;
  LinkListBlock?: Maybe<LinkListBlockOutput>;
  LinkTileBlock?: Maybe<LinkTileBlockOutput>;
  LoaderBlock?: Maybe<LoaderBlockOutput>;
  LocationBlock?: Maybe<LocationBlockOutput>;
  MeetingEventCardPage?: Maybe<MeetingEventCardPageOutput>;
  MeetingPage?: Maybe<MeetingPageOutput>;
  MemberDirectory?: Maybe<MemberDirectoryOutput>;
  MemberDirectoryPage?: Maybe<MemberDirectoryPageOutput>;
  MemberSectionBlock?: Maybe<MemberSectionBlockOutput>;
  MembersTableHeaderLabelsBlock?: Maybe<MembersTableHeaderLabelsBlockOutput>;
  MembershipHistoryDetailBlock?: Maybe<MembershipHistoryDetailBlockOutput>;
  MembershipHistoryDetailPage?: Maybe<MembershipHistoryDetailPageOutput>;
  MembershipInvoicePage?: Maybe<MembershipInvoicePageOutput>;
  MembershipLevelBlock?: Maybe<MembershipLevelBlockOutput>;
  MembershipLevelRadioBlock?: Maybe<MembershipLevelRadioBlockOutput>;
  MembershipLevelSectionBlock?: Maybe<MembershipLevelSectionBlockOutput>;
  MembershipLevelStepV2Block?: Maybe<MembershipLevelStepV2BlockOutput>;
  MembershipLevelsBlock?: Maybe<MembershipLevelsBlockOutput>;
  MembershipRenewalPage?: Maybe<MembershipRenewalPageOutput>;
  MembershipRenewalV2Page?: Maybe<MembershipRenewalV2PageOutput>;
  MembershipRequirementBlock?: Maybe<MembershipRequirementBlockOutput>;
  MembershipRequirementsBlock?: Maybe<MembershipRequirementsBlockOutput>;
  MembershipTypeSectionBlock?: Maybe<MembershipTypeSectionBlockOutput>;
  MembershipTypeStepBlock?: Maybe<MembershipTypeStepBlockOutput>;
  MembershipTypeStepV2Block?: Maybe<MembershipTypeStepV2BlockOutput>;
  ModalInfoBlock?: Maybe<ModalInfoBlockOutput>;
  NewIDRequestSectionBlock?: Maybe<NewIdRequestSectionBlockOutput>;
  NextCallOutBlock?: Maybe<NextCallOutBlockOutput>;
  NextContactUsBlock?: Maybe<NextContactUsBlockOutput>;
  NextContainerBlock?: Maybe<NextContainerBlockOutput>;
  NextDeadLetterQueueBlock?: Maybe<NextDeadLetterQueueBlockOutput>;
  NextEventBlock?: Maybe<NextEventBlockOutput>;
  NextHeroBlock?: Maybe<NextHeroBlockOutput>;
  NextInfoBoxBlock?: Maybe<NextInfoBoxBlockOutput>;
  NextPersonContainerBlock?: Maybe<NextPersonContainerBlockOutput>;
  NextPersonDataBlock?: Maybe<NextPersonDataBlockOutput>;
  NextStaffAdminPage?: Maybe<NextStaffAdminPageOutput>;
  NextStaticPage?: Maybe<NextStaticPageOutput>;
  NextSyncEventsBlock?: Maybe<NextSyncEventsBlockOutput>;
  NotFoundPage?: Maybe<NotFoundPageOutput>;
  NumberElementBlock?: Maybe<NumberElementBlockOutput>;
  NumberedContainerBlock?: Maybe<NumberedContainerBlockOutput>;
  NumberedItemBlock?: Maybe<NumberedItemBlockOutput>;
  ParagraphTextElementBlock?: Maybe<ParagraphTextElementBlockOutput>;
  PastPresidentsBlock?: Maybe<PastPresidentsBlockOutput>;
  PaymentProcessingScreenBlock?: Maybe<PaymentProcessingScreenBlockOutput>;
  PersonBlock?: Maybe<PersonBlockOutput>;
  PersonContainerBlock?: Maybe<PersonContainerBlockOutput>;
  PersonQuizPage?: Maybe<PersonQuizPageOutput>;
  PersonUpdatesSectionBlock?: Maybe<PersonUpdatesSectionBlockOutput>;
  PlaylistBlock?: Maybe<PlaylistBlockOutput>;
  PlaylistPromoBlock?: Maybe<PlaylistPromoBlockOutput>;
  PodcastDetailBlock?: Maybe<PodcastDetailBlockOutput>;
  PowerPhrasePage?: Maybe<PowerPhrasePageOutput>;
  PredefinedHiddenElementBlock?: Maybe<PredefinedHiddenElementBlockOutput>;
  PrepaymentErrorModalBlock?: Maybe<PrepaymentErrorModalBlockOutput>;
  PrepaymentErrorPageBlock?: Maybe<PrepaymentErrorPageBlockOutput>;
  PrepaymentGenericErrorBlock?: Maybe<PrepaymentGenericErrorBlockOutput>;
  PrepaymentHomepageBlock?: Maybe<PrepaymentHomepageBlockOutput>;
  PrepaymentHomepageFellowsDesignationBlock?: Maybe<PrepaymentHomepageFellowsDesignationBlockOutput>;
  PrepaymentHomepageGsBlock?: Maybe<PrepaymentHomepageGsBlockOutput>;
  PrepaymentHomepageMdrtBlock?: Maybe<PrepaymentHomepageMdrtBlockOutput>;
  PrepaymentLoaderScreenBlock?: Maybe<PrepaymentLoaderScreenBlockOutput>;
  PrepaymentMembershipInfoCardBlock?: Maybe<PrepaymentMembershipInfoCardBlockOutput>;
  PrepaymentMembershipInfoPageBlock?: Maybe<PrepaymentMembershipInfoPageBlockOutput>;
  PrepaymentMembershipTypeInfoCardBlock?: Maybe<PrepaymentMembershipTypeInfoCardBlockOutput>;
  PrepaymentPaymentPageBlock?: Maybe<PrepaymentPaymentPageBlockOutput>;
  PrepaymentPaymentStatusPageBlock?: Maybe<PrepaymentPaymentStatusPageBlockOutput>;
  PrepaymentPortalPage?: Maybe<PrepaymentPortalPageOutput>;
  PrepaymentProductNamesBlock?: Maybe<PrepaymentProductNamesBlockOutput>;
  PrepaymentSuccessfulPaymentPageBlock?: Maybe<PrepaymentSuccessfulPaymentPageBlockOutput>;
  PressReleasePage?: Maybe<PressReleasePageOutput>;
  PriceBreakdownBlock?: Maybe<PriceBreakdownBlockOutput>;
  ProductionAttestmentNumbersBlock?: Maybe<ProductionAttestmentNumbersBlockOutput>;
  ProductionDataSectionBlock?: Maybe<ProductionDataSectionBlockOutput>;
  ProductionDeleteModalBlock?: Maybe<ProductionDeleteModalBlockOutput>;
  ProductionModalBlock?: Maybe<ProductionModalBlockOutput>;
  ProductionStepBlock?: Maybe<ProductionStepBlockOutput>;
  ProductionStepV2Block?: Maybe<ProductionStepV2BlockOutput>;
  ProductionTableBlock?: Maybe<ProductionTableBlockOutput>;
  ProfileListBlock?: Maybe<ProfileListBlockOutput>;
  ProfilePictureBlock?: Maybe<ProfilePictureBlockOutput>;
  ProfileSectionBlock?: Maybe<ProfileSectionBlockOutput>;
  ProfileStepBlock?: Maybe<ProfileStepBlockOutput>;
  ProfileStepV2Block?: Maybe<ProfileStepV2BlockOutput>;
  PublicProfilePage?: Maybe<PublicProfilePageOutput>;
  QuizCareerBlock?: Maybe<QuizCareerBlockOutput>;
  QuizEducationBlock?: Maybe<QuizEducationBlockOutput>;
  QuizFinancialBlock?: Maybe<QuizFinancialBlockOutput>;
  QuizHealthBlock?: Maybe<QuizHealthBlockOutput>;
  QuizRelationshipsBlock?: Maybe<QuizRelationshipsBlockOutput>;
  QuizServiceBlock?: Maybe<QuizServiceBlockOutput>;
  QuizSpiritualBlock?: Maybe<QuizSpiritualBlockOutput>;
  RTContributorFormPage?: Maybe<RtContributorFormPageOutput>;
  RangeElementBlock?: Maybe<RangeElementBlockOutput>;
  ReceiptStepBlock?: Maybe<ReceiptStepBlockOutput>;
  ReceiptStepV2Block?: Maybe<ReceiptStepV2BlockOutput>;
  ResetButtonElementBlock?: Maybe<ResetButtonElementBlockOutput>;
  ReviewAndSubmitStepV2Block?: Maybe<ReviewAndSubmitStepV2BlockOutput>;
  ReviewBlock?: Maybe<ReviewBlockOutput>;
  ReviewStepBlock?: Maybe<ReviewStepBlockOutput>;
  RichTextBlock?: Maybe<RichTextBlockOutput>;
  RoutingStepBlock?: Maybe<RoutingStepBlockOutput>;
  SearchPage?: Maybe<SearchPageOutput>;
  SearchPageV2?: Maybe<SearchPageV2Output>;
  SectionContainerBlock?: Maybe<SectionContainerBlockOutput>;
  SectionItemBlock?: Maybe<SectionItemBlockOutput>;
  SelectionElementBlock?: Maybe<SelectionElementBlockOutput>;
  SelfAttestLevelOptionsBlock?: Maybe<SelfAttestLevelOptionsBlockOutput>;
  SettingSectionBlock?: Maybe<SettingSectionBlockOutput>;
  SiteDefinition?: Maybe<SiteDefinitionOutput>;
  SiteSettingsPage?: Maybe<SiteSettingsPageOutput>;
  SocialShareBlock?: Maybe<SocialShareBlockOutput>;
  SpeakerEngagementPage?: Maybe<SpeakerEngagementPageOutput>;
  SponsorSpeakerPage?: Maybe<SponsorSpeakerPageOutput>;
  SpotlightBlock?: Maybe<SpotlightBlockOutput>;
  SpotlightContainerBlock?: Maybe<SpotlightContainerBlockOutput>;
  SpotlightDataBlock?: Maybe<SpotlightDataBlockOutput>;
  SpotlightDataContainerBlock?: Maybe<SpotlightDataContainerBlockOutput>;
  StoreCardPage?: Maybe<StoreCardPageOutput>;
  SubmitButtonElementBlock?: Maybe<SubmitButtonElementBlockOutput>;
  SuccessSectionBlock?: Maybe<SuccessSectionBlockOutput>;
  SvgLinkBlock?: Maybe<SvgLinkBlockOutput>;
  SvgMedia?: Maybe<SvgMediaOutput>;
  SvgTextCardBlock?: Maybe<SvgTextCardBlockOutput>;
  TabContainerBlock?: Maybe<TabContainerBlockOutput>;
  TabItemBlock?: Maybe<TabItemBlockOutput>;
  TextCardBlock?: Maybe<TextCardBlockOutput>;
  TextContentBlock?: Maybe<TextContentBlockOutput>;
  TextareaElementBlock?: Maybe<TextareaElementBlockOutput>;
  TextboxElementBlock?: Maybe<TextboxElementBlockOutput>;
  TimelineContainerBlock?: Maybe<TimelineContainerBlockOutput>;
  TimelineItemBlock?: Maybe<TimelineItemBlockOutput>;
  ToolkitBlock?: Maybe<ToolkitBlockOutput>;
  ToolkitItemBlock?: Maybe<ToolkitItemBlockOutput>;
  ToolkitSectionBlock?: Maybe<ToolkitSectionBlockOutput>;
  ToolsCardPage?: Maybe<ToolsCardPageOutput>;
  TooltipBlock?: Maybe<TooltipBlockOutput>;
  UrlElementBlock?: Maybe<UrlElementBlockOutput>;
  Video?: Maybe<VideoOutput>;
  VideoBlock?: Maybe<VideoBlockOutput>;
  VideoDetailBlock?: Maybe<VideoDetailBlockOutput>;
  VideoMedia?: Maybe<VideoMediaOutput>;
  VideoPromoBlock?: Maybe<VideoPromoBlockOutput>;
  VisaLettersPage?: Maybe<VisaLettersPageOutput>;
  VisibilityOptionsBlock?: Maybe<VisibilityOptionsBlockOutput>;
  VisitorDataHiddenElementBlock?: Maybe<VisitorDataHiddenElementBlockOutput>;
  WireTransferSectionBlock?: Maybe<WireTransferSectionBlockOutput>;
  YourAnswersSectionBlock?: Maybe<YourAnswersSectionBlockOutput>;
};


export type QueryRefAmpSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AmpSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AmpSectionBlockWhereInput>;
};


export type QueryRefAccordionContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AccordionContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AccordionContainerBlockWhereInput>;
};


export type QueryRefAccordionItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AccordionItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AccordionItemBlockWhereInput>;
};


export type QueryRefAccountProfilePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AccountProfilePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AccountProfilePageWhereInput>;
};


export type QueryRefAddressInfoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AddressInfoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<AddressInfoBlockWhereInput>;
};


export type QueryRefBadgeBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BadgeBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BadgeBlockWhereInput>;
};


export type QueryRefBrandedTableBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BrandedTableBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BrandedTableBlockWhereInput>;
};


export type QueryRefBulkImporterUploaderSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BulkImporterUploaderSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<BulkImporterUploaderSectionBlockWhereInput>;
};


export type QueryRefButtonLabelBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ButtonLabelBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ButtonLabelBlockWhereInput>;
};


export type QueryRefCaptchaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CaptchaElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CaptchaElementBlockWhereInput>;
};


export type QueryRefCategoryListBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CategoryListBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CategoryListBlockWhereInput>;
};


export type QueryRefCertifyingOfficerSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CertifyingOfficerSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CertifyingOfficerSectionBlockWhereInput>;
};


export type QueryRefCflBadgesBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflBadgesBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflBadgesBlockWhereInput>;
};


export type QueryRefCflHomePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflHomePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflHomePageWhereInput>;
};


export type QueryRefCflMembershipKitCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflMembershipKitCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflMembershipKitCardBlockWhereInput>;
};


export type QueryRefCflMembershipKitCarouselBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflMembershipKitCarouselBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflMembershipKitCarouselBlockWhereInput>;
};


export type QueryRefCflSiteSettingsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflSiteSettingsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflSiteSettingsPageWhereInput>;
};


export type QueryRefCflSpecialResourceCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CflSpecialResourceCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CflSpecialResourceCardBlockWhereInput>;
};


export type QueryRefChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ChoiceElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ChoiceElementBlockWhereInput>;
};


export type QueryRefColumnContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ColumnContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ColumnContainerBlockWhereInput>;
};


export type QueryRefColumnLinksListContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ColumnLinksListContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ColumnLinksListContainerBlockWhereInput>;
};


export type QueryRefColumnLinksListItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ColumnLinksListItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ColumnLinksListItemBlockWhereInput>;
};


export type QueryRefCompanyAdminBulkImportDashboardSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyAdminBulkImportDashboardSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyAdminBulkImportDashboardSectionBlockWhereInput>;
};


export type QueryRefCompanyAdminBulkImportGettingStartedSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyAdminBulkImportGettingStartedSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyAdminBulkImportGettingStartedSectionBlockWhereInput>;
};


export type QueryRefCompanyAdminBulkImportPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyAdminBulkImportPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyAdminBulkImportPageWhereInput>;
};


export type QueryRefCompanyAdminCompanyListingsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyAdminCompanyListingsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyAdminCompanyListingsPageWhereInput>;
};


export type QueryRefCompanyAdminMembershipDirectoryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyAdminMembershipDirectoryPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyAdminMembershipDirectoryPageWhereInput>;
};


export type QueryRefCompanyRankingsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyRankingsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CompanyRankingsPageWhereInput>;
};


export type QueryRefConfirmationModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ConfirmationModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ConfirmationModalBlockWhereInput>;
};


export type QueryRefConfirmationStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ConfirmationStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ConfirmationStepBlockWhereInput>;
};


export type QueryRefCongratulationsStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CongratulationsStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<CongratulationsStepV2BlockWhereInput>;
};


export type QueryRefContactEmailElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContactEmailElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContactEmailElementBlockWhereInput>;
};


export type QueryRefContactMdrtIdElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContactMdrtIdElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContactMdrtIdElementBlockWhereInput>;
};


export type QueryRefContactNameElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContactNameElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContactNameElementBlockWhereInput>;
};


export type QueryRefContactPhoneElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContactPhoneElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContactPhoneElementBlockWhereInput>;
};


export type QueryRefContactsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContactsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContactsBlockWhereInput>;
};


export type QueryRefContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryRefDamAssetArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DamAssetOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DamAssetWhereInput>;
};


export type QueryRefDamImageAssetArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DamImageAssetOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DamImageAssetWhereInput>;
};


export type QueryRefDamVideoArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DamVideoOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DamVideoWhereInput>;
};


export type QueryRefDamVideoAssetArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DamVideoAssetOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DamVideoAssetWhereInput>;
};


export type QueryRefDashBoardSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashBoardSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashBoardSectionBlockWhereInput>;
};


export type QueryRefDashboardAccountPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardAccountPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardAccountPageWhereInput>;
};


export type QueryRefDashboardCarouselCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardCarouselCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardCarouselCardBlockWhereInput>;
};


export type QueryRefDashboardContactInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardContactInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardContactInformationBlockWhereInput>;
};


export type QueryRefDashboardLoginPasswordBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardLoginPasswordBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardLoginPasswordBlockWhereInput>;
};


export type QueryRefDashboardPermissionsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardPermissionsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardPermissionsBlockWhereInput>;
};


export type QueryRefDashboardPersonalInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardPersonalInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardPersonalInformationBlockWhereInput>;
};


export type QueryRefDashboardProfessionalInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardProfessionalInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardProfessionalInformationBlockWhereInput>;
};


export type QueryRefDashboardProfileBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardProfileBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardProfileBlockWhereInput>;
};


export type QueryRefDashboardSharedPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardSharedPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardSharedPageWhereInput>;
};


export type QueryRefDashboardSitePreferencesBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DashboardSitePreferencesBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DashboardSitePreferencesBlockWhereInput>;
};


export type QueryRefDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<System_Locales>>>;
  orderBy?: InputMaybe<DataOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DataWhereInput>;
};


export type QueryRefDataMismatchModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DataMismatchModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DataMismatchModalBlockWhereInput>;
};


export type QueryRefDeleteCertifyinLetterModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DeleteCertifyinLetterModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DeleteCertifyinLetterModalBlockWhereInput>;
};


export type QueryRefDescriptionButtonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DescriptionButtonBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DescriptionButtonBlockWhereInput>;
};


export type QueryRefDetailPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DetailPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DetailPageWhereInput>;
};


export type QueryRefDocumentMediaArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DocumentMediaOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DocumentMediaWhereInput>;
};


export type QueryRefDonationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DonationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DonationBlockWhereInput>;
};


export type QueryRefDownloadUploadSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DownloadUploadSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<DownloadUploadSectionBlockWhereInput>;
};


export type QueryRefEepSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EepSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EepSectionBlockWhereInput>;
};


export type QueryRefEvpCarouselBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpCarouselBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpCarouselBlockWhereInput>;
};


export type QueryRefEvpCarouselQuoteBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpCarouselQuoteBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpCarouselQuoteBlockWhereInput>;
};


export type QueryRefEvpCarouselQuoteSlideBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpCarouselQuoteSlideBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpCarouselQuoteSlideBlockWhereInput>;
};


export type QueryRefEvpCarouselSlideBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpCarouselSlideBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpCarouselSlideBlockWhereInput>;
};


export type QueryRefEvpContentBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpContentBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpContentBlockWhereInput>;
};


export type QueryRefEvpFeaturedResourcesBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpFeaturedResourcesBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpFeaturedResourcesBlockWhereInput>;
};


export type QueryRefEvpGenericPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpGenericPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpGenericPageWhereInput>;
};


export type QueryRefEvpHeroQuoteBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpHeroQuoteBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpHeroQuoteBlockWhereInput>;
};


export type QueryRefEvpHomePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpHomePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpHomePageWhereInput>;
};


export type QueryRefEvpImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpImageBlockWhereInput>;
};


export type QueryRefEvpImageLinkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpImageLinkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpImageLinkBlockWhereInput>;
};


export type QueryRefEvpLanguageSelectorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpLanguageSelectorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpLanguageSelectorBlockWhereInput>;
};


export type QueryRefEvpLinkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpLinkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpLinkBlockWhereInput>;
};


export type QueryRefEvpMediaFileBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpMediaFileBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpMediaFileBlockWhereInput>;
};


export type QueryRefEvpNavigationPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpNavigationPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpNavigationPageBlockWhereInput>;
};


export type QueryRefEvpPartnerSettingsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpPartnerSettingsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpPartnerSettingsBlockWhereInput>;
};


export type QueryRefEvpResourcePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpResourcePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpResourcePageWhereInput>;
};


export type QueryRefEvpSearchHeaderBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpSearchHeaderBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpSearchHeaderBlockWhereInput>;
};


export type QueryRefEvpSearchPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpSearchPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpSearchPageWhereInput>;
};


export type QueryRefEvpSiteSettingsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpSiteSettingsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpSiteSettingsPageWhereInput>;
};


export type QueryRefEvpTabBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabBlockWhereInput>;
};


export type QueryRefEvpTabCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabCardBlockWhereInput>;
};


export type QueryRefEvpTabCardsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabCardsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabCardsBlockWhereInput>;
};


export type QueryRefEvpTabImageTextBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabImageTextBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabImageTextBlockWhereInput>;
};


export type QueryRefEvpTabRichTextBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabRichTextBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabRichTextBlockWhereInput>;
};


export type QueryRefEvpTabVideoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabVideoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabVideoBlockWhereInput>;
};


export type QueryRefEvpTabsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTabsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTabsBlockWhereInput>;
};


export type QueryRefEvpTextImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpTextImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpTextImageBlockWhereInput>;
};


export type QueryRefEvpVideoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EvpVideoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EvpVideoBlockWhereInput>;
};


export type QueryRefEmployeeTableHeaderLabelsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EmployeeTableHeaderLabelsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EmployeeTableHeaderLabelsBlockWhereInput>;
};


export type QueryRefErrorModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ErrorModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ErrorModalBlockWhereInput>;
};


export type QueryRefErrorPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ErrorPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ErrorPageWhereInput>;
};


export type QueryRefErrorPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ErrorPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ErrorPageBlockWhereInput>;
};


export type QueryRefEventBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventBlockWhereInput>;
};


export type QueryRefEventLocationAndDateBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventLocationAndDateBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventLocationAndDateBlockWhereInput>;
};


export type QueryRefEventLocationInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventLocationInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventLocationInformationBlockWhereInput>;
};


export type QueryRefEventPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventPageWhereInput>;
};


export type QueryRefEventRegistrationInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventRegistrationInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventRegistrationInformationBlockWhereInput>;
};


export type QueryRefEventSessionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSessionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSessionBlockWhereInput>;
};


export type QueryRefEventSessionScheduleBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSessionScheduleBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSessionScheduleBlockWhereInput>;
};


export type QueryRefEventSessionTrackBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSessionTrackBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSessionTrackBlockWhereInput>;
};


export type QueryRefEventSessionTrackSpeakerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSessionTrackSpeakerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSessionTrackSpeakerBlockWhereInput>;
};


export type QueryRefEventSpeakerSearchPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSpeakerSearchPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSpeakerSearchPageWhereInput>;
};


export type QueryRefEventSpeakersBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventSpeakersBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventSpeakersBlockWhereInput>;
};


export type QueryRefEventTableContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EventTableContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<EventTableContainerBlockWhereInput>;
};


export type QueryRefExpandableContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExpandableContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ExpandableContainerBlockWhereInput>;
};


export type QueryRefFileUploadElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FileUploadElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FileUploadElementBlockWhereInput>;
};


export type QueryRefFlowFinishInformationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FlowFinishInformationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FlowFinishInformationBlockWhereInput>;
};


export type QueryRefFolderPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FolderPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FolderPageWhereInput>;
};


export type QueryRefFormContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FormContainerBlockWhereInput>;
};


export type QueryRefFormStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FormStepBlockWhereInput>;
};


export type QueryRefFourColumnTableBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FourColumnTableBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<FourColumnTableBlockWhereInput>;
};


export type QueryRefGaugeBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GaugeBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GaugeBlockWhereInput>;
};


export type QueryRefGeoDataBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GeoDataBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GeoDataBlockWhereInput>;
};


export type QueryRefGettingStartedStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GettingStartedStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GettingStartedStepBlockWhereInput>;
};


export type QueryRefGettingStartedStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GettingStartedStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GettingStartedStepV2BlockWhereInput>;
};


export type QueryRefGreetingCaseBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GreetingCaseBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GreetingCaseBlockWhereInput>;
};


export type QueryRefGreetingStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GreetingStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GreetingStepBlockWhereInput>;
};


export type QueryRefGreetingStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GreetingStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GreetingStepV2BlockWhereInput>;
};


export type QueryRefGsAwardsApplicationsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsApplicationsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsApplicationsBlockWhereInput>;
};


export type QueryRefGsAwardsConfirmationStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsConfirmationStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsConfirmationStepBlockWhereInput>;
};


export type QueryRefGsAwardsFileUploadBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsFileUploadBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsFileUploadBlockWhereInput>;
};


export type QueryRefGsAwardsGettingStartedStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsGettingStartedStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsGettingStartedStepBlockWhereInput>;
};


export type QueryRefGsAwardsMembershipStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsMembershipStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsMembershipStepBlockWhereInput>;
};


export type QueryRefGsAwardsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsPageWhereInput>;
};


export type QueryRefGsAwardsPersistencyStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsPersistencyStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsPersistencyStepBlockWhereInput>;
};


export type QueryRefGsAwardsProductionStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsProductionStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsProductionStepBlockWhereInput>;
};


export type QueryRefGsAwardsRecruitmentStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsRecruitmentStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsRecruitmentStepBlockWhereInput>;
};


export type QueryRefGsAwardsRetentionStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsRetentionStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsRetentionStepBlockWhereInput>;
};


export type QueryRefGsAwardsSelectApplicantStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsSelectApplicantStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsSelectApplicantStepBlockWhereInput>;
};


export type QueryRefGsAwardsSubmitStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsSubmitStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsSubmitStepBlockWhereInput>;
};


export type QueryRefGsAwardsVerificationStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsVerificationStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsVerificationStepBlockWhereInput>;
};


export type QueryRefGsAwardsWholePersonStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsAwardsWholePersonStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsAwardsWholePersonStepBlockWhereInput>;
};


export type QueryRefGsConfirmationStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsConfirmationStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsConfirmationStepBlockWhereInput>;
};


export type QueryRefGsGettingStartedStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsGettingStartedStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsGettingStartedStepBlockWhereInput>;
};


export type QueryRefGsGreetingStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsGreetingStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsGreetingStepBlockWhereInput>;
};


export type QueryRefGsLeadershipInformationStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsLeadershipInformationStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsLeadershipInformationStepBlockWhereInput>;
};


export type QueryRefGsMembershipRenewalPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsMembershipRenewalPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsMembershipRenewalPageWhereInput>;
};


export type QueryRefGsProfileStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsProfileStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsProfileStepBlockWhereInput>;
};


export type QueryRefGsReceiptStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsReceiptStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsReceiptStepBlockWhereInput>;
};


export type QueryRefGsReviewStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GsReviewStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<GsReviewStepBlockWhereInput>;
};


export type QueryRefHealthPoliciesSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HealthPoliciesSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HealthPoliciesSectionBlockWhereInput>;
};


export type QueryRefHeroTextContentBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HeroTextContentBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HeroTextContentBlockWhereInput>;
};


export type QueryRefHomePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HomePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HomePageWhereInput>;
};


export type QueryRefHomePageV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HomePageV2OrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<HomePageV2WhereInput>;
};


export type QueryRefIconRequirementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IconRequirementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<IconRequirementBlockWhereInput>;
};


export type QueryRefImageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageWhereInput>;
};


export type QueryRefImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageBlockWhereInput>;
};


export type QueryRefImageCaptionRichTextBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageCaptionRichTextBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageCaptionRichTextBlockWhereInput>;
};


export type QueryRefImageChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageChoiceElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageChoiceElementBlockWhereInput>;
};


export type QueryRefImageLinkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageLinkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageLinkBlockWhereInput>;
};


export type QueryRefImageMediaArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageMediaOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageMediaWhereInput>;
};


export type QueryRefImageTextBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageTextBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageTextBlockWhereInput>;
};


export type QueryRefImageTextBlockV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageTextBlockV2OrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageTextBlockV2WhereInput>;
};


export type QueryRefImageTextCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageTextCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageTextCardBlockWhereInput>;
};


export type QueryRefImageTextItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageTextItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ImageTextItemBlockWhereInput>;
};


export type QueryRefInfoBoxBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<InfoBoxBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<InfoBoxBlockWhereInput>;
};


export type QueryRefKeyLinkValueBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<KeyLinkValueBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<KeyLinkValueBlockWhereInput>;
};


export type QueryRefKeyTranslatedValueBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<KeyTranslatedValueBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<KeyTranslatedValueBlockWhereInput>;
};


export type QueryRefLandingPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LandingPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LandingPageWhereInput>;
};


export type QueryRefLanguageIdAndNameArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LanguageIdAndNameOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LanguageIdAndNameWhereInput>;
};


export type QueryRefLanguagesBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LanguagesBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LanguagesBlockWhereInput>;
};


export type QueryRefLearnCarouselContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnCarouselContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnCarouselContainerBlockWhereInput>;
};


export type QueryRefLearnCarouselContainerBlockV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnCarouselContainerBlockV2OrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnCarouselContainerBlockV2WhereInput>;
};


export type QueryRefLearnDetailPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnDetailPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnDetailPageWhereInput>;
};


export type QueryRefLearnHeroImageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnHeroImageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnHeroImageBlockWhereInput>;
};


export type QueryRefLearnLandingPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnLandingPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnLandingPageWhereInput>;
};


export type QueryRefLearnPageV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnPageV2OrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnPageV2WhereInput>;
};


export type QueryRefLearnPlayListPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LearnPlayListPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LearnPlayListPageWhereInput>;
};


export type QueryRefLikeAndBookmarkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LikeAndBookmarkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LikeAndBookmarkBlockWhereInput>;
};


export type QueryRefLinkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LinkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LinkBlockWhereInput>;
};


export type QueryRefLinkListBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LinkListBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LinkListBlockWhereInput>;
};


export type QueryRefLinkTileBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LinkTileBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LinkTileBlockWhereInput>;
};


export type QueryRefLoaderBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LoaderBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LoaderBlockWhereInput>;
};


export type QueryRefLocationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LocationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<LocationBlockWhereInput>;
};


export type QueryRefMeetingEventCardPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MeetingEventCardPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MeetingEventCardPageWhereInput>;
};


export type QueryRefMeetingPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MeetingPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MeetingPageWhereInput>;
};


export type QueryRefMemberDirectoryArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MemberDirectoryOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MemberDirectoryWhereInput>;
};


export type QueryRefMemberDirectoryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MemberDirectoryPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MemberDirectoryPageWhereInput>;
};


export type QueryRefMemberSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MemberSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MemberSectionBlockWhereInput>;
};


export type QueryRefMembersTableHeaderLabelsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembersTableHeaderLabelsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembersTableHeaderLabelsBlockWhereInput>;
};


export type QueryRefMembershipHistoryDetailBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipHistoryDetailBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipHistoryDetailBlockWhereInput>;
};


export type QueryRefMembershipHistoryDetailPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipHistoryDetailPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipHistoryDetailPageWhereInput>;
};


export type QueryRefMembershipInvoicePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipInvoicePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipInvoicePageWhereInput>;
};


export type QueryRefMembershipLevelBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipLevelBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipLevelBlockWhereInput>;
};


export type QueryRefMembershipLevelRadioBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipLevelRadioBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipLevelRadioBlockWhereInput>;
};


export type QueryRefMembershipLevelSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipLevelSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipLevelSectionBlockWhereInput>;
};


export type QueryRefMembershipLevelStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipLevelStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipLevelStepV2BlockWhereInput>;
};


export type QueryRefMembershipLevelsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipLevelsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipLevelsBlockWhereInput>;
};


export type QueryRefMembershipRenewalPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipRenewalPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipRenewalPageWhereInput>;
};


export type QueryRefMembershipRenewalV2PageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipRenewalV2PageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipRenewalV2PageWhereInput>;
};


export type QueryRefMembershipRequirementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipRequirementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipRequirementBlockWhereInput>;
};


export type QueryRefMembershipRequirementsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipRequirementsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipRequirementsBlockWhereInput>;
};


export type QueryRefMembershipTypeSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipTypeSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipTypeSectionBlockWhereInput>;
};


export type QueryRefMembershipTypeStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipTypeStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipTypeStepBlockWhereInput>;
};


export type QueryRefMembershipTypeStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MembershipTypeStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<MembershipTypeStepV2BlockWhereInput>;
};


export type QueryRefModalInfoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ModalInfoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ModalInfoBlockWhereInput>;
};


export type QueryRefNewIdRequestSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NewIdRequestSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NewIdRequestSectionBlockWhereInput>;
};


export type QueryRefNextCallOutBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextCallOutBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextCallOutBlockWhereInput>;
};


export type QueryRefNextContactUsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextContactUsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextContactUsBlockWhereInput>;
};


export type QueryRefNextContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextContainerBlockWhereInput>;
};


export type QueryRefNextDeadLetterQueueBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextDeadLetterQueueBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextDeadLetterQueueBlockWhereInput>;
};


export type QueryRefNextEventBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextEventBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextEventBlockWhereInput>;
};


export type QueryRefNextHeroBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextHeroBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextHeroBlockWhereInput>;
};


export type QueryRefNextInfoBoxBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextInfoBoxBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextInfoBoxBlockWhereInput>;
};


export type QueryRefNextPersonContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextPersonContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextPersonContainerBlockWhereInput>;
};


export type QueryRefNextPersonDataBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextPersonDataBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextPersonDataBlockWhereInput>;
};


export type QueryRefNextStaffAdminPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextStaffAdminPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextStaffAdminPageWhereInput>;
};


export type QueryRefNextStaticPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextStaticPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextStaticPageWhereInput>;
};


export type QueryRefNextSyncEventsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NextSyncEventsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NextSyncEventsBlockWhereInput>;
};


export type QueryRefNotFoundPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NotFoundPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NotFoundPageWhereInput>;
};


export type QueryRefNumberElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NumberElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NumberElementBlockWhereInput>;
};


export type QueryRefNumberedContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NumberedContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NumberedContainerBlockWhereInput>;
};


export type QueryRefNumberedItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NumberedItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<NumberedItemBlockWhereInput>;
};


export type QueryRefParagraphTextElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ParagraphTextElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ParagraphTextElementBlockWhereInput>;
};


export type QueryRefPastPresidentsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PastPresidentsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PastPresidentsBlockWhereInput>;
};


export type QueryRefPaymentProcessingScreenBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PaymentProcessingScreenBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PaymentProcessingScreenBlockWhereInput>;
};


export type QueryRefPersonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PersonBlockWhereInput>;
};


export type QueryRefPersonContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PersonContainerBlockWhereInput>;
};


export type QueryRefPersonQuizPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonQuizPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PersonQuizPageWhereInput>;
};


export type QueryRefPersonUpdatesSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonUpdatesSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PersonUpdatesSectionBlockWhereInput>;
};


export type QueryRefPlaylistBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PlaylistBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PlaylistBlockWhereInput>;
};


export type QueryRefPlaylistPromoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PlaylistPromoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PlaylistPromoBlockWhereInput>;
};


export type QueryRefPodcastDetailBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PodcastDetailBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PodcastDetailBlockWhereInput>;
};


export type QueryRefPowerPhrasePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PowerPhrasePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PowerPhrasePageWhereInput>;
};


export type QueryRefPredefinedHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PredefinedHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PredefinedHiddenElementBlockWhereInput>;
};


export type QueryRefPrepaymentErrorModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentErrorModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentErrorModalBlockWhereInput>;
};


export type QueryRefPrepaymentErrorPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentErrorPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentErrorPageBlockWhereInput>;
};


export type QueryRefPrepaymentGenericErrorBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentGenericErrorBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentGenericErrorBlockWhereInput>;
};


export type QueryRefPrepaymentHomepageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentHomepageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentHomepageBlockWhereInput>;
};


export type QueryRefPrepaymentHomepageFellowsDesignationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentHomepageFellowsDesignationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentHomepageFellowsDesignationBlockWhereInput>;
};


export type QueryRefPrepaymentHomepageGsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentHomepageGsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentHomepageGsBlockWhereInput>;
};


export type QueryRefPrepaymentHomepageMdrtBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentHomepageMdrtBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentHomepageMdrtBlockWhereInput>;
};


export type QueryRefPrepaymentLoaderScreenBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentLoaderScreenBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentLoaderScreenBlockWhereInput>;
};


export type QueryRefPrepaymentMembershipInfoCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentMembershipInfoCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentMembershipInfoCardBlockWhereInput>;
};


export type QueryRefPrepaymentMembershipInfoPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentMembershipInfoPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentMembershipInfoPageBlockWhereInput>;
};


export type QueryRefPrepaymentMembershipTypeInfoCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentMembershipTypeInfoCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentMembershipTypeInfoCardBlockWhereInput>;
};


export type QueryRefPrepaymentPaymentPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentPaymentPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentPaymentPageBlockWhereInput>;
};


export type QueryRefPrepaymentPaymentStatusPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentPaymentStatusPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentPaymentStatusPageBlockWhereInput>;
};


export type QueryRefPrepaymentPortalPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentPortalPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentPortalPageWhereInput>;
};


export type QueryRefPrepaymentProductNamesBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentProductNamesBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentProductNamesBlockWhereInput>;
};


export type QueryRefPrepaymentSuccessfulPaymentPageBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrepaymentSuccessfulPaymentPageBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PrepaymentSuccessfulPaymentPageBlockWhereInput>;
};


export type QueryRefPressReleasePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PressReleasePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PressReleasePageWhereInput>;
};


export type QueryRefPriceBreakdownBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PriceBreakdownBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PriceBreakdownBlockWhereInput>;
};


export type QueryRefProductionAttestmentNumbersBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionAttestmentNumbersBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionAttestmentNumbersBlockWhereInput>;
};


export type QueryRefProductionDataSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionDataSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionDataSectionBlockWhereInput>;
};


export type QueryRefProductionDeleteModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionDeleteModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionDeleteModalBlockWhereInput>;
};


export type QueryRefProductionModalBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionModalBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionModalBlockWhereInput>;
};


export type QueryRefProductionStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionStepBlockWhereInput>;
};


export type QueryRefProductionStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionStepV2BlockWhereInput>;
};


export type QueryRefProductionTableBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProductionTableBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProductionTableBlockWhereInput>;
};


export type QueryRefProfileListBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfileListBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfileListBlockWhereInput>;
};


export type QueryRefProfilePictureBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfilePictureBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfilePictureBlockWhereInput>;
};


export type QueryRefProfileSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfileSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfileSectionBlockWhereInput>;
};


export type QueryRefProfileStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfileStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfileStepBlockWhereInput>;
};


export type QueryRefProfileStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ProfileStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ProfileStepV2BlockWhereInput>;
};


export type QueryRefPublicProfilePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PublicProfilePageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<PublicProfilePageWhereInput>;
};


export type QueryRefQuizCareerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizCareerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizCareerBlockWhereInput>;
};


export type QueryRefQuizEducationBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizEducationBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizEducationBlockWhereInput>;
};


export type QueryRefQuizFinancialBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizFinancialBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizFinancialBlockWhereInput>;
};


export type QueryRefQuizHealthBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizHealthBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizHealthBlockWhereInput>;
};


export type QueryRefQuizRelationshipsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizRelationshipsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizRelationshipsBlockWhereInput>;
};


export type QueryRefQuizServiceBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizServiceBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizServiceBlockWhereInput>;
};


export type QueryRefQuizSpiritualBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuizSpiritualBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<QuizSpiritualBlockWhereInput>;
};


export type QueryRefRtContributorFormPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RtContributorFormPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RtContributorFormPageWhereInput>;
};


export type QueryRefRangeElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RangeElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RangeElementBlockWhereInput>;
};


export type QueryRefReceiptStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReceiptStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReceiptStepBlockWhereInput>;
};


export type QueryRefReceiptStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReceiptStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReceiptStepV2BlockWhereInput>;
};


export type QueryRefResetButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ResetButtonElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ResetButtonElementBlockWhereInput>;
};


export type QueryRefReviewAndSubmitStepV2BlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReviewAndSubmitStepV2BlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReviewAndSubmitStepV2BlockWhereInput>;
};


export type QueryRefReviewBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReviewBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReviewBlockWhereInput>;
};


export type QueryRefReviewStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ReviewStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ReviewStepBlockWhereInput>;
};


export type QueryRefRichTextBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RichTextBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RichTextBlockWhereInput>;
};


export type QueryRefRoutingStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RoutingStepBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<RoutingStepBlockWhereInput>;
};


export type QueryRefSearchPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SearchPageWhereInput>;
};


export type QueryRefSearchPageV2Args = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchPageV2OrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SearchPageV2WhereInput>;
};


export type QueryRefSectionContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SectionContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SectionContainerBlockWhereInput>;
};


export type QueryRefSectionItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SectionItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SectionItemBlockWhereInput>;
};


export type QueryRefSelectionElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SelectionElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SelectionElementBlockWhereInput>;
};


export type QueryRefSelfAttestLevelOptionsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SelfAttestLevelOptionsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SelfAttestLevelOptionsBlockWhereInput>;
};


export type QueryRefSettingSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SettingSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SettingSectionBlockWhereInput>;
};


export type QueryRefSiteDefinitionArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDefinitionOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SiteDefinitionWhereInput>;
};


export type QueryRefSiteSettingsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteSettingsPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SiteSettingsPageWhereInput>;
};


export type QueryRefSocialShareBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SocialShareBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SocialShareBlockWhereInput>;
};


export type QueryRefSpeakerEngagementPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpeakerEngagementPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpeakerEngagementPageWhereInput>;
};


export type QueryRefSponsorSpeakerPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SponsorSpeakerPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SponsorSpeakerPageWhereInput>;
};


export type QueryRefSpotlightBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpotlightBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpotlightBlockWhereInput>;
};


export type QueryRefSpotlightContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpotlightContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpotlightContainerBlockWhereInput>;
};


export type QueryRefSpotlightDataBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpotlightDataBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpotlightDataBlockWhereInput>;
};


export type QueryRefSpotlightDataContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SpotlightDataContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SpotlightDataContainerBlockWhereInput>;
};


export type QueryRefStoreCardPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StoreCardPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<StoreCardPageWhereInput>;
};


export type QueryRefSubmitButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SubmitButtonElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SubmitButtonElementBlockWhereInput>;
};


export type QueryRefSuccessSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SuccessSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SuccessSectionBlockWhereInput>;
};


export type QueryRefSvgLinkBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SvgLinkBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SvgLinkBlockWhereInput>;
};


export type QueryRefSvgMediaArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SvgMediaOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SvgMediaWhereInput>;
};


export type QueryRefSvgTextCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SvgTextCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<SvgTextCardBlockWhereInput>;
};


export type QueryRefTabContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TabContainerBlockWhereInput>;
};


export type QueryRefTabItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TabItemBlockWhereInput>;
};


export type QueryRefTextCardBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextCardBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextCardBlockWhereInput>;
};


export type QueryRefTextContentBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextContentBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextContentBlockWhereInput>;
};


export type QueryRefTextareaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextareaElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextareaElementBlockWhereInput>;
};


export type QueryRefTextboxElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextboxElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TextboxElementBlockWhereInput>;
};


export type QueryRefTimelineContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TimelineContainerBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TimelineContainerBlockWhereInput>;
};


export type QueryRefTimelineItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TimelineItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TimelineItemBlockWhereInput>;
};


export type QueryRefToolkitBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ToolkitBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ToolkitBlockWhereInput>;
};


export type QueryRefToolkitItemBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ToolkitItemBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ToolkitItemBlockWhereInput>;
};


export type QueryRefToolkitSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ToolkitSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ToolkitSectionBlockWhereInput>;
};


export type QueryRefToolsCardPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ToolsCardPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<ToolsCardPageWhereInput>;
};


export type QueryRefTooltipBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TooltipBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<TooltipBlockWhereInput>;
};


export type QueryRefUrlElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<UrlElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<UrlElementBlockWhereInput>;
};


export type QueryRefVideoArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoWhereInput>;
};


export type QueryRefVideoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoBlockWhereInput>;
};


export type QueryRefVideoDetailBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoDetailBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoDetailBlockWhereInput>;
};


export type QueryRefVideoMediaArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoMediaOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoMediaWhereInput>;
};


export type QueryRefVideoPromoBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VideoPromoBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VideoPromoBlockWhereInput>;
};


export type QueryRefVisaLettersPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VisaLettersPageOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VisaLettersPageWhereInput>;
};


export type QueryRefVisibilityOptionsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VisibilityOptionsBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VisibilityOptionsBlockWhereInput>;
};


export type QueryRefVisitorDataHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VisitorDataHiddenElementBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<VisitorDataHiddenElementBlockWhereInput>;
};


export type QueryRefWireTransferSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<WireTransferSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<WireTransferSectionBlockWhereInput>;
};


export type QueryRefYourAnswersSectionBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<YourAnswersSectionBlockOrderByInput>;
  skip?: Scalars['Int']['input'];
  where?: InputMaybe<YourAnswersSectionBlockWhereInput>;
};

/** Holds data for the Person Quiz page */
export type QuizCareerBlock = IContent & IData & {
  __typename?: 'QuizCareerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Questions for quiz block */
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** The text for title */
  Title?: Maybe<Scalars['String']['output']>;
  /** The text for quiz topic description */
  TopicDescription?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Person Quiz page */
export type QuizCareerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizCareerBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizCareerBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizCareerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizCareerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type QuizCareerBlockAutocomplete = {
  __typename?: 'QuizCareerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type QuizCareerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizCareerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizCareerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizCareerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizCareerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizCareerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizCareerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizCareerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizCareerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizCareerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuizCareerBlockFacet = {
  __typename?: 'QuizCareerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type QuizCareerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizCareerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizCareerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizCareerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizCareerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizCareerBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizCareerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type QuizCareerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type QuizCareerBlockOutput = {
  __typename?: 'QuizCareerBlockOutput';
  autocomplete?: Maybe<QuizCareerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<QuizCareerBlockFacet>;
  item?: Maybe<QuizCareerBlock>;
  items?: Maybe<Array<Maybe<QuizCareerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type QuizCareerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuizCareerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<QuizCareerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<QuizCareerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<QuizCareerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Person Quiz page */
export type QuizEducationBlock = IContent & IData & {
  __typename?: 'QuizEducationBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Questions for quiz block */
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** The text for title */
  Title?: Maybe<Scalars['String']['output']>;
  /** The text for quiz topic description */
  TopicDescription?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Person Quiz page */
export type QuizEducationBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizEducationBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizEducationBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizEducationBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizEducationBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type QuizEducationBlockAutocomplete = {
  __typename?: 'QuizEducationBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type QuizEducationBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizEducationBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizEducationBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizEducationBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizEducationBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizEducationBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizEducationBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizEducationBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizEducationBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizEducationBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuizEducationBlockFacet = {
  __typename?: 'QuizEducationBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type QuizEducationBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizEducationBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizEducationBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizEducationBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizEducationBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizEducationBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizEducationBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type QuizEducationBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type QuizEducationBlockOutput = {
  __typename?: 'QuizEducationBlockOutput';
  autocomplete?: Maybe<QuizEducationBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<QuizEducationBlockFacet>;
  item?: Maybe<QuizEducationBlock>;
  items?: Maybe<Array<Maybe<QuizEducationBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type QuizEducationBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuizEducationBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<QuizEducationBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<QuizEducationBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<QuizEducationBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Person Quiz page */
export type QuizFinancialBlock = IContent & IData & {
  __typename?: 'QuizFinancialBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Questions for quiz block */
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** The text for title */
  Title?: Maybe<Scalars['String']['output']>;
  /** The text for quiz topic description */
  TopicDescription?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Person Quiz page */
export type QuizFinancialBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizFinancialBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizFinancialBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizFinancialBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizFinancialBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type QuizFinancialBlockAutocomplete = {
  __typename?: 'QuizFinancialBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type QuizFinancialBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizFinancialBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizFinancialBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizFinancialBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizFinancialBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizFinancialBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizFinancialBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizFinancialBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizFinancialBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizFinancialBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuizFinancialBlockFacet = {
  __typename?: 'QuizFinancialBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type QuizFinancialBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizFinancialBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizFinancialBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizFinancialBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizFinancialBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizFinancialBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizFinancialBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type QuizFinancialBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type QuizFinancialBlockOutput = {
  __typename?: 'QuizFinancialBlockOutput';
  autocomplete?: Maybe<QuizFinancialBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<QuizFinancialBlockFacet>;
  item?: Maybe<QuizFinancialBlock>;
  items?: Maybe<Array<Maybe<QuizFinancialBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type QuizFinancialBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuizFinancialBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<QuizFinancialBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<QuizFinancialBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<QuizFinancialBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Person Quiz page */
export type QuizHealthBlock = IContent & IData & {
  __typename?: 'QuizHealthBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Questions for quiz block */
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** The text for title */
  Title?: Maybe<Scalars['String']['output']>;
  /** The text for quiz topic description */
  TopicDescription?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Person Quiz page */
export type QuizHealthBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizHealthBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizHealthBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizHealthBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizHealthBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type QuizHealthBlockAutocomplete = {
  __typename?: 'QuizHealthBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type QuizHealthBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizHealthBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizHealthBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizHealthBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizHealthBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizHealthBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizHealthBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizHealthBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizHealthBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizHealthBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuizHealthBlockFacet = {
  __typename?: 'QuizHealthBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type QuizHealthBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizHealthBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizHealthBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizHealthBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizHealthBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizHealthBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizHealthBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type QuizHealthBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type QuizHealthBlockOutput = {
  __typename?: 'QuizHealthBlockOutput';
  autocomplete?: Maybe<QuizHealthBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<QuizHealthBlockFacet>;
  item?: Maybe<QuizHealthBlock>;
  items?: Maybe<Array<Maybe<QuizHealthBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type QuizHealthBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuizHealthBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<QuizHealthBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<QuizHealthBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<QuizHealthBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type QuizQuestionPropertyValue = {
  __typename?: 'QuizQuestionPropertyValue';
  Question?: Maybe<Scalars['String']['output']>;
  QuestionId?: Maybe<Scalars['String']['output']>;
};

export type QuizQuestionPropertyValueAutocomplete = {
  __typename?: 'QuizQuestionPropertyValueAutocomplete';
  Question?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  QuestionId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type QuizQuestionPropertyValueAutocompleteQuestionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizQuestionPropertyValueAutocompleteQuestionIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuizQuestionPropertyValueFacet = {
  __typename?: 'QuizQuestionPropertyValueFacet';
  Question?: Maybe<Array<Maybe<StringFacet>>>;
  QuestionId?: Maybe<Array<Maybe<StringFacet>>>;
};


export type QuizQuestionPropertyValueFacetQuestionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizQuestionPropertyValueFacetQuestionIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuizQuestionPropertyValueOrderByInput = {
  Question?: InputMaybe<OrderBy>;
  QuestionId?: InputMaybe<OrderBy>;
};

export type QuizQuestionPropertyValueWhereInput = {
  Question?: InputMaybe<StringFilterInput>;
  QuestionId?: InputMaybe<StringFilterInput>;
};

/** Holds data for the Person Quiz page */
export type QuizRelationshipsBlock = IContent & IData & {
  __typename?: 'QuizRelationshipsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Questions for quiz block */
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** The text for title */
  Title?: Maybe<Scalars['String']['output']>;
  /** The text for quiz topic description */
  TopicDescription?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Person Quiz page */
export type QuizRelationshipsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizRelationshipsBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizRelationshipsBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizRelationshipsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizRelationshipsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type QuizRelationshipsBlockAutocomplete = {
  __typename?: 'QuizRelationshipsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type QuizRelationshipsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizRelationshipsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizRelationshipsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizRelationshipsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizRelationshipsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizRelationshipsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizRelationshipsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizRelationshipsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizRelationshipsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizRelationshipsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuizRelationshipsBlockFacet = {
  __typename?: 'QuizRelationshipsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type QuizRelationshipsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizRelationshipsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizRelationshipsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizRelationshipsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizRelationshipsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizRelationshipsBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizRelationshipsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type QuizRelationshipsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type QuizRelationshipsBlockOutput = {
  __typename?: 'QuizRelationshipsBlockOutput';
  autocomplete?: Maybe<QuizRelationshipsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<QuizRelationshipsBlockFacet>;
  item?: Maybe<QuizRelationshipsBlock>;
  items?: Maybe<Array<Maybe<QuizRelationshipsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type QuizRelationshipsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuizRelationshipsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<QuizRelationshipsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<QuizRelationshipsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<QuizRelationshipsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Person Quiz page */
export type QuizServiceBlock = IContent & IData & {
  __typename?: 'QuizServiceBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Questions for quiz block */
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** The text for title */
  Title?: Maybe<Scalars['String']['output']>;
  /** The text for quiz topic description */
  TopicDescription?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Person Quiz page */
export type QuizServiceBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizServiceBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizServiceBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizServiceBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizServiceBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type QuizServiceBlockAutocomplete = {
  __typename?: 'QuizServiceBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type QuizServiceBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizServiceBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizServiceBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizServiceBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizServiceBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizServiceBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizServiceBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizServiceBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizServiceBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizServiceBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuizServiceBlockFacet = {
  __typename?: 'QuizServiceBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type QuizServiceBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizServiceBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizServiceBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizServiceBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizServiceBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizServiceBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizServiceBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type QuizServiceBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type QuizServiceBlockOutput = {
  __typename?: 'QuizServiceBlockOutput';
  autocomplete?: Maybe<QuizServiceBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<QuizServiceBlockFacet>;
  item?: Maybe<QuizServiceBlock>;
  items?: Maybe<Array<Maybe<QuizServiceBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type QuizServiceBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuizServiceBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<QuizServiceBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<QuizServiceBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<QuizServiceBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Person Quiz page */
export type QuizSpiritualBlock = IContent & IData & {
  __typename?: 'QuizSpiritualBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Questions for quiz block */
  Questions?: Maybe<Array<Maybe<QuizQuestionPropertyValue>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** The text for title */
  Title?: Maybe<Scalars['String']['output']>;
  /** The text for quiz topic description */
  TopicDescription?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Person Quiz page */
export type QuizSpiritualBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizSpiritualBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizSpiritualBlockTopicDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizSpiritualBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Person Quiz page */
export type QuizSpiritualBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type QuizSpiritualBlockAutocomplete = {
  __typename?: 'QuizSpiritualBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Questions?: Maybe<QuizQuestionPropertyValueAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type QuizSpiritualBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizSpiritualBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizSpiritualBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizSpiritualBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizSpiritualBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizSpiritualBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizSpiritualBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizSpiritualBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizSpiritualBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuizSpiritualBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuizSpiritualBlockFacet = {
  __typename?: 'QuizSpiritualBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Questions?: Maybe<QuizQuestionPropertyValueFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopicDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type QuizSpiritualBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizSpiritualBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizSpiritualBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizSpiritualBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizSpiritualBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizSpiritualBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetTopicDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuizSpiritualBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type QuizSpiritualBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopicDescription?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type QuizSpiritualBlockOutput = {
  __typename?: 'QuizSpiritualBlockOutput';
  autocomplete?: Maybe<QuizSpiritualBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<QuizSpiritualBlockFacet>;
  item?: Maybe<QuizSpiritualBlock>;
  items?: Maybe<Array<Maybe<QuizSpiritualBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type QuizSpiritualBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuizSpiritualBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Questions?: InputMaybe<QuizQuestionPropertyValueWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopicDescription?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<QuizSpiritualBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<QuizSpiritualBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<QuizSpiritualBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Contributor Form */
export type RtContributorFormPage = IContent & IData & {
  __typename?: 'RTContributorFormPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<RtContributorFormPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<RtContributorFormPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Contributor Form */
export type RtContributorFormPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contributor Form */
export type RtContributorFormPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contributor Form */
export type RtContributorFormPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contributor Form */
export type RtContributorFormPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contributor Form */
export type RtContributorFormPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contributor Form */
export type RtContributorFormPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Contributor Form */
export type RtContributorFormPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RtContributorFormPageAutocomplete = {
  __typename?: 'RTContributorFormPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<RtContributorFormPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<RtContributorFormPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RtContributorFormPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RtContributorFormPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RtContributorFormPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RtContributorFormPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RtContributorFormPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RtContributorFormPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RtContributorFormPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RtContributorFormPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RtContributorFormPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RtContributorFormPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RtContributorFormPageFacet = {
  __typename?: 'RTContributorFormPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<RtContributorFormPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<RtContributorFormPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type RtContributorFormPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RtContributorFormPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RtContributorFormPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RtContributorFormPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RtContributorFormPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RtContributorFormPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RtContributorFormPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RtContributorFormPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RtContributorFormPageImageBlock = {
  __typename?: 'RTContributorFormPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type RtContributorFormPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RtContributorFormPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RtContributorFormPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RtContributorFormPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RtContributorFormPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type RtContributorFormPageImageBlockAutocomplete = {
  __typename?: 'RTContributorFormPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type RtContributorFormPageImageBlockFacet = {
  __typename?: 'RTContributorFormPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type RtContributorFormPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RtContributorFormPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RtContributorFormPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RtContributorFormPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type RtContributorFormPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type RtContributorFormPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<RtContributorFormPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<RtContributorFormPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type RtContributorFormPageOutput = {
  __typename?: 'RTContributorFormPageOutput';
  autocomplete?: Maybe<RtContributorFormPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RtContributorFormPageFacet>;
  item?: Maybe<RtContributorFormPage>;
  items?: Maybe<Array<Maybe<RtContributorFormPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type RtContributorFormPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RtContributorFormPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<RtContributorFormPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<RtContributorFormPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<RtContributorFormPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RtContributorFormPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RtContributorFormPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type RangeElementBlock = IContent & IData & {
  __typename?: 'RangeElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Max?: Maybe<Scalars['Int']['output']>;
  Min?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Step?: Maybe<Scalars['Int']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type RangeElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RangeElementBlockAutocomplete = {
  __typename?: 'RangeElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RangeElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockFacet = {
  __typename?: 'RangeElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Max?: Maybe<Array<Maybe<NumberFacet>>>;
  Min?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  Step?: Maybe<Array<Maybe<NumberFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type RangeElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RangeElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RangeElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RangeElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetMaxArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RangeElementBlockFacetMinArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RangeElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RangeElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RangeElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetStepArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RangeElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RangeElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RangeElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Max?: InputMaybe<OrderBy>;
  Min?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  Step?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type RangeElementBlockOutput = {
  __typename?: 'RangeElementBlockOutput';
  autocomplete?: Maybe<RangeElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RangeElementBlockFacet>;
  item?: Maybe<RangeElementBlock>;
  items?: Maybe<Array<Maybe<RangeElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type RangeElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RangeElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Max?: InputMaybe<IntFilterInput>;
  Min?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  Step?: InputMaybe<IntFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<RangeElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RangeElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RangeElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type RangeFacetsInput = {
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export enum Ranking {
  BoostOnly = 'BOOST_ONLY',
  Doc = 'DOC',
  Relevance = 'RELEVANCE',
  Semantic = 'SEMANTIC'
}

/** Holds data for the Membership Renewal page */
export type ReceiptStepBlock = IContent & IData & {
  __typename?: 'ReceiptStepBlock';
  AdditionalMembershipOptionLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicationDetailsHeading?: Maybe<Scalars['String']['output']>;
  AttestToProductionLabel?: Maybe<Scalars['String']['output']>;
  BackduesLabel?: Maybe<Scalars['String']['output']>;
  CardNumberLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CoTMembershipLabel?: Maybe<Scalars['String']['output']>;
  CompanyNameLabel?: Maybe<Scalars['String']['output']>;
  CompanyPrepaymentLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CostBreakdownLabel?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisabilityRequirementLabel?: Maybe<Scalars['String']['output']>;
  EthicsComplaintLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  GoBackButtonLabel?: Maybe<Scalars['String']['output']>;
  IndividualPrepaymentLabel?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  MdrtMembershipLabel?: Maybe<Scalars['String']['output']>;
  MemberDetailsHeading?: Maybe<Scalars['String']['output']>;
  MemberNameLabel?: Maybe<Scalars['String']['output']>;
  MembershipOptionsLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  OrderNumberLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentDateLabel?: Maybe<Scalars['String']['output']>;
  PaymentDetailsLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PrintButtonLabel?: Maybe<Scalars['String']['output']>;
  ProfessionalAssociationLabel?: Maybe<Scalars['String']['output']>;
  ReceiptAddressText?: Maybe<Scalars['String']['output']>;
  ReceiptFaxLabel?: Maybe<Scalars['String']['output']>;
  ReceiptFaxNumber?: Maybe<Scalars['String']['output']>;
  ReceiptHeading?: Maybe<Scalars['String']['output']>;
  ReceiptPhoneLabel?: Maybe<Scalars['String']['output']>;
  ReceiptPhoneNumber?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TermsAndConditionsLabel?: Maybe<Scalars['String']['output']>;
  ToTMembershipLabel?: Maybe<Scalars['String']['output']>;
  TotalAmountPaidLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockAdditionalMembershipOptionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockApplicationDetailsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockAttestToProductionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockBackduesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockCardNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockCoTMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockCompanyNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockCompanyPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockCostBreakdownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockDisabilityRequirementLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockEthicsComplaintLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockGoBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockIndividualPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockMdrtMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockMemberDetailsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockMemberNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockMembershipOptionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockOrderNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockPaymentDateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockPaymentDetailsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockPrintButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockProfessionalAssociationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockReceiptAddressTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockReceiptFaxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockReceiptFaxNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockReceiptHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockReceiptPhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockReceiptPhoneNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockTermsAndConditionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockToTMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlockTotalAmountPaidLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReceiptStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ReceiptStepBlockAutocomplete = {
  __typename?: 'ReceiptStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ReceiptStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReceiptStepBlockFacet = {
  __typename?: 'ReceiptStepBlockFacet';
  AdditionalMembershipOptionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationDetailsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  AttestToProductionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackduesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CardNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CoTMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CostBreakdownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisabilityRequirementLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EthicsComplaintLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  GoBackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IndividualPrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDetailsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MemberNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipOptionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OrderNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentDateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentDetailsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrintButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalAssociationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptAddressText?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptFaxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptFaxNumber?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptPhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReceiptPhoneNumber?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TermsAndConditionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ToTMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAmountPaidLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ReceiptStepBlockFacetAdditionalMembershipOptionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetApplicationDetailsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetAttestToProductionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetBackduesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetCardNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReceiptStepBlockFacetCoTMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetCompanyNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetCompanyPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetCostBreakdownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReceiptStepBlockFacetDisabilityRequirementLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetEthicsComplaintLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetGoBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetIndividualPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetMdrtMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetMemberDetailsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetMemberNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetMembershipOptionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetOrderNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetPaymentDateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetPaymentDetailsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetPrintButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetProfessionalAssociationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetReceiptAddressTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetReceiptFaxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetReceiptFaxNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetReceiptHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetReceiptPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetReceiptPhoneNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReceiptStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReceiptStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReceiptStepBlockFacetTermsAndConditionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetToTMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetTotalAmountPaidLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ReceiptStepBlockOrderByInput = {
  AdditionalMembershipOptionLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationDetailsHeading?: InputMaybe<OrderBy>;
  AttestToProductionLabel?: InputMaybe<OrderBy>;
  BackduesLabel?: InputMaybe<OrderBy>;
  CardNumberLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CoTMembershipLabel?: InputMaybe<OrderBy>;
  CompanyNameLabel?: InputMaybe<OrderBy>;
  CompanyPrepaymentLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CostBreakdownLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisabilityRequirementLabel?: InputMaybe<OrderBy>;
  EthicsComplaintLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  GoBackButtonLabel?: InputMaybe<OrderBy>;
  IndividualPrepaymentLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  MdrtMembershipLabel?: InputMaybe<OrderBy>;
  MemberDetailsHeading?: InputMaybe<OrderBy>;
  MemberNameLabel?: InputMaybe<OrderBy>;
  MembershipOptionsLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  OrderNumberLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentDateLabel?: InputMaybe<OrderBy>;
  PaymentDetailsLabel?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PrintButtonLabel?: InputMaybe<OrderBy>;
  ProfessionalAssociationLabel?: InputMaybe<OrderBy>;
  ReceiptAddressText?: InputMaybe<OrderBy>;
  ReceiptFaxLabel?: InputMaybe<OrderBy>;
  ReceiptFaxNumber?: InputMaybe<OrderBy>;
  ReceiptHeading?: InputMaybe<OrderBy>;
  ReceiptPhoneLabel?: InputMaybe<OrderBy>;
  ReceiptPhoneNumber?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TermsAndConditionsLabel?: InputMaybe<OrderBy>;
  ToTMembershipLabel?: InputMaybe<OrderBy>;
  TotalAmountPaidLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ReceiptStepBlockOutput = {
  __typename?: 'ReceiptStepBlockOutput';
  autocomplete?: Maybe<ReceiptStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ReceiptStepBlockFacet>;
  item?: Maybe<ReceiptStepBlock>;
  items?: Maybe<Array<Maybe<ReceiptStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ReceiptStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReceiptStepBlockWhereInput = {
  AdditionalMembershipOptionLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationDetailsHeading?: InputMaybe<SearchableStringFilterInput>;
  AttestToProductionLabel?: InputMaybe<SearchableStringFilterInput>;
  BackduesLabel?: InputMaybe<SearchableStringFilterInput>;
  CardNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CoTMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyNameLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyPrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CostBreakdownLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisabilityRequirementLabel?: InputMaybe<SearchableStringFilterInput>;
  EthicsComplaintLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  GoBackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  IndividualPrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  MdrtMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  MemberDetailsHeading?: InputMaybe<SearchableStringFilterInput>;
  MemberNameLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipOptionsLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  OrderNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentDateLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentDetailsLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PrintButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalAssociationLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptAddressText?: InputMaybe<SearchableStringFilterInput>;
  ReceiptFaxLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptFaxNumber?: InputMaybe<SearchableStringFilterInput>;
  ReceiptHeading?: InputMaybe<SearchableStringFilterInput>;
  ReceiptPhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  ReceiptPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TermsAndConditionsLabel?: InputMaybe<SearchableStringFilterInput>;
  ToTMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAmountPaidLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ReceiptStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ReceiptStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ReceiptStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2Block = IContent & IData & {
  __typename?: 'ReceiptStepV2Block';
  AdditionalFilingFeesLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicationDetailsHeader?: Maybe<Scalars['String']['output']>;
  AttestToProduction?: Maybe<Scalars['String']['output']>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  BackDuesLabel?: Maybe<Scalars['String']['output']>;
  COTLevelLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CompanyNameLabel?: Maybe<Scalars['String']['output']>;
  CompanyPrePaymentLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DisabilityRequestedLabel?: Maybe<Scalars['String']['output']>;
  EthicsComplaintLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FooterAddressText?: Maybe<Scalars['String']['output']>;
  FooterPhoneText?: Maybe<Scalars['String']['output']>;
  FooterPhoneTextXhtml?: Maybe<Scalars['String']['output']>;
  GoBackButtonText?: Maybe<Scalars['String']['output']>;
  HeaderAddressText?: Maybe<Scalars['String']['output']>;
  HeaderPhoneText?: Maybe<Scalars['String']['output']>;
  HeaderTitleText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeeLabel?: Maybe<Scalars['String']['output']>;
  LifeMemberText?: Maybe<Scalars['String']['output']>;
  MDRTLevelLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  MemberDetailsHeader?: Maybe<Scalars['String']['output']>;
  MemberNameLabel?: Maybe<Scalars['String']['output']>;
  MembershipTypeLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  OrderNumberLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentDateLabel?: Maybe<Scalars['String']['output']>;
  PaymentDetailsHeader?: Maybe<Scalars['String']['output']>;
  PaymentMethodLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLabel?: Maybe<Scalars['String']['output']>;
  PriceBreakdownHeader?: Maybe<Scalars['String']['output']>;
  PrintReceiptButtonLabel?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeMemberText?: Maybe<Scalars['String']['output']>;
  QualifyingMemberText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SelfPrePaymentLabel?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TOTLevelLabel?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsLabel?: Maybe<Scalars['String']['output']>;
  TotalAmountPaidLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockAdditionalFilingFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockApplicationDetailsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockAttestToProductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockBackDuesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockCotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockCompanyNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockCompanyPrePaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockDisabilityRequestedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockEthicsComplaintLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockFooterAddressTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockFooterPhoneTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockFooterPhoneTextXhtmlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockGoBackButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockHeaderAddressTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockHeaderPhoneTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockHeaderTitleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockLateFeeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockLifeMemberTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockMdrtLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockMemberDetailsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockMemberNameLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockMembershipTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockOrderNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockPaymentDateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockPaymentDetailsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockPaymentMethodLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockPhoneNumberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockPriceBreakdownHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockPrintReceiptButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockQualifyingAndLifeMemberTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockQualifyingMemberTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockSelfPrePaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockTotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockTermsAndConditionsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2BlockTotalAmountPaidLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReceiptStepV2Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ReceiptStepV2BlockAutocomplete = {
  __typename?: 'ReceiptStepV2BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ReceiptStepV2BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepV2BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepV2BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepV2BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepV2BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepV2BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepV2BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepV2BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepV2BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReceiptStepV2BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReceiptStepV2BlockFacet = {
  __typename?: 'ReceiptStepV2BlockFacet';
  AdditionalFilingFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationDetailsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  AttestToProduction?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackDuesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  COTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CompanyNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyPrePaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisabilityRequestedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EthicsComplaintLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FooterAddressText?: Maybe<Array<Maybe<StringFacet>>>;
  FooterPhoneText?: Maybe<Array<Maybe<StringFacet>>>;
  FooterPhoneTextXhtml?: Maybe<Array<Maybe<StringFacet>>>;
  GoBackButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderAddressText?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderPhoneText?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderTitleText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberText?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDetailsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MemberNameLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  OrderNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentDateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentDetailsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentMethodLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PriceBreakdownHeader?: Maybe<Array<Maybe<StringFacet>>>;
  PrintReceiptButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberText?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelfPrePaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TOTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAmountPaidLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ReceiptStepV2BlockFacetAdditionalFilingFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetApplicationDetailsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetAttestToProductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetBackDuesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetCotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReceiptStepV2BlockFacetCompanyNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetCompanyPrePaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReceiptStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetDisabilityRequestedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetEthicsComplaintLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetFooterAddressTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetFooterPhoneTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetFooterPhoneTextXhtmlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetGoBackButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetHeaderAddressTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetHeaderPhoneTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetHeaderTitleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetLateFeeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetLifeMemberTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetMdrtLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetMemberDetailsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetMemberNameLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetMembershipTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetOrderNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetPaymentDateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetPaymentDetailsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetPaymentMethodLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetPhoneNumberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetPriceBreakdownHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetPrintReceiptButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetQualifyingAndLifeMemberTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetQualifyingMemberTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReceiptStepV2BlockFacetSelfPrePaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReceiptStepV2BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReceiptStepV2BlockFacetTotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetTermsAndConditionsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetTotalAmountPaidLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReceiptStepV2BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ReceiptStepV2BlockOrderByInput = {
  AdditionalFilingFeesLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationDetailsHeader?: InputMaybe<OrderBy>;
  AttestToProduction?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  BackDuesLabel?: InputMaybe<OrderBy>;
  COTLevelLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CompanyNameLabel?: InputMaybe<OrderBy>;
  CompanyPrePaymentLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisabilityRequestedLabel?: InputMaybe<OrderBy>;
  EthicsComplaintLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FooterAddressText?: InputMaybe<OrderBy>;
  FooterPhoneText?: InputMaybe<OrderBy>;
  FooterPhoneTextXhtml?: InputMaybe<OrderBy>;
  GoBackButtonText?: InputMaybe<OrderBy>;
  HeaderAddressText?: InputMaybe<OrderBy>;
  HeaderPhoneText?: InputMaybe<OrderBy>;
  HeaderTitleText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeeLabel?: InputMaybe<OrderBy>;
  LifeMemberText?: InputMaybe<OrderBy>;
  MDRTLevelLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  MemberDetailsHeader?: InputMaybe<OrderBy>;
  MemberNameLabel?: InputMaybe<OrderBy>;
  MembershipTypeLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  OrderNumberLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentDateLabel?: InputMaybe<OrderBy>;
  PaymentDetailsHeader?: InputMaybe<OrderBy>;
  PaymentMethodLabel?: InputMaybe<OrderBy>;
  PhoneNumberLabel?: InputMaybe<OrderBy>;
  PriceBreakdownHeader?: InputMaybe<OrderBy>;
  PrintReceiptButtonLabel?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberText?: InputMaybe<OrderBy>;
  QualifyingMemberText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelfPrePaymentLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TOTLevelLabel?: InputMaybe<OrderBy>;
  TermsAndConditionsLabel?: InputMaybe<OrderBy>;
  TotalAmountPaidLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ReceiptStepV2BlockOutput = {
  __typename?: 'ReceiptStepV2BlockOutput';
  autocomplete?: Maybe<ReceiptStepV2BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ReceiptStepV2BlockFacet>;
  item?: Maybe<ReceiptStepV2Block>;
  items?: Maybe<Array<Maybe<ReceiptStepV2Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ReceiptStepV2BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReceiptStepV2BlockWhereInput = {
  AdditionalFilingFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationDetailsHeader?: InputMaybe<SearchableStringFilterInput>;
  AttestToProduction?: InputMaybe<SearchableStringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  BackDuesLabel?: InputMaybe<SearchableStringFilterInput>;
  COTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CompanyNameLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyPrePaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisabilityRequestedLabel?: InputMaybe<SearchableStringFilterInput>;
  EthicsComplaintLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FooterAddressText?: InputMaybe<SearchableStringFilterInput>;
  FooterPhoneText?: InputMaybe<SearchableStringFilterInput>;
  FooterPhoneTextXhtml?: InputMaybe<SearchableStringFilterInput>;
  GoBackButtonText?: InputMaybe<SearchableStringFilterInput>;
  HeaderAddressText?: InputMaybe<SearchableStringFilterInput>;
  HeaderPhoneText?: InputMaybe<SearchableStringFilterInput>;
  HeaderTitleText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeeLabel?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberText?: InputMaybe<SearchableStringFilterInput>;
  MDRTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  MemberDetailsHeader?: InputMaybe<SearchableStringFilterInput>;
  MemberNameLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  OrderNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentDateLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentDetailsHeader?: InputMaybe<SearchableStringFilterInput>;
  PaymentMethodLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLabel?: InputMaybe<SearchableStringFilterInput>;
  PriceBreakdownHeader?: InputMaybe<SearchableStringFilterInput>;
  PrintReceiptButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeMemberText?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMemberText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelfPrePaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TOTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalAmountPaidLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ReceiptStepV2BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ReceiptStepV2BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ReceiptStepV2BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ResetButtonElementBlock = IContent & IData & {
  __typename?: 'ResetButtonElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ResetButtonElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ResetButtonElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ResetButtonElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ResetButtonElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ResetButtonElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ResetButtonElementBlockAutocomplete = {
  __typename?: 'ResetButtonElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ResetButtonElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockFacet = {
  __typename?: 'ResetButtonElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ResetButtonElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResetButtonElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResetButtonElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResetButtonElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResetButtonElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResetButtonElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ResetButtonElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ResetButtonElementBlockOutput = {
  __typename?: 'ResetButtonElementBlockOutput';
  autocomplete?: Maybe<ResetButtonElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ResetButtonElementBlockFacet>;
  item?: Maybe<ResetButtonElementBlock>;
  items?: Maybe<Array<Maybe<ResetButtonElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ResetButtonElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResetButtonElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ResetButtonElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ResetButtonElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ResetButtonElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2Block = IContent & IData & {
  __typename?: 'ReviewAndSubmitStepV2Block';
  AliPayPaymentLabel?: Maybe<Scalars['String']['output']>;
  AlipayHelperText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackButtonLabel?: Maybe<Scalars['String']['output']>;
  COTLevelLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  CreditCardPaymentLabel?: Maybe<Scalars['String']['output']>;
  DataMismatchModal?: Maybe<ReviewAndSubmitStepV2BlockDataMismatchModalBlock>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MDRTLevelLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MembershipLevelSection?: Maybe<ReviewAndSubmitStepV2BlockMembershipLevelSectionBlock>;
  MembershipTypeSection?: Maybe<ReviewAndSubmitStepV2BlockMembershipTypeSectionBlock>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentSectionHeading?: Maybe<Scalars['String']['output']>;
  PriceBreakdownSection?: Maybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlock>;
  ProductionDataSection?: Maybe<ReviewAndSubmitStepV2BlockProductionDataSectionBlock>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TOTLevelLabel?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsCheckboxLabel?: Maybe<Scalars['String']['output']>;
  TermsAndConditionsNotCheckedError?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  YourAnswersSection?: Maybe<ReviewAndSubmitStepV2BlockYourAnswersSectionBlock>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockAliPayPaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockAlipayHelperTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockBackButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockCotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockCreditCardPaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockMdrtLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockPaymentSectionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockTotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockTermsAndConditionsCheckboxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2BlockTermsAndConditionsNotCheckedErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2Block_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal V2 page */
export type ReviewAndSubmitStepV2Block_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ReviewAndSubmitStepV2BlockAutocomplete = {
  __typename?: 'ReviewAndSubmitStepV2BlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ReviewAndSubmitStepV2BlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewAndSubmitStepV2BlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewAndSubmitStepV2BlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewAndSubmitStepV2BlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewAndSubmitStepV2BlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewAndSubmitStepV2BlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewAndSubmitStepV2BlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewAndSubmitStepV2BlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewAndSubmitStepV2BlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewAndSubmitStepV2BlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReviewAndSubmitStepV2BlockDataMismatchModalBlock = {
  __typename?: 'ReviewAndSubmitStepV2BlockDataMismatchModalBlock';
  CloseButtonText?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type ReviewAndSubmitStepV2BlockDataMismatchModalBlockCloseButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockDataMismatchModalBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockDataMismatchModalBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReviewAndSubmitStepV2BlockDataMismatchModalBlockFacet = {
  __typename?: 'ReviewAndSubmitStepV2BlockDataMismatchModalBlockFacet';
  CloseButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ReviewAndSubmitStepV2BlockDataMismatchModalBlockFacetCloseButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockDataMismatchModalBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockDataMismatchModalBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReviewAndSubmitStepV2BlockDataMismatchModalBlockOrderByInput = {
  CloseButtonText?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type ReviewAndSubmitStepV2BlockDataMismatchModalBlockWhereInput = {
  CloseButtonText?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type ReviewAndSubmitStepV2BlockFacet = {
  __typename?: 'ReviewAndSubmitStepV2BlockFacet';
  AliPayPaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AlipayHelperText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  COTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CreditCardPaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DataMismatchModal?: Maybe<ReviewAndSubmitStepV2BlockDataMismatchModalBlockFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MDRTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipLevelSection?: Maybe<ReviewAndSubmitStepV2BlockMembershipLevelSectionBlockFacet>;
  MembershipTypeSection?: Maybe<ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentSectionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PriceBreakdownSection?: Maybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlockFacet>;
  ProductionDataSection?: Maybe<ReviewAndSubmitStepV2BlockProductionDataSectionBlockFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TOTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsCheckboxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndConditionsNotCheckedError?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YourAnswersSection?: Maybe<ReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ReviewAndSubmitStepV2BlockFacetAliPayPaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetAlipayHelperTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetBackButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetCotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewAndSubmitStepV2BlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewAndSubmitStepV2BlockFacetCreditCardPaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetMdrtLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetPaymentSectionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewAndSubmitStepV2BlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewAndSubmitStepV2BlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewAndSubmitStepV2BlockFacetTotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetTermsAndConditionsCheckboxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetTermsAndConditionsNotCheckedErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ReviewAndSubmitStepV2BlockMembershipLevelSectionBlock = {
  __typename?: 'ReviewAndSubmitStepV2BlockMembershipLevelSectionBlock';
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
};


export type ReviewAndSubmitStepV2BlockMembershipLevelSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockMembershipLevelSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReviewAndSubmitStepV2BlockMembershipLevelSectionBlockFacet = {
  __typename?: 'ReviewAndSubmitStepV2BlockMembershipLevelSectionBlockFacet';
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ReviewAndSubmitStepV2BlockMembershipLevelSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockMembershipLevelSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReviewAndSubmitStepV2BlockMembershipLevelSectionBlockOrderByInput = {
  BlockReplacementText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
};

export type ReviewAndSubmitStepV2BlockMembershipLevelSectionBlockWhereInput = {
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
};

export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlock = {
  __typename?: 'ReviewAndSubmitStepV2BlockMembershipTypeSectionBlock';
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  LifeMemberLabel?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeMemberLabel?: Maybe<Scalars['String']['output']>;
  QualifyingMemberLabel?: Maybe<Scalars['String']['output']>;
};


export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockQualifyingAndLifeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockQualifyingMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacet = {
  __typename?: 'ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacet';
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacetLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacetQualifyingAndLifeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockFacetQualifyingMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockOrderByInput = {
  BlockReplacementText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  LifeMemberLabel?: InputMaybe<OrderBy>;
  QualifyingAndLifeMemberLabel?: InputMaybe<OrderBy>;
  QualifyingMemberLabel?: InputMaybe<OrderBy>;
};

export type ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockWhereInput = {
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingMemberLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type ReviewAndSubmitStepV2BlockOrderByInput = {
  AliPayPaymentLabel?: InputMaybe<OrderBy>;
  AlipayHelperText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BackButtonLabel?: InputMaybe<OrderBy>;
  COTLevelLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CreditCardPaymentLabel?: InputMaybe<OrderBy>;
  DataMismatchModal?: InputMaybe<ReviewAndSubmitStepV2BlockDataMismatchModalBlockOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MDRTLevelLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipLevelSection?: InputMaybe<ReviewAndSubmitStepV2BlockMembershipLevelSectionBlockOrderByInput>;
  MembershipTypeSection?: InputMaybe<ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentSectionHeading?: InputMaybe<OrderBy>;
  PriceBreakdownSection?: InputMaybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlockOrderByInput>;
  ProductionDataSection?: InputMaybe<ReviewAndSubmitStepV2BlockProductionDataSectionBlockOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TOTLevelLabel?: InputMaybe<OrderBy>;
  TermsAndConditionsCheckboxLabel?: InputMaybe<OrderBy>;
  TermsAndConditionsNotCheckedError?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  YourAnswersSection?: InputMaybe<ReviewAndSubmitStepV2BlockYourAnswersSectionBlockOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ReviewAndSubmitStepV2BlockOutput = {
  __typename?: 'ReviewAndSubmitStepV2BlockOutput';
  autocomplete?: Maybe<ReviewAndSubmitStepV2BlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ReviewAndSubmitStepV2BlockFacet>;
  item?: Maybe<ReviewAndSubmitStepV2Block>;
  items?: Maybe<Array<Maybe<ReviewAndSubmitStepV2Block>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ReviewAndSubmitStepV2BlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewAndSubmitStepV2BlockPriceBreakdownBlock = {
  __typename?: 'ReviewAndSubmitStepV2BlockPriceBreakdownBlock';
  BackDueLabel?: Maybe<Scalars['String']['output']>;
  BackDueTooltip?: Maybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlock>;
  CompanyPrepaymentLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  LateFeesTooltip?: Maybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlock>;
  PrepaymentLabel?: Maybe<Scalars['String']['output']>;
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockBackDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockCompanyPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockPrepaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockFacet = {
  __typename?: 'ReviewAndSubmitStepV2BlockPriceBreakdownBlockFacet';
  BackDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackDueTooltip?: Maybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacet>;
  CompanyPrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LateFeesTooltip?: Maybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacet>;
  PrepaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetBackDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetCompanyPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetPrepaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockOrderByInput = {
  BackDueLabel?: InputMaybe<OrderBy>;
  BackDueTooltip?: InputMaybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockOrderByInput>;
  CompanyPrepaymentLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  LateFeesTooltip?: InputMaybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockOrderByInput>;
  PrepaymentLabel?: InputMaybe<OrderBy>;
  TotalDueLabel?: InputMaybe<OrderBy>;
};

export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlock = {
  __typename?: 'ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacet = {
  __typename?: 'ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type ReviewAndSubmitStepV2BlockPriceBreakdownBlockWhereInput = {
  BackDueLabel?: InputMaybe<SearchableStringFilterInput>;
  BackDueTooltip?: InputMaybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockWhereInput>;
  CompanyPrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  LateFeesTooltip?: InputMaybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlockTooltipBlockWhereInput>;
  PrepaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type ReviewAndSubmitStepV2BlockProductionDataSectionBlock = {
  __typename?: 'ReviewAndSubmitStepV2BlockProductionDataSectionBlock';
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  CommissionLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncomeLabel?: Maybe<Scalars['String']['output']>;
  LifeMemberAttestmentText?: Maybe<Scalars['String']['output']>;
  PoliciesLabel?: Maybe<Scalars['String']['output']>;
  PolicyLabel?: Maybe<Scalars['String']['output']>;
  PremiumLabel?: Maybe<Scalars['String']['output']>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockCommissionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockIncomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockLifeMemberAttestmentTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockPoliciesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockPolicyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockPremiumLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockFacet = {
  __typename?: 'ReviewAndSubmitStepV2BlockProductionDataSectionBlockFacet';
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifeMemberAttestmentText?: Maybe<Array<Maybe<StringFacet>>>;
  PoliciesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PolicyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetCommissionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetIncomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetLifeMemberAttestmentTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetPoliciesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetPolicyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockFacetPremiumLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockOrderByInput = {
  BlockReplacementText?: InputMaybe<OrderBy>;
  CommissionLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IncomeLabel?: InputMaybe<OrderBy>;
  LifeMemberAttestmentText?: InputMaybe<OrderBy>;
  PoliciesLabel?: InputMaybe<OrderBy>;
  PolicyLabel?: InputMaybe<OrderBy>;
  PremiumLabel?: InputMaybe<OrderBy>;
};

export type ReviewAndSubmitStepV2BlockProductionDataSectionBlockWhereInput = {
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  CommissionLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncomeLabel?: InputMaybe<SearchableStringFilterInput>;
  LifeMemberAttestmentText?: InputMaybe<SearchableStringFilterInput>;
  PoliciesLabel?: InputMaybe<SearchableStringFilterInput>;
  PolicyLabel?: InputMaybe<SearchableStringFilterInput>;
  PremiumLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type ReviewAndSubmitStepV2BlockWhereInput = {
  AliPayPaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  AlipayHelperText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BackButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  COTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CreditCardPaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  DataMismatchModal?: InputMaybe<ReviewAndSubmitStepV2BlockDataMismatchModalBlockWhereInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MDRTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipLevelSection?: InputMaybe<ReviewAndSubmitStepV2BlockMembershipLevelSectionBlockWhereInput>;
  MembershipTypeSection?: InputMaybe<ReviewAndSubmitStepV2BlockMembershipTypeSectionBlockWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentSectionHeading?: InputMaybe<SearchableStringFilterInput>;
  PriceBreakdownSection?: InputMaybe<ReviewAndSubmitStepV2BlockPriceBreakdownBlockWhereInput>;
  ProductionDataSection?: InputMaybe<ReviewAndSubmitStepV2BlockProductionDataSectionBlockWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TOTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsCheckboxLabel?: InputMaybe<SearchableStringFilterInput>;
  TermsAndConditionsNotCheckedError?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  YourAnswersSection?: InputMaybe<ReviewAndSubmitStepV2BlockYourAnswersSectionBlockWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<ReviewAndSubmitStepV2BlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ReviewAndSubmitStepV2BlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ReviewAndSubmitStepV2BlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlock = {
  __typename?: 'ReviewAndSubmitStepV2BlockYourAnswersSectionBlock';
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  FirstQuestionLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  SecondQuestionLabel?: Maybe<Scalars['String']['output']>;
  ThirdQuestionLabel?: Maybe<Scalars['String']['output']>;
};


export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockFirstQuestionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockSecondQuestionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockThirdQuestionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacet = {
  __typename?: 'ReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacet';
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  FirstQuestionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  SecondQuestionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ThirdQuestionLabel?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacetFirstQuestionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacetSecondQuestionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockFacetThirdQuestionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockOrderByInput = {
  BlockReplacementText?: InputMaybe<OrderBy>;
  FirstQuestionLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  SecondQuestionLabel?: InputMaybe<OrderBy>;
  ThirdQuestionLabel?: InputMaybe<OrderBy>;
};

export type ReviewAndSubmitStepV2BlockYourAnswersSectionBlockWhereInput = {
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  FirstQuestionLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  SecondQuestionLabel?: InputMaybe<SearchableStringFilterInput>;
  ThirdQuestionLabel?: InputMaybe<SearchableStringFilterInput>;
};

export type ReviewBlock = IContent & IData & {
  __typename?: 'ReviewBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ReviewBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ReviewBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ReviewBlockAutocomplete = {
  __typename?: 'ReviewBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ReviewBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReviewBlockFacet = {
  __typename?: 'ReviewBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ReviewBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ReviewBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BlockReplacementText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ReviewBlockOutput = {
  __typename?: 'ReviewBlockOutput';
  autocomplete?: Maybe<ReviewBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ReviewBlockFacet>;
  item?: Maybe<ReviewBlock>;
  items?: Maybe<Array<Maybe<ReviewBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ReviewBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ReviewBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ReviewBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ReviewBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Membership Renewal page */
export type ReviewStepBlock = IContent & IData & {
  __typename?: 'ReviewStepBlock';
  AliPaySubmitMessage?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicationSubmittedWaitingMessage?: Maybe<Scalars['String']['output']>;
  ApplicationSubmittedWaitingMessageText?: Maybe<Scalars['String']['output']>;
  BackDuesLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  ChangeMembershipLevelModalHeadline?: Maybe<Scalars['String']['output']>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CoTMembershipLabel?: Maybe<Scalars['String']['output']>;
  CommissionLivesLabel?: Maybe<Scalars['String']['output']>;
  CommissionTotalLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CreateOrderErrorMessage?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  CvcDeclinedErrorMessage?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DisabilityApprovedLabel?: Maybe<Scalars['String']['output']>;
  DisabilityLabel?: Maybe<Scalars['String']['output']>;
  EditMembershipLevelModalHeadline?: Maybe<Scalars['String']['output']>;
  EthicalRequirementsLabel?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpiredCardErrorMessage?: Maybe<Scalars['String']['output']>;
  FiftyYearMembershipLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncomeLivesLabel?: Maybe<Scalars['String']['output']>;
  IncomeTotalLabel?: Maybe<Scalars['String']['output']>;
  IndividualPrePaymentLabel?: Maybe<Scalars['String']['output']>;
  InvalidCardNumberErrorMessage?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LateFeesLabel?: Maybe<Scalars['String']['output']>;
  LifeAttestLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtMembershipLabel?: Maybe<Scalars['String']['output']>;
  MembershipLevelLabel?: Maybe<Scalars['String']['output']>;
  MembershipLevelLinkText?: Maybe<Scalars['String']['output']>;
  MembershipLineItemLabel?: Maybe<Scalars['String']['output']>;
  MembershipTypeLabel?: Maybe<Scalars['String']['output']>;
  MetLifeSponsorshipLineItemLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PastPresidentLabel?: Maybe<Scalars['String']['output']>;
  PaymentError?: Maybe<Scalars['String']['output']>;
  PaymentPending?: Maybe<Scalars['String']['output']>;
  PaymentRetry?: Maybe<Scalars['String']['output']>;
  PaymentSuccess?: Maybe<Scalars['String']['output']>;
  PremiumLivesLabel?: Maybe<Scalars['String']['output']>;
  PremiumTotalLabel?: Maybe<Scalars['String']['output']>;
  PriceBreakdownLabel?: Maybe<Scalars['String']['output']>;
  ProfessionalAssociationLabel?: Maybe<Scalars['String']['output']>;
  QualifyingAndLifeAttestLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** The text for this step in the navigation */
  StepName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TaxesLineItemLabel?: Maybe<Scalars['String']['output']>;
  TermsAndAgreementsText?: Maybe<Scalars['String']['output']>;
  ToTMembershipLabel?: Maybe<Scalars['String']['output']>;
  ToTReviewDescription?: Maybe<Scalars['String']['output']>;
  TotalDueLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockAliPaySubmitMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockApplicationSubmittedWaitingMessageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockBackDuesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockChangeMembershipLevelModalHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockCoTMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockCommissionLivesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockCommissionTotalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockCreateOrderErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockCvcDeclinedErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockDisabilityApprovedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockDisabilityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockEditMembershipLevelModalHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockEthicalRequirementsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockExpiredCardErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockFiftyYearMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockIncomeLivesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockIncomeTotalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockIndividualPrePaymentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockInvalidCardNumberErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockLateFeesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockLifeAttestLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockMdrtMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockMembershipLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockMembershipLevelLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockMembershipLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockMembershipTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockMetLifeSponsorshipLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockPastPresidentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockPaymentErrorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockPaymentPendingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockPaymentRetryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockPaymentSuccessArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockPremiumLivesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockPremiumTotalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockPriceBreakdownLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockProfessionalAssociationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockQualifyingAndLifeAttestLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockStepNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockTaxesLineItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockTermsAndAgreementsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockToTMembershipLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockToTReviewDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlockTotalDueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Membership Renewal page */
export type ReviewStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ReviewStepBlockAutocomplete = {
  __typename?: 'ReviewStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ApplicationSubmittedWaitingMessage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ReviewStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewStepBlockAutocompleteApplicationSubmittedWaitingMessageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ReviewStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ReviewStepBlockFacet = {
  __typename?: 'ReviewStepBlockFacet';
  AliPaySubmitMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationSubmittedWaitingMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ApplicationSubmittedWaitingMessageText?: Maybe<Array<Maybe<StringFacet>>>;
  BackDuesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  ChangeMembershipLevelModalHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CoTMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionLivesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CommissionTotalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CreateOrderErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CvcDeclinedErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisabilityApprovedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  DisabilityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditMembershipLevelModalHeadline?: Maybe<Array<Maybe<StringFacet>>>;
  EthicalRequirementsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpiredCardErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  FiftyYearMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeLivesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IncomeTotalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IndividualPrePaymentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  InvalidCardNumberErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LateFeesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LifeAttestLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevelLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MetLifeSponsorshipLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PastPresidentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentError?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentPending?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentRetry?: Maybe<Array<Maybe<StringFacet>>>;
  PaymentSuccess?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumLivesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PremiumTotalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PriceBreakdownLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfessionalAssociationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  QualifyingAndLifeAttestLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TaxesLineItemLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TermsAndAgreementsText?: Maybe<Array<Maybe<StringFacet>>>;
  ToTMembershipLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ToTReviewDescription?: Maybe<Array<Maybe<StringFacet>>>;
  TotalDueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ReviewStepBlockFacetAliPaySubmitMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetApplicationSubmittedWaitingMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetApplicationSubmittedWaitingMessageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetBackDuesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetChangeMembershipLevelModalHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewStepBlockFacetCoTMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetCommissionLivesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetCommissionTotalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetCreateOrderErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewStepBlockFacetCvcDeclinedErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetDisabilityApprovedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetDisabilityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetEditMembershipLevelModalHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetEthicalRequirementsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetExpiredCardErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetFiftyYearMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetIncomeLivesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetIncomeTotalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetIndividualPrePaymentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetInvalidCardNumberErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetLateFeesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetLifeAttestLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetMdrtMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetMembershipLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetMembershipLevelLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetMembershipLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetMembershipTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetMetLifeSponsorshipLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetPastPresidentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetPaymentErrorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetPaymentPendingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetPaymentRetryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetPaymentSuccessArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetPremiumLivesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetPremiumTotalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetPriceBreakdownLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetProfessionalAssociationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetQualifyingAndLifeAttestLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetStepNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewStepBlockFacetTaxesLineItemLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetTermsAndAgreementsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetToTMembershipLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetToTReviewDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetTotalDueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ReviewStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ReviewStepBlockOrderByInput = {
  AliPaySubmitMessage?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ApplicationSubmittedWaitingMessage?: InputMaybe<OrderBy>;
  ApplicationSubmittedWaitingMessageText?: InputMaybe<OrderBy>;
  BackDuesLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  ChangeMembershipLevelModalHeadline?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  CoTMembershipLabel?: InputMaybe<OrderBy>;
  CommissionLivesLabel?: InputMaybe<OrderBy>;
  CommissionTotalLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CreateOrderErrorMessage?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CvcDeclinedErrorMessage?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisabilityApprovedLabel?: InputMaybe<OrderBy>;
  DisabilityLabel?: InputMaybe<OrderBy>;
  EditMembershipLevelModalHeadline?: InputMaybe<OrderBy>;
  EthicalRequirementsLabel?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpiredCardErrorMessage?: InputMaybe<OrderBy>;
  FiftyYearMembershipLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IncomeLivesLabel?: InputMaybe<OrderBy>;
  IncomeTotalLabel?: InputMaybe<OrderBy>;
  IndividualPrePaymentLabel?: InputMaybe<OrderBy>;
  InvalidCardNumberErrorMessage?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LateFeesLabel?: InputMaybe<OrderBy>;
  LifeAttestLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtMembershipLabel?: InputMaybe<OrderBy>;
  MembershipLevelLabel?: InputMaybe<OrderBy>;
  MembershipLevelLinkText?: InputMaybe<OrderBy>;
  MembershipLineItemLabel?: InputMaybe<OrderBy>;
  MembershipTypeLabel?: InputMaybe<OrderBy>;
  MetLifeSponsorshipLineItemLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PastPresidentLabel?: InputMaybe<OrderBy>;
  PaymentError?: InputMaybe<OrderBy>;
  PaymentPending?: InputMaybe<OrderBy>;
  PaymentRetry?: InputMaybe<OrderBy>;
  PaymentSuccess?: InputMaybe<OrderBy>;
  PremiumLivesLabel?: InputMaybe<OrderBy>;
  PremiumTotalLabel?: InputMaybe<OrderBy>;
  PriceBreakdownLabel?: InputMaybe<OrderBy>;
  ProfessionalAssociationLabel?: InputMaybe<OrderBy>;
  QualifyingAndLifeAttestLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TaxesLineItemLabel?: InputMaybe<OrderBy>;
  TermsAndAgreementsText?: InputMaybe<OrderBy>;
  ToTMembershipLabel?: InputMaybe<OrderBy>;
  ToTReviewDescription?: InputMaybe<OrderBy>;
  TotalDueLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ReviewStepBlockOutput = {
  __typename?: 'ReviewStepBlockOutput';
  autocomplete?: Maybe<ReviewStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ReviewStepBlockFacet>;
  item?: Maybe<ReviewStepBlock>;
  items?: Maybe<Array<Maybe<ReviewStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ReviewStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewStepBlockWhereInput = {
  AliPaySubmitMessage?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ApplicationSubmittedWaitingMessage?: InputMaybe<StringFilterInput>;
  ApplicationSubmittedWaitingMessageText?: InputMaybe<SearchableStringFilterInput>;
  BackDuesLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  ChangeMembershipLevelModalHeadline?: InputMaybe<SearchableStringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CoTMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  CommissionLivesLabel?: InputMaybe<SearchableStringFilterInput>;
  CommissionTotalLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CreateOrderErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CvcDeclinedErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisabilityApprovedLabel?: InputMaybe<SearchableStringFilterInput>;
  DisabilityLabel?: InputMaybe<SearchableStringFilterInput>;
  EditMembershipLevelModalHeadline?: InputMaybe<SearchableStringFilterInput>;
  EthicalRequirementsLabel?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpiredCardErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  FiftyYearMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncomeLivesLabel?: InputMaybe<SearchableStringFilterInput>;
  IncomeTotalLabel?: InputMaybe<SearchableStringFilterInput>;
  IndividualPrePaymentLabel?: InputMaybe<SearchableStringFilterInput>;
  InvalidCardNumberErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LateFeesLabel?: InputMaybe<SearchableStringFilterInput>;
  LifeAttestLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevelLinkText?: InputMaybe<SearchableStringFilterInput>;
  MembershipLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  MetLifeSponsorshipLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PastPresidentLabel?: InputMaybe<SearchableStringFilterInput>;
  PaymentError?: InputMaybe<SearchableStringFilterInput>;
  PaymentPending?: InputMaybe<SearchableStringFilterInput>;
  PaymentRetry?: InputMaybe<SearchableStringFilterInput>;
  PaymentSuccess?: InputMaybe<SearchableStringFilterInput>;
  PremiumLivesLabel?: InputMaybe<SearchableStringFilterInput>;
  PremiumTotalLabel?: InputMaybe<SearchableStringFilterInput>;
  PriceBreakdownLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfessionalAssociationLabel?: InputMaybe<SearchableStringFilterInput>;
  QualifyingAndLifeAttestLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TaxesLineItemLabel?: InputMaybe<SearchableStringFilterInput>;
  TermsAndAgreementsText?: InputMaybe<SearchableStringFilterInput>;
  ToTMembershipLabel?: InputMaybe<SearchableStringFilterInput>;
  ToTReviewDescription?: InputMaybe<SearchableStringFilterInput>;
  TotalDueLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ReviewStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ReviewStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ReviewStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A stand alone, full width rich text editor */
export type RichTextBlock = IContent & IData & {
  __typename?: 'RichTextBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A stand alone, full width rich text editor */
export type RichTextBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A stand alone, full width rich text editor */
export type RichTextBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A stand alone, full width rich text editor */
export type RichTextBlockContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A stand alone, full width rich text editor */
export type RichTextBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A stand alone, full width rich text editor */
export type RichTextBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A stand alone, full width rich text editor */
export type RichTextBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A stand alone, full width rich text editor */
export type RichTextBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A stand alone, full width rich text editor */
export type RichTextBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RichTextBlockAutocomplete = {
  __typename?: 'RichTextBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RichTextBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RichTextBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RichTextBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RichTextBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RichTextBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RichTextBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RichTextBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RichTextBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RichTextBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RichTextBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RichTextBlockFacet = {
  __typename?: 'RichTextBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type RichTextBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RichTextBlockFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RichTextBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RichTextBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RichTextBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RichTextBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RichTextBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RichTextBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RichTextBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type RichTextBlockOutput = {
  __typename?: 'RichTextBlockOutput';
  autocomplete?: Maybe<RichTextBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RichTextBlockFacet>;
  item?: Maybe<RichTextBlock>;
  items?: Maybe<Array<Maybe<RichTextBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type RichTextBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RichTextBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<RichTextBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RichTextBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RichTextBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds data for the Next Steps Block on the Membership Renewal page */
export type RoutingStepBlock = IContent & IData & {
  __typename?: 'RoutingStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CalloutButton?: Maybe<RoutingStepBlockLinkBlock>;
  CalloutHeading?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainSiteButton?: Maybe<RoutingStepBlockLinkBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StepNavigationName?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
  TileCards?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  TileCardsHeading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds data for the Next Steps Block on the Membership Renewal page */
export type RoutingStepBlockCalloutHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Next Steps Block on the Membership Renewal page */
export type RoutingStepBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Next Steps Block on the Membership Renewal page */
export type RoutingStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Next Steps Block on the Membership Renewal page */
export type RoutingStepBlockStepNavigationNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Next Steps Block on the Membership Renewal page */
export type RoutingStepBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Next Steps Block on the Membership Renewal page */
export type RoutingStepBlockTileCardsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Next Steps Block on the Membership Renewal page */
export type RoutingStepBlockTileCardsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Next Steps Block on the Membership Renewal page */
export type RoutingStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds data for the Next Steps Block on the Membership Renewal page */
export type RoutingStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RoutingStepBlockAutocomplete = {
  __typename?: 'RoutingStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CalloutButton?: Maybe<RoutingStepBlockLinkBlockAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MainSiteButton?: Maybe<RoutingStepBlockLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RoutingStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RoutingStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RoutingStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RoutingStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RoutingStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RoutingStepBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RoutingStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RoutingStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RoutingStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RoutingStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RoutingStepBlockFacet = {
  __typename?: 'RoutingStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CalloutButton?: Maybe<RoutingStepBlockLinkBlockFacet>;
  CalloutHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainSiteButton?: Maybe<RoutingStepBlockLinkBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StepNavigationName?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
  TileCards?: Maybe<ContentAreaItemModelSearchFacet>;
  TileCardsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type RoutingStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetCalloutHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RoutingStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RoutingStepBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RoutingStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RoutingStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RoutingStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetStepNavigationNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RoutingStepBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetTileCardsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RoutingStepBlockLinkBlock = {
  __typename?: 'RoutingStepBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type RoutingStepBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RoutingStepBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RoutingStepBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RoutingStepBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RoutingStepBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RoutingStepBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RoutingStepBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type RoutingStepBlockLinkBlockAutocomplete = {
  __typename?: 'RoutingStepBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RoutingStepBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RoutingStepBlockLinkBlockFacet = {
  __typename?: 'RoutingStepBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type RoutingStepBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RoutingStepBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RoutingStepBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RoutingStepBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type RoutingStepBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type RoutingStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CalloutButton?: InputMaybe<RoutingStepBlockLinkBlockOrderByInput>;
  CalloutHeading?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainSiteButton?: InputMaybe<RoutingStepBlockLinkBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StepNavigationName?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
  TileCards?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  TileCardsHeading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type RoutingStepBlockOutput = {
  __typename?: 'RoutingStepBlockOutput';
  autocomplete?: Maybe<RoutingStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RoutingStepBlockFacet>;
  item?: Maybe<RoutingStepBlock>;
  items?: Maybe<Array<Maybe<RoutingStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type RoutingStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoutingStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CalloutButton?: InputMaybe<RoutingStepBlockLinkBlockWhereInput>;
  CalloutHeading?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainSiteButton?: InputMaybe<RoutingStepBlockLinkBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StepNavigationName?: InputMaybe<SearchableStringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
  TileCards?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  TileCardsHeading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<RoutingStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RoutingStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RoutingStepBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type RowContent = {
  __typename?: 'RowContent';
  ColumnFour?: Maybe<Scalars['String']['output']>;
  ColumnOne?: Maybe<Scalars['String']['output']>;
  ColumnThree?: Maybe<Scalars['String']['output']>;
  ColumnTwo?: Maybe<Scalars['String']['output']>;
};

export type RowContentAutocomplete = {
  __typename?: 'RowContentAutocomplete';
  ColumnFour?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ColumnOne?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ColumnThree?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ColumnTwo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RowContentAutocompleteColumnFourArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RowContentAutocompleteColumnOneArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RowContentAutocompleteColumnThreeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RowContentAutocompleteColumnTwoArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RowContentFacet = {
  __typename?: 'RowContentFacet';
  ColumnFour?: Maybe<Array<Maybe<StringFacet>>>;
  ColumnOne?: Maybe<Array<Maybe<StringFacet>>>;
  ColumnThree?: Maybe<Array<Maybe<StringFacet>>>;
  ColumnTwo?: Maybe<Array<Maybe<StringFacet>>>;
};


export type RowContentFacetColumnFourArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RowContentFacetColumnOneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RowContentFacetColumnThreeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RowContentFacetColumnTwoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RowContentOrderByInput = {
  ColumnFour?: InputMaybe<OrderBy>;
  ColumnOne?: InputMaybe<OrderBy>;
  ColumnThree?: InputMaybe<OrderBy>;
  ColumnTwo?: InputMaybe<OrderBy>;
};

export type RowContentWhereInput = {
  ColumnFour?: InputMaybe<StringFilterInput>;
  ColumnOne?: InputMaybe<StringFilterInput>;
  ColumnThree?: InputMaybe<StringFilterInput>;
  ColumnTwo?: InputMaybe<StringFilterInput>;
};

/** The main search page */
export type SearchPage = IContent & IData & {
  __typename?: 'SearchPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ArticleResultLabel?: Maybe<Scalars['String']['output']>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AudioResultLabel?: Maybe<Scalars['String']['output']>;
  AuthorAndFeaturedPersonLabel?: Maybe<Scalars['String']['output']>;
  BookmarkTermLabel?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ClearAllLabel?: Maybe<Scalars['String']['output']>;
  ClearButtonLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentSourceFilterLabel?: Maybe<Scalars['String']['output']>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeFilterLabel?: Maybe<Scalars['String']['output']>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ErrorResultsText?: Maybe<Scalars['String']['output']>;
  EventResultLabel?: Maybe<Scalars['String']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  FiltersLabel?: Maybe<Scalars['String']['output']>;
  GuideResultLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Shown as the inline text in the login prompt button. */
  LoginPromptButtonText?: Maybe<Scalars['String']['output']>;
  /** Shown as the main content of the bigger login prompt. */
  LoginPromptContent?: Maybe<Scalars['String']['output']>;
  /** Path used to redirect user to login page. */
  LoginPromptRedirectPath?: Maybe<Scalars['String']['output']>;
  /** Shown as the inline text in the login prompt button, when many search results are returned. */
  LoginPromptRichContent?: Maybe<Scalars['String']['output']>;
  /** Shown as the title in the login prompt. */
  LoginPromptTitle?: Maybe<Scalars['String']['output']>;
  MarketingResultLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<SearchPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  MyResourcesFilterLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  NoMatchesLabel?: Maybe<Scalars['String']['output']>;
  NoResultsText?: Maybe<Scalars['String']['output']>;
  NoResultsTextLoggedIn?: Maybe<Scalars['String']['output']>;
  NoResultsTextLoggedOut?: Maybe<Scalars['String']['output']>;
  PageButtonLabel?: Maybe<Scalars['String']['output']>;
  /** Displays the page numbers text. Uses variables {{resultsShown}}, {{totalResults}}, and {{searchTerm}} */
  PageNumbersText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaylistResultLabel?: Maybe<Scalars['String']['output']>;
  PodcastResultLabel?: Maybe<Scalars['String']['output']>;
  PressReleaseResultLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  /** Shown when the user doesn't have access to some results in the current search query */
  RestrictedContentText?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SearchBarPlaceholder?: Maybe<Scalars['String']['output']>;
  SearchButtonLabel?: Maybe<Scalars['String']['output']>;
  SearchPlaceholderLabel?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteContentResultLabel?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SortByBestMatchLabel?: Maybe<Scalars['String']['output']>;
  SortByMostRecentLabel?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  StoreResultLabel?: Maybe<Scalars['String']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<SearchPageImageBlock>;
  TopicsFilterLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VideoResultLabel?: Maybe<Scalars['String']['output']>;
  YearFilterLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The main search page */
export type SearchPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageArticleResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageAudioResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageAuthorAndFeaturedPersonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageBookmarkTermLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageClearAllLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageClearButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageContentSourceFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageContentTypeFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageErrorResultsTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageEventResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageFiltersLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageGuideResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageLoginPromptButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageLoginPromptContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageLoginPromptRedirectPathArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageLoginPromptRichContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageLoginPromptTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageMarketingResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageMyResourcesFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageNoMatchesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageNoResultsTextLoggedInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageNoResultsTextLoggedOutArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPagePageButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPagePageNumbersTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPagePlaylistResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPagePodcastResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPagePressReleaseResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageRestrictedContentTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageSearchBarPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageSearchButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageSearchPlaceholderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageSiteContentResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageSortByBestMatchLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageSortByMostRecentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageStoreResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageTopicsFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageVideoResultLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPageYearFilterLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The main search page */
export type SearchPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SearchPageAutocomplete = {
  __typename?: 'SearchPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<SearchPageImageBlockAutocomplete>;
  NoResultsText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<SearchPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SearchPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageAutocompleteNoResultsTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchPageFacet = {
  __typename?: 'SearchPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ArticleResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  AudioResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorAndFeaturedPersonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BookmarkTermLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ClearAllLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ClearButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentSourceFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  EventResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FiltersLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GuideResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LoginPromptButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  LoginPromptContent?: Maybe<Array<Maybe<StringFacet>>>;
  LoginPromptRedirectPath?: Maybe<Array<Maybe<StringFacet>>>;
  LoginPromptRichContent?: Maybe<Array<Maybe<StringFacet>>>;
  LoginPromptTitle?: Maybe<Array<Maybe<StringFacet>>>;
  MarketingResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<SearchPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  MyResourcesFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NoMatchesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NoResultsText?: Maybe<Array<Maybe<StringFacet>>>;
  NoResultsTextLoggedIn?: Maybe<Array<Maybe<StringFacet>>>;
  NoResultsTextLoggedOut?: Maybe<Array<Maybe<StringFacet>>>;
  PageButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PageNumbersText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaylistResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PodcastResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PressReleaseResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RestrictedContentText?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchBarPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  SearchButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SearchPlaceholderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteContentResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SortByBestMatchLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SortByMostRecentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StoreResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ThumbnailImage?: Maybe<SearchPageImageBlockFacet>;
  TopicsFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VideoResultLabel?: Maybe<Array<Maybe<StringFacet>>>;
  YearFilterLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SearchPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetArticleResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetAudioResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetAuthorAndFeaturedPersonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetBookmarkTermLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchPageFacetClearAllLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetClearButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetContentSourceFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetContentTypeFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SearchPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetErrorResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetEventResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetFiltersLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetGuideResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SearchPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetLoginPromptButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetLoginPromptContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetLoginPromptRedirectPathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetLoginPromptRichContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetLoginPromptTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetMarketingResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetMyResourcesFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetNoMatchesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetNoResultsTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetNoResultsTextLoggedInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetNoResultsTextLoggedOutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetPageButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetPageNumbersTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetPlaylistResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetPodcastResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetPressReleaseResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetRestrictedContentTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchPageFacetSearchBarPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetSearchButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetSearchPlaceholderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetSiteContentResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetSortByBestMatchLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetSortByMostRecentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchPageFacetStoreResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetTopicsFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetVideoResultLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacetYearFilterLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SearchPageImageBlock = {
  __typename?: 'SearchPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type SearchPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SearchPageImageBlockAutocomplete = {
  __typename?: 'SearchPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type SearchPageImageBlockFacet = {
  __typename?: 'SearchPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SearchPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SearchPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type SearchPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ArticleResultLabel?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AudioResultLabel?: InputMaybe<OrderBy>;
  AuthorAndFeaturedPersonLabel?: InputMaybe<OrderBy>;
  BookmarkTermLabel?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ClearAllLabel?: InputMaybe<OrderBy>;
  ClearButtonLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentSourceFilterLabel?: InputMaybe<OrderBy>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeFilterLabel?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ErrorResultsText?: InputMaybe<OrderBy>;
  EventResultLabel?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FiltersLabel?: InputMaybe<OrderBy>;
  GuideResultLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LoginPromptButtonText?: InputMaybe<OrderBy>;
  LoginPromptContent?: InputMaybe<OrderBy>;
  LoginPromptRedirectPath?: InputMaybe<OrderBy>;
  LoginPromptRichContent?: InputMaybe<OrderBy>;
  LoginPromptTitle?: InputMaybe<OrderBy>;
  MarketingResultLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<SearchPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  MyResourcesFilterLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  NoMatchesLabel?: InputMaybe<OrderBy>;
  NoResultsText?: InputMaybe<OrderBy>;
  NoResultsTextLoggedIn?: InputMaybe<OrderBy>;
  NoResultsTextLoggedOut?: InputMaybe<OrderBy>;
  PageButtonLabel?: InputMaybe<OrderBy>;
  PageNumbersText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaylistResultLabel?: InputMaybe<OrderBy>;
  PodcastResultLabel?: InputMaybe<OrderBy>;
  PressReleaseResultLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RestrictedContentText?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchBarPlaceholder?: InputMaybe<OrderBy>;
  SearchButtonLabel?: InputMaybe<OrderBy>;
  SearchPlaceholderLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteContentResultLabel?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SortByBestMatchLabel?: InputMaybe<OrderBy>;
  SortByMostRecentLabel?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  StoreResultLabel?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<SearchPageImageBlockOrderByInput>;
  TopicsFilterLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VideoResultLabel?: InputMaybe<OrderBy>;
  YearFilterLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SearchPageOutput = {
  __typename?: 'SearchPageOutput';
  autocomplete?: Maybe<SearchPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SearchPageFacet>;
  item?: Maybe<SearchPage>;
  items?: Maybe<Array<Maybe<SearchPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SearchPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The page containing content for Search V2 */
export type SearchPageV2 = IContent & IData & {
  __typename?: 'SearchPageV2';
  AllResourcesLabel?: Maybe<Scalars['String']['output']>;
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ArticlesLabel?: Maybe<Scalars['String']['output']>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AudioLabel?: Maybe<Scalars['String']['output']>;
  AuthorFeaturedPersonLabel?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** Text used for no results message line 2 */
  CheckYourSpellingText?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  FilterResultsLabel?: Maybe<Scalars['String']['output']>;
  FiltersLabel?: Maybe<Scalars['String']['output']>;
  GuidesLabel?: Maybe<Scalars['String']['output']>;
  /** Text used for no results message line 3 */
  IfNotMemberText?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<SearchPageV2ImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  /** Text used for no results message line 1 */
  NoResultsFoundText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SavedContentLabel?: Maybe<Scalars['String']['output']>;
  /** Text used as aria label for clear input button */
  SearchInputClearButtonLabel?: Maybe<Scalars['String']['output']>;
  /** Text displayed in the search input when it's empty */
  SearchInputPlaceholder?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  /** Text used for no results message line 3 */
  SignInLabel?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SourceLabel?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<SearchPageV2ImageBlock>;
  TopicLabel?: Maybe<Scalars['String']['output']>;
  /** The label for total search results text */
  TotalResultsLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VideosLabel?: Maybe<Scalars['String']['output']>;
  YearLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for Search V2 */
export type SearchPageV2AllResourcesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2AnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2ArticlesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2AudioLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2AuthorFeaturedPersonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2CheckYourSpellingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2FilterResultsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2FiltersLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2GuidesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2IfNotMemberTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2MetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2MetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2MetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2NameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2NoResultsFoundTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2SavedContentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2SearchInputClearButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2SearchInputPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2SignInLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2SourceLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2TopicLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2TotalResultsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2VideosLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2YearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for Search V2 */
export type SearchPageV2_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SearchPageV2Autocomplete = {
  __typename?: 'SearchPageV2Autocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<SearchPageV2ImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<SearchPageV2ImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SearchPageV2AutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageV2AutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageV2AutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageV2AutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageV2AutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageV2AutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageV2AutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageV2AutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageV2AutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchPageV2Autocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchPageV2Facet = {
  __typename?: 'SearchPageV2Facet';
  AllResourcesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ArticlesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  AudioLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorFeaturedPersonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CheckYourSpellingText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  FilterResultsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FiltersLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GuidesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IfNotMemberText?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<SearchPageV2ImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NoResultsFoundText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SavedContentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SearchInputClearButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SearchInputPlaceholder?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SignInLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SourceLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<SearchPageV2ImageBlockFacet>;
  TopicLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TotalResultsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VideosLabel?: Maybe<Array<Maybe<StringFacet>>>;
  YearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SearchPageV2FacetAllResourcesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetArticlesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetAudioLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetAuthorFeaturedPersonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchPageV2FacetCheckYourSpellingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SearchPageV2FacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchPageV2FacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetFilterResultsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetFiltersLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetGuidesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetIfNotMemberTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SearchPageV2FacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetNoResultsFoundTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchPageV2FacetSavedContentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetSearchInputClearButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetSearchInputPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetSignInLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetSourceLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchPageV2FacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchPageV2FacetTopicLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetTotalResultsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetVideosLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2FacetYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2Facet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2Facet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SearchPageV2ImageBlock = {
  __typename?: 'SearchPageV2ImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type SearchPageV2ImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPageV2ImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPageV2ImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPageV2ImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchPageV2ImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SearchPageV2ImageBlockAutocomplete = {
  __typename?: 'SearchPageV2ImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type SearchPageV2ImageBlockFacet = {
  __typename?: 'SearchPageV2ImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SearchPageV2ImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2ImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2ImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2ImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchPageV2ImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SearchPageV2ImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchPageV2ImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type SearchPageV2ImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchPageV2OrderByInput = {
  AllResourcesLabel?: InputMaybe<OrderBy>;
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  ArticlesLabel?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AudioLabel?: InputMaybe<OrderBy>;
  AuthorFeaturedPersonLabel?: InputMaybe<OrderBy>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CheckYourSpellingText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  FilterResultsLabel?: InputMaybe<OrderBy>;
  FiltersLabel?: InputMaybe<OrderBy>;
  GuidesLabel?: InputMaybe<OrderBy>;
  IfNotMemberText?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<SearchPageV2ImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NoResultsFoundText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SavedContentLabel?: InputMaybe<OrderBy>;
  SearchInputClearButtonLabel?: InputMaybe<OrderBy>;
  SearchInputPlaceholder?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SignInLabel?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SourceLabel?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<SearchPageV2ImageBlockOrderByInput>;
  TopicLabel?: InputMaybe<OrderBy>;
  TotalResultsLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VideosLabel?: InputMaybe<OrderBy>;
  YearLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SearchPageV2Output = {
  __typename?: 'SearchPageV2Output';
  autocomplete?: Maybe<SearchPageV2Autocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SearchPageV2Facet>;
  item?: Maybe<SearchPageV2>;
  items?: Maybe<Array<Maybe<SearchPageV2>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SearchPageV2OutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchPageV2WhereInput = {
  AllResourcesLabel?: InputMaybe<SearchableStringFilterInput>;
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ArticlesLabel?: InputMaybe<SearchableStringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AudioLabel?: InputMaybe<SearchableStringFilterInput>;
  AuthorFeaturedPersonLabel?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CheckYourSpellingText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FilterResultsLabel?: InputMaybe<SearchableStringFilterInput>;
  FiltersLabel?: InputMaybe<SearchableStringFilterInput>;
  GuidesLabel?: InputMaybe<SearchableStringFilterInput>;
  IfNotMemberText?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<SearchPageV2ImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NoResultsFoundText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SavedContentLabel?: InputMaybe<SearchableStringFilterInput>;
  SearchInputClearButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  SearchInputPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SignInLabel?: InputMaybe<SearchableStringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SourceLabel?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<SearchPageV2ImageBlockWhereInput>;
  TopicLabel?: InputMaybe<SearchableStringFilterInput>;
  TotalResultsLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VideosLabel?: InputMaybe<SearchableStringFilterInput>;
  YearLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SearchPageV2WhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SearchPageV2WhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SearchPageV2WhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SearchPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ArticleResultLabel?: InputMaybe<SearchableStringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AudioResultLabel?: InputMaybe<SearchableStringFilterInput>;
  AuthorAndFeaturedPersonLabel?: InputMaybe<SearchableStringFilterInput>;
  BookmarkTermLabel?: InputMaybe<SearchableStringFilterInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ClearAllLabel?: InputMaybe<SearchableStringFilterInput>;
  ClearButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentSourceFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ErrorResultsText?: InputMaybe<SearchableStringFilterInput>;
  EventResultLabel?: InputMaybe<SearchableStringFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  FiltersLabel?: InputMaybe<SearchableStringFilterInput>;
  GuideResultLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LoginPromptButtonText?: InputMaybe<SearchableStringFilterInput>;
  LoginPromptContent?: InputMaybe<SearchableStringFilterInput>;
  LoginPromptRedirectPath?: InputMaybe<SearchableStringFilterInput>;
  LoginPromptRichContent?: InputMaybe<SearchableStringFilterInput>;
  LoginPromptTitle?: InputMaybe<SearchableStringFilterInput>;
  MarketingResultLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<SearchPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  MyResourcesFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NoMatchesLabel?: InputMaybe<SearchableStringFilterInput>;
  NoResultsText?: InputMaybe<StringFilterInput>;
  NoResultsTextLoggedIn?: InputMaybe<SearchableStringFilterInput>;
  NoResultsTextLoggedOut?: InputMaybe<SearchableStringFilterInput>;
  PageButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PageNumbersText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaylistResultLabel?: InputMaybe<SearchableStringFilterInput>;
  PodcastResultLabel?: InputMaybe<SearchableStringFilterInput>;
  PressReleaseResultLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RestrictedContentText?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchBarPlaceholder?: InputMaybe<SearchableStringFilterInput>;
  SearchButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  SearchPlaceholderLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteContentResultLabel?: InputMaybe<SearchableStringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SortByBestMatchLabel?: InputMaybe<SearchableStringFilterInput>;
  SortByMostRecentLabel?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  StoreResultLabel?: InputMaybe<SearchableStringFilterInput>;
  ThumbnailImage?: InputMaybe<SearchPageImageBlockWhereInput>;
  TopicsFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VideoResultLabel?: InputMaybe<SearchableStringFilterInput>;
  YearFilterLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SearchPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SearchPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SearchPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SearchableStringFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `contains` performs full-text search on a word or phrase. */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** enables supporting fuzzy matching on the query terms (keywords), which returns items that contain terms in the content similar to the keywords, as measured by a _Levenshtein edit distance_. An edit distance is the number of one-character changes needed to turn one term into another. The edit distance is based on the length of the term.  */
  fuzzy?: InputMaybe<Scalars['Boolean']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `like` matches on substrings with wildcard support: `%` to match on 0 or more characters, `_` to match on any character.  */
  like?: InputMaybe<Scalars['String']['input']>;
  /** `match` performs full-text search on a word or phrase where less relevant items are also returned. The `match` operator is only supported for `searchable` fields. It will improve fulltext search by making it easier to match on words. More exact matches will be ranked higher, less exact matches will be ranked lower. The `match` operator is supported with synonyms and fuzzy search. */
  match?: InputMaybe<Scalars['String']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `starts_with` retrieves matches that start with a certain value (prefix). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** expands query value with synonyms. Example: if `H2O` is a synonym of `water`, then querying for `water` will also return results with `H2O`. */
  synonyms?: InputMaybe<Array<InputMaybe<SynonymSlot>>>;
};

/** A block that shows a list of in-page anchors to sections of contents within this container */
export type SectionContainerBlock = IContent & IData & {
  __typename?: 'SectionContainerBlock';
  /** Additional links rendered after the section links */
  AdditionalLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** Any Section Block placed here will receive a link on the side of this container */
  Items?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** The label that appears for the flyup menu on mobile */
  MobileMenuText?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block that shows a list of in-page anchors to sections of contents within this container */
export type SectionContainerBlockAdditionalLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block that shows a list of in-page anchors to sections of contents within this container */
export type SectionContainerBlockItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block that shows a list of in-page anchors to sections of contents within this container */
export type SectionContainerBlockMobileMenuTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block that shows a list of in-page anchors to sections of contents within this container */
export type SectionContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block that shows a list of in-page anchors to sections of contents within this container */
export type SectionContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block that shows a list of in-page anchors to sections of contents within this container */
export type SectionContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SectionContainerBlockAutocomplete = {
  __typename?: 'SectionContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SectionContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SectionContainerBlockFacet = {
  __typename?: 'SectionContainerBlockFacet';
  AdditionalLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<ContentAreaItemModelSearchFacet>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MobileMenuText?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SectionContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SectionContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacetMobileMenuTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SectionContainerBlockOrderByInput = {
  AdditionalLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Items?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MobileMenuText?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SectionContainerBlockOutput = {
  __typename?: 'SectionContainerBlockOutput';
  autocomplete?: Maybe<SectionContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SectionContainerBlockFacet>;
  item?: Maybe<SectionContainerBlock>;
  items?: Maybe<Array<Maybe<SectionContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SectionContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SectionContainerBlockWhereInput = {
  AdditionalLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MobileMenuText?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SectionContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SectionContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SectionContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SectionItemBlock = IContent & IData & {
  __typename?: 'SectionItemBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** The heading that appears for this section above the content */
  Heading?: Maybe<Scalars['String']['output']>;
  /** Optional */
  Image?: Maybe<SectionItemBlockImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Items?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  /** The name that appears for this section on the left sidebar */
  SectionName?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type SectionItemBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionItemBlockItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionItemBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionItemBlockSectionNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionItemBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionItemBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SectionItemBlockAutocomplete = {
  __typename?: 'SectionItemBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<SectionItemBlockImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SectionItemBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionItemBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionItemBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionItemBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionItemBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionItemBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionItemBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionItemBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionItemBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionItemBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SectionItemBlockFacet = {
  __typename?: 'SectionItemBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<SectionItemBlockImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<ContentAreaItemModelSearchFacet>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SectionName?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SectionItemBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionItemBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionItemBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SectionItemBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionItemBlockFacetSectionNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionItemBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionItemBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SectionItemBlockImageBlock = {
  __typename?: 'SectionItemBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type SectionItemBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionItemBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionItemBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionItemBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionItemBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SectionItemBlockImageBlockAutocomplete = {
  __typename?: 'SectionItemBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type SectionItemBlockImageBlockFacet = {
  __typename?: 'SectionItemBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SectionItemBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionItemBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SectionItemBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SectionItemBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type SectionItemBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type SectionItemBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<SectionItemBlockImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Items?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SectionName?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SectionItemBlockOutput = {
  __typename?: 'SectionItemBlockOutput';
  autocomplete?: Maybe<SectionItemBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SectionItemBlockFacet>;
  item?: Maybe<SectionItemBlock>;
  items?: Maybe<Array<Maybe<SectionItemBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SectionItemBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SectionItemBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<SectionItemBlockImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SectionName?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SectionItemBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SectionItemBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SectionItemBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SelectionElementBlock = IContent & IData & {
  __typename?: 'SelectionElementBlock';
  AllowMultiSelect?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Feed?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type SelectionElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockFeedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SelectionElementBlockAutocomplete = {
  __typename?: 'SelectionElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SelectionElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockFacet = {
  __typename?: 'SelectionElementBlockFacet';
  AllowMultiSelect?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Feed?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SelectionElementBlockFacetAllowMultiSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SelectionElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelectionElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SelectionElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelectionElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetFeedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelectionElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelectionElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelectionElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SelectionElementBlockOrderByInput = {
  AllowMultiSelect?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Feed?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SelectionElementBlockOutput = {
  __typename?: 'SelectionElementBlockOutput';
  autocomplete?: Maybe<SelectionElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SelectionElementBlockFacet>;
  item?: Maybe<SelectionElementBlock>;
  items?: Maybe<Array<Maybe<SelectionElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SelectionElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SelectionElementBlockWhereInput = {
  AllowMultiSelect?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Feed?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SelectionElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SelectionElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SelectionElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SelfAttestLevelOptionsBlock = IContent & IData & {
  __typename?: 'SelfAttestLevelOptionsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SelfAttestCommissionSubheading?: Maybe<Scalars['String']['output']>;
  SelfAttestIncomeSubheading?: Maybe<Scalars['String']['output']>;
  SelfAttestLevelTitle1?: Maybe<Scalars['String']['output']>;
  SelfAttestLevelTitle2?: Maybe<Scalars['String']['output']>;
  SelfAttestLevelTitle3?: Maybe<Scalars['String']['output']>;
  SelfAttestPremiumSubheading?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type SelfAttestLevelOptionsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelfAttestLevelOptionsBlockSelfAttestCommissionSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelfAttestLevelOptionsBlockSelfAttestIncomeSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelfAttestLevelOptionsBlockSelfAttestLevelTitle1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelfAttestLevelOptionsBlockSelfAttestLevelTitle2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelfAttestLevelOptionsBlockSelfAttestLevelTitle3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelfAttestLevelOptionsBlockSelfAttestPremiumSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelfAttestLevelOptionsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelfAttestLevelOptionsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SelfAttestLevelOptionsBlockAutocomplete = {
  __typename?: 'SelfAttestLevelOptionsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SelfAttestLevelOptionsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelfAttestLevelOptionsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelfAttestLevelOptionsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelfAttestLevelOptionsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelfAttestLevelOptionsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelfAttestLevelOptionsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelfAttestLevelOptionsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelfAttestLevelOptionsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelfAttestLevelOptionsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelfAttestLevelOptionsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelfAttestLevelOptionsBlockFacet = {
  __typename?: 'SelfAttestLevelOptionsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelfAttestCommissionSubheading?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestIncomeSubheading?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestLevelTitle1?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestLevelTitle2?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestLevelTitle3?: Maybe<Array<Maybe<StringFacet>>>;
  SelfAttestPremiumSubheading?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SelfAttestLevelOptionsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelfAttestLevelOptionsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelfAttestLevelOptionsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelfAttestLevelOptionsBlockFacetSelfAttestCommissionSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetSelfAttestIncomeSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetSelfAttestLevelTitle1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetSelfAttestLevelTitle2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetSelfAttestLevelTitle3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetSelfAttestPremiumSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelfAttestLevelOptionsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelfAttestLevelOptionsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelfAttestLevelOptionsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SelfAttestLevelOptionsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelfAttestCommissionSubheading?: InputMaybe<OrderBy>;
  SelfAttestIncomeSubheading?: InputMaybe<OrderBy>;
  SelfAttestLevelTitle1?: InputMaybe<OrderBy>;
  SelfAttestLevelTitle2?: InputMaybe<OrderBy>;
  SelfAttestLevelTitle3?: InputMaybe<OrderBy>;
  SelfAttestPremiumSubheading?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SelfAttestLevelOptionsBlockOutput = {
  __typename?: 'SelfAttestLevelOptionsBlockOutput';
  autocomplete?: Maybe<SelfAttestLevelOptionsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SelfAttestLevelOptionsBlockFacet>;
  item?: Maybe<SelfAttestLevelOptionsBlock>;
  items?: Maybe<Array<Maybe<SelfAttestLevelOptionsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SelfAttestLevelOptionsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SelfAttestLevelOptionsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelfAttestCommissionSubheading?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestIncomeSubheading?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestLevelTitle1?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestLevelTitle2?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestLevelTitle3?: InputMaybe<SearchableStringFilterInput>;
  SelfAttestPremiumSubheading?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SelfAttestLevelOptionsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SelfAttestLevelOptionsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SelfAttestLevelOptionsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds setting data for the Account Profile page */
export type SettingSectionBlock = IContent & IData & {
  __typename?: 'SettingSectionBlock';
  AdditionalLanguagesHeading?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CommunicationPreferencesBusinessAnnouncements?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesContentNewsletter?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesIntroduction?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesMdrtFoundation?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesMdrtMeetings?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesMdrtStore?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesMemberBenefits?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesPleaseSelect?: Maybe<Scalars['String']['output']>;
  CommunicationPreferencesUnselectAllExplanation?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EmailAddressUpdateMessage?: Maybe<Scalars['String']['output']>;
  EmailHeading?: Maybe<Scalars['String']['output']>;
  EmailNotifications?: Maybe<Scalars['String']['output']>;
  EmailNotificationsHeading?: Maybe<Scalars['String']['output']>;
  EmailNotificationsRegardingHeading?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LanguageHeading?: Maybe<Scalars['String']['output']>;
  LoginCredentialsHeading?: Maybe<Scalars['String']['output']>;
  LoginWithFacebook?: Maybe<Scalars['String']['output']>;
  LoginWithGoogle?: Maybe<Scalars['String']['output']>;
  LoginWithLinkedIn?: Maybe<Scalars['String']['output']>;
  LogoutWithFacebook?: Maybe<Scalars['String']['output']>;
  LogoutWithGoogle?: Maybe<Scalars['String']['output']>;
  LogoutWithLinkedIn?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtIdHeading?: Maybe<Scalars['String']['output']>;
  MemberDirectory?: Maybe<Scalars['String']['output']>;
  MemberDirectoryHeading?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  OptedIn?: Maybe<Scalars['String']['output']>;
  OptedOut?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PasswordResetButton?: Maybe<SettingSectionBlockLinkBlock>;
  PasswordResetImpersonationButton?: Maybe<SettingSectionBlockLinkBlock>;
  PermissionsHeading?: Maybe<Scalars['String']['output']>;
  PreferredLanguageHeading?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RemoveHeading?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SMSPermissions?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SocialLoginHeading?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TextNotificationsHeading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UsernameHeading?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockAdditionalLanguagesHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockCommunicationPreferencesBusinessAnnouncementsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockCommunicationPreferencesContentNewsletterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockCommunicationPreferencesIntroductionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockCommunicationPreferencesMdrtFoundationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockCommunicationPreferencesMdrtMeetingsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockCommunicationPreferencesMdrtStoreArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockCommunicationPreferencesMemberBenefitsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockCommunicationPreferencesPleaseSelectArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockCommunicationPreferencesUnselectAllExplanationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockEmailAddressUpdateMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockEmailHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockEmailNotificationsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockEmailNotificationsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockEmailNotificationsRegardingHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockLanguageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockLoginCredentialsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockLoginWithFacebookArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockLoginWithGoogleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockLoginWithLinkedInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockLogoutWithFacebookArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockLogoutWithGoogleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockLogoutWithLinkedInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockMdrtIdHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockMemberDirectoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockMemberDirectoryHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockOptedInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockOptedOutArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockPermissionsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockPreferredLanguageHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockRemoveHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockSmsPermissionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockSocialLoginHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockTextNotificationsHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlockUsernameHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds setting data for the Account Profile page */
export type SettingSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SettingSectionBlockAutocomplete = {
  __typename?: 'SettingSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PasswordResetButton?: Maybe<SettingSectionBlockLinkBlockAutocomplete>;
  PasswordResetImpersonationButton?: Maybe<SettingSectionBlockLinkBlockAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SettingSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SettingSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SettingSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SettingSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SettingSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SettingSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SettingSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SettingSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SettingSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SettingSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SettingSectionBlockFacet = {
  __typename?: 'SettingSectionBlockFacet';
  AdditionalLanguagesHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CommunicationPreferencesBusinessAnnouncements?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesContentNewsletter?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesIntroduction?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesMdrtFoundation?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesMdrtMeetings?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesMdrtStore?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesMemberBenefits?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesPleaseSelect?: Maybe<Array<Maybe<StringFacet>>>;
  CommunicationPreferencesUnselectAllExplanation?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EmailAddressUpdateMessage?: Maybe<Array<Maybe<StringFacet>>>;
  EmailHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNotifications?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNotificationsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  EmailNotificationsRegardingHeading?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LanguageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  LoginCredentialsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  LoginWithFacebook?: Maybe<Array<Maybe<StringFacet>>>;
  LoginWithGoogle?: Maybe<Array<Maybe<StringFacet>>>;
  LoginWithLinkedIn?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutWithFacebook?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutWithGoogle?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutWithLinkedIn?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtIdHeading?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDirectory?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDirectoryHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  OptedIn?: Maybe<Array<Maybe<StringFacet>>>;
  OptedOut?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PasswordResetButton?: Maybe<SettingSectionBlockLinkBlockFacet>;
  PasswordResetImpersonationButton?: Maybe<SettingSectionBlockLinkBlockFacet>;
  PermissionsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PreferredLanguageHeading?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveHeading?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SMSPermissions?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SocialLoginHeading?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TextNotificationsHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UsernameHeading?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SettingSectionBlockFacetAdditionalLanguagesHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SettingSectionBlockFacetCommunicationPreferencesBusinessAnnouncementsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetCommunicationPreferencesContentNewsletterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetCommunicationPreferencesIntroductionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetCommunicationPreferencesMdrtFoundationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetCommunicationPreferencesMdrtMeetingsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetCommunicationPreferencesMdrtStoreArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetCommunicationPreferencesMemberBenefitsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetCommunicationPreferencesPleaseSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetCommunicationPreferencesUnselectAllExplanationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SettingSectionBlockFacetEmailAddressUpdateMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetEmailHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetEmailNotificationsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetEmailNotificationsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetEmailNotificationsRegardingHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SettingSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetLanguageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetLoginCredentialsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetLoginWithFacebookArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetLoginWithGoogleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetLoginWithLinkedInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetLogoutWithFacebookArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetLogoutWithGoogleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetLogoutWithLinkedInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetMdrtIdHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetMemberDirectoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetMemberDirectoryHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetOptedInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetOptedOutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetPermissionsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetPreferredLanguageHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetRemoveHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetSmsPermissionsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SettingSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetSocialLoginHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SettingSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SettingSectionBlockFacetTextNotificationsHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacetUsernameHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SettingSectionBlockLinkBlock = {
  __typename?: 'SettingSectionBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type SettingSectionBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SettingSectionBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SettingSectionBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SettingSectionBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SettingSectionBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SettingSectionBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SettingSectionBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SettingSectionBlockLinkBlockAutocomplete = {
  __typename?: 'SettingSectionBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SettingSectionBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SettingSectionBlockLinkBlockFacet = {
  __typename?: 'SettingSectionBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SettingSectionBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SettingSectionBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SettingSectionBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SettingSectionBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type SettingSectionBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type SettingSectionBlockOrderByInput = {
  AdditionalLanguagesHeading?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CommunicationPreferencesBusinessAnnouncements?: InputMaybe<OrderBy>;
  CommunicationPreferencesContentNewsletter?: InputMaybe<OrderBy>;
  CommunicationPreferencesIntroduction?: InputMaybe<OrderBy>;
  CommunicationPreferencesMdrtFoundation?: InputMaybe<OrderBy>;
  CommunicationPreferencesMdrtMeetings?: InputMaybe<OrderBy>;
  CommunicationPreferencesMdrtStore?: InputMaybe<OrderBy>;
  CommunicationPreferencesMemberBenefits?: InputMaybe<OrderBy>;
  CommunicationPreferencesPleaseSelect?: InputMaybe<OrderBy>;
  CommunicationPreferencesUnselectAllExplanation?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EmailAddressUpdateMessage?: InputMaybe<OrderBy>;
  EmailHeading?: InputMaybe<OrderBy>;
  EmailNotifications?: InputMaybe<OrderBy>;
  EmailNotificationsHeading?: InputMaybe<OrderBy>;
  EmailNotificationsRegardingHeading?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LanguageHeading?: InputMaybe<OrderBy>;
  LoginCredentialsHeading?: InputMaybe<OrderBy>;
  LoginWithFacebook?: InputMaybe<OrderBy>;
  LoginWithGoogle?: InputMaybe<OrderBy>;
  LoginWithLinkedIn?: InputMaybe<OrderBy>;
  LogoutWithFacebook?: InputMaybe<OrderBy>;
  LogoutWithGoogle?: InputMaybe<OrderBy>;
  LogoutWithLinkedIn?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtIdHeading?: InputMaybe<OrderBy>;
  MemberDirectory?: InputMaybe<OrderBy>;
  MemberDirectoryHeading?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  OptedIn?: InputMaybe<OrderBy>;
  OptedOut?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PasswordResetButton?: InputMaybe<SettingSectionBlockLinkBlockOrderByInput>;
  PasswordResetImpersonationButton?: InputMaybe<SettingSectionBlockLinkBlockOrderByInput>;
  PermissionsHeading?: InputMaybe<OrderBy>;
  PreferredLanguageHeading?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RemoveHeading?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SMSPermissions?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SocialLoginHeading?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TextNotificationsHeading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UsernameHeading?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SettingSectionBlockOutput = {
  __typename?: 'SettingSectionBlockOutput';
  autocomplete?: Maybe<SettingSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SettingSectionBlockFacet>;
  item?: Maybe<SettingSectionBlock>;
  items?: Maybe<Array<Maybe<SettingSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SettingSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingSectionBlockWhereInput = {
  AdditionalLanguagesHeading?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CommunicationPreferencesBusinessAnnouncements?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesContentNewsletter?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesIntroduction?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesMdrtFoundation?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesMdrtMeetings?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesMdrtStore?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesMemberBenefits?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesPleaseSelect?: InputMaybe<SearchableStringFilterInput>;
  CommunicationPreferencesUnselectAllExplanation?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EmailAddressUpdateMessage?: InputMaybe<SearchableStringFilterInput>;
  EmailHeading?: InputMaybe<SearchableStringFilterInput>;
  EmailNotifications?: InputMaybe<SearchableStringFilterInput>;
  EmailNotificationsHeading?: InputMaybe<SearchableStringFilterInput>;
  EmailNotificationsRegardingHeading?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LanguageHeading?: InputMaybe<SearchableStringFilterInput>;
  LoginCredentialsHeading?: InputMaybe<SearchableStringFilterInput>;
  LoginWithFacebook?: InputMaybe<SearchableStringFilterInput>;
  LoginWithGoogle?: InputMaybe<SearchableStringFilterInput>;
  LoginWithLinkedIn?: InputMaybe<SearchableStringFilterInput>;
  LogoutWithFacebook?: InputMaybe<SearchableStringFilterInput>;
  LogoutWithGoogle?: InputMaybe<SearchableStringFilterInput>;
  LogoutWithLinkedIn?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtIdHeading?: InputMaybe<SearchableStringFilterInput>;
  MemberDirectory?: InputMaybe<SearchableStringFilterInput>;
  MemberDirectoryHeading?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  OptedIn?: InputMaybe<SearchableStringFilterInput>;
  OptedOut?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PasswordResetButton?: InputMaybe<SettingSectionBlockLinkBlockWhereInput>;
  PasswordResetImpersonationButton?: InputMaybe<SettingSectionBlockLinkBlockWhereInput>;
  PermissionsHeading?: InputMaybe<SearchableStringFilterInput>;
  PreferredLanguageHeading?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RemoveHeading?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SMSPermissions?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SocialLoginHeading?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TextNotificationsHeading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UsernameHeading?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SettingSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SettingSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SettingSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SiteDefinition = IData & {
  __typename?: 'SiteDefinition';
  ContentLink?: Maybe<ContentModelReference>;
  ContentRoots?: Maybe<ContentRootsModel>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EditLocation?: Maybe<Scalars['String']['output']>;
  Hosts?: Maybe<Array<Maybe<HostDefinitionModel>>>;
  Id?: Maybe<Scalars['String']['output']>;
  Languages?: Maybe<Array<Maybe<SiteDefinitionLanguageModel>>>;
  Name?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
};


export type SiteDefinitionNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDefinition_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDefinition_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteDefinitionAutocomplete = {
  __typename?: 'SiteDefinitionAutocomplete';
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentRoots?: Maybe<ContentRootsModelAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EditLocation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Hosts?: Maybe<HostDefinitionModelAutocomplete>;
  Id?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Languages?: Maybe<SiteDefinitionLanguageModelAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteDefinitionAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionAutocompleteEditLocationArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionAutocompleteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionFacet = {
  __typename?: 'SiteDefinitionFacet';
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentRoots?: Maybe<ContentRootsModelFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  EditLocation?: Maybe<Array<Maybe<StringFacet>>>;
  Hosts?: Maybe<HostDefinitionModelFacet>;
  Id?: Maybe<Array<Maybe<StringFacet>>>;
  Languages?: Maybe<SiteDefinitionLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteDefinitionFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetEditLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModel = {
  __typename?: 'SiteDefinitionLanguageModel';
  DisplayName?: Maybe<Scalars['String']['output']>;
  IsMasterLanguage?: Maybe<Scalars['Bool']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UrlSegment?: Maybe<Scalars['String']['output']>;
};

export type SiteDefinitionLanguageModelAutocomplete = {
  __typename?: 'SiteDefinitionLanguageModelAutocomplete';
  DisplayName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  UrlSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteDefinitionLanguageModelAutocompleteDisplayNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionLanguageModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionLanguageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionLanguageModelAutocompleteUrlSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionLanguageModelFacet = {
  __typename?: 'SiteDefinitionLanguageModelFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  IsMasterLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UrlSegment?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteDefinitionLanguageModelFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetIsMasterLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetUrlSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModelOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  IsMasterLanguage?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UrlSegment?: InputMaybe<OrderBy>;
};

export type SiteDefinitionLanguageModelWhereInput = {
  DisplayName?: InputMaybe<StringFilterInput>;
  IsMasterLanguage?: InputMaybe<BoolFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UrlSegment?: InputMaybe<StringFilterInput>;
};

export type SiteDefinitionOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentRoots?: InputMaybe<ContentRootsModelOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  EditLocation?: InputMaybe<OrderBy>;
  Hosts?: InputMaybe<HostDefinitionModelOrderByInput>;
  Id?: InputMaybe<OrderBy>;
  Languages?: InputMaybe<SiteDefinitionLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SiteDefinitionOutput = {
  __typename?: 'SiteDefinitionOutput';
  autocomplete?: Maybe<SiteDefinitionAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiteDefinitionFacet>;
  item?: Maybe<SiteDefinition>;
  items?: Maybe<Array<Maybe<SiteDefinition>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SiteDefinitionOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteDefinitionWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentRoots?: InputMaybe<ContentRootsModelWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  EditLocation?: InputMaybe<StringFilterInput>;
  Hosts?: InputMaybe<HostDefinitionModelWhereInput>;
  Id?: InputMaybe<StringFilterInput>;
  Languages?: InputMaybe<SiteDefinitionLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
};

/** A container for global properties used throughout the site */
export type SiteSettingsPage = IContent & IData & {
  __typename?: 'SiteSettingsPage';
  AccessDenied?: Maybe<Scalars['String']['output']>;
  AccessibilityLabel?: Maybe<Scalars['String']['output']>;
  AccountLinkLabel?: Maybe<Scalars['String']['output']>;
  AccountProfilePage?: Maybe<ContentModelReference>;
  AccountSettingsPageReference?: Maybe<ContentModelReference>;
  AddBookmarkAriaLabel?: Maybe<Scalars['String']['output']>;
  AddBookmarkSuccessMessage?: Maybe<Scalars['String']['output']>;
  Address?: Maybe<Scalars['String']['output']>;
  AdminDashboardPage?: Maybe<ContentModelReference>;
  AdminDashboardPageLinkLabel?: Maybe<Scalars['String']['output']>;
  AirPlayLabel?: Maybe<Scalars['String']['output']>;
  Alerts?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnnouncementsLabel?: Maybe<Scalars['String']['output']>;
  AnnualMeetingSourceCategory?: Maybe<ContentModelReference>;
  AppDescription?: Maybe<Scalars['String']['output']>;
  AppStoreLink?: Maybe<Scalars['String']['output']>;
  AppStoreLinkAriaLabel?: Maybe<Scalars['String']['output']>;
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AudioLabel?: Maybe<Scalars['String']['output']>;
  /** Argument for the number of years is given using wildcard "{0}" */
  AuthorBlockMembershipTextTemplatePlural?: Maybe<Scalars['String']['output']>;
  /** Argument for the number of years is given using wildcard "{0}" */
  AuthorBlockMembershipTextTemplateSingular?: Maybe<Scalars['String']['output']>;
  AuthorBlockTitleWhenMultipleAuthors?: Maybe<Scalars['String']['output']>;
  AuthorBlockTitleWhenSingleAuthor?: Maybe<Scalars['String']['output']>;
  AuthorImportFolderReference?: Maybe<ContentModelReference>;
  AuthorsByLine?: Maybe<Scalars['String']['output']>;
  BackAriaLabel?: Maybe<Scalars['String']['output']>;
  BackLabel?: Maybe<Scalars['String']['output']>;
  BackToDashboard?: Maybe<Scalars['String']['output']>;
  BecomeMemberLabel?: Maybe<Scalars['String']['output']>;
  /** Raw scripts rendered in the body of the html. Used for Tag Manager, etc */
  BodyScripts?: Maybe<Scalars['String']['output']>;
  BoostLabel?: Maybe<Scalars['String']['output']>;
  By?: Maybe<Scalars['String']['output']>;
  COTLevelLabel?: Maybe<Scalars['String']['output']>;
  CancelLabel?: Maybe<Scalars['String']['output']>;
  CarouselBlockReference?: Maybe<ContentModelReference>;
  CarouselNextButtonLabel?: Maybe<Scalars['String']['output']>;
  CarouselPreviousButtonLabel?: Maybe<Scalars['String']['output']>;
  CategoriesRoot?: Maybe<ContentModelReference>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ChapterSitesHeader?: Maybe<Scalars['String']['output']>;
  ChapterSitesLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  CityLabel?: Maybe<Scalars['String']['output']>;
  Close?: Maybe<Scalars['String']['output']>;
  CompanyAdminBulkImportPage?: Maybe<ContentModelReference>;
  /** Company Admin Button Label */
  CompanyAdminButtonLabel?: Maybe<Scalars['String']['output']>;
  CompanyAdminCompanyListingsPage?: Maybe<ContentModelReference>;
  CompanyAdminDashboardPage?: Maybe<ContentModelReference>;
  CompanyAdminDashboardPageLinkLabel?: Maybe<Scalars['String']['output']>;
  CompanyAdminMembershipDirectoryPage?: Maybe<ContentModelReference>;
  /** Company Admin Section Description Label */
  CompanyAdminSectionDescriptionLabel?: Maybe<Scalars['String']['output']>;
  ConfirmLabel?: Maybe<Scalars['String']['output']>;
  ContactUsLink?: Maybe<SiteSettingsPageLinkBlock>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentSourceCategoryRoot?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  ContinueLabel?: Maybe<Scalars['String']['output']>;
  CopyLink?: Maybe<Scalars['String']['output']>;
  Copyright?: Maybe<Scalars['String']['output']>;
  CountryLabel?: Maybe<Scalars['String']['output']>;
  CreateAccountLabel?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  DateSavedSuccessfully?: Maybe<Scalars['String']['output']>;
  DaysBeforeReShowingContactForm?: Maybe<Scalars['Int']['output']>;
  DefaultRouteTitle?: Maybe<Scalars['String']['output']>;
  DisableNextAppCacheBust?: Maybe<Scalars['Bool']['output']>;
  DisclaimerLink?: Maybe<SiteSettingsPageLinkBlock>;
  DownloadLabel?: Maybe<Scalars['String']['output']>;
  EditLabel?: Maybe<Scalars['String']['output']>;
  EmailResource?: Maybe<Scalars['String']['output']>;
  EnterFullscreenLabel?: Maybe<Scalars['String']['output']>;
  EntityCategoryRoot?: Maybe<ContentModelReference>;
  EventSpeakerSearchPage?: Maybe<ContentModelReference>;
  EventsCategoryRoot?: Maybe<ContentModelReference>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExitFullscreenLabel?: Maybe<Scalars['String']['output']>;
  /** Fax Label */
  FaxLabel?: Maybe<Scalars['String']['output']>;
  FeaturedCarouselReference?: Maybe<ContentModelReference>;
  FooterLogo?: Maybe<SiteSettingsPageImageBlock>;
  FooterLogoLink?: Maybe<SiteSettingsPageLinkBlock>;
  /** Raw scripts rendered in the footer of the html. Used for Tag Manager, etc */
  FooterScripts?: Maybe<Scalars['String']['output']>;
  FooterSocialLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  FullscreenLabel?: Maybe<Scalars['String']['output']>;
  GlobalConferenceSourceCategory?: Maybe<ContentModelReference>;
  GoBackToHomepage?: Maybe<Scalars['String']['output']>;
  GoogleCastLabel?: Maybe<Scalars['String']['output']>;
  GooglePlayLink?: Maybe<Scalars['String']['output']>;
  GooglePlayLinkAriaLabel?: Maybe<Scalars['String']['output']>;
  Greeting?: Maybe<Scalars['String']['output']>;
  GsAwardsPage?: Maybe<ContentModelReference>;
  GsMembershipRenewalPage?: Maybe<ContentModelReference>;
  /** Raw scripts rendered in the header of the html. Used for Tag Manager, etc */
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  HelpfulLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  HelpfulLinksHeader?: Maybe<Scalars['String']['output']>;
  HomeLabel?: Maybe<Scalars['String']['output']>;
  ImpersonateModalButtonLabel?: Maybe<Scalars['String']['output']>;
  ImpersonateModalDescription?: Maybe<Scalars['String']['output']>;
  ImpersonateModalErrorMessage?: Maybe<Scalars['String']['output']>;
  ImpersonateModalPersonIDLabel?: Maybe<Scalars['String']['output']>;
  ImpersonateModalTitle?: Maybe<Scalars['String']['output']>;
  ImpersonationLinkLabel?: Maybe<Scalars['String']['output']>;
  In?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  KeyboardAnimationsLabel?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LanguageBlockReference?: Maybe<ContentModelReference>;
  LanguageIdsAndNames?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  LatinOnlyMessage?: Maybe<Scalars['String']['output']>;
  /** The folder containing the export.json file */
  LearnDetailImportFolderReference?: Maybe<ContentModelReference>;
  /** The destination folder for the new pages */
  LearnDetailImportTargetFolderReference?: Maybe<ContentModelReference>;
  LearnLandingPage?: Maybe<ContentModelReference>;
  LeavingConfirmMessage?: Maybe<Scalars['String']['output']>;
  LinkCopiedSuccessfully?: Maybe<Scalars['String']['output']>;
  LockedResourceModalHeading?: Maybe<Scalars['String']['output']>;
  LockedResourceModalSubheading?: Maybe<Scalars['String']['output']>;
  LogInPrompt?: Maybe<Scalars['String']['output']>;
  LoginBlockReference?: Maybe<ContentModelReference>;
  LoginLinkLabel?: Maybe<Scalars['String']['output']>;
  LoginPageReference?: Maybe<ContentModelReference>;
  LoginPromptText?: Maybe<Scalars['String']['output']>;
  LogoutLine?: Maybe<Scalars['String']['output']>;
  LogoutPageReference?: Maybe<ContentModelReference>;
  LoopLabel?: Maybe<Scalars['String']['output']>;
  MDRTId?: Maybe<Scalars['String']['output']>;
  MDRTLevelLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MdrtAppsHeader?: Maybe<Scalars['String']['output']>;
  MdrtEdgeSourceCategory?: Maybe<ContentModelReference>;
  MdrtIdLabel?: Maybe<Scalars['String']['output']>;
  MemberDirectoryPageReference?: Maybe<ContentModelReference>;
  MembersOnlyLabel?: Maybe<Scalars['String']['output']>;
  MembershipInvoicePage?: Maybe<ContentModelReference>;
  MembershipLevelLabel?: Maybe<Scalars['String']['output']>;
  MembershipRenewalPage?: Maybe<ContentModelReference>;
  MembershipRenewalV2Page?: Maybe<ContentModelReference>;
  MembershipRequirementsBlockReference?: Maybe<ContentModelReference>;
  MenuLink?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MenuTrigger?: Maybe<Scalars['String']['output']>;
  MinutesLabel?: Maybe<Scalars['String']['output']>;
  MobileApiAuthenticationToken?: Maybe<Scalars['String']['output']>;
  MobileApiBaseUrl?: Maybe<Scalars['String']['output']>;
  MuteLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NextButtonLabel?: Maybe<Scalars['String']['output']>;
  NextPageLabel?: Maybe<Scalars['String']['output']>;
  NoLabel?: Maybe<Scalars['String']['output']>;
  NoResultsLabel?: Maybe<Scalars['String']['output']>;
  NoResultsMessage?: Maybe<Scalars['String']['output']>;
  NormalLabel?: Maybe<Scalars['String']['output']>;
  NotApplicableLabel?: Maybe<Scalars['String']['output']>;
  Number?: Maybe<Scalars['String']['output']>;
  OffLabel?: Maybe<Scalars['String']['output']>;
  Optional?: Maybe<Scalars['String']['output']>;
  PWAPromptAddHomeInstructionsLabelApple?: Maybe<Scalars['String']['output']>;
  PWAPromptAddHomeInstructionsLabelSafari?: Maybe<Scalars['String']['output']>;
  PWAPromptBodyLabelApple?: Maybe<Scalars['String']['output']>;
  PWAPromptBodyLabelSafari?: Maybe<Scalars['String']['output']>;
  PWAPromptBodyLabelWeb?: Maybe<Scalars['String']['output']>;
  PWAPromptCancelLabel?: Maybe<Scalars['String']['output']>;
  PWAPromptInstallLabel?: Maybe<Scalars['String']['output']>;
  PWAPromptShareInstructionsLabelApple?: Maybe<Scalars['String']['output']>;
  PWAPromptShareInstructionsLabelSafari?: Maybe<Scalars['String']['output']>;
  PWAPromptTitleLabelApple?: Maybe<Scalars['String']['output']>;
  PWAPromptTitleLabelSafari?: Maybe<Scalars['String']['output']>;
  PageButtonLabel?: Maybe<Scalars['String']['output']>;
  PageNotFoundErrorMessage?: Maybe<Scalars['String']['output']>;
  Pagination?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PauseLabel?: Maybe<Scalars['String']['output']>;
  PeopleImportFolderReference?: Maybe<ContentModelReference>;
  PeopleImportTargetFolderReference?: Maybe<ContentModelReference>;
  PersonThumbnailPlaceholder?: Maybe<ContentModelReference>;
  /** Phone Label */
  PhoneLabel?: Maybe<Scalars['String']['output']>;
  PhoneNumberLink?: Maybe<SiteSettingsPageLinkBlock>;
  PlayLabel?: Maybe<Scalars['String']['output']>;
  PlaybackLabel?: Maybe<Scalars['String']['output']>;
  PrepaymentPortalPage?: Maybe<ContentModelReference>;
  PreviousPageLabel?: Maybe<Scalars['String']['output']>;
  PrivacyLink?: Maybe<SiteSettingsPageLinkBlock>;
  ProfileDropdownAriaLabel?: Maybe<Scalars['String']['output']>;
  ProfileDropdownTriggerAriaLabel?: Maybe<Scalars['String']['output']>;
  ProfileListHeading?: Maybe<Scalars['String']['output']>;
  PwaAppInstallAndroidImage?: Maybe<ContentModelReference>;
  PwaAppInstallAppleImage?: Maybe<ContentModelReference>;
  RegionCategoryRoot?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RemoveBookmarkAriaLabel?: Maybe<Scalars['String']['output']>;
  RemoveBookmarkSuccessMessage?: Maybe<Scalars['String']['output']>;
  RemoveLabel?: Maybe<Scalars['String']['output']>;
  RenewNowLabel?: Maybe<Scalars['String']['output']>;
  ReplayLabel?: Maybe<Scalars['String']['output']>;
  RequiredLabel?: Maybe<Scalars['String']['output']>;
  Reset?: Maybe<Scalars['String']['output']>;
  RoundTheTableMagazineSourceCategory?: Maybe<ContentModelReference>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SaveChanges?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SearchButtonLabel?: Maybe<Scalars['String']['output']>;
  SearchPageReference?: Maybe<ContentModelReference>;
  SearchPageV2Reference?: Maybe<ContentModelReference>;
  SeekBackwardLabel?: Maybe<Scalars['String']['output']>;
  SeekForwardLabel?: Maybe<Scalars['String']['output']>;
  SeekLabel?: Maybe<Scalars['String']['output']>;
  SelectLanguage?: Maybe<Scalars['String']['output']>;
  SelectLanguageLine?: Maybe<Scalars['String']['output']>;
  SettingsLabel?: Maybe<Scalars['String']['output']>;
  ShareBlockReference?: Maybe<ContentModelReference>;
  ShareOnFacebook?: Maybe<Scalars['String']['output']>;
  ShareOnLinkedIn?: Maybe<Scalars['String']['output']>;
  ShareOnX?: Maybe<Scalars['String']['output']>;
  ShareResourceMenuTrigger?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  ShowContactUpdateForm?: Maybe<Scalars['Bool']['output']>;
  SignInToViewLabel?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SomethingWentWrong?: Maybe<Scalars['String']['output']>;
  SpeedLabel?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  StateProvinceLabel?: Maybe<Scalars['String']['output']>;
  StaticPagesEventNextEventLabel?: Maybe<Scalars['String']['output']>;
  StaticPagesEventThisYearLabel?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TOTLevelLabel?: Maybe<Scalars['String']['output']>;
  ThumbnailPlaceholder?: Maybe<ContentModelReference>;
  ToastSomethingWentWrong?: Maybe<Scalars['String']['output']>;
  TopOfTheTableAnnualMeetingSourceCategory?: Maybe<ContentModelReference>;
  TopicsCategoryRoot?: Maybe<ContentModelReference>;
  TopicsCoveredLine?: Maybe<Scalars['String']['output']>;
  TotalItemsCountLabel?: Maybe<Scalars['String']['output']>;
  TryAgainErrorMessage?: Maybe<Scalars['String']['output']>;
  UnmuteLabel?: Maybe<Scalars['String']['output']>;
  UpdateReadTimeInSecondsForAllPublishedLearnDetailPages?: Maybe<Scalars['Bool']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UseNextNavigation?: Maybe<Scalars['Bool']['output']>;
  ViewProfile?: Maybe<Scalars['String']['output']>;
  ViewTypeCategoryRoot?: Maybe<ContentModelReference>;
  VolumeLabel?: Maybe<Scalars['String']['output']>;
  YearLabel?: Maybe<Scalars['String']['output']>;
  YesLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAccessDeniedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAccessibilityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAccountLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAddBookmarkAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAddBookmarkSuccessMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAddressArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAdminDashboardPageLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAirPlayLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAlertsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAnnouncementsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAppDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAppStoreLinkAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAudioLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAuthorBlockMembershipTextTemplatePluralArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAuthorBlockMembershipTextTemplateSingularArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAuthorBlockTitleWhenMultipleAuthorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAuthorBlockTitleWhenSingleAuthorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageAuthorsByLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageBackAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageBackLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageBackToDashboardArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageBecomeMemberLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageBodyScriptsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageBoostLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageByArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCancelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCarouselNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCarouselPreviousButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageChapterSitesHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageChapterSitesLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCloseArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCompanyAdminButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCompanyAdminDashboardPageLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCompanyAdminSectionDescriptionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageConfirmLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageContinueLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCopyLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCopyrightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCountryLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageCreateAccountLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageDateSavedSuccessfullyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageDefaultRouteTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageDownloadLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageEditLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageEmailResourceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageEnterFullscreenLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageExitFullscreenLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageFaxLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageFooterScriptsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageFooterSocialLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageFullscreenLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageGoBackToHomepageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageGoogleCastLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageGooglePlayLinkAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageGreetingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageHeaderScriptsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageHelpfulLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageHelpfulLinksHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageHomeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageImpersonateModalButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageImpersonateModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageImpersonateModalErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageImpersonateModalPersonIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageImpersonateModalTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageImpersonationLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageKeyboardAnimationsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageLanguageIdsAndNamesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageLatinOnlyMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageLeavingConfirmMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageLinkCopiedSuccessfullyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageLockedResourceModalHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageLockedResourceModalSubheadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageLogInPromptArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageLoginLinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageLoginPromptTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageLogoutLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageLoopLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMdrtIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMdrtLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMdrtAppsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMdrtIdLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMembersOnlyLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMembershipLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMenuLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMenuTriggerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMinutesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMobileApiAuthenticationTokenArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMobileApiBaseUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageMuteLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageNextButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageNextPageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageNoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageNoResultsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageNoResultsMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageNormalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageNotApplicableLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageNumberArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageOffLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageOptionalArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePwaPromptAddHomeInstructionsLabelAppleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePwaPromptAddHomeInstructionsLabelSafariArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePwaPromptBodyLabelAppleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePwaPromptBodyLabelSafariArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePwaPromptBodyLabelWebArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePwaPromptCancelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePwaPromptInstallLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePwaPromptShareInstructionsLabelAppleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePwaPromptShareInstructionsLabelSafariArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePwaPromptTitleLabelAppleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePwaPromptTitleLabelSafariArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePageButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePageNotFoundErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePaginationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePauseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePhoneLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePlayLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePlaybackLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPagePreviousPageLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageProfileDropdownAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageProfileDropdownTriggerAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageProfileListHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageRemoveBookmarkAriaLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageRemoveBookmarkSuccessMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageRemoveLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageRenewNowLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageReplayLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageRequiredLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageResetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageSaveChangesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageSearchButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageSeekBackwardLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageSeekForwardLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageSeekLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageSelectLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageSelectLanguageLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageSettingsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageShareOnFacebookArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageShareOnLinkedInArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageShareOnXArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageShareResourceMenuTriggerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageSignInToViewLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageSomethingWentWrongArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageSpeedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageStateProvinceLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageStaticPagesEventNextEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageStaticPagesEventThisYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageTotLevelLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageToastSomethingWentWrongArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageTopicsCoveredLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageTotalItemsCountLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageTryAgainErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageUnmuteLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageViewProfileArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageVolumeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageYearLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPageYesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A container for global properties used throughout the site */
export type SiteSettingsPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteSettingsPageAutocomplete = {
  __typename?: 'SiteSettingsPageAutocomplete';
  AccountProfilePage?: Maybe<ContentModelReferenceAutocomplete>;
  AccountSettingsPageReference?: Maybe<ContentModelReferenceAutocomplete>;
  AdminDashboardPage?: Maybe<ContentModelReferenceAutocomplete>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnnualMeetingSourceCategory?: Maybe<ContentModelReferenceAutocomplete>;
  AppStoreLink?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AuthorImportFolderReference?: Maybe<ContentModelReferenceAutocomplete>;
  CarouselBlockReference?: Maybe<ContentModelReferenceAutocomplete>;
  CategoriesRoot?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  CompanyAdminBulkImportPage?: Maybe<ContentModelReferenceAutocomplete>;
  CompanyAdminCompanyListingsPage?: Maybe<ContentModelReferenceAutocomplete>;
  CompanyAdminDashboardPage?: Maybe<ContentModelReferenceAutocomplete>;
  CompanyAdminMembershipDirectoryPage?: Maybe<ContentModelReferenceAutocomplete>;
  ContactUsLink?: Maybe<SiteSettingsPageLinkBlockAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentSourceCategoryRoot?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DisclaimerLink?: Maybe<SiteSettingsPageLinkBlockAutocomplete>;
  EntityCategoryRoot?: Maybe<ContentModelReferenceAutocomplete>;
  EventSpeakerSearchPage?: Maybe<ContentModelReferenceAutocomplete>;
  EventsCategoryRoot?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FeaturedCarouselReference?: Maybe<ContentModelReferenceAutocomplete>;
  FooterLogo?: Maybe<SiteSettingsPageImageBlockAutocomplete>;
  FooterLogoLink?: Maybe<SiteSettingsPageLinkBlockAutocomplete>;
  GlobalConferenceSourceCategory?: Maybe<ContentModelReferenceAutocomplete>;
  GooglePlayLink?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  GsAwardsPage?: Maybe<ContentModelReferenceAutocomplete>;
  GsMembershipRenewalPage?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LanguageBlockReference?: Maybe<ContentModelReferenceAutocomplete>;
  LearnDetailImportFolderReference?: Maybe<ContentModelReferenceAutocomplete>;
  LearnDetailImportTargetFolderReference?: Maybe<ContentModelReferenceAutocomplete>;
  LearnLandingPage?: Maybe<ContentModelReferenceAutocomplete>;
  LoginBlockReference?: Maybe<ContentModelReferenceAutocomplete>;
  LoginPageReference?: Maybe<ContentModelReferenceAutocomplete>;
  LogoutPageReference?: Maybe<ContentModelReferenceAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MdrtEdgeSourceCategory?: Maybe<ContentModelReferenceAutocomplete>;
  MemberDirectoryPageReference?: Maybe<ContentModelReferenceAutocomplete>;
  MembershipInvoicePage?: Maybe<ContentModelReferenceAutocomplete>;
  MembershipRenewalPage?: Maybe<ContentModelReferenceAutocomplete>;
  MembershipRenewalV2Page?: Maybe<ContentModelReferenceAutocomplete>;
  MembershipRequirementsBlockReference?: Maybe<ContentModelReferenceAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PeopleImportFolderReference?: Maybe<ContentModelReferenceAutocomplete>;
  PeopleImportTargetFolderReference?: Maybe<ContentModelReferenceAutocomplete>;
  PersonThumbnailPlaceholder?: Maybe<ContentModelReferenceAutocomplete>;
  PhoneNumberLink?: Maybe<SiteSettingsPageLinkBlockAutocomplete>;
  PrepaymentPortalPage?: Maybe<ContentModelReferenceAutocomplete>;
  PrivacyLink?: Maybe<SiteSettingsPageLinkBlockAutocomplete>;
  PwaAppInstallAndroidImage?: Maybe<ContentModelReferenceAutocomplete>;
  PwaAppInstallAppleImage?: Maybe<ContentModelReferenceAutocomplete>;
  RegionCategoryRoot?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RoundTheTableMagazineSourceCategory?: Maybe<ContentModelReferenceAutocomplete>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SearchPageReference?: Maybe<ContentModelReferenceAutocomplete>;
  SearchPageV2Reference?: Maybe<ContentModelReferenceAutocomplete>;
  ShareBlockReference?: Maybe<ContentModelReferenceAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailPlaceholder?: Maybe<ContentModelReferenceAutocomplete>;
  TopOfTheTableAnnualMeetingSourceCategory?: Maybe<ContentModelReferenceAutocomplete>;
  TopicsCategoryRoot?: Maybe<ContentModelReferenceAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ViewTypeCategoryRoot?: Maybe<ContentModelReferenceAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteSettingsPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteSettingsPageAutocompleteAppStoreLinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteSettingsPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteSettingsPageAutocompleteGooglePlayLinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteSettingsPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteSettingsPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteSettingsPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteSettingsPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteSettingsPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteSettingsPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteSettingsPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteSettingsPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteSettingsPageFacet = {
  __typename?: 'SiteSettingsPageFacet';
  AccessDenied?: Maybe<Array<Maybe<StringFacet>>>;
  AccessibilityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AccountLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AccountProfilePage?: Maybe<ContentModelReferenceFacet>;
  AccountSettingsPageReference?: Maybe<ContentModelReferenceFacet>;
  AddBookmarkAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AddBookmarkSuccessMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Address?: Maybe<Array<Maybe<StringFacet>>>;
  AdminDashboardPage?: Maybe<ContentModelReferenceFacet>;
  AdminDashboardPageLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AirPlayLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Alerts?: Maybe<ContentAreaItemModelSearchFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnnouncementsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnnualMeetingSourceCategory?: Maybe<ContentModelReferenceFacet>;
  AppDescription?: Maybe<Array<Maybe<StringFacet>>>;
  AppStoreLink?: Maybe<Array<Maybe<StringFacet>>>;
  AppStoreLinkAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  AudioLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorBlockMembershipTextTemplatePlural?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorBlockMembershipTextTemplateSingular?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorBlockTitleWhenMultipleAuthors?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorBlockTitleWhenSingleAuthor?: Maybe<Array<Maybe<StringFacet>>>;
  AuthorImportFolderReference?: Maybe<ContentModelReferenceFacet>;
  AuthorsByLine?: Maybe<Array<Maybe<StringFacet>>>;
  BackAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BackToDashboard?: Maybe<Array<Maybe<StringFacet>>>;
  BecomeMemberLabel?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  BoostLabel?: Maybe<Array<Maybe<StringFacet>>>;
  By?: Maybe<Array<Maybe<StringFacet>>>;
  COTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CancelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CarouselBlockReference?: Maybe<ContentModelReferenceFacet>;
  CarouselNextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CarouselPreviousButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CategoriesRoot?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ChapterSitesHeader?: Maybe<Array<Maybe<StringFacet>>>;
  ChapterSitesLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  CityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Close?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyAdminBulkImportPage?: Maybe<ContentModelReferenceFacet>;
  CompanyAdminButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyAdminCompanyListingsPage?: Maybe<ContentModelReferenceFacet>;
  CompanyAdminDashboardPage?: Maybe<ContentModelReferenceFacet>;
  CompanyAdminDashboardPageLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CompanyAdminMembershipDirectoryPage?: Maybe<ContentModelReferenceFacet>;
  CompanyAdminSectionDescriptionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ConfirmLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContactUsLink?: Maybe<SiteSettingsPageLinkBlockFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentSourceCategoryRoot?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  ContinueLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CopyLink?: Maybe<Array<Maybe<StringFacet>>>;
  Copyright?: Maybe<Array<Maybe<StringFacet>>>;
  CountryLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CreateAccountLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DateSavedSuccessfully?: Maybe<Array<Maybe<StringFacet>>>;
  DaysBeforeReShowingContactForm?: Maybe<Array<Maybe<NumberFacet>>>;
  DefaultRouteTitle?: Maybe<Array<Maybe<StringFacet>>>;
  DisableNextAppCacheBust?: Maybe<Array<Maybe<StringFacet>>>;
  DisclaimerLink?: Maybe<SiteSettingsPageLinkBlockFacet>;
  DownloadLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EditLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EmailResource?: Maybe<Array<Maybe<StringFacet>>>;
  EnterFullscreenLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EntityCategoryRoot?: Maybe<ContentModelReferenceFacet>;
  EventSpeakerSearchPage?: Maybe<ContentModelReferenceFacet>;
  EventsCategoryRoot?: Maybe<ContentModelReferenceFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExitFullscreenLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FaxLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedCarouselReference?: Maybe<ContentModelReferenceFacet>;
  FooterLogo?: Maybe<SiteSettingsPageImageBlockFacet>;
  FooterLogoLink?: Maybe<SiteSettingsPageLinkBlockFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  FooterSocialLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  FullscreenLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GlobalConferenceSourceCategory?: Maybe<ContentModelReferenceFacet>;
  GoBackToHomepage?: Maybe<Array<Maybe<StringFacet>>>;
  GoogleCastLabel?: Maybe<Array<Maybe<StringFacet>>>;
  GooglePlayLink?: Maybe<Array<Maybe<StringFacet>>>;
  GooglePlayLinkAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Greeting?: Maybe<Array<Maybe<StringFacet>>>;
  GsAwardsPage?: Maybe<ContentModelReferenceFacet>;
  GsMembershipRenewalPage?: Maybe<ContentModelReferenceFacet>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HelpfulLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  HelpfulLinksHeader?: Maybe<Array<Maybe<StringFacet>>>;
  HomeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ImpersonateModalButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ImpersonateModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  ImpersonateModalErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ImpersonateModalPersonIDLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ImpersonateModalTitle?: Maybe<Array<Maybe<StringFacet>>>;
  ImpersonationLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  In?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  KeyboardAnimationsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LanguageBlockReference?: Maybe<ContentModelReferenceFacet>;
  LanguageIdsAndNames?: Maybe<ContentAreaItemModelSearchFacet>;
  LatinOnlyMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LearnDetailImportFolderReference?: Maybe<ContentModelReferenceFacet>;
  LearnDetailImportTargetFolderReference?: Maybe<ContentModelReferenceFacet>;
  LearnLandingPage?: Maybe<ContentModelReferenceFacet>;
  LeavingConfirmMessage?: Maybe<Array<Maybe<StringFacet>>>;
  LinkCopiedSuccessfully?: Maybe<Array<Maybe<StringFacet>>>;
  LockedResourceModalHeading?: Maybe<Array<Maybe<StringFacet>>>;
  LockedResourceModalSubheading?: Maybe<Array<Maybe<StringFacet>>>;
  LogInPrompt?: Maybe<Array<Maybe<StringFacet>>>;
  LoginBlockReference?: Maybe<ContentModelReferenceFacet>;
  LoginLinkLabel?: Maybe<Array<Maybe<StringFacet>>>;
  LoginPageReference?: Maybe<ContentModelReferenceFacet>;
  LoginPromptText?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLine?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutPageReference?: Maybe<ContentModelReferenceFacet>;
  LoopLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTId?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MdrtAppsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MdrtEdgeSourceCategory?: Maybe<ContentModelReferenceFacet>;
  MdrtIdLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MemberDirectoryPageReference?: Maybe<ContentModelReferenceFacet>;
  MembersOnlyLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipInvoicePage?: Maybe<ContentModelReferenceFacet>;
  MembershipLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipRenewalPage?: Maybe<ContentModelReferenceFacet>;
  MembershipRenewalV2Page?: Maybe<ContentModelReferenceFacet>;
  MembershipRequirementsBlockReference?: Maybe<ContentModelReferenceFacet>;
  MenuLink?: Maybe<ContentAreaItemModelSearchFacet>;
  MenuTrigger?: Maybe<Array<Maybe<StringFacet>>>;
  MinutesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MobileApiAuthenticationToken?: Maybe<Array<Maybe<StringFacet>>>;
  MobileApiBaseUrl?: Maybe<Array<Maybe<StringFacet>>>;
  MuteLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NextPageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NoResultsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NoResultsMessage?: Maybe<Array<Maybe<StringFacet>>>;
  NormalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NotApplicableLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Number?: Maybe<Array<Maybe<StringFacet>>>;
  OffLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Optional?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptAddHomeInstructionsLabelApple?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptAddHomeInstructionsLabelSafari?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptBodyLabelApple?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptBodyLabelSafari?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptBodyLabelWeb?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptCancelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptInstallLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptShareInstructionsLabelApple?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptShareInstructionsLabelSafari?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptTitleLabelApple?: Maybe<Array<Maybe<StringFacet>>>;
  PWAPromptTitleLabelSafari?: Maybe<Array<Maybe<StringFacet>>>;
  PageButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PageNotFoundErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  Pagination?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PauseLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PeopleImportFolderReference?: Maybe<ContentModelReferenceFacet>;
  PeopleImportTargetFolderReference?: Maybe<ContentModelReferenceFacet>;
  PersonThumbnailPlaceholder?: Maybe<ContentModelReferenceFacet>;
  PhoneLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PhoneNumberLink?: Maybe<SiteSettingsPageLinkBlockFacet>;
  PlayLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PlaybackLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrepaymentPortalPage?: Maybe<ContentModelReferenceFacet>;
  PreviousPageLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PrivacyLink?: Maybe<SiteSettingsPageLinkBlockFacet>;
  ProfileDropdownAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileDropdownTriggerAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ProfileListHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PwaAppInstallAndroidImage?: Maybe<ContentModelReferenceFacet>;
  PwaAppInstallAppleImage?: Maybe<ContentModelReferenceFacet>;
  RegionCategoryRoot?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveBookmarkAriaLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveBookmarkSuccessMessage?: Maybe<Array<Maybe<StringFacet>>>;
  RemoveLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RenewNowLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ReplayLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RequiredLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Reset?: Maybe<Array<Maybe<StringFacet>>>;
  RoundTheTableMagazineSourceCategory?: Maybe<ContentModelReferenceFacet>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SaveChanges?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SearchPageReference?: Maybe<ContentModelReferenceFacet>;
  SearchPageV2Reference?: Maybe<ContentModelReferenceFacet>;
  SeekBackwardLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SeekForwardLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SeekLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SelectLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  SelectLanguageLine?: Maybe<Array<Maybe<StringFacet>>>;
  SettingsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ShareBlockReference?: Maybe<ContentModelReferenceFacet>;
  ShareOnFacebook?: Maybe<Array<Maybe<StringFacet>>>;
  ShareOnLinkedIn?: Maybe<Array<Maybe<StringFacet>>>;
  ShareOnX?: Maybe<Array<Maybe<StringFacet>>>;
  ShareResourceMenuTrigger?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowContactUpdateForm?: Maybe<Array<Maybe<StringFacet>>>;
  SignInToViewLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SomethingWentWrong?: Maybe<Array<Maybe<StringFacet>>>;
  SpeedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StateProvinceLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StaticPagesEventNextEventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  StaticPagesEventThisYearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TOTLevelLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ThumbnailPlaceholder?: Maybe<ContentModelReferenceFacet>;
  ToastSomethingWentWrong?: Maybe<Array<Maybe<StringFacet>>>;
  TopOfTheTableAnnualMeetingSourceCategory?: Maybe<ContentModelReferenceFacet>;
  TopicsCategoryRoot?: Maybe<ContentModelReferenceFacet>;
  TopicsCoveredLine?: Maybe<Array<Maybe<StringFacet>>>;
  TotalItemsCountLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TryAgainErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  UnmuteLabel?: Maybe<Array<Maybe<StringFacet>>>;
  UpdateReadTimeInSecondsForAllPublishedLearnDetailPages?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UseNextNavigation?: Maybe<Array<Maybe<StringFacet>>>;
  ViewProfile?: Maybe<Array<Maybe<StringFacet>>>;
  ViewTypeCategoryRoot?: Maybe<ContentModelReferenceFacet>;
  VolumeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  YearLabel?: Maybe<Array<Maybe<StringFacet>>>;
  YesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SiteSettingsPageFacetAccessDeniedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAccessibilityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAccountLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAddBookmarkAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAddBookmarkSuccessMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAdminDashboardPageLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAirPlayLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAnnouncementsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAppDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAppStoreLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAppStoreLinkAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAudioLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAuthorBlockMembershipTextTemplatePluralArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAuthorBlockMembershipTextTemplateSingularArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAuthorBlockTitleWhenMultipleAuthorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAuthorBlockTitleWhenSingleAuthorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetAuthorsByLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetBackAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetBackLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetBackToDashboardArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetBecomeMemberLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetBoostLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetByArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCancelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCarouselNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCarouselPreviousButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteSettingsPageFacetChapterSitesHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCloseArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCompanyAdminButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCompanyAdminDashboardPageLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCompanyAdminSectionDescriptionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetConfirmLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SiteSettingsPageFacetContinueLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCopyLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCopyrightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCountryLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCreateAccountLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteSettingsPageFacetDateSavedSuccessfullyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetDaysBeforeReShowingContactFormArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SiteSettingsPageFacetDefaultRouteTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetDisableNextAppCacheBustArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetDownloadLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetEditLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetEmailResourceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetEnterFullscreenLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetExitFullscreenLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetFaxLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetFullscreenLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetGoBackToHomepageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetGoogleCastLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetGooglePlayLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetGooglePlayLinkAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetGreetingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetHelpfulLinksHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetHomeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetImpersonateModalButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetImpersonateModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetImpersonateModalErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetImpersonateModalPersonIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetImpersonateModalTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetImpersonationLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetKeyboardAnimationsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetLatinOnlyMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetLeavingConfirmMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetLinkCopiedSuccessfullyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetLockedResourceModalHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetLockedResourceModalSubheadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetLogInPromptArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetLoginLinkLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetLoginPromptTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetLogoutLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetLoopLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetMdrtIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetMdrtLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetMdrtAppsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetMdrtIdLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetMembersOnlyLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetMembershipLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetMenuTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetMinutesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetMobileApiAuthenticationTokenArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetMobileApiBaseUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetMuteLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetNextButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetNextPageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetNoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetNoResultsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetNoResultsMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetNormalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetNotApplicableLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetNumberArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetOffLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetOptionalArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPwaPromptAddHomeInstructionsLabelAppleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPwaPromptAddHomeInstructionsLabelSafariArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPwaPromptBodyLabelAppleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPwaPromptBodyLabelSafariArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPwaPromptBodyLabelWebArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPwaPromptCancelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPwaPromptInstallLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPwaPromptShareInstructionsLabelAppleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPwaPromptShareInstructionsLabelSafariArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPwaPromptTitleLabelAppleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPwaPromptTitleLabelSafariArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPageButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPageNotFoundErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPaginationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPauseLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPhoneLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPlayLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPlaybackLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetPreviousPageLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetProfileDropdownAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetProfileDropdownTriggerAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetProfileListHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetRemoveBookmarkAriaLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetRemoveBookmarkSuccessMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetRemoveLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetRenewNowLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetReplayLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetRequiredLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetResetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSaveChangesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteSettingsPageFacetSearchButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSeekBackwardLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSeekForwardLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSeekLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSelectLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSelectLanguageLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSettingsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetShareOnFacebookArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetShareOnLinkedInArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetShareOnXArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetShareResourceMenuTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetShowContactUpdateFormArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSignInToViewLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSomethingWentWrongArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetSpeedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteSettingsPageFacetStateProvinceLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetStaticPagesEventNextEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetStaticPagesEventThisYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteSettingsPageFacetTotLevelLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetToastSomethingWentWrongArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetTopicsCoveredLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetTotalItemsCountLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetTryAgainErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetUnmuteLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetUpdateReadTimeInSecondsForAllPublishedLearnDetailPagesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetUseNextNavigationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetViewProfileArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetVolumeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetYearLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacetYesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SiteSettingsPageImageBlock = {
  __typename?: 'SiteSettingsPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type SiteSettingsPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteSettingsPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteSettingsPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteSettingsPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteSettingsPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SiteSettingsPageImageBlockAutocomplete = {
  __typename?: 'SiteSettingsPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type SiteSettingsPageImageBlockFacet = {
  __typename?: 'SiteSettingsPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteSettingsPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SiteSettingsPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteSettingsPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type SiteSettingsPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type SiteSettingsPageLinkBlock = {
  __typename?: 'SiteSettingsPageLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type SiteSettingsPageLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteSettingsPageLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteSettingsPageLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteSettingsPageLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteSettingsPageLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteSettingsPageLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteSettingsPageLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SiteSettingsPageLinkBlockAutocomplete = {
  __typename?: 'SiteSettingsPageLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteSettingsPageLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteSettingsPageLinkBlockFacet = {
  __typename?: 'SiteSettingsPageLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteSettingsPageLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SiteSettingsPageLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteSettingsPageLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteSettingsPageLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type SiteSettingsPageLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type SiteSettingsPageOrderByInput = {
  AccessDenied?: InputMaybe<OrderBy>;
  AccessibilityLabel?: InputMaybe<OrderBy>;
  AccountLinkLabel?: InputMaybe<OrderBy>;
  AccountProfilePage?: InputMaybe<ContentModelReferenceOrderByInput>;
  AccountSettingsPageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  AddBookmarkAriaLabel?: InputMaybe<OrderBy>;
  AddBookmarkSuccessMessage?: InputMaybe<OrderBy>;
  Address?: InputMaybe<OrderBy>;
  AdminDashboardPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  AdminDashboardPageLinkLabel?: InputMaybe<OrderBy>;
  AirPlayLabel?: InputMaybe<OrderBy>;
  Alerts?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  AnnouncementsLabel?: InputMaybe<OrderBy>;
  AnnualMeetingSourceCategory?: InputMaybe<ContentModelReferenceOrderByInput>;
  AppDescription?: InputMaybe<OrderBy>;
  AppStoreLink?: InputMaybe<OrderBy>;
  AppStoreLinkAriaLabel?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AudioLabel?: InputMaybe<OrderBy>;
  AuthorBlockMembershipTextTemplatePlural?: InputMaybe<OrderBy>;
  AuthorBlockMembershipTextTemplateSingular?: InputMaybe<OrderBy>;
  AuthorBlockTitleWhenMultipleAuthors?: InputMaybe<OrderBy>;
  AuthorBlockTitleWhenSingleAuthor?: InputMaybe<OrderBy>;
  AuthorImportFolderReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  AuthorsByLine?: InputMaybe<OrderBy>;
  BackAriaLabel?: InputMaybe<OrderBy>;
  BackLabel?: InputMaybe<OrderBy>;
  BackToDashboard?: InputMaybe<OrderBy>;
  BecomeMemberLabel?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  BoostLabel?: InputMaybe<OrderBy>;
  By?: InputMaybe<OrderBy>;
  COTLevelLabel?: InputMaybe<OrderBy>;
  CancelLabel?: InputMaybe<OrderBy>;
  CarouselBlockReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  CarouselNextButtonLabel?: InputMaybe<OrderBy>;
  CarouselPreviousButtonLabel?: InputMaybe<OrderBy>;
  CategoriesRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ChapterSitesHeader?: InputMaybe<OrderBy>;
  ChapterSitesLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  CityLabel?: InputMaybe<OrderBy>;
  Close?: InputMaybe<OrderBy>;
  CompanyAdminBulkImportPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  CompanyAdminButtonLabel?: InputMaybe<OrderBy>;
  CompanyAdminCompanyListingsPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  CompanyAdminDashboardPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  CompanyAdminDashboardPageLinkLabel?: InputMaybe<OrderBy>;
  CompanyAdminMembershipDirectoryPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  CompanyAdminSectionDescriptionLabel?: InputMaybe<OrderBy>;
  ConfirmLabel?: InputMaybe<OrderBy>;
  ContactUsLink?: InputMaybe<SiteSettingsPageLinkBlockOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentSourceCategoryRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  ContinueLabel?: InputMaybe<OrderBy>;
  CopyLink?: InputMaybe<OrderBy>;
  Copyright?: InputMaybe<OrderBy>;
  CountryLabel?: InputMaybe<OrderBy>;
  CreateAccountLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DateSavedSuccessfully?: InputMaybe<OrderBy>;
  DaysBeforeReShowingContactForm?: InputMaybe<OrderBy>;
  DefaultRouteTitle?: InputMaybe<OrderBy>;
  DisableNextAppCacheBust?: InputMaybe<OrderBy>;
  DisclaimerLink?: InputMaybe<SiteSettingsPageLinkBlockOrderByInput>;
  DownloadLabel?: InputMaybe<OrderBy>;
  EditLabel?: InputMaybe<OrderBy>;
  EmailResource?: InputMaybe<OrderBy>;
  EnterFullscreenLabel?: InputMaybe<OrderBy>;
  EntityCategoryRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  EventSpeakerSearchPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  EventsCategoryRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExitFullscreenLabel?: InputMaybe<OrderBy>;
  FaxLabel?: InputMaybe<OrderBy>;
  FeaturedCarouselReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterLogo?: InputMaybe<SiteSettingsPageImageBlockOrderByInput>;
  FooterLogoLink?: InputMaybe<SiteSettingsPageLinkBlockOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  FooterSocialLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FullscreenLabel?: InputMaybe<OrderBy>;
  GlobalConferenceSourceCategory?: InputMaybe<ContentModelReferenceOrderByInput>;
  GoBackToHomepage?: InputMaybe<OrderBy>;
  GoogleCastLabel?: InputMaybe<OrderBy>;
  GooglePlayLink?: InputMaybe<OrderBy>;
  GooglePlayLinkAriaLabel?: InputMaybe<OrderBy>;
  Greeting?: InputMaybe<OrderBy>;
  GsAwardsPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  GsMembershipRenewalPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  HeaderScripts?: InputMaybe<OrderBy>;
  HelpfulLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  HelpfulLinksHeader?: InputMaybe<OrderBy>;
  HomeLabel?: InputMaybe<OrderBy>;
  ImpersonateModalButtonLabel?: InputMaybe<OrderBy>;
  ImpersonateModalDescription?: InputMaybe<OrderBy>;
  ImpersonateModalErrorMessage?: InputMaybe<OrderBy>;
  ImpersonateModalPersonIDLabel?: InputMaybe<OrderBy>;
  ImpersonateModalTitle?: InputMaybe<OrderBy>;
  ImpersonationLinkLabel?: InputMaybe<OrderBy>;
  In?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  KeyboardAnimationsLabel?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LanguageBlockReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  LanguageIdsAndNames?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  LatinOnlyMessage?: InputMaybe<OrderBy>;
  LearnDetailImportFolderReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  LearnDetailImportTargetFolderReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  LearnLandingPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  LeavingConfirmMessage?: InputMaybe<OrderBy>;
  LinkCopiedSuccessfully?: InputMaybe<OrderBy>;
  LockedResourceModalHeading?: InputMaybe<OrderBy>;
  LockedResourceModalSubheading?: InputMaybe<OrderBy>;
  LogInPrompt?: InputMaybe<OrderBy>;
  LoginBlockReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  LoginLinkLabel?: InputMaybe<OrderBy>;
  LoginPageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  LoginPromptText?: InputMaybe<OrderBy>;
  LogoutLine?: InputMaybe<OrderBy>;
  LogoutPageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  LoopLabel?: InputMaybe<OrderBy>;
  MDRTId?: InputMaybe<OrderBy>;
  MDRTLevelLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MdrtAppsHeader?: InputMaybe<OrderBy>;
  MdrtEdgeSourceCategory?: InputMaybe<ContentModelReferenceOrderByInput>;
  MdrtIdLabel?: InputMaybe<OrderBy>;
  MemberDirectoryPageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  MembersOnlyLabel?: InputMaybe<OrderBy>;
  MembershipInvoicePage?: InputMaybe<ContentModelReferenceOrderByInput>;
  MembershipLevelLabel?: InputMaybe<OrderBy>;
  MembershipRenewalPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  MembershipRenewalV2Page?: InputMaybe<ContentModelReferenceOrderByInput>;
  MembershipRequirementsBlockReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  MenuLink?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MenuTrigger?: InputMaybe<OrderBy>;
  MinutesLabel?: InputMaybe<OrderBy>;
  MobileApiAuthenticationToken?: InputMaybe<OrderBy>;
  MobileApiBaseUrl?: InputMaybe<OrderBy>;
  MuteLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NextButtonLabel?: InputMaybe<OrderBy>;
  NextPageLabel?: InputMaybe<OrderBy>;
  NoLabel?: InputMaybe<OrderBy>;
  NoResultsLabel?: InputMaybe<OrderBy>;
  NoResultsMessage?: InputMaybe<OrderBy>;
  NormalLabel?: InputMaybe<OrderBy>;
  NotApplicableLabel?: InputMaybe<OrderBy>;
  Number?: InputMaybe<OrderBy>;
  OffLabel?: InputMaybe<OrderBy>;
  Optional?: InputMaybe<OrderBy>;
  PWAPromptAddHomeInstructionsLabelApple?: InputMaybe<OrderBy>;
  PWAPromptAddHomeInstructionsLabelSafari?: InputMaybe<OrderBy>;
  PWAPromptBodyLabelApple?: InputMaybe<OrderBy>;
  PWAPromptBodyLabelSafari?: InputMaybe<OrderBy>;
  PWAPromptBodyLabelWeb?: InputMaybe<OrderBy>;
  PWAPromptCancelLabel?: InputMaybe<OrderBy>;
  PWAPromptInstallLabel?: InputMaybe<OrderBy>;
  PWAPromptShareInstructionsLabelApple?: InputMaybe<OrderBy>;
  PWAPromptShareInstructionsLabelSafari?: InputMaybe<OrderBy>;
  PWAPromptTitleLabelApple?: InputMaybe<OrderBy>;
  PWAPromptTitleLabelSafari?: InputMaybe<OrderBy>;
  PageButtonLabel?: InputMaybe<OrderBy>;
  PageNotFoundErrorMessage?: InputMaybe<OrderBy>;
  Pagination?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PauseLabel?: InputMaybe<OrderBy>;
  PeopleImportFolderReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  PeopleImportTargetFolderReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonThumbnailPlaceholder?: InputMaybe<ContentModelReferenceOrderByInput>;
  PhoneLabel?: InputMaybe<OrderBy>;
  PhoneNumberLink?: InputMaybe<SiteSettingsPageLinkBlockOrderByInput>;
  PlayLabel?: InputMaybe<OrderBy>;
  PlaybackLabel?: InputMaybe<OrderBy>;
  PrepaymentPortalPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviousPageLabel?: InputMaybe<OrderBy>;
  PrivacyLink?: InputMaybe<SiteSettingsPageLinkBlockOrderByInput>;
  ProfileDropdownAriaLabel?: InputMaybe<OrderBy>;
  ProfileDropdownTriggerAriaLabel?: InputMaybe<OrderBy>;
  ProfileListHeading?: InputMaybe<OrderBy>;
  PwaAppInstallAndroidImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PwaAppInstallAppleImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  RegionCategoryRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RemoveBookmarkAriaLabel?: InputMaybe<OrderBy>;
  RemoveBookmarkSuccessMessage?: InputMaybe<OrderBy>;
  RemoveLabel?: InputMaybe<OrderBy>;
  RenewNowLabel?: InputMaybe<OrderBy>;
  ReplayLabel?: InputMaybe<OrderBy>;
  RequiredLabel?: InputMaybe<OrderBy>;
  Reset?: InputMaybe<OrderBy>;
  RoundTheTableMagazineSourceCategory?: InputMaybe<ContentModelReferenceOrderByInput>;
  RouteSegment?: InputMaybe<OrderBy>;
  SaveChanges?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchButtonLabel?: InputMaybe<OrderBy>;
  SearchPageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  SearchPageV2Reference?: InputMaybe<ContentModelReferenceOrderByInput>;
  SeekBackwardLabel?: InputMaybe<OrderBy>;
  SeekForwardLabel?: InputMaybe<OrderBy>;
  SeekLabel?: InputMaybe<OrderBy>;
  SelectLanguage?: InputMaybe<OrderBy>;
  SelectLanguageLine?: InputMaybe<OrderBy>;
  SettingsLabel?: InputMaybe<OrderBy>;
  ShareBlockReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ShareOnFacebook?: InputMaybe<OrderBy>;
  ShareOnLinkedIn?: InputMaybe<OrderBy>;
  ShareOnX?: InputMaybe<OrderBy>;
  ShareResourceMenuTrigger?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowContactUpdateForm?: InputMaybe<OrderBy>;
  SignInToViewLabel?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SomethingWentWrong?: InputMaybe<OrderBy>;
  SpeedLabel?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  StateProvinceLabel?: InputMaybe<OrderBy>;
  StaticPagesEventNextEventLabel?: InputMaybe<OrderBy>;
  StaticPagesEventThisYearLabel?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TOTLevelLabel?: InputMaybe<OrderBy>;
  ThumbnailPlaceholder?: InputMaybe<ContentModelReferenceOrderByInput>;
  ToastSomethingWentWrong?: InputMaybe<OrderBy>;
  TopOfTheTableAnnualMeetingSourceCategory?: InputMaybe<ContentModelReferenceOrderByInput>;
  TopicsCategoryRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  TopicsCoveredLine?: InputMaybe<OrderBy>;
  TotalItemsCountLabel?: InputMaybe<OrderBy>;
  TryAgainErrorMessage?: InputMaybe<OrderBy>;
  UnmuteLabel?: InputMaybe<OrderBy>;
  UpdateReadTimeInSecondsForAllPublishedLearnDetailPages?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UseNextNavigation?: InputMaybe<OrderBy>;
  ViewProfile?: InputMaybe<OrderBy>;
  ViewTypeCategoryRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  VolumeLabel?: InputMaybe<OrderBy>;
  YearLabel?: InputMaybe<OrderBy>;
  YesLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SiteSettingsPageOutput = {
  __typename?: 'SiteSettingsPageOutput';
  autocomplete?: Maybe<SiteSettingsPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiteSettingsPageFacet>;
  item?: Maybe<SiteSettingsPage>;
  items?: Maybe<Array<Maybe<SiteSettingsPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SiteSettingsPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteSettingsPageWhereInput = {
  AccessDenied?: InputMaybe<SearchableStringFilterInput>;
  AccessibilityLabel?: InputMaybe<SearchableStringFilterInput>;
  AccountLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  AccountProfilePage?: InputMaybe<ContentModelReferenceWhereInput>;
  AccountSettingsPageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  AddBookmarkAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  AddBookmarkSuccessMessage?: InputMaybe<SearchableStringFilterInput>;
  Address?: InputMaybe<SearchableStringFilterInput>;
  AdminDashboardPage?: InputMaybe<ContentModelReferenceWhereInput>;
  AdminDashboardPageLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  AirPlayLabel?: InputMaybe<SearchableStringFilterInput>;
  Alerts?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AnnouncementsLabel?: InputMaybe<SearchableStringFilterInput>;
  AnnualMeetingSourceCategory?: InputMaybe<ContentModelReferenceWhereInput>;
  AppDescription?: InputMaybe<SearchableStringFilterInput>;
  AppStoreLink?: InputMaybe<StringFilterInput>;
  AppStoreLinkAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AudioLabel?: InputMaybe<SearchableStringFilterInput>;
  AuthorBlockMembershipTextTemplatePlural?: InputMaybe<SearchableStringFilterInput>;
  AuthorBlockMembershipTextTemplateSingular?: InputMaybe<SearchableStringFilterInput>;
  AuthorBlockTitleWhenMultipleAuthors?: InputMaybe<SearchableStringFilterInput>;
  AuthorBlockTitleWhenSingleAuthor?: InputMaybe<SearchableStringFilterInput>;
  AuthorImportFolderReference?: InputMaybe<ContentModelReferenceWhereInput>;
  AuthorsByLine?: InputMaybe<SearchableStringFilterInput>;
  BackAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  BackLabel?: InputMaybe<SearchableStringFilterInput>;
  BackToDashboard?: InputMaybe<SearchableStringFilterInput>;
  BecomeMemberLabel?: InputMaybe<SearchableStringFilterInput>;
  BodyScripts?: InputMaybe<SearchableStringFilterInput>;
  BoostLabel?: InputMaybe<SearchableStringFilterInput>;
  By?: InputMaybe<SearchableStringFilterInput>;
  COTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  CancelLabel?: InputMaybe<SearchableStringFilterInput>;
  CarouselBlockReference?: InputMaybe<ContentModelReferenceWhereInput>;
  CarouselNextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  CarouselPreviousButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  CategoriesRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ChapterSitesHeader?: InputMaybe<SearchableStringFilterInput>;
  ChapterSitesLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  CityLabel?: InputMaybe<SearchableStringFilterInput>;
  Close?: InputMaybe<SearchableStringFilterInput>;
  CompanyAdminBulkImportPage?: InputMaybe<ContentModelReferenceWhereInput>;
  CompanyAdminButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyAdminCompanyListingsPage?: InputMaybe<ContentModelReferenceWhereInput>;
  CompanyAdminDashboardPage?: InputMaybe<ContentModelReferenceWhereInput>;
  CompanyAdminDashboardPageLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  CompanyAdminMembershipDirectoryPage?: InputMaybe<ContentModelReferenceWhereInput>;
  CompanyAdminSectionDescriptionLabel?: InputMaybe<SearchableStringFilterInput>;
  ConfirmLabel?: InputMaybe<SearchableStringFilterInput>;
  ContactUsLink?: InputMaybe<SiteSettingsPageLinkBlockWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentSourceCategoryRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  ContinueLabel?: InputMaybe<SearchableStringFilterInput>;
  CopyLink?: InputMaybe<SearchableStringFilterInput>;
  Copyright?: InputMaybe<SearchableStringFilterInput>;
  CountryLabel?: InputMaybe<SearchableStringFilterInput>;
  CreateAccountLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DateSavedSuccessfully?: InputMaybe<SearchableStringFilterInput>;
  DaysBeforeReShowingContactForm?: InputMaybe<IntFilterInput>;
  DefaultRouteTitle?: InputMaybe<SearchableStringFilterInput>;
  DisableNextAppCacheBust?: InputMaybe<BoolFilterInput>;
  DisclaimerLink?: InputMaybe<SiteSettingsPageLinkBlockWhereInput>;
  DownloadLabel?: InputMaybe<SearchableStringFilterInput>;
  EditLabel?: InputMaybe<SearchableStringFilterInput>;
  EmailResource?: InputMaybe<SearchableStringFilterInput>;
  EnterFullscreenLabel?: InputMaybe<SearchableStringFilterInput>;
  EntityCategoryRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  EventSpeakerSearchPage?: InputMaybe<ContentModelReferenceWhereInput>;
  EventsCategoryRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExitFullscreenLabel?: InputMaybe<SearchableStringFilterInput>;
  FaxLabel?: InputMaybe<SearchableStringFilterInput>;
  FeaturedCarouselReference?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterLogo?: InputMaybe<SiteSettingsPageImageBlockWhereInput>;
  FooterLogoLink?: InputMaybe<SiteSettingsPageLinkBlockWhereInput>;
  FooterScripts?: InputMaybe<SearchableStringFilterInput>;
  FooterSocialLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FullscreenLabel?: InputMaybe<SearchableStringFilterInput>;
  GlobalConferenceSourceCategory?: InputMaybe<ContentModelReferenceWhereInput>;
  GoBackToHomepage?: InputMaybe<SearchableStringFilterInput>;
  GoogleCastLabel?: InputMaybe<SearchableStringFilterInput>;
  GooglePlayLink?: InputMaybe<StringFilterInput>;
  GooglePlayLinkAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  Greeting?: InputMaybe<SearchableStringFilterInput>;
  GsAwardsPage?: InputMaybe<ContentModelReferenceWhereInput>;
  GsMembershipRenewalPage?: InputMaybe<ContentModelReferenceWhereInput>;
  HeaderScripts?: InputMaybe<SearchableStringFilterInput>;
  HelpfulLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  HelpfulLinksHeader?: InputMaybe<SearchableStringFilterInput>;
  HomeLabel?: InputMaybe<SearchableStringFilterInput>;
  ImpersonateModalButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  ImpersonateModalDescription?: InputMaybe<SearchableStringFilterInput>;
  ImpersonateModalErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  ImpersonateModalPersonIDLabel?: InputMaybe<SearchableStringFilterInput>;
  ImpersonateModalTitle?: InputMaybe<SearchableStringFilterInput>;
  ImpersonationLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  In?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  KeyboardAnimationsLabel?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LanguageBlockReference?: InputMaybe<ContentModelReferenceWhereInput>;
  LanguageIdsAndNames?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  LatinOnlyMessage?: InputMaybe<SearchableStringFilterInput>;
  LearnDetailImportFolderReference?: InputMaybe<ContentModelReferenceWhereInput>;
  LearnDetailImportTargetFolderReference?: InputMaybe<ContentModelReferenceWhereInput>;
  LearnLandingPage?: InputMaybe<ContentModelReferenceWhereInput>;
  LeavingConfirmMessage?: InputMaybe<SearchableStringFilterInput>;
  LinkCopiedSuccessfully?: InputMaybe<SearchableStringFilterInput>;
  LockedResourceModalHeading?: InputMaybe<SearchableStringFilterInput>;
  LockedResourceModalSubheading?: InputMaybe<SearchableStringFilterInput>;
  LogInPrompt?: InputMaybe<SearchableStringFilterInput>;
  LoginBlockReference?: InputMaybe<ContentModelReferenceWhereInput>;
  LoginLinkLabel?: InputMaybe<SearchableStringFilterInput>;
  LoginPageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  LoginPromptText?: InputMaybe<SearchableStringFilterInput>;
  LogoutLine?: InputMaybe<SearchableStringFilterInput>;
  LogoutPageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  LoopLabel?: InputMaybe<SearchableStringFilterInput>;
  MDRTId?: InputMaybe<SearchableStringFilterInput>;
  MDRTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MdrtAppsHeader?: InputMaybe<SearchableStringFilterInput>;
  MdrtEdgeSourceCategory?: InputMaybe<ContentModelReferenceWhereInput>;
  MdrtIdLabel?: InputMaybe<SearchableStringFilterInput>;
  MemberDirectoryPageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  MembersOnlyLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipInvoicePage?: InputMaybe<ContentModelReferenceWhereInput>;
  MembershipLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  MembershipRenewalPage?: InputMaybe<ContentModelReferenceWhereInput>;
  MembershipRenewalV2Page?: InputMaybe<ContentModelReferenceWhereInput>;
  MembershipRequirementsBlockReference?: InputMaybe<ContentModelReferenceWhereInput>;
  MenuLink?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MenuTrigger?: InputMaybe<SearchableStringFilterInput>;
  MinutesLabel?: InputMaybe<SearchableStringFilterInput>;
  MobileApiAuthenticationToken?: InputMaybe<SearchableStringFilterInput>;
  MobileApiBaseUrl?: InputMaybe<SearchableStringFilterInput>;
  MuteLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  NextPageLabel?: InputMaybe<SearchableStringFilterInput>;
  NoLabel?: InputMaybe<SearchableStringFilterInput>;
  NoResultsLabel?: InputMaybe<SearchableStringFilterInput>;
  NoResultsMessage?: InputMaybe<SearchableStringFilterInput>;
  NormalLabel?: InputMaybe<SearchableStringFilterInput>;
  NotApplicableLabel?: InputMaybe<SearchableStringFilterInput>;
  Number?: InputMaybe<SearchableStringFilterInput>;
  OffLabel?: InputMaybe<SearchableStringFilterInput>;
  Optional?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptAddHomeInstructionsLabelApple?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptAddHomeInstructionsLabelSafari?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptBodyLabelApple?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptBodyLabelSafari?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptBodyLabelWeb?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptCancelLabel?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptInstallLabel?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptShareInstructionsLabelApple?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptShareInstructionsLabelSafari?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptTitleLabelApple?: InputMaybe<SearchableStringFilterInput>;
  PWAPromptTitleLabelSafari?: InputMaybe<SearchableStringFilterInput>;
  PageButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  PageNotFoundErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  Pagination?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PauseLabel?: InputMaybe<SearchableStringFilterInput>;
  PeopleImportFolderReference?: InputMaybe<ContentModelReferenceWhereInput>;
  PeopleImportTargetFolderReference?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonThumbnailPlaceholder?: InputMaybe<ContentModelReferenceWhereInput>;
  PhoneLabel?: InputMaybe<SearchableStringFilterInput>;
  PhoneNumberLink?: InputMaybe<SiteSettingsPageLinkBlockWhereInput>;
  PlayLabel?: InputMaybe<SearchableStringFilterInput>;
  PlaybackLabel?: InputMaybe<SearchableStringFilterInput>;
  PrepaymentPortalPage?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviousPageLabel?: InputMaybe<SearchableStringFilterInput>;
  PrivacyLink?: InputMaybe<SiteSettingsPageLinkBlockWhereInput>;
  ProfileDropdownAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfileDropdownTriggerAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  ProfileListHeading?: InputMaybe<SearchableStringFilterInput>;
  PwaAppInstallAndroidImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PwaAppInstallAppleImage?: InputMaybe<ContentModelReferenceWhereInput>;
  RegionCategoryRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RemoveBookmarkAriaLabel?: InputMaybe<SearchableStringFilterInput>;
  RemoveBookmarkSuccessMessage?: InputMaybe<SearchableStringFilterInput>;
  RemoveLabel?: InputMaybe<SearchableStringFilterInput>;
  RenewNowLabel?: InputMaybe<SearchableStringFilterInput>;
  ReplayLabel?: InputMaybe<SearchableStringFilterInput>;
  RequiredLabel?: InputMaybe<SearchableStringFilterInput>;
  Reset?: InputMaybe<SearchableStringFilterInput>;
  RoundTheTableMagazineSourceCategory?: InputMaybe<ContentModelReferenceWhereInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SaveChanges?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  SearchPageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  SearchPageV2Reference?: InputMaybe<ContentModelReferenceWhereInput>;
  SeekBackwardLabel?: InputMaybe<SearchableStringFilterInput>;
  SeekForwardLabel?: InputMaybe<SearchableStringFilterInput>;
  SeekLabel?: InputMaybe<SearchableStringFilterInput>;
  SelectLanguage?: InputMaybe<SearchableStringFilterInput>;
  SelectLanguageLine?: InputMaybe<SearchableStringFilterInput>;
  SettingsLabel?: InputMaybe<SearchableStringFilterInput>;
  ShareBlockReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ShareOnFacebook?: InputMaybe<SearchableStringFilterInput>;
  ShareOnLinkedIn?: InputMaybe<SearchableStringFilterInput>;
  ShareOnX?: InputMaybe<SearchableStringFilterInput>;
  ShareResourceMenuTrigger?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowContactUpdateForm?: InputMaybe<BoolFilterInput>;
  SignInToViewLabel?: InputMaybe<SearchableStringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SomethingWentWrong?: InputMaybe<SearchableStringFilterInput>;
  SpeedLabel?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  StateProvinceLabel?: InputMaybe<SearchableStringFilterInput>;
  StaticPagesEventNextEventLabel?: InputMaybe<SearchableStringFilterInput>;
  StaticPagesEventThisYearLabel?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TOTLevelLabel?: InputMaybe<SearchableStringFilterInput>;
  ThumbnailPlaceholder?: InputMaybe<ContentModelReferenceWhereInput>;
  ToastSomethingWentWrong?: InputMaybe<SearchableStringFilterInput>;
  TopOfTheTableAnnualMeetingSourceCategory?: InputMaybe<ContentModelReferenceWhereInput>;
  TopicsCategoryRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  TopicsCoveredLine?: InputMaybe<SearchableStringFilterInput>;
  TotalItemsCountLabel?: InputMaybe<SearchableStringFilterInput>;
  TryAgainErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  UnmuteLabel?: InputMaybe<SearchableStringFilterInput>;
  UpdateReadTimeInSecondsForAllPublishedLearnDetailPages?: InputMaybe<BoolFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UseNextNavigation?: InputMaybe<BoolFilterInput>;
  ViewProfile?: InputMaybe<SearchableStringFilterInput>;
  ViewTypeCategoryRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  VolumeLabel?: InputMaybe<SearchableStringFilterInput>;
  YearLabel?: InputMaybe<SearchableStringFilterInput>;
  YesLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteSettingsPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteSettingsPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteSettingsPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A block that will render various Share links for the current page */
export type SocialShareBlock = IContent & IData & {
  __typename?: 'SocialShareBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  ShareLabel?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block that will render various Share links for the current page */
export type SocialShareBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block that will render various Share links for the current page */
export type SocialShareBlockShareLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block that will render various Share links for the current page */
export type SocialShareBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block that will render various Share links for the current page */
export type SocialShareBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SocialShareBlockAutocomplete = {
  __typename?: 'SocialShareBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SocialShareBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SocialShareBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SocialShareBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SocialShareBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SocialShareBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SocialShareBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SocialShareBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SocialShareBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SocialShareBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SocialShareBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SocialShareBlockFacet = {
  __typename?: 'SocialShareBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShareLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SocialShareBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SocialShareBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SocialShareBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SocialShareBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SocialShareBlockFacetShareLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SocialShareBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SocialShareBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SocialShareBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SocialShareBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShareLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SocialShareBlockOutput = {
  __typename?: 'SocialShareBlockOutput';
  autocomplete?: Maybe<SocialShareBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SocialShareBlockFacet>;
  item?: Maybe<SocialShareBlock>;
  items?: Maybe<Array<Maybe<SocialShareBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SocialShareBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SocialShareBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShareLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SocialShareBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SocialShareBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SocialShareBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SourcesEntry = {
  __typename?: 'SourcesEntry';
  Id?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['Int']['output']>;
};

export type SourcesEntryAutocomplete = {
  __typename?: 'SourcesEntryAutocomplete';
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SourcesEntryAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SourcesEntryFacet = {
  __typename?: 'SourcesEntryFacet';
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SourcesEntryFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SourcesEntryFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SourcesEntryFacetParentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SourcesEntryOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentId?: InputMaybe<OrderBy>;
};

export type SourcesEntryWhereInput = {
  Id?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  ParentId?: InputMaybe<IntFilterInput>;
};

/** Speaker Engagement */
export type SpeakerEngagementPage = IContent & IData & {
  __typename?: 'SpeakerEngagementPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MDRTContact?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<SpeakerEngagementPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SendToEmail?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<SpeakerEngagementPageImageBlock>;
  TitleParagraph1?: Maybe<Scalars['String']['output']>;
  TitleParagraph2?: Maybe<Scalars['String']['output']>;
  TitleText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Speaker Engagement */
export type SpeakerEngagementPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Speaker Engagement */
export type SpeakerEngagementPageMdrtContactArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Speaker Engagement */
export type SpeakerEngagementPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Speaker Engagement */
export type SpeakerEngagementPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Speaker Engagement */
export type SpeakerEngagementPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Speaker Engagement */
export type SpeakerEngagementPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Speaker Engagement */
export type SpeakerEngagementPageSendToEmailArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Speaker Engagement */
export type SpeakerEngagementPageTitleParagraph1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Speaker Engagement */
export type SpeakerEngagementPageTitleParagraph2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Speaker Engagement */
export type SpeakerEngagementPageTitleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Speaker Engagement */
export type SpeakerEngagementPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Speaker Engagement */
export type SpeakerEngagementPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SpeakerEngagementPageAutocomplete = {
  __typename?: 'SpeakerEngagementPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<SpeakerEngagementPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<SpeakerEngagementPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SpeakerEngagementPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpeakerEngagementPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpeakerEngagementPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpeakerEngagementPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpeakerEngagementPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpeakerEngagementPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpeakerEngagementPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpeakerEngagementPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpeakerEngagementPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpeakerEngagementPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpeakerEngagementPageFacet = {
  __typename?: 'SpeakerEngagementPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MDRTContact?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<SpeakerEngagementPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SendToEmail?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<SpeakerEngagementPageImageBlockFacet>;
  TitleParagraph1?: Maybe<Array<Maybe<StringFacet>>>;
  TitleParagraph2?: Maybe<Array<Maybe<StringFacet>>>;
  TitleText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SpeakerEngagementPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpeakerEngagementPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SpeakerEngagementPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpeakerEngagementPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SpeakerEngagementPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetMdrtContactArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpeakerEngagementPageFacetSendToEmailArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpeakerEngagementPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpeakerEngagementPageFacetTitleParagraph1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetTitleParagraph2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetTitleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SpeakerEngagementPageImageBlock = {
  __typename?: 'SpeakerEngagementPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type SpeakerEngagementPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpeakerEngagementPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpeakerEngagementPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpeakerEngagementPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpeakerEngagementPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SpeakerEngagementPageImageBlockAutocomplete = {
  __typename?: 'SpeakerEngagementPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type SpeakerEngagementPageImageBlockFacet = {
  __typename?: 'SpeakerEngagementPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SpeakerEngagementPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpeakerEngagementPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SpeakerEngagementPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpeakerEngagementPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type SpeakerEngagementPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type SpeakerEngagementPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MDRTContact?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<SpeakerEngagementPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SendToEmail?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<SpeakerEngagementPageImageBlockOrderByInput>;
  TitleParagraph1?: InputMaybe<OrderBy>;
  TitleParagraph2?: InputMaybe<OrderBy>;
  TitleText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SpeakerEngagementPageOutput = {
  __typename?: 'SpeakerEngagementPageOutput';
  autocomplete?: Maybe<SpeakerEngagementPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SpeakerEngagementPageFacet>;
  item?: Maybe<SpeakerEngagementPage>;
  items?: Maybe<Array<Maybe<SpeakerEngagementPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SpeakerEngagementPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpeakerEngagementPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MDRTContact?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<SpeakerEngagementPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SendToEmail?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<SpeakerEngagementPageImageBlockWhereInput>;
  TitleParagraph1?: InputMaybe<SearchableStringFilterInput>;
  TitleParagraph2?: InputMaybe<SearchableStringFilterInput>;
  TitleText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SpeakerEngagementPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SpeakerEngagementPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SpeakerEngagementPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Sponsor Speaker Submission */
export type SponsorSpeakerPage = IContent & IData & {
  __typename?: 'SponsorSpeakerPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<SponsorSpeakerPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<SponsorSpeakerPageImageBlock>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Sponsor Speaker Submission */
export type SponsorSpeakerPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Sponsor Speaker Submission */
export type SponsorSpeakerPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Sponsor Speaker Submission */
export type SponsorSpeakerPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Sponsor Speaker Submission */
export type SponsorSpeakerPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Sponsor Speaker Submission */
export type SponsorSpeakerPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Sponsor Speaker Submission */
export type SponsorSpeakerPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Sponsor Speaker Submission */
export type SponsorSpeakerPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SponsorSpeakerPageAutocomplete = {
  __typename?: 'SponsorSpeakerPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<SponsorSpeakerPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<SponsorSpeakerPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SponsorSpeakerPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SponsorSpeakerPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SponsorSpeakerPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SponsorSpeakerPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SponsorSpeakerPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SponsorSpeakerPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SponsorSpeakerPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SponsorSpeakerPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SponsorSpeakerPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SponsorSpeakerPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SponsorSpeakerPageFacet = {
  __typename?: 'SponsorSpeakerPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<SponsorSpeakerPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<SponsorSpeakerPageImageBlockFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SponsorSpeakerPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SponsorSpeakerPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SponsorSpeakerPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SponsorSpeakerPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SponsorSpeakerPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SponsorSpeakerPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SponsorSpeakerPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SponsorSpeakerPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SponsorSpeakerPageImageBlock = {
  __typename?: 'SponsorSpeakerPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type SponsorSpeakerPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SponsorSpeakerPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SponsorSpeakerPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SponsorSpeakerPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SponsorSpeakerPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SponsorSpeakerPageImageBlockAutocomplete = {
  __typename?: 'SponsorSpeakerPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type SponsorSpeakerPageImageBlockFacet = {
  __typename?: 'SponsorSpeakerPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SponsorSpeakerPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SponsorSpeakerPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SponsorSpeakerPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SponsorSpeakerPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type SponsorSpeakerPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type SponsorSpeakerPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<SponsorSpeakerPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<SponsorSpeakerPageImageBlockOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SponsorSpeakerPageOutput = {
  __typename?: 'SponsorSpeakerPageOutput';
  autocomplete?: Maybe<SponsorSpeakerPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SponsorSpeakerPageFacet>;
  item?: Maybe<SponsorSpeakerPage>;
  items?: Maybe<Array<Maybe<SponsorSpeakerPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SponsorSpeakerPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SponsorSpeakerPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<SponsorSpeakerPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<SponsorSpeakerPageImageBlockWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SponsorSpeakerPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SponsorSpeakerPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SponsorSpeakerPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Block to spotlight companies and link to reports */
export type SpotlightBlock = IContent & IData & {
  __typename?: 'SpotlightBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CallToActionLink?: Maybe<SpotlightBlockLinkBlock>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** List of company names in the ranking order */
  Companies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** A custom SVG to be shown on the card. You must select the 'Custom' option in the Icon Property. Recommended icon size is 48px by 48px. */
  CustomSvgIcon?: Maybe<ContentModelReference>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Icon to show next to block title */
  Icon?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Title to display at the top of the block */
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Block to spotlight companies and link to reports */
export type SpotlightBlockIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block to spotlight companies and link to reports */
export type SpotlightBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block to spotlight companies and link to reports */
export type SpotlightBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block to spotlight companies and link to reports */
export type SpotlightBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block to spotlight companies and link to reports */
export type SpotlightBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SpotlightBlockAutocomplete = {
  __typename?: 'SpotlightBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CallToActionLink?: Maybe<SpotlightBlockLinkBlockAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  Companies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CustomSvgIcon?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SpotlightBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightBlockAutocompleteCompaniesArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpotlightBlockFacet = {
  __typename?: 'SpotlightBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CallToActionLink?: Maybe<SpotlightBlockLinkBlockFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Companies?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CustomSvgIcon?: Maybe<ContentModelReferenceFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Icon?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SpotlightBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightBlockFacetCompaniesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightBlockFacetIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SpotlightBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SpotlightBlockLinkBlock = {
  __typename?: 'SpotlightBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type SpotlightBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SpotlightBlockLinkBlockAutocomplete = {
  __typename?: 'SpotlightBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SpotlightBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpotlightBlockLinkBlockFacet = {
  __typename?: 'SpotlightBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SpotlightBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SpotlightBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpotlightBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type SpotlightBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type SpotlightBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CallToActionLink?: InputMaybe<SpotlightBlockLinkBlockOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Companies?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CustomSvgIcon?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Icon?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SpotlightBlockOutput = {
  __typename?: 'SpotlightBlockOutput';
  autocomplete?: Maybe<SpotlightBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SpotlightBlockFacet>;
  item?: Maybe<SpotlightBlock>;
  items?: Maybe<Array<Maybe<SpotlightBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SpotlightBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpotlightBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CallToActionLink?: InputMaybe<SpotlightBlockLinkBlockWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Companies?: InputMaybe<StringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CustomSvgIcon?: InputMaybe<ContentModelReferenceWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Icon?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SpotlightBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SpotlightBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SpotlightBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Container Block to group Spotlight Blocks on page */
export type SpotlightContainerBlock = IContent & IData & {
  __typename?: 'SpotlightContainerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  /** Blocks to show in container. Recommend between 3 and 6 blocks. */
  SpotlightBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Container Block to group Spotlight Blocks on page */
export type SpotlightContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container Block to group Spotlight Blocks on page */
export type SpotlightContainerBlockSpotlightBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container Block to group Spotlight Blocks on page */
export type SpotlightContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container Block to group Spotlight Blocks on page */
export type SpotlightContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SpotlightContainerBlockAutocomplete = {
  __typename?: 'SpotlightContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SpotlightContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpotlightContainerBlockFacet = {
  __typename?: 'SpotlightContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SpotlightBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SpotlightContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SpotlightContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SpotlightContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SpotlightBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SpotlightContainerBlockOutput = {
  __typename?: 'SpotlightContainerBlockOutput';
  autocomplete?: Maybe<SpotlightContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SpotlightContainerBlockFacet>;
  item?: Maybe<SpotlightContainerBlock>;
  items?: Maybe<Array<Maybe<SpotlightContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SpotlightContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpotlightContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SpotlightBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SpotlightContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SpotlightContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SpotlightContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Used for displaying company statistics data */
export type SpotlightDataBlock = IContent & IData & {
  __typename?: 'SpotlightDataBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** The format to use when rendering the value. The default is to show it as entered. */
  DataFormat?: Maybe<Scalars['String']['output']>;
  /** Data to be displayed. Only the Name and Value fields are required. */
  DataItems?: Maybe<Scalars['String']['output']>;
  /** Select whether to show data as tabular or using progress bars */
  DisplayOption?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Optional heading to show above the data. */
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** When enabled, all progress bars will use the max value as the 100% reference. Otherwise, will be referenced to 100. */
  MaxValueReference?: Maybe<Scalars['Bool']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Used for displaying company statistics data */
export type SpotlightDataBlockDataFormatArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used for displaying company statistics data */
export type SpotlightDataBlockDisplayOptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used for displaying company statistics data */
export type SpotlightDataBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used for displaying company statistics data */
export type SpotlightDataBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used for displaying company statistics data */
export type SpotlightDataBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Used for displaying company statistics data */
export type SpotlightDataBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SpotlightDataBlockAutocomplete = {
  __typename?: 'SpotlightDataBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DataItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SpotlightDataBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataBlockAutocompleteDataItemsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpotlightDataBlockFacet = {
  __typename?: 'SpotlightDataBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DataFormat?: Maybe<Array<Maybe<StringFacet>>>;
  DataItems?: Maybe<Array<Maybe<StringFacet>>>;
  DisplayOption?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MaxValueReference?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SpotlightDataBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightDataBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightDataBlockFacetDataFormatArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetDataItemsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetDisplayOptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SpotlightDataBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetMaxValueReferenceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightDataBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightDataBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightDataBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SpotlightDataBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DataFormat?: InputMaybe<OrderBy>;
  DataItems?: InputMaybe<OrderBy>;
  DisplayOption?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MaxValueReference?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SpotlightDataBlockOutput = {
  __typename?: 'SpotlightDataBlockOutput';
  autocomplete?: Maybe<SpotlightDataBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SpotlightDataBlockFacet>;
  item?: Maybe<SpotlightDataBlock>;
  items?: Maybe<Array<Maybe<SpotlightDataBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SpotlightDataBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpotlightDataBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DataFormat?: InputMaybe<SearchableStringFilterInput>;
  DataItems?: InputMaybe<StringFilterInput>;
  DisplayOption?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MaxValueReference?: InputMaybe<BoolFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SpotlightDataBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SpotlightDataBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SpotlightDataBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Container block for displaying Spotlight Data blocks */
export type SpotlightDataContainerBlock = IContent & IData & {
  __typename?: 'SpotlightDataContainerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CTALink?: Maybe<SpotlightDataContainerBlockLinkBlock>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Data to be displayed within the block */
  DataBlocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Optional heading to show at the top of the block. */
  SubHeading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Container block for displaying Spotlight Data blocks */
export type SpotlightDataContainerBlockDataBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container block for displaying Spotlight Data blocks */
export type SpotlightDataContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container block for displaying Spotlight Data blocks */
export type SpotlightDataContainerBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container block for displaying Spotlight Data blocks */
export type SpotlightDataContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container block for displaying Spotlight Data blocks */
export type SpotlightDataContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SpotlightDataContainerBlockAutocomplete = {
  __typename?: 'SpotlightDataContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CTALink?: Maybe<SpotlightDataContainerBlockLinkBlockAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SpotlightDataContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataContainerBlockAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SpotlightDataContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpotlightDataContainerBlockFacet = {
  __typename?: 'SpotlightDataContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CTALink?: Maybe<SpotlightDataContainerBlockLinkBlockFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DataBlocks?: Maybe<ContentAreaItemModelSearchFacet>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SpotlightDataContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightDataContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightDataContainerBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SpotlightDataContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightDataContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightDataContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SpotlightDataContainerBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SpotlightDataContainerBlockLinkBlock = {
  __typename?: 'SpotlightDataContainerBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type SpotlightDataContainerBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightDataContainerBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightDataContainerBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightDataContainerBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightDataContainerBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightDataContainerBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SpotlightDataContainerBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SpotlightDataContainerBlockLinkBlockAutocomplete = {
  __typename?: 'SpotlightDataContainerBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SpotlightDataContainerBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SpotlightDataContainerBlockLinkBlockFacet = {
  __typename?: 'SpotlightDataContainerBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SpotlightDataContainerBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SpotlightDataContainerBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SpotlightDataContainerBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SpotlightDataContainerBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type SpotlightDataContainerBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type SpotlightDataContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CTALink?: InputMaybe<SpotlightDataContainerBlockLinkBlockOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DataBlocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SpotlightDataContainerBlockOutput = {
  __typename?: 'SpotlightDataContainerBlockOutput';
  autocomplete?: Maybe<SpotlightDataContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SpotlightDataContainerBlockFacet>;
  item?: Maybe<SpotlightDataContainerBlock>;
  items?: Maybe<Array<Maybe<SpotlightDataContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SpotlightDataContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpotlightDataContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CTALink?: InputMaybe<SpotlightDataContainerBlockLinkBlockWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DataBlocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Description?: InputMaybe<StringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SpotlightDataContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SpotlightDataContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SpotlightDataContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for a store card */
export type StoreCardPage = IContent & IData & {
  __typename?: 'StoreCardPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentCategory?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  Image?: Maybe<StoreCardPageImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<StoreCardPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  StoreUrl?: Maybe<StoreCardPageLinkBlock>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<StoreCardPageImageBlock>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for a store card */
export type StoreCardPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a store card */
export type StoreCardPageContentCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a store card */
export type StoreCardPageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a store card */
export type StoreCardPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a store card */
export type StoreCardPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a store card */
export type StoreCardPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a store card */
export type StoreCardPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a store card */
export type StoreCardPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a store card */
export type StoreCardPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a store card */
export type StoreCardPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type StoreCardPageAutocomplete = {
  __typename?: 'StoreCardPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Image?: Maybe<StoreCardPageImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<StoreCardPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  StoreUrl?: Maybe<StoreCardPageLinkBlockAutocomplete>;
  ThumbnailImage?: Maybe<StoreCardPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type StoreCardPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreCardPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreCardPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreCardPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreCardPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreCardPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreCardPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreCardPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreCardPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreCardPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StoreCardPageFacet = {
  __typename?: 'StoreCardPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  Image?: Maybe<StoreCardPageImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<StoreCardPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StoreUrl?: Maybe<StoreCardPageLinkBlockFacet>;
  ThumbnailImage?: Maybe<StoreCardPageImageBlockFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type StoreCardPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StoreCardPageFacetContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StoreCardPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StoreCardPageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StoreCardPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StoreCardPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StoreCardPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StoreCardPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type StoreCardPageImageBlock = {
  __typename?: 'StoreCardPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type StoreCardPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreCardPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreCardPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreCardPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreCardPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type StoreCardPageImageBlockAutocomplete = {
  __typename?: 'StoreCardPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type StoreCardPageImageBlockFacet = {
  __typename?: 'StoreCardPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type StoreCardPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StoreCardPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StoreCardPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type StoreCardPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type StoreCardPageLinkBlock = {
  __typename?: 'StoreCardPageLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type StoreCardPageLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreCardPageLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreCardPageLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreCardPageLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreCardPageLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreCardPageLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreCardPageLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type StoreCardPageLinkBlockAutocomplete = {
  __typename?: 'StoreCardPageLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type StoreCardPageLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StoreCardPageLinkBlockFacet = {
  __typename?: 'StoreCardPageLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type StoreCardPageLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StoreCardPageLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreCardPageLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StoreCardPageLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type StoreCardPageLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type StoreCardPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentCategory?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  Image?: InputMaybe<StoreCardPageImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<StoreCardPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  StoreUrl?: InputMaybe<StoreCardPageLinkBlockOrderByInput>;
  ThumbnailImage?: InputMaybe<StoreCardPageImageBlockOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type StoreCardPageOutput = {
  __typename?: 'StoreCardPageOutput';
  autocomplete?: Maybe<StoreCardPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<StoreCardPageFacet>;
  item?: Maybe<StoreCardPage>;
  items?: Maybe<Array<Maybe<StoreCardPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type StoreCardPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StoreCardPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentCategory?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  Image?: InputMaybe<StoreCardPageImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<StoreCardPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  StoreUrl?: InputMaybe<StoreCardPageLinkBlockWhereInput>;
  ThumbnailImage?: InputMaybe<StoreCardPageImageBlockWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<StoreCardPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<StoreCardPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<StoreCardPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type StringFacet = {
  __typename?: 'StringFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StringFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `ends_with` retrieves matches that end with a certain value (suffix). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** enables supporting fuzzy matching on the query terms (keywords), which returns items that contain terms in the content similar to the keywords, as measured by a _Levenshtein edit distance_. An edit distance is the number of one-character changes needed to turn one term into another. The edit distance is based on the length of the term.  */
  fuzzy?: InputMaybe<Scalars['Boolean']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `like` matches on substrings with wildcard support: `%` to match on 0 or more characters, `_` to match on any character.  */
  like?: InputMaybe<Scalars['String']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `starts_with` retrieves matches that start with a certain value (prefix). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** expands query value with synonyms. Example: if `H2O` is a synonym of `water`, then querying for `water` will also return results with `H2O`. */
  synonyms?: InputMaybe<Array<InputMaybe<SynonymSlot>>>;
};

export type SubmitButtonElementBlock = IContent & IData & {
  __typename?: 'SubmitButtonElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FinalizeForm?: Maybe<Scalars['Bool']['output']>;
  Image?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RedirectToPage?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type SubmitButtonElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SubmitButtonElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SubmitButtonElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SubmitButtonElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SubmitButtonElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SubmitButtonElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SubmitButtonElementBlockAutocomplete = {
  __typename?: 'SubmitButtonElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RedirectToPage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SubmitButtonElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteImageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteRedirectToPageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockFacet = {
  __typename?: 'SubmitButtonElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FinalizeForm?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RedirectToPage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SubmitButtonElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SubmitButtonElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SubmitButtonElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SubmitButtonElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetFinalizeFormArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetImageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetRedirectToPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SubmitButtonElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SubmitButtonElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SubmitButtonElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SubmitButtonElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FinalizeForm?: InputMaybe<OrderBy>;
  Image?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RedirectToPage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SubmitButtonElementBlockOutput = {
  __typename?: 'SubmitButtonElementBlockOutput';
  autocomplete?: Maybe<SubmitButtonElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SubmitButtonElementBlockFacet>;
  item?: Maybe<SubmitButtonElementBlock>;
  items?: Maybe<Array<Maybe<SubmitButtonElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SubmitButtonElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitButtonElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FinalizeForm?: InputMaybe<BoolFilterInput>;
  Image?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RedirectToPage?: InputMaybe<StringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SubmitButtonElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SubmitButtonElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SubmitButtonElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The Success step of the Company Admin page */
export type SuccessSectionBlock = IContent & IData & {
  __typename?: 'SuccessSectionBlock';
  AMPSubmittedText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EEPSubmittedText?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HealthPoliciesSubmittedText?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NewIDRequestSubmittedText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PersonUpdatesSubmittedText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WireTransferSubmittedText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The Success step of the Company Admin page */
export type SuccessSectionBlockAmpSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Success step of the Company Admin page */
export type SuccessSectionBlockEepSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Success step of the Company Admin page */
export type SuccessSectionBlockHealthPoliciesSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Success step of the Company Admin page */
export type SuccessSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Success step of the Company Admin page */
export type SuccessSectionBlockNewIdRequestSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Success step of the Company Admin page */
export type SuccessSectionBlockPersonUpdatesSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Success step of the Company Admin page */
export type SuccessSectionBlockWireTransferSubmittedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Success step of the Company Admin page */
export type SuccessSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The Success step of the Company Admin page */
export type SuccessSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SuccessSectionBlockAutocomplete = {
  __typename?: 'SuccessSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SuccessSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SuccessSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SuccessSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SuccessSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SuccessSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SuccessSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SuccessSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SuccessSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SuccessSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SuccessSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SuccessSectionBlockFacet = {
  __typename?: 'SuccessSectionBlockFacet';
  AMPSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EEPSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HealthPoliciesSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NewIDRequestSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonUpdatesSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WireTransferSubmittedText?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SuccessSectionBlockFacetAmpSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SuccessSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SuccessSectionBlockFacetEepSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetHealthPoliciesSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SuccessSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetNewIdRequestSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetPersonUpdatesSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SuccessSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SuccessSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SuccessSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacetWireTransferSubmittedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SuccessSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SuccessSectionBlockOrderByInput = {
  AMPSubmittedText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EEPSubmittedText?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HealthPoliciesSubmittedText?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NewIDRequestSubmittedText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonUpdatesSubmittedText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WireTransferSubmittedText?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SuccessSectionBlockOutput = {
  __typename?: 'SuccessSectionBlockOutput';
  autocomplete?: Maybe<SuccessSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SuccessSectionBlockFacet>;
  item?: Maybe<SuccessSectionBlock>;
  items?: Maybe<Array<Maybe<SuccessSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SuccessSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuccessSectionBlockWhereInput = {
  AMPSubmittedText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EEPSubmittedText?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HealthPoliciesSubmittedText?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NewIDRequestSubmittedText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonUpdatesSubmittedText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WireTransferSubmittedText?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SuccessSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SuccessSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SuccessSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SvgLinkBlock = IContent & IData & {
  __typename?: 'SvgLinkBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** The text displayed when the link is rendered */
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Select the icon to use for the brand icon */
  IconClass?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  /** When checked,The link file will be downloaded */
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Determines how the link opens */
  Target?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type SvgLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgLinkBlockIconClassArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgLinkBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgLinkBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgLinkBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SvgLinkBlockAutocomplete = {
  __typename?: 'SvgLinkBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SvgLinkBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgLinkBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgLinkBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgLinkBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgLinkBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgLinkBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgLinkBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgLinkBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgLinkBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgLinkBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SvgLinkBlockFacet = {
  __typename?: 'SvgLinkBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IconClass?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SvgLinkBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgLinkBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetIconClassArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SvgLinkBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgLinkBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgLinkBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgLinkBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SvgLinkBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IconClass?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkToContent?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SvgLinkBlockOutput = {
  __typename?: 'SvgLinkBlockOutput';
  autocomplete?: Maybe<SvgLinkBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SvgLinkBlockFacet>;
  item?: Maybe<SvgLinkBlock>;
  items?: Maybe<Array<Maybe<SvgLinkBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SvgLinkBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SvgLinkBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IconClass?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SvgLinkBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SvgLinkBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SvgLinkBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SvgMedia = IContent & IData & {
  __typename?: 'SvgMedia';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type SvgMediaContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgMediaNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgMedia_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgMedia_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SvgMediaAutocomplete = {
  __typename?: 'SvgMediaAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SvgMediaAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgMediaAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgMediaAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgMediaAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgMediaAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgMediaAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgMediaAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgMediaAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgMediaAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgMediaAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgMediaAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SvgMediaFacet = {
  __typename?: 'SvgMediaFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SvgMediaFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgMediaFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgMediaFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgMediaFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgMediaFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgMediaFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgMediaFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SvgMediaOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SvgMediaOutput = {
  __typename?: 'SvgMediaOutput';
  autocomplete?: Maybe<SvgMediaAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SvgMediaFacet>;
  item?: Maybe<SvgMedia>;
  items?: Maybe<Array<Maybe<SvgMedia>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SvgMediaOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SvgMediaWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SvgMediaWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SvgMediaWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SvgMediaWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This is a svg text card block */
export type SvgTextCardBlock = IContent & IData & {
  __typename?: 'SvgTextCardBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  /** Select the icon to use for the brand icon */
  IconClass?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkBlock?: Maybe<SvgTextCardBlockLinkBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a svg text card block */
export type SvgTextCardBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a svg text card block */
export type SvgTextCardBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a svg text card block */
export type SvgTextCardBlockIconClassArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a svg text card block */
export type SvgTextCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a svg text card block */
export type SvgTextCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a svg text card block */
export type SvgTextCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SvgTextCardBlockAutocomplete = {
  __typename?: 'SvgTextCardBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkBlock?: Maybe<SvgTextCardBlockLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SvgTextCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgTextCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgTextCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgTextCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgTextCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgTextCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgTextCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgTextCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgTextCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SvgTextCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SvgTextCardBlockFacet = {
  __typename?: 'SvgTextCardBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IconClass?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkBlock?: Maybe<SvgTextCardBlockLinkBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type SvgTextCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgTextCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgTextCardBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetIconClassArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SvgTextCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgTextCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgTextCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SvgTextCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type SvgTextCardBlockLinkBlock = {
  __typename?: 'SvgTextCardBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type SvgTextCardBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgTextCardBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgTextCardBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgTextCardBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgTextCardBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgTextCardBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SvgTextCardBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type SvgTextCardBlockLinkBlockAutocomplete = {
  __typename?: 'SvgTextCardBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SvgTextCardBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SvgTextCardBlockLinkBlockFacet = {
  __typename?: 'SvgTextCardBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SvgTextCardBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SvgTextCardBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SvgTextCardBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SvgTextCardBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type SvgTextCardBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type SvgTextCardBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IconClass?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkBlock?: InputMaybe<SvgTextCardBlockLinkBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type SvgTextCardBlockOutput = {
  __typename?: 'SvgTextCardBlockOutput';
  autocomplete?: Maybe<SvgTextCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SvgTextCardBlockFacet>;
  item?: Maybe<SvgTextCardBlock>;
  items?: Maybe<Array<Maybe<SvgTextCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SvgTextCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SvgTextCardBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IconClass?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkBlock?: InputMaybe<SvgTextCardBlockLinkBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SvgTextCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SvgTextCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SvgTextCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum SynonymSlot {
  /** synonym slot 1 */
  One = 'ONE',
  /** synonym slot 2 */
  Two = 'TWO'
}

/** A block that lets you tab between content */
export type TabContainerBlock = IContent & IData & {
  __typename?: 'TabContainerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Tabs?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block that lets you tab between content */
export type TabContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block that lets you tab between content */
export type TabContainerBlockTabsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block that lets you tab between content */
export type TabContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block that lets you tab between content */
export type TabContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TabContainerBlockAutocomplete = {
  __typename?: 'TabContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TabContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabContainerBlockFacet = {
  __typename?: 'TabContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Tabs?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TabContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TabContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TabContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Tabs?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TabContainerBlockOutput = {
  __typename?: 'TabContainerBlockOutput';
  autocomplete?: Maybe<TabContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TabContainerBlockFacet>;
  item?: Maybe<TabContainerBlock>;
  items?: Maybe<Array<Maybe<TabContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TabContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Tabs?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TabContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TabContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TabContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A child block that lets you tab between content */
export type TabItemBlock = IContent & IData & {
  __typename?: 'TabItemBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedFeaturedPeople?: Maybe<Array<Maybe<FeaturedPeopleEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A child block that lets you tab between content */
export type TabItemBlockMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A child block that lets you tab between content */
export type TabItemBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A child block that lets you tab between content */
export type TabItemBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A child block that lets you tab between content */
export type TabItemBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TabItemBlockAutocomplete = {
  __typename?: 'TabItemBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TabItemBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemBlockFacet = {
  __typename?: 'TabItemBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedFeaturedPeople?: Maybe<FeaturedPeopleEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TabItemBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabItemBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabItemBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TabItemBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabItemBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabItemBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabItemBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TabItemBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TabItemBlockOutput = {
  __typename?: 'TabItemBlockOutput';
  autocomplete?: Maybe<TabItemBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TabItemBlockFacet>;
  item?: Maybe<TabItemBlock>;
  items?: Maybe<Array<Maybe<TabItemBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TabItemBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabItemBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedFeaturedPeople?: InputMaybe<FeaturedPeopleEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TabItemBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TabItemBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TabItemBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Renders some text and a link */
export type TextCardBlock = IContent & IData & {
  __typename?: 'TextCardBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkBlock?: Maybe<TextCardBlockLinkBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  /** Show Border of the Card */
  ShowBorder?: Maybe<Scalars['Bool']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TextContent?: Maybe<TextCardBlockTextContentBlock>;
  /** Determines the color scheme */
  Theme?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Renders some text and a link */
export type TextCardBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders some text and a link */
export type TextCardBlockThemeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders some text and a link */
export type TextCardBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders some text and a link */
export type TextCardBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TextCardBlockAutocomplete = {
  __typename?: 'TextCardBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkBlock?: Maybe<TextCardBlockLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TextCardBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextCardBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextCardBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextCardBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextCardBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextCardBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextCardBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextCardBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextCardBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextCardBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextCardBlockFacet = {
  __typename?: 'TextCardBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkBlock?: Maybe<TextCardBlockLinkBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowBorder?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TextContent?: Maybe<TextCardBlockTextContentBlockFacet>;
  Theme?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TextCardBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextCardBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextCardBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TextCardBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextCardBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetShowBorderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextCardBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextCardBlockFacetThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TextCardBlockLinkBlock = {
  __typename?: 'TextCardBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type TextCardBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextCardBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextCardBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextCardBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextCardBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextCardBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextCardBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextCardBlockLinkBlockAutocomplete = {
  __typename?: 'TextCardBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TextCardBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextCardBlockLinkBlockFacet = {
  __typename?: 'TextCardBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TextCardBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TextCardBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextCardBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type TextCardBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type TextCardBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkBlock?: InputMaybe<TextCardBlockLinkBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowBorder?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TextContent?: InputMaybe<TextCardBlockTextContentBlockOrderByInput>;
  Theme?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TextCardBlockOutput = {
  __typename?: 'TextCardBlockOutput';
  autocomplete?: Maybe<TextCardBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TextCardBlockFacet>;
  item?: Maybe<TextCardBlock>;
  items?: Maybe<Array<Maybe<TextCardBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TextCardBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextCardBlockTextContentBlock = {
  __typename?: 'TextCardBlockTextContentBlock';
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
};


export type TextCardBlockTextContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextCardBlockTextContentBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextCardBlockTextContentBlockPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextCardBlockTextContentBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextCardBlockTextContentBlockFacet = {
  __typename?: 'TextCardBlockTextContentBlockFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TextCardBlockTextContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockTextContentBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockTextContentBlockFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextCardBlockTextContentBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextCardBlockTextContentBlockOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  PreHeading?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
};

export type TextCardBlockTextContentBlockWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type TextCardBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkBlock?: InputMaybe<TextCardBlockLinkBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowBorder?: InputMaybe<BoolFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TextContent?: InputMaybe<TextCardBlockTextContentBlockWhereInput>;
  Theme?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TextCardBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TextCardBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TextCardBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A block meant to be used as a reusable field that collects various text content */
export type TextContentBlock = IContent & IData & {
  __typename?: 'TextContentBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubHeading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type TextContentBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type TextContentBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type TextContentBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type TextContentBlockPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type TextContentBlockSubHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type TextContentBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A block meant to be used as a reusable field that collects various text content */
export type TextContentBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TextContentBlockAutocomplete = {
  __typename?: 'TextContentBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TextContentBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextContentBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextContentBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextContentBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextContentBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextContentBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextContentBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextContentBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextContentBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextContentBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextContentBlockFacet = {
  __typename?: 'TextContentBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TextContentBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextContentBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextContentBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextContentBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextContentBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextContentBlockFacetSubHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextContentBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TextContentBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreHeading?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubHeading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TextContentBlockOutput = {
  __typename?: 'TextContentBlockOutput';
  autocomplete?: Maybe<TextContentBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TextContentBlockFacet>;
  item?: Maybe<TextContentBlock>;
  items?: Maybe<Array<Maybe<TextContentBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TextContentBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextContentBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubHeading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TextContentBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TextContentBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TextContentBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type TextareaElementBlock = IContent & IData & {
  __typename?: 'TextareaElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type TextareaElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TextareaElementBlockAutocomplete = {
  __typename?: 'TextareaElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TextareaElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockFacet = {
  __typename?: 'TextareaElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TextareaElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TextareaElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextareaElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TextareaElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextareaElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextareaElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextareaElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextareaElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TextareaElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TextareaElementBlockOutput = {
  __typename?: 'TextareaElementBlockOutput';
  autocomplete?: Maybe<TextareaElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TextareaElementBlockFacet>;
  item?: Maybe<TextareaElementBlock>;
  items?: Maybe<Array<Maybe<TextareaElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TextareaElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextareaElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TextareaElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TextareaElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TextareaElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type TextboxElementBlock = IContent & IData & {
  __typename?: 'TextboxElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type TextboxElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TextboxElementBlockAutocomplete = {
  __typename?: 'TextboxElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TextboxElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockFacet = {
  __typename?: 'TextboxElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TextboxElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TextboxElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextboxElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TextboxElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextboxElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextboxElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextboxElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextboxElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TextboxElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TextboxElementBlockOutput = {
  __typename?: 'TextboxElementBlockOutput';
  autocomplete?: Maybe<TextboxElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TextboxElementBlockFacet>;
  item?: Maybe<TextboxElementBlock>;
  items?: Maybe<Array<Maybe<TextboxElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TextboxElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextboxElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TextboxElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TextboxElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TextboxElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Renders a list of items on a timeline */
export type TimelineContainerBlock = IContent & IData & {
  __typename?: 'TimelineContainerBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Text content for the footer */
  Footer?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TimelineItems?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Url?: Maybe<Scalars['String']['output']>;
  ViewMoreButtonLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Renders a list of items on a timeline */
export type TimelineContainerBlockFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a list of items on a timeline */
export type TimelineContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a list of items on a timeline */
export type TimelineContainerBlockTimelineItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a list of items on a timeline */
export type TimelineContainerBlockViewMoreButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a list of items on a timeline */
export type TimelineContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Renders a list of items on a timeline */
export type TimelineContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TimelineContainerBlockAutocomplete = {
  __typename?: 'TimelineContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TimelineContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineContainerBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TimelineContainerBlockFacet = {
  __typename?: 'TimelineContainerBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Footer?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TimelineItems?: Maybe<ContentAreaItemModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ViewMoreButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TimelineContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TimelineContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TimelineContainerBlockFacetFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TimelineContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TimelineContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TimelineContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TimelineContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacetViewMoreButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineContainerBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TimelineContainerBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Footer?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TimelineItems?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  ViewMoreButtonLabel?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TimelineContainerBlockOutput = {
  __typename?: 'TimelineContainerBlockOutput';
  autocomplete?: Maybe<TimelineContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TimelineContainerBlockFacet>;
  item?: Maybe<TimelineContainerBlock>;
  items?: Maybe<Array<Maybe<TimelineContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TimelineContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimelineContainerBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Footer?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TimelineItems?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  ViewMoreButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TimelineContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TimelineContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TimelineContainerBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** An item used in the Timeline Container Block */
export type TimelineItemBlock = IContent & IData & {
  __typename?: 'TimelineItemBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Date?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Image?: Maybe<TimelineItemBlockImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** An item used in the Timeline Container Block */
export type TimelineItemBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An item used in the Timeline Container Block */
export type TimelineItemBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An item used in the Timeline Container Block */
export type TimelineItemBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An item used in the Timeline Container Block */
export type TimelineItemBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TimelineItemBlockAutocomplete = {
  __typename?: 'TimelineItemBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<TimelineItemBlockImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TimelineItemBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineItemBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineItemBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineItemBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineItemBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineItemBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineItemBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineItemBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineItemBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TimelineItemBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TimelineItemBlockFacet = {
  __typename?: 'TimelineItemBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Date?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Image?: Maybe<TimelineItemBlockImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TimelineItemBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TimelineItemBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TimelineItemBlockFacetDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TimelineItemBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TimelineItemBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TimelineItemBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TimelineItemBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TimelineItemBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TimelineItemBlockImageBlock = {
  __typename?: 'TimelineItemBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type TimelineItemBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TimelineItemBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TimelineItemBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TimelineItemBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TimelineItemBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TimelineItemBlockImageBlockAutocomplete = {
  __typename?: 'TimelineItemBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type TimelineItemBlockImageBlockFacet = {
  __typename?: 'TimelineItemBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TimelineItemBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TimelineItemBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TimelineItemBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TimelineItemBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type TimelineItemBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type TimelineItemBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Date?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Image?: InputMaybe<TimelineItemBlockImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TimelineItemBlockOutput = {
  __typename?: 'TimelineItemBlockOutput';
  autocomplete?: Maybe<TimelineItemBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TimelineItemBlockFacet>;
  item?: Maybe<TimelineItemBlock>;
  items?: Maybe<Array<Maybe<TimelineItemBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TimelineItemBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimelineItemBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Date?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Image?: InputMaybe<TimelineItemBlockImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TimelineItemBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TimelineItemBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TimelineItemBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ToolkitBlock = IContent & IData & {
  __typename?: 'ToolkitBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  CareerStage?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Country?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FoundationDonorLevel?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LearnResourceTopic?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MeetingId?: Maybe<Scalars['String']['output']>;
  MeetingRegistrationStatus?: Maybe<Scalars['String']['output']>;
  MemberType?: Maybe<Scalars['String']['output']>;
  MembershipLevel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Tabs?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Title?: Maybe<Scalars['String']['output']>;
  TotalMemberYearsCountFrom?: Maybe<Scalars['Int']['output']>;
  TotalMemberYearsCountTo?: Maybe<Scalars['Int']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ToolkitBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockCareerStageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockFoundationDonorLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockLearnResourceTopicArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockMeetingIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockMeetingRegistrationStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockMemberTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockTabsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ToolkitBlockAutocomplete = {
  __typename?: 'ToolkitBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ToolkitBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ToolkitBlockFacet = {
  __typename?: 'ToolkitBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  CareerStage?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FoundationDonorLevel?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LearnResourceTopic?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MeetingId?: Maybe<Array<Maybe<StringFacet>>>;
  MeetingRegistrationStatus?: Maybe<Array<Maybe<StringFacet>>>;
  MemberType?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Tabs?: Maybe<ContentAreaItemModelSearchFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TotalMemberYearsCountFrom?: Maybe<Array<Maybe<NumberFacet>>>;
  TotalMemberYearsCountTo?: Maybe<Array<Maybe<NumberFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ToolkitBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetCareerStageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetFoundationDonorLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ToolkitBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetLearnResourceTopicArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetMeetingIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetMeetingRegistrationStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetMemberTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetMembershipLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacetTotalMemberYearsCountFromArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ToolkitBlockFacetTotalMemberYearsCountToArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ToolkitBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ToolkitBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  CareerStage?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FoundationDonorLevel?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LearnResourceTopic?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MeetingId?: InputMaybe<OrderBy>;
  MeetingRegistrationStatus?: InputMaybe<OrderBy>;
  MemberType?: InputMaybe<OrderBy>;
  MembershipLevel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Tabs?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  TotalMemberYearsCountFrom?: InputMaybe<OrderBy>;
  TotalMemberYearsCountTo?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ToolkitBlockOutput = {
  __typename?: 'ToolkitBlockOutput';
  autocomplete?: Maybe<ToolkitBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ToolkitBlockFacet>;
  item?: Maybe<ToolkitBlock>;
  items?: Maybe<Array<Maybe<ToolkitBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ToolkitBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ToolkitBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  CareerStage?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FoundationDonorLevel?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LearnResourceTopic?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MeetingId?: InputMaybe<SearchableStringFilterInput>;
  MeetingRegistrationStatus?: InputMaybe<SearchableStringFilterInput>;
  MemberType?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Tabs?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TotalMemberYearsCountFrom?: InputMaybe<IntFilterInput>;
  TotalMemberYearsCountTo?: InputMaybe<IntFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ToolkitBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ToolkitBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ToolkitBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ToolkitItemBlock = IContent & IData & {
  __typename?: 'ToolkitItemBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  Layout?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Sections?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ToolkitItemBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitItemBlockLayoutArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitItemBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitItemBlockSectionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitItemBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitItemBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitItemBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ToolkitItemBlockAutocomplete = {
  __typename?: 'ToolkitItemBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ToolkitItemBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitItemBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitItemBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitItemBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitItemBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitItemBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitItemBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitItemBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitItemBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitItemBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ToolkitItemBlockFacet = {
  __typename?: 'ToolkitItemBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Layout?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Sections?: Maybe<ContentAreaItemModelSearchFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ToolkitItemBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitItemBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitItemBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ToolkitItemBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetLayoutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitItemBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitItemBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitItemBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitItemBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ToolkitItemBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Layout?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Sections?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ToolkitItemBlockOutput = {
  __typename?: 'ToolkitItemBlockOutput';
  autocomplete?: Maybe<ToolkitItemBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ToolkitItemBlockFacet>;
  item?: Maybe<ToolkitItemBlock>;
  items?: Maybe<Array<Maybe<ToolkitItemBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ToolkitItemBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ToolkitItemBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Layout?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Sections?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ToolkitItemBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ToolkitItemBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ToolkitItemBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type ToolkitSectionBlock = IContent & IData & {
  __typename?: 'ToolkitSectionBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CareerStage?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Country?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FoundationDonorLevel?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Items?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Language?: Maybe<ContentLanguageModel>;
  LearnResourceTopic?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MeetingId?: Maybe<Scalars['String']['output']>;
  MeetingRegistrationStatus?: Maybe<Scalars['String']['output']>;
  MemberType?: Maybe<Scalars['String']['output']>;
  MembershipLevel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TotalMemberYearsCountFrom?: Maybe<Scalars['Int']['output']>;
  TotalMemberYearsCountTo?: Maybe<Scalars['Int']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type ToolkitSectionBlockCareerStageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlockFoundationDonorLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlockItemsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlockLearnResourceTopicArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlockMeetingIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlockMeetingRegistrationStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlockMemberTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlockMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolkitSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ToolkitSectionBlockAutocomplete = {
  __typename?: 'ToolkitSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ToolkitSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolkitSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ToolkitSectionBlockFacet = {
  __typename?: 'ToolkitSectionBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CareerStage?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FoundationDonorLevel?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<ContentAreaItemModelSearchFacet>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LearnResourceTopic?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MeetingId?: Maybe<Array<Maybe<StringFacet>>>;
  MeetingRegistrationStatus?: Maybe<Array<Maybe<StringFacet>>>;
  MemberType?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TotalMemberYearsCountFrom?: Maybe<Array<Maybe<NumberFacet>>>;
  TotalMemberYearsCountTo?: Maybe<Array<Maybe<NumberFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ToolkitSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetCareerStageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitSectionBlockFacetFoundationDonorLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ToolkitSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetLearnResourceTopicArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetMeetingIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetMeetingRegistrationStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetMemberTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetMembershipLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolkitSectionBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacetTotalMemberYearsCountFromArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ToolkitSectionBlockFacetTotalMemberYearsCountToArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ToolkitSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolkitSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ToolkitSectionBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CareerStage?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FoundationDonorLevel?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Items?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LearnResourceTopic?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MeetingId?: InputMaybe<OrderBy>;
  MeetingRegistrationStatus?: InputMaybe<OrderBy>;
  MemberType?: InputMaybe<OrderBy>;
  MembershipLevel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TotalMemberYearsCountFrom?: InputMaybe<OrderBy>;
  TotalMemberYearsCountTo?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ToolkitSectionBlockOutput = {
  __typename?: 'ToolkitSectionBlockOutput';
  autocomplete?: Maybe<ToolkitSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ToolkitSectionBlockFacet>;
  item?: Maybe<ToolkitSectionBlock>;
  items?: Maybe<Array<Maybe<ToolkitSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ToolkitSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ToolkitSectionBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CareerStage?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FoundationDonorLevel?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LearnResourceTopic?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MeetingId?: InputMaybe<SearchableStringFilterInput>;
  MeetingRegistrationStatus?: InputMaybe<SearchableStringFilterInput>;
  MemberType?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TotalMemberYearsCountFrom?: InputMaybe<IntFilterInput>;
  TotalMemberYearsCountTo?: InputMaybe<IntFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ToolkitSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ToolkitSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ToolkitSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The page containing content for a tools card */
export type ToolsCardPage = IContent & IData & {
  __typename?: 'ToolsCardPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  CardUrl?: Maybe<ToolsCardPageLinkBlock>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentCategory?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  Image?: Maybe<ToolsCardPageImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<ToolsCardPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<ToolsCardPageImageBlock>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** The page containing content for a tools card */
export type ToolsCardPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a tools card */
export type ToolsCardPageContentCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a tools card */
export type ToolsCardPageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a tools card */
export type ToolsCardPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a tools card */
export type ToolsCardPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a tools card */
export type ToolsCardPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a tools card */
export type ToolsCardPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a tools card */
export type ToolsCardPageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a tools card */
export type ToolsCardPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The page containing content for a tools card */
export type ToolsCardPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ToolsCardPageAutocomplete = {
  __typename?: 'ToolsCardPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  CardUrl?: Maybe<ToolsCardPageLinkBlockAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Image?: Maybe<ToolsCardPageImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<ToolsCardPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<ToolsCardPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ToolsCardPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolsCardPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolsCardPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolsCardPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolsCardPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolsCardPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolsCardPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolsCardPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolsCardPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ToolsCardPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ToolsCardPageFacet = {
  __typename?: 'ToolsCardPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  CardUrl?: Maybe<ToolsCardPageLinkBlockFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentCategory?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  Image?: Maybe<ToolsCardPageImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<ToolsCardPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<ToolsCardPageImageBlockFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ToolsCardPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolsCardPageFacetContentCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ToolsCardPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolsCardPageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ToolsCardPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolsCardPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolsCardPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolsCardPageFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ToolsCardPageImageBlock = {
  __typename?: 'ToolsCardPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type ToolsCardPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolsCardPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolsCardPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolsCardPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolsCardPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ToolsCardPageImageBlockAutocomplete = {
  __typename?: 'ToolsCardPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ToolsCardPageImageBlockFacet = {
  __typename?: 'ToolsCardPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ToolsCardPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ToolsCardPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ToolsCardPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type ToolsCardPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type ToolsCardPageLinkBlock = {
  __typename?: 'ToolsCardPageLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type ToolsCardPageLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolsCardPageLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolsCardPageLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolsCardPageLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolsCardPageLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolsCardPageLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ToolsCardPageLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ToolsCardPageLinkBlockAutocomplete = {
  __typename?: 'ToolsCardPageLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ToolsCardPageLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ToolsCardPageLinkBlockFacet = {
  __typename?: 'ToolsCardPageLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ToolsCardPageLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ToolsCardPageLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ToolsCardPageLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ToolsCardPageLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type ToolsCardPageLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type ToolsCardPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  CardUrl?: InputMaybe<ToolsCardPageLinkBlockOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentCategory?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  Image?: InputMaybe<ToolsCardPageImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<ToolsCardPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<ToolsCardPageImageBlockOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ToolsCardPageOutput = {
  __typename?: 'ToolsCardPageOutput';
  autocomplete?: Maybe<ToolsCardPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ToolsCardPageFacet>;
  item?: Maybe<ToolsCardPage>;
  items?: Maybe<Array<Maybe<ToolsCardPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ToolsCardPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ToolsCardPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  CardUrl?: InputMaybe<ToolsCardPageLinkBlockWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentCategory?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  Image?: InputMaybe<ToolsCardPageImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<ToolsCardPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<ToolsCardPageImageBlockWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ToolsCardPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ToolsCardPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ToolsCardPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type TooltipBlock = IContent & IData & {
  __typename?: 'TooltipBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type TooltipBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TooltipBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TooltipBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TooltipBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TooltipBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TooltipBlockAutocomplete = {
  __typename?: 'TooltipBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TooltipBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TooltipBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TooltipBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TooltipBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TooltipBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TooltipBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TooltipBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TooltipBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TooltipBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TooltipBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TooltipBlockFacet = {
  __typename?: 'TooltipBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TooltipBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TooltipBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TooltipBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TooltipBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TooltipBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TooltipBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TooltipBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TooltipBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TooltipBlockOutput = {
  __typename?: 'TooltipBlockOutput';
  autocomplete?: Maybe<TooltipBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TooltipBlockFacet>;
  item?: Maybe<TooltipBlock>;
  items?: Maybe<Array<Maybe<TooltipBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TooltipBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TooltipBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TooltipBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TooltipBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TooltipBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type TopicsEntry = {
  __typename?: 'TopicsEntry';
  Id?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['Int']['output']>;
};

export type TopicsEntryAutocomplete = {
  __typename?: 'TopicsEntryAutocomplete';
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TopicsEntryAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TopicsEntryFacet = {
  __typename?: 'TopicsEntryFacet';
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TopicsEntryFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TopicsEntryFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopicsEntryFacetParentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TopicsEntryOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentId?: InputMaybe<OrderBy>;
};

export type TopicsEntryWhereInput = {
  Id?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  ParentId?: InputMaybe<IntFilterInput>;
};

export type UrlElementBlock = IContent & IData & {
  __typename?: 'UrlElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type UrlElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type UrlElementBlockAutocomplete = {
  __typename?: 'UrlElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type UrlElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockFacet = {
  __typename?: 'UrlElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type UrlElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type UrlElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type UrlElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type UrlElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type UrlElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type UrlElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type UrlElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type UrlElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type UrlElementBlockOutput = {
  __typename?: 'UrlElementBlockOutput';
  autocomplete?: Maybe<UrlElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<UrlElementBlockFacet>;
  item?: Maybe<UrlElementBlock>;
  items?: Maybe<Array<Maybe<UrlElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type UrlElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UrlElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<UrlElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<UrlElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<UrlElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Video = IContent & IData & {
  __typename?: 'Video';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssetId?: Maybe<Scalars['Int']['output']>;
  AssetSize?: Maybe<Scalars['String']['output']>;
  AssetType?: Maybe<Scalars['Int']['output']>;
  AssetTypeName?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  ItemId?: Maybe<Scalars['Int']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MMUrl?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Preview?: Maybe<BlobModel>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  ReplacedWith?: Maybe<Scalars['Int']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  Source?: Maybe<BlobModel>;
  SourceFileExtension?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Title?: Maybe<Scalars['String']['output']>;
  Transcodes?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type VideoContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Video_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Video_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VideoAutocomplete = {
  __typename?: 'VideoAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssetSize?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssetTypeName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MMUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Preview?: Maybe<BlobModelAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Source?: Maybe<BlobModelAutocomplete>;
  SourceFileExtension?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Title?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Transcodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type VideoAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteAssetSizeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteAssetTypeNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteMmUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteSourceFileExtensionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteTranscodesArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

/** Image block used as a property */
export type VideoBlock = IContent & IData & {
  __typename?: 'VideoBlock';
  /** Title for this video when a user is reading the site with a screen reader. */
  AltText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** The video that will be rendered */
  VideoReference?: Maybe<ContentModelReference>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Image block used as a property */
export type VideoBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type VideoBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type VideoBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Image block used as a property */
export type VideoBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VideoBlockAutocomplete = {
  __typename?: 'VideoBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  VideoReference?: Maybe<ContentModelReferenceAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type VideoBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoBlockFacet = {
  __typename?: 'VideoBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VideoReference?: Maybe<ContentModelReferenceFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type VideoBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VideoBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VideoBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VideoReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VideoBlockOutput = {
  __typename?: 'VideoBlockOutput';
  autocomplete?: Maybe<VideoBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VideoBlockFacet>;
  item?: Maybe<VideoBlock>;
  items?: Maybe<Array<Maybe<VideoBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type VideoBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VideoReference?: InputMaybe<ContentModelReferenceWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<VideoBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VideoBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VideoBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** This block renders video details */
export type VideoDetailBlock = IContent & IData & {
  __typename?: 'VideoDetailBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Video?: Maybe<VideoDetailBlockVideoBlock>;
  ViewTranscript?: Maybe<VideoDetailBlockRichTextBlock>;
  ViewTranscriptLine?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This block renders video details */
export type VideoDetailBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders video details */
export type VideoDetailBlockViewTranscriptLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders video details */
export type VideoDetailBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This block renders video details */
export type VideoDetailBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VideoDetailBlockAutocomplete = {
  __typename?: 'VideoDetailBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Video?: Maybe<VideoDetailBlockVideoBlockAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type VideoDetailBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoDetailBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoDetailBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoDetailBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoDetailBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoDetailBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoDetailBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoDetailBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoDetailBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoDetailBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoDetailBlockFacet = {
  __typename?: 'VideoDetailBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Video?: Maybe<VideoDetailBlockVideoBlockFacet>;
  ViewTranscript?: Maybe<VideoDetailBlockRichTextBlockFacet>;
  ViewTranscriptLine?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type VideoDetailBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoDetailBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoDetailBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VideoDetailBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoDetailBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoDetailBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoDetailBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacetViewTranscriptLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VideoDetailBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Video?: InputMaybe<VideoDetailBlockVideoBlockOrderByInput>;
  ViewTranscript?: InputMaybe<VideoDetailBlockRichTextBlockOrderByInput>;
  ViewTranscriptLine?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VideoDetailBlockOutput = {
  __typename?: 'VideoDetailBlockOutput';
  autocomplete?: Maybe<VideoDetailBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VideoDetailBlockFacet>;
  item?: Maybe<VideoDetailBlock>;
  items?: Maybe<Array<Maybe<VideoDetailBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type VideoDetailBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoDetailBlockRichTextBlock = {
  __typename?: 'VideoDetailBlockRichTextBlock';
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type VideoDetailBlockRichTextBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoDetailBlockRichTextBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoDetailBlockRichTextBlockContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoDetailBlockRichTextBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoDetailBlockRichTextBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type VideoDetailBlockRichTextBlockFacet = {
  __typename?: 'VideoDetailBlockRichTextBlockFacet';
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type VideoDetailBlockRichTextBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockRichTextBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockRichTextBlockFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockRichTextBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockRichTextBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VideoDetailBlockRichTextBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoDetailBlockRichTextBlockOrderByInput = {
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type VideoDetailBlockRichTextBlockWhereInput = {
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type VideoDetailBlockVideoBlock = {
  __typename?: 'VideoDetailBlockVideoBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  VideoReference?: Maybe<ContentModelReference>;
};


export type VideoDetailBlockVideoBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type VideoDetailBlockVideoBlockAutocomplete = {
  __typename?: 'VideoDetailBlockVideoBlockAutocomplete';
  VideoReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type VideoDetailBlockVideoBlockFacet = {
  __typename?: 'VideoDetailBlockVideoBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  VideoReference?: Maybe<ContentModelReferenceFacet>;
};


export type VideoDetailBlockVideoBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoDetailBlockVideoBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VideoDetailBlockVideoBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  VideoReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type VideoDetailBlockVideoBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  VideoReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type VideoDetailBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Video?: InputMaybe<VideoDetailBlockVideoBlockWhereInput>;
  ViewTranscript?: InputMaybe<VideoDetailBlockRichTextBlockWhereInput>;
  ViewTranscriptLine?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VideoDetailBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VideoDetailBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VideoDetailBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type VideoFacet = {
  __typename?: 'VideoFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssetId?: Maybe<Array<Maybe<NumberFacet>>>;
  AssetSize?: Maybe<Array<Maybe<StringFacet>>>;
  AssetType?: Maybe<Array<Maybe<NumberFacet>>>;
  AssetTypeName?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  ItemId?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MMUrl?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Preview?: Maybe<BlobModelFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ReplacedWith?: Maybe<Array<Maybe<NumberFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  Source?: Maybe<BlobModelFacet>;
  SourceFileExtension?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Transcodes?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type VideoFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetAssetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VideoFacetAssetSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetAssetTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VideoFacetAssetTypeNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetItemIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VideoFacetMmUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetReplacedWithArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VideoFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetSourceFileExtensionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetTranscodesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VideoMedia = IContent & IData & {
  __typename?: 'VideoMedia';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type VideoMediaContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoMediaNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoMedia_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoMedia_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VideoMediaAutocomplete = {
  __typename?: 'VideoMediaAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type VideoMediaAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoMediaAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoMediaAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoMediaAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoMediaAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoMediaAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoMediaAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoMediaAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoMediaAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoMediaAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoMediaAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoMediaFacet = {
  __typename?: 'VideoMediaFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type VideoMediaFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoMediaFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoMediaFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoMediaFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoMediaFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoMediaFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoMediaFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VideoMediaOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VideoMediaOutput = {
  __typename?: 'VideoMediaOutput';
  autocomplete?: Maybe<VideoMediaAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VideoMediaFacet>;
  item?: Maybe<VideoMedia>;
  items?: Maybe<Array<Maybe<VideoMedia>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type VideoMediaOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoMediaWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VideoMediaWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VideoMediaWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VideoMediaWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type VideoOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AssetId?: InputMaybe<OrderBy>;
  AssetSize?: InputMaybe<OrderBy>;
  AssetType?: InputMaybe<OrderBy>;
  AssetTypeName?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  ItemId?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MMUrl?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Preview?: InputMaybe<BlobModelOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  ReplacedWith?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  Source?: InputMaybe<BlobModelOrderByInput>;
  SourceFileExtension?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Transcodes?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VideoOutput = {
  __typename?: 'VideoOutput';
  autocomplete?: Maybe<VideoAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VideoFacet>;
  item?: Maybe<Video>;
  items?: Maybe<Array<Maybe<Video>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type VideoOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This is a video promo block */
export type VideoPromoBlock = IContent & IData & {
  __typename?: 'VideoPromoBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Button?: Maybe<VideoPromoBlockLinkBlock>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<VideoPromoBlockImageBlock>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkBlock?: Maybe<VideoPromoBlockLinkBlock>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Time?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** This is a video promo block */
export type VideoPromoBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a video promo block */
export type VideoPromoBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a video promo block */
export type VideoPromoBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a video promo block */
export type VideoPromoBlockTimeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a video promo block */
export type VideoPromoBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** This is a video promo block */
export type VideoPromoBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VideoPromoBlockAutocomplete = {
  __typename?: 'VideoPromoBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Button?: Maybe<VideoPromoBlockLinkBlockAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<VideoPromoBlockImageBlockAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkBlock?: Maybe<VideoPromoBlockLinkBlockAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type VideoPromoBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoPromoBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoPromoBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoPromoBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoPromoBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoPromoBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoPromoBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoPromoBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoPromoBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VideoPromoBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoPromoBlockFacet = {
  __typename?: 'VideoPromoBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Button?: Maybe<VideoPromoBlockLinkBlockFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<VideoPromoBlockImageBlockFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkBlock?: Maybe<VideoPromoBlockLinkBlockFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Time?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type VideoPromoBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoPromoBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoPromoBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VideoPromoBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoPromoBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoPromoBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoPromoBlockFacetTimeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VideoPromoBlockImageBlock = {
  __typename?: 'VideoPromoBlockImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type VideoPromoBlockImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoPromoBlockImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoPromoBlockImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoPromoBlockImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoPromoBlockImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type VideoPromoBlockImageBlockAutocomplete = {
  __typename?: 'VideoPromoBlockImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type VideoPromoBlockImageBlockFacet = {
  __typename?: 'VideoPromoBlockImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type VideoPromoBlockImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VideoPromoBlockImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoPromoBlockImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type VideoPromoBlockImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type VideoPromoBlockLinkBlock = {
  __typename?: 'VideoPromoBlockLinkBlock';
  DisplayText?: Maybe<Scalars['String']['output']>;
  DownloadFileName?: Maybe<Scalars['String']['output']>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventLabel?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  LinkStyle?: Maybe<Scalars['String']['output']>;
  LinkToContent?: Maybe<Scalars['String']['output']>;
  ShouldDownload?: Maybe<Scalars['Bool']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};


export type VideoPromoBlockLinkBlockDisplayTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoPromoBlockLinkBlockDownloadFileNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoPromoBlockLinkBlockEventCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoPromoBlockLinkBlockEventLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoPromoBlockLinkBlockEventNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoPromoBlockLinkBlockLinkStyleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VideoPromoBlockLinkBlockTargetArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type VideoPromoBlockLinkBlockAutocomplete = {
  __typename?: 'VideoPromoBlockLinkBlockAutocomplete';
  LinkToContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type VideoPromoBlockLinkBlockAutocompleteLinkToContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VideoPromoBlockLinkBlockFacet = {
  __typename?: 'VideoPromoBlockLinkBlockFacet';
  DisplayText?: Maybe<Array<Maybe<StringFacet>>>;
  DownloadFileName?: Maybe<Array<Maybe<StringFacet>>>;
  EventCategory?: Maybe<Array<Maybe<StringFacet>>>;
  EventLabel?: Maybe<Array<Maybe<StringFacet>>>;
  EventName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  LinkStyle?: Maybe<Array<Maybe<StringFacet>>>;
  LinkToContent?: Maybe<Array<Maybe<StringFacet>>>;
  ShouldDownload?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
};


export type VideoPromoBlockLinkBlockFacetDisplayTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockLinkBlockFacetDownloadFileNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockLinkBlockFacetEventCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockLinkBlockFacetEventLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockLinkBlockFacetEventNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockLinkBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VideoPromoBlockLinkBlockFacetLinkStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockLinkBlockFacetLinkToContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockLinkBlockFacetShouldDownloadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VideoPromoBlockLinkBlockFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VideoPromoBlockLinkBlockOrderByInput = {
  DisplayText?: InputMaybe<OrderBy>;
  DownloadFileName?: InputMaybe<OrderBy>;
  EventCategory?: InputMaybe<OrderBy>;
  EventLabel?: InputMaybe<OrderBy>;
  EventName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  LinkStyle?: InputMaybe<OrderBy>;
  LinkToContent?: InputMaybe<OrderBy>;
  ShouldDownload?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
};

export type VideoPromoBlockLinkBlockWhereInput = {
  DisplayText?: InputMaybe<SearchableStringFilterInput>;
  DownloadFileName?: InputMaybe<SearchableStringFilterInput>;
  EventCategory?: InputMaybe<SearchableStringFilterInput>;
  EventLabel?: InputMaybe<SearchableStringFilterInput>;
  EventName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  LinkStyle?: InputMaybe<SearchableStringFilterInput>;
  LinkToContent?: InputMaybe<StringFilterInput>;
  ShouldDownload?: InputMaybe<BoolFilterInput>;
  Target?: InputMaybe<SearchableStringFilterInput>;
};

export type VideoPromoBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Button?: InputMaybe<VideoPromoBlockLinkBlockOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<VideoPromoBlockImageBlockOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkBlock?: InputMaybe<VideoPromoBlockLinkBlockOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Time?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VideoPromoBlockOutput = {
  __typename?: 'VideoPromoBlockOutput';
  autocomplete?: Maybe<VideoPromoBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VideoPromoBlockFacet>;
  item?: Maybe<VideoPromoBlock>;
  items?: Maybe<Array<Maybe<VideoPromoBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type VideoPromoBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoPromoBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Button?: InputMaybe<VideoPromoBlockLinkBlockWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<VideoPromoBlockImageBlockWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkBlock?: InputMaybe<VideoPromoBlockLinkBlockWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Time?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VideoPromoBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VideoPromoBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VideoPromoBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type VideoWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AssetId?: InputMaybe<IntFilterInput>;
  AssetSize?: InputMaybe<StringFilterInput>;
  AssetType?: InputMaybe<IntFilterInput>;
  AssetTypeName?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<StringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  ItemId?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MMUrl?: InputMaybe<StringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Preview?: InputMaybe<BlobModelWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ReplacedWith?: InputMaybe<IntFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  Source?: InputMaybe<BlobModelWhereInput>;
  SourceFileExtension?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Title?: InputMaybe<StringFilterInput>;
  Transcodes?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VideoWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VideoWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VideoWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Visa Letter */
export type VisaLettersPage = IContent & IData & {
  __typename?: 'VisaLettersPage';
  /** Used for analytics */
  AnalyticsCampaignName?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigned Grouops for page */
  AssignedGroups?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  AssignedGroupsReadAccess?: Maybe<Array<Maybe<AssignedGroupPropertyValue>>>;
  Categories?: Maybe<Array<Maybe<ContentModelReference>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentTypeID?: Maybe<Scalars['Int']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Hides this page from search engine crawlers */
  DisableSearchEngineIndexing?: Maybe<Scalars['Bool']['output']>;
  ExcludeFromSearch?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpandedCategories?: Maybe<Array<Maybe<ExpandedCategoriesEntry>>>;
  ExpandedSources?: Maybe<Array<Maybe<ExpandedSourcesEntry>>>;
  ExpandedTopics?: Maybe<Array<Maybe<ExpandedTopicsEntry>>>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Use a 1.91x1 Ratio image for sharing on Facebook */
  MetaImage?: Maybe<VisaLettersPageImageBlock>;
  /** Enter as a comma separated list, i.e. 'Something, Something Else, Also Something Else */
  MetaKeywordList?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Use a 1x1 Ratio image for carousels / search results */
  ThumbnailImage?: Maybe<VisaLettersPageImageBlock>;
  TitleText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Visa Letter */
export type VisaLettersPageAnalyticsCampaignNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Visa Letter */
export type VisaLettersPageMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Visa Letter */
export type VisaLettersPageMetaKeywordListArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Visa Letter */
export type VisaLettersPageMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Visa Letter */
export type VisaLettersPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Visa Letter */
export type VisaLettersPageTitleTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Visa Letter */
export type VisaLettersPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Visa Letter */
export type VisaLettersPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VisaLettersPageAutocomplete = {
  __typename?: 'VisaLettersPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueAutocomplete>;
  Categories?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryAutocomplete>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryAutocomplete>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MetaImage?: Maybe<VisaLettersPageImageBlockAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ThumbnailImage?: Maybe<VisaLettersPageImageBlockAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type VisaLettersPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisaLettersPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisaLettersPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisaLettersPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisaLettersPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisaLettersPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisaLettersPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisaLettersPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisaLettersPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisaLettersPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisaLettersPageFacet = {
  __typename?: 'VisaLettersPageFacet';
  AnalyticsCampaignName?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AssignedGroups?: Maybe<AssignedGroupPropertyValueFacet>;
  AssignedGroupsReadAccess?: Maybe<AssignedGroupPropertyValueFacet>;
  Categories?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContentTypeID?: Maybe<Array<Maybe<NumberFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableSearchEngineIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  ExcludeFromSearch?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpandedCategories?: Maybe<ExpandedCategoriesEntryFacet>;
  ExpandedSources?: Maybe<ExpandedSourcesEntryFacet>;
  ExpandedTopics?: Maybe<ExpandedTopicsEntryFacet>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaImage?: Maybe<VisaLettersPageImageBlockFacet>;
  MetaKeywordList?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThumbnailImage?: Maybe<VisaLettersPageImageBlockFacet>;
  TitleText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type VisaLettersPageFacetAnalyticsCampaignNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisaLettersPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetContentTypeIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VisaLettersPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisaLettersPageFacetDisableSearchEngineIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetExcludeFromSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VisaLettersPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetMetaKeywordListArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisaLettersPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisaLettersPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisaLettersPageFacetTitleTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VisaLettersPageImageBlock = {
  __typename?: 'VisaLettersPageImageBlock';
  AltText?: Maybe<Scalars['String']['output']>;
  AnchorLabel?: Maybe<Scalars['String']['output']>;
  AnchorLink?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  ImageSize?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  Seperator?: Maybe<Scalars['String']['output']>;
};


export type VisaLettersPageImageBlockAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisaLettersPageImageBlockAnchorLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisaLettersPageImageBlockAnchorLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisaLettersPageImageBlockImageSizeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisaLettersPageImageBlockSeperatorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type VisaLettersPageImageBlockAutocomplete = {
  __typename?: 'VisaLettersPageImageBlockAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type VisaLettersPageImageBlockFacet = {
  __typename?: 'VisaLettersPageImageBlockFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLabel?: Maybe<Array<Maybe<StringFacet>>>;
  AnchorLink?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  ImageSize?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  Seperator?: Maybe<Array<Maybe<StringFacet>>>;
};


export type VisaLettersPageImageBlockFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageImageBlockFacetAnchorLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageImageBlockFacetAnchorLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageImageBlockFacetImageSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisaLettersPageImageBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VisaLettersPageImageBlockFacetSeperatorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisaLettersPageImageBlockOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  AnchorLabel?: InputMaybe<OrderBy>;
  AnchorLink?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageSize?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  Seperator?: InputMaybe<OrderBy>;
};

export type VisaLettersPageImageBlockWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  AnchorLabel?: InputMaybe<SearchableStringFilterInput>;
  AnchorLink?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageSize?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  Seperator?: InputMaybe<SearchableStringFilterInput>;
};

export type VisaLettersPageOrderByInput = {
  AnalyticsCampaignName?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueOrderByInput>;
  Categories?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContentTypeID?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableSearchEngineIndexing?: InputMaybe<OrderBy>;
  ExcludeFromSearch?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryOrderByInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryOrderByInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryOrderByInput>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaImage?: InputMaybe<VisaLettersPageImageBlockOrderByInput>;
  MetaKeywordList?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThumbnailImage?: InputMaybe<VisaLettersPageImageBlockOrderByInput>;
  TitleText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VisaLettersPageOutput = {
  __typename?: 'VisaLettersPageOutput';
  autocomplete?: Maybe<VisaLettersPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VisaLettersPageFacet>;
  item?: Maybe<VisaLettersPage>;
  items?: Maybe<Array<Maybe<VisaLettersPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type VisaLettersPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisaLettersPageWhereInput = {
  AnalyticsCampaignName?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AssignedGroups?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  AssignedGroupsReadAccess?: InputMaybe<AssignedGroupPropertyValueWhereInput>;
  Categories?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContentTypeID?: InputMaybe<IntFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableSearchEngineIndexing?: InputMaybe<BoolFilterInput>;
  ExcludeFromSearch?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpandedCategories?: InputMaybe<ExpandedCategoriesEntryWhereInput>;
  ExpandedSources?: InputMaybe<ExpandedSourcesEntryWhereInput>;
  ExpandedTopics?: InputMaybe<ExpandedTopicsEntryWhereInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaImage?: InputMaybe<VisaLettersPageImageBlockWhereInput>;
  MetaKeywordList?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThumbnailImage?: InputMaybe<VisaLettersPageImageBlockWhereInput>;
  TitleText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VisaLettersPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VisaLettersPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VisaLettersPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type VisibilityOptionsBlock = IContent & IData & {
  __typename?: 'VisibilityOptionsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CareerStage?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Country?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FoundationDonorLevel?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LearnResourceTopic?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MeetingId?: Maybe<Scalars['String']['output']>;
  MeetingRegistrationStatus?: Maybe<Scalars['String']['output']>;
  MemberType?: Maybe<Scalars['String']['output']>;
  MembershipLevel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreferredLanguage?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TotalMemberYearsCountFrom?: Maybe<Scalars['Int']['output']>;
  TotalMemberYearsCountTo?: Maybe<Scalars['Int']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type VisibilityOptionsBlockCareerStageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisibilityOptionsBlockCountryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisibilityOptionsBlockFoundationDonorLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisibilityOptionsBlockLearnResourceTopicArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisibilityOptionsBlockMeetingIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisibilityOptionsBlockMeetingRegistrationStatusArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisibilityOptionsBlockMemberTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisibilityOptionsBlockMembershipLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisibilityOptionsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisibilityOptionsBlockPreferredLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisibilityOptionsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisibilityOptionsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VisibilityOptionsBlockAutocomplete = {
  __typename?: 'VisibilityOptionsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type VisibilityOptionsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisibilityOptionsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisibilityOptionsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisibilityOptionsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisibilityOptionsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisibilityOptionsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisibilityOptionsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisibilityOptionsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisibilityOptionsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisibilityOptionsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisibilityOptionsBlockFacet = {
  __typename?: 'VisibilityOptionsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CareerStage?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Country?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FoundationDonorLevel?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LearnResourceTopic?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MeetingId?: Maybe<Array<Maybe<StringFacet>>>;
  MeetingRegistrationStatus?: Maybe<Array<Maybe<StringFacet>>>;
  MemberType?: Maybe<Array<Maybe<StringFacet>>>;
  MembershipLevel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreferredLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalMemberYearsCountFrom?: Maybe<Array<Maybe<NumberFacet>>>;
  TotalMemberYearsCountTo?: Maybe<Array<Maybe<NumberFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type VisibilityOptionsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetCareerStageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisibilityOptionsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetCountryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisibilityOptionsBlockFacetFoundationDonorLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VisibilityOptionsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetLearnResourceTopicArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetMeetingIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetMeetingRegistrationStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetMemberTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetMembershipLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetPreferredLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisibilityOptionsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisibilityOptionsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisibilityOptionsBlockFacetTotalMemberYearsCountFromArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VisibilityOptionsBlockFacetTotalMemberYearsCountToArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type VisibilityOptionsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisibilityOptionsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VisibilityOptionsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CareerStage?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Country?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FoundationDonorLevel?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LearnResourceTopic?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MeetingId?: InputMaybe<OrderBy>;
  MeetingRegistrationStatus?: InputMaybe<OrderBy>;
  MemberType?: InputMaybe<OrderBy>;
  MembershipLevel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreferredLanguage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalMemberYearsCountFrom?: InputMaybe<OrderBy>;
  TotalMemberYearsCountTo?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VisibilityOptionsBlockOutput = {
  __typename?: 'VisibilityOptionsBlockOutput';
  autocomplete?: Maybe<VisibilityOptionsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VisibilityOptionsBlockFacet>;
  item?: Maybe<VisibilityOptionsBlock>;
  items?: Maybe<Array<Maybe<VisibilityOptionsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type VisibilityOptionsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisibilityOptionsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CareerStage?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Country?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FoundationDonorLevel?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LearnResourceTopic?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MeetingId?: InputMaybe<SearchableStringFilterInput>;
  MeetingRegistrationStatus?: InputMaybe<SearchableStringFilterInput>;
  MemberType?: InputMaybe<SearchableStringFilterInput>;
  MembershipLevel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreferredLanguage?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalMemberYearsCountFrom?: InputMaybe<IntFilterInput>;
  TotalMemberYearsCountTo?: InputMaybe<IntFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VisibilityOptionsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VisibilityOptionsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VisibilityOptionsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type VisitorDataHiddenElementBlock = IContent & IData & {
  __typename?: 'VisitorDataHiddenElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisitorDataSources?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type VisitorDataHiddenElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisitorDataHiddenElementBlockVisitorDataSourcesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisitorDataHiddenElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisitorDataHiddenElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VisitorDataHiddenElementBlockAutocomplete = {
  __typename?: 'VisitorDataHiddenElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type VisitorDataHiddenElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockFacet = {
  __typename?: 'VisitorDataHiddenElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisitorDataSources?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type VisitorDataHiddenElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisitorDataHiddenElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisitorDataHiddenElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisitorDataHiddenElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisitorDataHiddenElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisitorDataHiddenElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetVisitorDataSourcesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type VisitorDataHiddenElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisitorDataSources?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type VisitorDataHiddenElementBlockOutput = {
  __typename?: 'VisitorDataHiddenElementBlockOutput';
  autocomplete?: Maybe<VisitorDataHiddenElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VisitorDataHiddenElementBlockFacet>;
  item?: Maybe<VisitorDataHiddenElementBlock>;
  items?: Maybe<Array<Maybe<VisitorDataHiddenElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type VisitorDataHiddenElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisitorDataHiddenElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisitorDataSources?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VisitorDataHiddenElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VisitorDataHiddenElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VisitorDataHiddenElementBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlock = IContent & IData & {
  __typename?: 'WireTransferSectionBlock';
  AgentID?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackDues?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CourtOfTableCOT?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstGivenName?: Maybe<Scalars['String']['output']>;
  IndexTrigger?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastFamilyName?: Maybe<Scalars['String']['output']>;
  LateFee?: Maybe<Scalars['String']['output']>;
  MDRTDues?: Maybe<Scalars['String']['output']>;
  MDRTID?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MembershipYear?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TopOfTableTOT?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlockAgentIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlockBackDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlockCourtOfTableCotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlockFirstGivenNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlockLastFamilyNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlockLateFeeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlockMdrtDuesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlockMdrtidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlockMembershipYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlockTopOfTableTotArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Holds Wire Transfer data for the Company Admin page */
export type WireTransferSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type WireTransferSectionBlockAutocomplete = {
  __typename?: 'WireTransferSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type WireTransferSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WireTransferSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WireTransferSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WireTransferSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WireTransferSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WireTransferSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WireTransferSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WireTransferSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WireTransferSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WireTransferSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WireTransferSectionBlockFacet = {
  __typename?: 'WireTransferSectionBlockFacet';
  AgentID?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackDues?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CourtOfTableCOT?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstGivenName?: Maybe<Array<Maybe<StringFacet>>>;
  IndexTrigger?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastFamilyName?: Maybe<Array<Maybe<StringFacet>>>;
  LateFee?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTDues?: Maybe<Array<Maybe<StringFacet>>>;
  MDRTID?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MembershipYear?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TopOfTableTOT?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type WireTransferSectionBlockFacetAgentIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetBackDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WireTransferSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetCourtOfTableCotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WireTransferSectionBlockFacetFirstGivenNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetIndexTriggerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type WireTransferSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetLastFamilyNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetLateFeeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetMdrtDuesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetMdrtidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetMembershipYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WireTransferSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WireTransferSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WireTransferSectionBlockFacetTopOfTableTotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WireTransferSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type WireTransferSectionBlockOrderByInput = {
  AgentID?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BackDues?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CourtOfTableCOT?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstGivenName?: InputMaybe<OrderBy>;
  IndexTrigger?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastFamilyName?: InputMaybe<OrderBy>;
  LateFee?: InputMaybe<OrderBy>;
  MDRTDues?: InputMaybe<OrderBy>;
  MDRTID?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MembershipYear?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TopOfTableTOT?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type WireTransferSectionBlockOutput = {
  __typename?: 'WireTransferSectionBlockOutput';
  autocomplete?: Maybe<WireTransferSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<WireTransferSectionBlockFacet>;
  item?: Maybe<WireTransferSectionBlock>;
  items?: Maybe<Array<Maybe<WireTransferSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type WireTransferSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WireTransferSectionBlockWhereInput = {
  AgentID?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BackDues?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CourtOfTableCOT?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstGivenName?: InputMaybe<SearchableStringFilterInput>;
  IndexTrigger?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastFamilyName?: InputMaybe<SearchableStringFilterInput>;
  LateFee?: InputMaybe<SearchableStringFilterInput>;
  MDRTDues?: InputMaybe<SearchableStringFilterInput>;
  MDRTID?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MembershipYear?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TopOfTableTOT?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<WireTransferSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<WireTransferSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<WireTransferSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type YourAnswersSectionBlock = IContent & IData & {
  __typename?: 'YourAnswersSectionBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BlockReplacementText?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstQuestionLabel?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SecondQuestionLabel?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  ThirdQuestionLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type YourAnswersSectionBlockBlockReplacementTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type YourAnswersSectionBlockFirstQuestionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type YourAnswersSectionBlockHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type YourAnswersSectionBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type YourAnswersSectionBlockSecondQuestionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type YourAnswersSectionBlockThirdQuestionLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type YourAnswersSectionBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type YourAnswersSectionBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type YourAnswersSectionBlockAutocomplete = {
  __typename?: 'YourAnswersSectionBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type YourAnswersSectionBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YourAnswersSectionBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YourAnswersSectionBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YourAnswersSectionBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YourAnswersSectionBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YourAnswersSectionBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YourAnswersSectionBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YourAnswersSectionBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YourAnswersSectionBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YourAnswersSectionBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type YourAnswersSectionBlockFacet = {
  __typename?: 'YourAnswersSectionBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BlockReplacementText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstQuestionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SecondQuestionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  ThirdQuestionLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type YourAnswersSectionBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetBlockReplacementTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type YourAnswersSectionBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type YourAnswersSectionBlockFacetFirstQuestionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type YourAnswersSectionBlockFacetSecondQuestionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type YourAnswersSectionBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type YourAnswersSectionBlockFacetThirdQuestionLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YourAnswersSectionBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type YourAnswersSectionBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BlockReplacementText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstQuestionLabel?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SecondQuestionLabel?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  ThirdQuestionLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type YourAnswersSectionBlockOutput = {
  __typename?: 'YourAnswersSectionBlockOutput';
  autocomplete?: Maybe<YourAnswersSectionBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<YourAnswersSectionBlockFacet>;
  item?: Maybe<YourAnswersSectionBlock>;
  items?: Maybe<Array<Maybe<YourAnswersSectionBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type YourAnswersSectionBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type YourAnswersSectionBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BlockReplacementText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstQuestionLabel?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SecondQuestionLabel?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  ThirdQuestionLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<YourAnswersSectionBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<YourAnswersSectionBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<YourAnswersSectionBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum System_Locales {
  All = 'ALL',
  Neutral = 'NEUTRAL'
}

export type AccountSettingsSiteContactInformationContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type AccountSettingsSiteContactInformationContentQuery = { __typename?: 'Query', DashboardAccountPage?: { __typename?: 'DashboardAccountPageOutput', items?: Array<{ __typename?: 'DashboardAccountPage', CountryHint?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContactInformation?: { __typename?: 'DashboardAccountPageDashboardContactInformationBlock', Title?: string | null, Email?: string | null, SecondEmail?: string | null, PhoneType?: string | null, ISOCode?: string | null, AreaCode?: string | null, PhoneNumber?: string | null, WeChatID?: string | null, MailingAddress?: string | null, AddressLine1?: string | null, AddressLine2?: string | null, AddressLine3?: string | null, City?: string | null, StateProvince?: string | null, PostalCode?: string | null, LocalLanguageAddressTitle?: string | null, UniqueEmailValidationMessage?: string | null, InvalidEmailValidationMessage?: string | null, PrimaryPhoneTitle?: string | null, AdditionalPhoneLabel?: string | null, AdditionalPhoneTitle?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', RequiredLabel?: string | null, SaveChanges?: string | null, RemoveLabel?: string | null, CountryLabel?: string | null, LatinOnlyMessage?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type AccountSettingsInterestsContentQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSettingsInterestsContentQuery = { __typename?: 'Query', DashboardAccountPage?: { __typename?: 'DashboardAccountPageOutput', items?: Array<{ __typename?: 'DashboardAccountPage', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, SitePreferences?: { __typename?: 'DashboardAccountPageDashboardSitePreferencesBlock', Interests?: string | null, SelectTopics?: string | null, WhatInterests?: string | null, ChooseTopics?: string | null, SaveInterests?: string | null, InterestsErrorMessage?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', CancelLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type AccountSettingsLoginPasswordContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type AccountSettingsLoginPasswordContentQuery = { __typename?: 'Query', DashboardAccountPage?: { __typename?: 'DashboardAccountPageOutput', items?: Array<{ __typename?: 'DashboardAccountPage', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, LoginPassword?: { __typename?: 'DashboardAccountPageDashboardLoginPasswordBlock', MDRTID?: string | null, Email?: string | null, EmailEditInformation?: string | null, Title?: string | null, UserName?: string | null, UsernameNotUnique?: string | null, ApprovedSocialLogins?: string | null, BrowserPermissionInformation?: string | null, AppleLabel?: string | null, FacebookLabel?: string | null, GoogleLabel?: string | null, LinkedInLabel?: string | null, BiometricsSwitchLabel?: string | null, ResetPassword?: { __typename?: 'DashboardAccountPageDashboardLoginPasswordBlockLinkBlock', DisplayText?: string | null } | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', Close?: string | null, LatinOnlyMessage?: string | null, SaveChanges?: string | null, RequiredLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, AccountSettingsPageReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null } | null> | null } | null };

export type AccountSettingsPersonalInfoContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type AccountSettingsPersonalInfoContentQuery = { __typename?: 'Query', DashboardAccountPage?: { __typename?: 'DashboardAccountPageOutput', items?: Array<{ __typename?: 'DashboardAccountPage', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, PersonalInformation?: { __typename?: 'DashboardAccountPageDashboardPersonalInformationBlock', FirstName?: string | null, Gender?: string | null, LastName?: string | null, MiddleName?: string | null, PreferredName?: string | null, NavigationName?: string | null, Prefix?: string | null, Suffix?: string | null, Title?: string | null, YearOfBirth?: string | null, YearOfBirthValidationMessage?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', RequiredLabel?: string | null, LatinOnlyMessage?: string | null, SaveChanges?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type AccountSettingsProfessionalInfoContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type AccountSettingsProfessionalInfoContentQuery = { __typename?: 'Query', DashboardAccountPage?: { __typename?: 'DashboardAccountPageOutput', items?: Array<{ __typename?: 'DashboardAccountPage', CountryHint?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ProfessionalInformation?: { __typename?: 'DashboardAccountPageDashboardProfessionalInformationBlock', NavigationName?: string | null, Title?: string | null, AffiliatedCompany?: string | null, BrokerDealerCompany?: string | null, AgencyCompany?: string | null, PersonalCompany?: string | null, JobTitle?: string | null, Designation?: string | null, DesignationInformation?: string | null, AgentID?: string | null, YearOfFirstLicense?: string | null, YearOfFirstLicenseValidationMessage?: string | null, CompanyChangeAlertTitle?: string | null, CompanyChangeAlertBody?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', LatinOnlyMessage?: string | null, SaveChanges?: string | null, Close?: string | null, CountryLabel?: string | null, ConfirmLabel?: string | null, CancelLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type AccountSettingsProfileContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type AccountSettingsProfileContentQuery = { __typename?: 'Query', DashboardAccountPage?: { __typename?: 'DashboardAccountPageOutput', items?: Array<{ __typename?: 'DashboardAccountPage', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, SharedContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename: 'ProfilePictureBlock', Add?: string | null, PictureDescription?: string | null, Change?: string | null, Remove?: string | null, FileSizeHint?: string | null, FileSizeError?: string | null, FileTypeError?: string | null, ServerFileError?: string | null } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, Profile?: { __typename?: 'DashboardAccountPageDashboardProfileBlock', NavigationName?: string | null, Title?: string | null, DisplayName?: string | null, Bio?: string | null, SocialLinks?: string | null, ShareSocialLinks?: string | null, LinkedIn?: string | null, Facebook?: string | null, Instagram?: string | null, Twitter?: string | null, GetMembershipCertificate?: string | null, ViewMembershipInvoice?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', Close?: string | null, RequiredLabel?: string | null, SaveChanges?: string | null, CountryLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MembershipInvoicePage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null } | null> | null } | null };

export type AccountSettingsSitePreferencesContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type AccountSettingsSitePreferencesContentQuery = { __typename?: 'Query', DashboardAccountPage?: { __typename?: 'DashboardAccountPageOutput', items?: Array<{ __typename?: 'DashboardAccountPage', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, SitePreferences?: { __typename?: 'DashboardAccountPageDashboardSitePreferencesBlock', LanguageLabel?: string | null, ChooseLanguage?: string | null, PreferredLanguage?: string | null, MemberDirectory?: string | null, MemberDirectoryOptIn?: string | null, Interests?: string | null, SelectTopics?: string | null, WhatInterests?: string | null, ChooseTopics?: string | null, SaveInterests?: string | null, AddMoreTopicsButtonLabel?: string | null, InterestsErrorMessage?: string | null } | null, Permissions?: { __typename?: 'DashboardAccountPageDashboardPermissionsBlock', EmailNotification?: string | null, EmailNotificationInformation?: string | null, CommunicationTopicInformation?: string | null, MemberBenefits?: string | null, ContentNewsletter?: string | null, MDRTMeetings?: string | null, BusinessAnnouncements?: string | null, MDRTFoundation?: string | null, MDRTStore?: string | null, CommunicationRemovalInformation?: string | null, SMSNotification?: string | null, SMSNotificationPermission?: string | null, EmailPermission?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', SaveChanges?: string | null, RequiredLabel?: string | null, Close?: string | null, CancelLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type AccountSettingsPageQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type AccountSettingsPageQuery = { __typename?: 'Query', DashboardAccountPage?: { __typename?: 'DashboardAccountPageOutput', items?: Array<{ __typename?: 'DashboardAccountPage', RelativePath?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Profile?: { __typename?: 'DashboardAccountPageDashboardProfileBlock', NavigationName?: string | null } | null, ProfessionalInformation?: { __typename?: 'DashboardAccountPageDashboardProfessionalInformationBlock', NavigationName?: string | null } | null, PersonalInformation?: { __typename?: 'DashboardAccountPageDashboardPersonalInformationBlock', NavigationName?: string | null } | null, Permissions?: { __typename?: 'DashboardAccountPageDashboardPermissionsBlock', NavigationName?: string | null } | null, ContactInformation?: { __typename?: 'DashboardAccountPageDashboardContactInformationBlock', NavigationName?: string | null } | null, LoginPassword?: { __typename?: 'DashboardAccountPageDashboardLoginPasswordBlock', NavigationName?: string | null } | null, SitePreferences?: { __typename?: 'DashboardAccountPageDashboardSitePreferencesBlock', NavigationName?: string | null } | null } | null> | null } | null };

export type DeadLettersContentQueryVariables = Exact<{ [key: string]: never; }>;


export type DeadLettersContentQuery = { __typename?: 'Query', NextStaffAdminPage?: { __typename?: 'NextStaffAdminPageOutput', items?: Array<{ __typename?: 'NextStaffAdminPage', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, DeadLettersSectionContent?: { __typename?: 'NextStaffAdminPageNextDeadLetterQueueBlock', DeadLettersNoDeadLetters?: string | null, DeadLettersRetryDeadLetters?: string | null, DeadLettersQueue?: string | null } | null, DeadLettersTableContent?: { __typename?: 'NextStaffAdminPageNextDeadLetterQueueBlock', DeadLettersQueueName?: string | null, DeadLettersEnqueuedTime?: string | null, DeadLettersMessageId?: string | null, DeadLettersMessageName?: string | null } | null } | null> | null } | null };

export type PersonScopedDataTableContentQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonScopedDataTableContentQuery = { __typename?: 'Query', NextStaffAdminPage?: { __typename?: 'NextStaffAdminPageOutput', items?: Array<{ __typename?: 'NextStaffAdminPage', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, PersonData?: { __typename?: 'NextStaffAdminPageNextPersonDataBlock', PersonData?: string | null, PersonDataTriggerSync?: string | null, PersonDataExcludeFromLateFee?: string | null, PersonDataPrepayments?: string | null, PersonDataPayments?: string | null, PersonDataProductions?: string | null, PersonDataMembershipApplication?: string | null, PersonDataCustomerProfile?: string | null, PersonDataNoResults?: string | null } | null } | null> | null } | null };

export type SyncEventsTableContentQueryVariables = Exact<{ [key: string]: never; }>;


export type SyncEventsTableContentQuery = { __typename?: 'Query', NextStaffAdminPage?: { __typename?: 'NextStaffAdminPageOutput', items?: Array<{ __typename?: 'NextStaffAdminPage', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, SyncTableContent?: { __typename?: 'NextStaffAdminPageNextSyncEventsBlock', SyncEventsDeleteAllUserData?: string | null, SyncEventsUserDataDeleteConfirmation?: string | null, SyncEventsSyncEvent?: string | null, SyncEventsSyncOperation?: string | null, SyncEventsDate?: string | null } | null, SyncEventsFilter?: { __typename?: 'NextStaffAdminPageNextSyncEventsBlock', SyncEventsSelectPrepayment?: string | null, SyncEventsSelectProduction?: string | null, SyncEventsSelectAll?: string | null, SyncEventsSelectMembershipApplication?: string | null, SyncEventsSelectCustomerProfile?: string | null } | null } | null> | null } | null };

export type UsersListTableContentQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersListTableContentQuery = { __typename?: 'Query', NextStaffAdminPage?: { __typename?: 'NextStaffAdminPageOutput', items?: Array<{ __typename?: 'NextStaffAdminPage', UsersRequiringAttentionDeadLetterCount?: string | null, UsersRequiringAttentionDescription?: string | null, UsersRequiringAttentionEmailAddress?: string | null, UsersRequiringAttentionEnterPersonId?: string | null, UsersRequiringAttentionGoToPage?: string | null, UsersRequiringAttentionId?: string | null, UsersRequiringAttentionName?: string | null, UsersRequiringAttentionNoResults?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type AdminDashboardContentQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminDashboardContentQuery = { __typename?: 'Query', NextStaffAdminPage?: { __typename?: 'NextStaffAdminPageOutput', items?: Array<{ __typename?: 'NextStaffAdminPage', UsersRequiringAttention?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null> | null } | null };

export type PersonIdPageContentQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonIdPageContentQuery = { __typename?: 'Query', NextStaffAdminPage?: { __typename?: 'NextStaffAdminPageOutput', items?: Array<{ __typename?: 'NextStaffAdminPage', Back?: string | null, PersonId?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, SyncEventsBlock?: { __typename?: 'NextStaffAdminPageNextSyncEventsBlock', SyncEvents?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null> | null } | null };

export type AccountSettingsPreviewModalContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type AccountSettingsPreviewModalContentQuery = { __typename?: 'Query', DashboardAccountPage?: { __typename?: 'DashboardAccountPageOutput', items?: Array<{ __typename?: 'DashboardAccountPage', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, PersonalInformation?: { __typename?: 'DashboardAccountPageDashboardPersonalInformationBlock', FirstName?: string | null, Gender?: string | null, LastName?: string | null, MiddleName?: string | null, PreferredName?: string | null, Prefix?: string | null, Suffix?: string | null, YearOfBirth?: string | null } | null, ProfessionalInformation?: { __typename?: 'DashboardAccountPageDashboardProfessionalInformationBlock', AffiliatedCompany?: string | null, BrokerDealerCompany?: string | null, AgencyCompany?: string | null, PersonalCompany?: string | null, JobTitle?: string | null, Designation?: string | null, AgentID?: string | null, YearOfFirstLicense?: string | null } | null, ContactInformation?: { __typename?: 'DashboardAccountPageDashboardContactInformationBlock', Title?: string | null, Email?: string | null, SecondEmail?: string | null, PhoneType?: string | null, ISOCode?: string | null, AreaCode?: string | null, PhoneNumber?: string | null, WeChatID?: string | null, MailingAddress?: string | null, AddressLine1?: string | null, AddressLine2?: string | null, AddressLine3?: string | null, City?: string | null, StateProvince?: string | null, PostalCode?: string | null, LocalLanguageAddressTitle?: string | null } | null } | null> | null } | null, HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', ProfileDataValidationConfirmButtonLabel?: string | null, ProfileDataValidationContactInformationSectionTitle?: string | null, ProfileDataValidationEditLinkAriaLabel?: string | null, ProfileDataValidationModalDescription?: string | null, ProfileDataValidationModalTitle?: string | null, ProfileDataValidationPersonalInformationSectionTitle?: string | null, ProfileDataValidationProfessionalInformationSectionTitle?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', CountryLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type BiometricIdContentQueryVariables = Exact<{ [key: string]: never; }>;


export type BiometricIdContentQuery = { __typename?: 'Query', HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', BiometricAuthenticationDismissButton?: string | null, BiometricAuthenticationEnableButton?: string | null, BiometricAuthenticationHeading?: string | null, BiometricAuthenticationLoginMessage?: string | null, BiometricAuthenticationDisableMessage?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type CardsSectionContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type CardsSectionContentQuery = { __typename?: 'Query', HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', CardsSectionTitle?: string | null, CardsSectionTitleForMembers?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type DashboardCarouselCardsContentQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardCarouselCardsContentQuery = { __typename?: 'Query', HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, DashboardCarouselCardsContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock', Title?: string | null, Description?: string | null, ContentCategory?: string | null, PreferredLanguage?: string | null, Country?: string | null, MembershipLevel?: string | null, MemberType?: string | null, CareerStage?: string | null, LearnResourceTopic?: string | null, MeetingRegistrationStatus?: string | null, FoundationDonorLevel?: string | null, TotalMemberYearsCountFrom?: number | null, TotalMemberYearsCountTo?: number | null, MeetingId?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null, CardUrl?: { __typename?: 'DashboardCarouselCardBlockLinkBlock', DisplayText?: string | null, Target?: string | null, LinkToContent?: string | null } | null, LocationsAndDates?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock', Location?: string | null, StartDate?: any | null, EndDate?: any | null } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null };

export type DashboardCarouselCardBlockVisibilityOptionsFragment = { __typename?: 'DashboardCarouselCardBlock', PreferredLanguage?: string | null, Country?: string | null, MembershipLevel?: string | null, MemberType?: string | null, CareerStage?: string | null, LearnResourceTopic?: string | null, MeetingRegistrationStatus?: string | null, FoundationDonorLevel?: string | null, TotalMemberYearsCountFrom?: number | null, TotalMemberYearsCountTo?: number | null, MeetingId?: string | null };

export type LearnCardForYouCardFragment = { __typename?: 'LearnDetailPage', RelativePath?: string | null, ContentTypeSelection?: number | null, Subheading?: string | null, SubheadingText?: string | null, Heading?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null, ThumbnailImage?: { __typename?: 'LearnDetailPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, ExpandedCategories?: Array<{ __typename?: 'ExpandedCategoriesEntry', Name?: string | null, ParentId?: number | null, Id?: number | null } | null> | null };

export type LearnCardsForYouContentQueryVariables = Exact<{
  contentGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  relativePath: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type LearnCardsForYouContentQuery = { __typename?: 'Query', LearnDetailPage?: { __typename?: 'LearnDetailPageOutput', items?: Array<{ __typename?: 'LearnDetailPage', RelativePath?: string | null, ContentTypeSelection?: number | null, Subheading?: string | null, SubheadingText?: string | null, Heading?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null, ThumbnailImage?: { __typename?: 'LearnDetailPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, ExpandedCategories?: Array<{ __typename?: 'ExpandedCategoriesEntry', Name?: string | null, ParentId?: number | null, Id?: number | null } | null> | null } | null> | null } | null, HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', CardsTabLearnContentCategory?: string | null, CardsTabLearnButtonLabel?: string | null, AudioContentCategory?: string | null, PodcastContentCategory?: string | null, VideoContentCategory?: string | null, GuideContentCategory?: string | null, ArticleContentCategory?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type MeetingEventCardContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MeetingEventCardContentQuery = { __typename?: 'Query', MeetingEventCardPage?: { __typename?: 'MeetingEventCardPageOutput', items?: Array<{ __typename?: 'MeetingEventCardPage', Title?: string | null, Description?: string | null, CallToActionText?: string | null, ContentCategory?: string | null, Url?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, AssignedGroups?: Array<{ __typename?: 'AssignedGroupPropertyValue', AccessLevels?: string | null, GroupName?: string | null } | null> | null, LocationsAndDates?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock', Name?: string | null } | { __typename?: 'AccordionContainerBlock', Name?: string | null } | { __typename?: 'AccordionItemBlock', Name?: string | null } | { __typename?: 'AccountProfilePage', Name?: string | null } | { __typename?: 'AddressInfoBlock', Name?: string | null } | { __typename?: 'BadgeBlock', Name?: string | null } | { __typename?: 'BrandedTableBlock', Name?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Name?: string | null } | { __typename?: 'ButtonLabelBlock', Name?: string | null } | { __typename?: 'CaptchaElementBlock', Name?: string | null } | { __typename?: 'CategoryListBlock', Name?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Name?: string | null } | { __typename?: 'CflBadgesBlock', Name?: string | null } | { __typename?: 'CflHomePage', Name?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Name?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Name?: string | null } | { __typename?: 'CflSiteSettingsPage', Name?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Name?: string | null } | { __typename?: 'ChoiceElementBlock', Name?: string | null } | { __typename?: 'ColumnContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Name?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Name?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Name?: string | null } | { __typename?: 'CompanyRankingsPage', Name?: string | null } | { __typename?: 'ConfirmationModalBlock', Name?: string | null } | { __typename?: 'ConfirmationStepBlock', Name?: string | null } | { __typename?: 'CongratulationsStepV2Block', Name?: string | null } | { __typename?: 'ContactEmailElementBlock', Name?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Name?: string | null } | { __typename?: 'ContactNameElementBlock', Name?: string | null } | { __typename?: 'ContactPhoneElementBlock', Name?: string | null } | { __typename?: 'ContactsBlock', Name?: string | null } | { __typename?: 'Content', Name?: string | null } | { __typename?: 'DAMAsset', Name?: string | null } | { __typename?: 'DAMImageAsset', Name?: string | null } | { __typename?: 'DAMVideo', Name?: string | null } | { __typename?: 'DAMVideoAsset', Name?: string | null } | { __typename?: 'DashBoardSectionBlock', Name?: string | null } | { __typename?: 'DashboardAccountPage', Name?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Name?: string | null } | { __typename?: 'DashboardContactInformationBlock', Name?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Name?: string | null } | { __typename?: 'DashboardPermissionsBlock', Name?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfileBlock', Name?: string | null } | { __typename?: 'DashboardSharedPage', Name?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Name?: string | null } | { __typename?: 'DataMismatchModalBlock', Name?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Name?: string | null } | { __typename?: 'DescriptionButtonBlock', Name?: string | null } | { __typename?: 'DetailPage', Name?: string | null } | { __typename?: 'DocumentMedia', Name?: string | null } | { __typename?: 'DonationBlock', Name?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Name?: string | null } | { __typename?: 'EEPSectionBlock', Name?: string | null } | { __typename?: 'EVPCarouselBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Name?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Name?: string | null } | { __typename?: 'EVPContentBlock', Name?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Name?: string | null } | { __typename?: 'EVPGenericPage', Name?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Name?: string | null } | { __typename?: 'EVPHomePage', Name?: string | null } | { __typename?: 'EVPImageBlock', Name?: string | null } | { __typename?: 'EVPImageLinkBlock', Name?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Name?: string | null } | { __typename?: 'EVPLinkBlock', Name?: string | null } | { __typename?: 'EVPMediaFileBlock', Name?: string | null } | { __typename?: 'EVPNavigationPageBlock', Name?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Name?: string | null } | { __typename?: 'EVPResourcePage', Name?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Name?: string | null } | { __typename?: 'EVPSearchPage', Name?: string | null } | { __typename?: 'EVPSiteSettingsPage', Name?: string | null } | { __typename?: 'EVPTabBlock', Name?: string | null } | { __typename?: 'EVPTabCardBlock', Name?: string | null } | { __typename?: 'EVPTabCardsBlock', Name?: string | null } | { __typename?: 'EVPTabImageTextBlock', Name?: string | null } | { __typename?: 'EVPTabRichTextBlock', Name?: string | null } | { __typename?: 'EVPTabVideoBlock', Name?: string | null } | { __typename?: 'EVPTabsBlock', Name?: string | null } | { __typename?: 'EVPTextImageBlock', Name?: string | null } | { __typename?: 'EVPVideoBlock', Name?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'ErrorModalBlock', Name?: string | null } | { __typename?: 'ErrorPage', Name?: string | null } | { __typename?: 'ErrorPageBlock', Name?: string | null } | { __typename?: 'EventBlock', Name?: string | null } | { __typename?: 'EventLocationAndDateBlock', StartDate?: any | null, EndDate?: any | null, Location?: string | null, Name?: string | null } | { __typename?: 'EventLocationInformationBlock', Name?: string | null } | { __typename?: 'EventPage', Name?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Name?: string | null } | { __typename?: 'EventSessionBlock', Name?: string | null } | { __typename?: 'EventSessionScheduleBlock', Name?: string | null } | { __typename?: 'EventSessionTrackBlock', Name?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Name?: string | null } | { __typename?: 'EventSpeakerSearchPage', Name?: string | null } | { __typename?: 'EventSpeakersBlock', Name?: string | null } | { __typename?: 'EventTableContainerBlock', Name?: string | null } | { __typename?: 'ExpandableContainerBlock', Name?: string | null } | { __typename?: 'FileUploadElementBlock', Name?: string | null } | { __typename?: 'FlowFinishInformationBlock', Name?: string | null } | { __typename?: 'FolderPage', Name?: string | null } | { __typename?: 'FormContainerBlock', Name?: string | null } | { __typename?: 'FormStepBlock', Name?: string | null } | { __typename?: 'FourColumnTableBlock', Name?: string | null } | { __typename?: 'GaugeBlock', Name?: string | null } | { __typename?: 'GeoDataBlock', Name?: string | null } | { __typename?: 'GettingStartedStepBlock', Name?: string | null } | { __typename?: 'GettingStartedStepV2Block', Name?: string | null } | { __typename?: 'GreetingCaseBlock', Name?: string | null } | { __typename?: 'GreetingStepBlock', Name?: string | null } | { __typename?: 'GreetingStepV2Block', Name?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Name?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Name?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Name?: string | null } | { __typename?: 'GsAwardsPage', Name?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Name?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Name?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Name?: string | null } | { __typename?: 'GsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsGreetingStepBlock', Name?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Name?: string | null } | { __typename?: 'GsMembershipRenewalPage', Name?: string | null } | { __typename?: 'GsProfileStepBlock', Name?: string | null } | { __typename?: 'GsReceiptStepBlock', Name?: string | null } | { __typename?: 'GsReviewStepBlock', Name?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Name?: string | null } | { __typename?: 'HeroTextContentBlock', Name?: string | null } | { __typename?: 'HomePage', Name?: string | null } | { __typename?: 'HomePageV2', Name?: string | null } | { __typename?: 'IconRequirementBlock', Name?: string | null } | { __typename?: 'Image', Name?: string | null } | { __typename?: 'ImageBlock', Name?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Name?: string | null } | { __typename?: 'ImageChoiceElementBlock', Name?: string | null } | { __typename?: 'ImageLinkBlock', Name?: string | null } | { __typename?: 'ImageMedia', Name?: string | null } | { __typename?: 'ImageTextBlock', Name?: string | null } | { __typename?: 'ImageTextBlockV2', Name?: string | null } | { __typename?: 'ImageTextCardBlock', Name?: string | null } | { __typename?: 'ImageTextItemBlock', Name?: string | null } | { __typename?: 'InfoBoxBlock', Name?: string | null } | { __typename?: 'KeyLinkValueBlock', Name?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Name?: string | null } | { __typename?: 'LandingPage', Name?: string | null } | { __typename?: 'LanguageIdAndName', Name?: string | null } | { __typename?: 'LanguagesBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Name?: string | null } | { __typename?: 'LearnDetailPage', Name?: string | null } | { __typename?: 'LearnHeroImageBlock', Name?: string | null } | { __typename?: 'LearnLandingPage', Name?: string | null } | { __typename?: 'LearnPageV2', Name?: string | null } | { __typename?: 'LearnPlayListPage', Name?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Name?: string | null } | { __typename?: 'LinkBlock', Name?: string | null } | { __typename?: 'LinkListBlock', Name?: string | null } | { __typename?: 'LinkTileBlock', Name?: string | null } | { __typename?: 'LoaderBlock', Name?: string | null } | { __typename?: 'LocationBlock', Name?: string | null } | { __typename?: 'MeetingEventCardPage', Name?: string | null } | { __typename?: 'MeetingPage', Name?: string | null } | { __typename?: 'MemberDirectory', Name?: string | null } | { __typename?: 'MemberDirectoryPage', Name?: string | null } | { __typename?: 'MemberSectionBlock', Name?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Name?: string | null } | { __typename?: 'MembershipInvoicePage', Name?: string | null } | { __typename?: 'MembershipLevelBlock', Name?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Name?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Name?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Name?: string | null } | { __typename?: 'MembershipLevelsBlock', Name?: string | null } | { __typename?: 'MembershipRenewalPage', Name?: string | null } | { __typename?: 'MembershipRenewalV2Page', Name?: string | null } | { __typename?: 'MembershipRequirementBlock', Name?: string | null } | { __typename?: 'MembershipRequirementsBlock', Name?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Name?: string | null } | { __typename?: 'ModalInfoBlock', Name?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Name?: string | null } | { __typename?: 'NextCallOutBlock', Name?: string | null } | { __typename?: 'NextContactUsBlock', Name?: string | null } | { __typename?: 'NextContainerBlock', Name?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Name?: string | null } | { __typename?: 'NextEventBlock', Name?: string | null } | { __typename?: 'NextHeroBlock', Name?: string | null } | { __typename?: 'NextInfoBoxBlock', Name?: string | null } | { __typename?: 'NextPersonContainerBlock', Name?: string | null } | { __typename?: 'NextPersonDataBlock', Name?: string | null } | { __typename?: 'NextStaffAdminPage', Name?: string | null } | { __typename?: 'NextStaticPage', Name?: string | null } | { __typename?: 'NextSyncEventsBlock', Name?: string | null } | { __typename?: 'NotFoundPage', Name?: string | null } | { __typename?: 'NumberElementBlock', Name?: string | null } | { __typename?: 'NumberedContainerBlock', Name?: string | null } | { __typename?: 'NumberedItemBlock', Name?: string | null } | { __typename?: 'ParagraphTextElementBlock', Name?: string | null } | { __typename?: 'PastPresidentsBlock', Name?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Name?: string | null } | { __typename?: 'PersonBlock', Name?: string | null } | { __typename?: 'PersonContainerBlock', Name?: string | null } | { __typename?: 'PersonQuizPage', Name?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Name?: string | null } | { __typename?: 'PlaylistBlock', Name?: string | null } | { __typename?: 'PlaylistPromoBlock', Name?: string | null } | { __typename?: 'PodcastDetailBlock', Name?: string | null } | { __typename?: 'PowerPhrasePage', Name?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Name?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Name?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPortalPage', Name?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Name?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Name?: string | null } | { __typename?: 'PressReleasePage', Name?: string | null } | { __typename?: 'PriceBreakdownBlock', Name?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Name?: string | null } | { __typename?: 'ProductionDataSectionBlock', Name?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Name?: string | null } | { __typename?: 'ProductionModalBlock', Name?: string | null } | { __typename?: 'ProductionStepBlock', Name?: string | null } | { __typename?: 'ProductionStepV2Block', Name?: string | null } | { __typename?: 'ProductionTableBlock', Name?: string | null } | { __typename?: 'ProfileListBlock', Name?: string | null } | { __typename?: 'ProfilePictureBlock', Name?: string | null } | { __typename?: 'ProfileSectionBlock', Name?: string | null } | { __typename?: 'ProfileStepBlock', Name?: string | null } | { __typename?: 'ProfileStepV2Block', Name?: string | null } | { __typename?: 'PublicProfilePage', Name?: string | null } | { __typename?: 'QuizCareerBlock', Name?: string | null } | { __typename?: 'QuizEducationBlock', Name?: string | null } | { __typename?: 'QuizFinancialBlock', Name?: string | null } | { __typename?: 'QuizHealthBlock', Name?: string | null } | { __typename?: 'QuizRelationshipsBlock', Name?: string | null } | { __typename?: 'QuizServiceBlock', Name?: string | null } | { __typename?: 'QuizSpiritualBlock', Name?: string | null } | { __typename?: 'RTContributorFormPage', Name?: string | null } | { __typename?: 'RangeElementBlock', Name?: string | null } | { __typename?: 'ReceiptStepBlock', Name?: string | null } | { __typename?: 'ReceiptStepV2Block', Name?: string | null } | { __typename?: 'ResetButtonElementBlock', Name?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Name?: string | null } | { __typename?: 'ReviewBlock', Name?: string | null } | { __typename?: 'ReviewStepBlock', Name?: string | null } | { __typename?: 'RichTextBlock', Name?: string | null } | { __typename?: 'RoutingStepBlock', Name?: string | null } | { __typename?: 'SearchPage', Name?: string | null } | { __typename?: 'SearchPageV2', Name?: string | null } | { __typename?: 'SectionContainerBlock', Name?: string | null } | { __typename?: 'SectionItemBlock', Name?: string | null } | { __typename?: 'SelectionElementBlock', Name?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Name?: string | null } | { __typename?: 'SettingSectionBlock', Name?: string | null } | { __typename?: 'SiteSettingsPage', Name?: string | null } | { __typename?: 'SocialShareBlock', Name?: string | null } | { __typename?: 'SpeakerEngagementPage', Name?: string | null } | { __typename?: 'SponsorSpeakerPage', Name?: string | null } | { __typename?: 'SpotlightBlock', Name?: string | null } | { __typename?: 'SpotlightContainerBlock', Name?: string | null } | { __typename?: 'SpotlightDataBlock', Name?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Name?: string | null } | { __typename?: 'StoreCardPage', Name?: string | null } | { __typename?: 'SubmitButtonElementBlock', Name?: string | null } | { __typename?: 'SuccessSectionBlock', Name?: string | null } | { __typename?: 'SvgLinkBlock', Name?: string | null } | { __typename?: 'SvgMedia', Name?: string | null } | { __typename?: 'SvgTextCardBlock', Name?: string | null } | { __typename?: 'TabContainerBlock', Name?: string | null } | { __typename?: 'TabItemBlock', Name?: string | null } | { __typename?: 'TextCardBlock', Name?: string | null } | { __typename?: 'TextContentBlock', Name?: string | null } | { __typename?: 'TextareaElementBlock', Name?: string | null } | { __typename?: 'TextboxElementBlock', Name?: string | null } | { __typename?: 'TimelineContainerBlock', Name?: string | null } | { __typename?: 'TimelineItemBlock', Name?: string | null } | { __typename?: 'ToolkitBlock', Name?: string | null } | { __typename?: 'ToolkitItemBlock', Name?: string | null } | { __typename?: 'ToolkitSectionBlock', Name?: string | null } | { __typename?: 'ToolsCardPage', Name?: string | null } | { __typename?: 'TooltipBlock', Name?: string | null } | { __typename?: 'UrlElementBlock', Name?: string | null } | { __typename?: 'Video', Name?: string | null } | { __typename?: 'VideoBlock', Name?: string | null } | { __typename?: 'VideoDetailBlock', Name?: string | null } | { __typename?: 'VideoMedia', Name?: string | null } | { __typename?: 'VideoPromoBlock', Name?: string | null } | { __typename?: 'VisaLettersPage', Name?: string | null } | { __typename?: 'VisibilityOptionsBlock', Name?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Name?: string | null } | { __typename?: 'WireTransferSectionBlock', Name?: string | null } | { __typename?: 'YourAnswersSectionBlock', Name?: string | null } | null } | null } | null> | null, Image?: { __typename?: 'MeetingEventCardPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, EventUrl?: { __typename?: 'MeetingEventCardPageLinkBlock', DisplayText?: string | null, Target?: string | null, EventName?: string | null, EventLabel?: string | null, LinkToContent?: string | null } | null } | null> | null } | null };

export type MemberDirectoryCardContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberDirectoryCardContentQuery = { __typename?: 'Query', MemberDirectoryPage?: { __typename?: 'MemberDirectoryPageOutput', items?: Array<{ __typename?: 'MemberDirectoryPage', ContentCategory?: string | null, CardTitle?: string | null, CardDescription?: string | null, CardMembersNearYouLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, CardImage?: { __typename?: 'MemberDirectoryPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, CardUrl?: { __typename?: 'MemberDirectoryPageLinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null } | null } | null> | null } | null };

export type StoreCardContentQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreCardContentQuery = { __typename?: 'Query', StoreCardPage?: { __typename?: 'StoreCardPageOutput', items?: Array<{ __typename?: 'StoreCardPage', ContentCategory?: string | null, Title?: string | null, Description?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Image?: { __typename?: 'StoreCardPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, StoreUrl?: { __typename?: 'StoreCardPageLinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null } | null } | null> | null } | null };

export type ToolsCardContentQueryVariables = Exact<{ [key: string]: never; }>;


export type ToolsCardContentQuery = { __typename?: 'Query', ToolsCardPage?: { __typename?: 'ToolsCardPageOutput', items?: Array<{ __typename?: 'ToolsCardPage', Title?: string | null, Description?: string | null, ContentCategory?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, CardUrl?: { __typename?: 'ToolsCardPageLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, Target?: string | null } | null, Image?: { __typename?: 'ToolsCardPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null } | null> | null } | null };

export type DonationSectionContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type DonationSectionContentQuery = { __typename?: 'Query', HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, AuthenticatedContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename: 'DonationBlock', AnnualTabLabel?: string | null, LifetimeTabLabel?: string | null, AnnualChartAriaLabel?: string | null, LifetimeChartAriaLabel?: string | null, NoDonationsTitle?: string | null, NoDonationsDescription?: string | null, TabsSectionAriaLabel?: string | null, HelpText?: string | null, HelpTextJapan?: string | null, LifetimeTitleNoLevel?: string | null, LifetimeTitle?: string | null, LifetimeDescription?: string | null, AnnualTitleNoLevel?: string | null, AnnualTitle?: string | null, AnnualDescription?: string | null, AnnualDescriptionNoLevel?: string | null, DonateUrl?: { __typename?: 'DonationBlockLinkBlock', LinkToContent?: string | null, Target?: string | null, DisplayText?: string | null } | null } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null };

export type HeroSectionContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type HeroSectionContentQuery = { __typename?: 'Query', HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', MembershipYears?: string | null, DaysLeft?: string | null, FinishApplicationDisplayText?: string | null, RenewMembershipDisplayText?: string | null, UpgradeMembershipDisplayText?: string | null, ApplicationReceivedDisplayText?: string | null, ApplyForMembershipDisplayText?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MembershipPageLink?: { __typename?: 'HomePageV2LinkBlock', LinkToContent?: string | null } | null, AuthenticatedContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename: 'ProfilePictureBlock', Add?: string | null, Edit?: string | null, Upload?: string | null, PictureDescription?: string | null, Change?: string | null, Remove?: string | null, Save?: string | null, FileSizeHint?: string | null, FileSizeError?: string | null, FileTypeError?: string | null, ServerFileError?: string | null, ModalTitle?: string | null, ModalDescription?: string | null } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', Greeting?: string | null, MDRTId?: string | null, Close?: string | null, CompanyAdminButtonLabel?: string | null, CompanyAdminSectionDescriptionLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, CompanyAdminDashboardPage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', Url?: string | null } | { __typename?: 'AccordionContainerBlock', Url?: string | null } | { __typename?: 'AccordionItemBlock', Url?: string | null } | { __typename?: 'AccountProfilePage', Url?: string | null } | { __typename?: 'AddressInfoBlock', Url?: string | null } | { __typename?: 'BadgeBlock', Url?: string | null } | { __typename?: 'BrandedTableBlock', Url?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Url?: string | null } | { __typename?: 'ButtonLabelBlock', Url?: string | null } | { __typename?: 'CaptchaElementBlock', Url?: string | null } | { __typename?: 'CategoryListBlock', Url?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Url?: string | null } | { __typename?: 'CflBadgesBlock', Url?: string | null } | { __typename?: 'CflHomePage', Url?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Url?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Url?: string | null } | { __typename?: 'CflSiteSettingsPage', Url?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Url?: string | null } | { __typename?: 'ChoiceElementBlock', Url?: string | null } | { __typename?: 'ColumnContainerBlock', Url?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Url?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Url?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Url?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Url?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Url?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Url?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Url?: string | null } | { __typename?: 'CompanyRankingsPage', Url?: string | null } | { __typename?: 'ConfirmationModalBlock', Url?: string | null } | { __typename?: 'ConfirmationStepBlock', Url?: string | null } | { __typename?: 'CongratulationsStepV2Block', Url?: string | null } | { __typename?: 'ContactEmailElementBlock', Url?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Url?: string | null } | { __typename?: 'ContactNameElementBlock', Url?: string | null } | { __typename?: 'ContactPhoneElementBlock', Url?: string | null } | { __typename?: 'ContactsBlock', Url?: string | null } | { __typename?: 'Content', Url?: string | null } | { __typename?: 'DAMAsset', Url?: string | null } | { __typename?: 'DAMImageAsset', Url?: string | null } | { __typename?: 'DAMVideo', Url?: string | null } | { __typename?: 'DAMVideoAsset', Url?: string | null } | { __typename?: 'DashBoardSectionBlock', Url?: string | null } | { __typename?: 'DashboardAccountPage', Url?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Url?: string | null } | { __typename?: 'DashboardContactInformationBlock', Url?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Url?: string | null } | { __typename?: 'DashboardPermissionsBlock', Url?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Url?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Url?: string | null } | { __typename?: 'DashboardProfileBlock', Url?: string | null } | { __typename?: 'DashboardSharedPage', Url?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Url?: string | null } | { __typename?: 'DataMismatchModalBlock', Url?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Url?: string | null } | { __typename?: 'DescriptionButtonBlock', Url?: string | null } | { __typename?: 'DetailPage', Url?: string | null } | { __typename?: 'DocumentMedia', Url?: string | null } | { __typename?: 'DonationBlock', Url?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Url?: string | null } | { __typename?: 'EEPSectionBlock', Url?: string | null } | { __typename?: 'EVPCarouselBlock', Url?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Url?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Url?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Url?: string | null } | { __typename?: 'EVPContentBlock', Url?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Url?: string | null } | { __typename?: 'EVPGenericPage', Url?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Url?: string | null } | { __typename?: 'EVPHomePage', Url?: string | null } | { __typename?: 'EVPImageBlock', Url?: string | null } | { __typename?: 'EVPImageLinkBlock', Url?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Url?: string | null } | { __typename?: 'EVPLinkBlock', Url?: string | null } | { __typename?: 'EVPMediaFileBlock', Url?: string | null } | { __typename?: 'EVPNavigationPageBlock', Url?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Url?: string | null } | { __typename?: 'EVPResourcePage', Url?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Url?: string | null } | { __typename?: 'EVPSearchPage', Url?: string | null } | { __typename?: 'EVPSiteSettingsPage', Url?: string | null } | { __typename?: 'EVPTabBlock', Url?: string | null } | { __typename?: 'EVPTabCardBlock', Url?: string | null } | { __typename?: 'EVPTabCardsBlock', Url?: string | null } | { __typename?: 'EVPTabImageTextBlock', Url?: string | null } | { __typename?: 'EVPTabRichTextBlock', Url?: string | null } | { __typename?: 'EVPTabVideoBlock', Url?: string | null } | { __typename?: 'EVPTabsBlock', Url?: string | null } | { __typename?: 'EVPTextImageBlock', Url?: string | null } | { __typename?: 'EVPVideoBlock', Url?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Url?: string | null } | { __typename?: 'ErrorModalBlock', Url?: string | null } | { __typename?: 'ErrorPage', Url?: string | null } | { __typename?: 'ErrorPageBlock', Url?: string | null } | { __typename?: 'EventBlock', Url?: string | null } | { __typename?: 'EventLocationAndDateBlock', Url?: string | null } | { __typename?: 'EventLocationInformationBlock', Url?: string | null } | { __typename?: 'EventPage', Url?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Url?: string | null } | { __typename?: 'EventSessionBlock', Url?: string | null } | { __typename?: 'EventSessionScheduleBlock', Url?: string | null } | { __typename?: 'EventSessionTrackBlock', Url?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Url?: string | null } | { __typename?: 'EventSpeakerSearchPage', Url?: string | null } | { __typename?: 'EventSpeakersBlock', Url?: string | null } | { __typename?: 'EventTableContainerBlock', Url?: string | null } | { __typename?: 'ExpandableContainerBlock', Url?: string | null } | { __typename?: 'FileUploadElementBlock', Url?: string | null } | { __typename?: 'FlowFinishInformationBlock', Url?: string | null } | { __typename?: 'FolderPage', Url?: string | null } | { __typename?: 'FormContainerBlock', Url?: string | null } | { __typename?: 'FormStepBlock', Url?: string | null } | { __typename?: 'FourColumnTableBlock', Url?: string | null } | { __typename?: 'GaugeBlock', Url?: string | null } | { __typename?: 'GeoDataBlock', Url?: string | null } | { __typename?: 'GettingStartedStepBlock', Url?: string | null } | { __typename?: 'GettingStartedStepV2Block', Url?: string | null } | { __typename?: 'GreetingCaseBlock', Url?: string | null } | { __typename?: 'GreetingStepBlock', Url?: string | null } | { __typename?: 'GreetingStepV2Block', Url?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Url?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Url?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Url?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Url?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Url?: string | null } | { __typename?: 'GsAwardsPage', Url?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Url?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Url?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Url?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Url?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Url?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Url?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Url?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Url?: string | null } | { __typename?: 'GsConfirmationStepBlock', Url?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Url?: string | null } | { __typename?: 'GsGreetingStepBlock', Url?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Url?: string | null } | { __typename?: 'GsMembershipRenewalPage', Url?: string | null } | { __typename?: 'GsProfileStepBlock', Url?: string | null } | { __typename?: 'GsReceiptStepBlock', Url?: string | null } | { __typename?: 'GsReviewStepBlock', Url?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Url?: string | null } | { __typename?: 'HeroTextContentBlock', Url?: string | null } | { __typename?: 'HomePage', Url?: string | null } | { __typename?: 'HomePageV2', Url?: string | null } | { __typename?: 'IconRequirementBlock', Url?: string | null } | { __typename?: 'Image', Url?: string | null } | { __typename?: 'ImageBlock', Url?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Url?: string | null } | { __typename?: 'ImageChoiceElementBlock', Url?: string | null } | { __typename?: 'ImageLinkBlock', Url?: string | null } | { __typename?: 'ImageMedia', Url?: string | null } | { __typename?: 'ImageTextBlock', Url?: string | null } | { __typename?: 'ImageTextBlockV2', Url?: string | null } | { __typename?: 'ImageTextCardBlock', Url?: string | null } | { __typename?: 'ImageTextItemBlock', Url?: string | null } | { __typename?: 'InfoBoxBlock', Url?: string | null } | { __typename?: 'KeyLinkValueBlock', Url?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Url?: string | null } | { __typename?: 'LandingPage', Url?: string | null } | { __typename?: 'LanguageIdAndName', Url?: string | null } | { __typename?: 'LanguagesBlock', Url?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Url?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Url?: string | null } | { __typename?: 'LearnDetailPage', Url?: string | null } | { __typename?: 'LearnHeroImageBlock', Url?: string | null } | { __typename?: 'LearnLandingPage', Url?: string | null } | { __typename?: 'LearnPageV2', Url?: string | null } | { __typename?: 'LearnPlayListPage', Url?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Url?: string | null } | { __typename?: 'LinkBlock', Url?: string | null } | { __typename?: 'LinkListBlock', Url?: string | null } | { __typename?: 'LinkTileBlock', Url?: string | null } | { __typename?: 'LoaderBlock', Url?: string | null } | { __typename?: 'LocationBlock', Url?: string | null } | { __typename?: 'MeetingEventCardPage', Url?: string | null } | { __typename?: 'MeetingPage', Url?: string | null } | { __typename?: 'MemberDirectory', Url?: string | null } | { __typename?: 'MemberDirectoryPage', Url?: string | null } | { __typename?: 'MemberSectionBlock', Url?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Url?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Url?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Url?: string | null } | { __typename?: 'MembershipInvoicePage', Url?: string | null } | { __typename?: 'MembershipLevelBlock', Url?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Url?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Url?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Url?: string | null } | { __typename?: 'MembershipLevelsBlock', Url?: string | null } | { __typename?: 'MembershipRenewalPage', Url?: string | null } | { __typename?: 'MembershipRenewalV2Page', Url?: string | null } | { __typename?: 'MembershipRequirementBlock', Url?: string | null } | { __typename?: 'MembershipRequirementsBlock', Url?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Url?: string | null } | { __typename?: 'MembershipTypeStepBlock', Url?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Url?: string | null } | { __typename?: 'ModalInfoBlock', Url?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Url?: string | null } | { __typename?: 'NextCallOutBlock', Url?: string | null } | { __typename?: 'NextContactUsBlock', Url?: string | null } | { __typename?: 'NextContainerBlock', Url?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Url?: string | null } | { __typename?: 'NextEventBlock', Url?: string | null } | { __typename?: 'NextHeroBlock', Url?: string | null } | { __typename?: 'NextInfoBoxBlock', Url?: string | null } | { __typename?: 'NextPersonContainerBlock', Url?: string | null } | { __typename?: 'NextPersonDataBlock', Url?: string | null } | { __typename?: 'NextStaffAdminPage', Url?: string | null } | { __typename?: 'NextStaticPage', Url?: string | null } | { __typename?: 'NextSyncEventsBlock', Url?: string | null } | { __typename?: 'NotFoundPage', Url?: string | null } | { __typename?: 'NumberElementBlock', Url?: string | null } | { __typename?: 'NumberedContainerBlock', Url?: string | null } | { __typename?: 'NumberedItemBlock', Url?: string | null } | { __typename?: 'ParagraphTextElementBlock', Url?: string | null } | { __typename?: 'PastPresidentsBlock', Url?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Url?: string | null } | { __typename?: 'PersonBlock', Url?: string | null } | { __typename?: 'PersonContainerBlock', Url?: string | null } | { __typename?: 'PersonQuizPage', Url?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Url?: string | null } | { __typename?: 'PlaylistBlock', Url?: string | null } | { __typename?: 'PlaylistPromoBlock', Url?: string | null } | { __typename?: 'PodcastDetailBlock', Url?: string | null } | { __typename?: 'PowerPhrasePage', Url?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Url?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Url?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Url?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Url?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Url?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Url?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Url?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Url?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Url?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Url?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Url?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Url?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Url?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Url?: string | null } | { __typename?: 'PrepaymentPortalPage', Url?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Url?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Url?: string | null } | { __typename?: 'PressReleasePage', Url?: string | null } | { __typename?: 'PriceBreakdownBlock', Url?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Url?: string | null } | { __typename?: 'ProductionDataSectionBlock', Url?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Url?: string | null } | { __typename?: 'ProductionModalBlock', Url?: string | null } | { __typename?: 'ProductionStepBlock', Url?: string | null } | { __typename?: 'ProductionStepV2Block', Url?: string | null } | { __typename?: 'ProductionTableBlock', Url?: string | null } | { __typename?: 'ProfileListBlock', Url?: string | null } | { __typename?: 'ProfilePictureBlock', Url?: string | null } | { __typename?: 'ProfileSectionBlock', Url?: string | null } | { __typename?: 'ProfileStepBlock', Url?: string | null } | { __typename?: 'ProfileStepV2Block', Url?: string | null } | { __typename?: 'PublicProfilePage', Url?: string | null } | { __typename?: 'QuizCareerBlock', Url?: string | null } | { __typename?: 'QuizEducationBlock', Url?: string | null } | { __typename?: 'QuizFinancialBlock', Url?: string | null } | { __typename?: 'QuizHealthBlock', Url?: string | null } | { __typename?: 'QuizRelationshipsBlock', Url?: string | null } | { __typename?: 'QuizServiceBlock', Url?: string | null } | { __typename?: 'QuizSpiritualBlock', Url?: string | null } | { __typename?: 'RTContributorFormPage', Url?: string | null } | { __typename?: 'RangeElementBlock', Url?: string | null } | { __typename?: 'ReceiptStepBlock', Url?: string | null } | { __typename?: 'ReceiptStepV2Block', Url?: string | null } | { __typename?: 'ResetButtonElementBlock', Url?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Url?: string | null } | { __typename?: 'ReviewBlock', Url?: string | null } | { __typename?: 'ReviewStepBlock', Url?: string | null } | { __typename?: 'RichTextBlock', Url?: string | null } | { __typename?: 'RoutingStepBlock', Url?: string | null } | { __typename?: 'SearchPage', Url?: string | null } | { __typename?: 'SearchPageV2', Url?: string | null } | { __typename?: 'SectionContainerBlock', Url?: string | null } | { __typename?: 'SectionItemBlock', Url?: string | null } | { __typename?: 'SelectionElementBlock', Url?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Url?: string | null } | { __typename?: 'SettingSectionBlock', Url?: string | null } | { __typename?: 'SiteSettingsPage', Url?: string | null } | { __typename?: 'SocialShareBlock', Url?: string | null } | { __typename?: 'SpeakerEngagementPage', Url?: string | null } | { __typename?: 'SponsorSpeakerPage', Url?: string | null } | { __typename?: 'SpotlightBlock', Url?: string | null } | { __typename?: 'SpotlightContainerBlock', Url?: string | null } | { __typename?: 'SpotlightDataBlock', Url?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Url?: string | null } | { __typename?: 'StoreCardPage', Url?: string | null } | { __typename?: 'SubmitButtonElementBlock', Url?: string | null } | { __typename?: 'SuccessSectionBlock', Url?: string | null } | { __typename?: 'SvgLinkBlock', Url?: string | null } | { __typename?: 'SvgMedia', Url?: string | null } | { __typename?: 'SvgTextCardBlock', Url?: string | null } | { __typename?: 'TabContainerBlock', Url?: string | null } | { __typename?: 'TabItemBlock', Url?: string | null } | { __typename?: 'TextCardBlock', Url?: string | null } | { __typename?: 'TextContentBlock', Url?: string | null } | { __typename?: 'TextareaElementBlock', Url?: string | null } | { __typename?: 'TextboxElementBlock', Url?: string | null } | { __typename?: 'TimelineContainerBlock', Url?: string | null } | { __typename?: 'TimelineItemBlock', Url?: string | null } | { __typename?: 'ToolkitBlock', Url?: string | null } | { __typename?: 'ToolkitItemBlock', Url?: string | null } | { __typename?: 'ToolkitSectionBlock', Url?: string | null } | { __typename?: 'ToolsCardPage', Url?: string | null } | { __typename?: 'TooltipBlock', Url?: string | null } | { __typename?: 'UrlElementBlock', Url?: string | null } | { __typename?: 'Video', Url?: string | null } | { __typename?: 'VideoBlock', Url?: string | null } | { __typename?: 'VideoDetailBlock', Url?: string | null } | { __typename?: 'VideoMedia', Url?: string | null } | { __typename?: 'VideoPromoBlock', Url?: string | null } | { __typename?: 'VisaLettersPage', Url?: string | null } | { __typename?: 'VisibilityOptionsBlock', Url?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Url?: string | null } | { __typename?: 'WireTransferSectionBlock', Url?: string | null } | { __typename?: 'YourAnswersSectionBlock', Url?: string | null } | null } | null } | null> | null } | null };

export type MembershipToolkitBlockContentQueryVariables = Exact<{
  guid: Scalars['String']['input'];
}>;


export type MembershipToolkitBlockContentQuery = { __typename?: 'Query', ToolkitBlock?: { __typename?: 'ToolkitBlockOutput', items?: Array<{ __typename: 'ToolkitBlock', Title?: string | null, Description?: string | null, AnchorLink?: string | null, PreferredLanguage?: string | null, Country?: string | null, MembershipLevel?: string | null, MemberType?: string | null, CareerStage?: string | null, LearnResourceTopic?: string | null, MeetingRegistrationStatus?: string | null, FoundationDonorLevel?: string | null, TotalMemberYearsCountFrom?: number | null, TotalMemberYearsCountTo?: number | null, MeetingId?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Tabs?: Array<{ __typename: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock', Title?: string | null, Description?: string | null, Layout?: string | null, Sections?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock', Title?: string | null, PreferredLanguage?: string | null, Country?: string | null, MembershipLevel?: string | null, MemberType?: string | null, CareerStage?: string | null, LearnResourceTopic?: string | null, MeetingRegistrationStatus?: string | null, FoundationDonorLevel?: string | null, TotalMemberYearsCountFrom?: number | null, TotalMemberYearsCountTo?: number | null, MeetingId?: string | null, Items?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, IconClass?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null };

export type ToolkitItemVisibilityOptionsFragment = { __typename?: 'ToolkitBlock', PreferredLanguage?: string | null, Country?: string | null, MembershipLevel?: string | null, MemberType?: string | null, CareerStage?: string | null, LearnResourceTopic?: string | null, MeetingRegistrationStatus?: string | null, FoundationDonorLevel?: string | null, TotalMemberYearsCountFrom?: number | null, TotalMemberYearsCountTo?: number | null, MeetingId?: string | null };

export type ToolkitSectionBlockVisibilityOptionsFragment = { __typename?: 'ToolkitSectionBlock', PreferredLanguage?: string | null, Country?: string | null, MembershipLevel?: string | null, MemberType?: string | null, CareerStage?: string | null, LearnResourceTopic?: string | null, MeetingRegistrationStatus?: string | null, FoundationDonorLevel?: string | null, TotalMemberYearsCountFrom?: number | null, TotalMemberYearsCountTo?: number | null, MeetingId?: string | null };

export type MembershipToolkitBlockGuidQueryVariables = Exact<{ [key: string]: never; }>;


export type MembershipToolkitBlockGuidQuery = { __typename?: 'Query', HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename: 'HomePageV2', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, AuthenticatedContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null };

export type ScoreSectionContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type ScoreSectionContentQuery = { __typename?: 'Query', HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, AuthenticatedContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock', GaugeAriaLabel?: string | null, Relationships?: string | null, Health?: string | null, Education?: string | null, Career?: string | null, Service?: string | null, Financial?: string | null, Spiritual?: string | null, Headline?: string | null, UpdateScoresLink?: { __typename?: 'GaugeBlockLinkBlock', DisplayText?: string | null, LinkToContent?: string | null } | null } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null };

export type MemberResourcesCountQueryVariables = Exact<{
  where?: InputMaybe<LearnDetailPageWhereInput>;
}>;


export type MemberResourcesCountQuery = { __typename?: 'Query', LearnDetailPage?: { __typename?: 'LearnDetailPageOutput', total?: number | null } | null };

export type PeopleListCmsContentQueryVariables = Exact<{ [key: string]: never; }>;


export type PeopleListCmsContentQuery = { __typename?: 'Query', LearnPageV2?: { __typename?: 'LearnPageV2Output', items?: Array<{ __typename?: 'LearnPageV2', DetailPageMemberYearsSubheading?: string | null, DetailPageAuthorsHeading?: string | null, DetailPageMemberEmailButtonAriaLabelText?: string | null, DetailPageMemberDetailsButtonAriaLabelText?: string | null, DetailPageAuthorModalResoucesButtonLabelText?: string | null, DetailPageViewResourcesLinkLabelText?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type ProfileListBlockTranslationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileListBlockTranslationsQuery = { __typename?: 'Query', LearnPageV2?: { __typename?: 'LearnPageV2Output', items?: Array<{ __typename?: 'LearnPageV2', DetailPageMemberYearsSubheading?: string | null, DetailPageMemberEmailButtonAriaLabelText?: string | null, DetailPageMemberDetailsButtonAriaLabelText?: string | null, DetailPageAuthorModalResoucesButtonLabelText?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type ProfileListFromGuidQueryVariables = Exact<{
  guid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileListFromGuidQuery = { __typename?: 'Query', ProfileListBlock?: { __typename?: 'ProfileListBlockOutput', items?: Array<{ __typename?: 'ProfileListBlock', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ProfileList?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2' } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock', Name?: string | null, Title?: string | null, Description?: string | null, MemberYears?: string | null, Country?: string | null, EmailAddress?: string | null, City?: string | null, Image?: { __typename?: 'PersonBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock' } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null };

export type ProfileListLinkFragment = { __typename?: 'ProfileListBlock', Preheading?: string | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null };

export type LearnDetailPageFragment = { __typename?: 'LearnDetailPage', Heading?: string | null, Subheading?: string | null, SubheadingText?: string | null, Description?: string | null, ContentTypeSelection?: number | null, DisplayedDate?: any | null, AssignedGroupsReadAccess?: Array<{ __typename?: 'AssignedGroupPropertyValue', GroupName?: string | null } | null> | null, ExpandedCategories?: Array<{ __typename?: 'ExpandedCategoriesEntry', Name?: string | null, ParentId?: number | null } | null> | null, ExpandedSources?: Array<{ __typename?: 'ExpandedSourcesEntry', Id?: number | null, Name?: string | null } | null> | null, ExpandedTopics?: Array<{ __typename?: 'ExpandedTopicsEntry', Id?: number | null, Name?: string | null } | null> | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2', Type?: string | null, Heading?: string | null, SourcesFilterAllSelectionLabel?: string | null, ShowSourcesFilter?: any | null, ShowMagazineIssueFilter?: any | null, SelectedSources?: Array<{ __typename?: 'ContentModelReference', Id?: number | null } | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ExpandedSelectedSources?: Array<{ __typename?: 'SourcesEntry', Id?: number | null, Name?: string | null } | null> | null, ExpandedSelectedTopics?: Array<{ __typename?: 'TopicsEntry', Id?: number | null, Name?: string | null } | null> | null } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock', Preheading?: string | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null, Resource?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2' } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock', HeroImage?: { __typename?: 'LearnHeroImageBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, MobileImage?: { __typename?: 'LearnHeroImageBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock', ImageBlock?: { __typename?: 'PodcastDetailBlockLearnHeroImageBlock', HeroImage?: { __typename?: 'PodcastDetailBlockLearnHeroImageBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, MobileImage?: { __typename?: 'PodcastDetailBlockLearnHeroImageBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null } | null, AudioContent?: { __typename?: 'ContentModelReference', Url?: string | null } | null, ViewTranscript?: { __typename?: 'PodcastDetailBlockRichTextBlock', Content?: string | null } | null } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock' } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock', ViewTranscriptLine?: string | null, ViewTranscript?: { __typename?: 'VideoDetailBlockRichTextBlock', Content?: string | null } | null, Video?: { __typename?: 'VideoDetailBlockVideoBlock', AltText?: string | null, VideoReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null, Authors?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2' } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock', Name?: string | null, Title?: string | null, Description?: string | null, MemberYears?: string | null, Country?: string | null, EmailAddress?: string | null, City?: string | null, Image?: { __typename?: 'PersonBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock' } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null };

export type LearnDetailPageQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type LearnDetailPageQuery = { __typename?: 'Query', LearnDetailPage?: { __typename?: 'LearnDetailPageOutput', items?: Array<{ __typename?: 'LearnDetailPage', Heading?: string | null, Subheading?: string | null, SubheadingText?: string | null, Description?: string | null, ContentTypeSelection?: number | null, DisplayedDate?: any | null, AssignedGroupsReadAccess?: Array<{ __typename?: 'AssignedGroupPropertyValue', GroupName?: string | null } | null> | null, ExpandedCategories?: Array<{ __typename?: 'ExpandedCategoriesEntry', Name?: string | null, ParentId?: number | null } | null> | null, ExpandedSources?: Array<{ __typename?: 'ExpandedSourcesEntry', Id?: number | null, Name?: string | null } | null> | null, ExpandedTopics?: Array<{ __typename?: 'ExpandedTopicsEntry', Id?: number | null, Name?: string | null } | null> | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2', Type?: string | null, Heading?: string | null, SourcesFilterAllSelectionLabel?: string | null, ShowSourcesFilter?: any | null, ShowMagazineIssueFilter?: any | null, SelectedSources?: Array<{ __typename?: 'ContentModelReference', Id?: number | null } | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ExpandedSelectedSources?: Array<{ __typename?: 'SourcesEntry', Id?: number | null, Name?: string | null } | null> | null, ExpandedSelectedTopics?: Array<{ __typename?: 'TopicsEntry', Id?: number | null, Name?: string | null } | null> | null } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock', Preheading?: string | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null, Resource?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2' } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock', HeroImage?: { __typename?: 'LearnHeroImageBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, MobileImage?: { __typename?: 'LearnHeroImageBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock', ImageBlock?: { __typename?: 'PodcastDetailBlockLearnHeroImageBlock', HeroImage?: { __typename?: 'PodcastDetailBlockLearnHeroImageBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, MobileImage?: { __typename?: 'PodcastDetailBlockLearnHeroImageBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null } | null, AudioContent?: { __typename?: 'ContentModelReference', Url?: string | null } | null, ViewTranscript?: { __typename?: 'PodcastDetailBlockRichTextBlock', Content?: string | null } | null } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock' } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock', ViewTranscriptLine?: string | null, ViewTranscript?: { __typename?: 'VideoDetailBlockRichTextBlock', Content?: string | null } | null, Video?: { __typename?: 'VideoDetailBlockVideoBlock', AltText?: string | null, VideoReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null, Authors?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2' } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock', Name?: string | null, Title?: string | null, Description?: string | null, MemberYears?: string | null, Country?: string | null, EmailAddress?: string | null, City?: string | null, Image?: { __typename?: 'PersonBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock' } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null } | null> | null } | null };

export type LearnLandingPageFeaturedContentQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type LearnLandingPageFeaturedContentQuery = { __typename?: 'Query', LearnDetailPage?: { __typename?: 'LearnDetailPageOutput', items?: Array<{ __typename?: 'LearnDetailPage', RelativePath?: string | null, ReadTimeInSeconds?: number | null, ContentTypeSelection?: number | null, Subheading?: string | null, SubheadingText?: string | null, Heading?: string | null, MagazineIssueYear?: number | null, MagazineIssueMonth?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null, ExpandedCategories?: Array<{ __typename?: 'ExpandedCategoriesEntry', Id?: number | null, ParentId?: number | null, Name?: string | null } | null> | null, ThumbnailImage?: { __typename?: 'LearnDetailPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Authors?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock', Name?: string | null } | { __typename?: 'AccordionContainerBlock', Name?: string | null } | { __typename?: 'AccordionItemBlock', Name?: string | null } | { __typename?: 'AccountProfilePage', Name?: string | null } | { __typename?: 'AddressInfoBlock', Name?: string | null } | { __typename?: 'BadgeBlock', Name?: string | null } | { __typename?: 'BrandedTableBlock', Name?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Name?: string | null } | { __typename?: 'ButtonLabelBlock', Name?: string | null } | { __typename?: 'CaptchaElementBlock', Name?: string | null } | { __typename?: 'CategoryListBlock', Name?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Name?: string | null } | { __typename?: 'CflBadgesBlock', Name?: string | null } | { __typename?: 'CflHomePage', Name?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Name?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Name?: string | null } | { __typename?: 'CflSiteSettingsPage', Name?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Name?: string | null } | { __typename?: 'ChoiceElementBlock', Name?: string | null } | { __typename?: 'ColumnContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Name?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Name?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Name?: string | null } | { __typename?: 'CompanyRankingsPage', Name?: string | null } | { __typename?: 'ConfirmationModalBlock', Name?: string | null } | { __typename?: 'ConfirmationStepBlock', Name?: string | null } | { __typename?: 'CongratulationsStepV2Block', Name?: string | null } | { __typename?: 'ContactEmailElementBlock', Name?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Name?: string | null } | { __typename?: 'ContactNameElementBlock', Name?: string | null } | { __typename?: 'ContactPhoneElementBlock', Name?: string | null } | { __typename?: 'ContactsBlock', Name?: string | null } | { __typename?: 'Content', Name?: string | null } | { __typename?: 'DAMAsset', Name?: string | null } | { __typename?: 'DAMImageAsset', Name?: string | null } | { __typename?: 'DAMVideo', Name?: string | null } | { __typename?: 'DAMVideoAsset', Name?: string | null } | { __typename?: 'DashBoardSectionBlock', Name?: string | null } | { __typename?: 'DashboardAccountPage', Name?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Name?: string | null } | { __typename?: 'DashboardContactInformationBlock', Name?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Name?: string | null } | { __typename?: 'DashboardPermissionsBlock', Name?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfileBlock', Name?: string | null } | { __typename?: 'DashboardSharedPage', Name?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Name?: string | null } | { __typename?: 'DataMismatchModalBlock', Name?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Name?: string | null } | { __typename?: 'DescriptionButtonBlock', Name?: string | null } | { __typename?: 'DetailPage', Name?: string | null } | { __typename?: 'DocumentMedia', Name?: string | null } | { __typename?: 'DonationBlock', Name?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Name?: string | null } | { __typename?: 'EEPSectionBlock', Name?: string | null } | { __typename?: 'EVPCarouselBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Name?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Name?: string | null } | { __typename?: 'EVPContentBlock', Name?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Name?: string | null } | { __typename?: 'EVPGenericPage', Name?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Name?: string | null } | { __typename?: 'EVPHomePage', Name?: string | null } | { __typename?: 'EVPImageBlock', Name?: string | null } | { __typename?: 'EVPImageLinkBlock', Name?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Name?: string | null } | { __typename?: 'EVPLinkBlock', Name?: string | null } | { __typename?: 'EVPMediaFileBlock', Name?: string | null } | { __typename?: 'EVPNavigationPageBlock', Name?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Name?: string | null } | { __typename?: 'EVPResourcePage', Name?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Name?: string | null } | { __typename?: 'EVPSearchPage', Name?: string | null } | { __typename?: 'EVPSiteSettingsPage', Name?: string | null } | { __typename?: 'EVPTabBlock', Name?: string | null } | { __typename?: 'EVPTabCardBlock', Name?: string | null } | { __typename?: 'EVPTabCardsBlock', Name?: string | null } | { __typename?: 'EVPTabImageTextBlock', Name?: string | null } | { __typename?: 'EVPTabRichTextBlock', Name?: string | null } | { __typename?: 'EVPTabVideoBlock', Name?: string | null } | { __typename?: 'EVPTabsBlock', Name?: string | null } | { __typename?: 'EVPTextImageBlock', Name?: string | null } | { __typename?: 'EVPVideoBlock', Name?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'ErrorModalBlock', Name?: string | null } | { __typename?: 'ErrorPage', Name?: string | null } | { __typename?: 'ErrorPageBlock', Name?: string | null } | { __typename?: 'EventBlock', Name?: string | null } | { __typename?: 'EventLocationAndDateBlock', Name?: string | null } | { __typename?: 'EventLocationInformationBlock', Name?: string | null } | { __typename?: 'EventPage', Name?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Name?: string | null } | { __typename?: 'EventSessionBlock', Name?: string | null } | { __typename?: 'EventSessionScheduleBlock', Name?: string | null } | { __typename?: 'EventSessionTrackBlock', Name?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Name?: string | null } | { __typename?: 'EventSpeakerSearchPage', Name?: string | null } | { __typename?: 'EventSpeakersBlock', Name?: string | null } | { __typename?: 'EventTableContainerBlock', Name?: string | null } | { __typename?: 'ExpandableContainerBlock', Name?: string | null } | { __typename?: 'FileUploadElementBlock', Name?: string | null } | { __typename?: 'FlowFinishInformationBlock', Name?: string | null } | { __typename?: 'FolderPage', Name?: string | null } | { __typename?: 'FormContainerBlock', Name?: string | null } | { __typename?: 'FormStepBlock', Name?: string | null } | { __typename?: 'FourColumnTableBlock', Name?: string | null } | { __typename?: 'GaugeBlock', Name?: string | null } | { __typename?: 'GeoDataBlock', Name?: string | null } | { __typename?: 'GettingStartedStepBlock', Name?: string | null } | { __typename?: 'GettingStartedStepV2Block', Name?: string | null } | { __typename?: 'GreetingCaseBlock', Name?: string | null } | { __typename?: 'GreetingStepBlock', Name?: string | null } | { __typename?: 'GreetingStepV2Block', Name?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Name?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Name?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Name?: string | null } | { __typename?: 'GsAwardsPage', Name?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Name?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Name?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Name?: string | null } | { __typename?: 'GsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsGreetingStepBlock', Name?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Name?: string | null } | { __typename?: 'GsMembershipRenewalPage', Name?: string | null } | { __typename?: 'GsProfileStepBlock', Name?: string | null } | { __typename?: 'GsReceiptStepBlock', Name?: string | null } | { __typename?: 'GsReviewStepBlock', Name?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Name?: string | null } | { __typename?: 'HeroTextContentBlock', Name?: string | null } | { __typename?: 'HomePage', Name?: string | null } | { __typename?: 'HomePageV2', Name?: string | null } | { __typename?: 'IconRequirementBlock', Name?: string | null } | { __typename?: 'Image', Name?: string | null } | { __typename?: 'ImageBlock', Name?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Name?: string | null } | { __typename?: 'ImageChoiceElementBlock', Name?: string | null } | { __typename?: 'ImageLinkBlock', Name?: string | null } | { __typename?: 'ImageMedia', Name?: string | null } | { __typename?: 'ImageTextBlock', Name?: string | null } | { __typename?: 'ImageTextBlockV2', Name?: string | null } | { __typename?: 'ImageTextCardBlock', Name?: string | null } | { __typename?: 'ImageTextItemBlock', Name?: string | null } | { __typename?: 'InfoBoxBlock', Name?: string | null } | { __typename?: 'KeyLinkValueBlock', Name?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Name?: string | null } | { __typename?: 'LandingPage', Name?: string | null } | { __typename?: 'LanguageIdAndName', Name?: string | null } | { __typename?: 'LanguagesBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Name?: string | null } | { __typename?: 'LearnDetailPage', Name?: string | null } | { __typename?: 'LearnHeroImageBlock', Name?: string | null } | { __typename?: 'LearnLandingPage', Name?: string | null } | { __typename?: 'LearnPageV2', Name?: string | null } | { __typename?: 'LearnPlayListPage', Name?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Name?: string | null } | { __typename?: 'LinkBlock', Name?: string | null } | { __typename?: 'LinkListBlock', Name?: string | null } | { __typename?: 'LinkTileBlock', Name?: string | null } | { __typename?: 'LoaderBlock', Name?: string | null } | { __typename?: 'LocationBlock', Name?: string | null } | { __typename?: 'MeetingEventCardPage', Name?: string | null } | { __typename?: 'MeetingPage', Name?: string | null } | { __typename?: 'MemberDirectory', Name?: string | null } | { __typename?: 'MemberDirectoryPage', Name?: string | null } | { __typename?: 'MemberSectionBlock', Name?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Name?: string | null } | { __typename?: 'MembershipInvoicePage', Name?: string | null } | { __typename?: 'MembershipLevelBlock', Name?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Name?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Name?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Name?: string | null } | { __typename?: 'MembershipLevelsBlock', Name?: string | null } | { __typename?: 'MembershipRenewalPage', Name?: string | null } | { __typename?: 'MembershipRenewalV2Page', Name?: string | null } | { __typename?: 'MembershipRequirementBlock', Name?: string | null } | { __typename?: 'MembershipRequirementsBlock', Name?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Name?: string | null } | { __typename?: 'ModalInfoBlock', Name?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Name?: string | null } | { __typename?: 'NextCallOutBlock', Name?: string | null } | { __typename?: 'NextContactUsBlock', Name?: string | null } | { __typename?: 'NextContainerBlock', Name?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Name?: string | null } | { __typename?: 'NextEventBlock', Name?: string | null } | { __typename?: 'NextHeroBlock', Name?: string | null } | { __typename?: 'NextInfoBoxBlock', Name?: string | null } | { __typename?: 'NextPersonContainerBlock', Name?: string | null } | { __typename?: 'NextPersonDataBlock', Name?: string | null } | { __typename?: 'NextStaffAdminPage', Name?: string | null } | { __typename?: 'NextStaticPage', Name?: string | null } | { __typename?: 'NextSyncEventsBlock', Name?: string | null } | { __typename?: 'NotFoundPage', Name?: string | null } | { __typename?: 'NumberElementBlock', Name?: string | null } | { __typename?: 'NumberedContainerBlock', Name?: string | null } | { __typename?: 'NumberedItemBlock', Name?: string | null } | { __typename?: 'ParagraphTextElementBlock', Name?: string | null } | { __typename?: 'PastPresidentsBlock', Name?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Name?: string | null } | { __typename?: 'PersonBlock', Name?: string | null } | { __typename?: 'PersonContainerBlock', Name?: string | null } | { __typename?: 'PersonQuizPage', Name?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Name?: string | null } | { __typename?: 'PlaylistBlock', Name?: string | null } | { __typename?: 'PlaylistPromoBlock', Name?: string | null } | { __typename?: 'PodcastDetailBlock', Name?: string | null } | { __typename?: 'PowerPhrasePage', Name?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Name?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Name?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPortalPage', Name?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Name?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Name?: string | null } | { __typename?: 'PressReleasePage', Name?: string | null } | { __typename?: 'PriceBreakdownBlock', Name?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Name?: string | null } | { __typename?: 'ProductionDataSectionBlock', Name?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Name?: string | null } | { __typename?: 'ProductionModalBlock', Name?: string | null } | { __typename?: 'ProductionStepBlock', Name?: string | null } | { __typename?: 'ProductionStepV2Block', Name?: string | null } | { __typename?: 'ProductionTableBlock', Name?: string | null } | { __typename?: 'ProfileListBlock', Name?: string | null } | { __typename?: 'ProfilePictureBlock', Name?: string | null } | { __typename?: 'ProfileSectionBlock', Name?: string | null } | { __typename?: 'ProfileStepBlock', Name?: string | null } | { __typename?: 'ProfileStepV2Block', Name?: string | null } | { __typename?: 'PublicProfilePage', Name?: string | null } | { __typename?: 'QuizCareerBlock', Name?: string | null } | { __typename?: 'QuizEducationBlock', Name?: string | null } | { __typename?: 'QuizFinancialBlock', Name?: string | null } | { __typename?: 'QuizHealthBlock', Name?: string | null } | { __typename?: 'QuizRelationshipsBlock', Name?: string | null } | { __typename?: 'QuizServiceBlock', Name?: string | null } | { __typename?: 'QuizSpiritualBlock', Name?: string | null } | { __typename?: 'RTContributorFormPage', Name?: string | null } | { __typename?: 'RangeElementBlock', Name?: string | null } | { __typename?: 'ReceiptStepBlock', Name?: string | null } | { __typename?: 'ReceiptStepV2Block', Name?: string | null } | { __typename?: 'ResetButtonElementBlock', Name?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Name?: string | null } | { __typename?: 'ReviewBlock', Name?: string | null } | { __typename?: 'ReviewStepBlock', Name?: string | null } | { __typename?: 'RichTextBlock', Name?: string | null } | { __typename?: 'RoutingStepBlock', Name?: string | null } | { __typename?: 'SearchPage', Name?: string | null } | { __typename?: 'SearchPageV2', Name?: string | null } | { __typename?: 'SectionContainerBlock', Name?: string | null } | { __typename?: 'SectionItemBlock', Name?: string | null } | { __typename?: 'SelectionElementBlock', Name?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Name?: string | null } | { __typename?: 'SettingSectionBlock', Name?: string | null } | { __typename?: 'SiteSettingsPage', Name?: string | null } | { __typename?: 'SocialShareBlock', Name?: string | null } | { __typename?: 'SpeakerEngagementPage', Name?: string | null } | { __typename?: 'SponsorSpeakerPage', Name?: string | null } | { __typename?: 'SpotlightBlock', Name?: string | null } | { __typename?: 'SpotlightContainerBlock', Name?: string | null } | { __typename?: 'SpotlightDataBlock', Name?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Name?: string | null } | { __typename?: 'StoreCardPage', Name?: string | null } | { __typename?: 'SubmitButtonElementBlock', Name?: string | null } | { __typename?: 'SuccessSectionBlock', Name?: string | null } | { __typename?: 'SvgLinkBlock', Name?: string | null } | { __typename?: 'SvgMedia', Name?: string | null } | { __typename?: 'SvgTextCardBlock', Name?: string | null } | { __typename?: 'TabContainerBlock', Name?: string | null } | { __typename?: 'TabItemBlock', Name?: string | null } | { __typename?: 'TextCardBlock', Name?: string | null } | { __typename?: 'TextContentBlock', Name?: string | null } | { __typename?: 'TextareaElementBlock', Name?: string | null } | { __typename?: 'TextboxElementBlock', Name?: string | null } | { __typename?: 'TimelineContainerBlock', Name?: string | null } | { __typename?: 'TimelineItemBlock', Name?: string | null } | { __typename?: 'ToolkitBlock', Name?: string | null } | { __typename?: 'ToolkitItemBlock', Name?: string | null } | { __typename?: 'ToolkitSectionBlock', Name?: string | null } | { __typename?: 'ToolsCardPage', Name?: string | null } | { __typename?: 'TooltipBlock', Name?: string | null } | { __typename?: 'UrlElementBlock', Name?: string | null } | { __typename?: 'Video', Name?: string | null } | { __typename?: 'VideoBlock', Name?: string | null } | { __typename?: 'VideoDetailBlock', Name?: string | null } | { __typename?: 'VideoMedia', Name?: string | null } | { __typename?: 'VideoPromoBlock', Name?: string | null } | { __typename?: 'VisaLettersPage', Name?: string | null } | { __typename?: 'VisibilityOptionsBlock', Name?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Name?: string | null } | { __typename?: 'WireTransferSectionBlock', Name?: string | null } | { __typename?: 'YourAnswersSectionBlock', Name?: string | null } | null } | null } | null> | null, AssignedGroupsReadAccess?: Array<{ __typename?: 'AssignedGroupPropertyValue', GroupName?: string | null } | null> | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2' } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock', ProfileList?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock', Name?: string | null } | { __typename?: 'AccordionContainerBlock', Name?: string | null } | { __typename?: 'AccordionItemBlock', Name?: string | null } | { __typename?: 'AccountProfilePage', Name?: string | null } | { __typename?: 'AddressInfoBlock', Name?: string | null } | { __typename?: 'BadgeBlock', Name?: string | null } | { __typename?: 'BrandedTableBlock', Name?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Name?: string | null } | { __typename?: 'ButtonLabelBlock', Name?: string | null } | { __typename?: 'CaptchaElementBlock', Name?: string | null } | { __typename?: 'CategoryListBlock', Name?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Name?: string | null } | { __typename?: 'CflBadgesBlock', Name?: string | null } | { __typename?: 'CflHomePage', Name?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Name?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Name?: string | null } | { __typename?: 'CflSiteSettingsPage', Name?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Name?: string | null } | { __typename?: 'ChoiceElementBlock', Name?: string | null } | { __typename?: 'ColumnContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Name?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Name?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Name?: string | null } | { __typename?: 'CompanyRankingsPage', Name?: string | null } | { __typename?: 'ConfirmationModalBlock', Name?: string | null } | { __typename?: 'ConfirmationStepBlock', Name?: string | null } | { __typename?: 'CongratulationsStepV2Block', Name?: string | null } | { __typename?: 'ContactEmailElementBlock', Name?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Name?: string | null } | { __typename?: 'ContactNameElementBlock', Name?: string | null } | { __typename?: 'ContactPhoneElementBlock', Name?: string | null } | { __typename?: 'ContactsBlock', Name?: string | null } | { __typename?: 'Content', Name?: string | null } | { __typename?: 'DAMAsset', Name?: string | null } | { __typename?: 'DAMImageAsset', Name?: string | null } | { __typename?: 'DAMVideo', Name?: string | null } | { __typename?: 'DAMVideoAsset', Name?: string | null } | { __typename?: 'DashBoardSectionBlock', Name?: string | null } | { __typename?: 'DashboardAccountPage', Name?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Name?: string | null } | { __typename?: 'DashboardContactInformationBlock', Name?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Name?: string | null } | { __typename?: 'DashboardPermissionsBlock', Name?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfileBlock', Name?: string | null } | { __typename?: 'DashboardSharedPage', Name?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Name?: string | null } | { __typename?: 'DataMismatchModalBlock', Name?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Name?: string | null } | { __typename?: 'DescriptionButtonBlock', Name?: string | null } | { __typename?: 'DetailPage', Name?: string | null } | { __typename?: 'DocumentMedia', Name?: string | null } | { __typename?: 'DonationBlock', Name?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Name?: string | null } | { __typename?: 'EEPSectionBlock', Name?: string | null } | { __typename?: 'EVPCarouselBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Name?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Name?: string | null } | { __typename?: 'EVPContentBlock', Name?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Name?: string | null } | { __typename?: 'EVPGenericPage', Name?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Name?: string | null } | { __typename?: 'EVPHomePage', Name?: string | null } | { __typename?: 'EVPImageBlock', Name?: string | null } | { __typename?: 'EVPImageLinkBlock', Name?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Name?: string | null } | { __typename?: 'EVPLinkBlock', Name?: string | null } | { __typename?: 'EVPMediaFileBlock', Name?: string | null } | { __typename?: 'EVPNavigationPageBlock', Name?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Name?: string | null } | { __typename?: 'EVPResourcePage', Name?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Name?: string | null } | { __typename?: 'EVPSearchPage', Name?: string | null } | { __typename?: 'EVPSiteSettingsPage', Name?: string | null } | { __typename?: 'EVPTabBlock', Name?: string | null } | { __typename?: 'EVPTabCardBlock', Name?: string | null } | { __typename?: 'EVPTabCardsBlock', Name?: string | null } | { __typename?: 'EVPTabImageTextBlock', Name?: string | null } | { __typename?: 'EVPTabRichTextBlock', Name?: string | null } | { __typename?: 'EVPTabVideoBlock', Name?: string | null } | { __typename?: 'EVPTabsBlock', Name?: string | null } | { __typename?: 'EVPTextImageBlock', Name?: string | null } | { __typename?: 'EVPVideoBlock', Name?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'ErrorModalBlock', Name?: string | null } | { __typename?: 'ErrorPage', Name?: string | null } | { __typename?: 'ErrorPageBlock', Name?: string | null } | { __typename?: 'EventBlock', Name?: string | null } | { __typename?: 'EventLocationAndDateBlock', Name?: string | null } | { __typename?: 'EventLocationInformationBlock', Name?: string | null } | { __typename?: 'EventPage', Name?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Name?: string | null } | { __typename?: 'EventSessionBlock', Name?: string | null } | { __typename?: 'EventSessionScheduleBlock', Name?: string | null } | { __typename?: 'EventSessionTrackBlock', Name?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Name?: string | null } | { __typename?: 'EventSpeakerSearchPage', Name?: string | null } | { __typename?: 'EventSpeakersBlock', Name?: string | null } | { __typename?: 'EventTableContainerBlock', Name?: string | null } | { __typename?: 'ExpandableContainerBlock', Name?: string | null } | { __typename?: 'FileUploadElementBlock', Name?: string | null } | { __typename?: 'FlowFinishInformationBlock', Name?: string | null } | { __typename?: 'FolderPage', Name?: string | null } | { __typename?: 'FormContainerBlock', Name?: string | null } | { __typename?: 'FormStepBlock', Name?: string | null } | { __typename?: 'FourColumnTableBlock', Name?: string | null } | { __typename?: 'GaugeBlock', Name?: string | null } | { __typename?: 'GeoDataBlock', Name?: string | null } | { __typename?: 'GettingStartedStepBlock', Name?: string | null } | { __typename?: 'GettingStartedStepV2Block', Name?: string | null } | { __typename?: 'GreetingCaseBlock', Name?: string | null } | { __typename?: 'GreetingStepBlock', Name?: string | null } | { __typename?: 'GreetingStepV2Block', Name?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Name?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Name?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Name?: string | null } | { __typename?: 'GsAwardsPage', Name?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Name?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Name?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Name?: string | null } | { __typename?: 'GsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsGreetingStepBlock', Name?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Name?: string | null } | { __typename?: 'GsMembershipRenewalPage', Name?: string | null } | { __typename?: 'GsProfileStepBlock', Name?: string | null } | { __typename?: 'GsReceiptStepBlock', Name?: string | null } | { __typename?: 'GsReviewStepBlock', Name?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Name?: string | null } | { __typename?: 'HeroTextContentBlock', Name?: string | null } | { __typename?: 'HomePage', Name?: string | null } | { __typename?: 'HomePageV2', Name?: string | null } | { __typename?: 'IconRequirementBlock', Name?: string | null } | { __typename?: 'Image', Name?: string | null } | { __typename?: 'ImageBlock', Name?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Name?: string | null } | { __typename?: 'ImageChoiceElementBlock', Name?: string | null } | { __typename?: 'ImageLinkBlock', Name?: string | null } | { __typename?: 'ImageMedia', Name?: string | null } | { __typename?: 'ImageTextBlock', Name?: string | null } | { __typename?: 'ImageTextBlockV2', Name?: string | null } | { __typename?: 'ImageTextCardBlock', Name?: string | null } | { __typename?: 'ImageTextItemBlock', Name?: string | null } | { __typename?: 'InfoBoxBlock', Name?: string | null } | { __typename?: 'KeyLinkValueBlock', Name?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Name?: string | null } | { __typename?: 'LandingPage', Name?: string | null } | { __typename?: 'LanguageIdAndName', Name?: string | null } | { __typename?: 'LanguagesBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Name?: string | null } | { __typename?: 'LearnDetailPage', Name?: string | null } | { __typename?: 'LearnHeroImageBlock', Name?: string | null } | { __typename?: 'LearnLandingPage', Name?: string | null } | { __typename?: 'LearnPageV2', Name?: string | null } | { __typename?: 'LearnPlayListPage', Name?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Name?: string | null } | { __typename?: 'LinkBlock', Name?: string | null } | { __typename?: 'LinkListBlock', Name?: string | null } | { __typename?: 'LinkTileBlock', Name?: string | null } | { __typename?: 'LoaderBlock', Name?: string | null } | { __typename?: 'LocationBlock', Name?: string | null } | { __typename?: 'MeetingEventCardPage', Name?: string | null } | { __typename?: 'MeetingPage', Name?: string | null } | { __typename?: 'MemberDirectory', Name?: string | null } | { __typename?: 'MemberDirectoryPage', Name?: string | null } | { __typename?: 'MemberSectionBlock', Name?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Name?: string | null } | { __typename?: 'MembershipInvoicePage', Name?: string | null } | { __typename?: 'MembershipLevelBlock', Name?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Name?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Name?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Name?: string | null } | { __typename?: 'MembershipLevelsBlock', Name?: string | null } | { __typename?: 'MembershipRenewalPage', Name?: string | null } | { __typename?: 'MembershipRenewalV2Page', Name?: string | null } | { __typename?: 'MembershipRequirementBlock', Name?: string | null } | { __typename?: 'MembershipRequirementsBlock', Name?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Name?: string | null } | { __typename?: 'ModalInfoBlock', Name?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Name?: string | null } | { __typename?: 'NextCallOutBlock', Name?: string | null } | { __typename?: 'NextContactUsBlock', Name?: string | null } | { __typename?: 'NextContainerBlock', Name?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Name?: string | null } | { __typename?: 'NextEventBlock', Name?: string | null } | { __typename?: 'NextHeroBlock', Name?: string | null } | { __typename?: 'NextInfoBoxBlock', Name?: string | null } | { __typename?: 'NextPersonContainerBlock', Name?: string | null } | { __typename?: 'NextPersonDataBlock', Name?: string | null } | { __typename?: 'NextStaffAdminPage', Name?: string | null } | { __typename?: 'NextStaticPage', Name?: string | null } | { __typename?: 'NextSyncEventsBlock', Name?: string | null } | { __typename?: 'NotFoundPage', Name?: string | null } | { __typename?: 'NumberElementBlock', Name?: string | null } | { __typename?: 'NumberedContainerBlock', Name?: string | null } | { __typename?: 'NumberedItemBlock', Name?: string | null } | { __typename?: 'ParagraphTextElementBlock', Name?: string | null } | { __typename?: 'PastPresidentsBlock', Name?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Name?: string | null } | { __typename?: 'PersonBlock', Name?: string | null } | { __typename?: 'PersonContainerBlock', Name?: string | null } | { __typename?: 'PersonQuizPage', Name?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Name?: string | null } | { __typename?: 'PlaylistBlock', Name?: string | null } | { __typename?: 'PlaylistPromoBlock', Name?: string | null } | { __typename?: 'PodcastDetailBlock', Name?: string | null } | { __typename?: 'PowerPhrasePage', Name?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Name?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Name?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPortalPage', Name?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Name?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Name?: string | null } | { __typename?: 'PressReleasePage', Name?: string | null } | { __typename?: 'PriceBreakdownBlock', Name?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Name?: string | null } | { __typename?: 'ProductionDataSectionBlock', Name?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Name?: string | null } | { __typename?: 'ProductionModalBlock', Name?: string | null } | { __typename?: 'ProductionStepBlock', Name?: string | null } | { __typename?: 'ProductionStepV2Block', Name?: string | null } | { __typename?: 'ProductionTableBlock', Name?: string | null } | { __typename?: 'ProfileListBlock', Name?: string | null } | { __typename?: 'ProfilePictureBlock', Name?: string | null } | { __typename?: 'ProfileSectionBlock', Name?: string | null } | { __typename?: 'ProfileStepBlock', Name?: string | null } | { __typename?: 'ProfileStepV2Block', Name?: string | null } | { __typename?: 'PublicProfilePage', Name?: string | null } | { __typename?: 'QuizCareerBlock', Name?: string | null } | { __typename?: 'QuizEducationBlock', Name?: string | null } | { __typename?: 'QuizFinancialBlock', Name?: string | null } | { __typename?: 'QuizHealthBlock', Name?: string | null } | { __typename?: 'QuizRelationshipsBlock', Name?: string | null } | { __typename?: 'QuizServiceBlock', Name?: string | null } | { __typename?: 'QuizSpiritualBlock', Name?: string | null } | { __typename?: 'RTContributorFormPage', Name?: string | null } | { __typename?: 'RangeElementBlock', Name?: string | null } | { __typename?: 'ReceiptStepBlock', Name?: string | null } | { __typename?: 'ReceiptStepV2Block', Name?: string | null } | { __typename?: 'ResetButtonElementBlock', Name?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Name?: string | null } | { __typename?: 'ReviewBlock', Name?: string | null } | { __typename?: 'ReviewStepBlock', Name?: string | null } | { __typename?: 'RichTextBlock', Name?: string | null } | { __typename?: 'RoutingStepBlock', Name?: string | null } | { __typename?: 'SearchPage', Name?: string | null } | { __typename?: 'SearchPageV2', Name?: string | null } | { __typename?: 'SectionContainerBlock', Name?: string | null } | { __typename?: 'SectionItemBlock', Name?: string | null } | { __typename?: 'SelectionElementBlock', Name?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Name?: string | null } | { __typename?: 'SettingSectionBlock', Name?: string | null } | { __typename?: 'SiteSettingsPage', Name?: string | null } | { __typename?: 'SocialShareBlock', Name?: string | null } | { __typename?: 'SpeakerEngagementPage', Name?: string | null } | { __typename?: 'SponsorSpeakerPage', Name?: string | null } | { __typename?: 'SpotlightBlock', Name?: string | null } | { __typename?: 'SpotlightContainerBlock', Name?: string | null } | { __typename?: 'SpotlightDataBlock', Name?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Name?: string | null } | { __typename?: 'StoreCardPage', Name?: string | null } | { __typename?: 'SubmitButtonElementBlock', Name?: string | null } | { __typename?: 'SuccessSectionBlock', Name?: string | null } | { __typename?: 'SvgLinkBlock', Name?: string | null } | { __typename?: 'SvgMedia', Name?: string | null } | { __typename?: 'SvgTextCardBlock', Name?: string | null } | { __typename?: 'TabContainerBlock', Name?: string | null } | { __typename?: 'TabItemBlock', Name?: string | null } | { __typename?: 'TextCardBlock', Name?: string | null } | { __typename?: 'TextContentBlock', Name?: string | null } | { __typename?: 'TextareaElementBlock', Name?: string | null } | { __typename?: 'TextboxElementBlock', Name?: string | null } | { __typename?: 'TimelineContainerBlock', Name?: string | null } | { __typename?: 'TimelineItemBlock', Name?: string | null } | { __typename?: 'ToolkitBlock', Name?: string | null } | { __typename?: 'ToolkitItemBlock', Name?: string | null } | { __typename?: 'ToolkitSectionBlock', Name?: string | null } | { __typename?: 'ToolsCardPage', Name?: string | null } | { __typename?: 'TooltipBlock', Name?: string | null } | { __typename?: 'UrlElementBlock', Name?: string | null } | { __typename?: 'Video', Name?: string | null } | { __typename?: 'VideoBlock', Name?: string | null } | { __typename?: 'VideoDetailBlock', Name?: string | null } | { __typename?: 'VideoMedia', Name?: string | null } | { __typename?: 'VideoPromoBlock', Name?: string | null } | { __typename?: 'VisaLettersPage', Name?: string | null } | { __typename?: 'VisibilityOptionsBlock', Name?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Name?: string | null } | { __typename?: 'WireTransferSectionBlock', Name?: string | null } | { __typename?: 'YourAnswersSectionBlock', Name?: string | null } | null } | null } | null> | null } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null };

export type LearnLandingPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LearnLandingPageQuery = { __typename?: 'Query', LearnPageV2?: { __typename?: 'LearnPageV2Output', items?: Array<{ __typename?: 'LearnPageV2', SearchInputPlaceholder?: string | null, FeaturedContentViewNowLabelText?: string | null, SignInAlertText?: string | null, BrowseTopicsLabel?: string | null, SavedItemsLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2', Type?: string | null, Heading?: string | null, SourcesFilterAllSelectionLabel?: string | null, ShowSourcesFilter?: any | null, ShowMagazineIssueFilter?: any | null, SelectedSources?: Array<{ __typename?: 'ContentModelReference', Id?: number | null } | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ExpandedSelectedSources?: Array<{ __typename?: 'SourcesEntry', Id?: number | null, Name?: string | null } | null> | null, ExpandedSelectedTopics?: Array<{ __typename?: 'TopicsEntry', Id?: number | null, Name?: string | null } | null> | null } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock', Preheading?: string | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null, FeaturedContentIds?: Array<{ __typename?: 'FeaturedContentIdsEntry', Id?: number | null } | null> | null, FeaturedContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2' } | { __typename: 'LearnDetailPage', RelativePath?: string | null, ReadTimeInSeconds?: number | null, ContentTypeSelection?: number | null, Subheading?: string | null, SubheadingText?: string | null, Heading?: string | null, MagazineIssueYear?: number | null, MagazineIssueMonth?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null, ExpandedCategories?: Array<{ __typename?: 'ExpandedCategoriesEntry', Id?: number | null, ParentId?: number | null, Name?: string | null } | null> | null, ThumbnailImage?: { __typename?: 'LearnDetailPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Authors?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock', Name?: string | null } | { __typename?: 'AccordionContainerBlock', Name?: string | null } | { __typename?: 'AccordionItemBlock', Name?: string | null } | { __typename?: 'AccountProfilePage', Name?: string | null } | { __typename?: 'AddressInfoBlock', Name?: string | null } | { __typename?: 'BadgeBlock', Name?: string | null } | { __typename?: 'BrandedTableBlock', Name?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Name?: string | null } | { __typename?: 'ButtonLabelBlock', Name?: string | null } | { __typename?: 'CaptchaElementBlock', Name?: string | null } | { __typename?: 'CategoryListBlock', Name?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Name?: string | null } | { __typename?: 'CflBadgesBlock', Name?: string | null } | { __typename?: 'CflHomePage', Name?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Name?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Name?: string | null } | { __typename?: 'CflSiteSettingsPage', Name?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Name?: string | null } | { __typename?: 'ChoiceElementBlock', Name?: string | null } | { __typename?: 'ColumnContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Name?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Name?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Name?: string | null } | { __typename?: 'CompanyRankingsPage', Name?: string | null } | { __typename?: 'ConfirmationModalBlock', Name?: string | null } | { __typename?: 'ConfirmationStepBlock', Name?: string | null } | { __typename?: 'CongratulationsStepV2Block', Name?: string | null } | { __typename?: 'ContactEmailElementBlock', Name?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Name?: string | null } | { __typename?: 'ContactNameElementBlock', Name?: string | null } | { __typename?: 'ContactPhoneElementBlock', Name?: string | null } | { __typename?: 'ContactsBlock', Name?: string | null } | { __typename?: 'Content', Name?: string | null } | { __typename?: 'DAMAsset', Name?: string | null } | { __typename?: 'DAMImageAsset', Name?: string | null } | { __typename?: 'DAMVideo', Name?: string | null } | { __typename?: 'DAMVideoAsset', Name?: string | null } | { __typename?: 'DashBoardSectionBlock', Name?: string | null } | { __typename?: 'DashboardAccountPage', Name?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Name?: string | null } | { __typename?: 'DashboardContactInformationBlock', Name?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Name?: string | null } | { __typename?: 'DashboardPermissionsBlock', Name?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfileBlock', Name?: string | null } | { __typename?: 'DashboardSharedPage', Name?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Name?: string | null } | { __typename?: 'DataMismatchModalBlock', Name?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Name?: string | null } | { __typename?: 'DescriptionButtonBlock', Name?: string | null } | { __typename?: 'DetailPage', Name?: string | null } | { __typename?: 'DocumentMedia', Name?: string | null } | { __typename?: 'DonationBlock', Name?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Name?: string | null } | { __typename?: 'EEPSectionBlock', Name?: string | null } | { __typename?: 'EVPCarouselBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Name?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Name?: string | null } | { __typename?: 'EVPContentBlock', Name?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Name?: string | null } | { __typename?: 'EVPGenericPage', Name?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Name?: string | null } | { __typename?: 'EVPHomePage', Name?: string | null } | { __typename?: 'EVPImageBlock', Name?: string | null } | { __typename?: 'EVPImageLinkBlock', Name?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Name?: string | null } | { __typename?: 'EVPLinkBlock', Name?: string | null } | { __typename?: 'EVPMediaFileBlock', Name?: string | null } | { __typename?: 'EVPNavigationPageBlock', Name?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Name?: string | null } | { __typename?: 'EVPResourcePage', Name?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Name?: string | null } | { __typename?: 'EVPSearchPage', Name?: string | null } | { __typename?: 'EVPSiteSettingsPage', Name?: string | null } | { __typename?: 'EVPTabBlock', Name?: string | null } | { __typename?: 'EVPTabCardBlock', Name?: string | null } | { __typename?: 'EVPTabCardsBlock', Name?: string | null } | { __typename?: 'EVPTabImageTextBlock', Name?: string | null } | { __typename?: 'EVPTabRichTextBlock', Name?: string | null } | { __typename?: 'EVPTabVideoBlock', Name?: string | null } | { __typename?: 'EVPTabsBlock', Name?: string | null } | { __typename?: 'EVPTextImageBlock', Name?: string | null } | { __typename?: 'EVPVideoBlock', Name?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'ErrorModalBlock', Name?: string | null } | { __typename?: 'ErrorPage', Name?: string | null } | { __typename?: 'ErrorPageBlock', Name?: string | null } | { __typename?: 'EventBlock', Name?: string | null } | { __typename?: 'EventLocationAndDateBlock', Name?: string | null } | { __typename?: 'EventLocationInformationBlock', Name?: string | null } | { __typename?: 'EventPage', Name?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Name?: string | null } | { __typename?: 'EventSessionBlock', Name?: string | null } | { __typename?: 'EventSessionScheduleBlock', Name?: string | null } | { __typename?: 'EventSessionTrackBlock', Name?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Name?: string | null } | { __typename?: 'EventSpeakerSearchPage', Name?: string | null } | { __typename?: 'EventSpeakersBlock', Name?: string | null } | { __typename?: 'EventTableContainerBlock', Name?: string | null } | { __typename?: 'ExpandableContainerBlock', Name?: string | null } | { __typename?: 'FileUploadElementBlock', Name?: string | null } | { __typename?: 'FlowFinishInformationBlock', Name?: string | null } | { __typename?: 'FolderPage', Name?: string | null } | { __typename?: 'FormContainerBlock', Name?: string | null } | { __typename?: 'FormStepBlock', Name?: string | null } | { __typename?: 'FourColumnTableBlock', Name?: string | null } | { __typename?: 'GaugeBlock', Name?: string | null } | { __typename?: 'GeoDataBlock', Name?: string | null } | { __typename?: 'GettingStartedStepBlock', Name?: string | null } | { __typename?: 'GettingStartedStepV2Block', Name?: string | null } | { __typename?: 'GreetingCaseBlock', Name?: string | null } | { __typename?: 'GreetingStepBlock', Name?: string | null } | { __typename?: 'GreetingStepV2Block', Name?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Name?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Name?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Name?: string | null } | { __typename?: 'GsAwardsPage', Name?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Name?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Name?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Name?: string | null } | { __typename?: 'GsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsGreetingStepBlock', Name?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Name?: string | null } | { __typename?: 'GsMembershipRenewalPage', Name?: string | null } | { __typename?: 'GsProfileStepBlock', Name?: string | null } | { __typename?: 'GsReceiptStepBlock', Name?: string | null } | { __typename?: 'GsReviewStepBlock', Name?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Name?: string | null } | { __typename?: 'HeroTextContentBlock', Name?: string | null } | { __typename?: 'HomePage', Name?: string | null } | { __typename?: 'HomePageV2', Name?: string | null } | { __typename?: 'IconRequirementBlock', Name?: string | null } | { __typename?: 'Image', Name?: string | null } | { __typename?: 'ImageBlock', Name?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Name?: string | null } | { __typename?: 'ImageChoiceElementBlock', Name?: string | null } | { __typename?: 'ImageLinkBlock', Name?: string | null } | { __typename?: 'ImageMedia', Name?: string | null } | { __typename?: 'ImageTextBlock', Name?: string | null } | { __typename?: 'ImageTextBlockV2', Name?: string | null } | { __typename?: 'ImageTextCardBlock', Name?: string | null } | { __typename?: 'ImageTextItemBlock', Name?: string | null } | { __typename?: 'InfoBoxBlock', Name?: string | null } | { __typename?: 'KeyLinkValueBlock', Name?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Name?: string | null } | { __typename?: 'LandingPage', Name?: string | null } | { __typename?: 'LanguageIdAndName', Name?: string | null } | { __typename?: 'LanguagesBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Name?: string | null } | { __typename?: 'LearnDetailPage', Name?: string | null } | { __typename?: 'LearnHeroImageBlock', Name?: string | null } | { __typename?: 'LearnLandingPage', Name?: string | null } | { __typename?: 'LearnPageV2', Name?: string | null } | { __typename?: 'LearnPlayListPage', Name?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Name?: string | null } | { __typename?: 'LinkBlock', Name?: string | null } | { __typename?: 'LinkListBlock', Name?: string | null } | { __typename?: 'LinkTileBlock', Name?: string | null } | { __typename?: 'LoaderBlock', Name?: string | null } | { __typename?: 'LocationBlock', Name?: string | null } | { __typename?: 'MeetingEventCardPage', Name?: string | null } | { __typename?: 'MeetingPage', Name?: string | null } | { __typename?: 'MemberDirectory', Name?: string | null } | { __typename?: 'MemberDirectoryPage', Name?: string | null } | { __typename?: 'MemberSectionBlock', Name?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Name?: string | null } | { __typename?: 'MembershipInvoicePage', Name?: string | null } | { __typename?: 'MembershipLevelBlock', Name?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Name?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Name?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Name?: string | null } | { __typename?: 'MembershipLevelsBlock', Name?: string | null } | { __typename?: 'MembershipRenewalPage', Name?: string | null } | { __typename?: 'MembershipRenewalV2Page', Name?: string | null } | { __typename?: 'MembershipRequirementBlock', Name?: string | null } | { __typename?: 'MembershipRequirementsBlock', Name?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Name?: string | null } | { __typename?: 'ModalInfoBlock', Name?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Name?: string | null } | { __typename?: 'NextCallOutBlock', Name?: string | null } | { __typename?: 'NextContactUsBlock', Name?: string | null } | { __typename?: 'NextContainerBlock', Name?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Name?: string | null } | { __typename?: 'NextEventBlock', Name?: string | null } | { __typename?: 'NextHeroBlock', Name?: string | null } | { __typename?: 'NextInfoBoxBlock', Name?: string | null } | { __typename?: 'NextPersonContainerBlock', Name?: string | null } | { __typename?: 'NextPersonDataBlock', Name?: string | null } | { __typename?: 'NextStaffAdminPage', Name?: string | null } | { __typename?: 'NextStaticPage', Name?: string | null } | { __typename?: 'NextSyncEventsBlock', Name?: string | null } | { __typename?: 'NotFoundPage', Name?: string | null } | { __typename?: 'NumberElementBlock', Name?: string | null } | { __typename?: 'NumberedContainerBlock', Name?: string | null } | { __typename?: 'NumberedItemBlock', Name?: string | null } | { __typename?: 'ParagraphTextElementBlock', Name?: string | null } | { __typename?: 'PastPresidentsBlock', Name?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Name?: string | null } | { __typename?: 'PersonBlock', Name?: string | null } | { __typename?: 'PersonContainerBlock', Name?: string | null } | { __typename?: 'PersonQuizPage', Name?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Name?: string | null } | { __typename?: 'PlaylistBlock', Name?: string | null } | { __typename?: 'PlaylistPromoBlock', Name?: string | null } | { __typename?: 'PodcastDetailBlock', Name?: string | null } | { __typename?: 'PowerPhrasePage', Name?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Name?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Name?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPortalPage', Name?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Name?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Name?: string | null } | { __typename?: 'PressReleasePage', Name?: string | null } | { __typename?: 'PriceBreakdownBlock', Name?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Name?: string | null } | { __typename?: 'ProductionDataSectionBlock', Name?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Name?: string | null } | { __typename?: 'ProductionModalBlock', Name?: string | null } | { __typename?: 'ProductionStepBlock', Name?: string | null } | { __typename?: 'ProductionStepV2Block', Name?: string | null } | { __typename?: 'ProductionTableBlock', Name?: string | null } | { __typename?: 'ProfileListBlock', Name?: string | null } | { __typename?: 'ProfilePictureBlock', Name?: string | null } | { __typename?: 'ProfileSectionBlock', Name?: string | null } | { __typename?: 'ProfileStepBlock', Name?: string | null } | { __typename?: 'ProfileStepV2Block', Name?: string | null } | { __typename?: 'PublicProfilePage', Name?: string | null } | { __typename?: 'QuizCareerBlock', Name?: string | null } | { __typename?: 'QuizEducationBlock', Name?: string | null } | { __typename?: 'QuizFinancialBlock', Name?: string | null } | { __typename?: 'QuizHealthBlock', Name?: string | null } | { __typename?: 'QuizRelationshipsBlock', Name?: string | null } | { __typename?: 'QuizServiceBlock', Name?: string | null } | { __typename?: 'QuizSpiritualBlock', Name?: string | null } | { __typename?: 'RTContributorFormPage', Name?: string | null } | { __typename?: 'RangeElementBlock', Name?: string | null } | { __typename?: 'ReceiptStepBlock', Name?: string | null } | { __typename?: 'ReceiptStepV2Block', Name?: string | null } | { __typename?: 'ResetButtonElementBlock', Name?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Name?: string | null } | { __typename?: 'ReviewBlock', Name?: string | null } | { __typename?: 'ReviewStepBlock', Name?: string | null } | { __typename?: 'RichTextBlock', Name?: string | null } | { __typename?: 'RoutingStepBlock', Name?: string | null } | { __typename?: 'SearchPage', Name?: string | null } | { __typename?: 'SearchPageV2', Name?: string | null } | { __typename?: 'SectionContainerBlock', Name?: string | null } | { __typename?: 'SectionItemBlock', Name?: string | null } | { __typename?: 'SelectionElementBlock', Name?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Name?: string | null } | { __typename?: 'SettingSectionBlock', Name?: string | null } | { __typename?: 'SiteSettingsPage', Name?: string | null } | { __typename?: 'SocialShareBlock', Name?: string | null } | { __typename?: 'SpeakerEngagementPage', Name?: string | null } | { __typename?: 'SponsorSpeakerPage', Name?: string | null } | { __typename?: 'SpotlightBlock', Name?: string | null } | { __typename?: 'SpotlightContainerBlock', Name?: string | null } | { __typename?: 'SpotlightDataBlock', Name?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Name?: string | null } | { __typename?: 'StoreCardPage', Name?: string | null } | { __typename?: 'SubmitButtonElementBlock', Name?: string | null } | { __typename?: 'SuccessSectionBlock', Name?: string | null } | { __typename?: 'SvgLinkBlock', Name?: string | null } | { __typename?: 'SvgMedia', Name?: string | null } | { __typename?: 'SvgTextCardBlock', Name?: string | null } | { __typename?: 'TabContainerBlock', Name?: string | null } | { __typename?: 'TabItemBlock', Name?: string | null } | { __typename?: 'TextCardBlock', Name?: string | null } | { __typename?: 'TextContentBlock', Name?: string | null } | { __typename?: 'TextareaElementBlock', Name?: string | null } | { __typename?: 'TextboxElementBlock', Name?: string | null } | { __typename?: 'TimelineContainerBlock', Name?: string | null } | { __typename?: 'TimelineItemBlock', Name?: string | null } | { __typename?: 'ToolkitBlock', Name?: string | null } | { __typename?: 'ToolkitItemBlock', Name?: string | null } | { __typename?: 'ToolkitSectionBlock', Name?: string | null } | { __typename?: 'ToolsCardPage', Name?: string | null } | { __typename?: 'TooltipBlock', Name?: string | null } | { __typename?: 'UrlElementBlock', Name?: string | null } | { __typename?: 'Video', Name?: string | null } | { __typename?: 'VideoBlock', Name?: string | null } | { __typename?: 'VideoDetailBlock', Name?: string | null } | { __typename?: 'VideoMedia', Name?: string | null } | { __typename?: 'VideoPromoBlock', Name?: string | null } | { __typename?: 'VisaLettersPage', Name?: string | null } | { __typename?: 'VisibilityOptionsBlock', Name?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Name?: string | null } | { __typename?: 'WireTransferSectionBlock', Name?: string | null } | { __typename?: 'YourAnswersSectionBlock', Name?: string | null } | null } | null } | null> | null, AssignedGroupsReadAccess?: Array<{ __typename?: 'AssignedGroupPropertyValue', GroupName?: string | null } | null> | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2' } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock', ProfileList?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock', Name?: string | null } | { __typename?: 'AccordionContainerBlock', Name?: string | null } | { __typename?: 'AccordionItemBlock', Name?: string | null } | { __typename?: 'AccountProfilePage', Name?: string | null } | { __typename?: 'AddressInfoBlock', Name?: string | null } | { __typename?: 'BadgeBlock', Name?: string | null } | { __typename?: 'BrandedTableBlock', Name?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Name?: string | null } | { __typename?: 'ButtonLabelBlock', Name?: string | null } | { __typename?: 'CaptchaElementBlock', Name?: string | null } | { __typename?: 'CategoryListBlock', Name?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Name?: string | null } | { __typename?: 'CflBadgesBlock', Name?: string | null } | { __typename?: 'CflHomePage', Name?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Name?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Name?: string | null } | { __typename?: 'CflSiteSettingsPage', Name?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Name?: string | null } | { __typename?: 'ChoiceElementBlock', Name?: string | null } | { __typename?: 'ColumnContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Name?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Name?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Name?: string | null } | { __typename?: 'CompanyRankingsPage', Name?: string | null } | { __typename?: 'ConfirmationModalBlock', Name?: string | null } | { __typename?: 'ConfirmationStepBlock', Name?: string | null } | { __typename?: 'CongratulationsStepV2Block', Name?: string | null } | { __typename?: 'ContactEmailElementBlock', Name?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Name?: string | null } | { __typename?: 'ContactNameElementBlock', Name?: string | null } | { __typename?: 'ContactPhoneElementBlock', Name?: string | null } | { __typename?: 'ContactsBlock', Name?: string | null } | { __typename?: 'Content', Name?: string | null } | { __typename?: 'DAMAsset', Name?: string | null } | { __typename?: 'DAMImageAsset', Name?: string | null } | { __typename?: 'DAMVideo', Name?: string | null } | { __typename?: 'DAMVideoAsset', Name?: string | null } | { __typename?: 'DashBoardSectionBlock', Name?: string | null } | { __typename?: 'DashboardAccountPage', Name?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Name?: string | null } | { __typename?: 'DashboardContactInformationBlock', Name?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Name?: string | null } | { __typename?: 'DashboardPermissionsBlock', Name?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfileBlock', Name?: string | null } | { __typename?: 'DashboardSharedPage', Name?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Name?: string | null } | { __typename?: 'DataMismatchModalBlock', Name?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Name?: string | null } | { __typename?: 'DescriptionButtonBlock', Name?: string | null } | { __typename?: 'DetailPage', Name?: string | null } | { __typename?: 'DocumentMedia', Name?: string | null } | { __typename?: 'DonationBlock', Name?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Name?: string | null } | { __typename?: 'EEPSectionBlock', Name?: string | null } | { __typename?: 'EVPCarouselBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Name?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Name?: string | null } | { __typename?: 'EVPContentBlock', Name?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Name?: string | null } | { __typename?: 'EVPGenericPage', Name?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Name?: string | null } | { __typename?: 'EVPHomePage', Name?: string | null } | { __typename?: 'EVPImageBlock', Name?: string | null } | { __typename?: 'EVPImageLinkBlock', Name?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Name?: string | null } | { __typename?: 'EVPLinkBlock', Name?: string | null } | { __typename?: 'EVPMediaFileBlock', Name?: string | null } | { __typename?: 'EVPNavigationPageBlock', Name?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Name?: string | null } | { __typename?: 'EVPResourcePage', Name?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Name?: string | null } | { __typename?: 'EVPSearchPage', Name?: string | null } | { __typename?: 'EVPSiteSettingsPage', Name?: string | null } | { __typename?: 'EVPTabBlock', Name?: string | null } | { __typename?: 'EVPTabCardBlock', Name?: string | null } | { __typename?: 'EVPTabCardsBlock', Name?: string | null } | { __typename?: 'EVPTabImageTextBlock', Name?: string | null } | { __typename?: 'EVPTabRichTextBlock', Name?: string | null } | { __typename?: 'EVPTabVideoBlock', Name?: string | null } | { __typename?: 'EVPTabsBlock', Name?: string | null } | { __typename?: 'EVPTextImageBlock', Name?: string | null } | { __typename?: 'EVPVideoBlock', Name?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'ErrorModalBlock', Name?: string | null } | { __typename?: 'ErrorPage', Name?: string | null } | { __typename?: 'ErrorPageBlock', Name?: string | null } | { __typename?: 'EventBlock', Name?: string | null } | { __typename?: 'EventLocationAndDateBlock', Name?: string | null } | { __typename?: 'EventLocationInformationBlock', Name?: string | null } | { __typename?: 'EventPage', Name?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Name?: string | null } | { __typename?: 'EventSessionBlock', Name?: string | null } | { __typename?: 'EventSessionScheduleBlock', Name?: string | null } | { __typename?: 'EventSessionTrackBlock', Name?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Name?: string | null } | { __typename?: 'EventSpeakerSearchPage', Name?: string | null } | { __typename?: 'EventSpeakersBlock', Name?: string | null } | { __typename?: 'EventTableContainerBlock', Name?: string | null } | { __typename?: 'ExpandableContainerBlock', Name?: string | null } | { __typename?: 'FileUploadElementBlock', Name?: string | null } | { __typename?: 'FlowFinishInformationBlock', Name?: string | null } | { __typename?: 'FolderPage', Name?: string | null } | { __typename?: 'FormContainerBlock', Name?: string | null } | { __typename?: 'FormStepBlock', Name?: string | null } | { __typename?: 'FourColumnTableBlock', Name?: string | null } | { __typename?: 'GaugeBlock', Name?: string | null } | { __typename?: 'GeoDataBlock', Name?: string | null } | { __typename?: 'GettingStartedStepBlock', Name?: string | null } | { __typename?: 'GettingStartedStepV2Block', Name?: string | null } | { __typename?: 'GreetingCaseBlock', Name?: string | null } | { __typename?: 'GreetingStepBlock', Name?: string | null } | { __typename?: 'GreetingStepV2Block', Name?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Name?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Name?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Name?: string | null } | { __typename?: 'GsAwardsPage', Name?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Name?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Name?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Name?: string | null } | { __typename?: 'GsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsGreetingStepBlock', Name?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Name?: string | null } | { __typename?: 'GsMembershipRenewalPage', Name?: string | null } | { __typename?: 'GsProfileStepBlock', Name?: string | null } | { __typename?: 'GsReceiptStepBlock', Name?: string | null } | { __typename?: 'GsReviewStepBlock', Name?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Name?: string | null } | { __typename?: 'HeroTextContentBlock', Name?: string | null } | { __typename?: 'HomePage', Name?: string | null } | { __typename?: 'HomePageV2', Name?: string | null } | { __typename?: 'IconRequirementBlock', Name?: string | null } | { __typename?: 'Image', Name?: string | null } | { __typename?: 'ImageBlock', Name?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Name?: string | null } | { __typename?: 'ImageChoiceElementBlock', Name?: string | null } | { __typename?: 'ImageLinkBlock', Name?: string | null } | { __typename?: 'ImageMedia', Name?: string | null } | { __typename?: 'ImageTextBlock', Name?: string | null } | { __typename?: 'ImageTextBlockV2', Name?: string | null } | { __typename?: 'ImageTextCardBlock', Name?: string | null } | { __typename?: 'ImageTextItemBlock', Name?: string | null } | { __typename?: 'InfoBoxBlock', Name?: string | null } | { __typename?: 'KeyLinkValueBlock', Name?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Name?: string | null } | { __typename?: 'LandingPage', Name?: string | null } | { __typename?: 'LanguageIdAndName', Name?: string | null } | { __typename?: 'LanguagesBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Name?: string | null } | { __typename?: 'LearnDetailPage', Name?: string | null } | { __typename?: 'LearnHeroImageBlock', Name?: string | null } | { __typename?: 'LearnLandingPage', Name?: string | null } | { __typename?: 'LearnPageV2', Name?: string | null } | { __typename?: 'LearnPlayListPage', Name?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Name?: string | null } | { __typename?: 'LinkBlock', Name?: string | null } | { __typename?: 'LinkListBlock', Name?: string | null } | { __typename?: 'LinkTileBlock', Name?: string | null } | { __typename?: 'LoaderBlock', Name?: string | null } | { __typename?: 'LocationBlock', Name?: string | null } | { __typename?: 'MeetingEventCardPage', Name?: string | null } | { __typename?: 'MeetingPage', Name?: string | null } | { __typename?: 'MemberDirectory', Name?: string | null } | { __typename?: 'MemberDirectoryPage', Name?: string | null } | { __typename?: 'MemberSectionBlock', Name?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Name?: string | null } | { __typename?: 'MembershipInvoicePage', Name?: string | null } | { __typename?: 'MembershipLevelBlock', Name?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Name?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Name?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Name?: string | null } | { __typename?: 'MembershipLevelsBlock', Name?: string | null } | { __typename?: 'MembershipRenewalPage', Name?: string | null } | { __typename?: 'MembershipRenewalV2Page', Name?: string | null } | { __typename?: 'MembershipRequirementBlock', Name?: string | null } | { __typename?: 'MembershipRequirementsBlock', Name?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Name?: string | null } | { __typename?: 'ModalInfoBlock', Name?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Name?: string | null } | { __typename?: 'NextCallOutBlock', Name?: string | null } | { __typename?: 'NextContactUsBlock', Name?: string | null } | { __typename?: 'NextContainerBlock', Name?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Name?: string | null } | { __typename?: 'NextEventBlock', Name?: string | null } | { __typename?: 'NextHeroBlock', Name?: string | null } | { __typename?: 'NextInfoBoxBlock', Name?: string | null } | { __typename?: 'NextPersonContainerBlock', Name?: string | null } | { __typename?: 'NextPersonDataBlock', Name?: string | null } | { __typename?: 'NextStaffAdminPage', Name?: string | null } | { __typename?: 'NextStaticPage', Name?: string | null } | { __typename?: 'NextSyncEventsBlock', Name?: string | null } | { __typename?: 'NotFoundPage', Name?: string | null } | { __typename?: 'NumberElementBlock', Name?: string | null } | { __typename?: 'NumberedContainerBlock', Name?: string | null } | { __typename?: 'NumberedItemBlock', Name?: string | null } | { __typename?: 'ParagraphTextElementBlock', Name?: string | null } | { __typename?: 'PastPresidentsBlock', Name?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Name?: string | null } | { __typename?: 'PersonBlock', Name?: string | null } | { __typename?: 'PersonContainerBlock', Name?: string | null } | { __typename?: 'PersonQuizPage', Name?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Name?: string | null } | { __typename?: 'PlaylistBlock', Name?: string | null } | { __typename?: 'PlaylistPromoBlock', Name?: string | null } | { __typename?: 'PodcastDetailBlock', Name?: string | null } | { __typename?: 'PowerPhrasePage', Name?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Name?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Name?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPortalPage', Name?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Name?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Name?: string | null } | { __typename?: 'PressReleasePage', Name?: string | null } | { __typename?: 'PriceBreakdownBlock', Name?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Name?: string | null } | { __typename?: 'ProductionDataSectionBlock', Name?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Name?: string | null } | { __typename?: 'ProductionModalBlock', Name?: string | null } | { __typename?: 'ProductionStepBlock', Name?: string | null } | { __typename?: 'ProductionStepV2Block', Name?: string | null } | { __typename?: 'ProductionTableBlock', Name?: string | null } | { __typename?: 'ProfileListBlock', Name?: string | null } | { __typename?: 'ProfilePictureBlock', Name?: string | null } | { __typename?: 'ProfileSectionBlock', Name?: string | null } | { __typename?: 'ProfileStepBlock', Name?: string | null } | { __typename?: 'ProfileStepV2Block', Name?: string | null } | { __typename?: 'PublicProfilePage', Name?: string | null } | { __typename?: 'QuizCareerBlock', Name?: string | null } | { __typename?: 'QuizEducationBlock', Name?: string | null } | { __typename?: 'QuizFinancialBlock', Name?: string | null } | { __typename?: 'QuizHealthBlock', Name?: string | null } | { __typename?: 'QuizRelationshipsBlock', Name?: string | null } | { __typename?: 'QuizServiceBlock', Name?: string | null } | { __typename?: 'QuizSpiritualBlock', Name?: string | null } | { __typename?: 'RTContributorFormPage', Name?: string | null } | { __typename?: 'RangeElementBlock', Name?: string | null } | { __typename?: 'ReceiptStepBlock', Name?: string | null } | { __typename?: 'ReceiptStepV2Block', Name?: string | null } | { __typename?: 'ResetButtonElementBlock', Name?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Name?: string | null } | { __typename?: 'ReviewBlock', Name?: string | null } | { __typename?: 'ReviewStepBlock', Name?: string | null } | { __typename?: 'RichTextBlock', Name?: string | null } | { __typename?: 'RoutingStepBlock', Name?: string | null } | { __typename?: 'SearchPage', Name?: string | null } | { __typename?: 'SearchPageV2', Name?: string | null } | { __typename?: 'SectionContainerBlock', Name?: string | null } | { __typename?: 'SectionItemBlock', Name?: string | null } | { __typename?: 'SelectionElementBlock', Name?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Name?: string | null } | { __typename?: 'SettingSectionBlock', Name?: string | null } | { __typename?: 'SiteSettingsPage', Name?: string | null } | { __typename?: 'SocialShareBlock', Name?: string | null } | { __typename?: 'SpeakerEngagementPage', Name?: string | null } | { __typename?: 'SponsorSpeakerPage', Name?: string | null } | { __typename?: 'SpotlightBlock', Name?: string | null } | { __typename?: 'SpotlightContainerBlock', Name?: string | null } | { __typename?: 'SpotlightDataBlock', Name?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Name?: string | null } | { __typename?: 'StoreCardPage', Name?: string | null } | { __typename?: 'SubmitButtonElementBlock', Name?: string | null } | { __typename?: 'SuccessSectionBlock', Name?: string | null } | { __typename?: 'SvgLinkBlock', Name?: string | null } | { __typename?: 'SvgMedia', Name?: string | null } | { __typename?: 'SvgTextCardBlock', Name?: string | null } | { __typename?: 'TabContainerBlock', Name?: string | null } | { __typename?: 'TabItemBlock', Name?: string | null } | { __typename?: 'TextCardBlock', Name?: string | null } | { __typename?: 'TextContentBlock', Name?: string | null } | { __typename?: 'TextareaElementBlock', Name?: string | null } | { __typename?: 'TextboxElementBlock', Name?: string | null } | { __typename?: 'TimelineContainerBlock', Name?: string | null } | { __typename?: 'TimelineItemBlock', Name?: string | null } | { __typename?: 'ToolkitBlock', Name?: string | null } | { __typename?: 'ToolkitItemBlock', Name?: string | null } | { __typename?: 'ToolkitSectionBlock', Name?: string | null } | { __typename?: 'ToolsCardPage', Name?: string | null } | { __typename?: 'TooltipBlock', Name?: string | null } | { __typename?: 'UrlElementBlock', Name?: string | null } | { __typename?: 'Video', Name?: string | null } | { __typename?: 'VideoBlock', Name?: string | null } | { __typename?: 'VideoDetailBlock', Name?: string | null } | { __typename?: 'VideoMedia', Name?: string | null } | { __typename?: 'VideoPromoBlock', Name?: string | null } | { __typename?: 'VisaLettersPage', Name?: string | null } | { __typename?: 'VisibilityOptionsBlock', Name?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Name?: string | null } | { __typename?: 'WireTransferSectionBlock', Name?: string | null } | { __typename?: 'YourAnswersSectionBlock', Name?: string | null } | null } | null } | null> | null } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock' } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', CreateAccountLabel?: string | null, LogInPrompt?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type DetailPageMainContentTranslationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DetailPageMainContentTranslationsQuery = { __typename?: 'Query', LearnPageV2?: { __typename?: 'LearnPageV2Output', items?: Array<{ __typename?: 'LearnPageV2', DetailPageMemberYearsSubheading?: string | null, DetailPageAuthorsHeading?: string | null, DetailPageMemberEmailButtonAriaLabelText?: string | null, DetailPageMemberDetailsButtonAriaLabelText?: string | null, DetailPageAuthorModalResoucesButtonLabelText?: string | null, DetailPageVideoTranscriptAccordionButtonLabelText?: string | null, DetailPageViewResourcesLinkLabelText?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', In?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type MemberDirectoryPageQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type MemberDirectoryPageQuery = { __typename?: 'Query', MemberDirectoryPage?: { __typename?: 'MemberDirectoryPageOutput', items?: Array<{ __typename?: 'MemberDirectoryPage', Title?: string | null, MembersNearbyLabel?: string | null, ResultsForLabel?: string | null, SearchInputLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', COTLevelLabel?: string | null, CityLabel?: string | null, CountryLabel?: string | null, MDRTLevelLabel?: string | null, MembershipLevelLabel?: string | null, NextPageLabel?: string | null, NoResultsLabel?: string | null, NoResultsMessage?: string | null, Pagination?: string | null, PreviousPageLabel?: string | null, SearchButtonLabel?: string | null, StateProvinceLabel?: string | null, TOTLevelLabel?: string | null, TotalItemsCountLabel?: string | null, BackToDashboard?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type MemberDirectoryProfilePageQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type MemberDirectoryProfilePageQuery = { __typename?: 'Query', PublicProfilePage?: { __typename?: 'PublicProfilePageOutput', items?: Array<{ __typename?: 'PublicProfilePage', AchievementLevelLabel?: string | null, MembershipYearsLabel?: string | null, MembershipStatusLabel?: string | null, ContactInformationLabel?: string | null, LifeMembershipTypeLabel?: string | null, PictureDescription?: string | null, QualifyingLifeMembershipTypeLabel?: string | null, QualifyingMembershipTypeLabel?: string | null, BackToMemberDirectoryLabel?: string | null, YearsOfMembershipLevelLabel?: string | null, CommitteeSummaryCommitteeLabel?: string | null, YearLabel?: string | null, BirthdateLabel?: string | null, TotalPointsLabel?: string | null, CommitteeDetailCommitteeLabel?: string | null, AgeLabel?: string | null, AveragePercentageLabel?: string | null, RoleLabel?: string | null, IdLabel?: string | null, LeadershipLabel?: string | null, PointsPossibleLabel?: string | null, FoundationDonorLevelLabel?: string | null, JobsLabel?: string | null, PointsEarnedLabel?: string | null, FinalScoreLabel?: string | null, FirstLastMembershipLabel?: string | null, EngagementLabel?: string | null, DivisionLabel?: string | null, AnnualMeetingsCountLabel?: string | null, CommitteeSummaryTitleLabel?: string | null, CommitteeDetailTitleLabel?: string | null, AdditionalInformationTitleLabel?: string | null, GracePeriodIndicatorLabel?: string | null, GoToMemberDirectoryLabel?: string | null, MemberNotFoundErrorMessage?: string | null, GlobalConferenceMeetingsCountLabel?: string | null, BioLabel?: string | null, EmptyBioMessage?: string | null, FollowedTopicsLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', BackLabel?: string | null, COTLevelLabel?: string | null, MDRTLevelLabel?: string | null, MembershipLevelLabel?: string | null, TOTLevelLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type MembershipInvoicePageQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type MembershipInvoicePageQuery = { __typename?: 'Query', MembershipInvoicePage?: { __typename?: 'MembershipInvoicePageOutput', items?: Array<{ __typename?: 'MembershipInvoicePage', PrintButtonLabel?: string | null, HeaderTitleText?: string | null, HeaderAddressText?: string | null, HeaderPhoneText?: string | null, InvoiceHeader?: string | null, MemberDetailsHeader?: string | null, MemberNameLabel?: string | null, MdrtIdLabel?: string | null, PhoneNumberLabel?: string | null, CompanyNameLabel?: string | null, ApplicationDetailsHeader?: string | null, TermsAndConditionsLabel?: string | null, EthicsComplaintLabel?: string | null, DisabilityRequestedLabel?: string | null, MembershipTypeLabel?: string | null, AttestToProduction?: string | null, PaymentDetailsHeader?: string | null, PaymentDateLabel?: string | null, OrderNumberLabel?: string | null, PaymentMethodLabel?: string | null, PriceBreakdownHeader?: string | null, CompanyPrePaymentLabel?: string | null, SelfPrePaymentLabel?: string | null, BackDuesLabel?: string | null, LateFeeLabel?: string | null, AdditionalFilingFeesLabel?: string | null, TotalAmountPaidLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', MDRTLevelLabel?: string | null, COTLevelLabel?: string | null, TOTLevelLabel?: string | null, BackLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, AccountSettingsPageReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null } | null> | null } | null };

export type QuestionFieldsFragment = { __typename?: 'QuizQuestionPropertyValue', QuestionId?: string | null, Question?: string | null };

export type PersonQuizPageQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type PersonQuizPageQuery = { __typename?: 'Query', PersonQuizPage?: { __typename?: 'PersonQuizPageOutput', items?: Array<{ __typename?: 'PersonQuizPage', Title?: string | null, Description?: string | null, SliderInfo?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Relationships?: { __typename?: 'PersonQuizPageQuizRelationshipsBlock', Title?: string | null, TopicDescription?: string | null, Questions?: Array<{ __typename?: 'QuizQuestionPropertyValue', QuestionId?: string | null, Question?: string | null } | null> | null } | null, Health?: { __typename?: 'PersonQuizPageQuizHealthBlock', Title?: string | null, TopicDescription?: string | null, Questions?: Array<{ __typename?: 'QuizQuestionPropertyValue', QuestionId?: string | null, Question?: string | null } | null> | null } | null, Education?: { __typename?: 'PersonQuizPageQuizEducationBlock', Title?: string | null, TopicDescription?: string | null, Questions?: Array<{ __typename?: 'QuizQuestionPropertyValue', QuestionId?: string | null, Question?: string | null } | null> | null } | null, Career?: { __typename?: 'PersonQuizPageQuizCareerBlock', Title?: string | null, TopicDescription?: string | null, Questions?: Array<{ __typename?: 'QuizQuestionPropertyValue', QuestionId?: string | null, Question?: string | null } | null> | null } | null, Service?: { __typename?: 'PersonQuizPageQuizServiceBlock', Title?: string | null, TopicDescription?: string | null, Questions?: Array<{ __typename?: 'QuizQuestionPropertyValue', QuestionId?: string | null, Question?: string | null } | null> | null } | null, Financial?: { __typename?: 'PersonQuizPageQuizFinancialBlock', Title?: string | null, TopicDescription?: string | null, Questions?: Array<{ __typename?: 'QuizQuestionPropertyValue', QuestionId?: string | null, Question?: string | null } | null> | null } | null, Spiritual?: { __typename?: 'PersonQuizPageQuizSpiritualBlock', Title?: string | null, TopicDescription?: string | null, Questions?: Array<{ __typename?: 'QuizQuestionPropertyValue', QuestionId?: string | null, Question?: string | null } | null> | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', BackToDashboard?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type SearchCmsContentQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchCmsContentQuery = { __typename?: 'Query', SearchPageV2?: { __typename?: 'SearchPageV2Output', items?: Array<{ __typename?: 'SearchPageV2', SearchInputClearButtonLabel?: string | null, SearchInputPlaceholder?: string | null, TotalResultsLabel?: string | null, AllResourcesLabel?: string | null, ArticlesLabel?: string | null, AudioLabel?: string | null, VideosLabel?: string | null, GuidesLabel?: string | null, FiltersLabel?: string | null, SourceLabel?: string | null, TopicLabel?: string | null, FilterResultsLabel?: string | null, AuthorFeaturedPersonLabel?: string | null, YearLabel?: string | null, NoResultsFoundText?: string | null, SignInLabel?: string | null, IfNotMemberText?: string | null, CheckYourSpellingText?: string | null, SavedContentLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', NextPageLabel?: string | null, PreviousPageLabel?: string | null, TotalItemsCountLabel?: string | null, Pagination?: string | null, Close?: string | null, Reset?: string | null, MinutesLabel?: string | null, MembersOnlyLabel?: string | null, LockedResourceModalHeading?: string | null, LockedResourceModalSubheading?: string | null, LoginLinkLabel?: string | null, CancelLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null, LearnPageV2?: { __typename?: 'LearnPageV2Output', items?: Array<{ __typename?: 'LearnPageV2', SignInAlertText?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type GetResourceNameQueryVariables = Exact<{
  resource_guid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetResourceNameQuery = { __typename?: 'Query', LearnDetailPage?: { __typename?: 'LearnDetailPageOutput', items?: Array<{ __typename?: 'LearnDetailPage', Heading?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type LearnCarouselBlockFragment = { __typename: 'LearnCarouselContainerBlockV2', Type?: string | null, Heading?: string | null, SourcesFilterAllSelectionLabel?: string | null, ShowSourcesFilter?: any | null, ShowMagazineIssueFilter?: any | null, SelectedSources?: Array<{ __typename?: 'ContentModelReference', Id?: number | null } | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ExpandedSelectedSources?: Array<{ __typename?: 'SourcesEntry', Id?: number | null, Name?: string | null } | null> | null, ExpandedSelectedTopics?: Array<{ __typename?: 'TopicsEntry', Id?: number | null, Name?: string | null } | null> | null };

export type LearnContentCarouselCardFragment = { __typename?: 'LearnDetailPage', RelativePath?: string | null, ReadTimeInSeconds?: number | null, ContentTypeSelection?: number | null, Subheading?: string | null, SubheadingText?: string | null, Heading?: string | null, MagazineIssueYear?: number | null, MagazineIssueMonth?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null, ExpandedCategories?: Array<{ __typename?: 'ExpandedCategoriesEntry', Id?: number | null, ParentId?: number | null, Name?: string | null } | null> | null, ThumbnailImage?: { __typename?: 'LearnDetailPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Authors?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock', Name?: string | null } | { __typename?: 'AccordionContainerBlock', Name?: string | null } | { __typename?: 'AccordionItemBlock', Name?: string | null } | { __typename?: 'AccountProfilePage', Name?: string | null } | { __typename?: 'AddressInfoBlock', Name?: string | null } | { __typename?: 'BadgeBlock', Name?: string | null } | { __typename?: 'BrandedTableBlock', Name?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Name?: string | null } | { __typename?: 'ButtonLabelBlock', Name?: string | null } | { __typename?: 'CaptchaElementBlock', Name?: string | null } | { __typename?: 'CategoryListBlock', Name?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Name?: string | null } | { __typename?: 'CflBadgesBlock', Name?: string | null } | { __typename?: 'CflHomePage', Name?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Name?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Name?: string | null } | { __typename?: 'CflSiteSettingsPage', Name?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Name?: string | null } | { __typename?: 'ChoiceElementBlock', Name?: string | null } | { __typename?: 'ColumnContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Name?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Name?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Name?: string | null } | { __typename?: 'CompanyRankingsPage', Name?: string | null } | { __typename?: 'ConfirmationModalBlock', Name?: string | null } | { __typename?: 'ConfirmationStepBlock', Name?: string | null } | { __typename?: 'CongratulationsStepV2Block', Name?: string | null } | { __typename?: 'ContactEmailElementBlock', Name?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Name?: string | null } | { __typename?: 'ContactNameElementBlock', Name?: string | null } | { __typename?: 'ContactPhoneElementBlock', Name?: string | null } | { __typename?: 'ContactsBlock', Name?: string | null } | { __typename?: 'Content', Name?: string | null } | { __typename?: 'DAMAsset', Name?: string | null } | { __typename?: 'DAMImageAsset', Name?: string | null } | { __typename?: 'DAMVideo', Name?: string | null } | { __typename?: 'DAMVideoAsset', Name?: string | null } | { __typename?: 'DashBoardSectionBlock', Name?: string | null } | { __typename?: 'DashboardAccountPage', Name?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Name?: string | null } | { __typename?: 'DashboardContactInformationBlock', Name?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Name?: string | null } | { __typename?: 'DashboardPermissionsBlock', Name?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfileBlock', Name?: string | null } | { __typename?: 'DashboardSharedPage', Name?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Name?: string | null } | { __typename?: 'DataMismatchModalBlock', Name?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Name?: string | null } | { __typename?: 'DescriptionButtonBlock', Name?: string | null } | { __typename?: 'DetailPage', Name?: string | null } | { __typename?: 'DocumentMedia', Name?: string | null } | { __typename?: 'DonationBlock', Name?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Name?: string | null } | { __typename?: 'EEPSectionBlock', Name?: string | null } | { __typename?: 'EVPCarouselBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Name?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Name?: string | null } | { __typename?: 'EVPContentBlock', Name?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Name?: string | null } | { __typename?: 'EVPGenericPage', Name?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Name?: string | null } | { __typename?: 'EVPHomePage', Name?: string | null } | { __typename?: 'EVPImageBlock', Name?: string | null } | { __typename?: 'EVPImageLinkBlock', Name?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Name?: string | null } | { __typename?: 'EVPLinkBlock', Name?: string | null } | { __typename?: 'EVPMediaFileBlock', Name?: string | null } | { __typename?: 'EVPNavigationPageBlock', Name?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Name?: string | null } | { __typename?: 'EVPResourcePage', Name?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Name?: string | null } | { __typename?: 'EVPSearchPage', Name?: string | null } | { __typename?: 'EVPSiteSettingsPage', Name?: string | null } | { __typename?: 'EVPTabBlock', Name?: string | null } | { __typename?: 'EVPTabCardBlock', Name?: string | null } | { __typename?: 'EVPTabCardsBlock', Name?: string | null } | { __typename?: 'EVPTabImageTextBlock', Name?: string | null } | { __typename?: 'EVPTabRichTextBlock', Name?: string | null } | { __typename?: 'EVPTabVideoBlock', Name?: string | null } | { __typename?: 'EVPTabsBlock', Name?: string | null } | { __typename?: 'EVPTextImageBlock', Name?: string | null } | { __typename?: 'EVPVideoBlock', Name?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'ErrorModalBlock', Name?: string | null } | { __typename?: 'ErrorPage', Name?: string | null } | { __typename?: 'ErrorPageBlock', Name?: string | null } | { __typename?: 'EventBlock', Name?: string | null } | { __typename?: 'EventLocationAndDateBlock', Name?: string | null } | { __typename?: 'EventLocationInformationBlock', Name?: string | null } | { __typename?: 'EventPage', Name?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Name?: string | null } | { __typename?: 'EventSessionBlock', Name?: string | null } | { __typename?: 'EventSessionScheduleBlock', Name?: string | null } | { __typename?: 'EventSessionTrackBlock', Name?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Name?: string | null } | { __typename?: 'EventSpeakerSearchPage', Name?: string | null } | { __typename?: 'EventSpeakersBlock', Name?: string | null } | { __typename?: 'EventTableContainerBlock', Name?: string | null } | { __typename?: 'ExpandableContainerBlock', Name?: string | null } | { __typename?: 'FileUploadElementBlock', Name?: string | null } | { __typename?: 'FlowFinishInformationBlock', Name?: string | null } | { __typename?: 'FolderPage', Name?: string | null } | { __typename?: 'FormContainerBlock', Name?: string | null } | { __typename?: 'FormStepBlock', Name?: string | null } | { __typename?: 'FourColumnTableBlock', Name?: string | null } | { __typename?: 'GaugeBlock', Name?: string | null } | { __typename?: 'GeoDataBlock', Name?: string | null } | { __typename?: 'GettingStartedStepBlock', Name?: string | null } | { __typename?: 'GettingStartedStepV2Block', Name?: string | null } | { __typename?: 'GreetingCaseBlock', Name?: string | null } | { __typename?: 'GreetingStepBlock', Name?: string | null } | { __typename?: 'GreetingStepV2Block', Name?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Name?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Name?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Name?: string | null } | { __typename?: 'GsAwardsPage', Name?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Name?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Name?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Name?: string | null } | { __typename?: 'GsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsGreetingStepBlock', Name?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Name?: string | null } | { __typename?: 'GsMembershipRenewalPage', Name?: string | null } | { __typename?: 'GsProfileStepBlock', Name?: string | null } | { __typename?: 'GsReceiptStepBlock', Name?: string | null } | { __typename?: 'GsReviewStepBlock', Name?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Name?: string | null } | { __typename?: 'HeroTextContentBlock', Name?: string | null } | { __typename?: 'HomePage', Name?: string | null } | { __typename?: 'HomePageV2', Name?: string | null } | { __typename?: 'IconRequirementBlock', Name?: string | null } | { __typename?: 'Image', Name?: string | null } | { __typename?: 'ImageBlock', Name?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Name?: string | null } | { __typename?: 'ImageChoiceElementBlock', Name?: string | null } | { __typename?: 'ImageLinkBlock', Name?: string | null } | { __typename?: 'ImageMedia', Name?: string | null } | { __typename?: 'ImageTextBlock', Name?: string | null } | { __typename?: 'ImageTextBlockV2', Name?: string | null } | { __typename?: 'ImageTextCardBlock', Name?: string | null } | { __typename?: 'ImageTextItemBlock', Name?: string | null } | { __typename?: 'InfoBoxBlock', Name?: string | null } | { __typename?: 'KeyLinkValueBlock', Name?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Name?: string | null } | { __typename?: 'LandingPage', Name?: string | null } | { __typename?: 'LanguageIdAndName', Name?: string | null } | { __typename?: 'LanguagesBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Name?: string | null } | { __typename?: 'LearnDetailPage', Name?: string | null } | { __typename?: 'LearnHeroImageBlock', Name?: string | null } | { __typename?: 'LearnLandingPage', Name?: string | null } | { __typename?: 'LearnPageV2', Name?: string | null } | { __typename?: 'LearnPlayListPage', Name?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Name?: string | null } | { __typename?: 'LinkBlock', Name?: string | null } | { __typename?: 'LinkListBlock', Name?: string | null } | { __typename?: 'LinkTileBlock', Name?: string | null } | { __typename?: 'LoaderBlock', Name?: string | null } | { __typename?: 'LocationBlock', Name?: string | null } | { __typename?: 'MeetingEventCardPage', Name?: string | null } | { __typename?: 'MeetingPage', Name?: string | null } | { __typename?: 'MemberDirectory', Name?: string | null } | { __typename?: 'MemberDirectoryPage', Name?: string | null } | { __typename?: 'MemberSectionBlock', Name?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Name?: string | null } | { __typename?: 'MembershipInvoicePage', Name?: string | null } | { __typename?: 'MembershipLevelBlock', Name?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Name?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Name?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Name?: string | null } | { __typename?: 'MembershipLevelsBlock', Name?: string | null } | { __typename?: 'MembershipRenewalPage', Name?: string | null } | { __typename?: 'MembershipRenewalV2Page', Name?: string | null } | { __typename?: 'MembershipRequirementBlock', Name?: string | null } | { __typename?: 'MembershipRequirementsBlock', Name?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Name?: string | null } | { __typename?: 'ModalInfoBlock', Name?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Name?: string | null } | { __typename?: 'NextCallOutBlock', Name?: string | null } | { __typename?: 'NextContactUsBlock', Name?: string | null } | { __typename?: 'NextContainerBlock', Name?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Name?: string | null } | { __typename?: 'NextEventBlock', Name?: string | null } | { __typename?: 'NextHeroBlock', Name?: string | null } | { __typename?: 'NextInfoBoxBlock', Name?: string | null } | { __typename?: 'NextPersonContainerBlock', Name?: string | null } | { __typename?: 'NextPersonDataBlock', Name?: string | null } | { __typename?: 'NextStaffAdminPage', Name?: string | null } | { __typename?: 'NextStaticPage', Name?: string | null } | { __typename?: 'NextSyncEventsBlock', Name?: string | null } | { __typename?: 'NotFoundPage', Name?: string | null } | { __typename?: 'NumberElementBlock', Name?: string | null } | { __typename?: 'NumberedContainerBlock', Name?: string | null } | { __typename?: 'NumberedItemBlock', Name?: string | null } | { __typename?: 'ParagraphTextElementBlock', Name?: string | null } | { __typename?: 'PastPresidentsBlock', Name?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Name?: string | null } | { __typename?: 'PersonBlock', Name?: string | null } | { __typename?: 'PersonContainerBlock', Name?: string | null } | { __typename?: 'PersonQuizPage', Name?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Name?: string | null } | { __typename?: 'PlaylistBlock', Name?: string | null } | { __typename?: 'PlaylistPromoBlock', Name?: string | null } | { __typename?: 'PodcastDetailBlock', Name?: string | null } | { __typename?: 'PowerPhrasePage', Name?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Name?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Name?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPortalPage', Name?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Name?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Name?: string | null } | { __typename?: 'PressReleasePage', Name?: string | null } | { __typename?: 'PriceBreakdownBlock', Name?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Name?: string | null } | { __typename?: 'ProductionDataSectionBlock', Name?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Name?: string | null } | { __typename?: 'ProductionModalBlock', Name?: string | null } | { __typename?: 'ProductionStepBlock', Name?: string | null } | { __typename?: 'ProductionStepV2Block', Name?: string | null } | { __typename?: 'ProductionTableBlock', Name?: string | null } | { __typename?: 'ProfileListBlock', Name?: string | null } | { __typename?: 'ProfilePictureBlock', Name?: string | null } | { __typename?: 'ProfileSectionBlock', Name?: string | null } | { __typename?: 'ProfileStepBlock', Name?: string | null } | { __typename?: 'ProfileStepV2Block', Name?: string | null } | { __typename?: 'PublicProfilePage', Name?: string | null } | { __typename?: 'QuizCareerBlock', Name?: string | null } | { __typename?: 'QuizEducationBlock', Name?: string | null } | { __typename?: 'QuizFinancialBlock', Name?: string | null } | { __typename?: 'QuizHealthBlock', Name?: string | null } | { __typename?: 'QuizRelationshipsBlock', Name?: string | null } | { __typename?: 'QuizServiceBlock', Name?: string | null } | { __typename?: 'QuizSpiritualBlock', Name?: string | null } | { __typename?: 'RTContributorFormPage', Name?: string | null } | { __typename?: 'RangeElementBlock', Name?: string | null } | { __typename?: 'ReceiptStepBlock', Name?: string | null } | { __typename?: 'ReceiptStepV2Block', Name?: string | null } | { __typename?: 'ResetButtonElementBlock', Name?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Name?: string | null } | { __typename?: 'ReviewBlock', Name?: string | null } | { __typename?: 'ReviewStepBlock', Name?: string | null } | { __typename?: 'RichTextBlock', Name?: string | null } | { __typename?: 'RoutingStepBlock', Name?: string | null } | { __typename?: 'SearchPage', Name?: string | null } | { __typename?: 'SearchPageV2', Name?: string | null } | { __typename?: 'SectionContainerBlock', Name?: string | null } | { __typename?: 'SectionItemBlock', Name?: string | null } | { __typename?: 'SelectionElementBlock', Name?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Name?: string | null } | { __typename?: 'SettingSectionBlock', Name?: string | null } | { __typename?: 'SiteSettingsPage', Name?: string | null } | { __typename?: 'SocialShareBlock', Name?: string | null } | { __typename?: 'SpeakerEngagementPage', Name?: string | null } | { __typename?: 'SponsorSpeakerPage', Name?: string | null } | { __typename?: 'SpotlightBlock', Name?: string | null } | { __typename?: 'SpotlightContainerBlock', Name?: string | null } | { __typename?: 'SpotlightDataBlock', Name?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Name?: string | null } | { __typename?: 'StoreCardPage', Name?: string | null } | { __typename?: 'SubmitButtonElementBlock', Name?: string | null } | { __typename?: 'SuccessSectionBlock', Name?: string | null } | { __typename?: 'SvgLinkBlock', Name?: string | null } | { __typename?: 'SvgMedia', Name?: string | null } | { __typename?: 'SvgTextCardBlock', Name?: string | null } | { __typename?: 'TabContainerBlock', Name?: string | null } | { __typename?: 'TabItemBlock', Name?: string | null } | { __typename?: 'TextCardBlock', Name?: string | null } | { __typename?: 'TextContentBlock', Name?: string | null } | { __typename?: 'TextareaElementBlock', Name?: string | null } | { __typename?: 'TextboxElementBlock', Name?: string | null } | { __typename?: 'TimelineContainerBlock', Name?: string | null } | { __typename?: 'TimelineItemBlock', Name?: string | null } | { __typename?: 'ToolkitBlock', Name?: string | null } | { __typename?: 'ToolkitItemBlock', Name?: string | null } | { __typename?: 'ToolkitSectionBlock', Name?: string | null } | { __typename?: 'ToolsCardPage', Name?: string | null } | { __typename?: 'TooltipBlock', Name?: string | null } | { __typename?: 'UrlElementBlock', Name?: string | null } | { __typename?: 'Video', Name?: string | null } | { __typename?: 'VideoBlock', Name?: string | null } | { __typename?: 'VideoDetailBlock', Name?: string | null } | { __typename?: 'VideoMedia', Name?: string | null } | { __typename?: 'VideoPromoBlock', Name?: string | null } | { __typename?: 'VisaLettersPage', Name?: string | null } | { __typename?: 'VisibilityOptionsBlock', Name?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Name?: string | null } | { __typename?: 'WireTransferSectionBlock', Name?: string | null } | { __typename?: 'YourAnswersSectionBlock', Name?: string | null } | null } | null } | null> | null, AssignedGroupsReadAccess?: Array<{ __typename?: 'AssignedGroupPropertyValue', GroupName?: string | null } | null> | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2' } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock', ProfileList?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock', Name?: string | null } | { __typename?: 'AccordionContainerBlock', Name?: string | null } | { __typename?: 'AccordionItemBlock', Name?: string | null } | { __typename?: 'AccountProfilePage', Name?: string | null } | { __typename?: 'AddressInfoBlock', Name?: string | null } | { __typename?: 'BadgeBlock', Name?: string | null } | { __typename?: 'BrandedTableBlock', Name?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Name?: string | null } | { __typename?: 'ButtonLabelBlock', Name?: string | null } | { __typename?: 'CaptchaElementBlock', Name?: string | null } | { __typename?: 'CategoryListBlock', Name?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Name?: string | null } | { __typename?: 'CflBadgesBlock', Name?: string | null } | { __typename?: 'CflHomePage', Name?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Name?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Name?: string | null } | { __typename?: 'CflSiteSettingsPage', Name?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Name?: string | null } | { __typename?: 'ChoiceElementBlock', Name?: string | null } | { __typename?: 'ColumnContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Name?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Name?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Name?: string | null } | { __typename?: 'CompanyRankingsPage', Name?: string | null } | { __typename?: 'ConfirmationModalBlock', Name?: string | null } | { __typename?: 'ConfirmationStepBlock', Name?: string | null } | { __typename?: 'CongratulationsStepV2Block', Name?: string | null } | { __typename?: 'ContactEmailElementBlock', Name?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Name?: string | null } | { __typename?: 'ContactNameElementBlock', Name?: string | null } | { __typename?: 'ContactPhoneElementBlock', Name?: string | null } | { __typename?: 'ContactsBlock', Name?: string | null } | { __typename?: 'Content', Name?: string | null } | { __typename?: 'DAMAsset', Name?: string | null } | { __typename?: 'DAMImageAsset', Name?: string | null } | { __typename?: 'DAMVideo', Name?: string | null } | { __typename?: 'DAMVideoAsset', Name?: string | null } | { __typename?: 'DashBoardSectionBlock', Name?: string | null } | { __typename?: 'DashboardAccountPage', Name?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Name?: string | null } | { __typename?: 'DashboardContactInformationBlock', Name?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Name?: string | null } | { __typename?: 'DashboardPermissionsBlock', Name?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfileBlock', Name?: string | null } | { __typename?: 'DashboardSharedPage', Name?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Name?: string | null } | { __typename?: 'DataMismatchModalBlock', Name?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Name?: string | null } | { __typename?: 'DescriptionButtonBlock', Name?: string | null } | { __typename?: 'DetailPage', Name?: string | null } | { __typename?: 'DocumentMedia', Name?: string | null } | { __typename?: 'DonationBlock', Name?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Name?: string | null } | { __typename?: 'EEPSectionBlock', Name?: string | null } | { __typename?: 'EVPCarouselBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Name?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Name?: string | null } | { __typename?: 'EVPContentBlock', Name?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Name?: string | null } | { __typename?: 'EVPGenericPage', Name?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Name?: string | null } | { __typename?: 'EVPHomePage', Name?: string | null } | { __typename?: 'EVPImageBlock', Name?: string | null } | { __typename?: 'EVPImageLinkBlock', Name?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Name?: string | null } | { __typename?: 'EVPLinkBlock', Name?: string | null } | { __typename?: 'EVPMediaFileBlock', Name?: string | null } | { __typename?: 'EVPNavigationPageBlock', Name?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Name?: string | null } | { __typename?: 'EVPResourcePage', Name?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Name?: string | null } | { __typename?: 'EVPSearchPage', Name?: string | null } | { __typename?: 'EVPSiteSettingsPage', Name?: string | null } | { __typename?: 'EVPTabBlock', Name?: string | null } | { __typename?: 'EVPTabCardBlock', Name?: string | null } | { __typename?: 'EVPTabCardsBlock', Name?: string | null } | { __typename?: 'EVPTabImageTextBlock', Name?: string | null } | { __typename?: 'EVPTabRichTextBlock', Name?: string | null } | { __typename?: 'EVPTabVideoBlock', Name?: string | null } | { __typename?: 'EVPTabsBlock', Name?: string | null } | { __typename?: 'EVPTextImageBlock', Name?: string | null } | { __typename?: 'EVPVideoBlock', Name?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'ErrorModalBlock', Name?: string | null } | { __typename?: 'ErrorPage', Name?: string | null } | { __typename?: 'ErrorPageBlock', Name?: string | null } | { __typename?: 'EventBlock', Name?: string | null } | { __typename?: 'EventLocationAndDateBlock', Name?: string | null } | { __typename?: 'EventLocationInformationBlock', Name?: string | null } | { __typename?: 'EventPage', Name?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Name?: string | null } | { __typename?: 'EventSessionBlock', Name?: string | null } | { __typename?: 'EventSessionScheduleBlock', Name?: string | null } | { __typename?: 'EventSessionTrackBlock', Name?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Name?: string | null } | { __typename?: 'EventSpeakerSearchPage', Name?: string | null } | { __typename?: 'EventSpeakersBlock', Name?: string | null } | { __typename?: 'EventTableContainerBlock', Name?: string | null } | { __typename?: 'ExpandableContainerBlock', Name?: string | null } | { __typename?: 'FileUploadElementBlock', Name?: string | null } | { __typename?: 'FlowFinishInformationBlock', Name?: string | null } | { __typename?: 'FolderPage', Name?: string | null } | { __typename?: 'FormContainerBlock', Name?: string | null } | { __typename?: 'FormStepBlock', Name?: string | null } | { __typename?: 'FourColumnTableBlock', Name?: string | null } | { __typename?: 'GaugeBlock', Name?: string | null } | { __typename?: 'GeoDataBlock', Name?: string | null } | { __typename?: 'GettingStartedStepBlock', Name?: string | null } | { __typename?: 'GettingStartedStepV2Block', Name?: string | null } | { __typename?: 'GreetingCaseBlock', Name?: string | null } | { __typename?: 'GreetingStepBlock', Name?: string | null } | { __typename?: 'GreetingStepV2Block', Name?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Name?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Name?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Name?: string | null } | { __typename?: 'GsAwardsPage', Name?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Name?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Name?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Name?: string | null } | { __typename?: 'GsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsGreetingStepBlock', Name?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Name?: string | null } | { __typename?: 'GsMembershipRenewalPage', Name?: string | null } | { __typename?: 'GsProfileStepBlock', Name?: string | null } | { __typename?: 'GsReceiptStepBlock', Name?: string | null } | { __typename?: 'GsReviewStepBlock', Name?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Name?: string | null } | { __typename?: 'HeroTextContentBlock', Name?: string | null } | { __typename?: 'HomePage', Name?: string | null } | { __typename?: 'HomePageV2', Name?: string | null } | { __typename?: 'IconRequirementBlock', Name?: string | null } | { __typename?: 'Image', Name?: string | null } | { __typename?: 'ImageBlock', Name?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Name?: string | null } | { __typename?: 'ImageChoiceElementBlock', Name?: string | null } | { __typename?: 'ImageLinkBlock', Name?: string | null } | { __typename?: 'ImageMedia', Name?: string | null } | { __typename?: 'ImageTextBlock', Name?: string | null } | { __typename?: 'ImageTextBlockV2', Name?: string | null } | { __typename?: 'ImageTextCardBlock', Name?: string | null } | { __typename?: 'ImageTextItemBlock', Name?: string | null } | { __typename?: 'InfoBoxBlock', Name?: string | null } | { __typename?: 'KeyLinkValueBlock', Name?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Name?: string | null } | { __typename?: 'LandingPage', Name?: string | null } | { __typename?: 'LanguageIdAndName', Name?: string | null } | { __typename?: 'LanguagesBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Name?: string | null } | { __typename?: 'LearnDetailPage', Name?: string | null } | { __typename?: 'LearnHeroImageBlock', Name?: string | null } | { __typename?: 'LearnLandingPage', Name?: string | null } | { __typename?: 'LearnPageV2', Name?: string | null } | { __typename?: 'LearnPlayListPage', Name?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Name?: string | null } | { __typename?: 'LinkBlock', Name?: string | null } | { __typename?: 'LinkListBlock', Name?: string | null } | { __typename?: 'LinkTileBlock', Name?: string | null } | { __typename?: 'LoaderBlock', Name?: string | null } | { __typename?: 'LocationBlock', Name?: string | null } | { __typename?: 'MeetingEventCardPage', Name?: string | null } | { __typename?: 'MeetingPage', Name?: string | null } | { __typename?: 'MemberDirectory', Name?: string | null } | { __typename?: 'MemberDirectoryPage', Name?: string | null } | { __typename?: 'MemberSectionBlock', Name?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Name?: string | null } | { __typename?: 'MembershipInvoicePage', Name?: string | null } | { __typename?: 'MembershipLevelBlock', Name?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Name?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Name?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Name?: string | null } | { __typename?: 'MembershipLevelsBlock', Name?: string | null } | { __typename?: 'MembershipRenewalPage', Name?: string | null } | { __typename?: 'MembershipRenewalV2Page', Name?: string | null } | { __typename?: 'MembershipRequirementBlock', Name?: string | null } | { __typename?: 'MembershipRequirementsBlock', Name?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Name?: string | null } | { __typename?: 'ModalInfoBlock', Name?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Name?: string | null } | { __typename?: 'NextCallOutBlock', Name?: string | null } | { __typename?: 'NextContactUsBlock', Name?: string | null } | { __typename?: 'NextContainerBlock', Name?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Name?: string | null } | { __typename?: 'NextEventBlock', Name?: string | null } | { __typename?: 'NextHeroBlock', Name?: string | null } | { __typename?: 'NextInfoBoxBlock', Name?: string | null } | { __typename?: 'NextPersonContainerBlock', Name?: string | null } | { __typename?: 'NextPersonDataBlock', Name?: string | null } | { __typename?: 'NextStaffAdminPage', Name?: string | null } | { __typename?: 'NextStaticPage', Name?: string | null } | { __typename?: 'NextSyncEventsBlock', Name?: string | null } | { __typename?: 'NotFoundPage', Name?: string | null } | { __typename?: 'NumberElementBlock', Name?: string | null } | { __typename?: 'NumberedContainerBlock', Name?: string | null } | { __typename?: 'NumberedItemBlock', Name?: string | null } | { __typename?: 'ParagraphTextElementBlock', Name?: string | null } | { __typename?: 'PastPresidentsBlock', Name?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Name?: string | null } | { __typename?: 'PersonBlock', Name?: string | null } | { __typename?: 'PersonContainerBlock', Name?: string | null } | { __typename?: 'PersonQuizPage', Name?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Name?: string | null } | { __typename?: 'PlaylistBlock', Name?: string | null } | { __typename?: 'PlaylistPromoBlock', Name?: string | null } | { __typename?: 'PodcastDetailBlock', Name?: string | null } | { __typename?: 'PowerPhrasePage', Name?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Name?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Name?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPortalPage', Name?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Name?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Name?: string | null } | { __typename?: 'PressReleasePage', Name?: string | null } | { __typename?: 'PriceBreakdownBlock', Name?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Name?: string | null } | { __typename?: 'ProductionDataSectionBlock', Name?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Name?: string | null } | { __typename?: 'ProductionModalBlock', Name?: string | null } | { __typename?: 'ProductionStepBlock', Name?: string | null } | { __typename?: 'ProductionStepV2Block', Name?: string | null } | { __typename?: 'ProductionTableBlock', Name?: string | null } | { __typename?: 'ProfileListBlock', Name?: string | null } | { __typename?: 'ProfilePictureBlock', Name?: string | null } | { __typename?: 'ProfileSectionBlock', Name?: string | null } | { __typename?: 'ProfileStepBlock', Name?: string | null } | { __typename?: 'ProfileStepV2Block', Name?: string | null } | { __typename?: 'PublicProfilePage', Name?: string | null } | { __typename?: 'QuizCareerBlock', Name?: string | null } | { __typename?: 'QuizEducationBlock', Name?: string | null } | { __typename?: 'QuizFinancialBlock', Name?: string | null } | { __typename?: 'QuizHealthBlock', Name?: string | null } | { __typename?: 'QuizRelationshipsBlock', Name?: string | null } | { __typename?: 'QuizServiceBlock', Name?: string | null } | { __typename?: 'QuizSpiritualBlock', Name?: string | null } | { __typename?: 'RTContributorFormPage', Name?: string | null } | { __typename?: 'RangeElementBlock', Name?: string | null } | { __typename?: 'ReceiptStepBlock', Name?: string | null } | { __typename?: 'ReceiptStepV2Block', Name?: string | null } | { __typename?: 'ResetButtonElementBlock', Name?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Name?: string | null } | { __typename?: 'ReviewBlock', Name?: string | null } | { __typename?: 'ReviewStepBlock', Name?: string | null } | { __typename?: 'RichTextBlock', Name?: string | null } | { __typename?: 'RoutingStepBlock', Name?: string | null } | { __typename?: 'SearchPage', Name?: string | null } | { __typename?: 'SearchPageV2', Name?: string | null } | { __typename?: 'SectionContainerBlock', Name?: string | null } | { __typename?: 'SectionItemBlock', Name?: string | null } | { __typename?: 'SelectionElementBlock', Name?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Name?: string | null } | { __typename?: 'SettingSectionBlock', Name?: string | null } | { __typename?: 'SiteSettingsPage', Name?: string | null } | { __typename?: 'SocialShareBlock', Name?: string | null } | { __typename?: 'SpeakerEngagementPage', Name?: string | null } | { __typename?: 'SponsorSpeakerPage', Name?: string | null } | { __typename?: 'SpotlightBlock', Name?: string | null } | { __typename?: 'SpotlightContainerBlock', Name?: string | null } | { __typename?: 'SpotlightDataBlock', Name?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Name?: string | null } | { __typename?: 'StoreCardPage', Name?: string | null } | { __typename?: 'SubmitButtonElementBlock', Name?: string | null } | { __typename?: 'SuccessSectionBlock', Name?: string | null } | { __typename?: 'SvgLinkBlock', Name?: string | null } | { __typename?: 'SvgMedia', Name?: string | null } | { __typename?: 'SvgTextCardBlock', Name?: string | null } | { __typename?: 'TabContainerBlock', Name?: string | null } | { __typename?: 'TabItemBlock', Name?: string | null } | { __typename?: 'TextCardBlock', Name?: string | null } | { __typename?: 'TextContentBlock', Name?: string | null } | { __typename?: 'TextareaElementBlock', Name?: string | null } | { __typename?: 'TextboxElementBlock', Name?: string | null } | { __typename?: 'TimelineContainerBlock', Name?: string | null } | { __typename?: 'TimelineItemBlock', Name?: string | null } | { __typename?: 'ToolkitBlock', Name?: string | null } | { __typename?: 'ToolkitItemBlock', Name?: string | null } | { __typename?: 'ToolkitSectionBlock', Name?: string | null } | { __typename?: 'ToolsCardPage', Name?: string | null } | { __typename?: 'TooltipBlock', Name?: string | null } | { __typename?: 'UrlElementBlock', Name?: string | null } | { __typename?: 'Video', Name?: string | null } | { __typename?: 'VideoBlock', Name?: string | null } | { __typename?: 'VideoDetailBlock', Name?: string | null } | { __typename?: 'VideoMedia', Name?: string | null } | { __typename?: 'VideoPromoBlock', Name?: string | null } | { __typename?: 'VisaLettersPage', Name?: string | null } | { __typename?: 'VisibilityOptionsBlock', Name?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Name?: string | null } | { __typename?: 'WireTransferSectionBlock', Name?: string | null } | { __typename?: 'YourAnswersSectionBlock', Name?: string | null } | null } | null } | null> | null } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null };

export type LearnContentCarouselCardQueryVariables = Exact<{
  learn_content_guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type LearnContentCarouselCardQuery = { __typename?: 'Query', LearnDetailPage?: { __typename?: 'LearnDetailPageOutput', items?: Array<{ __typename?: 'LearnDetailPage', RelativePath?: string | null, ReadTimeInSeconds?: number | null, ContentTypeSelection?: number | null, Subheading?: string | null, SubheadingText?: string | null, Heading?: string | null, MagazineIssueYear?: number | null, MagazineIssueMonth?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null, ExpandedCategories?: Array<{ __typename?: 'ExpandedCategoriesEntry', Id?: number | null, ParentId?: number | null, Name?: string | null } | null> | null, ThumbnailImage?: { __typename?: 'LearnDetailPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Authors?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock', Name?: string | null } | { __typename?: 'AccordionContainerBlock', Name?: string | null } | { __typename?: 'AccordionItemBlock', Name?: string | null } | { __typename?: 'AccountProfilePage', Name?: string | null } | { __typename?: 'AddressInfoBlock', Name?: string | null } | { __typename?: 'BadgeBlock', Name?: string | null } | { __typename?: 'BrandedTableBlock', Name?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Name?: string | null } | { __typename?: 'ButtonLabelBlock', Name?: string | null } | { __typename?: 'CaptchaElementBlock', Name?: string | null } | { __typename?: 'CategoryListBlock', Name?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Name?: string | null } | { __typename?: 'CflBadgesBlock', Name?: string | null } | { __typename?: 'CflHomePage', Name?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Name?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Name?: string | null } | { __typename?: 'CflSiteSettingsPage', Name?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Name?: string | null } | { __typename?: 'ChoiceElementBlock', Name?: string | null } | { __typename?: 'ColumnContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Name?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Name?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Name?: string | null } | { __typename?: 'CompanyRankingsPage', Name?: string | null } | { __typename?: 'ConfirmationModalBlock', Name?: string | null } | { __typename?: 'ConfirmationStepBlock', Name?: string | null } | { __typename?: 'CongratulationsStepV2Block', Name?: string | null } | { __typename?: 'ContactEmailElementBlock', Name?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Name?: string | null } | { __typename?: 'ContactNameElementBlock', Name?: string | null } | { __typename?: 'ContactPhoneElementBlock', Name?: string | null } | { __typename?: 'ContactsBlock', Name?: string | null } | { __typename?: 'Content', Name?: string | null } | { __typename?: 'DAMAsset', Name?: string | null } | { __typename?: 'DAMImageAsset', Name?: string | null } | { __typename?: 'DAMVideo', Name?: string | null } | { __typename?: 'DAMVideoAsset', Name?: string | null } | { __typename?: 'DashBoardSectionBlock', Name?: string | null } | { __typename?: 'DashboardAccountPage', Name?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Name?: string | null } | { __typename?: 'DashboardContactInformationBlock', Name?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Name?: string | null } | { __typename?: 'DashboardPermissionsBlock', Name?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfileBlock', Name?: string | null } | { __typename?: 'DashboardSharedPage', Name?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Name?: string | null } | { __typename?: 'DataMismatchModalBlock', Name?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Name?: string | null } | { __typename?: 'DescriptionButtonBlock', Name?: string | null } | { __typename?: 'DetailPage', Name?: string | null } | { __typename?: 'DocumentMedia', Name?: string | null } | { __typename?: 'DonationBlock', Name?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Name?: string | null } | { __typename?: 'EEPSectionBlock', Name?: string | null } | { __typename?: 'EVPCarouselBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Name?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Name?: string | null } | { __typename?: 'EVPContentBlock', Name?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Name?: string | null } | { __typename?: 'EVPGenericPage', Name?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Name?: string | null } | { __typename?: 'EVPHomePage', Name?: string | null } | { __typename?: 'EVPImageBlock', Name?: string | null } | { __typename?: 'EVPImageLinkBlock', Name?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Name?: string | null } | { __typename?: 'EVPLinkBlock', Name?: string | null } | { __typename?: 'EVPMediaFileBlock', Name?: string | null } | { __typename?: 'EVPNavigationPageBlock', Name?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Name?: string | null } | { __typename?: 'EVPResourcePage', Name?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Name?: string | null } | { __typename?: 'EVPSearchPage', Name?: string | null } | { __typename?: 'EVPSiteSettingsPage', Name?: string | null } | { __typename?: 'EVPTabBlock', Name?: string | null } | { __typename?: 'EVPTabCardBlock', Name?: string | null } | { __typename?: 'EVPTabCardsBlock', Name?: string | null } | { __typename?: 'EVPTabImageTextBlock', Name?: string | null } | { __typename?: 'EVPTabRichTextBlock', Name?: string | null } | { __typename?: 'EVPTabVideoBlock', Name?: string | null } | { __typename?: 'EVPTabsBlock', Name?: string | null } | { __typename?: 'EVPTextImageBlock', Name?: string | null } | { __typename?: 'EVPVideoBlock', Name?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'ErrorModalBlock', Name?: string | null } | { __typename?: 'ErrorPage', Name?: string | null } | { __typename?: 'ErrorPageBlock', Name?: string | null } | { __typename?: 'EventBlock', Name?: string | null } | { __typename?: 'EventLocationAndDateBlock', Name?: string | null } | { __typename?: 'EventLocationInformationBlock', Name?: string | null } | { __typename?: 'EventPage', Name?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Name?: string | null } | { __typename?: 'EventSessionBlock', Name?: string | null } | { __typename?: 'EventSessionScheduleBlock', Name?: string | null } | { __typename?: 'EventSessionTrackBlock', Name?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Name?: string | null } | { __typename?: 'EventSpeakerSearchPage', Name?: string | null } | { __typename?: 'EventSpeakersBlock', Name?: string | null } | { __typename?: 'EventTableContainerBlock', Name?: string | null } | { __typename?: 'ExpandableContainerBlock', Name?: string | null } | { __typename?: 'FileUploadElementBlock', Name?: string | null } | { __typename?: 'FlowFinishInformationBlock', Name?: string | null } | { __typename?: 'FolderPage', Name?: string | null } | { __typename?: 'FormContainerBlock', Name?: string | null } | { __typename?: 'FormStepBlock', Name?: string | null } | { __typename?: 'FourColumnTableBlock', Name?: string | null } | { __typename?: 'GaugeBlock', Name?: string | null } | { __typename?: 'GeoDataBlock', Name?: string | null } | { __typename?: 'GettingStartedStepBlock', Name?: string | null } | { __typename?: 'GettingStartedStepV2Block', Name?: string | null } | { __typename?: 'GreetingCaseBlock', Name?: string | null } | { __typename?: 'GreetingStepBlock', Name?: string | null } | { __typename?: 'GreetingStepV2Block', Name?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Name?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Name?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Name?: string | null } | { __typename?: 'GsAwardsPage', Name?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Name?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Name?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Name?: string | null } | { __typename?: 'GsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsGreetingStepBlock', Name?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Name?: string | null } | { __typename?: 'GsMembershipRenewalPage', Name?: string | null } | { __typename?: 'GsProfileStepBlock', Name?: string | null } | { __typename?: 'GsReceiptStepBlock', Name?: string | null } | { __typename?: 'GsReviewStepBlock', Name?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Name?: string | null } | { __typename?: 'HeroTextContentBlock', Name?: string | null } | { __typename?: 'HomePage', Name?: string | null } | { __typename?: 'HomePageV2', Name?: string | null } | { __typename?: 'IconRequirementBlock', Name?: string | null } | { __typename?: 'Image', Name?: string | null } | { __typename?: 'ImageBlock', Name?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Name?: string | null } | { __typename?: 'ImageChoiceElementBlock', Name?: string | null } | { __typename?: 'ImageLinkBlock', Name?: string | null } | { __typename?: 'ImageMedia', Name?: string | null } | { __typename?: 'ImageTextBlock', Name?: string | null } | { __typename?: 'ImageTextBlockV2', Name?: string | null } | { __typename?: 'ImageTextCardBlock', Name?: string | null } | { __typename?: 'ImageTextItemBlock', Name?: string | null } | { __typename?: 'InfoBoxBlock', Name?: string | null } | { __typename?: 'KeyLinkValueBlock', Name?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Name?: string | null } | { __typename?: 'LandingPage', Name?: string | null } | { __typename?: 'LanguageIdAndName', Name?: string | null } | { __typename?: 'LanguagesBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Name?: string | null } | { __typename?: 'LearnDetailPage', Name?: string | null } | { __typename?: 'LearnHeroImageBlock', Name?: string | null } | { __typename?: 'LearnLandingPage', Name?: string | null } | { __typename?: 'LearnPageV2', Name?: string | null } | { __typename?: 'LearnPlayListPage', Name?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Name?: string | null } | { __typename?: 'LinkBlock', Name?: string | null } | { __typename?: 'LinkListBlock', Name?: string | null } | { __typename?: 'LinkTileBlock', Name?: string | null } | { __typename?: 'LoaderBlock', Name?: string | null } | { __typename?: 'LocationBlock', Name?: string | null } | { __typename?: 'MeetingEventCardPage', Name?: string | null } | { __typename?: 'MeetingPage', Name?: string | null } | { __typename?: 'MemberDirectory', Name?: string | null } | { __typename?: 'MemberDirectoryPage', Name?: string | null } | { __typename?: 'MemberSectionBlock', Name?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Name?: string | null } | { __typename?: 'MembershipInvoicePage', Name?: string | null } | { __typename?: 'MembershipLevelBlock', Name?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Name?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Name?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Name?: string | null } | { __typename?: 'MembershipLevelsBlock', Name?: string | null } | { __typename?: 'MembershipRenewalPage', Name?: string | null } | { __typename?: 'MembershipRenewalV2Page', Name?: string | null } | { __typename?: 'MembershipRequirementBlock', Name?: string | null } | { __typename?: 'MembershipRequirementsBlock', Name?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Name?: string | null } | { __typename?: 'ModalInfoBlock', Name?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Name?: string | null } | { __typename?: 'NextCallOutBlock', Name?: string | null } | { __typename?: 'NextContactUsBlock', Name?: string | null } | { __typename?: 'NextContainerBlock', Name?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Name?: string | null } | { __typename?: 'NextEventBlock', Name?: string | null } | { __typename?: 'NextHeroBlock', Name?: string | null } | { __typename?: 'NextInfoBoxBlock', Name?: string | null } | { __typename?: 'NextPersonContainerBlock', Name?: string | null } | { __typename?: 'NextPersonDataBlock', Name?: string | null } | { __typename?: 'NextStaffAdminPage', Name?: string | null } | { __typename?: 'NextStaticPage', Name?: string | null } | { __typename?: 'NextSyncEventsBlock', Name?: string | null } | { __typename?: 'NotFoundPage', Name?: string | null } | { __typename?: 'NumberElementBlock', Name?: string | null } | { __typename?: 'NumberedContainerBlock', Name?: string | null } | { __typename?: 'NumberedItemBlock', Name?: string | null } | { __typename?: 'ParagraphTextElementBlock', Name?: string | null } | { __typename?: 'PastPresidentsBlock', Name?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Name?: string | null } | { __typename?: 'PersonBlock', Name?: string | null } | { __typename?: 'PersonContainerBlock', Name?: string | null } | { __typename?: 'PersonQuizPage', Name?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Name?: string | null } | { __typename?: 'PlaylistBlock', Name?: string | null } | { __typename?: 'PlaylistPromoBlock', Name?: string | null } | { __typename?: 'PodcastDetailBlock', Name?: string | null } | { __typename?: 'PowerPhrasePage', Name?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Name?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Name?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPortalPage', Name?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Name?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Name?: string | null } | { __typename?: 'PressReleasePage', Name?: string | null } | { __typename?: 'PriceBreakdownBlock', Name?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Name?: string | null } | { __typename?: 'ProductionDataSectionBlock', Name?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Name?: string | null } | { __typename?: 'ProductionModalBlock', Name?: string | null } | { __typename?: 'ProductionStepBlock', Name?: string | null } | { __typename?: 'ProductionStepV2Block', Name?: string | null } | { __typename?: 'ProductionTableBlock', Name?: string | null } | { __typename?: 'ProfileListBlock', Name?: string | null } | { __typename?: 'ProfilePictureBlock', Name?: string | null } | { __typename?: 'ProfileSectionBlock', Name?: string | null } | { __typename?: 'ProfileStepBlock', Name?: string | null } | { __typename?: 'ProfileStepV2Block', Name?: string | null } | { __typename?: 'PublicProfilePage', Name?: string | null } | { __typename?: 'QuizCareerBlock', Name?: string | null } | { __typename?: 'QuizEducationBlock', Name?: string | null } | { __typename?: 'QuizFinancialBlock', Name?: string | null } | { __typename?: 'QuizHealthBlock', Name?: string | null } | { __typename?: 'QuizRelationshipsBlock', Name?: string | null } | { __typename?: 'QuizServiceBlock', Name?: string | null } | { __typename?: 'QuizSpiritualBlock', Name?: string | null } | { __typename?: 'RTContributorFormPage', Name?: string | null } | { __typename?: 'RangeElementBlock', Name?: string | null } | { __typename?: 'ReceiptStepBlock', Name?: string | null } | { __typename?: 'ReceiptStepV2Block', Name?: string | null } | { __typename?: 'ResetButtonElementBlock', Name?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Name?: string | null } | { __typename?: 'ReviewBlock', Name?: string | null } | { __typename?: 'ReviewStepBlock', Name?: string | null } | { __typename?: 'RichTextBlock', Name?: string | null } | { __typename?: 'RoutingStepBlock', Name?: string | null } | { __typename?: 'SearchPage', Name?: string | null } | { __typename?: 'SearchPageV2', Name?: string | null } | { __typename?: 'SectionContainerBlock', Name?: string | null } | { __typename?: 'SectionItemBlock', Name?: string | null } | { __typename?: 'SelectionElementBlock', Name?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Name?: string | null } | { __typename?: 'SettingSectionBlock', Name?: string | null } | { __typename?: 'SiteSettingsPage', Name?: string | null } | { __typename?: 'SocialShareBlock', Name?: string | null } | { __typename?: 'SpeakerEngagementPage', Name?: string | null } | { __typename?: 'SponsorSpeakerPage', Name?: string | null } | { __typename?: 'SpotlightBlock', Name?: string | null } | { __typename?: 'SpotlightContainerBlock', Name?: string | null } | { __typename?: 'SpotlightDataBlock', Name?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Name?: string | null } | { __typename?: 'StoreCardPage', Name?: string | null } | { __typename?: 'SubmitButtonElementBlock', Name?: string | null } | { __typename?: 'SuccessSectionBlock', Name?: string | null } | { __typename?: 'SvgLinkBlock', Name?: string | null } | { __typename?: 'SvgMedia', Name?: string | null } | { __typename?: 'SvgTextCardBlock', Name?: string | null } | { __typename?: 'TabContainerBlock', Name?: string | null } | { __typename?: 'TabItemBlock', Name?: string | null } | { __typename?: 'TextCardBlock', Name?: string | null } | { __typename?: 'TextContentBlock', Name?: string | null } | { __typename?: 'TextareaElementBlock', Name?: string | null } | { __typename?: 'TextboxElementBlock', Name?: string | null } | { __typename?: 'TimelineContainerBlock', Name?: string | null } | { __typename?: 'TimelineItemBlock', Name?: string | null } | { __typename?: 'ToolkitBlock', Name?: string | null } | { __typename?: 'ToolkitItemBlock', Name?: string | null } | { __typename?: 'ToolkitSectionBlock', Name?: string | null } | { __typename?: 'ToolsCardPage', Name?: string | null } | { __typename?: 'TooltipBlock', Name?: string | null } | { __typename?: 'UrlElementBlock', Name?: string | null } | { __typename?: 'Video', Name?: string | null } | { __typename?: 'VideoBlock', Name?: string | null } | { __typename?: 'VideoDetailBlock', Name?: string | null } | { __typename?: 'VideoMedia', Name?: string | null } | { __typename?: 'VideoPromoBlock', Name?: string | null } | { __typename?: 'VisaLettersPage', Name?: string | null } | { __typename?: 'VisibilityOptionsBlock', Name?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Name?: string | null } | { __typename?: 'WireTransferSectionBlock', Name?: string | null } | { __typename?: 'YourAnswersSectionBlock', Name?: string | null } | null } | null } | null> | null, AssignedGroupsReadAccess?: Array<{ __typename?: 'AssignedGroupPropertyValue', GroupName?: string | null } | null> | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2' } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock', ProfileList?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock', Name?: string | null } | { __typename?: 'AccordionContainerBlock', Name?: string | null } | { __typename?: 'AccordionItemBlock', Name?: string | null } | { __typename?: 'AccountProfilePage', Name?: string | null } | { __typename?: 'AddressInfoBlock', Name?: string | null } | { __typename?: 'BadgeBlock', Name?: string | null } | { __typename?: 'BrandedTableBlock', Name?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Name?: string | null } | { __typename?: 'ButtonLabelBlock', Name?: string | null } | { __typename?: 'CaptchaElementBlock', Name?: string | null } | { __typename?: 'CategoryListBlock', Name?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Name?: string | null } | { __typename?: 'CflBadgesBlock', Name?: string | null } | { __typename?: 'CflHomePage', Name?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Name?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Name?: string | null } | { __typename?: 'CflSiteSettingsPage', Name?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Name?: string | null } | { __typename?: 'ChoiceElementBlock', Name?: string | null } | { __typename?: 'ColumnContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Name?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Name?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Name?: string | null } | { __typename?: 'CompanyRankingsPage', Name?: string | null } | { __typename?: 'ConfirmationModalBlock', Name?: string | null } | { __typename?: 'ConfirmationStepBlock', Name?: string | null } | { __typename?: 'CongratulationsStepV2Block', Name?: string | null } | { __typename?: 'ContactEmailElementBlock', Name?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Name?: string | null } | { __typename?: 'ContactNameElementBlock', Name?: string | null } | { __typename?: 'ContactPhoneElementBlock', Name?: string | null } | { __typename?: 'ContactsBlock', Name?: string | null } | { __typename?: 'Content', Name?: string | null } | { __typename?: 'DAMAsset', Name?: string | null } | { __typename?: 'DAMImageAsset', Name?: string | null } | { __typename?: 'DAMVideo', Name?: string | null } | { __typename?: 'DAMVideoAsset', Name?: string | null } | { __typename?: 'DashBoardSectionBlock', Name?: string | null } | { __typename?: 'DashboardAccountPage', Name?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Name?: string | null } | { __typename?: 'DashboardContactInformationBlock', Name?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Name?: string | null } | { __typename?: 'DashboardPermissionsBlock', Name?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfileBlock', Name?: string | null } | { __typename?: 'DashboardSharedPage', Name?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Name?: string | null } | { __typename?: 'DataMismatchModalBlock', Name?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Name?: string | null } | { __typename?: 'DescriptionButtonBlock', Name?: string | null } | { __typename?: 'DetailPage', Name?: string | null } | { __typename?: 'DocumentMedia', Name?: string | null } | { __typename?: 'DonationBlock', Name?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Name?: string | null } | { __typename?: 'EEPSectionBlock', Name?: string | null } | { __typename?: 'EVPCarouselBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Name?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Name?: string | null } | { __typename?: 'EVPContentBlock', Name?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Name?: string | null } | { __typename?: 'EVPGenericPage', Name?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Name?: string | null } | { __typename?: 'EVPHomePage', Name?: string | null } | { __typename?: 'EVPImageBlock', Name?: string | null } | { __typename?: 'EVPImageLinkBlock', Name?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Name?: string | null } | { __typename?: 'EVPLinkBlock', Name?: string | null } | { __typename?: 'EVPMediaFileBlock', Name?: string | null } | { __typename?: 'EVPNavigationPageBlock', Name?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Name?: string | null } | { __typename?: 'EVPResourcePage', Name?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Name?: string | null } | { __typename?: 'EVPSearchPage', Name?: string | null } | { __typename?: 'EVPSiteSettingsPage', Name?: string | null } | { __typename?: 'EVPTabBlock', Name?: string | null } | { __typename?: 'EVPTabCardBlock', Name?: string | null } | { __typename?: 'EVPTabCardsBlock', Name?: string | null } | { __typename?: 'EVPTabImageTextBlock', Name?: string | null } | { __typename?: 'EVPTabRichTextBlock', Name?: string | null } | { __typename?: 'EVPTabVideoBlock', Name?: string | null } | { __typename?: 'EVPTabsBlock', Name?: string | null } | { __typename?: 'EVPTextImageBlock', Name?: string | null } | { __typename?: 'EVPVideoBlock', Name?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'ErrorModalBlock', Name?: string | null } | { __typename?: 'ErrorPage', Name?: string | null } | { __typename?: 'ErrorPageBlock', Name?: string | null } | { __typename?: 'EventBlock', Name?: string | null } | { __typename?: 'EventLocationAndDateBlock', Name?: string | null } | { __typename?: 'EventLocationInformationBlock', Name?: string | null } | { __typename?: 'EventPage', Name?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Name?: string | null } | { __typename?: 'EventSessionBlock', Name?: string | null } | { __typename?: 'EventSessionScheduleBlock', Name?: string | null } | { __typename?: 'EventSessionTrackBlock', Name?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Name?: string | null } | { __typename?: 'EventSpeakerSearchPage', Name?: string | null } | { __typename?: 'EventSpeakersBlock', Name?: string | null } | { __typename?: 'EventTableContainerBlock', Name?: string | null } | { __typename?: 'ExpandableContainerBlock', Name?: string | null } | { __typename?: 'FileUploadElementBlock', Name?: string | null } | { __typename?: 'FlowFinishInformationBlock', Name?: string | null } | { __typename?: 'FolderPage', Name?: string | null } | { __typename?: 'FormContainerBlock', Name?: string | null } | { __typename?: 'FormStepBlock', Name?: string | null } | { __typename?: 'FourColumnTableBlock', Name?: string | null } | { __typename?: 'GaugeBlock', Name?: string | null } | { __typename?: 'GeoDataBlock', Name?: string | null } | { __typename?: 'GettingStartedStepBlock', Name?: string | null } | { __typename?: 'GettingStartedStepV2Block', Name?: string | null } | { __typename?: 'GreetingCaseBlock', Name?: string | null } | { __typename?: 'GreetingStepBlock', Name?: string | null } | { __typename?: 'GreetingStepV2Block', Name?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Name?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Name?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Name?: string | null } | { __typename?: 'GsAwardsPage', Name?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Name?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Name?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Name?: string | null } | { __typename?: 'GsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsGreetingStepBlock', Name?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Name?: string | null } | { __typename?: 'GsMembershipRenewalPage', Name?: string | null } | { __typename?: 'GsProfileStepBlock', Name?: string | null } | { __typename?: 'GsReceiptStepBlock', Name?: string | null } | { __typename?: 'GsReviewStepBlock', Name?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Name?: string | null } | { __typename?: 'HeroTextContentBlock', Name?: string | null } | { __typename?: 'HomePage', Name?: string | null } | { __typename?: 'HomePageV2', Name?: string | null } | { __typename?: 'IconRequirementBlock', Name?: string | null } | { __typename?: 'Image', Name?: string | null } | { __typename?: 'ImageBlock', Name?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Name?: string | null } | { __typename?: 'ImageChoiceElementBlock', Name?: string | null } | { __typename?: 'ImageLinkBlock', Name?: string | null } | { __typename?: 'ImageMedia', Name?: string | null } | { __typename?: 'ImageTextBlock', Name?: string | null } | { __typename?: 'ImageTextBlockV2', Name?: string | null } | { __typename?: 'ImageTextCardBlock', Name?: string | null } | { __typename?: 'ImageTextItemBlock', Name?: string | null } | { __typename?: 'InfoBoxBlock', Name?: string | null } | { __typename?: 'KeyLinkValueBlock', Name?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Name?: string | null } | { __typename?: 'LandingPage', Name?: string | null } | { __typename?: 'LanguageIdAndName', Name?: string | null } | { __typename?: 'LanguagesBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Name?: string | null } | { __typename?: 'LearnDetailPage', Name?: string | null } | { __typename?: 'LearnHeroImageBlock', Name?: string | null } | { __typename?: 'LearnLandingPage', Name?: string | null } | { __typename?: 'LearnPageV2', Name?: string | null } | { __typename?: 'LearnPlayListPage', Name?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Name?: string | null } | { __typename?: 'LinkBlock', Name?: string | null } | { __typename?: 'LinkListBlock', Name?: string | null } | { __typename?: 'LinkTileBlock', Name?: string | null } | { __typename?: 'LoaderBlock', Name?: string | null } | { __typename?: 'LocationBlock', Name?: string | null } | { __typename?: 'MeetingEventCardPage', Name?: string | null } | { __typename?: 'MeetingPage', Name?: string | null } | { __typename?: 'MemberDirectory', Name?: string | null } | { __typename?: 'MemberDirectoryPage', Name?: string | null } | { __typename?: 'MemberSectionBlock', Name?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Name?: string | null } | { __typename?: 'MembershipInvoicePage', Name?: string | null } | { __typename?: 'MembershipLevelBlock', Name?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Name?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Name?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Name?: string | null } | { __typename?: 'MembershipLevelsBlock', Name?: string | null } | { __typename?: 'MembershipRenewalPage', Name?: string | null } | { __typename?: 'MembershipRenewalV2Page', Name?: string | null } | { __typename?: 'MembershipRequirementBlock', Name?: string | null } | { __typename?: 'MembershipRequirementsBlock', Name?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Name?: string | null } | { __typename?: 'ModalInfoBlock', Name?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Name?: string | null } | { __typename?: 'NextCallOutBlock', Name?: string | null } | { __typename?: 'NextContactUsBlock', Name?: string | null } | { __typename?: 'NextContainerBlock', Name?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Name?: string | null } | { __typename?: 'NextEventBlock', Name?: string | null } | { __typename?: 'NextHeroBlock', Name?: string | null } | { __typename?: 'NextInfoBoxBlock', Name?: string | null } | { __typename?: 'NextPersonContainerBlock', Name?: string | null } | { __typename?: 'NextPersonDataBlock', Name?: string | null } | { __typename?: 'NextStaffAdminPage', Name?: string | null } | { __typename?: 'NextStaticPage', Name?: string | null } | { __typename?: 'NextSyncEventsBlock', Name?: string | null } | { __typename?: 'NotFoundPage', Name?: string | null } | { __typename?: 'NumberElementBlock', Name?: string | null } | { __typename?: 'NumberedContainerBlock', Name?: string | null } | { __typename?: 'NumberedItemBlock', Name?: string | null } | { __typename?: 'ParagraphTextElementBlock', Name?: string | null } | { __typename?: 'PastPresidentsBlock', Name?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Name?: string | null } | { __typename?: 'PersonBlock', Name?: string | null } | { __typename?: 'PersonContainerBlock', Name?: string | null } | { __typename?: 'PersonQuizPage', Name?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Name?: string | null } | { __typename?: 'PlaylistBlock', Name?: string | null } | { __typename?: 'PlaylistPromoBlock', Name?: string | null } | { __typename?: 'PodcastDetailBlock', Name?: string | null } | { __typename?: 'PowerPhrasePage', Name?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Name?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Name?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPortalPage', Name?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Name?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Name?: string | null } | { __typename?: 'PressReleasePage', Name?: string | null } | { __typename?: 'PriceBreakdownBlock', Name?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Name?: string | null } | { __typename?: 'ProductionDataSectionBlock', Name?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Name?: string | null } | { __typename?: 'ProductionModalBlock', Name?: string | null } | { __typename?: 'ProductionStepBlock', Name?: string | null } | { __typename?: 'ProductionStepV2Block', Name?: string | null } | { __typename?: 'ProductionTableBlock', Name?: string | null } | { __typename?: 'ProfileListBlock', Name?: string | null } | { __typename?: 'ProfilePictureBlock', Name?: string | null } | { __typename?: 'ProfileSectionBlock', Name?: string | null } | { __typename?: 'ProfileStepBlock', Name?: string | null } | { __typename?: 'ProfileStepV2Block', Name?: string | null } | { __typename?: 'PublicProfilePage', Name?: string | null } | { __typename?: 'QuizCareerBlock', Name?: string | null } | { __typename?: 'QuizEducationBlock', Name?: string | null } | { __typename?: 'QuizFinancialBlock', Name?: string | null } | { __typename?: 'QuizHealthBlock', Name?: string | null } | { __typename?: 'QuizRelationshipsBlock', Name?: string | null } | { __typename?: 'QuizServiceBlock', Name?: string | null } | { __typename?: 'QuizSpiritualBlock', Name?: string | null } | { __typename?: 'RTContributorFormPage', Name?: string | null } | { __typename?: 'RangeElementBlock', Name?: string | null } | { __typename?: 'ReceiptStepBlock', Name?: string | null } | { __typename?: 'ReceiptStepV2Block', Name?: string | null } | { __typename?: 'ResetButtonElementBlock', Name?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Name?: string | null } | { __typename?: 'ReviewBlock', Name?: string | null } | { __typename?: 'ReviewStepBlock', Name?: string | null } | { __typename?: 'RichTextBlock', Name?: string | null } | { __typename?: 'RoutingStepBlock', Name?: string | null } | { __typename?: 'SearchPage', Name?: string | null } | { __typename?: 'SearchPageV2', Name?: string | null } | { __typename?: 'SectionContainerBlock', Name?: string | null } | { __typename?: 'SectionItemBlock', Name?: string | null } | { __typename?: 'SelectionElementBlock', Name?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Name?: string | null } | { __typename?: 'SettingSectionBlock', Name?: string | null } | { __typename?: 'SiteSettingsPage', Name?: string | null } | { __typename?: 'SocialShareBlock', Name?: string | null } | { __typename?: 'SpeakerEngagementPage', Name?: string | null } | { __typename?: 'SponsorSpeakerPage', Name?: string | null } | { __typename?: 'SpotlightBlock', Name?: string | null } | { __typename?: 'SpotlightContainerBlock', Name?: string | null } | { __typename?: 'SpotlightDataBlock', Name?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Name?: string | null } | { __typename?: 'StoreCardPage', Name?: string | null } | { __typename?: 'SubmitButtonElementBlock', Name?: string | null } | { __typename?: 'SuccessSectionBlock', Name?: string | null } | { __typename?: 'SvgLinkBlock', Name?: string | null } | { __typename?: 'SvgMedia', Name?: string | null } | { __typename?: 'SvgTextCardBlock', Name?: string | null } | { __typename?: 'TabContainerBlock', Name?: string | null } | { __typename?: 'TabItemBlock', Name?: string | null } | { __typename?: 'TextCardBlock', Name?: string | null } | { __typename?: 'TextContentBlock', Name?: string | null } | { __typename?: 'TextareaElementBlock', Name?: string | null } | { __typename?: 'TextboxElementBlock', Name?: string | null } | { __typename?: 'TimelineContainerBlock', Name?: string | null } | { __typename?: 'TimelineItemBlock', Name?: string | null } | { __typename?: 'ToolkitBlock', Name?: string | null } | { __typename?: 'ToolkitItemBlock', Name?: string | null } | { __typename?: 'ToolkitSectionBlock', Name?: string | null } | { __typename?: 'ToolsCardPage', Name?: string | null } | { __typename?: 'TooltipBlock', Name?: string | null } | { __typename?: 'UrlElementBlock', Name?: string | null } | { __typename?: 'Video', Name?: string | null } | { __typename?: 'VideoBlock', Name?: string | null } | { __typename?: 'VideoDetailBlock', Name?: string | null } | { __typename?: 'VideoMedia', Name?: string | null } | { __typename?: 'VideoPromoBlock', Name?: string | null } | { __typename?: 'VisaLettersPage', Name?: string | null } | { __typename?: 'VisibilityOptionsBlock', Name?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Name?: string | null } | { __typename?: 'WireTransferSectionBlock', Name?: string | null } | { __typename?: 'YourAnswersSectionBlock', Name?: string | null } | null } | null } | null> | null } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null };

export type LearnContentCarouselQueryVariables = Exact<{
  carousel_guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type LearnContentCarouselQuery = { __typename?: 'Query', LearnCarouselContainerBlockV2?: { __typename?: 'LearnCarouselContainerBlockV2Output', items?: Array<{ __typename: 'LearnCarouselContainerBlockV2', Type?: string | null, Heading?: string | null, SourcesFilterAllSelectionLabel?: string | null, ShowSourcesFilter?: any | null, ShowMagazineIssueFilter?: any | null, SelectedSources?: Array<{ __typename?: 'ContentModelReference', Id?: number | null } | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ExpandedSelectedSources?: Array<{ __typename?: 'SourcesEntry', Id?: number | null, Name?: string | null } | null> | null, ExpandedSelectedTopics?: Array<{ __typename?: 'TopicsEntry', Id?: number | null, Name?: string | null } | null> | null } | null> | null } | null };

export type LearnGenericTextsCmsContentQueryVariables = Exact<{ [key: string]: never; }>;


export type LearnGenericTextsCmsContentQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', Number?: string | null, Close?: string | null, MenuTrigger?: string | null, MinutesLabel?: string | null, AccountLinkLabel?: string | null, SignInToViewLabel?: string | null, MembersOnlyLabel?: string | null, LockedResourceModalHeading?: string | null, LockedResourceModalSubheading?: string | null, LoginLinkLabel?: string | null, CancelLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, AccountSettingsPageReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null } | null> | null } | null };

export type BookmarkButtonCmsContentQueryVariables = Exact<{ [key: string]: never; }>;


export type BookmarkButtonCmsContentQuery = { __typename?: 'Query', HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', AudioContentCategory?: string | null, VideoContentCategory?: string | null, GuideContentCategory?: string | null, ArticleContentCategory?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', AddBookmarkAriaLabel?: string | null, RemoveBookmarkAriaLabel?: string | null, AddBookmarkSuccessMessage?: string | null, RemoveBookmarkSuccessMessage?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type AccordionContainerBlockAnchorFragmentFragment = { __typename: 'AccordionContainerBlock', AnchorLink?: string | null, AnchorLabel?: string | null };

export type ImageTextBlockAnchorFragmentFragment = { __typename: 'ImageTextBlock', AnchorLink?: string | null, AnchorLabel?: string | null };

export type LandingPageFragment = { __typename: 'LandingPage', Name?: string | null, RelativePath?: string | null, Url?: string | null };

export type LearnPageV2Fragment = { __typename: 'LearnPageV2', Name?: string | null, RelativePath?: string | null, Url?: string | null };

export type MemberDirectoryPageFragment = { __typename: 'MemberDirectoryPage', Name?: string | null, RelativePath?: string | null, Url?: string | null };

export type MembershipRequirementsBlockAnchorFragmentFragment = { __typename: 'MembershipRequirementsBlock', ProductionRequirementsAnchorLabel?: string | null, ProductionRequirementsAnchorLink?: string | null, CertifyingLettersAnchorLabel?: string | null, CertifyingLettersAnchorLink?: string | null, EthicalCodeAnchorLabel?: string | null, EthicalCodeAnchorLink?: string | null, MembershipDuesAnchorLabel?: string | null, MembershipDuesAnchorLink?: string | null };

export type NextCallOutBlockAnchorFragmentFragment = { __typename: 'NextCallOutBlock', AnchorLink?: string | null, AnchorLabel?: string | null, AccessGroup?: string | null };

export type NextContactUsBlockAnchorFragmentFragment = { __typename: 'NextContactUsBlock', AnchorLabel?: string | null, AnchorLink?: string | null };

export type NextContainerBlockAnchorFragmentFragment = { __typename: 'NextContainerBlock', AnchorLink?: string | null, AnchorLabel?: string | null };

export type NextEventBlockAnchorFragmentFragment = { __typename: 'NextEventBlock', AnchorLink?: string | null, AnchorLabel?: string | null, ShowOnlyForEdgeAccessGroupMembers?: any | null };

export type NextHeroBlockAnchorFragmentFragment = { __typename: 'NextHeroBlock', AnchorLink?: string | null, AnchorLabel?: string | null, AccessGroup?: string | null };

export type NextStaticPageFragment = { __typename: 'NextStaticPage', Name?: string | null, RelativePath?: string | null, Url?: string | null, HasSecondaryNavigation?: any | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock', AnchorLink?: string | null, AnchorLabel?: string | null } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename: 'ImageTextBlock', AnchorLink?: string | null, AnchorLabel?: string | null } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock', ProductionRequirementsAnchorLabel?: string | null, ProductionRequirementsAnchorLink?: string | null, CertifyingLettersAnchorLabel?: string | null, CertifyingLettersAnchorLink?: string | null, EthicalCodeAnchorLabel?: string | null, EthicalCodeAnchorLink?: string | null, MembershipDuesAnchorLabel?: string | null, MembershipDuesAnchorLink?: string | null } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock', AnchorLink?: string | null, AnchorLabel?: string | null, AccessGroup?: string | null } | { __typename: 'NextContactUsBlock', AnchorLabel?: string | null, AnchorLink?: string | null } | { __typename: 'NextContainerBlock', AnchorLink?: string | null, AnchorLabel?: string | null } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock', AnchorLink?: string | null, AnchorLabel?: string | null, ShowOnlyForEdgeAccessGroupMembers?: any | null } | { __typename: 'NextHeroBlock', AnchorLink?: string | null, AnchorLabel?: string | null, AccessGroup?: string | null } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename: 'RichTextBlock', AnchorLink?: string | null, AnchorLabel?: string | null } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null };

export type RichTextBlockAnchorFragmentFragment = { __typename: 'RichTextBlock', AnchorLink?: string | null, AnchorLabel?: string | null };

export type HeaderContentQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaderContentQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', BecomeMemberLabel?: string | null, RenewNowLabel?: string | null, HomeLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null, HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MembershipPageLink?: { __typename?: 'HomePageV2LinkBlock', LinkToContent?: string | null } | null } | null> | null } | null };

export type HeaderNavigationLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaderNavigationLinksQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', Name?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MenuLink?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage', Name?: string | null, RelativePath?: string | null, Url?: string | null } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename: 'LearnPageV2', Name?: string | null, RelativePath?: string | null, Url?: string | null } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage', Name?: string | null, RelativePath?: string | null, Url?: string | null } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage', Name?: string | null, RelativePath?: string | null, Url?: string | null, HasSecondaryNavigation?: any | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock', AnchorLink?: string | null, AnchorLabel?: string | null } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename: 'ImageTextBlock', AnchorLink?: string | null, AnchorLabel?: string | null } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock', ProductionRequirementsAnchorLabel?: string | null, ProductionRequirementsAnchorLink?: string | null, CertifyingLettersAnchorLabel?: string | null, CertifyingLettersAnchorLink?: string | null, EthicalCodeAnchorLabel?: string | null, EthicalCodeAnchorLink?: string | null, MembershipDuesAnchorLabel?: string | null, MembershipDuesAnchorLink?: string | null } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock', AnchorLink?: string | null, AnchorLabel?: string | null, AccessGroup?: string | null } | { __typename: 'NextContactUsBlock', AnchorLabel?: string | null, AnchorLink?: string | null } | { __typename: 'NextContainerBlock', AnchorLink?: string | null, AnchorLabel?: string | null } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock', AnchorLink?: string | null, AnchorLabel?: string | null, ShowOnlyForEdgeAccessGroupMembers?: any | null } | { __typename: 'NextHeroBlock', AnchorLink?: string | null, AnchorLabel?: string | null, AccessGroup?: string | null } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename: 'RichTextBlock', AnchorLink?: string | null, AnchorLabel?: string | null } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null };

export type HeaderProfileDropdownContentQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaderProfileDropdownContentQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', MDRTId?: string | null, AccountLinkLabel?: string | null, BecomeMemberLabel?: string | null, AdminDashboardPageLinkLabel?: string | null, ImpersonationLinkLabel?: string | null, CompanyAdminDashboardPageLinkLabel?: string | null, SelectLanguageLine?: string | null, ProfileDropdownTriggerAriaLabel?: string | null, ProfileDropdownAriaLabel?: string | null, ImpersonateModalTitle?: string | null, ImpersonateModalDescription?: string | null, ImpersonateModalPersonIDLabel?: string | null, ImpersonateModalButtonLabel?: string | null, ImpersonateModalErrorMessage?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, AdminDashboardPage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null, AccountSettingsPageReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null, CompanyAdminDashboardPage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', Url?: string | null } | { __typename?: 'AccordionContainerBlock', Url?: string | null } | { __typename?: 'AccordionItemBlock', Url?: string | null } | { __typename?: 'AccountProfilePage', Url?: string | null } | { __typename?: 'AddressInfoBlock', Url?: string | null } | { __typename?: 'BadgeBlock', Url?: string | null } | { __typename?: 'BrandedTableBlock', Url?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Url?: string | null } | { __typename?: 'ButtonLabelBlock', Url?: string | null } | { __typename?: 'CaptchaElementBlock', Url?: string | null } | { __typename?: 'CategoryListBlock', Url?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Url?: string | null } | { __typename?: 'CflBadgesBlock', Url?: string | null } | { __typename?: 'CflHomePage', Url?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Url?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Url?: string | null } | { __typename?: 'CflSiteSettingsPage', Url?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Url?: string | null } | { __typename?: 'ChoiceElementBlock', Url?: string | null } | { __typename?: 'ColumnContainerBlock', Url?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Url?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Url?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Url?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Url?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Url?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Url?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Url?: string | null } | { __typename?: 'CompanyRankingsPage', Url?: string | null } | { __typename?: 'ConfirmationModalBlock', Url?: string | null } | { __typename?: 'ConfirmationStepBlock', Url?: string | null } | { __typename?: 'CongratulationsStepV2Block', Url?: string | null } | { __typename?: 'ContactEmailElementBlock', Url?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Url?: string | null } | { __typename?: 'ContactNameElementBlock', Url?: string | null } | { __typename?: 'ContactPhoneElementBlock', Url?: string | null } | { __typename?: 'ContactsBlock', Url?: string | null } | { __typename?: 'Content', Url?: string | null } | { __typename?: 'DAMAsset', Url?: string | null } | { __typename?: 'DAMImageAsset', Url?: string | null } | { __typename?: 'DAMVideo', Url?: string | null } | { __typename?: 'DAMVideoAsset', Url?: string | null } | { __typename?: 'DashBoardSectionBlock', Url?: string | null } | { __typename?: 'DashboardAccountPage', Url?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Url?: string | null } | { __typename?: 'DashboardContactInformationBlock', Url?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Url?: string | null } | { __typename?: 'DashboardPermissionsBlock', Url?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Url?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Url?: string | null } | { __typename?: 'DashboardProfileBlock', Url?: string | null } | { __typename?: 'DashboardSharedPage', Url?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Url?: string | null } | { __typename?: 'DataMismatchModalBlock', Url?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Url?: string | null } | { __typename?: 'DescriptionButtonBlock', Url?: string | null } | { __typename?: 'DetailPage', Url?: string | null } | { __typename?: 'DocumentMedia', Url?: string | null } | { __typename?: 'DonationBlock', Url?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Url?: string | null } | { __typename?: 'EEPSectionBlock', Url?: string | null } | { __typename?: 'EVPCarouselBlock', Url?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Url?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Url?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Url?: string | null } | { __typename?: 'EVPContentBlock', Url?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Url?: string | null } | { __typename?: 'EVPGenericPage', Url?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Url?: string | null } | { __typename?: 'EVPHomePage', Url?: string | null } | { __typename?: 'EVPImageBlock', Url?: string | null } | { __typename?: 'EVPImageLinkBlock', Url?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Url?: string | null } | { __typename?: 'EVPLinkBlock', Url?: string | null } | { __typename?: 'EVPMediaFileBlock', Url?: string | null } | { __typename?: 'EVPNavigationPageBlock', Url?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Url?: string | null } | { __typename?: 'EVPResourcePage', Url?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Url?: string | null } | { __typename?: 'EVPSearchPage', Url?: string | null } | { __typename?: 'EVPSiteSettingsPage', Url?: string | null } | { __typename?: 'EVPTabBlock', Url?: string | null } | { __typename?: 'EVPTabCardBlock', Url?: string | null } | { __typename?: 'EVPTabCardsBlock', Url?: string | null } | { __typename?: 'EVPTabImageTextBlock', Url?: string | null } | { __typename?: 'EVPTabRichTextBlock', Url?: string | null } | { __typename?: 'EVPTabVideoBlock', Url?: string | null } | { __typename?: 'EVPTabsBlock', Url?: string | null } | { __typename?: 'EVPTextImageBlock', Url?: string | null } | { __typename?: 'EVPVideoBlock', Url?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Url?: string | null } | { __typename?: 'ErrorModalBlock', Url?: string | null } | { __typename?: 'ErrorPage', Url?: string | null } | { __typename?: 'ErrorPageBlock', Url?: string | null } | { __typename?: 'EventBlock', Url?: string | null } | { __typename?: 'EventLocationAndDateBlock', Url?: string | null } | { __typename?: 'EventLocationInformationBlock', Url?: string | null } | { __typename?: 'EventPage', Url?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Url?: string | null } | { __typename?: 'EventSessionBlock', Url?: string | null } | { __typename?: 'EventSessionScheduleBlock', Url?: string | null } | { __typename?: 'EventSessionTrackBlock', Url?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Url?: string | null } | { __typename?: 'EventSpeakerSearchPage', Url?: string | null } | { __typename?: 'EventSpeakersBlock', Url?: string | null } | { __typename?: 'EventTableContainerBlock', Url?: string | null } | { __typename?: 'ExpandableContainerBlock', Url?: string | null } | { __typename?: 'FileUploadElementBlock', Url?: string | null } | { __typename?: 'FlowFinishInformationBlock', Url?: string | null } | { __typename?: 'FolderPage', Url?: string | null } | { __typename?: 'FormContainerBlock', Url?: string | null } | { __typename?: 'FormStepBlock', Url?: string | null } | { __typename?: 'FourColumnTableBlock', Url?: string | null } | { __typename?: 'GaugeBlock', Url?: string | null } | { __typename?: 'GeoDataBlock', Url?: string | null } | { __typename?: 'GettingStartedStepBlock', Url?: string | null } | { __typename?: 'GettingStartedStepV2Block', Url?: string | null } | { __typename?: 'GreetingCaseBlock', Url?: string | null } | { __typename?: 'GreetingStepBlock', Url?: string | null } | { __typename?: 'GreetingStepV2Block', Url?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Url?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Url?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Url?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Url?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Url?: string | null } | { __typename?: 'GsAwardsPage', Url?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Url?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Url?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Url?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Url?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Url?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Url?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Url?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Url?: string | null } | { __typename?: 'GsConfirmationStepBlock', Url?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Url?: string | null } | { __typename?: 'GsGreetingStepBlock', Url?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Url?: string | null } | { __typename?: 'GsMembershipRenewalPage', Url?: string | null } | { __typename?: 'GsProfileStepBlock', Url?: string | null } | { __typename?: 'GsReceiptStepBlock', Url?: string | null } | { __typename?: 'GsReviewStepBlock', Url?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Url?: string | null } | { __typename?: 'HeroTextContentBlock', Url?: string | null } | { __typename?: 'HomePage', Url?: string | null } | { __typename?: 'HomePageV2', Url?: string | null } | { __typename?: 'IconRequirementBlock', Url?: string | null } | { __typename?: 'Image', Url?: string | null } | { __typename?: 'ImageBlock', Url?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Url?: string | null } | { __typename?: 'ImageChoiceElementBlock', Url?: string | null } | { __typename?: 'ImageLinkBlock', Url?: string | null } | { __typename?: 'ImageMedia', Url?: string | null } | { __typename?: 'ImageTextBlock', Url?: string | null } | { __typename?: 'ImageTextBlockV2', Url?: string | null } | { __typename?: 'ImageTextCardBlock', Url?: string | null } | { __typename?: 'ImageTextItemBlock', Url?: string | null } | { __typename?: 'InfoBoxBlock', Url?: string | null } | { __typename?: 'KeyLinkValueBlock', Url?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Url?: string | null } | { __typename?: 'LandingPage', Url?: string | null } | { __typename?: 'LanguageIdAndName', Url?: string | null } | { __typename?: 'LanguagesBlock', Url?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Url?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Url?: string | null } | { __typename?: 'LearnDetailPage', Url?: string | null } | { __typename?: 'LearnHeroImageBlock', Url?: string | null } | { __typename?: 'LearnLandingPage', Url?: string | null } | { __typename?: 'LearnPageV2', Url?: string | null } | { __typename?: 'LearnPlayListPage', Url?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Url?: string | null } | { __typename?: 'LinkBlock', Url?: string | null } | { __typename?: 'LinkListBlock', Url?: string | null } | { __typename?: 'LinkTileBlock', Url?: string | null } | { __typename?: 'LoaderBlock', Url?: string | null } | { __typename?: 'LocationBlock', Url?: string | null } | { __typename?: 'MeetingEventCardPage', Url?: string | null } | { __typename?: 'MeetingPage', Url?: string | null } | { __typename?: 'MemberDirectory', Url?: string | null } | { __typename?: 'MemberDirectoryPage', Url?: string | null } | { __typename?: 'MemberSectionBlock', Url?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Url?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Url?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Url?: string | null } | { __typename?: 'MembershipInvoicePage', Url?: string | null } | { __typename?: 'MembershipLevelBlock', Url?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Url?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Url?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Url?: string | null } | { __typename?: 'MembershipLevelsBlock', Url?: string | null } | { __typename?: 'MembershipRenewalPage', Url?: string | null } | { __typename?: 'MembershipRenewalV2Page', Url?: string | null } | { __typename?: 'MembershipRequirementBlock', Url?: string | null } | { __typename?: 'MembershipRequirementsBlock', Url?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Url?: string | null } | { __typename?: 'MembershipTypeStepBlock', Url?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Url?: string | null } | { __typename?: 'ModalInfoBlock', Url?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Url?: string | null } | { __typename?: 'NextCallOutBlock', Url?: string | null } | { __typename?: 'NextContactUsBlock', Url?: string | null } | { __typename?: 'NextContainerBlock', Url?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Url?: string | null } | { __typename?: 'NextEventBlock', Url?: string | null } | { __typename?: 'NextHeroBlock', Url?: string | null } | { __typename?: 'NextInfoBoxBlock', Url?: string | null } | { __typename?: 'NextPersonContainerBlock', Url?: string | null } | { __typename?: 'NextPersonDataBlock', Url?: string | null } | { __typename?: 'NextStaffAdminPage', Url?: string | null } | { __typename?: 'NextStaticPage', Url?: string | null } | { __typename?: 'NextSyncEventsBlock', Url?: string | null } | { __typename?: 'NotFoundPage', Url?: string | null } | { __typename?: 'NumberElementBlock', Url?: string | null } | { __typename?: 'NumberedContainerBlock', Url?: string | null } | { __typename?: 'NumberedItemBlock', Url?: string | null } | { __typename?: 'ParagraphTextElementBlock', Url?: string | null } | { __typename?: 'PastPresidentsBlock', Url?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Url?: string | null } | { __typename?: 'PersonBlock', Url?: string | null } | { __typename?: 'PersonContainerBlock', Url?: string | null } | { __typename?: 'PersonQuizPage', Url?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Url?: string | null } | { __typename?: 'PlaylistBlock', Url?: string | null } | { __typename?: 'PlaylistPromoBlock', Url?: string | null } | { __typename?: 'PodcastDetailBlock', Url?: string | null } | { __typename?: 'PowerPhrasePage', Url?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Url?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Url?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Url?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Url?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Url?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Url?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Url?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Url?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Url?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Url?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Url?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Url?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Url?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Url?: string | null } | { __typename?: 'PrepaymentPortalPage', Url?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Url?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Url?: string | null } | { __typename?: 'PressReleasePage', Url?: string | null } | { __typename?: 'PriceBreakdownBlock', Url?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Url?: string | null } | { __typename?: 'ProductionDataSectionBlock', Url?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Url?: string | null } | { __typename?: 'ProductionModalBlock', Url?: string | null } | { __typename?: 'ProductionStepBlock', Url?: string | null } | { __typename?: 'ProductionStepV2Block', Url?: string | null } | { __typename?: 'ProductionTableBlock', Url?: string | null } | { __typename?: 'ProfileListBlock', Url?: string | null } | { __typename?: 'ProfilePictureBlock', Url?: string | null } | { __typename?: 'ProfileSectionBlock', Url?: string | null } | { __typename?: 'ProfileStepBlock', Url?: string | null } | { __typename?: 'ProfileStepV2Block', Url?: string | null } | { __typename?: 'PublicProfilePage', Url?: string | null } | { __typename?: 'QuizCareerBlock', Url?: string | null } | { __typename?: 'QuizEducationBlock', Url?: string | null } | { __typename?: 'QuizFinancialBlock', Url?: string | null } | { __typename?: 'QuizHealthBlock', Url?: string | null } | { __typename?: 'QuizRelationshipsBlock', Url?: string | null } | { __typename?: 'QuizServiceBlock', Url?: string | null } | { __typename?: 'QuizSpiritualBlock', Url?: string | null } | { __typename?: 'RTContributorFormPage', Url?: string | null } | { __typename?: 'RangeElementBlock', Url?: string | null } | { __typename?: 'ReceiptStepBlock', Url?: string | null } | { __typename?: 'ReceiptStepV2Block', Url?: string | null } | { __typename?: 'ResetButtonElementBlock', Url?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Url?: string | null } | { __typename?: 'ReviewBlock', Url?: string | null } | { __typename?: 'ReviewStepBlock', Url?: string | null } | { __typename?: 'RichTextBlock', Url?: string | null } | { __typename?: 'RoutingStepBlock', Url?: string | null } | { __typename?: 'SearchPage', Url?: string | null } | { __typename?: 'SearchPageV2', Url?: string | null } | { __typename?: 'SectionContainerBlock', Url?: string | null } | { __typename?: 'SectionItemBlock', Url?: string | null } | { __typename?: 'SelectionElementBlock', Url?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Url?: string | null } | { __typename?: 'SettingSectionBlock', Url?: string | null } | { __typename?: 'SiteSettingsPage', Url?: string | null } | { __typename?: 'SocialShareBlock', Url?: string | null } | { __typename?: 'SpeakerEngagementPage', Url?: string | null } | { __typename?: 'SponsorSpeakerPage', Url?: string | null } | { __typename?: 'SpotlightBlock', Url?: string | null } | { __typename?: 'SpotlightContainerBlock', Url?: string | null } | { __typename?: 'SpotlightDataBlock', Url?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Url?: string | null } | { __typename?: 'StoreCardPage', Url?: string | null } | { __typename?: 'SubmitButtonElementBlock', Url?: string | null } | { __typename?: 'SuccessSectionBlock', Url?: string | null } | { __typename?: 'SvgLinkBlock', Url?: string | null } | { __typename?: 'SvgMedia', Url?: string | null } | { __typename?: 'SvgTextCardBlock', Url?: string | null } | { __typename?: 'TabContainerBlock', Url?: string | null } | { __typename?: 'TabItemBlock', Url?: string | null } | { __typename?: 'TextCardBlock', Url?: string | null } | { __typename?: 'TextContentBlock', Url?: string | null } | { __typename?: 'TextareaElementBlock', Url?: string | null } | { __typename?: 'TextboxElementBlock', Url?: string | null } | { __typename?: 'TimelineContainerBlock', Url?: string | null } | { __typename?: 'TimelineItemBlock', Url?: string | null } | { __typename?: 'ToolkitBlock', Url?: string | null } | { __typename?: 'ToolkitItemBlock', Url?: string | null } | { __typename?: 'ToolkitSectionBlock', Url?: string | null } | { __typename?: 'ToolsCardPage', Url?: string | null } | { __typename?: 'TooltipBlock', Url?: string | null } | { __typename?: 'UrlElementBlock', Url?: string | null } | { __typename?: 'Video', Url?: string | null } | { __typename?: 'VideoBlock', Url?: string | null } | { __typename?: 'VideoDetailBlock', Url?: string | null } | { __typename?: 'VideoMedia', Url?: string | null } | { __typename?: 'VideoPromoBlock', Url?: string | null } | { __typename?: 'VisaLettersPage', Url?: string | null } | { __typename?: 'VisibilityOptionsBlock', Url?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Url?: string | null } | { __typename?: 'WireTransferSectionBlock', Url?: string | null } | { __typename?: 'YourAnswersSectionBlock', Url?: string | null } | null } | null } | null> | null } | null };

export type MembershipLevelBadgeContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MembershipLevelBadgeContentQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', COTLevelLabel?: string | null, MDRTLevelLabel?: string | null, TOTLevelLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type PlayerCmsContentQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerCmsContentQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', AccessibilityLabel?: string | null, AirPlayLabel?: string | null, AudioLabel?: string | null, BoostLabel?: string | null, AnnouncementsLabel?: string | null, ContinueLabel?: string | null, EnterFullscreenLabel?: string | null, ExitFullscreenLabel?: string | null, FullscreenLabel?: string | null, GoogleCastLabel?: string | null, KeyboardAnimationsLabel?: string | null, LoopLabel?: string | null, MuteLabel?: string | null, NormalLabel?: string | null, OffLabel?: string | null, PauseLabel?: string | null, PlayLabel?: string | null, PlaybackLabel?: string | null, ReplayLabel?: string | null, SeekBackwardLabel?: string | null, SeekForwardLabel?: string | null, SeekLabel?: string | null, SettingsLabel?: string | null, SpeedLabel?: string | null, UnmuteLabel?: string | null, VolumeLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type ShareDropdownCmsContentQueryVariables = Exact<{ [key: string]: never; }>;


export type ShareDropdownCmsContentQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', Close?: string | null, CopyLink?: string | null, EmailResource?: string | null, LinkCopiedSuccessfully?: string | null, ShareResourceMenuTrigger?: string | null, ShareOnX?: string | null, ShareOnLinkedIn?: string | null, ShareOnFacebook?: string | null, SomethingWentWrong?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type ErrorPageContentQueryVariables = Exact<{ [key: string]: never; }>;


export type ErrorPageContentQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', GoBackToHomepage?: string | null, LogInPrompt?: string | null, SomethingWentWrong?: string | null, AccessDenied?: string | null, PageNotFoundErrorMessage?: string | null, TryAgainErrorMessage?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type FooterContentQueryVariables = Exact<{ [key: string]: never; }>;


export type FooterContentQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', Address?: string | null, HelpfulLinksHeader?: string | null, ChapterSitesHeader?: string | null, MdrtAppsHeader?: string | null, GooglePlayLink?: string | null, AppStoreLink?: string | null, Copyright?: string | null, AppStoreLinkAriaLabel?: string | null, GooglePlayLinkAriaLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, FooterLogo?: { __typename?: 'SiteSettingsPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, FooterLogoLink?: { __typename?: 'SiteSettingsPageLinkBlock', LinkToContent?: string | null, Target?: string | null, DisplayText?: string | null } | null, ContactUsLink?: { __typename?: 'SiteSettingsPageLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, Target?: string | null } | null, PhoneNumberLink?: { __typename?: 'SiteSettingsPageLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, Target?: string | null } | null, HelpfulLinks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', RelativePath?: string | null, LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, ChapterSitesLinks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', RelativePath?: string | null, LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, PwaAppInstallAndroidImage?: { __typename?: 'ContentModelReference', Url?: string | null } | null, PwaAppInstallAppleImage?: { __typename?: 'ContentModelReference', Url?: string | null } | null, DisclaimerLink?: { __typename?: 'SiteSettingsPageLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, Target?: string | null } | null, PrivacyLink?: { __typename?: 'SiteSettingsPageLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, Target?: string | null } | null, FooterSocialLinks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock', Name?: string | null, LinkToContent?: string | null, Target?: string | null, IconClass?: string | null } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null };

export type PwaContentQueryVariables = Exact<{ [key: string]: never; }>;


export type PwaContentQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', PWAPromptAddHomeInstructionsLabelApple?: string | null, PWAPromptAddHomeInstructionsLabelSafari?: string | null, PWAPromptBodyLabelApple?: string | null, PWAPromptBodyLabelSafari?: string | null, PWAPromptBodyLabelWeb?: string | null, PWAPromptCancelLabel?: string | null, PWAPromptInstallLabel?: string | null, PWAPromptShareInstructionsLabelApple?: string | null, PWAPromptShareInstructionsLabelSafari?: string | null, PWAPromptTitleLabelApple?: string | null, PWAPromptTitleLabelSafari?: string | null, Close?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type CompanyRankingsPageQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type CompanyRankingsPageQuery = { __typename?: 'Query', CompanyRankingsPage?: { __typename?: 'CompanyRankingsPageOutput', items?: Array<{ __typename?: 'CompanyRankingsPage', Name?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock', Name?: string | null, Description?: string | null, Subheading?: string | null, AnchorLink?: string | null, AccordionItemBlock?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock', Subheading?: string | null, Description?: string | null } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename: 'ImageTextBlock', AccessGroup?: string | null, AnchorLink?: string | null, ReverseContent?: any | null, Theme?: string | null, Seperator?: string | null, Image?: { __typename?: 'ImageTextBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, TextContent?: { __typename?: 'ImageTextBlockTextContentBlock', PreHeading?: string | null, Heading?: string | null, SubHeading?: string | null, Description?: string | null } | null, CallToActionLinks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2', Type?: string | null, Heading?: string | null, SourcesFilterAllSelectionLabel?: string | null, ShowSourcesFilter?: any | null, ShowMagazineIssueFilter?: any | null, SelectedSources?: Array<{ __typename?: 'ContentModelReference', Id?: number | null } | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ExpandedSelectedSources?: Array<{ __typename?: 'SourcesEntry', Id?: number | null, Name?: string | null } | null> | null, ExpandedSelectedTopics?: Array<{ __typename?: 'TopicsEntry', Id?: number | null, Name?: string | null } | null> | null } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock', ProductionRequirementsAnchorLink?: string | null, CertifyingLettersAnchorLink?: string | null, EthicalCodeAnchorLink?: string | null, MembershipDuesAnchorLink?: string | null, EthicalCodeDescription?: string | null, EthicalCodeStepLabel?: string | null, CertifyingLettersStepLabel?: string | null, CertifyingLettersDescription?: string | null, RelativePath?: string | null, RouteSegment?: string | null, MembershipDuesDescription?: string | null, MembershipDuesStepLabel?: string | null, MembershipTableCoTHeading?: string | null, MembershipTableCommissionRowHeading?: string | null, MembershipTableIncomeRowHeading?: string | null, MembershipTableMemberHeading?: string | null, MembershipTableName?: string | null, MembershipTablePremiumRowHeading?: string | null, MembershipTableToTHeading?: string | null, MonthlyGoalChartsLinkText?: string | null, Name?: string | null, ViewMembershipRequirementsLabel?: string | null, ProductionRequirementsMonthlyGoalDescription?: string | null, ProductionRequirementsStepLabel?: string | null, ProfessionalAssociationsDescription?: string | null, ProfessionalAssociationsStepLabel?: string | null, ConversionFactorsStepLabel?: string | null, MonthlyGoalStepName?: string | null, ProductionApiErrorLabel?: string | null, NoRequirementsLabel?: string | null, CertifyingLettersFindOfficerLink?: { __typename?: 'MembershipRequirementsBlockLinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, DownloadFileName?: string | null, ShouldDownload?: any | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MembershipRequirementBlocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock', CoTDues?: number | null, GenericProductionFooterText?: string | null, MemberDues?: number | null, SpecificProductionFooterText?: string | null, ToTDues?: number | null, Date?: any | null, ConversionFactorsDescription?: string | null, DownloadRequirementsLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, IncomeCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCoreDownloadRequirementsLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCoreIncomeCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCorePremiumAndCommissionCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, PremiumAndCommissionCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, ConversionFactorsDownloadLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, MonthlyGoalCharts?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock', Key?: string | null, Name?: string | null, Value?: { __typename?: 'KeyLinkValueBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, Contacts?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock', Email?: string | null, FaxNumber?: string | null, PhoneNumber?: string | null, RegionTitle?: string | null } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock', Name?: string | null, AnchorLink?: string | null, Heading?: string | null, SubHeading?: string | null, AccessGroup?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, CallOutLinkBlock?: { __typename?: 'NextCallOutBlockLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, LinkStyle?: string | null, Target?: string | null, ShouldDownload?: any | null } | null } | { __typename: 'NextContactUsBlock', ContactUsText?: string | null, AnchorLink?: string | null } | { __typename: 'NextContainerBlock', AccessGroup?: string | null, Name?: string | null, AnchorLink?: string | null, Heading?: string | null, SubHeading?: string | null, Description?: string | null, Seperator?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Items?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename: 'ImageBlock', AltText?: string | null, _concreteType?: string | null, ImageSize?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock', Description?: string | null, Heading?: string | null, SubHeading?: string | null, _concreteType?: string | null, ImageSize?: string | null, Image?: { __typename?: 'ImageTextCardBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, LinkBlock?: { __typename?: 'ImageTextCardBlockLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, Target?: string | null, LinkStyle?: string | null } | null } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock', AnchorLink?: string | null, EventDescription?: string | null, EventHeading?: string | null, EventLocation?: string | null, NextEventLocation?: string | null, EventDateFrom?: any | null, EventDateTo?: any | null, NextEventDateFrom?: any | null, NextEventDateTo?: any | null, ReversedContent?: any | null, ShowOnlyForEdgeAccessGroupMembers?: any | null, EventImageBlock?: { __typename?: 'NextEventBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, EventLinkBlock?: { __typename?: 'NextEventBlockLinkBlock', LinkToContent?: string | null, Target?: string | null } | null } | { __typename: 'NextHeroBlock', AccessGroup?: string | null, Name?: string | null, AnchorLink?: string | null, HeroHeading?: string | null, HeroDescription?: string | null, HeroTheme?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, HeroImageBlocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename: 'ImageBlock', AltText?: string | null, _concreteType?: string | null, ImageSize?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, HeroLinkBlocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, HeroCtaButtons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock', ProfileList?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock', Name?: string | null, Title?: string | null, Description?: string | null, MemberYears?: string | null, Country?: string | null, EmailAddress?: string | null, City?: string | null, Image?: { __typename?: 'PersonBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock', PastPresidentsTableReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock', Footer?: string | null, TextContent?: { __typename?: 'FourColumnTableBlockTextContentBlock', Heading?: string | null } | null, Rows?: Array<{ __typename?: 'RowContent', ColumnOne?: string | null, ColumnTwo?: string | null, ColumnThree?: string | null, ColumnFour?: string | null } | null> | null } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename: 'RichTextBlock', AnchorLink?: string | null, Name?: string | null, Content?: string | null, AnchorLabel?: string | null, Heading?: string | null, Seperator?: string | null } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', CountryLabel?: string | null, YearLabel?: string | null, StaticPagesEventThisYearLabel?: string | null, StaticPagesEventNextEventLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type DynamicContentQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type DynamicContentQuery = { __typename?: 'Query', Content?: { __typename?: 'ContentOutput', items?: Array<{ __typename: 'AMPSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'AccordionContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'AccordionItemBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'AccountProfilePage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'AddressInfoBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'BadgeBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'BrandedTableBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ButtonLabelBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CaptchaElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CategoryListBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CertifyingOfficerSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CflBadgesBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CflHomePage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CflMembershipKitCardBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CflMembershipKitCarouselBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CflSiteSettingsPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CflSpecialResourceCardBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ChoiceElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ColumnContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ColumnLinksListContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ColumnLinksListItemBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CompanyAdminBulkImportPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CompanyRankingsPage', AnalyticsCampaignName?: string | null, DisableSearchEngineIndexing?: any | null, ContentTypeID?: number | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, MetaImage?: { __typename?: 'CompanyRankingsPageImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ConfirmationModalBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ConfirmationStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'CongratulationsStepV2Block', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ContactEmailElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ContactMdrtIdElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ContactNameElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ContactPhoneElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ContactsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'Content', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DAMAsset', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DAMImageAsset', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DAMVideo', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DAMVideoAsset', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DashBoardSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DashboardAccountPage', AnalyticsCampaignName?: string | null, DisableSearchEngineIndexing?: any | null, ContentTypeID?: number | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, MetaImage?: { __typename?: 'DashboardAccountPageImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DashboardCarouselCardBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DashboardContactInformationBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DashboardLoginPasswordBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DashboardPermissionsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DashboardPersonalInformationBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DashboardProfessionalInformationBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DashboardProfileBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DashboardSharedPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DashboardSitePreferencesBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DataMismatchModalBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DescriptionButtonBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DetailPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DocumentMedia', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DonationBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'DownloadUploadSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EEPSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPCarouselBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPCarouselQuoteBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPCarouselSlideBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPContentBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPFeaturedResourcesBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPGenericPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPHeroQuoteBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPHomePage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPImageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPImageLinkBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPLanguageSelectorBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPLinkBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPMediaFileBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPNavigationPageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPPartnerSettingsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPResourcePage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPSearchHeaderBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPSearchPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPSiteSettingsPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPTabBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPTabCardBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPTabCardsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPTabImageTextBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPTabRichTextBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPTabVideoBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPTabsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPTextImageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EVPVideoBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ErrorModalBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ErrorPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ErrorPageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventLocationAndDateBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventLocationInformationBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventRegistrationInformationBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventSessionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventSessionScheduleBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventSessionTrackBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventSpeakerSearchPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventSpeakersBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'EventTableContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ExpandableContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'FileUploadElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'FlowFinishInformationBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'FolderPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'FormContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'FormStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'FourColumnTableBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GaugeBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GeoDataBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GettingStartedStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GettingStartedStepV2Block', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GreetingCaseBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GreetingStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GreetingStepV2Block', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsApplicationsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsFileUploadBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsMembershipStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsProductionStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsRetentionStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsSubmitStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsVerificationStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsConfirmationStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsGettingStartedStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsGreetingStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsLeadershipInformationStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsMembershipRenewalPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsProfileStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsReceiptStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'GsReviewStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'HealthPoliciesSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'HeroTextContentBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'HomePage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'HomePageV2', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'IconRequirementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'Image', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ImageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ImageCaptionRichTextBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ImageChoiceElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ImageLinkBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ImageMedia', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ImageTextBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ImageTextBlockV2', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ImageTextCardBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ImageTextItemBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'InfoBoxBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'KeyLinkValueBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'KeyTranslatedValueBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LandingPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LanguageIdAndName', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LanguagesBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LearnCarouselContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LearnCarouselContainerBlockV2', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LearnDetailPage', AnalyticsCampaignName?: string | null, DisableSearchEngineIndexing?: any | null, ContentTypeID?: number | null, ContentTypeSelection?: number | null, LanguageBranchId?: string | null, DisplayedDateYear?: string | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, AssignedGroupsReadAccess?: Array<{ __typename?: 'AssignedGroupPropertyValue', GroupName?: string | null } | null> | null, ExpandedTopics?: Array<{ __typename?: 'ExpandedTopicsEntry', Name?: string | null } | null> | null, ExpandedSources?: Array<{ __typename?: 'ExpandedSourcesEntry', Name?: string | null } | null> | null, MetaImage?: { __typename?: 'LearnDetailPageImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LearnHeroImageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LearnLandingPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LearnPageV2', AnalyticsCampaignName?: string | null, DisableSearchEngineIndexing?: any | null, ContentTypeID?: number | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, MetaImage?: { __typename?: 'LearnPageV2ImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LearnPlayListPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LikeAndBookmarkBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LinkBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LinkListBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LinkTileBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LoaderBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'LocationBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MeetingEventCardPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MeetingPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MemberDirectory', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MemberDirectoryPage', AnalyticsCampaignName?: string | null, DisableSearchEngineIndexing?: any | null, ContentTypeID?: number | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, MetaImage?: { __typename?: 'MemberDirectoryPageImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MemberSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipHistoryDetailBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipHistoryDetailPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipInvoicePage', AnalyticsCampaignName?: string | null, DisableSearchEngineIndexing?: any | null, ContentTypeID?: number | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, MetaImage?: { __typename?: 'MembershipInvoicePageImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipLevelBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipLevelRadioBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipLevelSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipLevelStepV2Block', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipLevelsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipRenewalPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipRenewalV2Page', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipRequirementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipRequirementsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipTypeSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipTypeStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'MembershipTypeStepV2Block', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ModalInfoBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NewIDRequestSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextCallOutBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextContactUsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextDeadLetterQueueBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextEventBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextHeroBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextInfoBoxBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextPersonContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextPersonDataBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextStaffAdminPage', AnalyticsCampaignName?: string | null, DisableSearchEngineIndexing?: any | null, ContentTypeID?: number | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, MetaImage?: { __typename?: 'NextStaffAdminPageImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextStaticPage', AnalyticsCampaignName?: string | null, DisableSearchEngineIndexing?: any | null, ContentTypeID?: number | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, MetaImage?: { __typename?: 'NextStaticPageImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NextSyncEventsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NotFoundPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NumberElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NumberedContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'NumberedItemBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ParagraphTextElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PastPresidentsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PaymentProcessingScreenBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PersonBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PersonContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PersonQuizPage', AnalyticsCampaignName?: string | null, DisableSearchEngineIndexing?: any | null, ContentTypeID?: number | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, MetaImage?: { __typename?: 'PersonQuizPageImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PersonUpdatesSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PlaylistBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PlaylistPromoBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PodcastDetailBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PowerPhrasePage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PredefinedHiddenElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentErrorModalBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentErrorPageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentGenericErrorBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentHomepageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentHomepageGsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentPaymentPageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentPortalPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentProductNamesBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PressReleasePage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PriceBreakdownBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProductionDataSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProductionDeleteModalBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProductionModalBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProductionStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProductionStepV2Block', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProductionTableBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProfileListBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProfilePictureBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProfileSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProfileStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ProfileStepV2Block', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'PublicProfilePage', AnalyticsCampaignName?: string | null, DisableSearchEngineIndexing?: any | null, ContentTypeID?: number | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, MetaImage?: { __typename?: 'PublicProfilePageImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'QuizCareerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'QuizEducationBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'QuizFinancialBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'QuizHealthBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'QuizRelationshipsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'QuizServiceBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'QuizSpiritualBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'RTContributorFormPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'RangeElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ReceiptStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ReceiptStepV2Block', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ResetButtonElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ReviewBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ReviewStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'RichTextBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'RoutingStepBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SearchPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SearchPageV2', AnalyticsCampaignName?: string | null, DisableSearchEngineIndexing?: any | null, ContentTypeID?: number | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, MetaImage?: { __typename?: 'SearchPageV2ImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SectionContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SectionItemBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SelectionElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SettingSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SiteSettingsPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SocialShareBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SpeakerEngagementPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SponsorSpeakerPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SpotlightBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SpotlightContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SpotlightDataBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SpotlightDataContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'StoreCardPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SubmitButtonElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SuccessSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SvgLinkBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SvgMedia', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'SvgTextCardBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'TabContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'TabItemBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'TextCardBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'TextContentBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'TextareaElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'TextboxElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'TimelineContainerBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'TimelineItemBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ToolkitBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ToolkitItemBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ToolkitSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'ToolsCardPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'TooltipBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'UrlElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'Video', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'VideoBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'VideoDetailBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'VideoMedia', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'VideoPromoBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'VisaLettersPage', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'VisibilityOptionsBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'WireTransferSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | { __typename: 'YourAnswersSectionBlock', RelativePath?: string | null, Name?: string | null, Url?: string | null, Status?: string | null, ContentType?: Array<string | null> | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null } | null> | null } | null };

export type AccordionContainerBlockFragment = { __typename: 'AccordionContainerBlock', Name?: string | null, Description?: string | null, Subheading?: string | null, AnchorLink?: string | null, AccordionItemBlock?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock', Subheading?: string | null, Description?: string | null } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null };

export type AccordionItemBlockFragment = { __typename?: 'AccordionItemBlock', Subheading?: string | null, Description?: string | null };

export type NextCallOutBlockFragment = { __typename: 'NextCallOutBlock', Name?: string | null, AnchorLink?: string | null, Heading?: string | null, SubHeading?: string | null, AccessGroup?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, CallOutLinkBlock?: { __typename?: 'NextCallOutBlockLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, LinkStyle?: string | null, Target?: string | null, ShouldDownload?: any | null } | null };

export type ContactsBlockFragment = { __typename?: 'ContactsBlock', Email?: string | null, FaxNumber?: string | null, PhoneNumber?: string | null, RegionTitle?: string | null };

export type FourColumnTableBlockFragment = { __typename?: 'FourColumnTableBlock', Footer?: string | null, TextContent?: { __typename?: 'FourColumnTableBlockTextContentBlock', Heading?: string | null } | null, Rows?: Array<{ __typename?: 'RowContent', ColumnOne?: string | null, ColumnTwo?: string | null, ColumnThree?: string | null, ColumnFour?: string | null } | null> | null };

export type ImageBlockFragment = { __typename: 'ImageBlock', AltText?: string | null, _concreteType?: string | null, ImageSize?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null };

export type ImageTextBlockFragment = { __typename: 'ImageTextBlock', AccessGroup?: string | null, AnchorLink?: string | null, ReverseContent?: any | null, Theme?: string | null, Seperator?: string | null, Image?: { __typename?: 'ImageTextBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, TextContent?: { __typename?: 'ImageTextBlockTextContentBlock', PreHeading?: string | null, Heading?: string | null, SubHeading?: string | null, Description?: string | null } | null, CallToActionLinks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null };

export type ImageTextCardBlockFragment = { __typename: 'ImageTextCardBlock', Description?: string | null, Heading?: string | null, SubHeading?: string | null, _concreteType?: string | null, ImageSize?: string | null, Image?: { __typename?: 'ImageTextCardBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, LinkBlock?: { __typename?: 'ImageTextCardBlockLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, Target?: string | null, LinkStyle?: string | null } | null };

export type LinkBlockFragment = { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null };

export type SvgLinkBlockFragment = { __typename: 'SvgLinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, IconClass?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null };

export type MembershipRequirementLinkBlockFragment = { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null };

export type MembershipRequirementBlockFragment = { __typename?: 'MembershipRequirementBlock', CoTDues?: number | null, GenericProductionFooterText?: string | null, MemberDues?: number | null, SpecificProductionFooterText?: string | null, ToTDues?: number | null, Date?: any | null, ConversionFactorsDescription?: string | null, DownloadRequirementsLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, IncomeCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCoreDownloadRequirementsLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCoreIncomeCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCorePremiumAndCommissionCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, PremiumAndCommissionCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, ConversionFactorsDownloadLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, MonthlyGoalCharts?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock', Key?: string | null, Name?: string | null, Value?: { __typename?: 'KeyLinkValueBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null };

export type MembershipRequirementsBlockFragment = { __typename: 'MembershipRequirementsBlock', ProductionRequirementsAnchorLink?: string | null, CertifyingLettersAnchorLink?: string | null, EthicalCodeAnchorLink?: string | null, MembershipDuesAnchorLink?: string | null, EthicalCodeDescription?: string | null, EthicalCodeStepLabel?: string | null, CertifyingLettersStepLabel?: string | null, CertifyingLettersDescription?: string | null, RelativePath?: string | null, RouteSegment?: string | null, MembershipDuesDescription?: string | null, MembershipDuesStepLabel?: string | null, MembershipTableCoTHeading?: string | null, MembershipTableCommissionRowHeading?: string | null, MembershipTableIncomeRowHeading?: string | null, MembershipTableMemberHeading?: string | null, MembershipTableName?: string | null, MembershipTablePremiumRowHeading?: string | null, MembershipTableToTHeading?: string | null, MonthlyGoalChartsLinkText?: string | null, Name?: string | null, ViewMembershipRequirementsLabel?: string | null, ProductionRequirementsMonthlyGoalDescription?: string | null, ProductionRequirementsStepLabel?: string | null, ProfessionalAssociationsDescription?: string | null, ProfessionalAssociationsStepLabel?: string | null, ConversionFactorsStepLabel?: string | null, MonthlyGoalStepName?: string | null, ProductionApiErrorLabel?: string | null, NoRequirementsLabel?: string | null, CertifyingLettersFindOfficerLink?: { __typename?: 'MembershipRequirementsBlockLinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, DownloadFileName?: string | null, ShouldDownload?: any | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MembershipRequirementBlocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock', CoTDues?: number | null, GenericProductionFooterText?: string | null, MemberDues?: number | null, SpecificProductionFooterText?: string | null, ToTDues?: number | null, Date?: any | null, ConversionFactorsDescription?: string | null, DownloadRequirementsLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, IncomeCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCoreDownloadRequirementsLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCoreIncomeCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCorePremiumAndCommissionCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, PremiumAndCommissionCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, ConversionFactorsDownloadLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, MonthlyGoalCharts?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock', Key?: string | null, Name?: string | null, Value?: { __typename?: 'KeyLinkValueBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, Contacts?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock', Email?: string | null, FaxNumber?: string | null, PhoneNumber?: string | null, RegionTitle?: string | null } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null };

export type NextContactUsBlockFragment = { __typename: 'NextContactUsBlock', ContactUsText?: string | null, AnchorLink?: string | null };

export type NextContainerBlockFragment = { __typename: 'NextContainerBlock', AccessGroup?: string | null, Name?: string | null, AnchorLink?: string | null, Heading?: string | null, SubHeading?: string | null, Description?: string | null, Seperator?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Items?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename: 'ImageBlock', AltText?: string | null, _concreteType?: string | null, ImageSize?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock', Description?: string | null, Heading?: string | null, SubHeading?: string | null, _concreteType?: string | null, ImageSize?: string | null, Image?: { __typename?: 'ImageTextCardBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, LinkBlock?: { __typename?: 'ImageTextCardBlockLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, Target?: string | null, LinkStyle?: string | null } | null } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null };

export type NextEventBlockFragment = { __typename: 'NextEventBlock', AnchorLink?: string | null, EventDescription?: string | null, EventHeading?: string | null, EventLocation?: string | null, NextEventLocation?: string | null, EventDateFrom?: any | null, EventDateTo?: any | null, NextEventDateFrom?: any | null, NextEventDateTo?: any | null, ReversedContent?: any | null, ShowOnlyForEdgeAccessGroupMembers?: any | null, EventImageBlock?: { __typename?: 'NextEventBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, EventLinkBlock?: { __typename?: 'NextEventBlockLinkBlock', LinkToContent?: string | null, Target?: string | null } | null };

export type NextHeroBlockFragment = { __typename: 'NextHeroBlock', AccessGroup?: string | null, Name?: string | null, AnchorLink?: string | null, HeroHeading?: string | null, HeroDescription?: string | null, HeroTheme?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, HeroImageBlocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename: 'ImageBlock', AltText?: string | null, _concreteType?: string | null, ImageSize?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, HeroLinkBlocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, HeroCtaButtons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null };

export type NextPersonContainerBlockFragment = { __typename: 'NextPersonContainerBlock', ProfileList?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock', Name?: string | null, Title?: string | null, Description?: string | null, MemberYears?: string | null, Country?: string | null, EmailAddress?: string | null, City?: string | null, Image?: { __typename?: 'PersonBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null };

export type PageMainContentFragment = { __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2', Type?: string | null, Heading?: string | null, SourcesFilterAllSelectionLabel?: string | null, ShowSourcesFilter?: any | null, ShowMagazineIssueFilter?: any | null, SelectedSources?: Array<{ __typename?: 'ContentModelReference', Id?: number | null } | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ExpandedSelectedSources?: Array<{ __typename?: 'SourcesEntry', Id?: number | null, Name?: string | null } | null> | null, ExpandedSelectedTopics?: Array<{ __typename?: 'TopicsEntry', Id?: number | null, Name?: string | null } | null> | null } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock', Preheading?: string | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null };

export type PastPresidentsBlockFragment = { __typename: 'PastPresidentsBlock', PastPresidentsTableReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock', Footer?: string | null, TextContent?: { __typename?: 'FourColumnTableBlockTextContentBlock', Heading?: string | null } | null, Rows?: Array<{ __typename?: 'RowContent', ColumnOne?: string | null, ColumnTwo?: string | null, ColumnThree?: string | null, ColumnFour?: string | null } | null> | null } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null };

export type PersonBlockFragment = { __typename?: 'PersonBlock', Name?: string | null, Title?: string | null, Description?: string | null, MemberYears?: string | null, Country?: string | null, EmailAddress?: string | null, City?: string | null, Image?: { __typename?: 'PersonBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null };

export type RichTextBlockFragment = { __typename: 'RichTextBlock', AnchorLink?: string | null, Name?: string | null, Content?: string | null, AnchorLabel?: string | null, Heading?: string | null, Seperator?: string | null };

export type HomePageMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageMetadataQuery = { __typename?: 'Query', HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', DisableSearchEngineIndexing?: any | null, AnalyticsCampaignName?: string | null, ContentTypeID?: number | null, Name?: string | null, MetaTitle?: string | null, MetaDescription?: string | null, MetaKeywordList?: string | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Id?: number | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MasterLanguage?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MetaImage?: { __typename?: 'HomePageV2ImageBlock', ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null } | null> | null } | null };

export type LandingPageContentQueryVariables = Exact<{ [key: string]: never; }>;


export type LandingPageContentQuery = { __typename?: 'Query', HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', Name?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename: 'ImageTextBlock', AccessGroup?: string | null, AnchorLink?: string | null, ReverseContent?: any | null, Theme?: string | null, Seperator?: string | null, Image?: { __typename?: 'ImageTextBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, TextContent?: { __typename?: 'ImageTextBlockTextContentBlock', PreHeading?: string | null, Heading?: string | null, SubHeading?: string | null, Description?: string | null } | null, CallToActionLinks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock', Name?: string | null, AnchorLink?: string | null, Heading?: string | null, SubHeading?: string | null, AccessGroup?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, CallOutLinkBlock?: { __typename?: 'NextCallOutBlockLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, LinkStyle?: string | null, Target?: string | null, ShouldDownload?: any | null } | null } | { __typename?: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock', AccessGroup?: string | null, Name?: string | null, AnchorLink?: string | null, Heading?: string | null, SubHeading?: string | null, Description?: string | null, Seperator?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Items?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename: 'ImageBlock', AltText?: string | null, _concreteType?: string | null, ImageSize?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock', Description?: string | null, Heading?: string | null, SubHeading?: string | null, _concreteType?: string | null, ImageSize?: string | null, Image?: { __typename?: 'ImageTextCardBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, LinkBlock?: { __typename?: 'ImageTextCardBlockLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, Target?: string | null, LinkStyle?: string | null } | null } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename: 'NextHeroBlock', AccessGroup?: string | null, Name?: string | null, AnchorLink?: string | null, HeroHeading?: string | null, HeroDescription?: string | null, HeroTheme?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, HeroImageBlocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename: 'ImageBlock', AltText?: string | null, _concreteType?: string | null, ImageSize?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, HeroLinkBlocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, HeroCtaButtons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null> | null } | null };

export type LearnSearchResultsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LearnDetailPageOrderByInput>;
  where?: InputMaybe<LearnDetailPageWhereInput>;
  year?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  source?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  topic?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  facetLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LearnSearchResultsQuery = { __typename?: 'Query', LearnDetailPage?: { __typename?: 'LearnDetailPageOutput', total?: number | null, items?: Array<{ __typename?: 'LearnDetailPage', _id?: string | null, _score?: number | null, RouteSegment?: string | null, RelativePath?: string | null, Url?: string | null, DisplayedDate?: any | null, ReadTimeInSeconds?: number | null, Heading?: string | null, Description?: string | null, Subheading?: string | null, SubheadingText?: string | null, ContentTypeSelection?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Authors?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'AMPSectionBlock', Name?: string | null } | { __typename?: 'AccordionContainerBlock', Name?: string | null } | { __typename?: 'AccordionItemBlock', Name?: string | null } | { __typename?: 'AccountProfilePage', Name?: string | null } | { __typename?: 'AddressInfoBlock', Name?: string | null } | { __typename?: 'BadgeBlock', Name?: string | null } | { __typename?: 'BrandedTableBlock', Name?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Name?: string | null } | { __typename?: 'ButtonLabelBlock', Name?: string | null } | { __typename?: 'CaptchaElementBlock', Name?: string | null } | { __typename?: 'CategoryListBlock', Name?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Name?: string | null } | { __typename?: 'CflBadgesBlock', Name?: string | null } | { __typename?: 'CflHomePage', Name?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Name?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Name?: string | null } | { __typename?: 'CflSiteSettingsPage', Name?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Name?: string | null } | { __typename?: 'ChoiceElementBlock', Name?: string | null } | { __typename?: 'ColumnContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Name?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Name?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Name?: string | null } | { __typename?: 'CompanyRankingsPage', Name?: string | null } | { __typename?: 'ConfirmationModalBlock', Name?: string | null } | { __typename?: 'ConfirmationStepBlock', Name?: string | null } | { __typename?: 'CongratulationsStepV2Block', Name?: string | null } | { __typename?: 'ContactEmailElementBlock', Name?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Name?: string | null } | { __typename?: 'ContactNameElementBlock', Name?: string | null } | { __typename?: 'ContactPhoneElementBlock', Name?: string | null } | { __typename?: 'ContactsBlock', Name?: string | null } | { __typename?: 'Content', Name?: string | null } | { __typename?: 'DAMAsset', Name?: string | null } | { __typename?: 'DAMImageAsset', Name?: string | null } | { __typename?: 'DAMVideo', Name?: string | null } | { __typename?: 'DAMVideoAsset', Name?: string | null } | { __typename?: 'DashBoardSectionBlock', Name?: string | null } | { __typename?: 'DashboardAccountPage', Name?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Name?: string | null } | { __typename?: 'DashboardContactInformationBlock', Name?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Name?: string | null } | { __typename?: 'DashboardPermissionsBlock', Name?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfileBlock', Name?: string | null } | { __typename?: 'DashboardSharedPage', Name?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Name?: string | null } | { __typename?: 'DataMismatchModalBlock', Name?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Name?: string | null } | { __typename?: 'DescriptionButtonBlock', Name?: string | null } | { __typename?: 'DetailPage', Name?: string | null } | { __typename?: 'DocumentMedia', Name?: string | null } | { __typename?: 'DonationBlock', Name?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Name?: string | null } | { __typename?: 'EEPSectionBlock', Name?: string | null } | { __typename?: 'EVPCarouselBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Name?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Name?: string | null } | { __typename?: 'EVPContentBlock', Name?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Name?: string | null } | { __typename?: 'EVPGenericPage', Name?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Name?: string | null } | { __typename?: 'EVPHomePage', Name?: string | null } | { __typename?: 'EVPImageBlock', Name?: string | null } | { __typename?: 'EVPImageLinkBlock', Name?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Name?: string | null } | { __typename?: 'EVPLinkBlock', Name?: string | null } | { __typename?: 'EVPMediaFileBlock', Name?: string | null } | { __typename?: 'EVPNavigationPageBlock', Name?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Name?: string | null } | { __typename?: 'EVPResourcePage', Name?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Name?: string | null } | { __typename?: 'EVPSearchPage', Name?: string | null } | { __typename?: 'EVPSiteSettingsPage', Name?: string | null } | { __typename?: 'EVPTabBlock', Name?: string | null } | { __typename?: 'EVPTabCardBlock', Name?: string | null } | { __typename?: 'EVPTabCardsBlock', Name?: string | null } | { __typename?: 'EVPTabImageTextBlock', Name?: string | null } | { __typename?: 'EVPTabRichTextBlock', Name?: string | null } | { __typename?: 'EVPTabVideoBlock', Name?: string | null } | { __typename?: 'EVPTabsBlock', Name?: string | null } | { __typename?: 'EVPTextImageBlock', Name?: string | null } | { __typename?: 'EVPVideoBlock', Name?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'ErrorModalBlock', Name?: string | null } | { __typename?: 'ErrorPage', Name?: string | null } | { __typename?: 'ErrorPageBlock', Name?: string | null } | { __typename?: 'EventBlock', Name?: string | null } | { __typename?: 'EventLocationAndDateBlock', Name?: string | null } | { __typename?: 'EventLocationInformationBlock', Name?: string | null } | { __typename?: 'EventPage', Name?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Name?: string | null } | { __typename?: 'EventSessionBlock', Name?: string | null } | { __typename?: 'EventSessionScheduleBlock', Name?: string | null } | { __typename?: 'EventSessionTrackBlock', Name?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Name?: string | null } | { __typename?: 'EventSpeakerSearchPage', Name?: string | null } | { __typename?: 'EventSpeakersBlock', Name?: string | null } | { __typename?: 'EventTableContainerBlock', Name?: string | null } | { __typename?: 'ExpandableContainerBlock', Name?: string | null } | { __typename?: 'FileUploadElementBlock', Name?: string | null } | { __typename?: 'FlowFinishInformationBlock', Name?: string | null } | { __typename?: 'FolderPage', Name?: string | null } | { __typename?: 'FormContainerBlock', Name?: string | null } | { __typename?: 'FormStepBlock', Name?: string | null } | { __typename?: 'FourColumnTableBlock', Name?: string | null } | { __typename?: 'GaugeBlock', Name?: string | null } | { __typename?: 'GeoDataBlock', Name?: string | null } | { __typename?: 'GettingStartedStepBlock', Name?: string | null } | { __typename?: 'GettingStartedStepV2Block', Name?: string | null } | { __typename?: 'GreetingCaseBlock', Name?: string | null } | { __typename?: 'GreetingStepBlock', Name?: string | null } | { __typename?: 'GreetingStepV2Block', Name?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Name?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Name?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Name?: string | null } | { __typename?: 'GsAwardsPage', Name?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Name?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Name?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Name?: string | null } | { __typename?: 'GsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsGreetingStepBlock', Name?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Name?: string | null } | { __typename?: 'GsMembershipRenewalPage', Name?: string | null } | { __typename?: 'GsProfileStepBlock', Name?: string | null } | { __typename?: 'GsReceiptStepBlock', Name?: string | null } | { __typename?: 'GsReviewStepBlock', Name?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Name?: string | null } | { __typename?: 'HeroTextContentBlock', Name?: string | null } | { __typename?: 'HomePage', Name?: string | null } | { __typename?: 'HomePageV2', Name?: string | null } | { __typename?: 'IconRequirementBlock', Name?: string | null } | { __typename?: 'Image', Name?: string | null } | { __typename?: 'ImageBlock', Name?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Name?: string | null } | { __typename?: 'ImageChoiceElementBlock', Name?: string | null } | { __typename?: 'ImageLinkBlock', Name?: string | null } | { __typename?: 'ImageMedia', Name?: string | null } | { __typename?: 'ImageTextBlock', Name?: string | null } | { __typename?: 'ImageTextBlockV2', Name?: string | null } | { __typename?: 'ImageTextCardBlock', Name?: string | null } | { __typename?: 'ImageTextItemBlock', Name?: string | null } | { __typename?: 'InfoBoxBlock', Name?: string | null } | { __typename?: 'KeyLinkValueBlock', Name?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Name?: string | null } | { __typename?: 'LandingPage', Name?: string | null } | { __typename?: 'LanguageIdAndName', Name?: string | null } | { __typename?: 'LanguagesBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Name?: string | null } | { __typename?: 'LearnDetailPage', Name?: string | null } | { __typename?: 'LearnHeroImageBlock', Name?: string | null } | { __typename?: 'LearnLandingPage', Name?: string | null } | { __typename?: 'LearnPageV2', Name?: string | null } | { __typename?: 'LearnPlayListPage', Name?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Name?: string | null } | { __typename?: 'LinkBlock', Name?: string | null } | { __typename?: 'LinkListBlock', Name?: string | null } | { __typename?: 'LinkTileBlock', Name?: string | null } | { __typename?: 'LoaderBlock', Name?: string | null } | { __typename?: 'LocationBlock', Name?: string | null } | { __typename?: 'MeetingEventCardPage', Name?: string | null } | { __typename?: 'MeetingPage', Name?: string | null } | { __typename?: 'MemberDirectory', Name?: string | null } | { __typename?: 'MemberDirectoryPage', Name?: string | null } | { __typename?: 'MemberSectionBlock', Name?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Name?: string | null } | { __typename?: 'MembershipInvoicePage', Name?: string | null } | { __typename?: 'MembershipLevelBlock', Name?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Name?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Name?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Name?: string | null } | { __typename?: 'MembershipLevelsBlock', Name?: string | null } | { __typename?: 'MembershipRenewalPage', Name?: string | null } | { __typename?: 'MembershipRenewalV2Page', Name?: string | null } | { __typename?: 'MembershipRequirementBlock', Name?: string | null } | { __typename?: 'MembershipRequirementsBlock', Name?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Name?: string | null } | { __typename?: 'ModalInfoBlock', Name?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Name?: string | null } | { __typename?: 'NextCallOutBlock', Name?: string | null } | { __typename?: 'NextContactUsBlock', Name?: string | null } | { __typename?: 'NextContainerBlock', Name?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Name?: string | null } | { __typename?: 'NextEventBlock', Name?: string | null } | { __typename?: 'NextHeroBlock', Name?: string | null } | { __typename?: 'NextInfoBoxBlock', Name?: string | null } | { __typename?: 'NextPersonContainerBlock', Name?: string | null } | { __typename?: 'NextPersonDataBlock', Name?: string | null } | { __typename?: 'NextStaffAdminPage', Name?: string | null } | { __typename?: 'NextStaticPage', Name?: string | null } | { __typename?: 'NextSyncEventsBlock', Name?: string | null } | { __typename?: 'NotFoundPage', Name?: string | null } | { __typename?: 'NumberElementBlock', Name?: string | null } | { __typename?: 'NumberedContainerBlock', Name?: string | null } | { __typename?: 'NumberedItemBlock', Name?: string | null } | { __typename?: 'ParagraphTextElementBlock', Name?: string | null } | { __typename?: 'PastPresidentsBlock', Name?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Name?: string | null } | { __typename?: 'PersonBlock', Name?: string | null } | { __typename?: 'PersonContainerBlock', Name?: string | null } | { __typename?: 'PersonQuizPage', Name?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Name?: string | null } | { __typename?: 'PlaylistBlock', Name?: string | null } | { __typename?: 'PlaylistPromoBlock', Name?: string | null } | { __typename?: 'PodcastDetailBlock', Name?: string | null } | { __typename?: 'PowerPhrasePage', Name?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Name?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Name?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPortalPage', Name?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Name?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Name?: string | null } | { __typename?: 'PressReleasePage', Name?: string | null } | { __typename?: 'PriceBreakdownBlock', Name?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Name?: string | null } | { __typename?: 'ProductionDataSectionBlock', Name?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Name?: string | null } | { __typename?: 'ProductionModalBlock', Name?: string | null } | { __typename?: 'ProductionStepBlock', Name?: string | null } | { __typename?: 'ProductionStepV2Block', Name?: string | null } | { __typename?: 'ProductionTableBlock', Name?: string | null } | { __typename?: 'ProfileListBlock', Name?: string | null } | { __typename?: 'ProfilePictureBlock', Name?: string | null } | { __typename?: 'ProfileSectionBlock', Name?: string | null } | { __typename?: 'ProfileStepBlock', Name?: string | null } | { __typename?: 'ProfileStepV2Block', Name?: string | null } | { __typename?: 'PublicProfilePage', Name?: string | null } | { __typename?: 'QuizCareerBlock', Name?: string | null } | { __typename?: 'QuizEducationBlock', Name?: string | null } | { __typename?: 'QuizFinancialBlock', Name?: string | null } | { __typename?: 'QuizHealthBlock', Name?: string | null } | { __typename?: 'QuizRelationshipsBlock', Name?: string | null } | { __typename?: 'QuizServiceBlock', Name?: string | null } | { __typename?: 'QuizSpiritualBlock', Name?: string | null } | { __typename?: 'RTContributorFormPage', Name?: string | null } | { __typename?: 'RangeElementBlock', Name?: string | null } | { __typename?: 'ReceiptStepBlock', Name?: string | null } | { __typename?: 'ReceiptStepV2Block', Name?: string | null } | { __typename?: 'ResetButtonElementBlock', Name?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Name?: string | null } | { __typename?: 'ReviewBlock', Name?: string | null } | { __typename?: 'ReviewStepBlock', Name?: string | null } | { __typename?: 'RichTextBlock', Name?: string | null } | { __typename?: 'RoutingStepBlock', Name?: string | null } | { __typename?: 'SearchPage', Name?: string | null } | { __typename?: 'SearchPageV2', Name?: string | null } | { __typename?: 'SectionContainerBlock', Name?: string | null } | { __typename?: 'SectionItemBlock', Name?: string | null } | { __typename?: 'SelectionElementBlock', Name?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Name?: string | null } | { __typename?: 'SettingSectionBlock', Name?: string | null } | { __typename?: 'SiteSettingsPage', Name?: string | null } | { __typename?: 'SocialShareBlock', Name?: string | null } | { __typename?: 'SpeakerEngagementPage', Name?: string | null } | { __typename?: 'SponsorSpeakerPage', Name?: string | null } | { __typename?: 'SpotlightBlock', Name?: string | null } | { __typename?: 'SpotlightContainerBlock', Name?: string | null } | { __typename?: 'SpotlightDataBlock', Name?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Name?: string | null } | { __typename?: 'StoreCardPage', Name?: string | null } | { __typename?: 'SubmitButtonElementBlock', Name?: string | null } | { __typename?: 'SuccessSectionBlock', Name?: string | null } | { __typename?: 'SvgLinkBlock', Name?: string | null } | { __typename?: 'SvgMedia', Name?: string | null } | { __typename?: 'SvgTextCardBlock', Name?: string | null } | { __typename?: 'TabContainerBlock', Name?: string | null } | { __typename?: 'TabItemBlock', Name?: string | null } | { __typename?: 'TextCardBlock', Name?: string | null } | { __typename?: 'TextContentBlock', Name?: string | null } | { __typename?: 'TextareaElementBlock', Name?: string | null } | { __typename?: 'TextboxElementBlock', Name?: string | null } | { __typename?: 'TimelineContainerBlock', Name?: string | null } | { __typename?: 'TimelineItemBlock', Name?: string | null } | { __typename?: 'ToolkitBlock', Name?: string | null } | { __typename?: 'ToolkitItemBlock', Name?: string | null } | { __typename?: 'ToolkitSectionBlock', Name?: string | null } | { __typename?: 'ToolsCardPage', Name?: string | null } | { __typename?: 'TooltipBlock', Name?: string | null } | { __typename?: 'UrlElementBlock', Name?: string | null } | { __typename?: 'Video', Name?: string | null } | { __typename?: 'VideoBlock', Name?: string | null } | { __typename?: 'VideoDetailBlock', Name?: string | null } | { __typename?: 'VideoMedia', Name?: string | null } | { __typename?: 'VideoPromoBlock', Name?: string | null } | { __typename?: 'VisaLettersPage', Name?: string | null } | { __typename?: 'VisibilityOptionsBlock', Name?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Name?: string | null } | { __typename?: 'WireTransferSectionBlock', Name?: string | null } | { __typename?: 'YourAnswersSectionBlock', Name?: string | null } | null } | null } | null> | null, AssignedGroupsReadAccess?: Array<{ __typename?: 'AssignedGroupPropertyValue', GroupName?: string | null } | null> | null, ExpandedCategories?: Array<{ __typename?: 'ExpandedCategoriesEntry', Name?: string | null, ParentId?: number | null } | null> | null, ThumbnailImage?: { __typename?: 'LearnDetailPageImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock' } | { __typename: 'AccordionItemBlock' } | { __typename: 'AccountProfilePage' } | { __typename: 'AddressInfoBlock' } | { __typename: 'BadgeBlock' } | { __typename: 'BrandedTableBlock' } | { __typename: 'BulkImporterUploaderSectionBlock' } | { __typename: 'ButtonLabelBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'CategoryListBlock' } | { __typename: 'CertifyingOfficerSectionBlock' } | { __typename: 'CflBadgesBlock' } | { __typename: 'CflHomePage' } | { __typename: 'CflMembershipKitCardBlock' } | { __typename: 'CflMembershipKitCarouselBlock' } | { __typename: 'CflSiteSettingsPage' } | { __typename: 'CflSpecialResourceCardBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'ColumnContainerBlock' } | { __typename: 'ColumnLinksListContainerBlock' } | { __typename: 'ColumnLinksListItemBlock' } | { __typename: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename: 'CompanyAdminBulkImportPage' } | { __typename: 'CompanyAdminCompanyListingsPage' } | { __typename: 'CompanyAdminMembershipDirectoryPage' } | { __typename: 'CompanyRankingsPage' } | { __typename: 'ConfirmationModalBlock' } | { __typename: 'ConfirmationStepBlock' } | { __typename: 'CongratulationsStepV2Block' } | { __typename: 'ContactEmailElementBlock' } | { __typename: 'ContactMdrtIdElementBlock' } | { __typename: 'ContactNameElementBlock' } | { __typename: 'ContactPhoneElementBlock' } | { __typename: 'ContactsBlock' } | { __typename: 'Content' } | { __typename: 'DAMAsset' } | { __typename: 'DAMImageAsset' } | { __typename: 'DAMVideo' } | { __typename: 'DAMVideoAsset' } | { __typename: 'DashBoardSectionBlock' } | { __typename: 'DashboardAccountPage' } | { __typename: 'DashboardCarouselCardBlock' } | { __typename: 'DashboardContactInformationBlock' } | { __typename: 'DashboardLoginPasswordBlock' } | { __typename: 'DashboardPermissionsBlock' } | { __typename: 'DashboardPersonalInformationBlock' } | { __typename: 'DashboardProfessionalInformationBlock' } | { __typename: 'DashboardProfileBlock' } | { __typename: 'DashboardSharedPage' } | { __typename: 'DashboardSitePreferencesBlock' } | { __typename: 'DataMismatchModalBlock' } | { __typename: 'DeleteCertifyinLetterModalBlock' } | { __typename: 'DescriptionButtonBlock' } | { __typename: 'DetailPage' } | { __typename: 'DocumentMedia' } | { __typename: 'DonationBlock' } | { __typename: 'DownloadUploadSectionBlock' } | { __typename: 'EEPSectionBlock' } | { __typename: 'EVPCarouselBlock' } | { __typename: 'EVPCarouselQuoteBlock' } | { __typename: 'EVPCarouselQuoteSlideBlock' } | { __typename: 'EVPCarouselSlideBlock' } | { __typename: 'EVPContentBlock' } | { __typename: 'EVPFeaturedResourcesBlock' } | { __typename: 'EVPGenericPage' } | { __typename: 'EVPHeroQuoteBlock' } | { __typename: 'EVPHomePage' } | { __typename: 'EVPImageBlock' } | { __typename: 'EVPImageLinkBlock' } | { __typename: 'EVPLanguageSelectorBlock' } | { __typename: 'EVPLinkBlock' } | { __typename: 'EVPMediaFileBlock' } | { __typename: 'EVPNavigationPageBlock' } | { __typename: 'EVPPartnerSettingsBlock' } | { __typename: 'EVPResourcePage' } | { __typename: 'EVPSearchHeaderBlock' } | { __typename: 'EVPSearchPage' } | { __typename: 'EVPSiteSettingsPage' } | { __typename: 'EVPTabBlock' } | { __typename: 'EVPTabCardBlock' } | { __typename: 'EVPTabCardsBlock' } | { __typename: 'EVPTabImageTextBlock' } | { __typename: 'EVPTabRichTextBlock' } | { __typename: 'EVPTabVideoBlock' } | { __typename: 'EVPTabsBlock' } | { __typename: 'EVPTextImageBlock' } | { __typename: 'EVPVideoBlock' } | { __typename: 'EmployeeTableHeaderLabelsBlock' } | { __typename: 'ErrorModalBlock' } | { __typename: 'ErrorPage' } | { __typename: 'ErrorPageBlock' } | { __typename: 'EventBlock' } | { __typename: 'EventLocationAndDateBlock' } | { __typename: 'EventLocationInformationBlock' } | { __typename: 'EventPage' } | { __typename: 'EventRegistrationInformationBlock' } | { __typename: 'EventSessionBlock' } | { __typename: 'EventSessionScheduleBlock' } | { __typename: 'EventSessionTrackBlock' } | { __typename: 'EventSessionTrackSpeakerBlock' } | { __typename: 'EventSpeakerSearchPage' } | { __typename: 'EventSpeakersBlock' } | { __typename: 'EventTableContainerBlock' } | { __typename: 'ExpandableContainerBlock' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FlowFinishInformationBlock' } | { __typename: 'FolderPage' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'FourColumnTableBlock' } | { __typename: 'GaugeBlock' } | { __typename: 'GeoDataBlock' } | { __typename: 'GettingStartedStepBlock' } | { __typename: 'GettingStartedStepV2Block' } | { __typename: 'GreetingCaseBlock' } | { __typename: 'GreetingStepBlock' } | { __typename: 'GreetingStepV2Block' } | { __typename: 'GsAwardsApplicationsBlock' } | { __typename: 'GsAwardsConfirmationStepBlock' } | { __typename: 'GsAwardsFileUploadBlock' } | { __typename: 'GsAwardsGettingStartedStepBlock' } | { __typename: 'GsAwardsMembershipStepBlock' } | { __typename: 'GsAwardsPage' } | { __typename: 'GsAwardsPersistencyStepBlock' } | { __typename: 'GsAwardsProductionStepBlock' } | { __typename: 'GsAwardsRecruitmentStepBlock' } | { __typename: 'GsAwardsRetentionStepBlock' } | { __typename: 'GsAwardsSelectApplicantStepBlock' } | { __typename: 'GsAwardsSubmitStepBlock' } | { __typename: 'GsAwardsVerificationStepBlock' } | { __typename: 'GsAwardsWholePersonStepBlock' } | { __typename: 'GsConfirmationStepBlock' } | { __typename: 'GsGettingStartedStepBlock' } | { __typename: 'GsGreetingStepBlock' } | { __typename: 'GsLeadershipInformationStepBlock' } | { __typename: 'GsMembershipRenewalPage' } | { __typename: 'GsProfileStepBlock' } | { __typename: 'GsReceiptStepBlock' } | { __typename: 'GsReviewStepBlock' } | { __typename: 'HealthPoliciesSectionBlock' } | { __typename: 'HeroTextContentBlock' } | { __typename: 'HomePage' } | { __typename: 'HomePageV2' } | { __typename: 'IconRequirementBlock' } | { __typename: 'Image' } | { __typename: 'ImageBlock' } | { __typename: 'ImageCaptionRichTextBlock' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'ImageLinkBlock' } | { __typename: 'ImageMedia' } | { __typename: 'ImageTextBlock' } | { __typename: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock' } | { __typename: 'ImageTextItemBlock' } | { __typename: 'InfoBoxBlock' } | { __typename: 'KeyLinkValueBlock' } | { __typename: 'KeyTranslatedValueBlock' } | { __typename: 'LandingPage' } | { __typename: 'LanguageIdAndName' } | { __typename: 'LanguagesBlock' } | { __typename: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2' } | { __typename: 'LearnDetailPage' } | { __typename: 'LearnHeroImageBlock' } | { __typename: 'LearnLandingPage' } | { __typename: 'LearnPageV2' } | { __typename: 'LearnPlayListPage' } | { __typename: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock' } | { __typename: 'LinkListBlock' } | { __typename: 'LinkTileBlock' } | { __typename: 'LoaderBlock' } | { __typename: 'LocationBlock' } | { __typename: 'MeetingEventCardPage' } | { __typename: 'MeetingPage' } | { __typename: 'MemberDirectory' } | { __typename: 'MemberDirectoryPage' } | { __typename: 'MemberSectionBlock' } | { __typename: 'MembersTableHeaderLabelsBlock' } | { __typename: 'MembershipHistoryDetailBlock' } | { __typename: 'MembershipHistoryDetailPage' } | { __typename: 'MembershipInvoicePage' } | { __typename: 'MembershipLevelBlock' } | { __typename: 'MembershipLevelRadioBlock' } | { __typename: 'MembershipLevelSectionBlock' } | { __typename: 'MembershipLevelStepV2Block' } | { __typename: 'MembershipLevelsBlock' } | { __typename: 'MembershipRenewalPage' } | { __typename: 'MembershipRenewalV2Page' } | { __typename: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock' } | { __typename: 'MembershipTypeSectionBlock' } | { __typename: 'MembershipTypeStepBlock' } | { __typename: 'MembershipTypeStepV2Block' } | { __typename: 'ModalInfoBlock' } | { __typename: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock' } | { __typename: 'NextContactUsBlock' } | { __typename: 'NextContainerBlock' } | { __typename: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock' } | { __typename: 'NextHeroBlock' } | { __typename: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock' } | { __typename: 'NextPersonDataBlock' } | { __typename: 'NextStaffAdminPage' } | { __typename: 'NextStaticPage' } | { __typename: 'NextSyncEventsBlock' } | { __typename: 'NotFoundPage' } | { __typename: 'NumberElementBlock' } | { __typename: 'NumberedContainerBlock' } | { __typename: 'NumberedItemBlock' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock' } | { __typename: 'PaymentProcessingScreenBlock' } | { __typename: 'PersonBlock' } | { __typename: 'PersonContainerBlock' } | { __typename: 'PersonQuizPage' } | { __typename: 'PersonUpdatesSectionBlock' } | { __typename: 'PlaylistBlock' } | { __typename: 'PlaylistPromoBlock' } | { __typename: 'PodcastDetailBlock' } | { __typename: 'PowerPhrasePage' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrepaymentErrorModalBlock' } | { __typename: 'PrepaymentErrorPageBlock' } | { __typename: 'PrepaymentGenericErrorBlock' } | { __typename: 'PrepaymentHomepageBlock' } | { __typename: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename: 'PrepaymentHomepageGsBlock' } | { __typename: 'PrepaymentHomepageMdrtBlock' } | { __typename: 'PrepaymentLoaderScreenBlock' } | { __typename: 'PrepaymentMembershipInfoCardBlock' } | { __typename: 'PrepaymentMembershipInfoPageBlock' } | { __typename: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename: 'PrepaymentPaymentPageBlock' } | { __typename: 'PrepaymentPaymentStatusPageBlock' } | { __typename: 'PrepaymentPortalPage' } | { __typename: 'PrepaymentProductNamesBlock' } | { __typename: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename: 'PressReleasePage' } | { __typename: 'PriceBreakdownBlock' } | { __typename: 'ProductionAttestmentNumbersBlock' } | { __typename: 'ProductionDataSectionBlock' } | { __typename: 'ProductionDeleteModalBlock' } | { __typename: 'ProductionModalBlock' } | { __typename: 'ProductionStepBlock' } | { __typename: 'ProductionStepV2Block' } | { __typename: 'ProductionTableBlock' } | { __typename: 'ProfileListBlock', ProfileList?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock', Name?: string | null } | { __typename?: 'AccordionContainerBlock', Name?: string | null } | { __typename?: 'AccordionItemBlock', Name?: string | null } | { __typename?: 'AccountProfilePage', Name?: string | null } | { __typename?: 'AddressInfoBlock', Name?: string | null } | { __typename?: 'BadgeBlock', Name?: string | null } | { __typename?: 'BrandedTableBlock', Name?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', Name?: string | null } | { __typename?: 'ButtonLabelBlock', Name?: string | null } | { __typename?: 'CaptchaElementBlock', Name?: string | null } | { __typename?: 'CategoryListBlock', Name?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', Name?: string | null } | { __typename?: 'CflBadgesBlock', Name?: string | null } | { __typename?: 'CflHomePage', Name?: string | null } | { __typename?: 'CflMembershipKitCardBlock', Name?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', Name?: string | null } | { __typename?: 'CflSiteSettingsPage', Name?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', Name?: string | null } | { __typename?: 'ChoiceElementBlock', Name?: string | null } | { __typename?: 'ColumnContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', Name?: string | null } | { __typename?: 'ColumnLinksListItemBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', Name?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', Name?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', Name?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', Name?: string | null } | { __typename?: 'CompanyRankingsPage', Name?: string | null } | { __typename?: 'ConfirmationModalBlock', Name?: string | null } | { __typename?: 'ConfirmationStepBlock', Name?: string | null } | { __typename?: 'CongratulationsStepV2Block', Name?: string | null } | { __typename?: 'ContactEmailElementBlock', Name?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', Name?: string | null } | { __typename?: 'ContactNameElementBlock', Name?: string | null } | { __typename?: 'ContactPhoneElementBlock', Name?: string | null } | { __typename?: 'ContactsBlock', Name?: string | null } | { __typename?: 'Content', Name?: string | null } | { __typename?: 'DAMAsset', Name?: string | null } | { __typename?: 'DAMImageAsset', Name?: string | null } | { __typename?: 'DAMVideo', Name?: string | null } | { __typename?: 'DAMVideoAsset', Name?: string | null } | { __typename?: 'DashBoardSectionBlock', Name?: string | null } | { __typename?: 'DashboardAccountPage', Name?: string | null } | { __typename?: 'DashboardCarouselCardBlock', Name?: string | null } | { __typename?: 'DashboardContactInformationBlock', Name?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', Name?: string | null } | { __typename?: 'DashboardPermissionsBlock', Name?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', Name?: string | null } | { __typename?: 'DashboardProfileBlock', Name?: string | null } | { __typename?: 'DashboardSharedPage', Name?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', Name?: string | null } | { __typename?: 'DataMismatchModalBlock', Name?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', Name?: string | null } | { __typename?: 'DescriptionButtonBlock', Name?: string | null } | { __typename?: 'DetailPage', Name?: string | null } | { __typename?: 'DocumentMedia', Name?: string | null } | { __typename?: 'DonationBlock', Name?: string | null } | { __typename?: 'DownloadUploadSectionBlock', Name?: string | null } | { __typename?: 'EEPSectionBlock', Name?: string | null } | { __typename?: 'EVPCarouselBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', Name?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', Name?: string | null } | { __typename?: 'EVPCarouselSlideBlock', Name?: string | null } | { __typename?: 'EVPContentBlock', Name?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', Name?: string | null } | { __typename?: 'EVPGenericPage', Name?: string | null } | { __typename?: 'EVPHeroQuoteBlock', Name?: string | null } | { __typename?: 'EVPHomePage', Name?: string | null } | { __typename?: 'EVPImageBlock', Name?: string | null } | { __typename?: 'EVPImageLinkBlock', Name?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', Name?: string | null } | { __typename?: 'EVPLinkBlock', Name?: string | null } | { __typename?: 'EVPMediaFileBlock', Name?: string | null } | { __typename?: 'EVPNavigationPageBlock', Name?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', Name?: string | null } | { __typename?: 'EVPResourcePage', Name?: string | null } | { __typename?: 'EVPSearchHeaderBlock', Name?: string | null } | { __typename?: 'EVPSearchPage', Name?: string | null } | { __typename?: 'EVPSiteSettingsPage', Name?: string | null } | { __typename?: 'EVPTabBlock', Name?: string | null } | { __typename?: 'EVPTabCardBlock', Name?: string | null } | { __typename?: 'EVPTabCardsBlock', Name?: string | null } | { __typename?: 'EVPTabImageTextBlock', Name?: string | null } | { __typename?: 'EVPTabRichTextBlock', Name?: string | null } | { __typename?: 'EVPTabVideoBlock', Name?: string | null } | { __typename?: 'EVPTabsBlock', Name?: string | null } | { __typename?: 'EVPTextImageBlock', Name?: string | null } | { __typename?: 'EVPVideoBlock', Name?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'ErrorModalBlock', Name?: string | null } | { __typename?: 'ErrorPage', Name?: string | null } | { __typename?: 'ErrorPageBlock', Name?: string | null } | { __typename?: 'EventBlock', Name?: string | null } | { __typename?: 'EventLocationAndDateBlock', Name?: string | null } | { __typename?: 'EventLocationInformationBlock', Name?: string | null } | { __typename?: 'EventPage', Name?: string | null } | { __typename?: 'EventRegistrationInformationBlock', Name?: string | null } | { __typename?: 'EventSessionBlock', Name?: string | null } | { __typename?: 'EventSessionScheduleBlock', Name?: string | null } | { __typename?: 'EventSessionTrackBlock', Name?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', Name?: string | null } | { __typename?: 'EventSpeakerSearchPage', Name?: string | null } | { __typename?: 'EventSpeakersBlock', Name?: string | null } | { __typename?: 'EventTableContainerBlock', Name?: string | null } | { __typename?: 'ExpandableContainerBlock', Name?: string | null } | { __typename?: 'FileUploadElementBlock', Name?: string | null } | { __typename?: 'FlowFinishInformationBlock', Name?: string | null } | { __typename?: 'FolderPage', Name?: string | null } | { __typename?: 'FormContainerBlock', Name?: string | null } | { __typename?: 'FormStepBlock', Name?: string | null } | { __typename?: 'FourColumnTableBlock', Name?: string | null } | { __typename?: 'GaugeBlock', Name?: string | null } | { __typename?: 'GeoDataBlock', Name?: string | null } | { __typename?: 'GettingStartedStepBlock', Name?: string | null } | { __typename?: 'GettingStartedStepV2Block', Name?: string | null } | { __typename?: 'GreetingCaseBlock', Name?: string | null } | { __typename?: 'GreetingStepBlock', Name?: string | null } | { __typename?: 'GreetingStepV2Block', Name?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', Name?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', Name?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', Name?: string | null } | { __typename?: 'GsAwardsPage', Name?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', Name?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', Name?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', Name?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', Name?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', Name?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', Name?: string | null } | { __typename?: 'GsConfirmationStepBlock', Name?: string | null } | { __typename?: 'GsGettingStartedStepBlock', Name?: string | null } | { __typename?: 'GsGreetingStepBlock', Name?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', Name?: string | null } | { __typename?: 'GsMembershipRenewalPage', Name?: string | null } | { __typename?: 'GsProfileStepBlock', Name?: string | null } | { __typename?: 'GsReceiptStepBlock', Name?: string | null } | { __typename?: 'GsReviewStepBlock', Name?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', Name?: string | null } | { __typename?: 'HeroTextContentBlock', Name?: string | null } | { __typename?: 'HomePage', Name?: string | null } | { __typename?: 'HomePageV2', Name?: string | null } | { __typename?: 'IconRequirementBlock', Name?: string | null } | { __typename?: 'Image', Name?: string | null } | { __typename?: 'ImageBlock', Name?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', Name?: string | null } | { __typename?: 'ImageChoiceElementBlock', Name?: string | null } | { __typename?: 'ImageLinkBlock', Name?: string | null } | { __typename?: 'ImageMedia', Name?: string | null } | { __typename?: 'ImageTextBlock', Name?: string | null } | { __typename?: 'ImageTextBlockV2', Name?: string | null } | { __typename?: 'ImageTextCardBlock', Name?: string | null } | { __typename?: 'ImageTextItemBlock', Name?: string | null } | { __typename?: 'InfoBoxBlock', Name?: string | null } | { __typename?: 'KeyLinkValueBlock', Name?: string | null } | { __typename?: 'KeyTranslatedValueBlock', Name?: string | null } | { __typename?: 'LandingPage', Name?: string | null } | { __typename?: 'LanguageIdAndName', Name?: string | null } | { __typename?: 'LanguagesBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlock', Name?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', Name?: string | null } | { __typename?: 'LearnDetailPage', Name?: string | null } | { __typename?: 'LearnHeroImageBlock', Name?: string | null } | { __typename?: 'LearnLandingPage', Name?: string | null } | { __typename?: 'LearnPageV2', Name?: string | null } | { __typename?: 'LearnPlayListPage', Name?: string | null } | { __typename?: 'LikeAndBookmarkBlock', Name?: string | null } | { __typename?: 'LinkBlock', Name?: string | null } | { __typename?: 'LinkListBlock', Name?: string | null } | { __typename?: 'LinkTileBlock', Name?: string | null } | { __typename?: 'LoaderBlock', Name?: string | null } | { __typename?: 'LocationBlock', Name?: string | null } | { __typename?: 'MeetingEventCardPage', Name?: string | null } | { __typename?: 'MeetingPage', Name?: string | null } | { __typename?: 'MemberDirectory', Name?: string | null } | { __typename?: 'MemberDirectoryPage', Name?: string | null } | { __typename?: 'MemberSectionBlock', Name?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', Name?: string | null } | { __typename?: 'MembershipHistoryDetailPage', Name?: string | null } | { __typename?: 'MembershipInvoicePage', Name?: string | null } | { __typename?: 'MembershipLevelBlock', Name?: string | null } | { __typename?: 'MembershipLevelRadioBlock', Name?: string | null } | { __typename?: 'MembershipLevelSectionBlock', Name?: string | null } | { __typename?: 'MembershipLevelStepV2Block', Name?: string | null } | { __typename?: 'MembershipLevelsBlock', Name?: string | null } | { __typename?: 'MembershipRenewalPage', Name?: string | null } | { __typename?: 'MembershipRenewalV2Page', Name?: string | null } | { __typename?: 'MembershipRequirementBlock', Name?: string | null } | { __typename?: 'MembershipRequirementsBlock', Name?: string | null } | { __typename?: 'MembershipTypeSectionBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepBlock', Name?: string | null } | { __typename?: 'MembershipTypeStepV2Block', Name?: string | null } | { __typename?: 'ModalInfoBlock', Name?: string | null } | { __typename?: 'NewIDRequestSectionBlock', Name?: string | null } | { __typename?: 'NextCallOutBlock', Name?: string | null } | { __typename?: 'NextContactUsBlock', Name?: string | null } | { __typename?: 'NextContainerBlock', Name?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', Name?: string | null } | { __typename?: 'NextEventBlock', Name?: string | null } | { __typename?: 'NextHeroBlock', Name?: string | null } | { __typename?: 'NextInfoBoxBlock', Name?: string | null } | { __typename?: 'NextPersonContainerBlock', Name?: string | null } | { __typename?: 'NextPersonDataBlock', Name?: string | null } | { __typename?: 'NextStaffAdminPage', Name?: string | null } | { __typename?: 'NextStaticPage', Name?: string | null } | { __typename?: 'NextSyncEventsBlock', Name?: string | null } | { __typename?: 'NotFoundPage', Name?: string | null } | { __typename?: 'NumberElementBlock', Name?: string | null } | { __typename?: 'NumberedContainerBlock', Name?: string | null } | { __typename?: 'NumberedItemBlock', Name?: string | null } | { __typename?: 'ParagraphTextElementBlock', Name?: string | null } | { __typename?: 'PastPresidentsBlock', Name?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', Name?: string | null } | { __typename?: 'PersonBlock', Name?: string | null } | { __typename?: 'PersonContainerBlock', Name?: string | null } | { __typename?: 'PersonQuizPage', Name?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', Name?: string | null } | { __typename?: 'PlaylistBlock', Name?: string | null } | { __typename?: 'PlaylistPromoBlock', Name?: string | null } | { __typename?: 'PodcastDetailBlock', Name?: string | null } | { __typename?: 'PowerPhrasePage', Name?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', Name?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', Name?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', Name?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', Name?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', Name?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', Name?: string | null } | { __typename?: 'PrepaymentPortalPage', Name?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', Name?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', Name?: string | null } | { __typename?: 'PressReleasePage', Name?: string | null } | { __typename?: 'PriceBreakdownBlock', Name?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', Name?: string | null } | { __typename?: 'ProductionDataSectionBlock', Name?: string | null } | { __typename?: 'ProductionDeleteModalBlock', Name?: string | null } | { __typename?: 'ProductionModalBlock', Name?: string | null } | { __typename?: 'ProductionStepBlock', Name?: string | null } | { __typename?: 'ProductionStepV2Block', Name?: string | null } | { __typename?: 'ProductionTableBlock', Name?: string | null } | { __typename?: 'ProfileListBlock', Name?: string | null } | { __typename?: 'ProfilePictureBlock', Name?: string | null } | { __typename?: 'ProfileSectionBlock', Name?: string | null } | { __typename?: 'ProfileStepBlock', Name?: string | null } | { __typename?: 'ProfileStepV2Block', Name?: string | null } | { __typename?: 'PublicProfilePage', Name?: string | null } | { __typename?: 'QuizCareerBlock', Name?: string | null } | { __typename?: 'QuizEducationBlock', Name?: string | null } | { __typename?: 'QuizFinancialBlock', Name?: string | null } | { __typename?: 'QuizHealthBlock', Name?: string | null } | { __typename?: 'QuizRelationshipsBlock', Name?: string | null } | { __typename?: 'QuizServiceBlock', Name?: string | null } | { __typename?: 'QuizSpiritualBlock', Name?: string | null } | { __typename?: 'RTContributorFormPage', Name?: string | null } | { __typename?: 'RangeElementBlock', Name?: string | null } | { __typename?: 'ReceiptStepBlock', Name?: string | null } | { __typename?: 'ReceiptStepV2Block', Name?: string | null } | { __typename?: 'ResetButtonElementBlock', Name?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', Name?: string | null } | { __typename?: 'ReviewBlock', Name?: string | null } | { __typename?: 'ReviewStepBlock', Name?: string | null } | { __typename?: 'RichTextBlock', Name?: string | null } | { __typename?: 'RoutingStepBlock', Name?: string | null } | { __typename?: 'SearchPage', Name?: string | null } | { __typename?: 'SearchPageV2', Name?: string | null } | { __typename?: 'SectionContainerBlock', Name?: string | null } | { __typename?: 'SectionItemBlock', Name?: string | null } | { __typename?: 'SelectionElementBlock', Name?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', Name?: string | null } | { __typename?: 'SettingSectionBlock', Name?: string | null } | { __typename?: 'SiteSettingsPage', Name?: string | null } | { __typename?: 'SocialShareBlock', Name?: string | null } | { __typename?: 'SpeakerEngagementPage', Name?: string | null } | { __typename?: 'SponsorSpeakerPage', Name?: string | null } | { __typename?: 'SpotlightBlock', Name?: string | null } | { __typename?: 'SpotlightContainerBlock', Name?: string | null } | { __typename?: 'SpotlightDataBlock', Name?: string | null } | { __typename?: 'SpotlightDataContainerBlock', Name?: string | null } | { __typename?: 'StoreCardPage', Name?: string | null } | { __typename?: 'SubmitButtonElementBlock', Name?: string | null } | { __typename?: 'SuccessSectionBlock', Name?: string | null } | { __typename?: 'SvgLinkBlock', Name?: string | null } | { __typename?: 'SvgMedia', Name?: string | null } | { __typename?: 'SvgTextCardBlock', Name?: string | null } | { __typename?: 'TabContainerBlock', Name?: string | null } | { __typename?: 'TabItemBlock', Name?: string | null } | { __typename?: 'TextCardBlock', Name?: string | null } | { __typename?: 'TextContentBlock', Name?: string | null } | { __typename?: 'TextareaElementBlock', Name?: string | null } | { __typename?: 'TextboxElementBlock', Name?: string | null } | { __typename?: 'TimelineContainerBlock', Name?: string | null } | { __typename?: 'TimelineItemBlock', Name?: string | null } | { __typename?: 'ToolkitBlock', Name?: string | null } | { __typename?: 'ToolkitItemBlock', Name?: string | null } | { __typename?: 'ToolkitSectionBlock', Name?: string | null } | { __typename?: 'ToolsCardPage', Name?: string | null } | { __typename?: 'TooltipBlock', Name?: string | null } | { __typename?: 'UrlElementBlock', Name?: string | null } | { __typename?: 'Video', Name?: string | null } | { __typename?: 'VideoBlock', Name?: string | null } | { __typename?: 'VideoDetailBlock', Name?: string | null } | { __typename?: 'VideoMedia', Name?: string | null } | { __typename?: 'VideoPromoBlock', Name?: string | null } | { __typename?: 'VisaLettersPage', Name?: string | null } | { __typename?: 'VisibilityOptionsBlock', Name?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', Name?: string | null } | { __typename?: 'WireTransferSectionBlock', Name?: string | null } | { __typename?: 'YourAnswersSectionBlock', Name?: string | null } | null } | null } | null> | null } | { __typename: 'ProfilePictureBlock' } | { __typename: 'ProfileSectionBlock' } | { __typename: 'ProfileStepBlock' } | { __typename: 'ProfileStepV2Block' } | { __typename: 'PublicProfilePage' } | { __typename: 'QuizCareerBlock' } | { __typename: 'QuizEducationBlock' } | { __typename: 'QuizFinancialBlock' } | { __typename: 'QuizHealthBlock' } | { __typename: 'QuizRelationshipsBlock' } | { __typename: 'QuizServiceBlock' } | { __typename: 'QuizSpiritualBlock' } | { __typename: 'RTContributorFormPage' } | { __typename: 'RangeElementBlock' } | { __typename: 'ReceiptStepBlock' } | { __typename: 'ReceiptStepV2Block' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ReviewAndSubmitStepV2Block' } | { __typename: 'ReviewBlock' } | { __typename: 'ReviewStepBlock' } | { __typename: 'RichTextBlock' } | { __typename: 'RoutingStepBlock' } | { __typename: 'SearchPage' } | { __typename: 'SearchPageV2' } | { __typename: 'SectionContainerBlock' } | { __typename: 'SectionItemBlock' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SelfAttestLevelOptionsBlock' } | { __typename: 'SettingSectionBlock' } | { __typename: 'SiteSettingsPage' } | { __typename: 'SocialShareBlock' } | { __typename: 'SpeakerEngagementPage' } | { __typename: 'SponsorSpeakerPage' } | { __typename: 'SpotlightBlock' } | { __typename: 'SpotlightContainerBlock' } | { __typename: 'SpotlightDataBlock' } | { __typename: 'SpotlightDataContainerBlock' } | { __typename: 'StoreCardPage' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SuccessSectionBlock' } | { __typename: 'SvgLinkBlock' } | { __typename: 'SvgMedia' } | { __typename: 'SvgTextCardBlock' } | { __typename: 'TabContainerBlock' } | { __typename: 'TabItemBlock' } | { __typename: 'TextCardBlock' } | { __typename: 'TextContentBlock' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'TimelineContainerBlock' } | { __typename: 'TimelineItemBlock' } | { __typename: 'ToolkitBlock' } | { __typename: 'ToolkitItemBlock' } | { __typename: 'ToolkitSectionBlock' } | { __typename: 'ToolsCardPage' } | { __typename: 'TooltipBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'Video' } | { __typename: 'VideoBlock' } | { __typename: 'VideoDetailBlock' } | { __typename: 'VideoMedia' } | { __typename: 'VideoPromoBlock' } | { __typename: 'VisaLettersPage' } | { __typename: 'VisibilityOptionsBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WireTransferSectionBlock' } | { __typename: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null, facets?: { __typename?: 'LearnDetailPageFacet', DisplayedDateYear?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, ExpandedSources?: { __typename?: 'ExpandedSourcesEntryFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null, ExpandedTopics?: { __typename?: 'ExpandedTopicsEntryFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null } | null };

export type LocalPathsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocalPathsQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', SearchPageV2Reference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null, AccountSettingsPageReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null, MembershipRenewalV2Page?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null, CompanyAdminDashboardPage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null, LearnLandingPage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null, AdminDashboardPage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock', RelativePath?: string | null } | { __typename?: 'AccordionContainerBlock', RelativePath?: string | null } | { __typename?: 'AccordionItemBlock', RelativePath?: string | null } | { __typename?: 'AccountProfilePage', RelativePath?: string | null } | { __typename?: 'AddressInfoBlock', RelativePath?: string | null } | { __typename?: 'BadgeBlock', RelativePath?: string | null } | { __typename?: 'BrandedTableBlock', RelativePath?: string | null } | { __typename?: 'BulkImporterUploaderSectionBlock', RelativePath?: string | null } | { __typename?: 'ButtonLabelBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'CategoryListBlock', RelativePath?: string | null } | { __typename?: 'CertifyingOfficerSectionBlock', RelativePath?: string | null } | { __typename?: 'CflBadgesBlock', RelativePath?: string | null } | { __typename?: 'CflHomePage', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCardBlock', RelativePath?: string | null } | { __typename?: 'CflMembershipKitCarouselBlock', RelativePath?: string | null } | { __typename?: 'CflSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'CflSpecialResourceCardBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ColumnContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListContainerBlock', RelativePath?: string | null } | { __typename?: 'ColumnLinksListItemBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock', RelativePath?: string | null } | { __typename?: 'CompanyAdminBulkImportPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminCompanyListingsPage', RelativePath?: string | null } | { __typename?: 'CompanyAdminMembershipDirectoryPage', RelativePath?: string | null } | { __typename?: 'CompanyRankingsPage', RelativePath?: string | null } | { __typename?: 'ConfirmationModalBlock', RelativePath?: string | null } | { __typename?: 'ConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'CongratulationsStepV2Block', RelativePath?: string | null } | { __typename?: 'ContactEmailElementBlock', RelativePath?: string | null } | { __typename?: 'ContactMdrtIdElementBlock', RelativePath?: string | null } | { __typename?: 'ContactNameElementBlock', RelativePath?: string | null } | { __typename?: 'ContactPhoneElementBlock', RelativePath?: string | null } | { __typename?: 'ContactsBlock', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'DAMAsset', RelativePath?: string | null } | { __typename?: 'DAMImageAsset', RelativePath?: string | null } | { __typename?: 'DAMVideo', RelativePath?: string | null } | { __typename?: 'DAMVideoAsset', RelativePath?: string | null } | { __typename?: 'DashBoardSectionBlock', RelativePath?: string | null } | { __typename?: 'DashboardAccountPage', RelativePath?: string | null } | { __typename?: 'DashboardCarouselCardBlock', RelativePath?: string | null } | { __typename?: 'DashboardContactInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardLoginPasswordBlock', RelativePath?: string | null } | { __typename?: 'DashboardPermissionsBlock', RelativePath?: string | null } | { __typename?: 'DashboardPersonalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfessionalInformationBlock', RelativePath?: string | null } | { __typename?: 'DashboardProfileBlock', RelativePath?: string | null } | { __typename?: 'DashboardSharedPage', RelativePath?: string | null } | { __typename?: 'DashboardSitePreferencesBlock', RelativePath?: string | null } | { __typename?: 'DataMismatchModalBlock', RelativePath?: string | null } | { __typename?: 'DeleteCertifyinLetterModalBlock', RelativePath?: string | null } | { __typename?: 'DescriptionButtonBlock', RelativePath?: string | null } | { __typename?: 'DetailPage', RelativePath?: string | null } | { __typename?: 'DocumentMedia', RelativePath?: string | null } | { __typename?: 'DonationBlock', RelativePath?: string | null } | { __typename?: 'DownloadUploadSectionBlock', RelativePath?: string | null } | { __typename?: 'EEPSectionBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselQuoteSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPCarouselSlideBlock', RelativePath?: string | null } | { __typename?: 'EVPContentBlock', RelativePath?: string | null } | { __typename?: 'EVPFeaturedResourcesBlock', RelativePath?: string | null } | { __typename?: 'EVPGenericPage', RelativePath?: string | null } | { __typename?: 'EVPHeroQuoteBlock', RelativePath?: string | null } | { __typename?: 'EVPHomePage', RelativePath?: string | null } | { __typename?: 'EVPImageBlock', RelativePath?: string | null } | { __typename?: 'EVPImageLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPLanguageSelectorBlock', RelativePath?: string | null } | { __typename?: 'EVPLinkBlock', RelativePath?: string | null } | { __typename?: 'EVPMediaFileBlock', RelativePath?: string | null } | { __typename?: 'EVPNavigationPageBlock', RelativePath?: string | null } | { __typename?: 'EVPPartnerSettingsBlock', RelativePath?: string | null } | { __typename?: 'EVPResourcePage', RelativePath?: string | null } | { __typename?: 'EVPSearchHeaderBlock', RelativePath?: string | null } | { __typename?: 'EVPSearchPage', RelativePath?: string | null } | { __typename?: 'EVPSiteSettingsPage', RelativePath?: string | null } | { __typename?: 'EVPTabBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardBlock', RelativePath?: string | null } | { __typename?: 'EVPTabCardsBlock', RelativePath?: string | null } | { __typename?: 'EVPTabImageTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabRichTextBlock', RelativePath?: string | null } | { __typename?: 'EVPTabVideoBlock', RelativePath?: string | null } | { __typename?: 'EVPTabsBlock', RelativePath?: string | null } | { __typename?: 'EVPTextImageBlock', RelativePath?: string | null } | { __typename?: 'EVPVideoBlock', RelativePath?: string | null } | { __typename?: 'EmployeeTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'ErrorModalBlock', RelativePath?: string | null } | { __typename?: 'ErrorPage', RelativePath?: string | null } | { __typename?: 'ErrorPageBlock', RelativePath?: string | null } | { __typename?: 'EventBlock', RelativePath?: string | null } | { __typename?: 'EventLocationAndDateBlock', RelativePath?: string | null } | { __typename?: 'EventLocationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventPage', RelativePath?: string | null } | { __typename?: 'EventRegistrationInformationBlock', RelativePath?: string | null } | { __typename?: 'EventSessionBlock', RelativePath?: string | null } | { __typename?: 'EventSessionScheduleBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackBlock', RelativePath?: string | null } | { __typename?: 'EventSessionTrackSpeakerBlock', RelativePath?: string | null } | { __typename?: 'EventSpeakerSearchPage', RelativePath?: string | null } | { __typename?: 'EventSpeakersBlock', RelativePath?: string | null } | { __typename?: 'EventTableContainerBlock', RelativePath?: string | null } | { __typename?: 'ExpandableContainerBlock', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FlowFinishInformationBlock', RelativePath?: string | null } | { __typename?: 'FolderPage', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'FourColumnTableBlock', RelativePath?: string | null } | { __typename?: 'GaugeBlock', RelativePath?: string | null } | { __typename?: 'GeoDataBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GettingStartedStepV2Block', RelativePath?: string | null } | { __typename?: 'GreetingCaseBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GreetingStepV2Block', RelativePath?: string | null } | { __typename?: 'GsAwardsApplicationsBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsFileUploadBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsMembershipStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsPage', RelativePath?: string | null } | { __typename?: 'GsAwardsPersistencyStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsProductionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRecruitmentStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsRetentionStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSelectApplicantStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsSubmitStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsVerificationStepBlock', RelativePath?: string | null } | { __typename?: 'GsAwardsWholePersonStepBlock', RelativePath?: string | null } | { __typename?: 'GsConfirmationStepBlock', RelativePath?: string | null } | { __typename?: 'GsGettingStartedStepBlock', RelativePath?: string | null } | { __typename?: 'GsGreetingStepBlock', RelativePath?: string | null } | { __typename?: 'GsLeadershipInformationStepBlock', RelativePath?: string | null } | { __typename?: 'GsMembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'GsProfileStepBlock', RelativePath?: string | null } | { __typename?: 'GsReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'GsReviewStepBlock', RelativePath?: string | null } | { __typename?: 'HealthPoliciesSectionBlock', RelativePath?: string | null } | { __typename?: 'HeroTextContentBlock', RelativePath?: string | null } | { __typename?: 'HomePage', RelativePath?: string | null } | { __typename?: 'HomePageV2', RelativePath?: string | null } | { __typename?: 'IconRequirementBlock', RelativePath?: string | null } | { __typename?: 'Image', RelativePath?: string | null } | { __typename?: 'ImageBlock', RelativePath?: string | null } | { __typename?: 'ImageCaptionRichTextBlock', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'ImageLinkBlock', RelativePath?: string | null } | { __typename?: 'ImageMedia', RelativePath?: string | null } | { __typename?: 'ImageTextBlock', RelativePath?: string | null } | { __typename?: 'ImageTextBlockV2', RelativePath?: string | null } | { __typename?: 'ImageTextCardBlock', RelativePath?: string | null } | { __typename?: 'ImageTextItemBlock', RelativePath?: string | null } | { __typename?: 'InfoBoxBlock', RelativePath?: string | null } | { __typename?: 'KeyLinkValueBlock', RelativePath?: string | null } | { __typename?: 'KeyTranslatedValueBlock', RelativePath?: string | null } | { __typename?: 'LandingPage', RelativePath?: string | null } | { __typename?: 'LanguageIdAndName', RelativePath?: string | null } | { __typename?: 'LanguagesBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlock', RelativePath?: string | null } | { __typename?: 'LearnCarouselContainerBlockV2', RelativePath?: string | null } | { __typename?: 'LearnDetailPage', RelativePath?: string | null } | { __typename?: 'LearnHeroImageBlock', RelativePath?: string | null } | { __typename?: 'LearnLandingPage', RelativePath?: string | null } | { __typename?: 'LearnPageV2', RelativePath?: string | null } | { __typename?: 'LearnPlayListPage', RelativePath?: string | null } | { __typename?: 'LikeAndBookmarkBlock', RelativePath?: string | null } | { __typename?: 'LinkBlock', RelativePath?: string | null } | { __typename?: 'LinkListBlock', RelativePath?: string | null } | { __typename?: 'LinkTileBlock', RelativePath?: string | null } | { __typename?: 'LoaderBlock', RelativePath?: string | null } | { __typename?: 'LocationBlock', RelativePath?: string | null } | { __typename?: 'MeetingEventCardPage', RelativePath?: string | null } | { __typename?: 'MeetingPage', RelativePath?: string | null } | { __typename?: 'MemberDirectory', RelativePath?: string | null } | { __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | { __typename?: 'MemberSectionBlock', RelativePath?: string | null } | { __typename?: 'MembersTableHeaderLabelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailBlock', RelativePath?: string | null } | { __typename?: 'MembershipHistoryDetailPage', RelativePath?: string | null } | { __typename?: 'MembershipInvoicePage', RelativePath?: string | null } | { __typename?: 'MembershipLevelBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelRadioBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipLevelStepV2Block', RelativePath?: string | null } | { __typename?: 'MembershipLevelsBlock', RelativePath?: string | null } | { __typename?: 'MembershipRenewalPage', RelativePath?: string | null } | { __typename?: 'MembershipRenewalV2Page', RelativePath?: string | null } | { __typename?: 'MembershipRequirementBlock', RelativePath?: string | null } | { __typename?: 'MembershipRequirementsBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeSectionBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepBlock', RelativePath?: string | null } | { __typename?: 'MembershipTypeStepV2Block', RelativePath?: string | null } | { __typename?: 'ModalInfoBlock', RelativePath?: string | null } | { __typename?: 'NewIDRequestSectionBlock', RelativePath?: string | null } | { __typename?: 'NextCallOutBlock', RelativePath?: string | null } | { __typename?: 'NextContactUsBlock', RelativePath?: string | null } | { __typename?: 'NextContainerBlock', RelativePath?: string | null } | { __typename?: 'NextDeadLetterQueueBlock', RelativePath?: string | null } | { __typename?: 'NextEventBlock', RelativePath?: string | null } | { __typename?: 'NextHeroBlock', RelativePath?: string | null } | { __typename?: 'NextInfoBoxBlock', RelativePath?: string | null } | { __typename?: 'NextPersonContainerBlock', RelativePath?: string | null } | { __typename?: 'NextPersonDataBlock', RelativePath?: string | null } | { __typename?: 'NextStaffAdminPage', RelativePath?: string | null } | { __typename?: 'NextStaticPage', RelativePath?: string | null } | { __typename?: 'NextSyncEventsBlock', RelativePath?: string | null } | { __typename?: 'NotFoundPage', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'NumberedContainerBlock', RelativePath?: string | null } | { __typename?: 'NumberedItemBlock', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PastPresidentsBlock', RelativePath?: string | null } | { __typename?: 'PaymentProcessingScreenBlock', RelativePath?: string | null } | { __typename?: 'PersonBlock', RelativePath?: string | null } | { __typename?: 'PersonContainerBlock', RelativePath?: string | null } | { __typename?: 'PersonQuizPage', RelativePath?: string | null } | { __typename?: 'PersonUpdatesSectionBlock', RelativePath?: string | null } | { __typename?: 'PlaylistBlock', RelativePath?: string | null } | { __typename?: 'PlaylistPromoBlock', RelativePath?: string | null } | { __typename?: 'PodcastDetailBlock', RelativePath?: string | null } | { __typename?: 'PowerPhrasePage', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorModalBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentErrorPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentGenericErrorBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageGsBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentHomepageMdrtBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentLoaderScreenBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipInfoPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPaymentStatusPageBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentPortalPage', RelativePath?: string | null } | { __typename?: 'PrepaymentProductNamesBlock', RelativePath?: string | null } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock', RelativePath?: string | null } | { __typename?: 'PressReleasePage', RelativePath?: string | null } | { __typename?: 'PriceBreakdownBlock', RelativePath?: string | null } | { __typename?: 'ProductionAttestmentNumbersBlock', RelativePath?: string | null } | { __typename?: 'ProductionDataSectionBlock', RelativePath?: string | null } | { __typename?: 'ProductionDeleteModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionModalBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepBlock', RelativePath?: string | null } | { __typename?: 'ProductionStepV2Block', RelativePath?: string | null } | { __typename?: 'ProductionTableBlock', RelativePath?: string | null } | { __typename?: 'ProfileListBlock', RelativePath?: string | null } | { __typename?: 'ProfilePictureBlock', RelativePath?: string | null } | { __typename?: 'ProfileSectionBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepBlock', RelativePath?: string | null } | { __typename?: 'ProfileStepV2Block', RelativePath?: string | null } | { __typename?: 'PublicProfilePage', RelativePath?: string | null } | { __typename?: 'QuizCareerBlock', RelativePath?: string | null } | { __typename?: 'QuizEducationBlock', RelativePath?: string | null } | { __typename?: 'QuizFinancialBlock', RelativePath?: string | null } | { __typename?: 'QuizHealthBlock', RelativePath?: string | null } | { __typename?: 'QuizRelationshipsBlock', RelativePath?: string | null } | { __typename?: 'QuizServiceBlock', RelativePath?: string | null } | { __typename?: 'QuizSpiritualBlock', RelativePath?: string | null } | { __typename?: 'RTContributorFormPage', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepBlock', RelativePath?: string | null } | { __typename?: 'ReceiptStepV2Block', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ReviewAndSubmitStepV2Block', RelativePath?: string | null } | { __typename?: 'ReviewBlock', RelativePath?: string | null } | { __typename?: 'ReviewStepBlock', RelativePath?: string | null } | { __typename?: 'RichTextBlock', RelativePath?: string | null } | { __typename?: 'RoutingStepBlock', RelativePath?: string | null } | { __typename?: 'SearchPage', RelativePath?: string | null } | { __typename?: 'SearchPageV2', RelativePath?: string | null } | { __typename?: 'SectionContainerBlock', RelativePath?: string | null } | { __typename?: 'SectionItemBlock', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SelfAttestLevelOptionsBlock', RelativePath?: string | null } | { __typename?: 'SettingSectionBlock', RelativePath?: string | null } | { __typename?: 'SiteSettingsPage', RelativePath?: string | null } | { __typename?: 'SocialShareBlock', RelativePath?: string | null } | { __typename?: 'SpeakerEngagementPage', RelativePath?: string | null } | { __typename?: 'SponsorSpeakerPage', RelativePath?: string | null } | { __typename?: 'SpotlightBlock', RelativePath?: string | null } | { __typename?: 'SpotlightContainerBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataBlock', RelativePath?: string | null } | { __typename?: 'SpotlightDataContainerBlock', RelativePath?: string | null } | { __typename?: 'StoreCardPage', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SuccessSectionBlock', RelativePath?: string | null } | { __typename?: 'SvgLinkBlock', RelativePath?: string | null } | { __typename?: 'SvgMedia', RelativePath?: string | null } | { __typename?: 'SvgTextCardBlock', RelativePath?: string | null } | { __typename?: 'TabContainerBlock', RelativePath?: string | null } | { __typename?: 'TabItemBlock', RelativePath?: string | null } | { __typename?: 'TextCardBlock', RelativePath?: string | null } | { __typename?: 'TextContentBlock', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'TimelineContainerBlock', RelativePath?: string | null } | { __typename?: 'TimelineItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitBlock', RelativePath?: string | null } | { __typename?: 'ToolkitItemBlock', RelativePath?: string | null } | { __typename?: 'ToolkitSectionBlock', RelativePath?: string | null } | { __typename?: 'ToolsCardPage', RelativePath?: string | null } | { __typename?: 'TooltipBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'Video', RelativePath?: string | null } | { __typename?: 'VideoBlock', RelativePath?: string | null } | { __typename?: 'VideoDetailBlock', RelativePath?: string | null } | { __typename?: 'VideoMedia', RelativePath?: string | null } | { __typename?: 'VideoPromoBlock', RelativePath?: string | null } | { __typename?: 'VisaLettersPage', RelativePath?: string | null } | { __typename?: 'VisibilityOptionsBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WireTransferSectionBlock', RelativePath?: string | null } | { __typename?: 'YourAnswersSectionBlock', RelativePath?: string | null } | null } | null } | null> | null } | null, HomePageV2?: { __typename?: 'HomePageV2Output', items?: Array<{ __typename?: 'HomePageV2', RelativePath?: string | null } | null> | null } | null, PersonQuizPage?: { __typename?: 'PersonQuizPageOutput', items?: Array<{ __typename?: 'PersonQuizPage', RelativePath?: string | null } | null> | null } | null, MemberDirectoryPage?: { __typename?: 'MemberDirectoryPageOutput', items?: Array<{ __typename?: 'MemberDirectoryPage', RelativePath?: string | null } | null> | null } | null, PublicProfilePage?: { __typename?: 'PublicProfilePageOutput', items?: Array<{ __typename?: 'PublicProfilePage', RelativePath?: string | null } | null> | null } | null };

export type SiteLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteLanguagesQuery = { __typename?: 'Query', SiteDefinition?: { __typename?: 'SiteDefinitionOutput', items?: Array<{ __typename?: 'SiteDefinition', Languages?: Array<{ __typename?: 'SiteDefinitionLanguageModel', Name?: string | null, DisplayName?: string | null, UrlSegment?: string | null, IsMasterLanguage?: any | null } | null> | null } | null> | null } | null };

export type SiteSettingsCategoryAndSourceRootsQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteSettingsCategoryAndSourceRootsQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', TopicsCategoryRoot?: { __typename?: 'ContentModelReference', Id?: number | null } | null, ContentSourceCategoryRoot?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null> | null } | null };

export type SiteSettingsGlobalContentQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteSettingsGlobalContentQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', Close?: string | null, DateSavedSuccessfully?: string | null, Optional?: string | null, NoResultsLabel?: string | null, NoLabel?: string | null, YesLabel?: string | null, Url?: string | null, RelativePath?: string | null, GoBackToHomepage?: string | null, BackLabel?: string | null, BackAriaLabel?: string | null, LoginLinkLabel?: string | null, LogoutLine?: string | null, DefaultRouteTitle?: string | null, LeavingConfirmMessage?: string | null, AppDescription?: string | null, CarouselNextButtonLabel?: string | null, CarouselPreviousButtonLabel?: string | null, ToastSomethingWentWrong?: string | null, NextPageLabel?: string | null, PreviousPageLabel?: string | null, TotalItemsCountLabel?: string | null, Pagination?: string | null, DownloadLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null, ErrorPage?: { __typename?: 'ErrorPageOutput', items?: Array<{ __typename?: 'ErrorPage', Title?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null, NotFoundPage?: { __typename?: 'NotFoundPageOutput', items?: Array<{ __typename?: 'NotFoundPage', Title?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type StaticPageQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type StaticPageQuery = { __typename?: 'Query', NextStaticPage?: { __typename?: 'NextStaticPageOutput', items?: Array<{ __typename?: 'NextStaticPage', Name?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MainContent?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename: 'AccordionContainerBlock', Name?: string | null, Description?: string | null, Subheading?: string | null, AnchorLink?: string | null, AccordionItemBlock?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock', Subheading?: string | null, Description?: string | null } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename: 'ImageTextBlock', AccessGroup?: string | null, AnchorLink?: string | null, ReverseContent?: any | null, Theme?: string | null, Seperator?: string | null, Image?: { __typename?: 'ImageTextBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, TextContent?: { __typename?: 'ImageTextBlockTextContentBlock', PreHeading?: string | null, Heading?: string | null, SubHeading?: string | null, Description?: string | null } | null, CallToActionLinks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename: 'LearnCarouselContainerBlockV2', Type?: string | null, Heading?: string | null, SourcesFilterAllSelectionLabel?: string | null, ShowSourcesFilter?: any | null, ShowMagazineIssueFilter?: any | null, SelectedSources?: Array<{ __typename?: 'ContentModelReference', Id?: number | null } | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, ExpandedSelectedSources?: Array<{ __typename?: 'SourcesEntry', Id?: number | null, Name?: string | null } | null> | null, ExpandedSelectedTopics?: Array<{ __typename?: 'TopicsEntry', Id?: number | null, Name?: string | null } | null> | null } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename: 'MembershipRequirementsBlock', ProductionRequirementsAnchorLink?: string | null, CertifyingLettersAnchorLink?: string | null, EthicalCodeAnchorLink?: string | null, MembershipDuesAnchorLink?: string | null, EthicalCodeDescription?: string | null, EthicalCodeStepLabel?: string | null, CertifyingLettersStepLabel?: string | null, CertifyingLettersDescription?: string | null, RelativePath?: string | null, RouteSegment?: string | null, MembershipDuesDescription?: string | null, MembershipDuesStepLabel?: string | null, MembershipTableCoTHeading?: string | null, MembershipTableCommissionRowHeading?: string | null, MembershipTableIncomeRowHeading?: string | null, MembershipTableMemberHeading?: string | null, MembershipTableName?: string | null, MembershipTablePremiumRowHeading?: string | null, MembershipTableToTHeading?: string | null, MonthlyGoalChartsLinkText?: string | null, Name?: string | null, ViewMembershipRequirementsLabel?: string | null, ProductionRequirementsMonthlyGoalDescription?: string | null, ProductionRequirementsStepLabel?: string | null, ProfessionalAssociationsDescription?: string | null, ProfessionalAssociationsStepLabel?: string | null, ConversionFactorsStepLabel?: string | null, MonthlyGoalStepName?: string | null, ProductionApiErrorLabel?: string | null, NoRequirementsLabel?: string | null, CertifyingLettersFindOfficerLink?: { __typename?: 'MembershipRequirementsBlockLinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, DownloadFileName?: string | null, ShouldDownload?: any | null } | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, MembershipRequirementBlocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock', CoTDues?: number | null, GenericProductionFooterText?: string | null, MemberDues?: number | null, SpecificProductionFooterText?: string | null, ToTDues?: number | null, Date?: any | null, ConversionFactorsDescription?: string | null, DownloadRequirementsLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, IncomeCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCoreDownloadRequirementsLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCoreIncomeCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, NonCorePremiumAndCommissionCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, PremiumAndCommissionCertifyingLetters?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, ConversionFactorsDownloadLink?: { __typename?: 'MembershipRequirementBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null, MonthlyGoalCharts?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock', Key?: string | null, Name?: string | null, Value?: { __typename?: 'KeyLinkValueBlockLinkBlock', DisplayText?: string | null, DownloadFileName?: string | null, LinkStyle?: string | null, LinkToContent?: string | null, ShouldDownload?: any | null, Target?: string | null } | null } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, Contacts?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock', Email?: string | null, FaxNumber?: string | null, PhoneNumber?: string | null, RegionTitle?: string | null } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename: 'NextCallOutBlock', Name?: string | null, AnchorLink?: string | null, Heading?: string | null, SubHeading?: string | null, AccessGroup?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, CallOutLinkBlock?: { __typename?: 'NextCallOutBlockLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, LinkStyle?: string | null, Target?: string | null, ShouldDownload?: any | null } | null } | { __typename: 'NextContactUsBlock', ContactUsText?: string | null, AnchorLink?: string | null } | { __typename: 'NextContainerBlock', AccessGroup?: string | null, Name?: string | null, AnchorLink?: string | null, Heading?: string | null, SubHeading?: string | null, Description?: string | null, Seperator?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Items?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename: 'ImageBlock', AltText?: string | null, _concreteType?: string | null, ImageSize?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename: 'ImageTextCardBlock', Description?: string | null, Heading?: string | null, SubHeading?: string | null, _concreteType?: string | null, ImageSize?: string | null, Image?: { __typename?: 'ImageTextCardBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, LinkBlock?: { __typename?: 'ImageTextCardBlockLinkBlock', DisplayText?: string | null, LinkToContent?: string | null, Target?: string | null, LinkStyle?: string | null } | null } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename: 'NextEventBlock', AnchorLink?: string | null, EventDescription?: string | null, EventHeading?: string | null, EventLocation?: string | null, NextEventLocation?: string | null, EventDateFrom?: any | null, EventDateTo?: any | null, NextEventDateFrom?: any | null, NextEventDateTo?: any | null, ReversedContent?: any | null, ShowOnlyForEdgeAccessGroupMembers?: any | null, EventImageBlock?: { __typename?: 'NextEventBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, EventLinkBlock?: { __typename?: 'NextEventBlockLinkBlock', LinkToContent?: string | null, Target?: string | null } | null } | { __typename: 'NextHeroBlock', AccessGroup?: string | null, Name?: string | null, AnchorLink?: string | null, HeroHeading?: string | null, HeroDescription?: string | null, HeroTheme?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, HeroImageBlocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename: 'ImageBlock', AltText?: string | null, _concreteType?: string | null, ImageSize?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, HeroLinkBlocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', GuidValue?: string | null, Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null, HeroCtaButtons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename: 'LinkBlock', LinkToContent?: string | null, DisplayText?: string | null, Target?: string | null, LinkStyle?: string | null, ShouldDownload?: any | null, DownloadFileName?: string | null } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'NextInfoBoxBlock' } | { __typename: 'NextPersonContainerBlock', ProfileList?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock', Name?: string | null, Title?: string | null, Description?: string | null, MemberYears?: string | null, Country?: string | null, EmailAddress?: string | null, City?: string | null, Image?: { __typename?: 'PersonBlockImageBlock', AltText?: string | null, ImageReference?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null } | null } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename: 'PastPresidentsBlock', PastPresidentsTableReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock', Footer?: string | null, TextContent?: { __typename?: 'FourColumnTableBlockTextContentBlock', Heading?: string | null } | null, Rows?: Array<{ __typename?: 'RowContent', ColumnOne?: string | null, ColumnTwo?: string | null, ColumnThree?: string | null, ColumnFour?: string | null } | null> | null } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename?: 'LanguageIdAndName' } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename: 'RichTextBlock', AnchorLink?: string | null, Name?: string | null, Content?: string | null, AnchorLabel?: string | null, Heading?: string | null, Seperator?: string | null } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null, SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', CountryLabel?: string | null, YearLabel?: string | null, StaticPagesEventThisYearLabel?: string | null, StaticPagesEventNextEventLabel?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null } | null> | null } | null };

export type TopicFacetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LearnDetailPageWhereInput>;
}>;


export type TopicFacetsQuery = { __typename?: 'Query', LearnDetailPage?: { __typename?: 'LearnDetailPageOutput', facets?: { __typename?: 'LearnDetailPageFacet', ExpandedTopics?: { __typename?: 'ExpandedTopicsEntryFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null } | null };

export type TopicIdNameFacetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LearnDetailPageWhereInput>;
}>;


export type TopicIdNameFacetsQuery = { __typename?: 'Query', LearnDetailPage?: { __typename?: 'LearnDetailPageOutput', facets?: { __typename?: 'LearnDetailPageFacet', ExpandedTopics?: { __typename?: 'ExpandedTopicsEntryFacet', IdName?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null } | null };

export type LanguagesContentQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguagesContentQuery = { __typename?: 'Query', SiteSettingsPage?: { __typename?: 'SiteSettingsPageOutput', items?: Array<{ __typename?: 'SiteSettingsPage', SelectLanguage?: string | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, LanguageIdsAndNames?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'AMPSectionBlock' } | { __typename?: 'AccordionContainerBlock' } | { __typename?: 'AccordionItemBlock' } | { __typename?: 'AccountProfilePage' } | { __typename?: 'AddressInfoBlock' } | { __typename?: 'BadgeBlock' } | { __typename?: 'BrandedTableBlock' } | { __typename?: 'BulkImporterUploaderSectionBlock' } | { __typename?: 'ButtonLabelBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'CategoryListBlock' } | { __typename?: 'CertifyingOfficerSectionBlock' } | { __typename?: 'CflBadgesBlock' } | { __typename?: 'CflHomePage' } | { __typename?: 'CflMembershipKitCardBlock' } | { __typename?: 'CflMembershipKitCarouselBlock' } | { __typename?: 'CflSiteSettingsPage' } | { __typename?: 'CflSpecialResourceCardBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'ColumnContainerBlock' } | { __typename?: 'ColumnLinksListContainerBlock' } | { __typename?: 'ColumnLinksListItemBlock' } | { __typename?: 'CompanyAdminBulkImportDashboardSectionBlock' } | { __typename?: 'CompanyAdminBulkImportGettingStartedSectionBlock' } | { __typename?: 'CompanyAdminBulkImportPage' } | { __typename?: 'CompanyAdminCompanyListingsPage' } | { __typename?: 'CompanyAdminMembershipDirectoryPage' } | { __typename?: 'CompanyRankingsPage' } | { __typename?: 'ConfirmationModalBlock' } | { __typename?: 'ConfirmationStepBlock' } | { __typename?: 'CongratulationsStepV2Block' } | { __typename?: 'ContactEmailElementBlock' } | { __typename?: 'ContactMdrtIdElementBlock' } | { __typename?: 'ContactNameElementBlock' } | { __typename?: 'ContactPhoneElementBlock' } | { __typename?: 'ContactsBlock' } | { __typename?: 'Content' } | { __typename?: 'DAMAsset' } | { __typename?: 'DAMImageAsset' } | { __typename?: 'DAMVideo' } | { __typename?: 'DAMVideoAsset' } | { __typename?: 'DashBoardSectionBlock' } | { __typename?: 'DashboardAccountPage' } | { __typename?: 'DashboardCarouselCardBlock' } | { __typename?: 'DashboardContactInformationBlock' } | { __typename?: 'DashboardLoginPasswordBlock' } | { __typename?: 'DashboardPermissionsBlock' } | { __typename?: 'DashboardPersonalInformationBlock' } | { __typename?: 'DashboardProfessionalInformationBlock' } | { __typename?: 'DashboardProfileBlock' } | { __typename?: 'DashboardSharedPage' } | { __typename?: 'DashboardSitePreferencesBlock' } | { __typename?: 'DataMismatchModalBlock' } | { __typename?: 'DeleteCertifyinLetterModalBlock' } | { __typename?: 'DescriptionButtonBlock' } | { __typename?: 'DetailPage' } | { __typename?: 'DocumentMedia' } | { __typename?: 'DonationBlock' } | { __typename?: 'DownloadUploadSectionBlock' } | { __typename?: 'EEPSectionBlock' } | { __typename?: 'EVPCarouselBlock' } | { __typename?: 'EVPCarouselQuoteBlock' } | { __typename?: 'EVPCarouselQuoteSlideBlock' } | { __typename?: 'EVPCarouselSlideBlock' } | { __typename?: 'EVPContentBlock' } | { __typename?: 'EVPFeaturedResourcesBlock' } | { __typename?: 'EVPGenericPage' } | { __typename?: 'EVPHeroQuoteBlock' } | { __typename?: 'EVPHomePage' } | { __typename?: 'EVPImageBlock' } | { __typename?: 'EVPImageLinkBlock' } | { __typename?: 'EVPLanguageSelectorBlock' } | { __typename?: 'EVPLinkBlock' } | { __typename?: 'EVPMediaFileBlock' } | { __typename?: 'EVPNavigationPageBlock' } | { __typename?: 'EVPPartnerSettingsBlock' } | { __typename?: 'EVPResourcePage' } | { __typename?: 'EVPSearchHeaderBlock' } | { __typename?: 'EVPSearchPage' } | { __typename?: 'EVPSiteSettingsPage' } | { __typename?: 'EVPTabBlock' } | { __typename?: 'EVPTabCardBlock' } | { __typename?: 'EVPTabCardsBlock' } | { __typename?: 'EVPTabImageTextBlock' } | { __typename?: 'EVPTabRichTextBlock' } | { __typename?: 'EVPTabVideoBlock' } | { __typename?: 'EVPTabsBlock' } | { __typename?: 'EVPTextImageBlock' } | { __typename?: 'EVPVideoBlock' } | { __typename?: 'EmployeeTableHeaderLabelsBlock' } | { __typename?: 'ErrorModalBlock' } | { __typename?: 'ErrorPage' } | { __typename?: 'ErrorPageBlock' } | { __typename?: 'EventBlock' } | { __typename?: 'EventLocationAndDateBlock' } | { __typename?: 'EventLocationInformationBlock' } | { __typename?: 'EventPage' } | { __typename?: 'EventRegistrationInformationBlock' } | { __typename?: 'EventSessionBlock' } | { __typename?: 'EventSessionScheduleBlock' } | { __typename?: 'EventSessionTrackBlock' } | { __typename?: 'EventSessionTrackSpeakerBlock' } | { __typename?: 'EventSpeakerSearchPage' } | { __typename?: 'EventSpeakersBlock' } | { __typename?: 'EventTableContainerBlock' } | { __typename?: 'ExpandableContainerBlock' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FlowFinishInformationBlock' } | { __typename?: 'FolderPage' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'FourColumnTableBlock' } | { __typename?: 'GaugeBlock' } | { __typename?: 'GeoDataBlock' } | { __typename?: 'GettingStartedStepBlock' } | { __typename?: 'GettingStartedStepV2Block' } | { __typename?: 'GreetingCaseBlock' } | { __typename?: 'GreetingStepBlock' } | { __typename?: 'GreetingStepV2Block' } | { __typename?: 'GsAwardsApplicationsBlock' } | { __typename?: 'GsAwardsConfirmationStepBlock' } | { __typename?: 'GsAwardsFileUploadBlock' } | { __typename?: 'GsAwardsGettingStartedStepBlock' } | { __typename?: 'GsAwardsMembershipStepBlock' } | { __typename?: 'GsAwardsPage' } | { __typename?: 'GsAwardsPersistencyStepBlock' } | { __typename?: 'GsAwardsProductionStepBlock' } | { __typename?: 'GsAwardsRecruitmentStepBlock' } | { __typename?: 'GsAwardsRetentionStepBlock' } | { __typename?: 'GsAwardsSelectApplicantStepBlock' } | { __typename?: 'GsAwardsSubmitStepBlock' } | { __typename?: 'GsAwardsVerificationStepBlock' } | { __typename?: 'GsAwardsWholePersonStepBlock' } | { __typename?: 'GsConfirmationStepBlock' } | { __typename?: 'GsGettingStartedStepBlock' } | { __typename?: 'GsGreetingStepBlock' } | { __typename?: 'GsLeadershipInformationStepBlock' } | { __typename?: 'GsMembershipRenewalPage' } | { __typename?: 'GsProfileStepBlock' } | { __typename?: 'GsReceiptStepBlock' } | { __typename?: 'GsReviewStepBlock' } | { __typename?: 'HealthPoliciesSectionBlock' } | { __typename?: 'HeroTextContentBlock' } | { __typename?: 'HomePage' } | { __typename?: 'HomePageV2' } | { __typename?: 'IconRequirementBlock' } | { __typename?: 'Image' } | { __typename?: 'ImageBlock' } | { __typename?: 'ImageCaptionRichTextBlock' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'ImageLinkBlock' } | { __typename?: 'ImageMedia' } | { __typename?: 'ImageTextBlock' } | { __typename?: 'ImageTextBlockV2' } | { __typename?: 'ImageTextCardBlock' } | { __typename?: 'ImageTextItemBlock' } | { __typename?: 'InfoBoxBlock' } | { __typename?: 'KeyLinkValueBlock' } | { __typename?: 'KeyTranslatedValueBlock' } | { __typename?: 'LandingPage' } | { __typename: 'LanguageIdAndName', LanguageId?: string | null, LanguageName?: string | null } | { __typename?: 'LanguagesBlock' } | { __typename?: 'LearnCarouselContainerBlock' } | { __typename?: 'LearnCarouselContainerBlockV2' } | { __typename?: 'LearnDetailPage' } | { __typename?: 'LearnHeroImageBlock' } | { __typename?: 'LearnLandingPage' } | { __typename?: 'LearnPageV2' } | { __typename?: 'LearnPlayListPage' } | { __typename?: 'LikeAndBookmarkBlock' } | { __typename?: 'LinkBlock' } | { __typename?: 'LinkListBlock' } | { __typename?: 'LinkTileBlock' } | { __typename?: 'LoaderBlock' } | { __typename?: 'LocationBlock' } | { __typename?: 'MeetingEventCardPage' } | { __typename?: 'MeetingPage' } | { __typename?: 'MemberDirectory' } | { __typename?: 'MemberDirectoryPage' } | { __typename?: 'MemberSectionBlock' } | { __typename?: 'MembersTableHeaderLabelsBlock' } | { __typename?: 'MembershipHistoryDetailBlock' } | { __typename?: 'MembershipHistoryDetailPage' } | { __typename?: 'MembershipInvoicePage' } | { __typename?: 'MembershipLevelBlock' } | { __typename?: 'MembershipLevelRadioBlock' } | { __typename?: 'MembershipLevelSectionBlock' } | { __typename?: 'MembershipLevelStepV2Block' } | { __typename?: 'MembershipLevelsBlock' } | { __typename?: 'MembershipRenewalPage' } | { __typename?: 'MembershipRenewalV2Page' } | { __typename?: 'MembershipRequirementBlock' } | { __typename?: 'MembershipRequirementsBlock' } | { __typename?: 'MembershipTypeSectionBlock' } | { __typename?: 'MembershipTypeStepBlock' } | { __typename?: 'MembershipTypeStepV2Block' } | { __typename?: 'ModalInfoBlock' } | { __typename?: 'NewIDRequestSectionBlock' } | { __typename?: 'NextCallOutBlock' } | { __typename?: 'NextContactUsBlock' } | { __typename?: 'NextContainerBlock' } | { __typename?: 'NextDeadLetterQueueBlock' } | { __typename?: 'NextEventBlock' } | { __typename?: 'NextHeroBlock' } | { __typename?: 'NextInfoBoxBlock' } | { __typename?: 'NextPersonContainerBlock' } | { __typename?: 'NextPersonDataBlock' } | { __typename?: 'NextStaffAdminPage' } | { __typename?: 'NextStaticPage' } | { __typename?: 'NextSyncEventsBlock' } | { __typename?: 'NotFoundPage' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'NumberedContainerBlock' } | { __typename?: 'NumberedItemBlock' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PastPresidentsBlock' } | { __typename?: 'PaymentProcessingScreenBlock' } | { __typename?: 'PersonBlock' } | { __typename?: 'PersonContainerBlock' } | { __typename?: 'PersonQuizPage' } | { __typename?: 'PersonUpdatesSectionBlock' } | { __typename?: 'PlaylistBlock' } | { __typename?: 'PlaylistPromoBlock' } | { __typename?: 'PodcastDetailBlock' } | { __typename?: 'PowerPhrasePage' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrepaymentErrorModalBlock' } | { __typename?: 'PrepaymentErrorPageBlock' } | { __typename?: 'PrepaymentGenericErrorBlock' } | { __typename?: 'PrepaymentHomepageBlock' } | { __typename?: 'PrepaymentHomepageFellowsDesignationBlock' } | { __typename?: 'PrepaymentHomepageGsBlock' } | { __typename?: 'PrepaymentHomepageMdrtBlock' } | { __typename?: 'PrepaymentLoaderScreenBlock' } | { __typename?: 'PrepaymentMembershipInfoCardBlock' } | { __typename?: 'PrepaymentMembershipInfoPageBlock' } | { __typename?: 'PrepaymentMembershipTypeInfoCardBlock' } | { __typename?: 'PrepaymentPaymentPageBlock' } | { __typename?: 'PrepaymentPaymentStatusPageBlock' } | { __typename?: 'PrepaymentPortalPage' } | { __typename?: 'PrepaymentProductNamesBlock' } | { __typename?: 'PrepaymentSuccessfulPaymentPageBlock' } | { __typename?: 'PressReleasePage' } | { __typename?: 'PriceBreakdownBlock' } | { __typename?: 'ProductionAttestmentNumbersBlock' } | { __typename?: 'ProductionDataSectionBlock' } | { __typename?: 'ProductionDeleteModalBlock' } | { __typename?: 'ProductionModalBlock' } | { __typename?: 'ProductionStepBlock' } | { __typename?: 'ProductionStepV2Block' } | { __typename?: 'ProductionTableBlock' } | { __typename?: 'ProfileListBlock' } | { __typename?: 'ProfilePictureBlock' } | { __typename?: 'ProfileSectionBlock' } | { __typename?: 'ProfileStepBlock' } | { __typename?: 'ProfileStepV2Block' } | { __typename?: 'PublicProfilePage' } | { __typename?: 'QuizCareerBlock' } | { __typename?: 'QuizEducationBlock' } | { __typename?: 'QuizFinancialBlock' } | { __typename?: 'QuizHealthBlock' } | { __typename?: 'QuizRelationshipsBlock' } | { __typename?: 'QuizServiceBlock' } | { __typename?: 'QuizSpiritualBlock' } | { __typename?: 'RTContributorFormPage' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'ReceiptStepBlock' } | { __typename?: 'ReceiptStepV2Block' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ReviewAndSubmitStepV2Block' } | { __typename?: 'ReviewBlock' } | { __typename?: 'ReviewStepBlock' } | { __typename?: 'RichTextBlock' } | { __typename?: 'RoutingStepBlock' } | { __typename?: 'SearchPage' } | { __typename?: 'SearchPageV2' } | { __typename?: 'SectionContainerBlock' } | { __typename?: 'SectionItemBlock' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SelfAttestLevelOptionsBlock' } | { __typename?: 'SettingSectionBlock' } | { __typename?: 'SiteSettingsPage' } | { __typename?: 'SocialShareBlock' } | { __typename?: 'SpeakerEngagementPage' } | { __typename?: 'SponsorSpeakerPage' } | { __typename?: 'SpotlightBlock' } | { __typename?: 'SpotlightContainerBlock' } | { __typename?: 'SpotlightDataBlock' } | { __typename?: 'SpotlightDataContainerBlock' } | { __typename?: 'StoreCardPage' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SuccessSectionBlock' } | { __typename?: 'SvgLinkBlock' } | { __typename?: 'SvgMedia' } | { __typename?: 'SvgTextCardBlock' } | { __typename?: 'TabContainerBlock' } | { __typename?: 'TabItemBlock' } | { __typename?: 'TextCardBlock' } | { __typename?: 'TextContentBlock' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'TimelineContainerBlock' } | { __typename?: 'TimelineItemBlock' } | { __typename?: 'ToolkitBlock' } | { __typename?: 'ToolkitItemBlock' } | { __typename?: 'ToolkitSectionBlock' } | { __typename?: 'ToolsCardPage' } | { __typename?: 'TooltipBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'Video' } | { __typename?: 'VideoBlock' } | { __typename?: 'VideoDetailBlock' } | { __typename?: 'VideoMedia' } | { __typename?: 'VideoPromoBlock' } | { __typename?: 'VisaLettersPage' } | { __typename?: 'VisibilityOptionsBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WireTransferSectionBlock' } | { __typename?: 'YourAnswersSectionBlock' } | null } | null } | null> | null } | null> | null } | null };


export const DashboardCarouselCardBlockVisibilityOptionsFragmentDoc = `
    fragment DashboardCarouselCardBlockVisibilityOptions on DashboardCarouselCardBlock {
  PreferredLanguage
  Country
  MembershipLevel
  MemberType
  CareerStage
  LearnResourceTopic
  MeetingRegistrationStatus
  FoundationDonorLevel
  TotalMemberYearsCountFrom
  TotalMemberYearsCountTo
  MeetingId
}
    `;
export const LearnCardForYouCardFragmentDoc = `
    fragment LearnCardForYouCard on LearnDetailPage {
  Language {
    Name
  }
  ContentLink {
    GuidValue
  }
  RelativePath
  ThumbnailImage {
    ImageReference {
      Url
    }
    AltText
  }
  ContentTypeSelection
  Subheading
  SubheadingText
  Heading
  ExpandedCategories {
    Name
    ParentId
    Id
  }
}
    `;
export const ToolkitItemVisibilityOptionsFragmentDoc = `
    fragment ToolkitItemVisibilityOptions on ToolkitBlock {
  PreferredLanguage
  Country
  MembershipLevel
  MemberType
  CareerStage
  LearnResourceTopic
  MeetingRegistrationStatus
  FoundationDonorLevel
  TotalMemberYearsCountFrom
  TotalMemberYearsCountTo
  MeetingId
}
    `;
export const ToolkitSectionBlockVisibilityOptionsFragmentDoc = `
    fragment ToolkitSectionBlockVisibilityOptions on ToolkitSectionBlock {
  PreferredLanguage
  Country
  MembershipLevel
  MemberType
  CareerStage
  LearnResourceTopic
  MeetingRegistrationStatus
  FoundationDonorLevel
  TotalMemberYearsCountFrom
  TotalMemberYearsCountTo
  MeetingId
}
    `;
export const LearnCarouselBlockFragmentDoc = `
    fragment LearnCarouselBlock on LearnCarouselContainerBlockV2 {
  __typename
  Type
  Heading
  SourcesFilterAllSelectionLabel
  ShowSourcesFilter
  ShowMagazineIssueFilter
  SelectedSources {
    Id
  }
  ContentLink {
    GuidValue
  }
  Language {
    Name
  }
  ExpandedSelectedSources {
    Id
    Name
  }
  ExpandedSelectedTopics {
    Id
    Name
  }
}
    `;
export const ProfileListLinkFragmentDoc = `
    fragment ProfileListLink on ProfileListBlock {
  ContentLink {
    GuidValue
  }
  Preheading
}
    `;
export const PageMainContentFragmentDoc = `
    fragment PageMainContent on ContentAreaItemModelSearch {
  ContentLink {
    GuidValue
    Expanded {
      __typename
      ... on LearnCarouselContainerBlockV2 {
        ...LearnCarouselBlock
      }
      ... on ProfileListBlock {
        ...ProfileListLink
      }
    }
  }
}
    `;
export const PersonBlockFragmentDoc = `
    fragment PersonBlock on PersonBlock {
  Image {
    ImageReference {
      Url
    }
    AltText
  }
  Name
  Title
  Description
  MemberYears
  Country
  EmailAddress
  City
  ContentLink {
    GuidValue
  }
}
    `;
export const LearnDetailPageFragmentDoc = `
    fragment LearnDetailPage on LearnDetailPage {
  AssignedGroupsReadAccess {
    GroupName
  }
  Heading
  Subheading
  SubheadingText
  Description
  ContentTypeSelection
  ExpandedCategories {
    Name
    ParentId
  }
  ExpandedSources {
    Id
    Name
  }
  ExpandedTopics {
    Id
    Name
  }
  DisplayedDate
  MainContent {
    ...PageMainContent
  }
  Resource {
    ContentLink {
      Expanded {
        __typename
        ... on LearnHeroImageBlock {
          HeroImage {
            ImageReference {
              Url
            }
            AltText
          }
          MobileImage {
            ImageReference {
              Url
            }
            AltText
          }
        }
        ... on VideoDetailBlock {
          ViewTranscript {
            Content
          }
          ViewTranscriptLine
          Video {
            VideoReference {
              Url
            }
            AltText
          }
        }
        ... on PodcastDetailBlock {
          ImageBlock {
            HeroImage {
              AltText
              ImageReference {
                Url
              }
            }
            MobileImage {
              AltText
              ImageReference {
                Url
              }
            }
          }
          AudioContent {
            Url
          }
          ViewTranscript {
            Content
          }
        }
      }
    }
  }
  Authors {
    ContentLink {
      Expanded {
        __typename
        ... on PersonBlock {
          ...PersonBlock
        }
      }
    }
  }
  ContentLink {
    GuidValue
  }
}
    `;
export const QuestionFieldsFragmentDoc = `
    fragment questionFields on QuizQuestionPropertyValue {
  QuestionId
  Question
}
    `;
export const LearnContentCarouselCardFragmentDoc = `
    fragment LearnContentCarouselCard on LearnDetailPage {
  Language {
    Name
  }
  ContentLink {
    GuidValue
    Id
  }
  ExpandedCategories {
    Id
    ParentId
    Name
  }
  RelativePath
  ReadTimeInSeconds
  ThumbnailImage {
    ImageReference {
      Url
    }
    AltText
  }
  ContentTypeSelection
  Subheading
  SubheadingText
  Heading
  MagazineIssueYear
  MagazineIssueMonth
  Authors {
    ContentLink {
      Expanded {
        Name
      }
    }
  }
  AssignedGroupsReadAccess {
    GroupName
  }
  MainContent {
    ContentLink {
      Expanded {
        __typename
        ... on ProfileListBlock {
          ProfileList {
            ContentLink {
              Expanded {
                Name
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const LandingPageFragmentDoc = `
    fragment LandingPage on LandingPage {
  __typename
  Name
  RelativePath
  Url
}
    `;
export const LearnPageV2FragmentDoc = `
    fragment LearnPageV2 on LearnPageV2 {
  __typename
  Name
  RelativePath
  Url
}
    `;
export const MemberDirectoryPageFragmentDoc = `
    fragment MemberDirectoryPage on MemberDirectoryPage {
  __typename
  Name
  RelativePath
  Url
}
    `;
export const AccordionContainerBlockAnchorFragmentFragmentDoc = `
    fragment AccordionContainerBlockAnchorFragment on AccordionContainerBlock {
  __typename
  AnchorLink
  AnchorLabel
}
    `;
export const ImageTextBlockAnchorFragmentFragmentDoc = `
    fragment ImageTextBlockAnchorFragment on ImageTextBlock {
  __typename
  AnchorLink
  AnchorLabel
}
    `;
export const MembershipRequirementsBlockAnchorFragmentFragmentDoc = `
    fragment MembershipRequirementsBlockAnchorFragment on MembershipRequirementsBlock {
  __typename
  ProductionRequirementsAnchorLabel
  ProductionRequirementsAnchorLink
  CertifyingLettersAnchorLabel
  CertifyingLettersAnchorLink
  EthicalCodeAnchorLabel
  EthicalCodeAnchorLink
  MembershipDuesAnchorLabel
  MembershipDuesAnchorLink
}
    `;
export const NextCallOutBlockAnchorFragmentFragmentDoc = `
    fragment NextCallOutBlockAnchorFragment on NextCallOutBlock {
  __typename
  AnchorLink
  AnchorLabel
  AccessGroup
}
    `;
export const NextContainerBlockAnchorFragmentFragmentDoc = `
    fragment NextContainerBlockAnchorFragment on NextContainerBlock {
  __typename
  AnchorLink
  AnchorLabel
}
    `;
export const NextHeroBlockAnchorFragmentFragmentDoc = `
    fragment NextHeroBlockAnchorFragment on NextHeroBlock {
  __typename
  AnchorLink
  AnchorLabel
  AccessGroup
}
    `;
export const RichTextBlockAnchorFragmentFragmentDoc = `
    fragment RichTextBlockAnchorFragment on RichTextBlock {
  __typename
  AnchorLink
  AnchorLabel
}
    `;
export const NextEventBlockAnchorFragmentFragmentDoc = `
    fragment NextEventBlockAnchorFragment on NextEventBlock {
  __typename
  AnchorLink
  AnchorLabel
  ShowOnlyForEdgeAccessGroupMembers
}
    `;
export const NextContactUsBlockAnchorFragmentFragmentDoc = `
    fragment NextContactUsBlockAnchorFragment on NextContactUsBlock {
  __typename
  AnchorLabel
  AnchorLink
}
    `;
export const NextStaticPageFragmentDoc = `
    fragment NextStaticPage on NextStaticPage {
  __typename
  Name
  RelativePath
  Url
  HasSecondaryNavigation
  MainContent {
    ContentLink {
      Expanded {
        ...AccordionContainerBlockAnchorFragment
        ...ImageTextBlockAnchorFragment
        ...MembershipRequirementsBlockAnchorFragment
        ...NextCallOutBlockAnchorFragment
        ...NextContainerBlockAnchorFragment
        ...NextHeroBlockAnchorFragment
        ...RichTextBlockAnchorFragment
        ...NextEventBlockAnchorFragment
        ...NextContactUsBlockAnchorFragment
      }
    }
  }
}
    `;
export const AccordionItemBlockFragmentDoc = `
    fragment AccordionItemBlock on AccordionItemBlock {
  Subheading
  Description
}
    `;
export const AccordionContainerBlockFragmentDoc = `
    fragment AccordionContainerBlock on AccordionContainerBlock {
  __typename
  Name
  Description
  Subheading
  AnchorLink
  AccordionItemBlock {
    ContentLink {
      Expanded {
        ...AccordionItemBlock
      }
    }
  }
}
    `;
export const NextCallOutBlockFragmentDoc = `
    fragment NextCallOutBlock on NextCallOutBlock {
  __typename
  Name
  AnchorLink
  Language {
    Name
  }
  Heading
  SubHeading
  AccessGroup
  CallOutLinkBlock {
    DisplayText
    LinkToContent
    LinkStyle
    Target
    ShouldDownload
  }
}
    `;
export const LinkBlockFragmentDoc = `
    fragment LinkBlock on LinkBlock {
  __typename
  LinkToContent
  DisplayText
  Target
  LinkStyle
  ShouldDownload
  DownloadFileName
}
    `;
export const ImageTextBlockFragmentDoc = `
    fragment ImageTextBlock on ImageTextBlock {
  __typename
  AccessGroup
  AnchorLink
  Image {
    ImageReference {
      Url
    }
    AltText
  }
  ReverseContent
  Theme
  TextContent {
    PreHeading
    Heading
    SubHeading
    Description
  }
  CallToActionLinks {
    ContentLink {
      __typename
      Expanded {
        ...LinkBlock
      }
    }
  }
  Seperator
}
    `;
export const SvgLinkBlockFragmentDoc = `
    fragment SvgLinkBlock on SvgLinkBlock {
  __typename
  LinkToContent
  DisplayText
  Target
  IconClass
  ShouldDownload
  DownloadFileName
}
    `;
export const MembershipRequirementLinkBlockFragmentDoc = `
    fragment MembershipRequirementLinkBlock on MembershipRequirementBlockLinkBlock {
  DisplayText
  DownloadFileName
  LinkStyle
  LinkToContent
  ShouldDownload
  Target
}
    `;
export const MembershipRequirementBlockFragmentDoc = `
    fragment MembershipRequirementBlock on MembershipRequirementBlock {
  CoTDues
  DownloadRequirementsLink {
    ...MembershipRequirementLinkBlock
  }
  GenericProductionFooterText
  IncomeCertifyingLetters {
    ...MembershipRequirementLinkBlock
  }
  MemberDues
  NonCoreDownloadRequirementsLink {
    ...MembershipRequirementLinkBlock
  }
  NonCoreIncomeCertifyingLetters {
    ...MembershipRequirementLinkBlock
  }
  NonCorePremiumAndCommissionCertifyingLetters {
    ...MembershipRequirementLinkBlock
  }
  PremiumAndCommissionCertifyingLetters {
    ...MembershipRequirementLinkBlock
  }
  SpecificProductionFooterText
  ToTDues
  Date
  ConversionFactorsDescription
  ConversionFactorsDownloadLink {
    ...MembershipRequirementLinkBlock
  }
  MonthlyGoalCharts {
    ContentLink {
      Expanded {
        ... on KeyLinkValueBlock {
          Key
          Name
          Value {
            DisplayText
            DownloadFileName
            LinkStyle
            LinkToContent
            ShouldDownload
            Target
          }
        }
      }
    }
  }
}
    `;
export const ContactsBlockFragmentDoc = `
    fragment ContactsBlock on ContactsBlock {
  Email
  FaxNumber
  PhoneNumber
  RegionTitle
}
    `;
export const MembershipRequirementsBlockFragmentDoc = `
    fragment MembershipRequirementsBlock on MembershipRequirementsBlock {
  __typename
  ProductionRequirementsAnchorLink
  CertifyingLettersAnchorLink
  EthicalCodeAnchorLink
  MembershipDuesAnchorLink
  EthicalCodeDescription
  EthicalCodeStepLabel
  CertifyingLettersStepLabel
  CertifyingLettersDescription
  RelativePath
  RouteSegment
  CertifyingLettersFindOfficerLink {
    LinkToContent
    DisplayText
    Target
    LinkStyle
    DownloadFileName
    ShouldDownload
  }
  MembershipDuesDescription
  MembershipDuesStepLabel
  MembershipTableCoTHeading
  MembershipTableCommissionRowHeading
  MembershipTableIncomeRowHeading
  MembershipTableMemberHeading
  MembershipTableName
  MembershipTablePremiumRowHeading
  MembershipTableToTHeading
  MonthlyGoalChartsLinkText
  Name
  Language {
    Name
  }
  ViewMembershipRequirementsLabel
  ProductionRequirementsMonthlyGoalDescription
  ProductionRequirementsStepLabel
  ProfessionalAssociationsDescription
  ProfessionalAssociationsStepLabel
  MembershipRequirementBlocks {
    ContentLink {
      Expanded {
        ...MembershipRequirementBlock
      }
    }
  }
  ConversionFactorsStepLabel
  MonthlyGoalStepName
  ProductionApiErrorLabel
  NoRequirementsLabel
  Contacts {
    ContentLink {
      Expanded {
        ...ContactsBlock
      }
    }
  }
}
    `;
export const NextContactUsBlockFragmentDoc = `
    fragment NextContactUsBlock on NextContactUsBlock {
  __typename
  ContactUsText
  AnchorLink
}
    `;
export const ImageTextCardBlockFragmentDoc = `
    fragment ImageTextCardBlock on ImageTextCardBlock {
  __typename
  Description
  Heading
  Image {
    AltText
    ImageReference {
      Url
    }
  }
  SubHeading
  _concreteType
  LinkBlock {
    DisplayText
    LinkToContent
    Target
    LinkStyle
  }
  ImageSize
}
    `;
export const ImageBlockFragmentDoc = `
    fragment ImageBlock on ImageBlock {
  __typename
  AltText
  ImageReference {
    Url
  }
  _concreteType
  ImageSize
}
    `;
export const NextContainerBlockFragmentDoc = `
    fragment NextContainerBlock on NextContainerBlock {
  __typename
  AccessGroup
  Name
  AnchorLink
  Language {
    Name
  }
  Heading
  SubHeading
  Items {
    ContentLink {
      Expanded {
        ...ImageTextCardBlock
        ...ImageBlock
      }
      GuidValue
    }
  }
  Description
  Seperator
}
    `;
export const NextEventBlockFragmentDoc = `
    fragment NextEventBlock on NextEventBlock {
  __typename
  AnchorLink
  EventDescription
  EventHeading
  EventImageBlock {
    AltText
    ImageReference {
      Url
    }
  }
  EventLinkBlock {
    LinkToContent
    Target
  }
  EventLocation
  NextEventLocation
  EventDateFrom
  EventDateTo
  NextEventDateFrom
  NextEventDateTo
  ReversedContent
  ShowOnlyForEdgeAccessGroupMembers
}
    `;
export const NextHeroBlockFragmentDoc = `
    fragment NextHeroBlock on NextHeroBlock {
  __typename
  AccessGroup
  Name
  AnchorLink
  Language {
    Name
  }
  HeroHeading
  HeroDescription
  HeroTheme
  HeroImageBlocks {
    ContentLink {
      Expanded {
        ...ImageBlock
      }
      GuidValue
    }
  }
  HeroLinkBlocks {
    ContentLink {
      Expanded {
        ...LinkBlock
      }
      GuidValue
    }
  }
  HeroCtaButtons {
    ContentLink {
      Expanded {
        ...LinkBlock
      }
    }
  }
}
    `;
export const NextPersonContainerBlockFragmentDoc = `
    fragment NextPersonContainerBlock on NextPersonContainerBlock {
  __typename
  ProfileList {
    ContentLink {
      __typename
      Expanded {
        ...PersonBlock
      }
    }
  }
}
    `;
export const FourColumnTableBlockFragmentDoc = `
    fragment FourColumnTableBlock on FourColumnTableBlock {
  Footer
  TextContent {
    Heading
  }
  Rows {
    ColumnOne
    ColumnTwo
    ColumnThree
    ColumnFour
  }
}
    `;
export const PastPresidentsBlockFragmentDoc = `
    fragment PastPresidentsBlock on PastPresidentsBlock {
  __typename
  PastPresidentsTableReference {
    Expanded {
      ...FourColumnTableBlock
    }
  }
}
    `;
export const RichTextBlockFragmentDoc = `
    fragment RichTextBlock on RichTextBlock {
  __typename
  AnchorLink
  Name
  Content
  AnchorLabel
  Heading
  Seperator
}
    `;
export const AccountSettingsSiteContactInformationContentDocument = `
    query AccountSettingsSiteContactInformationContent($relativePath: String!) {
  DashboardAccountPage(
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      CountryHint
      ContactInformation {
        Title
        Email
        SecondEmail
        PhoneType
        ISOCode
        AreaCode
        PhoneNumber
        WeChatID
        MailingAddress
        AddressLine1
        AddressLine2
        AddressLine3
        City
        StateProvince
        PostalCode
        LocalLanguageAddressTitle
        UniqueEmailValidationMessage
        InvalidEmailValidationMessage
        PrimaryPhoneTitle
        AdditionalPhoneLabel
        AdditionalPhoneTitle
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      RequiredLabel
      SaveChanges
      RemoveLabel
      CountryLabel
      LatinOnlyMessage
    }
  }
}
    `;

export const useAccountSettingsSiteContactInformationContentQuery = <
      TData = AccountSettingsSiteContactInformationContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsSiteContactInformationContentQueryVariables,
      options?: Omit<UseQueryOptions<AccountSettingsSiteContactInformationContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AccountSettingsSiteContactInformationContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AccountSettingsSiteContactInformationContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsSiteContactInformationContent', variables],
    queryFn: gqlFetcher<AccountSettingsSiteContactInformationContentQuery, AccountSettingsSiteContactInformationContentQueryVariables>(AccountSettingsSiteContactInformationContentDocument, variables),
    ...options
  }
    )};

useAccountSettingsSiteContactInformationContentQuery.getKey = (variables: AccountSettingsSiteContactInformationContentQueryVariables) => ['AccountSettingsSiteContactInformationContent', variables];

export const useSuspenseAccountSettingsSiteContactInformationContentQuery = <
      TData = AccountSettingsSiteContactInformationContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsSiteContactInformationContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AccountSettingsSiteContactInformationContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AccountSettingsSiteContactInformationContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AccountSettingsSiteContactInformationContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsSiteContactInformationContentSuspense', variables],
    queryFn: gqlFetcher<AccountSettingsSiteContactInformationContentQuery, AccountSettingsSiteContactInformationContentQueryVariables>(AccountSettingsSiteContactInformationContentDocument, variables),
    ...options
  }
    )};

useSuspenseAccountSettingsSiteContactInformationContentQuery.getKey = (variables: AccountSettingsSiteContactInformationContentQueryVariables) => ['AccountSettingsSiteContactInformationContentSuspense', variables];


useAccountSettingsSiteContactInformationContentQuery.fetcher = (variables: AccountSettingsSiteContactInformationContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<AccountSettingsSiteContactInformationContentQuery, AccountSettingsSiteContactInformationContentQueryVariables>(AccountSettingsSiteContactInformationContentDocument, variables, options);

export const AccountSettingsInterestsContentDocument = `
    query AccountSettingsInterestsContent {
  DashboardAccountPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      SitePreferences {
        Interests
        SelectTopics
        WhatInterests
        ChooseTopics
        SaveInterests
        InterestsErrorMessage
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      CancelLabel
    }
  }
}
    `;

export const useAccountSettingsInterestsContentQuery = <
      TData = AccountSettingsInterestsContentQuery,
      TError = unknown
    >(
      variables?: AccountSettingsInterestsContentQueryVariables,
      options?: Omit<UseQueryOptions<AccountSettingsInterestsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AccountSettingsInterestsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AccountSettingsInterestsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['AccountSettingsInterestsContent'] : ['AccountSettingsInterestsContent', variables],
    queryFn: gqlFetcher<AccountSettingsInterestsContentQuery, AccountSettingsInterestsContentQueryVariables>(AccountSettingsInterestsContentDocument, variables),
    ...options
  }
    )};

useAccountSettingsInterestsContentQuery.getKey = (variables?: AccountSettingsInterestsContentQueryVariables) => variables === undefined ? ['AccountSettingsInterestsContent'] : ['AccountSettingsInterestsContent', variables];

export const useSuspenseAccountSettingsInterestsContentQuery = <
      TData = AccountSettingsInterestsContentQuery,
      TError = unknown
    >(
      variables?: AccountSettingsInterestsContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AccountSettingsInterestsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AccountSettingsInterestsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AccountSettingsInterestsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['AccountSettingsInterestsContentSuspense'] : ['AccountSettingsInterestsContentSuspense', variables],
    queryFn: gqlFetcher<AccountSettingsInterestsContentQuery, AccountSettingsInterestsContentQueryVariables>(AccountSettingsInterestsContentDocument, variables),
    ...options
  }
    )};

useSuspenseAccountSettingsInterestsContentQuery.getKey = (variables?: AccountSettingsInterestsContentQueryVariables) => variables === undefined ? ['AccountSettingsInterestsContentSuspense'] : ['AccountSettingsInterestsContentSuspense', variables];


useAccountSettingsInterestsContentQuery.fetcher = (variables?: AccountSettingsInterestsContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<AccountSettingsInterestsContentQuery, AccountSettingsInterestsContentQueryVariables>(AccountSettingsInterestsContentDocument, variables, options);

export const AccountSettingsLoginPasswordContentDocument = `
    query AccountSettingsLoginPasswordContent($relativePath: String!) {
  DashboardAccountPage(
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      LoginPassword {
        MDRTID
        Email
        EmailEditInformation
        Title
        UserName
        UsernameNotUnique
        ResetPassword {
          DisplayText
        }
        ApprovedSocialLogins
        BrowserPermissionInformation
        AppleLabel
        FacebookLabel
        GoogleLabel
        LinkedInLabel
        BiometricsSwitchLabel
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      Close
      LatinOnlyMessage
      SaveChanges
      RequiredLabel
      AccountSettingsPageReference {
        Expanded {
          RelativePath
        }
      }
    }
  }
}
    `;

export const useAccountSettingsLoginPasswordContentQuery = <
      TData = AccountSettingsLoginPasswordContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsLoginPasswordContentQueryVariables,
      options?: Omit<UseQueryOptions<AccountSettingsLoginPasswordContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AccountSettingsLoginPasswordContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AccountSettingsLoginPasswordContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsLoginPasswordContent', variables],
    queryFn: gqlFetcher<AccountSettingsLoginPasswordContentQuery, AccountSettingsLoginPasswordContentQueryVariables>(AccountSettingsLoginPasswordContentDocument, variables),
    ...options
  }
    )};

useAccountSettingsLoginPasswordContentQuery.getKey = (variables: AccountSettingsLoginPasswordContentQueryVariables) => ['AccountSettingsLoginPasswordContent', variables];

export const useSuspenseAccountSettingsLoginPasswordContentQuery = <
      TData = AccountSettingsLoginPasswordContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsLoginPasswordContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AccountSettingsLoginPasswordContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AccountSettingsLoginPasswordContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AccountSettingsLoginPasswordContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsLoginPasswordContentSuspense', variables],
    queryFn: gqlFetcher<AccountSettingsLoginPasswordContentQuery, AccountSettingsLoginPasswordContentQueryVariables>(AccountSettingsLoginPasswordContentDocument, variables),
    ...options
  }
    )};

useSuspenseAccountSettingsLoginPasswordContentQuery.getKey = (variables: AccountSettingsLoginPasswordContentQueryVariables) => ['AccountSettingsLoginPasswordContentSuspense', variables];


useAccountSettingsLoginPasswordContentQuery.fetcher = (variables: AccountSettingsLoginPasswordContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<AccountSettingsLoginPasswordContentQuery, AccountSettingsLoginPasswordContentQueryVariables>(AccountSettingsLoginPasswordContentDocument, variables, options);

export const AccountSettingsPersonalInfoContentDocument = `
    query AccountSettingsPersonalInfoContent($relativePath: String!) {
  DashboardAccountPage(
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      PersonalInformation {
        FirstName
        Gender
        LastName
        MiddleName
        PreferredName
        NavigationName
        Prefix
        Suffix
        Title
        YearOfBirth
        YearOfBirthValidationMessage
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      RequiredLabel
      LatinOnlyMessage
      SaveChanges
    }
  }
}
    `;

export const useAccountSettingsPersonalInfoContentQuery = <
      TData = AccountSettingsPersonalInfoContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsPersonalInfoContentQueryVariables,
      options?: Omit<UseQueryOptions<AccountSettingsPersonalInfoContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AccountSettingsPersonalInfoContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AccountSettingsPersonalInfoContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsPersonalInfoContent', variables],
    queryFn: gqlFetcher<AccountSettingsPersonalInfoContentQuery, AccountSettingsPersonalInfoContentQueryVariables>(AccountSettingsPersonalInfoContentDocument, variables),
    ...options
  }
    )};

useAccountSettingsPersonalInfoContentQuery.getKey = (variables: AccountSettingsPersonalInfoContentQueryVariables) => ['AccountSettingsPersonalInfoContent', variables];

export const useSuspenseAccountSettingsPersonalInfoContentQuery = <
      TData = AccountSettingsPersonalInfoContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsPersonalInfoContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AccountSettingsPersonalInfoContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AccountSettingsPersonalInfoContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AccountSettingsPersonalInfoContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsPersonalInfoContentSuspense', variables],
    queryFn: gqlFetcher<AccountSettingsPersonalInfoContentQuery, AccountSettingsPersonalInfoContentQueryVariables>(AccountSettingsPersonalInfoContentDocument, variables),
    ...options
  }
    )};

useSuspenseAccountSettingsPersonalInfoContentQuery.getKey = (variables: AccountSettingsPersonalInfoContentQueryVariables) => ['AccountSettingsPersonalInfoContentSuspense', variables];


useAccountSettingsPersonalInfoContentQuery.fetcher = (variables: AccountSettingsPersonalInfoContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<AccountSettingsPersonalInfoContentQuery, AccountSettingsPersonalInfoContentQueryVariables>(AccountSettingsPersonalInfoContentDocument, variables, options);

export const AccountSettingsProfessionalInfoContentDocument = `
    query AccountSettingsProfessionalInfoContent($relativePath: String!) {
  DashboardAccountPage(
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      CountryHint
      ProfessionalInformation {
        NavigationName
        Title
        AffiliatedCompany
        BrokerDealerCompany
        AgencyCompany
        PersonalCompany
        JobTitle
        Designation
        DesignationInformation
        AgentID
        YearOfFirstLicense
        YearOfFirstLicenseValidationMessage
        CompanyChangeAlertTitle
        CompanyChangeAlertBody
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      LatinOnlyMessage
      SaveChanges
      Close
      CountryLabel
      ConfirmLabel
      CancelLabel
    }
  }
}
    `;

export const useAccountSettingsProfessionalInfoContentQuery = <
      TData = AccountSettingsProfessionalInfoContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsProfessionalInfoContentQueryVariables,
      options?: Omit<UseQueryOptions<AccountSettingsProfessionalInfoContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AccountSettingsProfessionalInfoContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AccountSettingsProfessionalInfoContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsProfessionalInfoContent', variables],
    queryFn: gqlFetcher<AccountSettingsProfessionalInfoContentQuery, AccountSettingsProfessionalInfoContentQueryVariables>(AccountSettingsProfessionalInfoContentDocument, variables),
    ...options
  }
    )};

useAccountSettingsProfessionalInfoContentQuery.getKey = (variables: AccountSettingsProfessionalInfoContentQueryVariables) => ['AccountSettingsProfessionalInfoContent', variables];

export const useSuspenseAccountSettingsProfessionalInfoContentQuery = <
      TData = AccountSettingsProfessionalInfoContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsProfessionalInfoContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AccountSettingsProfessionalInfoContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AccountSettingsProfessionalInfoContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AccountSettingsProfessionalInfoContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsProfessionalInfoContentSuspense', variables],
    queryFn: gqlFetcher<AccountSettingsProfessionalInfoContentQuery, AccountSettingsProfessionalInfoContentQueryVariables>(AccountSettingsProfessionalInfoContentDocument, variables),
    ...options
  }
    )};

useSuspenseAccountSettingsProfessionalInfoContentQuery.getKey = (variables: AccountSettingsProfessionalInfoContentQueryVariables) => ['AccountSettingsProfessionalInfoContentSuspense', variables];


useAccountSettingsProfessionalInfoContentQuery.fetcher = (variables: AccountSettingsProfessionalInfoContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<AccountSettingsProfessionalInfoContentQuery, AccountSettingsProfessionalInfoContentQueryVariables>(AccountSettingsProfessionalInfoContentDocument, variables, options);

export const AccountSettingsProfileContentDocument = `
    query AccountSettingsProfileContent($relativePath: String!) {
  DashboardAccountPage(
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      SharedContent {
        ContentLink {
          Expanded {
            ... on ProfilePictureBlock {
              __typename
              Add
              PictureDescription
              Change
              Remove
              FileSizeHint
              FileSizeError
              FileTypeError
              ServerFileError
            }
          }
        }
      }
      Profile {
        NavigationName
        Title
        DisplayName
        Bio
        SocialLinks
        ShareSocialLinks
        LinkedIn
        Facebook
        Instagram
        Twitter
        GetMembershipCertificate
        ViewMembershipInvoice
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      Close
      RequiredLabel
      SaveChanges
      CountryLabel
      MembershipInvoicePage {
        Expanded {
          RelativePath
        }
      }
    }
  }
}
    `;

export const useAccountSettingsProfileContentQuery = <
      TData = AccountSettingsProfileContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsProfileContentQueryVariables,
      options?: Omit<UseQueryOptions<AccountSettingsProfileContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AccountSettingsProfileContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AccountSettingsProfileContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsProfileContent', variables],
    queryFn: gqlFetcher<AccountSettingsProfileContentQuery, AccountSettingsProfileContentQueryVariables>(AccountSettingsProfileContentDocument, variables),
    ...options
  }
    )};

useAccountSettingsProfileContentQuery.getKey = (variables: AccountSettingsProfileContentQueryVariables) => ['AccountSettingsProfileContent', variables];

export const useSuspenseAccountSettingsProfileContentQuery = <
      TData = AccountSettingsProfileContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsProfileContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AccountSettingsProfileContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AccountSettingsProfileContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AccountSettingsProfileContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsProfileContentSuspense', variables],
    queryFn: gqlFetcher<AccountSettingsProfileContentQuery, AccountSettingsProfileContentQueryVariables>(AccountSettingsProfileContentDocument, variables),
    ...options
  }
    )};

useSuspenseAccountSettingsProfileContentQuery.getKey = (variables: AccountSettingsProfileContentQueryVariables) => ['AccountSettingsProfileContentSuspense', variables];


useAccountSettingsProfileContentQuery.fetcher = (variables: AccountSettingsProfileContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<AccountSettingsProfileContentQuery, AccountSettingsProfileContentQueryVariables>(AccountSettingsProfileContentDocument, variables, options);

export const AccountSettingsSitePreferencesContentDocument = `
    query AccountSettingsSitePreferencesContent($relativePath: String!) {
  DashboardAccountPage(
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      SitePreferences {
        LanguageLabel
        ChooseLanguage
        PreferredLanguage
        MemberDirectory
        MemberDirectoryOptIn
        Interests
        SelectTopics
        WhatInterests
        ChooseTopics
        SaveInterests
        AddMoreTopicsButtonLabel
        InterestsErrorMessage
      }
      Permissions {
        EmailNotification
        EmailNotificationInformation
        CommunicationTopicInformation
        MemberBenefits
        ContentNewsletter
        MDRTMeetings
        BusinessAnnouncements
        MDRTFoundation
        MDRTStore
        CommunicationRemovalInformation
        SMSNotification
        SMSNotificationPermission
        EmailPermission
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      SaveChanges
      RequiredLabel
      Close
      CancelLabel
    }
  }
}
    `;

export const useAccountSettingsSitePreferencesContentQuery = <
      TData = AccountSettingsSitePreferencesContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsSitePreferencesContentQueryVariables,
      options?: Omit<UseQueryOptions<AccountSettingsSitePreferencesContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AccountSettingsSitePreferencesContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AccountSettingsSitePreferencesContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsSitePreferencesContent', variables],
    queryFn: gqlFetcher<AccountSettingsSitePreferencesContentQuery, AccountSettingsSitePreferencesContentQueryVariables>(AccountSettingsSitePreferencesContentDocument, variables),
    ...options
  }
    )};

useAccountSettingsSitePreferencesContentQuery.getKey = (variables: AccountSettingsSitePreferencesContentQueryVariables) => ['AccountSettingsSitePreferencesContent', variables];

export const useSuspenseAccountSettingsSitePreferencesContentQuery = <
      TData = AccountSettingsSitePreferencesContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsSitePreferencesContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AccountSettingsSitePreferencesContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AccountSettingsSitePreferencesContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AccountSettingsSitePreferencesContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsSitePreferencesContentSuspense', variables],
    queryFn: gqlFetcher<AccountSettingsSitePreferencesContentQuery, AccountSettingsSitePreferencesContentQueryVariables>(AccountSettingsSitePreferencesContentDocument, variables),
    ...options
  }
    )};

useSuspenseAccountSettingsSitePreferencesContentQuery.getKey = (variables: AccountSettingsSitePreferencesContentQueryVariables) => ['AccountSettingsSitePreferencesContentSuspense', variables];


useAccountSettingsSitePreferencesContentQuery.fetcher = (variables: AccountSettingsSitePreferencesContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<AccountSettingsSitePreferencesContentQuery, AccountSettingsSitePreferencesContentQueryVariables>(AccountSettingsSitePreferencesContentDocument, variables, options);

export const AccountSettingsPageDocument = `
    query AccountSettingsPage($relativePath: String!) {
  DashboardAccountPage(
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      Profile {
        NavigationName
      }
      ProfessionalInformation {
        NavigationName
      }
      PersonalInformation {
        NavigationName
      }
      Permissions {
        NavigationName
      }
      ContactInformation {
        NavigationName
      }
      LoginPassword {
        NavigationName
      }
      SitePreferences {
        NavigationName
      }
      RelativePath
    }
  }
}
    `;

export const useAccountSettingsPageQuery = <
      TData = AccountSettingsPageQuery,
      TError = unknown
    >(
      variables: AccountSettingsPageQueryVariables,
      options?: Omit<UseQueryOptions<AccountSettingsPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AccountSettingsPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AccountSettingsPageQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsPage', variables],
    queryFn: gqlFetcher<AccountSettingsPageQuery, AccountSettingsPageQueryVariables>(AccountSettingsPageDocument, variables),
    ...options
  }
    )};

useAccountSettingsPageQuery.getKey = (variables: AccountSettingsPageQueryVariables) => ['AccountSettingsPage', variables];

export const useSuspenseAccountSettingsPageQuery = <
      TData = AccountSettingsPageQuery,
      TError = unknown
    >(
      variables: AccountSettingsPageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AccountSettingsPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AccountSettingsPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AccountSettingsPageQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsPageSuspense', variables],
    queryFn: gqlFetcher<AccountSettingsPageQuery, AccountSettingsPageQueryVariables>(AccountSettingsPageDocument, variables),
    ...options
  }
    )};

useSuspenseAccountSettingsPageQuery.getKey = (variables: AccountSettingsPageQueryVariables) => ['AccountSettingsPageSuspense', variables];


useAccountSettingsPageQuery.fetcher = (variables: AccountSettingsPageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<AccountSettingsPageQuery, AccountSettingsPageQueryVariables>(AccountSettingsPageDocument, variables, options);

export const DeadLettersContentDocument = `
    query DeadLettersContent {
  NextStaffAdminPage(locale: ALL, where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      DeadLettersSectionContent: DeadLetterQueueBlock {
        DeadLettersNoDeadLetters
        DeadLettersRetryDeadLetters
        DeadLettersQueue
      }
      DeadLettersTableContent: DeadLetterQueueBlock {
        DeadLettersQueueName
        DeadLettersEnqueuedTime
        DeadLettersMessageId
        DeadLettersMessageName
      }
    }
  }
}
    `;

export const useDeadLettersContentQuery = <
      TData = DeadLettersContentQuery,
      TError = unknown
    >(
      variables?: DeadLettersContentQueryVariables,
      options?: Omit<UseQueryOptions<DeadLettersContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DeadLettersContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DeadLettersContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['DeadLettersContent'] : ['DeadLettersContent', variables],
    queryFn: gqlFetcher<DeadLettersContentQuery, DeadLettersContentQueryVariables>(DeadLettersContentDocument, variables),
    ...options
  }
    )};

useDeadLettersContentQuery.getKey = (variables?: DeadLettersContentQueryVariables) => variables === undefined ? ['DeadLettersContent'] : ['DeadLettersContent', variables];

export const useSuspenseDeadLettersContentQuery = <
      TData = DeadLettersContentQuery,
      TError = unknown
    >(
      variables?: DeadLettersContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<DeadLettersContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<DeadLettersContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<DeadLettersContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['DeadLettersContentSuspense'] : ['DeadLettersContentSuspense', variables],
    queryFn: gqlFetcher<DeadLettersContentQuery, DeadLettersContentQueryVariables>(DeadLettersContentDocument, variables),
    ...options
  }
    )};

useSuspenseDeadLettersContentQuery.getKey = (variables?: DeadLettersContentQueryVariables) => variables === undefined ? ['DeadLettersContentSuspense'] : ['DeadLettersContentSuspense', variables];


useDeadLettersContentQuery.fetcher = (variables?: DeadLettersContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<DeadLettersContentQuery, DeadLettersContentQueryVariables>(DeadLettersContentDocument, variables, options);

export const PersonScopedDataTableContentDocument = `
    query PersonScopedDataTableContent {
  NextStaffAdminPage(locale: ALL, where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      PersonData {
        PersonData
        PersonDataTriggerSync
        PersonDataExcludeFromLateFee
        PersonDataPrepayments
        PersonDataPayments
        PersonDataProductions
        PersonDataMembershipApplication
        PersonDataCustomerProfile
        PersonDataNoResults
      }
    }
  }
}
    `;

export const usePersonScopedDataTableContentQuery = <
      TData = PersonScopedDataTableContentQuery,
      TError = unknown
    >(
      variables?: PersonScopedDataTableContentQueryVariables,
      options?: Omit<UseQueryOptions<PersonScopedDataTableContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonScopedDataTableContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonScopedDataTableContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PersonScopedDataTableContent'] : ['PersonScopedDataTableContent', variables],
    queryFn: gqlFetcher<PersonScopedDataTableContentQuery, PersonScopedDataTableContentQueryVariables>(PersonScopedDataTableContentDocument, variables),
    ...options
  }
    )};

usePersonScopedDataTableContentQuery.getKey = (variables?: PersonScopedDataTableContentQueryVariables) => variables === undefined ? ['PersonScopedDataTableContent'] : ['PersonScopedDataTableContent', variables];

export const useSuspensePersonScopedDataTableContentQuery = <
      TData = PersonScopedDataTableContentQuery,
      TError = unknown
    >(
      variables?: PersonScopedDataTableContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PersonScopedDataTableContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PersonScopedDataTableContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PersonScopedDataTableContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PersonScopedDataTableContentSuspense'] : ['PersonScopedDataTableContentSuspense', variables],
    queryFn: gqlFetcher<PersonScopedDataTableContentQuery, PersonScopedDataTableContentQueryVariables>(PersonScopedDataTableContentDocument, variables),
    ...options
  }
    )};

useSuspensePersonScopedDataTableContentQuery.getKey = (variables?: PersonScopedDataTableContentQueryVariables) => variables === undefined ? ['PersonScopedDataTableContentSuspense'] : ['PersonScopedDataTableContentSuspense', variables];


usePersonScopedDataTableContentQuery.fetcher = (variables?: PersonScopedDataTableContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<PersonScopedDataTableContentQuery, PersonScopedDataTableContentQueryVariables>(PersonScopedDataTableContentDocument, variables, options);

export const SyncEventsTableContentDocument = `
    query SyncEventsTableContent {
  NextStaffAdminPage(locale: ALL, where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      SyncTableContent: SyncEventsBlock {
        SyncEventsDeleteAllUserData
        SyncEventsUserDataDeleteConfirmation
        SyncEventsSyncEvent
        SyncEventsSyncOperation
        SyncEventsDate
      }
      SyncEventsFilter: SyncEventsBlock {
        SyncEventsSelectPrepayment
        SyncEventsSelectProduction
        SyncEventsSelectAll
        SyncEventsSelectMembershipApplication
        SyncEventsSelectCustomerProfile
      }
    }
  }
}
    `;

export const useSyncEventsTableContentQuery = <
      TData = SyncEventsTableContentQuery,
      TError = unknown
    >(
      variables?: SyncEventsTableContentQueryVariables,
      options?: Omit<UseQueryOptions<SyncEventsTableContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SyncEventsTableContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SyncEventsTableContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SyncEventsTableContent'] : ['SyncEventsTableContent', variables],
    queryFn: gqlFetcher<SyncEventsTableContentQuery, SyncEventsTableContentQueryVariables>(SyncEventsTableContentDocument, variables),
    ...options
  }
    )};

useSyncEventsTableContentQuery.getKey = (variables?: SyncEventsTableContentQueryVariables) => variables === undefined ? ['SyncEventsTableContent'] : ['SyncEventsTableContent', variables];

export const useSuspenseSyncEventsTableContentQuery = <
      TData = SyncEventsTableContentQuery,
      TError = unknown
    >(
      variables?: SyncEventsTableContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<SyncEventsTableContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<SyncEventsTableContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<SyncEventsTableContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SyncEventsTableContentSuspense'] : ['SyncEventsTableContentSuspense', variables],
    queryFn: gqlFetcher<SyncEventsTableContentQuery, SyncEventsTableContentQueryVariables>(SyncEventsTableContentDocument, variables),
    ...options
  }
    )};

useSuspenseSyncEventsTableContentQuery.getKey = (variables?: SyncEventsTableContentQueryVariables) => variables === undefined ? ['SyncEventsTableContentSuspense'] : ['SyncEventsTableContentSuspense', variables];


useSyncEventsTableContentQuery.fetcher = (variables?: SyncEventsTableContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<SyncEventsTableContentQuery, SyncEventsTableContentQueryVariables>(SyncEventsTableContentDocument, variables, options);

export const UsersListTableContentDocument = `
    query UsersListTableContent {
  NextStaffAdminPage(locale: ALL, where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      UsersRequiringAttentionDeadLetterCount
      UsersRequiringAttentionDescription
      UsersRequiringAttentionEmailAddress
      UsersRequiringAttentionEnterPersonId
      UsersRequiringAttentionGoToPage
      UsersRequiringAttentionId
      UsersRequiringAttentionName
      UsersRequiringAttentionNoResults
    }
  }
}
    `;

export const useUsersListTableContentQuery = <
      TData = UsersListTableContentQuery,
      TError = unknown
    >(
      variables?: UsersListTableContentQueryVariables,
      options?: Omit<UseQueryOptions<UsersListTableContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UsersListTableContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UsersListTableContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['UsersListTableContent'] : ['UsersListTableContent', variables],
    queryFn: gqlFetcher<UsersListTableContentQuery, UsersListTableContentQueryVariables>(UsersListTableContentDocument, variables),
    ...options
  }
    )};

useUsersListTableContentQuery.getKey = (variables?: UsersListTableContentQueryVariables) => variables === undefined ? ['UsersListTableContent'] : ['UsersListTableContent', variables];

export const useSuspenseUsersListTableContentQuery = <
      TData = UsersListTableContentQuery,
      TError = unknown
    >(
      variables?: UsersListTableContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UsersListTableContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UsersListTableContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<UsersListTableContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['UsersListTableContentSuspense'] : ['UsersListTableContentSuspense', variables],
    queryFn: gqlFetcher<UsersListTableContentQuery, UsersListTableContentQueryVariables>(UsersListTableContentDocument, variables),
    ...options
  }
    )};

useSuspenseUsersListTableContentQuery.getKey = (variables?: UsersListTableContentQueryVariables) => variables === undefined ? ['UsersListTableContentSuspense'] : ['UsersListTableContentSuspense', variables];


useUsersListTableContentQuery.fetcher = (variables?: UsersListTableContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<UsersListTableContentQuery, UsersListTableContentQueryVariables>(UsersListTableContentDocument, variables, options);

export const AdminDashboardContentDocument = `
    query AdminDashboardContent {
  NextStaffAdminPage(locale: ALL, where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      UsersRequiringAttention
      ContentLink {
        Id
      }
    }
  }
}
    `;

export const useAdminDashboardContentQuery = <
      TData = AdminDashboardContentQuery,
      TError = unknown
    >(
      variables?: AdminDashboardContentQueryVariables,
      options?: Omit<UseQueryOptions<AdminDashboardContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminDashboardContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminDashboardContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['AdminDashboardContent'] : ['AdminDashboardContent', variables],
    queryFn: gqlFetcher<AdminDashboardContentQuery, AdminDashboardContentQueryVariables>(AdminDashboardContentDocument, variables),
    ...options
  }
    )};

useAdminDashboardContentQuery.getKey = (variables?: AdminDashboardContentQueryVariables) => variables === undefined ? ['AdminDashboardContent'] : ['AdminDashboardContent', variables];

export const useSuspenseAdminDashboardContentQuery = <
      TData = AdminDashboardContentQuery,
      TError = unknown
    >(
      variables?: AdminDashboardContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AdminDashboardContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AdminDashboardContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AdminDashboardContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['AdminDashboardContentSuspense'] : ['AdminDashboardContentSuspense', variables],
    queryFn: gqlFetcher<AdminDashboardContentQuery, AdminDashboardContentQueryVariables>(AdminDashboardContentDocument, variables),
    ...options
  }
    )};

useSuspenseAdminDashboardContentQuery.getKey = (variables?: AdminDashboardContentQueryVariables) => variables === undefined ? ['AdminDashboardContentSuspense'] : ['AdminDashboardContentSuspense', variables];


useAdminDashboardContentQuery.fetcher = (variables?: AdminDashboardContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<AdminDashboardContentQuery, AdminDashboardContentQueryVariables>(AdminDashboardContentDocument, variables, options);

export const PersonIdPageContentDocument = `
    query PersonIdPageContent {
  NextStaffAdminPage(locale: ALL, where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      Back
      PersonId
      SyncEventsBlock {
        SyncEvents
      }
      ContentLink {
        Id
      }
    }
  }
}
    `;

export const usePersonIdPageContentQuery = <
      TData = PersonIdPageContentQuery,
      TError = unknown
    >(
      variables?: PersonIdPageContentQueryVariables,
      options?: Omit<UseQueryOptions<PersonIdPageContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonIdPageContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonIdPageContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PersonIdPageContent'] : ['PersonIdPageContent', variables],
    queryFn: gqlFetcher<PersonIdPageContentQuery, PersonIdPageContentQueryVariables>(PersonIdPageContentDocument, variables),
    ...options
  }
    )};

usePersonIdPageContentQuery.getKey = (variables?: PersonIdPageContentQueryVariables) => variables === undefined ? ['PersonIdPageContent'] : ['PersonIdPageContent', variables];

export const useSuspensePersonIdPageContentQuery = <
      TData = PersonIdPageContentQuery,
      TError = unknown
    >(
      variables?: PersonIdPageContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PersonIdPageContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PersonIdPageContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PersonIdPageContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PersonIdPageContentSuspense'] : ['PersonIdPageContentSuspense', variables],
    queryFn: gqlFetcher<PersonIdPageContentQuery, PersonIdPageContentQueryVariables>(PersonIdPageContentDocument, variables),
    ...options
  }
    )};

useSuspensePersonIdPageContentQuery.getKey = (variables?: PersonIdPageContentQueryVariables) => variables === undefined ? ['PersonIdPageContentSuspense'] : ['PersonIdPageContentSuspense', variables];


usePersonIdPageContentQuery.fetcher = (variables?: PersonIdPageContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<PersonIdPageContentQuery, PersonIdPageContentQueryVariables>(PersonIdPageContentDocument, variables, options);

export const AccountSettingsPreviewModalContentDocument = `
    query AccountSettingsPreviewModalContent($relativePath: String!) {
  DashboardAccountPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      PersonalInformation {
        FirstName
        Gender
        LastName
        MiddleName
        PreferredName
        Prefix
        Suffix
        YearOfBirth
      }
      ProfessionalInformation {
        AffiliatedCompany
        BrokerDealerCompany
        AgencyCompany
        PersonalCompany
        JobTitle
        Designation
        AgentID
        YearOfFirstLicense
      }
      ContactInformation {
        Title
        Email
        SecondEmail
        PhoneType
        ISOCode
        AreaCode
        PhoneNumber
        WeChatID
        MailingAddress
        AddressLine1
        AddressLine2
        AddressLine3
        City
        StateProvince
        PostalCode
        LocalLanguageAddressTitle
      }
    }
  }
  HomePageV2(
    locale: ALL
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      ProfileDataValidationConfirmButtonLabel
      ProfileDataValidationContactInformationSectionTitle
      ProfileDataValidationEditLinkAriaLabel
      ProfileDataValidationModalDescription
      ProfileDataValidationModalTitle
      ProfileDataValidationPersonalInformationSectionTitle
      ProfileDataValidationProfessionalInformationSectionTitle
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      CountryLabel
    }
  }
}
    `;

export const useAccountSettingsPreviewModalContentQuery = <
      TData = AccountSettingsPreviewModalContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsPreviewModalContentQueryVariables,
      options?: Omit<UseQueryOptions<AccountSettingsPreviewModalContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AccountSettingsPreviewModalContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AccountSettingsPreviewModalContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsPreviewModalContent', variables],
    queryFn: gqlFetcher<AccountSettingsPreviewModalContentQuery, AccountSettingsPreviewModalContentQueryVariables>(AccountSettingsPreviewModalContentDocument, variables),
    ...options
  }
    )};

useAccountSettingsPreviewModalContentQuery.getKey = (variables: AccountSettingsPreviewModalContentQueryVariables) => ['AccountSettingsPreviewModalContent', variables];

export const useSuspenseAccountSettingsPreviewModalContentQuery = <
      TData = AccountSettingsPreviewModalContentQuery,
      TError = unknown
    >(
      variables: AccountSettingsPreviewModalContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AccountSettingsPreviewModalContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AccountSettingsPreviewModalContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AccountSettingsPreviewModalContentQuery, TError, TData>(
      {
    queryKey: ['AccountSettingsPreviewModalContentSuspense', variables],
    queryFn: gqlFetcher<AccountSettingsPreviewModalContentQuery, AccountSettingsPreviewModalContentQueryVariables>(AccountSettingsPreviewModalContentDocument, variables),
    ...options
  }
    )};

useSuspenseAccountSettingsPreviewModalContentQuery.getKey = (variables: AccountSettingsPreviewModalContentQueryVariables) => ['AccountSettingsPreviewModalContentSuspense', variables];


useAccountSettingsPreviewModalContentQuery.fetcher = (variables: AccountSettingsPreviewModalContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<AccountSettingsPreviewModalContentQuery, AccountSettingsPreviewModalContentQueryVariables>(AccountSettingsPreviewModalContentDocument, variables, options);

export const BiometricIdContentDocument = `
    query BiometricIdContent {
  HomePageV2(locale: ALL, where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      BiometricAuthenticationDismissButton
      BiometricAuthenticationEnableButton
      BiometricAuthenticationHeading
      BiometricAuthenticationLoginMessage
      BiometricAuthenticationDisableMessage
    }
  }
}
    `;

export const useBiometricIdContentQuery = <
      TData = BiometricIdContentQuery,
      TError = unknown
    >(
      variables?: BiometricIdContentQueryVariables,
      options?: Omit<UseQueryOptions<BiometricIdContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BiometricIdContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BiometricIdContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['BiometricIdContent'] : ['BiometricIdContent', variables],
    queryFn: gqlFetcher<BiometricIdContentQuery, BiometricIdContentQueryVariables>(BiometricIdContentDocument, variables),
    ...options
  }
    )};

useBiometricIdContentQuery.getKey = (variables?: BiometricIdContentQueryVariables) => variables === undefined ? ['BiometricIdContent'] : ['BiometricIdContent', variables];

export const useSuspenseBiometricIdContentQuery = <
      TData = BiometricIdContentQuery,
      TError = unknown
    >(
      variables?: BiometricIdContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<BiometricIdContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<BiometricIdContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<BiometricIdContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['BiometricIdContentSuspense'] : ['BiometricIdContentSuspense', variables],
    queryFn: gqlFetcher<BiometricIdContentQuery, BiometricIdContentQueryVariables>(BiometricIdContentDocument, variables),
    ...options
  }
    )};

useSuspenseBiometricIdContentQuery.getKey = (variables?: BiometricIdContentQueryVariables) => variables === undefined ? ['BiometricIdContentSuspense'] : ['BiometricIdContentSuspense', variables];


useBiometricIdContentQuery.fetcher = (variables?: BiometricIdContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<BiometricIdContentQuery, BiometricIdContentQueryVariables>(BiometricIdContentDocument, variables, options);

export const CardsSectionContentDocument = `
    query CardsSectionContent($relativePath: String!) {
  HomePageV2(
    locale: ALL
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      CardsSectionTitle
      CardsSectionTitleForMembers
    }
  }
}
    `;

export const useCardsSectionContentQuery = <
      TData = CardsSectionContentQuery,
      TError = unknown
    >(
      variables: CardsSectionContentQueryVariables,
      options?: Omit<UseQueryOptions<CardsSectionContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CardsSectionContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CardsSectionContentQuery, TError, TData>(
      {
    queryKey: ['CardsSectionContent', variables],
    queryFn: gqlFetcher<CardsSectionContentQuery, CardsSectionContentQueryVariables>(CardsSectionContentDocument, variables),
    ...options
  }
    )};

useCardsSectionContentQuery.getKey = (variables: CardsSectionContentQueryVariables) => ['CardsSectionContent', variables];

export const useSuspenseCardsSectionContentQuery = <
      TData = CardsSectionContentQuery,
      TError = unknown
    >(
      variables: CardsSectionContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CardsSectionContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CardsSectionContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CardsSectionContentQuery, TError, TData>(
      {
    queryKey: ['CardsSectionContentSuspense', variables],
    queryFn: gqlFetcher<CardsSectionContentQuery, CardsSectionContentQueryVariables>(CardsSectionContentDocument, variables),
    ...options
  }
    )};

useSuspenseCardsSectionContentQuery.getKey = (variables: CardsSectionContentQueryVariables) => ['CardsSectionContentSuspense', variables];


useCardsSectionContentQuery.fetcher = (variables: CardsSectionContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<CardsSectionContentQuery, CardsSectionContentQueryVariables>(CardsSectionContentDocument, variables, options);

export const DashboardCarouselCardsContentDocument = `
    query DashboardCarouselCardsContent($locale: String) {
  HomePageV2(where: {Language: {Name: {eq: $locale}}, Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      DashboardCarouselCardsContent {
        ContentLink {
          Expanded {
            ... on DashboardCarouselCardBlock {
              __typename
              Title
              Description
              ImageReference {
                Url
              }
              CardUrl {
                DisplayText
                Target
                LinkToContent
              }
              ContentCategory
              LocationsAndDates {
                ContentLink {
                  Expanded {
                    ... on EventLocationAndDateBlock {
                      Location
                      StartDate
                      EndDate
                    }
                  }
                }
              }
              ...DashboardCarouselCardBlockVisibilityOptions
            }
          }
        }
      }
    }
  }
}
    ${DashboardCarouselCardBlockVisibilityOptionsFragmentDoc}`;

export const useDashboardCarouselCardsContentQuery = <
      TData = DashboardCarouselCardsContentQuery,
      TError = unknown
    >(
      variables?: DashboardCarouselCardsContentQueryVariables,
      options?: Omit<UseQueryOptions<DashboardCarouselCardsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DashboardCarouselCardsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DashboardCarouselCardsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['DashboardCarouselCardsContent'] : ['DashboardCarouselCardsContent', variables],
    queryFn: gqlFetcher<DashboardCarouselCardsContentQuery, DashboardCarouselCardsContentQueryVariables>(DashboardCarouselCardsContentDocument, variables),
    ...options
  }
    )};

useDashboardCarouselCardsContentQuery.getKey = (variables?: DashboardCarouselCardsContentQueryVariables) => variables === undefined ? ['DashboardCarouselCardsContent'] : ['DashboardCarouselCardsContent', variables];

export const useSuspenseDashboardCarouselCardsContentQuery = <
      TData = DashboardCarouselCardsContentQuery,
      TError = unknown
    >(
      variables?: DashboardCarouselCardsContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<DashboardCarouselCardsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<DashboardCarouselCardsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<DashboardCarouselCardsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['DashboardCarouselCardsContentSuspense'] : ['DashboardCarouselCardsContentSuspense', variables],
    queryFn: gqlFetcher<DashboardCarouselCardsContentQuery, DashboardCarouselCardsContentQueryVariables>(DashboardCarouselCardsContentDocument, variables),
    ...options
  }
    )};

useSuspenseDashboardCarouselCardsContentQuery.getKey = (variables?: DashboardCarouselCardsContentQueryVariables) => variables === undefined ? ['DashboardCarouselCardsContentSuspense'] : ['DashboardCarouselCardsContentSuspense', variables];


useDashboardCarouselCardsContentQuery.fetcher = (variables?: DashboardCarouselCardsContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<DashboardCarouselCardsContentQuery, DashboardCarouselCardsContentQueryVariables>(DashboardCarouselCardsContentDocument, variables, options);

export const LearnCardsForYouContentDocument = `
    query LearnCardsForYouContent($contentGuids: [String], $relativePath: String!, $locale: String) {
  LearnDetailPage(
    limit: 100
    where: {ContentLink: {GuidValue: {in: $contentGuids}}, Status: {eq: "Published"}, Language: {Name: {eq: $locale}}}
  ) {
    items {
      ...LearnCardForYouCard
    }
  }
  HomePageV2(
    locale: ALL
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      CardsTabLearnContentCategory
      CardsTabLearnButtonLabel
      CardsTabLearnContentCategory
      AudioContentCategory
      PodcastContentCategory
      VideoContentCategory
      GuideContentCategory
      ArticleContentCategory
    }
  }
}
    ${LearnCardForYouCardFragmentDoc}`;

export const useLearnCardsForYouContentQuery = <
      TData = LearnCardsForYouContentQuery,
      TError = unknown
    >(
      variables: LearnCardsForYouContentQueryVariables,
      options?: Omit<UseQueryOptions<LearnCardsForYouContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnCardsForYouContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnCardsForYouContentQuery, TError, TData>(
      {
    queryKey: ['LearnCardsForYouContent', variables],
    queryFn: gqlFetcher<LearnCardsForYouContentQuery, LearnCardsForYouContentQueryVariables>(LearnCardsForYouContentDocument, variables),
    ...options
  }
    )};

useLearnCardsForYouContentQuery.getKey = (variables: LearnCardsForYouContentQueryVariables) => ['LearnCardsForYouContent', variables];

export const useSuspenseLearnCardsForYouContentQuery = <
      TData = LearnCardsForYouContentQuery,
      TError = unknown
    >(
      variables: LearnCardsForYouContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LearnCardsForYouContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LearnCardsForYouContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LearnCardsForYouContentQuery, TError, TData>(
      {
    queryKey: ['LearnCardsForYouContentSuspense', variables],
    queryFn: gqlFetcher<LearnCardsForYouContentQuery, LearnCardsForYouContentQueryVariables>(LearnCardsForYouContentDocument, variables),
    ...options
  }
    )};

useSuspenseLearnCardsForYouContentQuery.getKey = (variables: LearnCardsForYouContentQueryVariables) => ['LearnCardsForYouContentSuspense', variables];


useLearnCardsForYouContentQuery.fetcher = (variables: LearnCardsForYouContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<LearnCardsForYouContentQuery, LearnCardsForYouContentQueryVariables>(LearnCardsForYouContentDocument, variables, options);

export const MeetingEventCardContentDocument = `
    query MeetingEventCardContent {
  MeetingEventCardPage(limit: 100, where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      AssignedGroups {
        AccessLevels
        GroupName
      }
      LocationsAndDates {
        ContentLink {
          Expanded {
            Name
            ... on EventLocationAndDateBlock {
              StartDate
              EndDate
              Location
            }
          }
        }
      }
      Image {
        AltText
        ImageReference {
          Url
        }
      }
      Title
      Description
      CallToActionText
      ContentCategory
      EventUrl {
        DisplayText
        Target
        EventName
        EventLabel
        LinkToContent
      }
      Url
    }
  }
}
    `;

export const useMeetingEventCardContentQuery = <
      TData = MeetingEventCardContentQuery,
      TError = unknown
    >(
      variables?: MeetingEventCardContentQueryVariables,
      options?: Omit<UseQueryOptions<MeetingEventCardContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MeetingEventCardContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MeetingEventCardContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MeetingEventCardContent'] : ['MeetingEventCardContent', variables],
    queryFn: gqlFetcher<MeetingEventCardContentQuery, MeetingEventCardContentQueryVariables>(MeetingEventCardContentDocument, variables),
    ...options
  }
    )};

useMeetingEventCardContentQuery.getKey = (variables?: MeetingEventCardContentQueryVariables) => variables === undefined ? ['MeetingEventCardContent'] : ['MeetingEventCardContent', variables];

export const useSuspenseMeetingEventCardContentQuery = <
      TData = MeetingEventCardContentQuery,
      TError = unknown
    >(
      variables?: MeetingEventCardContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MeetingEventCardContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MeetingEventCardContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MeetingEventCardContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MeetingEventCardContentSuspense'] : ['MeetingEventCardContentSuspense', variables],
    queryFn: gqlFetcher<MeetingEventCardContentQuery, MeetingEventCardContentQueryVariables>(MeetingEventCardContentDocument, variables),
    ...options
  }
    )};

useSuspenseMeetingEventCardContentQuery.getKey = (variables?: MeetingEventCardContentQueryVariables) => variables === undefined ? ['MeetingEventCardContentSuspense'] : ['MeetingEventCardContentSuspense', variables];


useMeetingEventCardContentQuery.fetcher = (variables?: MeetingEventCardContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<MeetingEventCardContentQuery, MeetingEventCardContentQueryVariables>(MeetingEventCardContentDocument, variables, options);

export const MemberDirectoryCardContentDocument = `
    query MemberDirectoryCardContent {
  MemberDirectoryPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      CardImage {
        AltText
        ImageReference {
          Url
        }
      }
      ContentCategory
      CardTitle
      CardDescription
      CardMembersNearYouLabel
      CardUrl {
        LinkToContent
        DisplayText
        Target
      }
    }
  }
}
    `;

export const useMemberDirectoryCardContentQuery = <
      TData = MemberDirectoryCardContentQuery,
      TError = unknown
    >(
      variables?: MemberDirectoryCardContentQueryVariables,
      options?: Omit<UseQueryOptions<MemberDirectoryCardContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MemberDirectoryCardContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MemberDirectoryCardContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MemberDirectoryCardContent'] : ['MemberDirectoryCardContent', variables],
    queryFn: gqlFetcher<MemberDirectoryCardContentQuery, MemberDirectoryCardContentQueryVariables>(MemberDirectoryCardContentDocument, variables),
    ...options
  }
    )};

useMemberDirectoryCardContentQuery.getKey = (variables?: MemberDirectoryCardContentQueryVariables) => variables === undefined ? ['MemberDirectoryCardContent'] : ['MemberDirectoryCardContent', variables];

export const useSuspenseMemberDirectoryCardContentQuery = <
      TData = MemberDirectoryCardContentQuery,
      TError = unknown
    >(
      variables?: MemberDirectoryCardContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MemberDirectoryCardContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MemberDirectoryCardContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MemberDirectoryCardContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MemberDirectoryCardContentSuspense'] : ['MemberDirectoryCardContentSuspense', variables],
    queryFn: gqlFetcher<MemberDirectoryCardContentQuery, MemberDirectoryCardContentQueryVariables>(MemberDirectoryCardContentDocument, variables),
    ...options
  }
    )};

useSuspenseMemberDirectoryCardContentQuery.getKey = (variables?: MemberDirectoryCardContentQueryVariables) => variables === undefined ? ['MemberDirectoryCardContentSuspense'] : ['MemberDirectoryCardContentSuspense', variables];


useMemberDirectoryCardContentQuery.fetcher = (variables?: MemberDirectoryCardContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<MemberDirectoryCardContentQuery, MemberDirectoryCardContentQueryVariables>(MemberDirectoryCardContentDocument, variables, options);

export const StoreCardContentDocument = `
    query StoreCardContent {
  StoreCardPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      Image {
        AltText
        ImageReference {
          Url
        }
      }
      ContentCategory
      Title
      Description
      StoreUrl {
        LinkToContent
        DisplayText
        Target
      }
    }
  }
}
    `;

export const useStoreCardContentQuery = <
      TData = StoreCardContentQuery,
      TError = unknown
    >(
      variables?: StoreCardContentQueryVariables,
      options?: Omit<UseQueryOptions<StoreCardContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StoreCardContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<StoreCardContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['StoreCardContent'] : ['StoreCardContent', variables],
    queryFn: gqlFetcher<StoreCardContentQuery, StoreCardContentQueryVariables>(StoreCardContentDocument, variables),
    ...options
  }
    )};

useStoreCardContentQuery.getKey = (variables?: StoreCardContentQueryVariables) => variables === undefined ? ['StoreCardContent'] : ['StoreCardContent', variables];

export const useSuspenseStoreCardContentQuery = <
      TData = StoreCardContentQuery,
      TError = unknown
    >(
      variables?: StoreCardContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<StoreCardContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<StoreCardContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<StoreCardContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['StoreCardContentSuspense'] : ['StoreCardContentSuspense', variables],
    queryFn: gqlFetcher<StoreCardContentQuery, StoreCardContentQueryVariables>(StoreCardContentDocument, variables),
    ...options
  }
    )};

useSuspenseStoreCardContentQuery.getKey = (variables?: StoreCardContentQueryVariables) => variables === undefined ? ['StoreCardContentSuspense'] : ['StoreCardContentSuspense', variables];


useStoreCardContentQuery.fetcher = (variables?: StoreCardContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<StoreCardContentQuery, StoreCardContentQueryVariables>(StoreCardContentDocument, variables, options);

export const ToolsCardContentDocument = `
    query ToolsCardContent {
  ToolsCardPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      Title
      Description
      ContentCategory
      CardUrl {
        DisplayText
        LinkToContent
        Target
      }
      Image {
        AltText
        ImageReference {
          Url
        }
      }
    }
  }
}
    `;

export const useToolsCardContentQuery = <
      TData = ToolsCardContentQuery,
      TError = unknown
    >(
      variables?: ToolsCardContentQueryVariables,
      options?: Omit<UseQueryOptions<ToolsCardContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ToolsCardContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ToolsCardContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ToolsCardContent'] : ['ToolsCardContent', variables],
    queryFn: gqlFetcher<ToolsCardContentQuery, ToolsCardContentQueryVariables>(ToolsCardContentDocument, variables),
    ...options
  }
    )};

useToolsCardContentQuery.getKey = (variables?: ToolsCardContentQueryVariables) => variables === undefined ? ['ToolsCardContent'] : ['ToolsCardContent', variables];

export const useSuspenseToolsCardContentQuery = <
      TData = ToolsCardContentQuery,
      TError = unknown
    >(
      variables?: ToolsCardContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ToolsCardContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ToolsCardContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ToolsCardContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ToolsCardContentSuspense'] : ['ToolsCardContentSuspense', variables],
    queryFn: gqlFetcher<ToolsCardContentQuery, ToolsCardContentQueryVariables>(ToolsCardContentDocument, variables),
    ...options
  }
    )};

useSuspenseToolsCardContentQuery.getKey = (variables?: ToolsCardContentQueryVariables) => variables === undefined ? ['ToolsCardContentSuspense'] : ['ToolsCardContentSuspense', variables];


useToolsCardContentQuery.fetcher = (variables?: ToolsCardContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<ToolsCardContentQuery, ToolsCardContentQueryVariables>(ToolsCardContentDocument, variables, options);

export const DonationSectionContentDocument = `
    query DonationSectionContent($relativePath: String!) {
  HomePageV2(
    locale: ALL
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      AuthenticatedContent {
        ContentLink {
          Expanded {
            ... on DonationBlock {
              __typename
              DonateUrl {
                LinkToContent
                Target
                DisplayText
              }
              AnnualTabLabel
              LifetimeTabLabel
              AnnualChartAriaLabel
              LifetimeChartAriaLabel
              NoDonationsTitle
              NoDonationsDescription
              TabsSectionAriaLabel
              HelpText
              HelpTextJapan
              LifetimeTitleNoLevel
              LifetimeTitle
              LifetimeDescription
              AnnualTitleNoLevel
              AnnualTitle
              AnnualDescription
              AnnualDescriptionNoLevel
            }
          }
        }
      }
    }
  }
}
    `;

export const useDonationSectionContentQuery = <
      TData = DonationSectionContentQuery,
      TError = unknown
    >(
      variables: DonationSectionContentQueryVariables,
      options?: Omit<UseQueryOptions<DonationSectionContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DonationSectionContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DonationSectionContentQuery, TError, TData>(
      {
    queryKey: ['DonationSectionContent', variables],
    queryFn: gqlFetcher<DonationSectionContentQuery, DonationSectionContentQueryVariables>(DonationSectionContentDocument, variables),
    ...options
  }
    )};

useDonationSectionContentQuery.getKey = (variables: DonationSectionContentQueryVariables) => ['DonationSectionContent', variables];

export const useSuspenseDonationSectionContentQuery = <
      TData = DonationSectionContentQuery,
      TError = unknown
    >(
      variables: DonationSectionContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<DonationSectionContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<DonationSectionContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<DonationSectionContentQuery, TError, TData>(
      {
    queryKey: ['DonationSectionContentSuspense', variables],
    queryFn: gqlFetcher<DonationSectionContentQuery, DonationSectionContentQueryVariables>(DonationSectionContentDocument, variables),
    ...options
  }
    )};

useSuspenseDonationSectionContentQuery.getKey = (variables: DonationSectionContentQueryVariables) => ['DonationSectionContentSuspense', variables];


useDonationSectionContentQuery.fetcher = (variables: DonationSectionContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<DonationSectionContentQuery, DonationSectionContentQueryVariables>(DonationSectionContentDocument, variables, options);

export const HeroSectionContentDocument = `
    query HeroSectionContent($relativePath: String!) {
  HomePageV2(
    locale: ALL
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      MembershipYears
      DaysLeft
      FinishApplicationDisplayText
      RenewMembershipDisplayText
      UpgradeMembershipDisplayText
      ApplicationReceivedDisplayText
      ApplyForMembershipDisplayText
      MembershipPageLink {
        LinkToContent
      }
      AuthenticatedContent {
        ContentLink {
          Expanded {
            ... on ProfilePictureBlock {
              __typename
              Add
              Edit
              Upload
              PictureDescription
              Change
              Remove
              Save
              FileSizeHint
              FileSizeError
              FileTypeError
              ServerFileError
              ModalTitle
              ModalDescription
            }
          }
        }
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      Greeting
      MDRTId
      Close
      CompanyAdminButtonLabel
      CompanyAdminSectionDescriptionLabel
      CompanyAdminDashboardPage {
        Expanded {
          Url
        }
      }
    }
  }
}
    `;

export const useHeroSectionContentQuery = <
      TData = HeroSectionContentQuery,
      TError = unknown
    >(
      variables: HeroSectionContentQueryVariables,
      options?: Omit<UseQueryOptions<HeroSectionContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<HeroSectionContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<HeroSectionContentQuery, TError, TData>(
      {
    queryKey: ['HeroSectionContent', variables],
    queryFn: gqlFetcher<HeroSectionContentQuery, HeroSectionContentQueryVariables>(HeroSectionContentDocument, variables),
    ...options
  }
    )};

useHeroSectionContentQuery.getKey = (variables: HeroSectionContentQueryVariables) => ['HeroSectionContent', variables];

export const useSuspenseHeroSectionContentQuery = <
      TData = HeroSectionContentQuery,
      TError = unknown
    >(
      variables: HeroSectionContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<HeroSectionContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<HeroSectionContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<HeroSectionContentQuery, TError, TData>(
      {
    queryKey: ['HeroSectionContentSuspense', variables],
    queryFn: gqlFetcher<HeroSectionContentQuery, HeroSectionContentQueryVariables>(HeroSectionContentDocument, variables),
    ...options
  }
    )};

useSuspenseHeroSectionContentQuery.getKey = (variables: HeroSectionContentQueryVariables) => ['HeroSectionContentSuspense', variables];


useHeroSectionContentQuery.fetcher = (variables: HeroSectionContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<HeroSectionContentQuery, HeroSectionContentQueryVariables>(HeroSectionContentDocument, variables, options);

export const MembershipToolkitBlockContentDocument = `
    query MembershipToolkitBlockContent($guid: String!) {
  ToolkitBlock(ids: [$guid], where: {Status: {eq: "Published"}}) {
    items {
      __typename
      Language {
        Name
      }
      Title
      Description
      AnchorLink
      ...ToolkitItemVisibilityOptions
      Tabs {
        __typename
        ContentLink {
          Expanded {
            ... on ToolkitItemBlock {
              __typename
              Title
              Description
              Layout
              Sections {
                ContentLink {
                  Expanded {
                    ... on ToolkitSectionBlock {
                      __typename
                      Title
                      ...ToolkitSectionBlockVisibilityOptions
                      Items {
                        ContentLink {
                          Expanded {
                            ... on LinkBlock {
                              ...LinkBlock
                            }
                            ... on SvgLinkBlock {
                              ...SvgLinkBlock
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ToolkitItemVisibilityOptionsFragmentDoc}
${ToolkitSectionBlockVisibilityOptionsFragmentDoc}
${LinkBlockFragmentDoc}
${SvgLinkBlockFragmentDoc}`;

export const useMembershipToolkitBlockContentQuery = <
      TData = MembershipToolkitBlockContentQuery,
      TError = unknown
    >(
      variables: MembershipToolkitBlockContentQueryVariables,
      options?: Omit<UseQueryOptions<MembershipToolkitBlockContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MembershipToolkitBlockContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MembershipToolkitBlockContentQuery, TError, TData>(
      {
    queryKey: ['MembershipToolkitBlockContent', variables],
    queryFn: gqlFetcher<MembershipToolkitBlockContentQuery, MembershipToolkitBlockContentQueryVariables>(MembershipToolkitBlockContentDocument, variables),
    ...options
  }
    )};

useMembershipToolkitBlockContentQuery.getKey = (variables: MembershipToolkitBlockContentQueryVariables) => ['MembershipToolkitBlockContent', variables];

export const useSuspenseMembershipToolkitBlockContentQuery = <
      TData = MembershipToolkitBlockContentQuery,
      TError = unknown
    >(
      variables: MembershipToolkitBlockContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MembershipToolkitBlockContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MembershipToolkitBlockContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MembershipToolkitBlockContentQuery, TError, TData>(
      {
    queryKey: ['MembershipToolkitBlockContentSuspense', variables],
    queryFn: gqlFetcher<MembershipToolkitBlockContentQuery, MembershipToolkitBlockContentQueryVariables>(MembershipToolkitBlockContentDocument, variables),
    ...options
  }
    )};

useSuspenseMembershipToolkitBlockContentQuery.getKey = (variables: MembershipToolkitBlockContentQueryVariables) => ['MembershipToolkitBlockContentSuspense', variables];


useMembershipToolkitBlockContentQuery.fetcher = (variables: MembershipToolkitBlockContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<MembershipToolkitBlockContentQuery, MembershipToolkitBlockContentQueryVariables>(MembershipToolkitBlockContentDocument, variables, options);

export const MembershipToolkitBlockGuidDocument = `
    query MembershipToolkitBlockGuid {
  HomePageV2(
    locale: ALL
    where: {Status: {eq: "Published"}, Language: {Name: {eq: "en"}}}
  ) {
    items {
      __typename
      Language {
        Name
      }
      AuthenticatedContent {
        ContentLink {
          GuidValue
          Expanded {
            ... on ToolkitBlock {
              __typename
            }
          }
        }
      }
    }
  }
}
    `;

export const useMembershipToolkitBlockGuidQuery = <
      TData = MembershipToolkitBlockGuidQuery,
      TError = unknown
    >(
      variables?: MembershipToolkitBlockGuidQueryVariables,
      options?: Omit<UseQueryOptions<MembershipToolkitBlockGuidQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MembershipToolkitBlockGuidQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MembershipToolkitBlockGuidQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MembershipToolkitBlockGuid'] : ['MembershipToolkitBlockGuid', variables],
    queryFn: gqlFetcher<MembershipToolkitBlockGuidQuery, MembershipToolkitBlockGuidQueryVariables>(MembershipToolkitBlockGuidDocument, variables),
    ...options
  }
    )};

useMembershipToolkitBlockGuidQuery.getKey = (variables?: MembershipToolkitBlockGuidQueryVariables) => variables === undefined ? ['MembershipToolkitBlockGuid'] : ['MembershipToolkitBlockGuid', variables];

export const useSuspenseMembershipToolkitBlockGuidQuery = <
      TData = MembershipToolkitBlockGuidQuery,
      TError = unknown
    >(
      variables?: MembershipToolkitBlockGuidQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MembershipToolkitBlockGuidQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MembershipToolkitBlockGuidQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MembershipToolkitBlockGuidQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MembershipToolkitBlockGuidSuspense'] : ['MembershipToolkitBlockGuidSuspense', variables],
    queryFn: gqlFetcher<MembershipToolkitBlockGuidQuery, MembershipToolkitBlockGuidQueryVariables>(MembershipToolkitBlockGuidDocument, variables),
    ...options
  }
    )};

useSuspenseMembershipToolkitBlockGuidQuery.getKey = (variables?: MembershipToolkitBlockGuidQueryVariables) => variables === undefined ? ['MembershipToolkitBlockGuidSuspense'] : ['MembershipToolkitBlockGuidSuspense', variables];


useMembershipToolkitBlockGuidQuery.fetcher = (variables?: MembershipToolkitBlockGuidQueryVariables, options?: RequestInit['headers']) => gqlFetcher<MembershipToolkitBlockGuidQuery, MembershipToolkitBlockGuidQueryVariables>(MembershipToolkitBlockGuidDocument, variables, options);

export const ScoreSectionContentDocument = `
    query ScoreSectionContent($relativePath: String!) {
  HomePageV2(
    locale: ALL
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      AuthenticatedContent {
        ContentLink {
          Expanded {
            ... on GaugeBlock {
              __typename
              GaugeAriaLabel
              Relationships
              Health
              Education
              Career
              Service
              Financial
              Spiritual
              UpdateScoresLink {
                DisplayText
                LinkToContent
              }
              Headline
            }
          }
        }
      }
    }
  }
}
    `;

export const useScoreSectionContentQuery = <
      TData = ScoreSectionContentQuery,
      TError = unknown
    >(
      variables: ScoreSectionContentQueryVariables,
      options?: Omit<UseQueryOptions<ScoreSectionContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ScoreSectionContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ScoreSectionContentQuery, TError, TData>(
      {
    queryKey: ['ScoreSectionContent', variables],
    queryFn: gqlFetcher<ScoreSectionContentQuery, ScoreSectionContentQueryVariables>(ScoreSectionContentDocument, variables),
    ...options
  }
    )};

useScoreSectionContentQuery.getKey = (variables: ScoreSectionContentQueryVariables) => ['ScoreSectionContent', variables];

export const useSuspenseScoreSectionContentQuery = <
      TData = ScoreSectionContentQuery,
      TError = unknown
    >(
      variables: ScoreSectionContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ScoreSectionContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ScoreSectionContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ScoreSectionContentQuery, TError, TData>(
      {
    queryKey: ['ScoreSectionContentSuspense', variables],
    queryFn: gqlFetcher<ScoreSectionContentQuery, ScoreSectionContentQueryVariables>(ScoreSectionContentDocument, variables),
    ...options
  }
    )};

useSuspenseScoreSectionContentQuery.getKey = (variables: ScoreSectionContentQueryVariables) => ['ScoreSectionContentSuspense', variables];


useScoreSectionContentQuery.fetcher = (variables: ScoreSectionContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<ScoreSectionContentQuery, ScoreSectionContentQueryVariables>(ScoreSectionContentDocument, variables, options);

export const MemberResourcesCountDocument = `
    query MemberResourcesCount($where: LearnDetailPageWhereInput) {
  LearnDetailPage(where: $where) {
    total(all: true)
  }
}
    `;

export const useMemberResourcesCountQuery = <
      TData = MemberResourcesCountQuery,
      TError = unknown
    >(
      variables?: MemberResourcesCountQueryVariables,
      options?: Omit<UseQueryOptions<MemberResourcesCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MemberResourcesCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MemberResourcesCountQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MemberResourcesCount'] : ['MemberResourcesCount', variables],
    queryFn: gqlFetcher<MemberResourcesCountQuery, MemberResourcesCountQueryVariables>(MemberResourcesCountDocument, variables),
    ...options
  }
    )};

useMemberResourcesCountQuery.getKey = (variables?: MemberResourcesCountQueryVariables) => variables === undefined ? ['MemberResourcesCount'] : ['MemberResourcesCount', variables];

export const useSuspenseMemberResourcesCountQuery = <
      TData = MemberResourcesCountQuery,
      TError = unknown
    >(
      variables?: MemberResourcesCountQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MemberResourcesCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MemberResourcesCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MemberResourcesCountQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MemberResourcesCountSuspense'] : ['MemberResourcesCountSuspense', variables],
    queryFn: gqlFetcher<MemberResourcesCountQuery, MemberResourcesCountQueryVariables>(MemberResourcesCountDocument, variables),
    ...options
  }
    )};

useSuspenseMemberResourcesCountQuery.getKey = (variables?: MemberResourcesCountQueryVariables) => variables === undefined ? ['MemberResourcesCountSuspense'] : ['MemberResourcesCountSuspense', variables];


useMemberResourcesCountQuery.fetcher = (variables?: MemberResourcesCountQueryVariables, options?: RequestInit['headers']) => gqlFetcher<MemberResourcesCountQuery, MemberResourcesCountQueryVariables>(MemberResourcesCountDocument, variables, options);

export const PeopleListCmsContentDocument = `
    query PeopleListCmsContent {
  LearnPageV2(where: {Status: {eq: "Published"}}) {
    items {
      DetailPageMemberYearsSubheading
      DetailPageAuthorsHeading
      DetailPageMemberEmailButtonAriaLabelText
      DetailPageMemberDetailsButtonAriaLabelText
      DetailPageAuthorModalResoucesButtonLabelText
      DetailPageViewResourcesLinkLabelText
      Language {
        Name
      }
    }
  }
}
    `;

export const usePeopleListCmsContentQuery = <
      TData = PeopleListCmsContentQuery,
      TError = unknown
    >(
      variables?: PeopleListCmsContentQueryVariables,
      options?: Omit<UseQueryOptions<PeopleListCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PeopleListCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PeopleListCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PeopleListCmsContent'] : ['PeopleListCmsContent', variables],
    queryFn: gqlFetcher<PeopleListCmsContentQuery, PeopleListCmsContentQueryVariables>(PeopleListCmsContentDocument, variables),
    ...options
  }
    )};

usePeopleListCmsContentQuery.getKey = (variables?: PeopleListCmsContentQueryVariables) => variables === undefined ? ['PeopleListCmsContent'] : ['PeopleListCmsContent', variables];

export const useSuspensePeopleListCmsContentQuery = <
      TData = PeopleListCmsContentQuery,
      TError = unknown
    >(
      variables?: PeopleListCmsContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PeopleListCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PeopleListCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PeopleListCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PeopleListCmsContentSuspense'] : ['PeopleListCmsContentSuspense', variables],
    queryFn: gqlFetcher<PeopleListCmsContentQuery, PeopleListCmsContentQueryVariables>(PeopleListCmsContentDocument, variables),
    ...options
  }
    )};

useSuspensePeopleListCmsContentQuery.getKey = (variables?: PeopleListCmsContentQueryVariables) => variables === undefined ? ['PeopleListCmsContentSuspense'] : ['PeopleListCmsContentSuspense', variables];


usePeopleListCmsContentQuery.fetcher = (variables?: PeopleListCmsContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<PeopleListCmsContentQuery, PeopleListCmsContentQueryVariables>(PeopleListCmsContentDocument, variables, options);

export const ProfileListBlockTranslationsDocument = `
    query ProfileListBlockTranslations {
  LearnPageV2(where: {Status: {eq: "Published"}}) {
    items {
      DetailPageMemberYearsSubheading
      DetailPageMemberEmailButtonAriaLabelText
      DetailPageMemberDetailsButtonAriaLabelText
      DetailPageAuthorModalResoucesButtonLabelText
      Language {
        Name
      }
    }
  }
}
    `;

export const useProfileListBlockTranslationsQuery = <
      TData = ProfileListBlockTranslationsQuery,
      TError = unknown
    >(
      variables?: ProfileListBlockTranslationsQueryVariables,
      options?: Omit<UseQueryOptions<ProfileListBlockTranslationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProfileListBlockTranslationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProfileListBlockTranslationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ProfileListBlockTranslations'] : ['ProfileListBlockTranslations', variables],
    queryFn: gqlFetcher<ProfileListBlockTranslationsQuery, ProfileListBlockTranslationsQueryVariables>(ProfileListBlockTranslationsDocument, variables),
    ...options
  }
    )};

useProfileListBlockTranslationsQuery.getKey = (variables?: ProfileListBlockTranslationsQueryVariables) => variables === undefined ? ['ProfileListBlockTranslations'] : ['ProfileListBlockTranslations', variables];

export const useSuspenseProfileListBlockTranslationsQuery = <
      TData = ProfileListBlockTranslationsQuery,
      TError = unknown
    >(
      variables?: ProfileListBlockTranslationsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProfileListBlockTranslationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProfileListBlockTranslationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProfileListBlockTranslationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ProfileListBlockTranslationsSuspense'] : ['ProfileListBlockTranslationsSuspense', variables],
    queryFn: gqlFetcher<ProfileListBlockTranslationsQuery, ProfileListBlockTranslationsQueryVariables>(ProfileListBlockTranslationsDocument, variables),
    ...options
  }
    )};

useSuspenseProfileListBlockTranslationsQuery.getKey = (variables?: ProfileListBlockTranslationsQueryVariables) => variables === undefined ? ['ProfileListBlockTranslationsSuspense'] : ['ProfileListBlockTranslationsSuspense', variables];


useProfileListBlockTranslationsQuery.fetcher = (variables?: ProfileListBlockTranslationsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<ProfileListBlockTranslationsQuery, ProfileListBlockTranslationsQueryVariables>(ProfileListBlockTranslationsDocument, variables, options);

export const ProfileListFromGuidDocument = `
    query ProfileListFromGuid($guid: String) {
  ProfileListBlock(
    where: {ContentLink: {GuidValue: {eq: $guid}}, Status: {eq: "Published"}}
  ) {
    items {
      Language {
        Name
      }
      ProfileList {
        ContentLink {
          Expanded {
            __typename
            ... on PersonBlock {
              ...PersonBlock
            }
          }
        }
      }
    }
  }
}
    ${PersonBlockFragmentDoc}`;

export const useProfileListFromGuidQuery = <
      TData = ProfileListFromGuidQuery,
      TError = unknown
    >(
      variables?: ProfileListFromGuidQueryVariables,
      options?: Omit<UseQueryOptions<ProfileListFromGuidQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProfileListFromGuidQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProfileListFromGuidQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ProfileListFromGuid'] : ['ProfileListFromGuid', variables],
    queryFn: gqlFetcher<ProfileListFromGuidQuery, ProfileListFromGuidQueryVariables>(ProfileListFromGuidDocument, variables),
    ...options
  }
    )};

useProfileListFromGuidQuery.getKey = (variables?: ProfileListFromGuidQueryVariables) => variables === undefined ? ['ProfileListFromGuid'] : ['ProfileListFromGuid', variables];

export const useSuspenseProfileListFromGuidQuery = <
      TData = ProfileListFromGuidQuery,
      TError = unknown
    >(
      variables?: ProfileListFromGuidQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProfileListFromGuidQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProfileListFromGuidQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProfileListFromGuidQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ProfileListFromGuidSuspense'] : ['ProfileListFromGuidSuspense', variables],
    queryFn: gqlFetcher<ProfileListFromGuidQuery, ProfileListFromGuidQueryVariables>(ProfileListFromGuidDocument, variables),
    ...options
  }
    )};

useSuspenseProfileListFromGuidQuery.getKey = (variables?: ProfileListFromGuidQueryVariables) => variables === undefined ? ['ProfileListFromGuidSuspense'] : ['ProfileListFromGuidSuspense', variables];


useProfileListFromGuidQuery.fetcher = (variables?: ProfileListFromGuidQueryVariables, options?: RequestInit['headers']) => gqlFetcher<ProfileListFromGuidQuery, ProfileListFromGuidQueryVariables>(ProfileListFromGuidDocument, variables, options);

export const LearnDetailPageDocument = `
    query LearnDetailPage($relativePath: String!) {
  LearnDetailPage(
    where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}
    limit: 1
  ) {
    items {
      ...LearnDetailPage
    }
  }
}
    ${LearnDetailPageFragmentDoc}
${PageMainContentFragmentDoc}
${LearnCarouselBlockFragmentDoc}
${ProfileListLinkFragmentDoc}
${PersonBlockFragmentDoc}`;

export const useLearnDetailPageQuery = <
      TData = LearnDetailPageQuery,
      TError = unknown
    >(
      variables: LearnDetailPageQueryVariables,
      options?: Omit<UseQueryOptions<LearnDetailPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnDetailPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnDetailPageQuery, TError, TData>(
      {
    queryKey: ['LearnDetailPage', variables],
    queryFn: gqlFetcher<LearnDetailPageQuery, LearnDetailPageQueryVariables>(LearnDetailPageDocument, variables),
    ...options
  }
    )};

useLearnDetailPageQuery.getKey = (variables: LearnDetailPageQueryVariables) => ['LearnDetailPage', variables];

export const useSuspenseLearnDetailPageQuery = <
      TData = LearnDetailPageQuery,
      TError = unknown
    >(
      variables: LearnDetailPageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LearnDetailPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LearnDetailPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LearnDetailPageQuery, TError, TData>(
      {
    queryKey: ['LearnDetailPageSuspense', variables],
    queryFn: gqlFetcher<LearnDetailPageQuery, LearnDetailPageQueryVariables>(LearnDetailPageDocument, variables),
    ...options
  }
    )};

useSuspenseLearnDetailPageQuery.getKey = (variables: LearnDetailPageQueryVariables) => ['LearnDetailPageSuspense', variables];


useLearnDetailPageQuery.fetcher = (variables: LearnDetailPageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<LearnDetailPageQuery, LearnDetailPageQueryVariables>(LearnDetailPageDocument, variables, options);

export const LearnLandingPageFeaturedContentDocument = `
    query LearnLandingPageFeaturedContent($ids: [Int!]!, $locale: String) {
  LearnDetailPage(
    limit: 100
    where: {ContentLink: {Id: {in: $ids}}, Status: {eq: "Published"}, Language: {Name: {eq: $locale}}}
  ) {
    items {
      ...LearnContentCarouselCard
    }
  }
}
    ${LearnContentCarouselCardFragmentDoc}`;

export const useLearnLandingPageFeaturedContentQuery = <
      TData = LearnLandingPageFeaturedContentQuery,
      TError = unknown
    >(
      variables: LearnLandingPageFeaturedContentQueryVariables,
      options?: Omit<UseQueryOptions<LearnLandingPageFeaturedContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnLandingPageFeaturedContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnLandingPageFeaturedContentQuery, TError, TData>(
      {
    queryKey: ['LearnLandingPageFeaturedContent', variables],
    queryFn: gqlFetcher<LearnLandingPageFeaturedContentQuery, LearnLandingPageFeaturedContentQueryVariables>(LearnLandingPageFeaturedContentDocument, variables),
    ...options
  }
    )};

useLearnLandingPageFeaturedContentQuery.getKey = (variables: LearnLandingPageFeaturedContentQueryVariables) => ['LearnLandingPageFeaturedContent', variables];

export const useSuspenseLearnLandingPageFeaturedContentQuery = <
      TData = LearnLandingPageFeaturedContentQuery,
      TError = unknown
    >(
      variables: LearnLandingPageFeaturedContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LearnLandingPageFeaturedContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LearnLandingPageFeaturedContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LearnLandingPageFeaturedContentQuery, TError, TData>(
      {
    queryKey: ['LearnLandingPageFeaturedContentSuspense', variables],
    queryFn: gqlFetcher<LearnLandingPageFeaturedContentQuery, LearnLandingPageFeaturedContentQueryVariables>(LearnLandingPageFeaturedContentDocument, variables),
    ...options
  }
    )};

useSuspenseLearnLandingPageFeaturedContentQuery.getKey = (variables: LearnLandingPageFeaturedContentQueryVariables) => ['LearnLandingPageFeaturedContentSuspense', variables];


useLearnLandingPageFeaturedContentQuery.fetcher = (variables: LearnLandingPageFeaturedContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<LearnLandingPageFeaturedContentQuery, LearnLandingPageFeaturedContentQueryVariables>(LearnLandingPageFeaturedContentDocument, variables, options);

export const LearnLandingPageDocument = `
    query LearnLandingPage {
  LearnPageV2(where: {Status: {eq: "Published"}}) {
    items {
      SearchInputPlaceholder
      FeaturedContentViewNowLabelText
      SignInAlertText
      BrowseTopicsLabel
      SavedItemsLabel
      Language {
        Name
      }
      MainContent {
        ...PageMainContent
      }
      FeaturedContentIds {
        Id
      }
      FeaturedContent {
        ContentLink {
          Expanded {
            __typename
            ... on LearnDetailPage {
              ...LearnContentCarouselCard
            }
          }
        }
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      CreateAccountLabel
      LogInPrompt
    }
  }
}
    ${PageMainContentFragmentDoc}
${LearnCarouselBlockFragmentDoc}
${ProfileListLinkFragmentDoc}
${LearnContentCarouselCardFragmentDoc}`;

export const useLearnLandingPageQuery = <
      TData = LearnLandingPageQuery,
      TError = unknown
    >(
      variables?: LearnLandingPageQueryVariables,
      options?: Omit<UseQueryOptions<LearnLandingPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnLandingPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnLandingPageQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LearnLandingPage'] : ['LearnLandingPage', variables],
    queryFn: gqlFetcher<LearnLandingPageQuery, LearnLandingPageQueryVariables>(LearnLandingPageDocument, variables),
    ...options
  }
    )};

useLearnLandingPageQuery.getKey = (variables?: LearnLandingPageQueryVariables) => variables === undefined ? ['LearnLandingPage'] : ['LearnLandingPage', variables];

export const useSuspenseLearnLandingPageQuery = <
      TData = LearnLandingPageQuery,
      TError = unknown
    >(
      variables?: LearnLandingPageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LearnLandingPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LearnLandingPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LearnLandingPageQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LearnLandingPageSuspense'] : ['LearnLandingPageSuspense', variables],
    queryFn: gqlFetcher<LearnLandingPageQuery, LearnLandingPageQueryVariables>(LearnLandingPageDocument, variables),
    ...options
  }
    )};

useSuspenseLearnLandingPageQuery.getKey = (variables?: LearnLandingPageQueryVariables) => variables === undefined ? ['LearnLandingPageSuspense'] : ['LearnLandingPageSuspense', variables];


useLearnLandingPageQuery.fetcher = (variables?: LearnLandingPageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<LearnLandingPageQuery, LearnLandingPageQueryVariables>(LearnLandingPageDocument, variables, options);

export const DetailPageMainContentTranslationsDocument = `
    query DetailPageMainContentTranslations {
  LearnPageV2(where: {Status: {eq: "Published"}}) {
    items {
      DetailPageMemberYearsSubheading
      DetailPageAuthorsHeading
      DetailPageMemberEmailButtonAriaLabelText
      DetailPageMemberDetailsButtonAriaLabelText
      DetailPageAuthorModalResoucesButtonLabelText
      DetailPageVideoTranscriptAccordionButtonLabelText
      DetailPageViewResourcesLinkLabelText
      Language {
        Name
      }
    }
  }
  SiteSettingsPage {
    items {
      In
      Language {
        Name
      }
    }
  }
}
    `;

export const useDetailPageMainContentTranslationsQuery = <
      TData = DetailPageMainContentTranslationsQuery,
      TError = unknown
    >(
      variables?: DetailPageMainContentTranslationsQueryVariables,
      options?: Omit<UseQueryOptions<DetailPageMainContentTranslationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DetailPageMainContentTranslationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DetailPageMainContentTranslationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['DetailPageMainContentTranslations'] : ['DetailPageMainContentTranslations', variables],
    queryFn: gqlFetcher<DetailPageMainContentTranslationsQuery, DetailPageMainContentTranslationsQueryVariables>(DetailPageMainContentTranslationsDocument, variables),
    ...options
  }
    )};

useDetailPageMainContentTranslationsQuery.getKey = (variables?: DetailPageMainContentTranslationsQueryVariables) => variables === undefined ? ['DetailPageMainContentTranslations'] : ['DetailPageMainContentTranslations', variables];

export const useSuspenseDetailPageMainContentTranslationsQuery = <
      TData = DetailPageMainContentTranslationsQuery,
      TError = unknown
    >(
      variables?: DetailPageMainContentTranslationsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<DetailPageMainContentTranslationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<DetailPageMainContentTranslationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<DetailPageMainContentTranslationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['DetailPageMainContentTranslationsSuspense'] : ['DetailPageMainContentTranslationsSuspense', variables],
    queryFn: gqlFetcher<DetailPageMainContentTranslationsQuery, DetailPageMainContentTranslationsQueryVariables>(DetailPageMainContentTranslationsDocument, variables),
    ...options
  }
    )};

useSuspenseDetailPageMainContentTranslationsQuery.getKey = (variables?: DetailPageMainContentTranslationsQueryVariables) => variables === undefined ? ['DetailPageMainContentTranslationsSuspense'] : ['DetailPageMainContentTranslationsSuspense', variables];


useDetailPageMainContentTranslationsQuery.fetcher = (variables?: DetailPageMainContentTranslationsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<DetailPageMainContentTranslationsQuery, DetailPageMainContentTranslationsQueryVariables>(DetailPageMainContentTranslationsDocument, variables, options);

export const MemberDirectoryPageDocument = `
    query MemberDirectoryPage($relativePath: String!) {
  MemberDirectoryPage(
    orderBy: {Changed: DESC}
    where: {Status: {eq: "Published"}, RelativePath: {eq: $relativePath}}
  ) {
    items {
      Language {
        Name
      }
      Title
      MembersNearbyLabel
      ResultsForLabel
      SearchInputLabel
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      COTLevelLabel
      CityLabel
      CountryLabel
      MDRTLevelLabel
      MembershipLevelLabel
      NextPageLabel
      NoResultsLabel
      NoResultsLabel
      NoResultsMessage
      Pagination
      PreviousPageLabel
      SearchButtonLabel
      StateProvinceLabel
      TOTLevelLabel
      TotalItemsCountLabel
      BackToDashboard
    }
  }
}
    `;

export const useMemberDirectoryPageQuery = <
      TData = MemberDirectoryPageQuery,
      TError = unknown
    >(
      variables: MemberDirectoryPageQueryVariables,
      options?: Omit<UseQueryOptions<MemberDirectoryPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MemberDirectoryPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MemberDirectoryPageQuery, TError, TData>(
      {
    queryKey: ['MemberDirectoryPage', variables],
    queryFn: gqlFetcher<MemberDirectoryPageQuery, MemberDirectoryPageQueryVariables>(MemberDirectoryPageDocument, variables),
    ...options
  }
    )};

useMemberDirectoryPageQuery.getKey = (variables: MemberDirectoryPageQueryVariables) => ['MemberDirectoryPage', variables];

export const useSuspenseMemberDirectoryPageQuery = <
      TData = MemberDirectoryPageQuery,
      TError = unknown
    >(
      variables: MemberDirectoryPageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MemberDirectoryPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MemberDirectoryPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MemberDirectoryPageQuery, TError, TData>(
      {
    queryKey: ['MemberDirectoryPageSuspense', variables],
    queryFn: gqlFetcher<MemberDirectoryPageQuery, MemberDirectoryPageQueryVariables>(MemberDirectoryPageDocument, variables),
    ...options
  }
    )};

useSuspenseMemberDirectoryPageQuery.getKey = (variables: MemberDirectoryPageQueryVariables) => ['MemberDirectoryPageSuspense', variables];


useMemberDirectoryPageQuery.fetcher = (variables: MemberDirectoryPageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<MemberDirectoryPageQuery, MemberDirectoryPageQueryVariables>(MemberDirectoryPageDocument, variables, options);

export const MemberDirectoryProfilePageDocument = `
    query MemberDirectoryProfilePage($relativePath: String!) {
  PublicProfilePage(
    where: {Status: {eq: "Published"}, RelativePath: {eq: $relativePath}}
    orderBy: {Changed: DESC}
  ) {
    items {
      Language {
        Name
      }
      AchievementLevelLabel
      MembershipYearsLabel
      MembershipStatusLabel
      ContactInformationLabel
      LifeMembershipTypeLabel
      PictureDescription
      QualifyingLifeMembershipTypeLabel
      QualifyingMembershipTypeLabel
      BackToMemberDirectoryLabel
      YearsOfMembershipLevelLabel
      CommitteeSummaryCommitteeLabel
      YearLabel
      BirthdateLabel
      TotalPointsLabel
      CommitteeDetailCommitteeLabel
      AgeLabel
      AveragePercentageLabel
      RoleLabel
      IdLabel
      LeadershipLabel
      PointsPossibleLabel
      FoundationDonorLevelLabel
      JobsLabel
      PointsEarnedLabel
      FinalScoreLabel
      FirstLastMembershipLabel
      EngagementLabel
      DivisionLabel
      AnnualMeetingsCountLabel
      CommitteeSummaryTitleLabel
      CommitteeDetailTitleLabel
      AdditionalInformationTitleLabel
      GracePeriodIndicatorLabel
      GoToMemberDirectoryLabel
      MemberNotFoundErrorMessage
      GlobalConferenceMeetingsCountLabel
      BioLabel
      EmptyBioMessage
      FollowedTopicsLabel
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      BackLabel
      COTLevelLabel
      MDRTLevelLabel
      MembershipLevelLabel
      TOTLevelLabel
    }
  }
}
    `;

export const useMemberDirectoryProfilePageQuery = <
      TData = MemberDirectoryProfilePageQuery,
      TError = unknown
    >(
      variables: MemberDirectoryProfilePageQueryVariables,
      options?: Omit<UseQueryOptions<MemberDirectoryProfilePageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MemberDirectoryProfilePageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MemberDirectoryProfilePageQuery, TError, TData>(
      {
    queryKey: ['MemberDirectoryProfilePage', variables],
    queryFn: gqlFetcher<MemberDirectoryProfilePageQuery, MemberDirectoryProfilePageQueryVariables>(MemberDirectoryProfilePageDocument, variables),
    ...options
  }
    )};

useMemberDirectoryProfilePageQuery.getKey = (variables: MemberDirectoryProfilePageQueryVariables) => ['MemberDirectoryProfilePage', variables];

export const useSuspenseMemberDirectoryProfilePageQuery = <
      TData = MemberDirectoryProfilePageQuery,
      TError = unknown
    >(
      variables: MemberDirectoryProfilePageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MemberDirectoryProfilePageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MemberDirectoryProfilePageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MemberDirectoryProfilePageQuery, TError, TData>(
      {
    queryKey: ['MemberDirectoryProfilePageSuspense', variables],
    queryFn: gqlFetcher<MemberDirectoryProfilePageQuery, MemberDirectoryProfilePageQueryVariables>(MemberDirectoryProfilePageDocument, variables),
    ...options
  }
    )};

useSuspenseMemberDirectoryProfilePageQuery.getKey = (variables: MemberDirectoryProfilePageQueryVariables) => ['MemberDirectoryProfilePageSuspense', variables];


useMemberDirectoryProfilePageQuery.fetcher = (variables: MemberDirectoryProfilePageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<MemberDirectoryProfilePageQuery, MemberDirectoryProfilePageQueryVariables>(MemberDirectoryProfilePageDocument, variables, options);

export const MembershipInvoicePageDocument = `
    query MembershipInvoicePage($relativePath: String!) {
  MembershipInvoicePage(
    where: {Status: {eq: "Published"}, RelativePath: {eq: $relativePath}}
  ) {
    items {
      Language {
        Name
      }
      PrintButtonLabel
      HeaderTitleText
      HeaderAddressText
      HeaderPhoneText
      InvoiceHeader
      MemberDetailsHeader
      MemberNameLabel
      MdrtIdLabel
      PhoneNumberLabel
      CompanyNameLabel
      ApplicationDetailsHeader
      ApplicationDetailsHeader
      TermsAndConditionsLabel
      EthicsComplaintLabel
      DisabilityRequestedLabel
      MembershipTypeLabel
      AttestToProduction
      PaymentDetailsHeader
      PaymentDateLabel
      OrderNumberLabel
      PaymentMethodLabel
      PriceBreakdownHeader
      CompanyPrePaymentLabel
      SelfPrePaymentLabel
      BackDuesLabel
      LateFeeLabel
      AdditionalFilingFeesLabel
      TotalAmountPaidLabel
    }
  }
  SiteSettingsPage {
    items {
      Language {
        Name
      }
      MDRTLevelLabel
      COTLevelLabel
      TOTLevelLabel
      BackLabel
      AccountSettingsPageReference {
        Expanded {
          RelativePath
        }
      }
    }
  }
}
    `;

export const useMembershipInvoicePageQuery = <
      TData = MembershipInvoicePageQuery,
      TError = unknown
    >(
      variables: MembershipInvoicePageQueryVariables,
      options?: Omit<UseQueryOptions<MembershipInvoicePageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MembershipInvoicePageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MembershipInvoicePageQuery, TError, TData>(
      {
    queryKey: ['MembershipInvoicePage', variables],
    queryFn: gqlFetcher<MembershipInvoicePageQuery, MembershipInvoicePageQueryVariables>(MembershipInvoicePageDocument, variables),
    ...options
  }
    )};

useMembershipInvoicePageQuery.getKey = (variables: MembershipInvoicePageQueryVariables) => ['MembershipInvoicePage', variables];

export const useSuspenseMembershipInvoicePageQuery = <
      TData = MembershipInvoicePageQuery,
      TError = unknown
    >(
      variables: MembershipInvoicePageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MembershipInvoicePageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MembershipInvoicePageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MembershipInvoicePageQuery, TError, TData>(
      {
    queryKey: ['MembershipInvoicePageSuspense', variables],
    queryFn: gqlFetcher<MembershipInvoicePageQuery, MembershipInvoicePageQueryVariables>(MembershipInvoicePageDocument, variables),
    ...options
  }
    )};

useSuspenseMembershipInvoicePageQuery.getKey = (variables: MembershipInvoicePageQueryVariables) => ['MembershipInvoicePageSuspense', variables];


useMembershipInvoicePageQuery.fetcher = (variables: MembershipInvoicePageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<MembershipInvoicePageQuery, MembershipInvoicePageQueryVariables>(MembershipInvoicePageDocument, variables, options);

export const PersonQuizPageDocument = `
    query PersonQuizPage($relativePath: String!) {
  PersonQuizPage(
    orderBy: {Changed: DESC}
    where: {Status: {eq: "Published"}, RelativePath: {eq: $relativePath}}
  ) {
    items {
      Language {
        Name
      }
      Title
      Description
      SliderInfo
      Relationships {
        Title
        TopicDescription
        Questions {
          ...questionFields
        }
      }
      Health {
        Title
        TopicDescription
        Questions {
          ...questionFields
        }
      }
      Education {
        Title
        TopicDescription
        Questions {
          ...questionFields
        }
      }
      Career {
        Title
        TopicDescription
        Questions {
          ...questionFields
        }
      }
      Service {
        Title
        TopicDescription
        Questions {
          ...questionFields
        }
      }
      Financial {
        Title
        TopicDescription
        Questions {
          ...questionFields
        }
      }
      Spiritual {
        Title
        TopicDescription
        Questions {
          ...questionFields
        }
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      BackToDashboard
    }
  }
}
    ${QuestionFieldsFragmentDoc}`;

export const usePersonQuizPageQuery = <
      TData = PersonQuizPageQuery,
      TError = unknown
    >(
      variables: PersonQuizPageQueryVariables,
      options?: Omit<UseQueryOptions<PersonQuizPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonQuizPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonQuizPageQuery, TError, TData>(
      {
    queryKey: ['PersonQuizPage', variables],
    queryFn: gqlFetcher<PersonQuizPageQuery, PersonQuizPageQueryVariables>(PersonQuizPageDocument, variables),
    ...options
  }
    )};

usePersonQuizPageQuery.getKey = (variables: PersonQuizPageQueryVariables) => ['PersonQuizPage', variables];

export const useSuspensePersonQuizPageQuery = <
      TData = PersonQuizPageQuery,
      TError = unknown
    >(
      variables: PersonQuizPageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PersonQuizPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PersonQuizPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PersonQuizPageQuery, TError, TData>(
      {
    queryKey: ['PersonQuizPageSuspense', variables],
    queryFn: gqlFetcher<PersonQuizPageQuery, PersonQuizPageQueryVariables>(PersonQuizPageDocument, variables),
    ...options
  }
    )};

useSuspensePersonQuizPageQuery.getKey = (variables: PersonQuizPageQueryVariables) => ['PersonQuizPageSuspense', variables];


usePersonQuizPageQuery.fetcher = (variables: PersonQuizPageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<PersonQuizPageQuery, PersonQuizPageQueryVariables>(PersonQuizPageDocument, variables, options);

export const SearchCmsContentDocument = `
    query SearchCmsContent {
  SearchPageV2(where: {Status: {eq: "Published"}}) {
    items {
      SearchInputClearButtonLabel
      SearchInputPlaceholder
      TotalResultsLabel
      AllResourcesLabel
      ArticlesLabel
      AudioLabel
      VideosLabel
      GuidesLabel
      FiltersLabel
      SourceLabel
      TopicLabel
      FilterResultsLabel
      AuthorFeaturedPersonLabel
      YearLabel
      NoResultsFoundText
      SignInLabel
      IfNotMemberText
      CheckYourSpellingText
      Language {
        Name
      }
      SavedContentLabel
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      NextPageLabel
      PreviousPageLabel
      TotalItemsCountLabel
      Pagination
      Close
      Reset
      MinutesLabel
      MembersOnlyLabel
      LockedResourceModalHeading
      LockedResourceModalSubheading
      LoginLinkLabel
      CancelLabel
    }
  }
  LearnPageV2(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      SignInAlertText
    }
  }
}
    `;

export const useSearchCmsContentQuery = <
      TData = SearchCmsContentQuery,
      TError = unknown
    >(
      variables?: SearchCmsContentQueryVariables,
      options?: Omit<UseQueryOptions<SearchCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SearchCmsContent'] : ['SearchCmsContent', variables],
    queryFn: gqlFetcher<SearchCmsContentQuery, SearchCmsContentQueryVariables>(SearchCmsContentDocument, variables),
    ...options
  }
    )};

useSearchCmsContentQuery.getKey = (variables?: SearchCmsContentQueryVariables) => variables === undefined ? ['SearchCmsContent'] : ['SearchCmsContent', variables];

export const useSuspenseSearchCmsContentQuery = <
      TData = SearchCmsContentQuery,
      TError = unknown
    >(
      variables?: SearchCmsContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<SearchCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<SearchCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<SearchCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SearchCmsContentSuspense'] : ['SearchCmsContentSuspense', variables],
    queryFn: gqlFetcher<SearchCmsContentQuery, SearchCmsContentQueryVariables>(SearchCmsContentDocument, variables),
    ...options
  }
    )};

useSuspenseSearchCmsContentQuery.getKey = (variables?: SearchCmsContentQueryVariables) => variables === undefined ? ['SearchCmsContentSuspense'] : ['SearchCmsContentSuspense', variables];


useSearchCmsContentQuery.fetcher = (variables?: SearchCmsContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<SearchCmsContentQuery, SearchCmsContentQueryVariables>(SearchCmsContentDocument, variables, options);

export const GetResourceNameDocument = `
    query GetResourceName($resource_guid: String) {
  LearnDetailPage(
    where: {ContentLink: {GuidValue: {eq: $resource_guid}}, Status: {eq: "Published"}}
  ) {
    items {
      Heading
      Language {
        Name
      }
    }
  }
}
    `;

export const useGetResourceNameQuery = <
      TData = GetResourceNameQuery,
      TError = unknown
    >(
      variables?: GetResourceNameQueryVariables,
      options?: Omit<UseQueryOptions<GetResourceNameQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetResourceNameQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetResourceNameQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetResourceName'] : ['GetResourceName', variables],
    queryFn: gqlFetcher<GetResourceNameQuery, GetResourceNameQueryVariables>(GetResourceNameDocument, variables),
    ...options
  }
    )};

useGetResourceNameQuery.getKey = (variables?: GetResourceNameQueryVariables) => variables === undefined ? ['GetResourceName'] : ['GetResourceName', variables];

export const useSuspenseGetResourceNameQuery = <
      TData = GetResourceNameQuery,
      TError = unknown
    >(
      variables?: GetResourceNameQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<GetResourceNameQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<GetResourceNameQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<GetResourceNameQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetResourceNameSuspense'] : ['GetResourceNameSuspense', variables],
    queryFn: gqlFetcher<GetResourceNameQuery, GetResourceNameQueryVariables>(GetResourceNameDocument, variables),
    ...options
  }
    )};

useSuspenseGetResourceNameQuery.getKey = (variables?: GetResourceNameQueryVariables) => variables === undefined ? ['GetResourceNameSuspense'] : ['GetResourceNameSuspense', variables];


useGetResourceNameQuery.fetcher = (variables?: GetResourceNameQueryVariables, options?: RequestInit['headers']) => gqlFetcher<GetResourceNameQuery, GetResourceNameQueryVariables>(GetResourceNameDocument, variables, options);

export const LearnContentCarouselCardDocument = `
    query LearnContentCarouselCard($learn_content_guids: [String], $locale: String) {
  LearnDetailPage(
    limit: 100
    where: {ContentLink: {GuidValue: {in: $learn_content_guids}}, Status: {eq: "Published"}, Language: {Name: {eq: $locale}}}
  ) {
    items {
      ...LearnContentCarouselCard
    }
  }
}
    ${LearnContentCarouselCardFragmentDoc}`;

export const useLearnContentCarouselCardQuery = <
      TData = LearnContentCarouselCardQuery,
      TError = unknown
    >(
      variables?: LearnContentCarouselCardQueryVariables,
      options?: Omit<UseQueryOptions<LearnContentCarouselCardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnContentCarouselCardQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnContentCarouselCardQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LearnContentCarouselCard'] : ['LearnContentCarouselCard', variables],
    queryFn: gqlFetcher<LearnContentCarouselCardQuery, LearnContentCarouselCardQueryVariables>(LearnContentCarouselCardDocument, variables),
    ...options
  }
    )};

useLearnContentCarouselCardQuery.getKey = (variables?: LearnContentCarouselCardQueryVariables) => variables === undefined ? ['LearnContentCarouselCard'] : ['LearnContentCarouselCard', variables];

export const useSuspenseLearnContentCarouselCardQuery = <
      TData = LearnContentCarouselCardQuery,
      TError = unknown
    >(
      variables?: LearnContentCarouselCardQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LearnContentCarouselCardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LearnContentCarouselCardQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LearnContentCarouselCardQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LearnContentCarouselCardSuspense'] : ['LearnContentCarouselCardSuspense', variables],
    queryFn: gqlFetcher<LearnContentCarouselCardQuery, LearnContentCarouselCardQueryVariables>(LearnContentCarouselCardDocument, variables),
    ...options
  }
    )};

useSuspenseLearnContentCarouselCardQuery.getKey = (variables?: LearnContentCarouselCardQueryVariables) => variables === undefined ? ['LearnContentCarouselCardSuspense'] : ['LearnContentCarouselCardSuspense', variables];


useLearnContentCarouselCardQuery.fetcher = (variables?: LearnContentCarouselCardQueryVariables, options?: RequestInit['headers']) => gqlFetcher<LearnContentCarouselCardQuery, LearnContentCarouselCardQueryVariables>(LearnContentCarouselCardDocument, variables, options);

export const LearnContentCarouselDocument = `
    query LearnContentCarousel($carousel_guids: [String]) {
  LearnCarouselContainerBlockV2(
    limit: 100
    where: {ContentLink: {GuidValue: {in: $carousel_guids}}, Status: {eq: "Published"}}
  ) {
    items {
      ...LearnCarouselBlock
    }
  }
}
    ${LearnCarouselBlockFragmentDoc}`;

export const useLearnContentCarouselQuery = <
      TData = LearnContentCarouselQuery,
      TError = unknown
    >(
      variables?: LearnContentCarouselQueryVariables,
      options?: Omit<UseQueryOptions<LearnContentCarouselQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnContentCarouselQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnContentCarouselQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LearnContentCarousel'] : ['LearnContentCarousel', variables],
    queryFn: gqlFetcher<LearnContentCarouselQuery, LearnContentCarouselQueryVariables>(LearnContentCarouselDocument, variables),
    ...options
  }
    )};

useLearnContentCarouselQuery.getKey = (variables?: LearnContentCarouselQueryVariables) => variables === undefined ? ['LearnContentCarousel'] : ['LearnContentCarousel', variables];

export const useSuspenseLearnContentCarouselQuery = <
      TData = LearnContentCarouselQuery,
      TError = unknown
    >(
      variables?: LearnContentCarouselQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LearnContentCarouselQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LearnContentCarouselQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LearnContentCarouselQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LearnContentCarouselSuspense'] : ['LearnContentCarouselSuspense', variables],
    queryFn: gqlFetcher<LearnContentCarouselQuery, LearnContentCarouselQueryVariables>(LearnContentCarouselDocument, variables),
    ...options
  }
    )};

useSuspenseLearnContentCarouselQuery.getKey = (variables?: LearnContentCarouselQueryVariables) => variables === undefined ? ['LearnContentCarouselSuspense'] : ['LearnContentCarouselSuspense', variables];


useLearnContentCarouselQuery.fetcher = (variables?: LearnContentCarouselQueryVariables, options?: RequestInit['headers']) => gqlFetcher<LearnContentCarouselQuery, LearnContentCarouselQueryVariables>(LearnContentCarouselDocument, variables, options);

export const LearnGenericTextsCmsContentDocument = `
    query LearnGenericTextsCmsContent {
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      Number
      Close
      MenuTrigger
      MinutesLabel
      AccountLinkLabel
      AccountSettingsPageReference {
        Expanded {
          RelativePath
        }
      }
      SignInToViewLabel
      MembersOnlyLabel
      LockedResourceModalHeading
      LockedResourceModalSubheading
      LoginLinkLabel
      CancelLabel
    }
  }
}
    `;

export const useLearnGenericTextsCmsContentQuery = <
      TData = LearnGenericTextsCmsContentQuery,
      TError = unknown
    >(
      variables?: LearnGenericTextsCmsContentQueryVariables,
      options?: Omit<UseQueryOptions<LearnGenericTextsCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnGenericTextsCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnGenericTextsCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LearnGenericTextsCmsContent'] : ['LearnGenericTextsCmsContent', variables],
    queryFn: gqlFetcher<LearnGenericTextsCmsContentQuery, LearnGenericTextsCmsContentQueryVariables>(LearnGenericTextsCmsContentDocument, variables),
    ...options
  }
    )};

useLearnGenericTextsCmsContentQuery.getKey = (variables?: LearnGenericTextsCmsContentQueryVariables) => variables === undefined ? ['LearnGenericTextsCmsContent'] : ['LearnGenericTextsCmsContent', variables];

export const useSuspenseLearnGenericTextsCmsContentQuery = <
      TData = LearnGenericTextsCmsContentQuery,
      TError = unknown
    >(
      variables?: LearnGenericTextsCmsContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LearnGenericTextsCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LearnGenericTextsCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LearnGenericTextsCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LearnGenericTextsCmsContentSuspense'] : ['LearnGenericTextsCmsContentSuspense', variables],
    queryFn: gqlFetcher<LearnGenericTextsCmsContentQuery, LearnGenericTextsCmsContentQueryVariables>(LearnGenericTextsCmsContentDocument, variables),
    ...options
  }
    )};

useSuspenseLearnGenericTextsCmsContentQuery.getKey = (variables?: LearnGenericTextsCmsContentQueryVariables) => variables === undefined ? ['LearnGenericTextsCmsContentSuspense'] : ['LearnGenericTextsCmsContentSuspense', variables];


useLearnGenericTextsCmsContentQuery.fetcher = (variables?: LearnGenericTextsCmsContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<LearnGenericTextsCmsContentQuery, LearnGenericTextsCmsContentQueryVariables>(LearnGenericTextsCmsContentDocument, variables, options);

export const BookmarkButtonCmsContentDocument = `
    query BookmarkButtonCmsContent {
  HomePageV2(locale: ALL, where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      AudioContentCategory
      VideoContentCategory
      GuideContentCategory
      ArticleContentCategory
    }
  }
  SiteSettingsPage(locale: ALL, where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      AddBookmarkAriaLabel
      RemoveBookmarkAriaLabel
      AddBookmarkSuccessMessage
      RemoveBookmarkSuccessMessage
    }
  }
}
    `;

export const useBookmarkButtonCmsContentQuery = <
      TData = BookmarkButtonCmsContentQuery,
      TError = unknown
    >(
      variables?: BookmarkButtonCmsContentQueryVariables,
      options?: Omit<UseQueryOptions<BookmarkButtonCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BookmarkButtonCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BookmarkButtonCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['BookmarkButtonCmsContent'] : ['BookmarkButtonCmsContent', variables],
    queryFn: gqlFetcher<BookmarkButtonCmsContentQuery, BookmarkButtonCmsContentQueryVariables>(BookmarkButtonCmsContentDocument, variables),
    ...options
  }
    )};

useBookmarkButtonCmsContentQuery.getKey = (variables?: BookmarkButtonCmsContentQueryVariables) => variables === undefined ? ['BookmarkButtonCmsContent'] : ['BookmarkButtonCmsContent', variables];

export const useSuspenseBookmarkButtonCmsContentQuery = <
      TData = BookmarkButtonCmsContentQuery,
      TError = unknown
    >(
      variables?: BookmarkButtonCmsContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<BookmarkButtonCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<BookmarkButtonCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<BookmarkButtonCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['BookmarkButtonCmsContentSuspense'] : ['BookmarkButtonCmsContentSuspense', variables],
    queryFn: gqlFetcher<BookmarkButtonCmsContentQuery, BookmarkButtonCmsContentQueryVariables>(BookmarkButtonCmsContentDocument, variables),
    ...options
  }
    )};

useSuspenseBookmarkButtonCmsContentQuery.getKey = (variables?: BookmarkButtonCmsContentQueryVariables) => variables === undefined ? ['BookmarkButtonCmsContentSuspense'] : ['BookmarkButtonCmsContentSuspense', variables];


useBookmarkButtonCmsContentQuery.fetcher = (variables?: BookmarkButtonCmsContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<BookmarkButtonCmsContentQuery, BookmarkButtonCmsContentQueryVariables>(BookmarkButtonCmsContentDocument, variables, options);

export const HeaderContentDocument = `
    query HeaderContent {
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      BecomeMemberLabel
      RenewNowLabel
      HomeLabel
    }
  }
  HomePageV2(locale: ALL, where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      MembershipPageLink {
        LinkToContent
      }
    }
  }
}
    `;

export const useHeaderContentQuery = <
      TData = HeaderContentQuery,
      TError = unknown
    >(
      variables?: HeaderContentQueryVariables,
      options?: Omit<UseQueryOptions<HeaderContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<HeaderContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<HeaderContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['HeaderContent'] : ['HeaderContent', variables],
    queryFn: gqlFetcher<HeaderContentQuery, HeaderContentQueryVariables>(HeaderContentDocument, variables),
    ...options
  }
    )};

useHeaderContentQuery.getKey = (variables?: HeaderContentQueryVariables) => variables === undefined ? ['HeaderContent'] : ['HeaderContent', variables];

export const useSuspenseHeaderContentQuery = <
      TData = HeaderContentQuery,
      TError = unknown
    >(
      variables?: HeaderContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<HeaderContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<HeaderContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<HeaderContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['HeaderContentSuspense'] : ['HeaderContentSuspense', variables],
    queryFn: gqlFetcher<HeaderContentQuery, HeaderContentQueryVariables>(HeaderContentDocument, variables),
    ...options
  }
    )};

useSuspenseHeaderContentQuery.getKey = (variables?: HeaderContentQueryVariables) => variables === undefined ? ['HeaderContentSuspense'] : ['HeaderContentSuspense', variables];


useHeaderContentQuery.fetcher = (variables?: HeaderContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<HeaderContentQuery, HeaderContentQueryVariables>(HeaderContentDocument, variables, options);

export const HeaderNavigationLinksDocument = `
    query HeaderNavigationLinks {
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Name
      Language {
        Name
      }
      MenuLink {
        ContentLink {
          Expanded {
            ...NextStaticPage
            ...LandingPage
            ...LearnPageV2
            ...MemberDirectoryPage
          }
          GuidValue
        }
      }
    }
  }
}
    ${NextStaticPageFragmentDoc}
${AccordionContainerBlockAnchorFragmentFragmentDoc}
${ImageTextBlockAnchorFragmentFragmentDoc}
${MembershipRequirementsBlockAnchorFragmentFragmentDoc}
${NextCallOutBlockAnchorFragmentFragmentDoc}
${NextContainerBlockAnchorFragmentFragmentDoc}
${NextHeroBlockAnchorFragmentFragmentDoc}
${RichTextBlockAnchorFragmentFragmentDoc}
${NextEventBlockAnchorFragmentFragmentDoc}
${NextContactUsBlockAnchorFragmentFragmentDoc}
${LandingPageFragmentDoc}
${LearnPageV2FragmentDoc}
${MemberDirectoryPageFragmentDoc}`;

export const useHeaderNavigationLinksQuery = <
      TData = HeaderNavigationLinksQuery,
      TError = unknown
    >(
      variables?: HeaderNavigationLinksQueryVariables,
      options?: Omit<UseQueryOptions<HeaderNavigationLinksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<HeaderNavigationLinksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<HeaderNavigationLinksQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['HeaderNavigationLinks'] : ['HeaderNavigationLinks', variables],
    queryFn: gqlFetcher<HeaderNavigationLinksQuery, HeaderNavigationLinksQueryVariables>(HeaderNavigationLinksDocument, variables),
    ...options
  }
    )};

useHeaderNavigationLinksQuery.getKey = (variables?: HeaderNavigationLinksQueryVariables) => variables === undefined ? ['HeaderNavigationLinks'] : ['HeaderNavigationLinks', variables];

export const useSuspenseHeaderNavigationLinksQuery = <
      TData = HeaderNavigationLinksQuery,
      TError = unknown
    >(
      variables?: HeaderNavigationLinksQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<HeaderNavigationLinksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<HeaderNavigationLinksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<HeaderNavigationLinksQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['HeaderNavigationLinksSuspense'] : ['HeaderNavigationLinksSuspense', variables],
    queryFn: gqlFetcher<HeaderNavigationLinksQuery, HeaderNavigationLinksQueryVariables>(HeaderNavigationLinksDocument, variables),
    ...options
  }
    )};

useSuspenseHeaderNavigationLinksQuery.getKey = (variables?: HeaderNavigationLinksQueryVariables) => variables === undefined ? ['HeaderNavigationLinksSuspense'] : ['HeaderNavigationLinksSuspense', variables];


useHeaderNavigationLinksQuery.fetcher = (variables?: HeaderNavigationLinksQueryVariables, options?: RequestInit['headers']) => gqlFetcher<HeaderNavigationLinksQuery, HeaderNavigationLinksQueryVariables>(HeaderNavigationLinksDocument, variables, options);

export const HeaderProfileDropdownContentDocument = `
    query HeaderProfileDropdownContent {
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      MDRTId
      AccountLinkLabel
      BecomeMemberLabel
      AdminDashboardPageLinkLabel
      AdminDashboardPage {
        Expanded {
          RelativePath
        }
      }
      AccountSettingsPageReference {
        Expanded {
          RelativePath
        }
      }
      ImpersonationLinkLabel
      CompanyAdminDashboardPageLinkLabel
      CompanyAdminDashboardPage {
        Expanded {
          Url
        }
      }
      SelectLanguageLine
      ProfileDropdownTriggerAriaLabel
      ProfileDropdownAriaLabel
      ImpersonateModalTitle
      ImpersonateModalDescription
      ImpersonateModalPersonIDLabel
      ImpersonateModalButtonLabel
      ImpersonateModalErrorMessage
    }
  }
}
    `;

export const useHeaderProfileDropdownContentQuery = <
      TData = HeaderProfileDropdownContentQuery,
      TError = unknown
    >(
      variables?: HeaderProfileDropdownContentQueryVariables,
      options?: Omit<UseQueryOptions<HeaderProfileDropdownContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<HeaderProfileDropdownContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<HeaderProfileDropdownContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['HeaderProfileDropdownContent'] : ['HeaderProfileDropdownContent', variables],
    queryFn: gqlFetcher<HeaderProfileDropdownContentQuery, HeaderProfileDropdownContentQueryVariables>(HeaderProfileDropdownContentDocument, variables),
    ...options
  }
    )};

useHeaderProfileDropdownContentQuery.getKey = (variables?: HeaderProfileDropdownContentQueryVariables) => variables === undefined ? ['HeaderProfileDropdownContent'] : ['HeaderProfileDropdownContent', variables];

export const useSuspenseHeaderProfileDropdownContentQuery = <
      TData = HeaderProfileDropdownContentQuery,
      TError = unknown
    >(
      variables?: HeaderProfileDropdownContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<HeaderProfileDropdownContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<HeaderProfileDropdownContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<HeaderProfileDropdownContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['HeaderProfileDropdownContentSuspense'] : ['HeaderProfileDropdownContentSuspense', variables],
    queryFn: gqlFetcher<HeaderProfileDropdownContentQuery, HeaderProfileDropdownContentQueryVariables>(HeaderProfileDropdownContentDocument, variables),
    ...options
  }
    )};

useSuspenseHeaderProfileDropdownContentQuery.getKey = (variables?: HeaderProfileDropdownContentQueryVariables) => variables === undefined ? ['HeaderProfileDropdownContentSuspense'] : ['HeaderProfileDropdownContentSuspense', variables];


useHeaderProfileDropdownContentQuery.fetcher = (variables?: HeaderProfileDropdownContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<HeaderProfileDropdownContentQuery, HeaderProfileDropdownContentQueryVariables>(HeaderProfileDropdownContentDocument, variables, options);

export const MembershipLevelBadgeContentDocument = `
    query MembershipLevelBadgeContent {
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      COTLevelLabel
      MDRTLevelLabel
      TOTLevelLabel
    }
  }
}
    `;

export const useMembershipLevelBadgeContentQuery = <
      TData = MembershipLevelBadgeContentQuery,
      TError = unknown
    >(
      variables?: MembershipLevelBadgeContentQueryVariables,
      options?: Omit<UseQueryOptions<MembershipLevelBadgeContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MembershipLevelBadgeContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MembershipLevelBadgeContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MembershipLevelBadgeContent'] : ['MembershipLevelBadgeContent', variables],
    queryFn: gqlFetcher<MembershipLevelBadgeContentQuery, MembershipLevelBadgeContentQueryVariables>(MembershipLevelBadgeContentDocument, variables),
    ...options
  }
    )};

useMembershipLevelBadgeContentQuery.getKey = (variables?: MembershipLevelBadgeContentQueryVariables) => variables === undefined ? ['MembershipLevelBadgeContent'] : ['MembershipLevelBadgeContent', variables];

export const useSuspenseMembershipLevelBadgeContentQuery = <
      TData = MembershipLevelBadgeContentQuery,
      TError = unknown
    >(
      variables?: MembershipLevelBadgeContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MembershipLevelBadgeContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MembershipLevelBadgeContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MembershipLevelBadgeContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MembershipLevelBadgeContentSuspense'] : ['MembershipLevelBadgeContentSuspense', variables],
    queryFn: gqlFetcher<MembershipLevelBadgeContentQuery, MembershipLevelBadgeContentQueryVariables>(MembershipLevelBadgeContentDocument, variables),
    ...options
  }
    )};

useSuspenseMembershipLevelBadgeContentQuery.getKey = (variables?: MembershipLevelBadgeContentQueryVariables) => variables === undefined ? ['MembershipLevelBadgeContentSuspense'] : ['MembershipLevelBadgeContentSuspense', variables];


useMembershipLevelBadgeContentQuery.fetcher = (variables?: MembershipLevelBadgeContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<MembershipLevelBadgeContentQuery, MembershipLevelBadgeContentQueryVariables>(MembershipLevelBadgeContentDocument, variables, options);

export const PlayerCmsContentDocument = `
    query PlayerCmsContent {
  SiteSettingsPage {
    items {
      Language {
        Name
      }
      AccessibilityLabel
      AirPlayLabel
      AudioLabel
      BoostLabel
      AnnouncementsLabel
      ContinueLabel
      EnterFullscreenLabel
      ExitFullscreenLabel
      FullscreenLabel
      GoogleCastLabel
      KeyboardAnimationsLabel
      LoopLabel
      MuteLabel
      NormalLabel
      OffLabel
      PauseLabel
      PlayLabel
      PlaybackLabel
      ReplayLabel
      SeekBackwardLabel
      SeekForwardLabel
      SeekLabel
      SettingsLabel
      SpeedLabel
      UnmuteLabel
      VolumeLabel
    }
  }
}
    `;

export const usePlayerCmsContentQuery = <
      TData = PlayerCmsContentQuery,
      TError = unknown
    >(
      variables?: PlayerCmsContentQueryVariables,
      options?: Omit<UseQueryOptions<PlayerCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PlayerCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PlayerCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PlayerCmsContent'] : ['PlayerCmsContent', variables],
    queryFn: gqlFetcher<PlayerCmsContentQuery, PlayerCmsContentQueryVariables>(PlayerCmsContentDocument, variables),
    ...options
  }
    )};

usePlayerCmsContentQuery.getKey = (variables?: PlayerCmsContentQueryVariables) => variables === undefined ? ['PlayerCmsContent'] : ['PlayerCmsContent', variables];

export const useSuspensePlayerCmsContentQuery = <
      TData = PlayerCmsContentQuery,
      TError = unknown
    >(
      variables?: PlayerCmsContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PlayerCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PlayerCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PlayerCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PlayerCmsContentSuspense'] : ['PlayerCmsContentSuspense', variables],
    queryFn: gqlFetcher<PlayerCmsContentQuery, PlayerCmsContentQueryVariables>(PlayerCmsContentDocument, variables),
    ...options
  }
    )};

useSuspensePlayerCmsContentQuery.getKey = (variables?: PlayerCmsContentQueryVariables) => variables === undefined ? ['PlayerCmsContentSuspense'] : ['PlayerCmsContentSuspense', variables];


usePlayerCmsContentQuery.fetcher = (variables?: PlayerCmsContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<PlayerCmsContentQuery, PlayerCmsContentQueryVariables>(PlayerCmsContentDocument, variables, options);

export const ShareDropdownCmsContentDocument = `
    query ShareDropdownCmsContent {
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      Close
      CopyLink
      EmailResource
      LinkCopiedSuccessfully
      ShareResourceMenuTrigger
      ShareOnX
      ShareOnLinkedIn
      ShareOnFacebook
      SomethingWentWrong
    }
  }
}
    `;

export const useShareDropdownCmsContentQuery = <
      TData = ShareDropdownCmsContentQuery,
      TError = unknown
    >(
      variables?: ShareDropdownCmsContentQueryVariables,
      options?: Omit<UseQueryOptions<ShareDropdownCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ShareDropdownCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ShareDropdownCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ShareDropdownCmsContent'] : ['ShareDropdownCmsContent', variables],
    queryFn: gqlFetcher<ShareDropdownCmsContentQuery, ShareDropdownCmsContentQueryVariables>(ShareDropdownCmsContentDocument, variables),
    ...options
  }
    )};

useShareDropdownCmsContentQuery.getKey = (variables?: ShareDropdownCmsContentQueryVariables) => variables === undefined ? ['ShareDropdownCmsContent'] : ['ShareDropdownCmsContent', variables];

export const useSuspenseShareDropdownCmsContentQuery = <
      TData = ShareDropdownCmsContentQuery,
      TError = unknown
    >(
      variables?: ShareDropdownCmsContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ShareDropdownCmsContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ShareDropdownCmsContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ShareDropdownCmsContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ShareDropdownCmsContentSuspense'] : ['ShareDropdownCmsContentSuspense', variables],
    queryFn: gqlFetcher<ShareDropdownCmsContentQuery, ShareDropdownCmsContentQueryVariables>(ShareDropdownCmsContentDocument, variables),
    ...options
  }
    )};

useSuspenseShareDropdownCmsContentQuery.getKey = (variables?: ShareDropdownCmsContentQueryVariables) => variables === undefined ? ['ShareDropdownCmsContentSuspense'] : ['ShareDropdownCmsContentSuspense', variables];


useShareDropdownCmsContentQuery.fetcher = (variables?: ShareDropdownCmsContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<ShareDropdownCmsContentQuery, ShareDropdownCmsContentQueryVariables>(ShareDropdownCmsContentDocument, variables, options);

export const ErrorPageContentDocument = `
    query ErrorPageContent {
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      GoBackToHomepage
      LogInPrompt
      SomethingWentWrong
      AccessDenied
      PageNotFoundErrorMessage
      TryAgainErrorMessage
    }
  }
}
    `;

export const useErrorPageContentQuery = <
      TData = ErrorPageContentQuery,
      TError = unknown
    >(
      variables?: ErrorPageContentQueryVariables,
      options?: Omit<UseQueryOptions<ErrorPageContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ErrorPageContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ErrorPageContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ErrorPageContent'] : ['ErrorPageContent', variables],
    queryFn: gqlFetcher<ErrorPageContentQuery, ErrorPageContentQueryVariables>(ErrorPageContentDocument, variables),
    ...options
  }
    )};

useErrorPageContentQuery.getKey = (variables?: ErrorPageContentQueryVariables) => variables === undefined ? ['ErrorPageContent'] : ['ErrorPageContent', variables];

export const useSuspenseErrorPageContentQuery = <
      TData = ErrorPageContentQuery,
      TError = unknown
    >(
      variables?: ErrorPageContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ErrorPageContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ErrorPageContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ErrorPageContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ErrorPageContentSuspense'] : ['ErrorPageContentSuspense', variables],
    queryFn: gqlFetcher<ErrorPageContentQuery, ErrorPageContentQueryVariables>(ErrorPageContentDocument, variables),
    ...options
  }
    )};

useSuspenseErrorPageContentQuery.getKey = (variables?: ErrorPageContentQueryVariables) => variables === undefined ? ['ErrorPageContentSuspense'] : ['ErrorPageContentSuspense', variables];


useErrorPageContentQuery.fetcher = (variables?: ErrorPageContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<ErrorPageContentQuery, ErrorPageContentQueryVariables>(ErrorPageContentDocument, variables, options);

export const FooterContentDocument = `
    query FooterContent {
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      FooterLogo {
        AltText
        ImageReference {
          Url
        }
      }
      FooterLogoLink {
        LinkToContent
        Target
        DisplayText
      }
      ContactUsLink {
        DisplayText
        LinkToContent
        Target
      }
      Address
      PhoneNumberLink {
        DisplayText
        LinkToContent
        Target
      }
      HelpfulLinksHeader
      HelpfulLinks {
        ContentLink {
          Expanded {
            ... on LinkBlock {
              __typename
              RelativePath
              LinkToContent
              DisplayText
              Target
            }
          }
        }
      }
      ChapterSitesHeader
      ChapterSitesLinks {
        ContentLink {
          Expanded {
            ... on LinkBlock {
              __typename
              RelativePath
              LinkToContent
              DisplayText
              Target
            }
          }
        }
      }
      MdrtAppsHeader
      GooglePlayLink
      AppStoreLink
      PwaAppInstallAndroidImage {
        Url
      }
      PwaAppInstallAppleImage {
        Url
      }
      Copyright
      DisclaimerLink {
        DisplayText
        LinkToContent
        Target
      }
      PrivacyLink {
        DisplayText
        LinkToContent
        Target
      }
      FooterSocialLinks {
        ContentLink {
          Expanded {
            ... on SvgLinkBlock {
              __typename
              Name
              LinkToContent
              Target
              IconClass
            }
          }
        }
      }
      AppStoreLinkAriaLabel
      GooglePlayLinkAriaLabel
    }
  }
}
    `;

export const useFooterContentQuery = <
      TData = FooterContentQuery,
      TError = unknown
    >(
      variables?: FooterContentQueryVariables,
      options?: Omit<UseQueryOptions<FooterContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FooterContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FooterContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['FooterContent'] : ['FooterContent', variables],
    queryFn: gqlFetcher<FooterContentQuery, FooterContentQueryVariables>(FooterContentDocument, variables),
    ...options
  }
    )};

useFooterContentQuery.getKey = (variables?: FooterContentQueryVariables) => variables === undefined ? ['FooterContent'] : ['FooterContent', variables];

export const useSuspenseFooterContentQuery = <
      TData = FooterContentQuery,
      TError = unknown
    >(
      variables?: FooterContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<FooterContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<FooterContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<FooterContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['FooterContentSuspense'] : ['FooterContentSuspense', variables],
    queryFn: gqlFetcher<FooterContentQuery, FooterContentQueryVariables>(FooterContentDocument, variables),
    ...options
  }
    )};

useSuspenseFooterContentQuery.getKey = (variables?: FooterContentQueryVariables) => variables === undefined ? ['FooterContentSuspense'] : ['FooterContentSuspense', variables];


useFooterContentQuery.fetcher = (variables?: FooterContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<FooterContentQuery, FooterContentQueryVariables>(FooterContentDocument, variables, options);

export const PwaContentDocument = `
    query PwaContent {
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      PWAPromptAddHomeInstructionsLabelApple
      PWAPromptAddHomeInstructionsLabelSafari
      PWAPromptBodyLabelApple
      PWAPromptBodyLabelSafari
      PWAPromptBodyLabelWeb
      PWAPromptCancelLabel
      PWAPromptInstallLabel
      PWAPromptShareInstructionsLabelApple
      PWAPromptShareInstructionsLabelSafari
      PWAPromptTitleLabelApple
      PWAPromptTitleLabelSafari
      Close
    }
  }
}
    `;

export const usePwaContentQuery = <
      TData = PwaContentQuery,
      TError = unknown
    >(
      variables?: PwaContentQueryVariables,
      options?: Omit<UseQueryOptions<PwaContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PwaContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PwaContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PwaContent'] : ['PwaContent', variables],
    queryFn: gqlFetcher<PwaContentQuery, PwaContentQueryVariables>(PwaContentDocument, variables),
    ...options
  }
    )};

usePwaContentQuery.getKey = (variables?: PwaContentQueryVariables) => variables === undefined ? ['PwaContent'] : ['PwaContent', variables];

export const useSuspensePwaContentQuery = <
      TData = PwaContentQuery,
      TError = unknown
    >(
      variables?: PwaContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PwaContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PwaContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PwaContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PwaContentSuspense'] : ['PwaContentSuspense', variables],
    queryFn: gqlFetcher<PwaContentQuery, PwaContentQueryVariables>(PwaContentDocument, variables),
    ...options
  }
    )};

useSuspensePwaContentQuery.getKey = (variables?: PwaContentQueryVariables) => variables === undefined ? ['PwaContentSuspense'] : ['PwaContentSuspense', variables];


usePwaContentQuery.fetcher = (variables?: PwaContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<PwaContentQuery, PwaContentQueryVariables>(PwaContentDocument, variables, options);

export const CompanyRankingsPageDocument = `
    query CompanyRankingsPage($relativePath: String!) {
  CompanyRankingsPage(
    where: {Status: {eq: "Published"}, RelativePath: {eq: $relativePath}}
  ) {
    items {
      Language {
        Name
      }
      Name
      MainContent {
        ContentLink {
          GuidValue
          Expanded {
            ...NextHeroBlock
            ...NextContainerBlock
            ...ImageTextBlock
            ...RichTextBlock
            ...MembershipRequirementsBlock
            ...AccordionContainerBlock
            ...NextPersonContainerBlock
            ...PastPresidentsBlock
            ...NextEventBlock
            ...NextCallOutBlock
            ...NextContactUsBlock
            ...LearnCarouselBlock
          }
        }
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      CountryLabel
      Language {
        Name
      }
      YearLabel
      StaticPagesEventThisYearLabel
      StaticPagesEventNextEventLabel
    }
  }
}
    ${NextHeroBlockFragmentDoc}
${ImageBlockFragmentDoc}
${LinkBlockFragmentDoc}
${NextContainerBlockFragmentDoc}
${ImageTextCardBlockFragmentDoc}
${ImageTextBlockFragmentDoc}
${RichTextBlockFragmentDoc}
${MembershipRequirementsBlockFragmentDoc}
${MembershipRequirementBlockFragmentDoc}
${MembershipRequirementLinkBlockFragmentDoc}
${ContactsBlockFragmentDoc}
${AccordionContainerBlockFragmentDoc}
${AccordionItemBlockFragmentDoc}
${NextPersonContainerBlockFragmentDoc}
${PersonBlockFragmentDoc}
${PastPresidentsBlockFragmentDoc}
${FourColumnTableBlockFragmentDoc}
${NextEventBlockFragmentDoc}
${NextCallOutBlockFragmentDoc}
${NextContactUsBlockFragmentDoc}
${LearnCarouselBlockFragmentDoc}`;

export const useCompanyRankingsPageQuery = <
      TData = CompanyRankingsPageQuery,
      TError = unknown
    >(
      variables: CompanyRankingsPageQueryVariables,
      options?: Omit<UseQueryOptions<CompanyRankingsPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CompanyRankingsPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CompanyRankingsPageQuery, TError, TData>(
      {
    queryKey: ['CompanyRankingsPage', variables],
    queryFn: gqlFetcher<CompanyRankingsPageQuery, CompanyRankingsPageQueryVariables>(CompanyRankingsPageDocument, variables),
    ...options
  }
    )};

useCompanyRankingsPageQuery.getKey = (variables: CompanyRankingsPageQueryVariables) => ['CompanyRankingsPage', variables];

export const useSuspenseCompanyRankingsPageQuery = <
      TData = CompanyRankingsPageQuery,
      TError = unknown
    >(
      variables: CompanyRankingsPageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CompanyRankingsPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CompanyRankingsPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CompanyRankingsPageQuery, TError, TData>(
      {
    queryKey: ['CompanyRankingsPageSuspense', variables],
    queryFn: gqlFetcher<CompanyRankingsPageQuery, CompanyRankingsPageQueryVariables>(CompanyRankingsPageDocument, variables),
    ...options
  }
    )};

useSuspenseCompanyRankingsPageQuery.getKey = (variables: CompanyRankingsPageQueryVariables) => ['CompanyRankingsPageSuspense', variables];


useCompanyRankingsPageQuery.fetcher = (variables: CompanyRankingsPageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<CompanyRankingsPageQuery, CompanyRankingsPageQueryVariables>(CompanyRankingsPageDocument, variables, options);

export const DynamicContentDocument = `
    query DynamicContent($relativePath: String!) {
  Content(where: {RelativePath: {eq: $relativePath}, Status: {eq: "Published"}}) {
    items {
      RelativePath
      Name
      Url
      Language {
        Name
      }
      MasterLanguage {
        Name
      }
      Status
      ContentType
      ContentLink {
        GuidValue
        Id
      }
      __typename
      ... on LearnPageV2 {
        AnalyticsCampaignName
        DisableSearchEngineIndexing
        ContentTypeID
        MetaTitle
        MetaDescription
        MetaKeywordList
        MetaImage {
          ImageReference {
            Url
          }
        }
      }
      ... on LearnDetailPage {
        AssignedGroupsReadAccess {
          GroupName
        }
        AnalyticsCampaignName
        DisableSearchEngineIndexing
        ContentTypeID
        ContentTypeSelection
        LanguageBranchId
        DisplayedDateYear
        ExpandedTopics {
          Name
        }
        ExpandedSources {
          Name
        }
        MetaTitle
        MetaDescription
        MetaKeywordList
        MetaImage {
          ImageReference {
            Url
          }
        }
      }
      ... on SearchPageV2 {
        AnalyticsCampaignName
        DisableSearchEngineIndexing
        ContentTypeID
        MetaTitle
        MetaDescription
        MetaKeywordList
        MetaImage {
          ImageReference {
            Url
          }
        }
      }
      ... on DashboardAccountPage {
        AnalyticsCampaignName
        DisableSearchEngineIndexing
        ContentTypeID
        MetaTitle
        MetaDescription
        MetaKeywordList
        MetaImage {
          ImageReference {
            Url
          }
        }
      }
      ... on MembershipInvoicePage {
        AnalyticsCampaignName
        DisableSearchEngineIndexing
        ContentTypeID
        MetaTitle
        MetaDescription
        MetaKeywordList
        MetaImage {
          ImageReference {
            Url
          }
        }
      }
      ... on PersonQuizPage {
        AnalyticsCampaignName
        DisableSearchEngineIndexing
        ContentTypeID
        MetaTitle
        MetaDescription
        MetaKeywordList
        MetaImage {
          ImageReference {
            Url
          }
        }
      }
      ... on NextStaticPage {
        AnalyticsCampaignName
        DisableSearchEngineIndexing
        ContentTypeID
        MetaTitle
        MetaDescription
        MetaKeywordList
        MetaImage {
          ImageReference {
            Url
          }
        }
      }
      ... on NextStaffAdminPage {
        AnalyticsCampaignName
        DisableSearchEngineIndexing
        ContentTypeID
        MetaTitle
        MetaDescription
        MetaKeywordList
        MetaImage {
          ImageReference {
            Url
          }
        }
      }
      ... on MemberDirectoryPage {
        AnalyticsCampaignName
        DisableSearchEngineIndexing
        ContentTypeID
        MetaTitle
        MetaDescription
        MetaKeywordList
        MetaImage {
          ImageReference {
            Url
          }
        }
      }
      ... on PublicProfilePage {
        AnalyticsCampaignName
        DisableSearchEngineIndexing
        ContentTypeID
        MetaTitle
        MetaDescription
        MetaKeywordList
        MetaImage {
          ImageReference {
            Url
          }
        }
      }
      ... on CompanyRankingsPage {
        AnalyticsCampaignName
        DisableSearchEngineIndexing
        ContentTypeID
        MetaTitle
        MetaDescription
        MetaKeywordList
        MetaImage {
          ImageReference {
            Url
          }
        }
      }
    }
  }
}
    `;

export const useDynamicContentQuery = <
      TData = DynamicContentQuery,
      TError = unknown
    >(
      variables: DynamicContentQueryVariables,
      options?: Omit<UseQueryOptions<DynamicContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DynamicContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DynamicContentQuery, TError, TData>(
      {
    queryKey: ['DynamicContent', variables],
    queryFn: gqlFetcher<DynamicContentQuery, DynamicContentQueryVariables>(DynamicContentDocument, variables),
    ...options
  }
    )};

useDynamicContentQuery.getKey = (variables: DynamicContentQueryVariables) => ['DynamicContent', variables];

export const useSuspenseDynamicContentQuery = <
      TData = DynamicContentQuery,
      TError = unknown
    >(
      variables: DynamicContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<DynamicContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<DynamicContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<DynamicContentQuery, TError, TData>(
      {
    queryKey: ['DynamicContentSuspense', variables],
    queryFn: gqlFetcher<DynamicContentQuery, DynamicContentQueryVariables>(DynamicContentDocument, variables),
    ...options
  }
    )};

useSuspenseDynamicContentQuery.getKey = (variables: DynamicContentQueryVariables) => ['DynamicContentSuspense', variables];


useDynamicContentQuery.fetcher = (variables: DynamicContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<DynamicContentQuery, DynamicContentQueryVariables>(DynamicContentDocument, variables, options);

export const HomePageMetadataDocument = `
    query HomePageMetadata {
  HomePageV2(where: {Status: {eq: "Published"}}, orderBy: {Saved: DESC}) {
    items {
      DisableSearchEngineIndexing
      AnalyticsCampaignName
      ContentTypeID
      Name
      ContentLink {
        GuidValue
        Id
      }
      Language {
        Name
      }
      MasterLanguage {
        Name
      }
      MetaTitle
      MetaDescription
      MetaKeywordList
      MetaImage {
        ImageReference {
          Url
        }
      }
    }
  }
}
    `;

export const useHomePageMetadataQuery = <
      TData = HomePageMetadataQuery,
      TError = unknown
    >(
      variables?: HomePageMetadataQueryVariables,
      options?: Omit<UseQueryOptions<HomePageMetadataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<HomePageMetadataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<HomePageMetadataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['HomePageMetadata'] : ['HomePageMetadata', variables],
    queryFn: gqlFetcher<HomePageMetadataQuery, HomePageMetadataQueryVariables>(HomePageMetadataDocument, variables),
    ...options
  }
    )};

useHomePageMetadataQuery.getKey = (variables?: HomePageMetadataQueryVariables) => variables === undefined ? ['HomePageMetadata'] : ['HomePageMetadata', variables];

export const useSuspenseHomePageMetadataQuery = <
      TData = HomePageMetadataQuery,
      TError = unknown
    >(
      variables?: HomePageMetadataQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<HomePageMetadataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<HomePageMetadataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<HomePageMetadataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['HomePageMetadataSuspense'] : ['HomePageMetadataSuspense', variables],
    queryFn: gqlFetcher<HomePageMetadataQuery, HomePageMetadataQueryVariables>(HomePageMetadataDocument, variables),
    ...options
  }
    )};

useSuspenseHomePageMetadataQuery.getKey = (variables?: HomePageMetadataQueryVariables) => variables === undefined ? ['HomePageMetadataSuspense'] : ['HomePageMetadataSuspense', variables];


useHomePageMetadataQuery.fetcher = (variables?: HomePageMetadataQueryVariables, options?: RequestInit['headers']) => gqlFetcher<HomePageMetadataQuery, HomePageMetadataQueryVariables>(HomePageMetadataDocument, variables, options);

export const LandingPageContentDocument = `
    query LandingPageContent {
  HomePageV2(where: {Status: {eq: "Published"}, RouteSegment: {eq: "dashboard"}}) {
    items {
      Name
      Language {
        Name
      }
      MainContent {
        ContentLink {
          Expanded {
            ...ImageTextBlock
            ...NextContainerBlock
            ...NextHeroBlock
            ...NextCallOutBlock
          }
          GuidValue
        }
      }
      ContentLink {
        Id
      }
    }
  }
}
    ${ImageTextBlockFragmentDoc}
${LinkBlockFragmentDoc}
${NextContainerBlockFragmentDoc}
${ImageTextCardBlockFragmentDoc}
${ImageBlockFragmentDoc}
${NextHeroBlockFragmentDoc}
${NextCallOutBlockFragmentDoc}`;

export const useLandingPageContentQuery = <
      TData = LandingPageContentQuery,
      TError = unknown
    >(
      variables?: LandingPageContentQueryVariables,
      options?: Omit<UseQueryOptions<LandingPageContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LandingPageContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LandingPageContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LandingPageContent'] : ['LandingPageContent', variables],
    queryFn: gqlFetcher<LandingPageContentQuery, LandingPageContentQueryVariables>(LandingPageContentDocument, variables),
    ...options
  }
    )};

useLandingPageContentQuery.getKey = (variables?: LandingPageContentQueryVariables) => variables === undefined ? ['LandingPageContent'] : ['LandingPageContent', variables];

export const useSuspenseLandingPageContentQuery = <
      TData = LandingPageContentQuery,
      TError = unknown
    >(
      variables?: LandingPageContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LandingPageContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LandingPageContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LandingPageContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LandingPageContentSuspense'] : ['LandingPageContentSuspense', variables],
    queryFn: gqlFetcher<LandingPageContentQuery, LandingPageContentQueryVariables>(LandingPageContentDocument, variables),
    ...options
  }
    )};

useSuspenseLandingPageContentQuery.getKey = (variables?: LandingPageContentQueryVariables) => variables === undefined ? ['LandingPageContentSuspense'] : ['LandingPageContentSuspense', variables];


useLandingPageContentQuery.fetcher = (variables?: LandingPageContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<LandingPageContentQuery, LandingPageContentQueryVariables>(LandingPageContentDocument, variables, options);

export const LearnSearchResultsDocument = `
    query LearnSearchResults($limit: Int, $skip: Int, $orderBy: LearnDetailPageOrderByInput, $where: LearnDetailPageWhereInput, $year: [String!], $source: [String!], $topic: [String!], $facetLimit: Int) {
  LearnDetailPage(where: $where, limit: $limit, skip: $skip, orderBy: $orderBy) {
    total
    items {
      _id
      _score
      RouteSegment
      RelativePath
      Url
      Language {
        Name
      }
      Authors {
        ContentLink {
          Id
          Expanded {
            Name
          }
        }
      }
      AssignedGroupsReadAccess {
        GroupName
      }
      DisplayedDate
      ReadTimeInSeconds
      Heading
      Description
      Subheading
      SubheadingText
      ContentTypeSelection
      ExpandedCategories {
        Name
        ParentId
      }
      ThumbnailImage {
        AltText
        ImageReference {
          Url
        }
      }
      MainContent {
        ContentLink {
          Expanded {
            __typename
            ... on ProfileListBlock {
              ProfileList {
                ContentLink {
                  Expanded {
                    Name
                  }
                }
              }
            }
          }
        }
      }
    }
    facets {
      DisplayedDateYear(
        filters: $year
        limit: $facetLimit
        orderBy: DESC
        orderType: VALUE
      ) {
        name
        count
      }
      ExpandedSources {
        Name(filters: $source, limit: $facetLimit) {
          name
          count
        }
      }
      ExpandedTopics {
        Name(filters: $topic, limit: $facetLimit) {
          name
          count
        }
      }
    }
  }
}
    `;

export const useLearnSearchResultsQuery = <
      TData = LearnSearchResultsQuery,
      TError = unknown
    >(
      variables?: LearnSearchResultsQueryVariables,
      options?: Omit<UseQueryOptions<LearnSearchResultsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnSearchResultsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnSearchResultsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LearnSearchResults'] : ['LearnSearchResults', variables],
    queryFn: gqlFetcher<LearnSearchResultsQuery, LearnSearchResultsQueryVariables>(LearnSearchResultsDocument, variables),
    ...options
  }
    )};

useLearnSearchResultsQuery.getKey = (variables?: LearnSearchResultsQueryVariables) => variables === undefined ? ['LearnSearchResults'] : ['LearnSearchResults', variables];

export const useSuspenseLearnSearchResultsQuery = <
      TData = LearnSearchResultsQuery,
      TError = unknown
    >(
      variables?: LearnSearchResultsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LearnSearchResultsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LearnSearchResultsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LearnSearchResultsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LearnSearchResultsSuspense'] : ['LearnSearchResultsSuspense', variables],
    queryFn: gqlFetcher<LearnSearchResultsQuery, LearnSearchResultsQueryVariables>(LearnSearchResultsDocument, variables),
    ...options
  }
    )};

useSuspenseLearnSearchResultsQuery.getKey = (variables?: LearnSearchResultsQueryVariables) => variables === undefined ? ['LearnSearchResultsSuspense'] : ['LearnSearchResultsSuspense', variables];


useLearnSearchResultsQuery.fetcher = (variables?: LearnSearchResultsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<LearnSearchResultsQuery, LearnSearchResultsQueryVariables>(LearnSearchResultsDocument, variables, options);

export const LocalPathsDocument = `
    query LocalPaths {
  SiteSettingsPage(
    where: {Status: {eq: "Published"}, Language: {Name: {eq: "en"}}}
  ) {
    items {
      SearchPageV2Reference {
        Expanded {
          RelativePath
        }
      }
      AccountSettingsPageReference {
        Expanded {
          RelativePath
        }
      }
      MembershipRenewalV2Page {
        Expanded {
          RelativePath
        }
      }
      CompanyAdminDashboardPage {
        Expanded {
          RelativePath
        }
      }
      LearnLandingPage {
        Expanded {
          RelativePath
        }
      }
      AdminDashboardPage {
        Expanded {
          RelativePath
        }
      }
    }
  }
  HomePageV2(where: {Status: {eq: "Published"}, Language: {Name: {eq: "en"}}}) {
    items {
      RelativePath
    }
  }
  PersonQuizPage(where: {Status: {eq: "Published"}, Language: {Name: {eq: "en"}}}) {
    items {
      RelativePath
    }
  }
  MemberDirectoryPage(
    where: {Status: {eq: "Published"}, Language: {Name: {eq: "en"}}}
  ) {
    items {
      RelativePath
    }
  }
  PublicProfilePage(
    where: {Status: {eq: "Published"}, Language: {Name: {eq: "en"}}}
  ) {
    items {
      RelativePath
    }
  }
}
    `;

export const useLocalPathsQuery = <
      TData = LocalPathsQuery,
      TError = unknown
    >(
      variables?: LocalPathsQueryVariables,
      options?: Omit<UseQueryOptions<LocalPathsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LocalPathsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LocalPathsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LocalPaths'] : ['LocalPaths', variables],
    queryFn: gqlFetcher<LocalPathsQuery, LocalPathsQueryVariables>(LocalPathsDocument, variables),
    ...options
  }
    )};

useLocalPathsQuery.getKey = (variables?: LocalPathsQueryVariables) => variables === undefined ? ['LocalPaths'] : ['LocalPaths', variables];

export const useSuspenseLocalPathsQuery = <
      TData = LocalPathsQuery,
      TError = unknown
    >(
      variables?: LocalPathsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LocalPathsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LocalPathsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LocalPathsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LocalPathsSuspense'] : ['LocalPathsSuspense', variables],
    queryFn: gqlFetcher<LocalPathsQuery, LocalPathsQueryVariables>(LocalPathsDocument, variables),
    ...options
  }
    )};

useSuspenseLocalPathsQuery.getKey = (variables?: LocalPathsQueryVariables) => variables === undefined ? ['LocalPathsSuspense'] : ['LocalPathsSuspense', variables];


useLocalPathsQuery.fetcher = (variables?: LocalPathsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<LocalPathsQuery, LocalPathsQueryVariables>(LocalPathsDocument, variables, options);

export const SiteLanguagesDocument = `
    query SiteLanguages {
  SiteDefinition(
    where: {Name: {eq: "Million Dollar Round Table"}, Status: {eq: "Published"}}
  ) {
    items {
      Languages {
        Name
        DisplayName
        UrlSegment
        IsMasterLanguage
      }
    }
  }
}
    `;

export const useSiteLanguagesQuery = <
      TData = SiteLanguagesQuery,
      TError = unknown
    >(
      variables?: SiteLanguagesQueryVariables,
      options?: Omit<UseQueryOptions<SiteLanguagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SiteLanguagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SiteLanguagesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SiteLanguages'] : ['SiteLanguages', variables],
    queryFn: gqlFetcher<SiteLanguagesQuery, SiteLanguagesQueryVariables>(SiteLanguagesDocument, variables),
    ...options
  }
    )};

useSiteLanguagesQuery.getKey = (variables?: SiteLanguagesQueryVariables) => variables === undefined ? ['SiteLanguages'] : ['SiteLanguages', variables];

export const useSuspenseSiteLanguagesQuery = <
      TData = SiteLanguagesQuery,
      TError = unknown
    >(
      variables?: SiteLanguagesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<SiteLanguagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<SiteLanguagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<SiteLanguagesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SiteLanguagesSuspense'] : ['SiteLanguagesSuspense', variables],
    queryFn: gqlFetcher<SiteLanguagesQuery, SiteLanguagesQueryVariables>(SiteLanguagesDocument, variables),
    ...options
  }
    )};

useSuspenseSiteLanguagesQuery.getKey = (variables?: SiteLanguagesQueryVariables) => variables === undefined ? ['SiteLanguagesSuspense'] : ['SiteLanguagesSuspense', variables];


useSiteLanguagesQuery.fetcher = (variables?: SiteLanguagesQueryVariables, options?: RequestInit['headers']) => gqlFetcher<SiteLanguagesQuery, SiteLanguagesQueryVariables>(SiteLanguagesDocument, variables, options);

export const SiteSettingsCategoryAndSourceRootsDocument = `
    query SiteSettingsCategoryAndSourceRoots {
  SiteSettingsPage(limit: 1, where: {Status: {eq: "Published"}}) {
    items {
      TopicsCategoryRoot {
        Id
      }
      ContentSourceCategoryRoot {
        Id
      }
    }
  }
}
    `;

export const useSiteSettingsCategoryAndSourceRootsQuery = <
      TData = SiteSettingsCategoryAndSourceRootsQuery,
      TError = unknown
    >(
      variables?: SiteSettingsCategoryAndSourceRootsQueryVariables,
      options?: Omit<UseQueryOptions<SiteSettingsCategoryAndSourceRootsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SiteSettingsCategoryAndSourceRootsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SiteSettingsCategoryAndSourceRootsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SiteSettingsCategoryAndSourceRoots'] : ['SiteSettingsCategoryAndSourceRoots', variables],
    queryFn: gqlFetcher<SiteSettingsCategoryAndSourceRootsQuery, SiteSettingsCategoryAndSourceRootsQueryVariables>(SiteSettingsCategoryAndSourceRootsDocument, variables),
    ...options
  }
    )};

useSiteSettingsCategoryAndSourceRootsQuery.getKey = (variables?: SiteSettingsCategoryAndSourceRootsQueryVariables) => variables === undefined ? ['SiteSettingsCategoryAndSourceRoots'] : ['SiteSettingsCategoryAndSourceRoots', variables];

export const useSuspenseSiteSettingsCategoryAndSourceRootsQuery = <
      TData = SiteSettingsCategoryAndSourceRootsQuery,
      TError = unknown
    >(
      variables?: SiteSettingsCategoryAndSourceRootsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<SiteSettingsCategoryAndSourceRootsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<SiteSettingsCategoryAndSourceRootsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<SiteSettingsCategoryAndSourceRootsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SiteSettingsCategoryAndSourceRootsSuspense'] : ['SiteSettingsCategoryAndSourceRootsSuspense', variables],
    queryFn: gqlFetcher<SiteSettingsCategoryAndSourceRootsQuery, SiteSettingsCategoryAndSourceRootsQueryVariables>(SiteSettingsCategoryAndSourceRootsDocument, variables),
    ...options
  }
    )};

useSuspenseSiteSettingsCategoryAndSourceRootsQuery.getKey = (variables?: SiteSettingsCategoryAndSourceRootsQueryVariables) => variables === undefined ? ['SiteSettingsCategoryAndSourceRootsSuspense'] : ['SiteSettingsCategoryAndSourceRootsSuspense', variables];


useSiteSettingsCategoryAndSourceRootsQuery.fetcher = (variables?: SiteSettingsCategoryAndSourceRootsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<SiteSettingsCategoryAndSourceRootsQuery, SiteSettingsCategoryAndSourceRootsQueryVariables>(SiteSettingsCategoryAndSourceRootsDocument, variables, options);

export const SiteSettingsGlobalContentDocument = `
    query SiteSettingsGlobalContent {
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      Close
      DateSavedSuccessfully
      Optional
      NoResultsLabel
      NoLabel
      YesLabel
      Url
      RelativePath
      GoBackToHomepage
      BackLabel
      BackAriaLabel
      LoginLinkLabel
      LogoutLine
      DefaultRouteTitle
      LeavingConfirmMessage
      AppDescription
      CarouselNextButtonLabel
      CarouselPreviousButtonLabel
      ToastSomethingWentWrong
      NextPageLabel
      PreviousPageLabel
      TotalItemsCountLabel
      Pagination
      DownloadLabel
    }
  }
  ErrorPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      Title
    }
  }
  NotFoundPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      Title
    }
  }
}
    `;

export const useSiteSettingsGlobalContentQuery = <
      TData = SiteSettingsGlobalContentQuery,
      TError = unknown
    >(
      variables?: SiteSettingsGlobalContentQueryVariables,
      options?: Omit<UseQueryOptions<SiteSettingsGlobalContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SiteSettingsGlobalContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SiteSettingsGlobalContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SiteSettingsGlobalContent'] : ['SiteSettingsGlobalContent', variables],
    queryFn: gqlFetcher<SiteSettingsGlobalContentQuery, SiteSettingsGlobalContentQueryVariables>(SiteSettingsGlobalContentDocument, variables),
    ...options
  }
    )};

useSiteSettingsGlobalContentQuery.getKey = (variables?: SiteSettingsGlobalContentQueryVariables) => variables === undefined ? ['SiteSettingsGlobalContent'] : ['SiteSettingsGlobalContent', variables];

export const useSuspenseSiteSettingsGlobalContentQuery = <
      TData = SiteSettingsGlobalContentQuery,
      TError = unknown
    >(
      variables?: SiteSettingsGlobalContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<SiteSettingsGlobalContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<SiteSettingsGlobalContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<SiteSettingsGlobalContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SiteSettingsGlobalContentSuspense'] : ['SiteSettingsGlobalContentSuspense', variables],
    queryFn: gqlFetcher<SiteSettingsGlobalContentQuery, SiteSettingsGlobalContentQueryVariables>(SiteSettingsGlobalContentDocument, variables),
    ...options
  }
    )};

useSuspenseSiteSettingsGlobalContentQuery.getKey = (variables?: SiteSettingsGlobalContentQueryVariables) => variables === undefined ? ['SiteSettingsGlobalContentSuspense'] : ['SiteSettingsGlobalContentSuspense', variables];


useSiteSettingsGlobalContentQuery.fetcher = (variables?: SiteSettingsGlobalContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<SiteSettingsGlobalContentQuery, SiteSettingsGlobalContentQueryVariables>(SiteSettingsGlobalContentDocument, variables, options);

export const StaticPageDocument = `
    query StaticPage($relativePath: String!) {
  NextStaticPage(
    where: {Status: {eq: "Published"}, RelativePath: {eq: $relativePath}}
  ) {
    items {
      Language {
        Name
      }
      Name
      MainContent {
        ContentLink {
          GuidValue
          Expanded {
            ...NextHeroBlock
            ...NextContainerBlock
            ...ImageTextBlock
            ...RichTextBlock
            ...MembershipRequirementsBlock
            ...AccordionContainerBlock
            ...NextPersonContainerBlock
            ...PastPresidentsBlock
            ...NextEventBlock
            ...NextCallOutBlock
            ...NextContactUsBlock
            ...LearnCarouselBlock
          }
        }
      }
    }
  }
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      CountryLabel
      Language {
        Name
      }
      YearLabel
      StaticPagesEventThisYearLabel
      StaticPagesEventNextEventLabel
    }
  }
}
    ${NextHeroBlockFragmentDoc}
${ImageBlockFragmentDoc}
${LinkBlockFragmentDoc}
${NextContainerBlockFragmentDoc}
${ImageTextCardBlockFragmentDoc}
${ImageTextBlockFragmentDoc}
${RichTextBlockFragmentDoc}
${MembershipRequirementsBlockFragmentDoc}
${MembershipRequirementBlockFragmentDoc}
${MembershipRequirementLinkBlockFragmentDoc}
${ContactsBlockFragmentDoc}
${AccordionContainerBlockFragmentDoc}
${AccordionItemBlockFragmentDoc}
${NextPersonContainerBlockFragmentDoc}
${PersonBlockFragmentDoc}
${PastPresidentsBlockFragmentDoc}
${FourColumnTableBlockFragmentDoc}
${NextEventBlockFragmentDoc}
${NextCallOutBlockFragmentDoc}
${NextContactUsBlockFragmentDoc}
${LearnCarouselBlockFragmentDoc}`;

export const useStaticPageQuery = <
      TData = StaticPageQuery,
      TError = unknown
    >(
      variables: StaticPageQueryVariables,
      options?: Omit<UseQueryOptions<StaticPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StaticPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<StaticPageQuery, TError, TData>(
      {
    queryKey: ['StaticPage', variables],
    queryFn: gqlFetcher<StaticPageQuery, StaticPageQueryVariables>(StaticPageDocument, variables),
    ...options
  }
    )};

useStaticPageQuery.getKey = (variables: StaticPageQueryVariables) => ['StaticPage', variables];

export const useSuspenseStaticPageQuery = <
      TData = StaticPageQuery,
      TError = unknown
    >(
      variables: StaticPageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<StaticPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<StaticPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<StaticPageQuery, TError, TData>(
      {
    queryKey: ['StaticPageSuspense', variables],
    queryFn: gqlFetcher<StaticPageQuery, StaticPageQueryVariables>(StaticPageDocument, variables),
    ...options
  }
    )};

useSuspenseStaticPageQuery.getKey = (variables: StaticPageQueryVariables) => ['StaticPageSuspense', variables];


useStaticPageQuery.fetcher = (variables: StaticPageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<StaticPageQuery, StaticPageQueryVariables>(StaticPageDocument, variables, options);

export const TopicFacetsDocument = `
    query TopicFacets($limit: Int, $where: LearnDetailPageWhereInput) {
  LearnDetailPage(where: $where) {
    facets {
      ExpandedTopics {
        Name(limit: $limit) {
          name
          count
        }
      }
    }
  }
}
    `;

export const useTopicFacetsQuery = <
      TData = TopicFacetsQuery,
      TError = unknown
    >(
      variables?: TopicFacetsQueryVariables,
      options?: Omit<UseQueryOptions<TopicFacetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TopicFacetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TopicFacetsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['TopicFacets'] : ['TopicFacets', variables],
    queryFn: gqlFetcher<TopicFacetsQuery, TopicFacetsQueryVariables>(TopicFacetsDocument, variables),
    ...options
  }
    )};

useTopicFacetsQuery.getKey = (variables?: TopicFacetsQueryVariables) => variables === undefined ? ['TopicFacets'] : ['TopicFacets', variables];

export const useSuspenseTopicFacetsQuery = <
      TData = TopicFacetsQuery,
      TError = unknown
    >(
      variables?: TopicFacetsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<TopicFacetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<TopicFacetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<TopicFacetsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['TopicFacetsSuspense'] : ['TopicFacetsSuspense', variables],
    queryFn: gqlFetcher<TopicFacetsQuery, TopicFacetsQueryVariables>(TopicFacetsDocument, variables),
    ...options
  }
    )};

useSuspenseTopicFacetsQuery.getKey = (variables?: TopicFacetsQueryVariables) => variables === undefined ? ['TopicFacetsSuspense'] : ['TopicFacetsSuspense', variables];


useTopicFacetsQuery.fetcher = (variables?: TopicFacetsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<TopicFacetsQuery, TopicFacetsQueryVariables>(TopicFacetsDocument, variables, options);

export const TopicIdNameFacetsDocument = `
    query TopicIdNameFacets($limit: Int, $where: LearnDetailPageWhereInput) {
  LearnDetailPage(where: $where) {
    facets {
      ExpandedTopics {
        IdName(limit: $limit) {
          name
          count
        }
      }
    }
  }
}
    `;

export const useTopicIdNameFacetsQuery = <
      TData = TopicIdNameFacetsQuery,
      TError = unknown
    >(
      variables?: TopicIdNameFacetsQueryVariables,
      options?: Omit<UseQueryOptions<TopicIdNameFacetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TopicIdNameFacetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TopicIdNameFacetsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['TopicIdNameFacets'] : ['TopicIdNameFacets', variables],
    queryFn: gqlFetcher<TopicIdNameFacetsQuery, TopicIdNameFacetsQueryVariables>(TopicIdNameFacetsDocument, variables),
    ...options
  }
    )};

useTopicIdNameFacetsQuery.getKey = (variables?: TopicIdNameFacetsQueryVariables) => variables === undefined ? ['TopicIdNameFacets'] : ['TopicIdNameFacets', variables];

export const useSuspenseTopicIdNameFacetsQuery = <
      TData = TopicIdNameFacetsQuery,
      TError = unknown
    >(
      variables?: TopicIdNameFacetsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<TopicIdNameFacetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<TopicIdNameFacetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<TopicIdNameFacetsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['TopicIdNameFacetsSuspense'] : ['TopicIdNameFacetsSuspense', variables],
    queryFn: gqlFetcher<TopicIdNameFacetsQuery, TopicIdNameFacetsQueryVariables>(TopicIdNameFacetsDocument, variables),
    ...options
  }
    )};

useSuspenseTopicIdNameFacetsQuery.getKey = (variables?: TopicIdNameFacetsQueryVariables) => variables === undefined ? ['TopicIdNameFacetsSuspense'] : ['TopicIdNameFacetsSuspense', variables];


useTopicIdNameFacetsQuery.fetcher = (variables?: TopicIdNameFacetsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<TopicIdNameFacetsQuery, TopicIdNameFacetsQueryVariables>(TopicIdNameFacetsDocument, variables, options);

export const LanguagesContentDocument = `
    query LanguagesContent {
  SiteSettingsPage(where: {Status: {eq: "Published"}}) {
    items {
      Language {
        Name
      }
      SelectLanguage
      LanguageIdsAndNames {
        ContentLink {
          Expanded {
            ... on LanguageIdAndName {
              __typename
              LanguageId
              LanguageName
            }
          }
        }
      }
    }
  }
}
    `;

export const useLanguagesContentQuery = <
      TData = LanguagesContentQuery,
      TError = unknown
    >(
      variables?: LanguagesContentQueryVariables,
      options?: Omit<UseQueryOptions<LanguagesContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LanguagesContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LanguagesContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LanguagesContent'] : ['LanguagesContent', variables],
    queryFn: gqlFetcher<LanguagesContentQuery, LanguagesContentQueryVariables>(LanguagesContentDocument, variables),
    ...options
  }
    )};

useLanguagesContentQuery.getKey = (variables?: LanguagesContentQueryVariables) => variables === undefined ? ['LanguagesContent'] : ['LanguagesContent', variables];

export const useSuspenseLanguagesContentQuery = <
      TData = LanguagesContentQuery,
      TError = unknown
    >(
      variables?: LanguagesContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LanguagesContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LanguagesContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LanguagesContentQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LanguagesContentSuspense'] : ['LanguagesContentSuspense', variables],
    queryFn: gqlFetcher<LanguagesContentQuery, LanguagesContentQueryVariables>(LanguagesContentDocument, variables),
    ...options
  }
    )};

useSuspenseLanguagesContentQuery.getKey = (variables?: LanguagesContentQueryVariables) => variables === undefined ? ['LanguagesContentSuspense'] : ['LanguagesContentSuspense', variables];


useLanguagesContentQuery.fetcher = (variables?: LanguagesContentQueryVariables, options?: RequestInit['headers']) => gqlFetcher<LanguagesContentQuery, LanguagesContentQueryVariables>(LanguagesContentDocument, variables, options);
